/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var catbee = __webpack_require__(446);
	var components = __webpack_require__(436);
	var logger = __webpack_require__(470);
	var routes = __webpack_require__(472);
	var uhr = __webpack_require__(455);
	var linkSPA = __webpack_require__(433);
	var api = __webpack_require__(478);
	var handlebars = __webpack_require__(483);
	var hbHelpers = __webpack_require__(486);
	var serverTransport = __webpack_require__(491);
	var Document = __webpack_require__(402);
	var analytics = __webpack_require__(474);
	var bitrix = __webpack_require__(480);
	var gismap = __webpack_require__(482);
	
	if (global.ENV.isRelease) {
	  __webpack_require__(530);
	}
	
	var cat = catbee.create(global.ENV);
	
	__webpack_require__(194);
	
	__webpack_require__(1045);
	
	__webpack_require__(1039);
	
	components.register(cat.locator, Document);
	routes.register(cat);
	logger.register(cat.locator);
	uhr.register(cat.locator);
	api.register(cat.locator);
	handlebars.register(cat.locator);
	hbHelpers.register(cat.locator);
	linkSPA.register(cat.locator);
	serverTransport.register(cat.locator);
	analytics.register(cat.locator);
	bitrix.register(cat.locator);
	gismap.register(cat.locator);
	
	if (!global.ENV.isRelease) {
	  __webpack_require__(489).register(cat.locator);
	}
	
	cat.startWhenReady();
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	// Create a simple path alias to allow browserify to resolve
	// the runtime on a supported path.
	module.exports = __webpack_require__(1021)['default'];


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(8);
	var core = __webpack_require__(47);
	var hide = __webpack_require__(31);
	var redefine = __webpack_require__(32);
	var ctx = __webpack_require__(48);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.21';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function',
	      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading whitespace. */
	  var reTrimStart = /^\s+/;
	
	  /** Used to match a single whitespace character. */
	  var reWhitespace = /\s/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /**
	   * Used to validate the `validate` option in `_.template` variable.
	   *
	   * Forbids characters which could potentially change the meaning of the function argument definition:
	   * - "()," (modification of function parameters)
	   * - "=" (default value)
	   * - "[]{}" (destructuring of function parameters)
	   * - "/" (beginning of a comment)
	   * - whitespace
	   */
	  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	      if (types) {
	        return types;
	      }
	
	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.trim`.
	   *
	   * @private
	   * @param {string} string The string to trim.
	   * @returns {string} Returns the trimmed string.
	   */
	  function baseTrim(string) {
	    return string
	      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	      : string;
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedEndIndex(string) {
	    var index = string.length;
	
	    while (index-- && reWhitespace.test(string.charAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	      } else if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        stack || (stack = new Stack);
	        if (isObject(srcValue)) {
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || isFunction(objValue)) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      if (iteratees.length) {
	        iteratees = arrayMap(iteratees, function(iteratee) {
	          if (isArray(iteratee)) {
	            return function(value) {
	              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
	            }
	          }
	          return iteratee;
	        });
	      } else {
	        iteratees = [identity];
	      }
	
	      var index = -1;
	      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
	          return object;
	        }
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      var low = 0,
	          high = array == null ? 0 : array.length;
	      if (high === 0) {
	        return 0;
	      }
	
	      value = iteratee(value);
	      var valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision && nativeIsFinite(number)) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Check that cyclic values are equal.
	      var arrStacked = stack.get(array);
	      var othStacked = stack.get(other);
	      if (arrStacked && othStacked) {
	        return arrStacked == other && othStacked == array;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Check that cyclic values are equal.
	      var objStacked = stack.get(object);
	      var othStacked = stack.get(other);
	      if (objStacked && othStacked) {
	        return objStacked == other && othStacked == object;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function safeGet(object, key) {
	      if (key === 'constructor' && typeof object[key] === 'function') {
	        return;
	      }
	
	      if (key == '__proto__') {
	        return;
	      }
	
	      return object[key];
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     *
	     * // Combining several predicates using `_.overEvery` or `_.overSome`.
	     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	     * // => objects for ['fred', 'barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 30 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            clearTimeout(timerId);
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = baseTrim(value);
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      // The sourceURL gets injected into the source that's eval-ed, so be careful
	      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
	      // and escape the comment, thus injecting code that gets evaled.
	      var sourceURL = '//# sourceURL=' +
	        (hasOwnProperty.call(options, 'sourceURL')
	          ? (options.sourceURL + '').replace(/\s/g, ' ')
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Throw an error if a forbidden character was found in `variable`, to prevent
	      // potential command injection attacks.
	      else if (reForbiddenIdentifierChars.test(variable)) {
	        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
	      }
	
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return baseTrim(string);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.slice(0, trimmedEndIndex(string) + 1);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     *
	     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
	     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name + '';
	        if (!hasOwnProperty.call(realNames, key)) {
	          realNames[key] = [];
	        }
	        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(197)(module)))

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(3);
	
	var _require = __webpack_require__(58),
	    URI = _require.URI,
	    Query = _require.Query;
	
	function patchQuery(location, params) {
	    if (params) {
	        var uri = new URI(location);
	
	        if (!uri.query) {
	            uri.query = new Query();
	        }
	        if (!uri.query.values) {
	            uri.query.values = {};
	        }
	
	        _.forEach(params, function (value, key) {
	            uri.query.values[key] = value;
	        });
	
	        return uri.toString();
	    }
	
	    return location;
	}
	
	module.exports = {
	    cut: function cut(string) {
	        var firstClass = _.first(string.split(' '));
	        return '.' + firstClass;
	    },
	
	    pluralize: function pluralize(number, textForms) {
	        var n = Math.abs(number) % 100;
	        var n1 = n % 10;
	
	        if (n > 10 && n < 20) {
	            return textForms[2];
	        }
	
	        if (n1 > 1 && n1 < 5) {
	            return textForms[1];
	        }
	
	        if (n1 == 1) {
	            return textForms[0];
	        }
	
	        return textForms[2];
	    },
	
	    patchQuery: patchQuery,
	
	    patchQueryWithUtm: function patchQueryWithUtm(location, state) {
	        var utm = state.get('utm');
	
	        return patchQuery(location, utm);
	    }
	};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(3);
	
	var _require = __webpack_require__(15),
	    monkey = _require.monkey;
	
	var _require2 = __webpack_require__(58),
	    Query = _require2.Query;
	
	var windowUtils = __webpack_require__(421);
	var utils = __webpack_require__(4);
	
	function togglePopupFromArgs(_ref, state) {
	    var name = _ref.name;
	
	    var path = ['popups', 'active'];
	    var popups = state.get(path);
	
	    if (_.includes(popups, name)) {
	        state.set(path, []);
	        return;
	    }
	
	    state.set(path, [name]);
	}
	
	module.exports = {
	    set: function set(path, value) {
	        return function set(args, state) {
	            var pathAsArray = _.isArray(path) ? path : path.split('.');
	            var isEqual = _.isEqual(value, state.get(pathAsArray));
	
	            if (isEqual) {
	                return;
	            }
	
	            state.set(pathAsArray, value);
	        };
	    },
	    unset: function unset(template) {
	        var path = _.isArray(template) ? template : template.split('.');
	
	        return function unset(args, state) {
	            state.unset(path);
	        };
	    },
	    toggle: function toggle(template) {
	        var path = _.isArray(template) ? template : template.split('.');
	
	        return function toggle(args, state) {
	            var currentState = state.get(path);
	
	            state.set(path, !currentState);
	        };
	    },
	    setArg: function setArg(argName, value) {
	        return function (args, state, output) {
	            var _output;
	
	            return output((_output = {}, _output[argName] = value, _output));
	        };
	    },
	    setArgByFunction: function setArgByFunction(argName, func) {
	        return function (args, state, output) {
	            var _output2;
	
	            return output((_output2 = {}, _output2[argName] = func(args), _output2));
	        };
	    },
	    setArgFromState: function setArgFromState(argName, path) {
	        return function (args, state, output) {
	            var _output3;
	
	            return output((_output3 = {}, _output3[argName] = state.get(path), _output3));
	        };
	    },
	    setFromArgsToState: function setFromArgsToState(argName, statePathTemplate) {
	        var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	        var pathArr = _.isArray(statePathTemplate) ? statePathTemplate : statePathTemplate.split('.');
	        var pathTemplates = _.map(pathArr, _.template);
	
	        return function setFromArgsToState(args, state) {
	            var ctx = _.reduce(context, function (obj, value, key) {
	                obj[key] = args[value];
	                return obj;
	            }, {});
	            var path = _.map(pathTemplates, function (pathFn) {
	                return pathFn(ctx);
	            });
	            state.set(path, args[argName]);
	        };
	    },
	    updateStateFromArg: function updateStateFromArg(argName, path) {
	        return function setFromArgsToState(args, state) {
	            var entity = args[argName];
	            _.each(Object.keys(entity), function (key) {
	                state.set(path.concat(key), entity[key]);
	            });
	        };
	    },
	    patchURLQuery: function patchURLQuery(argsKey, queryKey) {
	        return function patchURLQuery(args, state, output, _ref2) {
	            var context = _ref2.context;
	
	            var key = args[argsKey];
	            var location = context.location.clone();
	
	            if (!location.query) {
	                location.query = new Query();
	            }
	
	            if (!location.query.values) {
	                location.query.values = {};
	            }
	
	            location.query.values[queryKey] = key;
	            var locationString = location.toString();
	            context.redirect(utils.patchQueryWithUtm(locationString, state), { silent: true });
	        };
	    },
	    queryRedirectFromState: function queryRedirectFromState(statePath) {
	        var absPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	        return function patchURLQuery(args, state, output, _ref3) {
	            var context = _ref3.context;
	
	            var query = state.get(statePath);
	
	            context.redirect(utils.patchQueryWithUtm(absPath + '?' + query, state), { silent: true });
	        };
	    },
	    queryOrderRedirect: function queryOrderRedirect(statePath) {
	        return function patchURLQuery(_ref4, state, output, _ref5) {
	            var orderId = _ref4.orderId;
	            var context = _ref5.context;
	
	            if (context.isServer) {
	                return;
	            }
	            var query = state.get(statePath);
	            var role = state.get(['user', 'role']);
	            var pageName = 'account';
	            if (role === 'manager') {
	                pageName = 'manager';
	            }
	            context.redirect(utils.patchQueryWithUtm('/' + pageName + '/orders/' + orderId + '?' + query, state), { silent: true });
	        };
	    },
	    openPopup: function openPopup(name) {
	        return function openPopup(args, state) {
	            var path = ['popups', 'active'];
	            var current = state.get(path);
	            var value = [name];
	
	            if (_.isEqual(current, value)) {
	                return;
	            }
	
	            state.set(path, value);
	        };
	    },
	    addPopup: function addPopup(name) {
	        return function addPopup(args, state) {
	            var path = ['popups', 'active'];
	            state.concat(path, [name]);
	        };
	    },
	    togglePopup: function togglePopup(name) {
	        return function togglePopup(args, state) {
	            togglePopupFromArgs({ name: name }, state);
	        };
	    },
	
	
	    togglePopupFromArgs: togglePopupFromArgs,
	
	    scrollTop: function scrollTop() {
	        windowUtils.scrollTo(0, 200);
	    },
	    isPage: function isPage(pageName) {
	        return function patchURLQuery(args, state, output) {
	            var currentPageName = state.get(['page', 'name']);
	            if (pageName === currentPageName) {
	                output.yes();
	                return;
	            }
	            output.no();
	        };
	    },
	    isLocalEditMode: function isLocalEditMode(args, state, output) {
	        var role = state.get(['user', 'role']);
	        var typeId = state.get(['account', 'orders', 'currentOrder', 'typeId']);
	
	        if (role === 'unauthorized' || role === 'manager' && typeId === 1) {
	            output.true();
	        } else {
	            output.false();
	        }
	    },
	    isSaveLocalChanges: function isSaveLocalChanges(args, state, output) {
	        var role = state.get(['user', 'role']);
	
	        if (role === 'unauthorized') {
	            output.yes();
	            return;
	        }
	
	        output.no();
	    },
	    setArgToCookie: function setArgToCookie(name, expiresMin) {
	        return function (args, state, output, _ref6) {
	            var context = _ref6.context;
	
	            if (args[name] !== undefined) {
	                var expires = new Date(Date.now() + expiresMin * 60 * 1000);
	                context.cookie.set({
	                    key: name,
	                    value: args[name],
	                    path: '/',
	                    expires: expires
	                });
	            }
	        };
	    },
	    tryGetArgFromCookie: function tryGetArgFromCookie(name) {
	        return function (args, state, output, _ref7) {
	            var context = _ref7.context;
	
	            var value = context.cookie.get(name);
	            if (value && value.length > 0) {
	                args[name] = value;
	                output.success();
	                return;
	            }
	            output.fail();
	        };
	    },
	    unsetCookie: function unsetCookie(name) {
	        return function (args, state, output, _ref8) {
	            var context = _ref8.context;
	
	            var expires = new Date(Date.now() - 1000);
	            context.cookie.set({
	                key: name,
	                value: '',
	                path: '/',
	                expires: expires
	            });
	        };
	    },
	    toggleItem: function toggleItem(path, value) {
	        return function (args, state) {
	            var values = state.get(path) || new Array(0);
	            var index = _.indexOf(values, value);
	            if (index > -1) {
	                state.unset(path.concat(index));
	            } else {
	                var newValues = _.clone(values);
	                newValues.push(value);
	                state.set(path, newValues);
	            }
	        };
	    },
	    toggleBool: function toggleBool(path) {
	        return function (args, state) {
	            var value = state.get(path) || false;
	            state.set(path, !value);
	        };
	    },
	    toggleBoolFromArgs: function toggleBoolFromArgs(_ref9, state) {
	        var path = _ref9.path;
	
	        var value = state.get(path) || false;
	        state.set(path, !value);
	    },
	    throwErrorServer: function throwErrorServer(args, state, output, _ref10) {
	        var context = _ref10.context;
	
	        if (!context.isServer) {
	            return;
	        }
	        throw Error('SERVER OSHIBKA UNHADLED');
	    },
	    consoleLog: function consoleLog(message) {
	        return function () {
	            console.log(message);
	        };
	    },
	    consoleLogArgs: function consoleLogArgs(args) {
	        console.log(args);
	    },
	    consoleLogArg: function consoleLogArg(name) {
	        return function (args) {
	            console.log(args[name]);
	        };
	    },
	    consoleLogState: function consoleLogState(path) {
	        return function (args, state) {
	            console.log(state.get(path));
	        };
	    },
	    setElementValue: function setElementValue(_ref11, state) {
	        var id = _ref11.id,
	            path = _ref11.path;
	
	        var value = state.get(path);
	        if (value !== undefined) {
	            document.getElementById(id).value = value;
	        }
	    },
	    setElementValueById: function setElementValueById(id, value) {
	        return function (args, state) {
	            var element = document.getElementById(id);
	            if (element) {
	                element.value = value;
	            }
	        };
	    },
	    setItemToLocalStorage: function setItemToLocalStorage(storageItemName, inputName) {
	        return function (args, state, output, _ref12) {
	            var context = _ref12.context,
	                locator = _ref12.locator;
	
	            if (context.isServer) {
	                return;
	            }
	            var window = locator.resolve('window');
	            window.localStorage.setItem(storageItemName, JSON.stringify(args[inputName]));
	        };
	    },
	    getItemFromLocalStorage: function getItemFromLocalStorage(storageItemName, outputName) {
	        return function (args, state, output, _ref13) {
	            var context = _ref13.context,
	                locator = _ref13.locator;
	
	            if (context.isServer) {
	                output.unavailable();
	                return;
	            }
	            var window = locator.resolve('window');
	            var serialized = window.localStorage.getItem(storageItemName);
	
	            if (!serialized) {
	                output.notExists({});
	                return;
	            }
	
	            var result = {};
	            result[outputName] = null;
	            try {
	                result[outputName] = JSON.parse(serialized);
	            } catch (e) {
	                output.notExists({});
	                return;
	            }
	
	            output.success(result);
	        };
	    },
	    isArgEqual: function isArgEqual(argName, value) {
	        return function (args, state, output) {
	            if (args[argName] === value) {
	                output.yes();
	            } else {
	                output.no();
	            }
	        };
	    },
	    isEqual: function isEqual(path, value) {
	        return function (args, state, output) {
	            if (state.get(path) === value) {
	                output.yes();
	            } else {
	                output.no();
	            }
	        };
	    },
	    isDefined: function isDefined(path) {
	        return function (args, state, output) {
	            if (state.get(path)) {
	                output.yes();
	            } else {
	                output.no();
	            }
	        };
	    },
	    isObjectDefinedAndNotEmpty: function isObjectDefinedAndNotEmpty(path) {
	        return function (args, state, output) {
	            var value = state.get(path);
	            if (value && Object.keys(value).length !== 0) {
	                output.yes();
	            } else {
	                output.no();
	            }
	        };
	    },
	    isArgNotNull: function isArgNotNull(argName) {
	        return function (args, state, output) {
	            if (args[argName]) {
	                output.yes();
	            } else {
	                output.no();
	            }
	        };
	    },
	    isArgsEqual: function isArgsEqual(arg1, arg2) {
	        return function (args, state, output) {
	            if (args[arg1] === args[arg2]) {
	                output.yes();
	            } else {
	                output.no();
	            }
	        };
	    },
	    isConditionTrue: function isConditionTrue(path, value, condition) {
	        return function (args, state, output) {
	            if (condition(state.get(path), value)) {
	                output.yes();
	            } else {
	                output.no();
	            }
	        };
	    },
	    toggleElementById: function toggleElementById(id) {
	        return function () {
	            var element = document.getElementById(id);
	            if (element) {
	                element.disabled = !element.disabled;
	            }
	        };
	    },
	    setElementVisibilityById: function setElementVisibilityById(id, value) {
	        return function () {
	            var element = document.getElementById(id);
	            if (element) {
	                element.style.visibility = value;
	            }
	        };
	    },
	    setPopupVisibility: function setPopupVisibility(name, path) {
	        return function (args, state) {
	            state.set(path, monkey([['popups', 'active'], function (popups) {
	                return _.includes(popups, name);
	            }]));
	        };
	    },
	    logOnWebApi: function logOnWebApi(message, level) {
	        return function (args, state, output, _ref14) {
	            var locator = _ref14.locator,
	                context = _ref14.context;
	
	            var api = locator.resolve('api');
	            var user = state.get(['user']);
	            var request = api.logOnWebApi(context, locator, { level: level,
	                message: message + ' ' + JSON.stringify(user) });
	
	            request.then(function (response) {
	                var code = _.get(response, 'status.code');
	                if (code !== 200) {
	                    output.error({ error: code });
	                }
	            }).catch(function (error) {
	                output.error({ error: error });
	            });
	        };
	    },
	    checkIsCookieEnabled: function checkIsCookieEnabled(args, state, output, _ref15) {
	        var context = _ref15.context;
	
	        if (context.isServer) {
	            output.server();
	            return;
	        }
	        var expires = new Date(Date.now() + 60 * 1000);
	        var key = 'datumlib.test.cookie';
	        context.cookie.set({
	            key: key,
	            value: key,
	            path: '/',
	            expires: expires
	        });
	        if (context.cookie.get(key)) {
	            output.yes();
	            return;
	        }
	        output.no();
	    }
	};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(10);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(3);
	
	function validateValue(value, locator) {
	    if (value && typeof value !== 'number') {
	        locator.resolve('logger').error('Value metric: ' + value + ' must be a number');
	
	        return false;
	    }
	
	    return true;
	}
	
	function validateArgs(category, resultAction) {
	    var _arguments = arguments;
	
	    return new Promise(function (res, rej) {
	        if (!_.isString(category) || !resultAction) {
	            return rej('Unrecognized validateArgs arguments: ' + [].join.call(_arguments));
	        }
	
	        res(Array.prototype.slice.call(_arguments));
	    });
	}
	
	module.exports = {
	    parseUtmFromQuery: function parseUtmFromQuery(args, state, output, _ref) {
	        var context = _ref.context;
	
	        var utils = __webpack_require__(4);
	
	        if (context.location.query) {
	            var utm = _.pick(context.location.query.values, ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content']);
	            state.set('utm', utm);
	        }
	    },
	    pageview: function pageview(args, state, output, _ref2) {
	        var locator = _ref2.locator,
	            context = _ref2.context;
	
	        if (context.isServer) {
	            return;
	        }
	
	        var analytics = locator.resolve('analytics');
	        var title = state.get('title');
	        var role = state.get(['user', 'role']);
	
	        analytics.pageview({ title: title, role: role });
	    },
	    event: function event(category, action, label, value) {
	        return function customEvent(args, state, output, _ref3) {
	            var locator = _ref3.locator,
	                context = _ref3.context;
	
	            if (context.isServer) {
	                return;
	            }
	
	            if (!validateValue(value, locator)) {
	                return;
	            }
	
	            var analytics = locator.resolve('analytics');
	            var role = state.get(['user', 'role']);
	
	            analytics.event({ role: role }, category, action, label, value);
	        };
	    },
	    argsValueEvent: function argsValueEvent(_ref4) {
	        var category = _ref4.category,
	            action = _ref4.action,
	            label = _ref4.label,
	            argsAction = _ref4.argsAction,
	            argsLabel = _ref4.argsLabel,
	            valueField = _ref4.valueField;
	
	        return function stateValueEvent(args, state, output, _ref5) {
	            var locator = _ref5.locator,
	                context = _ref5.context;
	
	            if (context.isServer) {
	                return;
	            }
	
	            var role = state.get(['user', 'role']);
	
	            var actionValue = args[argsAction];
	            var labelValue = args[argsLabel];
	            var metricValue = args[valueField];
	
	            var value = valueField ? metricValue : null;
	            var resultAction = _.isString(action) ? action : action[actionValue];
	            var resultLabel = label && (_.isString(label) ? label : label[labelValue]);
	
	            if (!validateValue(value, locator)) {
	                return;
	            }
	
	            validateArgs(category, resultAction, resultLabel, value).then(function (event) {
	                var _locator$resolve;
	
	                return (_locator$resolve = locator.resolve('analytics')).event.apply(_locator$resolve, [{ role: role }].concat(event));
	            }).catch(function (err) {
	                return err && locator.resolve('logger').error(err);
	            });
	        };
	    },
	    raiseArgsValueEvent: function raiseArgsValueEvent(_ref6, state, output, _ref7) {
	        var category = _ref6.category,
	            action = _ref6.action,
	            label = _ref6.label,
	            value = _ref6.value;
	        var locator = _ref7.locator,
	            context = _ref7.context;
	
	        if (context.isServer) {
	            return;
	        }
	
	        if (!validateValue(value, locator)) {
	            return;
	        }
	
	        var role = state.get(['user', 'role']);
	        validateArgs(category, action, label, value).then(function (event) {
	            var _locator$resolve2;
	
	            return (_locator$resolve2 = locator.resolve('analytics')).event.apply(_locator$resolve2, [{ role: role }].concat(event));
	        }).catch(function (err) {
	            return err && locator.resolve('logger').error(err);
	        });
	    },
	    fillEvent: function fillEvent(args, state, output) {
	        if (!args.value) {
	            output.noEvent();
	        }
	
	        delete args.value;
	        output.filled({ action: args.action });
	    },
	    fillEventFromTreeChecked: function fillEventFromTreeChecked(args, state, output) {
	        if (!args.value) {
	            output.noEvent();
	        }
	
	        delete args.value;
	        output.filled({ action: 'input' });
	    },
	    fillEventArgsFromAdditionalParamSet: function fillEventArgsFromAdditionalParamSet(args, state, output) {
	        if (args.value == false) {
	            output.noEvent();
	            return;
	        }
	
	        var column = _.find(state.get(['order', 'originalParameters', 'exportColumns', 'columns']), function (x) {
	            return x.id == Number(args.path);
	        });
	
	        var metricEvent = args.metricEventPrefix + column.propertyName.toLowerCase();
	
	        delete args.value;
	        output.filled({ category: metricEvent, action: 'input' });
	    },
	    fillEventOnOrderLoaded: function fillEventOnOrderLoaded(args, state, output) {
	        var metricEvent = void 0;
	        switch (state.get(['account', 'orders', 'currentOrder', 'stateId'])) {
	            case 1:
	                metricEvent = 'open_order_page_draft';
	                break;
	
	            case 2:
	                metricEvent = 'open_order_page_invoice_hold';
	                break;
	
	            case 3:
	                metricEvent = 'open_order_page_money_hold';
	                break;
	
	            case 4:
	                metricEvent = 'open_order_page_paid';
	                break;
	
	            case 5:
	                metricEvent = 'open_order_page_paid';
	                break;
	
	            case 6:
	                metricEvent = 'open_order_page_archive';
	                break;
	            default:
	                output.noEvent();
	                return;
	        }
	
	        output.filled({ category: metricEvent, action: 'see' });
	    },
	    fillEventIfBillAttached: function fillEventIfBillAttached(args, state, output) {
	        var documents = state.get(['account', 'orders', 'currentOrder', 'necessaryDocuments']);
	        var stateId = state.get(['account', 'orders', 'currentOrder', 'stateId']);
	
	        if (stateId >= 4) {
	            output.noEvent();
	            return;
	        }
	
	        var billDocuments = _.filter(documents, function (doc) {
	            return doc.typeId === 1 && doc.id;
	        });
	
	        if (billDocuments.length > 0) {
	            output.filled({ category: 'open_order_page_invoice_loaded', action: 'see' });
	            return;
	        }
	
	        output.noEvent();
	    }
	};

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 9 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 10 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	var redirect = __webpack_require__(35);
	var error = __webpack_require__(19);
	
	function usingLock(lockPath) {
	    var actions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	    return [utils.isEqual(lockPath, true), {
	        yes: [],
	        no: [utils.set(lockPath, true)].concat(actions, [utils.unset(lockPath)])
	    }];
	}
	
	module.exports = {
	    redirect: [redirect.redirectFromArgs],
	
	    redirectLogin: [utils.set(['layout'], 'auth'), utils.set(['page', 'components', 0, 'name'], 'login'), utils.set(['page', 'components', 0, 'id'], 'login'), redirect.redirect('/login')],
	
	    usingLock: usingLock,
	
	    logOnWebApi: function logOnWebApi(message, level) {
	        return [[utils.logOnWebApi(message, level), {
	            error: [error.internalError('logOnWebApi')]
	        }]];
	    },
	    toggleItem: function toggleItem(path, value) {
	        return [utils.toggleItem(path, value)];
	    },
	    toggleBool: function toggleBool(path) {
	        return [utils.toggleBool(path)];
	    },
	
	
	    togglePopupFromArgs: [utils.togglePopupFromArgs],
	
	    togglePopup: function togglePopup(name) {
	        return [utils.togglePopup(name)];
	    },
	    setFromArgsToState: function setFromArgsToState(argName, path) {
	        return [utils.setFromArgsToState(argName, path)];
	    },
	    unset: function unset(path) {
	        return [utils.unset(path)];
	    },
	
	
	    checkCookieEnabled: [[utils.checkIsCookieEnabled, {
	        yes: [],
	        no: [error.cookieDisabled('checkCookieEnabled')],
	        server: []
	    }]]
	};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v2.2.4
	 * http://jquery.com/
	 *
	 * Includes Sizzle.js
	 * http://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2016-05-20T17:23Z
	 */
	
	(function( global, factory ) {
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Support: Firefox 18+
	// Can't be in strict mode, several libs including ASP.NET trace
	// the stack via arguments.caller.callee and Firefox dies if
	// you try to trace through "use strict" call chains. (#13335)
	//"use strict";
	var arr = [];
	
	var document = window.document;
	
	var slice = arr.slice;
	
	var concat = arr.concat;
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var support = {};
	
	
	
	var
		version = "2.2.4",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android<4.1
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
	
		// Matches dashed string for camelizing
		rmsPrefix = /^-ms-/,
		rdashAlpha = /-([\da-z])/gi,
	
		// Used by jQuery.camelCase as callback to replace()
		fcamelCase = function( all, letter ) {
			return letter.toUpperCase();
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// Start with an empty selector
		selector: "",
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
			return num != null ?
	
				// Return just the one element from the set
				( num < 0 ? this[ num + this.length ] : this[ num ] ) :
	
				// Return all the elements in a clean array
				slice.call( this );
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
			ret.context = this.context;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = jQuery.isArray( copy ) ) ) ) {
	
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && jQuery.isArray( src ) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject( src ) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isFunction: function( obj ) {
			return jQuery.type( obj ) === "function";
		},
	
		isArray: Array.isArray,
	
		isWindow: function( obj ) {
			return obj != null && obj === obj.window;
		},
	
		isNumeric: function( obj ) {
	
			// parseFloat NaNs numeric-cast false positives (null|true|false|"")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			// adding 1 corrects loss of precision from parseFloat (#15100)
			var realStringObj = obj && obj.toString();
			return !jQuery.isArray( obj ) && ( realStringObj - parseFloat( realStringObj ) + 1 ) >= 0;
		},
	
		isPlainObject: function( obj ) {
			var key;
	
			// Not plain objects:
			// - Any object or value whose internal [[Class]] property is not "[object Object]"
			// - DOM nodes
			// - window
			if ( jQuery.type( obj ) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
				return false;
			}
	
			// Not own constructor property must be Object
			if ( obj.constructor &&
					!hasOwn.call( obj, "constructor" ) &&
					!hasOwn.call( obj.constructor.prototype || {}, "isPrototypeOf" ) ) {
				return false;
			}
	
			// Own properties are enumerated firstly, so to speed up,
			// if last one is own, then all properties are own
			for ( key in obj ) {}
	
			return key === undefined || hasOwn.call( obj, key );
		},
	
		isEmptyObject: function( obj ) {
			var name;
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		type: function( obj ) {
			if ( obj == null ) {
				return obj + "";
			}
	
			// Support: Android<4.0, iOS<6 (functionish RegExp)
			return typeof obj === "object" || typeof obj === "function" ?
				class2type[ toString.call( obj ) ] || "object" :
				typeof obj;
		},
	
		// Evaluates a script in a global context
		globalEval: function( code ) {
			var script,
				indirect = eval;
	
			code = jQuery.trim( code );
	
			if ( code ) {
	
				// If the code includes a valid, prologue position
				// strict mode pragma, execute code by injecting a
				// script tag into the document.
				if ( code.indexOf( "use strict" ) === 1 ) {
					script = document.createElement( "script" );
					script.text = code;
					document.head.appendChild( script ).parentNode.removeChild( script );
				} else {
	
					// Otherwise, avoid the DOM node creation, insertion
					// and removal by using an indirect global eval
	
					indirect( code );
				}
			}
		},
	
		// Convert dashed to camelCase; used by the css and data modules
		// Support: IE9-11+
		// Microsoft forgot to hump their vendor prefix (#9572)
		camelCase: function( string ) {
			return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
		},
	
		nodeName: function( elem, name ) {
			return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android<4.1
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// Bind a function to a context, optionally partially applying any
		// arguments.
		proxy: function( fn, context ) {
			var tmp, args, proxy;
	
			if ( typeof context === "string" ) {
				tmp = fn[ context ];
				context = fn;
				fn = tmp;
			}
	
			// Quick check to determine if target is callable, in the spec
			// this throws a TypeError, but we will just return undefined.
			if ( !jQuery.isFunction( fn ) ) {
				return undefined;
			}
	
			// Simulated bind
			args = slice.call( arguments, 2 );
			proxy = function() {
				return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
			};
	
			// Set the guid of unique handler to the same of original handler, so it can be removed
			proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
			return proxy;
		},
	
		now: Date.now,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	// JSHint would error on this code due to the Symbol not being defined in ES5.
	// Defining this global in .jshintrc would create a danger of using the global
	// unguarded in another place, it seems safer to just disable JSHint for these
	// three lines.
	/* jshint ignore: start */
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	/* jshint ignore: end */
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: iOS 8.2 (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = jQuery.type( obj );
	
		if ( type === "function" || jQuery.isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.2.1
	 * http://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2015-10-17
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// General-purpose constants
		MAX_NEGATIVE = 1 << 31,
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// http://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
		rescape = /'|\\/g,
	
		// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		};
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, nidselect, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
	
			if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
				setDocument( context );
			}
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
	
					// ID selector
					if ( (m = match[1]) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( (elem = context.getElementById( m )) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && (elem = newContext.getElementById( m )) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[2] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( (m = match[3]) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!compilerCache[ selector + " " ] &&
					(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
	
					if ( nodeType !== 1 ) {
						newContext = context;
						newSelector = selector;
	
					// qSA looks outside Element context, which is not what we want
					// Thanks to Andrew Dupont for this workaround technique
					// Support: IE <=8
					// Exclude object elements
					} else if ( context.nodeName.toLowerCase() !== "object" ) {
	
						// Capture the context ID, setting it first if necessary
						if ( (nid = context.getAttribute( "id" )) ) {
							nid = nid.replace( rescape, "\\$&" );
						} else {
							context.setAttribute( "id", (nid = expando) );
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						nidselect = ridentifier.test( nid ) ? "#" + nid : "[id='" + nid + "']";
						while ( i-- ) {
							groups[i] = nidselect + " " + toSelector( groups[i] );
						}
						newSelector = groups.join( "," );
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
					}
	
					if ( newSelector ) {
						try {
							push.apply( results,
								newContext.querySelectorAll( newSelector )
							);
							return results;
						} catch ( qsaError ) {
						} finally {
							if ( nid === expando ) {
								context.removeAttribute( "id" );
							}
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created div and expects a boolean result
	 */
	function assert( fn ) {
		var div = document.createElement("div");
	
		try {
			return !!fn( div );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( div.parentNode ) {
				div.parentNode.removeChild( div );
			}
			// release memory in IE
			div = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				( ~b.sourceIndex || MAX_NEGATIVE ) -
				( ~a.sourceIndex || MAX_NEGATIVE );
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, parent,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9-11, Edge
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		if ( (parent = document.defaultView) && parent.top !== parent ) {
			// Support: IE 11
			if ( parent.addEventListener ) {
				parent.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( parent.attachEvent ) {
				parent.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( div ) {
			div.className = "i";
			return !div.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( div ) {
			div.appendChild( document.createComment("") );
			return !div.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( div ) {
			docElem.appendChild( div ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		});
	
		// ID find and filter
		if ( support.getById ) {
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var m = context.getElementById( id );
					return m ? [ m ] : [];
				}
			};
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
		} else {
			// Support: IE6/7
			// getElementById is not reliable as a find shortcut
			delete Expr.find["ID"];
	
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See http://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( div ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// http://bugs.jquery.com/ticket/12359
				docElem.appendChild( div ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( div.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !div.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !div.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibing-combinator selector` fails
				if ( !div.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( div ) {
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement("input");
				input.setAttribute( "type", "hidden" );
				div.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( div.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":enabled").length ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				div.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( div ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( div, "div" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( div, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === document ? -1 :
					b === document ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			!compilerCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || (node[ expando ] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
								// Use previously-cached element index if available
								if ( useCache ) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || (node[ expando ] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										(outerCache[ node.uniqueID ] = {});
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
									// Use the same loop as above to seek `elem` from the start
									while ( (node = ++nodeIndex && node && node[ dir ] ||
										(diff = nodeIndex = 0) || start.pop()) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] || (node[ expando ] = {});
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													(outerCache[ node.uniqueID ] = {});
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": function( elem ) {
				return elem.disabled === false;
			},
	
			"disabled": function( elem ) {
				return elem.disabled === true;
			},
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			checkNonElements = base && dir === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
	
							if ( (oldCache = uniqueCache[ dir ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ dir ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context === document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						if ( !context && elem.ownerDocument !== document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context || document, xml) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					support.getById && context.nodeType === 9 && documentIsHTML &&
					Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( div1 ) {
		// Should return 1, but returns 4 (following)
		return div1.compareDocumentPosition( document.createElement("div") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( div ) {
		div.innerHTML = "<a href='#'></a>";
		return div.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( div ) {
		div.innerHTML = "<input/>";
		div.firstChild.setAttribute( "value", "" );
		return div.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( div ) {
		return div.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	var rsingleTag = ( /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/ );
	
	
	
	var risSimple = /^.[^:#\[\.,]*$/;
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( jQuery.isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				/* jshint -W018 */
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
	
		}
	
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
	
		}
	
		if ( typeof qualifier === "string" ) {
			if ( risSimple.test( qualifier ) ) {
				return jQuery.filter( qualifier, elements, not );
			}
	
			qualifier = jQuery.filter( qualifier, elements );
		}
	
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		return elems.length === 1 && elem.nodeType === 1 ?
			jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
			jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
				return elem.nodeType === 1;
			} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i,
				len = this.length,
				ret = [],
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			// Needed because $( selector, context ) becomes $( context ).find( selector )
			ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
			ret.selector = this.selector ? this.selector + " " + selector : selector;
			return ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( jQuery.isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						// Support: Blackberry 4.6
						// gEBID returns nodes no longer in the document (#6963)
						if ( elem && elem.parentNode ) {
	
							// Inject the element directly into the jQuery object
							this.length = 1;
							this[ 0 ] = elem;
						}
	
						this.context = document;
						this.selector = selector;
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this.context = this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( jQuery.isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			if ( selector.selector !== undefined ) {
				this.selector = selector.selector;
				this.context = selector.context;
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
					jQuery( selectors, context || this.context ) :
					0;
	
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
					// Always skip document fragments
					if ( cur.nodeType < 11 && ( pos ?
						pos.index( cur ) > -1 :
	
						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
						matched.push( cur );
						break;
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			return elem.contentDocument || jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnotwhite = ( /\S+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( jQuery.isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, listener list, final state
					[ "resolve", "done", jQuery.Callbacks( "once memory" ), "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ), "rejected" ],
					[ "notify", "progress", jQuery.Callbacks( "memory" ) ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					then: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
								var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];
	
								// deferred[ done | fail | progress ] for forwarding actions to newDefer
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && jQuery.isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this === promise ? newDefer.promise() : this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Keep pipe for back-compat
			promise.pipe = promise.then;
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 3 ];
	
				// promise[ done | fail | progress ] = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add( function() {
	
						// state = [ resolved | rejected ]
						state = stateString;
	
					// [ reject_list | resolve_list ].disable; progress_list.lock
					}, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
				}
	
				// deferred[ resolve | reject | notify ]
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? promise : this, arguments );
					return this;
				};
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( subordinate /* , ..., subordinateN */ ) {
			var i = 0,
				resolveValues = slice.call( arguments ),
				length = resolveValues.length,
	
				// the count of uncompleted subordinates
				remaining = length !== 1 ||
					( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,
	
				// the master Deferred.
				// If resolveValues consist of only a single Deferred, just use that.
				deferred = remaining === 1 ? subordinate : jQuery.Deferred(),
	
				// Update function for both resolve and progress values
				updateFunc = function( i, contexts, values ) {
					return function( value ) {
						contexts[ i ] = this;
						values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( values === progressValues ) {
							deferred.notifyWith( contexts, values );
						} else if ( !( --remaining ) ) {
							deferred.resolveWith( contexts, values );
						}
					};
				},
	
				progressValues, progressContexts, resolveContexts;
	
			// Add listeners to Deferred subordinates; treat others as resolved
			if ( length > 1 ) {
				progressValues = new Array( length );
				progressContexts = new Array( length );
				resolveContexts = new Array( length );
				for ( ; i < length; i++ ) {
					if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
						resolveValues[ i ].promise()
							.progress( updateFunc( i, progressContexts, progressValues ) )
							.done( updateFunc( i, resolveContexts, resolveValues ) )
							.fail( deferred.reject );
					} else {
						--remaining;
					}
				}
			}
	
			// If we're not waiting on anything, resolve the master
			if ( !remaining ) {
				deferred.resolveWith( resolveContexts, resolveValues );
			}
	
			return deferred.promise();
		}
	} );
	
	
	// The deferred used on DOM ready
	var readyList;
	
	jQuery.fn.ready = function( fn ) {
	
		// Add the callback
		jQuery.ready.promise().done( fn );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Hold (or release) the ready event
		holdReady: function( hold ) {
			if ( hold ) {
				jQuery.readyWait++;
			} else {
				jQuery.ready( true );
			}
		},
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
	
			// Trigger any bound ready events
			if ( jQuery.fn.triggerHandler ) {
				jQuery( document ).triggerHandler( "ready" );
				jQuery( document ).off( "ready" );
			}
		}
	} );
	
	/**
	 * The ready event handler and self cleanup method
	 */
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	jQuery.ready.promise = function( obj ) {
		if ( !readyList ) {
	
			readyList = jQuery.Deferred();
	
			// Catch cases where $(document).ready() is called
			// after the browser event has already occurred.
			// Support: IE9-10 only
			// Older IE sometimes signals "interactive" too soon
			if ( document.readyState === "complete" ||
				( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
				// Handle it asynchronously to allow scripts the opportunity to delay ready
				window.setTimeout( jQuery.ready );
	
			} else {
	
				// Use the handy event callback
				document.addEventListener( "DOMContentLoaded", completed );
	
				// A fallback to window.onload, that will always work
				window.addEventListener( "load", completed );
			}
		}
		return readyList.promise( obj );
	};
	
	// Kick off the DOM ready check even if the user does not
	jQuery.ready.promise();
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( jQuery.type( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !jQuery.isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		return chainable ?
			elems :
	
			// Gets
			bulk ?
				fn.call( elems ) :
				len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		/* jshint -W018 */
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		register: function( owner, initial ) {
			var value = initial || {};
	
			// If it is a node unlikely to be stringify-ed or looped over
			// use plain assignment
			if ( owner.nodeType ) {
				owner[ this.expando ] = value;
	
			// Otherwise secure it in a non-enumerable, non-writable property
			// configurability must be true to allow the property to be
			// deleted with the delete operator
			} else {
				Object.defineProperty( owner, this.expando, {
					value: value,
					writable: true,
					configurable: true
				} );
			}
			return owner[ this.expando ];
		},
		cache: function( owner ) {
	
			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( !acceptData( owner ) ) {
				return {};
			}
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			if ( typeof data === "string" ) {
				cache[ data ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ prop ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
				owner[ this.expando ] && owner[ this.expando ][ key ];
		},
		access: function( owner, key, value ) {
			var stored;
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				stored = this.get( owner, key );
	
				return stored !== undefined ?
					stored : this.get( owner, jQuery.camelCase( key ) );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i, name, camel,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key === undefined ) {
				this.register( owner );
	
			} else {
	
				// Support array or space separated string of keys
				if ( jQuery.isArray( key ) ) {
	
					// If "name" is an array of keys...
					// When data is initially created, via ("key", "val") signature,
					// keys will be converted to camelCase.
					// Since there is no way to tell _how_ a key was added, remove
					// both plain key and camelCase key. #12786
					// This will only penalize the array argument path.
					name = key.concat( key.map( jQuery.camelCase ) );
				} else {
					camel = jQuery.camelCase( key );
	
					// Try the string as a key before any manipulation
					if ( key in cache ) {
						name = [ key, camel ];
					} else {
	
						// If a key with the spaces exists, use it.
						// Otherwise, create an array by matching non-whitespace
						name = camel;
						name = name in cache ?
							[ name ] : ( name.match( rnotwhite ) || [] );
					}
				}
	
				i = name.length;
	
				while ( i-- ) {
					delete cache[ name[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <= 35-45+
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://code.google.com/p/chromium/issues/detail?id=378607
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = data === "true" ? true :
						data === "false" ? false :
						data === "null" ? null :
	
						// Only convert to a number if it doesn't change the string
						+data + "" === data ? +data :
						rbrace.test( data ) ? jQuery.parseJSON( data ) :
						data;
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE11+
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = jQuery.camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data, camelKey;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// with the key as-is
					data = dataUser.get( elem, key ) ||
	
						// Try to find dashed key if it exists (gh-2779)
						// This is for 2.2.x only
						dataUser.get( elem, key.replace( rmultiDash, "-$&" ).toLowerCase() );
	
					if ( data !== undefined ) {
						return data;
					}
	
					camelKey = jQuery.camelCase( key );
	
					// Attempt to get data from the cache
					// with the key camelized
					data = dataUser.get( elem, camelKey );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, camelKey, undefined );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				camelKey = jQuery.camelCase( key );
				this.each( function() {
	
					// First, attempt to store a copy or reference of any
					// data that might've been store with a camelCased key.
					var data = dataUser.get( this, camelKey );
	
					// For HTML5 data-* attribute interop, we have to
					// store property names with dashes in a camelCase form.
					// This might not apply to all properties...*
					dataUser.set( this, camelKey, value );
	
					// *... In the case of properties that might _actually_
					// have dashes, we need to also store a copy of that
					// unchanged property.
					if ( key.indexOf( "-" ) > -1 && data !== undefined ) {
						dataUser.set( this, key, value );
					}
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || jQuery.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var isHidden = function( elem, el ) {
	
			// isHidden might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
			return jQuery.css( elem, "display" ) === "none" ||
				!jQuery.contains( elem.ownerDocument, elem );
		};
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted,
			scale = 1,
			maxIterations = 20,
			currentValue = tween ?
				function() { return tween.cur(); } :
				function() { return jQuery.css( elem, prop, "" ); },
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			do {
	
				// If previous iteration zeroed out, double until we get *something*.
				// Use string for doubling so we don't accidentally see scale as unchanged below
				scale = scale || ".5";
	
				// Adjust and apply
				initialInUnit = initialInUnit / scale;
				jQuery.style( elem, prop, initialInUnit + unit );
	
			// Update scale, tolerating zero or NaN from tween.cur()
			// Break the loop if scale is unchanged or perfect, or if we've just had enough.
			} while (
				scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
			);
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([\w:-]+)/ );
	
	var rscriptType = ( /^$|\/(?:java|ecma)script/i );
	
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// Support: IE9
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	// Support: IE9
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function getAll( context, tag ) {
	
		// Support: IE9-11+
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret = typeof context.getElementsByTagName !== "undefined" ?
				context.getElementsByTagName( tag || "*" ) :
				typeof context.querySelectorAll !== "undefined" ?
					context.querySelectorAll( tag || "*" ) :
				[];
	
		return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
			jQuery.merge( [ context ], ret ) :
			ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, contains, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( jQuery.type( elem ) === "object" ) {
	
					// Support: Android<4.1, PhantomJS<2
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android<4.1, PhantomJS<2
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			contains = jQuery.contains( elem.ownerDocument, elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0-4.3, Safari<=5.1
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Safari<=5.1, Android<4.2
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE<=11+
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	} )();
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE9
	// See #13393 for more info
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = {};
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( event ) {
	
			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( event );
	
			var i, j, ret, matched, handleObj,
				handlerQueue = [],
				args = slice.call( arguments ),
				handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, matches, sel, handleObj,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Support (at least): Chrome, IE9
			// Find delegate handlers
			// Black-hole SVG <use> instance trees (#13180)
			//
			// Support: Firefox<=42+
			// Avoid non-left-click in FF but don't block IE radio events (#3861, gh-2343)
			if ( delegateCount && cur.nodeType &&
				( event.type !== "click" || isNaN( event.button ) || event.button < 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && ( cur.disabled !== true || event.type !== "click" ) ) {
						matches = [];
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matches[ sel ] === undefined ) {
								matches[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matches[ sel ] ) {
								matches.push( handleObj );
							}
						}
						if ( matches.length ) {
							handlerQueue.push( { elem: cur, handlers: matches } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: this, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		// Includes some event props shared by KeyEvent and MouseEvent
		props: ( "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase " +
			"metaKey relatedTarget shiftKey target timeStamp view which" ).split( " " ),
	
		fixHooks: {},
	
		keyHooks: {
			props: "char charCode key keyCode".split( " " ),
			filter: function( event, original ) {
	
				// Add which for key events
				if ( event.which == null ) {
					event.which = original.charCode != null ? original.charCode : original.keyCode;
				}
	
				return event;
			}
		},
	
		mouseHooks: {
			props: ( "button buttons clientX clientY offsetX offsetY pageX pageY " +
				"screenX screenY toElement" ).split( " " ),
			filter: function( event, original ) {
				var eventDoc, doc, body,
					button = original.button;
	
				// Calculate pageX/Y if missing and clientX/Y available
				if ( event.pageX == null && original.clientX != null ) {
					eventDoc = event.target.ownerDocument || document;
					doc = eventDoc.documentElement;
					body = eventDoc.body;
	
					event.pageX = original.clientX +
						( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) -
						( doc && doc.clientLeft || body && body.clientLeft || 0 );
					event.pageY = original.clientY +
						( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) -
						( doc && doc.clientTop  || body && body.clientTop  || 0 );
				}
	
				// Add which for click: 1 === left; 2 === middle; 3 === right
				// Note: button is not normalized, so don't use it
				if ( !event.which && button !== undefined ) {
					event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
				}
	
				return event;
			}
		},
	
		fix: function( event ) {
			if ( event[ jQuery.expando ] ) {
				return event;
			}
	
			// Create a writable copy of the event object and normalize some properties
			var i, prop, copy,
				type = event.type,
				originalEvent = event,
				fixHook = this.fixHooks[ type ];
	
			if ( !fixHook ) {
				this.fixHooks[ type ] = fixHook =
					rmouseEvent.test( type ) ? this.mouseHooks :
					rkeyEvent.test( type ) ? this.keyHooks :
					{};
			}
			copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;
	
			event = new jQuery.Event( originalEvent );
	
			i = copy.length;
			while ( i-- ) {
				prop = copy[ i ];
				event[ prop ] = originalEvent[ prop ];
			}
	
			// Support: Cordova 2.5 (WebKit) (#13255)
			// All events should have a target; Cordova deviceready doesn't
			if ( !event.target ) {
				event.target = document;
			}
	
			// Support: Safari 6.0+, Chrome<28
			// Target should not be a text node (#504, #13143)
			if ( event.target.nodeType === 3 ) {
				event.target = event.target.parentNode;
			}
	
			return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
	
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						this.focus();
						return false;
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
	
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( this.type === "checkbox" && this.click && jQuery.nodeName( this, "input" ) ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return jQuery.nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android<4.0
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || jQuery.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://code.google.com/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,
	
		// Support: IE 10-11, Edge 10240+
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rscriptTypeMasked = /^true\/(.*)/,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Manipulating tables requires a tbody
	function manipulationTarget( elem, content ) {
		return jQuery.nodeName( elem, "table" ) &&
			jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?
	
			elem.getElementsByTagName( "tbody" )[ 0 ] ||
				elem.appendChild( elem.ownerDocument.createElement( "tbody" ) ) :
			elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		var match = rscriptTypeMasked.exec( elem.type );
	
		if ( match ) {
			elem.type = match[ 1 ];
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.access( src );
			pdataCur = dataPriv.set( dest, pdataOld );
			events = pdataOld.events;
	
			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = concat.apply( [], args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			isFunction = jQuery.isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( isFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( isFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android<4.1, PhantomJS<2
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								jQuery.globalEval( node.textContent.replace( rcleanScript, "" ) );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html.replace( rxhtmlTag, "<$1></$2>" );
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <= 35-45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <= 35-45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
	
		// Keep domManip exposed until 3.0 (gh-2225)
		domManip: domManip,
	
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: QtWebKit
				// .get() because push.apply(_, arraylike) throws
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	
	
	var iframe,
		elemdisplay = {
	
			// Support: Firefox
			// We have to pre-define these values for FF (#10227)
			HTML: "block",
			BODY: "block"
		};
	
	/**
	 * Retrieve the actual display of a element
	 * @param {String} name nodeName of the element
	 * @param {Object} doc Document object
	 */
	
	// Called only from within defaultDisplay
	function actualDisplay( name, doc ) {
		var elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),
	
			display = jQuery.css( elem[ 0 ], "display" );
	
		// We don't have any data stored on the element,
		// so use "detach" method as fast way to get rid of the element
		elem.detach();
	
		return display;
	}
	
	/**
	 * Try to determine the default display value of an element
	 * @param {String} nodeName
	 */
	function defaultDisplay( nodeName ) {
		var doc = document,
			display = elemdisplay[ nodeName ];
	
		if ( !display ) {
			display = actualDisplay( nodeName, doc );
	
			// If the simple way fails, read from inside an iframe
			if ( display === "none" || !display ) {
	
				// Use the already-created iframe if possible
				iframe = ( iframe || jQuery( "<iframe frameborder='0' width='0' height='0'/>" ) )
					.appendTo( doc.documentElement );
	
				// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
				doc = iframe[ 0 ].contentDocument;
	
				// Support: IE
				doc.write();
				doc.close();
	
				display = actualDisplay( nodeName, doc );
				iframe.detach();
			}
	
			// Store the correct default display
			elemdisplay[ nodeName ] = display;
		}
	
		return display;
	}
	var rmargin = ( /^margin/ );
	
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE<=11+, Firefox<=30+ (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var documentElement = document.documentElement;
	
	
	
	( function() {
		var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE9-11+
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
			"padding:0;margin-top:1px;position:absolute";
		container.appendChild( div );
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
			div.style.cssText =
	
				// Support: Firefox<29, Android 2.3
				// Vendor-prefix box-sizing
				"-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;" +
				"position:relative;display:block;" +
				"margin:auto;border:1px;padding:1px;" +
				"top:1%;width:50%";
			div.innerHTML = "";
			documentElement.appendChild( container );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
			reliableMarginLeftVal = divStyle.marginLeft === "2px";
			boxSizingReliableVal = divStyle.width === "4px";
	
			// Support: Android 4.0 - 4.3 only
			// Some styles come back with percentage values, even though they shouldn't
			div.style.marginRight = "50%";
			pixelMarginRightVal = divStyle.marginRight === "4px";
	
			documentElement.removeChild( container );
		}
	
		jQuery.extend( support, {
			pixelPosition: function() {
	
				// This test is executed only once but we still do memoizing
				// since we can use the boxSizingReliable pre-computing.
				// No need to check if the test was already performed, though.
				computeStyleTests();
				return pixelPositionVal;
			},
			boxSizingReliable: function() {
				if ( boxSizingReliableVal == null ) {
					computeStyleTests();
				}
				return boxSizingReliableVal;
			},
			pixelMarginRight: function() {
	
				// Support: Android 4.0-4.3
				// We're checking for boxSizingReliableVal here instead of pixelMarginRightVal
				// since that compresses better and they're computed together anyway.
				if ( boxSizingReliableVal == null ) {
					computeStyleTests();
				}
				return pixelMarginRightVal;
			},
			reliableMarginLeft: function() {
	
				// Support: IE <=8 only, Android 4.0 - 4.3 only, Firefox <=3 - 37
				if ( boxSizingReliableVal == null ) {
					computeStyleTests();
				}
				return reliableMarginLeftVal;
			},
			reliableMarginRight: function() {
	
				// Support: Android 2.3
				// Check if div with explicit width and no margin-right incorrectly
				// gets computed margin-right based on width of container. (#3333)
				// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
				// This support function is only executed once so no memoizing is needed.
				var ret,
					marginDiv = div.appendChild( document.createElement( "div" ) );
	
				// Reset CSS: box-sizing; display; margin; border; padding
				marginDiv.style.cssText = div.style.cssText =
	
					// Support: Android 2.3
					// Vendor-prefix box-sizing
					"-webkit-box-sizing:content-box;box-sizing:content-box;" +
					"display:block;margin:0;border:0;padding:0";
				marginDiv.style.marginRight = marginDiv.style.width = "0";
				div.style.width = "1px";
				documentElement.appendChild( container );
	
				ret = !parseFloat( window.getComputedStyle( marginDiv ).marginRight );
	
				documentElement.removeChild( container );
				div.removeChild( marginDiv );
	
				return ret;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
			style = elem.style;
	
		computed = computed || getStyles( elem );
		ret = computed ? computed.getPropertyValue( name ) || computed[ name ] : undefined;
	
		// Support: Opera 12.1x only
		// Fall back to style even without computed
		// computed is undefined for elems on document fragments
		if ( ( ret === "" || ret === undefined ) && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}
	
		// Support: IE9
		// getPropertyValue is only needed for .css('filter') (#12537)
		if ( computed ) {
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// http://dev.w3.org/csswg/cssom/#resolved-values
			if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE9-11+
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "O", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style;
	
	// Return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( name ) {
	
		// Shortcut for names that are not vendor prefixed
		if ( name in emptyStyle ) {
			return name;
		}
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	function setPositiveNumber( elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
		var i = extra === ( isBorderBox ? "border" : "content" ) ?
	
			// If we already have the right measurement, avoid augmentation
			4 :
	
			// Otherwise initialize for horizontal or vertical properties
			name === "width" ? 1 : 0,
	
			val = 0;
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin, so add it if we want it
			if ( extra === "margin" ) {
				val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
			}
	
			if ( isBorderBox ) {
	
				// border-box includes padding, so remove it if we want content
				if ( extra === "content" ) {
					val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// At this point, extra isn't border nor margin, so remove border
				if ( extra !== "margin" ) {
					val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			} else {
	
				// At this point, extra isn't content, so add padding
				val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// At this point, extra isn't content nor padding, so add border
				if ( extra !== "padding" ) {
					val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		return val;
	}
	
	function getWidthOrHeight( elem, name, extra ) {
	
		// Start with offset property, which is equivalent to the border-box value
		var valueIsBorderBox = true,
			val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
			styles = getStyles( elem ),
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
		// Some non-html elements return undefined for offsetWidth, so check for null/undefined
		// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
		// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
		if ( val <= 0 || val == null ) {
	
			// Fall back to computed then uncomputed css if necessary
			val = curCSS( elem, name, styles );
			if ( val < 0 || val == null ) {
				val = elem.style[ name ];
			}
	
			// Computed unit is not pixels. Stop here and return.
			if ( rnumnonpx.test( val ) ) {
				return val;
			}
	
			// Check for style in case a browser which returns unreliable values
			// for getComputedStyle silently falls back to the reliable elem.style
			valueIsBorderBox = isBorderBox &&
				( support.boxSizingReliable() || val === elem.style[ name ] );
	
			// Normalize "", auto, and prepare for extra
			val = parseFloat( val ) || 0;
		}
	
		// Use the active box-sizing model to add/subtract irrelevant styles
		return ( val +
			augmentWidthOrHeight(
				elem,
				name,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles
			)
		) + "px";
	}
	
	function showHide( elements, show ) {
		var display, elem, hidden,
			values = [],
			index = 0,
			length = elements.length;
	
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			values[ index ] = dataPriv.get( elem, "olddisplay" );
			display = elem.style.display;
			if ( show ) {
	
				// Reset the inline display of this element to learn if it is
				// being hidden by cascaded rules or not
				if ( !values[ index ] && display === "none" ) {
					elem.style.display = "";
				}
	
				// Set elements which have been overridden with display: none
				// in a stylesheet to whatever the default browser style is
				// for such an element
				if ( elem.style.display === "" && isHidden( elem ) ) {
					values[ index ] = dataPriv.access(
						elem,
						"olddisplay",
						defaultDisplay( elem.nodeName )
					);
				}
			} else {
				hidden = isHidden( elem );
	
				if ( display !== "none" || !hidden ) {
					dataPriv.set(
						elem,
						"olddisplay",
						hidden ? display : jQuery.css( elem, "display" )
					);
				}
			}
		}
	
		// Set the display of most of the elements in a second loop
		// to avoid the constant reflow
		for ( index = 0; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
			if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
				elem.style.display = show ? values[ index ] || "" : "none";
			}
		}
	
		return elements;
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {
			"float": "cssFloat"
		},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = jQuery.camelCase( name ),
				style = elem.style;
	
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				if ( type === "number" ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// Support: IE9-11+
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					style[ name ] = value;
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = jQuery.camelCase( name );
	
			// Make sure that we're working with the right name
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( i, name ) {
		jQuery.cssHooks[ name ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
						elem.offsetWidth === 0 ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, name, extra );
							} ) :
							getWidthOrHeight( elem, name, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = extra && getStyles( elem ),
					subtract = extra && augmentWidthOrHeight(
						elem,
						name,
						extra,
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
						styles
					);
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ name ] = value;
					value = jQuery.css( elem, name );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);
	
	// Support: Android 2.3
	jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
		function( elem, computed ) {
			if ( computed ) {
				return swap( elem, { "display": "inline-block" },
					curCSS, [ elem, "marginRight" ] );
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( !rmargin.test( prefix ) ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( jQuery.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		},
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHidden( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 &&
					( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
						jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE9
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back Compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, timerId,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = jQuery.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4 ; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		/* jshint validthis: true */
		var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHidden( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Handle queue: false promises
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Height/width overflow pass
		if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {
	
			// Make sure that nothing sneaks out
			// Record all 3 overflow attributes because IE9-10 do not
			// change the overflow attribute when overflowX and
			// overflowY are set to the same value
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Set display property to inline-block for height/width
			// animations on inline elements that are having width/height animated
			display = jQuery.css( elem, "display" );
	
			// Test default display if display is currently "none"
			checkDisplay = display === "none" ?
				dataPriv.get( elem, "olddisplay" ) || defaultDisplay( elem.nodeName ) : display;
	
			if ( checkDisplay === "inline" && jQuery.css( elem, "float" ) === "none" ) {
				style.display = "inline-block";
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// show/hide pass
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.exec( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// If there is dataShow left over from a stopped hide or show
					// and we are going to proceed with show, we should pretend to be hidden
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
	
			// Any non-fx value stops us from restoring the original display value
			} else {
				display = undefined;
			}
		}
	
		if ( !jQuery.isEmptyObject( orig ) ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", {} );
			}
	
			// Store state if its toggle - enables .stop().toggle() to "reverse"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}
			if ( hidden ) {
				jQuery( elem ).show();
			} else {
				anim.done( function() {
					jQuery( elem ).hide();
				} );
			}
			anim.done( function() {
				var prop;
	
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
			for ( prop in orig ) {
				tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
	
				if ( !( prop in dataShow ) ) {
					dataShow[ prop ] = tween.start;
					if ( hidden ) {
						tween.end = tween.start;
						tween.start = prop === "width" || prop === "height" ? 1 : 0;
					}
				}
			}
	
		// If this is a noop like .hide().hide(), restore an overwritten display value
		} else if ( ( display === "none" ? defaultDisplay( elem.nodeName ) : display ) === "inline" ) {
			style.display = display;
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = jQuery.camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( jQuery.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length ; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				if ( percent < 1 && length ) {
					return remaining;
				} else {
					deferred.resolveWith( elem, [ animation ] );
					return false;
				}
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length ; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length ; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( jQuery.isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						jQuery.proxy( result.stop, result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( jQuery.isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		// attach callbacks from options
		return animation.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( jQuery.isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnotwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length ; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				jQuery.isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
		};
	
		opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ?
			opt.duration : opt.duration in jQuery.fx.speeds ?
				jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( jQuery.isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHidden ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = jQuery.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Checks the timer has not already been removed
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		if ( timer() ) {
			jQuery.fx.start();
		} else {
			jQuery.timers.pop();
		}
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( !timerId ) {
			timerId = window.setInterval( jQuery.fx.tick, jQuery.fx.interval );
		}
	};
	
	jQuery.fx.stop = function() {
		window.clearInterval( timerId );
	
		timerId = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// http://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: iOS<=5.1, Android<=4.2+
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE<=11+
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: Android<=2.3
		// Options inside disabled selects are incorrectly marked as disabled
		select.disabled = true;
		support.optDisabled = !opt.disabled;
	
		// Support: IE<=11+
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// All attributes are lowercase
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				name = name.toLowerCase();
				hooks = jQuery.attrHooks[ name ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						jQuery.nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name, propName,
				i = 0,
				attrNames = value && value.match( rnotwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					propName = jQuery.propFix[ name ] || name;
	
					// Boolean attributes get special treatment (#10870)
					if ( jQuery.expr.match.bool.test( name ) ) {
	
						// Set corresponding property to false
						elem[ propName ] = false;
					}
	
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle;
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ name ];
				attrHandle[ name ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					name.toLowerCase() :
					null;
				attrHandle[ name ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					return tabindex ?
						parseInt( tabindex, 10 ) :
						rfocusable.test( elem.nodeName ) ||
							rclickable.test( elem.nodeName ) && elem.href ?
								0 :
								-1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
	var rclass = /[\t\r\n\f]/g;
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnotwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 &&
						( " " + curValue + " " ).replace( rclass, " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnotwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 &&
						( " " + curValue + " " ).replace( rclass, " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value;
	
			if ( typeof stateVal === "boolean" && type === "string" ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( type === "string" ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = value.match( rnotwhite ) || [];
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + getClass( elem ) + " " ).replace( rclass, " " )
						.indexOf( className ) > -1
				) {
					return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g,
		rspaces = /[\x20\t\r\n\f]+/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, isFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					return typeof ret === "string" ?
	
						// Handle most common string cases
						ret.replace( rreturn, "" ) :
	
						// Handle cases where value is null/undef or number
						ret == null ? "" : ret;
				}
	
				return;
			}
	
			isFunction = jQuery.isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( isFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( jQuery.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE10-11+
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						jQuery.trim( jQuery.text( elem ) ).replace( rspaces, " " );
				}
			},
			select: {
				get: function( elem ) {
					var value, option,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one" || index < 0,
						values = one ? null : [],
						max = one ? index + 1 : options.length,
						i = index < 0 ?
							max :
							one ? index : 0;
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								( support.optDisabled ?
									!option.disabled : option.getAttribute( "disabled" ) === null ) &&
								( !option.parentNode.disabled ||
									!jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( jQuery.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
	
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
						elem[ type ]();
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	jQuery.each( ( "blur focus focusin focusout load resize scroll unload click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup error contextmenu" ).split( " " ),
		function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );
	
	jQuery.fn.extend( {
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	
	
	
	support.focusin = "onfocusin" in window;
	
	
	// Support: Firefox
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome, Safari
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://code.google.com/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = jQuery.now();
	
	var rquery = ( /\?/ );
	
	
	
	// Support: Android 2.3
	// Workaround failure to string-cast null input
	jQuery.parseJSON = function( data ) {
		return JSON.parse( data + "" );
	};
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE9
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rhash = /#.*$/,
		rts = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];
	
			if ( jQuery.isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
			// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": jQuery.parseJSON,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// The jqXHR state
				state = 0,
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( state === 2 ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return state === 2 ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						var lname = name.toLowerCase();
						if ( !state ) {
							name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( !state ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( state < 2 ) {
								for ( code in map ) {
	
									// Lazy-add the new callback in a way that preserves old ones
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							} else {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR ).complete = completeDeferred.add;
			jqXHR.success = jqXHR.done;
			jqXHR.error = jqXHR.fail;
	
			// Remove hash character (#7531: and string promotion)
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" ).replace( rhash, "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE8-11+
				// IE throws exception if url is malformed, e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE8-11+
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( state === 2 ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			cacheURL = s.url;
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// If data is available, append data to url
				if ( s.data ) {
					cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add anti-cache in url if needed
				if ( s.cache === false ) {
					s.url = rts.test( cacheURL ) ?
	
						// If there is already a '_' parameter, set its value
						cacheURL.replace( rts, "$1_=" + nonce++ ) :
	
						// Otherwise add one to the end
						cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
				}
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			for ( i in { success: 1, error: 1, complete: 1 } ) {
				jqXHR[ i ]( s[ i ] );
			}
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( state === 2 ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					state = 1;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Propagate exception as error if not done
					if ( state < 2 ) {
						done( -1, e );
	
					// Simply rethrow otherwise
					} else {
						throw e;
					}
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Called once
				if ( state === 2 ) {
					return;
				}
	
				// State is "done" now
				state = 2;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( jQuery.isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			async: false,
			global: false,
			"throws": true
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapAll( html.call( this, i ) );
				} );
			}
	
			if ( this[ 0 ] ) {
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var isFunction = jQuery.isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function() {
			return this.parent().each( function() {
				if ( !jQuery.nodeName( this, "body" ) ) {
					jQuery( this ).replaceWith( this.childNodes );
				}
			} ).end();
		}
	} );
	
	
	jQuery.expr.filters.hidden = function( elem ) {
		return !jQuery.expr.filters.visible( elem );
	};
	jQuery.expr.filters.visible = function( elem ) {
	
		// Support: Opera <= 12.12
		// Opera reports offsetWidths and offsetHeights less than zero on some elements
		// Use OR instead of AND as the element is not visible if either is true
		// See tickets #10406 and #13132
		return elem.offsetWidth > 0 || elem.offsetHeight > 0 || elem.getClientRects().length > 0;
	};
	
	
	
	
	var r20 = /%20/g,
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( jQuery.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && jQuery.type( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, value ) {
	
				// If value is a function, invoke it and return its value
				value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
				s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
			};
	
		// Set traditional to true for jQuery <= 1.3.2 behavior.
		if ( traditional === undefined ) {
			traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" ).replace( r20, "+" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( i, elem ) {
				var val = jQuery( this ).val();
	
				return val == null ?
					null :
					jQuery.isArray( val ) ?
						jQuery.map( val, function( val ) {
							return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
						} ) :
						{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE9
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE9
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = callback( "error" );
	
					// Support: IE9
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" ).prop( {
						charset: s.scriptCharset,
						src: s.url
					} ).on(
						"load error",
						callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						}
					);
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && jQuery.isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( !data || typeof data !== "string" ) {
			return null;
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
		context = context || document;
	
		var parsed = rsingleTag.exec( data ),
			scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	// Keep a copy of the old load method
	var _load = jQuery.fn.load;
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		if ( typeof url !== "string" && _load ) {
			return _load.apply( this, arguments );
		}
	
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = jQuery.trim( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( jQuery.isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.expr.filters.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	/**
	 * Gets a window from an element
	 */
	function getWindow( elem ) {
		return jQuery.isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
	}
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( jQuery.isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
		offset: function( options ) {
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var docElem, win,
				elem = this[ 0 ],
				box = { top: 0, left: 0 },
				doc = elem && elem.ownerDocument;
	
			if ( !doc ) {
				return;
			}
	
			docElem = doc.documentElement;
	
			// Make sure it's not a disconnected DOM node
			if ( !jQuery.contains( docElem, elem ) ) {
				return box;
			}
	
			box = elem.getBoundingClientRect();
			win = getWindow( doc );
			return {
				top: box.top + win.pageYOffset - docElem.clientTop,
				left: box.left + win.pageXOffset - docElem.clientLeft
			};
		},
	
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
			// because it is its only offset parent
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume getBoundingClientRect is there when computed position is fixed
				offset = elem.getBoundingClientRect();
	
			} else {
	
				// Get *real* offsetParent
				offsetParent = this.offsetParent();
	
				// Get correct offsets
				offset = this.offset();
				if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
					parentOffset = offsetParent.offset();
				}
	
				// Add offsetParent borders
				parentOffset.top += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
				var win = getWindow( elem );
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari<7-8+, Chrome<37-44+
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://code.google.com/p/chromium/issues/detail?id=229280
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( jQuery.isWindow( elem ) ) {
	
						// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
						// isn't a whole lot we can do. See pull request at this URL for discussion:
						// https://github.com/jquery/jquery/pull/764
						return elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable, null );
			};
		} );
	} );
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		},
		size: function() {
			return this.length;
		}
	} );
	
	jQuery.fn.andSelf = jQuery.fn.addBack;
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( !noGlobal ) {
		window.jQuery = window.$ = jQuery;
	}
	
	return jQuery;
	}));


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(107)('wks');
	var uid = __webpack_require__(85);
	var Symbol = __webpack_require__(8).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(50);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Cursor", {
	  enumerable: true,
	  get: function get() {
	    return _cursor["default"];
	  }
	});
	Object.defineProperty(exports, "MonkeyDefinition", {
	  enumerable: true,
	  get: function get() {
	    return _monkey.MonkeyDefinition;
	  }
	});
	Object.defineProperty(exports, "Monkey", {
	  enumerable: true,
	  get: function get() {
	    return _monkey.Monkey;
	  }
	});
	Object.defineProperty(exports, "type", {
	  enumerable: true,
	  get: function get() {
	    return _type["default"];
	  }
	});
	exports.helpers = exports["default"] = exports.VERSION = exports.dynamic = exports.monkey = void 0;
	
	var _emmett = _interopRequireDefault(__webpack_require__(191));
	
	var _cursor = _interopRequireDefault(__webpack_require__(236));
	
	var _monkey = __webpack_require__(119);
	
	var _watcher = _interopRequireDefault(__webpack_require__(532));
	
	var _type = _interopRequireDefault(__webpack_require__(91));
	
	var _update2 = _interopRequireDefault(__webpack_require__(237));
	
	var helpers = _interopRequireWildcard(__webpack_require__(103));
	
	exports.helpers = helpers;
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var arrayFrom = helpers.arrayFrom,
	    coercePath = helpers.coercePath,
	    deepFreeze = helpers.deepFreeze,
	    getIn = helpers.getIn,
	    makeError = helpers.makeError,
	    deepClone = helpers.deepClone,
	    deepMerge = helpers.deepMerge,
	    shallowClone = helpers.shallowClone,
	    shallowMerge = helpers.shallowMerge,
	    hashPath = helpers.hashPath;
	/**
	 * Baobab defaults
	 */
	
	var DEFAULTS = {
	  // Should the tree handle its transactions on its own?
	  autoCommit: true,
	  // Should the transactions be handled asynchronously?
	  asynchronous: true,
	  // Should the tree's data be immutable?
	  immutable: true,
	  // Should the monkeys be lazy?
	  lazyMonkeys: true,
	  // Should we evaluate monkeys?
	  monkeyBusiness: true,
	  // Should the tree be persistent?
	  persistent: true,
	  // Should the tree's update be pure?
	  pure: true,
	  // Validation specifications
	  validate: null,
	  // Validation behavior 'rollback' or 'notify'
	  validationBehavior: 'rollback'
	};
	/**
	 * Baobab class
	 *
	 * @constructor
	 * @param {object|array} [initialData={}]    - Initial data passed to the tree.
	 * @param {object}       [opts]              - Optional options.
	 * @param {boolean}      [opts.autoCommit]   - Should the tree auto-commit?
	 * @param {boolean}      [opts.asynchronous] - Should the tree's transactions
	 *                                             handled asynchronously?
	 * @param {boolean}      [opts.immutable]    - Should the tree be immutable?
	 * @param {boolean}      [opts.persistent]   - Should the tree be persistent?
	 * @param {boolean}      [opts.pure]         - Should the tree be pure?
	 * @param {function}     [opts.validate]     - Validation function.
	 * @param {string}       [opts.validationBehaviour] - "rollback" or "notify".
	 */
	
	var Baobab =
	/*#__PURE__*/
	function (_Emitter) {
	  _inherits(Baobab, _Emitter);
	
	  function Baobab(initialData, opts) {
	    var _this;
	
	    _classCallCheck(this, Baobab);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Baobab).call(this)); // Setting initialData to an empty object if no data is provided by use
	
	    if (arguments.length < 1) initialData = {}; // Checking whether given initial data is valid
	
	    if (!_type["default"].object(initialData) && !_type["default"].array(initialData)) throw makeError('Baobab: invalid data.', {
	      data: initialData
	    }); // Merging given options with defaults
	
	    _this.options = shallowMerge({}, DEFAULTS, opts); // Disabling immutability & persistence if persistence if disabled
	
	    if (!_this.options.persistent) {
	      _this.options.immutable = false;
	      _this.options.pure = false;
	    } // Privates
	
	
	    _this._identity = '[object Baobab]';
	    _this._cursors = {};
	    _this._future = null;
	    _this._transaction = [];
	    _this._affectedPathsIndex = {};
	    _this._monkeys = {};
	    _this._previousData = null;
	    _this._data = initialData; // Properties
	
	    _this.root = new _cursor["default"](_assertThisInitialized(_this), [], 'λ');
	    delete _this.root.release; // Does the user want an immutable tree?
	
	    if (_this.options.immutable) deepFreeze(_this._data); // Bootstrapping root cursor's getters and setters
	
	    var bootstrap = function bootstrap(name) {
	      _this[name] = function () {
	        var r = this.root[name].apply(this.root, arguments);
	        return r instanceof _cursor["default"] ? this : r;
	      };
	    };
	
	    ['apply', 'clone', 'concat', 'deepClone', 'deepMerge', 'exists', 'get', 'push', 'merge', 'pop', 'project', 'serialize', 'set', 'shift', 'splice', 'unset', 'unshift'].forEach(bootstrap); // Registering the initial monkeys
	
	    if (_this.options.monkeyBusiness) {
	      _this._refreshMonkeys();
	    } // Initial validation
	
	
	    var validationError = _this.validate();
	
	    if (validationError) throw Error('Baobab: invalid data.', {
	      error: validationError
	    });
	    return _this;
	  }
	  /**
	   * Internal method used to refresh the tree's monkey register on every
	   * update.
	   * Note 1) For the time being, placing monkeys beneath array nodes is not
	   * allowed for performance reasons.
	   *
	   * @param  {mixed}   node      - The starting node.
	   * @param  {array}   path      - The starting node's path.
	   * @param  {string}  operation - The operation that lead to a refreshment.
	   * @return {Baobab}            - The tree instance for chaining purposes.
	   */
	
	
	  _createClass(Baobab, [{
	    key: "_refreshMonkeys",
	    value: function _refreshMonkeys(node, path, operation) {
	      var _this2 = this;
	
	      var clean = function clean(data) {
	        var p = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	        if (data instanceof _monkey.Monkey) {
	          data.release();
	          (0, _update2["default"])(_this2._monkeys, p, {
	            type: 'unset'
	          }, {
	            immutable: false,
	            persistent: false,
	            pure: false
	          });
	          return;
	        }
	
	        if (_type["default"].object(data)) {
	          for (var k in data) {
	            clean(data[k], p.concat(k));
	          }
	        }
	      };
	
	      var walk = function walk(data) {
	        var p = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	        // Should we sit a monkey in the tree?
	        if (data instanceof _monkey.MonkeyDefinition || data instanceof _monkey.Monkey) {
	          var monkeyInstance = new _monkey.Monkey(_this2, p, data instanceof _monkey.Monkey ? data.definition : data);
	          (0, _update2["default"])(_this2._monkeys, p, {
	            type: 'set',
	            value: monkeyInstance
	          }, {
	            immutable: false,
	            persistent: false,
	            pure: false
	          });
	          return;
	        } // Object iteration
	
	
	        if (_type["default"].object(data)) {
	          for (var k in data) {
	            walk(data[k], p.concat(k));
	          }
	        }
	      }; // Walking the whole tree
	
	
	      if (!arguments.length) {
	        walk(this._data);
	      } else {
	        var monkeysNode = getIn(this._monkeys, path).data; // Is this required that we clean some already existing monkeys?
	
	        if (monkeysNode) clean(monkeysNode, path); // Let's walk the tree only from the updated point
	
	        if (operation !== 'unset') {
	          walk(node, path);
	        }
	      }
	
	      return this;
	    }
	    /**
	     * Method used to validate the tree's data.
	     *
	     * @return {boolean} - Is the tree valid?
	     */
	
	  }, {
	    key: "validate",
	    value: function validate(affectedPaths) {
	      var _this$options = this.options,
	          validate = _this$options.validate,
	          behavior = _this$options.validationBehavior;
	      if (typeof validate !== 'function') return null;
	      var error = validate.call(this, this._previousData, this._data, affectedPaths || [[]]);
	
	      if (error instanceof Error) {
	        if (behavior === 'rollback') {
	          this._data = this._previousData;
	          this._affectedPathsIndex = {};
	          this._transaction = [];
	          this._previousData = this._data;
	        }
	
	        this.emit('invalid', {
	          error: error
	        });
	        return error;
	      }
	
	      return null;
	    }
	    /**
	     * Method used to select data within the tree by creating a cursor. Cursors
	     * are kept as singletons by the tree for performance and hygiene reasons.
	     *
	     * Arity (1):
	     * @param {path}    path - Path to select in the tree.
	     *
	     * Arity (*):
	     * @param {...step} path - Path to select in the tree.
	     *
	     * @return {Cursor}      - The resultant cursor.
	     */
	
	  }, {
	    key: "select",
	    value: function select(path) {
	      // If no path is given, we simply return the root
	      path = path || []; // Variadic
	
	      if (arguments.length > 1) path = arrayFrom(arguments); // Checking that given path is valid
	
	      if (!_type["default"].path(path)) throw makeError('Baobab.select: invalid path.', {
	        path: path
	      }); // Casting to array
	
	      path = [].concat(path); // Computing hash (done here because it would be too late to do it in the
	      // cursor's constructor since we need to hit the cursors' index first).
	
	      var hash = hashPath(path); // Creating a new cursor or returning the already existing one for the
	      // requested path.
	
	      var cursor = this._cursors[hash];
	
	      if (!cursor) {
	        cursor = new _cursor["default"](this, path, hash);
	        this._cursors[hash] = cursor;
	      } // Emitting an event to notify that a part of the tree was selected
	
	
	      this.emit('select', {
	        path: path,
	        cursor: cursor
	      });
	      return cursor;
	    }
	    /**
	     * Method used to update the tree. Updates are simply expressed by a path,
	     * dynamic or not, and an operation.
	     *
	     * This is where path solving should happen and not in the cursor.
	     *
	     * @param  {path}   path      - The path where we'll apply the operation.
	     * @param  {object} operation - The operation to apply.
	     * @return {mixed} - Return the result of the update.
	     */
	
	  }, {
	    key: "update",
	    value: function update(path, operation) {
	      var _this3 = this;
	
	      // Coercing path
	      path = coercePath(path);
	      if (!_type["default"].operationType(operation.type)) throw makeError("Baobab.update: unknown operation type \"".concat(operation.type, "\"."), {
	        operation: operation
	      }); // Solving the given path
	
	      var _getIn = getIn(this._data, path),
	          solvedPath = _getIn.solvedPath,
	          exists = _getIn.exists; // If we couldn't solve the path, we throw
	
	
	      if (!solvedPath) throw makeError('Baobab.update: could not solve the given path.', {
	        path: solvedPath
	      }); // Read-only path?
	
	      var monkeyPath = _type["default"].monkeyPath(this._monkeys, solvedPath);
	
	      if (monkeyPath && solvedPath.length > monkeyPath.length) throw makeError('Baobab.update: attempting to update a read-only path.', {
	        path: solvedPath
	      }); // We don't unset irrelevant paths
	
	      if (operation.type === 'unset' && !exists) return; // If we merge data, we need to acknowledge monkeys
	
	      var realOperation = operation;
	
	      if (/merge/i.test(operation.type)) {
	        var monkeysNode = getIn(this._monkeys, solvedPath).data;
	
	        if (_type["default"].object(monkeysNode)) {
	          // Cloning the operation not to create weird behavior for the user
	          realOperation = shallowClone(realOperation); // Fetching the existing node in the current data
	
	          var currentNode = getIn(this._data, solvedPath).data;
	          if (/deep/i.test(realOperation.type)) realOperation.value = deepMerge({}, deepMerge({}, currentNode, deepClone(monkeysNode)), realOperation.value);else realOperation.value = shallowMerge({}, deepMerge({}, currentNode, deepClone(monkeysNode)), realOperation.value);
	        }
	      } // Stashing previous data if this is the frame's first update
	
	
	      if (!this._transaction.length) this._previousData = this._data; // Applying the operation
	
	      var result = (0, _update2["default"])(this._data, solvedPath, realOperation, this.options);
	      var data = result.data,
	          node = result.node; // If because of purity, the update was moot, we stop here
	
	      if (!('data' in result)) return node; // If the operation is push, the affected path is slightly different
	
	      var affectedPath = solvedPath.concat(operation.type === 'push' ? node.length - 1 : []);
	      var hash = hashPath(affectedPath); // Updating data and transaction
	
	      this._data = data;
	      this._affectedPathsIndex[hash] = true;
	
	      this._transaction.push(shallowMerge({}, operation, {
	        path: affectedPath
	      })); // Updating the monkeys
	
	
	      if (this.options.monkeyBusiness) {
	        this._refreshMonkeys(node, solvedPath, operation.type);
	      } // Emitting a `write` event
	
	
	      this.emit('write', {
	        path: affectedPath
	      }); // Should we let the user commit?
	
	      if (!this.options.autoCommit) return node; // Should we update asynchronously?
	
	      if (!this.options.asynchronous) {
	        this.commit();
	        return node;
	      } // Updating asynchronously
	
	
	      if (!this._future) this._future = setTimeout(function () {
	        return _this3.commit();
	      }, 0); // Finally returning the affected node
	
	      return node;
	    }
	    /**
	     * Method committing the updates of the tree and firing the tree's events.
	     *
	     * @return {Baobab} - The tree instance for chaining purposes.
	     */
	
	  }, {
	    key: "commit",
	    value: function commit() {
	      // Do not fire update if the transaction is empty
	      if (!this._transaction.length) return this; // Clearing timeout if one was defined
	
	      if (this._future) this._future = clearTimeout(this._future);
	      var affectedPaths = Object.keys(this._affectedPathsIndex).map(function (h) {
	        return h !== 'λ' ? h.split('λ').slice(1) : [];
	      }); // Is the tree still valid?
	
	      var validationError = this.validate(affectedPaths);
	      if (validationError) return this; // Caching to keep original references before we change them
	
	      var transaction = this._transaction,
	          previousData = this._previousData;
	      this._affectedPathsIndex = {};
	      this._transaction = [];
	      this._previousData = this._data; // Emitting update event
	
	      this.emit('update', {
	        paths: affectedPaths,
	        currentData: this._data,
	        transaction: transaction,
	        previousData: previousData
	      });
	      return this;
	    }
	    /**
	     * Method returning a monkey at the given path or else `null`.
	     *
	     * @param  {path}        path - Path of the monkey to retrieve.
	     * @return {Monkey|null}      - The Monkey instance of `null`.
	     */
	
	  }, {
	    key: "getMonkey",
	    value: function getMonkey(path) {
	      path = coercePath(path);
	      var monkey = getIn(this._monkeys, [].concat(path)).data;
	      if (monkey instanceof _monkey.Monkey) return monkey;
	      return null;
	    }
	    /**
	     * Method used to watch a collection of paths within the tree. Very useful
	     * to bind UI components and such to the tree.
	     *
	     * @param  {object} mapping - Mapping of paths to listen.
	     * @return {Cursor}         - The created watcher.
	     */
	
	  }, {
	    key: "watch",
	    value: function watch(mapping) {
	      return new _watcher["default"](this, mapping);
	    }
	    /**
	     * Method releasing the tree and its attached data from memory.
	     */
	
	  }, {
	    key: "release",
	    value: function release() {
	      var k;
	      this.emit('release');
	      delete this.root;
	      delete this._data;
	      delete this._previousData;
	      delete this._transaction;
	      delete this._affectedPathsIndex;
	      delete this._monkeys; // Releasing cursors
	
	      for (k in this._cursors) {
	        this._cursors[k].release();
	      }
	
	      delete this._cursors; // Killing event emitter
	
	      this.kill();
	    }
	    /**
	     * Overriding the `toJSON` method for convenient use with JSON.stringify.
	     *
	     * @return {mixed} - Data at cursor.
	     */
	
	  }, {
	    key: "toJSON",
	    value: function toJSON() {
	      return this.serialize();
	    }
	    /**
	     * Overriding the `toString` method for debugging purposes.
	     *
	     * @return {string} - The baobab's identity.
	     */
	
	  }, {
	    key: "toString",
	    value: function toString() {
	      return this._identity;
	    }
	  }]);
	
	  return Baobab;
	}(_emmett["default"]);
	/**
	 * Monkey helper.
	 */
	
	
	Baobab.monkey = function () {
	  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  if (!args.length) throw new Error('Baobab.monkey: missing definition.');
	  if (args.length === 1 && typeof args[0] !== 'function') return new _monkey.MonkeyDefinition(args[0]);
	  return new _monkey.MonkeyDefinition(args);
	};
	
	Baobab.dynamicNode = Baobab.monkey;
	var monkey = Baobab.monkey;
	exports.monkey = monkey;
	var dynamic = Baobab.dynamic;
	/**
	 * Exposing some internals for convenience
	 */
	
	exports.dynamic = dynamic;
	
	/**
	 * Version.
	 */
	Baobab.VERSION = '2.6.1';
	var VERSION = Baobab.VERSION;
	/**
	 * Exporting.
	 */
	
	exports.VERSION = VERSION;
	var _default = Baobab;
	exports["default"] = _default;
	for (var exportedName in exports)
	  Baobab[exportedName] = exports[exportedName];
	
	module.exports = Baobab;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(9)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(6);
	var IE8_DOM_DEFINE = __webpack_require__(250);
	var toPrimitive = __webpack_require__(54);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(16) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(52);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(4);
	var errorConverter = __webpack_require__(215);
	
	function sendErrorLogToWebApi(errorType, errorId, args, state, locator, context) {
	    var error = args.error;
	    var api = locator.resolve('api');
	    var user = state.get(['user']);
	    api.logOnWebApi(context, locator, {
	        level: 'info',
	        message: [errorType, errorId, errorConverter.convert(error), user]
	    });
	}
	
	module.exports = {
	    unauthorized: function unauthorized(args, state, output, _ref) {
	        var context = _ref.context;
	
	        context.redirect(utils.patchQueryWithUtm('/', state));
	    },
	    accessDenied: function accessDenied(errorId) {
	        return function (args, state, output, _ref2) {
	            var locator = _ref2.locator,
	                context = _ref2.context;
	
	            state.set(['layout'], 'error');
	            state.set(['errorType'], 'accessDenied');
	            state.set(['title'], 'Доступ запрещен');
	            state.set(['description'], 'Доступ к этому разделу ограничен');
	            sendErrorLogToWebApi('accessDenied', errorId, args, state, locator, context);
	        };
	    },
	    internalError: function internalError(errorId) {
	        return function (args, state, output, _ref3) {
	            var locator = _ref3.locator,
	                context = _ref3.context;
	
	            state.set(['layout'], 'error');
	            state.set(['errorType'], 'internalError');
	            state.set(['title'], 'Что-то пошло не так, но мы уже чиним');
	            state.set(['description'], 'Что-то пошло не так, но мы уже чиним.');
	            sendErrorLogToWebApi('internalError', errorId, args, state, locator, context);
	        };
	    },
	    notFound: function notFound(errorId) {
	        var isDontLog = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        return function (args, state, output, _ref4) {
	            var locator = _ref4.locator,
	                context = _ref4.context;
	
	            state.set(['layout'], 'error');
	            state.set(['errorType'], 'notFound');
	            state.set(['title'], 'Нет такой страницы');
	            state.set(['description'], 'Нет такой страницы. Быть может её и вовсе не существовало.');
	            if (!isDontLog) {
	                sendErrorLogToWebApi('notFound', errorId, args, state, locator, context);
	            }
	        };
	    },
	    passportError: function passportError(errorId) {
	        return function (args, state, output, _ref5) {
	            var locator = _ref5.locator,
	                context = _ref5.context;
	
	            state.set(['layout'], 'error');
	            state.set(['errorType'], 'passportError');
	            state.set(['title'], 'Что-то пошло не так, но мы уже чиним');
	            state.set(['description'], 'Что-то пошло не так, но мы уже чиним.');
	            sendErrorLogToWebApi('passportError', errorId, args, state, locator, context);
	        };
	    },
	    bitrixUnavailableError: function bitrixUnavailableError(errorId) {
	        return function (args, state, output, _ref6) {
	            var locator = _ref6.locator,
	                context = _ref6.context;
	
	            state.set(['layout'], 'error');
	            state.set(['errorType'], 'unavailableError');
	            state.set(['title'], 'Нет доступа к вашему Битрикс24');
	            state.set(['description'], 'Нет доступа к вашему Битрикс24.');
	            sendErrorLogToWebApi('bitrixUnavailableError', errorId, args, state, locator, context);
	        };
	    },
	    bitrixCertificateError: function bitrixCertificateError(errorId) {
	        return function (args, state, output, _ref7) {
	            var locator = _ref7.locator,
	                context = _ref7.context;
	
	            state.set(['layout'], 'error');
	            state.set(['errorType'], 'certificateError');
	            state.set(['title'], 'Сертификат вашего Битрикс24 недействителен');
	            state.set(['description'], 'Сертификат вашего Битрикс24 недействителен');
	            sendErrorLogToWebApi('bitrixCertificateError', errorId, args, state, locator, context);
	        };
	    },
	    cookieDisabled: function cookieDisabled(errorId) {
	        return function (args, state, output, _ref8) {
	            var locator = _ref8.locator,
	                context = _ref8.context;
	
	            state.set(['layout'], 'error');
	            state.set(['errorType'], 'cookieDisabled');
	            state.set(['title'], 'У вас в браузере выключены cookie, работа сайта невозможна');
	            state.set(['description'], 'У вас в браузере выключены cookie, работа сайта невозможна');
	            sendErrorLogToWebApi('cookieDisabled', errorId, args, state, locator, context);
	        };
	    }
	};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _require = __webpack_require__(15),
	    monkey = _require.monkey;
	
	var _ = __webpack_require__(3);
	var COMPONENTS = __webpack_require__(293);
	
	module.exports = {
	    setComponentsByLink: function setComponentsByLink(args, state) {
	        state.set(['page', 'components'], monkey(['page', 'name'], ['user', 'role'], function (page, role) {
	            return _.get(COMPONENTS, role + '.' + page);
	        }));
	    },
	    setIsLoading: function setIsLoading(value) {
	        return function (args, state) {
	            return state.set('isLoading', value);
	        };
	    }
	};

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	    setDashboardMeta: function setDashboardMeta(title, description) {
	        return function (args, state) {
	            state.set(['title'], title);
	            state.set(['description'], description);
	        };
	    }
	};

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	    email: {
	        properties: {
	            value: {
	                type: 'string',
	                required: true,
	                validator: {
	                    func: function func(value) {
	                        var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	                        return value.length < 64 && regex.test(value);
	                    },
	                    message: 'Неверный формат почты'
	                },
	                messages: {
	                    message: 'Неверный формат почты',
	                    emailAlreadyUsed: 'Пользователь с таким email уже зарегистрирован'
	                }
	            }
	        }
	    },
	    firstName: {
	        properties: {
	            value: {
	                type: 'string',
	                required: true,
	                minLength: 1,
	                message: 'Введите имя'
	            }
	        }
	    },
	    lastName: {
	        properties: {
	            value: {
	                type: 'string',
	                required: true,
	                minLength: 1,
	                message: 'Введите фамилию'
	            }
	        }
	    },
	    password: {
	        properties: {
	            value: {
	                type: 'string',
	                required: true,
	                minLength: 6,
	                message: 'Минимальная длина пароля – 6 символов'
	            }
	        }
	    },
	    repeatPassword: {
	        properties: {
	            value: {
	                type: 'string',
	                required: true,
	                messages: {
	                    repeat: 'Пароли не совпадают'
	                }
	            }
	        }
	    },
	
	    inn10: {
	        properties: {
	            value: {
	                required: false,
	                message: 'Введите ИНН (10 цифр)',
	                validator: {
	                    func: function func(value) {
	                        var n = value.split('');
	                        if (n.length !== 10) {
	                            return false;
	                        }
	
	                        for (var i = 0; i < n.length; i++) {
	                            n[i] = parseInt(n[i], 10);
	                        }
	
	                        var c10 = [2, 4, 10, 3, 5, 9, 4, 6, 8];
	                        var n10 = 0;
	                        for (var j = 0; j < 9; j++) {
	                            n10 += n[j] * c10[j];
	                        }
	
	                        n10 = n10 % 11 % 10;
	                        return n[9] === n10;
	                    },
	                    message: 'Некорректный ИНН'
	                }
	            }
	        }
	    },
	
	    inn12: {
	        properties: {
	            value: {
	                required: false,
	                message: 'Введите ИНН (12 цифр)',
	                validator: {
	                    func: function func(value) {
	                        var n = value.split('');
	                        if (n.length !== 12) {
	                            return false;
	                        }
	
	                        for (var i = 0; i < n.length; i++) {
	                            n[i] = parseInt(n[i], 10);
	                        }
	
	                        var c11 = [7, 2, 4, 10, 3, 5, 9, 4, 6, 8];
	                        var c12 = [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8];
	                        var n11 = 0;
	                        var n12 = 0;
	                        for (var z = 0; z < 10; z++) {
	                            n11 += n[z] * c11[z];
	                        }
	                        for (var l = 0; l < 11; l++) {
	                            n12 += n[l] * c12[l];
	                        }
	
	                        n11 = n11 % 11 % 10;
	                        n12 = n12 % 11 % 10;
	                        return n[10] === n11 && n[11] === n12;
	                    },
	                    message: 'Некорректный ИНН'
	                }
	            }
	        }
	    },
	
	    kpp: {
	        properties: {
	            value: {
	                required: false,
	                message: 'Введите КПП (9 цифр)',
	                pattern: '^([0-9]{9})?$'
	            }
	        }
	    },
	    bin: {
	        properties: {
	            value: {
	                required: true,
	                message: 'Введите БИН (12 цифр)',
	                pattern: '^([0-9]{12})?$'
	            }
	        }
	    },
	    number: {
	        properties: {
	            value: {
	                required: false,
	                message: 'Введите число',
	                pattern: '^\\d*[\\,\\.]?\\d*$'
	            }
	        }
	    },
	    numberOrEmpty: {
	        properties: {
	            value: {
	                required: false,
	                message: 'Введите число',
	                pattern: '(^$|^\\d*[\\,\\.]?\\d*$)'
	            }
	        }
	    },
	
	    stringOnlyLettersAndDigitsNotEmpty: {
	        properties: {
	            value: {
	                type: 'string',
	                required: false,
	                pattern: '^[а-яА-ЯёЁa-zA-Z0-9 ]+?$',
	                message: 'Введите значение'
	            }
	        }
	    }
	};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(3);
	var priceActions = __webpack_require__(71);
	
	var _require = __webpack_require__(72),
	    thenWithErrorHandling = _require.thenWithErrorHandling;
	
	var PATHS = {
	    showPriceMustBeBiggerThanZero: ['account', 'orders', 'currentOrder', 'tooltips', 'showPriceMustBeBiggerThanZero'],
	    showBillDocumentMustBeAttached: ['account', 'orders', 'currentOrder', 'tooltips', 'showBillDocumentMustBeAttached'],
	    showUploadFailTooltip: ['account', 'orders', 'currentOrder', 'tooltips', 'showUploadFailTooltip'],
	    orderAmount: ['account', 'orders', 'currentOrder', 'amount'],
	    orderAmountError: ['account', 'orders', 'currentOrder', 'errors', 'amount'],
	    isExportResultMustBeAttached: ['account', 'orders', 'currentOrder', 'tooltips', 'isExportResultMustBeAttached'],
	    isShowUploadResultFailTooltip: ['account', 'orders', 'currentOrder', 'tooltips', 'showUploadResultFailTooltip']
	};
	
	module.exports = {
	    PATHS: PATHS,
	
	    getSelectedParamsFromCurrentOrder: function getSelectedParamsFromCurrentOrder(args, state, output) {
	        var selectedParameters = state.get(['account', 'orders', 'currentOrder', 'selectedParameters']);
	        output.success({ selectedParameters: selectedParameters });
	    },
	    updateSelectedParamsForCurrentOrder: function updateSelectedParamsForCurrentOrder(args, state, output, _ref) {
	        var context = _ref.context,
	            locator = _ref.locator;
	
	        var orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
	        var selectedParameters = priceActions.getSelectedParameters(state);
	        var api = locator.resolve('api');
	        var request = api.updateOrderParameters(context, locator, { orderId: orderId, selectedParameters: selectedParameters });
	        request.then(function (response) {
	            var code = _.get(response, 'status.code');
	            if (code !== 200) {
	                output.error({ error: code });
	                return;
	            }
	            var content = _.get(response, 'content');
	            output.success(content);
	        }).catch(function (error) {
	            return output.error({ error: error });
	        });
	    },
	    updateOrder: function updateOrder(updateFields) {
	        return function updateOrder(args, state) {
	            _.forEach(updateFields, function (field) {
	                if (field === 'price' && !_.get(args, 'price')) {
	                    return;
	                }
	                state.set(['account', 'orders', 'currentOrder', field], _.get(args, field));
	            });
	            var isStateUpdated = _.indexOf(updateFields, 'stateId') > -1;
	            var isNameUpdated = _.indexOf(updateFields, 'name') > -1;
	
	            if (isStateUpdated || isNameUpdated) {
	                var ordersList = state.get(['account', 'orders', 'list', 'data']);
	                var orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
	                var orderIndex = _.findIndex(ordersList, { id: orderId });
	                if (orderIndex > -1) {
	                    if (isStateUpdated) {
	                        state.set(['account', 'orders', 'list', 'data', orderIndex, 'stateId'], _.get(args, 'stateId'));
	                    }
	                    if (isNameUpdated) {
	                        state.set(['account', 'orders', 'list', 'data', orderIndex, 'name'], _.get(args, 'name'));
	                    }
	                }
	            }
	        };
	    },
	    filterOptionalExportColumnsOnOrderDisable: function filterOptionalExportColumnsOnOrderDisable(args, state) {
	        var columns = state.get(['order', 'originalParameters', 'exportColumns', 'columns']);
	        var values = state.get(['order', 'computed', 'exportColumns', 'optional', 'value']);
	        var isOrderDisabled = state.get(['order', 'isDisabled']);
	        var columnsFiltered = _.filter(columns, function (x) {
	            return x.isBasic === true || !isOrderDisabled || values.hasOwnProperty(x.id) && values[x.id].IsChecked === true;
	        });
	        state.set(['order', 'originalParameters', 'exportColumns', 'columns'], columnsFiltered);
	    },
	    setPriceFromOrder: function setPriceFromOrder(args, state) {
	        state.set(['account', 'orders', 'currentOrder', 'price'], state.get(['order', 'price', 'data']));
	    },
	    getDocumentTypes: function getDocumentTypes(args, state, output, _ref2) {
	        var context = _ref2.context,
	            locator = _ref2.locator;
	
	        var api = locator.resolve('api');
	        var request = api.getDocumentTypes(context, state, {});
	
	        thenWithErrorHandling(request, function (data) {
	            return { necessaryDocuments: _.get(data, 'content') };
	        }, output);
	    },
	    isNeedToGetExportResults: function isNeedToGetExportResults(args, state, output) {
	        if (state.get(['account', 'orders', 'computed', 'componentsState', 'getExportResults'])) {
	            output.yes();
	            return;
	        }
	        output.no();
	    },
	    getExportResults: function getExportResults(args, state, output, _ref3) {
	        var locator = _ref3.locator,
	            context = _ref3.context;
	
	        var orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
	        var API = locator.resolve('api');
	
	        setTimeout(function exportResultsRetry() {
	            if (state.get(['account', 'orders', 'currentOrder', 'id']) !== orderId) {
	                output.orderChanged();
	                return;
	            }
	
	            var request = API.getExportResults(context, locator, orderId);
	            request.then(function (data) {
	                if (state.get(['account', 'orders', 'currentOrder', 'id']) !== orderId) {
	                    output.orderChanged();
	                    return;
	                }
	
	                var statusCode = _.get(data, 'status.code');
	
	                if (statusCode === 404) {
	                    setTimeout(exportResultsRetry, 10000);
	                    return;
	                }
	
	                if (statusCode !== 200) {
	                    output.error({ error: statusCode });
	                    return;
	                }
	
	                output.success({ exportResult: _.get(data, 'content.results'),
	                    hasBitrixLeads: _.get(data, 'content.hasBitrixLeads') });
	            }).catch(function (error) {
	                output.error({ error: error });
	            });
	        }, 0);
	    },
	    getOrderState: function getOrderState(args, state, output, _ref4) {
	        var locator = _ref4.locator,
	            context = _ref4.context;
	
	        var API = locator.resolve('api');
	        var timerId = setTimeout(function getState() {
	            if (state.get(['account', 'orders', 'currentOrder', 'stateId']) !== 3) {
	                output.dontNeed();
	                return;
	            }
	
	            var orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
	            var request = API.getOrderState(context, locator, orderId);
	            request.then(function (data) {
	                if (state.get(['account', 'orders', 'currentOrder', 'id']) !== orderId) {
	                    timerId = setTimeout(getState, 0);
	                    return;
	                }
	
	                var statusCode = _.get(data, 'status.code');
	                if (statusCode !== 200) {
	                    output.error({ error: statusCode });
	                    return;
	                }
	
	                var stateId = _.get(data, 'content');
	                if (stateId !== 3) {
	                    output.success({ stateId: stateId });
	                } else {
	                    timerId = setTimeout(getState, 10000);
	                }
	            }).catch(function (error) {
	                output.error({ error: error });
	            });
	        }, 0);
	    },
	    getHasBitrixLeads: function getHasBitrixLeads(args, state, output, _ref5) {
	        var locator = _ref5.locator,
	            context = _ref5.context;
	
	        var API = locator.resolve('api');
	        setTimeout(function getIsExportResultReady() {
	            if (state.get(['bitrix', 'isBitrix']) !== true || state.get(['account', 'orders', 'currentOrder', 'stateId']) !== 3 || state.get(['user', 'isFreeBitrixExportAllowed']) !== true) {
	                output.dontNeed();
	                return;
	            }
	
	            var orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
	            var request = API.getHasBitrixLeads(context, locator, orderId);
	            request.then(function (data) {
	                if (state.get(['account', 'orders', 'currentOrder', 'id']) !== orderId) {
	                    setTimeout(getIsExportResultReady, 0);
	                    return;
	                }
	
	                var statusCode = _.get(data, 'status.code');
	                if (statusCode !== 200) {
	                    output.error({ error: statusCode });
	                    return;
	                }
	
	                if (_.get(data, 'content') === true) {
	                    output.success({ hasBitrixLeads: true });
	                } else {
	                    setTimeout(getIsExportResultReady, 10000);
	                }
	            }).catch(function (error) {
	                output.error({ error: error });
	            });
	        }, 0);
	    },
	    waitBackendStandardState: function waitBackendStandardState(args, state, output, _ref6) {
	        var locator = _ref6.locator,
	            context = _ref6.context;
	
	        var API = locator.resolve('api');
	
	        var timerId = setTimeout(function waitWorkingRetry() {
	            var request = API.isBackendInStandardState(context, locator);
	            request.then(function (data) {
	                var statusCode = _.get(data, 'status.code');
	                if (statusCode !== 200) {
	                    output.error({ statusCode: code });
	                    return;
	                }
	
	                if (_.get(data, 'content') !== true) {
	                    timerId = setTimeout(waitWorkingRetry, 10000);
	                    return;
	                }
	
	                output.success();
	            }).catch(function (error) {
	                output.error({ error: error });
	            });
	        }, 0);
	    },
	    addCurrentOrderToList: function addCurrentOrderToList(args, state) {
	        var id = state.get(['account', 'orders', 'currentOrder', 'id']);
	        var list = state.get(['account', 'orders', 'list', 'data']);
	        if (_.findIndex(list, { id: id }) !== -1) {
	            return;
	        }
	        var listItem = {
	            id: id,
	            createDate: state.get(['account', 'orders', 'currentOrder', 'createDate']),
	            stateId: state.get(['account', 'orders', 'currentOrder', 'stateId']),
	            typeId: state.get(['account', 'orders', 'currentOrder', 'typeId'])
	        };
	        var newList = _.cloneDeep(list);
	        newList.unshift(listItem);
	        state.set(['account', 'orders', 'list', 'data'], newList);
	    }
	};

/***/ }),
/* 24 */
[1069, 424, 430, 428, 425, 431, 429, 426, 423, 427],
/* 25 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var form = __webpack_require__(205);
	
	module.exports = {
	    inputText: [form.inputText, form.validateUnsetError],
	
	    blurText: [form.trimText, form.validateText],
	
	    inputAndValidateText: [form.inputText, form.validateText]
	};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(3);
	
	module.exports = {
	    setSessionToken: function setSessionToken(_ref, state, output, _ref2) {
	        var auth = _ref.auth;
	        var context = _ref2.context;
	
	        var accessToken = _.get(auth, 'access_token');
	        var refreshToken = _.get(auth, 'refresh_token');
	        var expires = new Date(Date.now() + 3600 * 24 * 1000);
	
	        context.cookie.set({
	            key: 'access_token',
	            value: accessToken,
	            path: '/',
	            expires: expires
	        });
	
	        context.cookie.set({
	            key: 'refresh_token',
	            value: refreshToken,
	            path: '/',
	            expires: new Date(Date.now() + 3600 * 24 * 1000 * 30)
	        });
	    },
	    unsetSessionToken: function unsetSessionToken(args, state, output, _ref3) {
	        var context = _ref3.context;
	
	        context.cookie.set({
	            key: 'access_token',
	            value: '',
	            path: '/',
	            expires: -1
	        });
	
	        context.cookie.set({
	            key: 'refresh_token',
	            value: '',
	            path: '/',
	            expires: -1
	        });
	    },
	    setRegisterExtraToken: function setRegisterExtraToken(_ref4, state, output, _ref5) {
	        var auth = _ref4.auth;
	        var context = _ref5.context;
	
	        var accessToken = _.get(auth, 'access_token');
	        var refreshToken = _.get(auth, 'refresh_token');
	        var expires = new Date(Date.now() + 3600 * 24 * 1000);
	
	        context.cookie.set({
	            key: 'registration_extra_access_token',
	            value: accessToken,
	            path: '/',
	            expires: expires
	        });
	
	        context.cookie.set({
	            key: 'registration_extra_refresh_token',
	            value: refreshToken,
	            path: '/',
	            expires: new Date(Date.now() + 3600 * 24 * 1000 * 30)
	        });
	    },
	    unsetRegisterExtraToken: function unsetRegisterExtraToken(args, state, output, _ref6) {
	        var context = _ref6.context;
	
	        context.cookie.set({
	            key: 'registration_extra_access_token',
	            value: '',
	            path: '/',
	            expires: -1
	        });
	
	        context.cookie.set({
	            key: 'registration_extra_refresh_token',
	            value: '',
	            path: '/',
	            expires: -1
	        });
	    },
	    checkExistCookie: function checkExistCookie(args, state, output, _ref7) {
	        var context = _ref7.context;
	
	        var accessToken = context.cookie.get('access_token');
	
	        if (accessToken) {
	            output.exist();
	            return;
	        }
	
	        output.notExist();
	    },
	    getArgFromCookie: function getArgFromCookie(argName, cookieKey) {
	        return function (args, state, output, _ref8) {
	            var context = _ref8.context;
	
	            args[argName] = context.cookie.get(cookieKey);
	        };
	    },
	    unsetCookie: function unsetCookie(_ref9) {
	        var key = _ref9.key;
	
	        return function (args, state, output, _ref10) {
	            var context = _ref10.context;
	
	            context.cookie.set({
	                key: key,
	                value: '',
	                path: '/',
	                expires: -1
	            });
	        };
	    }
	};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(3);
	
	var PERMISSIONS = {
	    client: ['account'],
	    manager: ['manager'],
	    unauthorized: []
	};
	
	module.exports = {
	    updateUserRole: function updateUserRole(_ref, state) {
	        var user = _ref.user;
	
	        var role = user.isManager ? 'manager' : 'client';
	        if (state.get(['user', 'role']) !== role) {
	            state.set(['user', 'role'], role);
	        }
	    },
	    addUserRole: function addUserRole(_ref2, state, output) {
	        var user = _ref2.user;
	
	        var role = user.isManager ? 'manager' : 'client';
	        var extendedUser = Object.assign({ role: role }, user);
	
	        output({ extendedUser: extendedUser });
	    },
	    getUser: function getUser(_ref3, state, output, _ref4) {
	        var auth = _ref3.auth;
	        var locator = _ref4.locator,
	            context = _ref4.context;
	
	        var api = locator.resolve('api');
	        var requestArgs = {};
	        if (!state.get(['bitrix', 'isBitrix'])) {
	            requestArgs.token = _.get(auth, 'access_token');
	        }
	        var request = api.getCurrentUser(context, locator, requestArgs);
	        var username = state.get(['login', 'form', 'username']);
	
	        request.then(function (response) {
	            var code = _.get(response, 'status.code');
	            var content = _.get(response, 'content');
	
	            if (code === 200) {
	                output.allowed({
	                    user: content
	                });
	                return;
	            }
	
	            if (code === 503) {
	                if (content === 'NameResolutionFailure') {
	                    output.nameResolutionFailure();
	                    return;
	                } else if (content === 'TrustFailure') {
	                    output.trustFailure();
	                    return;
	                }
	            }
	
	            if (output[code]) {
	                output[code]({ username: username });
	                return;
	            }
	
	            output.denied();
	        }).catch(function () {
	            output.denied();
	        });
	    },
	    refreshToken: function refreshToken(args, state, output, _ref5) {
	        var locator = _ref5.locator,
	            context = _ref5.context;
	
	        var refreshToken = context.cookie.get('refresh_token');
	
	        var methodParams = {
	            grant_type: 'refresh',
	            client_id: 'hermes',
	            refresh_token: refreshToken
	        };
	
	        var API = locator.resolve('api');
	        var request = API.refreshToken(context, { methodParams: methodParams });
	
	        request.then(function (data) {
	            var code = _.get(data, 'status.code');
	            var auth = _.get(data, 'content');
	
	            if (code === 401) {
	                output.accessDenied({ code: code });
	                return;
	            }
	
	            if (code === 400) {
	                output.invalidValidation({ code: code });
	                return;
	            }
	
	            if (code !== 200) {
	                output.error({ code: code });
	                return;
	            }
	
	            output.success({ auth: auth });
	        }).catch(function (error) {
	            return output.error({ error: error });
	        });
	    },
	    checkAccessCookie: function checkAccessCookie(args, state, output, _ref6) {
	        var context = _ref6.context;
	
	        var token = context.cookie.get('access_token');
	
	        if (token) {
	            output.exist({ token: token });
	            return;
	        }
	
	        output.notExist();
	    },
	    checkRefreshCookie: function checkRefreshCookie(args, state, output, _ref7) {
	        var context = _ref7.context;
	
	        var refreshToken = context.cookie.get('refresh_token');
	
	        if (refreshToken) {
	            output.exist({ refreshToken: refreshToken });
	            return;
	        }
	
	        output.notExist();
	    },
	    checkPermissions: function checkPermissions(key) {
	        return function checkPermissions(args, state, output) {
	            var role = state.get(['user', 'role']);
	
	            var isAllowed = _.includes(PERMISSIONS[role], key);
	
	            if (isAllowed) {
	                output.allowed();
	                return;
	            }
	
	            output.denied();
	        };
	    },
	    isUnauthorized: function isUnauthorized(args, state, output) {
	        var role = state.get(['user', 'role']);
	
	        if (role === 'unauthorized') {
	            output.yes();
	        } else {
	            output.no();
	        }
	    },
	    isManager: function isManager(args, state, output) {
	        var role = state.get(['user', 'role']);
	
	        if (role === 'manager') {
	            output.true();
	        } else {
	            output.false();
	        }
	    },
	    addUserToArgs: function addUserToArgs(args, state, output) {
	        var user = state.get(['account', 'orders', 'currentOrder', 'localChanges', 'selectedUser']);
	        output({ user: user });
	    },
	    isUserChanged: function isUserChanged(args, state, output) {
	        var user = state.get(['account', 'orders', 'currentOrder', 'localChanges', 'selectedUser']);
	        if (user) {
	            output.true();
	        } else {
	            output.false();
	        }
	    },
	    isEmailAssociated: function isEmailAssociated(_ref8, state, output, _ref9) {
	        var email = _ref8.email;
	        var locator = _ref9.locator,
	            context = _ref9.context;
	
	        var API = locator.resolve('api');
	        var request = API.isEmailAssociated(context, locator, email);
	
	        request.then(function (data) {
	            var code = _.get(data, 'status.code');
	
	            if (code === 404) {
	                output.no();
	                return;
	            }
	
	            if (code !== 200) {
	                output.error({ error: code });
	                return;
	            }
	
	            output.yes();
	        }).catch(function (error) {
	            return output.error({ error: error });
	        });
	    }
	};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bitrix = __webpack_require__(70);
	var order = __webpack_require__(75);
	var orders = __webpack_require__(41);
	var currentOrder = __webpack_require__(23);
	var error = __webpack_require__(19);
	var utils = __webpack_require__(5);
	var accountUi = __webpack_require__(138);
	var user = __webpack_require__(28);
	var content = __webpack_require__(20);
	
	var _require = __webpack_require__(11),
	    usingLock = _require.usingLock;
	
	var analytics = __webpack_require__(7);
	var form = __webpack_require__(26);
	
	var getUser = [[user.getUser, {
	    allowed: [utils.updateStateFromArg('user', ['user']), user.updateUserRole],
	    nameResolutionFailure: [utils.set(['user', 'role'], 'unauthorized'), error.bitrixUnavailableError('user.getUser')],
	    trustFailure: [utils.set(['user', 'role'], 'unauthorized'), error.bitrixCertificateError('user.getUser')],
	    denied: [utils.set(['user', 'role'], 'unauthorized')]
	}]];
	
	var exportJobSuccessHandler = [utils.set(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'isExportDone'], true), [utils.isArgEqual('isExportFree', true), {
	    yes: [utils.setArgFromState('orderId', ['account', 'orders', 'currentOrder', 'id']), [orders.getOrder, {
	        success: [utils.setArgByFunction('price', function (args) {
	            return args['currentOrder'].price;
	        }), utils.setArgByFunction('necessaryDocuments', function (args) {
	            return args['currentOrder'].necessaryDocuments;
	        }), utils.setArgByFunction('paymentForm', function (args) {
	            return args['currentOrder'].paymentForm;
	        }), utils.setArgByFunction('freeLeadsAmount', function (args) {
	            return args['currentOrder'].freeLeadsAmount;
	        }), currentOrder.updateOrder(['price', 'necessaryDocuments', 'paymentForm', 'freeLeadsAmount'])],
	        notFound: [],
	        error: []
	    }]],
	    no: []
	}]];
	
	var backToOrderPage = [utils.unset(['account', 'orders', 'currentOrder', 'showBitrixLeadMapping']), utils.unset(['account', 'orders', 'currentOrder', 'bitrixExportLeads'])];
	
	var exportLeads = [[bitrix.exportLeads, {
	    success: [[utils.isArgEqual('isExportFree', true), {
	        yes: [utils.set(['user', 'isFreeBitrixExportAllowed'], false)],
	        no: []
	    }], [bitrix.getExportJobProgress, {
	        success: [].concat(exportJobSuccessHandler),
	        dontNeed: [],
	        error: [error.internalError('bitrix.getExportJobProgress')]
	    }]],
	
	    forbidden: [utils.unset(['user', 'isFreeBitrixExportAllowed'])].concat(backToOrderPage),
	    error: [error.internalError('bitrix.exportLeads')]
	}]];
	
	module.exports = {
	    onLoad: [[utils.isEqual(['bitrix', 'isInit'], true), {
	        yes: [],
	        no: [[bitrix.init, {
	            success: [utils.set(['bitrix', 'isInit'], true)],
	            error: [error.internalError('bitrix.init')]
	        }], bitrix.fitWindow]
	    }], [utils.isEqual(['user', 'id'], undefined), {
	        yes: [].concat(getUser),
	        no: []
	    }]].concat(order.onLoad, [bitrix.resize]),
	
	    getUser: getUser,
	
	    exportLeads: exportLeads,
	
	    setIncludeExportedFreeLeads: [utils.setFromArgsToState('value', ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'isIncludeExportedFreeLeads'])],
	
	    setBitrixRequiredFieldValue: [bitrix.setBitrixRequiredFieldValue, bitrix.validateMapping],
	
	    exportLeadsUsingMapping: [].concat(usingLock(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'exportLeadsProgressLock'], [bitrix.addLeadMappingToArgs, [utils.isArgEqual('isExportFree', true), {
	        yes: [analytics.argsValueEvent({ category: 'button_bitrix_export_free', action: 'click' })],
	        no: []
	    }], [utils.isDefined(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'requiredBitrixFields']), {
	        yes: [analytics.argsValueEvent({ category: 'button_bitrix_export_w_required_fields',
	            action: 'click' })],
	        no: []
	    }]].concat(exportLeads))),
	
	    backToOrderPage: backToOrderPage,
	
	    redirectToLeadsMapping: [utils.set(['account', 'orders', 'currentOrder', 'showBitrixLeadMapping'], true), content.setIsLoading(true), [bitrix.getLeadFields, {
	        success: [bitrix.initBitrixLeads, bitrix.validateMapping, [utils.isDefined(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'requiredBitrixFields']), {
	            yes: [analytics.argsValueEvent({ category: 'bitrix_required_fields_are_shown',
	                action: 'see' })],
	            no: []
	        }]],
	        error: [error.internalError('bitrix.getLeadFields')]
	    }], utils.setFromArgsToState('isExportFree', ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'isExportFree']), content.setIsLoading(false), bitrix.scrollTop],
	
	    selectHermesToBitrixLeadMapping: [bitrix.selectBitrixLeadField, bitrix.validateMapping],
	
	    selectHermesLeadRequiredValue: [utils.setArgByFunction('optionsPath', function (args) {
	        return ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'requiredFields', args.field, 'enumValues'];
	    }), accountUi.selectChanged, utils.setFromArgsToState('selectedValue', 'account.orders.currentOrder.bitrixExportLeads.requiredFields.${id}.value', { id: 'field' }), bitrix.validateMapping],
	
	    toogleFieldMappingIsNew: [utils.toggleBoolFromArgs, bitrix.validateMapping],
	
	    inputTextWithValidateMapping: [].concat(form.inputText, [bitrix.validateMapping]),
	
	    blurTextWithValidateMapping: [].concat(form.blurText, [bitrix.validateMapping]),
	
	    validateMapping: [bitrix.validateMapping],
	
	    setDate: function setDate(basePath) {
	        return [accountUi.setDate(basePath), bitrix.validateMapping];
	    },
	    unsetDate: function unsetDate(basePath) {
	        return [accountUi.unsetDate(basePath), bitrix.validateMapping];
	    },
	
	
	    resize: [bitrix.resize],
	
	    resizeIfAccountPage: [[utils.isEqual(['page', 'name'], 'account'), {
	        yes: [bitrix.resize],
	        no: []
	    }]]
	};

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var order = __webpack_require__(100);
	
	var _require = __webpack_require__(231),
	    calcPriceGroup = _require.calcPriceGroup;
	
	var customOrder = __webpack_require__(42);
	var currentOrder = __webpack_require__(23);
	var price = __webpack_require__(71);
	var content = __webpack_require__(20);
	var utils = __webpack_require__(5);
	var error = __webpack_require__(19);
	
	var _require2 = __webpack_require__(74),
	    setOrderParametersGroup = _require2.setOrderParametersGroup,
	    getAvailableParametersGroup = _require2.getAvailableParametersGroup;
	
	var _require3 = __webpack_require__(74),
	    restoreStateGroup = _require3.restoreStateGroup;
	
	module.exports = {
	    calcPriceGroup: calcPriceGroup,
	
	    setMapFilter: [utils.setFromArgsToState('mapFilter', ['order', 'cities', 'mapFilter'])].concat(calcPriceGroup),
	
	    initSelectedParamsFromLocalStorageGroup: [[utils.getItemFromLocalStorage('selected_params', 'selectedParameters'), {
	        success: [].concat(restoreStateGroup, [currentOrder.updateOrder(['selectedParameters']), content.setIsLoading(false)], calcPriceGroup, [customOrder.unsetFilterValuesChanged]),
	        notExists: [],
	        unavailable: []
	    }]],
	
	    startRestoringSelectedParams: [[order.getDraftOrder, {
	        success: [].concat(setOrderParametersGroup, [order.setShouldRestoreFromLocalStorage(false)], restoreStateGroup, [price.setPrice, utils.setFromArgsToState('id', ['order', 'draft', 'id']), utils.setFromArgsToState('isNeedToConfirmDataChanged', ['order', 'draft', 'isNeedToConfirmDataChanged'])]),
	        error: [].concat(getAvailableParametersGroup, [order.setShouldRestoreFromLocalStorage(true), price.setIsLoading(true), content.setIsLoading(true)])
	    }], customOrder.setComputedFields],
	
	    resetDraftGroup: [order.removeSavedSelectedParams].concat(restoreStateGroup, [[order.hasDraftOrderLoaded, {
	        yes: [[order.archiveOrder, {
	            success: [],
	            error: [error.internalError('order.archiveOrder')]
	        }]],
	        no: []
	    }]], calcPriceGroup)
	};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(17);
	var createDesc = __webpack_require__(81);
	module.exports = __webpack_require__(16) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(8);
	var hide = __webpack_require__(31);
	var has = __webpack_require__(37);
	var SRC = __webpack_require__(85)('src');
	var $toString = __webpack_require__(540);
	var TO_STRING = 'toString';
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(47).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var fails = __webpack_require__(9);
	var defined = __webpack_require__(52);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.30.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks() {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return (
	            input instanceof Array ||
	            Object.prototype.toString.call(input) === '[object Array]'
	        );
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return (
	            input != null &&
	            Object.prototype.toString.call(input) === '[object Object]'
	        );
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return Object.getOwnPropertyNames(obj).length === 0;
	        } else {
	            var k;
	            for (k in obj) {
	                if (hasOwnProp(obj, k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return (
	            typeof input === 'number' ||
	            Object.prototype.toString.call(input) === '[object Number]'
	        );
	    }
	
	    function isDate(input) {
	        return (
	            input instanceof Date ||
	            Object.prototype.toString.call(input) === '[object Date]'
	        );
	    }
	
	    function map(arr, fn) {
	        var res = [],
	            i,
	            arrLen = arr.length;
	        for (i = 0; i < arrLen; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidEra: null,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false,
	            parsedDateParts: [],
	            era: null,
	            meridiem: null,
	            rfc2822: false,
	            weekdayMismatch: false,
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this),
	                len = t.length >>> 0,
	                i;
	
	            for (i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        var flags = null,
	            parsedParts = false,
	            isNowValid = m._d && !isNaN(m._d.getTime());
	        if (isNowValid) {
	            flags = getParsingFlags(m);
	            parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            isNowValid =
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidEra &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	            if (m._strict) {
	                isNowValid =
	                    isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	        }
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        } else {
	            return isNowValid;
	        }
	        return m._isValid;
	    }
	
	    function createInvalid(flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = (hooks.momentProperties = []),
	        updateInProgress = false;
	
	    function copyConfig(to, from) {
	        var i,
	            prop,
	            val,
	            momentPropertiesLen = momentProperties.length;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentPropertiesLen > 0) {
	            for (i = 0; i < momentPropertiesLen; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment(obj) {
	        return (
	            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	        );
	    }
	
	    function warn(msg) {
	        if (
	            hooks.suppressDeprecationWarnings === false &&
	            typeof console !== 'undefined' &&
	            console.warn
	        ) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [],
	                    arg,
	                    i,
	                    key,
	                    argLen = arguments.length;
	                for (i = 0; i < argLen; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (key in arguments[0]) {
	                            if (hasOwnProp(arguments[0], key)) {
	                                arg += key + ': ' + arguments[0][key] + ', ';
	                            }
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(
	                    msg +
	                        '\nArguments: ' +
	                        Array.prototype.slice.call(args).join('') +
	                        '\n' +
	                        new Error().stack
	                );
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    function set(config) {
	        var prop, i;
	        for (i in config) {
	            if (hasOwnProp(config, i)) {
	                prop = config[i];
	                if (isFunction(prop)) {
	                    this[i] = prop;
	                } else {
	                    this['_' + i] = prop;
	                }
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' +
	                /\d{1,2}/.source
	        );
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig),
	            prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (
	                hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])
	            ) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i,
	                res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    };
	
	    function calendar(key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (
	            (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	            absNumber
	        );
	    }
	
	    var formattingTokens =
	            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	        formatFunctions = {},
	        formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(
	                    func.apply(this, arguments),
	                    token
	                );
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '',
	                i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i])
	                    ? array[i].call(mom, format)
	                    : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] =
	            formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(
	                localFormattingTokens,
	                replaceLongDateFormatTokens
	            );
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A',
	    };
	
	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper
	            .match(formattingTokens)
	            .map(function (tok) {
	                if (
	                    tok === 'MMMM' ||
	                    tok === 'MM' ||
	                    tok === 'DD' ||
	                    tok === 'dddd'
	                ) {
	                    return tok.slice(1);
	                }
	                return tok;
	            })
	            .join('');
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate() {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d',
	        defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        w: 'a week',
	        ww: '%d weeks',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    };
	
	    function relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return isFunction(output)
	            ? output(number, withoutSuffix, string, isFuture)
	            : output.replace(/%d/i, number);
	    }
	
	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {
	        D: 'date',
	        dates: 'date',
	        date: 'date',
	        d: 'day',
	        days: 'day',
	        day: 'day',
	        e: 'weekday',
	        weekdays: 'weekday',
	        weekday: 'weekday',
	        E: 'isoWeekday',
	        isoweekdays: 'isoWeekday',
	        isoweekday: 'isoWeekday',
	        DDD: 'dayOfYear',
	        dayofyears: 'dayOfYear',
	        dayofyear: 'dayOfYear',
	        h: 'hour',
	        hours: 'hour',
	        hour: 'hour',
	        ms: 'millisecond',
	        milliseconds: 'millisecond',
	        millisecond: 'millisecond',
	        m: 'minute',
	        minutes: 'minute',
	        minute: 'minute',
	        M: 'month',
	        months: 'month',
	        month: 'month',
	        Q: 'quarter',
	        quarters: 'quarter',
	        quarter: 'quarter',
	        s: 'second',
	        seconds: 'second',
	        second: 'second',
	        gg: 'weekYear',
	        weekyears: 'weekYear',
	        weekyear: 'weekYear',
	        GG: 'isoWeekYear',
	        isoweekyears: 'isoWeekYear',
	        isoweekyear: 'isoWeekYear',
	        w: 'week',
	        weeks: 'week',
	        week: 'week',
	        W: 'isoWeek',
	        isoweeks: 'isoWeek',
	        isoweek: 'isoWeek',
	        y: 'year',
	        years: 'year',
	        year: 'year',
	    };
	
	    function normalizeUnits(units) {
	        return typeof units === 'string'
	            ? aliases[units] || aliases[units.toLowerCase()]
	            : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {
	        date: 9,
	        day: 11,
	        weekday: 11,
	        isoWeekday: 11,
	        dayOfYear: 4,
	        hour: 13,
	        millisecond: 16,
	        minute: 14,
	        month: 8,
	        quarter: 7,
	        second: 15,
	        weekYear: 1,
	        isoWeekYear: 1,
	        week: 5,
	        isoWeek: 5,
	        year: 1,
	    };
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [],
	            u;
	        for (u in unitsObj) {
	            if (hasOwnProp(unitsObj, u)) {
	                units.push({ unit: u, priority: priorities[u] });
	            }
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    var match1 = /\d/, //       0 - 9
	        match2 = /\d\d/, //      00 - 99
	        match3 = /\d{3}/, //     000 - 999
	        match4 = /\d{4}/, //    0000 - 9999
	        match6 = /[+-]?\d{6}/, // -999999 - 999999
	        match1to2 = /\d\d?/, //       0 - 99
	        match3to4 = /\d\d\d\d?/, //     999 - 9999
	        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	        match1to3 = /\d{1,3}/, //       0 - 999
	        match1to4 = /\d{1,4}/, //       0 - 9999
	        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	        matchUnsigned = /\d+/, //       0 - inf
	        matchSigned = /[+-]?\d+/, //    -inf - inf
	        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	        // any word (or two) characters or numbers including two/three word month in arabic.
	        // includes scottish gaelic two word and hyphenated months
	        matchWord =
	            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	        match1to2NoLeadingZero = /^[1-9]\d?/, //         1-99
	        match1to2HasZero = /^([1-9]\d|\d)/, //           0-99
	        regexes;
	
	    regexes = {};
	
	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex)
	            ? regex
	            : function (isStrict, localeData) {
	                  return isStrict && strictRegex ? strictRegex : regex;
	              };
	    }
	
	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(
	            s
	                .replace('\\', '')
	                .replace(
	                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
	                    function (matched, p1, p2, p3, p4) {
	                        return p1 || p2 || p3 || p4;
	                    }
	                )
	        );
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    function absFloor(number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    var tokens = {};
	
	    function addParseToken(token, callback) {
	        var i,
	            func = callback,
	            tokenLen;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        tokenLen = token.length;
	        for (i = 0; i < tokenLen; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    var YEAR = 0,
	        MONTH = 1,
	        DATE = 2,
	        HOUR = 3,
	        MINUTE = 4,
	        SECOND = 5,
	        MILLISECOND = 6,
	        WEEK = 7,
	        WEEKDAY = 8;
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // PARSING
	
	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] =
	            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }
	
	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get(mom, unit) {
	        if (!mom.isValid()) {
	            return NaN;
	        }
	
	        var d = mom._d,
	            isUTC = mom._isUTC;
	
	        switch (unit) {
	            case 'Milliseconds':
	                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
	            case 'Seconds':
	                return isUTC ? d.getUTCSeconds() : d.getSeconds();
	            case 'Minutes':
	                return isUTC ? d.getUTCMinutes() : d.getMinutes();
	            case 'Hours':
	                return isUTC ? d.getUTCHours() : d.getHours();
	            case 'Date':
	                return isUTC ? d.getUTCDate() : d.getDate();
	            case 'Day':
	                return isUTC ? d.getUTCDay() : d.getDay();
	            case 'Month':
	                return isUTC ? d.getUTCMonth() : d.getMonth();
	            case 'FullYear':
	                return isUTC ? d.getUTCFullYear() : d.getFullYear();
	            default:
	                return NaN; // Just in case
	        }
	    }
	
	    function set$1(mom, unit, value) {
	        var d, isUTC, year, month, date;
	
	        if (!mom.isValid() || isNaN(value)) {
	            return;
	        }
	
	        d = mom._d;
	        isUTC = mom._isUTC;
	
	        switch (unit) {
	            case 'Milliseconds':
	                return void (isUTC
	                    ? d.setUTCMilliseconds(value)
	                    : d.setMilliseconds(value));
	            case 'Seconds':
	                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
	            case 'Minutes':
	                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
	            case 'Hours':
	                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
	            case 'Date':
	                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
	            // case 'Day': // Not real
	            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
	            // case 'Month': // Not used because we need to pass two variables
	            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
	            case 'FullYear':
	                break; // See below ...
	            default:
	                return; // Just in case
	        }
	
	        year = value;
	        month = mom.month();
	        date = mom.date();
	        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
	        void (isUTC
	            ? d.setUTCFullYear(year, month, date)
	            : d.setFullYear(year, month, date));
	    }
	
	    // MOMENTS
	
	    function stringGet(units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	    function stringSet(units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units),
	                i,
	                prioritizedLen = prioritized.length;
	            for (i = 0; i < prioritizedLen; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1
	            ? isLeapYear(year)
	                ? 29
	                : 28
	            : 31 - ((modMonth % 7) % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // PARSING
	
	    addRegexToken('M', match1to2, match1to2NoLeadingZero);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths =
	            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	                '_'
	            ),
	        defaultLocaleMonthsShort =
	            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	        defaultMonthsShortRegex = matchWord,
	        defaultMonthsRegex = matchWord;
	
	    function localeMonths(m, format) {
	        if (!m) {
	            return isArray(this._months)
	                ? this._months
	                : this._months['standalone'];
	        }
	        return isArray(this._months)
	            ? this._months[m.month()]
	            : this._months[
	                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                      ? 'format'
	                      : 'standalone'
	              ][m.month()];
	    }
	
	    function localeMonthsShort(m, format) {
	        if (!m) {
	            return isArray(this._monthsShort)
	                ? this._monthsShort
	                : this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort)
	            ? this._monthsShort[m.month()]
	            : this._monthsShort[
	                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	              ][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp(
	                    '^' + this.months(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	                this._shortMonthsParse[i] = new RegExp(
	                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex =
	                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'MMMM' &&
	                this._longMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'MMM' &&
	                this._shortMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth(mom, value) {
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        var month = value,
	            date = mom.date();
	
	        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
	        void (mom._isUTC
	            ? mom._d.setUTCMonth(month, date)
	            : mom._d.setMonth(month, date));
	        return mom;
	    }
	
	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function monthsShortRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict
	                ? this._monthsShortStrictRegex
	                : this._monthsShortRegex;
	        }
	    }
	
	    function monthsRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict
	                ? this._monthsStrictRegex
	                : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            shortP,
	            longP;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortP = regexEscape(this.monthsShort(mom, ''));
	            longP = regexEscape(this.months(mom, ''));
	            shortPieces.push(shortP);
	            longPieces.push(longP);
	            mixedPieces.push(longP);
	            mixedPieces.push(shortP);
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._monthsShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    function createDate(y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate(y) {
	        var date, args;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear,
	            resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear,
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek,
	            resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear,
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // PARSING
	
	    addRegexToken('w', match1to2, match1to2NoLeadingZero);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2, match1to2NoLeadingZero);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(
	        ['w', 'ww', 'W', 'WW'],
	        function (input, week, config, token) {
	            week[token.substr(0, 1)] = toInt(input);
	        }
	    );
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // PARSING
	
	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd', function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd', function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays(ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays =
	            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        defaultWeekdaysRegex = matchWord,
	        defaultWeekdaysShortRegex = matchWord,
	        defaultWeekdaysMinRegex = matchWord;
	
	    function localeWeekdays(m, format) {
	        var weekdays = isArray(this._weekdays)
	            ? this._weekdays
	            : this._weekdays[
	                  m && m !== true && this._weekdays.isFormat.test(format)
	                      ? 'format'
	                      : 'standalone'
	              ];
	        return m === true
	            ? shiftWeekdays(weekdays, this._week.dow)
	            : m
	              ? weekdays[m.day()]
	              : weekdays;
	    }
	
	    function localeWeekdaysShort(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : m
	              ? this._weekdaysShort[m.day()]
	              : this._weekdaysShort;
	    }
	
	    function localeWeekdaysMin(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : m
	              ? this._weekdaysMin[m.day()]
	              : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse(weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._shortWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._minWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	            }
	            if (!this._weekdaysParse[i]) {
	                regex =
	                    '^' +
	                    this.weekdays(mom, '') +
	                    '|^' +
	                    this.weekdaysShort(mom, '') +
	                    '|^' +
	                    this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'dddd' &&
	                this._fullWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'ddd' &&
	                this._shortWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'dd' &&
	                this._minWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        var day = get(this, 'Day');
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    function weekdaysRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict
	                ? this._weekdaysStrictRegex
	                : this._weekdaysRegex;
	        }
	    }
	
	    function weekdaysShortRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict
	                ? this._weekdaysShortStrictRegex
	                : this._weekdaysShortRegex;
	        }
	    }
	
	    function weekdaysMinRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict
	                ? this._weekdaysMinStrictRegex
	                : this._weekdaysMinRegex;
	        }
	    }
	
	    function computeWeekdaysParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [],
	            shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            minp,
	            shortp,
	            longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = regexEscape(this.weekdaysMin(mom, ''));
	            shortp = regexEscape(this.weekdaysShort(mom, ''));
	            longp = regexEscape(this.weekdays(mom, ''));
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysMinStrictRegex = new RegExp(
	            '^(' + minPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return (
	            '' +
	            hFormat.apply(this) +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return (
	            '' +
	            this.hours() +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(
	                this.hours(),
	                this.minutes(),
	                lowercase
	            );
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // PARSING
	
	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2, match1to2HasZero);
	    addRegexToken('h', match1to2, match1to2NoLeadingZero);
	    addRegexToken('k', match1to2, match1to2NoLeadingZero);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	        // Setting the hour should keep the time, because the user explicitly
	        // specified which hour they want. So trying to maintain the same hour (in
	        // a new timezone) makes sense. Adding/subtracting hours does not follow
	        // this rule.
	        getSetHour = makeGetSet('Hours', true);
	
	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse,
	    };
	
	    // internal storage for locale config files
	    var locales = {},
	        localeFamilies = {},
	        globalLocale;
	
	    function commonPrefix(arr1, arr2) {
	        var i,
	            minl = Math.min(arr1.length, arr2.length);
	        for (i = 0; i < minl; i += 1) {
	            if (arr1[i] !== arr2[i]) {
	                return i;
	            }
	        }
	        return minl;
	    }
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (
	                    next &&
	                    next.length >= j &&
	                    commonPrefix(split, next) >= j - 1
	                ) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function isLocaleNameSane(name) {
	        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
	        // Ensure name is available and function returns boolean
	        return !!(name && name.match('^[^/\\\\]*$'));
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null,
	            aliasedRequire;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (
	            locales[name] === undefined &&
	            typeof module !== 'undefined' &&
	            module &&
	            module.exports &&
	            isLocaleNameSane(name)
	        ) {
	            try {
	                oldLocale = globalLocale._abbr;
	                aliasedRequire = require;
	                __webpack_require__(1046)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {
	                // mark as not found to avoid repeating expensive file require call causing high CPU
	                // when trying to find en-US, en_US, en-us for every format call
	                locales[name] = null; // null means not found
	            }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            } else {
	                if (typeof console !== 'undefined' && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn(
	                        'Locale ' + key + ' not found. Did you forget to load it?'
	                    );
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale(name, config) {
	        if (config !== null) {
	            var locale,
	                parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple(
	                    'defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	                );
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config,
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale,
	                tmpLocale,
	                parentConfig = baseConfig;
	
	            if (locales[name] != null && locales[name].parentLocale != null) {
	                // Update existing child locale in-place to avoid memory-leaks
	                locales[name].set(mergeConfigs(locales[name]._config, config));
	            } else {
	                // MERGE
	                tmpLocale = loadLocale(name);
	                if (tmpLocale != null) {
	                    parentConfig = tmpLocale._config;
	                }
	                config = mergeConfigs(parentConfig, config);
	                if (tmpLocale == null) {
	                    // updateLocale is called for creating a new locale
	                    // Set abbr so it will have a name (getters return
	                    // undefined otherwise).
	                    config.abbr = name;
	                }
	                locale = new Locale(config);
	                locale.parentLocale = locales[name];
	                locales[name] = locale;
	            }
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                    if (name === getSetGlobalLocale()) {
	                        getSetGlobalLocale(name);
	                    }
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale(key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow(m) {
	        var overflow,
	            a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH] < 0 || a[MONTH] > 11
	                    ? MONTH
	                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                      ? DATE
	                      : a[HOUR] < 0 ||
	                          a[HOUR] > 24 ||
	                          (a[HOUR] === 24 &&
	                              (a[MINUTE] !== 0 ||
	                                  a[SECOND] !== 0 ||
	                                  a[MILLISECOND] !== 0))
	                        ? HOUR
	                        : a[MINUTE] < 0 || a[MINUTE] > 59
	                          ? MINUTE
	                          : a[SECOND] < 0 || a[SECOND] > 59
	                            ? SECOND
	                            : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                              ? MILLISECOND
	                              : -1;
	
	            if (
	                getParsingFlags(m)._overflowDayOfYear &&
	                (overflow < YEAR || overflow > DATE)
	            ) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        basicIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	        isoDates = [
	            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	            ['YYYY-DDD', /\d{4}-\d{3}/],
	            ['YYYY-MM', /\d{4}-\d\d/, false],
	            ['YYYYYYMMDD', /[+-]\d{10}/],
	            ['YYYYMMDD', /\d{8}/],
	            ['GGGG[W]WWE', /\d{4}W\d{3}/],
	            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	            ['YYYYDDD', /\d{7}/],
	            ['YYYYMM', /\d{6}/, false],
	            ['YYYY', /\d{4}/, false],
	        ],
	        // iso time formats and regexes
	        isoTimes = [
	            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	            ['HH:mm', /\d\d:\d\d/],
	            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	            ['HHmmss', /\d\d\d\d\d\d/],
	            ['HHmm', /\d\d\d\d/],
	            ['HH', /\d\d/],
	        ],
	        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	        rfc2822 =
	            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	        obsOffsets = {
	            UT: 0,
	            GMT: 0,
	            EDT: -4 * 60,
	            EST: -5 * 60,
	            CDT: -5 * 60,
	            CST: -6 * 60,
	            MDT: -6 * 60,
	            MST: -7 * 60,
	            PDT: -7 * 60,
	            PST: -8 * 60,
	        };
	
	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime,
	            dateFormat,
	            timeFormat,
	            tzFormat,
	            isoDatesLen = isoDates.length,
	            isoTimesLen = isoTimes.length;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	            for (i = 0, l = isoDatesLen; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimesLen; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    function extractFromRFC2822Strings(
	        yearStr,
	        monthStr,
	        dayStr,
	        hourStr,
	        minuteStr,
	        secondStr
	    ) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10),
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s
	            .replace(/\([^()]*\)|[\n\t]/g, ' ')
	            .replace(/(\s\s+)/g, ' ')
	            .replace(/^\s\s*/, '')
	            .replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(
	                    parsedInput[0],
	                    parsedInput[1],
	                    parsedInput[2]
	                ).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10),
	                m = hm % 100,
	                h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i)),
	            parsedArray;
	        if (match) {
	            parsedArray = extractFromRFC2822Strings(
	                match[4],
	                match[3],
	                match[2],
	                match[5],
	                match[6],
	                match[7]
	            );
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        if (config._strict) {
	            config._isValid = false;
	        } else {
	            // Final attempt, use Input Fallback
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [
	                nowValue.getUTCFullYear(),
	                nowValue.getUTCMonth(),
	                nowValue.getUTCDate(),
	            ];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            expectedWeekday,
	            yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (
	                config._dayOfYear > daysInYear(yearToUse) ||
	                config._dayOfYear === 0
	            ) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] =
	                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (
	            config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0
	        ) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(
	            null,
	            input
	        );
	        expectedWeekday = config._useUTC
	            ? config._d.getUTCDay()
	            : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (
	            config._w &&
	            typeof config._w.d !== 'undefined' &&
	            config._w.d !== expectedWeekday
	        ) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(
	                w.GG,
	                config._a[YEAR],
	                weekOfYear(createLocal(), 1, 4).year
	            );
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0,
	            era,
	            tokenLen;
	
	        tokens =
	            expandFormat(config._f, config._locale).match(formattingTokens) || [];
	        tokenLen = tokens.length;
	        for (i = 0; i < tokenLen; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	                [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(
	                    string.indexOf(parsedInput) + parsedInput.length
	                );
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver =
	            stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (
	            config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0
	        ) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(
	            config._locale,
	            config._a[HOUR],
	            config._meridiem
	        );
	
	        // handle era
	        era = getParsingFlags(config).era;
	        if (era !== null) {
	            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	        }
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	            scoreToBeat,
	            i,
	            currentScore,
	            validFormatFound,
	            bestFormatIsValid = false,
	            configfLen = config._f.length;
	
	        if (configfLen === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < configfLen; i++) {
	            currentScore = 0;
	            validFormatFound = false;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (isValid(tempConfig)) {
	                validFormatFound = true;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (!bestFormatIsValid) {
	                if (
	                    scoreToBeat == null ||
	                    currentScore < scoreToBeat ||
	                    validFormatFound
	                ) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                    if (validFormatFound) {
	                        bestFormatIsValid = true;
	                    }
	                }
	            } else {
	                if (currentScore < scoreToBeat) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                }
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i),
	            dayOrDate = i.day === undefined ? i.date : i.day;
	        config._a = map(
	            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	            function (obj) {
	                return obj && parseInt(obj, 10);
	            }
	        );
	
	        configFromArray(config);
	    }
	
	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({ nullInput: true });
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (format === true || format === false) {
	            strict = format;
	            format = undefined;
	        }
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if (
	            (isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)
	        ) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other < this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        ),
	        prototypeMax = deprecate(
	            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other > this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +new Date();
	    };
	
	    var ordering = [
	        'year',
	        'quarter',
	        'month',
	        'week',
	        'day',
	        'hour',
	        'minute',
	        'second',
	        'millisecond',
	    ];
	
	    function isDurationValid(m) {
	        var key,
	            unitHasDecimal = false,
	            i,
	            orderLen = ordering.length;
	        for (key in m) {
	            if (
	                hasOwnProp(m, key) &&
	                !(
	                    indexOf.call(ordering, key) !== -1 &&
	                    (m[key] == null || !isNaN(m[key]))
	                )
	            ) {
	                return false;
	            }
	        }
	
	        for (i = 0; i < orderLen; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds =
	            +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound(number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (
	                (dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
	            ) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    // FORMATTING
	
	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset(),
	                sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return (
	                sign +
	                zeroFill(~~(offset / 60), 2) +
	                separator +
	                zeroFill(~~offset % 60, 2)
	            );
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z', matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher),
	            chunk,
	            parts,
	            minutes;
	
	        if (matches === null) {
	            return null;
	        }
	
	        chunk = matches[matches.length - 1] || [];
	        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff =
	                (isMoment(input) || isDate(input)
	                    ? input.valueOf()
	                    : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset());
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(
	                        this,
	                        createDuration(input - offset, 'm'),
	                        1,
	                        false
	                    );
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset() {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            } else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset(input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime() {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted() {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {},
	            other;
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted =
	                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal() {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset() {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc() {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	        // and further modified to allow for strings containing both week and day
	        isoRegex =
	            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration(input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months,
	            };
	        } else if (isNumber(input) || !isNaN(+input)) {
	            duration = {};
	            if (key) {
	                duration[key] = +input;
	            } else {
	                duration.milliseconds = +input;
	            }
	        } else if ((match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	            };
	        } else if ((match = isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                w: parseIso(match[4], sign),
	                d: parseIso(match[5], sign),
	                h: parseIso(match[6], sign),
	                m: parseIso(match[7], sign),
	                s: parseIso(match[8], sign),
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if (
	            typeof duration === 'object' &&
	            ('from' in duration || 'to' in duration)
	        ) {
	            diffRes = momentsDifference(
	                createLocal(duration.from),
	                createLocal(duration.to)
	            );
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	            ret._isValid = input._isValid;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months =
	            other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +base.clone().add(res.months, 'M');
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return { milliseconds: 0, months: 0 };
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(
	                    name,
	                    'moment().' +
	                        name +
	                        '(period, number) is deprecated. Please use moment().' +
	                        name +
	                        '(number, period). ' +
	                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	                );
	                tmp = val;
	                val = period;
	                period = tmp;
	            }
	
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add = createAdder(1, 'add'),
	        subtract = createAdder(-1, 'subtract');
	
	    function isString(input) {
	        return typeof input === 'string' || input instanceof String;
	    }
	
	    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	    function isMomentInput(input) {
	        return (
	            isMoment(input) ||
	            isDate(input) ||
	            isString(input) ||
	            isNumber(input) ||
	            isNumberOrStringArray(input) ||
	            isMomentInputObject(input) ||
	            input === null ||
	            input === undefined
	        );
	    }
	
	    function isMomentInputObject(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'years',
	                'year',
	                'y',
	                'months',
	                'month',
	                'M',
	                'days',
	                'day',
	                'd',
	                'dates',
	                'date',
	                'D',
	                'hours',
	                'hour',
	                'h',
	                'minutes',
	                'minute',
	                'm',
	                'seconds',
	                'second',
	                's',
	                'milliseconds',
	                'millisecond',
	                'ms',
	            ],
	            i,
	            property,
	            propertyLen = properties.length;
	
	        for (i = 0; i < propertyLen; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function isNumberOrStringArray(input) {
	        var arrayTest = isArray(input),
	            dataTypeTest = false;
	        if (arrayTest) {
	            dataTypeTest =
	                input.filter(function (item) {
	                    return !isNumber(item) && isString(input);
	                }).length === 0;
	        }
	        return arrayTest && dataTypeTest;
	    }
	
	    function isCalendarSpec(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'sameDay',
	                'nextDay',
	                'lastDay',
	                'nextWeek',
	                'lastWeek',
	                'sameElse',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6
	            ? 'sameElse'
	            : diff < -1
	              ? 'lastWeek'
	              : diff < 0
	                ? 'lastDay'
	                : diff < 1
	                  ? 'sameDay'
	                  : diff < 2
	                    ? 'nextDay'
	                    : diff < 7
	                      ? 'nextWeek'
	                      : 'sameElse';
	    }
	
	    function calendar$1(time, formats) {
	        // Support for single parameter, formats only overload to the calendar function
	        if (arguments.length === 1) {
	            if (!arguments[0]) {
	                time = undefined;
	                formats = undefined;
	            } else if (isMomentInput(arguments[0])) {
	                time = arguments[0];
	                formats = undefined;
	            } else if (isCalendarSpec(arguments[0])) {
	                formats = arguments[0];
	                time = undefined;
	            }
	        }
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse',
	            output =
	                formats &&
	                (isFunction(formats[format])
	                    ? formats[format].call(this, now)
	                    : formats[format]);
	
	        return this.format(
	            output || this.localeData().calendar(format, this, createLocal(now))
	        );
	    }
	
	    function clone() {
	        return new Moment(this);
	    }
	
	    function isAfter(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween(from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (
	            (inclusivity[0] === '('
	                ? this.isAfter(localFrom, units)
	                : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')'
	                ? this.isBefore(localTo, units)
	                : !this.isAfter(localTo, units))
	        );
	    }
	
	    function isSame(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return (
	                this.clone().startOf(units).valueOf() <= inputMs &&
	                inputMs <= this.clone().endOf(units).valueOf()
	            );
	        }
	    }
	
	    function isSameOrAfter(input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore(input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff(input, units, asFloat) {
	        var that, zoneDelta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year':
	                output = monthDiff(this, that) / 12;
	                break;
	            case 'month':
	                output = monthDiff(this, that);
	                break;
	            case 'quarter':
	                output = monthDiff(this, that) / 3;
	                break;
	            case 'second':
	                output = (this - that) / 1e3;
	                break; // 1000
	            case 'minute':
	                output = (this - that) / 6e4;
	                break; // 1000 * 60
	            case 'hour':
	                output = (this - that) / 36e5;
	                break; // 1000 * 60 * 60
	            case 'day':
	                output = (this - that - zoneDelta) / 864e5;
	                break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week':
	                output = (this - that - zoneDelta) / 6048e5;
	                break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default:
	                output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff(a, b) {
	        if (a.date() < b.date()) {
	            // end-of-month calculations work correct when the start month has more
	            // days than the end month.
	            return -monthDiff(b, a);
	        }
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true,
	            m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(
	                m,
	                utc
	                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	            );
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                    .toISOString()
	                    .replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(
	            m,
	            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect() {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment',
	            zone = '',
	            prefix,
	            year,
	            datetime,
	            suffix;
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        prefix = '[' + func + '("]';
	        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	        datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format(inputString) {
	        if (!inputString) {
	            inputString = this.isUtc()
	                ? hooks.defaultFormatUtc
	                : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ to: this, from: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow(withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ from: this, to: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow(withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale(key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData() {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000,
	        MS_PER_MINUTE = 60 * MS_PER_SECOND,
	        MS_PER_HOUR = 60 * MS_PER_MINUTE,
	        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return ((dividend % divisor) + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3),
	                    1
	                );
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday()
	                );
	                break;
	            case 'isoWeek':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1)
	                );
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                    MS_PER_HOUR
	                );
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month() - (this.month() % 3) + 3,
	                        1
	                    ) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - this.weekday() + 7
	                    ) - 1;
	                break;
	            case 'isoWeek':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - (this.isoWeekday() - 1) + 7
	                    ) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time +=
	                    MS_PER_HOUR -
	                    mod$1(
	                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                        MS_PER_HOUR
	                    ) -
	                    1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf() {
	        return this._d.valueOf() - (this._offset || 0) * 60000;
	    }
	
	    function unix() {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate() {
	        return new Date(this.valueOf());
	    }
	
	    function toArray() {
	        var m = this;
	        return [
	            m.year(),
	            m.month(),
	            m.date(),
	            m.hour(),
	            m.minute(),
	            m.second(),
	            m.millisecond(),
	        ];
	    }
	
	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds(),
	        };
	    }
	
	    function toJSON() {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2() {
	        return isValid(this);
	    }
	
	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict,
	        };
	    }
	
	    addFormatToken('N', 0, 0, 'eraAbbr');
	    addFormatToken('NN', 0, 0, 'eraAbbr');
	    addFormatToken('NNN', 0, 0, 'eraAbbr');
	    addFormatToken('NNNN', 0, 0, 'eraName');
	    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
	
	    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	    addFormatToken('y', ['yy', 2], 0, 'eraYear');
	    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
	
	    addRegexToken('N', matchEraAbbr);
	    addRegexToken('NN', matchEraAbbr);
	    addRegexToken('NNN', matchEraAbbr);
	    addRegexToken('NNNN', matchEraName);
	    addRegexToken('NNNNN', matchEraNarrow);
	
	    addParseToken(
	        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
	        function (input, array, config, token) {
	            var era = config._locale.erasParse(input, token, config._strict);
	            if (era) {
	                getParsingFlags(config).era = era;
	            } else {
	                getParsingFlags(config).invalidEra = input;
	            }
	        }
	    );
	
	    addRegexToken('y', matchUnsigned);
	    addRegexToken('yy', matchUnsigned);
	    addRegexToken('yyy', matchUnsigned);
	    addRegexToken('yyyy', matchUnsigned);
	    addRegexToken('yo', matchEraYearOrdinal);
	
	    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	    addParseToken(['yo'], function (input, array, config, token) {
	        var match;
	        if (config._locale._eraYearOrdinalRegex) {
	            match = input.match(config._locale._eraYearOrdinalRegex);
	        }
	
	        if (config._locale.eraYearOrdinalParse) {
	            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	        } else {
	            array[YEAR] = parseInt(input, 10);
	        }
	    });
	
	    function localeEras(m, format) {
	        var i,
	            l,
	            date,
	            eras = this._eras || getLocale('en')._eras;
	        for (i = 0, l = eras.length; i < l; ++i) {
	            switch (typeof eras[i].since) {
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].since).startOf('day');
	                    eras[i].since = date.valueOf();
	                    break;
	            }
	
	            switch (typeof eras[i].until) {
	                case 'undefined':
	                    eras[i].until = +Infinity;
	                    break;
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].until).startOf('day').valueOf();
	                    eras[i].until = date.valueOf();
	                    break;
	            }
	        }
	        return eras;
	    }
	
	    function localeErasParse(eraName, format, strict) {
	        var i,
	            l,
	            eras = this.eras(),
	            name,
	            abbr,
	            narrow;
	        eraName = eraName.toUpperCase();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            name = eras[i].name.toUpperCase();
	            abbr = eras[i].abbr.toUpperCase();
	            narrow = eras[i].narrow.toUpperCase();
	
	            if (strict) {
	                switch (format) {
	                    case 'N':
	                    case 'NN':
	                    case 'NNN':
	                        if (abbr === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNN':
	                        if (name === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNNN':
	                        if (narrow === eraName) {
	                            return eras[i];
	                        }
	                        break;
	                }
	            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	                return eras[i];
	            }
	        }
	    }
	
	    function localeErasConvertYear(era, year) {
	        var dir = era.since <= era.until ? +1 : -1;
	        if (year === undefined) {
	            return hooks(era.since).year();
	        } else {
	            return hooks(era.since).year() + (year - era.offset) * dir;
	        }
	    }
	
	    function getEraName() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].name;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].name;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraNarrow() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].narrow;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].narrow;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraAbbr() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].abbr;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].abbr;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraYear() {
	        var i,
	            l,
	            dir,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            dir = eras[i].since <= eras[i].until ? +1 : -1;
	
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (
	                (eras[i].since <= val && val <= eras[i].until) ||
	                (eras[i].until <= val && val <= eras[i].since)
	            ) {
	                return (
	                    (this.year() - hooks(eras[i].since).year()) * dir +
	                    eras[i].offset
	                );
	            }
	        }
	
	        return this.year();
	    }
	
	    function erasNameRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNameRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNameRegex : this._erasRegex;
	    }
	
	    function erasAbbrRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasAbbrRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasAbbrRegex : this._erasRegex;
	    }
	
	    function erasNarrowRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNarrowRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNarrowRegex : this._erasRegex;
	    }
	
	    function matchEraAbbr(isStrict, locale) {
	        return locale.erasAbbrRegex(isStrict);
	    }
	
	    function matchEraName(isStrict, locale) {
	        return locale.erasNameRegex(isStrict);
	    }
	
	    function matchEraNarrow(isStrict, locale) {
	        return locale.erasNarrowRegex(isStrict);
	    }
	
	    function matchEraYearOrdinal(isStrict, locale) {
	        return locale._eraYearOrdinalRegex || matchUnsigned;
	    }
	
	    function computeErasParse() {
	        var abbrPieces = [],
	            namePieces = [],
	            narrowPieces = [],
	            mixedPieces = [],
	            i,
	            l,
	            erasName,
	            erasAbbr,
	            erasNarrow,
	            eras = this.eras();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            erasName = regexEscape(eras[i].name);
	            erasAbbr = regexEscape(eras[i].abbr);
	            erasNarrow = regexEscape(eras[i].narrow);
	
	            namePieces.push(erasName);
	            abbrPieces.push(erasAbbr);
	            narrowPieces.push(erasNarrow);
	            mixedPieces.push(erasName);
	            mixedPieces.push(erasAbbr);
	            mixedPieces.push(erasNarrow);
	        }
	
	        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	        this._erasNarrowRegex = new RegExp(
	            '^(' + narrowPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    // PARSING
	
	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);
	
	    addWeekParseToken(
	        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
	        function (input, week, config, token) {
	            week[token.substr(0, 2)] = toInt(input);
	        }
	    );
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.week(),
	            this.weekday() + this.localeData()._week.dow,
	            this.localeData()._week.dow,
	            this.localeData()._week.doy
	        );
	    }
	
	    function getSetISOWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.isoWeek(),
	            this.isoWeekday(),
	            1,
	            4
	        );
	    }
	
	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getISOWeeksInISOWeekYear() {
	        return weeksInYear(this.isoWeekYear(), 1, 4);
	    }
	
	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getWeeksInWeekYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter(input) {
	        return input == null
	            ? Math.ceil((this.month() + 1) / 3)
	            : this.month((input - 1) * 3 + (this.month() % 3));
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // PARSING
	
	    addRegexToken('D', match1to2, match1to2NoLeadingZero);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict
	            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	            : locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // PARSING
	
	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear(input) {
	        var dayOfYear =
	            Math.round(
	                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	            ) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // PARSING
	
	    addRegexToken('m', match1to2, match1to2HasZero);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // PARSING
	
	    addRegexToken('s', match1to2, match1to2HasZero);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	    // PARSING
	
	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);
	
	    var token, getSetMillisecond;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	
	    getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add = add;
	    proto.calendar = calendar$1;
	    proto.clone = clone;
	    proto.diff = diff;
	    proto.endOf = endOf;
	    proto.format = format;
	    proto.from = from;
	    proto.fromNow = fromNow;
	    proto.to = to;
	    proto.toNow = toNow;
	    proto.get = stringGet;
	    proto.invalidAt = invalidAt;
	    proto.isAfter = isAfter;
	    proto.isBefore = isBefore;
	    proto.isBetween = isBetween;
	    proto.isSame = isSame;
	    proto.isSameOrAfter = isSameOrAfter;
	    proto.isSameOrBefore = isSameOrBefore;
	    proto.isValid = isValid$2;
	    proto.lang = lang;
	    proto.locale = locale;
	    proto.localeData = localeData;
	    proto.max = prototypeMax;
	    proto.min = prototypeMin;
	    proto.parsingFlags = parsingFlags;
	    proto.set = stringSet;
	    proto.startOf = startOf;
	    proto.subtract = subtract;
	    proto.toArray = toArray;
	    proto.toObject = toObject;
	    proto.toDate = toDate;
	    proto.toISOString = toISOString;
	    proto.inspect = inspect;
	    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	            return 'Moment<' + this.format() + '>';
	        };
	    }
	    proto.toJSON = toJSON;
	    proto.toString = toString;
	    proto.unix = unix;
	    proto.valueOf = valueOf;
	    proto.creationData = creationData;
	    proto.eraName = getEraName;
	    proto.eraNarrow = getEraNarrow;
	    proto.eraAbbr = getEraAbbr;
	    proto.eraYear = getEraYear;
	    proto.year = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week = proto.weeks = getSetWeek;
	    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	    proto.weeksInYear = getWeeksInYear;
	    proto.weeksInWeekYear = getWeeksInWeekYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	    proto.date = getSetDayOfMonth;
	    proto.day = proto.days = getSetDayOfWeek;
	    proto.weekday = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset = getSetOffset;
	    proto.utc = setOffsetToUTC;
	    proto.local = setOffsetToLocal;
	    proto.parseZone = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST = isDaylightSavingTime;
	    proto.isLocal = isLocal;
	    proto.isUtcOffset = isUtcOffset;
	    proto.isUtc = isUtc;
	    proto.isUTC = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates = deprecate(
	        'dates accessor is deprecated. Use date instead.',
	        getSetDayOfMonth
	    );
	    proto.months = deprecate(
	        'months accessor is deprecated. Use month instead',
	        getSetMonth
	    );
	    proto.years = deprecate(
	        'years accessor is deprecated. Use year instead',
	        getSetYear
	    );
	    proto.zone = deprecate(
	        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	        getSetZone
	    );
	    proto.isDSTShifted = deprecate(
	        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	        isDaylightSavingTimeShifted
	    );
	
	    function createUnix(input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone() {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat(string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar = calendar;
	    proto$1.longDateFormat = longDateFormat;
	    proto$1.invalidDate = invalidDate;
	    proto$1.ordinal = ordinal;
	    proto$1.preparse = preParsePostFormat;
	    proto$1.postformat = preParsePostFormat;
	    proto$1.relativeTime = relativeTime;
	    proto$1.pastFuture = pastFuture;
	    proto$1.set = set;
	    proto$1.eras = localeEras;
	    proto$1.erasParse = localeErasParse;
	    proto$1.erasConvertYear = localeErasConvertYear;
	    proto$1.erasAbbrRegex = erasAbbrRegex;
	    proto$1.erasNameRegex = erasNameRegex;
	    proto$1.erasNarrowRegex = erasNarrowRegex;
	
	    proto$1.months = localeMonths;
	    proto$1.monthsShort = localeMonthsShort;
	    proto$1.monthsParse = localeMonthsParse;
	    proto$1.monthsRegex = monthsRegex;
	    proto$1.monthsShortRegex = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays = localeWeekdays;
	    proto$1.weekdaysMin = localeWeekdaysMin;
	    proto$1.weekdaysShort = localeWeekdaysShort;
	    proto$1.weekdaysParse = localeWeekdaysParse;
	
	    proto$1.weekdaysRegex = weekdaysRegex;
	    proto$1.weekdaysShortRegex = weekdaysShortRegex;
	    proto$1.weekdaysMinRegex = weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1(format, index, field, setter) {
	        var locale = getLocale(),
	            utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl(format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i,
	            out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl(localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0,
	            i,
	            out = [];
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths(format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort(format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        eras: [
	            {
	                since: '0001-01-01',
	                until: +Infinity,
	                offset: 1,
	                name: 'Anno Domini',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: 'Before Christ',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    toInt((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate(
	        'moment.lang is deprecated. Use moment.locale instead.',
	        getSetGlobalLocale
	    );
	    hooks.langData = deprecate(
	        'moment.langData is deprecated. Use moment.localeData instead.',
	        getLocale
	    );
	
	    var mathAbs = Math.abs;
	
	    function abs() {
	        var data = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);
	
	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1(duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1(input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1(input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble() {
	        var milliseconds = this._milliseconds,
	            days = this._days,
	            months = this._months,
	            data = this._data,
	            seconds,
	            minutes,
	            hours,
	            years,
	            monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (
	            !(
	                (milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0)
	            )
	        ) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;
	
	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;
	
	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days = days;
	        data.months = months;
	        data.years = years;
	
	        return this;
	    }
	
	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return (days * 4800) / 146097;
	    }
	
	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return (months * 146097) / 4800;
	    }
	
	    function as(units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days,
	            months,
	            milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':
	                    return months;
	                case 'quarter':
	                    return months / 3;
	                case 'year':
	                    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms'),
	        asSeconds = makeAs('s'),
	        asMinutes = makeAs('m'),
	        asHours = makeAs('h'),
	        asDays = makeAs('d'),
	        asWeeks = makeAs('w'),
	        asMonths = makeAs('M'),
	        asQuarters = makeAs('Q'),
	        asYears = makeAs('y'),
	        valueOf$1 = asMilliseconds;
	
	    function clone$1() {
	        return createDuration(this);
	    }
	
	    function get$2(units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds'),
	        seconds = makeGetter('seconds'),
	        minutes = makeGetter('minutes'),
	        hours = makeGetter('hours'),
	        days = makeGetter('days'),
	        months = makeGetter('months'),
	        years = makeGetter('years');
	
	    function weeks() {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round,
	        thresholds = {
	            ss: 44, // a few seconds to seconds
	            s: 45, // seconds to minute
	            m: 45, // minutes to hour
	            h: 22, // hours to day
	            d: 26, // days to month/week
	            w: null, // weeks to month
	            M: 11, // months to year
	        };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	        var duration = createDuration(posNegDuration).abs(),
	            seconds = round(duration.as('s')),
	            minutes = round(duration.as('m')),
	            hours = round(duration.as('h')),
	            days = round(duration.as('d')),
	            months = round(duration.as('M')),
	            weeks = round(duration.as('w')),
	            years = round(duration.as('y')),
	            a =
	                (seconds <= thresholds.ss && ['s', seconds]) ||
	                (seconds < thresholds.s && ['ss', seconds]) ||
	                (minutes <= 1 && ['m']) ||
	                (minutes < thresholds.m && ['mm', minutes]) ||
	                (hours <= 1 && ['h']) ||
	                (hours < thresholds.h && ['hh', hours]) ||
	                (days <= 1 && ['d']) ||
	                (days < thresholds.d && ['dd', days]);
	
	        if (thresholds.w != null) {
	            a =
	                a ||
	                (weeks <= 1 && ['w']) ||
	                (weeks < thresholds.w && ['ww', weeks]);
	        }
	        a = a ||
	            (months <= 1 && ['M']) ||
	            (months < thresholds.M && ['MM', months]) ||
	            (years <= 1 && ['y']) || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding(roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof roundingFunction === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize(argWithSuffix, argThresholds) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var withSuffix = false,
	            th = thresholds,
	            locale,
	            output;
	
	        if (typeof argWithSuffix === 'object') {
	            argThresholds = argWithSuffix;
	            argWithSuffix = false;
	        }
	        if (typeof argWithSuffix === 'boolean') {
	            withSuffix = argWithSuffix;
	        }
	        if (typeof argThresholds === 'object') {
	            th = Object.assign({}, thresholds, argThresholds);
	            if (argThresholds.s != null && argThresholds.ss == null) {
	                th.ss = argThresholds.s - 1;
	            }
	        }
	
	        locale = this.localeData();
	        output = relativeTime$1(this, !withSuffix, th, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return (x > 0) - (x < 0) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000,
	            days = abs$1(this._days),
	            months = abs$1(this._months),
	            minutes,
	            hours,
	            years,
	            s,
	            total = this.asSeconds(),
	            totalSign,
	            ymSign,
	            daysSign,
	            hmsSign;
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	
	        totalSign = total < 0 ? '-' : '';
	        ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return (
	            totalSign +
	            'P' +
	            (years ? ymSign + years + 'Y' : '') +
	            (months ? ymSign + months + 'M' : '') +
	            (days ? daysSign + days + 'D' : '') +
	            (hours || minutes || seconds ? 'T' : '') +
	            (hours ? hmsSign + hours + 'H' : '') +
	            (minutes ? hmsSign + minutes + 'M' : '') +
	            (seconds ? hmsSign + s + 'S' : '')
	        );
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid = isValid$1;
	    proto$2.abs = abs;
	    proto$2.add = add$1;
	    proto$2.subtract = subtract$1;
	    proto$2.as = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds = asSeconds;
	    proto$2.asMinutes = asMinutes;
	    proto$2.asHours = asHours;
	    proto$2.asDays = asDays;
	    proto$2.asWeeks = asWeeks;
	    proto$2.asMonths = asMonths;
	    proto$2.asQuarters = asQuarters;
	    proto$2.asYears = asYears;
	    proto$2.valueOf = valueOf$1;
	    proto$2._bubble = bubble;
	    proto$2.clone = clone$1;
	    proto$2.get = get$2;
	    proto$2.milliseconds = milliseconds;
	    proto$2.seconds = seconds;
	    proto$2.minutes = minutes;
	    proto$2.hours = hours;
	    proto$2.days = days;
	    proto$2.weeks = weeks;
	    proto$2.months = months;
	    proto$2.years = years;
	    proto$2.humanize = humanize;
	    proto$2.toISOString = toISOString$1;
	    proto$2.toString = toISOString$1;
	    proto$2.toJSON = toISOString$1;
	    proto$2.locale = locale;
	    proto$2.localeData = localeData;
	
	    proto$2.toIsoString = deprecate(
	        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	        toISOString$1
	    );
	    proto$2.lang = lang;
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    //! moment.js
	
	    hooks.version = '2.30.1';
	
	    setHookCallback(createLocal);
	
	    hooks.fn = proto;
	    hooks.min = min;
	    hooks.max = max;
	    hooks.now = now;
	    hooks.utc = createUTC;
	    hooks.unix = createUnix;
	    hooks.months = listMonths;
	    hooks.isDate = isDate;
	    hooks.locale = getSetGlobalLocale;
	    hooks.invalid = createInvalid;
	    hooks.duration = createDuration;
	    hooks.isMoment = isMoment;
	    hooks.weekdays = listWeekdays;
	    hooks.parseZone = createInZone;
	    hooks.localeData = getLocale;
	    hooks.isDuration = isDuration;
	    hooks.monthsShort = listMonthsShort;
	    hooks.weekdaysMin = listWeekdaysMin;
	    hooks.defineLocale = defineLocale;
	    hooks.updateLocale = updateLocale;
	    hooks.locales = listLocales;
	    hooks.weekdaysShort = listWeekdaysShort;
	    hooks.normalizeUnits = normalizeUnits;
	    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat = getCalendarFormat;
	    hooks.prototype = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD', // <input type="date" />
	        TIME: 'HH:mm', // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW', // <input type="week" />
	        MONTH: 'YYYY-MM', // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(197)(module)))

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _require = __webpack_require__(58),
	    Query = _require.Query;
	
	var utils = __webpack_require__(4);
	var bitrix = __webpack_require__(70);
	
	module.exports = {
	    redirect: function redirect(url) {
	        var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	        return function redirect(args, state, output, _ref) {
	            var context = _ref.context,
	                locator = _ref.locator;
	
	            if (context.isServer) {
	                return;
	            }
	
	            var location = utils.patchQueryWithUtm(url, state);
	
	            if (delay > 0) {
	                window.setTimeout(function () {
	                    context.redirect(location);
	                }, delay);
	            } else {
	                context.redirect(location);
	            }
	
	            if (state.get(['bitrix', 'isBitrix'])) {
	                bitrix.fitWindow(args, state, output, { locator: locator });
	            }
	        };
	    },
	    redirectFromArgs: function redirectFromArgs(args, state, output, _ref2) {
	        var context = _ref2.context;
	
	        if (context.isServer) {
	            return;
	        }
	
	        var location = utils.patchQueryWithUtm(args.url, state);
	        var delay = args.delay || 0;
	
	        if (delay > 0) {
	            window.setTimeout(function () {
	                context.redirect(location);
	            }, delay);
	        } else {
	            context.redirect(location);
	        }
	    },
	    redirectToRoot: function redirectToRoot(args, state, output, _ref3) {
	        var context = _ref3.context;
	
	        var root = state.get(['bitrix', 'isBitrix']) === true ? '/bitrix' : '/';
	        context.redirect(root);
	    },
	    locationRedirect: function locationRedirect(url) {
	        var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	        return function redirect(args, state, output, _ref4) {
	            var context = _ref4.context;
	
	            if (context.isServer) {
	                return;
	            }
	
	            var location = utils.patchQueryWithUtm(url, state);
	
	            if (delay > 0) {
	                window.setTimeout(function () {
	                    window.location = location;
	                }, delay);
	            } else {
	                window.location = location;
	            }
	        };
	    },
	    locationRedirectToOrder: function locationRedirectToOrder(url, subPath) {
	        var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	        return function redirect(args, state, output, _ref5) {
	            var context = _ref5.context;
	
	            if (context.isServer) {
	                return;
	            }
	
	            var location = utils.patchQueryWithUtm(url + args[subPath], state);
	
	            if (delay > 0) {
	                window.setTimeout(function () {
	                    window.location = location;
	                }, delay);
	            } else {
	                window.location = location;
	            }
	        };
	    },
	    patchURLQuery: function patchURLQuery(argsKey, queryKey) {
	        return function patchURLQuery(args, state, output, _ref6) {
	            var context = _ref6.context;
	
	            var key = args[argsKey];
	            var location = context.location.clone();
	
	            if (!location.query) {
	                location.query = new Query();
	            }
	
	            if (!location.query.values) {
	                location.query.values = {};
	            }
	
	            location.query.values[queryKey] = key;
	            var locationString = location.toString();
	            context.redirect(utils.patchQueryWithUtm(locationString, state), { silent: true });
	        };
	    },
	    queryRedirectFromState: function queryRedirectFromState(statePath) {
	        var absPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	        return function patchURLQuery(args, state, output, _ref7) {
	            var context = _ref7.context;
	
	            var query = state.get(statePath);
	
	            context.redirect(utils.patchQueryWithUtm(absPath + '?' + query, state), { silent: true });
	        };
	    },
	    queryOrderRedirect: function queryOrderRedirect(statePath) {
	        return function patchURLQuery(_ref8, state, output, _ref9) {
	            var orderId = _ref8.orderId;
	            var context = _ref9.context;
	
	            if (context.isServer) {
	                return;
	            }
	            var query = state.get(statePath);
	            var role = state.get(['user', 'role']);
	            var pageName = 'account';
	            if (role === 'manager') {
	                pageName = 'manager';
	            }
	            context.redirect(utils.patchQueryWithUtm('/' + pageName + '/orders/' + orderId + '?' + query, state), { silent: true });
	        };
	    }
	};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var header = __webpack_require__(309);
	var footer = __webpack_require__(56);
	var page = __webpack_require__(43);
	var utils = __webpack_require__(5);
	
	module.exports = {
	    setMainLayoutBlocks: [page.setCurrentPage, header.setHeaderMenu, utils.setPopupVisibility('settings', ['header', 'ui', 'settings', 'isOpen']), footer.setCopyrightYear]
	};

/***/ }),
/* 37 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(106);
	var createDesc = __webpack_require__(81);
	var toIObject = __webpack_require__(40);
	var toPrimitive = __webpack_require__(54);
	var has = __webpack_require__(37);
	var IE8_DOM_DEFINE = __webpack_require__(250);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(16) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(37);
	var toObject = __webpack_require__(18);
	var IE_PROTO = __webpack_require__(182)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(105);
	var defined = __webpack_require__(52);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _module$exports;
	
	var computed = __webpack_require__(61);
	var _ = __webpack_require__(3);
	
	var _require = __webpack_require__(72),
	    thenWithErrorHandling = _require.thenWithErrorHandling;
	
	var _require2 = __webpack_require__(192),
	    saveAs = _require2.saveAs;
	
	var progressBarHelper = __webpack_require__(217);
	var ordersComputedActions = __webpack_require__(61);
	var currentOrderActions = __webpack_require__(23);
	var debouncedSetName = _.debounce(setName, 1000);
	var debouncedUpdateOrderAmount = _.debounce(updateOrderAmount, 1000);
	
	function setName(args, state, output, _ref) {
	    var locator = _ref.locator,
	        context = _ref.context;
	
	    var API = locator.resolve('api');
	    var orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
	    var name = state.get(['account', 'orders', 'currentOrder', 'name']);
	
	    var request = API.setName(context, locator, { name: name, orderId: orderId });
	
	    request.then(function (response) {
	        var code = _.get(response, 'status.code');
	
	        if (code !== 200) {
	            output.error({ error: code });
	            return;
	        }
	
	        output.success({ name: name });
	    }).catch(function (error) {
	        return output.error({ error: error });
	    });
	}
	
	function updateOrderAmount(args, state, output, _ref2) {
	    var locator = _ref2.locator,
	        context = _ref2.context;
	
	    var API = locator.resolve('api');
	    var orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
	    var amount = state.get(currentOrderActions.PATHS.orderAmount);
	    var amountNumber = Number(amount);
	    var isDisabledAmountField = state.get(ordersComputedActions.PATHS.isDisabledAmountField);
	
	    if (isNaN(amountNumber) || isDisabledAmountField || !amountNumber) {
	        return;
	    }
	
	    var request = API.updateOrderAmount(context, locator, { amount: amountNumber, orderId: orderId });
	
	    request.then(function (response) {
	        var code = _.get(response, 'status.code');
	
	        if (code !== 200) {
	            output.error({ error: code });
	            return;
	        }
	
	        output.success({ amount: amountNumber });
	    }).catch(function (error) {
	        return output.error({ error: error });
	    });
	}
	
	module.exports = (_module$exports = {
	    setComputedFields: function setComputedFields(args, state) {
	        computed.computeShowDownloadAllButton(state);
	        computed.computeOrderCreateDate(state);
	        computed.computeOrderStateName(state);
	        computed.computePaymentTypeName(state);
	        computed.computeOrderIsEditable(state);
	        computed.computeOrderUser(state);
	        computed.computeOrderManager(state);
	        computed.computeDocumentsWillBeUploadedTooltipState(state);
	        computed.computeNecessaryDocumentsAddDeleteButtonsState(state);
	        computed.computeBillDraftDownloadButtonsState(state);
	        computed.computeContinueButtonState(state);
	        computed.computePayOnlineButtonState(state);
	        computed.computeContinueButtonLabel(state);
	        computed.computeOrderParametersIsAvailable(state);
	        computed.computeIsShowIndividualOrderParameters(state);
	        computed.computeIsShowResultUploadButton(state);
	        computed.computeIsCanDeleteResult(state);
	        computed.computeIsDisabledAmountField(state);
	        computed.computeMakeOrderButtonState(state);
	        computed.computeArchiveButtonState(state);
	        computed.computeSaveAllButtonState(state);
	        computed.computeRepeatButtonLabel(state);
	        computed.computeBitrixExportButtonState(state);
	        computed.computeFreeBitrixExportButtonState(state);
	        computed.computeLicenseAgreementCheckboxState(state);
	        computed.computeSpecialInfo(state);
	        computed.computeActionPanelState(state);
	        computed.computeSumCanChangeTooltipState(state);
	        computed.computeManagerState(state);
	        computed.computeUserState(state);
	        computed.computeShowPaymentType(state);
	        computed.computeManagerSelectState(state);
	        computed.computeUserSelectState(state);
	        computed.computeDataChangeTooltipState(state);
	        computed.computeCanMoveOrderToNextState(state);
	        computed.setManagerSelect(state);
	        computed.setUserSelect(state);
	        computed.setOrderPrice(state);
	        computed.setPaymentType(state);
	        computed.setUsersListFilter(state);
	        computed.filterOptionsUsersList(state);
	        computed.createUserButtonIsEnabled(state);
	        computed.computeIsNeedToGetExportResults(state);
	        computed.computeOrderStatisticState(state);
	        computed.computeOrderStatisticIsLoadingState(state);
	        computed.computePaymentTypeChangePanelState(state);
	        computed.computeIsOnlinePaymentDisabled(state);
	        computed.computeIsFilerValuesControlEnabled(state);
	        computed.computeExportResultState(state);
	        computed.computeIsDisabled(state);
	        computed.computeDatepickerIsDisabled(state);
	        computed.computeDatepicker2IsDisabled(state);
	    },
	
	
	    debouncedSetName: debouncedSetName,
	
	    debouncedUpdateOrderAmount: debouncedUpdateOrderAmount,
	
	    getOrder: function getOrder(_ref3, state, output, _ref4) {
	        var orderId = _ref3.orderId;
	        var locator = _ref4.locator,
	            context = _ref4.context;
	
	        var API = locator.resolve('api');
	
	        var request = API.getUserOrder(context, locator, { orderId: orderId });
	
	        request.then(function (data) {
	            var statusCode = _.get(data, 'status.code');
	
	            if (statusCode === 403 || statusCode === 404) {
	                output.notFound();
	                return;
	            }
	
	            if (statusCode !== 200) {
	                output.error({ error: statusCode });
	                return;
	            }
	
	            output.success({ currentOrder: data.content, availableParameters: data.content.availableParameters });
	        }).catch(function (error) {
	            return output.error({ error: error });
	        });
	    },
	    setCurrentOrder: function setCurrentOrder(_ref5, state) {
	        var currentOrder = _ref5.currentOrder;
	
	        state.set(['account', 'orders', 'currentOrder'], currentOrder);
	        state.set(['order', 'price', 'data'], currentOrder.price);
	        state.set(['order', 'typeId'], currentOrder.typeId);
	    },
	    setIsLicenseAgreementAccepted: function setIsLicenseAgreementAccepted(_ref6, state) {
	        var isLicenseAgreementAccepted = _ref6.isLicenseAgreementAccepted;
	
	        state.set(['account', 'orders', 'currentOrder', 'isLicenseAgreementAccepted'], isLicenseAgreementAccepted);
	    },
	    setIsNeedToConfirmDataVersionChange: function setIsNeedToConfirmDataVersionChange(args, state) {
	        state.set(['account', 'orders', 'currentOrder', 'isNeedToConfirmDataChanged'], true);
	    },
	    ifNeedToScrollTop: function ifNeedToScrollTop(args, state, output) {
	        var licenseMustBeAccepted = state.get(['account', 'orders', 'currentOrder', 'tooltips', 'showLicenseMustBeAccepted']);
	        var showBillDocumentMustBeAttached = state.get(currentOrderActions.PATHS.showBillDocumentMustBeAttached);
	        var disableContinue = state.get(['account', 'orders', 'disableContinue']);
	
	        if (licenseMustBeAccepted || showBillDocumentMustBeAttached || disableContinue) {
	            output.no();
	        } else {
	            output.yes();
	        }
	    },
	    ifOrderDataChanged: function ifOrderDataChanged(_ref7, state, output) {
	        var isDataChanged = _ref7.isDataChanged;
	
	        if (isDataChanged) {
	            output.yes();
	        } else {
	            output.no();
	        }
	    },
	    setDataChangedConfirmed: function setDataChangedConfirmed(args, state) {
	        state.set(['account', 'orders', 'currentOrder', 'isNeedToConfirmDataChanged'], false);
	    },
	    setOrderUpdateProperty: function setOrderUpdateProperty(_ref8, state) {
	        var path = _ref8.path,
	            value = _ref8.value;
	
	        state.set(['account', 'orders', 'currentOrder', 'update', path], value);
	    },
	    setPaymentTypeId: function setPaymentTypeId(_ref9, state) {
	        var paymentTypeId = _ref9.paymentTypeId;
	
	        state.set(['account', 'orders', 'currentOrder', 'paymentTypeId'], paymentTypeId);
	    },
	    setOrderAmount: function setOrderAmount(args, state) {
	        var totalPrice = state.get(['account', 'orders', 'computed', 'price', 'data', 'total', 'totalPrice']);
	
	        state.set(currentOrderActions.PATHS.orderAmount, totalPrice);
	    },
	    ifBillMustBeAttached: function ifBillMustBeAttached(args, state, output) {
	        var role = state.get(['user', 'role']);
	        var stateId = state.get(['account', 'orders', 'currentOrder', 'stateId']);
	        var necessaryDocuments = state.get(['account', 'orders', 'currentOrder', 'necessaryDocuments']);
	
	        if (role == 'manager' && (stateId === 2 || stateId === 3001)) {
	            var bill = _.find(necessaryDocuments, { typeId: 1 });
	
	            if (bill && !bill.id) {
	                output.yes();
	            }
	        }
	        output.no();
	    },
	    ifExportResultMustBeAttached: function ifExportResultMustBeAttached(args, state, output) {
	        var role = state.get(['user', 'role']);
	        var stateId = state.get(['account', 'orders', 'currentOrder', 'stateId']);
	        var exportResults = state.get(['account', 'orders', 'currentOrder', 'exportResult']);
	
	        if (role === 'manager' && (stateId === 3001 || stateId === 3002) && !exportResults.length) {
	            return output.yes();
	        }
	
	        return output.no();
	    },
	    ifUserMustBeSelected: function ifUserMustBeSelected(args, state, output) {
	        var typeId = state.get(['account', 'orders', 'currentOrder', 'typeId']);
	        var role = state.get(['user', 'role']);
	        var isUserSelected = state.get(['account', 'orders', 'computed', 'selectedUser', 'isUserSelected']);
	
	        if ((typeId === 1 || typeId === 4) && role === 'manager' && isUserSelected === false) {
	            output.yes();
	        }
	
	        output.no();
	    },
	    ifPriceMustBeBiggerThenZero: function ifPriceMustBeBiggerThenZero(args, state, output) {
	        var orderTotalPrice = state.get(['account', 'orders', 'currentOrder', 'price', 'total', 'totalPrice']);
	        var orderAmount = state.get(currentOrderActions.PATHS.orderAmount);
	        var typeId = state.get(['account', 'orders', 'currentOrder', 'typeId']);
	        var orderPrice = typeId === 4 ? Number(orderAmount) : orderTotalPrice;
	
	        if (isNaN(orderPrice) || orderPrice <= 0) {
	            output.yes();
	        }
	
	        output.no();
	    },
	    ifLicenseMustBeAccepted: function ifLicenseMustBeAccepted(args, state, output) {
	        var userMustAcceptLicense = state.get(['account', 'orders', 'computed', 'componentsState', 'showLicenseAgreementCheckbox']);
	        var userAcceptLicenseAgreement = state.get(['account', 'orders', 'currentOrder', 'update', 'userAcceptLicenseAgreement']);
	
	        if (userMustAcceptLicense && !userAcceptLicenseAgreement) {
	            output.yes();
	        }
	
	        output.no();
	    },
	    ifAcceptLicenseAgreement: function ifAcceptLicenseAgreement(args, state, output) {
	        var userAcceptLicenseAgreement = state.get(['account', 'orders', 'currentOrder', 'update', 'userAcceptLicenseAgreement']);
	
	        if (userAcceptLicenseAgreement) {
	            output.yes();
	        }
	
	        output.no();
	    },
	    ifCanMoverOrderToNextState: function ifCanMoverOrderToNextState(args, state, output) {
	        if (state.get(['account', 'orders', 'computed', 'сanMoveOrderToNextState'])) {
	            output.yes();
	        } else {
	            output.no();
	        }
	    },
	    ifContinueDisabled: function ifContinueDisabled(args, state, output) {
	        if (state.get(['account', 'orders', 'disableContinue'])) {
	            output.yes();
	        } else {
	            output.no();
	        }
	    },
	    acceptLicenseAgreement: function acceptLicenseAgreement(args, state, output, _ref10) {
	        var locator = _ref10.locator,
	            context = _ref10.context;
	
	        var API = locator.resolve('api');
	        var orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
	        var request = API.acceptLicenseAgreement(context, locator, { orderId: orderId });
	        thenWithErrorHandling(request, function () {
	            return { isLicenseAgreementAccepted: true };
	        }, output);
	    },
	    ifAcceptDataChanged: function ifAcceptDataChanged(args, state, output) {
	        var isNeedToConfirmDataChanged = state.get(['account', 'orders', 'currentOrder', 'isNeedToConfirmDataChanged']);
	
	        if (isNeedToConfirmDataChanged) {
	            output.yes();
	        }
	        output.no();
	    },
	    confirmDataChanged: function confirmDataChanged(args, state, output, _ref11) {
	        var locator = _ref11.locator,
	            context = _ref11.context;
	
	        var API = locator.resolve('api');
	        var orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
	        var request = API.confirmDataChanged(context, locator, { orderId: orderId });
	        thenWithErrorHandling(request, function () {
	            return {};
	        }, output);
	    },
	    moveOrderToNextState: function moveOrderToNextState(args, state, output, _ref12) {
	        var locator = _ref12.locator,
	            context = _ref12.context;
	
	        var API = locator.resolve('api');
	        var orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
	
	        var request = API.moveOrderToNextState(context, locator, { orderId: orderId });
	
	        request.then(function (data) {
	            var status = _.get(data, 'status.code');
	            if (status === 503) {
	                output.temporarilyUnavailable();
	                return;
	            }
	            if (status !== 200 && status !== 503) {
	                output.error({ error: status });
	                return;
	            }
	            output.success({ stateId: _.get(data, 'content.stateId'),
	                exportResult: _.get(data, 'content.exportResult'),
	                isDataChanged: _.get(data, 'content.isNeedToConfirmDataChanged'),
	                availableParameters: _.get(data, 'content.availableParameters'),
	                selectedParameters: _.get(data, 'content.selectedParameters'),
	                necessaryDocuments: _.get(data, 'content.necessaryDocuments'),
	                paymentForm: _.get(data, 'content.paymentForm'),
	                price: _.get(data, 'content.price')
	            });
	        }).catch(function (error) {
	            return output.error({ error: error });
	        });
	    },
	    archiveOrder: function archiveOrder(args, state, output, _ref13) {
	        var locator = _ref13.locator,
	            context = _ref13.context;
	
	        var API = locator.resolve('api');
	        var orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
	
	        var request = API.archiveOrder(context, locator, { orderId: orderId });
	        thenWithErrorHandling(request, function (data) {
	            return { stateId: _.get(data, 'content.stateId'), stateName: _.get(data, 'content.stateName') };
	        }, output);
	    },
	    isDownloadingExportResult: function isDownloadingExportResult(_ref14, state, output) {
	        var fileId = _ref14.fileId;
	
	        var exportResult = state.get(['account', 'orders', 'currentOrder', 'exportResult']);
	        if (exportResult && exportResult.id == fileId) {
	            output.yes();
	        }
	    },
	    downloadFile: function downloadFile(_ref15, state, output, _ref16) {
	        var fileId = _ref15.fileId;
	        var locator = _ref16.locator,
	            context = _ref16.context;
	
	        var API = locator.resolve('api');
	        var exportResults = state.get(['account', 'orders', 'currentOrder', 'exportResult']);
	        var fileName = '';
	        var isExportResult = false;
	
	        var exportResult = _.find(exportResults, { id: fileId.toString() });
	        if (exportResult) {
	            fileName = exportResult.name;
	            isExportResult = true;
	        } else {
	            var documents = state.get(['account', 'orders', 'currentOrder', 'necessaryDocuments']);
	            fileName = _.find(documents, { id: fileId.toString() }).name;
	        }
	
	        var request = API.downloadFile(context, locator, { fileId: fileId, fileName: fileName });
	        request.then(function (response) {
	            if (response.code === 200) {
	                var blob = new Blob([response.content], { type: response.contentType });
	                saveAs(blob, fileName);
	                if (isExportResult) {
	                    output.exportResultDownloaded();
	                }
	            } else {
	                output.error({ error: response.code });
	            }
	        }).catch(function (error) {
	            return output.error({ error: error });
	        });
	    },
	    downloadAll: function downloadAll(args, state, output, _ref17) {
	        var locator = _ref17.locator,
	            context = _ref17.context;
	
	        var API = locator.resolve('api');
	        var exportResults = state.get(['account', 'orders', 'currentOrder', 'exportResult']);
	
	        var i = 0;
	        var onProgressHandler = function onProgressHandler(oEvent) {
	            if (oEvent.lengthComputable) {
	                progressBarHelper.setPercentage('download-all', oEvent.loaded / oEvent.total * 100);
	            } else {}
	        };
	        var onStartDownload = function onStartDownload(fileName) {
	            progressBarHelper.init('download-all', fileName);
	        };
	        downloadAllInternal(exportResults, i, context, locator, API, output, onProgressHandler, onStartDownload);
	    },
	    downloadDraftFile: function downloadDraftFile(_ref18, state, output, _ref19) {
	        var orderId = _ref18.orderId,
	            typeId = _ref18.typeId;
	        var locator = _ref19.locator,
	            context = _ref19.context;
	
	        var API = locator.resolve('api');
	
	        var request = API.downloadDraftFile(context, locator, { orderId: orderId, typeId: typeId });
	        request.then(function (response) {
	            if (response.code === 200) {
	                var blob = new Blob([response.content], { type: response.contentType });
	                var fileName = response.contentDisposition.match(/attachment; filename=(.+)/)[1];
	                saveAs(blob, fileName);
	                output.ok();
	            } else {
	                output.error({ error: response.code });
	            }
	        }).catch(function (error) {
	            return output.error({ error: error });
	        });
	    },
	    getUsers: function getUsers(args, state, output, _ref20) {
	        var locator = _ref20.locator,
	            context = _ref20.context;
	
	        var API = locator.resolve('api');
	        var request = API.getUsers(context, locator);
	
	        thenWithErrorHandling(request, function (data) {
	            return { users: _.get(data, 'content') };
	        }, output);
	    },
	    getManagers: function getManagers(args, state, output, _ref21) {
	        var locator = _ref21.locator,
	            context = _ref21.context;
	
	        var API = locator.resolve('api');
	        var request = API.getManagers(context, locator);
	
	        thenWithErrorHandling(request, function (data) {
	            return { managers: _.get(data, 'content') };
	        }, output);
	    }
	}, _module$exports['setPaymentTypeId'] = function setPaymentTypeId(args, state) {
	    state.set(['account', 'orders', 'currentOrder', 'paymentTypeId'], state.get(['account', 'orders', 'currentOrder', 'localChanges', 'selectedPaymentTypeId']));
	}, _module$exports.selectPaymentType = function selectPaymentType(_ref22, state) {
	    var key = _ref22.key;
	
	    var path = ['account', 'orders', 'currentOrder', 'localChanges', 'selectedPaymentTypeId'];
	
	    var paymentMap = {
	        invoice: 1,
	        online: 2
	    };
	
	    state.set(path, paymentMap[key]);
	}, _module$exports.initOrderType = function initOrderType(_ref23, state) {
	    var key = _ref23.key;
	
	    var orderType = {
	        1: true,
	        2: false,
	        3: false,
	        4: false
	    };
	    state.set(['account', 'orders', 'create', 'orderType'], orderType);
	}, _module$exports.selectOrderType = function selectOrderType(_ref24, state) {
	    var key = _ref24.key;
	
	    var orderType = state.get(['account', 'orders', 'create', 'orderType']);
	    for (var property in orderType) {
	        state.set(['account', 'orders', 'create', 'orderType', property], false);
	    }
	    state.set(['account', 'orders', 'create', 'orderType', key], true);
	}, _module$exports.fillOrderTypeInSelectedParameters = function fillOrderTypeInSelectedParameters(args) {
	    args.selectedParameters = { orderType: Number(args.selectedValue) };
	}, _module$exports.toggleBillDocumentIsCheckable = function toggleBillDocumentIsCheckable(args, state) {
	    var docs = state.get(['account', 'orders', 'currentOrder', 'necessaryDocuments']);
	    var billIndex = _.findIndex(docs, { 'typeId': 1 });
	    if (billIndex > -1) {
	        var value = state.get(['account', 'orders', 'currentOrder', 'necessaryDocuments', billIndex, 'isCheckable']);
	        state.set(['account', 'orders', 'currentOrder', 'necessaryDocuments', billIndex, 'isCheckable'], !value);
	        args.path = billIndex;
	        args.value = value;
	    }
	}, _module$exports.isPaymentTypeChanged = function isPaymentTypeChanged(args, state, output) {
	    var paymentId = state.get(['account', 'orders', 'currentOrder', 'localChanges', 'selectedPaymentTypeId']);
	    if (paymentId) {
	        output.true();
	        return;
	    }
	    output.false();
	}, _module$exports.setPaymentType = function setPaymentType(args, state, output, _ref25) {
	    var locator = _ref25.locator,
	        context = _ref25.context;
	
	    var API = locator.resolve('api');
	    var orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
	    var paymentId = state.get(['account', 'orders', 'currentOrder', 'localChanges', 'selectedPaymentTypeId']);
	
	    var request = API.setPaymentType(context, locator, { paymentId: paymentId, orderId: orderId });
	
	    request.then(function (response) {
	        var code = _.get(response, 'status.code');
	        if (code !== 200) {
	            output.error({ error: code });
	            return;
	        }
	
	        var paymentTypeId = _.get(response, 'content.paymentTypeId');
	        var necessaryDocuments = _.get(response, 'content.necessaryDocuments');
	        output.success({ paymentTypeId: paymentTypeId, necessaryDocuments: necessaryDocuments });
	    }).catch(function (error) {
	        return output.error({ error: error });
	    });
	}, _module$exports.selectUser = function selectUser(_ref26, state) {
	    var selectedValue = _ref26.selectedValue;
	
	    var id = Number(selectedValue);
	    var users = state.get(['account', 'orders', 'users']);
	
	    var user = _.find(users, { id: id });
	
	    state.set(['account', 'orders', 'currentOrder', 'localChanges', 'selectedUser'], user);
	}, _module$exports.createUserStub = function createUserStub(args, state, output, _ref27) {
	    var locator = _ref27.locator,
	        context = _ref27.context;
	
	    var API = locator.resolve('api');
	    var email = state.get(['account', 'orders', 'createUser', 'input', 'email']);
	    var registerData = { email: email };
	
	    var request = API.registerStubHermesUser(context, locator, { registerData: registerData });
	
	    thenWithErrorHandling(request, function (data) {
	        return { user: _.get(data, 'content') };
	    }, output);
	}, _module$exports.selectManager = function selectManager(_ref28, state) {
	    var selectedValue = _ref28.selectedValue;
	
	    var id = Number(selectedValue);
	    var managers = state.get(['account', 'orders', 'managers']);
	
	    var manager = _.find(managers, { id: id });
	
	    state.set(['account', 'orders', 'currentOrder', 'localChanges', 'selectedManager'], manager);
	}, _module$exports.resetUserSelect = function resetUserSelect(args, state) {
	    state.unset(['account', 'orders', 'currentOrder', 'localChanges', 'selectedUser', 'id']);
	}, _module$exports.setUser = function setUser(args, state, output, _ref29) {
	    var locator = _ref29.locator,
	        context = _ref29.context;
	
	    var API = locator.resolve('api');
	    var orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
	
	    var orderUserId = state.get(['account', 'orders', 'currentOrder', 'user', 'id']);
	    var selectedUserId = state.get(['account', 'orders', 'currentOrder', 'localChanges', 'selectedUser', 'id']);
	    var userId = selectedUserId || orderUserId;
	
	    var request = API.setUser(context, locator, { userId: userId, orderId: orderId });
	
	    thenWithErrorHandling(request, function (data) {
	        return { user: _.get(data, 'content.user'),
	            necessaryDocuments: _.get(data, 'content.necessaryDocuments') };
	    }, output);
	}, _module$exports.resetManagerSelect = function resetManagerSelect(args, state) {
	    state.unset(['account', 'orders', 'currentOrder', 'localChanges', 'selectedManager', 'id']);
	}, _module$exports.resetAddParams = function resetAddParams(args, state) {
	    state.unset(['order', 'addParams']);
	}, _module$exports.setManager = function setManager(args, state, output, _ref30) {
	    var locator = _ref30.locator,
	        context = _ref30.context;
	
	    var API = locator.resolve('api');
	    var orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
	
	    var orderManagerId = state.get(['account', 'orders', 'currentOrder', 'manager', 'id']);
	    var selectedManagerId = state.get(['account', 'orders', 'currentOrder', 'localChanges', 'selectedManager', 'id']);
	    var managerId = selectedManagerId || orderManagerId;
	
	    var request = API.setManager(context, locator, { managerId: managerId, orderId: orderId });
	
	    thenWithErrorHandling(request, function (data) {
	        return { manager: _.get(data, 'content.manager') };
	    }, output);
	}, _module$exports.payOnline = function payOnline(args, state, output, _ref31) {
	    var locator = _ref31.locator,
	        context = _ref31.context;
	
	    var API = locator.resolve('api');
	    var orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
	    var request = API.getOnlinePaymentForm(context, locator, { orderId: orderId });
	    thenWithErrorHandling(request, function (data) {
	        return { url: _.get(data, 'content.url'), data: _.get(data, 'content.data') };
	    }, output);
	}, _module$exports.setOrderPaymentForm = function setOrderPaymentForm(_ref32, state) {
	    var url = _ref32.url,
	        data = _ref32.data;
	
	    state.set(['account', 'orders', 'currentOrder', 'paymentForm'], { url: url, data: data });
	}, _module$exports.isManagerChanged = function isManagerChanged(args, state, output) {
	    var manager = state.get(['account', 'orders', 'currentOrder', 'localChanges', 'selectedManager']);
	    if (manager) {
	        output.true();
	    } else {
	        output.false();
	    }
	}, _module$exports.unsetLocalChangesIfEmpty = function unsetLocalChangesIfEmpty(args, state, output) {
	    var localChanges = state.get(['account', 'orders', 'currentOrder', 'localChanges']);
	    if (localChanges) {
	        if (Object.keys(localChanges).length === 0) {
	            state.unset(['account', 'orders', 'currentOrder', 'localChanges']);
	        }
	        if (Object.keys(localChanges).length === 1 && localChanges.necessaryDocuments) {
	            if (Object.keys(localChanges.necessaryDocuments).length === 0) {
	                state.unset(['account', 'orders', 'currentOrder', 'localChanges']);
	            }
	        }
	    }
	}, _module$exports.saveLocalChanges = function saveLocalChanges(args, state, output, _ref33) {
	    var locator = _ref33.locator,
	        context = _ref33.context;
	
	    if (context.isServer) {
	        return;
	    }
	    var window = locator.resolve('window');
	
	    var localChanges = state.get(['account', 'orders', 'currentOrder', 'localChanges']);
	    window.localStorage.setItem('local_draft', JSON.stringify(localChanges));
	}, _module$exports.restoreLocalChanges = function restoreLocalChanges(_ref34, state, output, _ref35) {
	    var selectedParameters = _ref34.selectedParameters;
	    var context = _ref35.context,
	        locator = _ref35.locator;
	
	    if (context.isServer) {
	        return;
	    }
	    var window = locator.resolve('window');
	    var serialized = window.localStorage.getItem('local_draft');
	
	    if (!serialized) {
	        return;
	    }
	
	    var localChanges = null;
	    try {
	        localChanges = JSON.parse(serialized);
	    } catch (e) {
	        return;
	    }
	
	    output({ localChanges: localChanges });
	}, _module$exports.removeLocalChanges = function removeLocalChanges(args, state, output, _ref36) {
	    var context = _ref36.context,
	        locator = _ref36.locator;
	
	    if (context.isServer) {
	        return;
	    }
	
	    var window = locator.resolve('window');
	    window.localStorage.removeItem('local_draft');
	}, _module$exports.initAccountState = function initAccountState(_ref37, state, output, _ref38) {
	    var localChanges = _ref37.localChanges;
	    var locator = _ref38.locator,
	        context = _ref38.context;
	
	    state.set(['account', 'orders', 'list', 'data', 0, 'id'], "1");
	    state.set(['account', 'orders', 'list', 'data', 0, 'createDate'], Date.now());
	    state.set(['account', 'orders', 'list', 'data', 0, 'stateId'], 1000);
	
	    state.set(['account', 'orders', 'currentOrder', 'id'], "1");
	    state.set(['account', 'orders', 'currentOrder', 'typeId'], 1);
	    state.set(['account', 'orders', 'currentOrder', 'stateId'], 1000);
	    state.set(['account', 'orders', 'currentOrder', 'manager'], null);
	
	    if (context.isServer) {
	        return;
	    }
	
	    var window = locator.resolve('window');
	
	    if (window.localStorage.getItem('local_draft') === null) {
	        var _localChanges = {
	            selectedPaymentTypeId: 2,
	            necessaryDocuments: {
	                addOrRemove: []
	            }
	        };
	        window.localStorage.setItem('local_draft', JSON.stringify(_localChanges));
	    }
	}, _module$exports.restoreAccountOrderState = function restoreAccountOrderState(_ref39, state) {
	    var localChanges = _ref39.localChanges;
	
	    if (localChanges) {
	        state.set(['account', 'orders', 'currentOrder', 'localChanges'], localChanges);
	        var docTypes = _.get(localChanges, 'necessaryDocuments.addOrRemove', []);
	        var orderDocs = state.get(['account', 'orders', 'currentOrder', 'necessaryDocuments']);
	        _.forEach(docTypes, function (docType) {
	            if (docType.value) {
	                var orderDocIndex = _.findIndex(orderDocs, { typeId: docType.documentTypeId });
	                state.set(['account', 'orders', 'currentOrder', 'necessaryDocuments', orderDocIndex, 'isChecked'], true);
	            }
	        });
	    }
	}, _module$exports.saveLocalChangesFilterValues = function saveLocalChangesFilterValues(args, state, output) {
	    state.set(['account', 'orders', 'currentOrder', 'localChanges', 'filterValuesChanged'], true);
	    output({ price: state.get(['order', 'price', 'data']) });
	}, _module$exports.isFilterValuesChanged = function isFilterValuesChanged(args, state, output) {
	    var filterValuesChanged = state.get(['account', 'orders', 'currentOrder', 'localChanges', 'filterValuesChanged']);
	    if (filterValuesChanged && filterValuesChanged === true) {
	        output.true();
	    } else {
	        output.false();
	    }
	}, _module$exports.isFilterValuesInEditMode = function isFilterValuesInEditMode(args, state, output) {
	    var isDisabled = state.get(['order', 'isDisabled']);
	    if (isDisabled === false) {
	        output.yes();
	    } else {
	        output.no();
	    }
	}, _module$exports.orderIdToArgs = function orderIdToArgs(args, state) {
	    args.orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
	}, _module$exports.repeatOrder = function repeatOrder(args, state, output, _ref40) {
	    var locator = _ref40.locator,
	        context = _ref40.context;
	
	    var API = locator.resolve('api');
	    var orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
	
	    var request = API.repeatOrder(context, locator, { orderId: orderId });
	    request.then(function (response) {
	        var code = _.get(response, 'status.code');
	        if (code !== 201) {
	            output.error({ error: code });
	            return;
	        }
	        output.success({ orderId: _.get(response, 'content.id') });
	    }).catch(function (error) {
	        return output.error({ error: error });
	    });
	}, _module$exports.initOrderCreatorSelect = function initOrderCreatorSelect(args, state) {
	    state.set(['account', 'orders', 'createOrder', 'options'], [{ isActive: false, title: 'Online выборка', value: 1 }, { isActive: false, title: 'Offline выборка', value: 2 }, { isActive: false, title: 'Offline адр. план', value: 3 }, { isActive: false, title: 'Индив. выборка', value: 4 }]);
	    state.set(['account', 'orders', 'createOrder', 'isDisable'], false);
	    state.set(['account', 'orders', 'createOrder', 'header'], 'Новый заказ');
	}, _module$exports.validateOrderId = function validateOrderId(_ref41, state, output) {
	    var _ref41$orderId = _ref41.orderId,
	        orderId = _ref41$orderId === undefined ? '' : _ref41$orderId;
	
	    var orderNumberId = orderId.replace('DATA', '');
	    output({ orderId: orderNumberId });
	}, _module$exports);
	
	function downloadAllInternal(exportResults, i, context, locator, API, output, onProgressHandler, onStartDownload) {
	    var fileName = exportResults[i].name;
	    var request = API.downloadFile(context, locator, { fileId: exportResults[i].id, fileName: fileName }, onProgressHandler);
	    onStartDownload(fileName);
	    request.then(function (response) {
	        if (response.code === 200) {
	            var blob = new Blob([response.content], { type: response.contentType });
	            saveAs(blob, fileName);
	            i++;
	            if (i < exportResults.length) {
	                downloadAllInternal(exportResults, i, context, locator, API, output, onProgressHandler, onStartDownload);
	            } else {
	                output.success();
	            }
	        } else {
	            output.error({ error: response.code });
	        }
	    }).catch(function (error) {
	        return output.error({ error: error });
	    });
	}

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(3);
	var computed = __webpack_require__(304);
	var computedPrice = __webpack_require__(305);
	var moment = __webpack_require__(34);
	var treeHelpers = __webpack_require__(57);
	
	var _require = __webpack_require__(99),
	    recalculateFlags = _require.recalculateFlags;
	
	var additionalParameters = __webpack_require__(142);
	
	var _require2 = __webpack_require__(72),
	    thenWithErrorHandling = _require2.thenWithErrorHandling;
	
	var _require3 = __webpack_require__(192),
	    saveAs = _require3.saveAs;
	
	module.exports = {
	    setComputedFields: function setComputedFields(args, state) {
	        computedPrice.datepicker(state);
	        computedPrice.firmsPluralized(state);
	        computedPrice.isBasicPriceAnyDiscount(state);
	        computed.setCitiesComputes(state);
	        computed.setBranchesComputes(state);
	        computed.setRubricsComputes(state);
	        computed.setLegalEntitiesComputes(state);
	        computed.setPurposesComputes(state);
	        computed.setMapClassesComputes(state);
	        computed.setPaymentTypesComputes(state);
	        computed.setNumberOfEmployeesComputes(state);
	        computed.computeDataChangeTooltipState(state);
	        computed.computeIsExportColumnChecked(state, 'LegalForm');
	        computed.computeIsExportColumnChecked(state, 'Purpose');
	        computed.computeIsExportColumnChecked(state, 'PaymentTypes');
	        computed.computeRubricsState(state);
	        computed.formatExportColumnsOptional(state);
	        computed.formatExportColumnsOptionalOrder(state);
	        computed.formatExportColumnsBasic(state);
	        computed.formatExportColumnsBasicOrder(state);
	        computed.setExportColumnAlwaysTrueForBasicColumnsCheckbox(state);
	        computed.calculateOptionalExportColumnsValue(state);
	        computed.isShowGreeder(state);
	        computed.isOfflineOrder(state);
	        computed.isGosResSourceSelected(state);
	        computed.computeRubricsRecognizedInputValue(state);
	        computed.computeRubricsUnrecognizedInputValue(state);
	        computed.computeIsAnyUnrecognizedRubrics(state);
	        computed.computeCitiesRecognizedInputValue(state);
	        computed.computeCitiesUnrecognizedInputValue(state);
	        computed.computeIsAnyUnrecognizedCities(state);
	    },
	    setStatisticComputed: function setStatisticComputed(args, state) {
	        computed.setStatisticComputes(state);
	    },
	    getAvailableParameters: function getAvailableParameters(args, state, output, _ref) {
	        var context = _ref.context,
	            locator = _ref.locator;
	
	        var api = locator.resolve('api');
	        var request = api.getAvailableParameters(context, locator, {});
	        request.then(function (response) {
	            var code = _.get(response, 'status.code');
	
	            if (code !== 200) {
	                output.error({ error: code });
	                return;
	            }
	            var availableParameters = _.get(response, 'content');
	            output.success({ availableParameters: availableParameters });
	        }).catch(function (error) {
	            return output.error({ error: error });
	        });
	    },
	    setAvailableParameters: function setAvailableParameters(_ref2, state) {
	        var availableParameters = _ref2.availableParameters;
	
	        state.set(['order', 'originalParameters'], availableParameters);
	    },
	    restoreState: function restoreState(_ref3, state) {
	        var selectedParameters = _ref3.selectedParameters;
	
	        var rubrics = _.get(selectedParameters, 'rubrics', []);
	        var cities = _.get(selectedParameters, 'cities', []);
	        var branches = _.get(selectedParameters, 'branches', []);
	        var legalEntities = _.get(selectedParameters, 'legalEntities', []);
	        var purposes = _.get(selectedParameters, 'purposes', []);
	        var mapClasses = _.get(selectedParameters, 'mapClasses', []);
	        var paymentTypes = _.get(selectedParameters, 'paymentTypes', []);
	        var numberOfEmployees = _.get(selectedParameters, 'numberOfEmployees', []);
	        var numberOfFilials = _.get(selectedParameters, 'numberOfFilials', []);
	        var selectedExportColumns = _.get(selectedParameters, 'exportColumns', []);
	        var selectedGreederColumns = _.get(selectedParameters, 'greederColumns', []);
	        var onlyHeadCards = _.get(selectedParameters, 'onlyHeadCards', false);
	        var includeArchiveInn = _.get(selectedParameters, 'includeArchiveInn', false);
	        var mapFilter = _.get(selectedParameters, 'mapFilter');
	
	        if (state.get(['order', 'originalParameters', 'rubrics'])) {
	            treeHelpers.restoreSelectedLeafsState(state, ['order', 'originalParameters', 'rubrics'], ['order', 'rubrics', 'tree', 'selected'], rubrics);
	        }
	
	        if (state.get(['order', 'originalParameters', 'cities'])) {
	            treeHelpers.restoreSelectedLeafsState(state, ['order', 'originalParameters', 'cities'], ['order', 'cities', 'tree', 'selected'], cities);
	            recalculateFlags(state);
	        }
	
	        if (state.get(['order', 'originalParameters', 'branches'])) {
	            treeHelpers.restoreSelectedLeafsState(state, ['order', 'originalParameters', 'branches'], ['order', 'branches', 'tree', 'selected'], branches);
	            if (branches && branches.length > 0) {
	                state.set(['order', 'cities', 'tab'], 'branches');
	            }
	        }
	
	        if (state.get(['order', 'originalParameters', 'legalEntities'])) {
	            treeHelpers.restoreSelectedLeafsState(state, ['order', 'originalParameters', 'legalEntities'], ['order', 'addParams', 'legalEntities', 'tree', 'selected'], legalEntities);
	        }
	
	        if (state.get(['order', 'originalParameters', 'purposes'])) {
	            treeHelpers.restoreSelectedLeafsState(state, ['order', 'originalParameters', 'purposes'], ['order', 'addParams', 'purposes', 'tree', 'selected'], purposes);
	        }
	
	        if (state.get(['order', 'originalParameters', 'mapClasses'])) {
	            treeHelpers.restoreSelectedLeafsState(state, ['order', 'originalParameters', 'mapClasses'], ['order', 'addParams', 'mapClasses', 'tree', 'selected'], mapClasses);
	        }
	
	        if (state.get(['order', 'originalParameters', 'paymentTypes'])) {
	            treeHelpers.restoreSelectedLeafsState(state, ['order', 'originalParameters', 'paymentTypes'], ['order', 'addParams', 'paymentTypes', 'tree', 'selected'], paymentTypes);
	        }
	
	        if (state.get(['order', 'originalParameters', 'numberOfEmployees'])) {
	            treeHelpers.restoreSelectedLeafsState(state, ['order', 'originalParameters', 'numberOfEmployees'], ['order', 'addParams', 'numberOfEmployees', 'tree', 'selected'], numberOfEmployees);
	        }
	
	        function arrayToObj(array) {
	            var obj = {};
	            for (var i = 0; i < array.length; ++i) {
	                obj[i] = array[i];
	            }
	            return obj;
	        }
	
	        state.unset(['order', 'addParams', 'datepicker', 'value']);
	        state.unset(['order', 'addParams', 'datepicker2', 'value']);
	        additionalParameters.initExportColumnsState({}, state);
	        var exportColumns = state.get(['order', 'originalParameters', 'exportColumns', 'columns']);
	        _.forEach(exportColumns, function (x) {
	            var selected = _.find(selectedExportColumns, { columnId: x.id });
	            if (selected) {
	                state.set(['order', 'addParams', 'exportColumns', x.id, 'isChecked'], true);
	                state.set(['order', 'addParams', 'exportColumns', x.id, 'isMustBeFilled'], selected.isMustBeFilled);
	                if (selected.value) {
	                    if (x.filterType === 'IsInRangeDatetime') {
	                        var from = selected.value[0];
	                        var to = selected.value[1];
	
	                        state.set(['order', 'addParams', 'datepicker', 'value'], from && moment.utc(from).subtract(moment().utcOffset(), 'm').unix());
	                        state.set(['order', 'addParams', 'datepicker2', 'value'], to && moment.utc(to).subtract(moment().utcOffset(), 'm').unix());
	                    } else {
	                        state.set(['order', 'addParams', 'exportColumns', x.id, 'value'], arrayToObj(selected.value));
	                    }
	                }
	            }
	        });
	
	        additionalParameters.initGreederColumns({}, state);
	        _.forEach(selectedGreederColumns, function (x) {
	            state.set(['order', 'addParams', 'greederColumns', 'value', x, 'isChecked'], true);
	        });
	
	        var greederColumns = _.filter(state.get(['order', 'originalParameters', 'greederColumns']), function (x) {
	            return selectedGreederColumns.includes(x.id) && (x.isEgrip || x.isEgrul);
	        });
	        var isEgripSelected = _.findIndex(greederColumns, { isEgrip: true }) > -1;
	        var isEgrulSelected = _.findIndex(greederColumns, { isEgrul: true }) > -1;
	
	        var isAllEgrip = _.every(greederColumns, { isEgrip: true });
	        var isAllEgrul = _.every(greederColumns, { isEgrul: true });
	        if (isAllEgrip) {
	            isEgrulSelected = false;
	        } else if (isAllEgrul) {
	            isEgripSelected = false;
	        }
	        state.set(['order', 'addParams', 'greederColumns', 'source', 'egrip', 'isChecked'], isEgripSelected);
	        state.set(['order', 'addParams', 'greederColumns', 'source', 'egrul', 'isChecked'], isEgrulSelected);
	        additionalParameters.calcEnabledGreederColumns({}, state);
	
	        state.set(['order', 'addParams', 'onlyHeadCards'], onlyHeadCards);
	        state.set(['order', 'addParams', 'includeArchiveInn'], includeArchiveInn);
	
	        var filialsOptions = state.get(['order', 'addParams', 'numberOfFilials', 'options']);
	        if (filialsOptions) {
	            var optionIndex = _.findIndex(filialsOptions, function (x) {
	                return Number(x.value) === numberOfFilials;
	            });
	            if (optionIndex > -1) {
	                var oldActiveIndex = _.findIndex(filialsOptions, function (x) {
	                    return x.isActive === true;
	                });
	                if (oldActiveIndex > -1) {
	                    state.set(['order', 'addParams', 'numberOfFilials', 'options', oldActiveIndex, 'isActive'], false);
	                }
	                state.set(['order', 'addParams', 'numberOfFilials', 'options', optionIndex, 'isActive'], true);
	            }
	        }
	
	        state.set(['order', 'cities', 'mapFilterInit'], '');
	        state.unset(['order', 'cities', 'mapFilterInit']);
	        state.unset(['order', 'cities', 'mapFilter']);
	
	        if (mapFilter) {
	            state.set(['order', 'cities', 'mapFilterInit'], mapFilter);
	            state.set(['order', 'cities', 'tab'], 'map');
	        }
	    },
	    isEditable: function isEditable(args, state, output) {
	        var isEditable = state.get(['account', 'orders', 'computed', 'currentOrder', 'isEditable']);
	
	        if (isEditable === true) {
	            output.yes();
	        } else {
	            output.no();
	        }
	    },
	    setFilterValuesChanged: function setFilterValuesChanged(args, state) {
	        state.set(['account', 'orders', 'currentOrder', 'filterValuesChanged'], true);
	    },
	    unsetFilterValuesChanged: function unsetFilterValuesChanged(args, state) {
	        state.unset(['account', 'orders', 'currentOrder', 'filterValuesChanged']);
	        state.unset(['account', 'orders', 'currentOrder', 'tooltips', 'showChangesMustBeSavedOrCancelled']);
	    },
	    isFilterValuesChanged: function isFilterValuesChanged(args, state, output) {
	        var isChanged = state.get(['account', 'orders', 'currentOrder', 'filterValuesChanged']);
	        if (isChanged) {
	            output.yes();
	        } else {
	            output.no();
	        }
	    },
	    setShouldPersistToLocalStorage: function setShouldPersistToLocalStorage(value) {
	        return function (args, state) {
	            return state.set(['order', 'settings', 'shouldPersist'], value);
	        };
	    },
	    uploadTreeInput: function uploadTreeInput(_ref4, state, output, _ref5) {
	        var treeInput = _ref4.treeInput,
	            treeId = _ref4.treeId;
	        var context = _ref5.context,
	            locator = _ref5.locator;
	
	        var orderTypeId = state.get(['order', 'typeId']) || 1;
	        var api = locator.resolve('api');
	        var request = treeId === 'rubrics' ? api.uploadTreeInputRubrics(context, locator, treeInput) : api.uploadTreeInputCities(context, locator, treeInput, orderTypeId);
	
	        thenWithErrorHandling(request, function (data) {
	            return {
	                unrecognized: _.get(data, 'content.unrecognized'),
	                recognized: _.get(data, 'content.recognized') };
	        }, output);
	    },
	    selectRubrics: function selectRubrics(_ref6, state) {
	        var recognized = _ref6.recognized;
	
	        var recognizedNotIgnored = _.map(_.filter(recognized, { isIgnored: false }), 'id');
	        treeHelpers.selectLeafs(state, ['order', 'originalParameters', 'rubrics'], ['order', 'rubrics', 'tree', 'selected'], recognizedNotIgnored);
	    },
	    selectCities: function selectCities(_ref7, state) {
	        var recognized = _ref7.recognized;
	
	        var recognizedNotIgnored = _.map(_.filter(recognized, { isIgnored: false }), 'id');
	        treeHelpers.selectLeafs(state, ['order', 'originalParameters', 'cities'], ['order', 'cities', 'tree', 'selected'], recognizedNotIgnored);
	    },
	    showRubricsRecognitionResult: function showRubricsRecognitionResult(_ref8, state) {
	        var unrecognized = _ref8.unrecognized,
	            recognized = _ref8.recognized,
	            treeId = _ref8.treeId;
	
	        if (unrecognized && unrecognized.length > 0) {
	            state.set(['order', 'treeUpload', treeId, 'recognizeAll'], false);
	            state.set(['order', 'treeUpload', treeId, 'unrecognized'], unrecognized);
	        } else {
	            state.set(['order', 'treeUpload', treeId, 'recognizeAll'], true);
	            state.unset(['order', 'treeUpload', treeId, 'unrecognized']);
	        }
	        state.set(['order', 'treeUpload', treeId, 'recognized'], recognized);
	    },
	    downloadRubricsFile: function downloadRubricsFile(args, state, output, _ref9) {
	        var locator = _ref9.locator,
	            context = _ref9.context;
	
	        var API = locator.resolve('api');
	
	        var request = API.downloadRubricsFile(context, locator);
	        request.then(function (response) {
	            if (response.code === 200) {
	                var blob = new Blob([response.content], { type: response.contentType });
	                saveAs(blob, 'Data.2gis_рубрики.xlsx');
	                output.success();
	            } else {
	                output.error();
	            }
	        }).catch(function (error) {
	            return output.error({ error: error });
	        });
	    },
	    downloadCitiesFile: function downloadCitiesFile(args, state, output, _ref10) {
	        var locator = _ref10.locator,
	            context = _ref10.context;
	
	        var orderTypeId = state.get(['order', 'typeId']) || 1;
	        var API = locator.resolve('api');
	
	        var filePostfix = orderTypeId === 2 ? '(Offline выборка)' : orderTypeId === 3 ? '(Offline адр. план)' : '';
	
	        var request = API.downloadCitiesFile(context, locator, orderTypeId);
	        request.then(function (response) {
	            if (response.code === 200) {
	                var blob = new Blob([response.content], { type: response.contentType });
	                saveAs(blob, 'Data.2gis_\u0433\u043E\u0440\u043E\u0434\u0430' + filePostfix + '.xlsx');
	                output.success();
	            } else {
	                output.error();
	            }
	        }).catch(function (error) {
	            return output.error({ error: error });
	        });
	    },
	    switchTabTransition: function switchTabTransition(_ref11, state, output) {
	        var tabId = _ref11.tabId;
	
	        var currentTab = state.get(['order', 'cities', 'tab']) || 'default';
	        if (currentTab === 'branches' && tabId === 'default') {
	            output.branchesToDefault();
	        } else if (currentTab === 'default' && tabId === 'branches') {
	            output.defaultToBranches();
	        } else {
	            output.default();
	        }
	    },
	    isTabSelected: function isTabSelected(tabId) {
	        return function (args, state, output) {
	            var currentTab = state.get(['order', 'cities', 'tab']) || 'default';
	            if (tabId === currentTab) {
	                output.yes();
	            } else {
	                output.no();
	            }
	        };
	    }
	};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(3);
	
	var DEFAULT_ROOT_CLEANUP_EXCLUDES = ['layout', 'user', 'feedback', 'header', 'footer', 'bitrix'];
	
	module.exports = {
	    cleanup: function cleanup() {
	        var additionalExcludeFields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	        var node = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	        return function cleanup(args, state) {
	            var exclude = _.isEmpty(node) ? [].concat(DEFAULT_ROOT_CLEANUP_EXCLUDES, additionalExcludeFields) : additionalExcludeFields;
	
	            var tree = state.get(node);
	
	            _.each(tree, function (value, key) {
	                if (!_.includes(exclude, key)) {
	                    state.unset([].concat(node, [key]));
	                }
	            });
	        };
	    },
	    setCurrentPage: function setCurrentPage(_ref, state) {
	        var page = _ref.page;
	
	        var layout = state.get('layout');
	
	        if (!layout) {
	            state.set('layout', 'main');
	        }
	
	        state.set(['page', 'name'], page);
	    }
	};

/***/ }),
/* 44 */
[1069, 460, 466, 464, 461, 467, 465, 462, 459, 463],
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var user = __webpack_require__(28);
	var utils = __webpack_require__(5);
	var redirect = __webpack_require__(35);
	var error = __webpack_require__(19);
	var cookie = __webpack_require__(27);
	
	function refreshToken() {
	    var actions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    return [user.checkRefreshCookie, {
	        exist: [[user.refreshToken, {
	            success: [cookie.unsetSessionToken, cookie.setSessionToken].concat(actions),
	            accessDenied: [cookie.unsetSessionToken, utils.set(['user', 'role'], 'unauthorized')],
	            invalidValidation: [cookie.unsetSessionToken, utils.set(['user', 'role'], 'unauthorized')],
	            error: [utils.set(['user', 'role'], 'unauthorized')]
	        }]],
	        notExist: [utils.set(['user', 'role'], 'unauthorized')]
	    }];
	}
	
	module.exports = {
	    access: function access(section) {
	        var actions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	        return [user.checkPermissions(section), {
	            allowed: [].concat(actions),
	            denied: [error.accessDenied('user.checkPermissions')]
	        }];
	    },
	    checkAuthCookie: function checkAuthCookie() {
	        var actions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	        return [utils.isEqual(['bitrix', 'isBitrix'], true), {
	            yes: [],
	            no: [[user.checkAccessCookie, {
	                exist: [].concat(actions),
	                notExist: [].concat(refreshToken(actions))
	            }]]
	        }];
	    },
	
	    getUser: [[user.getUser, {
	        allowed: [user.addUserRole, utils.setFromArgsToState('extendedUser', 'user')],
	        401: [].concat(refreshToken([[user.getUser, {
	            allowed: [user.addUserRole, utils.setFromArgsToState('extendedUser', 'user')],
	            401: [utils.set(['user', 'role'], 'unauthorized')],
	            403: [error.accessDenied('user.getUser inner')],
	            404: [redirect.redirect('/registration/extra')],
	            denied: [utils.set(['user', 'role'], 'unauthorized')]
	        }]])),
	        403: [error.accessDenied('user.getUser outer')],
	        404: [redirect.redirect('/registration/extra')],
	        denied: [utils.set(['user', 'role'], 'unauthorized')]
	    }]]
	};

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 47 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(25);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(9);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ }),
/* 50 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(48);
	var IObject = __webpack_require__(105);
	var toObject = __webpack_require__(18);
	var toLength = __webpack_require__(14);
	var asc = __webpack_require__(166);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ }),
/* 52 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(2);
	var core = __webpack_require__(47);
	var fails = __webpack_require__(9);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(10);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 55 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.extend = extend;
	exports.indexOf = indexOf;
	exports.escapeExpression = escapeExpression;
	exports.isEmpty = isEmpty;
	exports.createFrame = createFrame;
	exports.blockParams = blockParams;
	exports.appendContextPath = appendContextPath;
	var escape = {
	  '&': '&amp;',
	  '<': '&lt;',
	  '>': '&gt;',
	  '"': '&quot;',
	  "'": '&#x27;',
	  '`': '&#x60;',
	  '=': '&#x3D;'
	};
	
	var badChars = /[&<>"'`=]/g,
	    possible = /[&<>"'`=]/;
	
	function escapeChar(chr) {
	  return escape[chr];
	}
	
	function extend(obj /* , ...source */) {
	  for (var i = 1; i < arguments.length; i++) {
	    for (var key in arguments[i]) {
	      if (Object.prototype.hasOwnProperty.call(arguments[i], key)) {
	        obj[key] = arguments[i][key];
	      }
	    }
	  }
	
	  return obj;
	}
	
	var toString = Object.prototype.toString;
	
	exports.toString = toString;
	// Sourced from lodash
	// https://github.com/bestiejs/lodash/blob/master/LICENSE.txt
	/* eslint-disable func-style */
	var isFunction = function isFunction(value) {
	  return typeof value === 'function';
	};
	// fallback for older versions of Chrome and Safari
	/* istanbul ignore next */
	if (isFunction(/x/)) {
	  exports.isFunction = isFunction = function (value) {
	    return typeof value === 'function' && toString.call(value) === '[object Function]';
	  };
	}
	exports.isFunction = isFunction;
	
	/* eslint-enable func-style */
	
	/* istanbul ignore next */
	var isArray = Array.isArray || function (value) {
	  return value && typeof value === 'object' ? toString.call(value) === '[object Array]' : false;
	};
	
	exports.isArray = isArray;
	// Older IE versions do not directly support indexOf so we must implement our own, sadly.
	
	function indexOf(array, value) {
	  for (var i = 0, len = array.length; i < len; i++) {
	    if (array[i] === value) {
	      return i;
	    }
	  }
	  return -1;
	}
	
	function escapeExpression(string) {
	  if (typeof string !== 'string') {
	    // don't escape SafeStrings, since they're already safe
	    if (string && string.toHTML) {
	      return string.toHTML();
	    } else if (string == null) {
	      return '';
	    } else if (!string) {
	      return string + '';
	    }
	
	    // Force a string conversion as this will be done by the append regardless and
	    // the regex test will do this transparently behind the scenes, causing issues if
	    // an object's to string has escaped characters in it.
	    string = '' + string;
	  }
	
	  if (!possible.test(string)) {
	    return string;
	  }
	  return string.replace(badChars, escapeChar);
	}
	
	function isEmpty(value) {
	  if (!value && value !== 0) {
	    return true;
	  } else if (isArray(value) && value.length === 0) {
	    return true;
	  } else {
	    return false;
	  }
	}
	
	function createFrame(object) {
	  var frame = extend({}, object);
	  frame._parent = object;
	  return frame;
	}
	
	function blockParams(params, ids) {
	  params.path = ids;
	  return params;
	}
	
	function appendContextPath(contextPath, id) {
	  return (contextPath ? contextPath + '.' : '') + id;
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var moment = __webpack_require__(34);
	
	module.exports = {
	    setCopyrightYear: function setCopyrightYear(args, state) {
	        var year = moment().year();
	        state.set(['footer', 'year'], year);
	    }
	};

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(3);
	
	module.exports = {
	    dfsRecursive: dfsRecursive,
	    initTreeUiState: initTreeUiState,
	    changeTreeNodeValue: changeTreeNodeValue,
	    getLeafs: getLeafs,
	    setAllSelection: setAllSelection,
	    getSelectedLeafs: getSelectedLeafs,
	    restoreSelectedLeafsState: restoreSelectedLeafsState,
	    selectLeafs: selectLeafs,
	    clearFilter: clearFilter,
	    selectBranch: selectBranch,
	    setValueByFilter: setValueByFilter
	};
	
	function getSelectedLeafs(leafs, selected) {
	    return _.filter(leafs, function (x) {
	        var state = selected && selected[x];
	        return state && state.value;
	    });
	}
	
	function changeTreeNodeValue(state, originalDataPath, basePath, nodeId, value) {
	    var tree = state.get(originalDataPath);
	    var selectedDataPath = basePath.concat('selected');
	
	    var selected = _.cloneDeep(state.get(selectedDataPath));
	    updateSelected(selected, tree, nodeId, value);
	
	    var node = state.get(originalDataPath.concat(nodeId));
	    if (node && node.parentCode) {
	        propagateCheckedToAscendants(state, tree, selected, node.parentCode);
	    }
	
	    state.set(selectedDataPath, selected);
	}
	
	function setAllSelection(state, originalDataPath, basePath, value) {
	    var nodeState = { value: value, indeterminate: false };
	    var selected = _.mapValues(state.get(originalDataPath), function () {
	        return nodeState;
	    });
	    state.set(basePath.concat('selected'), selected);
	}
	
	function selectBranch(state, originalDataPath, basePath, value, branchId) {
	    var selectedDataPath = basePath.concat('selected');
	    var selected = _.cloneDeep(state.get(selectedDataPath));
	    var branchedNodes = _.filter(state.get(originalDataPath), { 'branchId': branchId });
	    var tree = state.get(originalDataPath);
	
	    var parents = [];
	    _.forEach(branchedNodes, function (x) {
	        updateSelected(selected, tree, x.code, value);
	        parents.push(x.parentCode);
	    });
	
	    parents = _.uniqBy(parents, function (x) {
	        return x;
	    });
	    _.forEach(parents, function (x) {
	        propagateCheckedToAscendants(state, tree, selected, x);
	    });
	
	    state.set(basePath.concat('selected'), selected);
	}
	
	function setValueByFilter(state, originalDataPath, basePath, value, filter) {
	    var selectedDataPath = basePath.concat('selected');
	    var selected = _.cloneDeep(state.get(selectedDataPath));
	    var branchedNodes = _.filter(state.get(originalDataPath), filter);
	    var tree = state.get(originalDataPath);
	
	    var parents = [];
	    _.forEach(branchedNodes, function (x) {
	        updateSelected(selected, tree, x.code, value);
	        parents.push(x.parentCode);
	    });
	
	    parents = _.uniqBy(parents, function (x) {
	        return x;
	    });
	    _.forEach(parents, function (x) {
	        propagateCheckedToAscendants(state, tree, selected, x);
	    });
	
	    state.set(basePath.concat('selected'), selected);
	}
	
	function initTreeUiState(state, originalDataPath, basePath) {
	    var UI_STATE = { 0: true };
	
	    state.set(basePath.concat('expanded'), UI_STATE);
	    state.set(basePath.concat('filter'), null);
	    setAllSelection(state, originalDataPath, basePath, false);
	}
	
	function dfsRecursive(tree, nodeId, cb) {
	    var node = tree[nodeId];
	    var children = node.children || [];
	
	    _.forEach(children, function (x) {
	        return dfsRecursive(tree, x, cb);
	    });
	    cb(node);
	}
	
	function ascendRecursive(tree, nodeId, cb) {
	    if (nodeId === null) {
	        return;
	    }
	
	    var node = tree[nodeId];
	    if (cb(node)) {
	        return;
	    }
	
	    ascendRecursive(tree, node.parentCode, cb);
	}
	
	function getLeafs(tree) {
	    return _.chain(tree).filter(function (node) {
	        return node.children.length === 0;
	    }).map('code').value();
	}
	
	function updateSelected(selected, tree, nodeId, value) {
	    dfsRecursive(tree, nodeId, function (node) {
	        selected[node.code] = Object.assign({ value: value, indeterminate: false });
	    });
	}
	
	function propagateCheckedToDescendants(state, tree, selectedDataPath, nodeId, value) {
	    dfsRecursive(tree, nodeId, function (node) {
	        state.set(selectedDataPath.concat(node.code), Object.assign({ value: value, indeterminate: false }));
	    });
	}
	
	function propagateCheckedToAscendants(state, tree, selected, nodeId) {
	    ascendRecursive(tree, nodeId, function (node) {
	        if (node.code === '0') {
	            return true;
	        }
	
	        selected[node.code] = calculateNodeSelectionState(selected, node);
	    });
	}
	
	function calculateNodeSelectionState(selectionState, node) {
	    if (node.children.length === 0) {
	        return selectionState[node.code];
	    }
	
	    var childrenState = _.map(node.children, function (x) {
	        return selectionState[x];
	    });
	    var haveChecked = _.findIndex(childrenState, ['value', true]);
	    var haveUnchecked = _.findIndex(childrenState, ['value', false]);
	    if (haveChecked > -1 && haveUnchecked > -1) {
	        return { value: true, indeterminate: true };
	    }
	    var haveIndeterminate = _.findIndex(childrenState, ['indeterminate', true]);
	    if (haveIndeterminate > -1) {
	        return { value: true, indeterminate: true };
	    } else if (haveChecked > -1) {
	        return { value: true, indeterminate: false };
	    } else {
	        return { value: false, indeterminate: false };
	    }
	}
	
	function restoreSelectedLeafsState(state, originalDataPath, selectedDataPath, selectedLeafs) {
	    var tree = state.get(originalDataPath);
	
	    var defaultNodeSate = { value: false, indeterminate: false };
	    var selectionState = _.mapValues(tree, function () {
	        return Object.assign({}, defaultNodeSate);
	    });
	
	    _.forEach(selectedLeafs, function (nodeId) {
	        if (tree.hasOwnProperty(nodeId)) {
	            dfsRecursive(tree, nodeId, function (node) {
	                selectionState[node.code] = Object.create({ value: true, indeterminate: false });
	            });
	        } else {
	            state.set(['order', 'localStorageSelectedParamsWasOutdated'], true);
	        }
	    });
	
	    dfsRecursive(tree, '0', function (node) {
	        var newState = calculateNodeSelectionState(selectionState, node);
	        selectionState[node.code] = newState;
	    });
	
	    state.set(selectedDataPath, selectionState);
	}
	
	function selectLeafs(state, originalDataPath, selectedDataPath, selectedLeafs) {
	    var tree = state.get(originalDataPath);
	    var selectionState = _.cloneDeep(state.get(selectedDataPath));
	
	    _.forEach(selectedLeafs, function (nodeId) {
	        if (tree.hasOwnProperty(nodeId)) {
	            dfsRecursive(tree, nodeId, function (node) {
	                selectionState[node.code] = Object.create({ value: true, indeterminate: false });
	            });
	        } else {
	            state.set(['order', 'localStorageSelectedParamsWasOutdated'], true);
	        }
	    });
	
	    dfsRecursive(tree, '0', function (node) {
	        var newState = calculateNodeSelectionState(selectionState, node);
	        selectionState[node.code] = newState;
	    });
	
	    state.set(selectedDataPath, selectionState);
	}
	
	function clearFilter(state, basePath, treeId) {
	    state.set(basePath.concat('filter'), null);
	    var htmlInput = document.getElementById(treeId + 'Filter');
	    if (htmlInput) {
	        htmlInput.value = '';
	    }
	}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
		URI: __webpack_require__(457),
		Authority: __webpack_require__(220),
		UserInfo: __webpack_require__(222),
		Query: __webpack_require__(221)
	};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(272);
	var $export = __webpack_require__(2);
	var shared = __webpack_require__(107)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(276))());
	
	var getOrCreateMetadataMap = function (target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function (target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
	  return keys;
	};
	var toMetaKey = function (it) {
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function (O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(16)) {
	  var LIBRARY = __webpack_require__(66);
	  var global = __webpack_require__(8);
	  var fails = __webpack_require__(9);
	  var $export = __webpack_require__(2);
	  var $typed = __webpack_require__(132);
	  var $buffer = __webpack_require__(187);
	  var ctx = __webpack_require__(48);
	  var anInstance = __webpack_require__(76);
	  var propertyDesc = __webpack_require__(81);
	  var hide = __webpack_require__(31);
	  var redefineAll = __webpack_require__(82);
	  var toInteger = __webpack_require__(50);
	  var toLength = __webpack_require__(14);
	  var toIndex = __webpack_require__(270);
	  var toAbsoluteIndex = __webpack_require__(84);
	  var toPrimitive = __webpack_require__(54);
	  var has = __webpack_require__(37);
	  var classof = __webpack_require__(92);
	  var isObject = __webpack_require__(10);
	  var toObject = __webpack_require__(18);
	  var isArrayIter = __webpack_require__(173);
	  var create = __webpack_require__(78);
	  var getPrototypeOf = __webpack_require__(39);
	  var gOPN = __webpack_require__(79).f;
	  var getIterFn = __webpack_require__(189);
	  var uid = __webpack_require__(85);
	  var wks = __webpack_require__(13);
	  var createArrayMethod = __webpack_require__(51);
	  var createArrayIncludes = __webpack_require__(120);
	  var speciesConstructor = __webpack_require__(108);
	  var ArrayIterators = __webpack_require__(190);
	  var Iterators = __webpack_require__(93);
	  var $iterDetect = __webpack_require__(125);
	  var setSpecies = __webpack_require__(83);
	  var arrayFill = __webpack_require__(165);
	  var arrayCopyWithin = __webpack_require__(242);
	  var $DP = __webpack_require__(17);
	  var $GOPD = __webpack_require__(38);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(3);
	
	var _require = __webpack_require__(15),
	    monkey = _require.monkey;
	
	var moment = __webpack_require__(34);
	var DATE_FORMAT = 'DD.MM.YYYY';
	
	var _require2 = __webpack_require__(216),
	    getOrderStateName = _require2.getOrderStateName;
	
	var formatter = __webpack_require__(157);
	var currentOrderActions = __webpack_require__(23);
	
	var PATHS = {
	    showNecessaryDocumentsAddDeleteButtons: ['account', 'orders', 'computed', 'componentsState', 'showNecessaryDocumentsAddDeleteButtons'],
	    usersListFilter: ['account', 'orders', 'computed', 'filter'],
	    optionsFiltered: ['account', 'orders', 'computed', 'optionsFiltered'],
	    isShowSumCanChangeTooltip: ['account', 'orders', 'computed', 'componentsState', 'showSumCanChangeTooltip'],
	    isShowOrderParameters: ['account', 'orders', 'computed', 'componentsState', 'isShowOrderParameters'],
	    isShowIndividualOrderParameters: ['account', 'orders', 'computed', 'componentsState', 'isShowIndividualOrderParameters'],
	    isShowResultUploadButton: ['account', 'orders', 'computed', 'componentsState', 'isShowResultUploadButton'],
	    isCanDeleteResult: ['account', 'orders', 'computed', 'componentsState', 'isCanDeleteResult'],
	    isDisabledAmountField: ['account', 'orders', 'computed', 'componentsState', 'amount', 'isDisabledAmountField'],
	    isLoadingUploadResultDocument: ['account', 'orders', 'currentOrder', 'uploadResultDocument', 'isLoading']
	};
	
	var isMatch = function isMatch(value, filter) {
	    if (filter) {
	        return value.toLowerCase().indexOf(filter.toLowerCase()) !== -1;
	    }
	
	    return true;
	};
	
	module.exports = {
	    PATHS: PATHS,
	
	    computeShowDownloadAllButton: function computeShowDownloadAllButton(state) {
	        state.set(['account', 'orders', 'computed', 'componentsState', 'showDownloadAllButton'], monkey(['account', 'orders', 'currentOrder', 'exportResult'], function () {
	            var exportResult = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	            return exportResult && exportResult.length > 1;
	        }));
	    },
	    computeOrderCreateDate: function computeOrderCreateDate(state) {
	        state.set(['account', 'orders', 'computed', 'currentOrder', 'createDate'], monkey(['account', 'orders', 'currentOrder', 'createDate'], function () {
	            var createDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            if (createDate) {
	                return moment(createDate).format(DATE_FORMAT);
	            }
	            return {};
	        }));
	    },
	    computeOrderStateName: function computeOrderStateName(state) {
	        state.set(['account', 'orders', 'computed', 'currentOrder', 'stateName'], monkey(['account', 'orders', 'currentOrder', 'stateId'], function () {
	            var stateId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
	            return getOrderStateName(stateId);
	        }));
	    },
	    computePaymentTypeName: function computePaymentTypeName(state) {
	        state.set(['account', 'orders', 'computed', 'currentOrder', 'paymentName'], monkey(['account', 'orders', 'currentOrder', 'paymentTypeId'], function () {
	            var paymentTypeId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
	
	            switch (paymentTypeId) {
	                case 1:
	                    return 'Счёт';
	                case 2:
	                    return 'Онлайн оплата';
	                default:
	                    return '';
	            }
	        }));
	    },
	    computeOrderIsEditable: function computeOrderIsEditable(state) {
	        state.set(['account', 'orders', 'computed', 'currentOrder', 'isEditable'], monkey(['account', 'orders', 'currentOrder', 'stateId'], ['account', 'orders', 'currentOrder', 'typeId'], function () {
	            var stateId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
	            var typeId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
	
	            if (typeId === 1 && (stateId === 7 || stateId === 1 || stateId === 1000)) {
	                return true;
	            }
	            if (typeId === 2 && stateId === 1001) {
	                return true;
	            }
	            if (typeId === 3 && stateId === 2001) {
	                return true;
	            }
	            if (typeId === 4 && stateId === 3001) {
	                return true;
	            }
	
	            return false;
	        }));
	    },
	    computeOrderUser: function computeOrderUser(state) {
	        state.set(['account', 'orders', 'computed', 'currentOrder', 'user'], monkey(['account', 'orders', 'currentOrder', 'user'], function () {
	            var user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            var computedUser = {};
	            if (user) {
	                computedUser.fullName = formatter.fullName(user);
	                computedUser.shortName = formatter.shortName(user);
	            }
	            return computedUser;
	        }));
	    },
	    filterOptionsUsersList: function filterOptionsUsersList(state) {
	        state.set(PATHS.optionsFiltered, monkey(['account', 'orders', 'computed', 'selectedUser', 'options'], PATHS.usersListFilter, function () {
	            var usersList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	            var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	            return _.filter(usersList, function (item) {
	                return isMatch(item.title, filter) || item.isActive;
	            });
	        }));
	    },
	    computeOrderManager: function computeOrderManager(state) {
	        state.set(['account', 'orders', 'computed', 'currentOrder', 'manager'], monkey(['account', 'orders', 'currentOrder', 'manager'], function () {
	            var manager = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            var computedManager = {};
	            if (manager) {
	                computedManager.fullName = formatter.fullName(manager);
	            }
	            return computedManager;
	        }));
	    },
	    computeDocumentsWillBeUploadedTooltipState: function computeDocumentsWillBeUploadedTooltipState(state) {
	        state.set(['account', 'orders', 'computed', 'componentsState', 'showDocumentsWillBeUploadedTooltip'], monkey(['account', 'orders', 'currentOrder', 'stateId'], ['user', 'role'], function () {
	            var stateId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
	            var role = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	            if (role === 'client' && (stateId === 2 || stateId === 3 || stateId === 4)) {
	                return true;
	            }
	            return false;
	        }));
	    },
	    computeNecessaryDocumentsAddDeleteButtonsState: function computeNecessaryDocumentsAddDeleteButtonsState(state) {
	        state.set(PATHS.showNecessaryDocumentsAddDeleteButtons, monkey(['user', 'role'], ['account', 'orders', 'currentOrder', 'stateId'], function () {
	            var role = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	            var stateId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
	
	            if (role === 'manager' && stateId !== 7 && stateId !== 1 && stateId !== 6) {
	                return true;
	            }
	
	            return false;
	        }));
	    },
	    computeBillDraftDownloadButtonsState: function computeBillDraftDownloadButtonsState(state) {
	        state.set(['account', 'orders', 'computed', 'componentsState', 'showBillDraftDownloadButton'], monkey(['user', 'role'], ['account', 'orders', 'currentOrder', 'stateId'], function () {
	            var role = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	            var stateId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
	
	            if (role === 'manager' && stateId == 2) {
	                return true;
	            }
	            return false;
	        }));
	    },
	    computeContinueButtonState: function computeContinueButtonState(state) {
	        state.set(['account', 'orders', 'computed', 'componentsState', 'showContinueButton'], monkey(['account', 'orders', 'currentOrder', 'isLicenseAgreementAccepted'], ['account', 'orders', 'currentOrder', 'stateId'], ['account', 'orders', 'currentOrder', 'paymentTypeId'], ['user', 'role'], ['account', 'orders', 'computed', 'componentsState', 'showSaveAllButton'], ['account', 'orders', 'currentOrder', 'typeId'], function () {
	            var isLicenseAgreementAccepted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	            var stateId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
	            var paymentTypeId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
	            var role = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	            var showSaveAllButton = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	            var typeId = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : -1;
	
	            if (typeId === 1) {
	                if (role === 'client') {
	                    if (stateId === 1) {
	                        return true;
	                    }
	
	                    if (stateId !== 6 && isLicenseAgreementAccepted === false) {
	                        return true;
	                    }
	                }
	                if (role === 'manager') {
	                    if (showSaveAllButton) {
	                        return false;
	                    }
	
	                    if (stateId === 7 || stateId === 2) {
	                        return true;
	                    }
	                }
	            }
	            if (typeId === 2) {
	                if (stateId === 1001) {
	                    return true;
	                }
	            }
	            if (typeId === 3) {
	                if (stateId === 2001) {
	                    return true;
	                }
	            }
	            if (typeId === 4) {
	                if (role === 'client') {
	                    if (stateId === 3001) {
	                        return true;
	                    }
	
	                    if (stateId !== 3006 && isLicenseAgreementAccepted === false) {
	                        return true;
	                    }
	                }
	                if (role === 'manager') {
	                    if (showSaveAllButton) {
	                        return false;
	                    }
	
	                    if (stateId === 3001) {
	                        return true;
	                    }
	                }
	            }
	
	            return false;
	        }));
	    },
	    computePayOnlineButtonState: function computePayOnlineButtonState(state) {
	        state.set(['account', 'orders', 'computed', 'componentsState', 'showPayOnlineButton'], monkey(['account', 'orders', 'currentOrder', 'stateId'], ['account', 'orders', 'currentOrder', 'paymentForm'], function () {
	            var stateId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
	            var paymentForm = arguments[1];
	            return !(stateId !== 3 || !paymentForm);
	        }));
	    },
	    computeContinueButtonLabel: function computeContinueButtonLabel(state) {
	        state.set(['account', 'orders', 'computed', 'componentsState', 'continueButtonLabel'], monkey(['account', 'orders', 'currentOrder', 'typeId'], function () {
	            var typeId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
	
	            if (typeId === 2 || typeId === 3) {
	                return 'Выгрузить';
	            }
	
	            return 'Продолжить';
	        }));
	    },
	    computeOrderParametersIsAvailable: function computeOrderParametersIsAvailable(state) {
	        state.set(PATHS.isShowOrderParameters, monkey(['account', 'orders', 'currentOrder', 'typeId'], function () {
	            var typeId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
	
	            if (typeId === 4) {
	                return false;
	            }
	
	            return true;
	        }));
	    },
	    computeIsShowIndividualOrderParameters: function computeIsShowIndividualOrderParameters(state) {
	        state.set(PATHS.isShowIndividualOrderParameters, monkey(['account', 'orders', 'currentOrder', 'typeId'], ['user', 'role'], function () {
	            var typeId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
	            var role = arguments[1];
	
	            if (typeId === 4 && role === 'manager') {
	                return true;
	            }
	
	            return false;
	        }));
	    },
	    computeIsShowResultUploadButton: function computeIsShowResultUploadButton(state) {
	        state.set(PATHS.isShowResultUploadButton, monkey(['account', 'orders', 'currentOrder', 'typeId'], ['account', 'orders', 'currentOrder', 'stateId'], ['user', 'role'], function () {
	            var typeId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
	            var stateId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
	            var role = arguments[2];
	            return typeId === 4 && stateId === 3001 && role === 'manager';
	        }));
	    },
	    computeIsCanDeleteResult: function computeIsCanDeleteResult(state) {
	        state.set(PATHS.isCanDeleteResult, monkey(['account', 'orders', 'currentOrder', 'typeId'], ['account', 'orders', 'currentOrder', 'stateId'], ['user', 'role'], function () {
	            var typeId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
	            var stateId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
	            var role = arguments[2];
	
	            if (typeId === 4 && stateId === 3001 && role === 'manager') {
	                return true;
	            }
	
	            return false;
	        }));
	    },
	    computeIsDisabledAmountField: function computeIsDisabledAmountField(state) {
	        state.set(PATHS.isDisabledAmountField, monkey(['account', 'orders', 'currentOrder', 'typeId'], ['account', 'orders', 'currentOrder', 'stateId'], ['user', 'role'], function () {
	            var typeId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
	            var stateId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
	            var role = arguments[2];
	
	            if (typeId === 4 && stateId === 3001 && role === 'manager') {
	                return false;
	            }
	
	            return true;
	        }));
	    },
	    computeMakeOrderButtonState: function computeMakeOrderButtonState(state) {
	        state.set(['account', 'orders', 'computed', 'componentsState', 'showMakeOrderButton'], monkey(['account', 'orders', 'currentOrder', 'stateId'], function () {
	            var stateId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
	
	            if (stateId === 1000) {
	                return true;
	            }
	
	            return false;
	        }));
	    },
	    computeArchiveButtonState: function computeArchiveButtonState(state) {
	        state.set(['account', 'orders', 'computed', 'componentsState', 'showArchiveButton'], monkey(['account', 'orders', 'currentOrder', 'stateId'], ['account', 'orders', 'currentOrder', 'typeId'], function () {
	            var stateId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
	            var typeId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
	
	            if (typeId === 1) {
	                if (stateId === 7 || stateId === 1 || stateId === 2 || stateId === 3) {
	                    return true;
	                }
	            }
	            if (typeId === 2) {
	                if (stateId !== 1003) {
	                    return true;
	                }
	            }
	            if (typeId === 3) {
	                if (stateId !== 2003) {
	                    return true;
	                }
	            }
	            if (typeId === 4) {
	                if (stateId === 3001 || stateId === 3002 || stateId === 3003) {
	                    return true;
	                }
	            }
	
	            return false;
	        }));
	    },
	    computeSaveAllButtonState: function computeSaveAllButtonState(state) {
	        state.set(['account', 'orders', 'computed', 'componentsState', 'showSaveAllButton'], monkey(['account', 'orders', 'currentOrder', 'stateId'], ['user', 'role'], ['account', 'orders', 'currentOrder', 'localChanges'], ['account', 'orders', 'currentOrder', 'typeId'], function (stateId, role, localChanges) {
	            var typeId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : -1;
	
	            if (localChanges && role && role === 'manager') {
	                if (stateId && stateId !== 6 && typeId !== 4) {
	                    return true;
	                }
	            }
	
	            return false;
	        }));
	    },
	    computeRepeatButtonLabel: function computeRepeatButtonLabel(state) {
	        state.set(['account', 'orders', 'computed', 'componentsState', 'showRepeatButton'], monkey(['account', 'orders', 'currentOrder', 'stateId'], function () {
	            var stateId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
	
	            if (stateId === 2 || stateId === 3 || stateId === 4 || stateId === 5 || stateId === 6) {
	                return true;
	            }
	            if (stateId === 1002 || stateId === 1003) {
	                return true;
	            }
	            if (stateId === 2002 || stateId === 2003) {
	                return true;
	            }
	
	            return false;
	        }));
	    },
	    computeBitrixExportButtonState: function computeBitrixExportButtonState(state) {
	        state.set(['account', 'orders', 'computed', 'componentsState', 'showBitrixExportButton'], monkey(['account', 'orders', 'currentOrder', 'stateId'], ['bitrix', 'isBitrix'], ['user', 'isManager'], ['account', 'orders', 'currentOrder', 'hasBitrixLeads'], function () {
	            var stateId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
	            var isBitrix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	            var isManager = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	            var hasBitrixLeads = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	            if (isBitrix === true && isManager === false && (stateId === 4 || stateId === 5) && hasBitrixLeads === true) {
	                return true;
	            }
	
	            return false;
	        }));
	    },
	    computeFreeBitrixExportButtonState: function computeFreeBitrixExportButtonState(state) {
	        state.set(['account', 'orders', 'computed', 'componentsState', 'showFreeBitrixExportButton'], monkey(['account', 'orders', 'currentOrder', 'stateId'], ['user', 'isFreeBitrixExportAllowed'], ['bitrix', 'isBitrix'], ['user', 'isManager'], function () {
	            var stateId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
	            var isFreeBitrixExportAllowed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	            var isBitrix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	            var isManager = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	            if (stateId === 3 && isFreeBitrixExportAllowed === true && isBitrix === true && isManager === false) {
	                return true;
	            }
	
	            return false;
	        }));
	    },
	    computeLicenseAgreementCheckboxState: function computeLicenseAgreementCheckboxState(state) {
	        state.set(['account', 'orders', 'computed', 'componentsState', 'showLicenseAgreementCheckbox'], monkey(['account', 'orders', 'currentOrder', 'isLicenseAgreementAccepted'], ['user', 'role'], ['account', 'orders', 'computed', 'componentsState', 'showContinueButton'], function () {
	            var isLicenseAgreementAccepted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	            var role = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	            var showContinueButton = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	            if (role === 'client' && isLicenseAgreementAccepted === false && showContinueButton) {
	                return true;
	            }
	
	            return false;
	        }));
	    },
	    computeSpecialInfo: function computeSpecialInfo(state) {
	        state.set(['account', 'orders', 'computed', 'componentsState', 'specialInfo'], monkey(['account', 'orders', 'currentOrder', 'stateId'], ['user', 'role'], function () {
	            var stateId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
	            var role = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	            if (role === 'client' && stateId === 2) {
	                return 'Наши менеджеры прикрепят счет на оплату в ближайшие рабочие сутки.';
	            }
	
	            if (role === 'client' && stateId === 3002) {
	                return 'Чтобы продолжить работу с заказом, примите условия оказания услуг ниже.';
	            }
	
	            return null;
	        }));
	    },
	    computeActionPanelState: function computeActionPanelState(state) {
	        state.set(['account', 'orders', 'computed', 'componentsState', 'showActionPanel'], monkey(['account', 'orders', 'computed', 'componentsState', 'showContinueButton'], ['account', 'orders', 'computed', 'componentsState', 'showArchiveButton'], ['account', 'orders', 'computed', 'componentsState', 'showSaveAllButton'], ['account', 'orders', 'computed', 'componentsState', 'showMakeOrderButton'], ['account', 'orders', 'computed', 'componentsState', 'showRepeatButton'], ['account', 'orders', 'computed', 'componentsState', 'showPayOnlineButton'], function () {
	            var showContinueButton = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	            var showArchiveButton = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	            var showSaveAllButton = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	            var showMakeOrderButton = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	            var showRepeatButton = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	            var showPayOnlineButton = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
	            return showContinueButton || showArchiveButton || showSaveAllButton || showMakeOrderButton || showRepeatButton || showPayOnlineButton;
	        }));
	    },
	    computeSumCanChangeTooltipState: function computeSumCanChangeTooltipState(state) {
	        state.set(PATHS.isShowSumCanChangeTooltip, monkey(['account', 'orders', 'currentOrder', 'stateId'], function () {
	            var stateId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
	
	            if (stateId === 7 || stateId === 1) {
	                return true;
	            }
	
	            return false;
	        }));
	    },
	    computeManagerState: function computeManagerState(state) {
	        state.set(['account', 'orders', 'computed', 'componentsState', 'showManager'], monkey(['user', 'role'], ['account', 'orders', 'computed', 'currentOrder', 'manager', 'fullName'], function () {
	            var role = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	            var managerName = arguments[1];
	            return role === 'user' && managerName || role === 'manager';
	        }));
	    },
	    computeUserState: function computeUserState(state) {
	        state.set(['account', 'orders', 'computed', 'componentsState', 'showUser'], monkey(['user', 'role'], ['account', 'orders', 'currentOrder', 'typeId'], function () {
	            var role = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	            var typeId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
	
	            if (typeId === 1 || typeId === 4) {
	                return role !== 'unauthorized';
	            }
	
	            return false;
	        }));
	    },
	    computeShowPaymentType: function computeShowPaymentType(state) {
	        state.set(['account', 'orders', 'computed', 'componentsState', 'showPaymentType'], monkey(['account', 'orders', 'currentOrder', 'typeId'], function () {
	            var typeId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
	            return typeId === 1;
	        }));
	    },
	    computeManagerSelectState: function computeManagerSelectState(state) {
	        state.set(['account', 'orders', 'computed', 'componentsState', 'showManagerSelect'], monkey(['account', 'orders', 'currentOrder', 'stateId'], ['user', 'role'], ['account', 'orders', 'currentOrder', 'typeId'], function () {
	            var stateId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
	            var role = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	            var typeId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
	
	            if (typeId === 1 && role == 'manager') {
	                if (stateId != 5 && stateId != 6) {
	                    return true;
	                }
	            }
	            if (typeId === 4 && role == 'manager') {
	                if (stateId != 3005 && stateId != 3006) {
	                    return true;
	                }
	            }
	
	            return false;
	        }));
	    },
	    computeUserSelectState: function computeUserSelectState(state) {
	        state.set(['account', 'orders', 'computed', 'componentsState', 'showUserSelect'], monkey(['account', 'orders', 'currentOrder', 'stateId'], ['user', 'role'], function () {
	            var stateId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
	            var role = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	            if (role == 'manager') {
	                if (stateId === 7 || stateId === 1 || stateId === 3001) {
	                    return true;
	                }
	            }
	
	            return false;
	        }));
	    },
	    computeDataChangeTooltipState: function computeDataChangeTooltipState(state) {
	        state.set(['account', 'orders', 'computed', 'componentsState', 'showDataChangeTooltip'], monkey(['account', 'orders', 'currentOrder', 'stateId'], ['account', 'orders', 'currentOrder', 'isNeedToConfirmDataChanged'], ['account', 'orders', 'currentOrder', 'tooltips', 'hideDataChangedMustBeConfirmed'], function () {
	            var stateId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
	            var needConfirmDataChanged = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	            var hideTooltip = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	            if (stateId === 7 || stateId === 1 || stateId === 2 || stateId === 1001 || stateId === 2001 || stateId === 3001 || stateId === 3002) {
	                if (needConfirmDataChanged && !hideTooltip) {
	                    return true;
	                }
	            }
	
	            return false;
	        }));
	    },
	    computeCanMoveOrderToNextState: function computeCanMoveOrderToNextState(state) {
	        state.set(['account', 'orders', 'computed', 'сanMoveOrderToNextState'], monkey(['account', 'orders', 'currentOrder', 'typeId'], currentOrderActions.PATHS.showPriceMustBeBiggerThanZero, ['account', 'orders', 'currentOrder', 'tooltips', 'showUserMustBeSelected'], ['account', 'orders', 'currentOrder', 'tooltips', 'showLicenseMustBeAccepted'], ['account', 'orders', 'currentOrder', 'tooltips', 'showChangesMustBeSavedOrCancelled'], currentOrderActions.PATHS.showBillDocumentMustBeAttached, currentOrderActions.PATHS.isExportResultMustBeAttached, function () {
	            var typeId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
	            var showPriceMustBeBiggerThanZero = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	            var showUserMustBeSelected = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	            var showLicenseMustBeAccepted = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	            var showChangesMustBeSavedOrCancelled = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	            var showBillDocumentMustBeAttached = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
	            var isExportResultMustBeAttached = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
	
	            if (showPriceMustBeBiggerThanZero || showUserMustBeSelected || showLicenseMustBeAccepted || showChangesMustBeSavedOrCancelled || isExportResultMustBeAttached || typeId === 4 && showBillDocumentMustBeAttached) {
	                return false;
	            }
	
	            return true;
	        }));
	    },
	    computePaymentTypeChangePanelState: function computePaymentTypeChangePanelState(state) {
	        state.set(['account', 'orders', 'computed', 'componentsState', 'showPaymentTypeChangePanel'], monkey(['account', 'orders', 'currentOrder', 'stateId'], function () {
	            var stateId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
	            return stateId === 1 || stateId === 7 || stateId === 1000 || stateId === 3001;
	        }));
	    },
	    computeIsOnlinePaymentDisabled: function computeIsOnlinePaymentDisabled(state) {
	        state.set(['account', 'orders', 'computed', 'componentsState', 'onlinePaymentDisabled'], monkey(['account', 'orders', 'currentOrder', 'price', 'total', 'totalPrice'], ['account', 'orders', 'computed', 'price', 'data', 'total', 'totalPrice'], function () {
	            var totalPrice = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
	            var computedTotalPrice = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
	
	            var bigPrice = 250000;
	            if (totalPrice > bigPrice || computedTotalPrice > bigPrice) {
	                return true;
	            }
	
	            return false;
	        }));
	    },
	    computeIsFilerValuesControlEnabled: function computeIsFilerValuesControlEnabled(state) {
	        state.set(['account', 'orders', 'computed', 'componentsState', 'isFilerValuesControlEnabled'], monkey(['account', 'orders', 'currentOrder', 'filterValuesChanged'], ['order', 'price', 'isLoading'], function (filterValuesChanged, priceIsLoading) {
	            if (filterValuesChanged && !priceIsLoading) {
	                return true;
	            }
	
	            return false;
	        }));
	    },
	    computeExportResultState: function computeExportResultState(state) {
	        state.set(['account', 'orders', 'computed', 'componentsState', 'showExportResult'], monkey(['account', 'orders', 'currentOrder', 'stateId'], ['user', 'role'], ['account', 'orders', 'currentOrder', 'exportResult'], ['account', 'orders', 'currentOrder', 'isLicenseAgreementAccepted'], ['account', 'orders', 'currentOrder', 'typeId'], function () {
	            var stateId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
	            var role = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	            var exportResult = arguments[2];
	            var isLicenseAgreementAccepted = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	            var typeId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : -1;
	
	            if (typeId === 1) {
	                if (role === 'client' && !isLicenseAgreementAccepted) {
	                    return false;
	                }
	                if (stateId === 4 || stateId === 5) {
	                    return true;
	                }
	                if (role === 'manager' && stateId === 3) {
	                    return true;
	                }
	
	                if (stateId === 6 && exportResult && exportResult.length > 0) {
	                    return true;
	                }
	            }
	            if (typeId === 2 && stateId === 1002) {
	                return true;
	            }
	            if (typeId === 3 && stateId === 2002) {
	                return true;
	            }
	            if (typeId === 4) {
	                if (role === 'client' && !isLicenseAgreementAccepted) {
	                    return false;
	                }
	                if (stateId === 3004 || stateId === 3005) {
	                    return true;
	                }
	                if (role === 'manager' && (stateId === 3001 || stateId === 3002 || stateId === 3003)) {
	                    return true;
	                }
	
	                if (stateId === 3006 && exportResult && exportResult.length > 0) {
	                    return true;
	                }
	            }
	
	            return false;
	        }));
	    },
	    setManagerSelect: function setManagerSelect(state) {
	        state.set(['account', 'orders', 'computed', 'selectedManager'], monkey(['account', 'orders', 'managers'], ['account', 'orders', 'currentOrder', 'manager', 'id'], ['account', 'orders', 'currentOrder', 'localChanges', 'selectedManager', 'id'], ['account', 'orders', 'ui', 'selectedManager', 'isDisabled'], function () {
	            var managers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	            var managerId = arguments[1];
	            var selectedManagerId = arguments[2];
	            var isDisabled = arguments[3];
	
	            var selectedId = selectedManagerId || managerId;
	            var header = selectedId ? null : 'Выберите менеджера';
	
	            var options = _.map(managers, function (manager) {
	                return {
	                    isActive: selectedId == manager.id,
	                    title: formatOptionTitle(manager),
	                    value: manager.id
	                };
	            });
	
	            return { options: options, isDisabled: isDisabled, header: header };
	        }));
	    },
	    setUserSelect: function setUserSelect(state) {
	        state.set(['account', 'orders', 'computed', 'selectedUser'], monkey(['account', 'orders', 'users'], ['account', 'orders', 'currentOrder', 'user', 'id'], ['account', 'orders', 'currentOrder', 'localChanges', 'selectedUser', 'id'], ['account', 'orders', 'ui', 'selectedUser', 'isDisabled'], function () {
	            var users = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	            var userId = arguments[1];
	            var selectedUserId = arguments[2];
	            var isDisabled = arguments[3];
	
	            var selectedId = selectedUserId || userId;
	            var header = null;
	            var isUserSelected = true;
	
	            var options = _.map(users, function (user) {
	                return {
	                    isActive: selectedId == user.id,
	                    title: formatOptionTitle(user),
	                    value: user.id
	                };
	            });
	
	            if (_.every(options, ['isActive', false])) {
	                header = 'Выберите пользователя';
	                isUserSelected = false;
	            }
	
	            return { options: options, isDisabled: isDisabled, header: header, isUserSelected: isUserSelected };
	        }));
	    },
	    setOrderPrice: function setOrderPrice(state) {
	        state.set(['account', 'orders', 'computed', 'price'], monkey(['account', 'orders', 'currentOrder', 'filterValuesChanged'], ['account', 'orders', 'currentOrder', 'price'], ['order', 'price', 'data'], ['order', 'price', 'isLoading'], function (filterValuesChanged, currentOrderPrice, calculatedPrice, isLoadingPrice) {
	            var data = !filterValuesChanged ? currentOrderPrice : calculatedPrice;
	
	            return { data: data, isLoading: isLoadingPrice };
	        }));
	    },
	    setPaymentType: function setPaymentType(state) {
	        state.set(['account', 'orders', 'computed', 'paymentType'], monkey(['account', 'orders', 'currentOrder', 'paymentTypeId'], ['account', 'orders', 'currentOrder', 'localChanges', 'selectedPaymentTypeId'], function (paymentTypeId, selectedPaymentTypeId) {
	            var selectedId = selectedPaymentTypeId || paymentTypeId;
	            var paymentMap = {
	                1: 'invoice',
	                2: 'online'
	            };
	
	            var selectType = paymentMap[selectedId];
	
	            var defaultState = {
	                invoice: false,
	                online: false
	            };
	
	            defaultState[selectType] = true;
	
	            return defaultState;
	        }));
	    },
	    setUsersListFilter: function setUsersListFilter(state) {
	        state.set(PATHS.usersListFilter, '');
	    },
	    createUserButtonIsEnabled: function createUserButtonIsEnabled(state) {
	        state.set(['account', 'orders', 'computed', 'createUserIsEnabled'], monkey(['account', 'orders', 'createUser', 'error'], ['account', 'orders', 'createUser', 'input', 'email'], function (error, email) {
	            return _.isEmpty(error) && email && email.length;
	        }));
	    },
	    computeIsNeedToGetExportResults: function computeIsNeedToGetExportResults(state) {
	        state.set(['account', 'orders', 'computed', 'componentsState', 'getExportResults'], monkey(['account', 'orders', 'currentOrder', 'stateId'], ['user', 'role'], ['account', 'orders', 'currentOrder', 'exportResult'], function () {
	            var stateId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
	            var role = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	            var exportResult = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	            if (Object.keys(exportResult).length > 0) {
	                return false;
	            }
	
	            if (stateId === 4 || stateId === 5 || stateId === 1002 || stateId === 2002 || stateId === 3004 || stateId === 3005) {
	                return true;
	            }
	
	            if (role === 'manager' && (stateId === 3 || stateId === 3003)) {
	                return true;
	            }
	
	            return false;
	        }));
	    },
	    computeOrderStatisticState: function computeOrderStatisticState(state) {
	        state.set(['account', 'orders', 'computed', 'componentsState', 'showOrderStatistic'], monkey(['account', 'orders', 'currentOrder', 'typeId'], ['account', 'orders', 'currentOrder', 'price', 'total', 'totalPrice'], function () {
	            var typeId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
	            var totalPrice = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
	
	            if (totalPrice <= 0) {
	                return false;
	            }
	
	            if (typeId === 2) {
	                return true;
	            }
	
	            return false;
	        }));
	    },
	    computeOrderStatisticIsLoadingState: function computeOrderStatisticIsLoadingState(state) {
	        state.set(['account', 'orders', 'computed', 'componentsState', 'isStatisticLoading'], monkey(['order', 'originalParameters', 'statistic'], function () {
	            var statistic = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            if (Object.keys(statistic).length > 0) {
	                return false;
	            }
	
	            return true;
	        }));
	    },
	    computeIsDisabled: function computeIsDisabled(state) {
	        state.set(['order', 'isDisabled'], monkey(['account', 'orders', 'computed', 'currentOrder', 'isEditable'], function () {
	            var isEditable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	            return !isEditable;
	        }));
	    },
	    computeDatepickerIsDisabled: function computeDatepickerIsDisabled(state) {
	        state.set(['order', 'addParams', 'datepicker', 'ui', 'isDisabled'], monkey(['order', 'isDisabled'], function () {
	            var isDisabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	            return isDisabled;
	        }));
	    },
	    computeDatepicker2IsDisabled: function computeDatepicker2IsDisabled(state) {
	        state.set(['order', 'addParams', 'datepicker2', 'ui', 'isDisabled'], monkey(['order', 'isDisabled'], function () {
	            var isDisabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	            return isDisabled;
	        }));
	    }
	};
	
	function formatOptionTitle(user) {
	    return formatter.shortName(user) + ' (' + user.email + ')';
	}

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var order = __webpack_require__(75);
	var account = __webpack_require__(63);
	var orders = __webpack_require__(41);
	var documents = __webpack_require__(288);
	var error = __webpack_require__(19);
	var content = __webpack_require__(20);
	var utils = __webpack_require__(5);
	var user = __webpack_require__(28);
	var currentOrderGroups = __webpack_require__(118);
	var customOrderGroups = __webpack_require__(74);
	
	var _require = __webpack_require__(74),
	    restoreStateGroup = _require.restoreStateGroup;
	
	var customOrder = __webpack_require__(42);
	var analytics = __webpack_require__(7);
	
	var _require2 = __webpack_require__(160),
	    raiseEventsOnOrderLoaded = _require2.raiseEventsOnOrderLoaded;
	
	var _require3 = __webpack_require__(224),
	    saveFilterValues = _require3.saveFilterValues;
	
	var currentOrder = __webpack_require__(23);
	
	var _require4 = __webpack_require__(63),
	    updateOrderData = _require4.updateOrderData;
	
	var form = __webpack_require__(205);
	var ordersComputedActions = __webpack_require__(61);
	var currentOrderActions = __webpack_require__(23);
	
	var moveOrderToNextState = [[orders.ifAcceptLicenseAgreement, {
	    yes: [[orders.acceptLicenseAgreement, {
	        success: [orders.setIsLicenseAgreementAccepted],
	        error: [error.internalError('orders.acceptLicenseAgreement')]
	    }]],
	    no: []
	}], [orders.ifAcceptDataChanged, {
	    yes: [[orders.confirmDataChanged, {
	        success: [orders.setDataChangedConfirmed],
	        error: [error.internalError('orders.confirmDataChanged')]
	    }]],
	    no: []
	}], [orders.moveOrderToNextState, {
	    success: [currentOrder.updateOrder(['stateId', 'exportResult', 'necessaryDocuments', 'paymentForm', 'price']), currentOrder.filterOptionalExportColumnsOnOrderDisable].concat(raiseEventsOnOrderLoaded, [orders.ifOrderDataChanged, {
	        yes: [orders.setIsNeedToConfirmDataVersionChange].concat(customOrderGroups.setOrderParametersGroup, [customOrder.setComputedFields], restoreStateGroup, [utils.unset(['account', 'orders', 'currentOrder', 'tooltips', 'hideDataChangedMustBeConfirmed'])]),
	        no: []
	    }]),
	    error: [error.internalError('orders.moveOrderToNextState')],
	    temporarilyUnavailable: [utils.set(['account', 'orders', 'disableContinue'], true)]
	}]];
	
	var applyLocalChanges = [content.setIsLoading(true), [orders.isFilterValuesChanged, {
	    true: [].concat(saveFilterValues, [utils.unset(['account', 'orders', 'currentOrder', 'localChanges', 'filterValuesChanged'])]),
	    false: []
	}], [orders.isPaymentTypeChanged, {
	    true: [[orders.setPaymentType, {
	        success: [utils.unset(['account', 'orders', 'currentOrder', 'localChanges', 'selectedPaymentTypeId'])],
	        error: [error.internalError('orders.setPaymentType')]
	    }]],
	    false: []
	}], [documents.applyLocalChangesAddOrRemoveDocTypes, {
	    success: [utils.unset(['account', 'orders', 'currentOrder', 'localChanges', 'necessaryDocuments', 'addOrRemove'])],
	    error: []
	}], [documents.applyLocalChangesDeleteDocs, {
	    success: [utils.unset(['account', 'orders', 'currentOrder', 'localChanges', 'necessaryDocuments', 'delete'])],
	    error: [error.internalError('documents.applyLocalChangesDeleteDocs')]
	}], [documents.applyLocalChangesUploadDocs, {
	    success: [utils.unset(['account', 'orders', 'currentOrder', 'localChanges', 'necessaryDocuments', 'upload']), utils.unset(currentOrderActions.PATHS.showUploadFailTooltip), utils.unset(currentOrderActions.PATHS.showBillDocumentMustBeAttached)],
	    errorTooBigFile: [utils.set(currentOrderActions.PATHS.showUploadFailTooltip, true)],
	    error: [error.internalError('documents.applyLocalChangesUploadDocs')]
	}], [user.isUserChanged, {
	    true: [].concat(currentOrderGroups.setUserGroup, [utils.unset(['account', 'orders', 'currentOrder', 'localChanges', 'selectedUser'])]),
	    false: []
	}], [orders.isManagerChanged, {
	    true: [[orders.setManager, {
	        success: [utils.unset(['account', 'orders', 'currentOrder', 'localChanges', 'selectedManager'])],
	        error: [error.internalError('orders.setManager')]
	    }]],
	    false: []
	}], [customOrder.isFilterValuesChanged, {
	    yes: [utils.set(['account', 'orders', 'currentOrder', 'tooltips', 'showChangesMustBeSavedOrCancelled'], true), utils.scrollTop],
	    no: [orders.orderIdToArgs].concat(account.getOrder, [orders.unsetLocalChangesIfEmpty])
	}], content.setIsLoading(false)];
	
	module.exports = {
	    wrapperOnLoad: [[user.isUnauthorized, {
	        yes: [orders.restoreLocalChanges, orders.restoreAccountOrderState].concat(order.onLoad),
	        no: []
	    }]],
	    archiveOrder: [analytics.argsValueEvent({ category: 'button_remove_order', action: 'click' }), [orders.archiveOrder, {
	        success: [currentOrder.updateOrder(['stateId'])].concat(raiseEventsOnOrderLoaded),
	        error: [error.internalError('orders.archiveOrder')]
	    }]],
	    tryMoveOrderToNextState: [utils.set(['account', 'orders', 'currentOrder', 'isLoading'], true), [orders.ifLicenseMustBeAccepted, {
	        yes: [utils.set(['account', 'orders', 'currentOrder', 'tooltips', 'showLicenseMustBeAccepted'], true)],
	        no: []
	    }], [orders.ifUserMustBeSelected, {
	        yes: [utils.set(['account', 'orders', 'currentOrder', 'tooltips', 'showUserMustBeSelected'], true)],
	        no: []
	    }], [customOrder.isFilterValuesChanged, {
	        yes: [utils.set(['account', 'orders', 'currentOrder', 'tooltips', 'showChangesMustBeSavedOrCancelled'], true)],
	        no: []
	    }], [orders.ifPriceMustBeBiggerThenZero, {
	        yes: [utils.set(currentOrderActions.PATHS.showPriceMustBeBiggerThanZero, true)],
	        no: []
	    }], [orders.ifBillMustBeAttached, {
	        yes: [utils.set(currentOrderActions.PATHS.showBillDocumentMustBeAttached, true)],
	        no: []
	    }], [orders.ifExportResultMustBeAttached, {
	        yes: [utils.set(currentOrderActions.PATHS.isExportResultMustBeAttached, true)],
	        no: []
	    }], [orders.ifCanMoverOrderToNextState, {
	        yes: [].concat(moveOrderToNextState),
	        no: []
	    }], [orders.ifNeedToScrollTop, {
	        yes: [utils.scrollTop],
	        no: []
	    }], utils.set(['account', 'orders', 'currentOrder', 'isLoading'], false), [orders.ifContinueDisabled, {
	        yes: [[currentOrder.waitBackendStandardState, {
	            success: [utils.unset(['account', 'orders', 'disableContinue'])],
	            error: []
	        }]],
	        no: []
	    }]],
	
	    payOnline: [analytics.argsValueEvent({ category: 'button_pay_order_page_money_hold', action: 'click' }), content.setIsLoading(true), [orders.payOnline, {
	        success: [orders.setOrderPaymentForm],
	        error: [error.internalError('orders.payOnline')]
	    }], content.setIsLoading(false)],
	
	    uploadDocument: [[utils.isLocalEditMode, {
	        true: [documents.uploadDocumentLocal],
	        false: [[documents.uploadDocument, {
	            success: [documents.updateDocumentsInState, utils.unset(currentOrderActions.PATHS.showUploadFailTooltip), utils.unset(currentOrderActions.PATHS.showBillDocumentMustBeAttached)],
	            errorTooBigFile: [utils.set(currentOrderActions.PATHS.showUploadFailTooltip, true)],
	            error: [error.internalError('documents.uploadDocument')]
	        }]]
	    }]],
	    setDocumentType: [[documents.isCheckboxChecked, {
	        yes: [[utils.isLocalEditMode, {
	            true: [documents.addDocumentTypeLocal],
	            false: [[documents.addDocumentType, {
	                success: [],
	                error: [error.internalError('documents.addDocumentType')]
	            }]]
	        }]],
	        no: [[utils.isLocalEditMode, {
	            true: [documents.addDocumentTypeLocal],
	            false: [[documents.removeDocumentType, {
	                success: [],
	                error: [error.internalError('documents.removeDocumentType')]
	            }]]
	        }]]
	    }], [utils.isLocalEditMode, {
	        true: [[utils.isSaveLocalChanges, {
	            yes: [orders.saveLocalChanges],
	            no: []
	        }]],
	        false: []
	    }]],
	    applyLocalChanges: applyLocalChanges,
	
	    uploadResultDocument: [utils.set(ordersComputedActions.PATHS.isLoadingUploadResultDocument, true), utils.unset(currentOrderActions.PATHS.isShowUploadResultFailTooltip), [documents.uploadResultDocument, {
	        success: [].concat(applyLocalChanges, [utils.unset(currentOrderActions.PATHS.isShowUploadResultFailTooltip)]),
	        errorTooBigFile: [utils.set(currentOrderActions.PATHS.isShowUploadResultFailTooltip, true)],
	        error: [error.internalError('documents.uploadDocument')]
	    }], utils.set(ordersComputedActions.PATHS.isLoadingUploadResultDocument, false)],
	
	    licenseAccepted: [orders.setOrderUpdateProperty, utils.set(['account', 'orders', 'currentOrder', 'tooltips', 'showLicenseMustBeAccepted'], false)],
	    deleteDocument: [[utils.isLocalEditMode, {
	        true: [documents.deleteDocumentLocal],
	        false: [[documents.deleteDocument, {
	            success: [documents.deleteDocumentFromState],
	            error: [error.internalError('documents.deleteDocument')]
	        }]]
	    }]],
	    deleteResultDocument: [[documents.deleteDocument, {
	        success: [].concat(applyLocalChanges),
	        error: [error.internalError('documents.deleteDocument')]
	    }]],
	    downloadFile: [[orders.isDownloadingExportResult, {
	        yes: [analytics.argsValueEvent({ category: 'start_downloading_fetching', action: 'see' })]
	    }, orders.downloadFile, {
	        exportResultDownloaded: [analytics.argsValueEvent({ category: 'finish_downloading_fetching', action: 'see' })],
	        error: [error.internalError('orders.downloadFile')]
	    }]],
	
	    downloadAll: [utils.toggleElementById('export-result-download-all-button'), [orders.downloadAll, {
	        success: [],
	        error: [error.internalError('orders.downloadAll')]
	    }], utils.toggleElementById('export-result-download-all-button'), utils.setElementVisibilityById('download-all-progress-bar', 'hidden')],
	
	    downloadDraftFile: [orders.downloadDraftFile, {
	        ok: [],
	        error: [error.internalError('orders.downloadDraftFile')]
	    }],
	
	    selectUser: [orders.selectUser, [utils.isLocalEditMode, {
	        true: [utils.set(['account', 'orders', 'currentOrder', 'tooltips', 'showUserMustBeSelected'], false)],
	        false: [].concat(currentOrderGroups.setUserGroup)
	    }]],
	
	    selectManager: [orders.selectManager, [utils.isLocalEditMode, {
	        true: [],
	        false: [[orders.setManager, {
	            success: [],
	            error: []
	        }]]
	    }]],
	
	    selectOrderType: [orders.selectOrderType],
	
	    selectPaymentType: [[utils.isLocalEditMode, {
	        true: [orders.selectPaymentType, orders.setPaymentTypeId, [utils.isSaveLocalChanges, {
	            yes: [orders.saveLocalChanges],
	            no: []
	        }]],
	        false: [orders.selectPaymentType, [orders.setPaymentType, {
	            success: [currentOrder.updateOrder(['paymentTypeId', 'necessaryDocuments']), utils.unset(['account', 'orders', 'currentOrder', 'localChanges', 'selectedPaymentTypeId'])],
	            error: []
	        }]]
	    }]],
	    setPaymentType: [[orders.isPaymentTypeChanged, {
	        true: [[orders.setPaymentType, {
	            success: [currentOrder.updateOrder(['paymentTypeId', 'necessaryDocuments']), utils.unset(['account', 'orders', 'currentOrder', 'localChanges', 'selectedPaymentTypeId'])],
	            error: []
	        }]],
	        false: []
	    }]],
	    togglePopup: [utils.togglePopupFromArgs],
	    repeatOrder: [content.setIsLoading(true), [orders.repeatOrder, {
	        success: [].concat(updateOrderData, [currentOrder.addCurrentOrderToList]),
	        error: [error.internalError('orders.repeatOrder')]
	    }], content.setIsLoading(false), utils.setArg('category', 'button_repeat_order'), utils.setArg('action', 'click'), analytics.raiseArgsValueEvent],
	
	    nameInputText: [form.inputText, [orders.debouncedSetName, {
	        success: [currentOrder.updateOrder(['name'])],
	        error: [error.internalError('orders.debouncedSetName')]
	    }]],
	
	    amountInputText: [form.inputText, form.validateText, utils.set(currentOrderActions.PATHS.showPriceMustBeBiggerThanZero, false), [orders.debouncedUpdateOrderAmount, {
	        success: [],
	        error: [error.internalError('orders.debouncedUpdateOrderAmount')]
	    }]],
	
	    amountInputBlur: [form.trimText, form.validateText],
	
	    nameBlurText: []
	};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var user = __webpack_require__(28);
	var orders = __webpack_require__(41);
	var ordersList = __webpack_require__(109);
	var utils = __webpack_require__(5);
	var currentOrderGroups = __webpack_require__(118);
	var customOrderGroups = __webpack_require__(74);
	var customOrder = __webpack_require__(42);
	var accountOrder = __webpack_require__(23);
	var error = __webpack_require__(19);
	var content = __webpack_require__(20);
	
	var _require = __webpack_require__(160),
	    raiseEventsOnOrderLoaded = _require.raiseEventsOnOrderLoaded;
	
	var _require2 = __webpack_require__(11),
	    usingLock = _require2.usingLock;
	
	var getExportResults = [[accountOrder.isNeedToGetExportResults, {
	    yes: [].concat(usingLock(['account', 'orders', 'currentOrder', 'exportResultsLock'], [[accountOrder.getExportResults, {
	        success: [accountOrder.updateOrder(['exportResult', 'hasBitrixLeads'])],
	        orderChanged: [],
	        locked: [],
	        error: [error.internalError('accountOrder.getExportResults')]
	    }]])),
	    no: []
	}]];
	
	var getOrderGroup = [[orders.getOrder, {
	    success: [orders.setCurrentOrder, orders.resetUserSelect, orders.resetManagerSelect, orders.resetAddParams, orders.setOrderAmount, utils.unset(['order', 'cities', 'tab']), utils.setPopupVisibility('datepicker', ['order', 'popups', 'datepicker', 'isOpen']), utils.setPopupVisibility('datepicker2', ['order', 'popups', 'datepicker2', 'isOpen']), customOrder.setShouldPersistToLocalStorage(false)].concat(customOrderGroups.setOrderParametersGroup, [customOrder.setComputedFields], currentOrderGroups.initSelectedParamsFromOrderGroup),
	    notFound: [error.notFound('orders.getOrder')],
	    error: [error.internalError('orders.getOrder')]
	}]];
	
	module.exports = {
	    getExportResults: getExportResults,
	
	    getOrderState: [].concat(usingLock(['account', 'orders', 'getStateLock'], [[accountOrder.getOrderState, {
	        success: [accountOrder.updateOrder(['stateId'])].concat(getExportResults),
	        dontNeed: [],
	        error: [error.internalError('accountOrder.getOrderState')]
	    }]])),
	
	    getHasBitrixLeads: [].concat(usingLock(['account', 'orders', 'getHasBitrixLeads'], [[accountOrder.getHasBitrixLeads, {
	        success: [accountOrder.updateOrder(['hasBitrixLeads'])],
	        dontNeed: [],
	        error: [error.internalError('accountOrder.getHasBitrixLeads')]
	    }]])),
	
	    getOrder: [].concat(getOrderGroup),
	
	    selectOrder: [content.setIsLoading(true), utils.queryOrderRedirect(['account', 'orders', 'computed', 'query'])].concat(getOrderGroup, [content.setIsLoading(false)], raiseEventsOnOrderLoaded),
	
	    setLocalOrderData: [utils.set(['account', 'orders', 'list', 'isAllLoaded'], true), orders.initAccountState].concat(customOrderGroups.getAvailableParametersGroup, [customOrder.setComputedFields, [accountOrder.getDocumentTypes, {
	        success: [accountOrder.updateOrder(['necessaryDocuments'])],
	        error: [error.internalError('accountOrder.getDocumentTypes')]
	    }], utils.set(['account', 'orders', 'list', 'initialized'], true)]),
	
	    updateOrderData: [[user.isUnauthorized, {
	        no: [[ordersList.getOrdersList, {
	            success: [ordersList.addOrders, [ordersList.isAnyOrders, {
	                yes: [ordersList.setOrderIdArgsIfNotSet].concat(getOrderGroup, [utils.queryOrderRedirect(['account', 'orders', 'computed', 'query'])]),
	                no: []
	            }]],
	            notFound: [],
	            error: [error.internalError('ordersList.getOrdersList'), utils.set(['account', 'orders', 'list', 'isError'], true)]
	        }]],
	        yes: [utils.set(['account', 'orders', 'list', 'isAllLoaded'], true), orders.initAccountState].concat(customOrderGroups.getAvailableParametersGroup, [customOrder.setComputedFields, [accountOrder.getDocumentTypes, {
	            success: [accountOrder.updateOrder(['necessaryDocuments'])],
	            error: [error.internalError('accountOrder.getDocumentTypes')]
	        }]])
	    }], utils.set(['account', 'orders', 'list', 'initialized'], true)],
	
	    getManagersList: [[orders.getManagers, {
	        success: [utils.setFromArgsToState('managers', ['account', 'orders', 'managers'])],
	        error: []
	    }]],
	
	    getUsersList: [[orders.getUsers, {
	        success: [utils.setFromArgsToState('users', ['account', 'orders', 'users'])],
	        error: []
	    }]]
	};

/***/ }),
/* 64 */
/***/ (function(module, exports) {

	(function(window, $, undefined) {
	  'use strict';
	
	  if (!window) return; // Server side
	
	  var
	    _baron = baron, // Stored baron value for noConflict usage
	    pos = ['left', 'top', 'right', 'bottom', 'width', 'height'],
	    origin = {
	      v: { // Vertical
	        x: 'Y', pos: pos[1], oppos: pos[3], crossPos: pos[0], crossOpPos: pos[2], size: pos[5], crossSize: pos[4],
	        client: 'clientHeight', crossClient: 'clientWidth', crossScroll: 'scrollWidth', offset: 'offsetHeight', crossOffset: 'offsetWidth', offsetPos: 'offsetTop',
	        scroll: 'scrollTop', scrollSize: 'scrollHeight'
	      },
	      h: { // Horizontal
	        x: 'X', pos: pos[0], oppos: pos[2], crossPos: pos[1], crossOpPos: pos[3], size: pos[4], crossSize: pos[5],
	        client: 'clientWidth', crossClient: 'clientHeight', crossScroll: 'scrollHeight', offset: 'offsetWidth', crossOffset: 'offsetHeight', offsetPos: 'offsetLeft',
	        scroll: 'scrollLeft', scrollSize: 'scrollWidth'
	      }
	    },
	
	    each = function(obj, iterator) {
	      var i = 0;
	
	      if (obj.length === undefined || obj === window) obj = [obj];
	
	      while (obj[i]) {
	        iterator.call(this, obj[i], i);
	        i++;
	      }
	    },
	
	    baron = function(params) {
	      var jQueryMode,
	          roots,
	          $;
	
	      params = params || {};
	      $ = params.$ || $ || window.jQuery;
	      jQueryMode = this instanceof $;  // this - window or jQuery instance
	
	      if (jQueryMode) {
	        params.root = roots = this;
	      } else {
	        roots = $(params.root || params.scroller);
	      }
	
	      var instance = new baron.fn.constructor(roots, params, $);
	
	      if (instance.autoUpdate) {
	        instance.autoUpdate();
	      }
	
	      return instance;
	    };
	
	  // shortcut for getTime
	  function getTime() {
	    return new Date().getTime();
	  }
	
	  baron.fn = {
	    constructor: function(roots, input, $) {
	      var params = validate(input);
	
	      params.$ = $;
	      each.call(this, roots, function(root, i) {
	        var localParams = clone(params);
	
	        if (params.root && params.scroller) {
	          localParams.scroller = params.$(params.scroller, root);
	          if (!localParams.scroller.length) {
	            localParams.scroller = root;
	          }
	        } else {
	          localParams.scroller = root;
	        }
	
	        localParams.root = root;
	        this[i] = init(localParams);
	        this.length = i + 1;
	      });
	
	      this.params = params;
	    },
	
	    dispose: function() {
	      var params = this.params;
	
	      if (this[0]) { /* Если есть хотя бы 1 рабочий инстанс */
	        each(this, function(item) {
	          item.dispose(params);
	        });
	      }
	      this.params = null;
	    },
	
	    update: function() {
	      var i = 0;
	
	      while (this[i]) {
	        this[i].update.apply(this[i], arguments);
	        i++;
	      }
	    },
	
	    baron: function(params) {
	      params.root = [];
	      params.scroller = this.params.scroller;
	
	      each.call(this, this, function(elem) {
	        params.root.push(elem.root);
	      });
	      params.direction = (this.params.direction == 'v') ? 'h' : 'v';
	      params._chain = true;
	
	      return baron(params);
	    }
	  };
	
	  function manageEvents(item, eventManager, mode) {
	    item._eventHandlers = item._eventHandlers || [ // Creating new functions for one baron item only one time
	        {
	          // onScroll:
	          element: item.scroller,
	
	          handler: function(e) {
	            item.scroll(e);
	          },
	
	          type: 'scroll'
	        }, {
	          // css transitions & animations
	          element: item.root,
	
	          handler: function() {
	            item.update();
	          },
	
	          type: 'transitionend animationend'
	        }, {
	          // onKeyup (textarea):
	          element: item.scroller,
	
	          handler: function() {
	            item.update();
	          },
	
	          type: 'keyup'
	        }, {
	          // onMouseDown:
	          element: item.bar,
	
	          handler: function(e) {
	            e.preventDefault(); // Text selection disabling in Opera... and all other browsers?
	            item.selection(); // Disable text selection in ie8
	            item.drag.now = 1; // Save private byte
	          },
	
	          type: 'touchstart mousedown'
	        }, {
	          // onMouseUp:
	          element: document,
	
	          handler: function() {
	            item.selection(1); // Enable text selection
	            item.drag.now = 0;
	          },
	
	          type: 'mouseup blur touchend'
	        }, {
	          // onBodyClick:
	          element: document.body,
	
	          handler: function(e) {
	            if (item.drag.fix && !item.drag.now) {
	              e.stopImmediatePropagation();
	            }
	          },
	
	          type: 'click'
	        }, {
	          // onCoordinateReset:
	          element: document.body,
	
	          handler: function(e) {
	            if (e.button != 2) { // Not RM
	              item._pos0(e);
	            }
	            item.drag.fix = item.drag.now;
	          },
	
	          type: 'touchstart mousedown'
	        }, {
	          // onMouseMove:
	          element: document,
	
	          handler: function(e) {
	            if (item.drag.now) {
	              item.drag(e);
	            }
	          },
	
	          type: 'mousemove touchmove'
	        }, {
	          // onResize:
	          element: window,
	
	          handler: function() {
	            item.update();
	          },
	
	          type: 'resize'
	        }, {
	          // sizeChange:
	          element: item.root,
	
	          handler: function() {
	            item.update();
	          },
	
	          type: 'sizeChange'
	        }
	      ];
	
	    each(item._eventHandlers, function(event) {
	      if (event.element) {
	        eventManager(event.element, event.type, event.handler, mode);
	      }
	    });
	
	    // if (item.scroller) {
	    //     event(item.scroller, 'scroll', item._eventHandlers.onScroll, mode);
	    // }
	    // if (item.bar) {
	    //     event(item.bar, 'touchstart mousedown', item._eventHandlers.onMouseDown, mode);
	    // }
	    // event(document, 'mouseup blur touchend', item._eventHandlers.onMouseUp, mode);
	    // event(document, 'touchstart mousedown', item._eventHandlers.onCoordinateReset, mode);
	    // event(document, 'mousemove touchmove', item._eventHandlers.onMouseMove, mode);
	    // event(window, 'resize', item._eventHandlers.onResize, mode);
	    // if (item.root) {
	    //     event(item.root, 'sizeChange', item._eventHandlers.onResize, mode); // Custon event for alternate baron update mechanism
	    // }
	  }
	
	  function manageAttr(node, direction, mode) {
	    var attrName = 'data-baron-' + direction;
	
	    if (mode == 'on') {
	      node.setAttribute(attrName, 'inited');
	    } else if (mode == 'off') {
	      node.removeAttribute(attrName);
	    } else {
	      return node.getAttribute(attrName);
	    }
	  }
	
	  function init(params) {
	    if (manageAttr(params.root, params.direction)) throw new Error('Second baron initialization');
	
	    var out = new item.prototype.constructor(params); // __proto__ of returning object is baron.prototype
	
	    manageEvents(out, params.event, 'on');
	
	    manageAttr(out.root, params.direction, 'on');
	
	    out.update();
	
	    return out;
	  }
	
	  function clone(input) {
	    var output = {};
	
	    input = input || {};
	
	    for (var key in input) {
	      if (input.hasOwnProperty(key)) {
	        output[key] = input[key];
	      }
	    }
	
	    return output;
	  }
	
	  function validate(input) {
	    var output = clone(input);
	
	    output.direction = output.direction || 'v';
	
	    var event = input.event || function(elem, event, func, mode) {
	        output.$(elem)[mode || 'on'](event, func);
	      };
	
	    output.event = function(elems, e, func, mode) {
	      each(elems, function(elem) {
	        event(elem, e, func, mode);
	      });
	    };
	
	    return output;
	  }
	
	  function fire(eventName) {
	    /* jshint validthis:true */
	    if (this.events && this.events[eventName]) {
	      for (var i = 0 ; i < this.events[eventName].length ; i++) {
	        var args = Array.prototype.slice.call( arguments, 1 );
	
	        this.events[eventName][i].apply(this, args);
	      }
	    }
	  }
	
	  var item = {};
	
	  item.prototype = {
	    // underscore.js realization
	    _debounce: function(func, wait) {
	      var self = this,
	        timeout,
	      // args, // right now there is no need for arguments
	      // context, // and for context
	        timestamp;
	      // result; // and for result
	
	      var later = function() {
	        if (self._disposed) {
	          clearTimeout(timeout);
	          timeout = self = null;
	          return;
	        }
	
	        var last = getTime() - timestamp;
	
	        if (last < wait && last >= 0) {
	          timeout = setTimeout(later, wait - last);
	        } else {
	          timeout = null;
	          // result = func.apply(context, args);
	          func();
	          // context = args = null;
	        }
	      };
	
	      return function() {
	        // context = this;
	        // args = arguments;
	        timestamp = getTime();
	
	        if (!timeout) {
	          timeout = setTimeout(later, wait);
	        }
	
	        // return result;
	      };
	    },
	
	    constructor: function(params) {
	      var $,
	        barPos,
	        scrollerPos0,
	        track,
	        resizePauseTimer,
	        scrollPauseTimer,
	        scrollingTimer,
	        pause,
	        scrollLastFire,
	        resizeLastFire,
	        oldBarSize;
	
	      resizeLastFire = scrollLastFire = getTime();
	
	      $ = this.$ = params.$;
	      this.event = params.event;
	      this.events = {};
	
	      function getNode(sel, context) {
	        return $(sel, context)[0]; // Can be undefined
	      }
	
	      // DOM elements
	      this.root = params.root; // Always html node, not just selector
	      this.scroller = getNode(params.scroller); // (params.scroller) ? getNode(params.scroller, this.root) : this.root;
	      this.bar = getNode(params.bar, this.root);
	      track = this.track = getNode(params.track, this.root);
	      if (!this.track && this.bar) {
	        track = this.bar.parentNode;
	      }
	      this.clipper = this.scroller.parentNode;
	
	      // Parameters
	      this.direction = params.direction;
	      this.origin = origin[this.direction];
	      this.barOnCls = params.barOnCls || '_baron';
	      this.scrollingCls = params.scrollingCls;
	      this.barTopLimit = 0;
	      pause = params.pause * 1000 || 0;
	
	      // Updating height or width of bar
	      function setBarSize(size) {
	        /* jshint validthis:true */
	        var barMinSize = this.barMinSize || 20;
	
	        if (size > 0 && size < barMinSize) {
	          size = barMinSize;
	        }
	
	        if (this.bar) {
	          $(this.bar).css(this.origin.size, parseInt(size, 10) + 'px');
	        }
	      }
	
	      // Updating top or left bar position
	      function posBar(pos) {
	        /* jshint validthis:true */
	        if (this.bar) {
	          var was = $(this.bar).css(this.origin.pos),
	            will = +pos + 'px';
	
	          if (will && will != was) {
	            $(this.bar).css(this.origin.pos, will);
	          }
	        }
	      }
	
	      // Free path for bar
	      function k() {
	        /* jshint validthis:true */
	        return track[this.origin.client] - this.barTopLimit - this.bar[this.origin.offset];
	      }
	
	      // Relative content top position to bar top position
	      function relToPos(r) {
	        /* jshint validthis:true */
	        return r * k.call(this) + this.barTopLimit;
	      }
	
	      // Bar position to relative content position
	      function posToRel(t) {
	        /* jshint validthis:true */
	        return (t - this.barTopLimit) / k.call(this);
	      }
	
	      // Cursor position in main direction in px // Now with iOs support
	      this.cursor = function(e) {
	        return e['client' + this.origin.x] || (((e.originalEvent || e).touches || {})[0] || {})['page' + this.origin.x];
	      };
	
	      // Text selection pos preventing
	      function dontPosSelect() {
	        return false;
	      }
	
	      this.pos = function(x) { // Absolute scroller position in px
	        var ie = 'page' + this.origin.x + 'Offset',
	          key = (this.scroller[ie]) ? ie : this.origin.scroll;
	
	        if (x !== undefined) this.scroller[key] = x;
	
	        return this.scroller[key];
	      };
	
	      this.rpos = function(r) { // Relative scroller position (0..1)
	        var free = this.scroller[this.origin.scrollSize] - this.scroller[this.origin.client],
	          x;
	
	        if (r) {
	          x = this.pos(r * free);
	        } else {
	          x = this.pos();
	        }
	
	        return x / (free || 1);
	      };
	
	      // Switch on the bar by adding user-defined CSS classname to scroller
	      this.barOn = function(dispose) {
	        if (this.barOnCls) {
	          if (dispose || this.scroller[this.origin.client] >= this.scroller[this.origin.scrollSize]) {
	            if ($(this.root).hasClass(this.barOnCls)) $(this.root).removeClass(this.barOnCls);
	          } else {
	            if (!$(this.root).hasClass(this.barOnCls)) $(this.root).addClass(this.barOnCls);
	          }
	        }
	      };
	
	      this._pos0 = function(e) {
	        scrollerPos0 = this.cursor(e) - barPos;
	      };
	
	      this.drag = function(e) {
	        this.scroller[this.origin.scroll] = posToRel.call(this, this.cursor(e) - scrollerPos0) * (this.scroller[this.origin.scrollSize] - this.scroller[this.origin.client]);
	      };
	
	      // Text selection preventing on drag
	      this.selection = function(enable) {
	        this.event(document, 'selectpos selectstart', dontPosSelect, enable ? 'off' : 'on');
	      };
	
	      // onResize & DOM modified handler
	      this.resize = function() {
	        var self = this,
	          delay = 0;
	
	        if (getTime() - resizeLastFire < pause) {
	          clearTimeout(resizePauseTimer);
	          delay = pause;
	        }
	
	        function upd() {
	          var delta,
	            client,
	            offset,
	            was,
	            will;
	
	          // Change a css inline rule only if it is really changing value
	          // function tryCss(prop, value, ) {
	          //     var was = $(self.clipper).css(self.origin.crossSize),
	          //         will = self.clipper[self.origin.crossClient] - delta + 'px';
	          // };
	
	          self.barOn();
	
	          client = self.scroller[self.origin.crossClient];
	          offset = self.scroller[self.origin.crossOffset];
	          delta = offset - client;
	
	          if (offset) { // if there is no size, css should not be set
	            if (params.freeze && !self.clipper.style[self.origin.crossSize]) { // Sould fire only once
	              was = $(self.clipper).css(self.origin.crossSize);
	              will = self.clipper[self.origin.crossClient] - delta + 'px';
	
	              if (was != will) {
	                $(self.clipper).css(self.origin.crossSize, will);
	              }
	            }
	
	            was = $(self.clipper).css(self.origin.crossSize);
	            will = self.clipper[self.origin.crossClient] + delta + 'px';
	
	            if (was != will) {
	              $(self.scroller).css(self.origin.crossSize, will);
	            }
	          }
	
	          Array.prototype.unshift.call(arguments, 'resize');
	          fire.apply(self, arguments);
	
	          resizeLastFire = getTime();
	        }
	
	        if (delay) {
	          resizePauseTimer = setTimeout(upd, delay);
	        } else {
	          upd();
	        }
	      };
	
	      this.updatePositions = function() {
	        var newBarSize,
	          self = this;
	
	        if (self.bar) {
	          newBarSize = (track[self.origin.client] - self.barTopLimit) * self.scroller[self.origin.client] / self.scroller[self.origin.scrollSize];
	
	          // Positioning bar
	          if (parseInt(oldBarSize, 10) != parseInt(newBarSize, 10)) {
	            setBarSize.call(self, newBarSize);
	            oldBarSize = newBarSize;
	          }
	
	          barPos = relToPos.call(self, self.rpos());
	
	          posBar.call(self, barPos);
	        }
	
	        Array.prototype.unshift.call( arguments, 'scroll' );
	        fire.apply(self, arguments);
	
	        scrollLastFire = getTime();
	      };
	
	      // onScroll handler
	      this.scroll = function() {
	        var delay = 0,
	          self = this;
	
	        if (getTime() - scrollLastFire < pause) {
	          clearTimeout(scrollPauseTimer);
	          delay = pause;
	        }
	
	        if (getTime() - scrollLastFire < pause) {
	          clearTimeout(scrollPauseTimer);
	          delay = pause;
	        }
	
	        if (delay) {
	          scrollPauseTimer = setTimeout(function() {
	            self.updatePositions();
	          }, delay);
	        } else {
	          self.updatePositions();
	        }
	
	        if (self.scrollingCls) {
	          if (!scrollingTimer) {
	            this.$(this.scroller).addClass(this.scrollingCls);
	          }
	          clearTimeout(scrollingTimer);
	          scrollingTimer = setTimeout(function() {
	            self.$(self.scroller).removeClass(self.scrollingCls);
	            scrollingTimer = undefined;
	          }, 300);
	        }
	
	      };
	
	      return this;
	    },
	
	    update: function(params) {
	      fire.call(this, 'upd', params); // Update all plugins' params
	
	      this.resize(1);
	      this.updatePositions();
	
	      return this;
	    },
	
	    // One instance
	    dispose: function(params) {
	      manageEvents(this, this.event, 'off');
	      manageAttr(this.root, params.direction, 'off');
	      this.$(this.scroller).css(this.origin.crossSize, '');
	      this.barOn(true);
	      fire.call(this, 'dispose');
	      this._disposed = true;
	    },
	
	    on: function(eventName, func, arg) {
	      var names = eventName.split(' ');
	
	      for (var i = 0 ; i < names.length ; i++) {
	        if (names[i] == 'init') {
	          func.call(this, arg);
	        } else {
	          this.events[names[i]] = this.events[names[i]] || [];
	
	          this.events[names[i]].push(function(userArg) {
	            func.call(this, userArg || arg);
	          });
	        }
	      }
	    }
	  };
	
	  baron.fn.constructor.prototype = baron.fn;
	  item.prototype.constructor.prototype = item.prototype;
	
	  // Use when you need "baron" global var for another purposes
	  baron.noConflict = function() {
	    window.baron = _baron; // Restoring original value of "baron" global var
	
	    return baron;
	  };
	
	  baron.version = '0.7.10';
	  if ($ && $.fn) { // Adding baron to jQuery as plugin
	    $.fn.baron = baron;
	  }
	
	  window.baron = baron; // Use noConflict method if you need window.baron var for another purposes
	  if (module.exports) {
	    module.exports = baron;
	  }
	})(window, window.$);
	
	/* Fixable elements plugin for baron 0.6+ */
	(function(window, undefined) {
	  var fix = function(userParams) {
	    var elements, viewPortSize,
	      params = { // Default params
	        outside: '',
	        inside: '',
	        before: '',
	        after: '',
	        past: '',
	        future: '',
	        radius: 0,
	        minView: 0
	      },
	      topFixHeights = [], // inline style for element
	      topRealHeights = [], // ? something related to negative margins for fixable elements
	      headerTops = [], // offset positions when not fixed
	      scroller = this.scroller,
	      eventManager = this.event,
	      $ = this.$,
	      self = this;
	
	    // i - number of fixing element, pos - fix-position in px, flag - 1: top, 2: bottom
	    // Invocation only in case when fix-state changed
	    function fixElement(i, pos, flag) {
	      var ori = flag == 1 ? 'pos' : 'oppos';
	
	      if (viewPortSize < (params.minView || 0)) { // No headers fixing when no enought space for viewport
	        pos = undefined;
	      }
	
	      // Removing all fixing stuff - we can do this because fixElement triggers only when fixState really changed
	      this.$(elements[i]).css(this.origin.pos, '').css(this.origin.oppos, '').removeClass(params.outside);
	
	      // Fixing if needed
	      if (pos !== undefined) {
	        pos += 'px';
	        this.$(elements[i]).css(this.origin[ori], pos).addClass(params.outside);
	      }
	    }
	
	    function bubbleWheel(e) {
	      try {
	        i = document.createEvent('WheelEvent'); // i - for extra byte
	        // evt.initWebKitWheelEvent(deltaX, deltaY, window, screenX, screenY, clientX, clientY, ctrlKey, altKey, shiftKey, metaKey);
	        i.initWebKitWheelEvent(e.originalEvent.wheelDeltaX, e.originalEvent.wheelDeltaY);
	        scroller.dispatchEvent(i);
	        e.preventDefault();
	      } catch (e) {}
	    }
	
	    function init(_params) {
	      var pos;
	
	      for (var key in _params) {
	        params[key] = _params[key];
	      }
	
	      elements = this.$(params.elements, this.scroller);
	
	      if (elements) {
	        viewPortSize = this.scroller[this.origin.client];
	        for (var i = 0 ; i < elements.length ; i++) {
	          // Variable count-header heights
	          pos = {};
	          pos[this.origin.size] = elements[i][this.origin.offset];
	          if (elements[i].parentNode !== this.scroller) {
	            this.$(elements[i].parentNode).css(pos);
	          }
	          pos = {};
	          pos[this.origin.crossSize] = elements[i].parentNode[this.origin.crossClient];
	          this.$(elements[i]).css(pos);
	
	          // Between fixed headers
	          viewPortSize -= elements[i][this.origin.offset];
	
	          headerTops[i] = elements[i].parentNode[this.origin.offsetPos]; // No paddings for parentNode
	
	          // Summary elements height above current
	          topFixHeights[i] = (topFixHeights[i - 1] || 0); // Not zero because of negative margins
	          topRealHeights[i] = (topRealHeights[i - 1] || Math.min(headerTops[i], 0));
	
	          if (elements[i - 1]) {
	            topFixHeights[i] += elements[i - 1][this.origin.offset];
	            topRealHeights[i] += elements[i - 1][this.origin.offset];
	          }
	
	          if ( !(i == 0 && headerTops[i] == 0)/* && force */) {
	            this.event(elements[i], 'mousewheel', bubbleWheel, 'off');
	            this.event(elements[i], 'mousewheel', bubbleWheel);
	          }
	        }
	
	        if (params.limiter && elements[0]) { // Bottom edge of first count-header as top limit for track
	          if (this.track && this.track != this.scroller) {
	            pos = {};
	            pos[this.origin.pos] = elements[0].parentNode[this.origin.offset];
	            this.$(this.track).css(pos);
	          } else {
	            this.barTopLimit = elements[0].parentNode[this.origin.offset];
	          }
	          // this.barTopLimit = elements[0].parentNode[this.origin.offset];
	          this.scroll();
	        }
	
	        if (params.limiter === false) { // undefined (in second fix instance) should have no influence on bar limit
	          this.barTopLimit = 0;
	        }
	      }
	
	      var event = {
	        element: elements,
	
	        handler: function() {
	          var parent = $(this)[0].parentNode,
	            top = parent.offsetTop,
	            num;
	
	          // finding num -> elements[num] === this
	          for (var i = 0 ; i < elements.length ; i++ ) {
	            if (elements[i] === this) num = i;
	          }
	
	          var pos = top - topFixHeights[num];
	
	          if (params.scroll) { // User defined callback
	            params.scroll({
	              x1: self.scroller.scrollTop,
	              x2: pos
	            });
	          } else {
	            self.scroller.scrollTop = pos;
	          }
	        },
	
	        type: 'click'
	      };
	
	      if (params.clickable) {
	        this._eventHandlers.push(event); // For auto-dispose
	        // eventManager(event.element, event.type, event.handler, 'off');
	        eventManager(event.element, event.type, event.handler, 'on');
	      }
	    }
	
	    this.on('init', init, userParams);
	
	    var fixFlag = [], // 1 - past, 2 - future, 3 - current (not fixed)
	      gradFlag = [];
	    this.on('init scroll', function() {
	      var fixState, hTop, gradState;
	
	      if (elements) {
	        var change;
	
	        // fixFlag update
	        for (var i = 0 ; i < elements.length ; i++) {
	          fixState = 0;
	          if (headerTops[i] - this.pos() < topRealHeights[i] + params.radius) {
	            // Header trying to go up
	            fixState = 1;
	            hTop = topFixHeights[i];
	          } else if (headerTops[i] - this.pos() > topRealHeights[i] + viewPortSize - params.radius) {
	            // Header trying to go down
	            fixState = 2;
	            // console.log('topFixHeights[i] + viewPortSize + topRealHeights[i]', topFixHeights[i], this.scroller[this.origin.client], topRealHeights[i]);
	            hTop = this.scroller[this.origin.client] - elements[i][this.origin.offset] - topFixHeights[i] - viewPortSize;
	            // console.log('hTop', hTop, viewPortSize, elements[this.origin.offset], topFixHeights[i]);
	            //(topFixHeights[i] + viewPortSize + elements[this.origin.offset]) - this.scroller[this.origin.client];
	          } else {
	            // Header in viewport
	            fixState = 3;
	            hTop = undefined;
	          }
	
	          gradState = false;
	          if (headerTops[i] - this.pos() < topRealHeights[i] || headerTops[i] - this.pos() > topRealHeights[i] + viewPortSize) {
	            gradState = true;
	          }
	
	          if (fixState != fixFlag[i] || gradState != gradFlag[i]) {
	            fixElement.call(this, i, hTop, fixState);
	            fixFlag[i] = fixState;
	            gradFlag[i] = gradState;
	            change = true;
	          }
	        }
	
	        // Adding positioning classes (on last top and first bottom count-header)
	        if (change) { // At leats one change in elements flag structure occured
	          for (i = 0 ; i < elements.length ; i++) {
	            if (fixFlag[i] == 1 && params.past) {
	              this.$(elements[i]).addClass(params.past).removeClass(params.future);
	            }
	
	            if (fixFlag[i] == 2 && params.future) {
	              this.$(elements[i]).addClass(params.future).removeClass(params.past);
	            }
	
	            if (fixFlag[i] == 3) {
	              if (params.future || params.past) this.$(elements[i]).removeClass(params.past).removeClass(params.future);
	              if (params.inside) this.$(elements[i]).addClass(params.inside);
	            } else if (params.inside) {
	              this.$(elements[i]).removeClass(params.inside);
	            }
	
	            if (fixFlag[i] != fixFlag[i + 1] && fixFlag[i] == 1 && params.before) {
	              this.$(elements[i]).addClass(params.before).removeClass(params.after); // Last top fixed count-header
	            } else if (fixFlag[i] != fixFlag[i - 1] && fixFlag[i] == 2 && params.after) {
	              this.$(elements[i]).addClass(params.after).removeClass(params.before); // First bottom fixed count-header
	            } else {
	              this.$(elements[i]).removeClass(params.before).removeClass(params.after);
	            }
	
	            if (params.grad) {
	              if (gradFlag[i]) {
	                this.$(elements[i]).addClass(params.grad);
	              } else {
	                this.$(elements[i]).removeClass(params.grad);
	              }
	            }
	          }
	        }
	      }
	    });
	
	    this.on('resize upd', function(updParams) {
	      init.call(this, updParams && updParams.fix);
	    });
	  };
	
	  baron.fn.fix = function(params) {
	    var i = 0;
	
	    while (this[i]) {
	      fix.call(this[i], params);
	      i++;
	    }
	
	    return this;
	  };
	})(window);
	/* Autoupdate plugin for baron 0.6+ */
	(function(window) {
	  var MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver || null;
	
	  var autoUpdate = function() {
	    var self = this;
	    var watcher;
	
	    function actualizeWatcher() {
	      if (!self.root[self.origin.offset]) {
	        startWatch();
	      } else {
	        stopWatch();
	      }
	    }
	
	    // Set interval timeout for watching when root node will be visible
	    function startWatch() {
	      if (watcher) return;
	
	      watcher = setInterval(function() {
	        if (self.root[self.origin.offset]) {
	          stopWatch();
	          self.update();
	        }
	      }, 300); // is it good enought for you?)
	    }
	
	    function stopWatch() {
	      clearInterval(watcher);
	      watcher = null;
	    }
	
	    var debouncedUpdater = self._debounce(function() {
	      self.update();
	    }, 300);
	
	    this._observer = new MutationObserver(function() {
	      actualizeWatcher();
	      self.update();
	      debouncedUpdater();
	    });
	
	    this.on('init', function() {
	      self._observer.observe(self.root, {
	        childList: true,
	        subtree: true,
	        characterData: true
	        // attributes: true
	        // No reasons to set attributes to true
	        // The case when root/child node with already properly inited baron toggled to hidden and then back to visible,
	        // and the size of parent was changed during that hidden state, is very rare
	        // Other cases are covered by watcher, and you still can do .update by yourself
	      });
	
	      actualizeWatcher();
	    });
	
	    this.on('dispose', function() {
	      self._observer.disconnect();
	      stopWatch();
	      delete self._observer;
	    });
	  };
	
	  baron.fn.autoUpdate = function(params) {
	    if (!MutationObserver) return this;
	
	    var i = 0;
	
	    while (this[i]) {
	      autoUpdate.call(this[i], params);
	      i++;
	    }
	
	    return this;
	  };
	})(window);
	
	/* Controls plugin for baron 0.6+ */
	(function(window, undefined) {
	  var controls = function(params) {
	    var forward, backward, track, screen,
	      self = this, // AAAAAA!!!!!11
	      event;
	
	    screen = params.screen || 0.9;
	
	    if (params.forward) {
	      forward = this.$(params.forward, this.clipper);
	
	      event = {
	        element: forward,
	
	        handler: function() {
	          var y = self.pos() - params.delta || 30;
	
	          self.pos(y);
	        },
	
	        type: 'click'
	      };
	
	      this._eventHandlers.push(event); // For auto-dispose
	      this.event(event.element, event.type, event.handler, 'on');
	    }
	
	    if (params.backward) {
	      backward = this.$(params.backward, this.clipper);
	
	      event = {
	        element: backward,
	
	        handler: function() {
	          var y = self.pos() + params.delta || 30;
	
	          self.pos(y);
	        },
	
	        type: 'click'
	      };
	
	      this._eventHandlers.push(event); // For auto-dispose
	      this.event(event.element, event.type, event.handler, 'on');
	    }
	
	    if (params.track) {
	      if (params.track === true) {
	        track = this.track;
	      } else {
	        track = this.$(params.track, this.clipper)[0];
	      }
	
	      if (track) {
	        event = {
	          element: track,
	
	          handler: function(e) {
	            var x = e['offset' + self.origin.x],
	              xBar = self.bar[self.origin.offsetPos],
	              sign = 0;
	
	            if (x < xBar) {
	              sign = -1;
	            } else if (x > xBar + self.bar[self.origin.offset]) {
	              sign = 1;
	            }
	
	            var y = self.pos() + sign * screen * self.scroller[self.origin.client];
	            self.pos(y);
	          },
	
	          type: 'mousedown'
	        };
	
	        this._eventHandlers.push(event); // For auto-dispose
	        this.event(event.element, event.type, event.handler, 'on');
	      }
	    }
	  };
	
	  baron.fn.controls = function(params) {
	    var i = 0;
	
	    while (this[i]) {
	      controls.call(this[i], params);
	      i++;
	    }
	
	    return this;
	  };
	})(window);
	/* Pull to load plugin for baron 0.6+ */
	(function(window, undefined) {
	  var pull = function(params) {
	    var block = this.$(params.block),
	      size = params.size || this.origin.size,
	      limit = params.limit || 80,
	      onExpand = params.onExpand,
	      elements = params.elements || [],
	      inProgress = params.inProgress || '',
	      self = this,
	      _insistence = 0,
	      _zeroXCount = 0,
	      _interval,
	      _timer,
	      _x = 0,
	      _onExpandCalled,
	      _waiting = params.waiting || 500,
	      _on;
	
	    function getSize() {
	      return self.scroller[self.origin.scroll] + self.scroller[self.origin.offset];
	    }
	
	    // Scroller content height
	    function getContentSize() {
	      return self.scroller[self.origin.scrollSize];
	    }
	
	    // Scroller height
	    function getScrollerSize() {
	      return self.scroller[self.origin.client];
	    }
	
	    function step(x, force) {
	      var k = x * 0.0005;
	
	      return Math.floor(force - k * (x + 550));
	    }
	
	    function toggle(on) {
	      _on = on;
	
	      if (on) {
	        update(); // First time with no delay
	        _interval = setInterval(update, 200);
	      } else {
	        clearInterval(_interval);
	      }
	    }
	
	    function update() {
	      var pos = {},
	        height = getSize(),
	        scrollHeight = getContentSize(),
	        dx,
	        op4,
	        scrollInProgress = _insistence == 1;
	
	      op4 = 0; // Возвращающая сила
	      if (_insistence > 0) {
	        op4 = 40;
	      }
	      //if (_insistence > -1) {
	      dx = step(_x, op4);
	      if (height >= scrollHeight - _x && _insistence > -1) {
	        if (scrollInProgress) {
	          _x += dx;
	        }
	      } else {
	        _x = 0;
	      }
	
	      if (_x < 0) _x = 0;
	
	      pos[size] = _x + 'px';
	      if (getScrollerSize() <= getContentSize()) {
	        self.$(block).css(pos);
	        for (var i = 0 ; i < elements.length ; i++) {
	          self.$(elements[i].self).css(elements[i].property, Math.min(_x / limit * 100, 100) + '%');
	        }
	      }
	
	      if (inProgress && _x) {
	        self.$(self.root).addClass(inProgress);
	      }
	
	      if (_x == 0) {
	        if (params.onCollapse) {
	          params.onCollapse();
	        }
	      }
	
	      _insistence = 0;
	      _timer = setTimeout(function() {
	        _insistence = -1;
	      }, _waiting);
	      //}
	
	      if (onExpand && _x > limit && !_onExpandCalled) {
	        onExpand();
	        _onExpandCalled = true;
	      }
	
	      if (_x == 0) {
	        _zeroXCount++;
	      } else {
	        _zeroXCount = 0;
	      }
	      if (_zeroXCount > 1) {
	        toggle(false);
	        _onExpandCalled = false;
	        if (inProgress) {
	          self.$(self.root).removeClass(inProgress);
	        }
	      }
	    }
	
	    this.on('init', function() {
	      toggle(true);
	    });
	
	    this.on('dispose', function() {
	      toggle(false);
	    });
	
	    this.event(this.scroller, 'mousewheel DOMMouseScroll', function(e) {
	      var down = e.wheelDelta < 0 || (e.originalEvent && e.originalEvent.wheelDelta < 0) || e.detail > 0;
	
	      if (down) {
	        _insistence = 1;
	        clearTimeout(_timer);
	        if (!_on && getSize() >= getContentSize()) {
	          toggle(true);
	        }
	      }
	      //  else {
	      //     toggle(false);
	      // }
	    });
	  };
	
	  baron.fn.pull = function(params) {
	    var i = 0;
	
	    while (this[i]) {
	      pull.call(this[i], params);
	      i++;
	    }
	
	    return this;
	  };
	})(window);


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(13)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(31)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ }),
/* 66 */
/***/ (function(module, exports) {

	module.exports = false;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(85)('meta');
	var isObject = __webpack_require__(10);
	var has = __webpack_require__(37);
	var setDesc = __webpack_require__(17).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(9)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(3);
	var computed = __webpack_require__(297);
	var computedIndex = __webpack_require__(110);
	
	function setUserTypeRadio(userType, formPath, state) {
	    var userTypeRadio = {};
	    userTypeRadio[userType.toString()] = true;
	    state.set(formPath.concat(['userTypeRadio']), userTypeRadio);
	    computedIndex.computeCountryDropdown(state, ['account', 'userForm']);
	}
	
	function _initUserForm(user, state) {
	    state.unset(['account', 'userForm', 'isError']);
	    state.unset(['account', 'userForm', 'error']);
	    state.set(['account', 'userForm', 'original'], Object.assign({}, user));
	    state.set(['account', 'userForm', 'form'], Object.assign({}, user));
	    setUserTypeRadio(user.userType, ['account', 'userForm'], state);
	    if (user.userType === 1 && user.countryId === 1) {
	        state.set(['account', 'userForm', 'form', 'inn12'], user.inn);
	    } else if (user.userType === 2) {
	        switch (user.countryId) {
	            case 1:
	                state.set(['account', 'userForm', 'form', 'inn10'], user.inn);
	                break;
	            case 4:
	                state.set(['account', 'userForm', 'form', 'bin'], user.inn);
	                break;
	            default:
	                break;
	        }
	    } else if (user.userType === 3) {
	        switch (user.countryId) {
	            case 1:
	                state.set(['account', 'userForm', 'form', 'inn12'], user.inn);
	                break;
	            case 4:
	                state.set(['account', 'userForm', 'form', 'bin'], user.inn);
	                break;
	            default:
	                break;
	        }
	    }
	}
	
	module.exports = {
	    setComputedFields: function setComputedFields(args, state) {
	        computed.saveButton(state);
	        computed.cancelButton(state);
	        computed.isUserTypeSelectEnabled(state);
	    },
	    getCurrentUserData: function getCurrentUserData(args, state, output) {
	        var user = state.get(['user']);
	
	        output.success({ user: user });
	    },
	    setDefaultCountry: function setDefaultCountry(_ref) {
	        var user = _ref.user;
	
	        if (!user.countryId) {
	            user.countryId = 1;
	        }
	    },
	    initUserForm: function initUserForm(_ref2, state) {
	        var user = _ref2.user;
	
	        _initUserForm(user, state);
	    },
	    resetUserForm: function resetUserForm(args, state) {
	        var user = state.get(['account', 'userForm', 'original']);
	        _initUserForm(user, state);
	    },
	    updateUserInfo: function updateUserInfo(args, state, output, _ref3) {
	        var locator = _ref3.locator,
	            context = _ref3.context;
	
	        var Api = locator.resolve('api');
	
	        var form = state.get(['account', 'userForm', 'form']);
	
	        var requiredFields = ['city', 'firstName', 'lastName', 'middleName', 'phone', 'userType', 'countryId', 'legalAddress'];
	        var inn = void 0;
	        if (form.userType === 1 && form.countryId === 1) {
	            inn = form.inn12;
	        } else if (form.userType === 2) {
	            requiredFields = requiredFields.concat(['organization', 'kpp']);
	            switch (form.countryId) {
	                case 1:
	                    inn = form.inn10;
	                    break;
	                case 4:
	                    inn = form.bin;
	                    break;
	                default:
	                    break;
	            }
	        } else if (form.userType === 3) {
	            requiredFields = requiredFields.concat(['organization', 'legalAddress']);
	            switch (form.countryId) {
	                case 1:
	                    inn = form.inn12;
	                    break;
	                case 4:
	                    inn = form.bin;
	                    break;
	                default:
	                    break;
	            }
	        }
	
	        var data = _.pick(form, requiredFields);
	        data.inn = inn;
	        var userId = form.id;
	
	        var request = Api.updateUserInfo(context, locator, { userId: userId, data: data });
	
	        request.then(function (response) {
	            var code = _.get(response, 'status.code');
	
	            if (code === 200) {
	                output.success({
	                    user: _.get(response, 'content')
	                });
	                return;
	            }
	
	            output.error({ error: code });
	        }).catch(function (error) {
	            output.error({ error: error });
	        });
	    },
	    selectUserType: function selectUserType(formPath) {
	        return function (_ref4, state) {
	            var key = _ref4.key;
	
	            state.set(formPath.concat(['form', 'userType']), Number(key));
	            setUserTypeRadio(Number(key), formPath, state);
	        };
	    },
	    initUserType: function initUserType(formPath) {
	        return function (args, state) {
	            state.set(formPath.concat(['form', 'userType']), 1);
	            setUserTypeRadio(1, formPath, state);
	        };
	    }
	};

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var computed = __webpack_require__(110);
	
	module.exports = {
	    setComputedFields: function setComputedFields(args, state) {
	        computed.setComponentsByPage(state);
	        computed.setUserDataEmail(state);
	    }
	};

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(3);
	
	var _require = __webpack_require__(15),
	    monkey = _require.monkey;
	
	var progressBarHelper = __webpack_require__(217);
	var utils = __webpack_require__(5);
	var accountUi = __webpack_require__(138);
	var $ = __webpack_require__(12);
	var zoom = void 0,
	    frameWidth = void 0,
	    frameHeight = void 0;
	var dateFormatter = __webpack_require__(204);
	
	function getScrollbarWidth(element) {
	    var outer = document.createElement("div");
	    outer.style.visibility = "hidden";
	    outer.style.width = "100px";
	    element.appendChild(outer);
	
	    var widthNoScroll = outer.offsetWidth;
	
	    outer.style.overflow = "scroll";
	
	    var inner = document.createElement("div");
	    inner.style.width = "100%";
	    outer.appendChild(inner);
	
	    var widthWithScroll = inner.offsetWidth;
	
	    outer.parentNode.removeChild(outer);
	
	    return widthNoScroll - widthWithScroll;
	}
	
	module.exports = {
	    getCurrentUser: function getCurrentUser(args, state, output, _ref) {
	        var locator = _ref.locator;
	
	        try {
	            var bitrix = locator.resolve('bitrix');
	            bitrix.getCurrentUser(function (result) {
	                return output.success({ bitrixUser: result.data() });
	            });
	        } catch (error) {
	            output.error({ error: error });
	        }
	    },
	    getAuth: function getAuth(args, state, output, _ref2) {
	        var locator = _ref2.locator;
	
	        try {
	            var bitrix = locator.resolve('bitrix');
	            var auth = bitrix.getAuth();
	            output.success({ auth: auth });
	        } catch (error) {
	            output.error({ error: error });
	        }
	    },
	    init: function init(args, state, output, _ref3) {
	        var locator = _ref3.locator;
	
	        try {
	            var bitrix = locator.resolve('bitrix');
	            bitrix.init(function () {
	                return output.success();
	            });
	        } catch (error) {
	            output.error({ error: error });
	        }
	    },
	    resize: function resize(_ref4, state, output, _ref5) {
	        var minHeight = _ref4.minHeight;
	        var locator = _ref5.locator;
	
	        if (state.get(['bitrix', 'isBitrix']) === true) {
	            var bitrix = locator.resolve('bitrix');
	            var body = document.getElementById('hermes_body');
	            var newWidth = parseFloat(body.getAttribute('cat-width'));
	            var newHeight = _.max([$(body).height(), minHeight]);
	
	            if (newWidth === frameWidth && newHeight === frameHeight) {
	                return;
	            }
	            frameWidth = newWidth;
	            frameHeight = newHeight;
	            bitrix.resize(newWidth, newHeight);
	        }
	    },
	    scrollTop: function scrollTop(args, state, output, _ref6) {
	        var locator = _ref6.locator;
	
	        if (state.get(['bitrix', 'isBitrix']) === true) {
	            var bitrix = locator.resolve('bitrix');
	            bitrix.scroll(0);
	        }
	    },
	    fitWindow: function fitWindow(args, state, output, _ref7) {
	        var locator = _ref7.locator;
	
	        if (state.get(['bitrix', 'isBitrix']) === true) {
	            var bitrix = locator.resolve('bitrix');
	            var body = document.getElementById('hermes_body');
	
	            $(window).resize(function () {
	                var zoomNew = document.documentElement.clientWidth;
	                if (Math.abs(zoom - zoomNew) > 0) {
	                    zoom = zoomNew;
	                    bitrix.fitWindow(function () {
	                        body.setAttribute('cat-width', $(body).width() + getScrollbarWidth(body));
	                    });
	                }
	            });
	
	            if (body.getAttribute('cat-width')) {
	                return;
	            }
	            bitrix.fitWindow(function () {
	                body.setAttribute('cat-width', $(body).width() + getScrollbarWidth(body));
	                zoom = document.documentElement.clientWidth;
	            });
	        }
	    },
	    exportLeads: function exportLeads(_ref8, state, output, _ref9) {
	        var leadMapping = _ref8.leadMapping,
	            isExportFree = _ref8.isExportFree,
	            isIncludeExportedFreeLeads = _ref8.isIncludeExportedFreeLeads;
	        var locator = _ref9.locator,
	            context = _ref9.context;
	
	        var API = locator.resolve('api');
	        var orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
	
	        var request = API.exportLeads(context, locator, {
	            orderId: orderId, leadMapping: leadMapping, isExportFree: isExportFree,
	            isIncludeExportedFreeLeads: isIncludeExportedFreeLeads
	        });
	        request.then(function (response) {
	            var code = _.get(response, 'status.code');
	            if (code === 403) {
	                output.forbidden();
	                return;
	            }
	
	            if (code !== 200) {
	                output.error({ error: code });
	                return;
	            }
	            output.success({ exportJobId: _.get(response, 'content') });
	        }).catch(function (error) {
	            return output.error({ error: error });
	        });
	    },
	    getLeadFields: function getLeadFields(args, state, output, _ref10) {
	        var locator = _ref10.locator,
	            context = _ref10.context;
	
	        var API = locator.resolve('api');
	        var orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
	        var request = API.getLeadFields(context, locator, { orderId: orderId });
	        request.then(function (response) {
	            var code = _.get(response, 'status.code');
	            if (code !== 200) {
	                output.error({ error: code });
	                return;
	            }
	            output.success({ leadFields: _.get(response, 'content') });
	        }).catch(function (error) {
	            return output.error({ error: error });
	        });
	    },
	    initBitrixLeads: function initBitrixLeads(_ref11, state) {
	        var leadFields = _ref11.leadFields;
	
	        var bitrixFields = _.map(leadFields.bitrixFields, function (x) {
	            return { isActive: false, title: x.name, value: x.id };
	        });
	        var hermesFields = leadFields.hermesFields;
	        state.set(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'hasFieldCreationRight'], leadFields.hasFieldCreationRight);
	        state.set(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'freeLeadsAmount'], leadFields.freeLeadsAmount);
	        state.set(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'isOnlyFreeLeads'], leadFields.isOnlyFreeLeads);
	        state.set(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'hermesFields'], hermesFields);
	        _.forEach(hermesFields, function (item) {
	            var itemBitrixFields = _.cloneDeep(_.filter(bitrixFields, function (x) {
	                return item.acceptableMapping.includes(x.value);
	            }));
	            var ignoreField = { isActive: false, title: '- Не экспортировать -', value: '-1' };
	            var selectedIndex = _.findIndex(itemBitrixFields, { value: item.defaultMapping });
	            if (selectedIndex > -1) {
	                itemBitrixFields[selectedIndex].isActive = true;
	            } else {
	                ignoreField.isActive = true;
	            }
	            itemBitrixFields.unshift(ignoreField);
	            state.set(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'mapping', item.id, 'id'], item.id);
	            state.set(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'mapping', item.id, 'bitrixFields'], itemBitrixFields);
	            state.set(['account', 'popups', 'bitrixExportLeads', 'mapping', item.id, 'isOpen'], monkey([['popups', 'active'], function (popups) {
	                return _.includes(popups, 'leads' + item.id);
	            }]));
	        });
	
	        var requiredFields = _.filter(leadFields.bitrixFields, { isRequired: true });
	
	        if (requiredFields) {
	            _.forEach(requiredFields, function (item) {
	                if (item.type === 'enumeration') {
	                    item.enumValues = _.map(Object.keys(item.enumValues), function (key) {
	                        return { isActive: false, title: item.enumValues[key], value: key };
	                    });
	                    utils.setPopupVisibility('lead-required-field-' + item.id, ['account', 'popups', 'bitrixExportLeads', 'requiredFields', item.id, 'isOpen'])({}, state);
	                } else if (item.type === 'boolean') {
	                    item.value = false;
	                } else if (item.type === 'integer' || item.type === 'double' || item.type === 'money') {
	                    item.type = 'number';
	                } else if (item.type === 'url') {
	                    item.type = 'string';
	                } else if (item.type === 'date' || item.type === 'datetime') {
	                    item.type = 'datetime';
	                    utils.setPopupVisibility('lead-required-field-' + item.id, ['account', 'popups', 'bitrixExportLeads', 'requiredFields', item.id, 'isOpen'])({}, state);
	                    accountUi.setDatePickerComputed(item.id, ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'computed', 'requiredFields', item.id, 'datepicker'], ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'requiredFields', item.id, 'datepicker'], state);
	                }
	            });
	        }
	        state.set(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'requiredFields'], _.keyBy(requiredFields, function (x) {
	            return x.id;
	        }));
	    },
	    selectBitrixLeadField: function selectBitrixLeadField(_ref12, state) {
	        var field = _ref12.field,
	            selectedValue = _ref12.selectedValue;
	
	        var options = state.get(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'mapping', field, 'bitrixFields']);
	        var oldSelectedValueIndex = _.findIndex(options, { isActive: true });
	        if (oldSelectedValueIndex > -1) {
	            state.set(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'mapping', field, 'bitrixFields', oldSelectedValueIndex, 'isActive'], false);
	        }
	        var selectedIndex = _.findIndex(options, { value: selectedValue });
	        if (selectedIndex > -1) {
	            state.set(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'mapping', field, 'bitrixFields', selectedIndex, 'isActive'], true);
	        }
	    },
	    addLeadMappingToArgs: function addLeadMappingToArgs(args, state) {
	        var mappingState = state.get(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'mapping']);
	        var mapping = [];
	        _.forEach(Object.keys(mappingState), function (key) {
	            if (mappingState[key].isNew) {
	                mapping.push({
	                    from: key,
	                    newLabel: mappingState[key].newLabel
	                });
	                return;
	            }
	            var bitrixFields = mappingState[key].bitrixFields;
	            var selectedIndex = _.findIndex(bitrixFields, { isActive: true });
	            if (selectedIndex > -1) {
	                if (bitrixFields[selectedIndex].value === '-1') {
	                    return;
	                }
	                mapping.push({
	                    from: key,
	                    to: bitrixFields[selectedIndex].value
	                });
	            }
	        });
	
	        var required = state.get(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'requiredBitrixFields']);
	        var requiredValues = state.get(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'requiredFields']);
	        _.forEach(required, function (item) {
	            var value = _.get(requiredValues[item.id], 'value', undefined);
	            if (value) {
	                mapping.push({
	                    to: item.id,
	                    value: value.toString()
	                });
	            } else {
	                var date = _.get(requiredValues[item.id], 'datepicker.value', undefined);
	                if (date) {
	                    mapping.push({
	                        to: item.id,
	                        value: dateFormatter.getFormattedDate(date)
	                    });
	                }
	            }
	        });
	
	        args.leadMapping = JSON.stringify(mapping);
	        args.isExportFree = state.get(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'isExportFree']);
	
	        args.isIncludeExportedFreeLeads = state.get(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'isIncludeExportedFreeLeads']) || state.get(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'isOnlyFreeLeads']);
	    },
	    getExportJobProgress: function getExportJobProgress(_ref13, state, output, _ref14) {
	        var exportJobId = _ref13.exportJobId;
	        var locator = _ref14.locator,
	            context = _ref14.context;
	
	        var orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
	        var API = locator.resolve('api');
	        progressBarHelper.init('export-leads', 'Экспорт лидов');
	        setTimeout(function getExportJobProgress() {
	            if (state.get(['account', 'orders', 'currentOrder', 'id']) !== orderId) {
	                output.dontNeed();
	                return;
	            }
	
	            var request = API.getExportJobProgress(context, locator, { exportJobId: exportJobId });
	            request.then(function (data) {
	                if (state.get(['account', 'orders', 'currentOrder', 'id']) !== orderId) {
	                    output.dontNeed();
	                    return;
	                }
	
	                var statusCode = _.get(data, 'status.code');
	                if (statusCode !== 200) {
	                    output.error({ error: statusCode });
	                    return;
	                }
	
	                var jobProgress = _.get(data, 'content', 0);
	                if (isNaN(jobProgress)) {
	                    jobProgress = 0;
	                }
	
	                progressBarHelper.setPercentage('export-leads', jobProgress);
	                if (jobProgress >= 100) {
	                    output.success();
	                } else {
	                    setTimeout(getExportJobProgress, 2500);
	                }
	                return;
	            }).catch(function (error) {
	                output.error({ error: error });
	                return;
	            });
	        }, 0);
	    },
	    fillRegistrationForm: function fillRegistrationForm(_ref15, state) {
	        var bitrixUser = _ref15.bitrixUser;
	
	        state.set(['registrationExtra', 'form', 'firstName'], bitrixUser.NAME);
	        state.set(['registrationExtra', 'form', 'lastName'], bitrixUser.LAST_NAME);
	        state.set(['registrationExtra', 'form', 'middleName'], bitrixUser.SECOND_NAME);
	        state.set(['registrationExtra', 'form', 'city'], bitrixUser.PERSONAL_CITY);
	
	        var phone = bitrixUser.PERSONAL_MOBILE || bitrixUser.WORK_PHONE;
	        if (phone) {
	            phone = phone.replace(/[^0-9]/g, '');
	            if (phone.length === 11 && (phone.charAt(0) === '7' || phone.charAt(0) === '8')) {
	                phone = phone.substring(1);
	            }
	            if (phone.length !== 10) {
	                phone = null;
	            }
	            state.set(['registrationExtra', 'form', 'phone'], phone);
	        }
	    },
	    validateMapping: function validateMapping(args, state) {
	        var mapping = state.get(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'mapping']);
	        var mappingNotNew = _.filter(mapping, function (x) {
	            return !x.isNew;
	        });
	        var grouped = _.groupBy(mappingNotNew, function (x) {
	            return _.find(x.bitrixFields, { isActive: true }).value;
	        });
	        var duplicatesCount = 0;
	        var required = _.cloneDeep(state.get(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'requiredFields']));
	        _.forEach(Object.keys(grouped), function (key) {
	            delete required[key];
	            if (grouped[key].length < 2 || key === '-1') {
	                _.forEach(grouped[key], function (x) {
	                    state.unset(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'mapping', x.id, 'isError']);
	                });
	                return;
	            }
	            duplicatesCount++;
	            _.forEach(grouped[key], function (x) {
	                state.set(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'mapping', x.id, 'isError'], true);
	            });
	        });
	
	        state.set(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'missRequiredFields'], _.map(required, function (x) {
	            return x.name;
	        }));
	
	        var knownTypes = ['number', 'string', 'boolean', 'enumeration', 'datetime'];
	        var requiredKnownTypes = _.filter(required, function (x) {
	            return knownTypes.includes(x.type);
	        });
	        state.set(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'requiredBitrixFields'], requiredKnownTypes);
	
	        var requiredValues = state.get(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'requiredFields']);
	        if (requiredValues) {
	            _.forEach(Object.keys(requiredValues), function (key) {
	                if (!requiredValues[key].error && (requiredValues[key].value || _.get(requiredValues[key], 'datepicker.value'))) {
	                    delete required[key];
	                }
	            });
	        }
	
	        var mappingNewErrors = _.some(mapping, function (x) {
	            return x.isNew && (x.error || !x.newLabel);
	        });
	        state.set(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'duplicateError'], duplicatesCount > 0);
	        state.set(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'isError'], duplicatesCount > 0 || Object.keys(required).length > 0 || mappingNewErrors);
	    },
	    setTypeFilterItem: function setTypeFilterItem(_ref16, state) {
	        var path = _ref16.path,
	            value = _ref16.value;
	
	        state.set(['account', 'orders', 'list', 'typeFilter', path, 'isChecked'], value);
	    },
	    setBitrixRequiredFieldValue: function setBitrixRequiredFieldValue(_ref17, state) {
	        var path = _ref17.path,
	            value = _ref17.value;
	
	        state.set(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'requiredFields', path, 'value'], value);
	    }
	};

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var REQUEST_ID_PATH = ['order', 'price', 'requestId'];
	var REQUEST_IS_LOADING_PATH = ['order', 'price', 'isLoading'];
	
	var _ = __webpack_require__(3);
	
	var debouncedRequestPrice = _.debounce(requestPrice, 1000);
	var treeHelpers = __webpack_require__(57);
	var dateFormatter = __webpack_require__(204);
	
	function getSelectedParameters(state) {
	    var rubrics = getSelectedLeafs(state, ['order', 'rubrics', 'tree']);
	    var legalEntities = getSelectedLeafs(state, ['order', 'addParams', 'legalEntities', 'tree']);
	    var purposes = getSelectedLeafs(state, ['order', 'addParams', 'purposes', 'tree']);
	    var mapClasses = getSelectedLeafs(state, ['order', 'addParams', 'mapClasses', 'tree']);
	    var paymentTypes = getSelectedLeafs(state, ['order', 'addParams', 'paymentTypes', 'tree']);
	    var numberOfEmployees = getSelectedLeafs(state, ['order', 'addParams', 'numberOfEmployees', 'tree']);
	    var checkedColumns = _.filter(_.values(state.get(['order', 'addParams', 'exportColumns'])), function (x) {
	        return x.isChecked === true;
	    });
	    var numberOfFilialsValue = _.get(_.find(state.get(['order', 'addParams', 'numberOfFilials', 'options']), function (x) {
	        return x.isActive === true;
	    }), 'value');
	    var numberOfFilials = numberOfFilialsValue ? Number(numberOfFilialsValue) : null;
	
	    var greederColumnsSelected = state.get(['order', 'computed', 'isShowGreeder']) === true ? _.map(_.filter(_.values(state.get(['order', 'addParams', 'greederColumns', 'value'])), function (x) {
	        return x.isChecked === true;
	    }), function (x) {
	        return x.id;
	    }) : [];
	    var greederColumnsDisabled = _.map(_.filter(state.get(['order', 'addParams', 'greederColumns', 'view', 'gosReg']), function (x) {
	        return !x.isEnabled;
	    }), function (x) {
	        return x.id;
	    });
	    var greederColumns = _.filter(greederColumnsSelected, function (x) {
	        return !greederColumnsDisabled.includes(x);
	    });
	
	    var exportColumns = _.map(checkedColumns, function (x) {
	        var column = { columnId: x.id, isMustBeFilled: x.isMustBeFilled };
	        if (x.value) {
	            column.value = [_.get(x.value, '0', null), _.get(x.value, '1', null)];
	        }
	        return column;
	    });
	
	    var columnsConfig = state.get(['order', 'originalParameters', 'exportColumns', 'columns']);
	
	    var from = dateFormatter.getFormattedDate(state.get(['order', 'addParams', 'datepicker', 'value']));
	    var to = dateFormatter.getFormattedDate(state.get(['order', 'addParams', 'datepicker2', 'value']));
	    if (from !== null || to !== null) {
	        var dateColumnId = _.find(columnsConfig, { filterType: 'IsInRangeDatetime' }).id;
	        var dateColumn = _.find(exportColumns, { columnId: dateColumnId });
	        dateColumn.value = [from, to];
	        dateColumn.isMustBeFilled = true;
	    }
	
	    var doubleRangeIds = _.map(_.filter(columnsConfig, { filterType: 'IsInRangeDouble' }), function (x) {
	        return x.id;
	    });
	    var doubleRangeColumns = _.filter(exportColumns, function (x) {
	        return _.includes(doubleRangeIds, x.columnId);
	    });
	    _.forEach(doubleRangeColumns, function (x) {
	        if (x.value) {
	            if (x.value[0] && x.value[0] instanceof String) {
	                x.value[0] = parseFloat(x.value[0].replace(',', '.'));
	            }
	            if (x.value[1] && x.value[1] instanceof String) {
	                x.value[1] = parseFloat(x.value[1].replace(',', '.'));
	            }
	        }
	    });
	
	    var params = state.get(['order', 'addParams', 'params']);
	    var dataVersion = state.get(['order', 'originalParameters', 'dataVersion']);
	    var configVersion = state.get(['order', 'originalParameters', 'configVersion']);
	    var onlyHeadCards = state.get(['order', 'addParams', 'onlyHeadCards']);
	    var includeArchiveInn = state.get(['order', 'addParams', 'includeArchiveInn']);
	
	    var selectedParams = Object.assign({}, params, { rubrics: rubrics, legalEntities: legalEntities, purposes: purposes, mapClasses: mapClasses, paymentTypes: paymentTypes,
	        numberOfEmployees: numberOfEmployees, numberOfFilials: numberOfFilials, exportColumns: exportColumns, greederColumns: greederColumns, onlyHeadCards: onlyHeadCards, dataVersion: dataVersion, configVersion: configVersion, includeArchiveInn: includeArchiveInn });
	
	    var tab = state.get(['order', 'cities', 'tab']);
	    if (tab === 'map') {
	        selectedParams.mapFilter = state.get(['order', 'cities', 'mapFilter']) || state.get(['order', 'cities', 'mapFilterInit']);
	    } else if (tab === 'branches') {
	        var calcOnlyDefaultCities = state.get(['order', 'cities', 'calcOnlyDefaultCities']);
	        var branches = getSelectedLeafs(state, ['order', 'branches', 'tree']);
	        if (calcOnlyDefaultCities) {
	            var originalBranches = state.get(['order', 'originalParameters', 'branches']);
	            selectedParams.cities = _.map(_.filter(originalBranches, function (x) {
	                return branches.includes(x.code);
	            }), function (x) {
	                return x.defaultCityId;
	            });
	        } else {
	            selectedParams.branches = branches;
	        }
	    } else {
	        selectedParams.cities = getSelectedLeafs(state, ['order', 'cities', 'tree']);
	    }
	
	    return selectedParams;
	}
	
	function requestPrice(args, state, output, _ref) {
	    var context = _ref.context,
	        locator = _ref.locator;
	
	    var api = locator.resolve('api');
	
	    var orderTypeId = state.get(['order', 'typeId']);
	    if (orderTypeId === undefined) {
	        orderTypeId = 1;
	    }
	
	    var selectedParams = getSelectedParameters(state);
	
	    if (orderTypeId !== 3 && (!selectedParams.rubrics || selectedParams.rubrics.length <= 0)) {
	        output.requiredParametersNotFilled();
	        return;
	    }
	
	    if ((!selectedParams.cities || selectedParams.cities.length <= 0) && !selectedParams.mapFilter && !selectedParams.branches) {
	        output.requiredParametersNotFilled();
	        return;
	    }
	
	    var exportColumns = state.get(['order', 'addParams', 'exportColumns']);
	    var errors = _.map(exportColumns, 'error');
	
	    if (_.some(errors, function (x) {
	        return x && ((typeof x === 'undefined' ? 'undefined' : _typeof(x)) !== 'object' || Object.keys(x).length !== 0);
	    })) {
	        return;
	    }
	
	    var isPersistent = state.get(['order', 'settings', 'shouldPersist']);
	    if (isPersistent) {
	        storeCurrentState(selectedParams, context, locator);
	    }
	
	    var requestId = state.get(REQUEST_ID_PATH).toString();
	    var payload = Object.assign({ requestId: requestId }, selectedParams);
	
	    var request = api.getOrderPrice(context, locator, payload, orderTypeId);
	
	    request.then(function (response) {
	        var code = _.get(response, 'status.code');
	
	        if (code !== 200) {
	            output.error({ error: code });
	            return;
	        }
	        var price = _.get(response, 'content');
	        output.success({ price: price });
	    }).catch(function (error) {
	        return output.error({ error: error });
	    });
	}
	
	function getSelectedLeafs(state, basePath) {
	    var leafs = state.get(basePath.concat('computed', 'leafs'));
	    var selected = state.get(basePath.concat('selected'));
	
	    return treeHelpers.getSelectedLeafs(leafs, selected);
	}
	
	function storeCurrentState(selectedParams, context, locator) {
	    if (context.isServer) {
	        return;
	    }
	    var window = locator.resolve('window');
	    window.localStorage.setItem('selected_params', JSON.stringify(selectedParams));
	}
	
	function setPrice(_ref2, state) {
	    var price = _ref2.price;
	
	    state.set(['order', 'price', 'data'], price);
	    state.set(REQUEST_IS_LOADING_PATH, false);
	}
	
	module.exports = {
	    calcPrice: function calcPrice(args, state, output, _ref3) {
	        var context = _ref3.context,
	            locator = _ref3.locator;
	
	        debouncedRequestPrice(args, state, output, { context: context, locator: locator });
	    },
	    prepareToRequest: function prepareToRequest(args, state) {
	        var previous = state.get(REQUEST_ID_PATH) || 0;
	        var value = previous % Number.MAX_SAFE_INTEGER + 1;
	        state.set(REQUEST_ID_PATH, value);
	        state.set(REQUEST_IS_LOADING_PATH, true);
	    },
	
	
	    setPrice: setPrice,
	
	    setPriceIfRequestIdIsValid: function setPriceIfRequestIdIsValid(_ref4, state) {
	        var price = _ref4.price;
	
	        var expectedRequestId = state.get(REQUEST_ID_PATH).toString();
	        var actualRequestId = price.requestId;
	        if (actualRequestId === expectedRequestId) {
	            setPrice({ price: price }, state);
	        }
	    },
	    initPrice: function initPrice(args, state) {
	        var price = { totalPrice: 0, rowPrice: 0, rowAmount: 0 };
	
	        state.set(['order', 'price', 'data'], price);
	    },
	    setIsLoading: function setIsLoading(value) {
	        return function (args, state) {
	            return state.set(REQUEST_IS_LOADING_PATH, value);
	        };
	    },
	    isZeroPrice: function isZeroPrice(_ref5, state, output) {
	        var price = _ref5.price;
	
	        if (price.total.totalPrice <= 0) {
	            output.yes();
	        } else {
	            output.no();
	        }
	    },
	
	
	    getSelectedParameters: getSelectedParameters
	};

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(3);
	
	module.exports = {
	    thenWithErrorHandling: function thenWithErrorHandling(promise, dataFunction, output) {
	        promise.then(function (data) {
	            if (_.get(data, 'status.code') !== 200) {
	                output.error({ error: _.get(data, 'status.code') });
	                return;
	            }
	            output.success(dataFunction(data));
	        }).catch(function (error) {
	            output.error({ error: error });
	        });
	    }
	};

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	var ordersList = __webpack_require__(109);
	var order = __webpack_require__(100);
	var account = __webpack_require__(41);
	var user = __webpack_require__(28);
	var error = __webpack_require__(19);
	
	var _require = __webpack_require__(63),
	    updateOrderData = _require.updateOrderData;
	
	var updateOrdersList = [ordersList.filterToLocalStorage, ordersList.resetPaging, utils.queryRedirectFromState(['account', 'orders', 'computed', 'query']), [ordersList.getOrdersList, {
	    success: [utils.unset(['account', 'orders', 'list', 'data']), ordersList.addOrders, utils.unset(['account', 'orders', 'list', 'isNextPageLoading'])],
	    notFound: [utils.unset(['account', 'orders', 'list', 'data'])],
	    error: [utils.set(['account', 'orders', 'list', 'isError'], true)]
	}]];
	
	module.exports = {
	    scrolledToBottom: [ordersList.checkLoadingQueue, {
	        empty: [utils.set(['account', 'orders', 'list', 'isError'], false), utils.set(['account', 'orders', 'list', 'isNextPageLoading'], true), ordersList.incrementCurrentPage, [ordersList.getOrdersList, {
	            success: [ordersList.addOrders, utils.unset(['account', 'orders', 'list', 'isNextPageLoading'])],
	            notFound: [],
	            error: [utils.set(['account', 'orders', 'list', 'isError'], true)]
	        }]]
	    }],
	
	    selectFilter: [[user.isUnauthorized, {
	        yes: [],
	        no: [utils.setFromArgsToState('selectedValue', ['account', 'orders', 'list', 'selectedTypeFilter'])].concat(updateOrdersList)
	    }]],
	
	    togglePopup: [utils.togglePopupFromArgs],
	
	    setStatusFilterItem: [ordersList.setStatusFilterItem].concat(updateOrdersList),
	
	    setTypeFilterItem: [ordersList.setTypeFilterItem].concat(updateOrdersList),
	
	    toggleStatusFilter: [utils.togglePopup('statusFilter')],
	
	    updateOrdersList: [].concat(updateOrdersList),
	
	    filterOrdersListByText: [[ordersList.getActionByTextFilter, {
	        updateWithFilter: [utils.setFromArgsToState('textFilterValue', ['account', 'orders', 'list', 'filterText'])].concat(updateOrdersList),
	        updateWithoutFilter: [utils.unset(['account', 'orders', 'list', 'filterText'])].concat(updateOrdersList),
	        none: []
	    }]],
	
	    checkAssigned: [utils.setFromArgsToState('key', ['account', 'orders', 'list', 'selectedRadioFilter'])].concat(updateOrdersList),
	
	    onCreateOrder: [[account.fillOrderTypeInSelectedParameters, order.createOrder, {
	        success: [utils.set(['account', 'orders', 'list', 'isAllLoaded'], false), order.orderCreatedRedirect],
	        error: [error.internalError('orders-list.onCreateOrder')]
	    }]],
	
	    setTextFilterValue: [utils.setElementValue],
	
	    clearFilters: [utils.unset(['account', 'orders', 'list', 'filterText']), utils.setElementValueById('managerOrderTextFilter', ''), utils.unset(['account', 'orders', 'list', 'typeFilter']), utils.unset(['account', 'orders', 'list', 'stateFilter']), utils.set(['account', 'orders', 'list', 'selectedRadioFilter'], 'any')].concat(updateOrdersList),
	
	    onLoad: [[utils.isEqual(['user', 'isManager'], true), {
	        yes: [[utils.isEqual(['account', 'orders', 'shouldRestoreFilters'], true), {
	            yes: [ordersList.filterRestoreFromStorage],
	            no: [ordersList.filterToLocalStorage]
	        }], utils.setArgFromState('orderId', ['account', 'orders', 'queryOrderId'])].concat(updateOrderData, [utils.queryRedirectFromState(['account', 'orders', 'computed', 'query'])]),
	        no: []
	    }]]
	};

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var customOrder = __webpack_require__(42);
	var cities = __webpack_require__(99);
	var branches = __webpack_require__(143);
	var rubrics = __webpack_require__(114);
	var purposes = __webpack_require__(113);
	var mapClasses = __webpack_require__(144);
	var paymentTypes = __webpack_require__(146);
	var numberOfEmployees = __webpack_require__(145);
	var filials = __webpack_require__(203);
	var legalEntities = __webpack_require__(112);
	var addParams = __webpack_require__(142);
	var error = __webpack_require__(19);
	var utils = __webpack_require__(5);
	
	var setOrderParametersGroup = [customOrder.setAvailableParameters, cities.initTreeState, cities.initMapFilter, branches.initTreeState, rubrics.initTreeState, legalEntities.initTreeState, purposes.initTreeState, mapClasses.initTreeState, paymentTypes.initTreeState, numberOfEmployees.initTreeState, addParams.initExportColumnsState, addParams.initGreederColumns, filials.initOptions];
	
	var defaultToBranches = [utils.setArg('value', false), branches.setAll, utils.setArg('value', true), cities.getBranchesTreeFilter, branches.setSelection];
	
	module.exports = {
	    setOrderParametersGroup: setOrderParametersGroup,
	
	    getAvailableParametersGroup: [[customOrder.getAvailableParameters, {
	        success: [].concat(setOrderParametersGroup),
	        error: [error.internalError('customOrder.getAvailableParameters')]
	    }]],
	
	    defaultToBranches: defaultToBranches,
	
	    restoreStateGroup: [customOrder.restoreState, [customOrder.isTabSelected('branches'), {
	        yes: [[utils.isEqual(['account', 'orders', 'currentOrder', 'typeId'], 2), {
	            yes: [].concat(defaultToBranches),
	            no: []
	        }]],
	        no: []
	    }]]
	};

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var order = __webpack_require__(100);
	var analytics = __webpack_require__(7);
	var price = __webpack_require__(71);
	var orderGroups = __webpack_require__(30);
	var utils = __webpack_require__(5);
	var utilsSignals = __webpack_require__(11);
	var redirect = __webpack_require__(35);
	var error = __webpack_require__(19);
	var content = __webpack_require__(20);
	var user = __webpack_require__(28);
	var customOrder = __webpack_require__(42);
	var accountOrder = __webpack_require__(23);
	
	module.exports = {
	    onLoad: [].concat(utilsSignals.checkCookieEnabled, [price.initPrice], orderGroups.startRestoringSelectedParams, [customOrder.setShouldPersistToLocalStorage(true), [order.shouldRestoreFromLocalStorage, {
	        yes: [].concat(orderGroups.initSelectedParamsFromLocalStorageGroup),
	        no: []
	    }], price.setIsLoading(false), content.setIsLoading(false), utils.unset(['order', 'tooltip', 'hideDataChangeTooltip']), [utils.isPage('account'), {
	        yes: [accountOrder.setPriceFromOrder],
	        no: []
	    }]]),
	
	    onMakeOrderUnauthorized: [order.setShouldCreateOrderAfterLogin(true), [utils.isEqual(['bitrix', 'isBitrix'], true), {
	        yes: [redirect.redirect('/registration/extra')],
	        no: [redirect.redirect('/login')]
	    }]],
	
	    onCreateOrder: [content.setIsLoading(true), [user.isUnauthorized, {
	        yes: [utils.setArg('category', 'open_order_page_local_draft'), utils.setArg('action', 'click'), analytics.raiseArgsValueEvent, redirect.redirect('/account/orders?showLocal=true')],
	        no: [order.getSelectedParamsFromState, {
	            success: [order.fillOrderCreationParameters, [order.createOrder, {
	                success: [order.removeSavedSelectedParams, order.orderCreatedRedirect],
	                unauthorized: [order.setShouldCreateOrderAfterLogin(true), redirect.redirect('/login')],
	                error: [order.setShouldCreateOrderAfterLogin(false), error.internalError('order.createOrder')]
	            }]]
	        }]
	    }], content.setIsLoading(false)],
	
	    onReset: [].concat(orderGroups.resetDraftGroup),
	
	    showTooltip: [utils.set(['order', 'price', 'tooltipIsShow'], true)],
	
	    hideTooltip: [utils.unset(['order', 'price', 'tooltipIsShow'])],
	
	    clickCostButton: [utils.scrollTop],
	
	    tryRaiseCreateOrderWithFilterMap: [[customOrder.isTabSelected('map'), {
	        yes: [utils.setArg('category', 'create_order_with_filter_map'), utils.setArg('action', 'click'), analytics.raiseArgsValueEvent],
	        no: []
	    }]]
	};

/***/ }),
/* 76 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(48);
	var call = __webpack_require__(253);
	var isArrayIter = __webpack_require__(173);
	var anObject = __webpack_require__(6);
	var toLength = __webpack_require__(14);
	var getIterFn = __webpack_require__(189);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(6);
	var dPs = __webpack_require__(259);
	var enumBugKeys = __webpack_require__(169);
	var IE_PROTO = __webpack_require__(182)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(168)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(171).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(261);
	var hiddenKeys = __webpack_require__(169).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(261);
	var enumBugKeys = __webpack_require__(169);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 81 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(32);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(8);
	var dP = __webpack_require__(17);
	var DESCRIPTORS = __webpack_require__(16);
	var SPECIES = __webpack_require__(13)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(50);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 85 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(10);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ }),
/* 87 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var errorProps = ['description', 'fileName', 'lineNumber', 'endLineNumber', 'message', 'name', 'number', 'stack'];
	
	function Exception(message, node) {
	  var loc = node && node.loc,
	      line = undefined,
	      endLineNumber = undefined,
	      column = undefined,
	      endColumn = undefined;
	
	  if (loc) {
	    line = loc.start.line;
	    endLineNumber = loc.end.line;
	    column = loc.start.column;
	    endColumn = loc.end.column;
	
	    message += ' - ' + line + ':' + column;
	  }
	
	  var tmp = Error.prototype.constructor.call(this, message);
	
	  // Unfortunately errors are not enumerable in Chrome (at least), so `for prop in tmp` doesn't work.
	  for (var idx = 0; idx < errorProps.length; idx++) {
	    this[errorProps[idx]] = tmp[errorProps[idx]];
	  }
	
	  /* istanbul ignore else */
	  if (Error.captureStackTrace) {
	    Error.captureStackTrace(this, Exception);
	  }
	
	  try {
	    if (loc) {
	      this.lineNumber = line;
	      this.endLineNumber = endLineNumber;
	
	      // Work around issue under safari where we can't directly set the column value
	      /* istanbul ignore next */
	      if (Object.defineProperty) {
	        Object.defineProperty(this, 'column', {
	          value: column,
	          enumerable: true
	        });
	        Object.defineProperty(this, 'endColumn', {
	          value: endColumn,
	          enumerable: true
	        });
	      } else {
	        this.column = column;
	        this.endColumn = endColumn;
	      }
	    }
	  } catch (nop) {
	    /* Ignore if the browser is very particular */
	  }
	}
	
	Exception.prototype = new Error();
	
	exports['default'] = Exception;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(788);
	
	var Error = function () {
	    function Error() {
	        _classCallCheck(this, Error);
	
	        this.template = __webpack_require__(923);
	    }
	
	    Error.prototype.render = function render() {
	        var props = this.$context.props;
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, props, { css: css });
	        });
	    };
	
	    return Error;
	}();
	
	module.exports = {
	    constructor: Error
	};

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var treeFactory = __webpack_require__(388);
	var Filter = __webpack_require__(385);
	var Controls = __webpack_require__(384);
	var css = __webpack_require__(820);
	
	var _require = __webpack_require__(4),
	    cut = _require.cut;
	
	var $ = __webpack_require__(12);
	var treeSignals = __webpack_require__(228);
	
	var LIST_WRAPPER_SELECTOR = cut(css.fieldset);
	var LIST_SELECTOR = cut(css.contentTree);
	var SCROLLBAR_SELECTOR = cut(css.scrollbar);
	var SCROLLTRACK_SELECTOR = cut(css.scrolltrack);
	
	var FilterableTree = function () {
	    function FilterableTree() {
	        _classCallCheck(this, FilterableTree);
	
	        this.template = __webpack_require__(958);
	    }
	
	    FilterableTree.prototype.bind = function bind() {
	        this.initBaron();
	    };
	
	    FilterableTree.prototype.initBaron = function initBaron() {
	        var isInit = false;
	        var baron = __webpack_require__(64);
	        var elementId = this.$context.attributes.id;
	        var rootSelector = '#' + elementId + ' ' + LIST_WRAPPER_SELECTOR;
	
	        var root = document.getElementById(elementId);
	        if (root) {
	            var root1 = root.getElementsByClassName(LIST_WRAPPER_SELECTOR.substring(1))[0];
	            if (root1.getAttribute('data-baron-v')) {
	                isInit = true;
	            }
	        }
	        if (!isInit) {
	            baron({
	                root: rootSelector,
	                scroller: LIST_SELECTOR,
	                bar: SCROLLBAR_SELECTOR,
	                track: SCROLLTRACK_SELECTOR,
	                $: $
	            });
	        }
	    };
	
	    FilterableTree.prototype.render = function render() {
	        var props = this.$context.props;
	        var isSmallTreeBool = this.$context.props.isSmallTree === 'true';
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css }, { isSmallTreeBool: isSmallTreeBool }, props);
	        });
	    };
	
	    return FilterableTree;
	}();
	
	module.exports = function (_ref) {
	    var basePath = _ref.basePath,
	        customFilter = _ref.customFilter;
	
	    return {
	        constructor: FilterableTree,
	        children: [{
	            name: 'tree',
	            component: treeFactory(basePath),
	            props: {
	                onSubTreeCollapse: treeSignals.onSwitchSubTreeCollapse,
	                basePath: basePath
	            },
	            parentPropsMap: {
	                onItemCheck: 'onItemCheck',
	                checkboxIdPrefix: 'id',
	                isSmallTree: 'isSmallTree'
	            },
	            watcher: function watcher(attributes) {
	                var id = attributes['cat-id'];
	                return {
	                    item: basePath.concat('computed', 'items', id),
	                    expand: basePath.concat('expanded', id),
	                    autoExpand: basePath.concat('computed', 'autoExpand'),
	                    showDescendantsCount: basePath.concat('computed', 'showDescendantsCount'),
	                    isSelected: basePath.concat('selected', id, 'value'),
	                    showSelectedOnly: basePath.concat('computed', 'showSelectedOnly')
	                };
	            }
	        }, {
	            name: 'filter',
	            component: Filter,
	            props: {
	                onFilter: treeSignals.onFilter,
	                basePath: basePath
	            },
	            parentPropsMap: {
	                minLength: 'minFilterLength',
	                treeId: 'id'
	            },
	            watcher: {
	                hideFilter: basePath.concat('hideFilter')
	            }
	        }, {
	            name: 'controls',
	            component: Controls(customFilter),
	            props: {
	                onShowSelectedOnly: treeSignals.onShowSelectedOnly,
	                basePath: basePath
	            },
	            parentPropsMap: {
	                onSetAll: 'onSetAll',
	                treeId: 'id'
	            },
	            watcher: {
	                showSelectedOnly: basePath.concat('showSelectedOnly')
	            }
	        }]
	    };
	};

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var analytics = __webpack_require__(7);
	
	module.exports = {
	    raiseEvent: [analytics.raiseArgsValueEvent]
	};

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _monkey = __webpack_require__(119);
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	var type = {};
	/**
	 * Helpers
	 * --------
	 */
	
	/**
	 * Checking whether the given variable is of any of the given types.
	 *
	 * @todo   Optimize this function by dropping `some`.
	 *
	 * @param  {mixed} target  - Variable to test.
	 * @param  {array} allowed - Array of allowed types.
	 * @return {boolean}
	 */
	
	function anyOf(target, allowed) {
	  return allowed.some(function (t) {
	    return type[t](target);
	  });
	}
	/**
	 * Simple types
	 * -------------
	 */
	
	/**
	 * Checking whether the given variable is an array.
	 *
	 * @param  {mixed} target - Variable to test.
	 * @return {boolean}
	 */
	
	
	type.array = function (target) {
	  return Array.isArray(target);
	};
	/**
	 * Checking whether the given variable is an object.
	 *
	 * @param  {mixed} target - Variable to test.
	 * @return {boolean}
	 */
	
	
	type.object = function (target) {
	  return target && _typeof(target) === 'object' && !Array.isArray(target) && !(target instanceof Date) && !(target instanceof RegExp) && !(typeof Map === 'function' && target instanceof Map) && !(typeof Set === 'function' && target instanceof Set);
	};
	/**
	 * Checking whether the given variable is a string.
	 *
	 * @param  {mixed} target - Variable to test.
	 * @return {boolean}
	 */
	
	
	type.string = function (target) {
	  return typeof target === 'string';
	};
	/**
	 * Checking whether the given variable is a number.
	 *
	 * @param  {mixed} target - Variable to test.
	 * @return {boolean}
	 */
	
	
	type.number = function (target) {
	  return typeof target === 'number';
	};
	/**
	 * Checking whether the given variable is a function.
	 *
	 * @param  {mixed} target - Variable to test.
	 * @return {boolean}
	 */
	
	
	type["function"] = function (target) {
	  return typeof target === 'function';
	};
	/**
	 * Checking whether the given variable is a JavaScript primitive.
	 *
	 * @param  {mixed} target - Variable to test.
	 * @return {boolean}
	 */
	
	
	type.primitive = function (target) {
	  return target !== Object(target);
	};
	/**
	 * Complex types
	 * --------------
	 */
	
	/**
	 * Checking whether the given variable is a valid splicer.
	 *
	 * @param  {mixed} target    - Variable to test.
	 * @param  {array} [allowed] - Optional valid types in path.
	 * @return {boolean}
	 */
	
	
	type.splicer = function (target) {
	  if (!type.array(target) || target.length < 1) return false;
	  if (target.length > 1 && isNaN(+target[1])) return false;
	  return anyOf(target[0], ['number', 'function', 'object']);
	};
	/**
	 * Checking whether the given variable is a valid cursor path.
	 *
	 * @param  {mixed} target    - Variable to test.
	 * @param  {array} [allowed] - Optional valid types in path.
	 * @return {boolean}
	 */
	// Order is important for performance reasons
	
	
	var ALLOWED_FOR_PATH = ['string', 'number', 'function', 'object'];
	
	type.path = function (target) {
	  if (!target && target !== 0 && target !== '') return false;
	  return [].concat(target).every(function (step) {
	    return anyOf(step, ALLOWED_FOR_PATH);
	  });
	};
	/**
	 * Checking whether the given path is a dynamic one.
	 *
	 * @param  {mixed} path - The path to test.
	 * @return {boolean}
	 */
	
	
	type.dynamicPath = function (path) {
	  return path.some(function (step) {
	    return type["function"](step) || type.object(step);
	  });
	};
	/**
	 * Retrieve any monkey subpath in the given path or null if the path never comes
	 * across computed data.
	 *
	 * @param  {mixed} data - The data to test.
	 * @param  {array} path - The path to test.
	 * @return {boolean}
	 */
	
	
	type.monkeyPath = function (data, path) {
	  var subpath = [];
	  var c = data,
	      i,
	      l;
	
	  for (i = 0, l = path.length; i < l; i++) {
	    subpath.push(path[i]);
	    if (_typeof(c) !== 'object') return null;
	    c = c[path[i]];
	    if (c instanceof _monkey.Monkey) return subpath;
	  }
	
	  return null;
	};
	/**
	 * Check if the given object property is a lazy getter used by a monkey.
	 *
	 * @param  {mixed}   o           - The target object.
	 * @param  {string}  propertyKey - The property to test.
	 * @return {boolean}
	 */
	
	
	type.lazyGetter = function (o, propertyKey) {
	  var descriptor = Object.getOwnPropertyDescriptor(o, propertyKey);
	  return descriptor && descriptor.get && descriptor.get.isLazyGetter === true;
	};
	/**
	 * Returns the type of the given monkey definition or `null` if invalid.
	 *
	 * @param  {mixed} definition - The definition to check.
	 * @return {string|null}
	 */
	
	
	type.monkeyDefinition = function (definition) {
	  if (type.object(definition)) {
	    if (!type["function"](definition.get) || definition.cursors && (!type.object(definition.cursors) || !Object.keys(definition.cursors).every(function (k) {
	      return type.path(definition.cursors[k]);
	    }))) return null;
	    return 'object';
	  } else if (type.array(definition)) {
	    var offset = 1;
	    if (type.object(definition[definition.length - 1])) offset++;
	    if (!type["function"](definition[definition.length - offset]) || !definition.slice(0, -offset).every(function (p) {
	      return type.path(p);
	    })) return null;
	    return 'array';
	  }
	
	  return null;
	};
	/**
	 * Checking whether the given watcher definition is valid.
	 *
	 * @param  {mixed}   definition - The definition to check.
	 * @return {boolean}
	 */
	
	
	type.watcherMapping = function (definition) {
	  return type.object(definition) && Object.keys(definition).every(function (k) {
	    return type.path(definition[k]);
	  });
	};
	/**
	 * Checking whether the given string is a valid operation type.
	 *
	 * @param  {mixed} string - The string to test.
	 * @return {boolean}
	 */
	// Ordered by likeliness
	
	
	var VALID_OPERATIONS = ['set', 'apply', 'push', 'unshift', 'concat', 'pop', 'shift', 'deepMerge', 'merge', 'splice', 'unset'];
	
	type.operationType = function (string) {
	  return typeof string === 'string' && !!~VALID_OPERATIONS.indexOf(string);
	};
	
	var _default = type;
	exports["default"] = _default;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(46);
	var TAG = __webpack_require__(13)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 93 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(17).f;
	var has = __webpack_require__(37);
	var TAG = __webpack_require__(13)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var defined = __webpack_require__(52);
	var fails = __webpack_require__(9);
	var spaces = __webpack_require__(185);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ }),
/* 96 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./type')} */
	module.exports = TypeError;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(3);
	var computed = __webpack_require__(202);
	var computedIndex = __webpack_require__(110);
	
	var _require = __webpack_require__(72),
	    thenWithErrorHandling = _require.thenWithErrorHandling;
	
	var debouncedRegisterAuthUser = _.debounce(registerAuthUser, 1000);
	
	function registerAuthUser(args, state, output, _ref) {
	    var locator = _ref.locator,
	        context = _ref.context;
	
	    var formData = state.get(['registration', 'form']);
	
	    var registerData = {
	        grant_type: 'email',
	        email: formData.email,
	        password: formData.password
	    };
	
	    var queryData = {
	        client_id: 'hermes',
	        locale: 'ru_RU',
	        template: '/static/mail/template/register.twig'
	    };
	
	    var API = locator.resolve('api');
	    var request = API.registerAuthUser(context, { registerData: registerData, queryData: queryData });
	
	    request.then(function (data) {
	        var code = _.get(data, 'status.code');
	
	        if (code === 201) {
	            output.success({ auth: _.get(data, 'content') });
	            return;
	        }
	
	        var statusMap = {
	            EntityExists: 'emailAlreadyUsed'
	        };
	
	        var error = _.get(data, 'content.error');
	
	        var status = statusMap[error];
	
	        output[status]({ data: data });
	    }).catch(function (error) {
	        return output.error({ error: error });
	    });
	}
	
	module.exports = {
	    setComputedFields: function setComputedFields(args, state) {
	        computed.registerButton(state);
	        computed.setRepeatPasswordError(state);
	        computed.isUserTypeSelectEnabled(state);
	        computedIndex.computeCountryDropdown(state, ['registration']);
	    },
	    getCountries: function getCountries(args, state, output, _ref2) {
	        var locator = _ref2.locator,
	            context = _ref2.context;
	
	        var API = locator.resolve('api');
	        var request = API.getCountries(context, locator);
	
	        thenWithErrorHandling(request, function (data) {
	            return { countries: _.get(data, 'content') };
	        }, output);
	    },
	    fillLoginForm: function fillLoginForm(args, state) {
	        var loginForm = {
	            password: state.get(['registration', 'form', 'password']),
	            username: state.get(['registration', 'form', 'email'])
	        };
	
	        state.set(['login', 'form'], loginForm);
	    },
	
	
	    debouncedRegisterAuthUser: debouncedRegisterAuthUser,
	
	    registerHermesUser: function registerHermesUser(_ref3, state, output, _ref4) {
	        var auth = _ref3.auth;
	        var locator = _ref4.locator,
	            context = _ref4.context;
	
	        var formData = state.get(['registration', 'form']);
	        var token = auth.access_token;
	
	        var requiredFields = ['city', 'email', 'firstName', 'middleName', 'lastName', 'phone', 'isAcceptPersonalDataProcessing', 'userType', 'countryId', 'legalAddress'];
	        if (formData.userType === 2) {
	            requiredFields = requiredFields.concat(['organization', 'kpp']);
	        } else if (formData.userType === 3) {
	            requiredFields = requiredFields.concat(['organization']);
	        }
	        var registerData = _.chain(formData).pick(requiredFields).omitBy(_.isUndefined).value();
	
	        if (formData.userType === 2) {
	            switch (formData.countryId) {
	                case 1:
	                    registerData.inn = formData.inn10;
	                    break;
	                case 4:
	                    registerData.inn = formData.bin;
	                    break;
	                default:
	                    break;
	            }
	        } else if (formData.userType === 3) {
	            switch (formData.countryId) {
	                case 1:
	                    registerData.inn = formData.inn12;
	                    break;
	                case 4:
	                    registerData.inn = formData.bin;
	                    break;
	                default:
	                    break;
	            }
	        }
	
	        var API = locator.resolve('api');
	        var request = API.registerHermesUser(context, locator, { registerData: registerData, token: token });
	
	        request.then(function (data) {
	            var code = _.get(data, 'status.code');
	            var status = _.get(data, 'content.status');
	
	            if (code !== 200) {
	                output[status]({ code: code });
	                return;
	            }
	
	            output[status]({ data: data });
	        }).catch(function (error) {
	            return output.error({ error: error });
	        });
	    },
	    acceptPersonalDataProcessing: function acceptPersonalDataProcessing(args, state) {
	        state.set(['registration', 'form', 'isAcceptPersonalDataProcessing'], true);
	    },
	    declinePersonalDataProcessing: function declinePersonalDataProcessing(args, state) {
	        state.set(['registration', 'form', 'isAcceptPersonalDataProcessing'], false);
	    },
	    setRegistrationProperty: function setRegistrationProperty(_ref5, state) {
	        var path = _ref5.path,
	            value = _ref5.value;
	
	        state.set(['registration', 'form', path], value);
	    }
	};

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var treeHelper = __webpack_require__(57);
	var exportColumnHelper = __webpack_require__(308);
	var _ = __webpack_require__(3);
	
	function _setAll(originalPath, treePath, propertyName) {
	    return function (_ref, state) {
	        var value = _ref.value;
	
	        treeHelper.setAllSelection(state, originalPath, treePath, value);
	
	        if (value === true) {
	            exportColumnHelper.setExportColumnIsChecked({ value: value, propertyName: propertyName }, state);
	        }
	    };
	}
	
	module.exports = {
	    initTreeState: function initTreeState(args, state, originalPath, treePath) {
	        treeHelper.initTreeUiState(state, originalPath, treePath);
	    },
	    changeValue: function changeValue(_ref2, state, originalPath, treePath, propertyName) {
	        var path = _ref2.path,
	            value = _ref2.value;
	
	        treeHelper.changeTreeNodeValue(state, originalPath, treePath, path, value);
	
	        if (value === true) {
	            exportColumnHelper.setExportColumnIsChecked({ value: value, propertyName: propertyName }, state);
	        }
	    },
	    setAll: function setAll(_ref3, state, originalPath, treePath, propertyName) {
	        var value = _ref3.value;
	
	        var func = _setAll(originalPath, treePath, propertyName);
	        func({ value: value }, state);
	    },
	    tryUnsetSelected: function tryUnsetSelected(_ref4, state, originalPath, treePath, propertyName) {
	        var path = _ref4.path;
	
	        exportColumnHelper.tryUnsetAllSelected({ path: path, propertyName: propertyName,
	            setAllFunction: _setAll(originalPath, treePath, propertyName) }, state);
	    },
	    clearFilter: function clearFilter(args, state, treePath, filterName) {
	        treeHelper.clearFilter(state, treePath, filterName);
	    }
	};

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(3);
	var treeHelper = __webpack_require__(57);
	
	var _require = __webpack_require__(111),
	    clearFilter = _require.clearFilter;
	
	var CITIES_TREE_BASE_PATH = ['order', 'cities', 'tree'];
	var CITIES_ORIGINAL_DATA_PATH = ['order', 'originalParameters', 'cities'];
	
	module.exports = {
	    recalculateFlags: recalculateFlags,
	
	    initTreeState: function initTreeState(args, state) {
	        treeHelper.initTreeUiState(state, CITIES_ORIGINAL_DATA_PATH, CITIES_TREE_BASE_PATH);
	    },
	    changeValue: function changeValue(_ref, state) {
	        var path = _ref.path,
	            value = _ref.value;
	
	        treeHelper.changeTreeNodeValue(state, CITIES_ORIGINAL_DATA_PATH, CITIES_TREE_BASE_PATH, path, value);
	
	        recalculateFlags(state);
	    },
	    changeBranchSelection: function changeBranchSelection(_ref2, state) {
	        var value = _ref2.value,
	            branchId = _ref2.branchId;
	
	        treeHelper.selectBranch(state, CITIES_ORIGINAL_DATA_PATH, CITIES_TREE_BASE_PATH, value, branchId);
	
	        recalculateFlags(state);
	    },
	    setSelection: function setSelection(_ref3, state) {
	        var value = _ref3.value,
	            filter = _ref3.filter;
	
	        treeHelper.setValueByFilter(state, CITIES_ORIGINAL_DATA_PATH, CITIES_TREE_BASE_PATH, value, filter);
	
	        recalculateFlags(state);
	    },
	    setAll: function setAll(_ref4, state) {
	        var value = _ref4.value;
	
	        treeHelper.setAllSelection(state, CITIES_ORIGINAL_DATA_PATH, CITIES_TREE_BASE_PATH, value);
	        recalculateFlags(state);
	    },
	    toggleFilterType: function toggleFilterType(args, state) {
	        var path = CITIES_TREE_BASE_PATH.concat('showFilterTreeInput');
	        var value = state.get(path) || false;
	
	        state.set(path, !value);
	
	        state.set(CITIES_TREE_BASE_PATH.concat('hideFilter'), !value);
	    },
	    clearFilter: function clearFilter(args, state) {
	        treeHelper.clearFilter(state, CITIES_TREE_BASE_PATH, 'cities');
	        recalculateFlags(state);
	    },
	    localSaveMapFilter: function localSaveMapFilter(args, state) {
	        var mapFilter = state.get(['order', 'cities', 'mapFilter']);
	        if (mapFilter) {
	            state.set(['order', 'cities', 'mapFilterInit'], mapFilter);
	        }
	    },
	    initMapFilter: function initMapFilter(_ref5, state) {
	        var selectedParameters = _ref5.selectedParameters;
	
	        if (selectedParameters) {
	            state.set(['order', 'cities', 'mapFilterInit'], selectedParameters.mapFilter);
	        }
	    },
	    getBranchesTreeFilter: function getBranchesTreeFilter(args, state) {
	        var leafs = state.get(CITIES_TREE_BASE_PATH.concat('computed', 'leafs'));
	        var selected = state.get(CITIES_TREE_BASE_PATH.concat('selected'));
	        var selectedCities = treeHelper.getSelectedLeafs(leafs, selected);
	        var defaultCities = _.filter(state.get(CITIES_ORIGINAL_DATA_PATH), { isDefaultCity: true });
	        var selectedBranches = _.map(_.filter(defaultCities, function (city) {
	            return selectedCities.includes(city.code);
	        }), function (x) {
	            return x.branchId;
	        });
	        args.filter = function (node) {
	            return selectedBranches.includes(Number(node.code));
	        };
	    }
	};
	
	function recalculateFlags(state) {
	    var selected = state.get(CITIES_TREE_BASE_PATH.concat('selected'));
	    var original = state.get(CITIES_ORIGINAL_DATA_PATH);
	    var hasRussian = false;
	    var hasNonRussian = false;
	    _.forEach(selected, function (item, key) {
	        if (item.value === false || key === '0') {
	            return;
	        }
	        if (original[key].isRussian === true) {
	            hasRussian = true;
	            return false;
	        }
	    });
	    _.forEach(selected, function (item, key) {
	        if (item.value === false || key === '0') {
	            return;
	        }
	        if (original[key].isRussian === false) {
	            hasNonRussian = true;
	            return false;
	        }
	    });
	
	    if (hasRussian === true) {
	        state.set(CITIES_TREE_BASE_PATH.concat('hasRussians'), true);
	    } else {
	        state.unset(CITIES_TREE_BASE_PATH.concat('hasRussians'));
	    }
	
	    if (hasNonRussian === true) {
	        state.set(CITIES_TREE_BASE_PATH.concat('hasNonRussians'), true);
	    } else {
	        state.unset(CITIES_TREE_BASE_PATH.concat('hasNonRussians'));
	    }
	}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(3);
	var priceActions = __webpack_require__(71);
	
	var _require = __webpack_require__(72),
	    thenWithErrorHandling = _require.thenWithErrorHandling;
	
	var utils = __webpack_require__(4);
	
	module.exports = {
	    getDraftOrder: function getDraftOrder(args, state, output, _ref) {
	        var context = _ref.context,
	            locator = _ref.locator;
	
	        var role = state.get(['user', 'role']);
	
	        if (role !== 'client') {
	            output.error({ error: 'role not client' });
	            return;
	        }
	
	        var api = locator.resolve('api');
	        var request = api.getUserDraftOrder(context, locator);
	        request.then(function (response) {
	            var code = _.get(response, 'status.code');
	            if (code !== 200) {
	                output.error({ error: code });
	                return;
	            }
	
	            var _$get = _.get(response, 'content'),
	                selectedParameters = _$get.selectedParameters,
	                availableParameters = _$get.availableParameters,
	                price = _$get.price,
	                id = _$get.id,
	                isNeedToConfirmDataChanged = _$get.isNeedToConfirmDataChanged,
	                typeId = _$get.typeId;
	
	            output.success({ selectedParameters: selectedParameters, availableParameters: availableParameters, price: price, id: id, isNeedToConfirmDataChanged: isNeedToConfirmDataChanged, typeId: typeId });
	        }).catch(function (error) {
	            return output.error({ error: error });
	        });
	    },
	    hasDraftOrderLoaded: function hasDraftOrderLoaded(args, state, output) {
	        var orderId = state.get(['order', 'draft', 'id']);
	
	        if (orderId) {
	            output.yes({ orderId: orderId });
	            return;
	        }
	        output.no();
	    },
	    archiveOrder: function archiveOrder(_ref2, state, output, _ref3) {
	        var orderId = _ref2.orderId;
	        var locator = _ref3.locator,
	            context = _ref3.context;
	
	        var API = locator.resolve('api');
	
	        var request = API.archiveOrder(context, locator, { orderId: orderId });
	        thenWithErrorHandling(request, function (data) {
	            return data;
	        }, output);
	    },
	    setShouldRestoreFromLocalStorage: function setShouldRestoreFromLocalStorage(shouldRestore) {
	        return function (args, state) {
	            return state.set(['order', 'shouldRestoreFromLocalStorage'], shouldRestore);
	        };
	    },
	    shouldRestoreFromLocalStorage: function shouldRestoreFromLocalStorage(args, state, output) {
	        var shouldRestore = state.get(['order', 'shouldRestoreFromLocalStorage']);
	
	        if (shouldRestore) {
	            output.yes();
	        } else {
	            output.no();
	        }
	    },
	    fillOrderCreationParameters: function fillOrderCreationParameters(_ref4, state, output, _ref5) {
	        var selectedParameters = _ref4.selectedParameters;
	        var context = _ref5.context,
	            locator = _ref5.locator;
	
	        if (context.isServer) {
	            return;
	        }
	        var window = locator.resolve('window');
	        var serialized = window.localStorage.getItem('local_draft');
	
	        var localChanges = null;
	        if (serialized) {
	            try {
	                localChanges = JSON.parse(serialized);
	            } catch (e) {}
	        }
	
	        selectedParameters = {
	            parameters: selectedParameters
	        };
	
	        if (localChanges) {
	            selectedParameters.paymentTypeId = _.get(localChanges, 'selectedPaymentTypeId');
	            selectedParameters.necessaryDocumentsIds = _.map(_.get(localChanges, 'necessaryDocuments.addOrRemove', []), 'documentTypeId');
	        }
	
	        output({ selectedParameters: selectedParameters });
	    },
	    removeSavedSelectedParams: function removeSavedSelectedParams(args, state, output, _ref6) {
	        var context = _ref6.context,
	            locator = _ref6.locator;
	
	        if (context.isServer) {
	            return;
	        }
	        var window = locator.resolve('window');
	        window.localStorage.removeItem('selected_params');
	    },
	    getSelectedParamsFromState: function getSelectedParamsFromState(args, state, output) {
	        var selectedParameters = priceActions.getSelectedParameters(state);
	        output.success({ selectedParameters: selectedParameters });
	    },
	    createOrder: function createOrder(_ref7, state, output, _ref8) {
	        var selectedParameters = _ref7.selectedParameters;
	        var context = _ref8.context,
	            locator = _ref8.locator;
	
	        var api = locator.resolve('api');
	        var request = api.postOrderParameters(context, locator, { selectedParameters: selectedParameters });
	        request.then(function (response) {
	            var code = _.get(response, 'status.code');
	            if (code === 401) {
	                output.unauthorized();
	                return;
	            }
	            if (code !== 201) {
	                output.error({ error: code });
	                return;
	            }
	            var orderData = _.get(response, 'content');
	            output.success({ orderData: orderData });
	        }).catch(function (error) {
	            return output.error({ error: error });
	        });
	    },
	    setShouldCreateOrderAfterLogin: function setShouldCreateOrderAfterLogin(value) {
	        return function (args, state, output, _ref9) {
	            var context = _ref9.context,
	                locator = _ref9.locator;
	
	            if (context.isServer) {
	                return;
	            }
	            var window = locator.resolve('window');
	
	            if (value) {
	                window.localStorage.setItem('should_create_order_after_login', 'yes');
	            } else {
	                window.localStorage.removeItem('should_create_order_after_login');
	            }
	        };
	    },
	    shouldCreateOrderAfterLogin: function shouldCreateOrderAfterLogin(args, state, output, _ref10) {
	        var context = _ref10.context,
	            locator = _ref10.locator;
	
	        if (context.isServer) {
	            output.no();
	            return;
	        }
	        var window = locator.resolve('window');
	        var value = window.localStorage.getItem('should_create_order_after_login');
	
	        if (value === 'yes') {
	            output.yes();
	            return;
	        }
	
	        var localDraft = window.localStorage.getItem('local_draft');
	        if (localDraft) {
	            output.yes();
	            return;
	        }
	
	        output.no();
	    },
	    orderCreatedRedirect: function orderCreatedRedirect(_ref11, state, output, _ref12) {
	        var orderData = _ref11.orderData;
	        var context = _ref12.context;
	
	        var location = getOrderCreatedRedirectLocation(orderData.id || '', state);
	        context.redirect(utils.patchQueryWithUtm(location, state));
	    },
	    orderCreatedLocationRedirect: function orderCreatedLocationRedirect(_ref13, state) {
	        var orderData = _ref13.orderData;
	
	        var location = getOrderCreatedRedirectLocation(orderData.id || '', state);
	        window.location = location;
	    },
	    setOrderLocationToState: function setOrderLocationToState(statePath) {
	        return function (_ref14, state) {
	            var orderId = _ref14.orderId;
	
	            var orderLocation = getOrderCreatedRedirectLocation(orderId || '', state);
	            state.set(statePath, orderLocation);
	        };
	    }
	};
	
	function getOrderCreatedRedirectLocation(orderId, state) {
	    var role = state.get(['user', 'role']);
	    var pageName = 'account';
	    if (role === 'manager') {
	        pageName = 'manager';
	    }
	    return '/' + pageName + '/orders/' + orderId;
	}

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(843);
	
	var Preloader = function () {
	    function Preloader() {
	        _classCallCheck(this, Preloader);
	
	        this.template = __webpack_require__(987);
	    }
	
	    Preloader.prototype.render = function render() {
	        var props = this.$context.props;
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, props, { css: css });
	        });
	    };
	
	    return Preloader;
	}();
	
	module.exports = {
	    constructor: Preloader
	};

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var statistic = __webpack_require__(199);
	var utils = __webpack_require__(5);
	var error = __webpack_require__(19);
	
	var _require = __webpack_require__(11),
	    usingLock = _require.usingLock;
	
	var getStatisticChunk = [statistic.addStartIndexesToArgs, [statistic.getStatisticChunk, {
	    success: [statistic.setRows],
	    error: [error.internalError],
	    orderChanged: []
	}]];
	
	module.exports = {
	    getStatisticChunk: getStatisticChunk,
	
	    updateHeaderPosition: [utils.setFromArgsToState('topHeaderOffset', ['account', 'statistic', 'header', 'topOffset']), utils.setFromArgsToState('headerLeftOffsetLeft', ['account', 'statistic', 'header', 'left', 'offset', 'left'])],
	
	    expandHeader: [utils.toggleBool()],
	
	    toggleItem: function toggleItem(path, value) {
	        return [utils.toggleItem(path, value)].concat(getStatisticChunk);
	    },
	
	
	    toggleTranspose: [utils.toggleBool(['account', 'statistic', 'isTransposed']), statistic.transpose, utils.queryRedirectFromState(['account', 'statistic', 'computed', 'query'])].concat(getStatisticChunk),
	
	    downloadExcel: [].concat(usingLock(['account', 'statistic', 'downloadExcelLock'], [[statistic.downloadExcel, {
	        success: [],
	        error: [error.internalError]
	    }]])),
	
	    switchCityBranchMode: [utils.toggleBool(['account', 'statistic', 'isByBranch']), utils.queryRedirectFromState(['account', 'statistic', 'computed', 'query'])].concat(getStatisticChunk)
	};

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.arrayFrom = arrayFrom;
	exports.before = before;
	exports.coercePath = coercePath;
	exports.getIn = getIn;
	exports.makeError = makeError;
	exports.hashPath = hashPath;
	exports.solveRelativePath = solveRelativePath;
	exports.solveUpdate = solveUpdate;
	exports.splice = splice;
	exports.uniqid = exports.deepMerge = exports.shallowMerge = exports.deepFreeze = exports.freeze = exports.deepClone = exports.shallowClone = exports.Archive = void 0;
	
	var _monkey = __webpack_require__(119);
	
	var _type = _interopRequireDefault(__webpack_require__(91));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	var hasOwnProp = {}.hasOwnProperty;
	/**
	 * Function returning the index of the first element of a list matching the
	 * given predicate.
	 *
	 * @param  {array}     a  - The target array.
	 * @param  {function}  fn - The predicate function.
	 * @return {mixed}        - The index of the first matching item or -1.
	 */
	
	function index(a, fn) {
	  var i, l;
	
	  for (i = 0, l = a.length; i < l; i++) {
	    if (fn(a[i])) return i;
	  }
	
	  return -1;
	}
	/**
	 * Efficient slice function used to clone arrays or parts of them.
	 *
	 * @param  {array} array - The array to slice.
	 * @return {array}       - The sliced array.
	 */
	
	
	function slice(array) {
	  var newArray = new Array(array.length);
	  var i, l;
	
	  for (i = 0, l = array.length; i < l; i++) {
	    newArray[i] = array[i];
	  }
	
	  return newArray;
	}
	/**
	 * Archive abstraction
	 *
	 * @constructor
	 * @param {integer} size - Maximum number of records to store.
	 */
	
	
	var Archive =
	/*#__PURE__*/
	function () {
	  function Archive(size) {
	    _classCallCheck(this, Archive);
	
	    this.size = size;
	    this.records = [];
	  }
	  /**
	   * Method retrieving the records.
	   *
	   * @return {array} - The records.
	   */
	
	
	  _createClass(Archive, [{
	    key: "get",
	    value: function get() {
	      return this.records;
	    }
	    /**
	     * Method adding a record to the archive
	     *
	     * @param {object}  record - The record to store.
	     * @return {Archive}       - The archive itself for chaining purposes.
	     */
	
	  }, {
	    key: "add",
	    value: function add(record) {
	      this.records.unshift(record); // If the number of records is exceeded, we truncate the records
	
	      if (this.records.length > this.size) this.records.length = this.size;
	      return this;
	    }
	    /**
	     * Method clearing the records.
	     *
	     * @return {Archive} - The archive itself for chaining purposes.
	     */
	
	  }, {
	    key: "clear",
	    value: function clear() {
	      this.records = [];
	      return this;
	    }
	    /**
	     * Method to go back in time.
	     *
	     * @param {integer} steps - Number of steps we should go back by.
	     * @return {number}       - The last record.
	     */
	
	  }, {
	    key: "back",
	    value: function back(steps) {
	      var record = this.records[steps - 1];
	      if (record) this.records = this.records.slice(steps);
	      return record;
	    }
	  }]);
	
	  return Archive;
	}();
	/**
	 * Function creating a real array from what should be an array but is not.
	 * I'm looking at you nasty `arguments`...
	 *
	 * @param  {mixed} culprit - The culprit to convert.
	 * @return {array}         - The real array.
	 */
	
	
	exports.Archive = Archive;
	
	function arrayFrom(culprit) {
	  return slice(culprit);
	}
	/**
	 * Function decorating one function with another that will be called before the
	 * decorated one.
	 *
	 * @param  {function} decorator - The decorating function.
	 * @param  {function} fn        - The function to decorate.
	 * @return {function}           - The decorated function.
	 */
	
	
	function before(decorator, fn) {
	  return function () {
	    decorator.apply(null, arguments);
	    fn.apply(null, arguments);
	  };
	}
	/**
	 * Function cloning the given regular expression. Supports `y` and `u` flags
	 * already.
	 *
	 * @param  {RegExp} re - The target regular expression.
	 * @return {RegExp}    - The cloned regular expression.
	 */
	
	
	function cloneRegexp(re) {
	  var pattern = re.source;
	  var flags = '';
	  if (re.global) flags += 'g';
	  if (re.multiline) flags += 'm';
	  if (re.ignoreCase) flags += 'i';
	  if (re.sticky) flags += 'y';
	  if (re.unicode) flags += 'u';
	  return new RegExp(pattern, flags);
	}
	/**
	 * Function cloning the given variable.
	 *
	 * @todo: implement a faster way to clone an array.
	 *
	 * @param  {boolean} deep - Should we deep clone the variable.
	 * @param  {mixed}   item - The variable to clone
	 * @return {mixed}        - The cloned variable.
	 */
	
	
	function cloner(deep, item) {
	  if (!item || _typeof(item) !== 'object' || item instanceof Error || item instanceof _monkey.MonkeyDefinition || item instanceof _monkey.Monkey || 'ArrayBuffer' in global && item instanceof ArrayBuffer) return item; // Array
	
	  if (_type["default"].array(item)) {
	    if (deep) {
	      var a = new Array(item.length);
	
	      for (var i = 0, l = item.length; i < l; i++) {
	        a[i] = cloner(true, item[i]);
	      }
	
	      return a;
	    }
	
	    return slice(item);
	  } // Date
	
	
	  if (item instanceof Date) return new Date(item.getTime()); // RegExp
	
	  if (item instanceof RegExp) return cloneRegexp(item); // Object
	
	  if (_type["default"].object(item)) {
	    var o = {}; // NOTE: could be possible to erase computed properties through `null`.
	
	    var props = Object.getOwnPropertyNames(item);
	
	    for (var _i = 0, _l = props.length; _i < _l; _i++) {
	      var name = props[_i];
	      var k = Object.getOwnPropertyDescriptor(item, name);
	
	      if (k.enumerable === true) {
	        if (k.get && k.get.isLazyGetter) {
	          Object.defineProperty(o, name, {
	            get: k.get,
	            enumerable: true,
	            configurable: true
	          });
	        } else {
	          o[name] = deep ? cloner(true, item[name]) : item[name];
	        }
	      } else if (k.enumerable === false) {
	        Object.defineProperty(o, name, {
	          value: deep ? cloner(true, k.value) : k.value,
	          enumerable: false,
	          writable: true,
	          configurable: true
	        });
	      }
	    }
	
	    return o;
	  }
	
	  return item;
	}
	/**
	 * Exporting shallow and deep cloning functions.
	 */
	
	
	var shallowClone = cloner.bind(null, false),
	    deepClone = cloner.bind(null, true);
	exports.deepClone = deepClone;
	exports.shallowClone = shallowClone;
	
	/**
	 * Coerce the given variable into a full-fledged path.
	 *
	 * @param  {mixed} target - The variable to coerce.
	 * @return {array}        - The array path.
	 */
	function coercePath(target) {
	  if (target || target === 0 || target === '') return target;
	  return [];
	}
	/**
	 * Function comparing an object's properties to a given descriptive
	 * object.
	 *
	 * @param  {object} object      - The object to compare.
	 * @param  {object} description - The description's mapping.
	 * @return {boolean}            - Whether the object matches the description.
	 */
	
	
	function compare(object, description) {
	  var ok = true,
	      k; // If we reached here via a recursive call, object may be undefined because
	  // not all items in a collection will have the same deep nesting structure.
	
	  if (!object) return false;
	
	  for (k in description) {
	    if (_type["default"].object(description[k])) {
	      ok = ok && compare(object[k], description[k]);
	    } else if (_type["default"].array(description[k])) {
	      ok = ok && !!~description[k].indexOf(object[k]);
	    } else {
	      if (object[k] !== description[k]) return false;
	    }
	  }
	
	  return ok;
	}
	/**
	 * Function freezing the given variable if possible.
	 *
	 * @param  {boolean} deep - Should we recursively freeze the given objects?
	 * @param  {object}  o    - The variable to freeze.
	 * @return {object}    - The merged object.
	 */
	
	
	function freezer(deep, o) {
	  if (_typeof(o) !== 'object' || o === null || o instanceof _monkey.Monkey) return;
	  Object.freeze(o);
	  if (!deep) return;
	
	  if (Array.isArray(o)) {
	    // Iterating through the elements
	    var i, l;
	
	    for (i = 0, l = o.length; i < l; i++) {
	      deepFreeze(o[i]);
	    }
	  } else {
	    var p, k;
	
	    for (k in o) {
	      if (_type["default"].lazyGetter(o, k)) continue;
	      p = o[k];
	      if (!p || !hasOwnProp.call(o, k) || _typeof(p) !== 'object' || Object.isFrozen(p)) continue;
	      deepFreeze(p);
	    }
	  }
	}
	
	var freeze = freezer.bind(null, false),
	    deepFreeze = freezer.bind(null, true);
	exports.deepFreeze = deepFreeze;
	exports.freeze = freeze;
	
	/**
	 * Function retrieving nested data within the given object and according to
	 * the given path.
	 *
	 * @todo: work if dynamic path hit objects also.
	 * @todo: memoized perfgetters.
	 *
	 * @param  {object}  object - The object we need to get data from.
	 * @param  {array}   path   - The path to follow.
	 * @return {object}  result            - The result.
	 * @return {mixed}   result.data       - The data at path, or `undefined`.
	 * @return {array}   result.solvedPath - The solved path or `null`.
	 * @return {boolean} result.exists     - Does the path exists in the tree?
	 */
	var NOT_FOUND_OBJECT = {
	  data: undefined,
	  solvedPath: null,
	  exists: false
	};
	
	function getIn(object, path) {
	  if (!path) return NOT_FOUND_OBJECT;
	  var solvedPath = [];
	  var exists = true,
	      c = object,
	      idx,
	      i,
	      l;
	
	  for (i = 0, l = path.length; i < l; i++) {
	    if (!c) return {
	      data: undefined,
	      solvedPath: solvedPath.concat(path.slice(i)),
	      exists: false
	    };
	
	    if (typeof path[i] === 'function') {
	      if (!_type["default"].array(c)) return NOT_FOUND_OBJECT;
	      idx = index(c, path[i]);
	      if (!~idx) return NOT_FOUND_OBJECT;
	      solvedPath.push(idx);
	      c = c[idx];
	    } else if (_typeof(path[i]) === 'object') {
	      if (!_type["default"].array(c)) return NOT_FOUND_OBJECT;
	      idx = index(c, function (e) {
	        return compare(e, path[i]);
	      });
	      if (!~idx) return NOT_FOUND_OBJECT;
	      solvedPath.push(idx);
	      c = c[idx];
	    } else {
	      solvedPath.push(path[i]);
	      exists = _typeof(c) === 'object' && path[i] in c;
	      c = c[path[i]];
	    }
	  }
	
	  return {
	    data: c,
	    solvedPath: solvedPath,
	    exists: exists
	  };
	}
	/**
	 * Little helper returning a JavaScript error carrying some data with it.
	 *
	 * @param  {string} message - The error message.
	 * @param  {object} [data]  - Optional data to assign to the error.
	 * @return {Error}          - The created error.
	 */
	
	
	function makeError(message, data) {
	  var err = new Error(message);
	
	  for (var k in data) {
	    err[k] = data[k];
	  }
	
	  return err;
	}
	/**
	 * Function taking n objects to merge them together.
	 * Note 1): the latter object will take precedence over the first one.
	 * Note 2): the first object will be mutated to allow for perf scenarios.
	 * Note 3): this function will consider monkeys as leaves.
	 *
	 * @param  {boolean}   deep    - Whether the merge should be deep or not.
	 * @param  {...object} objects - Objects to merge.
	 * @return {object}            - The merged object.
	 */
	
	
	function merger(deep) {
	  for (var _len = arguments.length, objects = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    objects[_key - 1] = arguments[_key];
	  }
	
	  var o = objects[0];
	  var t, i, l, k;
	
	  for (i = 1, l = objects.length; i < l; i++) {
	    t = objects[i];
	
	    for (k in t) {
	      if (deep && _type["default"].object(t[k]) && !(t[k] instanceof _monkey.Monkey) && k !== '__proto__' && k !== 'constructor' && k !== 'prototype') {
	        o[k] = merger(true, o[k] || {}, t[k]);
	      } else {
	        o[k] = t[k];
	      }
	    }
	  }
	
	  return o;
	}
	/**
	 * Exporting both `shallowMerge` and `deepMerge` functions.
	 */
	
	
	var shallowMerge = merger.bind(null, false),
	    deepMerge = merger.bind(null, true);
	exports.deepMerge = deepMerge;
	exports.shallowMerge = shallowMerge;
	
	/**
	 * Function returning a string hash from a non-dynamic path expressed as an
	 * array.
	 *
	 * @param  {array}  path - The path to hash.
	 * @return {string} string - The resultant hash.
	 */
	function hashPath(path) {
	  return 'λ' + path.map(function (step) {
	    if (_type["default"]["function"](step) || _type["default"].object(step)) return "#".concat(uniqid(), "#");
	    return step;
	  }).join('λ');
	}
	/**
	 * Solving a potentially relative path.
	 *
	 * @param  {array} base - The base path from which to solve the path.
	 * @param  {array} to   - The subpath to reach.
	 * @param  {array}      - The solved absolute path.
	 */
	
	
	function solveRelativePath(base, to) {
	  var solvedPath = []; // Coercing to array
	
	  to = [].concat(to);
	
	  for (var i = 0, l = to.length; i < l; i++) {
	    var step = to[i];
	
	    if (step === '.') {
	      if (!i) solvedPath = base.slice(0);
	    } else if (step === '..') {
	      solvedPath = (!i ? base : solvedPath).slice(0, -1);
	    } else {
	      solvedPath.push(step);
	    }
	  }
	
	  return solvedPath;
	}
	/**
	 * Function determining whether some paths in the tree were affected by some
	 * updates that occurred at the given paths. This helper is mainly used at
	 * cursor level to determine whether the cursor is concerned by the updates
	 * fired at tree level.
	 *
	 * NOTES: 1) If performance become an issue, the following threefold loop
	 *           can be simplified to a complex twofold one.
	 *        2) A regex version could also work but I am not confident it would
	 *           be faster.
	 *        3) Another solution would be to keep a register of cursors like with
	 *           the monkeys and update along this tree.
	 *
	 * @param  {array} affectedPaths - The paths that were updated.
	 * @param  {array} comparedPaths - The paths that we are actually interested in.
	 * @return {boolean}             - Is the update relevant to the compared
	 *                                 paths?
	 */
	
	
	function solveUpdate(affectedPaths, comparedPaths) {
	  var i, j, k, l, m, n, p, c, s; // Looping through possible paths
	
	  for (i = 0, l = affectedPaths.length; i < l; i++) {
	    p = affectedPaths[i];
	    if (!p.length) return true; // Looping through logged paths
	
	    for (j = 0, m = comparedPaths.length; j < m; j++) {
	      c = comparedPaths[j];
	      if (!c || !c.length) return true; // Looping through steps
	
	      for (k = 0, n = c.length; k < n; k++) {
	        s = c[k]; // If path is not relevant, we break
	        // NOTE: the '!=' instead of '!==' is required here!
	
	        if (s != p[k]) break; // If we reached last item and we are relevant
	
	        if (k + 1 === n || k + 1 === p.length) return true;
	      }
	    }
	  }
	
	  return false;
	}
	/**
	 * Non-mutative version of the splice array method.
	 *
	 * @param  {array}    array        - The array to splice.
	 * @param  {integer}  startIndex   - The start index.
	 * @param  {integer}  nb           - Number of elements to remove.
	 * @param  {...mixed} elements     - Elements to append after splicing.
	 * @return {array}                 - The spliced array.
	 */
	
	
	function splice(array, startIndex, nb) {
	  for (var _len2 = arguments.length, elements = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
	    elements[_key2 - 3] = arguments[_key2];
	  }
	
	  if (nb === undefined && arguments.length === 2) nb = array.length - startIndex;else if (nb === null || nb === undefined) nb = 0;else if (isNaN(+nb)) throw new Error("argument nb ".concat(nb, " can not be parsed into a number!"));
	  nb = Math.max(0, nb); // Solving startIndex
	
	  if (_type["default"]["function"](startIndex)) startIndex = index(array, startIndex);
	  if (_type["default"].object(startIndex)) startIndex = index(array, function (e) {
	    return compare(e, startIndex);
	  }); // Positive index
	
	  if (startIndex >= 0) return array.slice(0, startIndex).concat(elements).concat(array.slice(startIndex + nb)); // Negative index
	
	  return array.slice(0, array.length + startIndex).concat(elements).concat(array.slice(array.length + startIndex + nb));
	}
	/**
	 * Function returning a unique incremental id each time it is called.
	 *
	 * @return {integer} - The latest unique id.
	 */
	
	
	var uniqid = function () {
	  var i = 0;
	  return function () {
	    return i++;
	  };
	}();
	
	exports.uniqid = uniqid;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(6);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(46);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 106 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(47);
	var global = __webpack_require__(8);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(66) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(6);
	var aFunction = __webpack_require__(25);
	var SPECIES = __webpack_require__(13)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var computed = __webpack_require__(141);
	var _ = __webpack_require__(3);
	
	var ALL_STATUSES = [{
	    id: 1,
	    name: 'Черновик'
	}, {
	    id: 2,
	    name: 'На оформлении'
	}, {
	    id: 3,
	    name: 'Ожидает оплату'
	}, {
	    id: 4,
	    name: 'Ожидает документы'
	}, {
	    id: 5,
	    name: 'Выполнен'
	}, {
	    id: 6,
	    name: 'Архив'
	}, {
	    id: 7,
	    name: 'Предчерновик'
	}];
	
	var ALL_TYPES = [{
	    id: 1,
	    name: 'Online выборка'
	}, {
	    id: 2,
	    name: 'Offline выборка'
	}, {
	    id: 3,
	    name: 'Offline адр. план'
	}, {
	    id: 4,
	    name: 'Индивидуальная выборка'
	}];
	
	var ORDER_TYPE_MAP = {
	    all: [1, 2, 3, 4, 5, 6],
	    active: [1, 2, 3, 4],
	    inactive: [5, 6]
	};
	
	function setStatusFilterItem(_ref, state) {
	    var path = _ref.path,
	        value = _ref.value;
	
	    state.set(['account', 'orders', 'list', 'stateFilter', path, 'isChecked'], value);
	}
	
	function setTypeFilterItem(_ref2, state) {
	    var path = _ref2.path,
	        value = _ref2.value;
	
	    state.set(['account', 'orders', 'list', 'typeFilter', path, 'isChecked'], value);
	}
	
	module.exports = {
	    setComputedFields: function setComputedFields(args, state) {
	        computed.formatOrderList(state);
	        computed.computeSelectedStatesArray(state);
	        computed.computeSelectedTypesArray(state);
	        computed.queryObject(state);
	    },
	    setStateFormUrlClient: function setStateFormUrlClient(_ref3, state) {
	        var type = _ref3.type;
	
	        var typeFilter = type || 'all';
	
	        state.set(['account', 'orders', 'list', 'selectedTypeFilter'], typeFilter);
	    },
	    setShouldRestoreFiltersFromLocalStorage: function setShouldRestoreFiltersFromLocalStorage(_ref4, state) {
	        var assigned = _ref4.assigned,
	            status = _ref4.status,
	            text = _ref4.text,
	            type = _ref4.type;
	
	        state.set(['account', 'orders', 'shouldRestoreFilters'], !assigned && !status && !text && !type);
	    },
	    setStateFormUrlManager: function setStateFormUrlManager(_ref5, state) {
	        var assigned = _ref5.assigned,
	            status = _ref5.status,
	            text = _ref5.text,
	            type = _ref5.type,
	            orderId = _ref5.orderId;
	
	        var radioFilter = assigned || 'any';
	        state.set(['account', 'orders', 'list', 'selectedRadioFilter'], radioFilter);
	        state.set(['account', 'orders', 'queryOrderId'], orderId);
	
	        if (status) {
	            var statusIds = _.map(status, function (id) {
	                return Number(id);
	            });
	            _.forEach(statusIds, function (id) {
	                setStatusFilterItem({ path: id, value: true }, state);
	            });
	        }
	
	        if (type) {
	            var ids = _.map(_.filter(type, function (id) {
	                return !isNaN(id);
	            }), function (id) {
	                return Number(id);
	            });
	            _.forEach(ids, function (id) {
	                setTypeFilterItem({ path: id, value: true }, state);
	            });
	        }
	
	        state.set(['account', 'orders', 'list', 'filterText'], text);
	    },
	    resetPaging: function resetPaging(args, state) {
	        state.set(['account', 'orders', 'list', 'page'], 1);
	        state.set(['account', 'orders', 'list', 'isAllLoaded'], false);
	    },
	    setPagingDefaultsIfNeeded: function setPagingDefaultsIfNeeded(args, state) {
	        state.apply(['account', 'orders', 'list', 'page'], function (page) {
	            return page || 1;
	        });
	        state.apply(['account', 'orders', 'list', 'count'], function (count) {
	            return count || 15;
	        });
	    },
	    incrementCurrentPage: function incrementCurrentPage(args, state) {
	        state.apply(['account', 'orders', 'list', 'page'], function (page) {
	            return page + 1;
	        });
	    },
	    getOrdersList: function getOrdersList(args, state, output, _ref6) {
	        var locator = _ref6.locator,
	            context = _ref6.context;
	
	        var API = locator.resolve('api');
	
	        var allLoaded = state.get(['account', 'orders', 'list', 'isAllLoaded']);
	        var page = state.get(['account', 'orders', 'list', 'page']);
	        var count = state.get(['account', 'orders', 'list', 'count']);
	        var assigned = state.get(['account', 'orders', 'list', 'selectedRadioFilter']);
	        var type = state.get(['account', 'orders', 'list', 'selectedTypeFilter']);
	        var text = state.get(['account', 'orders', 'list', 'filterText']);
	        var orderTypeForManager = state.get(['account', 'orders', 'computed', 'list', 'selectedTypes']);
	        var status = state.get(['account', 'orders', 'computed', 'list', 'selectedStates']);
	
	        if (type) {
	            status = ORDER_TYPE_MAP[type];
	        }
	
	        var queryData = _.omitBy({ page: page, count: count, status: status, assigned: assigned, text: text, type: orderTypeForManager }, _.isUndefined);
	
	        if (allLoaded) {
	            output.success();
	            return;
	        }
	
	        var request = API.getOrders(context, locator, { queryData: queryData });
	
	        request.then(function (data) {
	            var code = _.get(data, 'status.code');
	
	            if (code === 200) {
	                var ordersList = _.get(data, 'content');
	                output.success({ ordersList: ordersList });
	
	                return;
	            }
	
	            if (code === 404) {
	                output.notFound();
	
	                return;
	            }
	
	            output.error({ error: code });
	        }).catch(function (error) {
	            return output.error({ error: error });
	        });
	    },
	    checkLoadingQueue: function checkLoadingQueue(args, state, output) {
	        var isLoading = state.get(['account', 'orders', 'list', 'isNextPageLoading']);
	
	        if (!isLoading) {
	            output.empty();
	        }
	    },
	    addOrders: function addOrders(_ref7, state) {
	        var ordersList = _ref7.ordersList;
	
	        if (_.isEmpty(ordersList)) {
	            state.set(['account', 'orders', 'list', 'isAllLoaded'], true);
	            return;
	        }
	
	        var currentOrdersList = state.get(['account', 'orders', 'list', 'data']) || [];
	        var summaryOrdersList = currentOrdersList.concat(ordersList);
	        var deduplicatedOrdersList = _.orderBy(_.uniqBy(summaryOrdersList, 'id'), function (x) {
	            return parseInt(x.id, 10);
	        }, 'desc');
	
	        state.set(['account', 'orders', 'list', 'data'], deduplicatedOrdersList);
	    },
	    isAnyOrders: function isAnyOrders(args, state, output) {
	        var currentOrdersList = state.get(['account', 'orders', 'list', 'data']) || [];
	        if (currentOrdersList.length > 0) {
	            output.yes();
	            return;
	        }
	        output.no();
	    },
	    setOrderIdArgsIfNotSet: function setOrderIdArgsIfNotSet(args, state, output) {
	        var orderId = args.orderId;
	
	        if (!orderId) {
	            orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
	
	            if (!orderId) {
	                var currentOrdersList = state.get(['account', 'orders', 'list', 'data']) || [];
	                if (currentOrdersList.length > 0) {
	                    orderId = currentOrdersList[0].id;
	                }
	            }
	        }
	        output({ orderId: orderId });
	    },
	    setStatusFilterData: function setStatusFilterData(args, state) {
	        state.set(['account', 'orders', 'list', 'statusFilterData'], ALL_STATUSES);
	    },
	    setTypeFilterData: function setTypeFilterData(args, state) {
	        state.set(['account', 'orders', 'list', 'typeFilterData'], ALL_TYPES);
	    },
	
	
	    setStatusFilterItem: setStatusFilterItem,
	
	    setTypeFilterItem: setTypeFilterItem,
	
	    selectStatus: function selectStatus(_ref8, state) {
	        var key = _ref8.key,
	            isChecked = _ref8.isChecked;
	
	        var status = Number(key);
	        var statusPath = ['account', 'orders', 'list', 'selectedStatus'];
	
	        var statusList = _.clone(state.get(statusPath)) || [];
	
	        if (isChecked) {
	            statusList.push(status);
	        } else {
	            statusList = _.remove(statusList, function (val) {
	                return val != status;
	            });
	        }
	
	        state.set(statusPath, statusList);
	    },
	    getActionByTextFilter: function getActionByTextFilter(_ref9, state, output) {
	        var textFilterValue = _ref9.textFilterValue,
	            minLength = _ref9.minLength;
	
	        if (textFilterValue && textFilterValue.length >= minLength) {
	            output.updateWithFilter();
	        } else {
	            var oldValue = state.get(['account', 'orders', 'list', 'filterText']);
	            if (oldValue && oldValue.length >= minLength) {
	                output.updateWithoutFilter();
	            } else {
	                output.none();
	            }
	        }
	    },
	    filterToLocalStorage: function filterToLocalStorage(args, state, output, _ref10) {
	        var context = _ref10.context,
	            locator = _ref10.locator;
	
	        if (context.isServer) {
	            return;
	        }
	        var window = locator.resolve('window');
	        var ordersFilter = {};
	        ordersFilter.selectedRadioFilter = state.get(['account', 'orders', 'list', 'selectedRadioFilter']);
	
	        ordersFilter.filterText = state.get(['account', 'orders', 'list', 'filterText']);
	        ordersFilter.stateFilter = state.get(['account', 'orders', 'list', 'stateFilter']);
	        ordersFilter.typeFilter = state.get(['account', 'orders', 'list', 'typeFilter']);
	        window.localStorage.setItem('ordersFilter', JSON.stringify(ordersFilter));
	    },
	    filterRestoreFromStorage: function filterRestoreFromStorage(args, state, output, _ref11) {
	        var locator = _ref11.locator;
	
	        var window = locator.resolve('window');
	        var serialized = window.localStorage.getItem('ordersFilter');
	
	        if (!serialized) {
	            return;
	        }
	
	        var ordersFilter = JSON.parse(serialized);
	        state.set(['account', 'orders', 'list', 'selectedRadioFilter'], ordersFilter.selectedRadioFilter);
	
	        state.set(['account', 'orders', 'list', 'filterText'], ordersFilter.filterText);
	        state.set(['account', 'orders', 'list', 'stateFilter'], ordersFilter.stateFilter);
	        state.set(['account', 'orders', 'list', 'typeFilter'], ordersFilter.typeFilter);
	    }
	};

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(3);
	
	var _require = __webpack_require__(15),
	    monkey = _require.monkey;
	
	var COMPONENTS = __webpack_require__(292);
	
	module.exports = {
	    setComponentsByPage: function setComponentsByPage(state) {
	        state.set(['page', 'components'], monkey(['page', 'name'], function (page) {
	            return _.get(COMPONENTS, page);
	        }));
	    },
	    computeCountryDropdown: function computeCountryDropdown(state, basePath) {
	        state.set(basePath.concat(['computed', 'countryDropdown']), monkey(basePath.concat(['countries']), basePath.concat(['form', 'countryId']), function () {
	            var countries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	            var selectedCountryId = arguments[1];
	
	            var header = null;
	            var isDisabled = false;
	
	            var options = _.map(countries, function (country) {
	                return {
	                    isActive: Number(selectedCountryId) === country.id,
	                    title: country.name,
	                    value: country.id
	                };
	            });
	
	            if (_.every(options, ['isActive', false])) {
	                header = 'Выберите страну';
	            }
	
	            return { options: options, header: header, isDisabled: isDisabled };
	        }));
	    },
	    setUserDataEmail: function setUserDataEmail(state) {
	        state.set(['auth', 'computed', 'userData', 'email'], monkey(['login', 'form', 'email'], ['registration', 'form', 'email'], ['restore', 'form', 'email'], function (loginEmail, registerEmail, restoreEmail) {
	            return loginEmail || registerEmail || restoreEmail;
	        }));
	
	        state.set(['auth', 'computed', 'userData', 'password'], monkey(['login', 'form', 'password'], ['registration', 'form', 'password'], ['restore', 'form', 'password'], function (loginPassword, registerPassword, restorePassword) {
	            return loginPassword || registerPassword || restorePassword;
	        }));
	    }
	};

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var treeHelper = __webpack_require__(57);
	var DEFAULT_MIN_LENGTH = 4;
	
	module.exports = {
	    initTreeState: function initTreeState(_ref, state) {
	        var basePath = _ref.basePath,
	            srcDataPath = _ref.srcDataPath;
	
	        treeHelper.initTreeUiState(state, srcDataPath, basePath);
	    },
	    switchSubTreeCollapse: function switchSubTreeCollapse(_ref2, state) {
	        var basePath = _ref2.basePath,
	            nodeId = _ref2.nodeId;
	
	        var fullPath = basePath.concat('expanded', nodeId);
	        var value = state.get(fullPath);
	        state.set(fullPath, !value);
	    },
	    switchSubTreeCollapseCustom: function switchSubTreeCollapseCustom(_ref3, state) {
	        var basePath = _ref3.basePath,
	            nodeId = _ref3.nodeId,
	            collapseType = _ref3.collapseType;
	
	        var fullPath = basePath.concat(collapseType, nodeId);
	        var value = state.get(fullPath);
	        state.set(fullPath, !value);
	    },
	    setFilter: function setFilter(_ref4, state) {
	        var basePath = _ref4.basePath,
	            value = _ref4.value,
	            minLength = _ref4.minLength;
	
	        var minFilterLength = minLength || DEFAULT_MIN_LENGTH;
	        var path = basePath.concat('filter');
	
	        var currentValue = state.get(path);
	        if (value.length >= minFilterLength) {
	            state.set(path, value);
	        } else if (currentValue !== null) {
	            state.set(path, null);
	        }
	    },
	    setShowSelectedOnly: function setShowSelectedOnly(_ref5, state) {
	        var basePath = _ref5.basePath,
	            showSelectedOnly = _ref5.showSelectedOnly,
	            treeId = _ref5.treeId;
	
	        var path = basePath.concat('showSelectedOnly');
	        var value = showSelectedOnly;
	        if (showSelectedOnly === undefined) {
	            value = !state.get(path);
	        }
	        state.set(path, value);
	
	        state.set(basePath.concat('filter'), null);
	        var htmlInput = document.getElementById(treeId + 'Filter');
	        if (htmlInput) {
	            htmlInput.value = '';
	        }
	    },
	    initFilter: function initFilter(_ref6, state) {
	        var basePath = _ref6.basePath,
	            treeId = _ref6.treeId;
	
	        var value = state.get(basePath.concat('filter'));
	        if (value) {
	            document.getElementById(treeId + 'Filter').value = value;
	        }
	    },
	    changeValue: function changeValue(_ref7, state) {
	        var basePath = _ref7.basePath,
	            srcDataPath = _ref7.srcDataPath,
	            nodeId = _ref7.nodeId,
	            value = _ref7.value;
	
	        treeHelper.changeTreeNodeValue(state, srcDataPath, basePath, nodeId, value);
	    }
	};

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var commonTree = __webpack_require__(98);
	
	var TREE_BASE_PATH = ['order', 'addParams', 'legalEntities', 'tree'];
	var ORIGINAL_DATA_PATH = ['order', 'originalParameters', 'legalEntities'];
	var PROPERTY_NAME = 'LegalForm';
	
	module.exports = {
	    initTreeState: function initTreeState(args, state) {
	        commonTree.initTreeState(args, state, ORIGINAL_DATA_PATH, TREE_BASE_PATH);
	    },
	    changeValue: function changeValue(args, state) {
	        commonTree.changeValue(args, state, ORIGINAL_DATA_PATH, TREE_BASE_PATH, PROPERTY_NAME);
	    },
	    setAll: function setAll(args, state) {
	        commonTree.setAll(args, state, ORIGINAL_DATA_PATH, TREE_BASE_PATH, PROPERTY_NAME);
	    },
	    tryUnsetSelected: function tryUnsetSelected(args, state) {
	        commonTree.tryUnsetSelected(args, state, ORIGINAL_DATA_PATH, TREE_BASE_PATH, PROPERTY_NAME);
	    },
	    clearFilter: function clearFilter(args, state) {
	        commonTree.clearFilter(args, state, TREE_BASE_PATH, 'legal-entities');
	    }
	};

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var commonTree = __webpack_require__(98);
	
	var TREE_BASE_PATH = ['order', 'addParams', 'purposes', 'tree'];
	var ORIGINAL_DATA_PATH = ['order', 'originalParameters', 'purposes'];
	var PROPERTY_NAME = 'Purpose';
	
	module.exports = {
	    initTreeState: function initTreeState(args, state) {
	        commonTree.initTreeState(args, state, ORIGINAL_DATA_PATH, TREE_BASE_PATH);
	    },
	    changeValue: function changeValue(args, state) {
	        commonTree.changeValue(args, state, ORIGINAL_DATA_PATH, TREE_BASE_PATH, PROPERTY_NAME);
	    },
	    setAll: function setAll(args, state) {
	        commonTree.setAll(args, state, ORIGINAL_DATA_PATH, TREE_BASE_PATH, PROPERTY_NAME);
	    },
	    tryUnsetSelected: function tryUnsetSelected(args, state) {
	        commonTree.tryUnsetSelected(args, state, ORIGINAL_DATA_PATH, TREE_BASE_PATH, PROPERTY_NAME);
	    },
	    clearFilter: function clearFilter(args, state) {
	        commonTree.clearFilter(args, state, TREE_BASE_PATH, 'purposes');
	    }
	};

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var treeHelper = __webpack_require__(57);
	
	var RUBRICS_TREE_BASE_PATH = ['order', 'rubrics', 'tree'];
	var RUBRICS_ORIGINAL_DATA_PATH = ['order', 'originalParameters', 'rubrics'];
	
	module.exports = {
	    initTreeState: function initTreeState(args, state) {
	        treeHelper.initTreeUiState(state, RUBRICS_ORIGINAL_DATA_PATH, RUBRICS_TREE_BASE_PATH);
	    },
	    changeValue: function changeValue(_ref, state) {
	        var path = _ref.path,
	            value = _ref.value;
	
	        treeHelper.changeTreeNodeValue(state, RUBRICS_ORIGINAL_DATA_PATH, RUBRICS_TREE_BASE_PATH, path, value);
	    },
	    setAll: function setAll(_ref2, state) {
	        var value = _ref2.value;
	
	        treeHelper.setAllSelection(state, RUBRICS_ORIGINAL_DATA_PATH, RUBRICS_TREE_BASE_PATH, value);
	    },
	    isToggleFilterTypeOn: function isToggleFilterTypeOn(args, state, output) {
	        var path = RUBRICS_TREE_BASE_PATH.concat('showFilterTreeInput');
	        if (state.get(path)) {
	            output.no();
	        } else {
	            output.yes();
	        }
	    },
	    toggleFilterType: function toggleFilterType(args, state) {
	        var path = RUBRICS_TREE_BASE_PATH.concat('showFilterTreeInput');
	        var value = state.get(path) || false;
	
	        state.set(path, !value);
	
	        state.set(RUBRICS_TREE_BASE_PATH.concat('hideFilter'), !value);
	    },
	    clearFilter: function clearFilter(args, state) {
	        treeHelper.clearFilter(state, RUBRICS_TREE_BASE_PATH, 'rubrics');
	    }
	};

/***/ }),
/* 115 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
		encodeUserInfoSubComponent: function encodeUserInfoSubComponent(string) {
			return string.replace(/[^\w\.~\-!\$&'\(\)\*\+,;=\uD800-\uDBFF\uDC00-\uDFFF]/g, encodeURIComponent);
		},
		encodeHost: function encodeHost(string) {
			return string.replace(/[^\w\.~\-!\$&'\(\)\*\+,;=:\[\]\uD800-\uDBFF\uDC00-\uDFFF]/g, encodeURIComponent);
		},
		encodePath: function encodePath(string) {
			return string.split(/%2f/i).map(function (part) {
				return part.replace(/[^\w\.~\-!\$&'\(\)\*\+,;=:@\/\uD800-\uDBFF\uDC00-\uDFFF]/g, encodeURIComponent);
			}).reduce(function (prev, current) {
				return !prev ? current : prev + '%2F' + current;
			}, '');
		},
		encodeQuerySubComponent: function encodeQuerySubComponent(string) {
			return string.replace(/[^\w\.~\-!\$'\(\)\*,;:@\/\?\uD800-\uDBFF\uDC00-\uDFFF]/g, encodeURIComponent);
		},
		encodeFragment: function encodeFragment(string) {
			return string.replace(/[^\w\.~\-!\$&'\(\)\*\+,;=:@\/\?\uD800-\uDBFF\uDC00-\uDFFF]/g, encodeURIComponent);
		},
		decode: function decode(string) {
			return decodeURIComponent(string);
		},
		decodePath: function decodePath(string) {
			return string.split(/%2f/i).map(decodeURIComponent).reduce(function (prev, current) {
				return !prev ? current : prev + '%2F' + current;
			}, '');
		}
	};

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var addParams = __webpack_require__(142);
	var utils = __webpack_require__(5);
	
	var _require = __webpack_require__(30),
	    calcPriceGroup = _require.calcPriceGroup;
	
	var analytics = __webpack_require__(7);
	var form = __webpack_require__(26);
	var customOrder = __webpack_require__(42);
	
	module.exports = {
	    selectDate: function selectDate(name, isFrom) {
	        var setDateAction = isFrom ? addParams.changeDateDatepickerFrom : addParams.changeDateDatepickerTo;
	        return [addParams.setExportDateTimeColumnIsChecked, setDateAction, utils.togglePopup(name)].concat(calcPriceGroup, [analytics.argsValueEvent({ category: 'date_of_company', action: 'see' })]);
	    },
	    clearDatepicker: function clearDatepicker(path) {
	        return [utils.unset(path)].concat(calcPriceGroup);
	    },
	
	
	    setGreederColumnIsChecked: [addParams.setGreederColumnIsChecked, customOrder.setFilterValuesChanged],
	
	    setGreederColumnSource: [addParams.setGreederColumnSource, customOrder.setFilterValuesChanged],
	
	    setAllGreederColumns: [addParams.setAllGreederColumnIsChecked, customOrder.setFilterValuesChanged],
	
	    setExportColumnIsChecked: [addParams.setExportColumnIsChecked, addParams.unsetRelatedParams, utils.setArg('metricEventPrefix', 'checkbox_optional_column_'), [analytics.fillEventArgsFromAdditionalParamSet, {
	        filled: [analytics.raiseArgsValueEvent],
	        noEvent: []
	    }]].concat(calcPriceGroup),
	
	    setExportColumnIsMustBeFilled: [addParams.setExportColumnIsMustBeFilled, utils.setArg('metricEventPrefix', 'checkbox_availability_'), [analytics.fillEventArgsFromAdditionalParamSet, {
	        filled: [analytics.raiseArgsValueEvent],
	        noEvent: []
	    }]].concat(calcPriceGroup),
	
	    toggleOnlyHeadCards: [utils.toggleBool(['order', 'addParams', 'onlyHeadCards']), analytics.argsValueEvent({ category: 'checkbox_only_head_cards', action: 'input' })].concat(calcPriceGroup),
	
	    inputText: [].concat(form.inputAndValidateText, [addParams.setExportAreaColumnIsChecked], calcPriceGroup),
	
	    blurText: [].concat(form.blurText, calcPriceGroup),
	
	    toggleArchiveInn: [utils.toggleBool(['order', 'addParams', 'includeArchiveInn'])].concat(calcPriceGroup)
	};

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var cities = __webpack_require__(99);
	
	var _require = __webpack_require__(42),
	    isTabSelected = _require.isTabSelected;
	
	var _require2 = __webpack_require__(30),
	    calcPriceGroup = _require2.calcPriceGroup;
	
	var analytics = __webpack_require__(7);
	var utils = __webpack_require__(5);
	
	module.exports = {
	    onItemCheck: [cities.changeValue, utils.setArg('category', 'checkbox_geo'), [analytics.fillEventFromTreeChecked, {
	        filled: [analytics.raiseArgsValueEvent],
	        noEvent: []
	    }]].concat(calcPriceGroup),
	
	    onBranchCheck: [cities.changeBranchSelection, utils.setArg('category', 'select_branch'), utils.setArg('action', 'click'), [analytics.fillEvent, {
	        filled: [analytics.raiseArgsValueEvent],
	        noEvent: []
	    }]].concat(calcPriceGroup),
	
	    onSetAll: [cities.setAll].concat(calcPriceGroup),
	
	    toggleMapFilter: [[isTabSelected('map'), {
	        yes: [cities.localSaveMapFilter, utils.unset(['order', 'cities', 'tab'])],
	        no: [utils.set(['order', 'cities', 'tab'], 'map'), utils.setArg('category', 'tab_filter_map'), utils.setArg('action', 'click'), analytics.raiseArgsValueEvent]
	    }]].concat(calcPriceGroup),
	
	    toggleFilterType: [cities.toggleFilterType]
	};

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var customOrder = __webpack_require__(42);
	var error = __webpack_require__(19);
	var currentOrder = __webpack_require__(23);
	var orders = __webpack_require__(41);
	var utils = __webpack_require__(5);
	
	var _require = __webpack_require__(74),
	    restoreStateGroup = _require.restoreStateGroup;
	
	module.exports = {
	    initSelectedParamsFromOrderGroup: [[currentOrder.getSelectedParamsFromCurrentOrder, {
	        success: [].concat(restoreStateGroup),
	        error: [error.internalError('currentOrder.getSelectedParamsFromCurrentOrder')]
	    }]],
	
	    saveSelectedParamsGroup: [[currentOrder.updateSelectedParamsForCurrentOrder, {
	        success: [currentOrder.updateOrder(['price', 'paymentTypeId', 'necessaryDocuments', 'selectedParameters'])].concat(restoreStateGroup, [orders.setDataChangedConfirmed]),
	        error: [error.internalError('currentOrder.updateSelectedParamsForCurrentOrder')]
	    }]],
	
	    setUserGroup: [[orders.setUser, {
	        success: [currentOrder.updateOrder(['user', 'necessaryDocuments']), utils.unset(['account', 'orders', 'currentOrder', 'localChanges', 'selectedUser']), utils.set(['account', 'orders', 'currentOrder', 'tooltips', 'showUserMustBeSelected'], false)],
	        error: []
	    }]]
	};

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Monkey = exports.MonkeyDefinition = void 0;
	
	var _type = _interopRequireDefault(__webpack_require__(91));
	
	var _update2 = _interopRequireDefault(__webpack_require__(237));
	
	var _helpers = __webpack_require__(103);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Monkey Definition class
	 * Note: The only reason why this is a class is to be able to spot it within
	 * otherwise ordinary data.
	 *
	 * @constructor
	 * @param {array|object} definition - The formal definition of the monkey.
	 */
	var MonkeyDefinition = function MonkeyDefinition(definition) {
	  var _this = this;
	
	  _classCallCheck(this, MonkeyDefinition);
	
	  var monkeyType = _type["default"].monkeyDefinition(definition);
	
	  if (!monkeyType) throw (0, _helpers.makeError)('Baobab.monkey: invalid definition.', {
	    definition: definition
	  });
	  this.type = monkeyType;
	
	  if (this.type === 'object') {
	    this.getter = definition.get;
	    this.projection = definition.cursors || {};
	    this.paths = Object.keys(this.projection).map(function (k) {
	      return _this.projection[k];
	    });
	    this.options = definition.options || {};
	  } else {
	    var offset = 1,
	        options = {};
	
	    if (_type["default"].object(definition[definition.length - 1])) {
	      offset++;
	      options = definition[definition.length - 1];
	    }
	
	    this.getter = definition[definition.length - offset];
	    this.projection = definition.slice(0, -offset);
	    this.paths = this.projection;
	    this.options = options;
	  } // Coercing paths for convenience
	
	
	  this.paths = this.paths.map(function (p) {
	    return [].concat(p);
	  }); // Does the definition contain dynamic paths
	
	  this.hasDynamicPaths = this.paths.some(_type["default"].dynamicPath);
	};
	/**
	 * Monkey core class
	 *
	 * @constructor
	 * @param {Baobab}           tree       - The bound tree.
	 * @param {MonkeyDefinition} definition - A definition instance.
	 */
	
	
	exports.MonkeyDefinition = MonkeyDefinition;
	
	var Monkey =
	/*#__PURE__*/
	function () {
	  function Monkey(tree, pathInTree, definition) {
	    var _this2 = this;
	
	    _classCallCheck(this, Monkey);
	
	    // Properties
	    this.tree = tree;
	    this.path = pathInTree;
	    this.definition = definition; // Adapting the definition's paths & projection to this monkey's case
	
	    var projection = definition.projection,
	        relative = _helpers.solveRelativePath.bind(null, pathInTree.slice(0, -1));
	
	    if (definition.type === 'object') {
	      this.projection = Object.keys(projection).reduce(function (acc, k) {
	        acc[k] = relative(projection[k]);
	        return acc;
	      }, {});
	      this.depPaths = Object.keys(this.projection).map(function (k) {
	        return _this2.projection[k];
	      });
	    } else {
	      this.projection = projection.map(relative);
	      this.depPaths = this.projection;
	    } // Internal state
	
	
	    this.state = {
	      killed: false
	    };
	    /**
	     * Listener on the tree's `write` event.
	     *
	     * When the tree writes, this listener will check whether the updated paths
	     * are of any use to the monkey and, if so, will update the tree's node
	     * where the monkey sits.
	     */
	
	    this.writeListener = function (_ref) {
	      var path = _ref.data.path;
	      if (_this2.state.killed) return; // Is the monkey affected by the current write event?
	
	      var concerned = (0, _helpers.solveUpdate)([path], _this2.relatedPaths());
	      if (concerned) _this2.update();
	    };
	    /**
	     * Listener on the tree's `monkey` event.
	     *
	     * When another monkey updates, this listener will check whether the
	     * updated paths are of any use to the monkey and, if so, will update the
	     * tree's node where the monkey sits.
	     */
	
	
	    this.recursiveListener = function (_ref2) {
	      var _ref2$data = _ref2.data,
	          monkey = _ref2$data.monkey,
	          path = _ref2$data.path;
	      if (_this2.state.killed) return; // Breaking if this is the same monkey
	
	      if (_this2 === monkey) return; // Is the monkey affected by the current monkey event?
	
	      var concerned = (0, _helpers.solveUpdate)([path], _this2.relatedPaths(false));
	      if (concerned) _this2.update();
	    }; // Binding listeners
	
	
	    this.tree.on('write', this.writeListener);
	    this.tree.on('_monkey', this.recursiveListener); // Updating relevant node
	
	    this.update();
	  }
	  /**
	   * Method returning solved paths related to the monkey.
	   *
	   * @param  {boolean} recursive - Should we compute recursive paths?
	   * @return {array}             - An array of related paths.
	   */
	
	
	  _createClass(Monkey, [{
	    key: "relatedPaths",
	    value: function relatedPaths() {
	      var _this3 = this;
	
	      var recursive = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	      var paths;
	      if (this.definition.hasDynamicPaths) paths = this.depPaths.map(function (p) {
	        return (0, _helpers.getIn)(_this3.tree._data, p).solvedPath;
	      });else paths = this.depPaths;
	      var isRecursive = recursive && this.depPaths.some(function (p) {
	        return !!_type["default"].monkeyPath(_this3.tree._monkeys, p);
	      });
	      if (!isRecursive) return paths;
	      return paths.reduce(function (accumulatedPaths, path) {
	        var monkeyPath = _type["default"].monkeyPath(_this3.tree._monkeys, path);
	
	        if (!monkeyPath) return accumulatedPaths.concat([path]); // Solving recursive path
	
	        var relatedMonkey = (0, _helpers.getIn)(_this3.tree._monkeys, monkeyPath).data;
	        return accumulatedPaths.concat(relatedMonkey.relatedPaths());
	      }, []);
	    }
	    /**
	     * Method used to update the tree's internal data with a lazy getter holding
	     * the computed data.
	     *
	     * @return {Monkey} - Returns itself for chaining purposes.
	     */
	
	  }, {
	    key: "update",
	    value: function update() {
	      var _this4 = this;
	
	      var deps = this.tree.project(this.projection);
	
	      var lazyGetter = function (tree, def, data) {
	        var cache = null,
	            alreadyComputed = false;
	        return function () {
	          if (!alreadyComputed) {
	            cache = def.getter.apply(tree, def.type === 'object' ? [data] : data);
	            if (tree.options.immutable && def.options.immutable !== false) (0, _helpers.deepFreeze)(cache); // update tree affected paths
	
	            var hash = (0, _helpers.hashPath)(_this4.path);
	            tree._affectedPathsIndex[hash] = true;
	            alreadyComputed = true;
	          }
	
	          return cache;
	        };
	      }(this.tree, this.definition, deps);
	
	      lazyGetter.isLazyGetter = true; // Should we write the lazy getter in the tree or solve it right now?
	
	      if (this.tree.options.lazyMonkeys) {
	        this.tree._data = (0, _update2["default"])(this.tree._data, this.path, {
	          type: 'monkey',
	          value: lazyGetter
	        }, this.tree.options).data;
	      } else {
	        var result = (0, _update2["default"])(this.tree._data, this.path, {
	          type: 'set',
	          value: lazyGetter(),
	          options: {
	            mutableLeaf: !this.definition.options.immutable
	          }
	        }, this.tree.options);
	        if ('data' in result) this.tree._data = result.data;
	      } // Notifying the monkey's update so we can handle recursivity
	
	
	      this.tree.emit('_monkey', {
	        monkey: this,
	        path: this.path
	      });
	      return this;
	    }
	    /**
	     * Method releasing the monkey from memory.
	     */
	
	  }, {
	    key: "release",
	    value: function release() {
	      // Unbinding events
	      this.tree.off('write', this.writeListener);
	      this.tree.off('_monkey', this.recursiveListener);
	      this.state.killed = true; // Deleting properties
	      // NOTE: not deleting this.definition because some strange things happen
	      // in the _refreshMonkeys method. See #372.
	
	      delete this.projection;
	      delete this.depPaths;
	      delete this.tree;
	    }
	  }]);
	
	  return Monkey;
	}();
	
	exports.Monkey = Monkey;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(40);
	var toLength = __webpack_require__(14);
	var toAbsoluteIndex = __webpack_require__(84);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(8);
	var $export = __webpack_require__(2);
	var redefine = __webpack_require__(32);
	var redefineAll = __webpack_require__(82);
	var meta = __webpack_require__(67);
	var forOf = __webpack_require__(77);
	var anInstance = __webpack_require__(76);
	var isObject = __webpack_require__(10);
	var fails = __webpack_require__(9);
	var $iterDetect = __webpack_require__(125);
	var setToStringTag = __webpack_require__(94);
	var inheritIfRequired = __webpack_require__(172);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(273);
	var redefine = __webpack_require__(32);
	var hide = __webpack_require__(31);
	var fails = __webpack_require__(9);
	var defined = __webpack_require__(52);
	var wks = __webpack_require__(13);
	var regexpExec = __webpack_require__(180);
	
	var SPECIES = wks('species');
	
	var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
	  // #replace needs built-in support for named groups.
	  // #match works fine because it just return the exec results, even if it has
	  // a "grops" property.
	  var re = /./;
	  re.exec = function () {
	    var result = [];
	    result.groups = { a: '7' };
	    return result;
	  };
	  return ''.replace(re, '$<a>') !== '7';
	});
	
	var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
	  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
	  var re = /(?:)/;
	  var originalExec = re.exec;
	  re.exec = function () { return originalExec.apply(this, arguments); };
	  var result = 'ab'.split(re);
	  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
	})();
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	
	  var DELEGATES_TO_SYMBOL = !fails(function () {
	    // String methods call symbol-named RegEp methods
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  });
	
	  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
	    // Symbol-named RegExp methods call .exec
	    var execCalled = false;
	    var re = /a/;
	    re.exec = function () { execCalled = true; return null; };
	    if (KEY === 'split') {
	      // RegExp[@@split] doesn't call the regex's exec method, but first creates
	      // a new one. We need to return the patched regex when creating the new one.
	      re.constructor = {};
	      re.constructor[SPECIES] = function () { return re; };
	    }
	    re[SYMBOL]('');
	    return !execCalled;
	  }) : undefined;
	
	  if (
	    !DELEGATES_TO_SYMBOL ||
	    !DELEGATES_TO_EXEC ||
	    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
	    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
	  ) {
	    var nativeRegExpMethod = /./[SYMBOL];
	    var fns = exec(
	      defined,
	      SYMBOL,
	      ''[KEY],
	      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
	        if (regexp.exec === regexpExec) {
	          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
	            // The native String method already delegates to @@method (this
	            // polyfilled function), leasing to infinite recursion.
	            // We avoid it by directly calling the native @@method method.
	            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
	          }
	          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
	        }
	        return { done: false };
	      }
	    );
	    var strfn = fns[0];
	    var rxfn = fns[1];
	
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(46);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(10);
	var cof = __webpack_require__(46);
	var MATCH = __webpack_require__(13)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(13)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(66) || !__webpack_require__(9)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(8)[K];
	});


/***/ }),
/* 127 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var classof = __webpack_require__(92);
	var builtinExec = RegExp.prototype.exec;
	
	 // `RegExpExec` abstract operation
	// https://tc39.github.io/ecma262/#sec-regexpexec
	module.exports = function (R, S) {
	  var exec = R.exec;
	  if (typeof exec === 'function') {
	    var result = exec.call(R, S);
	    if (typeof result !== 'object') {
	      throw new TypeError('RegExp exec method returned something other than an Object or null');
	    }
	    return result;
	  }
	  if (classof(R) !== 'RegExp') {
	    throw new TypeError('RegExp#exec called on incompatible receiver');
	  }
	  return builtinExec.call(R, S);
	};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(2);
	var aFunction = __webpack_require__(25);
	var ctx = __webpack_require__(48);
	var forOf = __webpack_require__(77);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(2);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(50);
	var defined = __webpack_require__(52);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(8);
	var hide = __webpack_require__(31);
	var uid = __webpack_require__(85);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(8);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 134 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"section":"user-shared-data-form__section-d4mdt","label":"user-shared-data-form__label-2LGQl","twoLineLabel":"user-shared-data-form__twoLineLabel-tUX-J","title":"user-shared-data-form__title-3LltT","field":"user-shared-data-form__field-2QBvJ","asterisk":"user-shared-data-form__asterisk-1l7hq","fieldset":"user-shared-data-form__fieldset-2jdwn","radioButton":"user-shared-data-form__radioButton-3AAZX"};

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(876);
	
	module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var hasMap = typeof Map === 'function' && Map.prototype;
	var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
	var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
	var mapForEach = hasMap && Map.prototype.forEach;
	var hasSet = typeof Set === 'function' && Set.prototype;
	var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
	var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
	var setForEach = hasSet && Set.prototype.forEach;
	var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
	var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
	var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
	var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
	var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
	var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
	var booleanValueOf = Boolean.prototype.valueOf;
	var objectToString = Object.prototype.toString;
	var functionToString = Function.prototype.toString;
	var $match = String.prototype.match;
	var $slice = String.prototype.slice;
	var $replace = String.prototype.replace;
	var $toUpperCase = String.prototype.toUpperCase;
	var $toLowerCase = String.prototype.toLowerCase;
	var $test = RegExp.prototype.test;
	var $concat = Array.prototype.concat;
	var $join = Array.prototype.join;
	var $arrSlice = Array.prototype.slice;
	var $floor = Math.floor;
	var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
	var gOPS = Object.getOwnPropertySymbols;
	var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
	var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
	// ie, `has-tostringtag/shams
	var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
	    ? Symbol.toStringTag
	    : null;
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	
	var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
	    [].__proto__ === Array.prototype // eslint-disable-line no-proto
	        ? function (O) {
	            return O.__proto__; // eslint-disable-line no-proto
	        }
	        : null
	);
	
	function addNumericSeparator(num, str) {
	    if (
	        num === Infinity
	        || num === -Infinity
	        || num !== num
	        || (num && num > -1000 && num < 1000)
	        || $test.call(/e/, str)
	    ) {
	        return str;
	    }
	    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
	    if (typeof num === 'number') {
	        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
	        if (int !== num) {
	            var intStr = String(int);
	            var dec = $slice.call(str, intStr.length + 1);
	            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
	        }
	    }
	    return $replace.call(str, sepRegex, '$&_');
	}
	
	var utilInspect = __webpack_require__(1062);
	var inspectCustom = utilInspect.custom;
	var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;
	
	var quotes = {
	    __proto__: null,
	    'double': '"',
	    single: "'"
	};
	var quoteREs = {
	    __proto__: null,
	    'double': /(["\\])/g,
	    single: /(['\\])/g
	};
	
	module.exports = function inspect_(obj, options, depth, seen) {
	    var opts = options || {};
	
	    if (has(opts, 'quoteStyle') && !has(quotes, opts.quoteStyle)) {
	        throw new TypeError('option "quoteStyle" must be "single" or "double"');
	    }
	    if (
	        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
	            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
	            : opts.maxStringLength !== null
	        )
	    ) {
	        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
	    }
	    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
	    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
	        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
	    }
	
	    if (
	        has(opts, 'indent')
	        && opts.indent !== null
	        && opts.indent !== '\t'
	        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
	    ) {
	        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
	    }
	    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
	        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
	    }
	    var numericSeparator = opts.numericSeparator;
	
	    if (typeof obj === 'undefined') {
	        return 'undefined';
	    }
	    if (obj === null) {
	        return 'null';
	    }
	    if (typeof obj === 'boolean') {
	        return obj ? 'true' : 'false';
	    }
	
	    if (typeof obj === 'string') {
	        return inspectString(obj, opts);
	    }
	    if (typeof obj === 'number') {
	        if (obj === 0) {
	            return Infinity / obj > 0 ? '0' : '-0';
	        }
	        var str = String(obj);
	        return numericSeparator ? addNumericSeparator(obj, str) : str;
	    }
	    if (typeof obj === 'bigint') {
	        var bigIntStr = String(obj) + 'n';
	        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
	    }
	
	    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
	    if (typeof depth === 'undefined') { depth = 0; }
	    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
	        return isArray(obj) ? '[Array]' : '[Object]';
	    }
	
	    var indent = getIndent(opts, depth);
	
	    if (typeof seen === 'undefined') {
	        seen = [];
	    } else if (indexOf(seen, obj) >= 0) {
	        return '[Circular]';
	    }
	
	    function inspect(value, from, noIndent) {
	        if (from) {
	            seen = $arrSlice.call(seen);
	            seen.push(from);
	        }
	        if (noIndent) {
	            var newOpts = {
	                depth: opts.depth
	            };
	            if (has(opts, 'quoteStyle')) {
	                newOpts.quoteStyle = opts.quoteStyle;
	            }
	            return inspect_(value, newOpts, depth + 1, seen);
	        }
	        return inspect_(value, opts, depth + 1, seen);
	    }
	
	    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
	        var name = nameOf(obj);
	        var keys = arrObjKeys(obj, inspect);
	        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
	    }
	    if (isSymbol(obj)) {
	        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
	        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
	    }
	    if (isElement(obj)) {
	        var s = '<' + $toLowerCase.call(String(obj.nodeName));
	        var attrs = obj.attributes || [];
	        for (var i = 0; i < attrs.length; i++) {
	            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
	        }
	        s += '>';
	        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
	        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
	        return s;
	    }
	    if (isArray(obj)) {
	        if (obj.length === 0) { return '[]'; }
	        var xs = arrObjKeys(obj, inspect);
	        if (indent && !singleLineValues(xs)) {
	            return '[' + indentedJoin(xs, indent) + ']';
	        }
	        return '[ ' + $join.call(xs, ', ') + ' ]';
	    }
	    if (isError(obj)) {
	        var parts = arrObjKeys(obj, inspect);
	        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
	            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
	        }
	        if (parts.length === 0) { return '[' + String(obj) + ']'; }
	        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
	    }
	    if (typeof obj === 'object' && customInspect) {
	        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
	            return utilInspect(obj, { depth: maxDepth - depth });
	        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
	            return obj.inspect();
	        }
	    }
	    if (isMap(obj)) {
	        var mapParts = [];
	        if (mapForEach) {
	            mapForEach.call(obj, function (value, key) {
	                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
	            });
	        }
	        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
	    }
	    if (isSet(obj)) {
	        var setParts = [];
	        if (setForEach) {
	            setForEach.call(obj, function (value) {
	                setParts.push(inspect(value, obj));
	            });
	        }
	        return collectionOf('Set', setSize.call(obj), setParts, indent);
	    }
	    if (isWeakMap(obj)) {
	        return weakCollectionOf('WeakMap');
	    }
	    if (isWeakSet(obj)) {
	        return weakCollectionOf('WeakSet');
	    }
	    if (isWeakRef(obj)) {
	        return weakCollectionOf('WeakRef');
	    }
	    if (isNumber(obj)) {
	        return markBoxed(inspect(Number(obj)));
	    }
	    if (isBigInt(obj)) {
	        return markBoxed(inspect(bigIntValueOf.call(obj)));
	    }
	    if (isBoolean(obj)) {
	        return markBoxed(booleanValueOf.call(obj));
	    }
	    if (isString(obj)) {
	        return markBoxed(inspect(String(obj)));
	    }
	    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
	    /* eslint-env browser */
	    if (typeof window !== 'undefined' && obj === window) {
	        return '{ [object Window] }';
	    }
	    if (
	        (typeof globalThis !== 'undefined' && obj === globalThis)
	        || (typeof global !== 'undefined' && obj === global)
	    ) {
	        return '{ [object globalThis] }';
	    }
	    if (!isDate(obj) && !isRegExp(obj)) {
	        var ys = arrObjKeys(obj, inspect);
	        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
	        var protoTag = obj instanceof Object ? '' : 'null prototype';
	        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
	        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
	        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
	        if (ys.length === 0) { return tag + '{}'; }
	        if (indent) {
	            return tag + '{' + indentedJoin(ys, indent) + '}';
	        }
	        return tag + '{ ' + $join.call(ys, ', ') + ' }';
	    }
	    return String(obj);
	};
	
	function wrapQuotes(s, defaultStyle, opts) {
	    var style = opts.quoteStyle || defaultStyle;
	    var quoteChar = quotes[style];
	    return quoteChar + s + quoteChar;
	}
	
	function quote(s) {
	    return $replace.call(String(s), /"/g, '&quot;');
	}
	
	function isArray(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
	function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
	function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
	function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
	function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
	function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
	function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
	
	// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
	function isSymbol(obj) {
	    if (hasShammedSymbols) {
	        return obj && typeof obj === 'object' && obj instanceof Symbol;
	    }
	    if (typeof obj === 'symbol') {
	        return true;
	    }
	    if (!obj || typeof obj !== 'object' || !symToString) {
	        return false;
	    }
	    try {
	        symToString.call(obj);
	        return true;
	    } catch (e) {}
	    return false;
	}
	
	function isBigInt(obj) {
	    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
	        return false;
	    }
	    try {
	        bigIntValueOf.call(obj);
	        return true;
	    } catch (e) {}
	    return false;
	}
	
	var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
	function has(obj, key) {
	    return hasOwn.call(obj, key);
	}
	
	function toStr(obj) {
	    return objectToString.call(obj);
	}
	
	function nameOf(f) {
	    if (f.name) { return f.name; }
	    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
	    if (m) { return m[1]; }
	    return null;
	}
	
	function indexOf(xs, x) {
	    if (xs.indexOf) { return xs.indexOf(x); }
	    for (var i = 0, l = xs.length; i < l; i++) {
	        if (xs[i] === x) { return i; }
	    }
	    return -1;
	}
	
	function isMap(x) {
	    if (!mapSize || !x || typeof x !== 'object') {
	        return false;
	    }
	    try {
	        mapSize.call(x);
	        try {
	            setSize.call(x);
	        } catch (s) {
	            return true;
	        }
	        return x instanceof Map; // core-js workaround, pre-v2.5.0
	    } catch (e) {}
	    return false;
	}
	
	function isWeakMap(x) {
	    if (!weakMapHas || !x || typeof x !== 'object') {
	        return false;
	    }
	    try {
	        weakMapHas.call(x, weakMapHas);
	        try {
	            weakSetHas.call(x, weakSetHas);
	        } catch (s) {
	            return true;
	        }
	        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
	    } catch (e) {}
	    return false;
	}
	
	function isWeakRef(x) {
	    if (!weakRefDeref || !x || typeof x !== 'object') {
	        return false;
	    }
	    try {
	        weakRefDeref.call(x);
	        return true;
	    } catch (e) {}
	    return false;
	}
	
	function isSet(x) {
	    if (!setSize || !x || typeof x !== 'object') {
	        return false;
	    }
	    try {
	        setSize.call(x);
	        try {
	            mapSize.call(x);
	        } catch (m) {
	            return true;
	        }
	        return x instanceof Set; // core-js workaround, pre-v2.5.0
	    } catch (e) {}
	    return false;
	}
	
	function isWeakSet(x) {
	    if (!weakSetHas || !x || typeof x !== 'object') {
	        return false;
	    }
	    try {
	        weakSetHas.call(x, weakSetHas);
	        try {
	            weakMapHas.call(x, weakMapHas);
	        } catch (s) {
	            return true;
	        }
	        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
	    } catch (e) {}
	    return false;
	}
	
	function isElement(x) {
	    if (!x || typeof x !== 'object') { return false; }
	    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
	        return true;
	    }
	    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
	}
	
	function inspectString(str, opts) {
	    if (str.length > opts.maxStringLength) {
	        var remaining = str.length - opts.maxStringLength;
	        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
	        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
	    }
	    var quoteRE = quoteREs[opts.quoteStyle || 'single'];
	    quoteRE.lastIndex = 0;
	    // eslint-disable-next-line no-control-regex
	    var s = $replace.call($replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, lowbyte);
	    return wrapQuotes(s, 'single', opts);
	}
	
	function lowbyte(c) {
	    var n = c.charCodeAt(0);
	    var x = {
	        8: 'b',
	        9: 't',
	        10: 'n',
	        12: 'f',
	        13: 'r'
	    }[n];
	    if (x) { return '\\' + x; }
	    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
	}
	
	function markBoxed(str) {
	    return 'Object(' + str + ')';
	}
	
	function weakCollectionOf(type) {
	    return type + ' { ? }';
	}
	
	function collectionOf(type, size, entries, indent) {
	    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
	    return type + ' (' + size + ') {' + joinedEntries + '}';
	}
	
	function singleLineValues(xs) {
	    for (var i = 0; i < xs.length; i++) {
	        if (indexOf(xs[i], '\n') >= 0) {
	            return false;
	        }
	    }
	    return true;
	}
	
	function getIndent(opts, depth) {
	    var baseIndent;
	    if (opts.indent === '\t') {
	        baseIndent = '\t';
	    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
	        baseIndent = $join.call(Array(opts.indent + 1), ' ');
	    } else {
	        return null;
	    }
	    return {
	        base: baseIndent,
	        prev: $join.call(Array(depth + 1), baseIndent)
	    };
	}
	
	function indentedJoin(xs, indent) {
	    if (xs.length === 0) { return ''; }
	    var lineJoiner = '\n' + indent.prev + indent.base;
	    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
	}
	
	function arrObjKeys(obj, inspect) {
	    var isArr = isArray(obj);
	    var xs = [];
	    if (isArr) {
	        xs.length = obj.length;
	        for (var i = 0; i < obj.length; i++) {
	            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
	        }
	    }
	    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
	    var symMap;
	    if (hasShammedSymbols) {
	        symMap = {};
	        for (var k = 0; k < syms.length; k++) {
	            symMap['$' + syms[k]] = syms[k];
	        }
	    }
	
	    for (var key in obj) { // eslint-disable-line no-restricted-syntax
	        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
	        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
	        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
	            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
	            continue; // eslint-disable-line no-restricted-syntax, no-continue
	        } else if ($test.call(/[^\w$]/, key)) {
	            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
	        } else {
	            xs.push(key + ': ' + inspect(obj[key], obj));
	        }
	    }
	    if (typeof gOPS === 'function') {
	        for (var j = 0; j < syms.length; j++) {
	            if (isEnumerable.call(obj, syms[j])) {
	                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
	            }
	        }
	    }
	    return xs;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var computed = __webpack_require__(294);
	
	module.exports = {
	    setComputedFields: function setComputedFields(args, state) {
	        computed.subnavigationElements(state);
	        computed.contentComponents(state);
	    },
	    isShowLocalOrder: function isShowLocalOrder(_ref, state, output) {
	        var showLocal = _ref.showLocal;
	
	        if (showLocal && showLocal == 'true') {
	            output.yes();
	            return;
	        }
	        output.no();
	    }
	};

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(3);
	var moment = __webpack_require__(34);
	
	var _require = __webpack_require__(15),
	    monkey = _require.monkey;
	
	var utils = __webpack_require__(5);
	
	module.exports = {
	    selectChanged: function selectChanged(_ref, state) {
	        var optionsPath = _ref.optionsPath,
	            selectedValue = _ref.selectedValue;
	
	        var options = state.get(optionsPath);
	        var oldSelectedValueIndex = _.findIndex(options, { isActive: true });
	        if (oldSelectedValueIndex > -1) {
	            state.set(optionsPath.concat(oldSelectedValueIndex).concat('isActive'), false);
	        }
	        var selectedIndex = _.findIndex(options, { value: selectedValue });
	        if (selectedIndex > -1) {
	            state.set(optionsPath.concat(selectedIndex).concat('isActive'), true);
	        }
	    },
	    scrollPageDatepicker: function scrollPageDatepicker(path) {
	        return function (_ref2, state) {
	            var toRight = _ref2.toRight;
	
	            sctollDatePickerInternal({ path: path, toRight: toRight }, state);
	        };
	    },
	    scrollPageDatepickerBase: function scrollPageDatepickerBase(basePath) {
	        return function (_ref3, state) {
	            var id = _ref3.id,
	                toRight = _ref3.toRight;
	
	            var path = basePath.concat(id).concat(['datepicker', 'calendar']);
	            sctollDatePickerInternal({ path: path, toRight: toRight }, state);
	        };
	    },
	    setDate: function setDate(basePath) {
	        return function (_ref4, state) {
	            var date = _ref4.date,
	                datepickerId = _ref4.datepickerId;
	
	            state.set(basePath.concat(datepickerId).concat(['datepicker', 'value']), date);
	            state.set(['popups', 'active'], []);
	        };
	    },
	    unsetDate: function unsetDate(basePath) {
	        return function (_ref5, state) {
	            var date = _ref5.date,
	                id = _ref5.id;
	
	            state.unset(basePath.concat(id).concat(['datepicker', 'value']), date);
	        };
	    },
	    setDatePickerComputed: function setDatePickerComputed(id, pathTo, pathFrom, state) {
	        state.set(pathTo, monkey(pathFrom.concat('value'), pathFrom.concat('calendar'), pathFrom.concat('ui', 'isDisabled'), function (selectedDate, calendar, isDisabled) {
	            var today = moment().subtract(1, 'day').unix();
	            var till = moment().add(10, 'y').unix();
	            var title = selectedDate ? moment.unix(selectedDate).format('DD.MM.YYYY') : '';
	            var calendars = calendar ? calendar : [{ date: today }];
	
	            return {
	                id: id,
	                mod: 'discounts',
	                withoutButton: true,
	                withInputs: false,
	                availableRange: {
	                    from: moment({ year: 2000, month: 0 }).unix(),
	                    till: till
	                },
	                calendars: calendars,
	                selectedDate: selectedDate,
	                title: { date: title },
	                isDisabled: isDisabled
	            };
	        }));
	    },
	    togglePopup: function togglePopup(args, state) {
	        var name = 'lead-required-field-' + args.id;
	        utils.togglePopupFromArgs({ name: name }, state);
	    }
	};
	
	function sctollDatePickerInternal(_ref6, state) {
	    var path = _ref6.path,
	        toRight = _ref6.toRight;
	
	    var calendar = state.get(path);
	    var date = calendar ? moment.unix(_.first(calendar).date) : moment().day(1);
	
	    if (toRight) {
	        date.add(1, 'month');
	    } else {
	        date.subtract(1, 'month');
	    }
	    state.set(path, [{ date: date.unix() }]);
	}

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(3);
	var computed = __webpack_require__(299);
	
	module.exports = {
	    setComputedFields: function setComputedFields(args, state) {
	        computed.errorMessage(state);
	        computed.errorState(state);
	    },
	    loginUser: function loginUser(args, state, output, _ref) {
	        var locator = _ref.locator,
	            context = _ref.context;
	
	        var loginForm = state.get(['login', 'form']);
	
	        var loginData = {
	            grant_type: 'password',
	            client_id: 'hermes'
	        };
	
	        loginData = Object.assign(loginData, loginForm);
	
	        var API = locator.resolve('api');
	        var request = API.authUser(context, { loginData: loginData });
	
	        request.then(function (data) {
	            var code = _.get(data, 'status.code');
	            var auth = _.get(data, 'content');
	
	            if (code === 401) {
	                output.accessDenied({ code: code });
	                return;
	            }
	
	            if (code === 400) {
	                output.invalidValidation({ code: code });
	                return;
	            }
	
	            if (code === 200) {
	                output.success({ auth: auth });
	                return;
	            }
	
	            output.error({ code: code });
	        }).catch(function (error) {
	            return output.error({ error: error });
	        });
	    },
	    passLoginInfoToRegistrationForm: function passLoginInfoToRegistrationForm(args, state) {
	        var loginForm = state.get(['login', 'form']);
	        if (loginForm) {
	            var data = {
	                email: loginForm.username,
	                password: loginForm.password
	            };
	            state.set(['registration', 'form'], data);
	        }
	    }
	};

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(3);
	var computed = __webpack_require__(300);
	var computedIndex = __webpack_require__(110);
	
	module.exports = {
	    setComputedFields: function setComputedFields(args, state) {
	        computed.registerButton(state);
	        computed.errorMessage(state);
	        computed.errorState(state);
	        computed.isUserTypeSelectEnabled(state);
	        computedIndex.computeCountryDropdown(state, ['registrationExtra']);
	    },
	    registerHermesUser: function registerHermesUser(args, state, output, _ref) {
	        var locator = _ref.locator,
	            context = _ref.context;
	
	        var formData = state.get(['registrationExtra', 'form']);
	        var token = context.cookie.get('registration_extra_access_token');
	        var refreshToken = context.cookie.get('registration_extra_access_token');
	
	        var registerData = _.chain(formData).pick(['city', 'firstName', 'middleName', 'lastName', 'organization', 'phone', 'isAcceptPersonalDataProcessing', 'legalAddress', 'kpp', 'isLegalEntity', 'userType', 'countryId']).omitBy(_.isUndefined).value();
	
	        if (formData.userType === 1 && formData.countryId === 1) {
	            registerData.inn = formData.inn12;
	        } else if (formData.userType === 2) {
	            switch (formData.countryId) {
	                case 1:
	                    registerData.inn = formData.inn10;
	                    break;
	                case 4:
	                    registerData.inn = formData.bin;
	                    break;
	                default:
	                    break;
	            }
	        } else if (formData.userType === 3) {
	            switch (formData.countryId) {
	                case 1:
	                    registerData.inn = formData.inn12;
	                    break;
	                case 4:
	                    registerData.inn = formData.bin;
	                    break;
	                default:
	                    break;
	            }
	        }
	
	        var API = locator.resolve('api');
	        var request = API.registerHermesUser(context, locator, { registerData: registerData, token: token });
	
	        request.then(function (data) {
	            var code = _.get(data, 'status.code');
	            var status = _.get(data, 'content.status') || 'error';
	
	            if (code !== 200) {
	                output[status]({ code: code });
	                return;
	            }
	
	            var auth = {
	                access_token: token,
	                refresh_token: refreshToken
	            };
	
	            output[status]({ auth: auth });
	        }).catch(function (error) {
	            return output.error({ error: error });
	        });
	    },
	    sendConfirmationMail: function sendConfirmationMail(args, state, output, _ref2) {
	        var locator = _ref2.locator,
	            context = _ref2.context;
	
	        var queryData = {
	            access_token: context.cookie.get('registration_extra_access_token'),
	            locale: 'ru_RU',
	            template: '/static/mail/template/register.twig'
	        };
	
	        var API = locator.resolve('api');
	        API.sendConfirmationMail(context, { queryData: queryData });
	    },
	    acceptPersonalDataProcessing: function acceptPersonalDataProcessing(args, state) {
	        state.set(['registrationExtra', 'form', 'isAcceptPersonalDataProcessing'], true);
	    },
	    declinePersonalDataProcessing: function declinePersonalDataProcessing(args, state) {
	        state.set(['registrationExtra', 'form', 'isAcceptPersonalDataProcessing'], false);
	    },
	    setRegistrationProperty: function setRegistrationProperty(_ref3, state) {
	        var path = _ref3.path,
	            value = _ref3.value;
	
	        state.set(['registrationExtra', 'form', path], value);
	    },
	    selectUserType: function selectUserType(_ref4, state) {
	        var key = _ref4.key;
	
	        var path = ['registrationExtra', 'form', 'isLegalEntity'];
	        var isLegalEntity = key === 'true';
	        state.set(path, isLegalEntity);
	    }
	};

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(3);
	
	var _require = __webpack_require__(15),
	    monkey = _require.monkey;
	
	var moment = __webpack_require__(34);
	var DATE_FORMAT = 'DD.MM.YYYY';
	
	var _require2 = __webpack_require__(4),
	    pluralize = _require2.pluralize;
	
	var _require3 = __webpack_require__(58),
	    Query = _require3.Query;
	
	var orderStateNameHolder = __webpack_require__(216);
	
	function prepareTitle(allOptions, selectedOptions) {
	    var selectionNum = selectedOptions.length;
	    var title = pluralize(selectionNum, ['Выбран', 'Выбрано', 'Выбрано']) + ' ' + selectionNum + '\n                        ' + pluralize(selectionNum, ['статус', 'статуса', 'статусов']);
	
	    if (allOptions.length == selectionNum) {
	        return 'Все статусы';
	    } else if (selectionNum == 0) {
	        return 'Выберите статусы';
	    }
	
	    return title;
	}
	
	module.exports = {
	    formatOrderList: function formatOrderList(state) {
	        state.set(['account', 'orders', 'computed', 'ordersList'], monkey(['account', 'orders', 'list', 'data'], ['account', 'orders', 'currentOrder', 'id'], function () {
	            var ordersList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	            var currentOrderId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	            return _.map(ordersList, function (item) {
	                return {
	                    id: item.id,
	                    name: item.name,
	                    createDate: moment(item.createDate).format(DATE_FORMAT),
	                    isSelected: item.id === currentOrderId,
	                    stateId: Number(item.stateId),
	                    stateName: orderStateNameHolder.getOrderStateName(item.stateId),
	                    userNameMarkedup: item.userNameMarkedup && item.userNameMarkedup.length > 0 ? item.userNameMarkedup : undefined,
	                    userEmailMarkedup: item.userEmailMarkedup && item.userEmailMarkedup.length > 0 ? item.userEmailMarkedup : undefined,
	                    idMarkedup: item.idMarkedup && item.idMarkedup.length > 0 ? item.idMarkedup : undefined,
	                    nameMarkedup: item.nameMarkedup && item.nameMarkedup.length > 0 ? item.nameMarkedup : undefined
	                };
	            });
	        }));
	    },
	    computeSelectedStatesArray: function computeSelectedStatesArray(state) {
	        state.set(['account', 'orders', 'computed', 'list', 'selectedStates'], monkey(['account', 'orders', 'list', 'stateFilter'], function (stateFilter) {
	            var status = void 0;
	            if (stateFilter) {
	                status = [];
	                _.forEach(Object.keys(stateFilter), function (key) {
	                    if (stateFilter[key].isChecked === true && !isNaN(key)) {
	                        status.push(Number(key));
	                    }
	                });
	            }
	            return status;
	        }));
	    },
	    computeSelectedTypesArray: function computeSelectedTypesArray(state) {
	        state.set(['account', 'orders', 'computed', 'list', 'selectedTypes'], monkey(['account', 'orders', 'list', 'typeFilter'], function (typeFilter) {
	            var type = void 0;
	            if (typeFilter) {
	                type = [];
	                _.forEach(Object.keys(typeFilter), function (key) {
	                    if (typeFilter[key].isChecked === true && !isNaN(key)) {
	                        type.push(Number(key));
	                    }
	                });
	            }
	            return type;
	        }));
	    },
	    queryObject: function queryObject(state) {
	        state.set(['account', 'orders', 'computed', 'query'], monkey(['account', 'orders', 'list', 'selectedRadioFilter'], ['account', 'orders', 'computed', 'list', 'selectedStates'], ['account', 'orders', 'list', 'selectedTypeFilter'], ['account', 'orders', 'list', 'filterText'], ['account', 'orders', 'computed', 'list', 'selectedTypes'], function (assigned, status, orderTypeForUser, text, orderTypeForManager) {
	            var type = orderTypeForUser || orderTypeForManager || undefined;
	            var queryObj = _.omitBy({ assigned: assigned, status: status, type: type, text: text }, _.isUndefined);
	
	            var query = new Query();
	            query.values = queryObj;
	
	            return query.toString();
	        }));
	    },
	    setOrdersFilters: function setOrdersFilters(args, state) {
	        var FILTERS = [{
	            title: 'Активные заказы',
	            value: 'active',
	            form: 'circle',
	            color: 'green'
	        }, {
	            title: 'Неактивные заказы',
	            value: 'inactive',
	            form: 'circle',
	            color: 'gray'
	        }, {
	            title: 'Все заказы',
	            value: 'all',
	            form: 'circle',
	            color: 'transparent'
	        }];
	
	        state.set(['account', 'orders', 'computed', 'ordersOriginalFilters'], monkey(['user', 'role'], function (role) {
	            if (role === 'client') {
	                return _.reject(FILTERS, { value: 'myOrders' });
	            }
	            if (role === 'unauthorized') {
	                return _.filter(FILTERS, { value: 'all' });
	            }
	
	            return FILTERS;
	        }));
	    },
	    setActiveOrdersFilter: function setActiveOrdersFilter(args, state) {
	        state.set(['account', 'orders', 'computed', 'typeFilter'], monkey(['account', 'orders', 'computed', 'ordersOriginalFilters'], ['account', 'orders', 'list', 'selectedTypeFilter'], ['account', 'orders', 'ui', 'typeFilter', 'isDisabled'], function (filters, currentFilter, isDisabled) {
	            var options = _.map(filters, function (item) {
	                return Object.assign({ isActive: currentFilter == item.value }, item);
	            });
	
	            return { options: options, isDisabled: isDisabled };
	        }));
	    },
	    setStatusSelect: function setStatusSelect(args, state) {
	        state.set(['account', 'orders', 'computed', 'statusFilter'], monkey(['account', 'orders', 'list', 'statusFilterData'], ['account', 'orders', 'list', 'selectedStatus'], function (allStatus) {
	            var selectedStatus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	            var options = _.map(allStatus, function (status) {
	                return {
	                    isSelected: _.includes(selectedStatus, status.id),
	                    key: status.id,
	                    name: status.name
	                };
	            });
	
	            var title = prepareTitle(options, selectedStatus);
	            var allSelected = options.length === selectedStatus.length;
	            var allUnchecked = !selectedStatus.length;
	
	            return { options: options, title: title, allSelected: allSelected, allUnchecked: allUnchecked };
	        }));
	    },
	    setRadioFilter: function setRadioFilter(args, state) {
	        state.set(['account', 'orders', 'computed', 'assignType'], monkey(['account', 'orders', 'list', 'selectedRadioFilter'], function () {
	            var selectedKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'all';
	
	            var defaultState = {
	                all: false,
	                my: false,
	                unassigned: false
	            };
	
	            defaultState[selectedKey] = true;
	
	            return defaultState;
	        }));
	    },
	    computeIsRadioFilterActive: function computeIsRadioFilterActive(args, state) {
	        state.set(['account', 'orders', 'computed', 'list', 'isAssignTypeFilterActive'], monkey(['account', 'orders', 'list', 'selectedRadioFilter'], function (selectedRadioFilter) {
	            return selectedRadioFilter && selectedRadioFilter !== "any";
	        }));
	    }
	};

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(3);
	var numberOfEmployees = __webpack_require__(145);
	var paymentTypes = __webpack_require__(146);
	var legalEntities = __webpack_require__(112);
	var purposes = __webpack_require__(113);
	
	function calcEnabledGreederColumns(args, state) {
	    var sources = state.get(['order', 'addParams', 'greederColumns', 'source']);
	    var enabledSources = _.filter(Object.keys(sources), function (x) {
	        return sources[x].isChecked === true;
	    });
	    var isEnabledFunc = function isEnabledFunc(x) {
	        return false;
	    };
	    if (enabledSources.length === 2) {
	        isEnabledFunc = function isEnabledFunc(x) {
	            return true;
	        };
	    } else if (enabledSources[0] === 'egrip') {
	        isEnabledFunc = function isEnabledFunc(x) {
	            return x.isEgrip === true;
	        };
	    } else if (enabledSources[0] === 'egrul') {
	        isEnabledFunc = function isEnabledFunc(x) {
	            return x.isEgrul === true;
	        };
	    }
	    var columns = _.filter(state.get(['order', 'originalParameters', 'greederColumns']), function (x) {
	        return x.isEgrip || x.isEgrul;
	    });
	    var viewColumns = state.get(['order', 'addParams', 'greederColumns', 'view', 'gosReg']);
	    _.forEach(columns, function (x) {
	        var index = _.findIndex(viewColumns, { id: x.id });
	        state.set(['order', 'addParams', 'greederColumns', 'view', 'gosReg', index, 'isEnabled'], isEnabledFunc(x));
	    });
	}
	
	module.exports = {
	    changeDateDatepickerFrom: function changeDateDatepickerFrom(_ref, state) {
	        var date = _ref.date;
	
	        state.set(['order', 'addParams', 'datepicker', 'value'], date);
	        var to = state.get(['order', 'addParams', 'datepicker2', 'value']);
	        if (to && date > to) {
	            state.unset(['order', 'addParams', 'datepicker2', 'value']);
	        }
	    },
	    changeDateDatepickerTo: function changeDateDatepickerTo(_ref2, state) {
	        var date = _ref2.date;
	
	        var dateEnd = Number(date) + 86340;
	        state.set(['order', 'addParams', 'datepicker2', 'value'], dateEnd);
	        var from = state.get(['order', 'addParams', 'datepicker', 'value']);
	        if (from && dateEnd < from) {
	            state.unset(['order', 'addParams', 'datepicker', 'value']);
	        }
	    },
	    initExportColumnsState: function initExportColumnsState(args, state) {
	        var columns = {};
	        _.forEach(state.get(['order', 'originalParameters', 'exportColumns', 'columns']), function (x) {
	            columns[x.id] = { id: x.id, isChecked: x.isBasic, isMustBeFilled: false };
	        });
	        state.set(['order', 'addParams', 'exportColumns'], columns);
	    },
	    initGreederColumns: function initGreederColumns(args, state) {
	        var origin = state.get(['order', 'originalParameters', 'greederColumns']);
	
	        var columnGroups = _.groupBy(_.filter(origin, function (x) {
	            return x.source;
	        }), function (x) {
	            return x.source;
	        });
	        _.forEach(columnGroups, function (x, key) {
	            state.set(['order', 'addParams', 'greederColumns', 'view', key], _.map(x, function (y) {
	                return { id: y.id, title: y.title };
	            }));
	        });
	        state.set(['order', 'addParams', 'greederColumns', 'view', 'gosReg'], _.map(_.filter(origin, function (x) {
	            return x.isEgrip || x.isEgrul;
	        }), function (x) {
	            return { id: x.id, title: x.title };
	        }));
	
	        var values = {};
	        _.forEach(origin, function (x) {
	            values[x.id] = { id: x.id };
	        });
	        state.set(['order', 'addParams', 'greederColumns', 'value'], values);
	    },
	    setGreederColumnIsChecked: function setGreederColumnIsChecked(_ref3, state) {
	        var path = _ref3.path,
	            value = _ref3.value;
	
	        state.set(['order', 'addParams', 'greederColumns', 'value', path, 'isChecked'], value);
	    },
	    setAllGreederColumnIsChecked: function setAllGreederColumnIsChecked(_ref4, state) {
	        var value = _ref4.value;
	
	        var gosColumns = state.get(['order', 'addParams', 'greederColumns', 'view', 'gosReg']);
	        if (value === true) {
	            gosColumns = _.filter(gosColumns, { isEnabled: true });
	        }
	        _.forEach(gosColumns, function (x) {
	            state.set(['order', 'addParams', 'greederColumns', 'value', x.id, 'isChecked'], value);
	        });
	        calcEnabledGreederColumns({}, state);
	    },
	    setGreederColumnSource: function setGreederColumnSource(_ref5, state) {
	        var path = _ref5.path,
	            value = _ref5.value;
	
	        state.set(['order', 'addParams', 'greederColumns', 'source', path, 'isChecked'], value);
	        calcEnabledGreederColumns({}, state);
	    },
	
	
	    calcEnabledGreederColumns: calcEnabledGreederColumns,
	
	    setExportColumnIsChecked: function setExportColumnIsChecked(_ref6, state) {
	        var path = _ref6.path,
	            value = _ref6.value;
	
	        var pathInt = parseInt(path, 10);
	        state.set(['order', 'addParams', 'exportColumns', pathInt, 'isChecked'], value);
	        if (value === false) {
	            state.set(['order', 'addParams', 'exportColumns', pathInt, 'isMustBeFilled'], value);
	            state.unset(['order', 'addParams', 'exportColumns', pathInt, 'value']);
	            state.unset(['order', 'addParams', 'exportColumns', pathInt, 'error']);
	
	            var dateColumnId = _.find(state.get(['order', 'originalParameters', 'exportColumns', 'columns']), { filterType: 'IsInRangeDatetime' });
	            if (dateColumnId && pathInt == dateColumnId.id) {
	                state.set(['order', 'addParams', 'datepicker', 'value'], null);
	                state.set(['order', 'addParams', 'datepicker2', 'value'], null);
	            }
	
	            legalEntities.tryUnsetSelected({ path: pathInt }, state);
	            numberOfEmployees.tryUnsetSelected({ path: pathInt }, state);
	            paymentTypes.tryUnsetSelected({ path: pathInt }, state);
	            purposes.tryUnsetSelected({ path: pathInt }, state);
	        }
	    },
	    setExportDateTimeColumnIsChecked: function setExportDateTimeColumnIsChecked(args, state) {
	        var dateColumnId = _.find(state.get(['order', 'originalParameters', 'exportColumns', 'columns']), { filterType: 'IsInRangeDatetime' }).id;
	        state.set(['order', 'addParams', 'exportColumns', dateColumnId, 'isChecked'], true);
	    },
	    setExportAreaColumnIsChecked: function setExportAreaColumnIsChecked(args, state) {
	        var columnId = _.find(state.get(['order', 'originalParameters', 'exportColumns', 'columns']), { filterType: 'IsInRangeDouble' }).id;
	        state.set(['order', 'addParams', 'exportColumns', columnId, 'isChecked'], true);
	    },
	    setExportColumnIsMustBeFilled: function setExportColumnIsMustBeFilled(_ref7, state) {
	        var path = _ref7.path,
	            value = _ref7.value;
	
	        state.set(['order', 'addParams', 'exportColumns', path, 'isMustBeFilled'], value);
	        if (value) {
	            state.set(['order', 'addParams', 'exportColumns', path, 'isChecked'], value);
	        }
	    },
	    unsetRelatedParams: function unsetRelatedParams(_ref8, state) {
	        var path = _ref8.path,
	            value = _ref8.value;
	
	        var RELATED = {
	            Inn: ['order', 'addParams', 'includeArchiveInn']
	        };
	
	        var columns = state.get(['order', 'originalParameters', 'exportColumns', 'columns']);
	        var propertyName = (_.find(columns, function (_ref9) {
	            var id = _ref9.id;
	            return id == path;
	        }) || {}).propertyName;
	
	        if (value === false && propertyName && RELATED[propertyName]) {
	            state.set(RELATED[propertyName], false);
	        }
	    }
	};

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(3);
	var treeHelper = __webpack_require__(57);
	
	var _require = __webpack_require__(111),
	    clearFilter = _require.clearFilter;
	
	var BASE_PATH = ['order', 'branches', 'tree'];
	var ORIGINAL_DATA_PATH = ['order', 'originalParameters', 'branches'];
	
	module.exports = {
	    initTreeState: function initTreeState(args, state) {
	        treeHelper.initTreeUiState(state, ORIGINAL_DATA_PATH, BASE_PATH);
	    },
	    changeValue: function changeValue(_ref, state) {
	        var path = _ref.path,
	            value = _ref.value;
	
	        treeHelper.changeTreeNodeValue(state, ORIGINAL_DATA_PATH, BASE_PATH, path, value);
	    },
	    setSelection: function setSelection(_ref2, state) {
	        var value = _ref2.value,
	            filter = _ref2.filter;
	
	        treeHelper.setValueByFilter(state, ORIGINAL_DATA_PATH, BASE_PATH, value, filter);
	    },
	    getCitiesTreeFilter: function getCitiesTreeFilter(args, state) {
	        var leafs = state.get(BASE_PATH.concat('computed', 'leafs'));
	        var selected = state.get(BASE_PATH.concat('selected'));
	        var selectedBranches = treeHelper.getSelectedLeafs(leafs, selected);
	        var calcOnlyDefaultCities = state.get(['order', 'cities', 'calcOnlyDefaultCities']);
	        if (calcOnlyDefaultCities) {
	            var originalBranches = state.get(['order', 'originalParameters', 'branches']);
	            var selectedCities = _.map(_.filter(originalBranches, function (x) {
	                return selectedBranches.includes(x.code);
	            }), function (x) {
	                return x.defaultCityId;
	            });
	
	            args.filter = function (node) {
	                if (node.branchId) {
	                    return selectedCities.includes(node.code);
	                }
	                return false;
	            };
	        } else {
	            args.filter = function (node) {
	                if (node.branchId) {
	                    return selectedBranches.includes(node.branchId.toString());
	                }
	                return false;
	            };
	        }
	    },
	    setAll: function setAll(_ref3, state) {
	        var value = _ref3.value;
	
	        treeHelper.setAllSelection(state, ORIGINAL_DATA_PATH, BASE_PATH, value);
	    },
	    clearFilter: function clearFilter(args, state) {
	        treeHelper.clearFilter(state, BASE_PATH, 'branches');
	    }
	};

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var commonTree = __webpack_require__(98);
	
	var TREE_BASE_PATH = ['order', 'addParams', 'mapClasses', 'tree'];
	var ORIGINAL_DATA_PATH = ['order', 'originalParameters', 'mapClasses'];
	var PROPERTY_NAME = 'MapClass';
	
	module.exports = {
	    initTreeState: function initTreeState(args, state) {
	        commonTree.initTreeState(args, state, ORIGINAL_DATA_PATH, TREE_BASE_PATH);
	    },
	    changeValue: function changeValue(args, state) {
	        commonTree.changeValue(args, state, ORIGINAL_DATA_PATH, TREE_BASE_PATH, PROPERTY_NAME);
	    },
	    setAll: function setAll(args, state) {
	        commonTree.setAll(args, state, ORIGINAL_DATA_PATH, TREE_BASE_PATH, PROPERTY_NAME);
	    },
	    tryUnsetSelected: function tryUnsetSelected(args, state) {
	        commonTree.tryUnsetSelected(args, state, ORIGINAL_DATA_PATH, TREE_BASE_PATH, PROPERTY_NAME);
	    },
	    clearFilter: function clearFilter(args, state) {
	        commonTree.clearFilter(args, state, TREE_BASE_PATH, 'mapClasses');
	    }
	};

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var commonTree = __webpack_require__(98);
	
	var TREE_BASE_PATH = ['order', 'addParams', 'numberOfEmployees', 'tree'];
	var ORIGINAL_DATA_PATH = ['order', 'originalParameters', 'numberOfEmployees'];
	var PROPERTY_NAME = 'NumberOfEmployees';
	
	module.exports = {
	    initTreeState: function initTreeState(args, state) {
	        commonTree.initTreeState(args, state, ORIGINAL_DATA_PATH, TREE_BASE_PATH);
	    },
	    changeValue: function changeValue(args, state) {
	        commonTree.changeValue(args, state, ORIGINAL_DATA_PATH, TREE_BASE_PATH, PROPERTY_NAME);
	    },
	    setAll: function setAll(args, state) {
	        commonTree.setAll(args, state, ORIGINAL_DATA_PATH, TREE_BASE_PATH, PROPERTY_NAME);
	    },
	    tryUnsetSelected: function tryUnsetSelected(args, state) {
	        commonTree.tryUnsetSelected(args, state, ORIGINAL_DATA_PATH, TREE_BASE_PATH, PROPERTY_NAME);
	    }
	};

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var commonTree = __webpack_require__(98);
	
	var TREE_BASE_PATH = ['order', 'addParams', 'paymentTypes', 'tree'];
	var ORIGINAL_DATA_PATH = ['order', 'originalParameters', 'paymentTypes'];
	var PROPERTY_NAME = 'PaymentTypes';
	
	module.exports = {
	    initTreeState: function initTreeState(args, state) {
	        commonTree.initTreeState(args, state, ORIGINAL_DATA_PATH, TREE_BASE_PATH);
	    },
	    changeValue: function changeValue(args, state) {
	        commonTree.changeValue(args, state, ORIGINAL_DATA_PATH, TREE_BASE_PATH, PROPERTY_NAME);
	    },
	    setAll: function setAll(args, state) {
	        commonTree.setAll(args, state, ORIGINAL_DATA_PATH, TREE_BASE_PATH, PROPERTY_NAME);
	    },
	    tryUnsetSelected: function tryUnsetSelected(args, state) {
	        commonTree.tryUnsetSelected(args, state, ORIGINAL_DATA_PATH, TREE_BASE_PATH, PROPERTY_NAME);
	    }
	};

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(769);
	
	var Header = function () {
	    function Header() {
	        _classCallCheck(this, Header);
	
	        this.template = __webpack_require__(901);
	    }
	
	    Header.prototype.render = function render() {
	        var _this = this;
	
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, _this.$context.props, { css: css });
	        });
	    };
	
	    return Header;
	}();
	
	module.exports = {
	    constructor: Header
	};

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var $ = __webpack_require__(12);
	var css = __webpack_require__(768);
	
	var _require = __webpack_require__(4),
	    cut = _require.cut;
	
	var SELECTOR_HEADER = cut(css.headerClickable);
	var SELECTOR_COLLAPSED = css.collapsed;
	var SELECTOR_WRAPPER = cut(css.wrapper);
	var SELECTOR_PANEL = cut(css.panel);
	var SELECTOR_CONTENT = cut(css.content);
	
	var Collapse = function () {
	    function Collapse() {
	        _classCallCheck(this, Collapse);
	
	        this.template = __webpack_require__(902);
	    }
	
	    Collapse.prototype.render = function render() {
	        var _this = this;
	
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, _this.$context.props, { css: css });
	        });
	    };
	
	    Collapse.prototype.bind = function bind() {
	        var _click;
	
	        return {
	            click: (_click = {}, _click[SELECTOR_HEADER] = this.onClick, _click)
	        };
	    };
	
	    Collapse.prototype.onClick = function onClick(e) {
	        e.stopPropagation();
	
	        var element = $(this.$context.element);
	        var panel = element.find(SELECTOR_PANEL);
	        var content = element.find(SELECTOR_CONTENT);
	        var wrapper = element.find(SELECTOR_WRAPPER);
	
	        var fullHeight = wrapper.height();
	
	        var isCollapsed = panel.hasClass(SELECTOR_COLLAPSED);
	        panel.toggleClass(SELECTOR_COLLAPSED);
	
	        var startHeight = isCollapsed ? 0 : fullHeight;
	        var height = isCollapsed ? fullHeight : 0;
	
	        content.css({ overflow: 'hidden', 'max-height': startHeight + 'px' });
	
	        content.animate({ 'max-height': height + 'px' }, 250, function () {
	            content.removeAttr('style');
	        });
	    };
	
	    return Collapse;
	}();
	
	module.exports = Collapse;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var $ = __webpack_require__(12);
	var css = __webpack_require__(814);
	
	var _require = __webpack_require__(4),
	    cut = _require.cut;
	
	var _require2 = __webpack_require__(90),
	    raiseEvent = _require2.raiseEvent;
	
	var bitrix = __webpack_require__(29);
	
	var SELECTOR_HEADER = cut(css.headerClickable);
	var SELECTOR_COLLAPSED = css.collapsed;
	var SELECTOR_WRAPPER = cut(css.wrapper);
	var SELECTOR_PANEL = cut(css.panel);
	var SELECTOR_CONTENT = cut(css.content);
	
	var Collapse = function () {
	    function Collapse() {
	        _classCallCheck(this, Collapse);
	
	        this.template = __webpack_require__(951);
	    }
	
	    Collapse.prototype.render = function render() {
	        var _this = this;
	
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, _this.$context.props, { css: css });
	        });
	    };
	
	    Collapse.prototype.bind = function bind() {
	        var _click;
	
	        return {
	            click: (_click = {}, _click[SELECTOR_HEADER] = this.onClick, _click)
	        };
	    };
	
	    Collapse.prototype.onClick = function onClick(e) {
	        var _this2 = this;
	
	        e.stopPropagation();
	
	        var element = $(this.$context.element);
	        var panel = element.find(SELECTOR_PANEL);
	        var content = element.find(SELECTOR_CONTENT);
	        var wrapper = element.find(SELECTOR_WRAPPER);
	
	        var fullHeight = wrapper.height();
	
	        var isCollapsed = panel.hasClass(SELECTOR_COLLAPSED);
	        panel.toggleClass(SELECTOR_COLLAPSED);
	
	        var startHeight = isCollapsed ? 0 : fullHeight;
	        var height = isCollapsed ? fullHeight : 0;
	
	        content.css({ overflow: 'hidden', 'max-height': startHeight + 'px' });
	
	        content.animate({ 'max-height': height + 'px' }, 250, function () {
	            content.removeAttr('style');
	            _this2.$context.signal(bitrix.resize);
	        });
	
	        if (this.$context.props.dontUseMetric !== 'true' && isCollapsed) {
	            this.$context.signal(raiseEvent, { category: this.$context.props.metricCategory, action: 'click' });
	        }
	    };
	
	    return Collapse;
	}();
	
	module.exports = Collapse;

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var cities = __webpack_require__(382);
	var rubrics = __webpack_require__(394);
	var addParams = __webpack_require__(374);
	var tooltip = __webpack_require__(395);
	var MakeOrderButton = __webpack_require__(214);
	var css = __webpack_require__(815);
	
	var _require = __webpack_require__(4),
	    cut = _require.cut;
	
	var RESET_SELECTOR = cut(css.reset);
	
	var CustomOrder = function () {
	    function CustomOrder() {
	        _classCallCheck(this, CustomOrder);
	
	        this.template = __webpack_require__(965);
	    }
	
	    CustomOrder.prototype.render = function render() {
	        var isEditable = this.$context.props.isEditable;
	        var showReset = this.$context.props.showReset;
	        var showOrderButton = this.$context.props.showOrderButton;
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({ isEditable: isEditable, showReset: showReset, showOrderButton: showOrderButton }, data, { css: css });
	        });
	    };
	
	    CustomOrder.prototype.bind = function bind() {
	        var _click;
	
	        return {
	            click: (_click = {}, _click[RESET_SELECTOR] = this.onReset, _click)
	        };
	    };
	
	    CustomOrder.prototype.onReset = function onReset(e) {
	        e.preventDefault();
	        this.$context.signal(this.$context.props.onReset);
	    };
	
	    return CustomOrder;
	}();
	
	module.exports = {
	    constructor: CustomOrder,
	    children: [{
	        name: 'cities-collapse',
	        component: cities,
	        parentPropsMap: {
	            isSmallTree: 'isSmallTree',
	            dontUseMetric: 'dontUseMetric'
	        },
	        props: {
	            metricCategory: 'link_city'
	        }
	    }, {
	        name: 'rubrics-collapse',
	        component: rubrics,
	        parentPropsMap: {
	            isSmallTree: 'isSmallTree',
	            dontUseMetric: 'dontUseMetric'
	        },
	        props: {
	            metricCategory: 'link_rubric'
	        }
	    }, {
	        name: 'additional-parameters-collapse',
	        component: addParams,
	        parentPropsMap: {
	            isSmallTree: 'isSmallTree',
	            dontUseMetric: 'dontUseMetric'
	        },
	        props: {
	            metricCategory: 'link_extra_options'
	        }
	    }, {
	        name: 'tooltip',
	        component: tooltip,
	        watcher: {
	            showDataChangedTooltip: ['order', 'computed', 'showDataChangeTooltip']
	        }
	    }, {
	        name: 'make-order-button',
	        component: MakeOrderButton,
	        props: {
	            isBig: true
	        },
	        watcher: {
	            totalPrice: ['order', 'price', 'data', 'total', 'totalPrice'],
	            isZero: ['order', 'price', 'isZero']
	        }
	    }]
	};

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Discounts = function () {
	    function Discounts() {
	        _classCallCheck(this, Discounts);
	
	        this.template = __webpack_require__(967);
	    }
	
	    Discounts.prototype.render = function render() {
	        return this.$context.getWatcherData();
	    };
	
	    return Discounts;
	}();
	
	module.exports = {
	    constructor: Discounts
	};

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(134);
	
	var _require = __webpack_require__(24),
	    Text = _require.Text;
	
	var _require2 = __webpack_require__(26),
	    inputText = _require2.inputText,
	    blurText = _require2.blurText;
	
	var SCHEMES = __webpack_require__(22);
	
	var UserForm = function () {
	    function UserForm() {
	        _classCallCheck(this, UserForm);
	
	        this.template = __webpack_require__(969);
	    }
	
	    UserForm.prototype.render = function render() {
	        var _this = this;
	
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, _this.$context.props, { css: css });
	        });
	    };
	
	    return UserForm;
	}();
	
	module.exports = function (formPath) {
	    return {
	        constructor: UserForm,
	        children: [{
	            name: 'text-inn12',
	            component: Text,
	            props: {
	                signals: { inputText: inputText, blurText: blurText },
	                position: 'leftToRight',
	                scheme: SCHEMES.inn12
	            },
	            watcher: {
	                value: formPath.concat(['form', 'inn12']),
	                error: formPath.concat(['error', 'inn12'])
	            }
	        }, {
	            name: 'text-legal-address',
	            component: Text,
	            props: {
	                signals: { inputText: inputText, blurText: blurText }
	            },
	            watcher: {
	                value: formPath.concat(['form', 'legalAddress'])
	            }
	        }]
	    };
	};

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(134);
	
	var _require = __webpack_require__(24),
	    Text = _require.Text;
	
	var _require2 = __webpack_require__(26),
	    inputText = _require2.inputText,
	    blurText = _require2.blurText;
	
	var SCHEMES = __webpack_require__(22);
	
	var UserForm = function () {
	    function UserForm() {
	        _classCallCheck(this, UserForm);
	
	        this.template = __webpack_require__(970);
	    }
	
	    UserForm.prototype.render = function render() {
	        var _this = this;
	
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, _this.$context.props, { css: css });
	        });
	    };
	
	    return UserForm;
	}();
	
	module.exports = function (formPath) {
	    return {
	        constructor: UserForm,
	        children: [{
	            name: 'text-org',
	            component: Text,
	            props: {
	                signals: { inputText: inputText, blurText: blurText }
	            },
	            watcher: {
	                value: formPath.concat(['form', 'organization'])
	            }
	        }, {
	            name: 'text-inn10',
	            component: Text,
	            props: {
	                signals: { inputText: inputText, blurText: blurText },
	                position: 'leftToRight',
	                scheme: SCHEMES.inn10
	            },
	            watcher: {
	                value: formPath.concat(['form', 'inn10']),
	                error: formPath.concat(['error', 'inn10'])
	            }
	        }, {
	            name: 'text-bin',
	            component: Text,
	            props: {
	                signals: { inputText: inputText, blurText: blurText },
	                position: 'leftToRight',
	                scheme: SCHEMES.bin
	            },
	            watcher: {
	                value: formPath.concat(['form', 'bin']),
	                error: formPath.concat(['error', 'bin'])
	            }
	        }, {
	            name: 'text-kpp',
	            component: Text,
	            props: {
	                signals: { inputText: inputText, blurText: blurText },
	                position: 'leftToRight',
	                scheme: SCHEMES.kpp
	            },
	            watcher: {
	                value: formPath.concat(['form', 'kpp']),
	                error: formPath.concat(['error', 'kpp'])
	            }
	        }, {
	            name: 'text-legal-address',
	            component: Text,
	            props: {
	                signals: { inputText: inputText, blurText: blurText }
	            },
	            watcher: {
	                value: formPath.concat(['form', 'legalAddress'])
	            }
	        }]
	    };
	};

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(134);
	
	var _require = __webpack_require__(24),
	    Text = _require.Text;
	
	var _require2 = __webpack_require__(26),
	    inputText = _require2.inputText,
	    blurText = _require2.blurText;
	
	var SCHEMES = __webpack_require__(22);
	
	var UserForm = function () {
	    function UserForm() {
	        _classCallCheck(this, UserForm);
	
	        this.template = __webpack_require__(971);
	    }
	
	    UserForm.prototype.render = function render() {
	        var _this = this;
	
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, _this.$context.props, { css: css });
	        });
	    };
	
	    return UserForm;
	}();
	
	module.exports = function (formPath) {
	    return {
	        constructor: UserForm,
	        children: [{
	            name: 'text-org',
	            component: Text,
	            props: {
	                signals: { inputText: inputText, blurText: blurText }
	            },
	            watcher: {
	                value: formPath.concat(['form', 'organization'])
	            }
	        }, {
	            name: 'text-inn12',
	            component: Text,
	            props: {
	                signals: { inputText: inputText, blurText: blurText },
	                position: 'leftToRight',
	                scheme: SCHEMES.inn12
	            },
	            watcher: {
	                value: formPath.concat(['form', 'inn12']),
	                error: formPath.concat(['error', 'inn12'])
	            }
	        }, {
	            name: 'text-bin',
	            component: Text,
	            props: {
	                signals: { inputText: inputText, blurText: blurText },
	                position: 'leftToRight',
	                scheme: SCHEMES.bin
	            },
	            watcher: {
	                value: formPath.concat(['form', 'bin']),
	                error: formPath.concat(['error', 'bin'])
	            }
	        }, {
	            name: 'text-legal-address',
	            component: Text,
	            props: {
	                signals: { inputText: inputText, blurText: blurText }
	            },
	            watcher: {
	                value: formPath.concat(['form', 'legalAddress'])
	            }
	        }]
	    };
	};

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(134);
	
	var _require = __webpack_require__(24),
	    Text = _require.Text,
	    Radio = _require.Radio,
	    Select = _require.Select;
	
	var _require2 = __webpack_require__(26),
	    inputText = _require2.inputText,
	    blurText = _require2.blurText;
	
	var SCHEMES = __webpack_require__(22);
	var signalsUtils = __webpack_require__(11);
	
	var UserForm = function () {
	    function UserForm() {
	        _classCallCheck(this, UserForm);
	
	        this.template = __webpack_require__(974);
	    }
	
	    UserForm.prototype.render = function render() {
	        var _this = this;
	
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, _this.$context.props, { css: css });
	        });
	    };
	
	    return UserForm;
	}();
	
	module.exports = function (formPath, signalSelectUserType, signalSelectCounty) {
	    return {
	        constructor: UserForm,
	        children: [{
	            name: 'text-email',
	            component: Text,
	            props: {
	                signals: { inputText: inputText, blurText: blurText },
	                position: 'leftToRight'
	            },
	            watcher: {
	                value: formPath.concat(['form', 'email'])
	            }
	        }, {
	            name: 'text-first-name',
	            component: Text,
	            props: {
	                signals: { inputText: inputText, blurText: blurText },
	                position: 'leftToRight',
	                scheme: SCHEMES.firstName
	            },
	            watcher: {
	                value: formPath.concat(['form', 'firstName']),
	                error: formPath.concat(['error', 'firstName'])
	            }
	        }, {
	            name: 'text-middle-name',
	            component: Text,
	            props: {
	                signals: { inputText: inputText, blurText: blurText }
	            },
	            watcher: {
	                value: formPath.concat(['form', 'middleName'])
	            }
	        }, {
	            name: 'text-last-name',
	            component: Text,
	            props: {
	                signals: { inputText: inputText, blurText: blurText },
	                position: 'leftToRight',
	                scheme: SCHEMES.lastName
	            },
	            watcher: {
	                value: formPath.concat(['form', 'lastName']),
	                error: formPath.concat(['error', 'lastName'])
	            }
	        }, {
	            name: 'text-org',
	            component: Text,
	            props: {
	                signals: { inputText: inputText, blurText: blurText }
	            },
	            watcher: {
	                value: formPath.concat(['form', 'organization'])
	            }
	        }, {
	            name: 'text-phone',
	            component: Text,
	            props: {
	                signals: { inputText: inputText, blurText: blurText },
	                mask: '+7(999)999-99-99'
	            },
	            watcher: {
	                value: formPath.concat(['form', 'phone'])
	            }
	        }, {
	            name: 'text-city',
	            component: Text,
	            props: {
	                signals: { inputText: inputText, blurText: blurText }
	            },
	            watcher: {
	                value: formPath.concat(['form', 'city'])
	            }
	        }, {
	            name: 'user-type',
	            component: Radio,
	            props: {
	                signal: signalSelectUserType
	            },
	            watcher: function watcher(attributes) {
	                return {
	                    value: formPath.concat(['userTypeRadio', attributes['cat-key']])
	                };
	            }
	        }, {
	            name: 'country-dropdown',
	            component: Select,
	            props: {
	                signalOnSelect: signalSelectCounty,
	                signalOnToggle: signalsUtils.togglePopupFromArgs
	            },
	            watcher: {
	                options: formPath.concat(['computed', 'countryDropdown', 'options']),
	                isDisabled: formPath.concat(['computed', 'countryDropdown', 'isDisabled']),
	                isOpen: formPath.concat(['popups', 'countryDropdown', 'isOpen']),
	                header: formPath.concat(['computed', 'countryDropdown', 'header'])
	            }
	        }]
	    };
	};

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(842);
	
	var ModalOverlay = function () {
	    function ModalOverlay() {
	        _classCallCheck(this, ModalOverlay);
	
	        this.template = __webpack_require__(986);
	    }
	
	    ModalOverlay.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    return ModalOverlay;
	}();
	
	module.exports = {
	    constructor: ModalOverlay
	};

/***/ }),
/* 157 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	    fullName: function fullName(user) {
	        if (!user) {
	            return null;
	        }
	        var firstName = user.firstName,
	            _user$middleName = user.middleName,
	            middleName = _user$middleName === undefined ? '' : _user$middleName,
	            lastName = user.lastName;
	
	        return (lastName + ' ' + firstName + ' ' + (middleName || '')).trim();
	    },
	
	    shortName: function shortName(user) {
	        if (!user) {
	            return null;
	        }
	        var firstName = user.firstName,
	            _user$middleName2 = user.middleName,
	            middleName = _user$middleName2 === undefined ? '' : _user$middleName2,
	            lastName = user.lastName;
	
	        var components = [lastName];
	
	        if (firstName) {
	            if (firstName.length > 1) {
	                components.push(firstName.charAt(0) + '.');
	            } else {
	                components.push(firstName);
	            }
	        }
	        if (middleName) {
	            if (middleName.length > 1) {
	                components.push(middleName.charAt(0) + '.');
	            } else {
	                components.push(middleName);
	            }
	        }
	
	        return components.join(' ');
	    }
	};

/***/ }),
/* 158 */
/***/ (function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var helper = {
	  ELEMENT_NODE_TYPE: 1,
	  ATTRIBUTE_NODE_TYPE: 2,
	  COMPONENT_PREFIX: 'cat-',
	  COMPONENT_ID: '$catbeeId',
	  COMPONENT_PREFIX_REGEXP: /^cat-/i,
	  DOCUMENT_COMPONENT_NAME: 'document',
	  DOCUMENT_ELEMENT_NAME: 'html',
	  DOCUMENT_TAG_NAME: 'HTML',
	  HEAD_TAG_NAME: 'HEAD',
	  SLOT_TAG_NAME: 'SLOT',
	  HEAD_COMPONENT_NAME: 'head',
	
	  isDocumentComponent: function isDocumentComponent(componentName) {
	    return componentName.toLowerCase() === helper.DOCUMENT_COMPONENT_NAME;
	  },
	  isHeadComponent: function isHeadComponent(componentName) {
	    return componentName.toLowerCase() === helper.HEAD_COMPONENT_NAME;
	  },
	  isComponentNode: function isComponentNode(node) {
	    return node.nodeType === helper.ELEMENT_NODE_TYPE && (helper.COMPONENT_PREFIX_REGEXP.test(node.nodeName) || node.nodeName === helper.HEAD_TAG_NAME || node.nodeName === helper.DOCUMENT_TAG_NAME);
	  },
	  isSlotNode: function isSlotNode(node) {
	    return node.nodeType === helper.ELEMENT_NODE_TYPE && node.nodeName === helper.SLOT_TAG_NAME;
	  },
	  getOriginalComponentName: function getOriginalComponentName(fullComponentName) {
	    if (typeof fullComponentName !== 'string') {
	      return '';
	    }
	    fullComponentName = fullComponentName.toLowerCase();
	    if (fullComponentName === helper.HEAD_COMPONENT_NAME) {
	      return fullComponentName;
	    }
	    if (fullComponentName === helper.DOCUMENT_COMPONENT_NAME || fullComponentName === helper.DOCUMENT_ELEMENT_NAME) {
	      return helper.DOCUMENT_COMPONENT_NAME;
	    }
	    return fullComponentName.replace(helper.COMPONENT_PREFIX_REGEXP, '');
	  },
	  getTagNameForComponentName: function getTagNameForComponentName(componentName) {
	    if (typeof componentName !== 'string') {
	      return '';
	    }
	    var upperComponentName = componentName.toUpperCase();
	    if (componentName === helper.HEAD_COMPONENT_NAME) {
	      return upperComponentName;
	    }
	    if (componentName === helper.DOCUMENT_COMPONENT_NAME) {
	      return helper.DOCUMENT_ELEMENT_NAME.toUpperCase();
	    }
	    return helper.COMPONENT_PREFIX.toUpperCase() + upperComponentName;
	  },
	  getMethodToInvoke: function getMethodToInvoke(module, prefix, name) {
	    if (!module || (typeof module === 'undefined' ? 'undefined' : _typeof(module)) !== 'object') {
	      return defaultPromiseMethod;
	    }
	    var methodName = helper.getCamelCaseName(prefix, name);
	    if (typeof module[methodName] === 'function') {
	      return module[methodName].bind(module);
	    }
	    if (typeof module[prefix] === 'function') {
	      return module[prefix].bind(module, name);
	    }
	
	    return defaultPromiseMethod;
	  },
	  getCamelCaseName: function getCamelCaseName(prefix, name) {
	    if (!name) {
	      return '';
	    }
	
	    var parts = name.split(/[^a-z0-9]/i);
	    var camelCaseName = String(prefix || '');
	
	    parts.forEach(function (part) {
	      if (!part) {
	        return;
	      }
	
	      camelCaseName += camelCaseName ? part[0].toUpperCase() : part[0].toLowerCase();
	      camelCaseName += part.substring(1);
	    });
	
	    return camelCaseName;
	  },
	  getSafePromise: function getSafePromise(action) {
	    var result;
	    try {
	      result = action();
	    } catch (e) {
	      return Promise.reject(e);
	    }
	    return Promise.resolve(result);
	  }
	};
	
	function defaultPromiseMethod() {
	  return Promise.resolve();
	}
	
	module.exports = helper;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var customOrder = __webpack_require__(42);
	var filterableTree = __webpack_require__(111);
	var utils = __webpack_require__(5);
	var error = __webpack_require__(19);
	var analytics = __webpack_require__(7);
	
	var _require = __webpack_require__(231),
	    calcPriceGroup = _require.calcPriceGroup;
	
	var rubrics = __webpack_require__(114);
	var branches = __webpack_require__(143);
	var cities = __webpack_require__(99);
	
	var _require2 = __webpack_require__(74),
	    defaultToBranches = _require2.defaultToBranches;
	
	module.exports = {
	    uploadTreeInputRubrics: [[customOrder.uploadTreeInput, {
	        success: [utils.setArg('value', false), rubrics.setAll, customOrder.showRubricsRecognitionResult, customOrder.selectRubrics, utils.setArg('showSelectedOnly', true), filterableTree.setShowSelectedOnly].concat(calcPriceGroup),
	        error: []
	    }], utils.setArg('category', 'button_filter_rubrics_list'), utils.setArg('action', 'click'), analytics.raiseArgsValueEvent],
	
	    uploadTreeInputCities: [[customOrder.uploadTreeInput, {
	        success: [utils.setArg('value', false), cities.setAll, customOrder.showRubricsRecognitionResult, customOrder.selectCities, utils.setArg('showSelectedOnly', true), filterableTree.setShowSelectedOnly].concat(calcPriceGroup),
	        error: []
	    }], utils.setArg('category', 'button_filter_cities_list'), utils.setArg('action', 'click'), analytics.raiseArgsValueEvent],
	
	    downloadRubricsFile: [[customOrder.downloadRubricsFile, {
	        success: [],
	        error: [error.internalError('customOrder.downloadRubricsFile')]
	    }], utils.setArg('category', 'button_download_rubrics'), utils.setArg('action', 'click'), analytics.raiseArgsValueEvent],
	
	    downloadCitiesFile: [[customOrder.downloadCitiesFile, {
	        success: [],
	        error: [error.internalError('customOrder.downloadCitiesFile')]
	    }], utils.setArg('category', 'button_download_cities'), utils.setArg('action', 'click'), analytics.raiseArgsValueEvent],
	
	    selectTab: [[customOrder.switchTabTransition, {
	        branchesToDefault: [utils.setArg('value', false), cities.setAll, utils.setArg('value', true), branches.getCitiesTreeFilter, cities.setSelection],
	        defaultToBranches: [].concat(defaultToBranches),
	        default: []
	    }], utils.setFromArgsToState('tabId', ['order', 'cities', 'tab']), utils.unset(['order', 'cities', 'calcOnlyDefaultCities'])].concat(calcPriceGroup)
	};

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var analytics = __webpack_require__(7);
	module.exports = {
	    raiseEventsOnOrderLoaded: [[analytics.fillEventOnOrderLoaded, {
	        filled: [analytics.raiseArgsValueEvent],
	        noEvent: []
	    }], [analytics.fillEventIfBillAttached, {
	        filled: [analytics.raiseArgsValueEvent],
	        noEvent: []
	    }]]
	};

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var order = __webpack_require__(100);
	var utils = __webpack_require__(5);
	var redirect = __webpack_require__(35);
	var account = __webpack_require__(41);
	var user = __webpack_require__(28);
	
	module.exports = {
	    createOrderAfterLoginIfNeededOrRedirect: [[order.shouldCreateOrderAfterLogin, {
	        yes: [utils.getItemFromLocalStorage('selected_params', 'selectedParameters'), {
	            success: [order.fillOrderCreationParameters, [order.createOrder, {
	                success: [order.removeSavedSelectedParams, account.removeLocalChanges, order.setShouldCreateOrderAfterLogin(false), utils.set(['account', 'orders', 'list'], {}), utils.set(['account', 'orders', 'list', 'isAllLoaded'], false), order.orderCreatedRedirect],
	                unauthorized: [order.setShouldCreateOrderAfterLogin(true), redirect.redirect('/login')],
	                error: [order.setShouldCreateOrderAfterLogin(false), redirect.redirectToRoot]
	            }]],
	            notExists: [redirect.redirectToRoot],
	            unavailable: [redirect.redirectToRoot]
	        }],
	        no: [[utils.tryGetArgFromCookie('orderId'), {
	            success: [[user.isManager, {
	                true: [redirect.locationRedirectToOrder('/manager/orders/', 'orderId')],
	                false: [redirect.locationRedirectToOrder('/account/orders/', 'orderId')]
	            }], utils.unsetCookie('orderId')],
	            fail: [redirect.redirectToRoot]
	        }]]
	    }]]
	};

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var price = __webpack_require__(311);
	var error = __webpack_require__(19);
	
	module.exports = {
	    getPrices: [price.getPrices, {
	        success: [price.setPrices],
	        error: [error.internalError('price.getPrices')]
	    }],
	
	    setComputedFields: [price.setComputedFields],
	
	    getColumns: [price.getColumns, {
	        success: [price.setColumns],
	        error: [error.internalError('price.getColumns')]
	    }]
	};

/***/ }),
/* 163 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./functionCall')} */
	module.exports = Function.prototype.call;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var at = __webpack_require__(131)(true);
	
	 // `AdvanceStringIndex` abstract operation
	// https://tc39.github.io/ecma262/#sec-advancestringindex
	module.exports = function (S, index, unicode) {
	  return index + (unicode ? at(S, index).length : 1);
	};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(18);
	var toAbsoluteIndex = __webpack_require__(84);
	var toLength = __webpack_require__(14);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(536);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(17);
	var createDesc = __webpack_require__(81);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(10);
	var document = __webpack_require__(8).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 169 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(13)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(8).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(10);
	var setPrototypeOf = __webpack_require__(181).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(93);
	var ITERATOR = __webpack_require__(13)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(78);
	var descriptor = __webpack_require__(81);
	var setToStringTag = __webpack_require__(94);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(31)(IteratorPrototype, __webpack_require__(13)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(66);
	var $export = __webpack_require__(2);
	var redefine = __webpack_require__(32);
	var hide = __webpack_require__(31);
	var Iterators = __webpack_require__(93);
	var $iterCreate = __webpack_require__(174);
	var setToStringTag = __webpack_require__(94);
	var getPrototypeOf = __webpack_require__(39);
	var ITERATOR = __webpack_require__(13)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 176 */
/***/ (function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ }),
/* 177 */
/***/ (function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(8);
	var macrotask = __webpack_require__(186).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(46)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(25);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var regexpFlags = __webpack_require__(104);
	
	var nativeExec = RegExp.prototype.exec;
	// This always refers to the native implementation, because the
	// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
	// which loads this file before patching the method.
	var nativeReplace = String.prototype.replace;
	
	var patchedExec = nativeExec;
	
	var LAST_INDEX = 'lastIndex';
	
	var UPDATES_LAST_INDEX_WRONG = (function () {
	  var re1 = /a/,
	      re2 = /b*/g;
	  nativeExec.call(re1, 'a');
	  nativeExec.call(re2, 'a');
	  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
	})();
	
	// nonparticipating capturing group, copied from es5-shim's String#split patch.
	var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
	
	var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;
	
	if (PATCH) {
	  patchedExec = function exec(str) {
	    var re = this;
	    var lastIndex, reCopy, match, i;
	
	    if (NPCG_INCLUDED) {
	      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
	    }
	    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];
	
	    match = nativeExec.call(re, str);
	
	    if (UPDATES_LAST_INDEX_WRONG && match) {
	      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
	    }
	    if (NPCG_INCLUDED && match && match.length > 1) {
	      // Fix browsers whose `exec` methods don't consistently return `undefined`
	      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
	      // eslint-disable-next-line no-loop-func
	      nativeReplace.call(match[0], reCopy, function () {
	        for (i = 1; i < arguments.length - 2; i++) {
	          if (arguments[i] === undefined) match[i] = undefined;
	        }
	      });
	    }
	
	    return match;
	  };
	}
	
	module.exports = patchedExec;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(10);
	var anObject = __webpack_require__(6);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(48)(Function.call, __webpack_require__(38).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(107)('keys');
	var uid = __webpack_require__(85);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(124);
	var defined = __webpack_require__(52);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(50);
	var defined = __webpack_require__(52);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ }),
/* 185 */
/***/ (function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(48);
	var invoke = __webpack_require__(251);
	var html = __webpack_require__(171);
	var cel = __webpack_require__(168);
	var global = __webpack_require__(8);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(46)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(8);
	var DESCRIPTORS = __webpack_require__(16);
	var LIBRARY = __webpack_require__(66);
	var $typed = __webpack_require__(132);
	var hide = __webpack_require__(31);
	var redefineAll = __webpack_require__(82);
	var fails = __webpack_require__(9);
	var anInstance = __webpack_require__(76);
	var toInteger = __webpack_require__(50);
	var toLength = __webpack_require__(14);
	var toIndex = __webpack_require__(270);
	var gOPN = __webpack_require__(79).f;
	var dP = __webpack_require__(17).f;
	var arrayFill = __webpack_require__(165);
	var setToStringTag = __webpack_require__(94);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = new Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(new Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(8);
	var core = __webpack_require__(47);
	var LIBRARY = __webpack_require__(66);
	var wksExt = __webpack_require__(271);
	var defineProperty = __webpack_require__(17).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(92);
	var ITERATOR = __webpack_require__(13)('iterator');
	var Iterators = __webpack_require__(93);
	module.exports = __webpack_require__(47).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(65);
	var step = __webpack_require__(254);
	var Iterators = __webpack_require__(93);
	var toIObject = __webpack_require__(40);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(175)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 191 */
/***/ (function(module, exports) {

	/**
	 * Here is the list of every allowed parameter when using Emitter#on:
	 * @type {Object}
	 */
	var __allowedOptions = {
	  once: 'boolean',
	  scope: 'object'
	};
	
	/**
	 * Incremental id used to order event handlers.
	 */
	var __order = 0;
	
	/**
	 * A simple helper to shallowly merge two objects. The second one will "win"
	 * over the first one.
	 *
	 * @param  {object}  o1 First target object.
	 * @param  {object}  o2 Second target object.
	 * @return {object}     Returns the merged object.
	 */
	function shallowMerge(o1, o2) {
	  var o = {},
	      k;
	
	  for (k in o1) o[k] = o1[k];
	  for (k in o2) o[k] = o2[k];
	
	  return o;
	}
	
	/**
	 * Is the given variable a plain JavaScript object?
	 *
	 * @param  {mixed}  v   Target.
	 * @return {boolean}    The boolean result.
	 */
	function isPlainObject(v) {
	  return v &&
	          typeof v === 'object' &&
	          !Array.isArray(v) &&
	          !(v instanceof Function) &&
	          !(v instanceof RegExp);
	}
	
	/**
	 * Iterate over an object that may have ES6 Symbols.
	 *
	 * @param  {object}   object  Object on which to iterate.
	 * @param  {function} fn      Iterator function.
	 * @param  {object}   [scope] Optional scope.
	 */
	function forIn(object, fn, scope) {
	  var symbols,
	      k,
	      i,
	      l;
	
	  for (k in object)
	    fn.call(scope || null, k, object[k]);
	
	  if (Object.getOwnPropertySymbols) {
	    symbols = Object.getOwnPropertySymbols(object);
	
	    for (i = 0, l = symbols.length; i < l; i++)
	      fn.call(scope || null, symbols[i], object[symbols[i]]);
	  }
	}
	
	/**
	 * The emitter's constructor. It initializes the handlers-per-events store and
	 * the global handlers store.
	 *
	 * Emitters are useful for non-DOM events communication. Read its methods
	 * documentation for more information about how it works.
	 *
	 * @return {Emitter}         The fresh new instance.
	 */
	var Emitter = function() {
	  this._enabled = true;
	
	  // Dirty trick that will set the necessary properties to the emitter
	  this.unbindAll();
	};
	
	/**
	 * This method unbinds every handlers attached to every or any events. So, these
	 * functions will no more be executed when the related events are emitted. If
	 * the functions were not bound to the events, nothing will happen, and no error
	 * will be thrown.
	 *
	 * Usage:
	 * ******
	 * > myEmitter.unbindAll();
	 *
	 * @return {Emitter}      Returns this.
	 */
	Emitter.prototype.unbindAll = function() {
	
	  this._handlers = {};
	  this._handlersAll = [];
	  this._handlersComplex = [];
	
	  return this;
	};
	
	
	/**
	 * This method binds one or more functions to the emitter, handled to one or a
	 * suite of events. So, these functions will be executed anytime one related
	 * event is emitted.
	 *
	 * It is also possible to bind a function to any emitted event by not specifying
	 * any event to bind the function to.
	 *
	 * Recognized options:
	 * *******************
	 *  - {?boolean} once   If true, the handlers will be unbound after the first
	 *                      execution. Default value: false.
	 *  - {?object}  scope  If a scope is given, then the listeners will be called
	 *                      with this scope as "this".
	 *
	 * Variant 1:
	 * **********
	 * > myEmitter.on('myEvent', function(e) { console.log(e); });
	 * > // Or:
	 * > myEmitter.on('myEvent', function(e) { console.log(e); }, { once: true });
	 *
	 * @param  {EventName} event   The event to listen to.
	 * @param  {Handler}   handler The function to bind.
	 * @param  {?object}   options Some options.
	 * @return {Emitter}           Returns this.
	 *
	 * Variant 2:
	 * **********
	 * > myEmitter.on(
	 * >   ['myEvent1', 'myEvent2'],
	 * >   function(e) { console.log(e); }
	 * > );
	 * > // Or:
	 * > myEmitter.on(
	 * >   ['myEvent1', 'myEvent2'],
	 * >   function(e) { console.log(e); }
	 * >   { once: true }}
	 * > );
	 *
	 * @param  {EventName[]} events  The events to listen to.
	 * @param  {Handler}     handler The function to bind.
	 * @param  {?object}     options Some options.
	 * @return {Emitter}             Returns this.
	 *
	 * Variant 3:
	 * **********
	 * > myEmitter.on({
	 * >   myEvent1: function(e) { console.log(e); },
	 * >   myEvent2: function(e) { console.log(e); }
	 * > });
	 * > // Or:
	 * > myEmitter.on({
	 * >   myEvent1: function(e) { console.log(e); },
	 * >   myEvent2: function(e) { console.log(e); }
	 * > }, { once: true });
	 *
	 * @param  {Object<EventName, Handler>} bindings An object containing
	 *                                               pairs event / function.
	 * @param  {?object}                    options  Some options.
	 * @return {Emitter}                             Returns this.
	 *
	 * Variant 4:
	 * **********
	 * > myEmitter.on(function(e) { console.log(e); });
	 * > // Or:
	 * > myEmitter.on(function(e) { console.log(e); }, { once: true });
	 *
	 * @param  {Handler} handler The function to bind to every events.
	 * @param  {?object} options Some options.
	 * @return {Emitter}         Returns this.
	 */
	Emitter.prototype.on = function(a, b, c) {
	  var i,
	      l,
	      k,
	      event,
	      eArray,
	      handlersList,
	      bindingObject;
	
	  // Variant 3
	  if (isPlainObject(a)) {
	    forIn(a, function(name, fn) {
	      this.on(name, fn, b);
	    }, this);
	
	    return this;
	  }
	
	  // Variant 4
	  if (typeof a === 'function') {
	    c = b;
	    b = a;
	    a = null;
	  }
	
	  eArray = [].concat(a);
	
	  for (i = 0, l = eArray.length; i < l; i++) {
	    event = eArray[i];
	
	    bindingObject = {
	      order: __order++,
	      fn: b
	    };
	
	    // Defining the list in which the handler should be inserted
	    if (typeof event === 'string' || typeof event === 'symbol') {
	      if (!this._handlers[event])
	        this._handlers[event] = [];
	      handlersList = this._handlers[event];
	      bindingObject.type = event;
	    }
	    else if (event instanceof RegExp) {
	      handlersList = this._handlersComplex;
	      bindingObject.pattern = event;
	    }
	    else if (event === null) {
	      handlersList = this._handlersAll;
	    }
	    else {
	      throw Error('Emitter.on: invalid event.');
	    }
	
	    // Appending needed properties
	    for (k in c || {})
	      if (__allowedOptions[k])
	        bindingObject[k] = c[k];
	
	    handlersList.push(bindingObject);
	  }
	
	  return this;
	};
	
	
	/**
	 * This method works exactly as the previous #on, but will add an options object
	 * if none is given, and set the option "once" to true.
	 *
	 * The polymorphism works exactly as with the #on method.
	 */
	Emitter.prototype.once = function() {
	  var args = Array.prototype.slice.call(arguments),
	      li = args.length - 1;
	
	  if (isPlainObject(args[li]) && args.length > 1)
	    args[li] = shallowMerge(args[li], {once: true});
	  else
	    args.push({once: true});
	
	  return this.on.apply(this, args);
	};
	
	
	/**
	 * This method unbinds one or more functions from events of the emitter. So,
	 * these functions will no more be executed when the related events are emitter.
	 * If the functions were not bound to the events, nothing will happen, and no
	 * error will be thrown.
	 *
	 * Variant 1:
	 * **********
	 * > myEmitter.off('myEvent', myHandler);
	 *
	 * @param  {EventName} event   The event to unbind the handler from.
	 * @param  {Handler}   handler The function to unbind.
	 * @return {Emitter}           Returns this.
	 *
	 * Variant 2:
	 * **********
	 * > myEmitter.off(['myEvent1', 'myEvent2'], myHandler);
	 *
	 * @param  {EventName[]} events  The events to unbind the handler from.
	 * @param  {Handler}     handler The function to unbind.
	 * @return {Emitter}             Returns this.
	 *
	 * Variant 3:
	 * **********
	 * > myEmitter.off({
	 * >   myEvent1: myHandler1,
	 * >   myEvent2: myHandler2
	 * > });
	 *
	 * @param  {Object<EventName, Handler>} bindings An object containing pairs
	 *                                               event / function.
	 * @return {Emitter}                             Returns this.
	 *
	 * Variant 4:
	 * **********
	 * > myEmitter.off(myHandler);
	 *
	 * @param  {Handler} handler The function to unbind from every events.
	 * @return {Emitter}         Returns this.
	 *
	 * Variant 5:
	 * **********
	 * > myEmitter.off(event);
	 *
	 * @param  {EventName} event The event we should unbind.
	 * @return {Emitter}         Returns this.
	 */
	function filter(target, fn) {
	  target = target || [];
	
	  var a = [],
	      l,
	      i;
	
	  for (i = 0, l = target.length; i < l; i++)
	    if (target[i].fn !== fn)
	      a.push(target[i]);
	
	  return a;
	}
	
	Emitter.prototype.off = function(events, fn) {
	  var i,
	      n,
	      k,
	      event;
	
	  // Variant 4:
	  if (arguments.length === 1 && typeof events === 'function') {
	    fn = arguments[0];
	
	    var keys = Object.keys(this._handlers)
	      .concat(Object.getOwnPropertySymbols(this._handlers));
	
	    // Handlers bound to events:
	    for (i = 0; i < keys.length; i++) {
	      k = keys[i];
	
	      this._handlers[k] = filter(this._handlers[k], fn);
	
	      if (this._handlers[k].length === 0)
	        delete this._handlers[k];
	    }
	
	    // Generic Handlers
	    this._handlersAll = filter(this._handlersAll, fn);
	
	    // Complex handlers
	    this._handlersComplex = filter(this._handlersComplex, fn);
	  }
	
	  // Variant 5
	  else if (arguments.length === 1 &&
	            (typeof events === 'string' || typeof events === 'symbol')) {
	    delete this._handlers[events];
	  }
	
	  // Variant 1 and 2:
	  else if (arguments.length === 2) {
	    var eArray = [].concat(events);
	
	    for (i = 0, n = eArray.length; i < n; i++) {
	      event = eArray[i];
	
	      this._handlers[event] = filter(this._handlers[event], fn);
	
	      if ((this._handlers[event] || []).length === 0)
	        delete this._handlers[event];
	    }
	  }
	
	  // Variant 3
	  else if (isPlainObject(events)) {
	    forIn(events, this.off, this);
	  }
	
	  return this;
	};
	
	/**
	 * This method retrieve the listeners attached to a particular event.
	 *
	 * @param  {?EventName} event Name of the event.
	 * @return {array}            Array of handler functions.
	 */
	Emitter.prototype.listeners = function(event) {
	  var handlers = this._handlersAll || [],
	      complex = false,
	      h,
	      i,
	      l;
	
	  if (!event)
	    throw Error('Emitter.listeners: no event provided.');
	
	  handlers = handlers.concat(this._handlers[event] || []);
	
	  for (i = 0, l = this._handlersComplex.length; i < l; i++) {
	    h = this._handlersComplex[i];
	
	    if (typeof event === 'string' && ~event.search(h.pattern)) {
	      complex = true;
	      handlers.push(h);
	    }
	  }
	
	  // If we have any complex handlers, we need to sort
	  if (this._handlersAll.length || complex)
	    return handlers.sort(function(a, b) {
	      return a.order - b.order;
	    });
	  else
	    return handlers.slice(0);
	};
	
	/**
	 * This method emits the specified event(s), and executes every handlers bound
	 * to the event(s).
	 *
	 * Variant 1:
	 * **********
	 * > myEmitter.emit('myEvent');
	 * > myEmitter.emit('myEvent', myData);
	 *
	 * @param  {EventName} event The event to emit.
	 * @param  {object?}   data  Some data.
	 * @return {Emitter}         Returns this.
	 *
	 * Variant 2:
	 * **********
	 * > myEmitter.emit(['myEvent1', 'myEvent2']);
	 * > myEmitter.emit(['myEvent1', 'myEvent2'], myData);
	 *
	 * @param  {EventName[]} events The events to emit.
	 * @param  {object?}     data   Some data.
	 * @return {Emitter}            Returns this.
	 *
	 * Variant 3:
	 * **********
	 * > myEmitter.emit({myEvent1: myData1, myEvent2: myData2});
	 *
	 * @param  {Object<EventName, any>} events The events to emit.
	 * @return {Emitter}                       Returns this.
	 */
	Emitter.prototype.emit = function(events, data) {
	
	  // Short exit if the emitter is disabled
	  if (!this._enabled)
	    return this;
	
	  // Object variant
	  if (isPlainObject(events)) {
	    forIn(events, this.emit, this);
	    return this;
	  }
	
	  var eArray = [].concat(events),
	      onces = [],
	      event,
	      parent,
	      handlers,
	      handler,
	      i,
	      j,
	      l,
	      m;
	
	  for (i = 0, l = eArray.length; i < l; i++) {
	    handlers = this.listeners(eArray[i]);
	
	    for (j = 0, m = handlers.length; j < m; j++) {
	      handler = handlers[j];
	      event = {
	        type: eArray[i],
	        target: this
	      };
	
	      if (arguments.length > 1)
	        event.data = data;
	
	      handler.fn.call('scope' in handler ? handler.scope : this, event);
	
	      if (handler.once)
	        onces.push(handler);
	    }
	
	    // Cleaning onces
	    for (j = onces.length - 1; j >= 0; j--) {
	      if (onces[j].type)
	        parent = this._handlers[onces[j].type];
	      else if (onces[j].pattern)
	        parent = this._handlersComplex;
	      else
	        parent = this._handlersAll;
	
	      var onceIndex = parent.indexOf(onces[j]);
	      if (onceIndex !== -1) {
	        parent.splice(onceIndex, 1);
	      }
	    }
	  }
	
	  return this;
	};
	
	
	/**
	 * This method will unbind all listeners and make it impossible to ever rebind
	 * any listener to any event.
	 */
	Emitter.prototype.kill = function() {
	
	  this.unbindAll();
	  this._handlers = null;
	  this._handlersAll = null;
	  this._handlersComplex = null;
	  this._enabled = false;
	
	  // Nooping methods
	  this.unbindAll =
	  this.on =
	  this.once =
	  this.off =
	  this.emit =
	  this.listeners = Function.prototype;
	};
	
	
	/**
	 * This method disabled the emitter, which means its emit method will do
	 * nothing.
	 *
	 * @return {Emitter} Returns this.
	 */
	Emitter.prototype.disable = function() {
	  this._enabled = false;
	
	  return this;
	};
	
	
	/**
	 * This method enables the emitter.
	 *
	 * @return {Emitter} Returns this.
	 */
	Emitter.prototype.enable = function() {
	  this._enabled = true;
	
	  return this;
	};
	
	
	/**
	 * Version:
	 */
	Emitter.version = '3.2.0';
	
	
	/**
	 * Export:
	 */
	module.exports = Emitter;


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* FileSaver.js
	 * A saveAs() FileSaver implementation.
	 * 1.3.2
	 * 2016-06-16 18:25:19
	 *
	 * By Eli Grey, http://eligrey.com
	 * License: MIT
	 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
	 */
	
	/*global self */
	/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */
	
	/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */
	
	var saveAs = saveAs || (function(view) {
		"use strict";
		// IE <10 is explicitly unsupported
		if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
			return;
		}
		var
			  doc = view.document
			  // only get URL when necessary in case Blob.js hasn't overridden it yet
			, get_URL = function() {
				return view.URL || view.webkitURL || view;
			}
			, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a")
			, can_use_save_link = "download" in save_link
			, click = function(node) {
				var event = new MouseEvent("click");
				node.dispatchEvent(event);
			}
			, is_safari = /constructor/i.test(view.HTMLElement) || view.safari
			, is_chrome_ios =/CriOS\/[\d]+/.test(navigator.userAgent)
			, throw_outside = function(ex) {
				(view.setImmediate || view.setTimeout)(function() {
					throw ex;
				}, 0);
			}
			, force_saveable_type = "application/octet-stream"
			// the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
			, arbitrary_revoke_timeout = 1000 * 40 // in ms
			, revoke = function(file) {
				var revoker = function() {
					if (typeof file === "string") { // file is an object URL
						get_URL().revokeObjectURL(file);
					} else { // file is a File
						file.remove();
					}
				};
				setTimeout(revoker, arbitrary_revoke_timeout);
			}
			, dispatch = function(filesaver, event_types, event) {
				event_types = [].concat(event_types);
				var i = event_types.length;
				while (i--) {
					var listener = filesaver["on" + event_types[i]];
					if (typeof listener === "function") {
						try {
							listener.call(filesaver, event || filesaver);
						} catch (ex) {
							throw_outside(ex);
						}
					}
				}
			}
			, auto_bom = function(blob) {
				// prepend BOM for UTF-8 XML and text/* types (including HTML)
				// note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
				if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
					return new Blob([String.fromCharCode(0xFEFF), blob], {type: blob.type});
				}
				return blob;
			}
			, FileSaver = function(blob, name, no_auto_bom) {
				if (!no_auto_bom) {
					blob = auto_bom(blob);
				}
				// First try a.download, then web filesystem, then object URLs
				var
					  filesaver = this
					, type = blob.type
					, force = type === force_saveable_type
					, object_url
					, dispatch_all = function() {
						dispatch(filesaver, "writestart progress write writeend".split(" "));
					}
					// on any filesys errors revert to saving with object URLs
					, fs_error = function() {
						if ((is_chrome_ios || (force && is_safari)) && view.FileReader) {
							// Safari doesn't allow downloading of blob urls
							var reader = new FileReader();
							reader.onloadend = function() {
								var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
								var popup = view.open(url, '_blank');
								if(!popup) view.location.href = url;
								url=undefined; // release reference before dispatching
								filesaver.readyState = filesaver.DONE;
								dispatch_all();
							};
							reader.readAsDataURL(blob);
							filesaver.readyState = filesaver.INIT;
							return;
						}
						// don't create more object URLs than needed
						if (!object_url) {
							object_url = get_URL().createObjectURL(blob);
						}
						if (force) {
							view.location.href = object_url;
						} else {
							var opened = view.open(object_url, "_blank");
							if (!opened) {
								// Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
								view.location.href = object_url;
							}
						}
						filesaver.readyState = filesaver.DONE;
						dispatch_all();
						revoke(object_url);
					}
				;
				filesaver.readyState = filesaver.INIT;
	
				if (can_use_save_link) {
					object_url = get_URL().createObjectURL(blob);
					setTimeout(function() {
						save_link.href = object_url;
						save_link.download = name;
						click(save_link);
						dispatch_all();
						revoke(object_url);
						filesaver.readyState = filesaver.DONE;
					});
					return;
				}
	
				fs_error();
			}
			, FS_proto = FileSaver.prototype
			, saveAs = function(blob, name, no_auto_bom) {
				return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
			}
		;
		// IE 10+ (native saveAs)
		if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
			return function(blob, name, no_auto_bom) {
				name = name || blob.name || "download";
	
				if (!no_auto_bom) {
					blob = auto_bom(blob);
				}
				return navigator.msSaveOrOpenBlob(blob, name);
			};
		}
	
		FS_proto.abort = function(){};
		FS_proto.readyState = FS_proto.INIT = 0;
		FS_proto.WRITING = 1;
		FS_proto.DONE = 2;
	
		FS_proto.error =
		FS_proto.onwritestart =
		FS_proto.onprogress =
		FS_proto.onwrite =
		FS_proto.onabort =
		FS_proto.onerror =
		FS_proto.onwriteend =
			null;
	
		return saveAs;
	}(
		   typeof self !== "undefined" && self
		|| typeof window !== "undefined" && window
		|| this.content
	));
	// `self` is undefined in Firefox for Android content script context
	// while `this` is nsIContentFrameMessageManager
	// with an attribute `content` that corresponds to the window
	
	if (typeof module !== "undefined" && module.exports) {
	  module.exports.saveAs = saveAs;
	} else if (("function" !== "undefined" && __webpack_require__(1061) !== null) && (__webpack_require__(286) !== null)) {
	  !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    return saveAs;
	  }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var undefined;
	
	var $Object = __webpack_require__(743);
	
	var $Error = __webpack_require__(738);
	var $EvalError = __webpack_require__(737);
	var $RangeError = __webpack_require__(739);
	var $ReferenceError = __webpack_require__(740);
	var $SyntaxError = __webpack_require__(741);
	var $TypeError = __webpack_require__(96);
	var $URIError = __webpack_require__(742);
	
	var abs = __webpack_require__(1040);
	var floor = __webpack_require__(1041);
	var max = __webpack_require__(1042);
	var min = __webpack_require__(1043);
	var pow = __webpack_require__(1044);
	
	var $Function = Function;
	
	// eslint-disable-next-line consistent-return
	var getEvalledConstructor = function (expressionSyntax) {
		try {
			return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
		} catch (e) {}
	};
	
	var $gOPD = __webpack_require__(277);
	var $defineProperty = __webpack_require__(736);
	
	var throwTypeError = function () {
		throw new $TypeError();
	};
	var ThrowTypeError = $gOPD
		? (function () {
			try {
				// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
				arguments.callee; // IE 8 does not throw here
				return throwTypeError;
			} catch (calleeThrows) {
				try {
					// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
					return $gOPD(arguments, 'callee').get;
				} catch (gOPDthrows) {
					return throwTypeError;
				}
			}
		}())
		: throwTypeError;
	
	var hasSymbols = __webpack_require__(1036)();
	var getDunderProto = __webpack_require__(735);
	
	var getProto = (typeof Reflect === 'function' && Reflect.getPrototypeOf)
		|| $Object.getPrototypeOf
		|| getDunderProto;
	
	var $apply = __webpack_require__(238);
	var $call = __webpack_require__(163);
	
	var needsEval = {};
	
	var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);
	
	var INTRINSICS = {
		__proto__: null,
		'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
		'%Array%': Array,
		'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
		'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
		'%AsyncFromSyncIteratorPrototype%': undefined,
		'%AsyncFunction%': needsEval,
		'%AsyncGenerator%': needsEval,
		'%AsyncGeneratorFunction%': needsEval,
		'%AsyncIteratorPrototype%': needsEval,
		'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
		'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
		'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
		'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
		'%Boolean%': Boolean,
		'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
		'%Date%': Date,
		'%decodeURI%': decodeURI,
		'%decodeURIComponent%': decodeURIComponent,
		'%encodeURI%': encodeURI,
		'%encodeURIComponent%': encodeURIComponent,
		'%Error%': $Error,
		'%eval%': eval, // eslint-disable-line no-eval
		'%EvalError%': $EvalError,
		'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
		'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
		'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
		'%Function%': $Function,
		'%GeneratorFunction%': needsEval,
		'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
		'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
		'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
		'%isFinite%': isFinite,
		'%isNaN%': isNaN,
		'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
		'%JSON%': typeof JSON === 'object' ? JSON : undefined,
		'%Map%': typeof Map === 'undefined' ? undefined : Map,
		'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
		'%Math%': Math,
		'%Number%': Number,
		'%Object%': $Object,
		'%Object.getOwnPropertyDescriptor%': $gOPD,
		'%parseFloat%': parseFloat,
		'%parseInt%': parseInt,
		'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
		'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
		'%RangeError%': $RangeError,
		'%ReferenceError%': $ReferenceError,
		'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
		'%RegExp%': RegExp,
		'%Set%': typeof Set === 'undefined' ? undefined : Set,
		'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
		'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
		'%String%': String,
		'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
		'%Symbol%': hasSymbols ? Symbol : undefined,
		'%SyntaxError%': $SyntaxError,
		'%ThrowTypeError%': ThrowTypeError,
		'%TypedArray%': TypedArray,
		'%TypeError%': $TypeError,
		'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
		'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
		'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
		'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
		'%URIError%': $URIError,
		'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
		'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
		'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
	
		'%Function.prototype.call%': $call,
		'%Function.prototype.apply%': $apply,
		'%Object.defineProperty%': $defineProperty,
		'%Math.abs%': abs,
		'%Math.floor%': floor,
		'%Math.max%': max,
		'%Math.min%': min,
		'%Math.pow%': pow
	};
	
	if (getProto) {
		try {
			null.error; // eslint-disable-line no-unused-expressions
		} catch (e) {
			// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
			var errorProto = getProto(getProto(e));
			INTRINSICS['%Error.prototype%'] = errorProto;
		}
	}
	
	var doEval = function doEval(name) {
		var value;
		if (name === '%AsyncFunction%') {
			value = getEvalledConstructor('async function () {}');
		} else if (name === '%GeneratorFunction%') {
			value = getEvalledConstructor('function* () {}');
		} else if (name === '%AsyncGeneratorFunction%') {
			value = getEvalledConstructor('async function* () {}');
		} else if (name === '%AsyncGenerator%') {
			var fn = doEval('%AsyncGeneratorFunction%');
			if (fn) {
				value = fn.prototype;
			}
		} else if (name === '%AsyncIteratorPrototype%') {
			var gen = doEval('%AsyncGenerator%');
			if (gen && getProto) {
				value = getProto(gen.prototype);
			}
		}
	
		INTRINSICS[name] = value;
	
		return value;
	};
	
	var LEGACY_ALIASES = {
		__proto__: null,
		'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
		'%ArrayPrototype%': ['Array', 'prototype'],
		'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
		'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
		'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
		'%ArrayProto_values%': ['Array', 'prototype', 'values'],
		'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
		'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
		'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
		'%BooleanPrototype%': ['Boolean', 'prototype'],
		'%DataViewPrototype%': ['DataView', 'prototype'],
		'%DatePrototype%': ['Date', 'prototype'],
		'%ErrorPrototype%': ['Error', 'prototype'],
		'%EvalErrorPrototype%': ['EvalError', 'prototype'],
		'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
		'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
		'%FunctionPrototype%': ['Function', 'prototype'],
		'%Generator%': ['GeneratorFunction', 'prototype'],
		'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
		'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
		'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
		'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
		'%JSONParse%': ['JSON', 'parse'],
		'%JSONStringify%': ['JSON', 'stringify'],
		'%MapPrototype%': ['Map', 'prototype'],
		'%NumberPrototype%': ['Number', 'prototype'],
		'%ObjectPrototype%': ['Object', 'prototype'],
		'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
		'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
		'%PromisePrototype%': ['Promise', 'prototype'],
		'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
		'%Promise_all%': ['Promise', 'all'],
		'%Promise_reject%': ['Promise', 'reject'],
		'%Promise_resolve%': ['Promise', 'resolve'],
		'%RangeErrorPrototype%': ['RangeError', 'prototype'],
		'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
		'%RegExpPrototype%': ['RegExp', 'prototype'],
		'%SetPrototype%': ['Set', 'prototype'],
		'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
		'%StringPrototype%': ['String', 'prototype'],
		'%SymbolPrototype%': ['Symbol', 'prototype'],
		'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
		'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
		'%TypeErrorPrototype%': ['TypeError', 'prototype'],
		'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
		'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
		'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
		'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
		'%URIErrorPrototype%': ['URIError', 'prototype'],
		'%WeakMapPrototype%': ['WeakMap', 'prototype'],
		'%WeakSetPrototype%': ['WeakSet', 'prototype']
	};
	
	var bind = __webpack_require__(135);
	var hasOwn = __webpack_require__(1038);
	var $concat = bind.call($call, Array.prototype.concat);
	var $spliceApply = bind.call($apply, Array.prototype.splice);
	var $replace = bind.call($call, String.prototype.replace);
	var $strSlice = bind.call($call, String.prototype.slice);
	var $exec = bind.call($call, RegExp.prototype.exec);
	
	/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
	var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
	var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
	var stringToPath = function stringToPath(string) {
		var first = $strSlice(string, 0, 1);
		var last = $strSlice(string, -1);
		if (first === '%' && last !== '%') {
			throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
		} else if (last === '%' && first !== '%') {
			throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
		}
		var result = [];
		$replace(string, rePropName, function (match, number, quote, subString) {
			result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
		});
		return result;
	};
	/* end adaptation */
	
	var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
		var intrinsicName = name;
		var alias;
		if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
			alias = LEGACY_ALIASES[intrinsicName];
			intrinsicName = '%' + alias[0] + '%';
		}
	
		if (hasOwn(INTRINSICS, intrinsicName)) {
			var value = INTRINSICS[intrinsicName];
			if (value === needsEval) {
				value = doEval(intrinsicName);
			}
			if (typeof value === 'undefined' && !allowMissing) {
				throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
			}
	
			return {
				alias: alias,
				name: intrinsicName,
				value: value
			};
		}
	
		throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
	};
	
	module.exports = function GetIntrinsic(name, allowMissing) {
		if (typeof name !== 'string' || name.length === 0) {
			throw new $TypeError('intrinsic name must be a non-empty string');
		}
		if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
			throw new $TypeError('"allowMissing" argument must be a boolean');
		}
	
		if ($exec(/^%?[^%]*%?$/, name) === null) {
			throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
		}
		var parts = stringToPath(name);
		var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
	
		var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
		var intrinsicRealName = intrinsic.name;
		var value = intrinsic.value;
		var skipFurtherCaching = false;
	
		var alias = intrinsic.alias;
		if (alias) {
			intrinsicBaseName = alias[0];
			$spliceApply(parts, $concat([0, 1], alias));
		}
	
		for (var i = 1, isOwn = true; i < parts.length; i += 1) {
			var part = parts[i];
			var first = $strSlice(part, 0, 1);
			var last = $strSlice(part, -1);
			if (
				(
					(first === '"' || first === "'" || first === '`')
					|| (last === '"' || last === "'" || last === '`')
				)
				&& first !== last
			) {
				throw new $SyntaxError('property names with quotes must have matching quotes');
			}
			if (part === 'constructor' || !isOwn) {
				skipFurtherCaching = true;
			}
	
			intrinsicBaseName += '.' + part;
			intrinsicRealName = '%' + intrinsicBaseName + '%';
	
			if (hasOwn(INTRINSICS, intrinsicRealName)) {
				value = INTRINSICS[intrinsicRealName];
			} else if (value != null) {
				if (!(part in value)) {
					if (!allowMissing) {
						throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
					}
					return void undefined;
				}
				if ($gOPD && (i + 1) >= parts.length) {
					var desc = $gOPD(value, part);
					isOwn = !!desc;
	
					// By convention, when a data property is converted to an accessor
					// property to emulate a data property that does not suffer from
					// the override mistake, that accessor's getter is marked with
					// an `originalValue` property. Here, when we detect this, we
					// uphold the illusion by pretending to see that original data
					// property, i.e., returning the value rather than the getter
					// itself.
					if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
						value = desc.get;
					} else {
						value = value[part];
					}
				} else {
					isOwn = hasOwn(value, part);
					value = value[part];
				}
	
				if (isOwn && !skipFurtherCaching) {
					INTRINSICS[intrinsicRealName] = value;
				}
			}
		}
		return value;
	};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(34)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	              ? forms[1]
	              : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            hh: 'час_часа_часов',
	            dd: 'день_дня_дней',
	            ww: 'неделя_недели_недель',
	            MM: 'месяц_месяца_месяцев',
	            yy: 'год_года_лет',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [
	        /^янв/i,
	        /^фев/i,
	        /^мар/i,
	        /^апр/i,
	        /^ма[йя]/i,
	        /^июн/i,
	        /^июл/i,
	        /^авг/i,
	        /^сен/i,
	        /^окт/i,
	        /^ноя/i,
	        /^дек/i,
	    ];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months: {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
	                '_'
	            ),
	            standalone:
	                'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	                    '_'
	                ),
	        },
	        monthsShort: {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	            standalone:
	                'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
	                    '_'
	                ),
	        },
	        weekdays: {
	            standalone:
	                'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
	                    '_'
	                ),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
	        },
	        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex:
	            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex:
	            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex:
	            /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соответствует только сокращённым формам
	        monthsShortStrictRegex:
	            /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., H:mm',
	            LLLL: 'dddd, D MMMM YYYY г., H:mm',
	        },
	        calendar: {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'через %s',
	            past: '%s назад',
	            s: 'несколько секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'час',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            w: 'неделя',
	            ww: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM: function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ru;
	
	})));


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! @preserve
	 * numeral.js
	 * version : 2.0.6
	 * author : Adam Draper
	 * license : MIT
	 * http://adamwdraper.github.com/Numeral-js/
	 */
	
	(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module === 'object' && module.exports) {
	        module.exports = factory();
	    } else {
	        global.numeral = factory();
	    }
	}(this, function () {
	    /************************************
	        Variables
	    ************************************/
	
	    var numeral,
	        _,
	        VERSION = '2.0.6',
	        formats = {},
	        locales = {},
	        defaults = {
	            currentLocale: 'en',
	            zeroFormat: null,
	            nullFormat: null,
	            defaultFormat: '0,0',
	            scalePercentBy100: true
	        },
	        options = {
	            currentLocale: defaults.currentLocale,
	            zeroFormat: defaults.zeroFormat,
	            nullFormat: defaults.nullFormat,
	            defaultFormat: defaults.defaultFormat,
	            scalePercentBy100: defaults.scalePercentBy100
	        };
	
	
	    /************************************
	        Constructors
	    ************************************/
	
	    // Numeral prototype object
	    function Numeral(input, number) {
	        this._input = input;
	
	        this._value = number;
	    }
	
	    numeral = function(input) {
	        var value,
	            kind,
	            unformatFunction,
	            regexp;
	
	        if (numeral.isNumeral(input)) {
	            value = input.value();
	        } else if (input === 0 || typeof input === 'undefined') {
	            value = 0;
	        } else if (input === null || _.isNaN(input)) {
	            value = null;
	        } else if (typeof input === 'string') {
	            if (options.zeroFormat && input === options.zeroFormat) {
	                value = 0;
	            } else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, '').length) {
	                value = null;
	            } else {
	                for (kind in formats) {
	                    regexp = typeof formats[kind].regexps.unformat === 'function' ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;
	
	                    if (regexp && input.match(regexp)) {
	                        unformatFunction = formats[kind].unformat;
	
	                        break;
	                    }
	                }
	
	                unformatFunction = unformatFunction || numeral._.stringToNumber;
	
	                value = unformatFunction(input);
	            }
	        } else {
	            value = Number(input)|| null;
	        }
	
	        return new Numeral(input, value);
	    };
	
	    // version number
	    numeral.version = VERSION;
	
	    // compare numeral object
	    numeral.isNumeral = function(obj) {
	        return obj instanceof Numeral;
	    };
	
	    // helper functions
	    numeral._ = _ = {
	        // formats numbers separators, decimals places, signs, abbreviations
	        numberToFormat: function(value, format, roundingFunction) {
	            var locale = locales[numeral.options.currentLocale],
	                negP = false,
	                optDec = false,
	                leadingCount = 0,
	                abbr = '',
	                trillion = 1000000000000,
	                billion = 1000000000,
	                million = 1000000,
	                thousand = 1000,
	                decimal = '',
	                neg = false,
	                abbrForce, // force abbreviation
	                abs,
	                min,
	                max,
	                power,
	                int,
	                precision,
	                signed,
	                thousands,
	                output;
	
	            // make sure we never format a null value
	            value = value || 0;
	
	            abs = Math.abs(value);
	
	            // see if we should use parentheses for negative number or if we should prefix with a sign
	            // if both are present we default to parentheses
	            if (numeral._.includes(format, '(')) {
	                negP = true;
	                format = format.replace(/[\(|\)]/g, '');
	            } else if (numeral._.includes(format, '+') || numeral._.includes(format, '-')) {
	                signed = numeral._.includes(format, '+') ? format.indexOf('+') : value < 0 ? format.indexOf('-') : -1;
	                format = format.replace(/[\+|\-]/g, '');
	            }
	
	            // see if abbreviation is wanted
	            if (numeral._.includes(format, 'a')) {
	                abbrForce = format.match(/a(k|m|b|t)?/);
	
	                abbrForce = abbrForce ? abbrForce[1] : false;
	
	                // check for space before abbreviation
	                if (numeral._.includes(format, ' a')) {
	                    abbr = ' ';
	                }
	
	                format = format.replace(new RegExp(abbr + 'a[kmbt]?'), '');
	
	                if (abs >= trillion && !abbrForce || abbrForce === 't') {
	                    // trillion
	                    abbr += locale.abbreviations.trillion;
	                    value = value / trillion;
	                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === 'b') {
	                    // billion
	                    abbr += locale.abbreviations.billion;
	                    value = value / billion;
	                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === 'm') {
	                    // million
	                    abbr += locale.abbreviations.million;
	                    value = value / million;
	                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === 'k') {
	                    // thousand
	                    abbr += locale.abbreviations.thousand;
	                    value = value / thousand;
	                }
	            }
	
	            // check for optional decimals
	            if (numeral._.includes(format, '[.]')) {
	                optDec = true;
	                format = format.replace('[.]', '.');
	            }
	
	            // break number and format
	            int = value.toString().split('.')[0];
	            precision = format.split('.')[1];
	            thousands = format.indexOf(',');
	            leadingCount = (format.split('.')[0].split(',')[0].match(/0/g) || []).length;
	
	            if (precision) {
	                if (numeral._.includes(precision, '[')) {
	                    precision = precision.replace(']', '');
	                    precision = precision.split('[');
	                    decimal = numeral._.toFixed(value, (precision[0].length + precision[1].length), roundingFunction, precision[1].length);
	                } else {
	                    decimal = numeral._.toFixed(value, precision.length, roundingFunction);
	                }
	
	                int = decimal.split('.')[0];
	
	                if (numeral._.includes(decimal, '.')) {
	                    decimal = locale.delimiters.decimal + decimal.split('.')[1];
	                } else {
	                    decimal = '';
	                }
	
	                if (optDec && Number(decimal.slice(1)) === 0) {
	                    decimal = '';
	                }
	            } else {
	                int = numeral._.toFixed(value, 0, roundingFunction);
	            }
	
	            // check abbreviation again after rounding
	            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
	                int = String(Number(int) / 1000);
	
	                switch (abbr) {
	                    case locale.abbreviations.thousand:
	                        abbr = locale.abbreviations.million;
	                        break;
	                    case locale.abbreviations.million:
	                        abbr = locale.abbreviations.billion;
	                        break;
	                    case locale.abbreviations.billion:
	                        abbr = locale.abbreviations.trillion;
	                        break;
	                }
	            }
	
	
	            // format number
	            if (numeral._.includes(int, '-')) {
	                int = int.slice(1);
	                neg = true;
	            }
	
	            if (int.length < leadingCount) {
	                for (var i = leadingCount - int.length; i > 0; i--) {
	                    int = '0' + int;
	                }
	            }
	
	            if (thousands > -1) {
	                int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + locale.delimiters.thousands);
	            }
	
	            if (format.indexOf('.') === 0) {
	                int = '';
	            }
	
	            output = int + decimal + (abbr ? abbr : '');
	
	            if (negP) {
	                output = (negP && neg ? '(' : '') + output + (negP && neg ? ')' : '');
	            } else {
	                if (signed >= 0) {
	                    output = signed === 0 ? (neg ? '-' : '+') + output : output + (neg ? '-' : '+');
	                } else if (neg) {
	                    output = '-' + output;
	                }
	            }
	
	            return output;
	        },
	        // unformats numbers separators, decimals places, signs, abbreviations
	        stringToNumber: function(string) {
	            var locale = locales[options.currentLocale],
	                stringOriginal = string,
	                abbreviations = {
	                    thousand: 3,
	                    million: 6,
	                    billion: 9,
	                    trillion: 12
	                },
	                abbreviation,
	                value,
	                i,
	                regexp;
	
	            if (options.zeroFormat && string === options.zeroFormat) {
	                value = 0;
	            } else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, '').length) {
	                value = null;
	            } else {
	                value = 1;
	
	                if (locale.delimiters.decimal !== '.') {
	                    string = string.replace(/\./g, '').replace(locale.delimiters.decimal, '.');
	                }
	
	                for (abbreviation in abbreviations) {
	                    regexp = new RegExp('[^a-zA-Z]' + locale.abbreviations[abbreviation] + '(?:\\)|(\\' + locale.currency.symbol + ')?(?:\\))?)?$');
	
	                    if (stringOriginal.match(regexp)) {
	                        value *= Math.pow(10, abbreviations[abbreviation]);
	                        break;
	                    }
	                }
	
	                // check for negative number
	                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;
	
	                // remove non numbers
	                string = string.replace(/[^0-9\.]+/g, '');
	
	                value *= Number(string);
	            }
	
	            return value;
	        },
	        isNaN: function(value) {
	            return typeof value === 'number' && isNaN(value);
	        },
	        includes: function(string, search) {
	            return string.indexOf(search) !== -1;
	        },
	        insert: function(string, subString, start) {
	            return string.slice(0, start) + subString + string.slice(start);
	        },
	        reduce: function(array, callback /*, initialValue*/) {
	            if (this === null) {
	                throw new TypeError('Array.prototype.reduce called on null or undefined');
	            }
	
	            if (typeof callback !== 'function') {
	                throw new TypeError(callback + ' is not a function');
	            }
	
	            var t = Object(array),
	                len = t.length >>> 0,
	                k = 0,
	                value;
	
	            if (arguments.length === 3) {
	                value = arguments[2];
	            } else {
	                while (k < len && !(k in t)) {
	                    k++;
	                }
	
	                if (k >= len) {
	                    throw new TypeError('Reduce of empty array with no initial value');
	                }
	
	                value = t[k++];
	            }
	            for (; k < len; k++) {
	                if (k in t) {
	                    value = callback(value, t[k], k, t);
	                }
	            }
	            return value;
	        },
	        /**
	         * Computes the multiplier necessary to make x >= 1,
	         * effectively eliminating miscalculations caused by
	         * finite precision.
	         */
	        multiplier: function (x) {
	            var parts = x.toString().split('.');
	
	            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
	        },
	        /**
	         * Given a variable number of arguments, returns the maximum
	         * multiplier that must be used to normalize an operation involving
	         * all of them.
	         */
	        correctionFactor: function () {
	            var args = Array.prototype.slice.call(arguments);
	
	            return args.reduce(function(accum, next) {
	                var mn = _.multiplier(next);
	                return accum > mn ? accum : mn;
	            }, 1);
	        },
	        /**
	         * Implementation of toFixed() that treats floats more like decimals
	         *
	         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
	         * problems for accounting- and finance-related software.
	         */
	        toFixed: function(value, maxDecimals, roundingFunction, optionals) {
	            var splitValue = value.toString().split('.'),
	                minDecimals = maxDecimals - (optionals || 0),
	                boundedPrecision,
	                optionalsRegExp,
	                power,
	                output;
	
	            // Use the smallest precision value possible to avoid errors from floating point representation
	            if (splitValue.length === 2) {
	              boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
	            } else {
	              boundedPrecision = minDecimals;
	            }
	
	            power = Math.pow(10, boundedPrecision);
	
	            // Multiply up by precision, round accurately, then divide and use native toFixed():
	            output = (roundingFunction(value + 'e+' + boundedPrecision) / power).toFixed(boundedPrecision);
	
	            if (optionals > maxDecimals - boundedPrecision) {
	                optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
	                output = output.replace(optionalsRegExp, '');
	            }
	
	            return output;
	        }
	    };
	
	    // avaliable options
	    numeral.options = options;
	
	    // avaliable formats
	    numeral.formats = formats;
	
	    // avaliable formats
	    numeral.locales = locales;
	
	    // This function sets the current locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    numeral.locale = function(key) {
	        if (key) {
	            options.currentLocale = key.toLowerCase();
	        }
	
	        return options.currentLocale;
	    };
	
	    // This function provides access to the loaded locale data.  If
	    // no arguments are passed in, it will simply return the current
	    // global locale object.
	    numeral.localeData = function(key) {
	        if (!key) {
	            return locales[options.currentLocale];
	        }
	
	        key = key.toLowerCase();
	
	        if (!locales[key]) {
	            throw new Error('Unknown locale : ' + key);
	        }
	
	        return locales[key];
	    };
	
	    numeral.reset = function() {
	        for (var property in defaults) {
	            options[property] = defaults[property];
	        }
	    };
	
	    numeral.zeroFormat = function(format) {
	        options.zeroFormat = typeof(format) === 'string' ? format : null;
	    };
	
	    numeral.nullFormat = function (format) {
	        options.nullFormat = typeof(format) === 'string' ? format : null;
	    };
	
	    numeral.defaultFormat = function(format) {
	        options.defaultFormat = typeof(format) === 'string' ? format : '0.0';
	    };
	
	    numeral.register = function(type, name, format) {
	        name = name.toLowerCase();
	
	        if (this[type + 's'][name]) {
	            throw new TypeError(name + ' ' + type + ' already registered.');
	        }
	
	        this[type + 's'][name] = format;
	
	        return format;
	    };
	
	
	    numeral.validate = function(val, culture) {
	        var _decimalSep,
	            _thousandSep,
	            _currSymbol,
	            _valArray,
	            _abbrObj,
	            _thousandRegEx,
	            localeData,
	            temp;
	
	        //coerce val to string
	        if (typeof val !== 'string') {
	            val += '';
	
	            if (console.warn) {
	                console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
	            }
	        }
	
	        //trim whitespaces from either sides
	        val = val.trim();
	
	        //if val is just digits return true
	        if (!!val.match(/^\d+$/)) {
	            return true;
	        }
	
	        //if val is empty return false
	        if (val === '') {
	            return false;
	        }
	
	        //get the decimal and thousands separator from numeral.localeData
	        try {
	            //check if the culture is understood by numeral. if not, default it to current locale
	            localeData = numeral.localeData(culture);
	        } catch (e) {
	            localeData = numeral.localeData(numeral.locale());
	        }
	
	        //setup the delimiters and currency symbol based on culture/locale
	        _currSymbol = localeData.currency.symbol;
	        _abbrObj = localeData.abbreviations;
	        _decimalSep = localeData.delimiters.decimal;
	        if (localeData.delimiters.thousands === '.') {
	            _thousandSep = '\\.';
	        } else {
	            _thousandSep = localeData.delimiters.thousands;
	        }
	
	        // validating currency symbol
	        temp = val.match(/^[^\d]+/);
	        if (temp !== null) {
	            val = val.substr(1);
	            if (temp[0] !== _currSymbol) {
	                return false;
	            }
	        }
	
	        //validating abbreviation symbol
	        temp = val.match(/[^\d]+$/);
	        if (temp !== null) {
	            val = val.slice(0, -1);
	            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
	                return false;
	            }
	        }
	
	        _thousandRegEx = new RegExp(_thousandSep + '{2}');
	
	        if (!val.match(/[^\d.,]/g)) {
	            _valArray = val.split(_decimalSep);
	            if (_valArray.length > 2) {
	                return false;
	            } else {
	                if (_valArray.length < 2) {
	                    return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx));
	                } else {
	                    if (_valArray[0].length === 1) {
	                        return ( !! _valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
	                    } else {
	                        return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
	                    }
	                }
	            }
	        }
	
	        return false;
	    };
	
	
	    /************************************
	        Numeral Prototype
	    ************************************/
	
	    numeral.fn = Numeral.prototype = {
	        clone: function() {
	            return numeral(this);
	        },
	        format: function(inputString, roundingFunction) {
	            var value = this._value,
	                format = inputString || options.defaultFormat,
	                kind,
	                output,
	                formatFunction;
	
	            // make sure we have a roundingFunction
	            roundingFunction = roundingFunction || Math.round;
	
	            // format based on value
	            if (value === 0 && options.zeroFormat !== null) {
	                output = options.zeroFormat;
	            } else if (value === null && options.nullFormat !== null) {
	                output = options.nullFormat;
	            } else {
	                for (kind in formats) {
	                    if (format.match(formats[kind].regexps.format)) {
	                        formatFunction = formats[kind].format;
	
	                        break;
	                    }
	                }
	
	                formatFunction = formatFunction || numeral._.numberToFormat;
	
	                output = formatFunction(value, format, roundingFunction);
	            }
	
	            return output;
	        },
	        value: function() {
	            return this._value;
	        },
	        input: function() {
	            return this._input;
	        },
	        set: function(value) {
	            this._value = Number(value);
	
	            return this;
	        },
	        add: function(value) {
	            var corrFactor = _.correctionFactor.call(null, this._value, value);
	
	            function cback(accum, curr, currI, O) {
	                return accum + Math.round(corrFactor * curr);
	            }
	
	            this._value = _.reduce([this._value, value], cback, 0) / corrFactor;
	
	            return this;
	        },
	        subtract: function(value) {
	            var corrFactor = _.correctionFactor.call(null, this._value, value);
	
	            function cback(accum, curr, currI, O) {
	                return accum - Math.round(corrFactor * curr);
	            }
	
	            this._value = _.reduce([value], cback, Math.round(this._value * corrFactor)) / corrFactor;
	
	            return this;
	        },
	        multiply: function(value) {
	            function cback(accum, curr, currI, O) {
	                var corrFactor = _.correctionFactor(accum, curr);
	                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
	            }
	
	            this._value = _.reduce([this._value, value], cback, 1);
	
	            return this;
	        },
	        divide: function(value) {
	            function cback(accum, curr, currI, O) {
	                var corrFactor = _.correctionFactor(accum, curr);
	                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
	            }
	
	            this._value = _.reduce([this._value, value], cback);
	
	            return this;
	        },
	        difference: function(value) {
	            return Math.abs(numeral(this._value).subtract(value).value());
	        }
	    };
	
	    /************************************
	        Default Locale && Format
	    ************************************/
	
	    numeral.register('locale', 'en', {
	        delimiters: {
	            thousands: ',',
	            decimal: '.'
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'm',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function(number) {
	            var b = number % 10;
	            return (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	        },
	        currency: {
	            symbol: '$'
	        }
	    });
	
	    
	
	(function() {
	        numeral.register('format', 'bps', {
	            regexps: {
	                format: /(BPS)/,
	                unformat: /(BPS)/
	            },
	            format: function(value, format, roundingFunction) {
	                var space = numeral._.includes(format, ' BPS') ? ' ' : '',
	                    output;
	
	                value = value * 10000;
	
	                // check for space before BPS
	                format = format.replace(/\s?BPS/, '');
	
	                output = numeral._.numberToFormat(value, format, roundingFunction);
	
	                if (numeral._.includes(output, ')')) {
	                    output = output.split('');
	
	                    output.splice(-1, 0, space + 'BPS');
	
	                    output = output.join('');
	                } else {
	                    output = output + space + 'BPS';
	                }
	
	                return output;
	            },
	            unformat: function(string) {
	                return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
	            }
	        });
	})();
	
	
	(function() {
	        var decimal = {
	            base: 1000,
	            suffixes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
	        },
	        binary = {
	            base: 1024,
	            suffixes: ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
	        };
	
	    var allSuffixes =  decimal.suffixes.concat(binary.suffixes.filter(function (item) {
	            return decimal.suffixes.indexOf(item) < 0;
	        }));
	        var unformatRegex = allSuffixes.join('|');
	        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
	        unformatRegex = '(' + unformatRegex.replace('B', 'B(?!PS)') + ')';
	
	    numeral.register('format', 'bytes', {
	        regexps: {
	            format: /([0\s]i?b)/,
	            unformat: new RegExp(unformatRegex)
	        },
	        format: function(value, format, roundingFunction) {
	            var output,
	                bytes = numeral._.includes(format, 'ib') ? binary : decimal,
	                suffix = numeral._.includes(format, ' b') || numeral._.includes(format, ' ib') ? ' ' : '',
	                power,
	                min,
	                max;
	
	            // check for space before
	            format = format.replace(/\s?i?b/, '');
	
	            for (power = 0; power <= bytes.suffixes.length; power++) {
	                min = Math.pow(bytes.base, power);
	                max = Math.pow(bytes.base, power + 1);
	
	                if (value === null || value === 0 || value >= min && value < max) {
	                    suffix += bytes.suffixes[power];
	
	                    if (min > 0) {
	                        value = value / min;
	                    }
	
	                    break;
	                }
	            }
	
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            return output + suffix;
	        },
	        unformat: function(string) {
	            var value = numeral._.stringToNumber(string),
	                power,
	                bytesMultiplier;
	
	            if (value) {
	                for (power = decimal.suffixes.length - 1; power >= 0; power--) {
	                    if (numeral._.includes(string, decimal.suffixes[power])) {
	                        bytesMultiplier = Math.pow(decimal.base, power);
	
	                        break;
	                    }
	
	                    if (numeral._.includes(string, binary.suffixes[power])) {
	                        bytesMultiplier = Math.pow(binary.base, power);
	
	                        break;
	                    }
	                }
	
	                value *= (bytesMultiplier || 1);
	            }
	
	            return value;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'currency', {
	        regexps: {
	            format: /(\$)/
	        },
	        format: function(value, format, roundingFunction) {
	            var locale = numeral.locales[numeral.options.currentLocale],
	                symbols = {
	                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
	                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
	                },
	                output,
	                symbol,
	                i;
	
	            // strip format of spaces and $
	            format = format.replace(/\s?\$\s?/, '');
	
	            // format the number
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            // update the before and after based on value
	            if (value >= 0) {
	                symbols.before = symbols.before.replace(/[\-\(]/, '');
	                symbols.after = symbols.after.replace(/[\-\)]/, '');
	            } else if (value < 0 && (!numeral._.includes(symbols.before, '-') && !numeral._.includes(symbols.before, '('))) {
	                symbols.before = '-' + symbols.before;
	            }
	
	            // loop through each before symbol
	            for (i = 0; i < symbols.before.length; i++) {
	                symbol = symbols.before[i];
	
	                switch (symbol) {
	                    case '$':
	                        output = numeral._.insert(output, locale.currency.symbol, i);
	                        break;
	                    case ' ':
	                        output = numeral._.insert(output, ' ', i + locale.currency.symbol.length - 1);
	                        break;
	                }
	            }
	
	            // loop through each after symbol
	            for (i = symbols.after.length - 1; i >= 0; i--) {
	                symbol = symbols.after[i];
	
	                switch (symbol) {
	                    case '$':
	                        output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
	                        break;
	                    case ' ':
	                        output = i === symbols.after.length - 1 ? output + ' ' : numeral._.insert(output, ' ', -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
	                        break;
	                }
	            }
	
	
	            return output;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'exponential', {
	        regexps: {
	            format: /(e\+|e-)/,
	            unformat: /(e\+|e-)/
	        },
	        format: function(value, format, roundingFunction) {
	            var output,
	                exponential = typeof value === 'number' && !numeral._.isNaN(value) ? value.toExponential() : '0e+0',
	                parts = exponential.split('e');
	
	            format = format.replace(/e[\+|\-]{1}0/, '');
	
	            output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);
	
	            return output + 'e' + parts[1];
	        },
	        unformat: function(string) {
	            var parts = numeral._.includes(string, 'e+') ? string.split('e+') : string.split('e-'),
	                value = Number(parts[0]),
	                power = Number(parts[1]);
	
	            power = numeral._.includes(string, 'e-') ? power *= -1 : power;
	
	            function cback(accum, curr, currI, O) {
	                var corrFactor = numeral._.correctionFactor(accum, curr),
	                    num = (accum * corrFactor) * (curr * corrFactor) / (corrFactor * corrFactor);
	                return num;
	            }
	
	            return numeral._.reduce([value, Math.pow(10, power)], cback, 1);
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'ordinal', {
	        regexps: {
	            format: /(o)/
	        },
	        format: function(value, format, roundingFunction) {
	            var locale = numeral.locales[numeral.options.currentLocale],
	                output,
	                ordinal = numeral._.includes(format, ' o') ? ' ' : '';
	
	            // check for space before
	            format = format.replace(/\s?o/, '');
	
	            ordinal += locale.ordinal(value);
	
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            return output + ordinal;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'percentage', {
	        regexps: {
	            format: /(%)/,
	            unformat: /(%)/
	        },
	        format: function(value, format, roundingFunction) {
	            var space = numeral._.includes(format, ' %') ? ' ' : '',
	                output;
	
	            if (numeral.options.scalePercentBy100) {
	                value = value * 100;
	            }
	
	            // check for space before %
	            format = format.replace(/\s?\%/, '');
	
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            if (numeral._.includes(output, ')')) {
	                output = output.split('');
	
	                output.splice(-1, 0, space + '%');
	
	                output = output.join('');
	            } else {
	                output = output + space + '%';
	            }
	
	            return output;
	        },
	        unformat: function(string) {
	            var number = numeral._.stringToNumber(string);
	            if (numeral.options.scalePercentBy100) {
	                return number * 0.01;
	            }
	            return number;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'time', {
	        regexps: {
	            format: /(:)/,
	            unformat: /(:)/
	        },
	        format: function(value, format, roundingFunction) {
	            var hours = Math.floor(value / 60 / 60),
	                minutes = Math.floor((value - (hours * 60 * 60)) / 60),
	                seconds = Math.round(value - (hours * 60 * 60) - (minutes * 60));
	
	            return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
	        },
	        unformat: function(string) {
	            var timeArray = string.split(':'),
	                seconds = 0;
	
	            // turn hours and minutes into seconds and add them all up
	            if (timeArray.length === 3) {
	                // hours
	                seconds = seconds + (Number(timeArray[0]) * 60 * 60);
	                // minutes
	                seconds = seconds + (Number(timeArray[1]) * 60);
	                // seconds
	                seconds = seconds + Number(timeArray[2]);
	            } else if (timeArray.length === 2) {
	                // minutes
	                seconds = seconds + (Number(timeArray[0]) * 60);
	                // seconds
	                seconds = seconds + Number(timeArray[1]);
	            }
	            return Number(seconds);
	        }
	    });
	})();
	
	return numeral;
	}));


/***/ }),
/* 196 */
/***/ (function(module, exports) {

	'use strict';
	
	var replace = String.prototype.replace;
	var percentTwenties = /%20/g;
	
	var Format = {
	    RFC1738: 'RFC1738',
	    RFC3986: 'RFC3986'
	};
	
	module.exports = {
	    'default': Format.RFC3986,
	    formatters: {
	        RFC1738: function (value) {
	            return replace.call(value, percentTwenties, '+');
	        },
	        RFC3986: function (value) {
	            return String(value);
	        }
	    },
	    RFC1738: Format.RFC1738,
	    RFC3986: Format.RFC3986
	};


/***/ }),
/* 197 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(3);
	var computed = __webpack_require__(295);
	
	module.exports = {
	    setComputedFields: function setComputedFields(args, state) {
	        computed.computeChangePasswordButtonState(state);
	        computed.setRepeatPasswordError(state);
	    },
	    resetUserForm: function resetUserForm(args, state) {
	        state.unset(['account', 'passwordChangeForm', 'isError']);
	        state.unset(['account', 'passwordChangeForm', 'error']);
	    },
	    ifChangePasswordInProcess: function ifChangePasswordInProcess(args, state, output) {
	        if (state.get(['account', 'passwordChangeForm', 'inProcess'])) {
	            return output.yes();
	        }
	        return output.no();
	    },
	    changePassword: function changePassword(args, state, output, _ref) {
	        var locator = _ref.locator,
	            context = _ref.context;
	
	        var password = state.get(['account', 'passwordChangeForm', 'password']);
	        var passwordNew = state.get(['account', 'passwordChangeForm', 'passwordNew']);
	
	        var API = locator.resolve('api');
	        var request = API.passwordChangeActual(context, { password: password, passwordNew: passwordNew });
	
	        request.then(function (data) {
	            var code = _.get(data, 'status.code');
	
	            if (code === 422) {
	                output.wrongPassword({ code: code });
	                return;
	            }
	
	            if (code !== 204) {
	                output.error({ code: code });
	                return;
	            }
	
	            output.success({ data: data });
	        }).catch(function (error) {
	            return output.error({ error: error });
	        });
	    }
	};

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(3);
	var fileSaver = __webpack_require__(192);
	var computed = __webpack_require__(296);
	
	var cellWidth = 145;
	var cellHeight = 27;
	var headerHeight = 100;
	var headerWidth = 225;
	var xAmount = 70;
	var yAmount = 70;
	
	var overlapAmount = 20;
	
	var getStatisticTimerId = void 0;
	var statisticRequestId = 0;
	var lastProcessedStatisticRequestId = 0;
	
	module.exports = {
	    setRows: function setRows(_ref, state) {
	        var _ref$yStartIndex = _ref.yStartIndex,
	            yStartIndex = _ref$yStartIndex === undefined ? 0 : _ref$yStartIndex,
	            _ref$xStartIndex = _ref.xStartIndex,
	            xStartIndex = _ref$xStartIndex === undefined ? 0 : _ref$xStartIndex,
	            statisticChunk = _ref.statisticChunk;
	
	        state.set(['account', 'statistic', 'yStartIndex'], Math.max(yStartIndex - overlapAmount, 0));
	        state.set(['account', 'statistic', 'data'], statisticChunk.rows);
	        state.set(['account', 'statistic', 'header', 'top', 'data'], statisticChunk.xHeader);
	        state.set(['account', 'statistic', 'header', 'left', 'data'], statisticChunk.yHeader);
	        state.set(['account', 'statistic', 'topOffset'], Math.max(yStartIndex - overlapAmount, 0) * cellHeight + headerHeight - 1);
	        state.set(['account', 'statistic', 'leftOffset'], Math.max(xStartIndex - overlapAmount, 0) * cellWidth + headerWidth - 1);
	        state.set(['account', 'statistic', 'height'], statisticChunk.yLastIndex * cellHeight + headerHeight);
	        state.set(['account', 'statistic', 'width'], statisticChunk.xLastIndex * cellWidth + headerWidth);
	    },
	    addStartIndexesToArgs: function addStartIndexesToArgs(args, state, output, _ref2) {
	        var context = _ref2.context;
	
	        var scrollLeft = 0;
	        var scrollTop = 0;
	
	        if (!context.isServer) {
	            var target = document.getElementById('scrollable');
	            if (target) {
	                scrollLeft = target.scrollLeft;
	                scrollTop = target.scrollTop;
	            }
	        }
	
	        args.xStartIndex = Math.ceil((scrollLeft || 0) / cellWidth);
	        args.yStartIndex = Math.ceil((scrollTop || 0) / cellHeight);
	    },
	    getStatisticChunk: function getStatisticChunk(_ref3, state, output, _ref4) {
	        var xStartIndex = _ref3.xStartIndex,
	            yStartIndex = _ref3.yStartIndex;
	        var locator = _ref4.locator,
	            context = _ref4.context;
	
	        if (getStatisticTimerId) {
	            clearTimeout(getStatisticTimerId);
	        }
	
	        var API = locator.resolve('api');
	        var orderId = state.get(['account', 'statistic', 'orderId']);
	        var xExtended = state.get(['account', 'statistic', 'xExtended']) || [];
	        var yExtended = state.get(['account', 'statistic', 'yExtended']) || [];
	        var isTransposed = state.get(['account', 'statistic', 'isTransposed']) || false;
	        var isByBranch = state.get(['account', 'statistic', 'isByBranch']) || false;
	
	        getStatisticTimerId = setTimeout(function getStatisticRetry() {
	            var request = API.getStatisticChunk(context, locator, { orderId: orderId, xStartIndex: Math.max(xStartIndex - overlapAmount, 0),
	                yStartIndex: Math.max(yStartIndex - overlapAmount, 0),
	                xAmount: xAmount, yAmount: yAmount, xExtended: xExtended, yExtended: yExtended, isTransposed: isTransposed, isByBranch: isByBranch });
	
	            var requestId = statisticRequestId++;
	
	            request.then(function (data) {
	                if (state.get(['account', 'statistic', 'orderId']) !== orderId) {
	                    output.orderChanged();
	                    return;
	                }
	
	                var statusCode = _.get(data, 'status.code');
	
	                if (statusCode === 404) {
	                    getStatisticTimerId = setTimeout(getStatisticRetry, 10000);
	                    return;
	                }
	
	                if (statusCode !== 200) {
	                    output.error({ error: statusCode });
	                    return;
	                }
	
	                if (requestId < lastProcessedStatisticRequestId) {
	                    output.orderChanged();
	                    return;
	                }
	
	                lastProcessedStatisticRequestId = requestId;
	                output.success({ statisticChunk: data.content });
	            }).catch(function (error) {
	                return output.error(error);
	            });
	        }, 0);
	    },
	    transpose: function transpose(args, state) {
	        var xExtended = state.get(['account', 'statistic', 'xExtended']);
	        state.set(['account', 'statistic', 'xExtended'], state.get(['account', 'statistic', 'yExtended']));
	        state.set(['account', 'statistic', 'yExtended'], xExtended);
	    },
	    downloadExcel: function downloadExcel(args, state, output, _ref5) {
	        var locator = _ref5.locator,
	            context = _ref5.context;
	
	        var orderId = state.get(['account', 'statistic', 'orderId']);
	        var isTransposed = state.get(['account', 'statistic', 'isTransposed']) || false;
	        var isByBranch = state.get(['account', 'statistic', 'isByBranch']) || false;
	        var API = locator.resolve('api');
	
	        var request = API.downloadStatisticFile(context, locator, { orderId: orderId, isTransposed: isTransposed, isByBranch: isByBranch });
	
	        request.then(function (response) {
	            if (response.code === 200) {
	                var blob = new Blob([response.content], { type: response.contentType });
	                var fileName = response.contentDisposition.match(/attachment; filename=(.+)/)[1];
	
	                fileSaver.saveAs(blob, fileName);
	                output.success();
	            } else {
	                output.error({ error: response.code });
	            }
	        }).catch(function (error) {
	            return output.error({ error: error });
	        });
	    },
	    setComputedFields: function setComputedFields(args, state) {
	        computed.queryObject(state);
	    }
	};

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(3);
	var computed = __webpack_require__(301);
	
	module.exports = {
	    setComputedFields: function setComputedFields(args, state) {
	        computed.restoreButton(state);
	        computed.setRepeatPasswordError(state);
	        computed.errorMessage(state);
	        computed.errorState(state);
	    },
	    passwordChange: function passwordChange(args, state, output, _ref) {
	        var locator = _ref.locator,
	            context = _ref.context;
	
	        var password = state.get(['restoreChange', 'form', 'password']);
	        var restoreToken = state.get('restoreToken');
	
	        var API = locator.resolve('api');
	        var request = API.passwordChange(context, { password: password, restoreToken: restoreToken });
	
	        request.then(function (data) {
	            var code = _.get(data, 'status.code');
	
	            if (code === 404) {
	                output.notFound({ code: code });
	                return;
	            }
	
	            if (code === 401) {
	                output.invalidToken({ code: code });
	                return;
	            }
	
	            if (code !== 200) {
	                output.error({ code: code });
	                return;
	            }
	
	            output.success({ data: data });
	        }).catch(function (error) {
	            return output.error({ error: error });
	        });
	    }
	};

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(3);
	var computed = __webpack_require__(302);
	
	module.exports = {
	    setComputedFields: function setComputedFields(args, state) {
	        computed.restoreButton(state);
	        computed.errorMessage(state);
	        computed.errorState(state);
	    },
	    restorePassword: function restorePassword(args, state, output, _ref) {
	        var locator = _ref.locator,
	            context = _ref.context;
	
	        var email = state.get(['restore', 'form', 'email']);
	
	        var restoreData = {
	            grant_type: 'email',
	            email: email
	        };
	
	        var queryData = {
	            client_id: 'hermes',
	            template: '/static/mail/template/recovery.twig'
	        };
	
	        var API = locator.resolve('api');
	        var request = API.restorePassword(context, { restoreData: restoreData, queryData: queryData });
	
	        request.then(function (data) {
	            var code = _.get(data, 'status.code');
	
	            if (code === 404) {
	                output.notFound({ code: code });
	                return;
	            }
	
	            if (code !== 200) {
	                output.error({ code: code });
	                return;
	            }
	
	            output.success({ data: data });
	        }).catch(function (error) {
	            return output.error({ error: error });
	        });
	    }
	};

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(3);
	var computed = __webpack_require__(15).monkey;
	var SCHEME = __webpack_require__(22);
	
	function isContinueEnabled(error, form, isDisabled, extraRequiredFields) {
	    var requiredFields = ['firstName', 'lastName', 'countryId', 'legalAddress'];
	    if (extraRequiredFields) {
	        requiredFields = requiredFields.concat(extraRequiredFields);
	    }
	    if (form && form.userType === 2) {
	        requiredFields = _.concat(requiredFields, ['organization']);
	        switch (form.countryId) {
	            case 1:
	                requiredFields = _.concat(requiredFields, ['inn10', 'kpp']);
	                break;
	            case 4:
	                requiredFields = _.concat(requiredFields, ['bin']);
	                break;
	            default:
	                break;
	        }
	    } else if (form && form.userType === 3) {
	        requiredFields = _.concat(requiredFields, ['organization', 'inn12']);
	    }
	    var requiredError = _.clone(error, false);
	    if (requiredError && form && form.userType === 1) {
	        delete requiredError['organization'];
	        delete requiredError['inn10'];
	        delete requiredError['inn12'];
	        delete requiredError['bin'];
	        delete requiredError['kpp'];
	    }
	    var requiredKeys = _.keys(_.omitBy(form, function (key) {
	        return !key;
	    }));
	    var differenceLength = _.difference(requiredFields, requiredKeys).length;
	
	    return _.every([_.isEmpty(requiredError), !differenceLength, !isDisabled]);
	}
	
	module.exports = {
	    isContinueEnabled: isContinueEnabled,
	
	    registerButton: function registerButton(state) {
	        state.set(['registration', 'computed', 'registerButton', 'isEnabled'], computed(['registration', 'error'], ['registration', 'computed', 'error', 'repeatPassword'], ['registration', 'form'], ['registration', 'ui', 'registerButton', 'isDisabled'], function (error, repeatPassword, form, isDisabled) {
	            if (repeatPassword) {
	                return false;
	            }
	            return isContinueEnabled(error, form, isDisabled, ['email', 'password', 'repeatPassword']);
	        }));
	    },
	    setRepeatPasswordError: function setRepeatPasswordError(state) {
	        state.set(['registration', 'computed', 'error', 'repeatPassword'], computed(['registration', 'error', 'repeatPassword'], ['registration', 'form', 'repeatPassword'], ['registration', 'form', 'password'], function (errorRepeatPassword, repeatPassword, password) {
	            if (!repeatPassword) {
	                return;
	            }
	
	            if (errorRepeatPassword) {
	                return errorRepeatPassword;
	            }
	
	            if (repeatPassword !== password) {
	                return _.get(SCHEME.repeatPassword, 'properties.value.messages.repeat');
	            }
	        }));
	    },
	    isUserTypeSelectEnabled: function isUserTypeSelectEnabled(state) {
	        state.set(['registration', 'computed', 'isUserTypeSelectEnabled'], computed(['registration', 'form', 'countryId'], function (countryId) {
	            return countryId === 1 || countryId === 4;
	        }));
	    }
	};

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(3);
	var utils = __webpack_require__(5);
	var basePath = ['order', 'addParams', 'numberOfFilials'];
	
	module.exports = {
	    initOptions: function initOptions(_ref, state) {
	        var availableParameters = _ref.availableParameters;
	
	        var numberOfFilials = availableParameters.numberOfFilials;
	        var columns = availableParameters.exportColumns ? availableParameters.exportColumns.columns : [];
	        var filialsExportColumn = _.find(columns, function (x) {
	            return x.propertyName === 'NumberOfFilials';
	        });
	
	        if (filialsExportColumn && numberOfFilials) {
	            state.set(['order', 'addParams', 'numberOfFilials', 'options'], _.map(Object.keys(numberOfFilials), function (key) {
	                return { isActive: key === '-1', title: numberOfFilials[key], value: key };
	            }));
	            state.set(['order', 'addParams', 'numberOfFilials', 'isDisable'], false);
	            state.set(['order', 'addParams', 'numberOfFilials', 'isOpen'], false);
	
	            utils.setPopupVisibility('numberOfFilialsPopup', ['order', 'addParams', 'numberOfFilials', 'isOpen'])({}, state);
	        }
	    },
	    selectFilialsNumber: function selectFilialsNumber(_ref2, state) {
	        var selectedValue = _ref2.selectedValue;
	
	        var options = state.get(basePath.concat('options'));
	        var oldSelectedValueIndex = _.findIndex(options, { isActive: true });
	        if (oldSelectedValueIndex > -1) {
	            state.set(basePath.concat(['options', oldSelectedValueIndex, 'isActive']), false);
	        }
	        var selectedIndex = _.findIndex(options, { value: selectedValue });
	        if (selectedIndex > -1) {
	            state.set(basePath.concat(['options', selectedIndex, 'isActive']), true);
	        }
	    }
	};

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var moment = __webpack_require__(34);
	
	module.exports = {
	    getFormattedDate: function getFormattedDate(unixStamp) {
	        var dateMoment = moment.unix(unixStamp);
	
	        return unixStamp ? moment(dateMoment).utc().add(dateMoment.utcOffset(), 'm').toISOString() : null;
	    }
	};

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var revalidator = __webpack_require__(1053);
	var _ = __webpack_require__(3);
	
	module.exports = {
	    inputText: function inputText(_ref, state) {
	        var path = _ref.path,
	            value = _ref.value;
	
	        if (!path) {
	            return;
	        }
	
	        var setPath = path.split('.');
	        state.set(setPath, value);
	    },
	    trimText: function trimText(_ref2, state) {
	        var path = _ref2.path,
	            value = _ref2.value;
	
	        if (!path) {
	            return;
	        }
	
	        var setPath = path.split('.');
	
	        state.set(setPath, _.trim(value));
	    },
	    validateText: function validateText(_ref3, state) {
	        var scheme = _ref3.scheme,
	            errorPath = _ref3.errorPath,
	            errorMessage = _ref3.errorMessage,
	            validationValue = _ref3.validationValue,
	            value = _ref3.value;
	
	        var target = { value: validationValue || value };
	        var message = errorMessage;
	
	        if (!errorPath || !scheme) {
	            return;
	        }
	
	        var type = _.get(scheme, 'properties.value.type');
	
	        if (type === 'number') {
	            target.value = Number(target.value);
	        }
	        if (type === 'string') {
	            target.value = _.trim(target.value);
	        }
	
	        var status = revalidator.validate(target, scheme);
	
	        var errors = status.errors,
	            valid = status.valid;
	
	        var errorPathArray = errorPath.split('.');
	
	        if (valid) {
	            var validatorFunction = _.get(scheme, 'properties.value.validator.func');
	            if (validatorFunction && !validatorFunction(target.value)) {
	                valid = false;
	                message = _.get(scheme, 'properties.value.validator.message');
	            }
	        }
	
	        if (valid) {
	            if (state.get(errorPathArray)) {
	                state.unset(errorPathArray);
	            }
	        } else {
	            message = message || _.chain(errors).first().get('message').value();
	            state.set(errorPathArray, message);
	        }
	    },
	    validateUnsetError: function validateUnsetError(_ref4, state) {
	        var scheme = _ref4.scheme,
	            errorPath = _ref4.errorPath,
	            validationValue = _ref4.validationValue,
	            value = _ref4.value;
	
	        var target = { value: validationValue || value };
	
	        if (!errorPath || !scheme) {
	            return;
	        }
	
	        var type = _.get(scheme, 'properties.value.type');
	
	        if (type === 'number') {
	            target.value = Number(target.value);
	        }
	        if (type === 'string') {
	            target.value = _.trim(target.value);
	        }
	
	        var status = revalidator.validate(target, scheme);
	        var valid = status.valid;
	
	
	        var errorPathArr = errorPath.split('.');
	
	        if (valid && state.get(errorPathArr)) {
	            state.unset(errorPathArr);
	        }
	    }
	};

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var computed = __webpack_require__(306);
	var _ = __webpack_require__(3);
	
	var MULTIPLIER_MAP = {
	    buildings: 1,
	    city: 0.5,
	    clouds: 0.4
	};
	
	var DEFAULT_VALUE = 0;
	var MAX_VALUE = 1900;
	var OFFSET = 475;
	
	function asyncSetDefaultAnimation(field, state) {
	    state.set(['slider', 'asyncAnimation'], true);
	
	    setTimeout(function () {
	        state.set(['slider', 'noAnimation'], true);
	    }, 500);
	
	    setTimeout(function () {
	        state.set(['slider', 'positions', field], DEFAULT_VALUE);
	    }, 550);
	
	    setTimeout(function () {
	        state.unset(['slider', 'noAnimation']);
	        state.unset(['slider', 'asyncAnimation']);
	    }, 650);
	}
	
	module.exports = {
	    setComputedFields: function setComputedFields(args, state) {
	        computed.promoText(state);
	    },
	    asyncAnimation: function asyncAnimation(args, state, output) {
	        var asyncAnimation = state.get(['slider', 'asyncAnimation']);
	
	        if (asyncAnimation) {
	            return;
	        }
	
	        output.no();
	    },
	    sliderNextView: function sliderNextView(args, state) {
	        var page = state.get(['slider', 'page']);
	        var positions = state.get(['slider', 'positions']);
	
	        _.each(MULTIPLIER_MAP, function (multiplier, field) {
	            var currentPosition = positions[field];
	
	            if (OFFSET * multiplier + currentPosition >= MAX_VALUE) {
	                asyncSetDefaultAnimation(field, state);
	            }
	
	            state.set(['slider', 'positions', field], OFFSET * multiplier + currentPosition);
	        });
	
	        state.set(['slider', 'page'], (page + 1) % 5 || 1);
	    }
	};

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(761);
	var Price = __webpack_require__(208);
	var ordersComputedActions = __webpack_require__(61);
	var currentOrderActions = __webpack_require__(23);
	
	var Header = function () {
	    function Header() {
	        _classCallCheck(this, Header);
	
	        this.template = __webpack_require__(893);
	    }
	
	    Header.prototype.render = function render() {
	        var props = this.$context.props;
	
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, props, { css: css });
	        });
	    };
	
	    return Header;
	}();
	
	module.exports = {
	    constructor: Header,
	    children: [{
	        name: 'price',
	        component: Price,
	        watcher: {
	            isShowAsterisk: ordersComputedActions.PATHS.isShowSumCanChangeTooltip,
	            rowPrice: ['account', 'orders', 'computed', 'price', 'data', 'total', 'rowPrice'],
	            totalPrice: ['account', 'orders', 'computed', 'price', 'data', 'total', 'totalPrice'],
	            orderAmount: currentOrderActions.PATHS.orderAmount,
	            rowAmount: ['account', 'orders', 'computed', 'price', 'data', 'total', 'rowAmount'],
	            isLoading: ['account', 'orders', 'computed', 'price', 'isLoading'],
	            typeId: ['account', 'orders', 'currentOrder', 'typeId']
	        }
	    }]
	};

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Preloader = __webpack_require__(101);
	var css = __webpack_require__(765);
	
	var Price = function () {
	    function Price() {
	        _classCallCheck(this, Price);
	
	        this.template = __webpack_require__(897);
	    }
	
	    Price.prototype.render = function render() {
	        var isHeader = 'cat-header' in this.$context.attributes;
	
	        return this.$context.getWatcherData().then(function (data) {
	            var totalPrice = data.typeId === 4 ? data.orderAmount : data.totalPrice;
	
	            return Object.assign({}, { isHeader: isHeader }, data, { css: css }, { totalPrice: totalPrice });
	        });
	    };
	
	    return Price;
	}();
	
	module.exports = {
	    constructor: Price,
	    children: [{
	        name: 'preloader-small',
	        component: Preloader,
	        props: {
	            size: 'small'
	        }
	    }, {
	        name: 'preloader',
	        component: Preloader
	    }]
	};

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(795);
	var $ = __webpack_require__(12);
	
	var _require = __webpack_require__(90),
	    raiseEvent = _require.raiseEvent;
	
	var _require2 = __webpack_require__(4),
	    cut = _require2.cut;
	
	var ACCEPT = cut(css.accept);
	var CANCEL = cut(css.cancel);
	var CONTAINER = cut(css.container);
	
	var ToS = function () {
	    function ToS() {
	        _classCallCheck(this, ToS);
	
	        this.template = __webpack_require__(931);
	        this.tabTrapBound = this.trapTab.bind(this);
	    }
	
	    ToS.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    ToS.prototype.bind = function bind() {
	        var _click;
	
	        $('body').addClass(css.scrollDisabled);
	
	        document.addEventListener('focus', this.tabTrapBound, true);
	
	        return {
	            focus: {
	                document: this.test
	            },
	            click: (_click = {}, _click[ACCEPT] = this.handleAccept, _click[CANCEL] = this.handleCancel, _click)
	        };
	    };
	
	    ToS.prototype.unbind = function unbind() {
	        document.removeEventListener('focus', this.tabTrapBound, true);
	        $('body').removeClass(css.scrollDisabled);
	    };
	
	    ToS.prototype.trapTab = function trapTab(event) {
	        var el = $(this.$context.element);
	        var modal = el.find(CONTAINER)[0];
	        if (!modal.contains(event.target)) {
	            event.stopPropagation();
	            modal.focus();
	        }
	    };
	
	    ToS.prototype.handleCancel = function handleCancel() {
	        this.$context.signal(raiseEvent, { category: 'button_cancel_popup_agreement', action: 'click' });
	        this.$context.signal(this.$context.props.signals.cancel);
	    };
	
	    ToS.prototype.handleAccept = function handleAccept() {
	        this.$context.signal(raiseEvent, { category: 'button_accept_popup_agreement', action: 'click' });
	        this.$context.signal(this.$context.props.signals.accept);
	    };
	
	    return ToS;
	}();
	
	module.exports = {
	    constructor: ToS
	};

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(802);
	var filterableTreeFactory = __webpack_require__(89);
	var legalEntities = __webpack_require__(503);
	
	var Discount = function () {
	    function Discount() {
	        _classCallCheck(this, Discount);
	
	        this.template = __webpack_require__(938);
	    }
	
	    Discount.prototype.render = function render() {
	        var props = this.$context.props;
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, props, { css: css });
	        });
	    };
	
	    return Discount;
	}();
	
	module.exports = {
	    constructor: Discount,
	    children: [{
	        name: 'legal-tree',
	        component: filterableTreeFactory({
	            basePath: ['order', 'addParams', 'legalEntities', 'tree']
	        }),
	        watcher: {
	            isDisabled: ['order', 'isDisabled']
	        },
	        props: {
	            id: 'legal-entities',
	            onItemCheck: legalEntities.onItemCheck,
	            onSetAll: legalEntities.onSetAll,
	            minFilterLength: 2,
	            isInnerTree: true
	        },
	        parentPropsMap: {
	            isSmallTree: 'isSmallTree'
	        }
	    }]
	};

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(805);
	var filterableTreeFactory = __webpack_require__(89);
	var purposes = __webpack_require__(507);
	
	var Discount = function () {
	    function Discount() {
	        _classCallCheck(this, Discount);
	
	        this.template = __webpack_require__(941);
	    }
	
	    Discount.prototype.render = function render() {
	        var props = this.$context.props;
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, props, { css: css });
	        });
	    };
	
	    return Discount;
	}();
	
	module.exports = {
	    constructor: Discount,
	    children: [{
	        name: 'purpose-tree',
	        component: filterableTreeFactory({
	            basePath: ['order', 'addParams', 'purposes', 'tree']
	        }),
	        watcher: {
	            isDisabled: ['order', 'isDisabled']
	        },
	        props: {
	            id: 'purposes',
	            onItemCheck: purposes.onItemCheck,
	            onSetAll: purposes.onSetAll,
	            minFilterLength: 2,
	            isInnerTree: true
	        },
	        parentPropsMap: {
	            isSmallTree: 'isSmallTree'
	        }
	    }]
	};

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(818);
	
	var _require = __webpack_require__(4),
	    pluralize = _require.pluralize;
	
	var treeHelper = __webpack_require__(57);
	
	var Header = function () {
	    function Header() {
	        _classCallCheck(this, Header);
	
	        this.template = __webpack_require__(954);
	    }
	
	    Header.prototype.render = function render() {
	        var _this = this;
	
	        return this.$context.getWatcherData().then(function (data) {
	            var selectedLeafs = treeHelper.getSelectedLeafs(data.leafs, data.selected);
	            var count = selectedLeafs.length;
	
	            var title = count ? count + ' ' + pluralize(count, _this.$context.props.pluralized) : _this.$context.props.defaultTitle;
	
	            return Object.assign({}, data, { title: title }, { css: css });
	        });
	    };
	
	    return Header;
	}();
	
	module.exports = {
	    constructor: Header
	};

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(831);
	var Error = __webpack_require__(88);
	var UserSharedDataForm = __webpack_require__(155);
	var IndividualForm = __webpack_require__(152);
	var LegalEntityForm = __webpack_require__(153);
	var SoleProprietorForm = __webpack_require__(154);
	var ActionsPanel = __webpack_require__(397);
	var signals = __webpack_require__(225);
	
	var UserForm = function () {
	    function UserForm() {
	        _classCallCheck(this, UserForm);
	
	        this.template = __webpack_require__(973);
	    }
	
	    UserForm.prototype.render = function render() {
	        var _this = this;
	
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, _this.$context.props, { css: css });
	        });
	    };
	
	    return UserForm;
	}();
	
	module.exports = {
	    constructor: UserForm,
	    children: [{
	        name: 'error',
	        component: Error,
	        props: {
	            text: 'Что-то пошло не так. Пожалуйста, нажмите кнопку еще раз.'
	        },
	        watcher: {
	            isError: ['account', 'userForm', 'isError']
	        }
	    }, {
	        name: 'user-shared-data-form',
	        component: UserSharedDataForm(['account', 'userForm'], signals.selectUserType, signals.selectCountry),
	        props: {
	            formPath: 'account.userForm',
	            disableEmail: true
	        },
	        parentPropsMap: {
	            'disableEditing': 'disableEditing'
	        },
	        watcher: {
	            isUserTypeSelectEnabled: ['account', 'userForm', 'computed', 'isUserTypeSelectEnabled']
	        }
	    }, {
	        name: 'legal-entity-form',
	        component: LegalEntityForm(['account', 'userForm']),
	        props: {
	            formPath: 'account.userForm'
	        },
	        parentPropsMap: {
	            'disableEditing': 'disableEditing'
	        },
	        watcher: {
	            userCountryId: ['account', 'userForm', 'form', 'countryId']
	        }
	    }, {
	        name: 'sole-proprietor-form',
	        component: SoleProprietorForm(['account', 'userForm']),
	        props: {
	            formPath: 'account.userForm'
	        },
	        parentPropsMap: {
	            'disableEditing': 'disableEditing'
	        },
	        watcher: {
	            userCountryId: ['account', 'userForm', 'form', 'countryId']
	        }
	    }, {
	        name: 'individual-form',
	        component: IndividualForm(['account', 'userForm']),
	        props: {
	            formPath: 'account.userForm'
	        },
	        parentPropsMap: {
	            'disableEditing': 'disableEditing'
	        },
	        watcher: {
	            userCountryId: ['account', 'userForm', 'form', 'countryId']
	        }
	    }, {
	        name: 'actions-panel',
	        component: ActionsPanel,
	        watcher: {
	            isSaveEnabled: ['account', 'userForm', 'computed', 'saveButton', 'isEnabled'],
	            isCancelEnabled: ['account', 'userForm', 'computed', 'cancelButton', 'isEnabled']
	        }
	    }]
	};

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(845);
	
	var _require = __webpack_require__(4),
	    cut = _require.cut;
	
	var _require2 = __webpack_require__(75),
	    onCreateOrder = _require2.onCreateOrder,
	    tryRaiseCreateOrderWithFilterMap = _require2.tryRaiseCreateOrderWithFilterMap;
	
	var _require3 = __webpack_require__(90),
	    raiseEvent = _require3.raiseEvent;
	
	var BUTTON_SELECTOR = cut(css.button);
	
	var MakeOrderButton = function () {
	    function MakeOrderButton() {
	        _classCallCheck(this, MakeOrderButton);
	
	        this.template = __webpack_require__(988);
	    }
	
	    MakeOrderButton.prototype.render = function render() {
	        var isBig = this.$context.props.isBig;
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({ isBig: isBig }, data, { css: css });
	        });
	    };
	
	    MakeOrderButton.prototype.bind = function bind() {
	        var _click;
	
	        return {
	            click: (_click = {}, _click[BUTTON_SELECTOR] = this.onCreateOrderClick, _click)
	        };
	    };
	
	    MakeOrderButton.prototype.onCreateOrderClick = function onCreateOrderClick() {
	        this.$context.signal(onCreateOrder);
	        var category = 'checkout';
	        if (this.$context.props.isUp) {
	            category = 'checkout_up';
	        }
	        this.$context.signal(raiseEvent, { category: category, action: 'click' });
	        this.$context.signal(tryRaiseCreateOrderWithFilterMap);
	    };
	
	    return MakeOrderButton;
	}();
	
	module.exports = {
	    constructor: MakeOrderButton
	};

/***/ }),
/* 215 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = {
	    convert: function convert(value) {
	        if (value instanceof Error) {
	            var error = {};
	
	            Object.getOwnPropertyNames(value).forEach(function (key) {
	                error[key] = value[key];
	            });
	
	            return error;
	        }
	
	        return value;
	    }
	};

/***/ }),
/* 216 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	    getOrderStateName: function getOrderStateName(stateId) {
	        switch (stateId) {
	            case 7:
	                return 'ПредЧерновик';
	            case 1000:
	                return 'Черновик';
	            case 1:
	                return 'Черновик';
	            case 2:
	                return 'На оформлении';
	            case 3:
	                return 'Ожидает оплату';
	            case 4:
	                return 'Ожидает документы';
	            case 5:
	                return 'Выполнен';
	            case 6:
	                return 'Архив';
	            case 1001:
	                return 'Черновик (Offline выборка)';
	            case 1002:
	                return 'Выполнен (Offline выборка)';
	            case 1003:
	                return 'Архив (Offline выборка)';
	            case 2001:
	                return 'Черновик (Offline адр. план)';
	            case 2002:
	                return 'Выполнен (Offline адр. план)';
	            case 2003:
	                return 'Архив (Offline адр. план)';
	            case 3001:
	                return 'Черновик (Индив. выборка)';
	            case 3002:
	                return 'Ожидает подтверждения (Индив. выборка)';
	            case 3003:
	                return 'Ожидает оплату (Индив. выборка)';
	            case 3004:
	                return 'Ожидает документы (Индив. выборка)';
	            case 3005:
	                return 'Выполнен (Индив. выборка)';
	            case 3006:
	                return 'Архив (Индив. выборка)';
	            default:
	                return null;
	        }
	    }
	};

/***/ }),
/* 217 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	    init: init,
	    setPercentage: setPercentage
	};
	
	function init(id, label) {
	    var progressBarElement = document.getElementById(id + '-progress-bar');
	    if (progressBarElement) {
	        document.getElementById(id + '-progress-name').innerHTML = label;
	        document.getElementById(id + '-progress-bar-inner').style.width = '0%';
	        document.getElementById(id + '-progress-percentage').innerHTML = '0%';
	        progressBarElement.style.visibility = 'visible';
	    }
	}
	
	function setPercentage(id, percentage) {
	    var progressBarInnerElement = document.getElementById(id + '-progress-bar-inner');
	    var progressBarPercentageElement = document.getElementById(id + '-progress-percentage');
	    if (progressBarInnerElement && progressBarPercentageElement) {
	        var percentString = Math.round(percentage).toString() + '%';
	        progressBarInnerElement.style.width = percentString;
	        progressBarPercentageElement.innerHTML = percentString;
	    }
	}

/***/ }),
/* 218 */
/***/ (function(module, exports) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ERROR_EVENT_NAME = 'Event name should be a string';
	var ERROR_EVENT_HANDLER = 'Event handler should be a function';
	
	var ModuleApiProviderBase = function () {
	  function ModuleApiProviderBase(locator) {
	    _classCallCheck(this, ModuleApiProviderBase);
	
	    this.locator = locator;
	
	    this.cookie = locator.resolve('cookieWrapper');
	
	    this._eventBus = locator.resolve('eventBus');
	  }
	
	  ModuleApiProviderBase.prototype.on = function on(eventName, handler) {
	    checkEventNameAndHandler(eventName, handler);
	    this._eventBus.on(eventName, handler);
	    return this;
	  };
	
	  ModuleApiProviderBase.prototype.once = function once(eventName, handler) {
	    checkEventNameAndHandler(eventName, handler);
	    this._eventBus.once(eventName, handler);
	    return this;
	  };
	
	  ModuleApiProviderBase.prototype.removeListener = function removeListener(eventName, handler) {
	    checkEventNameAndHandler(eventName, handler);
	    this._eventBus.removeListener(eventName, handler);
	    return this;
	  };
	
	  ModuleApiProviderBase.prototype.removeAllListeners = function removeAllListeners(eventName) {
	    checkEventNameAndHandler(eventName, noop);
	    this._eventBus.removeAllListeners(eventName);
	    return this;
	  };
	
	  return ModuleApiProviderBase;
	}();
	
	function checkEventNameAndHandler(eventName, handler) {
	  if (typeof eventName !== 'string') {
	    throw new Error(ERROR_EVENT_NAME);
	  }
	
	  if (typeof handler !== 'function') {
	    throw new Error(ERROR_EVENT_HANDLER);
	  }
	}
	
	function noop() {}
	
	module.exports = ModuleApiProviderBase;

/***/ }),
/* 219 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = {
	  defineReadOnly: function defineReadOnly(object, name, value) {
	    Object.defineProperty(object, name, {
	      enumerable: false,
	      configurable: false,
	      writable: false,
	      value: value
	    });
	  }
	};

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UserInfo = __webpack_require__(222);
	var percentEncodingHelper = __webpack_require__(115);
	
	var PORT_REGEXP = /^\d+$/;
	var ERROR_PORT = 'URI authority port must satisfy expression ' + PORT_REGEXP.toString();
	
	var Authority = function () {
		Authority.createUserInfo = function createUserInfo(string) {
			return new UserInfo(string);
		};
	
		Authority.prototype.createUserInfo = function createUserInfo(string) {
			return Authority.createUserInfo(string);
		};
	
		function Authority(authorityString) {
			_classCallCheck(this, Authority);
	
			this.userInfo = null;
	
			this.port = null;
	
			this.host = null;
	
			if (typeof authorityString === 'string' && authorityString.length > 0) {
				var firstAtIndex = authorityString.indexOf('@');
				if (firstAtIndex !== -1) {
					var userInfoString = authorityString.substring(0, firstAtIndex);
					this.userInfo = new UserInfo(userInfoString);
					authorityString = authorityString.substring(firstAtIndex + 1);
				}
	
				var lastColonIndex = authorityString.lastIndexOf(':');
				if (lastColonIndex !== -1) {
					var portString = authorityString.substring(lastColonIndex + 1);
					if (lastColonIndex === authorityString.length - 1) {
						this.port = '';
						authorityString = authorityString.substring(0, lastColonIndex);
					} else if (PORT_REGEXP.test(portString)) {
						this.port = portString;
						authorityString = authorityString.substring(0, lastColonIndex);
					}
				}
	
				this.host = percentEncodingHelper.decode(authorityString);
			}
		}
	
		Authority.prototype.clone = function clone() {
			var authority = new Authority();
			if (this.userInfo) {
				authority.userInfo = this.userInfo.clone();
			}
			if (typeof this.host === 'string') {
				authority.host = this.host;
			}
			if (typeof this.port === 'string') {
				authority.port = this.port;
			}
			return authority;
		};
	
		Authority.prototype.toString = function toString() {
			var result = '';
			if (this.userInfo instanceof UserInfo) {
				result += this.userInfo.toString() + '@';
			}
			if (this.host !== undefined && this.host !== null) {
				var host = String(this.host);
				result += percentEncodingHelper.encodeHost(host);
			}
			if (this.port !== undefined && this.port !== null) {
				var port = String(this.port);
				if (port.length > 0 && !PORT_REGEXP.test(port)) {
					throw new Error(ERROR_PORT);
				}
				result += ':' + port;
			}
			return result;
		};
	
		return Authority;
	}();
	
	module.exports = Authority;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var percentEncodingHelper = __webpack_require__(115);
	
	var Query = function () {
		function Query(queryString) {
			var _this = this;
	
			_classCallCheck(this, Query);
	
			this.values = null;
	
			if (typeof queryString === 'string') {
				this.values = {};
	
				queryString.split('&').forEach(function (pair) {
					var parts = pair.split('=');
					var key = percentEncodingHelper.decode(parts[0]);
					if (!key) {
						return;
					}
					if (key in _this.values && !(_this.values[key] instanceof Array)) {
						_this.values[key] = [_this.values[key]];
					}
	
					var value = typeof parts[1] === 'string' ? percentEncodingHelper.decode(parts[1]) : null;
	
					if (_this.values[key] instanceof Array) {
						_this.values[key].push(value);
					} else {
						_this.values[key] = value;
					}
				}, this);
			}
		}
	
		Query.prototype.clone = function clone() {
			var _this2 = this;
	
			var query = new Query();
			if (this.values) {
				query.values = {};
				Object.keys(this.values).forEach(function (key) {
					query.values[key] = _this2.values[key];
				}, this);
			}
			return query;
		};
	
		Query.prototype.toString = function toString() {
			var _this3 = this;
	
			if (!this.values) {
				return '';
			}
	
			var queryString = '';
			Object.keys(this.values).forEach(function (key) {
				var values = _this3.values[key] instanceof Array ? _this3.values[key] : [_this3.values[key]];
	
				values.forEach(function (value) {
					queryString += '&' + percentEncodingHelper.encodeQuerySubComponent(key);
					if (value === undefined || value === null) {
						return;
					}
					value = String(value);
					queryString += '=' + percentEncodingHelper.encodeQuerySubComponent(value);
				});
			}, this);
	
			return queryString.replace(/^&/, '');
		};
	
		return Query;
	}();
	
	module.exports = Query;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var percentEncodingHelper = __webpack_require__(115);
	
	var UserInfo = function () {
		function UserInfo(userInfoString) {
			_classCallCheck(this, UserInfo);
	
			this.user = null;
	
			this.password = null;
	
			if (typeof userInfoString === 'string' && userInfoString.length > 0) {
				var parts = userInfoString.split(':');
				if (typeof parts[0] === 'string') {
					this.user = percentEncodingHelper.decode(parts[0]);
				}
				if (typeof parts[1] === 'string') {
					this.password = percentEncodingHelper.decode(parts[1]);
				}
			}
		}
	
		UserInfo.prototype.clone = function clone() {
			var userInfo = new UserInfo();
			if (typeof this.user === 'string') {
				userInfo.user = this.user;
			}
			if (typeof this.password === 'string') {
				userInfo.password = this.password;
			}
			return userInfo;
		};
	
		UserInfo.prototype.toString = function toString() {
			var result = '';
			if (this.user !== undefined && this.user !== null) {
				var user = String(this.user);
				result += percentEncodingHelper.encodeUserInfoSubComponent(user);
			}
			if (this.password !== undefined && this.password !== null) {
				var password = String(this.password);
				result += ':' + percentEncodingHelper.encodeUserInfoSubComponent(password);
			}
	
			return result;
		};
	
		return UserInfo;
	}();
	
	module.exports = UserInfo;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _ = __webpack_require__(3);
	
	var BaseTracker = function () {
	  function BaseTracker() {
	    _classCallCheck(this, BaseTracker);
	
	    this._window = null;
	
	    this._initPromise = null;
	  }
	
	  BaseTracker.prototype.event = function event(data, args) {
	    var _this = this;
	
	    this._initPromise.then(function () {
	      return _this._event(data, args);
	    });
	  };
	
	  BaseTracker.prototype.pageview = function pageview() {
	    var _this2 = this;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    this._initPromise.then(function () {
	      return _this2._pageview.apply(_this2, args);
	    });
	  };
	
	  BaseTracker.prototype._domain = function _domain() {
	    return _.last(this._window.location.hostname.split('.'));
	  };
	
	  BaseTracker.prototype._domainConfig = function _domainConfig(config) {
	    return config[this._domain()] || config.ru;
	  };
	
	  return BaseTracker;
	}();
	
	module.exports = BaseTracker;

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	
	var _require = __webpack_require__(118),
	    initSelectedParamsFromOrderGroup = _require.initSelectedParamsFromOrderGroup,
	    saveSelectedParamsGroup = _require.saveSelectedParamsGroup;
	
	var orders = __webpack_require__(41);
	var currentOrder = __webpack_require__(23);
	var customOrder = __webpack_require__(42);
	
	var _require2 = __webpack_require__(30),
	    calcPriceGroup = _require2.calcPriceGroup;
	
	var content = __webpack_require__(20);
	
	var cities = __webpack_require__(99);
	var rubrics = __webpack_require__(114);
	var legalEntities = __webpack_require__(112);
	var purposes = __webpack_require__(113);
	var mapClasses = __webpack_require__(144);
	var currentOrderActions = __webpack_require__(23);
	
	var saveFilterValues = [content.setIsLoading(true)].concat(saveSelectedParamsGroup, [currentOrder.updateOrder(['price', 'paymentTypeId', 'necessaryDocuments']), content.setIsLoading(false), utils.set(currentOrderActions.PATHS.showPriceMustBeBiggerThanZero, false), utils.set(['account', 'orders', 'currentOrder', 'tooltips', 'hideDataChangedMustBeConfirmed'], true)]);
	
	var clearFilters = [cities.clearFilter, rubrics.clearFilter, legalEntities.clearFilter, purposes.clearFilter, mapClasses.clearFilter];
	
	module.exports = {
	    onEdit: [].concat(calcPriceGroup, [utils.set(currentOrderActions.PATHS.showPriceMustBeBiggerThanZero, false), utils.set(['account', 'orders', 'currentOrder', 'tooltips', 'hideDataChangedMustBeConfirmed'], true)]),
	    onCancel: [].concat(clearFilters, [content.setIsLoading(true)], initSelectedParamsFromOrderGroup, [content.setIsLoading(false), customOrder.unsetFilterValuesChanged]),
	    onSave: [].concat(clearFilters, [utils.unset(['order', 'originalParameters', 'statistic']), utils.set(currentOrderActions.PATHS.showPriceMustBeBiggerThanZero, false), [utils.isLocalEditMode, {
	        true: [orders.saveLocalChangesFilterValues, currentOrder.updateOrder(['price']), [utils.isConditionTrue(['account', 'orders', 'computed', 'price', 'data', 'total', 'totalPrice'], 250000, function (total, max) {
	            return total > max;
	        }), {
	            yes: [utils.set(['account', 'orders', 'currentOrder', 'localChanges', 'selectedPaymentTypeId'], 1)],
	            no: []
	        }]],
	        false: [].concat(saveFilterValues)
	    }], customOrder.unsetFilterValuesChanged]),
	    saveFilterValues: [].concat(saveFilterValues)
	};

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var userForm = __webpack_require__(68);
	var content = __webpack_require__(20);
	var utils = __webpack_require__(5);
	
	module.exports = {
	    onSaveUserInfoChange: [content.setIsLoading(true), [userForm.updateUserInfo, {
	        success: [userForm.initUserForm],
	        error: [utils.set(['account', 'userForm', 'isError'], true)]
	    }], content.setIsLoading(false)],
	
	    onCancelUserInfoChange: [userForm.resetUserForm],
	
	    selectUserType: [userForm.selectUserType(['account', 'userForm'])],
	    selectCountry: [utils.setArgByFunction('selectedValue', function (args) {
	        return Number(args['selectedValue']);
	    }), utils.setFromArgsToState('selectedValue', ['account', 'userForm', 'form', 'countryId']), [utils.isEqual(['account', 'userForm', 'computed', 'isUserTypeSelectEnabled'], false), {
	        yes: [utils.set(['account', 'userForm', 'form', 'userType'], 1), utils.unset(['registration', 'userTypeRadio']), utils.set(['account', 'userForm', 'userTypeRadio', 1], true)],
	        no: []
	    }]]
	};

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var accountUi = __webpack_require__(138);
	
	module.exports = {
	    scrollPageDatepicker: function scrollPageDatepicker(path) {
	        return [accountUi.scrollPageDatepicker(path)];
	    },
	    scrollPageDatepickerBase: function scrollPageDatepickerBase(path) {
	        return [accountUi.scrollPageDatepickerBase(path)];
	    },
	    setDate: function setDate(basePath) {
	        return [accountUi.setDate(basePath)];
	    },
	    unsetDate: function unsetDate(basePath) {
	        return [accountUi.unsetDate(basePath)];
	    },
	
	
	    togglePopup: [accountUi.togglePopup]
	};

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var branches = __webpack_require__(143);
	
	var _require = __webpack_require__(30),
	    calcPriceGroup = _require.calcPriceGroup;
	
	var analytics = __webpack_require__(7);
	var utils = __webpack_require__(5);
	
	module.exports = {
	    onItemCheck: [branches.changeValue].concat(calcPriceGroup),
	
	    onBranchCheck: [branches.changeBranchSelection].concat(calcPriceGroup),
	
	    onSetAll: [branches.setAll].concat(calcPriceGroup),
	
	    toggleCalcOnlyDefaultCities: [utils.toggleBool(['order', 'cities', 'calcOnlyDefaultCities'])].concat(calcPriceGroup)
	};

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var treeActions = __webpack_require__(111);
	var utils = __webpack_require__(5);
	
	module.exports = {
	    onSwitchSubTreeCollapse: [treeActions.switchSubTreeCollapse],
	    onSwitchSubTreeCollapseCustom: [treeActions.switchSubTreeCollapseCustom],
	    onFilter: [treeActions.setFilter],
	    initFilter: [treeActions.initFilter],
	    onShowSelectedOnly: [treeActions.setShowSelectedOnly],
	    onItemCheck: [treeActions.changeValue]
	};

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var rubrics = __webpack_require__(114);
	
	var _require = __webpack_require__(30),
	    calcPriceGroup = _require.calcPriceGroup;
	
	var analytics = __webpack_require__(7);
	var utils = __webpack_require__(5);
	
	module.exports = {
	    onItemCheck: [rubrics.changeValue, utils.setArg('category', 'checkbox_rubric'), [analytics.fillEventFromTreeChecked, {
	        filled: [analytics.raiseArgsValueEvent],
	        noEvent: []
	    }]].concat(calcPriceGroup),
	
	    onSetAll: [rubrics.setAll].concat(calcPriceGroup),
	
	    toggleFilterType: [[rubrics.isToggleFilterTypeOn, {
	        yes: [utils.setArg('category', 'tab_filter_rubrics_list'), utils.setArg('action', 'click'), analytics.raiseArgsValueEvent],
	        no: []
	    }], rubrics.toggleFilterType]
	};

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var authGroups = __webpack_require__(161);
	var utils = __webpack_require__(5);
	var cookie = __webpack_require__(27);
	var user = __webpack_require__(28);
	var analytics = __webpack_require__(7);
	
	module.exports = {
	    loginSuccess: [utils.set(['page', 'name'], 'alert'), utils.set(['auth', 'alert', 'type'], 'loginSuccess'), analytics.argsValueEvent({ category: 'post_successful_authorization', action: 'see' }), cookie.setSessionToken, user.addUserRole, utils.setFromArgsToState('extendedUser', 'user')].concat(authGroups.createOrderAfterLoginIfNeededOrRedirect)
	};

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var price = __webpack_require__(71);
	var utils = __webpack_require__(5);
	
	var _require = __webpack_require__(42),
	    setFilterValuesChanged = _require.setFilterValuesChanged;
	
	module.exports = {
	    calcPriceGroup: [setFilterValuesChanged, utils.unset(['order', 'price', 'isZero']), price.prepareToRequest, [price.calcPrice, {
	        requiredParametersNotFilled: [utils.set(['order', 'price', 'isError'], false), price.initPrice, price.setIsLoading(false)],
	        success: [price.setPriceIfRequestIdIsValid, utils.set(['order', 'price', 'isError'], false), [price.isZeroPrice, {
	            yes: [utils.set(['order', 'price', 'isZero'], true)],
	            no: []
	        }]],
	        error: [utils.set(['order', 'price', 'isError'], true)]
	    }], utils.set(['order', 'tooltip', 'hideDataChangeTooltip'], true)]
	};

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	var utilsSignals = __webpack_require__(11);
	var analytics = __webpack_require__(7);
	var content = __webpack_require__(20);
	var account = __webpack_require__(137);
	var orders = __webpack_require__(41);
	var ordersList = __webpack_require__(109);
	var computedOrdersList = __webpack_require__(141);
	var userGroup = __webpack_require__(45);
	var layoutGroup = __webpack_require__(36);
	var accountGroup = __webpack_require__(63);
	
	var _require = __webpack_require__(160),
	    raiseEventsOnOrderLoaded = _require.raiseEventsOnOrderLoaded;
	
	var seo = __webpack_require__(21);
	var user = __webpack_require__(28);
	var bitrix = __webpack_require__(70);
	
	var setDefaults = [utils.setPopupVisibility('ordersFilter', ['account', 'popups', 'ordersFilter', 'isOpen']), utils.set(['account', 'orders', 'ui', 'typeFilter', 'isDisabled'], false), ordersList.setPagingDefaultsIfNeeded, ordersList.setStateFormUrlClient];
	
	var setComputedForClient = [computedOrdersList.setOrdersFilters, computedOrdersList.setActiveOrdersFilter];
	
	var initPage = [utils.set('layout', 'main'), utils.setFromArgsToState('subPage', 'page.sub')].concat(layoutGroup.setMainLayoutBlocks, [seo.setDashboardMeta('Заказы - Библиотека данных', 'Мои заказы'), content.setComponentsByLink], setDefaults, [account.setComputedFields, orders.setComputedFields, ordersList.setComputedFields], setComputedForClient, [content.setIsLoading(true)]);
	
	module.exports = [analytics.parseUtmFromQuery, orders.validateOrderId].concat(userGroup.checkAuthCookie([].concat(userGroup.getUser)), [[user.isUnauthorized, {
	    yes: [[account.isShowLocalOrder, {
	        yes: [].concat(initPage, accountGroup.setLocalOrderData),
	        no: [utils.setArgToCookie('orderId', 10)].concat(utilsSignals.redirectLogin)
	    }]],
	    no: [].concat(userGroup.access('account', [].concat(initPage, accountGroup.updateOrderData, [content.setIsLoading(false), analytics.pageview], raiseEventsOnOrderLoaded)))
	}]]);

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	var footer = __webpack_require__(56);
	var auth = __webpack_require__(69);
	var analytics = __webpack_require__(7);
	var error = __webpack_require__(19);
	
	module.exports = [analytics.parseUtmFromQuery, utils.set('layout', 'auth'), auth.setComputedFields, analytics.pageview, footer.setCopyrightYear, error.passportError('page passport-error')];

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	var content = __webpack_require__(20);
	var account = __webpack_require__(137);
	var orders = __webpack_require__(41);
	var ordersList = __webpack_require__(109);
	var computedOrdersList = __webpack_require__(141);
	var userGroup = __webpack_require__(45);
	var layoutGroup = __webpack_require__(36);
	var analytics = __webpack_require__(7);
	
	var _require = __webpack_require__(63),
	    getManagersList = _require.getManagersList,
	    getUsersList = _require.getUsersList;
	
	var seo = __webpack_require__(21);
	var user = __webpack_require__(28);
	var utilsSignals = __webpack_require__(11);
	
	var setDefaults = [utils.setPopupVisibility('statusFilter', ['account', 'popups', 'statusFilter', 'isOpen']), utils.setPopupVisibility('userSelect', ['account', 'popups', 'userSelect', 'isOpen']), utils.setPopupVisibility('managerSelect', ['account', 'popups', 'managerSelect', 'isOpen']), utils.setPopupVisibility('createOrder', ['account', 'popups', 'createOrder', 'isOpen']), ordersList.setPagingDefaultsIfNeeded, utils.set(['account', 'orders', 'managers'], []), ordersList.setShouldRestoreFiltersFromLocalStorage, ordersList.setStateFormUrlManager, ordersList.setStatusFilterData, ordersList.setTypeFilterData, orders.initOrderCreatorSelect];
	
	var setComputedForManager = [computedOrdersList.setStatusSelect, computedOrdersList.setRadioFilter, computedOrdersList.computeIsRadioFilterActive];
	
	module.exports = [analytics.parseUtmFromQuery, content.setIsLoading(true)].concat(userGroup.checkAuthCookie([].concat(userGroup.getUser)), [[user.isUnauthorized, {
	    yes: [utils.setArgToCookie('orderId', 10)].concat(utilsSignals.redirectLogin),
	    no: [].concat(userGroup.access('manager', [utils.set('layout', 'main'), utils.setFromArgsToState('subPage', 'page.sub')].concat(layoutGroup.setMainLayoutBlocks, [seo.setDashboardMeta('Панель менеджера - Библиотека данных', 'Панель менеджера'), content.setComponentsByLink], setDefaults, [account.setComputedFields, orders.setComputedFields, ordersList.setComputedFields], setComputedForManager, getManagersList, getUsersList, [orders.initOrderType, analytics.pageview, content.setIsLoading(false)])))
	}]]);

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	var content = __webpack_require__(20);
	var account = __webpack_require__(137);
	var userGroup = __webpack_require__(45);
	var layoutGroup = __webpack_require__(36);
	var orders = __webpack_require__(41);
	var usersList = __webpack_require__(289);
	var userForm = __webpack_require__(68);
	var users = __webpack_require__(290);
	var analytics = __webpack_require__(7);
	var seo = __webpack_require__(21);
	var registration = __webpack_require__(97);
	var error = __webpack_require__(19);
	
	module.exports = [analytics.parseUtmFromQuery].concat(userGroup.checkAuthCookie([].concat(userGroup.getUser)), userGroup.access('manager', [utils.set('layout', 'main'), utils.setFromArgsToState('subPage', 'page.sub')].concat(layoutGroup.setMainLayoutBlocks, [[registration.getCountries, {
	    success: [utils.setFromArgsToState('countries', ['account', 'userForm', 'countries'])],
	    error: [error.internalError('manager.users.getCountries')]
	}], seo.setDashboardMeta('Панель менеджера - Библиотека данных', 'Панель менеджера'), content.setComponentsByLink, account.setComputedFields, usersList.setComputedFields, [orders.getUsers, {
	    success: [utils.setFromArgsToState('users', ['account', 'users', 'list', 'data']), userForm.setComputedFields],
	    error: []
	}], [usersList.isUserSelected, {
	    yes: [utils.set(['account', 'users', 'selectedUserIsLoading'], true), [users.getUser, {
	        success: [userForm.setDefaultCountry, userForm.initUserForm],
	        error: []
	    }], utils.set(['account', 'users', 'selectedUserIsLoading'], false)],
	    no: []
	}], analytics.pageview])));

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _emmett = _interopRequireDefault(__webpack_require__(191));
	
	var _monkey = __webpack_require__(119);
	
	var _type = _interopRequireDefault(__webpack_require__(91));
	
	var _helpers = __webpack_require__(103);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	/**
	 * Traversal helper function for dynamic cursors. Will throw a legible error
	 * if traversal is not possible.
	 *
	 * @param {string} method     - The method name, to create a correct error msg.
	 * @param {array}  solvedPath - The cursor's solved path.
	 */
	function checkPossibilityOfDynamicTraversal(method, solvedPath) {
	  if (!solvedPath) throw (0, _helpers.makeError)("Baobab.Cursor.".concat(method, ": ") + "cannot use ".concat(method, " on an unresolved dynamic path."), {
	    path: solvedPath
	  });
	}
	/**
	 * Cursor class
	 *
	 * @constructor
	 * @param {Baobab} tree   - The cursor's root.
	 * @param {array}  path   - The cursor's path in the tree.
	 * @param {string} hash   - The path's hash computed ahead by the tree.
	 */
	
	
	var Cursor =
	/*#__PURE__*/
	function (_Emitter) {
	  _inherits(Cursor, _Emitter);
	
	  function Cursor(tree, path, hash) {
	    var _this;
	
	    _classCallCheck(this, Cursor);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Cursor).call(this)); // If no path were to be provided, we fallback to an empty path (root)
	
	    path = path || []; // Privates
	
	    _this._identity = '[object Cursor]';
	    _this._archive = null; // Properties
	
	    _this.tree = tree;
	    _this.path = path;
	    _this.hash = hash; // State
	
	    _this.state = {
	      killed: false,
	      recording: false,
	      undoing: false
	    }; // Checking whether the given path is dynamic or not
	
	    _this._dynamicPath = _type["default"].dynamicPath(_this.path); // Checking whether the given path will meet a monkey
	
	    _this._monkeyPath = _type["default"].monkeyPath(_this.tree._monkeys, _this.path);
	    if (!_this._dynamicPath) _this.solvedPath = _this.path;else _this.solvedPath = (0, _helpers.getIn)(_this.tree._data, _this.path).solvedPath;
	    /**
	     * Listener bound to the tree's writes so that cursors with dynamic paths
	     * may update their solved path correctly.
	     *
	     * @param {object} event - The event fired by the tree.
	     */
	
	    _this._writeHandler = function (_ref) {
	      var data = _ref.data;
	      if (_this.state.killed || !(0, _helpers.solveUpdate)([data.path], _this._getComparedPaths())) return;
	      _this.solvedPath = (0, _helpers.getIn)(_this.tree._data, _this.path).solvedPath;
	    };
	    /**
	     * Function in charge of actually trigger the cursor's updates and
	     * deal with the archived records.
	     *
	     * @note: probably should wrap the current solvedPath in closure to avoid
	     * for tricky cases where it would fail.
	     *
	     * @param {mixed} previousData - the tree's previous data.
	     */
	
	
	    var fireUpdate = function fireUpdate(previousData) {
	      var self = _assertThisInitialized(_this);
	
	      var eventData = {
	        get previousData() {
	          return (0, _helpers.getIn)(previousData, self.solvedPath).data;
	        },
	
	        get currentData() {
	          return self.get();
	        }
	
	      };
	      if (_this.state.recording && !_this.state.undoing) _this.archive.add(eventData.previousData);
	      _this.state.undoing = false;
	      return _this.emit('update', eventData);
	    };
	    /**
	     * Listener bound to the tree's updates and determining whether the
	     * cursor is affected and should react accordingly.
	     *
	     * Note that this listener is lazily bound to the tree to be sure
	     * one wouldn't leak listeners when only creating cursors for convenience
	     * and not to listen to updates specifically.
	     *
	     * @param {object} event - The event fired by the tree.
	     */
	
	
	    _this._updateHandler = function (event) {
	      if (_this.state.killed) return;
	
	      var _event$data = event.data,
	          paths = _event$data.paths,
	          previousData = _event$data.previousData,
	          update = fireUpdate.bind(_assertThisInitialized(_this), previousData),
	          comparedPaths = _this._getComparedPaths();
	
	      if ((0, _helpers.solveUpdate)(paths, comparedPaths)) return update();
	    }; // Lazy binding
	
	
	    var bound = false;
	
	    _this._lazyBind = function () {
	      if (bound) return;
	      bound = true;
	      if (_this._dynamicPath) _this.tree.on('write', _this._writeHandler);
	      return _this.tree.on('update', _this._updateHandler);
	    }; // If the path is dynamic, we actually need to listen to the tree
	
	
	    if (_this._dynamicPath) {
	      _this._lazyBind();
	    } else {
	      // Overriding the emitter `on` and `once` methods
	      _this.on = (0, _helpers.before)(_this._lazyBind, _this.on.bind(_assertThisInitialized(_this)));
	      _this.once = (0, _helpers.before)(_this._lazyBind, _this.once.bind(_assertThisInitialized(_this)));
	    }
	
	    return _this;
	  }
	  /**
	   * Internal helpers
	   * -----------------
	   */
	
	  /**
	   * Method returning the paths of the tree watched over by the cursor and that
	   * should be taken into account when solving a potential update.
	   *
	   * @return {array} - Array of paths to compare with a given update.
	   */
	
	
	  _createClass(Cursor, [{
	    key: "_getComparedPaths",
	    value: function _getComparedPaths() {
	      // Checking whether we should keep track of some dependencies
	      var additionalPaths = this._monkeyPath ? (0, _helpers.getIn)(this.tree._monkeys, this._monkeyPath).data.relatedPaths() : [];
	      return [this.solvedPath].concat(additionalPaths);
	    }
	    /**
	     * Predicates
	     * -----------
	     */
	
	    /**
	     * Method returning whether the cursor is at root level.
	     *
	     * @return {boolean} - Is the cursor the root?
	     */
	
	  }, {
	    key: "isRoot",
	    value: function isRoot() {
	      return !this.path.length;
	    }
	    /**
	     * Method returning whether the cursor is at leaf level.
	     *
	     * @return {boolean} - Is the cursor a leaf?
	     */
	
	  }, {
	    key: "isLeaf",
	    value: function isLeaf() {
	      return _type["default"].primitive(this._get().data);
	    }
	    /**
	     * Method returning whether the cursor is at branch level.
	     *
	     * @return {boolean} - Is the cursor a branch?
	     */
	
	  }, {
	    key: "isBranch",
	    value: function isBranch() {
	      return !this.isRoot() && !this.isLeaf();
	    }
	    /**
	     * Traversal Methods
	     * ------------------
	     */
	
	    /**
	     * Method returning the root cursor.
	     *
	     * @return {Baobab} - The root cursor.
	     */
	
	  }, {
	    key: "root",
	    value: function root() {
	      return this.tree.select();
	    }
	    /**
	     * Method selecting a subpath as a new cursor.
	     *
	     * Arity (1):
	     * @param  {path} path    - The path to select.
	     *
	     * Arity (*):
	     * @param  {...step} path - The path to select.
	     *
	     * @return {Cursor}       - The created cursor.
	     */
	
	  }, {
	    key: "select",
	    value: function select(path) {
	      if (arguments.length > 1) path = (0, _helpers.arrayFrom)(arguments);
	      return this.tree.select(this.path.concat(path));
	    }
	    /**
	     * Method returning the parent node of the cursor or else `null` if the
	     * cursor is already at root level.
	     *
	     * @return {Baobab} - The parent cursor.
	     */
	
	  }, {
	    key: "up",
	    value: function up() {
	      if (!this.isRoot()) return this.tree.select(this.path.slice(0, -1));
	      return null;
	    }
	    /**
	     * Method returning the child node of the cursor.
	     *
	     * @return {Baobab} - The child cursor.
	     */
	
	  }, {
	    key: "down",
	    value: function down() {
	      checkPossibilityOfDynamicTraversal('down', this.solvedPath);
	      if (!(this._get().data instanceof Array)) throw Error('Baobab.Cursor.down: cannot go down on a non-list type.');
	      return this.tree.select(this.solvedPath.concat(0));
	    }
	    /**
	     * Method returning the left sibling node of the cursor if this one is
	     * pointing at a list. Returns `null` if this cursor is already leftmost.
	     *
	     * @return {Baobab} - The left sibling cursor.
	     */
	
	  }, {
	    key: "left",
	    value: function left() {
	      checkPossibilityOfDynamicTraversal('left', this.solvedPath);
	      var last = +this.solvedPath[this.solvedPath.length - 1];
	      if (isNaN(last)) throw Error('Baobab.Cursor.left: cannot go left on a non-list type.');
	      return last ? this.tree.select(this.solvedPath.slice(0, -1).concat(last - 1)) : null;
	    }
	    /**
	     * Method returning the right sibling node of the cursor if this one is
	     * pointing at a list. Returns `null` if this cursor is already rightmost.
	     *
	     * @return {Baobab} - The right sibling cursor.
	     */
	
	  }, {
	    key: "right",
	    value: function right() {
	      checkPossibilityOfDynamicTraversal('right', this.solvedPath);
	      var last = +this.solvedPath[this.solvedPath.length - 1];
	      if (isNaN(last)) throw Error('Baobab.Cursor.right: cannot go right on a non-list type.');
	      if (last + 1 === this.up()._get().data.length) return null;
	      return this.tree.select(this.solvedPath.slice(0, -1).concat(last + 1));
	    }
	    /**
	     * Method returning the leftmost sibling node of the cursor if this one is
	     * pointing at a list.
	     *
	     * @return {Baobab} - The leftmost sibling cursor.
	     */
	
	  }, {
	    key: "leftmost",
	    value: function leftmost() {
	      checkPossibilityOfDynamicTraversal('leftmost', this.solvedPath);
	      var last = +this.solvedPath[this.solvedPath.length - 1];
	      if (isNaN(last)) throw Error('Baobab.Cursor.leftmost: cannot go left on a non-list type.');
	      return this.tree.select(this.solvedPath.slice(0, -1).concat(0));
	    }
	    /**
	     * Method returning the rightmost sibling node of the cursor if this one is
	     * pointing at a list.
	     *
	     * @return {Baobab} - The rightmost sibling cursor.
	     */
	
	  }, {
	    key: "rightmost",
	    value: function rightmost() {
	      checkPossibilityOfDynamicTraversal('rightmost', this.solvedPath);
	      var last = +this.solvedPath[this.solvedPath.length - 1];
	      if (isNaN(last)) throw Error('Baobab.Cursor.rightmost: cannot go right on a non-list type.');
	
	      var list = this.up()._get().data;
	
	      return this.tree.select(this.solvedPath.slice(0, -1).concat(list.length - 1));
	    }
	    /**
	     * Method mapping the children nodes of the cursor.
	     *
	     * @param  {function} fn      - The function to map.
	     * @param  {object}   [scope] - An optional scope.
	     * @return {array}            - The resultant array.
	     */
	
	  }, {
	    key: "map",
	    value: function map(fn, scope) {
	      checkPossibilityOfDynamicTraversal('map', this.solvedPath);
	
	      var array = this._get().data,
	          l = arguments.length;
	
	      if (!_type["default"].array(array)) throw Error('baobab.Cursor.map: cannot map a non-list type.');
	      return array.map(function (item, i) {
	        return fn.call(l > 1 ? scope : this, this.select(i), i, array);
	      }, this);
	    }
	    /**
	     * Getter Methods
	     * ---------------
	     */
	
	    /**
	     * Internal get method. Basically contains the main body of the `get` method
	     * without the event emitting. This is sometimes needed not to fire useless
	     * events.
	     *
	     * @param  {path}   [path=[]]       - Path to get in the tree.
	     * @return {object} info            - The resultant information.
	     * @return {mixed}  info.data       - Data at path.
	     * @return {array}  info.solvedPath - The path solved when getting.
	     */
	
	  }, {
	    key: "_get",
	    value: function _get() {
	      var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      if (!_type["default"].path(path)) throw (0, _helpers.makeError)('Baobab.Cursor.getters: invalid path.', {
	        path: path
	      });
	      if (!this.solvedPath) return {
	        data: undefined,
	        solvedPath: null,
	        exists: false
	      };
	      return (0, _helpers.getIn)(this.tree._data, this.solvedPath.concat(path));
	    }
	    /**
	     * Method used to check whether a certain path exists in the tree starting
	     * from the current cursor.
	     *
	     * Arity (1):
	     * @param  {path}   path           - Path to check in the tree.
	     *
	     * Arity (2):
	     * @param {..step}  path           - Path to check in the tree.
	     *
	     * @return {boolean}               - Does the given path exists?
	     */
	
	  }, {
	    key: "exists",
	    value: function exists(path) {
	      path = (0, _helpers.coercePath)(path);
	      if (arguments.length > 1) path = (0, _helpers.arrayFrom)(arguments);
	      return this._get(path).exists;
	    }
	    /**
	     * Method used to get data from the tree. Will fire a `get` event from the
	     * tree so that the user may sometimes react upon it to fetch data, for
	     * instance.
	     *
	     * Arity (1):
	     * @param  {path}   path           - Path to get in the tree.
	     *
	     * Arity (2):
	     * @param  {..step} path           - Path to get in the tree.
	     *
	     * @return {mixed}                 - Data at path.
	     */
	
	  }, {
	    key: "get",
	    value: function get(path) {
	      path = (0, _helpers.coercePath)(path);
	      if (arguments.length > 1) path = (0, _helpers.arrayFrom)(arguments);
	
	      var _this$_get = this._get(path),
	          data = _this$_get.data,
	          solvedPath = _this$_get.solvedPath; // Emitting the event
	
	
	      this.tree.emit('get', {
	        data: data,
	        solvedPath: solvedPath,
	        path: this.path.concat(path)
	      });
	      return data;
	    }
	    /**
	     * Method used to shallow clone data from the tree.
	     *
	     * Arity (1):
	     * @param  {path}   path           - Path to get in the tree.
	     *
	     * Arity (2):
	     * @param  {..step} path           - Path to get in the tree.
	     *
	     * @return {mixed}                 - Cloned data at path.
	     */
	
	  }, {
	    key: "clone",
	    value: function clone() {
	      var data = this.get.apply(this, arguments);
	      return (0, _helpers.shallowClone)(data);
	    }
	    /**
	     * Method used to deep clone data from the tree.
	     *
	     * Arity (1):
	     * @param  {path}   path           - Path to get in the tree.
	     *
	     * Arity (2):
	     * @param  {..step} path           - Path to get in the tree.
	     *
	     * @return {mixed}                 - Cloned data at path.
	     */
	
	  }, {
	    key: "deepClone",
	    value: function deepClone() {
	      var data = this.get.apply(this, arguments);
	      return (0, _helpers.deepClone)(data);
	    }
	    /**
	     * Method used to return raw data from the tree, by carefully avoiding
	     * computed one.
	     *
	     * @todo: should be more performant as the cloning should happen as well as
	     * when dropping computed data.
	     *
	     * Arity (1):
	     * @param  {path}   path           - Path to serialize in the tree.
	     *
	     * Arity (2):
	     * @param  {..step} path           - Path to serialize in the tree.
	     *
	     * @return {mixed}                 - The retrieved raw data.
	     */
	
	  }, {
	    key: "serialize",
	    value: function serialize(path) {
	      path = (0, _helpers.coercePath)(path);
	      if (arguments.length > 1) path = (0, _helpers.arrayFrom)(arguments);
	      if (!_type["default"].path(path)) throw (0, _helpers.makeError)('Baobab.Cursor.getters: invalid path.', {
	        path: path
	      });
	      if (!this.solvedPath) return undefined;
	      var fullPath = this.solvedPath.concat(path);
	      var data = (0, _helpers.deepClone)((0, _helpers.getIn)(this.tree._data, fullPath).data),
	          monkeys = (0, _helpers.getIn)(this.tree._monkeys, fullPath).data;
	
	      var dropComputedData = function dropComputedData(d, m) {
	        if (!_type["default"].object(m) || !_type["default"].object(d)) return;
	
	        for (var k in m) {
	          if (m[k] instanceof _monkey.Monkey) delete d[k];else dropComputedData(d[k], m[k]);
	        }
	      };
	
	      dropComputedData(data, monkeys);
	      return data;
	    }
	    /**
	     * Method used to project some of the data at cursor onto a map or a list.
	     *
	     * @param  {object|array} projection - The projection's formal definition.
	     * @return {object|array}            - The resultant map/list.
	     */
	
	  }, {
	    key: "project",
	    value: function project(projection) {
	      if (_type["default"].object(projection)) {
	        var data = {};
	
	        for (var k in projection) {
	          data[k] = this.get(projection[k]);
	        }
	
	        return data;
	      } else if (_type["default"].array(projection)) {
	        var _data = [];
	
	        for (var i = 0, l = projection.length; i < l; i++) {
	          _data.push(this.get(projection[i]));
	        }
	
	        return _data;
	      }
	
	      throw (0, _helpers.makeError)('Baobab.Cursor.project: wrong projection.', {
	        projection: projection
	      });
	    }
	    /**
	     * History Methods
	     * ----------------
	     */
	
	    /**
	     * Methods starting to record the cursor's successive states.
	     *
	     * @param  {integer} [maxRecords] - Maximum records to keep in memory. Note
	     *                                  that if no number is provided, the cursor
	     *                                  will keep everything.
	     * @return {Cursor}               - The cursor instance for chaining purposes.
	     */
	
	  }, {
	    key: "startRecording",
	    value: function startRecording(maxRecords) {
	      maxRecords = maxRecords || Infinity;
	      if (maxRecords < 1) throw (0, _helpers.makeError)('Baobab.Cursor.startRecording: invalid max records.', {
	        value: maxRecords
	      });
	      this.state.recording = true;
	      if (this.archive) return this; // Lazy binding
	
	      this._lazyBind();
	
	      this.archive = new _helpers.Archive(maxRecords);
	      return this;
	    }
	    /**
	     * Methods stopping to record the cursor's successive states.
	     *
	     * @return {Cursor} - The cursor instance for chaining purposes.
	     */
	
	  }, {
	    key: "stopRecording",
	    value: function stopRecording() {
	      this.state.recording = false;
	      return this;
	    }
	    /**
	     * Methods undoing n steps of the cursor's recorded states.
	     *
	     * @param  {integer} [steps=1] - The number of steps to rollback.
	     * @return {Cursor}            - The cursor instance for chaining purposes.
	     */
	
	  }, {
	    key: "undo",
	    value: function undo() {
	      var steps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      if (!this.state.recording) throw new Error('Baobab.Cursor.undo: cursor is not recording.');
	      var record = this.archive.back(steps);
	      if (!record) throw Error('Baobab.Cursor.undo: cannot find a relevant record.');
	      this.state.undoing = true;
	      this.set(record);
	      return this;
	    }
	    /**
	     * Methods returning whether the cursor has a recorded history.
	     *
	     * @return {boolean} - `true` if the cursor has a recorded history?
	     */
	
	  }, {
	    key: "hasHistory",
	    value: function hasHistory() {
	      return !!(this.archive && this.archive.get().length);
	    }
	    /**
	     * Methods returning the cursor's history.
	     *
	     * @return {array} - The cursor's history.
	     */
	
	  }, {
	    key: "getHistory",
	    value: function getHistory() {
	      return this.archive ? this.archive.get() : [];
	    }
	    /**
	     * Methods clearing the cursor's history.
	     *
	     * @return {Cursor} - The cursor instance for chaining purposes.
	     */
	
	  }, {
	    key: "clearHistory",
	    value: function clearHistory() {
	      if (this.archive) this.archive.clear();
	      return this;
	    }
	    /**
	     * Releasing
	     * ----------
	     */
	
	    /**
	     * Methods releasing the cursor from memory.
	     */
	
	  }, {
	    key: "release",
	    value: function release() {
	      // Removing listeners on parent
	      if (this._dynamicPath) this.tree.off('write', this._writeHandler);
	      this.tree.off('update', this._updateHandler); // Unsubscribe from the parent
	
	      if (this.hash) delete this.tree._cursors[this.hash]; // Dereferencing
	
	      delete this.tree;
	      delete this.path;
	      delete this.solvedPath;
	      delete this.archive; // Killing emitter
	
	      this.kill();
	      this.state.killed = true;
	    }
	    /**
	     * Output
	     * -------
	     */
	
	    /**
	     * Overriding the `toJSON` method for convenient use with JSON.stringify.
	     *
	     * @return {mixed} - Data at cursor.
	     */
	
	  }, {
	    key: "toJSON",
	    value: function toJSON() {
	      return this.serialize();
	    }
	    /**
	     * Overriding the `toString` method for debugging purposes.
	     *
	     * @return {string} - The cursor's identity.
	     */
	
	  }, {
	    key: "toString",
	    value: function toString() {
	      return this._identity;
	    }
	  }]);
	
	  return Cursor;
	}(_emmett["default"]);
	/**
	 * Method used to allow iterating over cursors containing list-type data.
	 *
	 * e.g. for(let i of cursor) { ... }
	 *
	 * @returns {object} -  Each item sequentially.
	 */
	
	
	exports["default"] = Cursor;
	
	if (typeof Symbol === 'function' && typeof Symbol.iterator !== 'undefined') {
	  Cursor.prototype[Symbol.iterator] = function () {
	    var array = this._get().data;
	
	    if (!_type["default"].array(array)) throw Error('baobab.Cursor.@@iterate: cannot iterate a non-list type.');
	    var i = 0;
	    var cursor = this,
	        length = array.length;
	    return {
	      next: function next() {
	        if (i < length) {
	          return {
	            value: cursor.select(i++)
	          };
	        }
	
	        return {
	          done: true
	        };
	      }
	    };
	  };
	}
	/**
	 * Setter Methods
	 * ---------------
	 *
	 * Those methods are dynamically assigned to the class for DRY reasons.
	 */
	// Not using a Set so that ES5 consumers don't pay a bundle size price
	
	
	var INTRANSITIVE_SETTERS = {
	  unset: true,
	  pop: true,
	  shift: true
	};
	/**
	 * Function creating a setter method for the Cursor class.
	 *
	 * @param {string}   name          - the method's name.
	 * @param {function} [typeChecker] - a function checking that the given value is
	 *                                   valid for the given operation.
	 */
	
	function makeSetter(name, typeChecker) {
	  /**
	   * Binding a setter method to the Cursor class and having the following
	   * definition.
	   *
	   * Note: this is not really possible to make those setters variadic because
	   * it would create an impossible polymorphism with path.
	   *
	   * @todo: perform value validation elsewhere so that tree.update can
	   * beneficiate from it.
	   *
	   * Arity (1):
	   * @param  {mixed} value - New value to set at cursor's path.
	   *
	   * Arity (2):
	   * @param  {path}  path  - Subpath to update starting from cursor's.
	   * @param  {mixed} value - New value to set.
	   *
	   * @return {mixed}       - Data at path.
	   */
	  Cursor.prototype[name] = function (path, value) {
	    // We should warn the user if he applies to many arguments to the function
	    if (arguments.length > 2) throw (0, _helpers.makeError)("Baobab.Cursor.".concat(name, ": too many arguments.")); // Handling arities
	
	    if (arguments.length === 1 && !INTRANSITIVE_SETTERS[name]) {
	      value = path;
	      path = [];
	    } // Coerce path
	
	
	    path = (0, _helpers.coercePath)(path); // Checking the path's validity
	
	    if (!_type["default"].path(path)) throw (0, _helpers.makeError)("Baobab.Cursor.".concat(name, ": invalid path."), {
	      path: path
	    }); // Checking the value's validity
	
	    if (typeChecker && !typeChecker(value)) throw (0, _helpers.makeError)("Baobab.Cursor.".concat(name, ": invalid value."), {
	      path: path,
	      value: value
	    }); // Checking the solvability of the cursor's dynamic path
	
	    if (!this.solvedPath) throw (0, _helpers.makeError)("Baobab.Cursor.".concat(name, ": the dynamic path of the cursor cannot be solved."), {
	      path: this.path
	    });
	    var fullPath = this.solvedPath.concat(path); // Filing the update to the tree
	
	    return this.tree.update(fullPath, {
	      type: name,
	      value: value
	    });
	  };
	}
	/**
	 * Making the necessary setters.
	 */
	
	
	makeSetter('set');
	makeSetter('unset');
	makeSetter('apply', _type["default"]["function"]);
	makeSetter('push');
	makeSetter('concat', _type["default"].array);
	makeSetter('unshift');
	makeSetter('pop');
	makeSetter('shift');
	makeSetter('splice', _type["default"].splicer);
	makeSetter('merge', _type["default"].object);
	makeSetter('deepMerge', _type["default"].object);

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = update;
	
	var _type = _interopRequireDefault(__webpack_require__(91));
	
	var _helpers = __webpack_require__(103);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function err(operation, expectedTarget, path) {
	  return (0, _helpers.makeError)("Baobab.update: cannot apply the \"".concat(operation, "\" on ") + "a non ".concat(expectedTarget, " (path: /").concat(path.join('/'), ")."), {
	    path: path
	  });
	}
	/**
	 * Function aiming at applying a single update operation on the given tree's
	 * data.
	 *
	 * @param  {mixed}  data      - The tree's data.
	 * @param  {path}   path      - Path of the update.
	 * @param  {object} operation - The operation to apply.
	 * @param  {object} [opts]    - Optional options.
	 * @return {mixed}            - Both the new tree's data and the updated node.
	 */
	
	
	function update(data, path, operation) {
	  var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var operationType = operation.type,
	      value = operation.value,
	      _operation$options = operation.options,
	      operationOptions = _operation$options === void 0 ? {} : _operation$options; // Dummy root, so we can shift and alter the root
	
	  var dummy = {
	    root: data
	  },
	      dummyPath = ['root'].concat(_toConsumableArray(path)),
	      currentPath = []; // Walking the path
	
	  var p = dummy,
	      i,
	      l,
	      s;
	
	  for (i = 0, l = dummyPath.length; i < l; i++) {
	    // Current item's reference is therefore p[s]
	    // The reason why we don't create a variable here for convenience
	    // is because we actually need to mutate the reference.
	    s = dummyPath[i]; // Updating the path
	
	    if (i > 0) currentPath.push(s); // If we reached the end of the path, we apply the operation
	
	    if (i === l - 1) {
	      /**
	       * Set
	       */
	      if (operationType === 'set') {
	        // Purity check
	        if (opts.pure && p[s] === value) return {
	          node: p[s]
	        };
	
	        if (_type["default"].lazyGetter(p, s)) {
	          Object.defineProperty(p, s, {
	            value: value,
	            enumerable: true,
	            configurable: true
	          });
	        } else if (opts.persistent && !operationOptions.mutableLeaf) {
	          p[s] = (0, _helpers.shallowClone)(value);
	        } else {
	          p[s] = value;
	        }
	      }
	      /**
	       * Monkey
	       */
	      else if (operationType === 'monkey') {
	          Object.defineProperty(p, s, {
	            get: value,
	            enumerable: true,
	            configurable: true
	          });
	        }
	        /**
	         * Apply
	         */
	        else if (operationType === 'apply') {
	            var result = value(p[s]); // Purity check
	
	            if (opts.pure && p[s] === result) return {
	              node: p[s]
	            };
	
	            if (_type["default"].lazyGetter(p, s)) {
	              Object.defineProperty(p, s, {
	                value: result,
	                enumerable: true,
	                configurable: true
	              });
	            } else if (opts.persistent) {
	              p[s] = (0, _helpers.shallowClone)(result);
	            } else {
	              p[s] = result;
	            }
	          }
	          /**
	           * Push
	           */
	          else if (operationType === 'push') {
	              if (!_type["default"].array(p[s])) throw err('push', 'array', currentPath);
	              if (opts.persistent) p[s] = p[s].concat([value]);else p[s].push(value);
	            }
	            /**
	             * Unshift
	             */
	            else if (operationType === 'unshift') {
	                if (!_type["default"].array(p[s])) throw err('unshift', 'array', currentPath);
	                if (opts.persistent) p[s] = [value].concat(p[s]);else p[s].unshift(value);
	              }
	              /**
	               * Concat
	               */
	              else if (operationType === 'concat') {
	                  if (!_type["default"].array(p[s])) throw err('concat', 'array', currentPath);
	                  if (opts.persistent) p[s] = p[s].concat(value);else p[s].push.apply(p[s], value);
	                }
	                /**
	                 * Splice
	                 */
	                else if (operationType === 'splice') {
	                    if (!_type["default"].array(p[s])) throw err('splice', 'array', currentPath);
	                    if (opts.persistent) p[s] = _helpers.splice.apply(null, [p[s]].concat(value));else p[s].splice.apply(p[s], value);
	                  }
	                  /**
	                   * Pop
	                   */
	                  else if (operationType === 'pop') {
	                      if (!_type["default"].array(p[s])) throw err('pop', 'array', currentPath);
	                      if (opts.persistent) p[s] = (0, _helpers.splice)(p[s], -1, 1);else p[s].pop();
	                    }
	                    /**
	                     * Shift
	                     */
	                    else if (operationType === 'shift') {
	                        if (!_type["default"].array(p[s])) throw err('shift', 'array', currentPath);
	                        if (opts.persistent) p[s] = (0, _helpers.splice)(p[s], 0, 1);else p[s].shift();
	                      }
	                      /**
	                       * Unset
	                       */
	                      else if (operationType === 'unset') {
	                          if (_type["default"].object(p)) delete p[s];else if (_type["default"].array(p)) p.splice(s, 1);
	                        }
	                        /**
	                         * Merge
	                         */
	                        else if (operationType === 'merge') {
	                            if (!_type["default"].object(p[s])) throw err('merge', 'object', currentPath);
	                            if (opts.persistent) p[s] = (0, _helpers.shallowMerge)({}, p[s], value);else p[s] = (0, _helpers.shallowMerge)(p[s], value);
	                          }
	                          /**
	                           * Deep merge
	                           */
	                          else if (operationType === 'deepMerge') {
	                              if (!_type["default"].object(p[s])) throw err('deepMerge', 'object', currentPath);
	                              if (opts.persistent) p[s] = (0, _helpers.deepMerge)({}, p[s], value);else p[s] = (0, _helpers.deepMerge)(p[s], value);
	                            } // Deep freezing the resulting value
	
	
	      if (opts.immutable && !operationOptions.mutableLeaf) (0, _helpers.deepFreeze)(p);
	      break;
	    } // If we reached a leaf, we override by setting an empty object
	    else if (_type["default"].primitive(p[s])) {
	        p[s] = {};
	      } // Else, we shift the reference and continue the path
	      else if (opts.persistent) {
	          p[s] = (0, _helpers.shallowClone)(p[s]);
	        } // Should we freeze the current step before continuing?
	
	
	    if (opts.immutable && l > 0) (0, _helpers.freeze)(p);
	    p = p[s];
	  } // If we are updating a dynamic node, we need not return the affected node
	
	
	  if (_type["default"].lazyGetter(p, s)) return {
	    data: dummy.root
	  }; // Returning new data object
	
	  return {
	    data: dummy.root,
	    node: p[s]
	  };
	}

/***/ }),
/* 238 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./functionApply')} */
	module.exports = Function.prototype.apply;


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(135);
	var $TypeError = __webpack_require__(96);
	
	var $call = __webpack_require__(163);
	var $actualApply = __webpack_require__(533);
	
	/** @type {import('.')} */
	module.exports = function callBindBasic(args) {
		if (args.length < 1 || typeof args[0] !== 'function') {
			throw new $TypeError('a function is required');
		}
		return $actualApply(bind, $call, args);
	};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(193);
	
	var callBindBasic = __webpack_require__(239);
	
	/** @type {(thisArg: string, searchString: string, position?: number) => number} */
	var $indexOf = callBindBasic([GetIntrinsic('%String.prototype.indexOf%')]);
	
	/** @type {import('.')} */
	module.exports = function callBoundIntrinsic(name, allowMissing) {
		// eslint-disable-next-line no-extra-parens
		var intrinsic = /** @type {Parameters<typeof callBindBasic>[0][0]} */ (GetIntrinsic(name, !!allowMissing));
		if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
			return callBindBasic([intrinsic]);
		}
		return intrinsic;
	};


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(46);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(18);
	var toAbsoluteIndex = __webpack_require__(84);
	var toLength = __webpack_require__(14);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(77);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(25);
	var toObject = __webpack_require__(18);
	var IObject = __webpack_require__(105);
	var toLength = __webpack_require__(14);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(25);
	var isObject = __webpack_require__(10);
	var invoke = __webpack_require__(251);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(17).f;
	var create = __webpack_require__(78);
	var redefineAll = __webpack_require__(82);
	var ctx = __webpack_require__(48);
	var anInstance = __webpack_require__(76);
	var forOf = __webpack_require__(77);
	var $iterDefine = __webpack_require__(175);
	var step = __webpack_require__(254);
	var setSpecies = __webpack_require__(83);
	var DESCRIPTORS = __webpack_require__(16);
	var fastKey = __webpack_require__(67).fastKey;
	var validate = __webpack_require__(86);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(92);
	var from = __webpack_require__(243);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(82);
	var getWeak = __webpack_require__(67).getWeak;
	var anObject = __webpack_require__(6);
	var isObject = __webpack_require__(10);
	var anInstance = __webpack_require__(76);
	var forOf = __webpack_require__(77);
	var createArrayMethod = __webpack_require__(51);
	var $has = __webpack_require__(37);
	var validate = __webpack_require__(86);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(123);
	var isObject = __webpack_require__(10);
	var toLength = __webpack_require__(14);
	var ctx = __webpack_require__(48);
	var IS_CONCAT_SPREADABLE = __webpack_require__(13)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(16) && !__webpack_require__(9)(function () {
	  return Object.defineProperty(__webpack_require__(168)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 251 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(10);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(6);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 254 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(177);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ }),
/* 256 */
/***/ (function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ }),
/* 257 */
/***/ (function(module, exports) {

	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (
	    arguments.length === 0
	      // eslint-disable-next-line no-self-compare
	      || x != x
	      // eslint-disable-next-line no-self-compare
	      || inLow != inLow
	      // eslint-disable-next-line no-self-compare
	      || inHigh != inHigh
	      // eslint-disable-next-line no-self-compare
	      || outLow != outLow
	      // eslint-disable-next-line no-self-compare
	      || outHigh != outHigh
	  ) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(16);
	var getKeys = __webpack_require__(80);
	var gOPS = __webpack_require__(127);
	var pIE = __webpack_require__(106);
	var toObject = __webpack_require__(18);
	var IObject = __webpack_require__(105);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(9)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(17);
	var anObject = __webpack_require__(6);
	var getKeys = __webpack_require__(80);
	
	module.exports = __webpack_require__(16) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(40);
	var gOPN = __webpack_require__(79).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(37);
	var toIObject = __webpack_require__(40);
	var arrayIndexOf = __webpack_require__(120)(false);
	var IE_PROTO = __webpack_require__(182)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	var DESCRIPTORS = __webpack_require__(16);
	var getKeys = __webpack_require__(80);
	var toIObject = __webpack_require__(40);
	var isEnum = __webpack_require__(106).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || isEnum.call(O, key)) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(79);
	var gOPS = __webpack_require__(127);
	var anObject = __webpack_require__(6);
	var Reflect = __webpack_require__(8).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(8).parseFloat;
	var $trim = __webpack_require__(95).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(185) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(8).parseInt;
	var $trim = __webpack_require__(95).trim;
	var ws = __webpack_require__(185);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ }),
/* 266 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(6);
	var isObject = __webpack_require__(10);
	var newPromiseCapability = __webpack_require__(179);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 268 */
/***/ (function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(14);
	var repeat = __webpack_require__(184);
	var defined = __webpack_require__(52);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(50);
	var toLength = __webpack_require__(14);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(13);


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(246);
	var validate = __webpack_require__(86);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(121)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var regexpExec = __webpack_require__(180);
	__webpack_require__(2)({
	  target: 'RegExp',
	  proto: true,
	  forced: regexpExec !== /./.exec
	}, {
	  exec: regexpExec
	});


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(16) && /./g.flags != 'g') __webpack_require__(17).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(104)
	});


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(246);
	var validate = __webpack_require__(86);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(121)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(8);
	var each = __webpack_require__(51)(0);
	var redefine = __webpack_require__(32);
	var meta = __webpack_require__(67);
	var assign = __webpack_require__(258);
	var weak = __webpack_require__(248);
	var isObject = __webpack_require__(10);
	var validate = __webpack_require__(86);
	var NATIVE_WEAK_MAP = __webpack_require__(86);
	var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(121)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (NATIVE_WEAK_MAP && IS_IE11) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/** @type {import('.')} */
	var $gOPD = __webpack_require__(877);
	
	if ($gOPD) {
		try {
			$gOPD([], 'length');
		} catch (e) {
			// IE 8 has a broken gOPD
			$gOPD = null;
		}
	}
	
	module.exports = $gOPD;


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.HandlebarsEnvironment = HandlebarsEnvironment;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _utils = __webpack_require__(55);
	
	var _exception = __webpack_require__(87);
	
	var _exception2 = _interopRequireDefault(_exception);
	
	var _helpers = __webpack_require__(279);
	
	var _decorators = __webpack_require__(1022);
	
	var _logger = __webpack_require__(281);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _internalProtoAccess = __webpack_require__(280);
	
	var VERSION = '4.7.8';
	exports.VERSION = VERSION;
	var COMPILER_REVISION = 8;
	exports.COMPILER_REVISION = COMPILER_REVISION;
	var LAST_COMPATIBLE_COMPILER_REVISION = 7;
	
	exports.LAST_COMPATIBLE_COMPILER_REVISION = LAST_COMPATIBLE_COMPILER_REVISION;
	var REVISION_CHANGES = {
	  1: '<= 1.0.rc.2', // 1.0.rc.2 is actually rev2 but doesn't report it
	  2: '== 1.0.0-rc.3',
	  3: '== 1.0.0-rc.4',
	  4: '== 1.x.x',
	  5: '== 2.0.0-alpha.x',
	  6: '>= 2.0.0-beta.1',
	  7: '>= 4.0.0 <4.3.0',
	  8: '>= 4.3.0'
	};
	
	exports.REVISION_CHANGES = REVISION_CHANGES;
	var objectType = '[object Object]';
	
	function HandlebarsEnvironment(helpers, partials, decorators) {
	  this.helpers = helpers || {};
	  this.partials = partials || {};
	  this.decorators = decorators || {};
	
	  _helpers.registerDefaultHelpers(this);
	  _decorators.registerDefaultDecorators(this);
	}
	
	HandlebarsEnvironment.prototype = {
	  constructor: HandlebarsEnvironment,
	
	  logger: _logger2['default'],
	  log: _logger2['default'].log,
	
	  registerHelper: function registerHelper(name, fn) {
	    if (_utils.toString.call(name) === objectType) {
	      if (fn) {
	        throw new _exception2['default']('Arg not supported with multiple helpers');
	      }
	      _utils.extend(this.helpers, name);
	    } else {
	      this.helpers[name] = fn;
	    }
	  },
	  unregisterHelper: function unregisterHelper(name) {
	    delete this.helpers[name];
	  },
	
	  registerPartial: function registerPartial(name, partial) {
	    if (_utils.toString.call(name) === objectType) {
	      _utils.extend(this.partials, name);
	    } else {
	      if (typeof partial === 'undefined') {
	        throw new _exception2['default']('Attempting to register a partial called "' + name + '" as undefined');
	      }
	      this.partials[name] = partial;
	    }
	  },
	  unregisterPartial: function unregisterPartial(name) {
	    delete this.partials[name];
	  },
	
	  registerDecorator: function registerDecorator(name, fn) {
	    if (_utils.toString.call(name) === objectType) {
	      if (fn) {
	        throw new _exception2['default']('Arg not supported with multiple decorators');
	      }
	      _utils.extend(this.decorators, name);
	    } else {
	      this.decorators[name] = fn;
	    }
	  },
	  unregisterDecorator: function unregisterDecorator(name) {
	    delete this.decorators[name];
	  },
	  /**
	   * Reset the memory of illegal property accesses that have already been logged.
	   * @deprecated should only be used in handlebars test-cases
	   */
	  resetLoggedPropertyAccesses: function resetLoggedPropertyAccesses() {
	    _internalProtoAccess.resetLoggedProperties();
	  }
	};
	
	var log = _logger2['default'].log;
	
	exports.log = log;
	exports.createFrame = _utils.createFrame;
	exports.logger = _logger2['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.registerDefaultHelpers = registerDefaultHelpers;
	exports.moveHelperToHooks = moveHelperToHooks;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _helpersBlockHelperMissing = __webpack_require__(1024);
	
	var _helpersBlockHelperMissing2 = _interopRequireDefault(_helpersBlockHelperMissing);
	
	var _helpersEach = __webpack_require__(1025);
	
	var _helpersEach2 = _interopRequireDefault(_helpersEach);
	
	var _helpersHelperMissing = __webpack_require__(1026);
	
	var _helpersHelperMissing2 = _interopRequireDefault(_helpersHelperMissing);
	
	var _helpersIf = __webpack_require__(1027);
	
	var _helpersIf2 = _interopRequireDefault(_helpersIf);
	
	var _helpersLog = __webpack_require__(1028);
	
	var _helpersLog2 = _interopRequireDefault(_helpersLog);
	
	var _helpersLookup = __webpack_require__(1029);
	
	var _helpersLookup2 = _interopRequireDefault(_helpersLookup);
	
	var _helpersWith = __webpack_require__(1030);
	
	var _helpersWith2 = _interopRequireDefault(_helpersWith);
	
	function registerDefaultHelpers(instance) {
	  _helpersBlockHelperMissing2['default'](instance);
	  _helpersEach2['default'](instance);
	  _helpersHelperMissing2['default'](instance);
	  _helpersIf2['default'](instance);
	  _helpersLog2['default'](instance);
	  _helpersLookup2['default'](instance);
	  _helpersWith2['default'](instance);
	}
	
	function moveHelperToHooks(instance, helperName, keepHelper) {
	  if (instance.helpers[helperName]) {
	    instance.hooks[helperName] = instance.helpers[helperName];
	    if (!keepHelper) {
	      delete instance.helpers[helperName];
	    }
	  }
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createProtoAccessControl = createProtoAccessControl;
	exports.resultIsAllowed = resultIsAllowed;
	exports.resetLoggedProperties = resetLoggedProperties;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _createNewLookupObject = __webpack_require__(1031);
	
	var _logger = __webpack_require__(281);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var loggedProperties = Object.create(null);
	
	function createProtoAccessControl(runtimeOptions) {
	  var defaultMethodWhiteList = Object.create(null);
	  defaultMethodWhiteList['constructor'] = false;
	  defaultMethodWhiteList['__defineGetter__'] = false;
	  defaultMethodWhiteList['__defineSetter__'] = false;
	  defaultMethodWhiteList['__lookupGetter__'] = false;
	
	  var defaultPropertyWhiteList = Object.create(null);
	  // eslint-disable-next-line no-proto
	  defaultPropertyWhiteList['__proto__'] = false;
	
	  return {
	    properties: {
	      whitelist: _createNewLookupObject.createNewLookupObject(defaultPropertyWhiteList, runtimeOptions.allowedProtoProperties),
	      defaultValue: runtimeOptions.allowProtoPropertiesByDefault
	    },
	    methods: {
	      whitelist: _createNewLookupObject.createNewLookupObject(defaultMethodWhiteList, runtimeOptions.allowedProtoMethods),
	      defaultValue: runtimeOptions.allowProtoMethodsByDefault
	    }
	  };
	}
	
	function resultIsAllowed(result, protoAccessControl, propertyName) {
	  if (typeof result === 'function') {
	    return checkWhiteList(protoAccessControl.methods, propertyName);
	  } else {
	    return checkWhiteList(protoAccessControl.properties, propertyName);
	  }
	}
	
	function checkWhiteList(protoAccessControlForType, propertyName) {
	  if (protoAccessControlForType.whitelist[propertyName] !== undefined) {
	    return protoAccessControlForType.whitelist[propertyName] === true;
	  }
	  if (protoAccessControlForType.defaultValue !== undefined) {
	    return protoAccessControlForType.defaultValue;
	  }
	  logUnexpecedPropertyAccessOnce(propertyName);
	  return false;
	}
	
	function logUnexpecedPropertyAccessOnce(propertyName) {
	  if (loggedProperties[propertyName] !== true) {
	    loggedProperties[propertyName] = true;
	    _logger2['default'].log('error', 'Handlebars: Access has been denied to resolve the property "' + propertyName + '" because it is not an "own property" of its parent.\n' + 'You can add a runtime option to disable the check or this warning:\n' + 'See https://handlebarsjs.com/api-reference/runtime-options.html#options-to-control-prototype-access for details');
	  }
	}
	
	function resetLoggedProperties() {
	  Object.keys(loggedProperties).forEach(function (propertyName) {
	    delete loggedProperties[propertyName];
	  });
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2ludGVybmFsL3Byb3RvLWFjY2Vzcy5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7O3FDQUFzQyw0QkFBNEI7O3NCQUMvQyxXQUFXOzs7O0FBRTlCLElBQU0sZ0JBQWdCLEdBQUcsTUFBTSxDQUFDLE1BQU0sQ0FBQyxJQUFJLENBQUMsQ0FBQzs7QUFFdEMsU0FBUyx3QkFBd0IsQ0FBQyxjQUFjLEVBQUU7QUFDdkQsTUFBSSxzQkFBc0IsR0FBRyxNQUFNLENBQUMsTUFBTSxDQUFDLElBQUksQ0FBQyxDQUFDO0FBQ2pELHdCQUFzQixDQUFDLGFBQWEsQ0FBQyxHQUFHLEtBQUssQ0FBQztBQUM5Qyx3QkFBc0IsQ0FBQyxrQkFBa0IsQ0FBQyxHQUFHLEtBQUssQ0FBQztBQUNuRCx3QkFBc0IsQ0FBQyxrQkFBa0IsQ0FBQyxHQUFHLEtBQUssQ0FBQztBQUNuRCx3QkFBc0IsQ0FBQyxrQkFBa0IsQ0FBQyxHQUFHLEtBQUssQ0FBQzs7QUFFbkQsTUFBSSx3QkFBd0IsR0FBRyxNQUFNLENBQUMsTUFBTSxDQUFDLElBQUksQ0FBQyxDQUFDOztBQUVuRCwwQkFBd0IsQ0FBQyxXQUFXLENBQUMsR0FBRyxLQUFLLENBQUM7O0FBRTlDLFNBQU87QUFDTCxjQUFVLEVBQUU7QUFDVixlQUFTLEVBQUUsNkNBQ1Qsd0JBQXdCLEVBQ3hCLGNBQWMsQ0FBQyxzQkFBc0IsQ0FDdEM7QUFDRCxrQkFBWSxFQUFFLGNBQWMsQ0FBQyw2QkFBNkI7S0FDM0Q7QUFDRCxXQUFPLEVBQUU7QUFDUCxlQUFTLEVBQUUsNkNBQ1Qsc0JBQXNCLEVBQ3RCLGNBQWMsQ0FBQyxtQkFBbUIsQ0FDbkM7QUFDRCxrQkFBWSxFQUFFLGNBQWMsQ0FBQywwQkFBMEI7S0FDeEQ7R0FDRixDQUFDO0NBQ0g7O0FBRU0sU0FBUyxlQUFlLENBQUMsTUFBTSxFQUFFLGtCQUFrQixFQUFFLFlBQVksRUFBRTtBQUN4RSxNQUFJLE9BQU8sTUFBTSxLQUFLLFVBQVUsRUFBRTtBQUNoQyxXQUFPLGNBQWMsQ0FBQyxrQkFBa0IsQ0FBQyxPQUFPLEVBQUUsWUFBWSxDQUFDLENBQUM7R0FDakUsTUFBTTtBQUNMLFdBQU8sY0FBYyxDQUFDLGtCQUFrQixDQUFDLFVBQVUsRUFBRSxZQUFZLENBQUMsQ0FBQztHQUNwRTtDQUNGOztBQUVELFNBQVMsY0FBYyxDQUFDLHlCQUF5QixFQUFFLFlBQVksRUFBRTtBQUMvRCxNQUFJLHlCQUF5QixDQUFDLFNBQVMsQ0FBQyxZQUFZLENBQUMsS0FBSyxTQUFTLEVBQUU7QUFDbkUsV0FBTyx5QkFBeUIsQ0FBQyxTQUFTLENBQUMsWUFBWSxDQUFDLEtBQUssSUFBSSxDQUFDO0dBQ25FO0FBQ0QsTUFBSSx5QkFBeUIsQ0FBQyxZQUFZLEtBQUssU0FBUyxFQUFFO0FBQ3hELFdBQU8seUJBQXlCLENBQUMsWUFBWSxDQUFDO0dBQy9DO0FBQ0QsZ0NBQThCLENBQUMsWUFBWSxDQUFDLENBQUM7QUFDN0MsU0FBTyxLQUFLLENBQUM7Q0FDZDs7QUFFRCxTQUFTLDhCQUE4QixDQUFDLFlBQVksRUFBRTtBQUNwRCxNQUFJLGdCQUFnQixDQUFDLFlBQVksQ0FBQyxLQUFLLElBQUksRUFBRTtBQUMzQyxvQkFBZ0IsQ0FBQyxZQUFZLENBQUMsR0FBRyxJQUFJLENBQUM7QUFDdEMsd0JBQU8sR0FBRyxDQUNSLE9BQU8sRUFDUCxpRUFBK0QsWUFBWSxvSUFDSCxvSEFDMkMsQ0FDcEgsQ0FBQztHQUNIO0NBQ0Y7O0FBRU0sU0FBUyxxQkFBcUIsR0FBRztBQUN0QyxRQUFNLENBQUMsSUFBSSxDQUFDLGdCQUFnQixDQUFDLENBQUMsT0FBTyxDQUFDLFVBQUEsWUFBWSxFQUFJO0FBQ3BELFdBQU8sZ0JBQWdCLENBQUMsWUFBWSxDQUFDLENBQUM7R0FDdkMsQ0FBQyxDQUFDO0NBQ0oiLCJmaWxlIjoicHJvdG8tYWNjZXNzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3JlYXRlTmV3TG9va3VwT2JqZWN0IH0gZnJvbSAnLi9jcmVhdGUtbmV3LWxvb2t1cC1vYmplY3QnO1xuaW1wb3J0IGxvZ2dlciBmcm9tICcuLi9sb2dnZXInO1xuXG5jb25zdCBsb2dnZWRQcm9wZXJ0aWVzID0gT2JqZWN0LmNyZWF0ZShudWxsKTtcblxuZXhwb3J0IGZ1bmN0aW9uIGNyZWF0ZVByb3RvQWNjZXNzQ29udHJvbChydW50aW1lT3B0aW9ucykge1xuICBsZXQgZGVmYXVsdE1ldGhvZFdoaXRlTGlzdCA9IE9iamVjdC5jcmVhdGUobnVsbCk7XG4gIGRlZmF1bHRNZXRob2RXaGl0ZUxpc3RbJ2NvbnN0cnVjdG9yJ10gPSBmYWxzZTtcbiAgZGVmYXVsdE1ldGhvZFdoaXRlTGlzdFsnX19kZWZpbmVHZXR0ZXJfXyddID0gZmFsc2U7XG4gIGRlZmF1bHRNZXRob2RXaGl0ZUxpc3RbJ19fZGVmaW5lU2V0dGVyX18nXSA9IGZhbHNlO1xuICBkZWZhdWx0TWV0aG9kV2hpdGVMaXN0WydfX2xvb2t1cEdldHRlcl9fJ10gPSBmYWxzZTtcblxuICBsZXQgZGVmYXVsdFByb3BlcnR5V2hpdGVMaXN0ID0gT2JqZWN0LmNyZWF0ZShudWxsKTtcbiAgLy8gZXNsaW50LWRpc2FibGUtbmV4dC1saW5lIG5vLXByb3RvXG4gIGRlZmF1bHRQcm9wZXJ0eVdoaXRlTGlzdFsnX19wcm90b19fJ10gPSBmYWxzZTtcblxuICByZXR1cm4ge1xuICAgIHByb3BlcnRpZXM6IHtcbiAgICAgIHdoaXRlbGlzdDogY3JlYXRlTmV3TG9va3VwT2JqZWN0KFxuICAgICAgICBkZWZhdWx0UHJvcGVydHlXaGl0ZUxpc3QsXG4gICAgICAgIHJ1bnRpbWVPcHRpb25zLmFsbG93ZWRQcm90b1Byb3BlcnRpZXNcbiAgICAgICksXG4gICAgICBkZWZhdWx0VmFsdWU6IHJ1bnRpbWVPcHRpb25zLmFsbG93UHJvdG9Qcm9wZXJ0aWVzQnlEZWZhdWx0XG4gICAgfSxcbiAgICBtZXRob2RzOiB7XG4gICAgICB3aGl0ZWxpc3Q6IGNyZWF0ZU5ld0xvb2t1cE9iamVjdChcbiAgICAgICAgZGVmYXVsdE1ldGhvZFdoaXRlTGlzdCxcbiAgICAgICAgcnVudGltZU9wdGlvbnMuYWxsb3dlZFByb3RvTWV0aG9kc1xuICAgICAgKSxcbiAgICAgIGRlZmF1bHRWYWx1ZTogcnVudGltZU9wdGlvbnMuYWxsb3dQcm90b01ldGhvZHNCeURlZmF1bHRcbiAgICB9XG4gIH07XG59XG5cbmV4cG9ydCBmdW5jdGlvbiByZXN1bHRJc0FsbG93ZWQocmVzdWx0LCBwcm90b0FjY2Vzc0NvbnRyb2wsIHByb3BlcnR5TmFtZSkge1xuICBpZiAodHlwZW9mIHJlc3VsdCA9PT0gJ2Z1bmN0aW9uJykge1xuICAgIHJldHVybiBjaGVja1doaXRlTGlzdChwcm90b0FjY2Vzc0NvbnRyb2wubWV0aG9kcywgcHJvcGVydHlOYW1lKTtcbiAgfSBlbHNlIHtcbiAgICByZXR1cm4gY2hlY2tXaGl0ZUxpc3QocHJvdG9BY2Nlc3NDb250cm9sLnByb3BlcnRpZXMsIHByb3BlcnR5TmFtZSk7XG4gIH1cbn1cblxuZnVuY3Rpb24gY2hlY2tXaGl0ZUxpc3QocHJvdG9BY2Nlc3NDb250cm9sRm9yVHlwZSwgcHJvcGVydHlOYW1lKSB7XG4gIGlmIChwcm90b0FjY2Vzc0NvbnRyb2xGb3JUeXBlLndoaXRlbGlzdFtwcm9wZXJ0eU5hbWVdICE9PSB1bmRlZmluZWQpIHtcbiAgICByZXR1cm4gcHJvdG9BY2Nlc3NDb250cm9sRm9yVHlwZS53aGl0ZWxpc3RbcHJvcGVydHlOYW1lXSA9PT0gdHJ1ZTtcbiAgfVxuICBpZiAocHJvdG9BY2Nlc3NDb250cm9sRm9yVHlwZS5kZWZhdWx0VmFsdWUgIT09IHVuZGVmaW5lZCkge1xuICAgIHJldHVybiBwcm90b0FjY2Vzc0NvbnRyb2xGb3JUeXBlLmRlZmF1bHRWYWx1ZTtcbiAgfVxuICBsb2dVbmV4cGVjZWRQcm9wZXJ0eUFjY2Vzc09uY2UocHJvcGVydHlOYW1lKTtcbiAgcmV0dXJuIGZhbHNlO1xufVxuXG5mdW5jdGlvbiBsb2dVbmV4cGVjZWRQcm9wZXJ0eUFjY2Vzc09uY2UocHJvcGVydHlOYW1lKSB7XG4gIGlmIChsb2dnZWRQcm9wZXJ0aWVzW3Byb3BlcnR5TmFtZV0gIT09IHRydWUpIHtcbiAgICBsb2dnZWRQcm9wZXJ0aWVzW3Byb3BlcnR5TmFtZV0gPSB0cnVlO1xuICAgIGxvZ2dlci5sb2coXG4gICAgICAnZXJyb3InLFxuICAgICAgYEhhbmRsZWJhcnM6IEFjY2VzcyBoYXMgYmVlbiBkZW5pZWQgdG8gcmVzb2x2ZSB0aGUgcHJvcGVydHkgXCIke3Byb3BlcnR5TmFtZX1cIiBiZWNhdXNlIGl0IGlzIG5vdCBhbiBcIm93biBwcm9wZXJ0eVwiIG9mIGl0cyBwYXJlbnQuXFxuYCArXG4gICAgICAgIGBZb3UgY2FuIGFkZCBhIHJ1bnRpbWUgb3B0aW9uIHRvIGRpc2FibGUgdGhlIGNoZWNrIG9yIHRoaXMgd2FybmluZzpcXG5gICtcbiAgICAgICAgYFNlZSBodHRwczovL2hhbmRsZWJhcnNqcy5jb20vYXBpLXJlZmVyZW5jZS9ydW50aW1lLW9wdGlvbnMuaHRtbCNvcHRpb25zLXRvLWNvbnRyb2wtcHJvdG90eXBlLWFjY2VzcyBmb3IgZGV0YWlsc2BcbiAgICApO1xuICB9XG59XG5cbmV4cG9ydCBmdW5jdGlvbiByZXNldExvZ2dlZFByb3BlcnRpZXMoKSB7XG4gIE9iamVjdC5rZXlzKGxvZ2dlZFByb3BlcnRpZXMpLmZvckVhY2gocHJvcGVydHlOYW1lID0+IHtcbiAgICBkZWxldGUgbG9nZ2VkUHJvcGVydGllc1twcm9wZXJ0eU5hbWVdO1xuICB9KTtcbn1cbiJdfQ==


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__(55);
	
	var logger = {
	  methodMap: ['debug', 'info', 'warn', 'error'],
	  level: 'info',
	
	  // Maps a given level value to the `methodMap` indexes above.
	  lookupLevel: function lookupLevel(level) {
	    if (typeof level === 'string') {
	      var levelMap = _utils.indexOf(logger.methodMap, level.toLowerCase());
	      if (levelMap >= 0) {
	        level = levelMap;
	      } else {
	        level = parseInt(level, 10);
	      }
	    }
	
	    return level;
	  },
	
	  // Can be overridden in the host environment
	  log: function log(level) {
	    level = logger.lookupLevel(level);
	
	    if (typeof console !== 'undefined' && logger.lookupLevel(logger.level) <= level) {
	      var method = logger.methodMap[level];
	      // eslint-disable-next-line no-console
	      if (!console[method]) {
	        method = 'log';
	      }
	
	      for (var _len = arguments.length, message = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        message[_key - 1] = arguments[_key];
	      }
	
	      console[method].apply(console, message); // eslint-disable-line no-console
	    }
	  }
	};
	
	exports['default'] = logger;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var formats = __webpack_require__(196);
	
	var has = Object.prototype.hasOwnProperty;
	var isArray = Array.isArray;
	
	var hexTable = (function () {
	    var array = [];
	    for (var i = 0; i < 256; ++i) {
	        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
	    }
	
	    return array;
	}());
	
	var compactQueue = function compactQueue(queue) {
	    while (queue.length > 1) {
	        var item = queue.pop();
	        var obj = item.obj[item.prop];
	
	        if (isArray(obj)) {
	            var compacted = [];
	
	            for (var j = 0; j < obj.length; ++j) {
	                if (typeof obj[j] !== 'undefined') {
	                    compacted.push(obj[j]);
	                }
	            }
	
	            item.obj[item.prop] = compacted;
	        }
	    }
	};
	
	var arrayToObject = function arrayToObject(source, options) {
	    var obj = options && options.plainObjects ? { __proto__: null } : {};
	    for (var i = 0; i < source.length; ++i) {
	        if (typeof source[i] !== 'undefined') {
	            obj[i] = source[i];
	        }
	    }
	
	    return obj;
	};
	
	var merge = function merge(target, source, options) {
	    /* eslint no-param-reassign: 0 */
	    if (!source) {
	        return target;
	    }
	
	    if (typeof source !== 'object' && typeof source !== 'function') {
	        if (isArray(target)) {
	            target.push(source);
	        } else if (target && typeof target === 'object') {
	            if (
	                (options && (options.plainObjects || options.allowPrototypes))
	                || !has.call(Object.prototype, source)
	            ) {
	                target[source] = true;
	            }
	        } else {
	            return [target, source];
	        }
	
	        return target;
	    }
	
	    if (!target || typeof target !== 'object') {
	        return [target].concat(source);
	    }
	
	    var mergeTarget = target;
	    if (isArray(target) && !isArray(source)) {
	        mergeTarget = arrayToObject(target, options);
	    }
	
	    if (isArray(target) && isArray(source)) {
	        source.forEach(function (item, i) {
	            if (has.call(target, i)) {
	                var targetItem = target[i];
	                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
	                    target[i] = merge(targetItem, item, options);
	                } else {
	                    target.push(item);
	                }
	            } else {
	                target[i] = item;
	            }
	        });
	        return target;
	    }
	
	    return Object.keys(source).reduce(function (acc, key) {
	        var value = source[key];
	
	        if (has.call(acc, key)) {
	            acc[key] = merge(acc[key], value, options);
	        } else {
	            acc[key] = value;
	        }
	        return acc;
	    }, mergeTarget);
	};
	
	var assign = function assignSingleSource(target, source) {
	    return Object.keys(source).reduce(function (acc, key) {
	        acc[key] = source[key];
	        return acc;
	    }, target);
	};
	
	var decode = function (str, defaultDecoder, charset) {
	    var strWithoutPlus = str.replace(/\+/g, ' ');
	    if (charset === 'iso-8859-1') {
	        // unescape never throws, no try...catch needed:
	        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
	    }
	    // utf-8
	    try {
	        return decodeURIComponent(strWithoutPlus);
	    } catch (e) {
	        return strWithoutPlus;
	    }
	};
	
	var limit = 1024;
	
	/* eslint operator-linebreak: [2, "before"] */
	
	var encode = function encode(str, defaultEncoder, charset, kind, format) {
	    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
	    // It has been adapted here for stricter adherence to RFC 3986
	    if (str.length === 0) {
	        return str;
	    }
	
	    var string = str;
	    if (typeof str === 'symbol') {
	        string = Symbol.prototype.toString.call(str);
	    } else if (typeof str !== 'string') {
	        string = String(str);
	    }
	
	    if (charset === 'iso-8859-1') {
	        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
	            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
	        });
	    }
	
	    var out = '';
	    for (var j = 0; j < string.length; j += limit) {
	        var segment = string.length >= limit ? string.slice(j, j + limit) : string;
	        var arr = [];
	
	        for (var i = 0; i < segment.length; ++i) {
	            var c = segment.charCodeAt(i);
	            if (
	                c === 0x2D // -
	                || c === 0x2E // .
	                || c === 0x5F // _
	                || c === 0x7E // ~
	                || (c >= 0x30 && c <= 0x39) // 0-9
	                || (c >= 0x41 && c <= 0x5A) // a-z
	                || (c >= 0x61 && c <= 0x7A) // A-Z
	                || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
	            ) {
	                arr[arr.length] = segment.charAt(i);
	                continue;
	            }
	
	            if (c < 0x80) {
	                arr[arr.length] = hexTable[c];
	                continue;
	            }
	
	            if (c < 0x800) {
	                arr[arr.length] = hexTable[0xC0 | (c >> 6)]
	                    + hexTable[0x80 | (c & 0x3F)];
	                continue;
	            }
	
	            if (c < 0xD800 || c >= 0xE000) {
	                arr[arr.length] = hexTable[0xE0 | (c >> 12)]
	                    + hexTable[0x80 | ((c >> 6) & 0x3F)]
	                    + hexTable[0x80 | (c & 0x3F)];
	                continue;
	            }
	
	            i += 1;
	            c = 0x10000 + (((c & 0x3FF) << 10) | (segment.charCodeAt(i) & 0x3FF));
	
	            arr[arr.length] = hexTable[0xF0 | (c >> 18)]
	                + hexTable[0x80 | ((c >> 12) & 0x3F)]
	                + hexTable[0x80 | ((c >> 6) & 0x3F)]
	                + hexTable[0x80 | (c & 0x3F)];
	        }
	
	        out += arr.join('');
	    }
	
	    return out;
	};
	
	var compact = function compact(value) {
	    var queue = [{ obj: { o: value }, prop: 'o' }];
	    var refs = [];
	
	    for (var i = 0; i < queue.length; ++i) {
	        var item = queue[i];
	        var obj = item.obj[item.prop];
	
	        var keys = Object.keys(obj);
	        for (var j = 0; j < keys.length; ++j) {
	            var key = keys[j];
	            var val = obj[key];
	            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
	                queue.push({ obj: obj, prop: key });
	                refs.push(val);
	            }
	        }
	    }
	
	    compactQueue(queue);
	
	    return value;
	};
	
	var isRegExp = function isRegExp(obj) {
	    return Object.prototype.toString.call(obj) === '[object RegExp]';
	};
	
	var isBuffer = function isBuffer(obj) {
	    if (!obj || typeof obj !== 'object') {
	        return false;
	    }
	
	    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
	};
	
	var combine = function combine(a, b) {
	    return [].concat(a, b);
	};
	
	var maybeMap = function maybeMap(val, fn) {
	    if (isArray(val)) {
	        var mapped = [];
	        for (var i = 0; i < val.length; i += 1) {
	            mapped.push(fn(val[i]));
	        }
	        return mapped;
	    }
	    return fn(val);
	};
	
	module.exports = {
	    arrayToObject: arrayToObject,
	    assign: assign,
	    combine: combine,
	    compact: compact,
	    decode: decode,
	    encode: encode,
	    isBuffer: isBuffer,
	    isRegExp: isRegExp,
	    maybeMap: maybeMap,
	    merge: merge
	};


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(193);
	var callBound = __webpack_require__(240);
	var inspect = __webpack_require__(136);
	
	var $TypeError = __webpack_require__(96);
	var $Map = GetIntrinsic('%Map%', true);
	
	/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */
	var $mapGet = callBound('Map.prototype.get', true);
	/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */
	var $mapSet = callBound('Map.prototype.set', true);
	/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */
	var $mapHas = callBound('Map.prototype.has', true);
	/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */
	var $mapDelete = callBound('Map.prototype.delete', true);
	/** @type {<K, V>(thisArg: Map<K, V>) => number} */
	var $mapSize = callBound('Map.prototype.size', true);
	
	/** @type {import('.')} */
	module.exports = !!$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
		/** @typedef {ReturnType<typeof getSideChannelMap>} Channel */
		/** @typedef {Parameters<Channel['get']>[0]} K */
		/** @typedef {Parameters<Channel['set']>[1]} V */
	
		/** @type {Map<K, V> | undefined} */ var $m;
	
		/** @type {Channel} */
		var channel = {
			assert: function (key) {
				if (!channel.has(key)) {
					throw new $TypeError('Side channel does not contain ' + inspect(key));
				}
			},
			'delete': function (key) {
				if ($m) {
					var result = $mapDelete($m, key);
					if ($mapSize($m) === 0) {
						$m = void undefined;
					}
					return result;
				}
				return false;
			},
			get: function (key) { // eslint-disable-line consistent-return
				if ($m) {
					return $mapGet($m, key);
				}
			},
			has: function (key) {
				if ($m) {
					return $mapHas($m, key);
				}
				return false;
			},
			set: function (key, value) {
				if (!$m) {
					// @ts-expect-error TS can't handle narrowing a variable inside a closure
					$m = new $Map();
				}
				$mapSet($m, key, value);
			}
		};
	
		// @ts-expect-error TODO: figure out why TS is erroring here
		return channel;
	};


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = process.env.NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(1059);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(1058);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(1049)))

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	//     uuid.js
	//
	//     Copyright (c) 2010-2012 Robert Kieffer
	//     MIT License - http://opensource.org/licenses/mit-license.php
	
	// Unique ID creation requires a high quality random # generator.  We feature
	// detect to determine the best RNG source, normalizing to a function that
	// returns 128-bits of randomness, since that's what's usually required
	var _rng = __webpack_require__(1060);
	
	// Maps for number <-> hex string conversion
	var _byteToHex = [];
	var _hexToByte = {};
	for (var i = 0; i < 256; i++) {
	  _byteToHex[i] = (i + 0x100).toString(16).substr(1);
	  _hexToByte[_byteToHex[i]] = i;
	}
	
	// **`parse()` - Parse a UUID into it's component bytes**
	function parse(s, buf, offset) {
	  var i = (buf && offset) || 0, ii = 0;
	
	  buf = buf || [];
	  s.toLowerCase().replace(/[0-9a-f]{2}/g, function(oct) {
	    if (ii < 16) { // Don't overflow!
	      buf[i + ii++] = _hexToByte[oct];
	    }
	  });
	
	  // Zero out remaining bytes if string was short
	  while (ii < 16) {
	    buf[i + ii++] = 0;
	  }
	
	  return buf;
	}
	
	// **`unparse()` - Convert UUID byte array (ala parse()) into a string**
	function unparse(buf, offset) {
	  var i = offset || 0, bth = _byteToHex;
	  return  bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]];
	}
	
	// **`v1()` - Generate time-based UUID**
	//
	// Inspired by https://github.com/LiosK/UUID.js
	// and http://docs.python.org/library/uuid.html
	
	// random #'s we need to init node and clockseq
	var _seedBytes = _rng();
	
	// Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
	var _nodeId = [
	  _seedBytes[0] | 0x01,
	  _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]
	];
	
	// Per 4.2.2, randomize (14 bit) clockseq
	var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;
	
	// Previous uuid creation time
	var _lastMSecs = 0, _lastNSecs = 0;
	
	// See https://github.com/broofa/node-uuid for API details
	function v1(options, buf, offset) {
	  var i = buf && offset || 0;
	  var b = buf || [];
	
	  options = options || {};
	
	  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;
	
	  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
	  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
	  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
	  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
	  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
	
	  // Per 4.2.1.2, use count of uuid's generated during the current clock
	  // cycle to simulate higher resolution clock
	  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;
	
	  // Time since last uuid creation (in msecs)
	  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;
	
	  // Per 4.2.1.2, Bump clockseq on clock regression
	  if (dt < 0 && options.clockseq === undefined) {
	    clockseq = clockseq + 1 & 0x3fff;
	  }
	
	  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
	  // time interval
	  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
	    nsecs = 0;
	  }
	
	  // Per 4.2.1.2 Throw error if too many uuids are requested
	  if (nsecs >= 10000) {
	    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
	  }
	
	  _lastMSecs = msecs;
	  _lastNSecs = nsecs;
	  _clockseq = clockseq;
	
	  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
	  msecs += 12219292800000;
	
	  // `time_low`
	  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
	  b[i++] = tl >>> 24 & 0xff;
	  b[i++] = tl >>> 16 & 0xff;
	  b[i++] = tl >>> 8 & 0xff;
	  b[i++] = tl & 0xff;
	
	  // `time_mid`
	  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
	  b[i++] = tmh >>> 8 & 0xff;
	  b[i++] = tmh & 0xff;
	
	  // `time_high_and_version`
	  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
	  b[i++] = tmh >>> 16 & 0xff;
	
	  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
	  b[i++] = clockseq >>> 8 | 0x80;
	
	  // `clock_seq_low`
	  b[i++] = clockseq & 0xff;
	
	  // `node`
	  var node = options.node || _nodeId;
	  for (var n = 0; n < 6; n++) {
	    b[i + n] = node[n];
	  }
	
	  return buf ? buf : unparse(b);
	}
	
	// **`v4()` - Generate random UUID**
	
	// See https://github.com/broofa/node-uuid for API details
	function v4(options, buf, offset) {
	  // Deprecated - 'format' argument, as supported in v1.2
	  var i = buf && offset || 0;
	
	  if (typeof(options) == 'string') {
	    buf = options == 'binary' ? new Array(16) : null;
	    options = null;
	  }
	  options = options || {};
	
	  var rnds = options.random || (options.rng || _rng)();
	
	  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	  rnds[6] = (rnds[6] & 0x0f) | 0x40;
	  rnds[8] = (rnds[8] & 0x3f) | 0x80;
	
	  // Copy bytes to buffer, if provided
	  if (buf) {
	    for (var ii = 0; ii < 16; ii++) {
	      buf[i + ii] = rnds[ii];
	    }
	  }
	
	  return buf || unparse(rnds);
	}
	
	// Export public API
	var uuid = v4;
	uuid.v1 = v1;
	uuid.v4 = v4;
	uuid.parse = parse;
	uuid.unparse = unparse;
	
	module.exports = uuid;


/***/ }),
/* 286 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	var require;var require;/*
	 Maps api created at 2GIS. Build on Leaflet.
	 (c) 2013-2016, 2GIS
	*/
	
	!function(t){if(true)module.exports=t();else if("function"==typeof define&&define.amd)define([],t);else{var e;e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this,e.DG=t()}}(function(){var define,module,exports;return function(){function t(e,i,o){function n(a,s){if(!i[a]){if(!e[a]){var l="function"==typeof require&&require;if(!s&&l)return require(a,!0);if(r)return r(a,!0);var u=new Error("Cannot find module '"+a+"'");throw u.code="MODULE_NOT_FOUND",u}var c=i[a]={exports:{}};e[a][0].call(c.exports,function(t){var i=e[a][1][t];return n(i||t)},c,c.exports,t,e,i,o)}return i[a].exports}for(var r="function"==typeof require&&require,a=0;a<o.length;a++)n(o[a]);return n}return t}()({1:[function(t,e,i){var o=".leaflet-image-layer,.leaflet-layer,.leaflet-map-pane canvas,.leaflet-map-pane svg,.leaflet-marker-icon,.leaflet-marker-shadow,.leaflet-pane,.leaflet-tile,.leaflet-tile-container,.leaflet-zoom-box{position:absolute;left:0;top:0}.leaflet-container{overflow:hidden;outline:0;font:12px/1.5 \"Helvetica Neue\",Arial,Helvetica,sans-serif}.leaflet-marker-icon,.leaflet-marker-shadow,.leaflet-tile{-webkit-user-select:none;-ms-user-select:none;user-select:none;-webkit-user-drag:none}.leaflet-safari .leaflet-tile{image-rendering:-webkit-optimize-contrast}.leaflet-safari .leaflet-tile-container{width:1600px;height:1600px;-webkit-transform-origin:0 0}.leaflet-marker-icon,.leaflet-marker-shadow{display:block}.leaflet-container .leaflet-marker-pane img,.leaflet-container .leaflet-overlay-pane svg,.leaflet-container .leaflet-tile-pane img,.leaflet-container img.leaflet-image-layer{max-width:none!important}.leaflet-container.leaflet-touch-zoom{-ms-touch-action:pan-x pan-y;touch-action:pan-x pan-y}.leaflet-container.leaflet-touch-drag{-ms-touch-action:pinch-zoom}.leaflet-container.leaflet-touch-drag.leaflet-touch-drag{-ms-touch-action:none;touch-action:none}.leaflet-tile{-webkit-filter:inherit;filter:inherit;visibility:hidden}.leaflet-tile-loaded{visibility:inherit}.leaflet-zoom-box{width:0;height:0;-webkit-box-sizing:border-box;box-sizing:border-box;z-index:800;border:2px dotted #38f;background:rgba(255,255,255,.5)}.leaflet-overlay-pane svg{-moz-user-select:none}.leaflet-pane{z-index:400}.leaflet-tile-pane{z-index:200}.leaflet-overlay-pane{z-index:400}.leaflet-shadow-pane{z-index:500}.leaflet-marker-pane{z-index:600}.leaflet-tooltip-pane{z-index:650}.leaflet-popup-pane{z-index:700}.leaflet-map-pane canvas{z-index:100}.leaflet-map-pane svg{z-index:200}.leaflet-vml-shape{width:1px;height:1px}.lvml{behavior:url(#default#VML);display:inline-block;position:absolute}.leaflet-control{position:relative;z-index:800;pointer-events:visiblePainted;pointer-events:auto;float:left;clear:both}.leaflet-bottom,.leaflet-top{position:absolute;z-index:1000;pointer-events:none}.leaflet-top{top:0}.leaflet-right{right:0}.leaflet-bottom{bottom:0}.leaflet-left{left:0}.leaflet-right .leaflet-control{float:right;margin-right:10px}.leaflet-top .leaflet-control{margin-top:10px}.leaflet-bottom .leaflet-control{margin-bottom:10px}.leaflet-left .leaflet-control{margin-left:10px}.leaflet-fade-anim .leaflet-tile{will-change:opacity}.leaflet-fade-anim .leaflet-popup{opacity:0;-webkit-transition:opacity .2s linear;transition:opacity .2s linear}.leaflet-fade-anim .leaflet-map-pane .leaflet-popup{opacity:1}.leaflet-zoom-animated{-webkit-transform-origin:0 0;-ms-transform-origin:0 0;transform-origin:0 0}.leaflet-zoom-anim .leaflet-zoom-animated{will-change:transform;-webkit-transition:-webkit-transform .25s cubic-bezier(0,0,.25,1);transition:-webkit-transform .25s cubic-bezier(0,0,.25,1);transition:transform .25s cubic-bezier(0,0,.25,1);transition:transform .25s cubic-bezier(0,0,.25,1),-webkit-transform .25s cubic-bezier(0,0,.25,1)}.leaflet-pan-anim .leaflet-tile,.leaflet-zoom-anim .leaflet-tile{-webkit-transition:none;transition:none}.leaflet-zoom-anim .leaflet-zoom-hide{visibility:hidden}.leaflet-interactive{cursor:pointer}.leaflet-grab{cursor:-webkit-grab;cursor:-moz-grab}.leaflet-crosshair,.leaflet-crosshair .leaflet-interactive{cursor:crosshair}.leaflet-control,.leaflet-popup-pane{cursor:auto}.leaflet-dragging .leaflet-grab,.leaflet-dragging .leaflet-grab .leaflet-interactive,.leaflet-dragging .leaflet-marker-draggable{cursor:move;cursor:-webkit-grabbing;cursor:-moz-grabbing}.leaflet-image-layer,.leaflet-marker-icon,.leaflet-marker-shadow,.leaflet-pane>svg path,.leaflet-tile-container{pointer-events:none}.leaflet-image-layer.leaflet-interactive,.leaflet-marker-icon.leaflet-interactive,.leaflet-pane>svg path.leaflet-interactive{pointer-events:visiblePainted;pointer-events:auto}.leaflet-container a{color:#0078A8}.leaflet-container a.leaflet-active{outline:orange solid 2px}.leaflet-bar{-webkit-box-shadow:0 1px 5px rgba(0,0,0,.65);box-shadow:0 1px 5px rgba(0,0,0,.65);border-radius:4px}.leaflet-bar a,.leaflet-bar a:hover{background-color:#fff;border-bottom:1px solid #ccc;width:26px;height:26px;line-height:26px;display:block;text-align:center;text-decoration:none;color:#000}.leaflet-bar a,.leaflet-control-layers-toggle{background-position:50% 50%;background-repeat:no-repeat;display:block}.leaflet-bar a:hover{background-color:#f4f4f4}.leaflet-bar a:first-child{border-top-left-radius:4px;border-top-right-radius:4px}.leaflet-bar a:last-child{border-bottom-left-radius:4px;border-bottom-right-radius:4px;border-bottom:none}.leaflet-bar a.leaflet-disabled{cursor:default;background-color:#f4f4f4;color:#bbb}.leaflet-touch .leaflet-bar a{width:30px;height:30px;line-height:30px}.leaflet-control-zoom-in,.leaflet-control-zoom-out{font:700 18px 'Lucida Console',Monaco,monospace;text-indent:1px}.leaflet-control-zoom-out{font-size:20px}.leaflet-touch .leaflet-control-zoom-in{font-size:22px}.leaflet-touch .leaflet-control-zoom-out{font-size:24px}.leaflet-control-layers{-webkit-box-shadow:0 1px 5px rgba(0,0,0,.4);box-shadow:0 1px 5px rgba(0,0,0,.4);background:#fff;border-radius:5px}.leaflet-control-layers-toggle{background-image:url(dist/css/images/layers.png);width:36px;height:36px}.leaflet-retina .leaflet-control-layers-toggle{background-image:url(dist/css/images/layers-2x.png);background-size:26px 26px}.leaflet-touch .leaflet-control-layers-toggle{width:44px;height:44px}.leaflet-control-layers .leaflet-control-layers-list,.leaflet-control-layers-expanded .leaflet-control-layers-toggle{display:none}.leaflet-control-layers-expanded .leaflet-control-layers-list{display:block;position:relative}.leaflet-control-layers-expanded{padding:6px 10px 6px 6px;color:#333;background:#fff}.leaflet-control-layers-scrollbar{overflow-y:scroll;padding-right:5px}.leaflet-control-layers-selector{margin-top:2px;position:relative;top:1px}.leaflet-control-layers label{display:block}.leaflet-control-layers-separator{height:0;border-top:1px solid #ddd;margin:5px -10px 5px -6px}.leaflet-default-icon-path{background-image:url(dist/css/images/marker-icon.png)}.leaflet-container .leaflet-control-attribution{background:#fff;background:rgba(255,255,255,.7);margin:0}.leaflet-control-attribution,.leaflet-control-scale-line{padding:0 5px;color:#333}.leaflet-control-attribution a{text-decoration:none}.leaflet-control-attribution a:hover{text-decoration:underline}.leaflet-container .leaflet-control-attribution,.leaflet-container .leaflet-control-scale{font-size:11px}.leaflet-left .leaflet-control-scale{margin-left:5px}.leaflet-bottom .leaflet-control-scale{margin-bottom:5px}.leaflet-control-scale-line{border:2px solid #777;border-top:none;line-height:1.1;padding:2px 5px 1px;font-size:11px;white-space:nowrap;overflow:hidden;-webkit-box-sizing:border-box;box-sizing:border-box;background:#fff;background:rgba(255,255,255,.5)}.leaflet-control-scale-line:not(:first-child){border-top:2px solid #777;border-bottom:none;margin-top:-2px}.leaflet-control-scale-line:not(:first-child):not(:last-child){border-bottom:2px solid #777}.leaflet-touch .leaflet-bar,.leaflet-touch .leaflet-control-attribution,.leaflet-touch .leaflet-control-layers{-webkit-box-shadow:none;box-shadow:none}.leaflet-touch .leaflet-bar,.leaflet-touch .leaflet-control-layers{border:2px solid rgba(0,0,0,.2);background-clip:padding-box}.leaflet-popup{position:absolute;text-align:center}.dg-schedule__string,.leaflet-popup-content-wrapper,[class^=dg-] caption,[class^=dg-] th{text-align:left}.leaflet-popup-tip-container{width:40px;position:absolute;left:50%;margin-left:-20px;overflow:hidden;pointer-events:none}.leaflet-popup-tip{width:17px;height:17px;padding:1px;margin:-10px auto 0;-webkit-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg)}.leaflet-popup-content-wrapper,.leaflet-popup-tip{background:#fff;color:#333;-webkit-box-shadow:0 3px 14px rgba(0,0,0,.4);box-shadow:0 3px 14px rgba(0,0,0,.4)}.leaflet-container a.leaflet-popup-close-button{border:none;font:16px/14px Tahoma,Verdana,sans-serif;color:#c3c3c3;text-decoration:none;background:0 0}.leaflet-container a.leaflet-popup-close-button:hover{color:#999}.leaflet-oldie .leaflet-popup-content-wrapper{zoom:1}.leaflet-oldie .leaflet-popup-tip{width:24px;margin:0 auto;-ms-filter:\"progid:DXImageTransform.Microsoft.Matrix(M11=0.70710678, M12=0.70710678, M21=-0.70710678, M22=0.70710678)\";filter:progid:DXImageTransform.Microsoft.Matrix(M11=.70710678, M12=.70710678, M21=-.70710678, M22=.70710678)}.leaflet-oldie .leaflet-popup-tip-container{margin-top:-1px}.leaflet-oldie .leaflet-control-layers,.leaflet-oldie .leaflet-control-zoom,.leaflet-oldie .leaflet-popup-content-wrapper,.leaflet-oldie .leaflet-popup-tip{border:1px solid #999}.leaflet-div-icon{background:#fff;border:1px solid #666}.leaflet-tooltip{position:absolute;padding:6px;background-color:#fff;border:1px solid #fff;border-radius:3px;color:#222;white-space:nowrap;-webkit-user-select:none;-ms-user-select:none;user-select:none;pointer-events:none;-webkit-box-shadow:0 1px 3px rgba(0,0,0,.4);box-shadow:0 1px 3px rgba(0,0,0,.4)}.leaflet-tooltip.leaflet-clickable{cursor:pointer;pointer-events:auto}.leaflet-tooltip-bottom:before,.leaflet-tooltip-left:before,.leaflet-tooltip-right:before,.leaflet-tooltip-top:before{position:absolute;pointer-events:none;border:6px solid transparent;background:0 0;content:\"\"}.leaflet-tooltip-bottom{margin-top:6px}.leaflet-tooltip-top{margin-top:-6px}.leaflet-tooltip-bottom:before,.leaflet-tooltip-top:before{left:50%;margin-left:-6px}.leaflet-tooltip-top:before{bottom:0;margin-bottom:-12px;border-top-color:#fff}.leaflet-tooltip-bottom:before{top:0;margin-top:-12px;margin-left:-6px;border-bottom-color:#fff}.leaflet-tooltip-left{margin-left:-6px}.leaflet-tooltip-right{margin-left:6px}.leaflet-tooltip-left:before,.leaflet-tooltip-right:before{top:50%;margin-top:-6px}.leaflet-tooltip-left:before{right:0;margin-right:-12px;border-left-color:#fff}.leaflet-tooltip-right:before{left:0;margin-left:-12px;border-right-color:#fff}[class^=dg-],[class^=dg-]:after,[class^=dg-]:before{-webkit-box-sizing:content-box;box-sizing:content-box;margin:0;padding:0;vertical-align:baseline;font-weight:inherit;font-style:inherit;font-size:1em;font-family:inherit;line-height:1.2}[class^=dg-]>[class^=dg-]:last-child{margin-bottom:0}[class^=dg-] abbr,[class^=dg-] fieldset,[class^=dg-] img{border:0}[class^=dg-] blockquote,[class^=dg-] q{quotes:none}[class^=dg-] blockquote:after,[class^=dg-] blockquote:before,[class^=dg-] q:after,[class^=dg-] q:before{content:'';content:none}[class^=dg-] ol,[class^=dg-] ul{list-style:none}[class^=dg-] table{border-spacing:0;border-collapse:collapse}[class^=dg-] td,[class^=dg-] th{vertical-align:middle}[class^=dg-] button::-moz-focus-inner,[class^=dg-] input::-moz-focus-inner{padding:0;border:0}.dg-label{position:absolute;top:0;left:0;max-width:none;max-height:none;width:300px;-webkit-user-select:none;-ms-user-select:none;user-select:none}.dg-label__content{display:inline-block;overflow:hidden;padding:3px 7px;min-width:30px;max-width:300px;width:auto;border-width:1px;border-style:solid;border-radius:2px;vertical-align:top;font-size:12px;border-color:#323232;border-color:rgba(50,50,50,.85);background:#323232;background:rgba(50,50,50,.85);color:#ffd26e}.leaflet-top .dg-label_name_location-error{top:5px}.leaflet-right .dg-label_name_location-error{right:40px;left:auto;text-align:right}.leaflet-bottom .dg-label_name_location-error{top:4px}.leaflet-left .dg-label_name_location-error{left:40px}.leaflet-popup{margin-bottom:0}.leaflet-popup-tip-container{height:0}.leaflet-popup-content-wrapper{overflow:hidden;padding:0;min-width:60px;min-height:50px;border:0;border-radius:3px;-webkit-box-shadow:none;box-shadow:none;color:#e6e6e6;font-size:14px;-webkit-transition:opacity ease-out .2s,max-height ease-out .2s,height ease-out .2s;transition:opacity ease-out .2s,max-height ease-out .2s,height ease-out .2s;-webkit-transform-origin:50% 100%;-ms-transform-origin:50% 100%;transform-origin:50% 100%;background:rgba(50,50,50,.9)}.leaflet-popup-content-wrapper:before{float:right;width:30px;height:17px;content:''}.leaflet-popup-content{position:relative;margin:16px;width:auto;line-height:1.4}.leaflet-popup a{outline:0}.leaflet-popup-content p{margin:0}.leaflet-popup-scrolled{overflow:visible;border:0}.leaflet-popup-inner{position:relative;z-index:0}.leaflet-popup_show_true{-webkit-transition:opacity ease-in-out .2s,height ease-out .2s,-webkit-transform ease-in-out .2s;transition:opacity ease-in-out .2s,height ease-out .2s,-webkit-transform ease-in-out .2s;transition:transform ease-in-out .2s,opacity ease-in-out .2s,height ease-out .2s;transition:transform ease-in-out .2s,opacity ease-in-out .2s,height ease-out .2s,-webkit-transform ease-in-out .2s;-webkit-transform:scale(1);-ms-transform:scale(1);transform:scale(1)}.leaflet-popup_show_false{opacity:0!important;-webkit-transition:all ease-in-out .1s;transition:all ease-in-out .1s;-webkit-transform:scale(.2);-ms-transform:scale(.2);transform:scale(.2)}.leaflet-popup_preloader_true{width:384px;height:52px}.leaflet-map-pane .leaflet-popup-tip-container{position:absolute;top:auto;bottom:0;left:50%;margin-left:-29px;width:58px;height:47px;background-repeat:no-repeat;-webkit-transform:translateY(47px);-ms-transform:translateY(47px);transform:translateY(47px);pointer-events:none}.leaflet-popup-tip{display:none}.leaflet-popup-tip-container_svg{background-repeat:no-repeat;background-image:url(https://maps.api.2gis.ru/2.0/img/DGPopup__popupShadow.png);background-position:50% 95%;background-size:36px 12px}.leaflet-retina .leaflet-popup-tip-container_svg{background-image:url(https://maps.api.2gis.ru/2.0/img/DGPopup__popupShadow@2x.png)}.leaflet-container a.leaflet-popup-close-button{position:absolute;top:3px;right:3px;z-index:1;overflow:hidden;padding:0;width:30px;height:30px;text-align:center;font-weight:400;font-size:18px;line-height:30px;cursor:pointer}.no-touch .leaflet-container a.leaflet-popup-close-button:hover{border-radius:2px;-webkit-transition:all .2s;transition:all .2s;background-color:#222;-webkit-box-shadow:0 1px 3px rgba(0,0,0,.5);box-shadow:0 1px 3px rgba(0,0,0,.5)}.leaflet-container a.leaflet-popup-close-button:active{color:#777}.leaflet-container a.leaflet-popup-close-button:after{position:absolute;z-index:2;content:'';top:-3px;right:-5px;width:40px;height:40px}.leaflet-popup-tip-container_image{background-repeat:no-repeat;background-image:url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2258%22%20height%3D%2247%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M0%200c12.643%200%2028%207.115%2028%2044h2c0-36.885%2015.358-44%2028-44h-58z%22%20fill%3D%22rgba(50%2C50%2C50%2C.9)%22%3E%3C%2Fpath%3E%0A%3C%2Fsvg%3E%0A')}.leaflet-map-pane .leaflet-popup-tip-container_svg{fill:rgba(50,50,50,.9)}.dg-wrapper{position:relative;overflow:hidden}.dg-scroller{height:100%;overflow-y:scroll;border:0}.dg-scroller::-webkit-scrollbar{width:0}.dg-scroller__bar{z-index:1;right:0;background:#999}.dg-scroller__bar_h{bottom:2px;height:8px}.dg-header__title{width:100%;margin:0;-webkit-box-sizing:border-box;box-sizing:border-box;background:#999}.dg-header__title_state_fixed{position:absolute;z-index:1}.dg-scroller_hidden_true{overflow:auto}.dg-scroller__wrapper{position:relative;overflow:hidden}.dg-scroller__bar-wrapper{position:absolute;top:18px;right:3px;bottom:4px;width:7px;border-radius:5px}.dg-scroller_hidden_true .dg-scroller__bar-wrapper{visibility:hidden}.dg-popup__header+.dg-popup__container-wrapper .dg-scroller__bar-wrapper{top:4px}.dg-scroller__bar{position:absolute;min-height:20px;width:7px;border-radius:3px;pointer-events:auto}.leaflet-popup-scrolled .dg-popup__footer:before,.leaflet-popup-scrolled .dg-popup__header:after{display:block;width:100%;height:1px;content:''}.scroller__bar-wrapper .scroller__bar{background-color:#665b4f}.scroller__bar-wrapper:hover .scroller__bar{background-color:#897a6b}.dg-popup__container{margin:0}.leaflet-popup-scrolled .dg-popup__container{padding:8px 14px 8px 0}.dg-popup__header{position:relative;padding-bottom:12px}.leaflet-popup-scrolled .dg-popup__header:after{position:relative;top:12px}.dg-popup__footer{position:relative;bottom:0;overflow:hidden}.dg-control-round,.dg-control-round__icon{position:relative;width:30px;height:30px;border-radius:50%}.dg-popup_hidden_true{display:none}.leaflet-popup-scrolled .dg-popup__footer:before,.leaflet-popup-scrolled .dg-popup__header:after{border-bottom:1px solid #636363;background-color:#494949}.dg-control-round{padding:5px;cursor:default}.dg-control-round__icon{display:block;background-color:#f0f0f0;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#fff),to(#e0e0e0));background-image:-webkit-linear-gradient(top,#fff 0,#e0e0e0 100%);background-image:linear-gradient(to bottom,#fff 0,#e0e0e0 100%);color:#2b2a29;text-align:center;text-decoration:none;text-shadow:0 1px 0 #fff;font-size:22px;line-height:30px;cursor:pointer}.no-touch .dg-control-round__icon:hover{background-color:#f5f5f5;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#ebebeb),to(#fff));background-image:-webkit-linear-gradient(top,#ebebeb 0,#fff 100%);background-image:linear-gradient(to bottom,#ebebeb 0,#fff 100%)}.dg-control-round__icon:active,.dg-control-round__icon_state_active,.no-touch .dg-control-round__icon:active{background-color:#ebebeb;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#d6d6d6),to(#fff));background-image:-webkit-linear-gradient(top,#d6d6d6 0,#fff 100%);background-image:linear-gradient(to bottom,#d6d6d6 0,#fff 100%)}.leaflet-touch .dg-control-round__icon:before{position:absolute;top:-10px;right:-15px;bottom:-10px;left:-15px;content:''}.dg-control-round_is-hidden_true{display:none}.dg-control-round{background-color:#3d3d3d;-webkit-box-shadow:0 3px 5px 0 rgba(0,0,0,.3);box-shadow:0 3px 5px 0 rgba(0,0,0,.3)}.dg-control-round__icon{-webkit-box-shadow:0 2px 2px 0 rgba(0,0,0,.4);box-shadow:0 2px 2px 0 rgba(0,0,0,.4)}.no-touch .dg-control-round__icon:hover{-webkit-box-shadow:inset 0 1px #fff,0 0 0 1px rgba(0,0,0,.3),0 1px 0 1px rgba(0,0,0,.4);box-shadow:inset 0 1px #fff,0 0 0 1px rgba(0,0,0,.3),0 1px 0 1px rgba(0,0,0,.4)}.dg-control-round__icon:active,.dg-control-round__icon_state_active,.no-touch .dg-control-round__icon:active{-webkit-box-shadow:inset 0 1px 1px 1px rgba(0,0,0,.2),0 0 0 1px rgba(0,0,0,.3),0 -1px 1px 0 #000;box-shadow:inset 0 1px 1px 1px rgba(0,0,0,.2),0 0 0 1px rgba(0,0,0,.3),0 -1px 1px 0 #000}.leaflet-disabled .dg-control-round__icon,.leaflet-disabled .dg-control-round__icon:active,.no-touch .leaflet-disabled .dg-control-round__icon:hover{background-image:none;cursor:default;background-color:#b8b8b8;-webkit-box-shadow:none;box-shadow:none}.dg-museum{position:absolute;top:0;left:0;right:0;z-index:1500;padding:4px 5px 8px;background:#333;color:#fff;opacity:.97;text-align:center}.dg-museum-browser{position:relative;top:4px;display:inline-block;width:16px;height:16px;margin:0 4px;background:url(https://maps.api.2gis.ru/2.0/img/DGMuseum.jpg) left top no-repeat}.dg-museum__chrome{background-position:0 0}.dg-museum__chrome:hover{background-position:0 -16px}.dg-museum__firefox{background-position:-16px 0}.dg-museum__firefox:hover{background-position:-16px -16px}.dg-museum__safari{background-position:-32px 0}.dg-museum__safari:hover{background-position:-32px -16px}.dg-museum__opera{width:15px;background-position:-48px 0}.dg-museum__opera:hover{background-position:-48px -16px}.dg-museum__ie{width:17px;background-position:-63px 0}.dg-museum__ie:hover{background-position:-63px -16px}.dg-museum__close{display:inline-block;margin:0 4px;width:9px;height:9px;background:url(https://maps.api.2gis.ru/2.0/img/DGMuseum_close.gif) top left no-repeat;cursor:pointer}.dg-museum__close:hover{opacity:.6}.leaflet-container{z-index:0;background:#f7f3df;cursor:default}.leaflet-container:-webkit-full-screen{width:100%!important;height:100%!important}.leaflet-container:-ms-fullscreen{width:100%!important;height:100%!important}.leaflet-container:fullscreen{width:100%!important;height:100%!important}.leaflet-dragging,.leaflet-dragging .leaflet-clickable,.leaflet-dragging .leaflet-container{cursor:move}.leaflet-control a,.leaflet-control a:focus{outline:0!important}.leaflet-container .leaflet-control-attribution{background-color:transparent;-webkit-box-shadow:none;box-shadow:none}.dg-customization__marker{background-repeat:no-repeat}.dg-customization__marker:before{position:absolute;top:0;left:0;width:100%;height:100%;background-image:inherit;background-size:contain;background-repeat:no-repeat;-webkit-transition:opacity ease-in-out .2s,-webkit-transform ease-in-out .2s;transition:opacity ease-in-out .2s,-webkit-transform ease-in-out .2s;transition:opacity ease-in-out .2s,transform ease-in-out .2s;transition:opacity ease-in-out .2s,transform ease-in-out .2s,-webkit-transform ease-in-out .2s;-webkit-transform:scale(1,1);-ms-transform:scale(1,1);transform:scale(1,1);-webkit-transform-origin:50% 100%;-ms-transform-origin:50% 100%;transform-origin:50% 100%}.dg-customization__marker_type_mushroom{background-repeat:no-repeat;background-image:url(https://maps.api.2gis.ru/2.0/img/DGCustomization__marker.png);background-size:22px 34px;width:22px;height:34px;-webkit-transform-origin:50% 100%;-ms-transform-origin:50% 100%;transform-origin:50% 100%;-webkit-animation:dg-customization__show-marker .2s;animation:dg-customization__show-marker .2s}.leaflet-retina .dg-customization__marker_type_mushroom{background-image:url(https://maps.api.2gis.ru/2.0/img/DGCustomization__marker@2x.png)}.dg-customization__marker_type_mushroom:focus{outline:0}.no-touch .dg-customization__marker_type_mushroom:hover{background-repeat:no-repeat;background-image:url(https://maps.api.2gis.ru/2.0/img/DGCustomization__markerHover.png);background-size:22px 34px}.leaflet-retina .no-touch .dg-customization__marker_type_mushroom:hover{background-image:url(https://maps.api.2gis.ru/2.0/img/DGCustomization__markerHover@2x.png)}.dg-customization__marker_type_mushroom:active,.no-touch .dg-customization__marker_type_mushroom:active{background-repeat:no-repeat;background-image:url(https://maps.api.2gis.ru/2.0/img/DGCustomization__markerActive.png);background-size:22px 34px}.leaflet-retina .dg-customization__marker_type_mushroom:active,.leaflet-retina .no-touch .dg-customization__marker_type_mushroom:active{background-image:url(https://maps.api.2gis.ru/2.0/img/DGCustomization__markerActive@2x.png)}@-webkit-keyframes dg-customization__show-marker{from{opacity:0}to{opacity:1}}@keyframes dg-customization__show-marker{from{opacity:0}to{opacity:1}}.dg-customization__marker_appear{background-position:999px}.dg-customization__marker_appear:before{content:''}.dg-customization__marker_disappear{background-position:999px;pointer-events:none}.dg-customization__marker_disappear:before{visibility:hidden;content:'';opacity:0;-webkit-transform:scale(1.2,1.8);-ms-transform:scale(1.2,1.8);transform:scale(1.2,1.8);-webkit-animation:dg-customization__marker-to-callout .2s;animation:dg-customization__marker-to-callout .2s}@-webkit-keyframes dg-customization__marker-to-callout{0%{visibility:visible;opacity:1;-webkit-transform:scale(1,1);transform:scale(1,1)}100%{visibility:visible;opacity:0;-webkit-transform:scale(1.2,1.8);transform:scale(1.2,1.8)}}@keyframes dg-customization__marker-to-callout{0%{visibility:visible;opacity:1;-webkit-transform:scale(1,1);transform:scale(1,1)}100%{visibility:visible;opacity:0;-webkit-transform:scale(1.2,1.8);transform:scale(1.2,1.8)}}.dg-dragging-false{touch-action:auto;-ms-touch-action:auto}.dg-zoom{width:40px;height:74px}.dg-zoom__in{position:absolute;top:0;left:0}.leaflet-touch .dg-zoom__in:before{position:absolute;top:-5px;right:-10px;bottom:0;left:-10px;content:''}.dg-zoom__in:after{position:absolute;right:0;bottom:-1px;left:0;z-index:-1;margin:auto;width:12px;height:2px;-webkit-box-shadow:0 0 3px 2px rgba(0,0,0,.3);box-shadow:0 0 3px 2px rgba(0,0,0,.3);content:''}.dg-zoom__button_type_in:after,.dg-zoom__button_type_in:before,.leaflet-touch .dg-zoom__button_type_in:before{position:absolute;top:0;right:0;bottom:0;left:0;margin:auto;width:14px;height:2px;background-color:#7a7a7a;-webkit-box-shadow:0 1px #fff;box-shadow:0 1px #fff;content:''}.dg-zoom__button_type_in:after{width:2px;height:14px}.no-touch .dg-zoom__button_type_in:hover:after,.no-touch .dg-zoom__button_type_in:hover:before{background-color:#616161}.dg-zoom__button_type_in:active:after,.dg-zoom__button_type_in:active:before,.no-touch .dg-zoom__button_type_in:active:after,.no-touch .dg-zoom__button_type_in:active:before{background-color:#575757}.leaflet-disabled .dg-zoom__button_type_in:active:after,.leaflet-disabled .dg-zoom__button_type_in:active:before,.leaflet-disabled .dg-zoom__button_type_in:after,.leaflet-disabled .dg-zoom__button_type_in:before,.no-touch .leaflet-disabled .dg-zoom__button_type_in:hover:after,.no-touch .leaflet-disabled .dg-zoom__button_type_in:hover:before{-webkit-box-shadow:none;box-shadow:none}.dg-zoom__out{position:absolute;top:40px;right:0;left:0;margin:auto;width:22px;height:22px}.dg-zoom__out:after{position:absolute;top:-1px;right:0;left:0;margin:auto;width:12px;height:2px;content:''}.dg-zoom__button_type_out{width:22px;height:22px}.leaflet-touch .dg-zoom__button_type_out:before{top:-5px;right:-19px;bottom:-19px;left:-19px}.dg-control-round__icon_name_fullscreen:after,.dg-control-round__icon_name_locate:after,.dg-zoom__button_type_out:after{position:absolute;top:0;left:0;content:'';bottom:0}.dg-zoom__button_type_out:after{right:0;margin:auto;width:10px;height:2px;background:#7a7a7a;-webkit-box-shadow:0 1px #fff;box-shadow:0 1px #fff}.no-touch .dg-zoom__button_type_out:hover:after{background:#616161}.dg-zoom__button_type_out:active:after,.no-touch .dg-zoom__button_type_out:active:after{background:#575757}.leaflet-disabled .dg-zoom__button_type_out:active:after,.leaflet-disabled .dg-zoom__button_type_out:after,.no-touch .leaflet-disabled .dg-zoom__button_type_out:hover:after{-webkit-box-shadow:none;box-shadow:none}.dg-zoom__out{-webkit-box-shadow:0 2px 3px 0 rgba(0,0,0,.3);box-shadow:0 2px 3px 0 rgba(0,0,0,.3)}.dg-zoom__out:after{background-color:#3d3d3d}.leaflet-disabled .dg-zoom__button_type_in:active:after,.leaflet-disabled .dg-zoom__button_type_in:active:before,.leaflet-disabled .dg-zoom__button_type_in:after,.leaflet-disabled .dg-zoom__button_type_in:before,.leaflet-disabled .dg-zoom__button_type_out:active:after,.leaflet-disabled .dg-zoom__button_type_out:after,.no-touch .leaflet-disabled .dg-zoom__button_type_in:hover:after,.no-touch .leaflet-disabled .dg-zoom__button_type_in:hover:before,.no-touch .leaflet-disabled .dg-zoom__button_type_out:hover:after{background-color:#707070}.dg-attribution{background-color:transparent!important}.dg-attribution .dg-attribution__copyright{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;-webkit-box-align:center!important;-ms-flex-align:center!important;align-items:center!important;text-align:right!important;white-space:nowrap!important;font-size:9px!important;font-family:Helvetica,Arial,sans-serif!important}.dg-attribution .dg-attribution__links{display:inline-block!important;margin:0!important;padding:0 5px 0 0!important}.dg-attribution .dg-attribution__link-item{padding:0!important;list-style-type:none!important}.dg-attribution .dg-attribution__logo-url{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20width%3D%2240%22%20height%3D%2220%22%20viewBox%3D%220%200%2040%2020%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M2.00011%208.72731C1.98229%205.72738%204.05025%204%206.80779%204C9.47674%204%2011.2797%205.58179%2011.2797%208.05437C11.2797%2010.1091%2010.0602%2011.2546%207.99196%2012.2727C7.21431%2012.6547%206.34807%2013.1818%205.46454%2013.4544H11.3681V16H2.00011V12.66C3.85604%2012.0235%204.88111%2011.3271%206.59576%2010.4728C7.90363%209.81815%208.71666%209.23633%208.71666%208.1819C8.71666%207.16358%207.97439%206.36366%206.80779%206.36366C5.27006%206.36366%204.52753%207.52729%204.56292%208.72731H2.00011Z%22%20fill%3D%22%236E7173%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M23.6348%209.63643V10.5453C23.6348%2013.5455%2021.6552%2016%2018.067%2016C14.6202%2016%2012.2518%2013.4727%2012.2518%209.99986C12.2518%206.52731%2014.5497%204%2018.1554%204C21.2487%204%2023.1751%205.8363%2023.6348%207.99991H21.0717C20.6301%206.96353%2019.534%206.36366%2018.2261%206.36366C15.9813%206.36366%2014.7263%208.14523%2014.7263%209.99986C14.7263%2011.8545%2015.9991%2013.6363%2018.2086%2013.6363C19.5872%2013.6363%2020.736%2012.9456%2021.0896%2011.8181H17.7313V9.63643H23.6348Z%22%20fill%3D%22%236E7173%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M27.4528%2016H24.9783V4H27.4528V16Z%22%20fill%3D%22%236E7173%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M38.4292%207.63648H35.8662C35.6185%206.85461%2034.947%206.18167%2033.4446%206.18167C32.1543%206.18167%2031.5004%206.69096%2031.5004%207.41809C31.5004%208.30915%2032.7375%208.56366%2034.293%208.83623L34.361%208.84818C36.4076%209.20779%2038.5%209.57545%2038.5%2012.2727C38.5%2014.8%2036.4672%2016%2033.7274%2016C31.1998%2016%2028.9373%2014.4727%2028.6899%2012.1818H31.2527C31.5712%2013.1273%2032.5079%2013.8181%2033.8512%2013.8181C35.1415%2013.8181%2035.8662%2013.3818%2035.8662%2012.5455C35.8662%2011.514%2034.3606%2011.2653%2032.8555%2011.0167C32.8221%2011.0112%2032.7887%2011.0056%2032.7553%2011.0001C31.1468%2010.7273%2028.8844%209.9818%2028.8844%207.54535C28.8844%205.34534%2030.7581%204%2033.5332%204C36.2727%204%2038.164%205.41814%2038.4292%207.63648Z%22%20fill%3D%22%236E7173%22%2F%3E%0A%3C%2Fsvg%3E%0A);width:40px;height:20px;background-size:40px 20px;margin:0 3px 0 0!important}.dg-attribution .dg-attribution__open2gis-button{background:#fff!important;border-radius:4px!important;-webkit-box-shadow:0 3px 5px rgba(0,0,0,.2)!important;box-shadow:0 3px 5px rgba(0,0,0,.2)!important;padding:4px 6px 4px 4px!important;position:relative!important;display:inline-block!important;-webkit-box-sizing:border-box!important;box-sizing:border-box!important;text-align:left!important;text-decoration:none!important;line-height:14px!important;font-style:normal!important;font-weight:600!important;font-size:9px!important;cursor:pointer!important;-webkit-transition:all .1s!important;transition:all .1s!important;height:22px!important;min-width:101px!important}.no-touch .dg-attribution .dg-attribution__open2gis-button:hover{-webkit-transition:background .2s!important;transition:background .2s!important;background:#e7f3ff!important}.dg-attribution .dg-attribution__open2gis-icon-button:before{display:inline-block!important;margin:-1px 4px 0 0!important;width:12px!important;height:12px!important;background-size:contain!important;background-repeat:no-repeat!important;content:''!important;vertical-align:middle!important}.dg-attribution .dg-attribution__button-wrapper{margin-left:3px!important}.dg-attribution .dg-attribution__button-wrapper .dg-attribution__open2gis-button{color:#454C4F!important}.no-touch .dg-attribution .dg-attribution__button-wrapper .dg-attribution__open2gis-button:hover{color:#286482!important}.dg-attribution .dg-attribution__open2gis-button_name_open:before{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20width%3D%2210%22%20height%3D%2212%22%20viewBox%3D%220%200%2010%2012%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M5%200C7.97834%200%2010%202.30909%2010%204.8C10%205.8%209.78339%206.67273%209.27798%207.76364C6.31769%207.76364%205.77617%209.74545%205.64982%2011.0727L5.55957%2012H4.44043L4.35018%2011.0727C4.22383%209.74545%203.68231%207.76364%200.722022%207.76364C0.216607%206.67273%200%205.8%200%204.8C0%202.30909%202.02166%200%205%200Z%22%20fill%3D%22%23299400%22%2F%3E%0A%3C%2Fsvg%3E%0A);width:10px;height:12px;background-size:10px 12px}.leaflet-container .dg-attribution .dg-attribution__link{background:-webkit-gradient(linear,left top,right top,from(rgba(8,8,8,.3)),to(rgba(8,8,8,.3))) 0 95%/10px 1px repeat-x!important;background:-webkit-linear-gradient(left,rgba(8,8,8,.3),rgba(8,8,8,.3) 100%) 0 95%/10px 1px repeat-x!important;background:linear-gradient(to right,rgba(8,8,8,.3),rgba(8,8,8,.3) 100%) 0 95%/10px 1px repeat-x!important;color:#333!important;text-decoration:none!important;font-size:9px!important;font-family:Helvetica,Arial,sans-serif!important;cursor:pointer!important}.leaflet-container .dg-attribution .dg-attribution__link:hover{background-image:-webkit-gradient(linear,left top,right top,from(#080808),to(#080808))!important;background-image:-webkit-linear-gradient(left,#080808,#080808 100%)!important;background-image:linear-gradient(to right,#080808,#080808 100%)!important;color:#333!important;text-decoration:none!important}.dg-location__pin{background-repeat:no-repeat;width:20px;height:20px;background-image:url(https://maps.api.2gis.ru/2.0/img/sprite.basic.png);background-position:-40px 0;background-size:90px 74px}.leaflet-retina .dg-location__pin{background-image:url(https://maps.api.2gis.ru/2.0/img/sprite@2x.basic.png);background-position:-40px 0;background-size:90px 73.5px}.dg-location__pin_state_following{background-repeat:no-repeat;width:20px;height:20px;background-image:url(https://maps.api.2gis.ru/2.0/img/sprite.basic.png);background-position:-40px -20px;background-size:90px 74px}.leaflet-retina .dg-location__pin_state_following{background-image:url(https://maps.api.2gis.ru/2.0/img/sprite@2x.basic.png);background-position:-40px -20px;background-size:90px 73.5px}.dg-control-round__icon_state_active.dg-control-round__icon_name_locate:active:after,.dg-control-round__icon_state_active.dg-control-round__icon_name_locate:after,.no-touch .dg-control-round__icon_state_active.dg-control-round__icon_name_locate:hover:after{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2218%22%20height%3D%2218%22%3E%0A%20%20%20%20%3Cg%20fill%3D%22%2323a5d4%22%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%2017%2C8%20H%2015.92%20C%2015.48%2C4.937%2013.064%2C2.52%2010%2C2.08%20V%201%20C%2010%2C0.448%209.553%2C0%209%2C0%208.447%2C0%208%2C0.448%208%2C1%20V%202.08%20C%204.936%2C2.52%202.52%2C4.937%202.08%2C8%20H%201%20C%200.447%2C8%200%2C8.448%200%2C9%200%2C9.553%200.447%2C10%201%2C10%20H%202.08%20C%202.52%2C13.063%204.936%2C15.48%208%2C15.92%20V%2017%20c%200%2C0.553%200.447%2C1%201%2C1%200.553%2C0%201%2C-0.447%201%2C-1%20V%2015.92%20C%2013.064%2C15.481%2015.48%2C13.064%2015.92%2C10%20H%2017%20C%2017.553%2C10%2018%2C9.553%2018%2C9%2018%2C8.448%2017.553%2C8%2017%2C8%20z%20M%209%2C14%20C%206.24%2C14%204%2C11.762%204%2C9%204%2C6.238%206.24%2C4%209%2C4%20c%202.761%2C0%205%2C2.238%205%2C5%200%2C2.762%20-2.239%2C5%20-5%2C5%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Ccircle%20cx%3D%229%22%20cy%3D%229%22%20r%3D%223%22%2F%3E%0A%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%2014%2C10.004%20C%2014%2C9.834%2013.991%2C9.667%2013.975%2C9.502%2013.723%2C12.027%2011.592%2C14%209%2C14%206.408%2C14%204.277%2C12.027%204.025%2C9.502%204.009%2C9.667%204%2C9.834%204%2C10.004%20c%200%2C2.762%202.24%2C5%205%2C5%202.761%2C0%205%2C-2.238%205%2C-5%20z%20M%2010%2C3.083%20c%203.064%2C0.439%205.48%2C2.856%205.92%2C5.921%20H%2017%20c%200.369%2C0%200.688%2C0.201%200.86%2C0.498%20C%2017.947%2C9.354%2018%2C9.184%2018%2C9%2018%2C8.448%2017.553%2C8%2017%2C8%20H%2015.92%20C%2015.48%2C4.937%2013.064%2C2.52%2010%2C2.08%20V%203.083%20z%20M%201%2C9.004%20H%202.08%20C%202.52%2C5.939%204.936%2C3.522%208%2C3.083%20V%202.08%20C%204.936%2C2.52%202.52%2C4.937%202.08%2C8%20H%201%20C%200.447%2C8%200%2C8.448%200%2C9%200%2C9.184%200.053%2C9.354%200.14%2C9.502%200.312%2C9.205%200.631%2C9.004%201%2C9.004%20z%20m%208%2C-8%20c%200.553%2C0%201%2C0.447%201%2C1%20V%201%20C%2010%2C0.448%209.553%2C0%209%2C0%208.447%2C0%208%2C0.448%208%2C1%20v%201.004%20c%200%2C-0.553%200.447%2C-1%201%2C-1%20z%22%20fill%3D%22%232685aa%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22m%209%2C7%20c%201.486%2C0%202.717%2C1.082%202.955%2C2.5%20C%2011.982%2C9.337%2012%2C9.171%2012%2C9%2012%2C7.344%2010.656%2C6%209%2C6%207.344%2C6%206%2C7.344%206%2C9%206%2C9.171%206.018%2C9.337%206.045%2C9.5%206.283%2C8.082%207.514%2C7%209%2C7%20z%22%20fill%3D%22%231c85ab%22%2F%3E%0A%3C%2Fsvg%3E%0A)}@-webkit-keyframes DGLocation__locateIconRequestingAnim{to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes DGLocation__locateIconRequestingAnim{to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}.dg-control-round__icon_name_locate:after{right:0;margin:auto;background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2218%22%20height%3D%2218%22%3E%0A%20%20%20%20%3Cg%20fill%3D%22%23616161%22%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%2017%2C8%20H%2015.92%20C%2015.48%2C4.937%2013.064%2C2.52%2010%2C2.08%20V%201%20C%2010%2C0.448%209.553%2C0%209%2C0%208.447%2C0%208%2C0.448%208%2C1%20V%202.08%20C%204.936%2C2.52%202.52%2C4.937%202.08%2C8%20H%201%20C%200.447%2C8%200%2C8.448%200%2C9%200%2C9.553%200.447%2C10%201%2C10%20H%202.08%20C%202.52%2C13.063%204.936%2C15.48%208%2C15.92%20V%2017%20c%200%2C0.553%200.447%2C1%201%2C1%200.553%2C0%201%2C-0.447%201%2C-1%20V%2015.92%20C%2013.064%2C15.481%2015.48%2C13.064%2015.92%2C10%20H%2017%20C%2017.553%2C10%2018%2C9.553%2018%2C9%2018%2C8.448%2017.553%2C8%2017%2C8%20z%20M%209%2C14%20C%206.24%2C14%204%2C11.762%204%2C9%204%2C6.238%206.24%2C4%209%2C4%20c%202.761%2C0%205%2C2.238%205%2C5%200%2C2.762%20-2.239%2C5%20-5%2C5%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Ccircle%20cx%3D%229%22%20cy%3D%229%22%20r%3D%223%22%2F%3E%0A%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3Cg%20fill%3D%22%23444%22%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%2014%2C10.004%20C%2014%2C9.834%2013.991%2C9.667%2013.975%2C9.502%2013.723%2C12.027%2011.592%2C14%209%2C14%206.408%2C14%204.277%2C12.027%204.025%2C9.502%204.009%2C9.667%204%2C9.834%204%2C10.004%20c%200%2C2.762%202.24%2C5%205%2C5%202.761%2C0%205%2C-2.238%205%2C-5%20z%20M%2010%2C3.083%20c%203.064%2C0.439%205.48%2C2.856%205.92%2C5.921%20H%2017%20c%200.369%2C0%200.688%2C0.201%200.86%2C0.498%20C%2017.947%2C9.354%2018%2C9.184%2018%2C9%2018%2C8.448%2017.553%2C8%2017%2C8%20H%2015.92%20C%2015.48%2C4.937%2013.064%2C2.52%2010%2C2.08%20V%203.083%20z%20M%201%2C9.004%20H%202.08%20C%202.52%2C5.939%204.936%2C3.522%208%2C3.083%20V%202.08%20C%204.936%2C2.52%202.52%2C4.937%202.08%2C8%20H%201%20C%200.447%2C8%200%2C8.448%200%2C9%200%2C9.184%200.053%2C9.354%200.14%2C9.502%200.312%2C9.205%200.631%2C9.004%201%2C9.004%20z%20m%208%2C-8%20c%200.553%2C0%201%2C0.447%201%2C1%20V%201%20C%2010%2C0.448%209.553%2C0%209%2C0%208.447%2C0%208%2C0.448%208%2C1%20v%201.004%20c%200%2C-0.553%200.447%2C-1%201%2C-1%20z%22%2F%3E%0A%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3Cpath%20d%3D%22m%209%2C7%20c%201.486%2C0%202.717%2C1.082%202.955%2C2.5%20C%2011.982%2C9.337%2012%2C9.171%2012%2C9%2012%2C7.344%2010.656%2C6%209%2C6%207.344%2C6%206%2C7.344%206%2C9%206%2C9.171%206.018%2C9.337%206.045%2C9.5%206.283%2C8.082%207.514%2C7%209%2C7%20z%22%20fill%3D%22%23444%22%2F%3E%0A%3C%2Fsvg%3E%0A);width:18px;height:18px;background-size:18px 18px}.dg-control-round__icon_name_locate:active:after,.no-touch .dg-control-round__icon_name_locate:hover:after{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2218%22%20height%3D%2218%22%3E%0A%20%20%20%20%3Cg%20fill%3D%22%23424242%22%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%2017%2C8%20H%2015.92%20C%2015.48%2C4.937%2013.064%2C2.52%2010%2C2.08%20V%201%20C%2010%2C0.448%209.553%2C0%209%2C0%208.447%2C0%208%2C0.448%208%2C1%20V%202.08%20C%204.936%2C2.52%202.52%2C4.937%202.08%2C8%20H%201%20C%200.447%2C8%200%2C8.448%200%2C9%200%2C9.553%200.447%2C10%201%2C10%20H%202.08%20C%202.52%2C13.063%204.936%2C15.48%208%2C15.92%20V%2017%20c%200%2C0.553%200.447%2C1%201%2C1%200.553%2C0%201%2C-0.447%201%2C-1%20V%2015.92%20C%2013.064%2C15.481%2015.48%2C13.064%2015.92%2C10%20H%2017%20C%2017.553%2C10%2018%2C9.553%2018%2C9%2018%2C8.448%2017.553%2C8%2017%2C8%20z%20M%209%2C14%20C%206.24%2C14%204%2C11.762%204%2C9%204%2C6.238%206.24%2C4%209%2C4%20c%202.761%2C0%205%2C2.238%205%2C5%200%2C2.762%20-2.239%2C5%20-5%2C5%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Ccircle%20cx%3D%229%22%20cy%3D%229%22%20r%3D%223%22%2F%3E%0A%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3Cg%20fill%3D%22%232e2e2e%22%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%2014%2C10.004%20C%2014%2C9.834%2013.991%2C9.667%2013.975%2C9.502%2013.723%2C12.027%2011.592%2C14%209%2C14%206.408%2C14%204.277%2C12.027%204.025%2C9.502%204.009%2C9.667%204%2C9.834%204%2C10.004%20c%200%2C2.762%202.24%2C5%205%2C5%202.761%2C0%205%2C-2.238%205%2C-5%20z%20M%2010%2C3.083%20c%203.064%2C0.439%205.48%2C2.856%205.92%2C5.921%20H%2017%20c%200.369%2C0%200.688%2C0.201%200.86%2C0.498%20C%2017.947%2C9.354%2018%2C9.184%2018%2C9%2018%2C8.448%2017.553%2C8%2017%2C8%20H%2015.92%20C%2015.48%2C4.937%2013.064%2C2.52%2010%2C2.08%20V%203.083%20z%20M%201%2C9.004%20H%202.08%20C%202.52%2C5.939%204.936%2C3.522%208%2C3.083%20V%202.08%20C%204.936%2C2.52%202.52%2C4.937%202.08%2C8%20H%201%20C%200.447%2C8%200%2C8.448%200%2C9%200%2C9.184%200.053%2C9.354%200.14%2C9.502%200.312%2C9.205%200.631%2C9.004%201%2C9.004%20z%20m%208%2C-8%20c%200.553%2C0%201%2C0.447%201%2C1%20V%201%20C%2010%2C0.448%209.553%2C0%209%2C0%208.447%2C0%208%2C0.448%208%2C1%20v%201.004%20c%200%2C-0.553%200.447%2C-1%201%2C-1%20z%22%2F%3E%0A%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3Cpath%20d%3D%22m%209%2C7%20c%201.486%2C0%202.717%2C1.082%202.955%2C2.5%20C%2011.982%2C9.337%2012%2C9.171%2012%2C9%2012%2C7.344%2010.656%2C6%209%2C6%207.344%2C6%206%2C7.344%206%2C9%206%2C9.171%206.018%2C9.337%206.045%2C9.5%206.283%2C8.082%207.514%2C7%209%2C7%20z%22%20fill%3D%22%232e2e2e%22%2F%3E%0A%3C%2Fsvg%3E%0A)}.dg-control-round__icon_state_requesting.dg-control-round__icon_name_locate:active:after,.dg-control-round__icon_state_requesting.dg-control-round__icon_name_locate:after,.no-touch .dg-control-round__icon_state_requesting.dg-control-round__icon_name_locate:hover:after{background-repeat:no-repeat;width:24px;height:24px;background-image:url(https://maps.api.2gis.ru/2.0/img/sprite.dark.png);background-position:0 0;background-size:78px 65px;-webkit-animation:DGLocation__locateIconRequestingAnim 1s linear infinite;animation:DGLocation__locateIconRequestingAnim 1s linear infinite;image-rendering:optimizeQuality}.leaflet-retina .dg-control-round__icon_state_requesting.dg-control-round__icon_name_locate:active:after,.leaflet-retina .dg-control-round__icon_state_requesting.dg-control-round__icon_name_locate:after,.leaflet-retina .no-touch .dg-control-round__icon_state_requesting.dg-control-round__icon_name_locate:hover:after{background-image:url(https://maps.api.2gis.ru/2.0/img/sprite@2x.dark.png);background-position:0 0;background-size:78px 65px}.dg-control-round__icon_state_active.dg-control-round__icon_name_fullscreen:active:after,.dg-control-round__icon_state_active.dg-control-round__icon_name_fullscreen:after,.no-touch .dg-control-round__icon_state_active.dg-control-round__icon_name_fullscreen:hover:after{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2216%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%206%2C1%20H%201%20V%206%20H%203%20V%203%20h%203%20z%20m%204%2C14%20h%205%20v%20-5%20h%20-2%20v%203%20H%2010%20z%20M%2015%2C6%20V%201%20h%20-5%20v%202%20h%203%20V%206%20z%20M%201%2C10%20v%205%20H%206%20V%2013%20H%203%20v%20-3%20z%22%20fill%3D%22%230da4d4%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%201%2C1%20H%206%20V%202%20H%201%20z%20m%209%2C0%20h%205%20v%201%20h%20-5%20z%20m%203%2C9%20h%202%20v%201%20h%20-2%20z%20m%20-3%2C3%20h%203%20v%201%20h%20-3%20z%20m%20-7%2C0%20h%203%20v%201%20H%203%20z%20M%201%2C10%20h%202%20v%201%20H%201%20z%22%20fill%3D%22%230a84ab%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%201%2C6%20H%203%20V%207%20H%201%20z%20m%2012%2C0%20h%202%20V%207%20H%2013%20z%20M%201%2C15%20h%205%20v%201%20H%201%20z%20m%209%2C0%20h%205%20v%201%20h%20-5%20z%22%20fill%3D%22%23fff%22%2F%3E%0A%3C%2Fsvg%3E%0A)}.dg-control-round__icon_name_fullscreen:after{right:0;margin:auto;background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2216%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%201%2C3%20H%206%20V%204%20H%201%20z%22%20fill%3D%22%23fff%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%206%2C1%20H%201%20V%206%20H%203%20V%203%20h%203%20z%20m%204%2C14%20h%205%20v%20-5%20h%20-2%20v%203%20h%20-3%20z%22%20fill%3D%22%236c6c6c%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22m%2010%2C3%20h%205%20v%201%20h%20-5%20z%22%20fill%3D%22%23fff%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%2015%2C6%20V%201%20h%20-5%20v%202%20h%203%20V%206%20z%20M%201%2C10%20v%205%20H%206%20V%2013%20H%203%20v%20-3%20z%22%20fill%3D%22%236c6c6c%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%201%2C1%20H%206%20V%202%20H%201%20z%20m%209%2C0%20h%205%20v%201%20h%20-5%20z%20m%203%2C9%20h%202%20v%201%20h%20-2%20z%20m%20-3%2C3%20h%203%20v%201%20h%20-3%20z%20m%20-7%2C0%20h%203%20v%201%20H%203%20z%20M%201%2C10%20h%202%20v%201%20H%201%20z%22%20fill%3D%22%234b4b4b%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%201%2C6%20H%203%20V%207%20H%201%20z%20m%2012%2C0%20h%202%20V%207%20H%2013%20z%20M%201%2C15%20h%205%20v%201%20H%201%20z%20m%209%2C0%20h%205%20v%201%20h%20-5%20z%22%20fill%3D%22%23fff%22%2F%3E%0A%3C%2Fsvg%3E%0A);width:16px;height:16px;background-size:16px 16px}.dg-map-geoclicker__address+.dg-map-geoclicker__purpose,.dg-map-geoclicker__purpose+.dg-map-geoclicker__address{margin-top:-6px}.dg-control-round__icon_name_fullscreen:active:after,.no-touch .dg-control-round__icon_name_fullscreen:hover:after{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2216%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22m%2012%2C9%20h%204%20v%207%20h%20-4%20z%20m%20-3%2C3%20h%205%20v%204%20H%209%20z%22%20fill%3D%22%23fff%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22m%2010%2C15%20h%205%20v%20-5%20h%20-2%20v%203%20h%20-3%20z%22%20fill%3D%22%23282828%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22m%200%2C9%20h%204%20v%207%20H%200%20z%20m%202%2C3%20h%205%20v%204%20H%202%20z%22%20fill%3D%22%23fff%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22m%201%2C10%20v%205%20H%206%20V%2013%20H%203%20v%20-3%20z%22%20fill%3D%22%23282828%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%200%2C0%20H%204%20V%207%20H%200%20z%20m%209%2C0%20h%205%20V%204%20H%209%20z%20m%203%2C0%20h%204%20v%207%20h%20-4%20z%22%20fill%3D%22%23fff%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%2015%2C6%20V%201%20h%20-5%20v%202%20h%203%20v%203%20z%22%20fill%3D%22%23282828%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%202%2C0%20H%207%20V%204%20H%202%20z%22%20fill%3D%22%23fff%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%206%2C1%20H%201%20V%206%20H%203%20V%203%20h%203%20z%22%20fill%3D%22%23282828%22%2F%3E%0A%3C%2Fsvg%3E%0A)}.dg-building-callout__body{position:relative}.dg-building-callout__list{margin-bottom:8px;padding-left:24px;color:#ffe6aa;list-style:none}.dg-building-callout__list-item{position:relative;margin-bottom:4px;font-size:12px}.dg-building-callout__list-item:before{position:absolute;top:5px;left:-21px;content:'';background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%226%22%20height%3D%226%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%203%2C-0.002%20C%204.654%2C-0.002%205.994%2C1.342%205.994%2C3%205.994%2C4.658%204.655%2C6.002%203%2C6.002%201.345%2C6.002%200.005%2C4.658%200.005%2C3%200.005%2C1.342%201.346%2C-0.002%203%2C-0.002%20z%22%20fill%3D%22%23aaa%22%20fill-rule%3D%22evenodd%22%2F%3E%0A%3C%2Fsvg%3E%0A);width:6px;height:6px;background-size:6px 6px}.dg-map-geoclicker__address{margin-bottom:10px;font-size:16px}.dg-map-geoclicker__address-header{position:relative;margin-bottom:4px;padding-left:24px}.dg-map-geoclicker__address-header:first-child:before{position:absolute;top:5px;left:1px;content:''}.dg-map-geoclicker__address-drilldown{position:relative;margin-bottom:4px;padding-left:24px;color:#aaa;font-size:12px}.dg-map-geoclicker__address-drilldown:first-child:before{position:absolute;top:2px;left:1px;content:''}.dg-map-geoclicker__purpose{position:relative;margin-bottom:10px;padding-left:24px;font-size:16px}.dg-map-geoclicker__purpose:before{position:absolute;top:4px;left:2px;content:''}.dg-map-geoclicker__sight-description{overflow:hidden;padding:.5em 0 0 24px;max-height:3.6em}a.dg-map-geoclicker__show-more-sights-link{position:relative;margin-left:24px;border-bottom:1px dotted;text-decoration:none;color:#ffe6aa}.dg-preloader_animation_true:after,.dg-preloader_animation_true:before,a.dg-map-geoclicker__show-more-sights-link:after{position:absolute;content:''}a.dg-map-geoclicker__show-more-sights-link:after{top:4px;margin-left:5px;width:6px;height:10px;font-weight:700}.dg-map-geoclicker__clamped-line{display:block;white-space:nowrap}.dg-map-geoclicker__clamped-line_last{overflow:hidden;width:100%;text-overflow:ellipsis}.dg-map-geoclicker__preloader-wrapper{display:table-cell;vertical-align:middle;text-align:center}.dg-map-geoclicker__address-drilldown:first-child:before,.dg-map-geoclicker__address-header:first-child:before{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%229%22%20height%3D%2211%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%204.958%2C11%20C%204.958%2C9.036%206.756%2C6.751%208.719%2C6.751%208.885%2C6.223%209%2C5.656%209%2C5.063%209%2C2.267%206.985%2C0%204.5%2C0%202.015%2C0%200%2C2.267%200%2C5.063%200%2C5.656%200.114%2C6.222%200.28%2C6.751%202.243%2C6.751%204.018%2C9.012%204.018%2C11%20h%200.94%20z%22%20fill%3D%22%23a0a0a0%22%2F%3E%0A%3C%2Fsvg%3E%0A);width:9px;height:11px;background-size:9px 11px}.dg-map-geoclicker__purpose:before{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%228%22%20height%3D%2212%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22m%203.582%2C8%20c%200.211%2C0%200.798%2C0.035%201%2C0%20v%204%20l%20-2%2C-1%20V%208%20c%200.372%2C0.066%200.861%2C0%201%2C0%20z%20M%200.44%2C5.384%20C%200.163%2C4.866%200%2C4.276%200%2C3.646%200%2C1.633%201.604%2C0.002%203.582%2C0.002%20c%201.978%2C0%203.582%2C1.631%203.582%2C3.644%200%2C0.647%20-0.169%2C1.254%20-0.461%2C1.781%20L%206.641%2C5.495%206.618%2C5.567%20C%205.954%2C6.549%204.844%2C7.192%203.584%2C7.192%202.25%2C7.192%201.084%2C6.467%200.44%2C5.384%20z%20M%202.613%2C1.276%20c%20-0.549%2C0%20-0.995%2C0.453%20-0.995%2C1.013%200%2C0.559%200.446%2C1.013%200.995%2C1.013%200.551%2C0%200.996%2C-0.454%200.996%2C-1.013%200%2C-0.56%20-0.445%2C-1.013%20-0.996%2C-1.013%20z%22%20fill%3D%22%23a0a0a0%22%2F%3E%0A%3C%2Fsvg%3E%0A);width:8px;height:12px;background-size:8px 12px}.dg-map-geoclicker__purpose_type_street:before{top:4px;background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2212%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%208.8%2C0%20H%203.199%20L%200%2C12%20H%2012%20L%208.8%2C0%20z%20M%207%2C12%20H%205%20V%209%20h%202%20v%203%20z%20M%207%2C8%20H%205%20V%206%20H%207%20V%208%20z%20M%207%2C5%20H%205%20V%203%20H%207%20V%205%20z%20M%207%2C2%20H%205%20V%200%20h%202%20v%202%20z%22%20fill%3D%22%23a0a0a0%22%2F%3E%0A%3C%2Fsvg%3E%0A);width:12px;height:12px;background-size:12px 12px}.dg-preloader_animation_true:after,.dg-preloader_animation_true:before{top:50%;left:50%;outline:transparent solid 1px;image-rendering:optimizeQuality}.dg-map-geoclicker__purpose_type_sight:before{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%228%22%20height%3D%2212%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%207%2C0%20H%202.547%20C%200.547%2C0%200%2C0.828%200%2C2.5%200%2C3.734%200.5%2C5%202%2C5%203.359%2C5%204%2C3.844%204%2C3%204%2C2.281%202.859%2C2%202%2C2%202%2C2.766%202.234%2C3%203%2C3%203%2C3.69%202.48%2C4%202%2C4%201.234%2C4%201%2C3.329%201%2C2.5%201%2C1.693%201.375%2C1%202.5%2C1%204.391%2C1%205%2C1.656%205%2C3%205%2C4.6%204.338%2C5.119%203%2C6%20v%204%20H%202%20v%202%20H%208%20V%201%20L%207%2C0%20z%20M%204%2C10%20V%206%20l%201%2C1%20v%203%20H%204%20z%20m%202%2C0%20V%206%20l%201%2C1%20v%203%20H%206%20z%22%20fill%3D%22%23aaa%22%20fill-rule%3D%22evenodd%22%2F%3E%0A%3C%2Fsvg%3E%0A);width:8px;height:12px;background-size:8px 12px}.dg-map-geoclicker__purpose_type_settlement:before{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2212%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%209%2C9%20C%208.235%2C9%207.762%2C9.522%207.259%2C10.022%207.795%2C10.38%208.051%2C11.05%207.879%2C12%20H%2012%20C%2012%2C10.46%2010.535%2C9%209%2C9%20z%20m%20-2.868%2C1.248%20c%20-0.965%2C0%20-1.747%2C0.784%20-1.747%2C1.751%20h%203.494%20c%200%2C-0.967%20-0.782%2C-1.751%20-1.747%2C-1.751%20z%20M%2010%2C1%20V%200%20H%207%20V%201%20H%205%20V%206%20L%206%2C7%20V%202%20H%207%20V%207%20L%208%2C8%20V%202%20h%201%20v%206%20h%201%20V%202%20h%201%20v%207%20l%201%2C0.607%20V%201%20H%2010%20z%20M%206.66%2C9.539%206.721%2C9.479%20C%206.903%2C9.297%207.104%2C9.14%207.314%2C9.004%20V%208.414%20L%206.131%2C7.187%203%2C8%20v%204%20H%203.62%20C%203.62%2C10.612%204.747%2C9.483%206.132%2C9.483%206.312%2C9.482%206.49%2C9.502%206.66%2C9.539%20z%20M%202%2C12%20z%20M%201%2C2%200%2C5%20v%207%20H%202%20V%205%20L%201%2C2%20z%20M%201.111%2C6.955%20C%200.804%2C6.955%200.556%2C6.706%200.556%2C6.4%20c%200%2C-0.307%200.248%2C-0.555%200.555%2C-0.555%200.307%2C0%200.554%2C0.248%200.554%2C0.555%200%2C0.306%20-0.247%2C0.555%20-0.554%2C0.555%20z%22%20fill%3D%22%23a0a0a0%22%2F%3E%0A%3C%2Fsvg%3E%0A);width:12px;height:12px;background-size:12px 12px}.no-touch a.dg-map-geoclicker__show-more-sights-link:hover{color:#9cd}a.dg-map-geoclicker__show-more-sights-link:after{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%226%22%20height%3D%2210%22%20viewBox%3D%220%200%206%2010%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%206%2C5%20V%205.4%20L%201.4%2C10%20H%200%20L%200%2C8.6%203.6%2C5%200%2C1.4%200%2C0%201.4%2C0%206%2C4.6%20V%205%20l%200%2C0%200%2C0%200%2C0%200%2C0%200%2C0%20z%22%20fill%3D%22%23aaa%22%20fill-rule%3D%22evenodd%22%2F%3E%0A%3C%2Fsvg%3E%0A)}.dg-map-geoclicker__drilldown{margin-bottom:10px;color:#aaa}.dg-preloader{position:relative;margin:0 auto;width:200px;height:44px;vertical-align:middle}.dg-preloader_animation_false{background-repeat:no-repeat;background-image:url(https://maps.api.2gis.ru/2.0/img/DGPreloader__preloader.gif);background-size:100px 26px;background-attachment:scroll;background-position:50% 50%}.dg-preloader_animation_true:before{margin:-22px 0 0 -22px;width:44px;height:44px;-webkit-animation:dg-preloader__outer 5s linear infinite;animation:dg-preloader__outer 5s linear infinite}.dg-preloader_animation_true.dg-preloader_size_small:before{margin:-12px 0 0 -12px;width:24px;height:24px}.dg-preloader_animation_true.dg-preloader_scheme_regular:before{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2244%22%20height%3D%2244%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%2035.68%2C10.32%20C%2038.368%2C13.465%2040%2C17.539%2040%2C22%2040%2C31.941%2031.941%2C40%2022%2C40%2012.059%2C40%204%2C31.941%204%2C22%204%2C17.539%205.632%2C13.465%208.32%2C10.32%20L%205.48%2C7.48%20C%202.07%2C11.354%200%2C16.434%200%2C22%200%2C34.15%209.85%2C44%2022%2C44%2034.15%2C44%2044%2C34.15%2044%2C22%2044%2C16.434%2041.93%2C11.354%2038.52%2C7.48%20l%20-2.84%2C2.84%20z%22%20fill%3D%22%230da5d5%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%209.271%2C9.272%20C%2012.529%2C6.015%2017.029%2C4%2022%2C4%2026.971%2C4%2031.471%2C6.015%2034.729%2C9.272%20L%2037.557%2C6.444%20C%2033.575%2C2.462%2028.075%2C0%2022%2C0%2015.925%2C0%2010.425%2C2.462%206.443%2C6.444%20l%202.828%2C2.828%20z%22%20fill%3D%22%23a6cd2a%22%2F%3E%0A%3C%2Fsvg%3E%0A);background-size:44px 44px}.dg-preloader_animation_true.dg-preloader_scheme_regular.dg-preloader_size_small:before{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%2018.564%2C7.435%20C%2019.467%2C8.73%2020%2C10.302%2020%2C12%2020%2C16.418%2016.418%2C20%2012%2C20%207.582%2C20%204%2C16.418%204%2C12%204%2C10.302%204.533%2C8.73%205.436%2C7.435%20L%202.581%2C4.581%20C%200.969%2C6.623%200%2C9.195%200%2C12%200%2C18.627%205.373%2C24%2012%2C24%2018.627%2C24%2024%2C18.627%2024%2C12%2024%2C9.195%2023.031%2C6.623%2021.419%2C4.581%20l%20-2.855%2C2.854%20z%22%20fill%3D%22%230da5d5%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%2012%2C0%20C%208.686%2C0%205.686%2C1.343%203.516%2C3.515%20L%206.343%2C6.343%20C%207.791%2C4.895%209.791%2C4%2012%2C4%20c%202.209%2C0%204.209%2C0.895%205.657%2C2.343%20L%2020.484%2C3.515%20C%2018.314%2C1.343%2015.314%2C0%2012%2C0%20z%22%20fill%3D%22%23a6cd2a%22%2F%3E%0A%3C%2Fsvg%3E%0A);background-size:24px 24px}.dg-preloader_animation_true:after{margin:-16px 0 0 -16px;width:32px;height:32px;-webkit-animation:dg-preloader__inner 4s linear infinite;animation:dg-preloader__inner 4s linear infinite}.dg-preloader_animation_true.dg-preloader_size_small:after{margin:-6px 0 0 -6px;width:12px;height:12px}.dg-preloader_animation_true.dg-preloader_scheme_regular:after{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2232%22%20height%3D%2232%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%206.581%2C23.419%20C%204.969%2C21.377%204%2C18.804%204%2C16%204%2C9.373%209.373%2C4%2016%2C4%20c%206.627%2C0%2012%2C5.373%2012%2C12%200%2C2.804%20-0.969%2C5.377%20-2.581%2C7.419%20l%202.847%2C2.847%20C%2030.594%2C23.487%2032%2C19.909%2032%2C16%2032%2C7.163%2024.837%2C0%2016%2C0%207.163%2C0%200%2C7.163%200%2C16%20c%200%2C3.909%201.406%2C7.487%203.734%2C10.266%20l%202.847%2C-2.847%20z%22%20fill%3D%22%23a6cd2a%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%2027.314%2C27.314%2024.486%2C24.486%20C%2022.314%2C26.657%2019.314%2C28%2016%2C28%2012.686%2C28%209.686%2C26.657%207.516%2C24.485%20L%204.688%2C27.313%20C%207.582%2C30.209%2011.582%2C32%2016%2C32%20c%204.418%2C0%208.418%2C-1.791%2011.314%2C-4.686%20z%22%20fill%3D%22%230da5d5%22%2F%3E%0A%3C%2Fsvg%3E%0A);background-size:32px 32px}.dg-preloader_animation_true.dg-preloader_scheme_regular.dg-preloader_size_small:after{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2212%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%203.141%2C6.86%20C%203.059%2C6.586%203%2C6.301%203%2C6%203%2C4.343%204.343%2C3%206%2C3%207.657%2C3%209%2C4.343%209%2C6%209%2C6.301%208.941%2C6.586%208.859%2C6.86%20l%202.26%2C2.259%20C%2011.674%2C8.209%2012%2C7.144%2012%2C6%2012%2C2.686%209.314%2C0%206%2C0%202.686%2C0%200%2C2.686%200%2C6%200%2C7.144%200.326%2C8.209%200.881%2C9.119%20L%203.141%2C6.86%20z%22%20fill%3D%22%23a6cd2a%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22m%206%2C12%20c%201.657%2C0%203.157%2C-0.672%204.243%2C-1.757%20L%208.122%2C8.122%20C%207.578%2C8.664%206.828%2C9%206%2C9%205.172%2C9%204.422%2C8.664%203.879%2C8.121%20L%201.758%2C10.242%20C%202.843%2C11.328%204.343%2C12%206%2C12%20z%22%20fill%3D%22%230da5d5%22%2F%3E%0A%3C%2Fsvg%3E%0A);background-size:12px 12px}@-webkit-keyframes dg-preloader__outer{to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes dg-preloader__outer{to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@-webkit-keyframes dg-preloader__inner{to{-webkit-transform:rotate(-360deg);transform:rotate(-360deg)}}@keyframes dg-preloader__inner{to{-webkit-transform:rotate(-360deg);transform:rotate(-360deg)}}.dg-popup__footer-buttons{display:table;margin-top:10px;width:100%}.dg-popup__footer-button-wrapper{display:table-cell}.dg-popup__footer-button{position:relative;display:inline-block;-webkit-box-sizing:border-box;box-sizing:border-box;margin-left:5%;width:95%;border-radius:2px;text-align:center;text-decoration:none;font:12px/24px Arial,sans-serif;cursor:pointer;-webkit-transition:all .1s;transition:all .1s}.dg-popup__footer-button-wrapper:first-child .dg-popup__footer-button{margin:0;width:100%}.dg-popup__footer-icon-button:before{display:inline-block;margin:-2px 5px 0 0;width:12px;height:12px;background-size:contain;background-repeat:no-repeat;content:'';vertical-align:middle}.dg-popup__button_name_back:before,.dg-popup__button_name_firm-card-back:before,.dg-popup__button_name_firm-list-back:before{width:9px;height:6px}.dg-popup__show-less-house-link{position:relative;top:6px;margin:0 15px 10px;color:#0070c0;text-decoration:none;font-size:12px;line-height:24px}.dg-popup__header-links{margin:8px 18px 0 0}.dg-popup__header-title_for_firmcard{position:relative;overflow:hidden;max-height:3.4em}.dg-popup__header-teaser{display:-webkit-box;height:3.3em;-webkit-line-clamp:3;-webkit-box-orient:vertical}.dg-popup__header-title{display:block;white-space:normal;font:22px/24px 'Arial narrow',Arial,sans-serif}.dg-popup__header-link,.dg-popup__rating{display:inline-block;vertical-align:middle}.dg-firm-card__link,.dg-popup__header-link,.dg-schedule__string-time,.dg-schedule__table-cell-group,.dg-schedule__today-inner{white-space:nowrap}.dg-popup__header-link{margin-left:2.6em}.dg-popup__header-link:first-child{margin-left:1.2em}.dg-popup__rating{margin:0 .4em 3px 0;width:70px;height:14px}.dg-popup__rating-stars{background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2214%22%20height%3D%2214%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%206.999%2C0%208.748%2C4.989%2013.997%2C4.991%209.83%2C8.708%2011.324%2C14.002%206.999%2C10.871%202.674%2C14.002%204.168%2C8.708%200%2C4.991%205.249%2C4.989%206.999%2C0%20z%22%20fill%3D%22%23ffc84b%22%2F%3E%0A%3C%2Fsvg%3E%0A);float:left;height:100%}.dg-popup__link{position:relative;background-position:center bottom;background-size:10px 1px;background-repeat:repeat-x;text-decoration:none;-webkit-tap-highlight-color:transparent}.dg-popup__link_type_booklet:before,.dg-popup__link_type_photos:before{position:absolute;top:2px;left:-18px;display:inherit;content:'';width:12px;height:10px}.dg-popup__link_type_flamp_reviews{margin-left:.1em}.dg-popup__link_type_booklet:before{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22m%200%2C8%203%2C2%20V%202%20L%200%2C0%20V%208%20z%20M%204%2C10%208%2C8%20V%200%20L%204%2C2%20v%208%20z%20M%209%2C0%20v%208%20l%203%2C2%20V%202%20L%209%2C0%20z%22%20fill%3D%22%237dc814%22%20fill-rule%3D%22evenodd%22%2F%3E%0A%3C%2Fsvg%3E%0A);background-size:12px 10px}a.dg-popup__link{background-image:-webkit-gradient(linear,left top,right top,from(rgba(255,230,170,.3)),to(rgba(255,230,170,.3)));background-image:-webkit-linear-gradient(left,rgba(255,230,170,.3),rgba(255,230,170,.3) 100%);background-image:linear-gradient(to right,rgba(255,230,170,.3),rgba(255,230,170,.3) 100%);color:#ffe6aa}.no-touch .dg-firm-card__link a:hover,.no-touch a.dg-popup__link:hover{background-image:-webkit-gradient(linear,left top,right top,from(rgba(153,204,221,.3)),to(rgba(153,204,221,.3)));background-image:-webkit-linear-gradient(left,rgba(153,204,221,.3),rgba(153,204,221,.3) 100%)}.no-touch a.dg-popup__link:hover{background-image:linear-gradient(to right,rgba(153,204,221,.3),rgba(153,204,221,.3) 100%);color:#9cd}.dg-popup__header-title{color:#ffc84b}.dg-popup__footer-button-wrapper .dg-popup__footer-button,.dg-popup__footer-button-wrapper .dg-popup__footer-button:hover{color:#e6e6e6}.dg-popup__footer-button{background:rgba(0,0,0,.2);-webkit-box-shadow:0 1px rgba(0,0,0,.1);box-shadow:0 1px rgba(0,0,0,.1)}.no-touch .dg-popup__footer-button:hover{-webkit-transition:all .2s;transition:all .2s;background:#222;-webkit-box-shadow:0 1px 3px rgba(0,0,0,.5);box-shadow:0 1px 3px rgba(0,0,0,.5)}.dg-popup__rating{background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2214%22%20height%3D%2214%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%207.002%2C0%208.751%2C4.989%2014%2C4.991%209.833%2C8.708%2011.327%2C14.002%207.002%2C10.871%202.677%2C14.002%204.171%2C8.708%200.003%2C4.991%205.252%2C4.989%207.002%2C0%20z%22%20fill%3D%22%23aaa%22%2F%3E%0A%3C%2Fsvg%3E%0A)}.dg-popup__link_type_photos:before{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%2011%2C1%20H%2010%20L%209%2C0%20H%206%20L%205%2C1%20H%201%20L%200%2C2%20v%207%20l%201%2C1%20H%2011%20L%2012%2C9%20V%202%20L%2011%2C1%20z%20M%203%2C4%20H%202%20V%203%20h%201%20v%201%20z%20m%204.518%2C3.992%20c%20-1.381%2C0%20-2.5%2C-1.119%20-2.5%2C-2.5%200%2C-1.38%201.119%2C-2.5%202.5%2C-2.5%201.38%2C0%202.5%2C1.12%202.5%2C2.5%200%2C1.381%20-1.121%2C2.5%20-2.5%2C2.5%20z%22%20fill%3D%22%2379b0bc%22%20fill-rule%3D%22evenodd%22%2F%3E%0A%3C%2Fsvg%3E%0A);background-size:12px 10px}.dg-popup__button_name_back:before,.dg-popup__button_name_firm-card-back:before,.dg-popup__button_name_firm-list-back:before{background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%229%22%20height%3D%226%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%200%2C3%204%2C6%20V%204%20H%209%20V%202%20H%204%20V%200%20z%22%20fill%3D%22%239f9f9f%22%2F%3E%0A%3C%2Fsvg%3E%0A);background-repeat:no-repeat}.dg-popup__button_name_back:before{width:9px;height:6px;background-size:9px 6px}.dg-popup__button_name_goto:before{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2220%22%20height%3D%227%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%2016.5%2C0%20C%2014.738%2C0%2013.295%2C1.306%2013.051%2C3%20H%204.949%20C%204.718%2C1.858%203.71%2C1%202.5%2C1%201.119%2C1%200%2C2.119%200%2C3.5%200%2C4.881%201.119%2C6%202.5%2C6%203.71%2C6%204.718%2C5.142%204.949%2C4%20h%208.102%20C%2013.295%2C5.693%2014.739%2C7%2016.5%2C7%2018.433%2C7%2020%2C5.433%2020%2C3.5%2020%2C1.566%2018.433%2C0%2016.5%2C0%20z%22%20fill%3D%22%239f9f9f%22%2F%3E%0A%3C%2Fsvg%3E%0A);width:20px;height:7px;background-size:20px 7px}.dg-popup__button_name_show-entrance:before{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2212%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%205%2C9%209%2C6%205%2C3%20V%205%20H%200%20V%207%20H%205%20V%209%20z%20M%209.6%2C0%20H%202.4%20C%201.074%2C0%200%2C1.074%200%2C2.4%20V%204%20H%202%20V%203.6%20C%202%2C2.716%202.716%2C2%203.6%2C2%20H%208.4%20C%209.283%2C2%2010%2C2.716%2010%2C3.6%20V%208.4%20C%2010%2C9.284%209.283%2C10%208.4%2C10%20H%203.6%20C%202.716%2C10%202%2C9.284%202%2C8.4%20V%208%20H%200%20V%209.6%20C%200%2C10.925%201.074%2C12%202.4%2C12%20H%209.6%20C%2010.926%2C12%2012%2C10.925%2012%2C9.6%20V%202.4%20C%2012%2C1.074%2010.926%2C0%209.6%2C0%20z%22%20fill%3D%22%23a0a0a0%22%20fill-rule%3D%22evenodd%22%2F%3E%0A%3C%2Fsvg%3E%0A)}.dg-firm-card__icon{position:relative;padding-left:24px}.dg-firm-card__address:before,.dg-firm-card__icon:before{position:absolute;content:''}.dg-firm-card__icon:before{top:0;left:0;margin:auto;background-position:0 50%;background-repeat:no-repeat}.dg-firm-card__link{overflow:hidden;margin-bottom:4px;text-overflow:ellipsis;word-wrap:normal;line-height:16px}.dg-firm-card__link a{background-position:center bottom;background-size:10px 1px;background-repeat:repeat-x;text-decoration:none;background-image:-webkit-gradient(linear,left top,right top,from(rgba(255,230,170,.3)),to(rgba(255,230,170,.3)));background-image:-webkit-linear-gradient(left,rgba(255,230,170,.3),rgba(255,230,170,.3) 100%);background-image:linear-gradient(to right,rgba(255,230,170,.3),rgba(255,230,170,.3) 100%);color:#ffe6aa}.dg-firm-card__address{margin-bottom:10px;font-size:16px}.dg-firm-card__address:before{top:5px;left:1px}.dg-firm-card__comment{position:relative;margin-left:5px;font-size:12px}.dg-firm-card__phone{overflow:hidden;margin-bottom:4px;text-overflow:ellipsis;line-height:16px}.dg-firm-card__phone:before{top:3px;left:1px}.dg-firm-card__site:before{top:3px}.dg-firm-card__rubrics{overflow:hidden;margin-bottom:4px;font-size:12px;line-height:16px}.dg-firm-card__rubrics-list{margin:0;padding:0;list-style:none}.dg-firm-card__rubrics-list-item{display:inline;cursor:default}.dg-firm-card__rubrics-list-item:before{display:inline-block;margin:0 4px;content:'•'}.dg-firm-card__rubrics-list-item:first-child:before{margin:0;content:''}.dg-firm-card__aa{margin:0 0 4px;padding:0 0 0 24px;font-size:12px}.dg-firm-card__aa-list{display:inline;margin:0;padding:0;list-style:none;line-height:16px}.dg-firm-card__aa-list-item{display:inline;-webkit-box-sizing:border-box;box-sizing:border-box;max-width:100%;cursor:default}.dg-firm-card__aa-list-item:before{display:inline-block;margin:0 4px;content:'•'}.dg-control-round__icon_name_ruler:after,.dg-control-round__icon_name_traffic:after,.dg-firm-card__aa-list-item:first-child:before,.dg-schedule__today:after,.dg-schedule__today:before{content:''}.dg-firm-card__aa-list-item:first-child:before{margin:0}.dg-firm-card__aa-list-additional{display:inline;margin:0;padding:0;list-style:none;line-height:16px}.dg-firm-card__schedule{margin-bottom:10px}.no-touch .dg-firm-card__link a:hover{background-image:linear-gradient(to right,rgba(153,204,221,.3),rgba(153,204,221,.3) 100%);color:#9cd}.dg-firm-card__comment,.dg-firm-card__rubrics{color:#aaa}.dg-firm-card__rubrics-list-item:after{color:#6e6964}.dg-firm-card__aa-list-item:after{color:#e6e6e6}.dg-firm-card__address:before{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%229%22%20height%3D%2211%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%204.958%2C11%20C%204.958%2C9.036%206.756%2C6.751%208.719%2C6.751%208.885%2C6.223%209%2C5.656%209%2C5.063%209%2C2.267%206.985%2C0%204.5%2C0%202.015%2C0%200%2C2.267%200%2C5.063%200%2C5.656%200.114%2C6.222%200.28%2C6.751%202.243%2C6.751%204.018%2C9.012%204.018%2C11%20h%200.94%20z%22%20fill%3D%22%23a0a0a0%22%2F%3E%0A%3C%2Fsvg%3E%0A);width:9px;height:11px;background-size:9px 11px}.dg-firm-card__phone:before{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2210%22%20height%3D%2210%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%209.181%2C9.05%20C%208.673%2C9.556%208.047%2C9.873%207.391%2C10%206.156%2C9.841%205.008%2C9.417%203.998%2C8.788%20L%201.293%2C6.092%20C%200.639%2C5.053%200.203%2C3.865%200.052%2C2.589%200.19%2C1.964%200.494%2C1.368%200.983%2C0.882%20L%201.803%2C0.065%203.987%2C2.241%20V%202.79%20L%203.441%2C3.332%20c%20-0.452%2C0.451%20-0.453%2C1.183%200%2C1.634%20L%205.082%2C6.6%20c%200.452%2C0.451%201.187%2C0.451%201.639%2C0%20L%207.244%2C6.079%20H%207.838%20L%2010%2C8.233%209.181%2C9.05%20z%22%20fill%3D%22%23a0a0a0%22%20fill-rule%3D%22evenodd%22%2F%3E%0A%3C%2Fsvg%3E%0A);width:10px;height:10px;background-size:10px 10px}.dg-firm-card__site:before{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2211%22%20height%3D%2211%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%205.5%2C11%20C%202.463%2C11%200%2C8.538%200%2C5.5%200%2C2.462%202.463%2C0%205.5%2C0%208.537%2C0%2011%2C2.462%2011%2C5.5%2011%2C8.538%208.537%2C11%205.5%2C11%20z%20m%200%2C-9%20C%203.566%2C2%202%2C3.567%202%2C5.5%202%2C7.433%203.566%2C9%205.5%2C9%205.655%2C9%205.804%2C8.974%205.954%2C8.954%20L%203%2C6%20V%205%20L%205.571%2C3.286%205.984%2C2.049%20C%205.824%2C2.026%205.666%2C2%205.5%2C2%20z%20M%208.949%2C5%20H%207.375%20C%207.021%2C5.505%206.545%2C6.082%206%2C6.497%20V%208.95%20C%207.693%2C8.705%209%2C7.262%209%2C5.5%209%2C5.329%208.974%2C5.165%208.949%2C5%20z%22%20fill%3D%22%23a0a0a0%22%20fill-rule%3D%22evenodd%22%2F%3E%0A%3C%2Fsvg%3E%0A);width:11px;height:11px;background-size:11px 11px}.dg-firm-card__email:before{top:5px;background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2211%22%20height%3D%227%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22m%2011%2C1.555%20v%203.89%20C%2011%2C6.303%2010.242%2C7%209.309%2C7%20H%201.692%20C%200.758%2C7%200%2C6.303%200%2C5.444%20V%201.554%20L%205.5%2C4.826%2011%2C1.555%20z%20M%200.191%2C0%20H%2010.808%20L%205.5%2C3.111%200.191%2C0%20z%22%20fill%3D%22%23aaa%22%20fill-rule%3D%22evenodd%22%2F%3E%0A%3C%2Fsvg%3E%0A);width:11px;height:7px;background-size:11px 7px}.dg-schedule__today{position:relative;display:inline-block;margin-left:24px;max-width:84%;background-position:center bottom;background-size:2px 1px;background-repeat:repeat-x;font-size:14px;line-height:16px;cursor:pointer}.dg-schedule__today:before{position:absolute;top:3px;left:-24px}.dg-schedule__today-inner{overflow:hidden;width:100%;text-overflow:ellipsis}.dg-schedule_works-everyday_true .dg-schedule__today{background-image:none;cursor:default}.dg-schedule_works-everyday_true .dg-schedule__today:after{background-image:none}.dg-schedule_open_true .dg-schedule__today:before{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2211%22%20height%3D%2211%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%205.5%2C11%20C%202.463%2C11%200%2C8.537%200%2C5.5%200%2C2.462%202.463%2C0%205.5%2C0%208.537%2C0%2011%2C2.462%2011%2C5.5%2011%2C8.537%208.537%2C11%205.5%2C11%20z%20M%206%2C5.293%20V%202%20H%205%20V%205.707%20L%207.646%2C8.353%208.353%2C7.646%206%2C5.293%20z%22%20fill%3D%22%2370bf00%22%20fill-rule%3D%22evenodd%22%2F%3E%0A%3C%2Fsvg%3E%0A);width:11px;height:11px;background-size:11px 11px}.dg-schedule__now{margin:2px 7px 0 36px;font-size:12px}.dg-schedule__string{padding:3px 16px 3px 24px;font-size:14px}.dg-schedule__table{display:none;text-align:center;font-size:0}.dg-schedule__tc{display:inline-block;padding:2px 0 15px;width:44px;vertical-align:top;white-space:normal;font-size:14px}.dg-schedule__tc_pre{width:19px}.dg-schedule__day-name{margin:0;color:#8c8782;text-transform:capitalize}.dg-schedule__td{margin:10px 0 0}.dg-schedule_state_expanded .dg-schedule__popup{display:block;visibility:visible;max-height:1000px;opacity:1}.dg-schedule__table-clock{margin:13px 0 0}.dg-schedule__today{background-image:-webkit-gradient(linear,left top,right top,from(rgba(230,230,230,.55)),color-stop(50%,rgba(230,230,230,.55)),color-stop(51%,rgba(0,0,0,0)),to(rgba(0,0,0,0)));background-image:-webkit-linear-gradient(left,rgba(230,230,230,.55),rgba(230,230,230,.55) 50%,rgba(0,0,0,0) 51%,rgba(0,0,0,0) 100%);background-image:linear-gradient(to right,rgba(230,230,230,.55),rgba(230,230,230,.55) 50%,rgba(0,0,0,0) 51%,rgba(0,0,0,0) 100%)}.dg-schedule__now{color:#aaa}.dg-schedule__string-time,.dg-schedule__td{color:#e6e6e6}.dg-schedule__tc_active_true{background:rgba(255,255,255,.1)}.dg-schedule__table-clock{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2211%22%20height%3D%2211%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%205.5%2C11%20C%202.463%2C11%200%2C8.537%200%2C5.5%200%2C2.462%202.463%2C0%205.5%2C0%208.537%2C0%2011%2C2.462%2011%2C5.5%2011%2C8.537%208.537%2C11%205.5%2C11%20z%20M%206%2C5.293%20V%202%20H%205%20V%205.707%20L%207.646%2C8.353%208.353%2C7.646%206%2C5.293%20z%22%20fill%3D%22%23a0a0a0%22%20fill-rule%3D%22evenodd%22%2F%3E%0A%3C%2Fsvg%3E%0A);width:11px;height:11px;background-size:11px 11px}.dg-schedule__table-lunch{margin:31px 0 0;background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2211%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%204%2C7%20H%208%20C%208.58%2C7%209.461%2C6.084%209.826%2C4.977%20V%205%20C%2011.047%2C5%2012%2C3.453%2012%2C2.031%2012%2C1.453%2011.531%2C1%2011.016%2C1%20H%2010%20C%2010%2C0.188%209.781%2C0%209%2C0%20H%203%20C%202.297%2C0%202%2C0.188%202%2C1%20v%203%20c%200%2C1.49%201.137%2C3%202%2C3%20z%20m%206%2C-5%20h%200.5%20C%2010.875%2C2%2011%2C2.219%2011%2C2.5%2011%2C3.625%2010.562%2C4%2010%2C4%20V%202%20z%20M%200%2C9%20c%200%2C0.448%201.791%2C1%203%2C1%200%2C0.405%200.646%2C1%201%2C1%20h%204%20c%200.354%2C0%201%2C-0.595%201%2C-1%201.208%2C0%203%2C-0.552%203%2C-1%20V%208%20H%200%20v%201%20z%22%20fill%3D%22%23aaa5a0%22%2F%3E%0A%3C%2Fsvg%3E%0A);width:12px;height:11px;background-size:12px 11px}.dg-schedule_open_false .dg-schedule__today:before{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2211%22%20height%3D%2211%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%205.5%2C11%20C%202.463%2C11%200%2C8.537%200%2C5.5%200%2C2.462%202.463%2C0%205.5%2C0%208.537%2C0%2011%2C2.462%2011%2C5.5%2011%2C8.537%208.537%2C11%205.5%2C11%20z%20M%206%2C5.293%20V%202%20H%205%20V%205.707%20L%207.646%2C8.353%208.353%2C7.646%206%2C5.293%20z%22%20fill%3D%22%23a0a0a0%22%20fill-rule%3D%22evenodd%22%2F%3E%0A%3C%2Fsvg%3E%0A);width:11px;height:11px;background-size:11px 11px}.dg-schedule__today:after,.dg-schedule__today_shown_true:after{background-repeat:no-repeat;height:6px;background-size:10px 6px;width:10px}.dg-schedule__today:after{position:absolute;right:-15px;bottom:4px;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2210%22%20height%3D%226%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%205%2C6%20H%204.586%20L%200%2C1.414%20V%200%20H%201.414%20L%205%2C3.586%208.586%2C0%20H%2010%20V%201.414%20L%205.414%2C6%20H%205%20z%22%20fill%3D%22%23a5a09c%22%20fill-rule%3D%22evenodd%22%2F%3E%0A%3C%2Fsvg%3E%0A)}.dg-schedule__today_shown_true:after{background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2210%22%20height%3D%226%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%205%2C0%20H%205.414%20L%2010%2C4.586%20V%206%20H%208.586%20L%205%2C2.414%201.414%2C6%20H%200%20V%204.586%20L%204.586%2C0%20H%205%20z%22%20fill%3D%22%23a5a09c%22%20fill-rule%3D%22evenodd%22%2F%3E%0A%3C%2Fsvg%3E%0A)}.dg-link,.dg-link:hover{background-position:0 95%;background-size:10px 1px;background-repeat:repeat-x}.dg-link_type_local{background:-webkit-gradient(linear,left top,right top,from(#9cd),color-stop(50%,#9cd),color-stop(50%,transparent));background:-webkit-linear-gradient(left,#9cd,#9cd 50%,transparent 50%);background:linear-gradient(to right,#9cd,#9cd 50%,transparent 50%)}.no-touch .dg-link_type_local:hover{background:-webkit-gradient(linear,left top,right top,from(#9bc),color-stop(50%,#9bc),color-stop(50%,transparent));background:-webkit-linear-gradient(left,#9bc,#9bc 50%,transparent 50%);background:linear-gradient(to right,#9bc,#9bc 50%,transparent 50%)}.dg-link.dg-link_type_local,.dg-link.dg-link_type_local:hover{background-size:6px 1px}.dg-control-round__icon_name_traffic:after{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2220%22%20height%3D%2214%22%20viewBox%3D%220%200%2020%2014%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%2018%2C5%20C%2018%2C4%2017%2C1%2015%2C1%20H%2012%2010%20C%208%2C1%207%2C4%207%2C5%20H%205%20v%202%20h%201%20v%204%20c%200%2C0.6%200%2C1%201%2C1%20v%202%20h%202%20v%20-2%20h%207%20v%202%20h%202%20v%20-2%20c%201%2C0%201%2C-0.4%201%2C-1%20V%207%20h%201%20V%205%20H%2018%20z%20M%2010%2C3%20h%202%203%20c%202%2C0%202%2C1%202%2C3%20H%208%20C%208%2C4%208%2C3%2010%2C3%20z%20M%209%2C10%20H%208%20C%207.4%2C10%207%2C9.6%207%2C9%207%2C8.4%207.4%2C8%208%2C8%20h%201%20c%200.6%2C0%201%2C0.4%201%2C1%200%2C0.6%20-0.4%2C1%20-1%2C1%20z%20m%208%2C0%20H%2016%20C%2015.4%2C10%2015%2C9.6%2015%2C9%2015%2C8.4%2015.4%2C8%2016%2C8%20h%201%20c%200.6%2C0%201%2C0.4%201%2C1%200%2C0.6%20-0.4%2C1%20-1%2C1%20z%20M%204%2C4%20H%206%20V%203%20H%204%20C%201%2C3%201%2C6%201%2C7%20H%200%20v%201%20h%201%20v%204%20H%203%20V%2011%20H%205%20V%207%20H%202%20C%202%2C6%202%2C4%204%2C4%20z%20M%203%2C9%204%2C10%20H%202%20V%209%20h%201%20z%22%20fill%3D%22%23616161%22%20fill-rule%3D%22evenodd%22%2F%3E%0A%20%20%20%20%3Cg%20fill%3D%22%23fff%22%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22m%2016%2C8%20h%201%20c%200.4%2C0%200.7%2C0.2%200.8%2C0.5%20C%2017.9%2C8.4%2018%2C8.2%2018%2C8%2018%2C7.4%2017.6%2C7%2017%2C7%20h%20-1%20c%20-0.6%2C0%20-1%2C0.4%20-1%2C1%200%2C0.2%200.1%2C0.4%200.2%2C0.5%20C%2015.3%2C8.2%2015.6%2C8%2016%2C8%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%208%2C8%20H%209%20C%209.4%2C8%209.7%2C8.2%209.8%2C8.5%209.9%2C8.4%2010%2C8.2%2010%2C8%2010%2C7.4%209.6%2C7%209%2C7%20H%208%20C%207.4%2C7%207%2C7.4%207%2C8%207%2C8.2%207.1%2C8.4%207.2%2C8.5%207.3%2C8.2%207.6%2C8%208%2C8%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%206%2C3%20H%204%20C%204%2C3%204%2C3%204%2C3%202%2C3%202%2C5%202%2C6%20H%202%20C%202.1%2C5%202.5%2C4%204%2C4%20H%205%206%20V%203%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M0%207H1V8H0z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%2015%2C2%20H%2012%2010%20C%208%2C2%208%2C3%208%2C5%20H%208%20C%208%2C3.7%208.3%2C3%2010%2C3%20h%202%203%20c%201.7%2C0%201.9%2C0.7%202%2C2%20h%200%20C%2017%2C3%2017%2C2%2015%2C2%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M3%209L4%209%203%208%202%208%202%209%202%209%202%209%203%209z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%207%2C11%20C%206%2C11%206%2C10.6%206%2C10%20v%201%20c%200%2C0.6%200%2C1%201%2C1%20v%20-1%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22m%2018%2C11%20v%201%20c%201%2C0%201%2C-0.4%201%2C-1%20v%20-1%20c%200%2C0.6%200%2C1%20-1%2C1%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M19%206H20V7H19z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M3%2011L1%2011%201%2012%203%2012%203%2011%205%2011%205%207%205%207%205%2010%203%2010z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M16%2013H18V14H16z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M5%206H6V7H5z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M9%2013L7%2013%207%2014%209%2014%209%2012%2016%2012%2016%2011%209%2011z%22%2F%3E%0A%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3Cg%20fill%3D%22%23444%22%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%202%2C6%20C%202%2C6.4%202%2C6.7%202%2C7%20H%205%20V%206%20H%202%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M2%209L2%2010%204%2010%203%209z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%204%2C3%20H%206%20V%202%20H%204%20C%201%2C2%201%2C5%201%2C6%20H%200%20V%207%20H%201%20C%201%2C6%201%2C3%204%2C3%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%2018%2C4%20C%2018%2C3%2017%2C0%2015%2C0%20H%2012%2010%20C%208%2C0%207%2C3%207%2C4%20H%206%205%20V%205%20H%207%20C%207%2C4%208%2C1%2010%2C1%20h%202%203%20c%202%2C0%203%2C3%203%2C4%20h%202%20V%204%20h%20-2%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%208%2C10%20H%209%20C%209.6%2C10%2010%2C9.6%2010%2C9%2010%2C8.8%209.9%2C8.6%209.8%2C8.5%209.7%2C8.8%209.4%2C9%209%2C9%20H%208%20C%207.6%2C9%207.3%2C8.8%207.2%2C8.5%207.1%2C8.6%207%2C8.8%207%2C9%20c%200%2C0.6%200.4%2C1%201%2C1%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%2017%2C6%20C%2017%2C5.6%2017%2C5.3%2017%2C5%20H%208%20c%200%2C0.3%200%2C0.6%200%2C1%20h%209%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%2017.8%2C8.5%20C%2017.7%2C8.8%2017.4%2C9%2017%2C9%20H%2016%20C%2015.6%2C9%2015.3%2C8.8%2015.2%2C8.5%2015.1%2C8.6%2015%2C8.8%2015%2C9%20c%200%2C0.6%200.4%2C1%201%2C1%20h%201%20c%200.6%2C0%201%2C-0.4%201%2C-1%200%2C-0.2%20-0.1%2C-0.4%20-0.2%2C-0.5%20z%22%2F%3E%0A%20%20%20%20%3C%2Fg%3E%0A%3C%2Fsvg%3E%0A);width:20px;height:14px;background-size:20px 14px;position:absolute;top:0;right:0;bottom:0;left:0;margin:auto}.dg-control-round__icon_name_traffic:active:after,.no-touch .dg-control-round__icon_name_traffic:hover:after{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2220%22%20height%3D%2214%22%20viewBox%3D%220%200%2020%2014%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%2018%2C5%20C%2018%2C4%2017%2C1%2015%2C1%20H%2012%2010%20C%208%2C1%207%2C4%207%2C5%20H%205%20v%202%20h%201%20v%204%20c%200%2C0.6%200%2C1%201%2C1%20v%202%20h%202%20v%20-2%20h%207%20v%202%20h%202%20v%20-2%20c%201%2C0%201%2C-0.4%201%2C-1%20V%207%20h%201%20V%205%20H%2018%20z%20M%2010%2C3%20h%202%203%20c%202%2C0%202%2C1%202%2C3%20H%208%20C%208%2C4%208%2C3%2010%2C3%20z%20M%209%2C10%20H%208%20C%207.4%2C10%207%2C9.6%207%2C9%207%2C8.4%207.4%2C8%208%2C8%20h%201%20c%200.6%2C0%201%2C0.4%201%2C1%200%2C0.6%20-0.4%2C1%20-1%2C1%20z%20m%208%2C0%20H%2016%20C%2015.4%2C10%2015%2C9.6%2015%2C9%2015%2C8.4%2015.4%2C8%2016%2C8%20h%201%20c%200.6%2C0%201%2C0.4%201%2C1%200%2C0.6%20-0.4%2C1%20-1%2C1%20z%20M%204%2C4%20H%206%20V%203%20H%204%20C%201%2C3%201%2C6%201%2C7%20H%200%20v%201%20h%201%20v%204%20H%203%20V%2011%20H%205%20V%207%20H%202%20C%202%2C6%202%2C4%204%2C4%20z%20M%203%2C9%204%2C10%20H%202%20V%209%20h%201%20z%22%20fill%3D%22%23424242%22%20fill-rule%3D%22evenodd%22%2F%3E%0A%20%20%20%20%3Cg%20fill%3D%22%23fff%22%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22m%2016%2C8%20h%201%20c%200.4%2C0%200.7%2C0.2%200.8%2C0.5%20C%2017.9%2C8.4%2018%2C8.2%2018%2C8%2018%2C7.4%2017.6%2C7%2017%2C7%20h%20-1%20c%20-0.6%2C0%20-1%2C0.4%20-1%2C1%200%2C0.2%200.1%2C0.4%200.2%2C0.5%20C%2015.3%2C8.2%2015.6%2C8%2016%2C8%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%208%2C8%20H%209%20C%209.4%2C8%209.7%2C8.2%209.8%2C8.5%209.9%2C8.4%2010%2C8.2%2010%2C8%2010%2C7.4%209.6%2C7%209%2C7%20H%208%20C%207.4%2C7%207%2C7.4%207%2C8%207%2C8.2%207.1%2C8.4%207.2%2C8.5%207.3%2C8.2%207.6%2C8%208%2C8%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%206%2C3%20H%204%20C%204%2C3%204%2C3%204%2C3%202%2C3%202%2C5%202%2C6%20H%202%20C%202.1%2C5%202.5%2C4%204%2C4%20H%205%206%20V%203%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M0%207H1V8H0z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%2015%2C2%20H%2012%2010%20C%208%2C2%208%2C3%208%2C5%20H%208%20C%208%2C3.7%208.3%2C3%2010%2C3%20h%202%203%20c%201.7%2C0%201.9%2C0.7%202%2C2%20h%200%20C%2017%2C3%2017%2C2%2015%2C2%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M3%209L4%209%203%208%202%208%202%209%202%209%202%209%203%209z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%207%2C11%20C%206%2C11%206%2C10.6%206%2C10%20v%201%20c%200%2C0.6%200%2C1%201%2C1%20v%20-1%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22m%2018%2C11%20v%201%20c%201%2C0%201%2C-0.4%201%2C-1%20v%20-1%20c%200%2C0.6%200%2C1%20-1%2C1%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M19%206H20V7H19z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M3%2011L1%2011%201%2012%203%2012%203%2011%205%2011%205%207%205%207%205%2010%203%2010z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M16%2013H18V14H16z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M5%206H6V7H5z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M9%2013L7%2013%207%2014%209%2014%209%2012%2016%2012%2016%2011%209%2011z%22%2F%3E%0A%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3Cg%20fill%3D%22%232e2e2e%22%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%202%2C6%20C%202%2C6.4%202%2C6.7%202%2C7%20H%205%20V%206%20H%202%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M2%209L2%2010%204%2010%203%209z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%204%2C3%20H%206%20V%202%20H%204%20C%201%2C2%201%2C5%201%2C6%20H%200%20V%207%20H%201%20C%201%2C6%201%2C3%204%2C3%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%2018%2C4%20C%2018%2C3%2017%2C0%2015%2C0%20H%2012%2010%20C%208%2C0%207%2C3%207%2C4%20H%206%205%20V%205%20H%207%20C%207%2C4%208%2C1%2010%2C1%20h%202%203%20c%202%2C0%203%2C3%203%2C4%20h%202%20V%204%20h%20-2%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%208%2C10%20H%209%20C%209.6%2C10%2010%2C9.6%2010%2C9%2010%2C8.8%209.9%2C8.6%209.8%2C8.5%209.7%2C8.8%209.4%2C9%209%2C9%20H%208%20C%207.6%2C9%207.3%2C8.8%207.2%2C8.5%207.1%2C8.6%207%2C8.8%207%2C9%20c%200%2C0.6%200.4%2C1%201%2C1%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%2017%2C6%20C%2017%2C5.6%2017%2C5.3%2017%2C5%20H%208%20c%200%2C0.3%200%2C0.6%200%2C1%20h%209%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%2017.8%2C8.5%20C%2017.7%2C8.8%2017.4%2C9%2017%2C9%20H%2016%20C%2015.6%2C9%2015.3%2C8.8%2015.2%2C8.5%2015.1%2C8.6%2015%2C8.8%2015%2C9%20c%200%2C0.6%200.4%2C1%201%2C1%20h%201%20c%200.6%2C0%201%2C-0.4%201%2C-1%200%2C-0.2%20-0.1%2C-0.4%20-0.2%2C-0.5%20z%22%2F%3E%0A%20%20%20%20%3C%2Fg%3E%0A%3C%2Fsvg%3E%0A)}.dg-control-round__icon_state_active.dg-control-round__icon_name_traffic:active:after,.dg-control-round__icon_state_active.dg-control-round__icon_name_traffic:after,.no-touch .dg-control-round__icon_state_active.dg-control-round__icon_name_traffic:hover:after{background-image:none}a.dg-traffic-control{z-index:0;color:#f2f2f2;text-decoration:none;text-shadow:0 1px 2px rgba(0,0,0,.3);font:400 15px/32px 'Arial narrow',Arial,sans-serif}a.dg-traffic-control_color_green:after,a.dg-traffic-control_color_red:after,a.dg-traffic-control_color_yellow:after{position:absolute;top:0;right:0;bottom:0;left:0;z-index:-1;margin:auto;width:22px;height:22px;border-radius:50%;-webkit-box-shadow:inset 0 1px 0 0 rgba(0,0,0,.2),0 1px 0 0 #fff;box-shadow:inset 0 1px 0 0 rgba(0,0,0,.2),0 1px 0 0 #fff}.no-touch a.dg-traffic-control:hover{color:#f2f2f2}.no-touch a.dg-traffic-control_color_green:hover:after,.no-touch a.dg-traffic-control_color_red:hover:after,.no-touch a.dg-traffic-control_color_yellow:hover:after{width:22px;height:22px}a.dg-traffic-control_color_green:after{background:#3fc03b}.no-touch a.dg-traffic-control_color_green:hover:after,a.dg-traffic-control_color_green:active:after{background:-webkit-gradient(linear,left bottom,left top,from(#2aa731),to(#53e13a)) #3ec435;background:-webkit-linear-gradient(bottom,#2aa731,#53e13a) #3ec435;background:linear-gradient(to top,#2aa731,#53e13a) #3ec435}a.dg-traffic-control_color_yellow:after{background:#f3b223}.no-touch a.dg-traffic-control_color_yellow:hover:after,a.dg-traffic-control_color_yellow:active:after{background:-webkit-gradient(linear,left bottom,left top,from(#ef931b),to(#f7be26)) #f4a820;background:-webkit-linear-gradient(bottom,#ef931b,#f7be26) #f4a820;background:linear-gradient(to top,#ef931b,#f7be26) #f4a820}a.dg-traffic-control_color_red:after{background:#eb240c}.no-touch a.dg-traffic-control_color_red:hover:after,a.dg-traffic-control_color_red:active:after{background:-webkit-gradient(linear,left bottom,left top,from(#c01c0a),to(#f73416)) #db2811;background:-webkit-linear-gradient(bottom,#c01c0a,#f73416) #db2811;background:linear-gradient(to top,#c01c0a,#f73416) #db2811}.leaflet-rulerMarker-pane{z-index:600}.dg-ruler__label{position:absolute;top:0;left:0;z-index:200;-webkit-tap-highlight-color:transparent}.dg-ruler__label-spacer{display:block}.dg-ruler__label-container{display:none;padding:2px 4px;border:4px solid #fff;border-radius:13px;background:#0da5d5;background-clip:padding-box;color:#fff;white-space:nowrap;font-size:12px}.dg-ruler__point{display:inline-block;margin:2px 4px 0 0;width:10px;height:10px;border-radius:5px;background:#fff}.dg-ruler__label-remove-link{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2212%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%206%2C0%20C%202.687%2C0%200%2C2.687%200%2C6%200%2C9.313%202.687%2C12%206%2C12%209.313%2C12%2012%2C9.313%2012%2C6%2012%2C2.687%209.313%2C0%206%2C0%20z%20M%209.401%2C9.398%208.8%2C9.6%206%2C6.8%203.199%2C9.6%202.59%2C9.415%202.375%2C8.774%205.199%2C6%202.399%2C3.175%202.62%2C2.591%203.175%2C2.375%205.949%2C5.225%208.774%2C2.375%209.415%2C2.605%209.566%2C3.196%206.824%2C6%209.6%2C8.8%209.401%2C9.398%20z%22%20fill%3D%22%23fff%22%20fill-rule%3D%22evenodd%22%2F%3E%0A%3C%2Fsvg%3E%0A);width:12px;height:12px;background-size:12px 12px;display:none;margin:1px 0 0 4px;vertical-align:top;-webkit-transition:all .2s ease;transition:all .2s ease}.no-touch .dg-ruler__label-remove-link:hover{-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg)}.dg-ruler__remove-link-overlay{position:absolute;top:-7px;right:-7px;bottom:-7px;width:40px}.no-touch .dg-ruler__remove-link-overlay{display:none}.dg-control-round__icon_name_ruler:after{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%229%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22m%2012.999%2C0%20v%204.001%20h%20-1%20V%200%20h%20-2%20v%202%20h%20-1%20V%200%20h%20-2%20V%202%20H%206%20V%200%20H%203.998%20v%204.001%20h%20-1%20V%200%20h%20-3%20V%208%20H%2016%20V%200%20z%22%20fill%3D%22%23616161%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22m%202.999%2C4%20h%201%20v%201%20h%20-1%20z%20m%203%2C-2%20h%201%20v%201%20h%20-1%20z%20m%203%2C0%20h%201%20v%201%20h%20-1%20z%20m%203%2C2%20h%201%20v%201%20h%20-1%20z%22%20fill%3D%22%23444%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%200%2C8%20H%2016%20V%209%20H%200%20z%22%20fill%3D%22%23fff%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%200%2C0%20H%203%20V%201%20H%200%20z%20m%2013%2C0%20h%203%20v%201%20h%20-3%20z%20m%20-3%2C0%20h%202%20V%201%20H%2010%20z%20M%207%2C0%20H%209%20V%201%20H%207%20z%20M%204%2C0%20H%206%20V%201%20H%204%20z%22%20fill%3D%22%23444%22%2F%3E%0A%3C%2Fsvg%3E%0A);width:16px;height:9px;background-size:16px 9px;position:absolute;top:0;right:0;bottom:0;left:0;margin:auto}.dg-control-round__icon_name_ruler:active:after,.no-touch .dg-control-round__icon_name_ruler:hover:after{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%229%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22m%2012.999%2C0%20v%204.001%20h%20-1%20V%200%20h%20-2%20v%202%20h%20-1%20V%200%20h%20-2%20V%202%20H%206%20V%200%20H%203.998%20v%204.001%20h%20-1%20V%200%20h%20-3%20V%208%20H%2016%20V%200%20z%22%20fill%3D%22%23424242%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22m%202.999%2C4%20h%201%20v%201%20h%20-1%20z%20m%203%2C-2%20h%201%20v%201%20h%20-1%20z%20m%203%2C0%20h%201%20v%201%20h%20-1%20z%20m%203%2C2%20h%201%20v%201%20h%20-1%20z%22%20fill%3D%22%232e2e2e%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%200%2C8%20H%2016%20V%209%20H%200%20z%22%20fill%3D%22%23fff%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%200%2C0%20H%203%20V%201%20H%200%20z%20m%2013%2C0%20h%203%20v%201%20h%20-3%20z%20m%20-3%2C0%20h%202%20V%201%20H%2010%20z%20M%207%2C0%20H%209%20V%201%20H%207%20z%20M%204%2C0%20H%206%20V%201%20H%204%20z%22%20fill%3D%22%232e2e2e%22%2F%3E%0A%3C%2Fsvg%3E%0A)}.dg-control-round__icon_state_active.dg-control-round__icon_name_ruler:active:after,.dg-control-round__icon_state_active.dg-control-round__icon_name_ruler:after,.no-touch .dg-control-round__icon_state_active.dg-control-round__icon_name_ruler:hover:after{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%229%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22m%2012.999%2C0%20v%204.001%20h%20-1%20V%200%20h%20-2%20v%202%20h%20-1%20V%200%20h%20-2%20V%202%20H%206%20V%200%20H%203.999%20v%204.001%20h%20-1%20V%200%20h%20-3%20V%208%20H%2016%20V%200%20z%22%20fill%3D%22%2321a7d6%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22m%202.999%2C4%20h%201%20v%201%20h%20-1%20z%20m%203%2C-2%20h%201%20v%201%20h%20-1%20z%20m%203%2C0%20h%201%20v%201%20h%20-1%20z%20m%203%2C2%20h%201%20v%201%20h%20-1%20z%22%20fill%3D%22%23147596%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%200%2C8%20H%2016%20V%209%20H%200%20z%22%20fill%3D%22%23fff%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%200%2C0%20H%203%20V%201%20H%200%20z%20m%2013%2C0%20h%203%20v%201%20h%20-3%20z%20m%20-3%2C0%20h%202%20V%201%20H%2010%20z%20M%207%2C0%20H%209%20V%201%20H%207%20z%20M%204%2C0%20H%206%20V%201%20H%204%20z%22%20fill%3D%22%23147596%22%2F%3E%0A%3C%2Fsvg%3E%0A)}";
	t("browserify-css").createStyle(o,{href:"dist/css/styles.full.dark.css"},{insertAt:"bottom"}),e.exports=o},{"browserify-css":3}],2:[function(_dereq_,module,exports){(function(process){function toPoint(t,e,i){return t instanceof DG.Point?t:DG.Util.isArray(t)?new DG.Point(t[0],t[1]):void 0===t||null===t?t:"object"==typeof t&&"x"in t&&"y"in t?new DG.Point(t.x,t.y):new DG.Point(t,e,i)}"function"!=typeof Array.prototype.reduce&&(Array.prototype.reduce=function(t,e){"use strict";if(null===this||"undefined"==typeof this)throw new TypeError("Array.prototype.reduce called on null or undefined");if("function"!=typeof t)throw new TypeError(t+" is not a function");var i,o,n=this.length>>>0,r=!1;for(1<arguments.length&&(o=e,r=!0),i=0;n>i;++i)this.hasOwnProperty(i)&&(r?o=t(o,this[i],i,this):(o=this[i],r=!0));if(!r)throw new TypeError("Reduce of empty array with no initial value");return o}),Array.prototype.forEach||(Array.prototype.forEach=function(t,e){"use strict";var i,o;if(null==this)throw new TypeError("this is null or not defined");var n,r=Object(this),a=r.length>>>0;if("[object Function]"!=={}.toString.call(t))throw new TypeError(t+" is not a function");for(arguments.length>=2&&(i=e),o=0;o<a;)o in r&&(n=r[o],t.call(i,n,o,r)),o++}),Object.keys||(Object.keys=function(){"use strict";var t=Object.prototype.hasOwnProperty,e=!{toString:null}.propertyIsEnumerable("toString"),i=["toString","toLocaleString","valueOf","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","constructor"],o=i.length;return function(n){if("object"!=typeof n&&("function"!=typeof n||null===n))throw new TypeError("Object.keys called on non-object");var r,a,s=[];for(r in n)t.call(n,r)&&s.push(r);if(e)for(a=0;a<o;a++)t.call(n,i[a])&&s.push(i[a]);return s}}()),Array.prototype.some||(Array.prototype.some=function(t){"use strict";if(void 0===this||null===this)throw new TypeError;var e=Object(this),i=e.length>>>0;if("function"!=typeof t)throw new TypeError;for(var o=arguments.length>=2?arguments[1]:void 0,n=0;n<i;n++)if(n in e&&t.call(o,e[n],n,e))return!0;return!1}),Array.prototype.map||(Array.prototype.map=function(t){"use strict";if(void 0===this||null===this)throw new TypeError;var e=Object(this),i=e.length>>>0;if("function"!=typeof t)throw new TypeError;for(var o=new Array(i),n=arguments.length>=2?arguments[1]:void 0,r=0;r<i;r++)r in e&&(o[r]=t.call(n,e[r],r,e));return o}),Array.prototype.filter||(Array.prototype.filter=function(t){"use strict";if(void 0===this||null===this)throw new TypeError;var e=Object(this),i=e.length>>>0;if("function"!=typeof t)throw new TypeError;for(var o=[],n=arguments.length>=2?arguments[1]:void 0,r=0;r<i;r++)if(r in e){var a=e[r];t.call(n,a,r,e)&&o.push(a)}return o}),Function.prototype.bind||(Function.prototype.bind=function(t){if("function"!=typeof this)throw new TypeError("Function.prototype.bind - what is trying to be bound is not callable");var e=Array.prototype.slice.call(arguments,1),i=this,o=function(){},n=function(){return i.apply(this instanceof o&&t?this:t,e.concat(Array.prototype.slice.call(arguments)))};return o.prototype=this.prototype,n.prototype=new o,n}),Array.prototype.indexOf||(Array.prototype.indexOf=function(t,e){if(void 0===this||null===this)throw new TypeError('"this" is null or not defined');var i=this.length>>>0;for(e=+e||0,Math.abs(e)===1/0&&(e=0),e<0&&(e+=i,e<0&&(e=0));e<i;e++)if(this[e]===t)return e;return-1}),"function"!=typeof Promise&&!function(){var t,e,i,o;!function(){var n={},r={};t=function(t,e,i){n[t]={deps:e,callback:i}},o=i=e=function(t){function i(e){if("."!==e.charAt(0))return e;for(var i=e.split("/"),o=t.split("/").slice(0,-1),n=0,r=i.length;n<r;n++){var a=i[n];if(".."===a)o.pop();else{if("."===a)continue;o.push(a)}}return o.join("/")}if(o._eak_seen=n,r[t])return r[t];if(r[t]={},!n[t])throw new Error("Could not find module "+t);for(var a,s=n[t],l=s.deps,u=s.callback,c=[],h=0,d=l.length;h<d;h++)"exports"===l[h]?c.push(a={}):c.push(e(i(l[h])));var p=u.apply(this,c);return r[t]=a||p}}(),t("promise/all",["./utils","exports"],function(t,e){"use strict";function i(t){var e=this;if(!o(t))throw new TypeError("You must pass an array to all.");return new e(function(e,i){function o(t){return function(e){r(t,e)}}function r(t,i){s[t]=i,0===--l&&e(s)}var a,s=[],l=t.length;0===l&&e([]);for(var u=0;u<t.length;u++)a=t[u],a&&n(a.then)?a.then(o(u),i):r(u,a)})}var o=t.isArray,n=t.isFunction;e.all=i}),t("promise/asap",["exports"],function(t){"use strict";function e(){return function(){process.nextTick(n)}}function i(){var t=0,e=new l(n),i=document.createTextNode("");return e.observe(i,{characterData:!0}),function(){i.data=t=++t%2}}function o(){return function(){u.setTimeout(n,1)}}function n(){for(var t=0;t<c.length;t++){var e=c[t],i=e[0],o=e[1];i(o)}c=[]}function r(t,e){var i=c.push([t,e]);1===i&&a()}var a,s="undefined"!=typeof window?window:{},l=s.MutationObserver||s.WebKitMutationObserver,u=window,c=[];a="undefined"!=typeof process&&"[object process]"==={}.toString.call(process)?e():l?i():o(),t.asap=r}),t("promise/config",["exports"],function(t){"use strict";function e(t,e){return 2!==arguments.length?i[t]:void(i[t]=e)}var i={instrument:!1};t.config=i,t.configure=e}),t("promise/polyfill",["./promise","./utils","exports"],function(t,e,i){"use strict";function o(){var t;t="undefined"!=typeof window&&window.document?window:self;var e="Promise"in t&&"resolve"in t.Promise&&"reject"in t.Promise&&"all"in t.Promise&&"race"in t.Promise&&function(){var e;return new t.Promise(function(t){e=t}),r(e)}();e||(t.Promise=n)}var n=t.Promise,r=e.isFunction;i.polyfill=o}),t("promise/promise",["./config","./utils","./all","./race","./resolve","./reject","./asap","exports"],function(t,e,i,o,n,r,a,s){"use strict";function l(t){if(!C(t))throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");if(!(this instanceof l))throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");this._subscribers=[],u(t,this)}function u(t,e){function i(t){_(e,t)}function o(t){f(e,t)}try{t(i,o)}catch(n){o(n)}}function c(t,e,i,o){var n,r,a,s,l=C(i);if(l)try{n=i(o),a=!0}catch(u){s=!0,r=u}else n=o,a=!0;p(e,n)||(l&&a?_(e,n):s?f(e,r):t===E?_(e,n):t===G&&f(e,n))}function h(t,e,i,o){var n=t._subscribers,r=n.length;n[r]=e,n[r+E]=i,n[r+G]=o}function d(t,e){for(var i,o,n=t._subscribers,r=t._detail,a=0;a<n.length;a+=3)i=n[a],o=n[a+e],c(e,i,o,r);t._subscribers=null}function p(t,e){var i,o=null;try{if(t===e)throw new TypeError("A promises callback cannot return that same promise.");if(b(e)&&(o=e.then,C(o)))return o.call(e,function(o){return!!i||(i=!0,void(e!==o?_(t,o):m(t,o)))},function(e){return!!i||(i=!0,void f(t,e))}),!0}catch(n){return!!i||(f(t,n),!0)}return!1}function _(t,e){t===e?m(t,e):p(t,e)||m(t,e)}function m(t,e){t._state===z&&(t._state=P,t._detail=e,y.async(g,t))}function f(t,e){t._state===z&&(t._state=P,t._detail=e,y.async(v,t))}function g(t){d(t,t._state=E)}function v(t){d(t,t._state=G)}var y=t.config,b=(t.configure,e.objectOrFunction),C=e.isFunction,w=(e.now,i.all),k=o.race,x=n.resolve,D=r.reject,L=a.asap;y.async=L;var z=void 0,P=0,E=1,G=2;l.prototype={constructor:l,_state:void 0,_detail:void 0,_subscribers:void 0,then:function(t,e){var i=this,o=new this.constructor(function(){});if(this._state){var n=arguments;y.async(function(){c(i._state,o,n[i._state-1],i._detail)})}else h(this,o,t,e);return o},"catch":function(t){return this.then(null,t)}},l.all=w,l.race=k,l.resolve=x,l.reject=D,s.Promise=l}),t("promise/race",["./utils","exports"],function(t,e){"use strict";function i(t){var e=this;if(!o(t))throw new TypeError("You must pass an array to race.");return new e(function(e,i){for(var o,n=0;n<t.length;n++)o=t[n],o&&"function"==typeof o.then?o.then(e,i):e(o)})}var o=t.isArray;e.race=i}),t("promise/reject",["exports"],function(t){"use strict";function e(t){var e=this;return new e(function(e,i){i(t)})}t.reject=e}),t("promise/resolve",["exports"],function(t){"use strict";function e(t){if(t&&"object"==typeof t&&t.constructor===this)return t;var e=this;return new e(function(e){e(t)})}t.resolve=e}),t("promise/utils",["exports"],function(t){"use strict";function e(t){return i(t)||"object"==typeof t&&null!==t}function i(t){return"function"==typeof t}function o(t){return"[object Array]"===Object.prototype.toString.call(t)}var n=Date.now||function(){return(new Date).getTime()};t.objectOrFunction=e,t.isFunction=i,t.isArray=o,t.now=n}),e("promise/polyfill").polyfill()}(),_dereq_("leaflet"),_dereq_("html5shiv");var oldDG=window.DG,DG=new(function(){var t=function(){},e=function(){};return e.prototype=L,t.prototype=new e,t}());for(var prop in oldDG)oldDG.hasOwnProperty(prop)&&"undefined"==typeof DG[prop]&&(DG[prop]=oldDG[prop]);window.__dgApi__=window.__dgApi__||{},DG.version=window.__dgApi__.version,DG.Icon.Default.imagePath="../img/vendors/leaflet",DG.Map.addInitHook(function(){var t=!1;return function(){t||(!function(t,e,i,o,n,r,a){t.GoogleAnalyticsObject=n,t[n]=t[n]||function(){(t[n].q=t[n].q||[]).push(arguments)},t[n].l=1*new Date,r=e.createElement(i),a=e.getElementsByTagName(i)[0],r.async=1,r.src=o,a.parentNode.insertBefore(r,a)}(window,document,"script",DG.config.googleAnalytics,"ga"),t=!0),ga("create",DG.config.gaCode,{storage:"none",name:DG.config.gaName,sampleRate:50}),ga(DG.config.gaName+".set","anonymizeIp",!0),ga(DG.config.gaName+".send","pageview")}}()),DG.Map.include({addHandler:function(t,e){if(!e)return this;var i=this.options[t],o=i===Object(i)?i:null,n=this[t]=new e(this,o);return this._handlers.push(n),i&&n.enable(),this}}),DG.Map.addInitHook(function(){DG.Browser.touchEnabled||DG.DomUtil.addClass(this._container,"no-touch")}),window.DG=DG,module.exports=DG;var handlers=window.__dgApi__.callbacks||[],chain=Promise.resolve();handlers.forEach(function(t){chain=chain.then(t[0],t[1])}),DG.then=function(t,e){return chain.then(t,e)},chain["catch"](function(t){console.error(t)}),DG.plugin=function(t){var e,i=new RegExp(/.js$/i),o=new RegExp(/.css$/i);return new Promise(function(n){function r(){e--,0===e&&n()}function a(t){var e=document.createElement("script");e.setAttribute("type","text/javascript"),e.setAttribute("src",t),e.onload=function(){r()},e.onerror=function(){r()},e.onreadystatechange=function(){"complete"!==e.readyState&&"loaded"!==e.readyState||r()},document.getElementsByTagName("head")[0].appendChild(e)}function s(t){var e=document.createElement("link");e.setAttribute("rel","stylesheet"),e.setAttribute("type","text/css"),e.setAttribute("href",t),document.getElementsByTagName("head")[0].appendChild(e),r()}function l(t){return i.test(t)}function u(t){return o.test(t)}function c(t){l(t)?a(t):u(t)?s(t):e--}DG.Util.isArray(t)&&(e=t.length,t.forEach(function(t){c(t)})),"string"==typeof t&&(e=1,c(t))})},DG.ajax=function(){function handleReadyState(t,e,i){return function(){return t._aborted?i(t.request):void(t.request&&4===t.request[readyState]&&(t.request.onreadystatechange=noop,twoHundo.test(t.request.status)?e(t.request):i(t.request)))}}function setHeaders(t,e){var i,o=e.headers||{};o.Accept=o.Accept||defaultHeaders.accept[e.dataType]||defaultHeaders.accept["*"],e.crossDomain||o[requestedWith]||(o[requestedWith]=defaultHeaders.requestedWith),o[contentType]||(o[contentType]=e.contentType||defaultHeaders.contentType);for(i in o)o.hasOwnProperty(i)&&"setRequestHeader"in t&&t.setRequestHeader(i,o[i])}function setCredentials(t,e){"undefined"!=typeof e.withCredentials&&"undefined"!=typeof t.withCredentials&&(t.withCredentials=!!e.withCredentials)}function generalCallback(t){lastValue=t}function urlappend(t,e){return t+(/\?/.test(t)?"&":"?")+e}function handleJsonp(t,e,i,o){var n=uniqid++,r=t.jsonpCallback||"callback",a=t.jsonpCallbackName||callbackPrefix,s=new RegExp("((^|\\?|&)"+r+")=([^&]+)"),l=o.match(s),u=doc.createElement("script"),c=0,h=navigator.userAgent.indexOf("MSIE 10.0")!==-1;return l?"?"===l[3]?o=o.replace(s,"$1="+a):a=l[3]:o=urlappend(o,r+"="+a),win[a]=generalCallback,u.type="text/javascript",u.src=o,u.async=!0,"undefined"==typeof u.onreadystatechange||h||(u.event="onclick",u.htmlFor=u.id="_request_"+n),u.onerror=function(){u.onerror=u.onload=u.onreadystatechange=null,i({},"Request unknown error",{}),lastValue=void 0,head.removeChild(u),c=1},u.onload=u.onreadystatechange=function(){return!(u[readyState]&&"complete"!==u[readyState]&&"loaded"!==u[readyState]||c)&&(u.onerror=u.onload=u.onreadystatechange=null,u.onclick&&u.onclick(),e(lastValue),lastValue=void 0,head.removeChild(u),void(c=1))},head.appendChild(u),{abort:function(){u.onerror=u.onload=u.onreadystatechange=null,i({},"Request is aborted: timeout",{}),lastValue=void 0,head.removeChild(u),c=1}}}function getRequest(t,e){var i,o=this.options,n=(o.type||"GET").toUpperCase(),r="string"==typeof o?o:o.url,a=o.processData!==!1&&o.data&&"string"!=typeof o.data?Ajax.toQueryString(o.data):o.data||null,s=!1;return"jsonp"!==o.type&&"GET"!==n||!a||(r=urlappend(r,a),a=null),"jsonp"===o.type?handleJsonp(o,t,e,r):(i=xhr(o),i.open(n,r,o.async!==!1),setHeaders(i,o),setCredentials(i,o),win[xDomainRequest]&&i instanceof win[xDomainRequest]?(i.onload=t,i.onprogress=function(){},i.ontimeout=function(){},i.onerror=e,s=!0):i.onreadystatechange=handleReadyState(this,t,e),s?setTimeout(function(){i.send(a)},200):i.send(a),i)}function buildParams(t,e,i,o){var n,r,a,s=/\[\]$/;if(DG.Util.isArray(e))for(r=0;e&&r<e.length;r++)a=e[r],i||s.test(t)?o(t,a):buildParams(t+"["+("object"==typeof a?r:"")+"]",a,i,o);else if(e&&"[object Object]"===e.toString())for(n in e)e.hasOwnProperty(n)&&buildParams(t+"["+n+"]",e[n],i,o);else o(t,e)}function setType(t){var e=t.match(/\.(json|jsonp|html|xml)(\?|$)/);return e?e[1]:"js"}function isCrossDomain(t){var e=rurl.exec(t.toLowerCase());return!(!e||e[1]===ajaxLocParts[1]&&e[2]===ajaxLocParts[2]&&(e[3]||("http:"===e[1]?"80":"443"))===(ajaxLocParts[3]||("http:"===ajaxLocParts[1]?"80":"443")))}function doRequest(o){"crossDomain"in o||(o.crossDomain=isCrossDomain(o.url));var self={};return self.promise=new Promise(function(resolve,reject){function complete(t){o.timeout&&clearTimeout(self.timeout),self.timeout=null,self._erred?reject(t):resolve(t)}function success(resp){resp="jsonp"!==type?self.request:resp;var filteredResponse=globalSetupOptions.dataFilter(resp.responseText,type),r=filteredResponse;try{resp.responseText=r}catch(e){}if(r)switch(type){case"json":try{resp=win.JSON.parse(r)}catch(err){return error(resp,"Could not parse JSON in response",err)}break;case"js":resp=eval("("+r+")");break;case"html":resp=r;break;case"xml":resp=resp.responseXML&&resp.responseXML.parseError&&resp.responseXML.parseError.errorCode&&resp.responseXML.parseError.reason?null:resp.responseXML}self._responseArgs.resp=resp,complete(resp)}function error(t,e,i){t=self.request,self._responseArgs.resp=t,self._responseArgs.msg=e,self._responseArgs.t=i,self._erred=!0,complete(t)}self.abort=function(){self._aborted=!0,reject("aborted")},self.url=o.url,self.timeout=null,self.options=o,self._aborted=!1,self._erred=!1,self._responseArgs={};var type="jsonp"===o.type?o.type:o.dataType||setType(self.url);o.timeout&&(self.timeout=setTimeout(function(){self.abort()},o.timeout)),self.request=getRequest.call(self,success,error)}),self}function Ajax(t,e){"[object Object]"===Object.prototype.toString.call(t)&&(e=t,t=void 0),e=e||{},e.url=t||e.url;var i=doRequest(e),o=i.promise;return(e.success||e.error||e.complete)&&o.then(e.success,e.error),o.abort=i.abort,o}var win=window,doc=document,rurl=/^([\w.+-]+:)?(?:\/\/([^\/?#:]*)(?::(\d+)|)|)/,twoHundo=/^20\d$/,ajaxLocParts,ajaxLocation,byTag="getElementsByTagName",readyState="readyState",contentType="Content-Type",requestedWith="X-Requested-With",head=doc[byTag]("head")[0],uniqid=0,callbackPrefix="l_dg_ajax_callback_"+ +new Date,lastValue,xmlHttpRequest="XMLHttpRequest",xDomainRequest="XDomainRequest",noop=function(){},defaultHeaders={contentType:"application/x-www-form-urlencoded",requestedWith:xmlHttpRequest,accept:{"*":"text/javascript, text/html, application/xml, text/xml, */*",xml:"application/xml, text/xml",html:"text/html",text:"text/plain",json:"application/json, text/javascript",js:"application/javascript, text/javascript"}},xhr=function(t){if(t.crossDomain===!0){var e=win[xmlHttpRequest]?new XMLHttpRequest:null;if(e&&"withCredentials"in e)return e;if(win[xDomainRequest])return new XDomainRequest;throw new Error("Browser does not support cross-origin requests")}return new XMLHttpRequest},globalSetupOptions={dataFilter:function(t){return t}};try{ajaxLocation=location.href}catch(e){ajaxLocation=document.createElement("a"),ajaxLocation.href="",ajaxLocation=ajaxLocation.href}ajaxLocParts=rurl.exec(ajaxLocation.toLowerCase())||[],Ajax.setup=function(t){t=t||{};for(var e in t)t.hasOwnProperty(e)&&(globalSetupOptions[e]=t[e])},Ajax.toQueryString=function(t,e){var i,o,n=e||!1,r=[],a=encodeURIComponent,s=function(t,e){e="function"==typeof e?e():e||"",r[r.length]=a(t)+"="+a(e)};if(DG.Util.isArray(t))for(o=0;t&&o<t.length;o++)s(t[o].name,t[o].value);else for(i in t)t.hasOwnProperty(i)&&buildParams(i,t[i],n,s);return r.join("&").replace(/%20/g,"+")};var testxhr=win[xmlHttpRequest]?new XMLHttpRequest:null;return Ajax.corsSupport=!(!(testxhr&&"withCredentials"in testxhr||win[xDomainRequest])||DG.Browser.ie&&document.location.host.toLowerCase().search(/[а-я]/)!=-1),Ajax}(),DG.Wkt={},DG.Wkt.toGeoJSON=function(t){function e(e){var i=t.substring(m).match(e);return i?(m+=i[0].length,i[0]):null}function i(t){return t&&f.match(/\d+/)&&(t.crs={type:"name",properties:{name:"urn:ogc:def:crs:EPSG::"+f}}),t}function o(){e(/^\s*/)}function n(){o();for(var t,i=0,n=[],r=[n],a=n;t=e(/^(\()/)||e(/^(\))/)||e(/^(\,)/)||e(/^[-+]?([0-9]*\.[0-9]+|[0-9]+)/);){if("("===t)r.push(a),a=[],r[r.length-1].push(a),i++;else if(")"===t){if(a=r.pop(),i--,0===i)break}else","===t?(a=[],r[r.length-1].push(a)):a.push(parseFloat(t));o()}return r.length=0,0!==i?null:n}function r(){for(var t,i,n=[];i=e(/^[-+]?([0-9]*\.[0-9]+|[0-9]+)/)||e(/^(\,)/);)","===i?(n.push(t),t=[]):(t||(t=[]),t.push(parseFloat(i))),o();return t&&n.push(t),n.length?n:null}function a(){if(!e(/^(point)/i))return null;if(o(),!e(/^(\()/))return null;var t=r();return o(),e(/^(\))/)?{type:"Point",coordinates:t[0]}:null}function s(){if(!e(/^(multipoint)/i))return null;o();var t=n();return o(),{type:"MultiPoint",coordinates:t}}function l(){if(!e(/^(multilinestring)/i))return null;o();var t=n();return o(),{type:"MultiLineString",coordinates:t}}function u(){if(!e(/^(linestring)/i))return null;if(o(),!e(/^(\()/))return null;var t=r();return e(/^(\))/)?{type:"LineString",coordinates:t}:null}function c(){return e(/^(polygon)/i)?(o(),{type:"Polygon",coordinates:n()}):null}function h(){return e(/^(multipolygon)/i)?(o(),{type:"MultiPolygon",coordinates:n()}):null}function d(){var t,i=[];if(!e(/^(geometrycollection)/i))return null;if(o(),!e(/^(\()/))return null;for(;t=p();)i.push(t),o(),e(/^(\,)/),o();return e(/^(\))/)?{type:"GeometryCollection",geometries:i}:null}function p(){return a()||u()||c()||s()||l()||h()||d()}DG.Util.isArray(t)&&(t=t[0]);var _=t.split(";");t=_.pop();var m=0,f=(_.shift()||"").split("=").pop();return i(p())},DG.Wkt.geoJsonLayer=function(t,e){return DG.geoJson(DG.Wkt.toGeoJSON(t),e)},DG.Wkt._coordsToLatLngs=function(t){return DG.Util.isArray(t)&&!DG.Util.isArray(t[0])?[DG.GeoJSON.coordsToLatLng(t)]:t.map(function(t){return DG.Wkt._coordsToLatLngs(t)}).reduce(function(t,e){return t.concat(e)})},DG.Wkt.toLatLngs=function(t){return DG.Util.isArray(t)||(t=[t]),t.map(function(t){var e=DG.Wkt.toGeoJSON(t).coordinates;return DG.Wkt._coordsToLatLngs(e)}).reduce(function(t,e){return t.concat(e)})},DG.Wkt.toPoints=function(t){return DG.Wkt.toGeoJSON(t).coordinates},DG.Wkt.pointsToLatLngOnMap=function(t,e){return function i(t){return Array.isArray(t)&&Array.isArray(t[0])?t.map(i):e.containerPointToLatLng(t)}(DG.Wkt.toPoints(t))},DG.ProjectDetector=DG.Handler.extend({initialize:function(t){this._map=t,this._project=void 0,this._loadProjectList()},addHooks:function(){this._projectWatch(),this._map.on("move",this._projectWatch,this)},removeHooks:function(){this._map.off("move",this._projectWatch,this)},getProject:function(){return!!this._project&&DG.Util.extend({},this._project)},getProjectsList:function(){return this._projectList.slice(0)},isProjectHere:function(t,e,i){if(!t)return null;t instanceof DG.LatLng||t instanceof DG.LatLngBounds||(t=DG.latLng(t)),t=t instanceof DG.LatLngBounds?DG.latLngBounds(t.getSouthWest().wrap(),t.getNorthEast().wrap()):t.wrap(),i=i||(t instanceof DG.LatLngBounds?"intersects":"contains");var o="intersects"==i?this._testProjectIntersects:this._testProjectContains;return o=o.bind(this,t),e?o(e):this._projectList.filter(o)[0]},_projectWatch:function(){this._map._loaded&&(this._project&&this._zoomInProject(this._project)&&this._centerInProject(this._project)||(this._searchProject(),this._project&&this._map.attributionControl._update(null,this._project.country_code)))},_checkProjectData:function(t){function e(t){return void 0!==t&&null!==t}return t&&t.bounds&&e(t.code)&&e(t.domain)&&e(t.country_code)&&e(t.flags)&&t.zoom_level&&e(t.zoom_level.min)&&e(t.zoom_level.max)&&t.time_zone&&e(t.time_zone.offset)},_loadProjectList:function(){DG.fallbackProjectsList=DG.fallbackProjectsList||[],DG.projectsList||(DG.projectsList=DG.fallbackProjectsList),delete DG.fallbackProjectsList,this._projectList=DG.projectsList.filter(this._checkProjectData).map(function(t){var e=DG.Wkt.toGeoJSON(t.bounds),i=DG.geoJSON(e).getBounds(),o=t.default_pos?DG.latLng(t.default_pos.lat,t.default_pos.lon):null;return{id:t.id,code:t.code,minZoom:t.zoom_level.min,maxZoom:t.zoom_level.max,timeOffset:t.time_zone.offset,bound:e,latLngBounds:i,traffic:!!t.flags.traffic,transport:!!t.flags.public_transport,roads:!!t.flags.road_network,country_code:t.country_code,domain:t.domain,defaultPos:o}})},_searchProject:function(){var t=this._projectList.filter(this._zoomInProject,this),e=t.filter(this._centerInProject,this);if(0===e.length){var i=this._map.getBounds();if(e=t.filter(DG.bind(this._testProjectIntersects,this,i)),e.length>1){for(var o=this._map.getCenter(),n=e[0],r=1;r<e.length;r++){var a=e[r];a.defaultPos&&o.distanceTo(n.defaultPos)>o.distanceTo(a.defaultPos)&&(n=a)}e=[n]}}var s=e[0]||null;if(this._project!==s){var l=this;null!==this._project&&(this._project=null,setTimeout(function(){l._map.fire("projectleave")},1)),s&&(this._project=s,setTimeout(function(){l._map.fire("projectchange",{getProject:l.getProject.bind(l)})},1))}},_testProjectIntersects:function(t,e){return e.latLngBounds.intersects(t)},_testProjectContains:function(t,e){return DG.PolyUtil.inside([t.lng,t.lat],e.bound)},_centerInProject:function(t,e){return this.isProjectHere(this._map.getCenter(),t,e)},_zoomInProject:function(t){return this._map.getZoom()>=t.minZoom}}),DG.Map.mergeOptions({projectDetector:!0}),DG.Map.addInitHook("addHandler","projectDetector",DG.ProjectDetector),DG.Metric=function(){},DG.Metric.Segments=function(){this.length=0},DG.Metric.Segments.prototype={push:function(t){return this[this.length]=this.length>0?this[this.length-1]+t:t,this.length+=1,this},getLength:function(){return this[this.length-1]},getReverse:function(){var t=new DG.Metric.Segments,e=this.length-1;if(e<0)return t;for(;e--;)t.push(this[e+1]-this[e]);return t.push(this[0])},getIndex:function(t){var e=this.length-1;if(e<0)return e;for(;e--&&!(this[e]<=t););return e+1},getSegRatio:function(t){var e=this.getIndex(t),i=e>0?this[e-1]:0;return(t-i)/(this[e]-i)},getSegLength:function(t){var e=this.getIndex(t),i=e>0?this[e-1]:0;return t-i}},DG.VertexTransform=DG.Class.extend({initialize:function(t){this._vertices=t,this._scale=null,this._angle=null,this._trans=null,this._matrix=null,this.load()},load:function(){return this.vertices=this._vertices.map(function(t){return t.clone()}),this.vertices.clone=DG.VertexTransform.clone,this},save:function(){return this._vertices=this.vertices.map(function(t){return t.clone()}),this},setScale:function(t){return this._scale=t,this},getScale:function(){return this._scale},setAngle:function(t){return this._angle=t,this},getAngle:function(){return this._angle},setTranslation:function(t){return this._trans=t,this},getTranslation:function(){return this._trans},setMatrix:function(t){return this._matrix=t,this},getMatrix:function(){return this._matrix},scale:function(t){var e=this.vertices,i=e.length;for(t=t||this._scale||1;i--;)e[i].x*=t,e[i].y*=t;return this},unScale:function(t){return t=t||this._scale||1,this.scale(1/t)},rotate:function(t){for(var e,i,o=t?t.cos:this._angle?this._angle.cos:1,n=t?t.sin:this._angle?this._angle.sin:0,r=this.vertices,a=r.length;a--;)e=r[a].x,i=r[a].y,r[a].x=e*o-i*n,r[a].y=e*n+i*o;return this},unRotate:function(t){var e=t?t.cos:this._angle?this._angle.cos:1,i=t?t.sin:this._angle?this._angle.sin:0;return this.rotate({cos:e,sin:-i})},translate:function(t){for(var e=t?t.x:this._trans?this._trans.x:0,i=t?t.y:this._trans?this._trans.y:0,o=this.vertices,n=o.length;n--;)o[n].x+=e,o[n].y+=i;return this},unTranslate:function(t){var e=t?t.x:this._trans?this._trans.x:0,i=t?t.y:this._trans?this._trans.y:0;return this.translate({x:-e,y:-i})},transform:function(t){var e,i,o,n,r,a,s,l,u=this.vertices,c=u.length;for(t?(e=t[0],i=t[1],r=t[2],o=t[3],n=t[4],a=t[5]):this._matrix?(e=this._matrix[0],i=this._matrix[1],r=this._matrix[2],o=this._matrix[3],n=this._matrix[4],a=this._matrix[5]):(e=1,i=0,r=0,o=0,n=1,a=0);c--;)s=u[c].x,l=u[c].y,u[c].x=s*e+l*i+r,u[c].y=s*o+l*n+a;return this},statics:{scale:function(t,e){var i,o,n=t.vertices,r=[];e=e||1;for(var a=0;a<n.length;a++)i=n[a].x*e,o=n[a].y*e,r.push(new DG.Point(i,o));return r.clone=DG.VertexTransform.clone,r},unScale:function(t,e){return e=e||1,DG.VertexTransform.scale(t,1/e)},rotate:function(t,e){for(var i,o,n,r,a=e?e.cos:1,s=e?e.sin:0,l=t.vertices,u=[],c=0;c<l.length;c++)n=l[c].x,r=l[c].y,i=n*a-r*s,o=n*s+r*a,u.push(new DG.Point(i,o));return u.clone=DG.VertexTransform.clone,u},unRotate:function(t,e){var i=e?e.cos:1,o=e?e.sin:0;return DG.VertexTransform.rotate(t,{cos:i,sin:-o})},translate:function(t,e){for(var i,o,n=e?e.x:0,r=e?e.y:0,a=t.vertices,s=[],l=0;l<a.length;l++)i=a[l].x+n,o=a[l].y+r,s.push(new DG.Point(i,o));return s.clone=DG.VertexTransform.clone,s},unTranslate:function(t,e){var i=e?e.x:0,o=e?e.y:0;return DG.VertexTransform.translate(t,{x:-i,y:-o})},clone:function(){return new DG.VertexTransform(this).save()},getLength:function(t,e){var i,o;return"number"==typeof t?Math.sqrt(t*t+e*e):(i=e.x-t.x,o=e.y-t.y,Math.sqrt(i*i+o*o))},getScaled:function(t,e,i){var o,n;return"number"==typeof t?new DG.Point(t*i,e*i):(o=(e.x-t.x)*i,n=(e.y-t.y)*i,new DG.Point(t.x+o,t.y+n))},getAngle:function(t,e,i){var o,n,r,a,s,l;return"number"==typeof t?(o=Math.sqrt(t*t+e*e),o>0?{cos:t/o,sin:e/o}:{cos:1,sin:0}):(r=t.x,a=t.y,s=e.x,l=e.y,i&&(r-=i.x,a-=i.y,s-=i.x,l-=i.y),n=Math.sqrt(r*r+a*a)*Math.sqrt(s*s+l*l),{cos:(r*s+a*l)/n,sin:(r*l-s*a)/n})},getAnglesSum:function(t,e){return{cos:t.cos*e.cos-t.sin*e.sin,sin:t.sin*e.cos+t.cos*e.sin}},getAnglesDif:function(t,e){return{cos:t.cos*e.cos+t.sin*e.sin,sin:t.sin*e.cos-t.cos*e.sin}}}}),DG.ArrowPathTransform=DG.VertexTransform.extend({initialize:function(t){this._lengths=new DG.Metric.Segments,this._vertices=[[],[]],this._drawings=[[],[]],this._setPath(t),this.subPath(1)},load:function(){return this.subPath(1)},save:function(){return this},_setPath:function(t){var e,i,o,n,r,a,s,l=DG.ArrowPathTransform.transform,u=this._vertices,c=this._drawings,h=DG.Point,d=t.width,p=[[],[],[]],_=[];for(u.push(t.vertices),u[0].push(new DG.Point(t.offset,(+d))),u[1].push(new DG.Point(t.offset,(-d))),a=DG.ArrowPathTransform.getAngles(t),r=-t.offset,e=0;e<a.length;e++)i=t.vertices[e+1].x,o=d*a[e].cot,n=a[e].tan*d*8/3,o>0?(u[0].push(new h(i+o,(+d))),c[0].push("L"),p[2].push(1),p[1].push(u[1].length),u[1].push(new h(i+o,(-d))),u[1].push(new h(i+o-n,(-d))),l(u,a[e],{x:i,y:0}),u[1].push(new h(0-o+n,(-d))),u[1].push(new h(0-o,(-d))),c[1].push("L","C"),_.push(Math.abs(i+o)-r),r=+o):(u[1].push(new h(i-o,(-d))),c[1].push("L"),p[2].push(0),p[0].push(u[0].length),u[0].push(new h(i-o,(+d))),u[0].push(new h(i-o+n,(+d))),l(u,a[e],{x:i,y:0}),u[0].push(new h(0+o-n,(+d))),u[0].push(new h(0+o,(+d))),c[0].push("L","C"),_.push(Math.abs(i-o)-r),r=-o);o=t.vertices[e+1].x,n=4*d/3,u[0].push(new h(o,(+d))),u[1].push(new h(o,(-d))),u[0].push(new h(o-n,(+d))),u[1].push(new h(o-n,(-d))),c[0].push("L"),c[1].push("L"),_.push(Math.abs(o)-r),u[1].reverse(),c[1].reverse(),s=DG.VertexTransform.getAnglesSum(a.fullAngle,t.getAngle()),l(u,s,u.pop()[0]),o=u[0].length,n=u[1].length,this._arcs=p[2].map(function(t){return r=p[t].shift(),t>0?new DG.ArcBezier(u[1].slice(n-r-4,n-r)):new DG.ArcBezier(u[0].slice(r,r+4).reverse())}).reverse(),this._lengths.push(_.pop()),_.reverse().forEach(function(t,e){this._lengths.push(this._arcs[e].getLength()).push(t)},this),this[0]={vertices:[u[0][o-2],u[0][o-1],u[1][0],u[1][1]],drawings:["M","C"]},this[1]={vertices:u[0].concat(u[1]),drawings:["M"].concat(c[0],"C",c[1])}},_setAngleAndDisplacement:function(t,e){this.angle=DG.VertexTransform.getAngle({x:t.x-e.x,y:t.y-e.y},{x:0,y:1}),this.displ=e.clone()},subPath:function(t){if(t=t>1?1:t,0===t||1===t)return this.vertices=this[t].vertices.map(function(t){return t.clone()}),this.drawings=this[t].drawings,this._setAngleAndDisplacement(this.vertices[0],this.vertices[this.vertices.length-1]),this;for(var e,i,o=DG.VertexTransform.getScaled,n=this._vertices,r=this._drawings,a=this._lengths,s=a.getLength()*t,l=a.getIndex(s),u=a.getSegRatio(s),c=n[0].length-2,h=1,d=r[0].length-1,p=0,_=0,m=0;m++<l;)m%2==1?(c--,d--,h++,p++):("C"===r[0][d]?(c-=3,d-=1):(h+=3,p+=1),_++);return l%2==1?(_=this._arcs[_],"C"===r[0][d]?(_=_.getCurveBefore(_.getTbyL(a.getSegLength(s))),e=_.points[3],i=n[1][h],this.vertices=_.points.slice(1).reverse().concat(n[0].slice(c),n[1].slice(0,h+1)).map(function(t){return t.clone()}),this.drawings=["M"].concat(r[0].slice(d),"C",r[1].slice(0,p))):(_=_.getCurveBefore(_.getTbyL(a.getSegLength(s))),e=n[0][c],i=_.points[3],this.vertices=n[0].slice(c).concat(n[1].slice(0,h+1),_.points.slice(1)).map(function(t){return t.clone()}),this.drawings=["M"].concat(r[0].slice(d+1),"C",r[1].slice(0,p+1)))):(e=o(n[0][c],n[0][c-1],u),i=o(n[1][h],n[1][h+1],u),this.vertices=[e].concat(n[0].slice(c),n[1].slice(0,h+1),i).map(function(t){return t.clone()}),this.drawings=["M"].concat(r[0].slice(d),"C",r[1].slice(0,p+1))),this._setAngleAndDisplacement(e,i),this},statics:{getAngles:function(t){for(var e,i,o,n,r,a,s,l=DG.VertexTransform.getAngle,u={cos:1,sin:0},c=t.vertices,h=[],d=1,p=c.length-1;d<p;d++)i=l(c[d-1],c[d+1],c[d]),e=Math.abs(i.sin),e<1e-6?(c.splice(c.length-d-1,1),p--,d--):(i.cot=(1+i.cos)/i.sin,i.cos=-i.cos,r=(1+i.cos)/i.sin,s=r<0?-1:1,a=s*Math.sqrt(4*r*r+4),i.tan=-.5*(r+r-a),h.push(i),o=u.cos*i.cos-u.sin*i.sin,n=u.sin*i.cos+u.cos*i.sin,u={cos:o,sin:n});return h.fullAngle={cos:u.cos,sin:-u.sin},h},getTranslatedPath:function(t,e){var i=new DG.VertexTransform([]),o=e.length-1,n=t.project(e[o]),r=n.x,a=n.y;for(i.vertices.push(new DG.Point(0,0));o--;)n=t.project(e[o]),i.vertices.push(new DG.Point(n.x-r,n.y-a));return i.setAngle(DG.VertexTransform.getAngle(-i.vertices[1].x,-i.vertices[1].y)).unRotate()},transform:function(t,e,i){for(var o,n,r,a,s=t.length,l=e.cos,u=e.sin,c=i.x,h=i.y;s--;)for(o=t[s],a=o.length;a--;)n=o[a].x-c,r=o[a].y-h,o[a].x=n*l-r*u,o[a].y=n*u+r*l}}}),DG.ArrowTipTransform=DG.VertexTransform.extend({initialize:function(t,e){this.drawings=e.drawings,this._vertices=e.vertices,this._setShape(t,e)},_setShape:function(t,e){var i=e.vertices[0],o=Math.abs(i.y),n=t.vertices[1].x,r=i.x,a=n-r+o+o;t.width=o,t.offset=r+(a>0?a:0),t.vertices.length<3&&r>-10&&(t.offset+=2.5),this._vertices=this.load().unTranslate(i).vertices},subShape:function(t){return this.load().unRotate(t.angle).translate(t.displ),this}}),DG.ComplexPath=DG.Path.extend({options:{fill:!0,fillOpacity:1,interactive:!1},initialize:function(t){DG.setOptions(this,t),this._empty=[],this._pxEmpty=DG.bounds(DG.point(0,0),DG.point(0,0)),
	this._pxBounds=this._pxEmpty,this._vertices=[this._empty],this._drawings=[this._empty]},getEvents:function(){return{}},_project:function(){var t,e,i=this.options;this._map&&(t=this._map.getZoom(),i.visibility.isShown&&i.transform[t]?(e=2.2-.2*(19-t),i.weight!==e&&this.setStyle({weight:+e.toFixed(2)}),this._vertices[0]=i.transform[t].vertices,this._drawings[0]=i.transform[t].drawings,this._pxBounds=i.transform[t]._pxBounds):(this._vertices[0]=this._empty,this._drawings[0]=this._empty,this._pxBounds=this._pxEmpty))},_update:function(){this._map&&this._updatePath()},_updatePath:function(){this._renderer._updateComplexPath(this)}}),DG.extend(L.Canvas.prototype,{_updateComplexPath:function(t,e){var i,o,n,r,a,s,l,u,c,h,d,p=t._drawings,_=t._vertices,m=this._ctx;for(this._drawnLayers[t._leaflet_id]=t,m.beginPath(),i=0;i<_.length;i++){for(d=_[i],a=s=0,o=n=0;o<d.length;)switch(r=p[i][n++]){case"M":a=d[o].x,s=d[o].y,o+=1,m.moveTo(a,s);break;case"m":a+=d[o].x,s+=d[o].y,o+=1,m.moveTo(a,s);break;case"L":a=d[o].x,s=d[o].y,o+=1,m.lineTo(a,s);break;case"l":a+=d[o].x,s+=d[o].y,o+=1,m.lineTo(a,s);break;case"C":l=d[o].x,u=d[o].y,o+=1,c=d[o].x,h=d[o].y,o+=1,a=d[o].x,s=d[o].y,o+=1,m.bezierCurveTo(l,u,c,h,a,s);break;case"c":l=a+d[o].x,u=s+d[o].y,o+=1,c=a+d[o].x,h=s+d[o].y,o+=1,a+=d[o].x,s+=d[o].y,o+=1,m.bezierCurveTo(l,u,c,h,a,s);break;case"Q":l=d[o].x,u=d[o].y,o+=1,a=d[o].x,s=d[o].y,o+=1,m.quadraticCurveTo(l,u,a,s);break;case"q":l=a+d[o].x,u=s+d[o].y,o+=1,a+=d[o].x,s+=d[o].y,o+=1,m.quadraticCurveTo(l,u,a,s)}e&&m.closePath()}this._fillStroke(m,t)}}),DG.extend(L.SVG.prototype,{_updateComplexPath:function(t,e){this._setPath(t,L.SVG.complexPointsToPath(t._vertices,t._drawings,e))}}),DG.extend(L.SVG,{complexPointsToPath:function(t,e,i){var o,n,r,a,s,l,u="",c=DG.Browser.svg;for(o=0;o<t.length;o++){if(l=t[o],c)for(n=r=0;n<l.length;){switch(s=e[o][r++]){case"C":case"c":a=3;break;case"Q":case"q":a=2;break;default:a=1}for(u+=s;a--;)u+=l[n].x.toFixed(4)+","+l[n].y.toFixed(4)+" ",n+=1}else for(n=r=0;n<l.length;){switch(s=e[o][r++]){case"M":s="m",a=1;break;case"m":s="t",a=1;break;case"L":s="l",a=1;break;case"l":s="r",a=1;break;case"C":s="c",a=3;break;case"c":s="v",a=3;break;case"Q":u+="C"+l[n].x.toFixed(0)+","+l[n].y.toFixed(0)+" "+l[n].x.toFixed(0)+","+l[n].y.toFixed(0)+" "+l[n+1].x.toFixed(0)+","+l[n+1].y.toFixed(0)+" ",n+=2,s="",a=0;break;case"q":u+="c"+l[n].x.toFixed(0)+","+l[n].y.toFixed(0)+" "+l[n].x.toFixed(0)+","+l[n].y.toFixed(0)+" "+l[n+1].x.toFixed(0)+","+l[n+1].y.toFixed(0)+" ",n+=2,s="",a=0;break;default:a=1}for(u+=s;a--;)u+=l[n].x.toFixed(0)+","+l[n].y.toFixed(0)+" ",n+=1}u+=i?c?"z":"x":""}return u||"m0,0"}}),DG.Bezier=DG.Class.extend({initialize:function(t,e){e?this.points=t.map(function(t){return t.clone()}):this.points=t,this.dpoints=this._getDerivatives(),this.order=this.points.length-1,this._lut=[]},getPoint:function(t){var e,i,o,n,r,a,s,l=this.points;return 0===t?l[0]:1===t?l[this.order]:(e=1-t,i=e*e,o=t*t,this.order>2?(n=i*e,r=i*t*3,a=e*o*3,s=t*o):(l=[l[0],l[1],l[2],{x:0,y:0}],n=i,r=e*t*2,a=o,s=0),new DG.Point(n*l[0].x+r*l[1].x+a*l[2].x+s*l[3].x,n*l[0].y+r*l[1].y+a*l[2].y+s*l[3].y))},derivative:function(t){var e,i,o,n=this.dpoints[0],r=1-t;return this.order>2?(e=r*r,i=r*t*2,o=t*t):(n=[n[0],n[1],{x:0,y:0}],e=r,i=t,o=0),new DG.Point(e*n[0].x+i*n[1].x+o*n[2].x,e*n[0].y+i*n[1].y+o*n[2].y)},getLength:function(){for(var t,e,i,o=DG.Bezier.WEIGHT,n=DG.Bezier.ABSCISSA,r=.5,a=0,s=0;s<n.length;s++)i=r*n[s]+r,t=this.derivative(i),e=t.x*t.x+t.y*t.y,a+=o[s]*Math.sqrt(e);return r*a},getCurveBefore:function(t){var e,i,o,n,r,a,s,l,u,c=this.points;return 1===t?this.clone():(u=[],e=t*t,o=t-1,n=o*o,u[0]=new DG.Point(c[0].x,c[0].y),u[1]=new DG.Point(t*c[1].x-o*c[0].x,t*c[1].y-o*c[0].y),a=t*o*2,u[2]=new DG.Point(e*c[2].x-a*c[1].x+n*c[0].x,e*c[2].y-a*c[1].y+n*c[0].y),this.order>2&&(i=e*t,r=n*o,s=e*o*3,l=t*n*3,u[3]=new DG.Point(i*c[3].x-s*c[2].x+l*c[1].x-r*c[0].x,i*c[3].y-s*c[2].y+l*c[1].y-r*c[0].y)),new DG.Bezier(u))},getCurveAfter:function(t){var e,i,o,n,r,a,s,l,u,c=this.points,h=this.order;return 1===t?this.clone():(u=[],e=t*t,o=t-1,n=o*o,u[h]=new DG.Point(c[h].x,c[h].y),u[--h]=new DG.Point(t*c[h+1].x-o*c[h].x,t*c[h+1].y-o*c[h].y),a=t*o*2,u[--h]=new DG.Point(e*c[h+2].x-a*c[h+1].x+n*c[h].x,e*c[h+2].y-a*c[h+1].y+n*c[h].y),this.order>2&&(i=e*t,r=n*o,s=e*o*3,l=t*n*3,u[--h]=new DG.Point(i*c[h+3].x-s*c[h+2].x+l*c[h+1].x-r*c[h].x,i*c[h+3].y-s*c[h+2].y+l*c[h+1].y-r*c[h].y)),new DG.Bezier(u))},_getDerivatives:function(){var t,e,i,o,n=this.points,r=[];for(t=n.length,e=t-1;t>1;t--,e--){for(o=[],i=0;i<e;i++)o.push(new DG.Point(e*(n[i+1].x-n[i].x),e*(n[i+1].y-n[i].y)));r.push(o),n=o}return r},getLUT:function(t){return t=t||125,this._lut.length!==t+1&&(this.order>2?this._setLUT3(t):this._setLUT2(t)),this._lut},_setLUT2:function(t){var e,i,o,n,r,a=this._lut=[],s=this.points;a.push({x:s[0].x,y:s[0].y,l:0});for(var l=1;l<t;l++)e=l/t,i=1-e,o=i*i,n=i*e*2,r=e*e,a.push({x:o*s[0].x+n*s[1].x+r*s[2].x,y:o*s[0].y+n*s[1].y+r*s[2].y});a.push({x:s[2].x,y:s[2].y,l:0})},_setLUT3:function(t){var e,i,o,n,r,a,s,l,u=this._lut=[],c=this.points;u.push({x:c[0].x,y:c[0].y,l:0});for(var h=1;h<t;h++)e=h/t,o=1-e,n=o*o,i=e*e,r=n*o,a=n*e*3,s=o*i*3,l=e*i,u.push({x:r*c[0].x+a*c[1].x+s*c[2].x+l*c[3].x,y:r*c[0].y+a*c[1].y+s*c[2].y+l*c[3].y});u.push({x:c[3].x,y:c[3].y,l:0})},clone:function(){return new DG.Bezier(this.points,(!0))}}),DG.bezier=function(t){return("number"==typeof t||t instanceof DG.Point)&&(t=Array.prototype.slice.call(arguments)),"number"==typeof t[0]?(t=t.length<7?[new DG.Point(t[0],t[1]),new DG.Point(t[2],t[3]),new DG.Point(t[4],t[5])]:[new DG.Point(t[0],t[1]),new DG.Point(t[2],t[3]),new DG.Point(t[4],t[5]),new DG.Point(t[6],t[7])],new DG.Bezier(t)):new DG.Bezier(t,(!0))},DG.Bezier.WEIGHT=[.362683783378362,.362683783378362,.3137066458778873,.3137066458778873,.2223810344533745,.2223810344533745,.1012285362903763,.1012285362903763],DG.Bezier.ABSCISSA=[-.1834346424956498,.1834346424956498,-.525532409916329,.525532409916329,-.7966664774136267,.7966664774136267,-.9602898564975363,.9602898564975363],DG.TimeBezier=DG.Bezier.extend({initialize:function(t,e,i){DG.Bezier.prototype.initialize.call(this,[DG.TimeBezier.START,t,e,DG.TimeBezier.END],i)},getYbyX:function(t){var e,i=this.getLUT(),o=i.length-1,n=0;if(t<=0)return 0;if(t>=1)return 1;for(;;)if(e=n+(o-n>>1),t<i[e].x?o=e:n=e,o-n<2)break;return t=(t-i[n].x)/(i[o].x-i[n].x),i[n].y+(i[o].y-i[n].y)*t},getLUT:function(t){var e,i,o,n,r,a,s,l=this.points;if(t=t||240,this._lut.length===t+1)return this._lut;this._lut=s=[],s.push({x:0,y:0});for(var u=1;u<t;u++)e=u/t,o=1-e,i=e*e,n=o*o*e*3,r=o*i*3,a=e*i,s.push({x:n*l[1].x+r*l[2].x+a,y:n*l[1].y+r*l[2].y+a});return s.push({x:1,y:1}),s},clone:function(){return new DG.TimeBezier(this.points,(!0))}}),DG.TimeBezier.START=DG.point(0,0),DG.TimeBezier.END=DG.point(1,1),DG.ArcBezier=DG.Bezier.extend({initialize:function(t,e){DG.Bezier.prototype.initialize.call(this,t,e),this.getLUT(),this._setLutLengths()},getTbyL:function(t){var e,i,o,n=this.getLUT(),r=n.length-1,a=0;if(t<=0)return 0;if(t>=n[r].l)return 1;for(;;)if(e=a+(r-a>>1),t<n[e].l?r=e:a=e,r-a<2)break;t=(t-n[a].l)/(n[r].l-n[a].l),i=n[a].x+(n[r].x-n[a].x)*t,o=n[a].y+(n[r].y-n[a].y)*t;var s,l,u,c,h=r/n.length,d=a/n.length,p=1/n.length/10,_=Math.pow(2,53)-1;for(c=d;d<h;d+=p)s=this.getPoint(d),l=s.x-i,u=s.y-o,t=Math.sqrt(l*l+u*u),t<_&&(_=t,c=d);return c},_setLutLengths:function(){var t,e,i=this._lut;i[0].l=0;for(var o=1;o<i.length;o++)t=i[o].x-i[o-1].x,e=i[o].y-i[o-1].y,i[o].l=i[o-1].l+Math.sqrt(t*t+e*e)},getLength:function(){return this._lut[this._lut.length-1].l},clone:function(){return new DG.ArcBezier(this.points,(!0))}}),DG.Animation=DG.Evented.extend({options:{},initialize:function(t){DG.setOptions(this,t),this._animID=-1,this._startTime=0,this._running=!1,this._animation=null,this._durations=null},start:function(){this.stop(),this._prepare(),this._running=!0,this.fire("start"),this._startTime=(new Date).getTime(),this._animate()},stop:function(){this._running&&this._run(this._durations.getLength())},_prepare:function(){this._animation=DG.Util.isArray(this.options.animation)?this.options.animation:[this.options.animation],this._durations=new DG.Metric.Segments,this._animation.forEach(function(t){this.push(t.duration)},this._durations)},_animate:function(){this._animID=DG.Util.requestAnimFrame(this._animate,this),this._run()},_run:function(t){var e,i,o;t=t?t:(new Date).getTime()-this._startTime,t<this._durations.getLength()?(i=this._durations.getIndex(t),e=this._durations.getSegRatio(t),o=this._animation[i]["function"].getYbyX(e),this._step(this._getFrameValues(i,o))):(i=this._durations.length-1,this._step(this._getFrameValues(i,1)),this._complete())},_step:function(t){this.fire("step",t)},_complete:function(){DG.Util.cancelAnimFrame(this._animID),this._durations=null,this._animation=null,this._running=!1,this.fire("end")},_getFrameValues:function(t,e){var i,o,n=this._animation[t].frames,r={progress:e};if(n)for(var a in n)n[a].progress?r[a]=n[a].progress(e):(i=n[a].from,o=n[a].to,r[a]=i+(o-i)*e);return r}}),DG.animation=function(t){return new DG.Animation(t)},DG.Animation.LINEAR=new DG.TimeBezier(DG.point(0,0),DG.point(1,1)),DG.Animation.EASE=new DG.TimeBezier(DG.point(.25,.1),DG.point(.25,1)),DG.Animation.EASE_IN=new DG.TimeBezier(DG.point(.42,0),DG.point(1,1)),DG.Animation.EASE_IN_OUT=new DG.TimeBezier(DG.point(.42,0),DG.point(.58,1)),DG.Animation.EASE_OUT=new DG.TimeBezier(DG.point(0,0),DG.point(.58,1)),DG.Entrance=DG.FeatureGroup.extend({options:{vectors:[],fillColor:"#0085a0",strokeColor:"#fff",enableAnimation:!0,interactive:!1,autoClose:!0},initialize:function(t){DG.LayerGroup.prototype.initialize.call(this),DG.setOptions(this,t),this._bounds=new DG.LatLngBounds,this._animations={bounce:DG.animation(DG.Entrance.BOUNCE_ANIMATION),path:DG.animation(DG.Entrance.PATH_ANIMATION)},this._initArrows(),this._isShown=!1},onAdd:function(t){DG.LayerGroup.prototype.onAdd.call(this,t),this.show()},onRemove:function(t){this.hide(),DG.LayerGroup.prototype.onRemove.call(this,t)},getEvents:function(){var t={};return this.options.autoClose&&(t.layeradd=this._removeEntrance),this.options.enableAnimation&&(t.zoomend=this._animate),t},show:function(t){return this._layers&&(t&&this.fitBounds(),this._isShown||(this._isShown=!0,this.eachLayer(function(t){t.setVisibility(!0)}),this.options.enableAnimation&&this._animate(),this._map.fire("entranceshow"))),this},hide:function(){return this._layers&&this._isShown&&(this._isShown=!1,this.eachLayer(function(t){t.setVisibility(!1)}),this._map.fire("entrancehide")),this},isShown:function(){return this._isShown},getBounds:function(){return this._bounds},setFillColor:function(t){this.eachLayer(function(e){e.setStyle({fillColor:t})})},setStrokeColor:function(t){this.eachLayer(function(e){e.setStyle({color:t})})},_initArrows:function(){var t={color:this.options.strokeColor,fillColor:this.options.fillColor,interactive:this.options.interactive};this.options.vectors.map(function(t){return DG.Wkt.toLatLngs(t)}).forEach(function(e){var i=DG.Util.create(t),o=DG.latLngBounds(e);this._bounds.extend(o),i.latlngs=e,i.bounds=o,this.options.enableAnimation&&(e.length>2?i.animation=this._animations.path:(i.animation=this._animations.bounce,i.distance=!0)),this.addLayer(DG.entrance.arrow(i))},this)},_animate:function(){this._isShown&&(this._animations.bounce.start(),this._animations.path.start())},fitBounds:function(){var t,e=this._map,i=this.getBounds();return e.getBounds().contains(i)&&this._isAllowedZoom()||(t=this._getFitZoom(),e.projectDetector.getProject()||e.once("moveend",function(){e.setZoom(this._getFitZoom())},this),e.setView(i.getCenter(),t,{animate:!0})),this},_getFitZoom:function(){var t=this._map.projectDetector.getProject();return t?t.maxZoom:DG.Entrance.SHOW_FROM_ZOOM},_isAllowedZoom:function(){return this._map.getZoom()>=DG.Entrance.SHOW_FROM_ZOOM},_removeEntrance:function(t){(t.layer instanceof DG.Popup||t.layer instanceof DG.Entrance&&t.layer!==this)&&this.remove()}}),DG.entrance=function(t){return new DG.Entrance(t)},DG.Entrance.SHOW_FROM_ZOOM=16,DG.Entrance.PATH_ANIMATION={animation:{"function":DG.Animation.EASE_IN_OUT,duration:750}},DG.Entrance.BOUNCE_ANIMATION={animation:[{"function":DG.Animation.EASE_IN_OUT,duration:250,frames:{distance:{from:0,to:.6}}},{"function":DG.Animation.EASE_IN,duration:135,frames:{distance:{from:.6,to:0}}},{"function":DG.Animation.EASE_OUT,duration:135,frames:{distance:{from:0,to:.16}}},{"function":DG.Animation.EASE_IN,duration:90,frames:{distance:{from:.16,to:0}}},{"function":DG.Animation.EASE_OUT,duration:90,frames:{distance:{from:0,to:.06}}},{"function":DG.Animation.EASE_IN,duration:50,frames:{distance:{from:.06,to:0}}}]},DG.Entrance.Arrow=DG.FeatureGroup.extend({initialize:function(t){DG.LayerGroup.prototype.initialize.call(this),DG.setOptions(this,t),this._progress=1,this._distance=0,this._visibility={isShown:!1},this._position=t.latlngs[t.latlngs.length-1],this._shape=this.options.shape||DG.Entrance.Arrow.SHAPE,this._apt={},this._att={}},beforeAdd:function(t){var e=this.options;!e.animation||t.options.preferCanvas||DG.Browser.ielt9?e.animation=null:e.animation.on("step",this._animation,this),this.projection(),this.addLayer(new DG.ComplexPath({lineCap:"butt",color:e.color,fillColor:e.fillColor,interactive:e.interactive,visibility:this._visibility,transform:this._apt})),this.addLayer(new DG.ComplexPath({lineJoin:"miter",color:e.color,fillColor:e.fillColor,interactive:e.interactive,visibility:this._visibility,transform:this._att}))},getEvents:function(){return{zoomend:this._project,moveend:this._update,viewreset:this._reset}},setVisibility:function(t){this._visibility.isShown!==t&&(this._visibility.isShown=t,t?this.options.animation||this._reset():this._reset())},getBounds:function(){return this.options.bounds},projection:function(){var t,e,i,o,n=this._map||this._mapToAdd,r=n?n.getZoom():0,a=this._shape.vertices[r],s=this._shape.drawings[r],l=this.options.latlngs;return r&&a&&s&&(this._att[r]||(e=DG.ArrowPathTransform.getTranslatedPath(n,l),t={vertices:a,drawings:s},this._att[r]=new DG.ArrowTipTransform(e,t),this._apt[r]=new DG.ArrowPathTransform(e)),i=n.latLngToLayerPoint(this._position),o=n.latLngToLayerPoint(l[l.length-2]),this._apt[r]._pxBounds||this._setBounds(i,o,this._apt[r],this._att[r]),this.options.distance&&(i=DG.VertexTransform.getScaled(i,o,this._distance)),this._apt[r].subPath(this._progress).translate(i),this._att[r].subShape(this._apt[r]).translate(i)),this},_animation:function(t){void 0!=t.distance?this._distance=t.distance:this._progress=t.progress,this._visibility.isShown&&(this._project(),this._update())},_project:function(){this.projection().invoke("_project")},_update:function(){this.invoke("_update")},_reset:function(){this._resetBounds(),this._project(),this._update()},_resetBounds:function(){var t;for(t in this._apt)this._apt[t]._pxBounds=null;for(t in this._att)this._att[t]._pxBounds=null},_setBounds:function(t,e,i,o){var n=i.subPath(1).translate(t).vertices,r=o.subShape(i).translate(t).vertices;i._pxBounds=new DG.Bounds(n),o._pxBounds=new DG.Bounds(r)}}),DG.entrance.arrow=function(t){return new DG.Entrance.Arrow(t)},DG.Entrance.Arrow.SHAPE={vertices:{16:[[-6.5,-1.8],[-6.0522,-1.8],[-7.0975,-5.2537],[-6.6619,-6.2565],[-6.598,-6.355],[-6.1757,-6.147],[.8371,-.3552],[.9275,-.1764],[.9275,.1764],[.8371,.3552],[-6.1757,6.147],[-6.598,6.355],[-6.6619,6.2565],[-7.0975,5.2537],[-6.0522,1.8],[-6.5,1.8]],17:[[-9,-2.4],[-7.889,-2.4],[-9.9245,-7.2548],[-9.3363,-8.6404],[-9.3448,-8.6448],[-8.8717,-8.3508],[1.0285,-.3552],[1.119,-.1764],[1.119,.1764],[1.0285,.3552],[-8.8717,8.3508],[-9.3448,8.6448],[-9.3363,8.6404],[-9.9245,7.2548],[-7.889,2.4],[-9,2.4]],18:[[-11.5,-3],[-10.0795,-3],[-12.4909,-9.3173],[-11.8402,-10.7654],[-11.5986,-10.7073],[-10.938,-10.2258],[1.1497,-.3552],[1.2402,-.1764],[1.2402,.1764],[1.1497,.3552],[-10.938,10.2258],[-11.5986,10.7073],[-11.8402,10.7654],[-12.4909,9.3173],[-10.0795,3],[-11.5,3]],19:[[-13,-3.6],[-11.66,-3.6],[-14.1696,-10.8351],[-13.5189,-12.2832],[-13.2773,-12.2251],[-12.6167,-11.7436],[1.3061,-.3552],[1.3966,-.1764],[1.3966,.1764],[1.3061,.3552],[-12.6167,11.7436],[-13.2773,12.2251],[-13.5189,12.2832],[-14.1696,10.8351],[-11.66,3.6],[-13,3.6]]},drawings:{16:["M","L","L","C","L","C","L","C","L","L"],17:["M","L","L","C","L","C","L","C","L","L"],18:["M","L","L","C","L","C","L","C","L","L"],19:["M","L","L","C","L","C","L","C","L","L"]}},function(t){for(var e in t)t[e]=t[e].map(function(t){return DG.point(t)})}(DG.Entrance.Arrow.SHAPE.vertices),DG.Label=DG.Layer.extend({options:{offset:new DG.Point(12,15),className:"dg-label",zIndexOffset:0,textDirection:"auto"},_typeOfString:Object.prototype.toString.call("s"),_defaultZIndex:100,initialize:function(t,e){DG.Util.setOptions(this,e),this._animated=DG.Browser.any3d,this._content=t},onAdd:function(t){this._map=t,this._el||this._initDOM(),this._visible=!0,this.setContent(this._content)._onViewReset(),t.on("viewreset",this._onViewReset,this).on("zoomanim",this._onZoomAnimation,this)},onRemove:function(t){t.off("viewreset",this._onViewReset,this).off("zoomanim",this._onZoomAnimation,this),this._visible=!1,this._el.removeChild(this._container),DG.Util.falseFn(this._container.offsetWidth),this._container=null,t.getPanes().tooltipPane.removeChild(this._el),this._el=null},_initDOM:function(){this._el=DG.DomUtil.create("div",this.options.className+" leaflet-zoom-"+(this._animated?"animated":"hide"),this._map.getPanes().tooltipPane),this._el.style.zIndex=this._defaultZIndex+this.options.zIndexOffset,this._container=DG.DomUtil.create("div",this.options.className+"__content",this._el),this._container.setAttribute("dir",this.options.textDirection),DG.DomEvent.disableClickPropagation(this._el).on(this._container,"mousewheel",DG.DomEvent.stopPropagation).on(this._container,"contextmenu",DG.DomEvent.stopPropagation)},_onViewReset:function(){this._visible&&this._latlng&&DG.DomUtil.setPosition(this._el,this._map.latLngToLayerPoint(this._latlng).add(this.options.offset),DG.Browser.ie)},_onZoomAnimation:function(t){this._latlng&&DG.DomUtil.setPosition(this._el,this._map._latLngToNewLayerPoint(this._latlng,t.zoom,t.center).add(this.options.offset))},setOffset:function(t){return t instanceof DG.Point&&(this.options.offset=t,this._onViewReset()),this},setZIndexOffset:function(t){return isNaN(+t)||(this.options.zIndexOffset=+t,this._visible&&(this._el.style.zIndex=this._defaultZIndex+this.options.zIndexOffset)),this},setContent:function(t){return Object.prototype.toString.call(t)!==this._typeOfString?this:(this._content=t,this._visible&&(this._container.innerHTML=t),this)},setPosition:function(t){return t instanceof DG.LatLng?(this._latlng=t,this._onViewReset(),this):this}}),DG.label=function(t,e){return new DG.Label(t,e)},DG.Marker.include({bindLabel:function(t,e){return this._label?(this._label.setContent(t),e&&(this.options.offset!==e.offset&&this._label.setOffset(this.options.offset=e.offset),this.options["static"]!==e["static"]&&this.unbindLabel().bindLabel(t,e))):(e=DG.extend({offset:new DG.Point(5,5)},e),this._label=DG.label(t,e),this.once("remove",this._onMarkerRemove),e["static"]?this.showLabel():this.on("mouseover",this._mouseOverLabel).on("mouseout",this._mouseOutLabel).on("dragstart",this._dragStartLabel).on("dragend",this._dragEndLabel),"undefined"!=typeof this._map?this._updateLabelZIndex():this.once("add",this._updateLabelZIndex)),this},unbindLabel:function(){return this._label&&(this.hideLabel().off("remove",this.unbindLabel).off("mouseover",this._mouseOverLabel).off("mouseout",this._mouseOutLabel).off("dragstart",this._dragStartLabel).off("dragend",this._dragEndLabel).off("move",this._updatePosition).off("add",this._updateLabelZIndex),this._label=null),this},_onMarkerRemove:function(){if(this._label){var t=this._label._content;this.once("add",function(){this._label||this.bindLabel(t)}),this.unbindLabel()}},getLabel:function(){return this._label?this._label:null},_originalUpdateZIndex:DG.Marker.prototype._updateZIndex,_updateZIndex:function(t){return this._zIndex||(this._zIndex=0),this._originalUpdateZIndex(t),this._updateLabelZIndex(),this},_updateLabelZIndex:function(){return this._label&&this._icon&&this._label.setZIndexOffset(this._icon.style.zIndex),this},showLabel:function(){return this._label&&this.on("move",this._updatePosition)._map.addLayer(this._label.setPosition(this.getLatLng())),this},hideLabel:function(){return this._label&&this.off("move",this._updatePosition)._map.removeLayer(this._label),this},_updatePosition:function(){this._label.setPosition(this.getLatLng())},_dragStartLabel:function(){this._label.isMarkerDragging=!0,this.hideLabel()},_dragEndLabel:function(){this._label.isMarkerDragging=!1,this._label.isMouseOverMarker&&this.showLabel()},_mouseOverLabel:function(){this._label.isMouseOverMarker=!0,this._label.isMarkerDragging||this.showLabel()},_mouseOutLabel:function(){this._label.isMouseOverMarker=!1,this.hideLabel()}}),DG.Marker.addInitHook(function(){"undefined"!=typeof this.options.label&&this.bindLabel(this.options.label)}),DG.Path.include({bindLabel:function(t,e){return this._label?(this._label.setContent(t),this._label.options.offset!==e.offset&&this._label.setOffset(e.offset)):(this._label=DG.label(t,e),this.on(this._labelEvents,this)),this},unbindLabel:function(){return this._label&&(this.off(this._labelEvents,this),this._map.removeLayer(this._label),this._label=null),this},getLabel:function(){return this._label?this._label:null},_labelEvents:{mouseover:function(t){this._map.addLayer(this._label.setPosition(t.latlng)),DG.DomEvent.stop(t)},mousemove:function(t){this._label.setPosition(t.latlng),DG.DomEvent.stop(t)},mouseout:function(t){this._map.removeLayer(this._label),DG.DomEvent.stop(t)},remove:function(){this._map.removeLayer(this._label)}}}),DG.Path.addInitHook(function(){"undefined"!=typeof this.options.label&&this.bindLabel(this.options.label)}),DG.Entrance.include({bindLabel:function(t,e){return this._label?(this._label.setContent(t),this._label.options.offset!==e.offset&&this._label.setOffset(e.offset)):(this._label=DG.label(t,e),this.on(this._labelEvents,this)),this},unbindLabel:function(){return this._label&&(this.off(this._labelEvents,this),this._map.removeLayer(this._label),this._label=null),this},getLabel:function(){return this._label?this._label:null},_labelEvents:{mouseover:function(t){this._map.addLayer(this._label.setPosition(t.latlng)),DG.DomEvent.stop(t)},mousemove:function(t){this._label.setPosition(t.latlng),DG.DomEvent.stop(t)},mouseout:function(){this._label.remove()},remove:function(){this._label.remove()}}}),DG.Entrance.addInitHook(function(){"undefined"!=typeof this.options.label&&this.bindLabel(this.options.label)}),DG.configTheme=DG.configTheme||{},DG.configTheme.balloonOptions={offset:{x:1,y:-43}},_dereq_("../../../vendors/baron"),function(){var t=DG.configTheme.balloonOptions.offset.x,e=DG.configTheme.balloonOptions.offset.y,i=DG.Popup.prototype.initialize,o=DG.Popup.prototype._initLayout,n=DG.Popup.prototype.onAdd,r=baron.noConflict(),a=function(t){this[0]=t,this.length=1};a.prototype={setAttribute:function(t,e){return this[0].setAttribute(t,e),this},getAttribute:function(t){return this[0].getAttribute(t)},removeAttribute:function(t){return this[0].removeAttribute(t),this},css:function(t,e){return e?(this[0].style[t]=e,this):DG.DomUtil.getStyle(this[0],t)}},DG.Popup.prototype.options.offset=DG.point(t,e),DG.Popup.mergeOptions({border:16,mapControlsWidth:60,textDirection:"auto"}),DG.Popup.include({_headerContent:null,_footerContent:null,_scroller:null,_scrollerBar:null,_barWrapper:null,_baron:null,_isBaronExist:!1,_popupShowClass:"leaflet-popup_show_true",_popupHideClass:"leaflet-popup_show_false",_popupTipClass:"leaflet-popup-tip-container",_tipSVGPath:"M0 0c12.643 0 28 7.115 28 44h2c0-36.885 15.358-44 28-44h-58z",_isAutoPanPaddingUserDefined:!1,initialize:function(t,e){this._popupStructure={},this._isAutoPanPaddingUserDefined=t&&t.hasOwnProperty("autoPanPadding"),i.call(this,t,e)},onAdd:function(t){t.on({entranceshow:this._closePopup,resize:this.resize},this),n.call(this,t),this._animateOpening(),void 0!==typeof ga&&ga(DG.config.gaName+".send","event","Popup","Use")},onRemove:function(t){this._animateClosing(),t.off({entranceshow:this._closePopup,resize:this.resize},this),DG.DomUtil.TRANSITION?this._removeTimeout=setTimeout(L.bind(L.DomUtil.remove,L.DomUtil,this._container),200):L.DomUtil.remove(this._container),t.fire("popupclose",{popup:this}),this._source&&this._source.fire("popupclose",{popup:this},!0)},setContent:function(t){return this._isNode(t)||"object"!=typeof t?this._bodyContent=t:Object.keys(t).forEach(function(e){this["_"+e+"Content"]=t[e]},this),this.update(),this},setHeaderContent:function(t){return this._headerContent=t,this.update(),this},setFooterContent:function(t){return this._footerContent=t,this.update(),this},getContent:function(){return this._bodyContent},getHeaderContent:function(){return this._headerContent},getFooterContent:function(){return this._footerContent},clear:function(){return Object.keys(this._popupStructure).forEach(this._clearElement,this),this._isBaronExist=!1,this},clearHeader:function(){return this._clearElement("header")},clearFooter:function(){return this._clearElement("footer")},findElement:function(t){return this._contentNode.querySelector(t)},_animateOpening:function(){DG.DomUtil.addClass(this._innerContainer,this._popupShowClass),DG.DomUtil.removeClass(this._innerContainer,this._popupHideClass)},_animateClosing:function(){DG.DomUtil.addClass(this._innerContainer,this._popupHideClass),DG.DomUtil.removeClass(this._innerContainer,this._popupShowClass)},_closePopup:function(){this._map.closePopup(this)},_isNode:function(t){return!!t.nodeName},_onCloseButtonClick:function(t){this._map&&this._map.closePopup(this),L.DomEvent.stop(t)},_close:function(){this._map&&(DG.Browser.mobile&&this._map.geoclicker&&(this.options.closeOnClick||this._map.options.closePopupOnClick)&&(this._map.geoclicker.popupWasOpen=!0),this._map.closePopup(this))},_initLayout:function(){o.call(this),DG.DomEvent.on(this._contentNode,"wheel",function(t){var e;if(t.composedPath)e=t.composedPath();else{var i=t.target;for(e=[];i.parentNode;)e.push(i),i=i.parentNode}e.indexOf(this._scroller)!==-1&&e.indexOf(this._barWrapper)===-1||t.preventDefault()},this),this._innerContainer=DG.DomUtil.create("div","leaflet-popup-inner "+this._popupHideClass,this._container),DG.DomEvent.disableClickPropagation(this._innerContainer),this.options.closeButton&&this._innerContainer.appendChild(this._detachEl(this._closeButton)),this._innerContainer.appendChild(this._detachEl(this._wrapper));var t=this._detachEl(this._tipContainer);if(DG.Browser.svg){var e=DG.SVG.create("path"),i=this._popupTipClass+" "+this._popupTipClass+"_svg";e.setAttribute("d",this._tipSVGPath),t=DG.SVG.create("svg"),t.setAttribute("class",i),t.appendChild(e),DG.DomEvent.disableClickPropagation(e)}else DG.DomUtil.addClass(t,this._popupTipClass+"_image"),DG.DomEvent.disableClickPropagation(t);this._innerContainer.appendChild(t)},_clearElement:function(t){return this["_"+t+"Content"]=null,this._detachEl(this._popupStructure[t]),delete this._popupStructure[t],this},_updateScrollPosition:function(){this._baron&&this._baron.update()},resize:function(){var t=this._updateLayout();if(this._updatePosition(),t)if(this._isBaronExist){DG.DomUtil.removeClass(this._scroller,"dg-scroller_hidden_true"),DG.DomUtil.addClass(this._scroller,"dg-scroller");var e=!!this._isBaronExist&&this._scroller.scrollTop;e&&(this._scroller.scrollTop=e);var i=this.options.maxHeight-2*this.options.border-this._getDelta();this._scrollerWrapper.style.height=i+"px",this._updateScrollPosition()}else this._isContentHeightEnough()||(this._initBaronScroller(),this._initBaron());else this._isBaronExist&&(this._scrollerWrapper.style.height="",DG.DomUtil.removeClass(this._scroller,"dg-scroller"),DG.DomUtil.addClass(this._scroller,"dg-scroller_hidden_true"),DG.DomUtil.removeClass(this._scroller,"dg-scroller"),DG.DomEvent.off(this._scroller,"scroll",this._onScroll));this._adjustPan(),this._bindAdjustPanOnTransitionEnd()},_adjustPan:function(t){if(this._map){if(t){if("max-height"!==t.propertyName)return;DG.DomEvent.off(this._wrapper,DG.DomUtil.TRANSITION_END,this._adjustPan)}var e=this.options;if(e.autoPan){var i=this._map,o=this._container.offsetHeight,n=this._containerWidth,r=new L.Point(this._containerLeft,-o-this._containerBottom);this._zoomAnimated&&r._add(L.DomUtil.getPosition(this._container));var a=[e.autoPanPadding[0],e.autoPanPadding[1]];!this._isAutoPanPaddingUserDefined&&this._map._container.offsetWidth>=e.maxWidth+2*e.mapControlsWidth&&(a[0]=e.mapControlsWidth);var s=i.layerPointToContainerPoint(r),l=L.point(a),u=L.point(e.autoPanPaddingTopLeft||l),c=L.point(e.autoPanPaddingBottomRight||l),h=i.getSize(),d=0,p=0;0!==h.x&&0!==h.y&&(s.x+n+c.x>h.x&&(d=s.x+n-h.x+c.x),s.x-d-u.x<0&&(d=s.x-u.x),s.y+o+c.y>h.y&&(p=s.y+o-h.y+c.y),s.y-p-u.y<0&&(p=s.y-u.y),(d||p)&&i.fire("autopanstart").panBy([d,p]))}}},_bindAdjustPanOnTransitionEnd:function(){DG.DomUtil.TRANSITION?DG.DomEvent.on(this._wrapper,DG.DomUtil.TRANSITION_END,this._adjustPan,this):this._adjustPan()},_isContentHeightEnough:function(){var t=this.options;if(!t.maxHeight)return!0;var e=this._popupStructure.body?this._popupStructure.body.offsetHeight+this._getDelta():this._contentNode.offsetHeight;return e+=2*t.border,e<=t.maxHeight},_initBaronScroller:function(){var t=this._popupStructure.body.parentNode,e=this._scrollerWrapper=DG.DomUtil.create("div","dg-scroller__wrapper",t),i=this._scroller=DG.DomUtil.create("div","dg-scroller",e),o=this._barWrapper=DG.DomUtil.create("div","dg-scroller__bar-wrapper",i),n=this.options.maxHeight-2*this.options.border;this._scrollerBar=DG.DomUtil.create("div","dg-scroller__bar",o),i.appendChild(this._detachEl(this._popupStructure.body)),n-=this._getDelta(),e.style.height=Math.max(18,n)+"px",e.style.width=t.offsetWidth+5+"px",this._isBaronExist=!0,this._switchEvents()},_onScroll:function(t){this.fire("scroll",{originalEvent:t})},_onClick:function(t){t.target=t.target||t.srcElement,this._moving||this.fire("click",{originalEvent:t})},_onStart:function(t){if(this._moved=!1,!this._moving){var e=t.touches?t.touches[0]:t;this._startPoint=new DG.Point(e.clientX,e.clientY),this._toggleTouchEvents()}},_onEnd:function(t){this._toggleTouchEvents(!0),this._onClick(t),this._moving=!1},_onMove:function(t){if(t.touches&&t.touches.length>1)return void(this._moved=!0);var e=t.touches&&1===t.touches.length?t.touches[0]:t,i=DG.point(e.clientX,e.clientY),o=Math.abs(i.subtract(this._startPoint).y);!o||o<10||(this._moving=this._moved=!0)},_initBaron:function(){var t=this._scrollerWrapper;this._baron=r({scroller:".dg-scroller",bar:".dg-scroller__bar",track:".dg-scroller__bar-wrapper",$:function(e){var i="[object String]"==={}.toString.call(e)?t.querySelector(e):e;return new a(i)},event:function(t,e,i,o){e.split(" ").forEach(function(e){DG.DomEvent[o||"on"](t,e,i)})}})},_initHeader:function(){this._popupStructure.header=DG.DomUtil.create("header","dg-popup__header",this._contentNode),this._popupStructure.header.setAttribute("dir",this.options.textDirection)},_initFooter:function(){this._popupStructure.footer=DG.DomUtil.create("footer","dg-popup__footer",this._contentNode),this._popupStructure.footer.setAttribute("dir",this.options.textDirection)},_initBodyContainer:function(){this._popupStructure.wrapper=DG.DomUtil.create("div","dg-popup__container-wrapper",this._contentNode),this._popupStructure.body=DG.DomUtil.create("div","dg-popup__container",this._popupStructure.wrapper),this._popupStructure.body.setAttribute("dir",this.options.textDirection)},update:function(){if(this._map){if(DG.Browser.ielt9||(this._container.style.visibility="hidden"),this._switchEvents(!0),this._clearNode(this._contentNode),this._isBaronExist=!1,this._headerContent&&this._initHeader(),this._bodyContent&&this._initBodyContainer(),this._footerContent&&this._initFooter(),
	this._updatePopupStructure(),this.resize(),DG.DomEvent.on(this._wrapper,"click",DG.DomEvent.stopPropagation),this._switchEvents(),DG.Browser.ielt9){var t=this._popupStructure.footer;t&&(t.className+=" ie8")}DG.Browser.ielt9||(this._container.style.visibility="")}},_getDelta:function(){var t=0,e=this._popupStructure;return e.header&&(t+=e.header.offsetHeight),e.footer&&(t+=e.footer.offsetHeight),t},_updateLayout:function(){var t,e=this.options,i=this._contentNode,o=this._wrapper,n=i.style,r=o.style,a="leaflet-popup-scrolled",s=!1;n.margin=e.border+"px",DG.DomUtil.removeClass(i,a),this._isContentHeightEnough()?r.maxHeight=i.offsetHeight+2*e.border+"px":(r.maxHeight=e.maxHeight+"px",DG.DomUtil.addClass(i,a),s=!0);var l=2*e.autoPanPadding[0];return e.sprawling?(t=e.maxWidth,t=Math.min(t,this._map._container.offsetWidth-l),t=Math.max(t,e.minWidth)):(r.width="",n.whiteSpace="nowrap",t=o.offsetWidth,n.whiteSpace="",t=Math.min(t,this._map._container.offsetWidth-l),t=Math.min(Math.max(t,e.minWidth),e.maxWidth)),r.width=t+"px",this._containerWidth=this._container.offsetWidth,s},_updatePopupStructure:function(){Object.keys(this._popupStructure).forEach(function(t){this._insertContent(this["_"+t+"Content"],this._popupStructure[t])},this),this.fire("contentupdate")},_insertContent:function(t,e){t&&e&&(t="function"==typeof t?t(this._source||this):t,"string"==typeof t?e.innerHTML=t:(this._clearNode(e),e.appendChild(t)))},_clearNode:function(t){for(;t.hasChildNodes();)t.removeChild(t.firstChild)},_detachEl:function(t){return t.parentNode&&t.parentNode.removeChild(t),t},_switchEvents:function(t){var e=t?"off":"on";DG.Browser.touch?DG.DomEvent[e](this._contentNode,"touchstart mousedown mousemove",this._onStart,this):DG.DomEvent[e](this._contentNode,"click",this._onClick,this),this._isBaronExist&&DG.DomEvent[e](this._scroller,"scroll",this._onScroll,this)},_toggleTouchEvents:function(t){var e=t?"off":"on";DG.DomEvent[e](this._contentNode,"touchmove",this._onMove,this),DG.DomEvent[e](this._contentNode,"touchend",this._onEnd,this)}})}(),DG.Map.include({_markerClass:"dg-customization__marker_type_mushroom",_markerShowClass:"dg-customization__marker_appear",_markerHideClass:"dg-customization__marker_disappear",_dgHideClass:"dg-popup_hidden_true",openPopup:function(t,e,i){if(!(t instanceof L.Popup)){var o=t;t=new L.Popup(i).setContent(o)}return e&&t.setLatLng(e),this.hasLayer(t)?this:(this._popup&&this._popup.options.autoClose&&this.closePopup(),this._popup=t,t._source&&t._source._icon&&(t._source._icon.className.indexOf(this._markerClass)!==-1?(DG.DomUtil.removeClass(t._source._icon,this._markerShowClass),DG.DomUtil.addClass(t._source._icon,this._markerHideClass)):(DG.DomUtil.addClass(t._source._icon,this._dgHideClass),t._source._shadow&&DG.DomUtil.addClass(t._source._shadow,this._dgHideClass))),this.addLayer(t))},closePopup:function(t){return t&&t!==this._popup||(t=this._popup,this._popup=null),t&&(t._source&&t._source._icon&&(t._source._icon.className.indexOf(this._markerClass)!==-1?(DG.DomUtil.removeClass(t._source._icon,this._markerHideClass),DG.DomUtil.addClass(t._source._icon,this._markerShowClass)):(DG.DomUtil.removeClass(t._source._icon,this._dgHideClass),t._source._shadow&&DG.DomUtil.removeClass(t._source._shadow,this._dgHideClass))),this.removeLayer(t)),this}}),DG.Dictionary={},DG.Dictionary.ru={pluralRules:function(t){return t%10===1&&t%100!==11?0:t%10>=2&&t%10<=4&&t%10%1===0&&(t%100<12||t%100>14)?1:t%10===0||t%10>=5&&t%10<=9&&t%10%1===0||t%100>=11&&t%100<=14&&t%100%1===0?2:void 0}},DG.Dictionary.en={pluralRules:function(t){return 1===t?0:1}},DG.Dictionary.it={pluralRules:function(t){return 1===t?0:1}},DG.Dictionary.cs={pluralRules:function(t){return 1===t?0:t>=2&&t<=4?1:2}},DG.Dictionary.es={pluralRules:function(t){return t>=2?1:0}},DG.Dictionary.ar={pluralRules:function(){return 0}},DG.Locale={t:function(t,e){var i,o,n,r=this._map.getLang(),a=!1;return"undefined"==typeof this.constructor.Dictionary[r]&&(r="ar"===r?"en":DG.config.defaultLang),o=this.constructor.Dictionary[r][t],(a="undefined"!=typeof o)?(i=a?o:t,void 0!==e&&(e=parseInt(e,10),e=isNaN(e)?0:e,n=this.constructor.Dictionary[r].pluralRules(e),i=o[n]),i=DG.Util.template(i,{n:e})):t}},DG.Map.include({setLang:function(t){t&&"[object String]"===Object.prototype.toString.call(t)&&(this.options.currentLang=t,this.fire("langchange",{lang:t}))},getLang:function(){if(!this.options.currentLang){var t=document.documentElement,e=t.lang||t.getAttributeNS&&t.getAttributeNS("http://www.w3.org/XML/1998/namespace","lang")||DG.config.defaultLang;this.options.currentLang=e}return this.options.currentLang}}),DG.RoundControl=DG.Control.extend({includes:DG.Mixin.Events,options:{position:"topright",iconClass:"default"},onAdd:function(t){var e=this._controlCLass="dg-control-round",i=this._controlIconCLass=this._controlCLass+"__icon",o=DG.DomUtil.create("div","");if(this._disable)return o;DG.DomUtil.addClass(o,e);var n=this._link=DG.DomUtil.create("a",i+" "+i+"_name_"+this.options.iconClass,o);return n.href="#",this._renderTranslation(),this._map=t,DG.DomEvent.on(o,"click",this._toggleControl,this).on(o,"dblclick",DG.DomEvent.stopPropagation).on(n,"mousedown",DG.DomEvent.stopPropagation),this.fireEvent("add"),o},onRemove:function(){this.fireEvent("remove"),DG.DomEvent.off(this._link,"click",this._toggleControl)},setState:function(t){return this._link&&this._container?(this._state&&(DG.DomUtil.removeClass(this._container,this._controlCLass+"_state_"+this._state),DG.DomUtil.removeClass(this._link,this._controlIconCLass+"_state_"+this._state),this._state=null),t&&(this._state=t,DG.DomUtil.addClass(this._container,this._controlCLass+"_state_"+this._state),DG.DomUtil.addClass(this._link,this._controlIconCLass+"_state_"+this._state)),this):this},_toggleControl:function(t){DG.DomEvent.stop(t),this.fireEvent("click")}}),DG.RoundControl.include(DG.Locale),DG.roundControl=function(t){return new DG.RoundControl(t)};var ie9=function(){var t=document.createElement("div"),e=t.getElementsByTagName("i");return t.innerHTML="<!--[if IE 9]><i></i><![endif]-->",Boolean(e[0])}(),safari51=DG.Browser.safari&&navigator.userAgent.indexOf("Version/5.1")!==-1,wasPreviouslyDisabled=!1;try{wasPreviouslyDisabled="false"===localStorage.getItem("DGMuseum")}catch(err){}DG.Map.mergeOptions({museum:!wasPreviouslyDisabled&&(DG.Browser.ielt9||ie9||DG.Browser.opera12||safari51)}),DG.Map.Museum=DG.Handler.extend({statics:{Dictionary:{ar:{wearesorry:"لا نضمن لك تشغيل ثابت للتطبيق على متصفحك. حاول التحديث:"},cs:{wearesorry:"Nezaručujeme stabilní fungování aplikace ve Vašem prohlížeči. Zkuste provést aktualizaci:"},en:{wearesorry:"We do not guarantee stable operation of the application in your browser. Try updating:"},es:{wearesorry:"No garantizamos un funcionamiento estable de la aplicación en su buscador. Intente actualizarlo:"},it:{wearesorry:"Non garantiamo il funzionamento stabile dell'applicazione nel tuo browser. Prova ad aggiornare:"},ru:{wearesorry:"Мы не гарантируем стабильную работу приложения в вашем браузере. Попробуйте обновиться:"}}},includes:[DG.Locale],initialize:function(t){this._map=t,this._element=document.createElement("div"),this._element.className="dg-museum",this._element.innerHTML='<span></span><a class="dg-museum-browser dg-museum__chrome" target="_blank" href="https://www.google.com/chrome/"></a><a class="dg-museum-browser dg-museum__firefox" target="_blank" href="https://www.mozilla.org/firefox/new/"></a><a class="dg-museum-browser dg-museum__safari" target="_blank" href="https://support.apple.com/downloads/safari"></a><a class="dg-museum-browser dg-museum__opera" target="_blank" href="https://www.opera.com/"></a><a class="dg-museum-browser dg-museum__ie" target="_blank" href="https://windows.microsoft.com/internet-explorer/download-ie"></a>',this._text=this._element.children[0],this._closeButton=document.createElement("span"),this._closeButton.className="dg-museum__close",this._element.appendChild(this._closeButton),this._renderTranslation()},addHooks:function(){this._map.getContainer().appendChild(this._element),this._map.on("langchange",this._renderTranslation,this),DG.DomEvent.on(this._closeButton,"click",this._onCloseButtonClick,this)},removeHooks:function(){this._map.getContainer().removeChild(this._element),this._map.off("langchange",this._renderTranslation,this),DG.DomEvent.off(this._closeButton,"click",this._onCloseButtonClick,this)},_onCloseButtonClick:function(t){DG.DomEvent.stop(t);try{localStorage.setItem("DGMuseum","false")}catch(e){}this.disable()},_renderTranslation:function(){var t=this._map.getLang();this._text.innerHTML=this.t("wearesorry"),this._element.setAttribute("dir","ar"===t?"rtl":"ltr")}}),DG.Map.addInitHook("addHandler","museum",DG.Map.Museum),DG.configTheme=DG.configTheme||{},DG.configTheme.markersData={iconSize:[22,34],className:"dg-customization__marker dg-customization__marker_type_mushroom",iconAnchor:[10,32]},DG.Map.mergeOptions({bounceAtZoomLimits:!1});var controlAddTo=DG.Control.prototype.addTo;DG.Control.include({addTo:function(t){return t.on("langchange",this._renderTranslation,this),controlAddTo.call(this,t)},_renderTranslation:function(){}}),DG.DivIcon.include({createIcon:function(t){var e=t&&"DIV"===t.tagName?t:document.createElement("div"),i=this.options;if(i.html instanceof Element?(DG.DomUtil.empty(e),e.appendChild(i.html)):e.innerHTML=i.html!==!1?i.html:"",i.bgPos){var o=toPoint(i.bgPos);e.style.backgroundPosition=-o.x+"px "+-o.y+"px"}return this._setIconStyles(e,"icon"),e}}),DG.Browser.safari51=DG.Browser.safari&&navigator.userAgent.indexOf("Version/5.1")!==-1;var msPointer=navigator.msPointerEnabled&&navigator.msMaxTouchPoints&&!window.PointerEvent,pointer=window.PointerEvent&&navigator.pointerEnabled&&navigator.maxTouchPoints||msPointer,documentTouch=window.DocumentTouch&&document instanceof window.DocumentTouch;DG.Browser.touchEnabled=pointer||"ontouchstart"in window||documentTouch,DG.Marker.prototype.options.icon=DG.divIcon(DG.configTheme.markersData);var utilSetOptions=DG.Util.setOptions;if(DG.setOptions=L.setOptions=DG.Util.setOptions=function(t,e){return e&&"undefined"!=typeof e.clickable&&(e.interactive=e.clickable),utilSetOptions.call(this,t,e)},DG.Layer.mergeOptions({nonBubblingEvents:["click","dblclick","mouseover","mouseout","contextmenu"]}),L.Canvas.include({_initContainer:function(){var t=this._container=document.createElement("canvas");L.DomEvent.on(t,"mousemove",this._onMouseMove,this).on(t,"click dblclick mousedown mouseup contextmenu",this._onClick,this).on(t,"mouseout",this._handleMouseOut,this),this._ctx=t.getContext("2d")}}),DG.Path){var pathInitialize=DG.Path.prototype.onAdd,loggedGeometryTypes={};DG.Path.include({onAdd:function(t){var e="Unknown";return DG.Rectangle&&this instanceof DG.Rectangle?e="Rectangle":DG.Circle&&this instanceof DG.Circle?e="Circle":DG.CircleMarker&&this instanceof DG.CircleMarker?e="CircleMarker":DG.Polygon&&this instanceof DG.Polygon?e="Polygon":DG.Polyline&&this instanceof DG.Polyline&&(e="Polyline"),loggedGeometryTypes[e]||(loggedGeometryTypes[e]=!0,void 0!==typeof ga&&ga(DG.config.gaName+".send","event","Geometry","Use",e)),pathInitialize.call(this,t)}})}var initMap=DG.Map.prototype.initialize,panBy=DG.Map.prototype.panBy,getBoundsZoom=DG.Map.prototype.getBoundsZoom,setMaxZoom=DG.Map.prototype.setMaxZoom;DG.Map.include({_tileLayersNumber:0,_mapMaxZoomCache:null,initialize:function(t,e){e=DG.extend({wheelPxPerZoomLevel:1e4},e),this.metaLayers=[],initMap.call(this,t,e),this.options.center&&void 0!==this.options.zoom&&this.setView(DG.latLng(this.options.center),this.options.zoom,{reset:!0}),this._lastMetalayer={layer:void 0,entity:void 0}},setView:function(t,e,i){if(this._restrictZoom(t,e),e=void 0===e?this._zoom:this._limitZoom(e),t=this._limitCenter(DG.latLng(t),e,this.options.maxBounds),i=i||{},i.animate&&(i.animate=this._testAnimation(t)),this._stop(),this._loaded&&!i.reset&&i!==!0){void 0!==i.animate&&(i.zoom=DG.extend({animate:i.animate,duration:i.duration},i.zoom),i.pan=DG.extend({animate:i.animate,duration:i.duration},i.pan));var o=this._zoom!==e?this._tryAnimatedZoom&&this._tryAnimatedZoom(t,e,i.zoom):this._tryAnimatedPan(t,i.pan);if(o)return clearTimeout(this._sizeTimer),this}return this._resetView(t,e),this},panBy:function(t,e){var i=panBy.call(this,t,e),o=this._restrictZoom(this.getCenter());return this.getZoom()>o&&this.setZoom(o),i},getBoundsZoom:function(t,e,i){return t=DG.latLngBounds(t),this._restrictZoom(t),getBoundsZoom.call(this,t,e,i)},getTileLayersNumber:function(){return this._tileLayersNumber},setMaxZoom:function(t){return this._mapMaxZoomCache=null,setMaxZoom.call(this,t)},_testAnimation:function(t){if(this.projectDetector.enabled()){var e=this.projectDetector.getProject(),i=this.projectDetector.isProjectHere(t);if(e&&i)return e.code===i.code}return!0},_updateTileLayers:function(t){t.layer instanceof DG.TileLayer&&!t.layer._isDg&&("layeradd"===t.type?this._tileLayersNumber++:this._tileLayersNumber--)},_getNewBounds:function(t,e){if(t instanceof DG.LatLngBounds)return t;var i=this.project(t,e),o=this.getSize().divideBy(2),n=this.unproject(i.subtract(o),e),r=this.unproject(i.add(o),e);return DG.latLngBounds(n,r)},_restrictZoom:function(t,e){if(this._layers&&this.projectDetector.enabled()&&0===this._tileLayersNumber){var i=this.options,o=!!i.maxZoom,n=this.baseLayer,r=this._getNewBounds(t,e),a=this.projectDetector.isProjectHere(r);return o?(this._mapMaxZoomCache||(this.baseLayer.options.detectRetina&&DG.Browser.retina&&i.maxZoom>0&&i.maxZoom--,this._mapMaxZoomCache=i.maxZoom),i.maxZoom=this._mapMaxZoomCache&&a?this._mapMaxZoomCache:DG.config.projectLeaveMaxZoom,a&&(this._mapMaxZoomCache=i.maxZoom),i.maxZoom):(a?n.options.detectRetina&&DG.Browser.retina&&a.maxZoom>0?n.options.maxZoom=a.maxZoom-1:n.options.maxZoom=a.maxZoom:n.options.maxZoom=DG.config.projectLeaveMaxZoom,n.options.maxNativeZoom=n.options.maxZoom,this._updateZoomLevels(),n.options.maxZoom)}},_fireDOMEvent:function(t,e,i){if(13!==t.keyCode){if("click"===t.type){var o=L.Util.extend({},t);o.type="preclick",this._fireDOMEvent(o,o.type,i)}if(!t._stopped&&(i=(i||[]).concat(this._findEventTargets(t,e)),i.length)){var n=i[0];"contextmenu"===e&&n.listens(e,!0)&&L.DomEvent.preventDefault(t);var r={originalEvent:t,eventTargets:i,eventTargetsMapIndex:i.indexOf(this)};if("keypress"!==t.type){var a=n instanceof L.Marker;r.containerPoint=a?this.latLngToContainerPoint(n.getLatLng()):this.mouseEventToContainerPoint(t),r.layerPoint=this.containerPointToLayerPoint(r.containerPoint),r.latlng=a?n.getLatLng():this.layerPointToLatLng(r.layerPoint)}for(var s=0;s<i.length;s++){if(i[s]===this){var l=this._getCurrentMetaLayer(r);"mousemove"===e?this._lastMetalayer.entity&&l.entity&&this._lastMetalayer.entity.id===l.entity.id?this._fireMetalayerEvent("mousemove",l,r):(this._fireMetalayerEvent("mouseout",this._lastMetalayer,r),this._fireMetalayerEvent("mouseover",l,r),this._fireMetalayerEvent("mousemove",l,r),this._lastMetalayer=l):this._fireMetalayerEvent(e,l,r),r.originalEvent._stopped||i[s].fire(e,r,!0)}else i[s].fire(e,r,!0),this._lastMetalayer.entity&&r.originalEvent._stopped&&(this._fireMetalayerEvent("mouseout",this._lastMetalayer,r),this._lastMetalayer={layer:void 0,entity:void 0});if(r.originalEvent._stopped||i[s].options.nonBubblingEvents&&L.Util.indexOf(i[s].options.nonBubblingEvents,e)!==-1)return}}}},_getCurrentMetaLayer:function(t){var e=t.originalEvent.target||t.originalEvent.srcElement,i="click"===t.originalEvent.type;if(e===this._container||DG.Browser.ie&&"leaflet-tile leaflet-tile-loaded"===e.className||"CANVAS"===e.tagName)for(var o=this.metaLayers.length-1;o>=0;o--){var n=this.metaLayers[o].getHoveredObject(t);if(n)return{layer:this.metaLayers[o],entity:n};if(i)return{layer:this.metaLayers[o],entity:void 0}}return{layer:void 0,entity:void 0}},_fireMetalayerEvent:function(t,e,i){if((e.entity||"click"===t)&&e.layer){var o=e.layer.mapEvents[t];o&&(i.entity=e.entity,o.call(e.layer,i))}}}),DG.Map.addInitHook(function(){this.on("layeradd layerremove",this._updateTileLayers)}),DG.Map.addInitHook(function(){0==this.options.dragging&&0==this.options.tap&&DG.DomUtil.addClass(this._container,"dg-dragging-false")}),DG.Map.addInitHook(function(){function t(){var t=this.getLang(),o=this.projectDetector&&this.projectDetector.getProject();"ru"!==t||o?this.baseLayer.options.errorTileUrl=e:this.baseLayer.options.errorTileUrl=i,""===u&&"ar"===t&&o&&"ae"===o.country_code?(u="ar",this.baseLayer.setUrl(a),this.baseLayer.setPreviewUrl&&this.baseLayer.setPreviewUrl(l)):"ar"!==u||"ar"===t&&o&&"ae"===o.country_code||(u="",this.baseLayer.setUrl(r),this.baseLayer.setPreviewUrl&&this.baseLayer.setPreviewUrl(s))}var e="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX28t5R0k5UAAAAH0lEQVR4Xu3AAQkAAADCMPunNsdhWxwAAAAAAAAAwAEhAAABg2UP5AAAAABJRU5ErkJggg==",i=DG.config.protocol+DG.config.baseUrl+"/img/nomap_ru.png",o=DG.Browser.mobile?DG.MobileTileLayer:DG.TileLayer,n=o.extend({initialize:function(t,e){this._isDg=!0,o.prototype.initialize.call(this,t,e)},getTiles:function(){return this._tiles}}),r=DG.config.protocol+(DG.Browser.retina?DG.config.retinaTileServer:DG.config.tileServer),a=DG.config.protocol+(DG.Browser.retina?DG.config.arabicRetinaTileServer:DG.config.arabicTileServer),s=DG.config.protocol+(DG.Browser.retina?DG.config.previewRetinaTileServer:DG.config.previewTileServer),l=DG.config.protocol+(DG.Browser.retina?DG.config.arabicPreviewRetinaTileServer:DG.config.arabicPreviewTileServer);this.baseLayer=new n(r,{subdomains:"0123",errorTileUrl:"ru"===this.getLang()?i:e,detectRetina:DG.config.detectRetina,maxZoom:19,maxNativeZoom:19,zIndex:0,updateWhenIdle:!1,previewUrl:s});var u="";t.call(this),this.baseLayer.addTo(this),this.on({langchange:t,projectchange:t,projectleave:t},this)}),DG.Map.mergeOptions({tilesCheck:!0}),DG.Map.TilesCheck=DG.Handler.extend({initialize:function(t){this._map=t,this._layer=t.baseLayer,this._moveStartEventCounter=0,this._moveEndEventCounter=0,this._loadingEventCounter=0,this._loadEventCounter=0},addHooks:function(){this._map.on(this._mapEvents,this),this._layer.on(this._layerEvents,this)},removeHooks:function(){this._map.off(this._mapEvents,this),this._layer.off(this._layerEvents,this)},_mapEvents:{layeradd:function(t){t.layer==this._layer&&this.enable()},layerremove:function(t){t.layer==this._layer&&this.disable()},movestart:function(){this._stopWaiting(),this._moveStartEventCounter++,this._isWaiting=!0},moveend:function(){this._moveEndEventCounter++,(this._isWaiting||this._moveStartEventCounter===this._moveEndEventCounter)&&(this._isMoveEnd=!0,this._checkWaiting())}},_layerEvents:{loading:function(){this._loadingEventCounter++},load:function(){this._loadEventCounter++,(this._isWaiting||this._loadingEventCounter===this._loadEventCounter)&&(this._isLoad=!0,this._checkWaiting())}},_stopWaiting:function(){this._isWaiting=!1,this._isMoveEnd=!1,this._isLoad=!1},_checkWaiting:function(){this._isWaiting&&this._isLoad&&this._isMoveEnd&&(this._stopWaiting(),this._resetCounters(),this._checkTiles())},_checkTiles:function(){if(0===this._map.getTileLayersNumber()&&this._map._loaded){var t=this._layer._tileZoom,e=this._layer.options.errorTileUrl,i=this._layer.getTiles();for(var o in i)if(i[o].coords.z===t&&i[o].el.src!==e)return;this._map.zoomOut()}},_resetCounters:function(){this._moveStartEventCounter=0,this._moveEndEventCounter=0,this._loadingEventCounter=0,this._loadEventCounter=0}}),DG.Map.addInitHook("addHandler","tilesCheck",DG.Map.TilesCheck);var onDragEnd=DG.Map.Drag.prototype._onDragEnd;DG.Map.Drag.include({_rememberTimeAndPosition:function(){var t=this._lastTime=+new Date,e=this._lastPos=this._draggable._absPos||this._draggable._newPos;for(this._positions.push(e),this._times.push(t);t-this._times[0]>50;)this._positions.shift(),this._times.shift()},_onDrag:function(t){this._map.options.inertia&&this._rememberTimeAndPosition(),this._map.fire("move",t).fire("drag",t)},_onDragEnd:function(){this._map.options.inertia&&!DG.Browser.touch&&this._rememberTimeAndPosition(),onDragEnd.call(this)}}),DG.PolyUtil.inside=function(t,e,i){i=i||DG.PolyUtil._defaultPointReduce;var o=e.coordinates,n=i(t);"Polygon"===e.type&&(o=[o]);for(var r=!1,a=0;a<o.length&&!r;){if(this._inRing(n,o[a][0],i)){for(var s=!1,l=1;l<o[a].length&&!s;)this._inRing(n,o[a][l],i)&&(s=!0),l++;s||(r=!0)}a++}return r},DG.PolyUtil._inRing=function(t,e,i){for(var o=!1,n=0,r=e.length-1;n<e.length;r=n++){var a=i(e[n]),s=i(e[r]),l=a[0],u=a[1],c=s[0],h=s[1],d=u>t[1]!=h>t[1]&&t[0]<(c-l)*(t[1]-u)/(h-u)+l;d&&(o=!o)}return o},DG.PolyUtil._defaultPointReduce=function(t){return t},DG.Browser.mobile&&!function(){var t=L.DomUtil.addClass;L.DomUtil.addClass=function(e,i){"leaflet-dragging"!==i&&"leaflet-drag-target"!==i&&t(e,i)};var e=L.DomUtil.removeClass;L.DomUtil.removeClass=function(t,i){"leaflet-dragging"!==i&&"leaflet-drag-target"!==i&&e(t,i)},L.Draggable.include({_onMove:function(t){if(!t._simulated&&this._enabled){if(t.touches&&t.touches.length>1)return void(this._moved=!0);var e=t.touches&&1===t.touches.length?t.touches[0]:t,i=new L.Point(e.clientX,e.clientY),o=i.subtract(this._startPoint);if((o.x||o.y)&&!(Math.abs(o.x)+Math.abs(o.y)<this.options.clickTolerance)){L.DomEvent.preventDefault(t),this._moved||(this.fire("dragstart"),this._moved=!0,this._startPos=L.DomUtil.getPosition(this._element).subtract(o),this._lastTarget=t.target||t.srcElement,window.SVGElementInstance&&this._lastTarget instanceof window.SVGElementInstance&&(this._lastTarget=this._lastTarget.correspondingUseElement));var n=this._startPos.add(o)._round();this._moving=!0,L.Util.cancelAnimFrame(this._animRequest),this._lastEvent=t,this._newPos&&this._newPos.x==n.x&&this._newPos.y==n.y||(this._newPos=n,this._animRequest=L.Util.requestAnimFrame(this._updatePosition,this,!0))}}}}),L.Map.Drag.include({_onDragEnd:function(t){var e=this._map,i=e.options,o=!i.inertia||this._times.length<2;if(e.fire("dragend",t),o)e.fire("moveend");else{var n=this._lastPos.subtract(this._positions[0]),r=(this._lastTime-this._times[0])/1e3,a=i.easeLinearity,s=n.multiplyBy(a/r),l=s.distanceTo([0,0]),u=Math.min(i.inertiaMaxSpeed,l),c=s.multiplyBy(u/l),h=1,d=c.multiplyBy(-h/2).round();d.x||d.y?(d=e._limitOffset(d,e.options.maxBounds),L.Util.requestAnimFrame(function(){e.panBy(d,{duration:h,easeLinearity:a,noMoveStart:!0,animate:!0})})):e.fire("moveend")}}})}(),L.MobileTileLayer=L.TileLayer.extend({initialize:function(t,e){L.TileLayer.prototype.initialize.call(this,t,e),this._previewUrl=e.previewUrl},setPreviewUrl:function(t){this._previewUrl=t,this.redraw()},createTile:function(t,e,i){var o=document.createElement("img");return o.onload=L.bind(this._tileOnLoad,this,e,o),o.onerror=L.bind(this._tileOnError,this,e,o),this.options.crossOrigin&&(o.crossOrigin=""),o.alt="",o.src=this.getTileUrl(t,i),o},_initTile:function(t){t.style.position="absolute";var e=this.getTileSize();return t.style.width=e.x+"px",t.style.height=e.y+"px",t.style.visibility="hidden",t.style.pointerEvents="none",t.onselectstart=L.Util.falseFn,t.onmousemove=L.Util.falseFn,L.Browser.android&&!L.Browser.android23&&(t.style.WebkitBackfaceVisibility="hidden"),t},_updateLevels:function(){var t=this._tileZoom,e=this.options.maxZoom;if(void 0!==t){for(var i in this._levels)this._levels[i].el.children.length||i===t?this._levels[i].el.style.zIndex=e-Math.abs(t-i):(L.DomUtil.remove(this._levels[i].el),this._removeTilesAtZoom(i),delete this._levels[i]);var o=this._levels[t],n=this._map;return o||(o=this._levels[t]={},o.el=L.DomUtil.create("div","leaflet-zoom-animated",this._container),o.el.style.zIndex=e,o.origin=n.project(n.unproject(n.getPixelOrigin()),t).round(),o.zoom=t,this._setZoomTransform(o,n.getCenter(),n.getZoom()),L.Util.falseFn(o.el.offsetWidth)),this._level=o,o}},_update:function(t){var e=this._map;if(e){var i=e.getZoom();if(void 0===t&&(t=e.getCenter()),void 0!==this._tileZoom){var o=this._getTiledPixelBounds(t),n=this._pxBoundsToTileRange(o),r=n.getCenter(),a=[],s=this.options.keepBuffer,l=new L.Bounds(n.getBottomLeft().subtract([s,-s]),n.getTopRight().add([s,-s]));for(var u in this._tiles){var c=this._tiles[u].coords;c.z===this._tileZoom&&l.contains(L.point(c.x,c.y))||(this._tiles[u].current=!1)}if(Math.abs(i-this._tileZoom)>1)return void this._setView(t,i);for(var h=n.min.y;h<=n.max.y;h++)for(var d=n.min.x;d<=n.max.x;d++){var p=new L.Point(d,h);if(p.z=this._tileZoom,this._isValidTile(p)){var _=this._tiles[this._tileCoordsToKey(p)];_?_.current=!0:a.push(p)}}if(a.sort(function(t,e){return t.distanceTo(r)-e.distanceTo(r)}),0!==a.length)for(this._loading||(this._loading=!0,this.fire("loading")),d=0;d<a.length;d++)this._addTile(a[d],this._level.el)}}},_needPreviewTile:function(t){return this._tileZoom-this._map.getZoom()>0?!this._existTileFromLowerZoom(t):!this._existTilesFromHigherZoom(t)},_existTileFromLowerZoom:function(t){var e=L.point(t.x/2,t.y/2)._floor();e.z=t.z-1;var i=this._tileCoordsToKey(e),o=this._tiles[i];return o&&!o.preview},_existTilesFromHigherZoom:function(t){for(var e=t.x,i=t.y,o=2*e;o<2*e+2;o++)for(var n=2*i;n<2*i+2;n++){var r=new L.Point(o,n);r.z=t.z+1;var a=this._tileCoordsToKey(r);if(!this._tiles[a])return!1}return!0},_addTile:function(t,e){var i=this._getTilePos(t),o=this._tileCoordsToKey(t),n=this._wrapCoords(t),r=this._needPreviewTile(n),a=r?this._previewUrl:this._url,s=this.createTile(n,L.bind(this._tileReady,this,t),a);this._initTile(s),L.DomUtil.setPosition(s,i),this._tiles[o]={el:s,preview:r,coords:t,current:!0},e.appendChild(s),this.fire("tileloadstart",{tile:s,coords:t})},_tileReady:function(t,e,i){if(this._map){e&&this.fire("tileerror",{error:e,tile:i,coords:t});var o=this._tileCoordsToKey(t);i=this._tiles[o],i&&(i.originalEl&&i.el.parentNode?(i.el.parentNode.replaceChild(i.originalEl,i.el),i.el=i.originalEl,i.originalEl=null,i.preview=!1):i.preview&&(i.originalEl=this.createTile(this._wrapCoords(t),L.bind(this._tileReady,this,t),this._url),this._initTile(i.originalEl),L.DomUtil.setPosition(i.originalEl,this._getTilePos(t))),i.loaded=+new Date,i.active=!0,this._pruneTiles(),e||(i.el.style.visibility="",this.fire("tileload",{tile:i.el,preview:i.preview,coords:t})),this._noTilesToLoad()&&(this._loading=!1,this.fire("load"),L.Browser.ielt9||!this._map._fadeAnimated?L.Util.requestAnimFrame(this._pruneTiles,this):setTimeout(L.bind(this._pruneTiles,this),250)))}},getTileUrl:function(t,e){var i={r:L.Browser.retina?"@2x":"",s:this._getSubdomain(t),x:t.x,y:t.y,z:this._getZoomForUrl()};if(this._map&&!this._map.options.crs.infinite){var o=this._globalTileRange.max.y-t.y;this.options.tms&&(i.y=o),i["-y"]=o}return L.Util.template(e,L.extend(i,this.options))}}),DG.Control.Zoom.include(DG.Locale),DG.Control.Zoom.Dictionary={},DG.Control.Zoom.include({onAdd:function(t){var e="dg-zoom",i='<div class="dg-control-round__icon '+e+"__control "+e+"__button "+e+'__button_type_{type}"></div>',o=DG.DomUtil.create("div",e);return this._map=t,this._zoomInButton=this._createButton(DG.Util.template(i,{type:"in"}),this.t("zoom_in"),"dg-control-round "+e+"__in",o,this._zoomIn,this),this._zoomOutButton=this._createButton(DG.Util.template(i,{type:"out"}),this.t("zoom_out"),"dg-control-round "+e+"__out",o,this._zoomOut,this),this._updateDisabled(),t.on("zoomend zoomlevelschange",this._updateDisabled,this),o},_originalCreateButton:DG.Control.Zoom.prototype._createButton,_createButton:function(){var t=Array.prototype.slice.call(arguments),e=this._originalCreateButton.apply(this,t),i=e.children[0],o="dg-control-round_state_active",n="dg-control-round__icon_state_active";return DG.DomEvent.on(e,"touchstart",function(){DG.DomUtil.addClass(e,o),DG.DomUtil.addClass(i,n)}).on(e,"touchend touchcancel",function(){DG.DomUtil.removeClass(e,o),DG.DomUtil.removeClass(i,n)}),e},_renderTranslation:function(){this._zoomInButton&&this._zoomOutButton&&(this._zoomInButton.title=this.t("zoom_in"),this._zoomOutButton.title=this.t("zoom_out"))}}),DG.Control.Zoom.Dictionary.ru={zoom_in:"Приблизить",zoom_out:"Отдалить"},DG.Control.Zoom.Dictionary.it={zoom_in:"Zoom avanti",zoom_out:"Zoom indietro"},DG.Control.Zoom.Dictionary.cs={zoom_in:"Přiblížit",zoom_out:"Oddálit"},DG.Control.Zoom.Dictionary.en={zoom_in:"Zoom in",zoom_out:"Zoom out"},DG.Control.Zoom.Dictionary.es={zoom_in:"Acercar",zoom_out:"Alejar"},DG.Control.Zoom.Dictionary.ar={zoom_in:"",zoom_out:""};var dust=_dereq_("dustjs-linkedin");_dereq_("dustjs-helpers"),DG.dust=function(t,e){var i;return dust.render(t,e,function(t,e){i=e}),i},DG.Control.Attribution.include(DG.Locale),DG.Control.Attribution.Dictionary={},DG.Control.Attribution.include({options:{position:"bottomright"},_getLink:function(t){var e={ru:{copyright_logo:"https://2gis.ru/?utm_source=copyright&utm_medium=map&utm_campaign=partners",copyright_apilink:"https://dev.2gis.ru/?utm_source=copyright&utm_medium=map&utm_campaign=partners",copyright_license:"https://law.2gis.ru/api-rules/",open_link:"https://2gis.ru"},it:{copyright_logo:"https://2gis.it/?utm_source=copyright&utm_medium=map&utm_campaign=partners",copyright_apilink:"https://dev.2gis.com/?utm_source=copyright&utm_medium=map&utm_campaign=partners",copyright_license:"https://law.2gis.it/licensing-agreement/",open_link:"https://2gis.ru"},cz:{copyright_logo:"https://praha.2gis.cz/?utm_source=copyright&utm_medium=map&utm_campaign=partners",copyright_apilink:"https://dev.2gis.com/?utm_source=copyright&utm_medium=map&utm_campaign=partners",copyright_license:"https://law.2gis.cz/api-rules/",open_link:"https://2gis.ru"},cl:{copyright_logo:"https://santiago.2gis.cl/?utm_source=copyright&utm_medium=map&utm_campaign=partners",copyright_apilink:"https://dev.2gis.com/?utm_source=copyright&utm_medium=map&utm_campaign=partners",copyright_license:"https://law.2gis.cl/api-rules/",open_link:"https://2gis.ru"},cy:{copyright_logo:"https://info.2gis.com.cy/lemesos?utm_source=copyright&utm_medium=map&utm_campaign=partners",copyright_apilink:"https://dev.2gis.com/?utm_source=copyright&utm_medium=map&utm_campaign=partners",copyright_license:"https://law.2gis.com.cy/api-rules/",open_link:"https://2gis.ru"},ae:{copyright_logo:"https://2gis.ae/dubai?utm_source=copyright&utm_medium=map&utm_campaign=partners",copyright_apilink:"http://dev.2gis.com/?utm_source=copyright&utm_medium=map&utm_campaign=partners",copyright_license:"https://law.2gis.ae/api-rules/",open_link:"https://2gis.ae"}},i=this._countryCode in e?this._countryCode:"ru";return e[i][t]},_markerToRoute:void 0,_markers:[],_checkMarkerLayers:function(){this._markerToRoute=1!=this._markers.length?void 0:this._markers[0],this._update()},_mapEvents:{layeradd:function(t){t.layer instanceof DG.Marker&&(this._markers.push(t.layer),this._markers.length<=2&&this._checkMarkerLayers())},layerremove:function(t){if(t.layer instanceof DG.Marker){for(var e=[],i=0;i<this._markers.length;i++)this._markers[i]!==t.layer&&e.push(this._markers[i]);this._markers=e,this._markers.length<=1&&this._checkMarkerLayers()}}},onAdd:function(t){t._copyright||(t._copyright=!0,this._first=!0),this._logotype=t.options.logotype,this._open2gis=this._getLink("open_link"),this._map.on(this._mapEvents,this),t.attributionControl=this,this._container=DG.DomUtil.create("div","dg-attribution"),DG.DomEvent.disableClickPropagation(this._container);for(var e in t._layers)t._layers[e].getAttribution&&this.addAttribution(t._layers[e].getAttribution());return this._update(),DG.DomEvent.on(this._container,"touchstart",this._updateLink,this),this._container},_updateLink:function(t){"linkButton"===t.target.name&&(this._open2gis=this._getOpenUrl(),t.target.href=this._open2gis)},_update:function(t,e){if(this._map){"undefined"!=typeof e&&(this._countryCode=e);var i=[];for(var o in this._attributions)this._attributions[o]&&i.push(o);var n=[],r="";this._first&&(r=this._getAttributionHTML(t)),this.options.prefix&&n.push(this.options.prefix),i.length&&n.push(i.join(", ")),this._container.innerHTML=r+n.join(" | ")}},_getOpenUrl:function(){return this._markerToRoute?DG.Util.template(DG.config.ppLink2gis,{gislink:this._getLink("open_link"),
	center:this._map.getCenter().lng+","+this._map.getCenter().lat,zoom:this._map.getZoom(),rsType:this._map.getZoom()>11?"bus":"car",point:this._markerToRoute._latlng.lng+","+this._markerToRoute._latlng.lat}):DG.Util.template(DG.config.openLink2gis,{gislink:this._getLink("open_link"),center:this._map.getCenter().lng+","+this._map.getCenter().lat,zoom:this._map.getZoom()})},_getData:function(t){t=t||this._map.getLang();var e={name:"open",label:this._markerToRoute?this.t("route_on"):this.t("open_on")},i="open_on"==e.label||"route_on"==e.label||this._logotype;return{logotype:i,work_on:this.t("work_on"),lang:t,copyright_apilink:this._getLink("copyright_apilink"),copyright_license:this._getLink("copyright_license"),copyright_logo:this._getLink("copyright_logo"),open2gis_link:this._open2gis,open2gis_name:"linkButton",license_agreement:this.t("license_agreement"),dir:"ar"!==t?"ltr":"rtl",btn:e}},_getAttributionHTML:function(t){return DG.dust("DGAttribution/copyright",this._getData(t))},_renderTranslation:function(t){this._update(t.lang)}}),DG.Map.addInitHook(function(){this._copyright||DG.control.attribution().addTo(this)}),DG.Control.Attribution.Dictionary.ru={license_agreement:"Лицензионное соглашение",work_on:"Работает на API 2ГИС",open_on:"Открыть в 2ГИС",route_on:"Доехать с 2ГИС"},DG.Control.Attribution.Dictionary.it={license_agreement:"Accordo di licenza",work_on:"2GIS API"},DG.Control.Attribution.Dictionary.cs={license_agreement:"Licenční smlouva",work_on:"Pracuje na API 2GIS"},DG.Control.Attribution.Dictionary.en={license_agreement:"License agreement",work_on:"Uses 2GIS API"},DG.Control.Attribution.Dictionary.es={license_agreement:"Acuerdo de licencia",work_on:"2GIS API"},DG.Control.Attribution.Dictionary.ar={license_agreement:"إتفاقية ترخيص",work_on:"يعمل بتطبيق 2GIS",open_on:"Open in 2GIS",route_on:"Route on 2GIS"},DG.Control.Location=DG.RoundControl.extend({statics:{Dictionary:{}},options:{iconClass:"locate",position:DG.Browser.mobile?"bottomright":"topleft",drawCircle:!0,follow:!0,stopFollowingOnDrag:!1,metric:!0,onLocationError:function(){},onLocationOutsideMapBounds:function(){},locateOptions:{}},initialize:function(t){return DG.Util.setOptions(this,t),navigator.geolocation?(this._event=void 0,this._locateOptions={watch:!0,setView:!0,maximumAge:1/0,maxZoom:1/0},DG.extend(this._locateOptions,this.options.locateOptions),this._resetVariables(),void this.on({click:this._handleLocate,add:this._initLocate})):void(this._disable=!0)},_initLocate:function(){this._layer=new DG.LayerGroup,this._layer.addTo(this._map),this._map.on({locationfound:this._onLocationFound,locationerror:this._onLocationError},this)},_handleLocate:function(){this._active&&(!this._event||this._map.getBounds().contains(this._event.latlng)||this._isOutsideMapBounds())?this._stopLocate():(this._locateOnNextLocationFound=!0,this._active||this._map.locate(this._locateOptions),this._active=!0,this.options.follow&&this._startFollowing(),this._clearError(),this._event?this._visualizeLocation():this.setState("requesting"))},_onLocationFound:function(t){this._event&&this._event.latlng.lat===t.latlng.lat&&this._event.latlng.lng===t.latlng.lng&&this._event.accuracy===t.accuracy||this._active&&(this._event=t,this.options.follow&&this._following&&(this._locateOnNextLocationFound=!0),this._visualizeLocation())},_startFollowing:function(){this._following=!0,this.options.stopFollowingOnDrag&&this._map.on("dragstart",this._stopFollowing,this)},_stopFollowing:function(){this._following=!1,this.options.stopFollowingOnDrag&&this._map.off("dragstart",this._stopFollowing,this),this._visualizeLocation()},_isOutsideMapBounds:function(){return void 0!==this._event&&(this._map.options.maxBounds&&!this._map.options.maxBounds.contains(this._event.latlng))},_visualizeLocation:function(){void 0===this._event.accuracy&&(this._event.accuracy=0);var t=this._event.accuracy;if(this._locateOnNextLocationFound){if(this._isOutsideMapBounds())this.options.onLocationOutsideMapBounds(this);else if(this._locateOptions.setView){var e=this._map.projectDetector.getProject(),i=e?e.maxZoom:DG.config.projectLeaveMaxZoom;i=Math.min(this._locateOptions.maxZoom,i),this._map.setView(this._event.latlng,i)}this._locateOnNextLocationFound=!1}var o={clickable:!1,color:"#FFF",fillColor:"#FFF",fillOpacity:.4,weight:0,opacity:.3};this.options.drawCircle&&(this._circle?this._circle.setLatLng(this._event.latlng).setRadius(t):this._circle=DG.circle(this._event.latlng,t,o).addTo(this._layer));var n="dg-location__pin";n+=this._following?" "+n+"state_following":"";var r={icon:DG.divIcon({className:n,iconSize:[20,20]})};this._marker?this._marker.setLatLng(this._event.latlng):this._marker=DG.marker(this._event.latlng,r).bindLabel(this.t("you_are_here")).addTo(this._layer),DG.DomEvent.on(this._marker,"click",function(){this._map.fireEvent("dgLocateClick")},this),this._container&&this.setState("active")},_resetVariables:function(){this._active=!1,this._following=!1},_stopLocate:function(){this._map.stopLocate(),this._map.off("dragstart",this._stopFollowing),this.setState(),this._resetVariables(),this._layer.clearLayers(),this._marker=void 0,this._circle=void 0,this._event=void 0},_onLocationError:function(t){if(3!==t.code||!this._locateOptions.watch){this._stopLocate(),this._error=DG.DomUtil.create("div","dg-label dg-label_name_location-error",this._container),this._errorText=DG.DomUtil.create("div","dg-label__content",this._error),this._errorText.innerHTML=this.t("cant_find");var e=this;setTimeout(function(){e._clearError()},3e3),this.options.onLocationError(t)}},_clearError:function(){this._error&&(this._container.removeChild(this._error),this._error=void 0,this._errorText=void 0)},_renderTranslation:function(){this._link&&(this._link.title=this.t("button_title")),this._marker&&this._marker.bindLabel(this.t("you_are_here"))}}),DG.control.location=function(t){return new DG.Control.Location(t)},DG.Map.addInitHook(function(){this.options.locationControl&&(this.locationControl=DG.control.location(this.options.locationControl),this.addControl(this.locationControl))}),DG.Control.Location.Dictionary.ru={cant_find:"Мы не смогли Вас найти",you_are_here:"Вы здесь",button_title:"Найти Вас на карте"},DG.Control.Location.Dictionary.it={cant_find:"Non siamo riusciti a localizzarti",you_are_here:"Voi siete qui",button_title:"Trova la tua posizione sulla mappa"},DG.Control.Location.Dictionary.cs={cant_find:"Nepodařilo se nám určit Vaši polohu",you_are_here:"Jste tady",button_title:"Určit Vaši polohu na mapě"},DG.Control.Location.Dictionary.en={cant_find:"We can't find you",you_are_here:"You are here",button_title:"Show your location"},DG.Control.Location.Dictionary.es={cant_find:"No pudimos encontrarte",you_are_here:"Tú estás aquí",button_title:"Encontrarte en el mapa"},DG.Control.Location.Dictionary.ar={cant_find:"لم نستطع تحديد موقعك",you_are_here:"أنت هنا",button_title:"موقعي"},DG.Screenfull=DG.Class.extend({_apiMap:[["requestFullscreen","exitFullscreen","fullscreenElement","fullscreenEnabled","fullscreenchange","fullscreenerror"],["webkitRequestFullscreen","webkitExitFullscreen","webkitFullscreenElement","webkitFullscreenEnabled","webkitfullscreenchange","webkitfullscreenerror"],["mozRequestFullScreen","mozCancelFullScreen","mozFullScreenElement","mozFullScreenEnabled","mozfullscreenchange","mozfullscreenerror"],["msRequestFullscreen","msExitFullscreen","msFullscreenElement","msFullscreenEnabled","MSFullscreenChange","MSFullscreenError"]],initialize:function(){this.api=this._api()},request:function(t){var e=this.api.requestFullscreen;t=t||document.documentElement,t[e](Element.ALLOW_KEYBOARD_INPUT)},exit:function(){document[this.api.exitFullscreen]()},isFullscreen:function(){return!!document[this.api.fullscreenElement]},isAvailable:function(){return Boolean(this.api)},_api:function(){var t={},e=this._apiMap;return e.forEach(function(i){i&&i[1]in document&&i.forEach(function(i,o){t[e[0][o]]=i})}),!!t.requestFullscreen&&t}}),DG.screenfull=new DG.Screenfull,DG.Control.Fullscreen=DG.RoundControl.extend({statics:{Dictionary:{}},options:{position:"topright",iconClass:"fullscreen"},initialize:function(t){DG.Util.setOptions(this,t),this._isFullscreen=!1,this.on("click",this._toggleFullscreen)},_toggleFullscreen:function(){this._isFullscreen?this._toggle(!1,"exit","on","cancelfullscreen"):this._toggle(!0,"request","on","requestfullscreen"),this._renderTranslation(),this._map.invalidateSize()},_renderTranslation:function(){this._link.title=this.t(this._isFullscreen?"title_min":"title_max")},_toggle:function(t,e,i,o){var n=this._map._container;this._isFullscreen=t,this.setState(t?"active":""),DG.screenfull[e](n),DG.DomEvent[i](document,DG.screenfull.api.fullscreenchange,this._onFullScreenStateChange,this),this._map.fire(o)},_onFullScreenStateChange:function(){DG.screenfull.isFullscreen()||this._toggle(!1,"exit","on","cancelfullscreen")}}),DG.control.fullscreen=function(t){return new DG.Control.Fullscreen(t)},DG.Map.mergeOptions({fullscreenControl:!0}),DG.Map.addInitHook(function(){this.options.fullscreenControl&&(this.fullscreenControl=DG.control.fullscreen(this.options.fullscreenControl),DG.screenfull.isAvailable()&&this.addControl(this.fullscreenControl))}),DG.Control.Fullscreen.Dictionary.ru={title_max:"Развернуть",title_min:"Восстановить"},DG.Control.Fullscreen.Dictionary.it={title_max:"Espandi",title_min:"Ripristina"},DG.Control.Fullscreen.Dictionary.cs={title_max:"Rozbalit",title_min:"Obnovit"},DG.Control.Fullscreen.Dictionary.en={title_max:"Expand",title_min:"Restore"},DG.Control.Fullscreen.Dictionary.es={title_max:"Maximizar",title_min:"Restaurar"},DG.Control.Fullscreen.Dictionary.ar={title_max:"",title_min:""},DG.Meta={},DG.Meta.Layer=DG.Layer.extend({options:{tileSize:256,minZoom:0,maxZoom:19,zoomOffset:0,eventBubbling:"transparent"},initialize:function(t,e){DG.TileLayer.prototype.initialize.call(this,null,e),delete this._url,this._currentTileKey="",this._currentTileData=[],this._lastEntity=void 0,this._dispatchMouseEvents=!0,this._origin=DG.Meta.origin(t,{dataFilter:this.options.dataFilter})},getOrigin:function(){return this._origin},onAdd:function(t){this._resetView(),t.metaLayers.push(this),t.on("rulerstart",this._disableDispatchMouseEvents,this),t.on("rulerend",this._enableDispatchMouseEvents,this);var e=this;DG.Browser.touchEnabled&&this.options.isPoi&&t.eachLayer(function(t){if(t instanceof L.TileLayer){t.on("tileloadstart",e._onTileLoadStart,e);for(var i in t._tiles)e._onTileLoadStart({coords:t._tiles[i].coords})}})},onRemove:function(t){var e=this;DG.Browser.touchEnabled&&this.options.isPoi&&t.eachLayer(function(t){t instanceof L.TileLayer&&t.off("tileloadstart",e._onTileLoadStart)}),this._tileZoom=null;var i=t.metaLayers.indexOf(this);i!==-1&&t.metaLayers.splice(i,1),t.off("rulerstart",this._disableDispatchMouseEvents,this),t.off("rulerend",this._enableDispatchMouseEvents,this)},getEvents:function(){return{viewprereset:this._invalidateAll,viewreset:this._resetView,zoom:this._resetView,moveend:this._onMoveEnd}},setUrl:function(t){this._currentTileKey="",this._currentTileData=[],this._lastEntity=void 0,this._dispatchMouseEvents=!0,this._origin.setURL(t,!0)},getHoveredObject:function(t){var e,i=this.getTileSize(),o=this._map.mouseEventToLayerPoint(t.originalEvent),n=this._map.getPixelOrigin().add(o),r=n.unscaleBy(i).floor(),a=DG.point(n.x%i.x,n.y%i.y),s=this._map.getZoom(),l=this;if(!(s>this.options.maxZoom+this.options.zoomOffset||s<this.options.minZoom-this.options.zoomOffset)&&this._isValidTile(r))return this._wrapCoords(r),r.z=this._getZoomForUrl(),r.key=i.x+"x"+i.y,e=this._origin.getTileKey(r),e===this._currentTileKey?l._lastEntity=l._getHoveredObject(a):this._origin.getTileData(r,function(t){l._currentTileKey=e,l._currentTileData=t,l._lastEntity=l._getHoveredObject(a)}),this._lastEntity},_removeAllTiles:DG.GridLayer.prototype._removeAllTiles,_getZoomForUrl:DG.TileLayer.prototype._getZoomForUrl,getTileSize:DG.TileLayer.prototype.getTileSize,_isValidTile:DG.GridLayer.prototype._isValidTile,_wrapCoords:DG.GridLayer.prototype._wrapCoords,_resetView:DG.GridLayer.prototype._resetView,_resetGrid:DG.GridLayer.prototype._resetGrid,_invalidateAll:DG.GridLayer.prototype._invalidateAll,_pxBoundsToTileRange:DG.GridLayer.prototype._pxBoundsToTileRange,_onMoveEnd:function(){this._map&&!this._map._animatingZoom&&this._resetView()},_onTileLoadStart:function(t){var e=this.getTileSize();t.coords.key=e.x+"x"+e.y,this._origin.getTileData(t.coords)},_enableDispatchMouseEvents:function(){this._dispatchMouseEvents=!0},_disableDispatchMouseEvents:function(){this._dispatchMouseEvents=!1},mapEvents:{mousemove:function(t){this._fireMetalayerEvent("mousemove",t)},mouseover:function(t){this._fireMetalayerEvent("mouseover",t)},mouseout:function(t){this._fireMetalayerEvent("mouseout",t),this._currentTileKey=""},click:function(t){var e=this.getTileSize(),i=this._map.mouseEventToLayerPoint(t.originalEvent),o=this._map.getPixelOrigin().add(i),n=o.unscaleBy(e).floor(),r=DG.point(o.x%e.x,o.y%e.y);n.z=this._getZoomForUrl(),n.key=e.x+"x"+e.y;var a=this._origin.getTileKey(n),s=this,l=function(e){s._currentTileData=e,s._currentTileKey=a,s._lastEntity=s._getHoveredObject(r),s._mouseDown=!1,s._lastEntity&&(t.entity=s._lastEntity,s._fireMetalayerEvent("click",t))};this._origin.getTileData(n,function(e){e?l(e):s._origin._requests[a]&&(DG.DomEvent.stop(t),s._origin._requests[a].then(function(){if(delete t.originalEvent._stopped,l(s._origin._tileStorage[a]),!t.originalEvent._stopped)for(var e=t.eventTargets,i=t.eventTargetsMapIndex;i<e.length;i++)if(e[i].fire("click",t,!0),t.originalEvent._stopped||e[i].options.nonBubblingEvents&&L.Util.indexOf(e[i].options.nonBubblingEvents,"click")!==-1)return}))})},dblclick:function(t){this._fireMetalayerEvent("dblclick",t)},mousedown:function(t){this._mouseDown=!0,this._fireMetalayerEvent("mousedown",t)},contextmenu:function(t){this._fireMetalayerEvent("contextmenu",t)}},_fireMetalayerEvent:function(t,e){if(e.entity&&this._dispatchMouseEvents){this.fire(t,{meta:e.entity,latlng:this._map.mouseEventToLatLng(e.originalEvent)});var i="mousedown"===t||this._mouseDown&&"mousemove"===t;"layer"!==this.options.eventBubbling||i||DG.DomEvent.stop(e)}},_getHoveredObject:function(t){if(this._currentTileData)for(var e=0;e<this._currentTileData.length;e++)if(DG.PolyUtil.inside(t,this._currentTileData[e].geometry,this._pointReduceHelper))return this._currentTileData[e]},_pointReduceHelper:function(t){return[t.x,t.y]},_setView:function(t,e,i,o){var n=Math.round(e),r=this._tileZoom!==n;!o&&r&&(this._tileZoom=n,this._resetGrid())}}),DG.Meta.layer=function(t,e){return new DG.Meta.Layer(t,e)},DG.Meta.Origin=DG.Class.extend({options:{subdomains:"0123",dataFilter:null},_url:!1,initialize:function(t,e){this._url=t,this._requests={},this._tileStorage={},e=DG.setOptions(this,e),"string"==typeof e.subdomains&&(e.subdomains=e.subdomains.split(""))},getTileData:function(t,e){var i=this.getTileKey(t),o=this,n="function"==typeof e?e:function(){};if("undefined"==typeof this._tileStorage[i]&&"undefined"==typeof this._requests[i]){this._tileStorage[i]=!1;var r=this._requests[i]=this._requestData(t).then(function(e){return o._requests[i]!==r?void n(!1):(o.setTileData(i,o.options.dataFilter?o.options.dataFilter(e,t):e),delete o._requests[i],void n(o._tileStorage[i]))})}else n(this._tileStorage[i])},setTileData:function(t,e){return"string"!=typeof t&&(t=this.getTileKey(t)),e.forEach(function(e){e.geometry.constructor!==Object&&(e.geometry=DG.Wkt.toGeoJSON(e.geometry)),this._tileStorage[t]||(this._tileStorage[t]=[]),this._tileStorage[t].push(e)},this),this},flush:function(){return this._tileStorage={},Object.keys(this._requests).forEach(function(t){this[t].abort&&this[t].abort()},this._requests),this._requests={},this},setURL:function(t,e){return this._url=t,e&&this.flush(),this},getTileKey:function(t){return[t.x,t.y,t.z,t.key].join(":")},_requestData:function(t){return this._url?this._performRequest(t):Promise.resolve([])},_performRequest:function(t){return DG.ajax(this._prepareURL(t),{type:"get",dataType:"json"})},_prepareURL:function(t){return DG.Util.template(this._url,{x:t.x,y:t.y,z:t.z,s:this._getSubdomain(t)})},_getSubdomain:DG.TileLayer.prototype._getSubdomain}),DG.Meta.origin=function(t,e){return new DG.Meta.Origin(t,e)},DG.Map.mergeOptions({poi:!0}),DG.Poi=DG.Handler.extend({options:{disableLabel:!1},initialize:function(t,e){this._map=t,DG.Util.setOptions(this,e);var i=DG.config.protocol+(DG.Browser.retina?DG.config.retinaPoiMetaServer:DG.config.poiMetaServer);this._metaLayer=DG.Meta.layer(i,{minZoom:DG.config.poiLayerMinZoom,maxNativeZoom:19,detectRetina:DG.config.detectRetina,eventBubbling:"layer",dataFilter:DG.bind(this._processData,this),isPoi:!0}),this._currentTilesLang=""},addHooks:function(){this._map.addLayer(this._metaLayer),this.options.disableLabel||(this._labelHelper=DG.label()),this._metaLayer.on(this._layerEventsListeners,this),this._map.on("langchange",this._updateUrl,this),this._map.on("projectchange",this._updateUrl,this),this._map.on("projectleave",this._updateUrl,this)},removeHooks:function(){this._map.removeLayer(this._metaLayer),this.options.disableLabel||(this._map.removeLayer(this._labelHelper),this._labelHelper=null),this._metaLayer.off(this._layerEventsListeners,this),this._map.off("langchange",this._updateUrl,this),this._map.off("projectchange",this._updateUrl,this),this._map.off("projectleave",this._updateUrl,this)},getMetaLayer:function(){return this._metaLayer},_updateUrl:function(){var t=DG.config.protocol+(DG.Browser.retina?DG.config.retinaPoiMetaServer:DG.config.poiMetaServer),e=DG.config.protocol+(DG.Browser.retina?DG.config.arabicRetinaPoiMetaServer:DG.config.arabicPoiMetaServer),i=this._map.getLang(),o=this._map.projectDetector&&this._map.projectDetector.getProject();""===this._currentTilesLang&&"ar"===i&&o&&"ae"===o.country_code?(this._currentTilesLang="ar",this._metaLayer.setUrl(e)):"ar"!==this._currentTilesLang||"ar"===i&&o&&"ae"===o.country_code||(this._currentTilesLang="",this._metaLayer.setUrl(t))},_processData:function(t,e){var i=e.scaleBy(this._metaLayer.getTileSize()),o=DG.bind(this._polygonLngLatToPoints,this,i,e.z);return""===t.responseText?[]:t.result.poi.map(function(t){var e=void 0!==t.hovers?t.hovers:[t.hover];return{id:t.id,hint:t.links[0].name,linked:t.links[0],geometry:e.map(DG.Wkt.toGeoJSON)}}).map(function(t){var e=t.geometry.reduce(function(t,e){return"Polygon"===e.type?t.push(o(e.coordinates)):"MultiPolygon"===e.type&&(t=t.concat(e.coordinates.map(o))),t},[]);return t.geometry={type:"MultiPolygon",coordinates:e},t})},_polygonLngLatToPoints:function(t,e,i){var o=this._map;return i.map(function(i){return i.map(function(i){return o.project([i[1],i[0]],e).round().subtract(t)})})},_layerEventsListeners:{mouseover:function(t){this._setCursor("pointer"),t.meta.hint&&t.meta.hint.length&&!this.options.disableLabel&&(this._labelHelper.setPosition(t.latlng).setContent(t.meta.hint).setZIndexOffset(300),this._map.addLayer(this._labelHelper)),this._map.fire("poihover",{latlng:t.latlng,meta:t.meta})},mouseout:function(t){this._setCursor(""),this.options.disableLabel||this._map.removeLayer(this._labelHelper),this._map.fire("poileave",{latlng:t.latlng,meta:t.meta})},mousemove:function(t){this.options.disableLabel||this._labelHelper.setPosition(t.latlng)}},_setCursor:function(t){this._map.getContainer().style.cursor=t}}),DG.Map.addInitHook("addHandler","poi",DG.Poi),DG.Map.mergeOptions({geoclicker:!1}),DG.Geoclicker=DG.Handler.extend({clickCount:0,pendingClick:0,timeout:250,initialize:function(t,e){this._map=t,this._controller=new DG.Geoclicker.Controller(t,e)},addHooks:function(){this._toggleEvents(!0),void 0!==typeof ga&&ga(DG.config.gaName+".send","event","Geoclicker","Enable"),this._map.on("rulerstart",this._pause,this).on("rulerend",this._unpause,this)},removeHooks:function(){this._toggleEvents(),this._map.off("rulerstart",this._pause,this).off("rulerend",this._unpause,this)},_checkOpenPopup:function(){DG.Browser.mobile&&this._map._popup&&(this._map._popup.options.closeOnClick||this._map.options.closePopupOnClick)&&(this.popupWasOpen=!0)},_pause:function(){this._toggleEvents()},_unpause:function(){this.enabled()&&this._toggleEvents(!0)},_toggleEvents:function(t){this._map[t?"on":"off"](this._mapEventsListeners,this),this._map.poi&&this._map.poi.getMetaLayer()[t?"on":"off"]("click",this._onMetaClick,this)},getController:function(){return this._controller},_onMetaClick:function(t){this.clickCount=0,clearTimeout(this.pendingClick),this.popupWasOpen=!1,this._mapEventsListeners.click.call(this,t)},_mapEventsListeners:{langchange:function(){this._controller.reinvokeHandler()},popupclose:function(t){this._controller.handlePopupClose(t.popup)},click:function(t){0===this.clickCount?(this.clickCount=1,this._singleClick(t)):(this.clickCount=0,clearTimeout(this.pendingClick),this.popupWasOpen=!1)},dblclick:function(){DG.Browser.ielt9&&(this.clickCount=0,this.popupWasOpen=!1,clearTimeout(this.pendingClick))}},_singleClick:function(t){var e=this;clearTimeout(this.pendingClick),this.pendingClick=setTimeout(function(){if(t.meta&&(e._checkOpenPopup(),e._map.closePopup()),!e.popupWasOpen){var i=e._map.getZoom();e._controller.handleClick(t.latlng,i,t.meta)}e.clickCount=0,e.popupWasOpen=!1},this.timeout)}}),DG.Map.addInitHook("addHandler","geoclicker",DG.Geoclicker),DG.Geoclicker.clampHelper=function(t,e){var i,o,n,r,a,s,l,u,c,h=document.createElement.bind(document),d=document.createTextNode.bind(document);if(i=h("span"),function(t){t.position="absolute",t.whiteSpace="pre",t.visibility="hidden",t.margin="0 18px 8px 0"}(i.style),t.ownerDocument&&t.ownerDocument===document){for(r=s=0,a=1,c=!1,n=t.clientWidth,o=(t.textContent||t.innerText).replace(/\n/g," ");null!==t.firstChild;)t.removeChild(t.firstChild);t.appendChild(i),o.replace(/ |-/g,function(p,_){a!==e&&(i.appendChild(d(o.substr(r,_-r))),n<i.clientWidth?(c?(u=o.substr(r,_+1-r),r=_+1):(u=o.substr(r,s-r),r=s),l=h("span"),l.appendChild(d(u)),t.appendChild(l),l.className="dg-map-geoclicker__clamped-line",c=!0,a++):c=!1,s=_+1,i.removeChild(i.firstChild))}),t.removeChild(i),l=h("span"),l.className="dg-map-geoclicker__clamped-line dg-map-geoclicker__clamped-line_last",l.appendChild(d(o.substr(r))),t.appendChild(l)}},DG.Geoclicker.Provider={},DG.Geoclicker.Provider.CatalogApi=DG.Class.extend({initialize:function(t){this._map=t;var e=DG.config.protocol+DG.config.webApiServer+"/"+DG.config.webApiVersion+"/";this._urlGeoSearch=e+"geo/search",this._urlGeoGet=e+"geo/get",this._urlDetails=e+"catalog/branch/get",this._urlFirmsInHouse=e+"catalog/branch/list",this._key=DG.config.geoclickerCatalogApiKey,this._geoFields=DG.config.geoAdditionalFields,this._firmInfoFields=DG.config.firmInfoFields},getLocations:function(t){var e=t.zoom,i=t.latlng,o=t.beforeRequest||function(){},n=this.getTypesByZoom(e),r=i.lng+","+i.lat;return n?(o(),this.geoSearch(r,n,e).then(DG.bind(function(t){return this._filterResponse(t,n)},this))):Promise.reject("no type")},firmsInHouse:function(t,e){e=e||{};var i={building_id:t,page:e.page||1};return this._performRequest(i,this._urlFirmsInHouse)},getFirmInfo:function(t){return this._performRequest({type:"filial",id:t,fields:this._firmInfoFields},this._urlDetails)},geoSearch:function(t,e,i){var o={point:t,type:e,zoom_level:i,fields:this._geoFields};return this._performRequest(o,this._urlGeoSearch)},geoGet:function(t){var e={id:t,fields:this._geoFields};return this._performRequest(e,this._urlGeoGet)},cancelLastRequest:function(){this._lastRequest&&this._lastRequest.abort()},getTypesByZoom:function(t){var e={"adm_div.settlement":8,"adm_div.city":8,"adm_div.division":11,"adm_div.district":12,street:14,building:14,"adm_div.place":15,poi:15,attraction:17},i=[];return Object.keys(e).forEach(function(o){t>=e[o]&&i.push(o)}),i.length?i.join(","):null},_performRequest:function(t,e){var i=DG.extend({key:this._key},t),o="get";return this.cancelLastRequest(),DG.ajax.corsSupport||(o=i.format="jsonp"),this._lastRequest=DG.ajax(e,{type:o,data:i,timeout:this._timeoutMs,withCredentials:!0}),this._lastRequest},_filterResponse:function(t,e){var i,o,n,r,a,s={};if(this._isNotFound(t))return!1;for(r=t.result.items,i=r.length-1;i>=0;i--)o=r[i],a=o.type,o.subtype&&(a+="."+o.subtype),e&&e.indexOf(a)===-1||(s[a]=o,n=!0);return!!n&&s},_isNotFound:function(t){return!(t&&(!t.meta||!t.meta.error)&&t.result&&t.result.items&&t.result.items.length)}}),DG.Geoclicker.Handler={},DG.Geoclicker.Handler.Default=DG.Class.extend({includes:DG.Locale,statics:{Dictionary:{}},_eventHandlers:{},initialize:function(t,e,i){this._controller=t,this._view=e,this._map=i},handle:function(){return Promise.resolve({tmpl:"popupHeader",data:{title:this.t("we_have_not")}})},addClickEvent:function(){this._view._popup.on("click",this._runEventHandlers,this),this._map.once("popupclose",this._removeClickEvent,this)},_removeClickEvent:function(){this._view._popup.off("click",this._runEventHandlers,this)},_addEventHandler:function(t,e){this._eventHandlers[t]=e},_runEventHandlers:function(t){var e=t.originalEvent.target;for(var i in this._eventHandlers)if(this._eventHandlers.hasOwnProperty(i)&&e.className.indexOf(i)>-1)return DG.DomEvent.preventDefault(t.originalEvent),void this._eventHandlers[i].call(this,e)},_clearEventHandlers:function(){this._eventHandlers={}},_getDirectionsUrl:function(t){var e=this._map.projectDetector.getProject();return e?DG.Util.template(DG.config.ppnotLink,{domain:e.domain,projectCode:e.code,center:this._map.getCenter().lng+","+this._map.getCenter().lat,zoom:this._map.getZoom(),name:encodeURIComponent(t),rsType:e.transport?"bus":"car",point:this._popup._latlng.lng+","+this._popup._latlng.lat}):""},_getDrilldown:function(t){var e,i=[];return t.adm_div&&(i=t.adm_div.reduce(function(t,e){return e.name&&t.push(e.name),t},[]).reverse()),i.length&&t.address&&t.address.postcode&&i.push(t.address.postcode),e=i.join(", ")}}),DG.Geoclicker.Handler.HandlerExample=DG.Geoclicker.Handler.Default.extend({handle:function(t,e){return Promise.resolve({tmpl:e+":<br/>"+t[e].id})}}),DG.Geoclicker.Handler.ApiError=DG.Geoclicker.Handler.Default.extend({handle:function(){var t=this._view.render({tmpl:"popupHeader",data:{title:this.t("apiErrorTitle")}});return Promise.resolve({header:t,tmpl:this.t("apiErrorBody")})}}),DG.Geoclicker.Handler.CityArea=DG.Geoclicker.Handler.Default.extend({_polylineStyleDefault:{fillColor:"#ff9387",color:"#ff9387",noClip:!0,opacity:1},_polylineStyles:{11:{fillOpacity:.18,weight:1},12:{fillOpacity:.12,weight:1},13:{fillOpacity:.08,weight:2},18:{fillOpacity:0,weight:3}},handle:function(t,e){return!!t[e]&&(this._stylesInited||this._initStyles(),this._geometry&&this._map.removeLayer(this._geometry),this._popup=this._view.getPopup(),this._geometryZoomStyle=this._getPolyStyleNum(),this._geometry=DG.Wkt.geoJsonLayer(t[e].geometry.selection,{style:this._polylineStyles[this._geometryZoomStyle],interactive:!1}).addTo(this._map),this._map.on("zoomend",this._updateGeometry,this).once("popupclose",this._clearPopup,this),Promise.resolve(this._fillCityAreaObject(t,e)))},_fillCityAreaObject:function(t,e){var i={name:this.t("noname"),drilldown:"",purpose:this.t(e),type:e.split(".").join("_")};return i.drilldown=this._getDrilldown(t[e]),t[e].name&&(i.name=t[e].name),{tmpl:"cityarea",data:i,header:this._view.render({tmpl:"popupHeader",data:{title:i.name}})}},_initStyles:function(){this._stylesInited=!0,Object.keys(this._polylineStyles).forEach(function(t){DG.extend(this._polylineStyles[t],this._polylineStyleDefault)},this)},_getPolyStyleNum:function(){var t=this._map.getZoom();return Object.keys(this._polylineStyles).filter(function(e){return t<=e})[0]||!1},_updateGeometry:function(){var t=this._getPolyStyleNum();t&&t!==this._geometryZoomStyle&&(this._geometryZoomStyle=t,this._geometry.setStyle(this._polylineStyles[t]))},_clearPopup:function(){this._map.removeLayer(this._geometry).off("zoomend",this._updateGeometry,this)}}),DG.Geoclicker.Handler.House=DG.Geoclicker.Handler.Default.extend({_firmsOnPage:20,_scrollThrottleInterval:400,_scrollHeightReserve:60,options:{showBooklet:!0,showPhotos:!0,showRouteSearch:!0},handle:function(t){return!!t.building&&(this.firmCard=null,this._page=1,this._houseObject=null,this._firmList=null,this._firmListObject=null,this._firmCardObject=null,this._onScroll=!1,this._isFirmlistOpen=!1,this._id=t.building.id,this._totalPages=1,this._api=this._controller.getCatalogApi(),this._popup=this._view.getPopup(),this._initedPopupClose=!1,this._directionsUrl=this._getDirectionsUrl(t.building.name),this._firmListLoader=this._view.initLoader(!0),this._houseObject=this._fillHouseObject(t.building),Promise.resolve(this._houseObject))},_isRouteSearchAllowed:function(){var t=this._controller.getMap().projectDetector.getProject();return t.transport||t.roads},_firmCardSetup:function(){var t=this._controller.getMap().projectDetector.getProject();return{render:this._view.renderTemplate,lang:this._map.getLang(),domain:t?t.domain:"ru",ajax:DG.bind(this._api.getFirmInfo,this._api),timezoneOffset:t?t.timeOffset:0,map:this._map,popup:this._popup,isMobile:DG.Browser.mobile,showEntrance:DG.Entrance,gotoUrl:this._directionsUrl,onFirmReady:DG.bind(this._onFirmReady,this),onToggle:DG.bind(this._popup.resize,this._popup),showBooklet:this.options.showBooklet,showPhotos:this.options.showPhotos,showRouteSearch:this.options.showRouteSearch&&this._isRouteSearchAllowed(),t:DG.bind(this.t,this)}},_fillFirmCardObject:function(t){var e=this._firmCardSetup();return this.firmCard=new FirmCard(t,e),this._initPopupClose(),this.firmCard.getContainer()},_firmListSetup:function(){var t=this._firmCardSetup();return DG.extend(t,{backBtn:DG.bind(this._showHousePopup,this),onFirmClick:DG.bind(this._onFirmListClick,this),onShowLess:DG.bind(this._showHousePopup,this),pasteLoader:DG.bind(this._pasteLoader,this)}),{firmCard:t,firmlistItemTmpl:"firmlistItem",onListReady:DG.bind(this._renderFirmList,this)}},_initShortFirmList:function(t){var e=this._firmListSetup();return this._shortFirmList=new FirmCard.List(t,e),this._shortFirmList.renderList()},_initFirmList:function(t){if(!t)return!1;var e=t.result.items,i=this._firmListSetup();i.firmCard.backBtn=DG.bind(this._showListPopup,this),this._shortFirmList&&this._shortFirmList._toggleEventHandlers(!0),this._firmList=new FirmCard.List(e,i),this._firmListObject=this._fillFirmListObject(this._firmList.renderList()),this._clearAndRenderPopup(this._firmListObject)},_fillFirmListObject:function(t){var e=this;return{tmpl:t,header:this._header,footer:this._view.render({tmpl:"popupFooterBtns",data:{btns:[{name:"back",label:this.t("back_button"),icon:!0}]}}),afterRender:function(){e._initPopupClose(),e._totalPages>1&&e._firmListLoader&&this.tmpl.parentNode.appendChild(e._firmListLoader)}}},_onFirmReady:function(t){var e=this;t.afterRender=function(){var t=e._popup._popupStructure.header.firstChild;DG.Browser.ielt9||t.offsetHeight>72&&(DG.DomUtil.addClass(t,"dg-popup__header-teaser"),DG.Browser.webkit||DG.Geoclicker.clampHelper(t,3))},this._clearAndRenderPopup(t)},_showHousePopup:function(){this._popup.off("scroll",this._onScroll),this._clearAndRenderPopup(this._houseObject),this._shortFirmList&&this._shortFirmList._toggleEventHandlers()},_onFirmListClick:function(){this._popup.off("scroll",this._onScroll)},_pasteLoader:function(){var t=DG.DomUtil.create("div","dg-map-geoclicker__preloader-wrapper"),e=this._view.initLoader();t.insertBefore(e,t.firstChild),t.style.height=this._popup._contentNode.offsetHeight-1+"px",t.style.width=this._popup._contentNode.offsetWidth+"px",this._clearAndRenderPopup({tmpl:t})},_initPopupClose:function(){this._initedPopupClose||(this._controller.getMap().once("popupclose",DG.bind(this._onPopupClose,this)),this._initedPopupClose=!0)},_showListPopup:function(){var t=this._firmListObject;this._pasteLoader(),t?(this._clearAndRenderPopup(t),this._firmList._toggleEventHandlers()):t=this._api.firmsInHouse(this._id).then(DG.bind(this._initFirmList,this)),this._onScroll||(this._onScroll=DG.Util.throttle(this._handlePopupScroll,this._scrollThrottleInterval,this)),
	this._popup.on("scroll",this._onScroll)},_renderFirmList:function(){this._isFirmlistOpen||(this._popup.resize(),this._isFirmlistOpen=!0)},_onPopupClose:function(){this._initedPopupClose=!1,this._firmList&&(this._firmList.clearList(),this._firmList=null,this._popup.off("scroll",this._onScroll)),this._firmId=null,this.firmCard&&(this.firmCard._toggleEventHandlers(!0),this.firmCard=null),this._firmListLoader=null,this._page=1,this._clearEventHandlers()},_initShowMore:function(){var t=this._popup.findElement(".dg-popup__button_name_all");t&&this._addEventHandler("dg-popup__button_name_all",DG.bind(this._showListPopup,this))},_clearAndRenderPopup:function(t){this._clearEventHandlers(),this._popup.clear("header","footer"),this._view.renderPopup(t)},_appendFirmList:function(t){this._firmList.addFirms(t.result.items),this._popup._updateScrollPosition()},_handlePopupScroll:function(t){var e=t.originalEvent.target||t.target._scroller;DG.DomEvent.stop(t),this._totalPages<=1||e&&e.scrollHeight<=e.scrollTop+e.offsetHeight+this._scrollHeightReserve&&this._handlePaging()},_handlePaging:function(){if(this._page++,this._totalPages&&this._page<=this._totalPages&&this._api.firmsInHouse(this._id,{page:this._page}).then(DG.bind(this._appendFirmList,this)),this._page===this._totalPages){var t=this._firmListLoader;t&&t.parentNode&&t.parentNode.removeChild(t),this._popup.off("scroll",this._onScroll)}}}),DG.Geoclicker.Handler.House.include({_getAddressString:function(t){return t.address&&t.address.components?t.address.components.filter(function(t){return"street_number"===t.type}).map(function(t){return t.street+", "+t.number}).join(" / "):""},_fillBody:function(t){var e={},i=DG.DomUtil.create("div","dg-building-callout__body"),o=t.links&&t.links.branches,n=this._getDrilldown(t);return t.building_name?e.address={header:this._getAddressString(t),drilldown:n}:n&&(e.address={drilldown:n}),e.purpose=t.purpose_name+(t.floors?", "+this.t("n_floors",t.floors.ground_count):""),o&&o.count>0&&(this._totalPages=Math.ceil(t.links.branches.count/this._firmsOnPage)),t.links&&t.links.attractions&&t.links.attractions.length&&(e.attractions=t.links.attractions.reduce(function(t,e){return e.name&&t.push(e.name),t},[])),i.innerHTML=this._view.render({tmpl:"house",data:e}),o&&o.items&&i.appendChild(this._initShortFirmList(o.items)),i},_fillHeader:function(t){var e={};return t.building_name?e.title=t.building_name:t.address&&t.address.components?e.title=this._getAddressString(t):e.title=t.purpose_name,this._header=this._view.render({tmpl:"popupHeader",data:e}),this._header},_fillFooter:function(t){var e=[],i=t.links&&t.links.branches,o=i&&i.items&&i.items.length||0;return i&&i.count>o&&e.push(this._getShowAllData(i.count)),this._isRouteSearchAllowed()&&e.push({name:"goto",label:this.t("go_to"),icon:!0,href:this._directionsUrl}),this._view.render({tmpl:"popupFooterBtns",data:{btns:e}})},_getShowAllData:function(t){return{name:"all",label:this.t("show_organization_in_building",t)}},_fillHouseObject:function(t){var e=this;return{header:this._fillHeader(t),tmpl:this._fillBody(t),footer:this._fillFooter(t),afterRender:function(){e._initShowMore(),e._initPopupClose()}}}}),DG.Geoclicker.Handler.Poi=DG.Geoclicker.Handler.House.extend({handle:function(t){if(!t.poi)return!1;if(this.firmCard=null,this._page=1,this._houseObject=null,this._firmList=null,this._firmListObject=null,this._firmCardObject=null,this._onScroll=!1,this._isFirmlistOpen=!1,this._id=t.poi.reference.id,this._totalPages=1,this._api=this._controller.getCatalogApi(),this._popup=this._view.getPopup(),this._initedPopupClose=!1,this._directionsUrl=this._getDirectionsUrl(t.poi.reference.name),this._firmListLoader=this._view.initLoader(!0),"building"===t.poi.reference.type){var e=this;return e._api.geoGet(t.poi.reference.id).then(function(t){return e._houseObject=e._fillHouseObject(t.result.items[0]),Promise.resolve(e._houseObject)})}return"branch"===t.poi.reference.type&&(this._fillFirmCardObject(t.poi.reference.id),!0)}}),DG.Geoclicker.Handler.Sight=DG.Geoclicker.Handler.Default.extend({handle:function(t){return!!t.attraction&&(this._popup=this._view.getPopup(),this._initedPopupClose=!1,Promise.resolve(this._fillSightObject(t)))},_fillSightObject:function(t){var e=t.attraction,i={},o=this,n={btns:[{name:"goto",label:this.t("go_to"),icon:!0}]};return e.name?(i.buildingName=e.name,i.purpose=e.subtype_name):i.buildingName=e.subtype_name,i.description=e.description,i.drillDown=this._getDrilldown(e),this._checkDescFieldHeight(i.description)&&(i.showMoreText=this.t("show_more_about_sight")),n.btns[0].href=this._getDirectionsUrl(i.buildingName),{tmpl:"sight",data:i,header:this._view.render({tmpl:"popupHeader",data:{title:i.buildingName}}),footer:this._view.render({tmpl:"popupFooterBtns",data:n}),afterRender:function(){o._needShowMore&&o._initShowMore(),o._initPopupClose()}}},_initPopupClose:function(){this._initedPopupClose||(this._controller.getMap().once("popupclose",DG.bind(this._clearPopup,this)),this._initedPopupClose=!0)},_clearPopup:function(){this._initedPopupClose=!1,this._clearEventHandlers()},_showMoreText:function(){this._desc.style.maxHeight="100%",this._link.parentNode.removeChild(this._link),this._popup.resize()},_initShowMore:function(){this._link=this._popup.findElement(".dg-map-geoclicker__show-more-sights-link"),this._desc=this._popup.findElement(".dg-map-geoclicker__sight-description"),this._link&&this._desc&&this._addEventHandler("dg-map-geoclicker__show-more-sights-link",DG.bind(this._showMoreText,this))},_checkDescFieldHeight:function(t){var e,i=DG.DomUtil.create("div","");return i.style.visibility="hidden",i.innerHTML=t,this._popup._contentNode.appendChild(i),e=i.offsetHeight,this._popup._contentNode.removeChild(i),this._needShowMore=e>40,this._needShowMore}}),DG.Geoclicker.View=DG.Class.extend({initialize:function(t,e){this._map=t,this._popup=DG.popup({maxHeight:300,minHeight:50,maxWidth:385,minWidth:310,sprawling:!0,closeOnClick:!0}),e&&DG.Util.setOptions(this,e)},initLoader:function(t){var e=document.createElement("div");return e.innerHTML=DG.dust("DGGeoclicker/loader",{small:t,anim:this._detectCssAnimation()}),e.firstChild},showPopup:function(t,e){this._popup.setContent(e).setLatLng(t).openOn(this._map)},render:function(t){var e,i={};return t=t||{},t.tmpl=t.tmpl||"",e=t.data?this.renderTemplate(t.tmpl,t.data):t.tmpl,t.beforeRender&&t.beforeRender(),t.popup&&(t.header&&(i.header=t.header),t.footer&&(i.footer=t.footer),i.body=e,this._popup.setContent(i)),t.afterRender&&t.afterRender(),e},renderTemplate:function(t,e){return DG.dust("DGGeoclicker/"+t,e)},renderPopup:function(t){return t.popup=!0,this.render(t)},getPopup:function(){return this._popup},_detectCssAnimation:function(){var t=!1,e="Webkit Moz O ms Khtml".split(" "),i=document.createElement("div");if(i.style.animationName&&(t=!0),t===!1)for(var o=0;o<e.length;o++)if(void 0!==i.style[e[o]+"AnimationName"]){t=!0;break}return t}}),DG.Geoclicker.Controller=DG.Class.extend({options:{handlersSequence:{poi:DG.Geoclicker.Handler.Poi,attraction:DG.Geoclicker.Handler.Sight,building:DG.Geoclicker.Handler.House,street:DG.Geoclicker.Handler.CityArea,"adm_div.place":DG.Geoclicker.Handler.CityArea,"adm_div.district":DG.Geoclicker.Handler.CityArea,"adm_div.division":DG.Geoclicker.Handler.CityArea,"adm_div.settlement":DG.Geoclicker.Handler.CityArea,"adm_div.city":DG.Geoclicker.Handler.CityArea,"default":DG.Geoclicker.Handler.Default,apiError:DG.Geoclicker.Handler.ApiError}},initialize:function(t,e){this._options=e,this._handlers={},this._catalogApi=new DG.Geoclicker.Provider.CatalogApi(t),this._map=t,this._view=new DG.Geoclicker.View(t),this._renderHandlerResult=DG.bind(this._renderHandlerResult,this),this._lastHandleClickArguments=null},handlePopupClose:function(t){t===this._view.getPopup()&&(this._lastHandleClickArguments=null,this._catalogApi.cancelLastRequest())},handleClick:function(t,e,i){function o(){var e=n._view.initLoader();n._view._popup.clear(),n._view.showPopup(t,e),n._lastHandleClickArguments=r}var n=this,r=Array.prototype.slice.call(arguments,0);if(void 0!==typeof ga&&ga(DG.config.gaName+".send","event","Geoclicker","Use"),i&&i.linked&&"sight"!=i.linked.type&&"attraction"!=i.linked.type){if("branch"!=i.linked.type&&"building"!=i.linked.type)return;o(),n.handleResponse({poi:{reference:i.linked}})}else this._catalogApi.getLocations({latlng:t,zoom:e,beforeRequest:o}).then(function(t){n.handleResponse(t)},function(t){n.handleResponse(t)})},handleResponse:function(t){var e;if(!t)return void this._runHandler("default");if("no type"!==t){if("aborted"===t)return void this._runHandler("apiError");for(e=this.findHandler(t);e;){if(this._runHandler(e,t))return;delete t[e],e=this.findHandler(t)}this._runHandler("default")}},findHandler:function(t){for(var e in this.options.handlersSequence)if(t[e])return e;return null},getCatalogApi:function(){return this._catalogApi},getMap:function(){return this._map},reinvokeHandler:function(){this._lastHandleClickArguments&&this.handleClick.apply(this,this._lastHandleClickArguments)},_runHandler:function(t,e){e=e||{},this._initHandlerOnce(t),this._handlers[t].addClickEvent();var i=this._handlers[t].handle(e,t);return i&&i.then?i.then(this._renderHandlerResult):i},_renderHandlerResult:function(t){this._view.renderPopup(t)},_initHandlerOnce:function(t){this._handlers[t]||(this._handlers[t]=new this.options.handlersSequence[t](this,this._view,this._map,this._options))}}),DG.Geoclicker.Handler.Default.Dictionary.it=DG.extend({apiErrorTitle:"Oh oh, c'è&nbsp;un&nbsp;errore",apiErrorBody:"I nostri server si rifiutano di rispondere. Stiamo facendo del nostro meglio per convincerli a&nbsp;comportarsi bene. Ritorna tra qualche minuto.",we_have_not:"Non disponiamo ancora di informazioni su questo posto",noname:"Nome non indicato","adm_div.place":"Luogo","adm_div.division":"Zona","adm_div.settlement":"Comune",street:"Via","adm_div.district":"Municipalità","adm_div.city":"Сittà",go_to:"Come arrivare",show_organization_in_building:["{n} azienda in tutto","{n} aziende in tutto"],show_more_about_sight:"Maggiori informazioni",back_button:"Indietro",n_floors:["{n} piano","{n} piani"]},DG.Dictionary.it),DG.Geoclicker.Handler.Default.Dictionary.ru=DG.extend({apiErrorTitle:"Ошибочка вышла",apiErrorBody:"Наши серверы отказываются отвечать. Мы уже прикладываем все силы, чтобы вразумить их. Возвращайтесь к&nbsp;нам через&nbsp;несколько минут.",we_have_not:"Это место мы ещё не успели изучить",noname:"Без названия","adm_div.place":"Место","adm_div.division":"Округ","adm_div.settlement":"Населенный пункт",street:"Улица","adm_div.district":"Район","adm_div.city":"Город",go_to:"Проехать сюда",show_organization_in_building:["Всего {n} организация","Всего {n} организации","Всего {n} организаций"],show_more_about_sight:"Подробнее",back_button:"Назад",n_floors:["{n} этаж","{n} этажа","{n} этажей"]},DG.Dictionary.ru),DG.Geoclicker.Handler.Default.Dictionary.en=DG.extend({apiErrorTitle:"Oops! Error detected.",apiErrorBody:"Our servers are not responding. We are doing our best to straighten them out. Please return to us in a few minutes.",we_have_not:"We haven't collected info about this place yet",noname:"No name","adm_div.place":"Place","adm_div.division":"Area","adm_div.settlement":"Village",street:"Street","adm_div.district":"District","adm_div.city":"City",go_to:"Directions to here",show_organization_in_building:["{n} organization total","{n} organizations total"],back_button:"Back",show_more_about_sight:"More information",n_floors:["{n} floor","{n} floors"]},DG.Dictionary.en),DG.Geoclicker.Handler.Default.Dictionary.cs=DG.extend({apiErrorTitle:"Chybička se&nbsp;vloudila",apiErrorBody:"Naše servery odmítají reagovat. Již nyní vynakládáme veškeré úsilí, abychom je přivedli k rozumu. Zkuste akci opakovat za několik minut.",we_have_not:"O tomto místě zatím nemáme informace",noname:"Bez názvu","adm_div.place":"Místo","adm_div.division":"Správní obvod","adm_div.settlement":"Obec",street:"Ulice","adm_div.district":"Městská část","adm_div.city":"Město",go_to:"Cesta sem",show_organization_in_building:["Celkem {n} organizace","Celkem {n} organizace","Celkem {n} organizací"],back_button:"Zpět",show_more_about_sight:"Více",n_floors:["{n} patro","{n} patra","{n} pater"]},DG.Dictionary.cs),DG.Geoclicker.Handler.Default.Dictionary.es=DG.extend({apiErrorTitle:"Vaya, ha ocurrido un error",apiErrorBody:"Nuestros servidores se niegan a responder. Ya nos estamos esforzando por hacerlos entrar en razón. Vuelva con nosotros pasados unos minutos.",we_have_not:"Todavía no hemos recopilado la información sobre este lugar",noname:"Sin nombre","adm_div.place":"Lugar","adm_div.division":"Comuna","adm_div.settlement":"Población",street:"Calle","adm_div.district":"Comuna","adm_div.city":"Ciudad",go_to:"Ir para allá",show_organization_in_building:["Total {n} organización","Total {n} organizaciones","Total {n} organizaciones"],show_more_about_sight:"Read more",back_button:"Atrás",n_floors:["{n} piso","{n} pisos"]},DG.Dictionary.es);var FirmCard=function(t,e){this._setOptions(e),this._firmContentObject={},this._schedule=new FirmCard.Schedule({localLang:this.options.lang,dict:this.dict}),this.render(t)};FirmCard.prototype={render:function(t){if(t)return t!==this._firmId?(this._firmContentObject={},this._renderCardById(t)):this._toggleEventHandlers(),this._firmContentObject},getSchedule:function(){return this._schedule},getContainer:function(){return this._container},_renderCardById:function(t){var e=this;this.options.ajax(t).then(function(i){if(!i)return!1;var o=i.result.items;"undefined"!==o&&(e._firmData=o[0],e._convertWebsite(),e._firmId=t,e._renderFirmCard(),e._toggleEventHandlers())},function(t){e._renderError()})},_createFirmContainer:function(){var t=document.createElement("div");return t.setAttribute("id","dg-map-firm-full-"+this._firmId),t.setAttribute("class","dg-map-firm-full"),t},_getPaymentTypes:function(t){var e=[],i="general_payment_type";return t.attribute_groups?(t.attribute_groups.forEach(function(t){t.name||t.attributes.forEach(function(t){t.tag.substring(0,i.length)===i&&e.push(t.name)})}),e):e},_groupRubrics:function(t){var e={primary:[],additional:[]};return t.rubrics&&t.rubrics.length?(t.rubrics.forEach(function(t){e[t.kind].push(t)}),e):e},_convertWebsite:function(){this._firmData.contact_groups&&this._firmData.contact_groups.forEach(function(t){t.contacts&&t.contacts.forEach(function(t){"website"==t.type&&(t.url||(t.url=t.value))})})},_renderFirmCard:function(){var t,e,i,o,n,r,a,s=this._firmData,l=this._container=this._createFirmContainer();e=this._schedule.transform(s.schedule,{zoneOffset:this.options.timezoneOffset,apiLang:this.options.lang,localLang:this.options.lang}),i=this._schedule.forecast(e),r=this._getPaymentTypes(s),a=this._groupRubrics(s),t=this._buildFirmCardBody(this._getConfigFirmCardBody(s,e,i,r,a)),o=this._fillHeaderLinks(),n=this._fillFooterButtons(),this._firmContentObject.header=this.options.render("firmCardHeader",{firmName:s.name,links:o}),l.innerHTML=t,this._firmContentObject.tmpl=l,n.length&&(this._footerContainer=document.createElement("div"),this._footerContainer.innerHTML=this.options.render("popupFooterBtns",{btns:n}),this._firmContentObject.footer=this._footerContainer),this.options.onFirmReady&&this.options.onFirmReady(this._firmContentObject)},_renderError:function(){this._firmContentObject.header=this.options.render("popupHeader",{title:this.options.t("apiErrorTitle")}),this._firmContentObject.tmpl=this.options.t("apiErrorBody"),this.options.onFirmReady&&this.options.onFirmReady(this._firmContentObject)},_getConfigFirmCardBody:function(t,e,i,o,n){return[{tmpl:"firmCardAddr",data:{address:t.address_name,comment:t.address_comment}},{tmpl:"firmCardContacts",data:{groups:t.contact_groups}},{tmpl:"firmCardSchedule",data:{schedule:e,forecast:i}},{tmpl:"frimCardPayments",data:{payments:o}},{tmpl:"firmCardRubric",data:{rubrics:n}}]},_buildFirmCardBody:function(t){var e=this;return t.reduce(function(t,i){var o=e.options.render(i.tmpl,i.data);return t+o},"")},_fillFooterButtons:function(){var t=[];return this.options.backBtn&&t.push({name:"firm-card-back",label:this.dict.t(this.options.lang,"btnBack"),icon:!0}),this.options.showRouteSearch&&t.push({name:"goto",label:this.dict.t(this.options.lang,"btnFindWay"),icon:!0,href:this.options.gotoUrl}),this._firmData.links&&this._firmData.links.entrances&&this.options.showEntrance&&t.push({name:"show-entrance",label:this.dict.t(this.options.lang,"btnEntrance"),icon:!0}),t},_fillHeaderLinks:function(){var t,e,i=[],o=this._firmData.reviews;this._firmData.external_content&&this._firmData.external_content.forEach(function(e){e&&"booklet"==e.type&&(t=e)}),o&&o.is_reviewable&&(i.push({name:"flamp_stars",width:20*o.rating}),i.push({name:"flamp_reviews",label:this.dict.t(this.options.lang,"linkReviews",o.review_count?o.review_count:0),href:FirmCard.DataHelper.getFlampUrl(this._firmId)}));for(var n,r=this._firmData.external_content,a=0;a<r.length;a++)if("photo_album"==r[a].type&&"common"==r[a].subtype){n=r[a];break}return!this.options.isMobile&&n&&n.count&&this.options.showPhotos&&(e=L.Util.template(DG.config.photosLink,{id:this._firmId,domain:this.options.domain}),i.push({name:"photos",href:e,label:this.dict.t(this.options.lang,"linkPhoto",n.count)})),!this.options.isMobile&&t&&t.url&&this.options.showBooklet&&i.push({name:"booklet",href:t.url,label:this.dict.t(this.options.lang,"linkBooklet")}),i},_events:{"dg-popup__button_name_firm-card-back":function(){this.options.backBtn(),this._toggleEventHandlers(!0)},"dg-popup__button_name_show-entrance":function(){var t=new this.options.showEntrance({vectors:this._firmData.links.entrances[0].geometry.vectors});t.addTo(this.options.map),t.fitBounds(),this._toggleEventHandlers(!0)},"dg-schedule__today":function(){this._onToggleSchedule()}},_toggleEventHandlers:function(t){this.options.popup[t?"off":"on"]("click",this._onClick,this),this.options.map[t?"off":"on"]("popupclose",this._onClose,this)},_onClick:function(t){var e=t.originalEvent.target;for(var i in this._events)if(this._events.hasOwnProperty(i)&&e.className.indexOf(i)>-1)return DG.DomEvent.preventDefault(t.originalEvent),void this._events[i].call(this,e)},_onClose:function(t){this._toggleEventHandlers(!0)},_onToggleSchedule:function(){var t=this._container.querySelector(".dg-schedule__table"),e=this._container.querySelector(".dg-schedule__now"),i=this._container.querySelector(".dg-schedule__today"),o=" dg-schedule__today_shown_true";t&&("block"===t.style.display?(t.style.display="none",e.style.display="block",i.className=i.className.replace(o,"")):(e.style.display="none",t.style.display="block",i.className+=o),this.options.onToggle&&this.options.onToggle())},_setOptions:function(t){var e,t=t||{};this.options=t,t.lang=t.lang||"ru";for(e in t)t.hasOwnProperty(e)&&(this.options[e]=t[e])},_hasTouch:function(){return"ontouchstart"in window||navigator.maxTouchPoints>0||navigator.msMaxTouchPoints>0}},FirmCard.DataHelper={payMethods:["americanexpress","cash","dinersclub","goldcrown","internet","mastercard","noncash","visa"],_msgs:{},getFlampUrl:function(t){return DG.config.flampUrl.concat(t,"?",DG.config.flampGoogleAnalytics)},msg:function(t){return this._msgs.hasOwnProperty(t)?this._msgs[t]:(console&&console.log("Cant't find translation for '"+t+"'."),t.toString().replace("_"," "))},getProjectTime:function(t,e){var i,o;return i=e?new Date(e):new Date,t?(o=i.getTime()+6e4*i.getTimezoneOffset(),new Date(o+6e4*t)):i}},function(){FirmCard.List=function(t,e){this._firms={},this._setOptions(e),this._container=e&&e.container||document.createElement("ul"),this._container.setAttribute("class","dg-building-callout__list"),this._eventHandlersInited=!1,this._firmCard=this._createFirm(),this.renderList(t)},FirmCard.List.prototype={renderList:function(t){return t&&(this._toggleEventHandlers(),this.addFirms(t)),this.options.onListReady&&this.options.onListReady(this._container),this._container},_processFirms:function(t,e){if(t){var i="_"+e+"Firm";if(this._isArray(t))for(var o=0,n=t.length;o<n;o++)this[i](t[o]);else this[i](t)}},addFirms:function(t){this._processFirms(t,"add")},removeFirms:function(t){this._processFirms(t,"remove")},setLang:function(t){this.options.firmCard.lang=t},getLang:function(){return this.options.firmCard.lang},getContainer:function(){return this._container},clearList:function(){this._firms={},this._toggleEventHandlers(!0),this._clearContainer()},_removeFirm:function(t){return!!this._firms[t]&&(this._container.removeChild(this._firms[t]),void delete this._firms[t])},_addFirm:function(t){var e,i,o,n=this.options.firmlistItemTmpl;i={name:t.name,id:t.id.split("_").slice(0,1)},i.id in this._firms||(e=this._createListItem(),o=n?this.options.firmCard.render(n,{firm:i}):i.name,e.insertAdjacentHTML("beforeend",o),this._firms[i.id]=e,this._container.appendChild(e))},_createListItem:function(){var t=document.createElement("li");return t.setAttribute("class","dg-building-callout__list-item"),t},_isArray:function(t){return"[object Array]"==={}.toString.call(t)},_createFirm:function(t){return new FirmCard(t,this.options.firmCard)},_isEmptyObj:function(t){for(var e in t)if(t.hasOwnProperty(e))return!1;return!0},_events:{"dg-popup__link":function(t){var e=this._firmCard.render(t.id);this.options.firmCard[this._isEmptyObj(e)?"pasteLoader":"onFirmReady"](e),this.options.firmCard.onFirmClick&&this.options.firmCard.onFirmClick(),this._toggleEventHandlers(!0)},"dg-building-callout__list-item":function(t){t=t.children[0],this._events["dg-popup__link"].call(this,t)},"dg-popup__button_name_back":function(){this.options.firmCard.onShowLess(),this._toggleEventHandlers(!0)}},_toggleEventHandlers:function(t){this.options.firmCard.popup[t?"off":"on"]("click",this._onClick,this)},_onClick:function(t){var e=t.originalEvent.target;for(var i in this._events)if(this._events.hasOwnProperty(i)&&e.className.indexOf(i)>-1)return DG.DomEvent.preventDefault(t.originalEvent),void this._events[i].call(this,e)},_clearContainer:function(){for(var t=this._container;t.hasChildNodes();)t.removeChild(t.firstChild)},_setOptions:function(t){t||(t={}),this.options=t,this.options.firmCard||(this.options.firmCard={}),t.firmCard.lang||(this.options.firmCard.lang="ru");for(var e in t)t.hasOwnProperty(e)&&(this.options[e]=t[e])}}}(),FirmCard.Schedule=function(t){return t=t||{},this.localLang=t.localLang||"ru",this.dict=t.dict,this},FirmCard.Schedule.prototype={setLang:function(t){return this.localLang=t||"ru",this},transform:function(t,e){function i(t,e){var i=arguments.length>2?Array.prototype.slice.call(arguments,2):null;return function(){return t.apply(e,i||arguments)}}function o(t){return t.charAt(0).toUpperCase()+t.slice(1)}function n(t){return t.substr(0,2)}function r(t){return t.substr(3,2)}function a(t){var e=+n(t)%24+"";return 1===e.length&&(e="0"+e),e+":"+r(t)}function s(t){return(t+70)%7}function l(t,e){if(null!=t)return null==e?t[t.length-1]:slice.call(t,Math.max(t.length-e,0))}function u(t,e){if(t===e)return!0;if(!(t instanceof Object&&e instanceof Object))return!1;if(t.constructor!==e.constructor)return!1;for(var i in t)if(t.hasOwnProperty(i)){if(!e.hasOwnProperty(i))return!1;if(t[i]!==e[i]){if("object"!=typeof t[i])return!1;if(!u(t[i],e[i]))return!1}}for(i in e)if(e.hasOwnProperty(i)&&!t.hasOwnProperty(i))return!1;return!0}function c(t,e,i){arguments.length<=1&&(e=t||0,t=0),i=arguments[2]||1;for(var o=Math.max(Math.ceil((e-t)/i),0),n=0,r=new Array(o);n<o;)r[n++]=t,t+=i;return r}function h(t){var e=Array.prototype.slice.call(arguments,1);return e.forEach(function(e){if(e)for(var i in e)void 0===t[i]&&(t[i]=e[i])}),t}function d(t,e){return p(t.map(function(t,i,o){return{value:t,index:i,criteria:e.call(this,t,i,o)}}).sort(function(t,e){var i=t.criteria,o=e.criteria;if(i!==o){if(i>o||void 0===i)return 1;if(i<o||void 0===o)return-1}return t.index-e.index}),"value")}function p(t,e){var i,o=[];for(i=0;i<t.length;++i)o[i]=t[i][e];return o}function _(t){var e,i,o,a,s=[];if(!t||!t.working_hours)return[];for(var l=0;l<t.working_hours.length;l++)e=t.working_hours[l].from,i=t.working_hours[l].to,o=n(i)-n(e),a=r(i)-r(e),(o<0||0===o&&a<=0)&&(i=+n(i)+24+":"+r(i)),s[2*l]={time:e,type:"open"},s[2*l+1]={time:i,type:t.working_hours.length-1===l?"close":"lunch"};return s}function m(t){for(var e,i,o=[],a=[],l=E.indexOf(w),u=0;u<7;u++)i=s(l+u),e=_(t[E[i]]),e.forEach(function(t){var e=new Date(P);e.setDate(e.getDate()+u),e.setHours(n(t.time)),e.setMinutes(r(t.time));var i=e.getTime();o.push({ts:i,type:t.type}),o[o.length-1]&&o[o.length-2]&&o[o.length-1].ts===o[o.length-2].ts&&(o.pop(),o.pop()),o[o.length-1]&&o[o.length-2]&&o[o.length-1].ts<=P&&o[o.length-2].ts<=P&&(o[o.length-1].ts+=6048e5,o[o.length-2].ts+=6048e5)});for(o=d(o,function(t){return t.ts}),u=0;u<o.length;)o[u+1]&&o[u].ts===o[u+1].ts?u++:a.push(o[u].ts),u++;return 2===a.length&&a[1]-a[0]===6048e5?[]:o}function f(t,e,i){if(1===e&&t>B)return N(M,"tommorow");if(e>1)switch(i){case 0:return N(M,"nextSun");case 1:return N(M,"nextMon");case 2:return N(M,"nextTue");case 3:return N(M,"nextWed");case 4:return N(M,"nextThu");case 5:return N(M,"nextFri");case 6:return N(M,"nextSat")}}function g(t,e){var i,o=864e5,n=new Date(t.ts);return i=Math.round((n-e)/o),"open"===t.type&&n.getHours()<1&&i++,i}function v(e){var i,o,n=[];z.now={},o=m(t),o.length||(z.always=!0,z.now.open=!0);for(var r=0;r<o.length;r++)if(P>=(o[r-1]&&o[r-1].ts||0)&&P<o[r].ts){var s=Math.floor((o[r].ts-P)/36e5),u=Math.floor((o[r].ts-P)/6e4-60*s),c=new Date(P),h="open"!==o[r].type,d=g(o[r],c);u=10*Math.floor(u/10)?10*Math.floor(u/10):5,z.now.open=h,z.now.lunch=!!(o[r-1]&&"lunch"===o[r-1].type||"lunch"===l(o).type),z.will={willType:o[r].type,d:d,h:s,m:u};var v=new Date(o[r].ts);z.will.when=f(s,d,v.getDay());var y=new Date(o[r].ts),b=y.getHours(),C=y.getMinutes();b<10&&(b="0"+b),C<10&&(C="0"+C),z.will.till=b+":"+C}if(e){for(i=p(_(e),"time"),r=2;r<i.length;r+=2)n.push({from:i[r-1],to:i[r]});x=a(i[0]),D=a(i[i.length-1]),x===D?z.today={alltime:!0,alltimeStr:N(M,"worksAroundTheClock"),from:"00:00",to:"24:00"}:z.today={from:x,to:D},n.length>0&&(z.lunch=n,z.lunchStr=N(M,"lunch"))}}function y(){for(var e=[],i=!1,o=0;o<7;o++){var n=E[o],r=0;if(e[o]={},t[n]){for(var s=t[n],l=p(_(s),"time"),u=[],d=2;d<l.length;d+=2)i=!0,u.push({from:l[d-1],to:l[d]});r=Math.max(l.length/2,r),e[o]={from:a(l[0]),to:a(l[l.length-1]),lunch:u}}n===w&&(e[o].active=!0),e[o].key=G[o]}return e.forEach(function(t){t.lunch&&h(t.lunch,c(1,r))}),{table:e,hasLunch:i}}function b(t,e){var i,n={dayList:[],lunch:[]},r=[];if(t&&t.working_hours&&t.working_hours.length){i=p(_(t),"time"),i.forEach(function(t,e){0===e?n.from=a(t):e===i.length-1?n.to=a(t):r.push(a(t))});for(var l=0;l<r.length;l+=2)n.lunch.push({from:r[l],to:r[l+1],lunchStr:o(N(M,"lunch"))});"00:00"==n.from&&"00:00"==n.to&&(n.to="24:00"),t.round_the_clock&&(n.alltime=!0,n.alltimeStr=N(M,"worksAroundTheClock"))}else n.holiday=!0;var c=[0,0,0,0,0,0,0],h=0;return E.forEach(function(i,o){if(u(e[i],t)||!e[i]&&null===t)n.dayList.push(T[o]),c[s(o+F)]=1,h++;else{if(h>2){for(var r=n.dayList.pop(),a=1;a<h-1;a++)n.dayList.pop();n.dayList[n.dayList.length-1]+=" — "+r}h=0}}),n.budni=u(S,c),n.everyday=1===Math.min.apply(Math,c),n.holiday&&(n.holidayStr=N(M,"restDay",n.dayList.length).slice(2)),n.dayList=n.dayList.join(", "),n.dayList=n.dayList.charAt(0).toUpperCase()+n.dayList.slice(1),n}function C(t,e){for(var i=[],o=t.length-1;o>=0;o--)i.push(b(t[o],e));return i}if(t){e=e||{};for(var w,k,x,D,L=e.zoneOffset||0,z={},P=e.now||FirmCard.DataHelper.getProjectTime(L).getTime(),E=[],G=[],T=[],A=["Mon","Tue","Wed","Thu","Fri","Sat","Sun"],O=["monday","tuesday","wednesday","thursday","friday","saturday","sunday"],M=e.localLang||this.localLang,S=e.localWorkingDays||[0,1,1,1,1,1,0],F=e.firstdayOffset||1,B=e.minHoursToDisplayClosure||4,N=i(this.dict.t,this.dict),H=0;H<7;H++)E[H]=A[H],G[H]=this.dict.t(M,A[H].toLowerCase()),T[H]=this.dict.t(M,O[H]);w=A[s(new Date(P).getDay()-F)],k=t[w],v(k);var U=[],R=0,j=0,I=[];if(Object.keys(t).forEach(function(e){t[e]&&t[e].working_hours&&(R++,u(t[e],l(U))||U.push(t[e]))}),j=U.length,R<7&&j++,j>2)z.week=y(t);else if(1===j)z.week={evently:[b(t[E[0]],t)]};else{for(H=0;H<j;H++)if(I[H]=0,U[H])for(var Z=p(_(U[H]),"time"),V=0;V<Z.length;V+=2){var Y=n(Z[V+1])+r(Z[V+1])/60-(n(Z[V])+r(Z[V])/60);I[H]+=Y}else U[H]=null;var W=d(U,function(t,e){return I[e]});z.week={evently:C(W,t)}}return z.comment=t.comment,z.week&&z.week.evently&&1===z.week.evently.length&&(z.everyday=z.week.evently[0].everyday),z}},forecast:function(t,e){var i,o,n="",r={},a=e&&e.maxHours||1;return t?t.always?{today:{text:this.dict.t(this.localLang,"aroundTheClock")},open:!0}:(t.will&&t.will.h<a&&(t.will.h&&(n+=this.dict.t(this.localLang,"nHours",t.will.h)+" "),t.will.m&&(n+=this.dict.t(this.localLang,"nMins",t.will.m))),t.today?(r.text=this.dict.t(this.localLang,"today"),t.everyday&&(r.text=this.dict.t(this.localLang,"everyday")),r.from=t.today.from,r.to=t.today.to,r.lunch=t.lunch,r.lunch&&(r.lunchStr=this.dict.t(this.localLang,"lunch"))):r.text=this.dict.t(this.localLang,"todayIsRestDay"),t.always?(r.text=this.dict.t(this.localLang,"aroundTheClock"),i=!0):t.now&&(i=t.now.open,o=i?t.will&&"lunch"===t.will.willType?t.will&&t.will.h<a?this.dict.t(this.localLang,"_in")+" "+this.dict.t(this.localLang,"nMins",n)+this.dict.t(this.localLang,"isClosingOnDinner"):this.dict.t(this.localLang,"isOpen"):t.will.h<a?this.dict.t(this.localLang,"closeIn")+this.dict.t(this.localLang,"nMins",n):this.dict.t(this.localLang,"isOpen"):t.will&&t.will.when?this.dict.t(this.localLang,"open")+t.will.when:t.now&&t.now.lunch?t.will.h<a?this.dict.t(this.localLang,"Lunch")+this.dict.t(this.localLang,"openIn")+this.dict.t(this.localLang,"nMins",n):this.dict.t(this.localLang,"Lunch")+this.dict.t(this.localLang,"openAt")+t.will.till:t.will&&t.will.h<a?this.dict.t(this.localLang,"openIn")+this.dict.t(this.localLang,"nMins",n):this.dict.t(this.localLang,"openAt")+t.will.till),{today:r,now:o,open:i,week:t.week,comment:t.comment,everyday:t.everyday}):{}}},FirmCard.prototype.dict={t:function(t,e,i){var o,n,r,a=!1;return"undefined"==typeof this[t]&&(t="ar"===t?"en":"ru"),n=this[t][e],(a="undefined"!=typeof n)?(o=a?n:e,void 0!==i&&(i=parseInt(i,10),i=isNaN(i)?0:i,r=this[t].pluralRules(i),o=i+" "+n[r]),o):e},ru:{pluralRules:function(t){return t%10===1&&t%100!==11?0:t%10>=2&&t%10<=4&&t%10%1===0&&(t%100<12||t%100>14)?1:t%10===0||t%10>=5&&t%10<=9&&t%10%1===0||t%100>=11&&t%100<=14&&t%100%1===0?2:void 0},btnBack:"Назад",btnFindWay:"Проехать сюда",btnEntrance:"Найти вход",linkReviews:["отзыв","отзыва","отзывов"],linkPhoto:["фото","фото","фото"],linkBooklet:"Буклет",tommorow:"завтра",afterTommorow:"послезавтра",afterWeek:"через неделю",nextSun:"в воскресенье",nextMon:"в понедельник",nextTue:"во вторник",nextWed:"в среду",nextThu:"в четверг",nextFri:"в пятницу",nextSat:"в субботу",willOpen:"откроется",willClose:"закроется",isOpen:"Открыто",openTill:"Открыто до ",closeIn:"Закроется через ",openAt:"Откроется в ",openIn:"Откроется через ",open:"Откроется ",nHours:["час","часа","часов"],nMins:["минуту","минуты","минут"],lunch:"обед",Lunch:"Обед. ",workingDays:"Рабочие дни",weekdays:"Будние дни",restDay:["выходной","выходные","выходные"],reviewsOnFlamp:"Отзывы на Флампе",writeReviewOnFlamp:"Написать отзыв на Флампе",payment:"оплата",everyday:"Ежедневно c",worksAroundTheClock:"Работает круглосуточно",aroundTheClock:"Круглосуточно",knowMore:"узнать больше",toClose:"до закрытия",monday:"понедельник",tuesday:"вторник",wednesday:"среда",thursday:"четверг",friday:"пятница",saturday:"суббота",sunday:"воскресенье",mon:"пон",tue:"втр",wed:"срд",thu:"чтв",fri:"птн",sat:"сбт",sun:"вск",toLunch:"до обеда",today:"Сегодня",lessThenHour:"менее часа",youCouldLate:"вы можете не успеть",workingTime:"рабочее время",showAllOrgInRubric:"Показать все организации рубрики",todayIsRestDay:"Сегодня выходной",internet:"Оплата через Интернет",noncash:"Безналичный расчет",goldcrown:"Золотая Корона",dinersclub:"Diners Club",
	mastercard:"Mastercard",maestrocard:"MaestroCard",visa:"Visa",cash:"Наличный расчет",americanexpress:"American Express",hour:"час",less:"менее",_in:"Через",isClosingOnDinner:" закрывается на обед"},it:{pluralRules:function(t){return 1===t?0:1},btnBack:"Indietro",btnFindWay:"Come arrivare ",btnEntrance:"Trova l'ingresso",linkReviews:["recensione","recensioni"],linkPhoto:["fotografia","fotografie"],linkBooklet:"Sull'azienda",tommorow:"domani",afterTommorow:"dopodomani",afterWeek:"tra una settimana",nextSun:"la domenica",nextMon:"il lunedi",nextTue:"il martedì",nextWed:"il mercoledì",nextThu:"il giovedi",nextFri:"il venerdì",nextSat:"il sabato",willOpen:"apre",willClose:"ciuso",isOpen:"Aperto",openTill:"Aperto fino alle ",closeIn:"Chiude tra ",openAt:"Apre alle ",openIn:"Apre tra ",open:"Apre ",nHours:["ora","ore"],nMins:["minuto","minuti"],lunch:"pausa pranzo",Lunch:"Pausa pranzo. ",workingDays:"Giorni feriali",weekdays:"Giorni feriali",restDay:["chiusura","chiusura"],reviewsOnFlamp:"Recensioni su Flamp",writeReviewOnFlamp:"Scrivi una recensione su Flamp",payment:"pagamento",everyday:"Ogni giorno dalole",worksAroundTheClock:"Operativo 24 ore su 24",aroundTheClock:"24 ore su 24",knowMore:"ulteriori informazioni",toClose:"fino alla chiusura",monday:"lunedi",tuesday:"martedì",wednesday:"mercoledì",thursday:"giovedi",friday:"venerdì",saturday:"sabato",sunday:"domenica",mon:"lun",tue:"mar",wed:"mer",thu:"gio",fri:"ven",sat:"sab",sun:"dom",toLunch:"fino alla pausa pranzo",today:"Oggi",lessThenHour:"meno di un'ora",youCouldLate:"affrettarsi, chiusura imminente",workingTime:"orario di lavoro",showAllOrgInRubric:"Visualizza tutte le aziende della categoria",todayIsRestDay:"oggi chiuso",internet:"Pagamento on-line",noncash:"Pagamento non in contanti",goldcrown:"Zolotaja Korona",dinersclub:"Diners Club",mastercard:"MasterCard",maestrocard:"MaestroCard",visa:"Visa",cash:"Pagamento in contanti",americanexpress:"American Express",hour:"un'ora",less:"meno di",_in:"Tra",isClosingOnDinner:"chiude per pausa pranzo"},en:{pluralRules:function(t){return 1===t?0:1},btnBack:"Back",btnFindWay:"Get here",btnEntrance:"Find entrance",linkReviews:["review","reviews"],linkPhoto:["photo","photos"],linkBooklet:"About company",tommorow:"tomorrow",afterTommorow:"the day after tomorrow",afterWeek:"in a week",nextSun:"on Sunday",nextMon:"on Monday",nextTue:"on Tuesday",nextWed:"on Wednesday",nextThu:"on Thursday",nextFri:"on Friday",nextSat:"on Saturday",willOpen:"opens ",willClose:"closes",isOpen:"Open",openTill:"Open till ",closeIn:"Closes in ",openAt:"Opens at ",openIn:"Opens in ",open:"Opens ",nHours:["hour","hours"],nMins:["minute","minutes"],lunch:"lunch break",Lunch:"Lunch break. ",workingDays:"Working days",weekdays:"Weekdays",restDay:["day off","days off"],reviewsOnFlamp:"Reviews on Flamp",writeReviewOnFlamp:"Write a review on Flamp",payment:"payment",everyday:"Daily from",worksAroundTheClock:"Open 24 hours",aroundTheClock:"24h",knowMore:"see also",toClose:"until closing",monday:"Monday",tuesday:"Tuesday",wednesday:"Wednesday",thursday:"Thursday",friday:"Friday",saturday:"Saturday",sunday:"Sunday",mon:"Mon",tue:"Tue",wed:"Wed",thu:"Thu",fri:"Fri",sat:"Sat",sun:"Sun",toLunch:"until lunch",today:"Today",lessThenHour:"less then one hour",youCouldLate:"you might be late",workingTime:"working hours",showAllOrgInRubric:"Show all organizations in the category",todayIsRestDay:"closed today",internet:"Online",noncash:" No-cash",goldcrown:"Golden Crown",dinersclub:"Diners Club",mastercard:"Mastercard",maestrocard:"MaestroCard",visa:"Visa",cash:"Cash",americanexpress:"American Express",hour:"hour",less:"less",_in:"In",isClosingOnDinner:"will be closing for lunch"},cs:{pluralRules:function(t){return 1===t?0:t>=2&&t<=4?1:2},btnBack:"Zpět",btnFindWay:"Jet sem",btnEntrance:"Hledat vstup",linkReviews:["recenze","recenze","recenzí"],linkPhoto:["fotografie","fotografie","fotografií"],linkBooklet:"Leták",tommorow:"zítra",afterTommorow:"pozítří",afterWeek:"za týden",nextSun:"v neděli",nextMon:"v pondělí",nextTue:"v úterý",nextWed:"ve středu",nextThu:"ve čtvrtek",nextFri:"v pátek",nextSat:"v sobotu",willOpen:"otevře se",willClose:"zavře se",isOpen:"Otevřeno",openTill:"Otevřeno do ",closeIn:"Zavře se za ",openAt:"Otevře se v ",openIn:"Otevře se za ",open:"Otevře se ",nHours:["hodinu","hodiny","hodin"],nMins:["minutu","minuty","minut"],lunch:"polední přestávka",Lunch:"Polední přestávka. ",workingDays:"Všední dny",weekdays:"Všední dny",restDay:["zavřeno","zavřeno"],reviewsOnFlamp:"Recenze na Flampu",writeReviewOnFlamp:"Napsat recenzi na Flampu",payment:"platba",everyday:"Denně od ",worksAroundTheClock:"Pracuje nonstop",aroundTheClock:"Nonstop",knowMore:"dozvědět se více",toClose:"do uzavření",monday:"pondělí",tuesday:"úterý",wednesday:"středa",thursday:"čtvrtek",friday:"pátek",saturday:"sobota",sunday:"neděle",mon:"po",tue:"út",wed:"st",thu:"čt",fri:"pá",sat:"so",sun:"ne",toLunch:"do polední přestávky",today:"Dnes",lessThenHour:"méně než hodinu",youCouldLate:"nemusíte to stihnout",workingTime:"pracovní doba",showAllOrgInRubric:"Zobrazit všechny organizace v rubrice",todayIsRestDay:"Dnes je zavřeno",internet:"Platba prostřednictvím Internetu",noncash:"Bezhotovostní platba",goldcrown:"Zolotaja Korona",dinersclub:"Diners Club",mastercard:"Mastercard",maestrocard:"MaestroCard",visa:"Visa",cash:"Platba hotově",americanexpress:"American Express",hour:"hodinu",less:"méně",_in:"Za",isClosingOnDinner:"začíná polední přestávka"},es:{pluralRules:function(t){return 1===t?0:t>=2&&t<=4?1:2},btnBack:"Atrás",btnFindWay:"Ir para allá",btnEntrance:"Buscar acceso",linkReviews:["comentario","comentarios","comentarios"],linkPhoto:["foto","fotos","fotos"],linkBooklet:"Folleto",tommorow:"mañana",afterTommorow:"pasado mañana",afterWeek:"en una semana más",nextSun:"el domingo",nextMon:"el lunes",nextTue:"el martes",nextWed:"el miércoles",nextThu:"el jueves",nextFri:"el viernes",nextSat:"el sábado",willOpen:"se abrirá",willClose:"se cerrará",isOpen:"Abierto",openTill:"Abierto hasta ",closeIn:"Se cerrará dentro de ",openAt:"Se abrirá el ",openIn:"Se abrirá dentro de ",open:"Se abrirá ",nHours:["hora","horas","horas"],nMins:["minuto","minutos","minutos"],lunch:"hora de colación",Lunch:"Hora de colación. ",workingDays:"Días laborables",weekdays:"Días laborables",restDay:["cerrado","cerrado"],reviewsOnFlamp:"Comentarios en Flamp",writeReviewOnFlamp:"Escribir un comentario en Flamp",payment:"pago",everyday:"Cada día desde",worksAroundTheClock:"Abierto las 24 horas",aroundTheClock:"24 horas",knowMore:"para saber más",toClose:"hasta el cierre",monday:"lunes",tuesday:"martes",wednesday:"miércoles",thursday:"jueves",friday:"viernes",saturday:"sábado",sunday:"domingo",mon:"lun",tue:"mar",wed:"mié",thu:"jue",fri:"vie",sat:"sáb",sun:"dom",toLunch:"antes de la hora de colación",today:"Hoy",lessThenHour:"menos de una hora",youCouldLate:"puede ser que no alcanzas a llegar",workingTime:"horario de trabajo",showAllOrgInRubric:"Mostrar todas las empresas de la categoría",todayIsRestDay:"Hoy cerrado",internet:"Pago por Internet",noncash:"Pago sin efectivo",goldcrown:"Zolotaya Korona",dinersclub:"Diners Club",mastercard:"Mastercard",maestrocard:"MaestroCard",visa:"Visa",cash:"Pago en efectivo",americanexpress:"American Express",hour:"hora",less:"menos de",_in:"Dentro de",isClosingOnDinner:"se cierra por hora de colación"}},DG.Traffic=DG.TileLayer.extend({options:{period:0,disableLabel:!1,updateWhenIdle:!1},statics:{Dictionary:{}},initialize:function(t){this._tileUrl=DG.config.protocol+(DG.Browser.retina?DG.config.retinaTrafficTileServer:DG.config.trafficTileServer),this._metaUrl=DG.config.protocol+(DG.Browser.retina?DG.config.retinaTrafficMetaServer:DG.config.trafficMetaServer),this._timeUrl=DG.config.protocol+DG.config.trafficTimestampServer,this._updateInterval=DG.config.trafficLayerUpdateInterval,this._layersOptions={errorTileUrl:"data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",subdomains:"012345679",maxNativeZoom:18,detectRetina:DG.config.detectRetina,minZoom:DG.config.trafficLayerMinZoom},t=DG.setOptions(this,DG.extend(t||{},this._layersOptions)),this._metaLayer=DG.Meta.layer(null,{detectRetina:t.detectRetina,maxNativeZoom:t.maxNativeZoom,dataFilter:DG.bind(this._processData,this),minZoom:t.minZoom}),this._isDg=!0,this._isOnRequest=!1,this._onTimer=DG.bind(this._onTimer,this),DG.TileLayer.prototype.initialize.call(this,this._tileUrl,t)},onAdd:function(t){if(this._initContainer(),this._levels={},this._tiles={},this.options.period)this.options.timestampString="",this._onAddSetParams(t);else{var e=this;this._isOnRequest=!0,this._getTimestampString().then(function(t){e.options.timestampString="?"+t},function(){e.options.timestampString="?"+(new Date).getTime()}).then(function(){e._isOnRequest=!1,e._map&&e._onAddSetParams(t)})}},onRemove:function(t){this._isOnRequest?(L.DomUtil.remove(this._container),t._removeZoomLimit(this),this._container=null):(clearInterval(this._updateTimer),t.removeLayer(this._metaLayer).off("projectchange projectleave",this._onMapProjectChange,this),this.options.disableLabel||(this._metaLayer.off(this._layerEventsListeners,this),this._map.removeLayer(this._labelHelper),this._labelHelper=null,this._map.off("langchange",this._updateLang,this)),DG.TileLayer.prototype.onRemove.call(this,t))},update:function(){var t=this;this._getTimestampString().then(function(e){t.options.timestampString="?"+e},function(){t.options.timestampString="?"+(new Date).getTime()}).then(function(){t.fire("update",{timestamp:t.options.timestampString}),t._layerEventsListeners.mouseout.call(t),t._metaLayer.getOrigin().setURL(t._prepareMetaURL(),t),t.redraw()})},getSubdomain:function(){return this._layersOptions.subdomains[Math.floor(Math.random()*this._layersOptions.subdomains.length)]},_updateLang:function(){var t=this._map.getLang();"ar"===t?this._labelHelper.options.textDirection="rtl":this._labelHelper.options.textDirection="auto"},_getTimestampString:function(){return DG.ajax(DG.Util.template(this._timeUrl,DG.extend({s:this.getSubdomain(),projectCode:this._map.projectDetector.getProject().code},this.options||{})),{type:"get"})},_onTimer:function(){0===this.options.period&&this.update()},_processData:function(t,e){var i=e.scaleBy(this.getTileSize()),o=DG.bind(this._polygonLngLatToPoints,this,i),n={};return DG.Util.isArray(t)?(t[1].forEach(function(t){this[t.graph_id]=t.speed_text},n),t[0].map(function(t){return{id:t.graph_id,speed:n[t.graph_id],geometry:DG.Wkt.toGeoJSON(t.geometry[0].object[0])}}).filter(function(t){return"Polygon"==t.geometry.type||"MultiPolygon"==t.geometry.type}).map(function(t){var e=t.geometry;return"Polygon"==e.type?e.coordinates=o(e.coordinates):"MultiPolygon"==e.type&&(e.coordinates=e.coordinates.map(o)),t})):[]},_polygonLngLatToPoints:function(t,e){var i=this._map;return e.map(function(e){return e.map(function(e){return i.project([e[1],e[0]]).round().subtract(t)})})},_prepareMetaURL:function(){return DG.Util.template(this._metaUrl,DG.extend({x:"{x}",y:"{y}",z:"{z}",s:"{s}"},this.options))},_updateLayerProject:function(){var t=this._map.projectDetector.getProject();DG.setOptions(this,t&&t.traffic?{projectCode:t.code,bounds:t.latLngBounds,minZoom:Math.max(t.minZoom,this._layersOptions.minZoom),maxZoom:t.maxZoom}:{maxZoom:t?t.maxZoom:DG.config.projectLeaveMaxZoom,minZoom:0}),this._metaLayer.getOrigin().setURL(this._prepareMetaURL())},_onMapProjectChange:function(){this._updateLayerProject(),this.redraw()},_layerEventsListeners:{mouseover:function(t){this._setCursor("pointer"),this._labelHelper&&t.meta.speed&&this._labelHelper.setPosition(t.latlng).setContent(t.meta.speed+" "+this.t("speed_unit_km_h")).addTo(this._map)},mouseout:function(){this._setCursor(""),this._labelHelper&&this._map.removeLayer(this._labelHelper)},mousemove:function(t){this._labelHelper&&this._labelHelper.setPosition(t.latlng)}},_setCursor:function(t){this._map.getContainer().style.cursor=t},_onAddSetParams:function(t){this._updateLayerProject(),t.addLayer(this._metaLayer).on("projectchange projectleave",this._onMapProjectChange,this),this.options.disableLabel||(this._metaLayer.on(this._layerEventsListeners,this),this._labelHelper=DG.label(),this._map.on("langchange",this._updateLang,this)),this._updateInterval&&(this._updateTimer=setInterval(this._onTimer,this._updateInterval)),this._resetView(),this._update()},_update:function(t){this._isOnRequest||DG.TileLayer.prototype._update.call(this,t)}}),DG.Traffic.include(DG.Locale),DG.traffic=function(t){return new DG.Traffic(t)},DG.Traffic.Dictionary.ru={speed_unit_km_h:"км/ч"},DG.Traffic.Dictionary.it={speed_unit_km_h:"km/h"},DG.Traffic.Dictionary.cs={speed_unit_km_h:"km/h"},DG.Traffic.Dictionary.es={speed_unit_km_h:"km/h"},DG.Traffic.Dictionary.en={speed_unit_km_h:"km/h"},DG.Traffic.Dictionary.ar={speed_unit_km_h:"كم/ساعة"},DG.Control.Traffic=DG.RoundControl.extend({options:{position:"topright",iconClass:"traffic"},statics:{Dictionary:{}},initialize:function(t){this._trafficClass="dg-traffic-control",this._controlHideClass="dg-control-round_is-hidden_true",DG.setOptions(this,t),DG.extend(this,{_active:!1,_trafficLayer:null}).on(this._controlEvents,this)},_controlEvents:{add:function(){this._trafficLayer=DG.traffic(),this._map.on("zoomend projectchange projectleave",this._updateControlVisibility,this)},click:function(){this._active=!this._active,this._active?(this.setState("active"),this._showTraffic()):(this.setState(""),this._hideTraffic())},remove:function(){this.off(this._controlEvents,this),this._map.off("zoomend projectchange projectleave",this._updateControlVisibility,this),this._active&&(this._map.removeLayer(this._trafficLayer),this._active=!1),this._trafficLayer=null}},_showTraffic:function(){this._updateTrafficScore(),this._map.addLayer(this._trafficLayer)},_hideTraffic:function(){this._handleDom("remove"),this._map.removeLayer(this._trafficLayer)},_handleDom:function(t,e){var i=this._link;i.innerHTML=isNaN(e)?"":e,DG.DomUtil[t+"Class"](i,this._trafficClass),DG.DomUtil[t+"Class"](i,this._trafficClass+"_color_"+this._scoreRate)},_getTrafficColor:function(t){var e="green";return t>7?e="red":t>4&&(e="yellow"),e},_updateControlVisibility:function(){var t=this._map.projectDetector.getProject(),e=t&&t.traffic,i=this._map.getZoom()<DG.config.trafficLayerMinZoom||!e?"addClass":"removeClass";DG.DomUtil[i](this._container,this._controlHideClass),this._active&&e&&this._updateTrafficScore()},_updateTrafficScore:function(){var t=this;this._getTrafficScore().then(function(e){e=parseInt(e,10),t._scoreRate=t._getTrafficColor(e),t._handleDom("add",e)})},_getTrafficScore:function(){var t=DG.Util.template(DG.config.protocol+DG.config.trafficScoreServer,{s:this._trafficLayer.getSubdomain(),projectCode:this._map.projectDetector.getProject().code});return DG.ajax(t,{type:"get"})},_renderTranslation:function(){this._link.title=this.t("button_title")}}),DG.control.traffic=function(t){return new DG.Control.Traffic(t)},DG.Map.mergeOptions({trafficControl:!1}),DG.Map.addInitHook(function(){this.options.trafficControl&&(this.trafficControl=DG.control.traffic(this.options.trafficControl),this.addControl(this.trafficControl))}),DG.Control.Traffic.Dictionary.ru={button_title:"Пробки"},DG.Control.Traffic.Dictionary.it={button_title:"Colonna"},DG.Control.Traffic.Dictionary.cs={button_title:"Zácpy"},DG.Control.Traffic.Dictionary.es={button_title:"Taco"},DG.Control.Traffic.Dictionary.en={button_title:"Traffic"},DG.Control.Traffic.Dictionary.ar={button_title:"حركة السير"},DG.Ruler=DG.Layer.extend({options:{editable:!0},includes:[DG.Locale],statics:{Dictionary:{}},initialize:function(t,e){DG.Util.setOptions(this,e),this._layers={back:null,middle:null,front:null,mouse:null},this._points=[],this._layersContainer=DG.featureGroup(),Object.keys(this._layers).forEach(function(t){this._layersContainer.addLayer(this._layers[t]=DG.featureGroup())},this),this._reset(),DG.Browser.mobile?(delete this._lineMouseEvents.mouseover,delete this._lineMouseEvents.mouseout,delete this._lineMouseEvents.mousemove):delete this._lineMouseEvents.click,t&&t.length&&this.setLatLngs(t)},onAdd:function(t){this._map=t.on("langchange",this._updateDistance,this),this._map.getPane("rulerMarkerPane")||this._map.createPane("rulerMarkerPane"),this._map.getPane("rulerPane")||this._map.createPane("rulerPane"),this._layersContainer.addTo(this._map),this._points.length&&(this._layers.mouse.fire("layeradd"),this._updateDistance()),this._layers.mouse.on(this._lineMouseEvents,this)},onRemove:function(t){t.off("langchange",this._updateDistance,this).removeLayer(this._layersContainer),this._layers.mouse.off(this._lineMouseEvents,this),this._reset()},getTotalDistance:function(){return this._calcDistance()},spliceLatLngs:function(t){var e=this._points.length,i=t>=0?Math.min(t,e):e-t,o=Array.prototype.splice.apply(this._points,arguments).map(function(t){return this._layers.mouse.removeLayer(t),t.off().getLatLng()},this),n=this._points.length;if(n){for(var r=i;r<n;r++)this._points[r]instanceof DG.Ruler.LayeredMarker||(this._points[r]=this._createPoint(this._points[r],this.options.iconStyles.large).on(this._pointEvents,this).once("add",this._addCloseHandler,this).addTo(this._layers.mouse,this._layers)),r&&!this._points[r-1]._legs&&this._addLegs(this._points[r-1]),this._points[r].setPointStyle(this.options.iconStyles[r&&r<n-1?"small":"large"]),this._points[r]._pos=r;this._removeLegs(this._points[n-1]),e>0&&e<n&&this._points[e-1].collapse(),this._points[i]&&this._updateLegs(this._points[i]),i>1&&this._points[i-1].setPointStyle(this.options.iconStyles.small),this._updateDistance(),this._normalizeRulerPoints()}return DG.Browser.touch&&this._lineMarkerHelper&&this._lineMarkerHelper.collapse(),this._fireChangeEvent(),o},addLatLng:function(t){var e=this._points[this._points.length-1]||null;return t=DG.latLng(t),e&&(t=this._normalizeLatLng(t,e.getLatLng())),this.spliceLatLngs(this._points.length,0,t),this},getLatLngs:function(){return this._points.map(function(t){return t.getLatLng()})},setLatLngs:function(t){var e=t.slice();return e.unshift(0,this._points.length),this.spliceLatLngs.apply(this,e),this},_reset:function(){DG.extend(this,{_lineMarkerHelper:null,_morphingNow:!1})},_lineMouseEvents:{click:function(t){var e=t.layer;if(e instanceof DG.Marker&&e._pos!==this._points.length-1)this._lineMarkerHelper&&this._lineMarkerHelper.collapse(),e.setText(this._getFormatedDistance(e)),this._lineMarkerHelper=e;else if(e instanceof DG.Path&&this.options.editable){var i=t.latlng,o=e._point._pos+1;this.spliceLatLngs(o,0,i)}},mouseover:function(t){var e=t.layer;if(e._hovered=!0,!this._morphingNow)if(e instanceof DG.Marker&&e._pos!==this._points.length-1)e.setText(this._getFormatedDistance(e));else if(e instanceof DG.Path&&!this._lineMarkerHelper){var i=e._point;this._lineMarkerHelper=this._addRunningLabel(this._nearestPoint(i._legs.middle,t.latlng),i)}},mouseout:function(t){var e=t.layer,i=t.originalEvent;e._hovered=!1,this._morphingNow||e._pos===this._points.length-1||(e instanceof DG.Marker?(!i.relatedTarget||i.relatedTarget!==e.querySelector("container")&&i.relatedTarget.parentNode!==e.querySelector("container"))&&e.collapse():this._removeRunningLabel())},mousemove:function(t){if(!this._morphingNow&&this._lineMarkerHelper){var e=t.layer._point,i=this._nearestPoint(e._legs.middle,t.latlng);this._lineMarkerHelper.setLatLng(i).setText(this._getFormatedDistance(e,e.getLatLng().distanceTo(i)))}},layeradd:function(){Object.keys(this._layers).forEach(function(t){this._layers[t].bringToFront()},this)}},_fireChangeEvent:function(){this.fire("changed",{latlngs:this.getLatLngs()})},_addRunningLabel:function(t,e){var i=this._createPoint(t).addTo(this._layers.mouse,this._layers),o=this._map.getPane("rulerPane");return o.insertBefore(i._icon,o.lastElementChild),i.setText(this._getFormatedDistance(e,e.getLatLng().distanceTo(t)))},_removeRunningLabel:function(){this._lineMarkerHelper&&(this._layers.mouse.removeLayer(this._lineMarkerHelper),this._lineMarkerHelper=null)},_insertPointInLine:function(t){var e,i=this._lineMarkerHelper.getLatLng(),o=t.target._point._pos+1;if(L.Browser.ie){var n=t.originalEvent.target||t.originalEvent.srcElement,r=n.parentNode;r.appendChild(n)}L.DomEvent.stopPropagation(t.originalEvent),this.spliceLatLngs(o,0,i),e=this._points[o],e.setText(this._getFormatedDistance(e)),setTimeout(function(){if(document.createEvent){var t=document.createEvent("MouseEvents");t.initMouseEvent("mouseup",!1,!1,document.defaultView,1,0,0,0,0,!1,!1,!1,!1,1,e._icon),document.dispatchEvent(t),t=document.createEvent("MouseEvents"),t.initMouseEvent("mousedown",!1,!1,document.defaultView,1,0,0,0,0,!1,!1,!1,!1,1,e._icon),e._icon.dispatchEvent(t)}else e._icon.fireEvent("onMouseUp",DG.extend(document.createEventObject(),{button:1,bubbles:!1,cancelable:!1})),e._icon.fireEvent("onMouseDown",DG.extend(document.createEventObject(),{button:1,bubbles:!1,cancelable:!1}))},0),this._removeRunningLabel(),this._updateLegs(e)},_nearestPoint:function(t,e){for(var i,o,n=this,r=this._project(e),a=t.getLatLngs().map(function(t){return n._project(t)}),s=0;s<a.length-1;s++){var l=DG.LineUtil.pointToSegmentDistance(r,a[s],a[s+1]);(void 0===i||l<i)&&(i=l,o=s)}var u=DG.LineUtil.closestPointOnSegment(r,a[o],a[o+1]);return this._unproject(u)},_addCloseHandler:function(t){t.target.on("click",this._deletePoint,this).querySelector("remove-link").style.display="inline-block"},_createPoint:function(t,e){var i=e?e:this.options.iconStyles.large,o={};return Object.keys(i).forEach(function(e){o[e]=DG.circleMarker(t,i[e])}),DG.Ruler.layeredMarker(t,{layers:o,draggable:this.options.editable,textDirection:"ar"!==this._map.getLang()?"auto":"rtl"})},_normalizeLatLng:function(t,e){for(var i=t.lng<e.lng?360:-360,o=t.lng;Math.abs(o-e.lng)>180;)o+=i;return DG.latLng(t.lat,o)},_normalizeRulerPoints:function(t){t=t||this._points[0];var e,i,o,n,r,a=this,s=t._pos,l=[];for(e=s+1;e<this._points.length;e++)i=this._points[e],o=this._points[e-1],n=i.getLatLng(),r=this._normalizeLatLng(n,o.getLatLng()),r.equals(n)||(i.setLatLng(r),l.push(e));for(e=s-1;e>=0;e--)i=this._points[e],o=this._points[e+1],n=i.getLatLng(),r=this._normalizeLatLng(n,o.getLatLng()),r.equals(n)||(i.setLatLng(r),l.push(e));l.sort().reduce(function(t,e){var i=t&&t===e-1;return a._updateLegs(a._points[e],i),e},null)},_pointEvents:{drag:function(t){var e=t.target;this._normalizeRulerPoints(e),DG.Browser.touch||e===this._points[this._points.length-1]||e.setText(this._getFormatedDistance(e)),this._updateLegs(e),this._updateDistance()},dragend:function(t){var e=t.target;this._morphingNow=!1,e._hovered||e===this._points[this._points.length-1]||e.collapse(),this._fireChangeEvent()},dragstart:function(){DG.Browser.touch&&this._lineMarkerHelper&&this._lineMarkerHelper.collapse(),this._morphingNow=!0}},_deletePoint:function(t){var e=t.originalEvent,i=e.target||e.srcElement;"dg-ruler__label-remove-link"!==i.className&&"dg-ruler__remove-link-overlay"!==i.className||(DG.DomEvent.stop(t.originalEvent),this.spliceLatLngs(t.target._pos,1))},_degToRad:function(t){return Math.PI/180*t},_radToDeg:function(t){return 180/Math.PI*t},_project:function(t){return this._map?this._map.project(t):DG.CRS.EPSG3857.latLngToPoint(t,1)},_unproject:function(t){return this._map?this._map.unproject(t):DG.CRS.EPSG3857.pointToLatLng(t,1)},_calcAngle:function(t,e,i){e=this._normalizeLatLng(e,t),i=this._normalizeLatLng(i,t),t=this._project(t),e=this._project(e),i=this._project(i);var o=e.x-t.x,n=i.x-t.x,r=e.y-t.y,a=i.y-t.y,s=o*n+r*a,l=Math.sqrt(o*o+r*r),u=Math.sqrt(n*n+a*a);return Math.acos(s/(l*u))},_calcMidPoint:function(t,e){var i=this._degToRad(t.lng),o=this._degToRad(t.lat),n=this._degToRad(e.lng),r=this._degToRad(e.lat),a=Math.acos(Math.sin(o)*Math.sin(r)+Math.cos(o)*Math.cos(r)*Math.cos(i-n)),s=.5,l=Math.sin((1-s)*a)/Math.sin(a),u=Math.sin(s*a)/Math.sin(a),c=l*Math.cos(o)*Math.cos(i)+u*Math.cos(r)*Math.cos(n),h=l*Math.cos(o)*Math.sin(i)+u*Math.cos(r)*Math.sin(n),d=l*Math.sin(o)+u*Math.sin(r),p=Math.atan2(d,Math.sqrt(c*c+h*h)),_=Math.atan2(h,c);return DG.latLng(this._radToDeg(p),this._radToDeg(_))},_adaptiveSample:function(t,e,i,o){if(i>9)return[];o=o||this._calcMidPoint(t,e);var n=this._calcMidPoint(t,o),r=this._calcMidPoint(o,e),a=this._calcAngle(n,o,t),s=this._calcAngle(o,t,e),l=this._calcAngle(r,o,e),u=3.1;if(a>u&&s>u&&l>u)return[];var c=[];return c=c.concat(this._adaptiveSample(t,o,i+1,n)),c.push(o),c=c.concat(this._adaptiveSample(o,e,i+1,r))},_calcGreatCircle:function(t,e){if(e=this._normalizeLatLng(e,t),t.equals(e,1))return[t,e];if(180==Math.abs(e.lng-t.lng)){var i=t.lat+e.lat>0?90:-90;return[t,DG.latLng(i,t.lng),DG.latLng(i,e.lng),e]}var o=[];o.push(t),o=o.concat(this._adaptiveSample(t,e,0)),o.push(e);for(var n=1;n<o.length;n++)o[n]=this._normalizeLatLng(o[n],o[n-1]);return o},_addLegs:function(t){var e=this.options.pathStyles,i=this._calcGreatCircle(t.getLatLng(),this._points[t._pos+1].getLatLng());t._legs={},Object.keys(e).forEach(function(o){t._legs[o]=DG.polyline(i,e[o]).addTo(this._layers[o])},this),t._legs.mouse._point=t.once("remove",this._clearRemovingPointLegs,this),this.options.editable&&!DG.Browser.mobile&&t._legs.mouse.on("mousedown",this._insertPointInLine,this),this._map&&this._layers.mouse.addLayer(t._legs.mouse)},_clearRemovingPointLegs:function(t){this._removeLegs(t.target)},_removeLegs:function(t){t._legs&&(Object.keys(t._legs).forEach(function(e){this._layers[e].removeLayer(t._legs[e])},this),t._legs=null)},_updateLegs:function(t,e){var i,o=t.getLatLng(),n=this._points[t._pos-1],r=this._points[t._pos+1],a=this;n&&!e&&(i=a._calcGreatCircle(n.getLatLng(),o),Object.keys(n._legs).forEach(function(t){n._legs[t].setLatLngs(i)})),r&&(i=a._calcGreatCircle(o,r.getLatLng()),Object.keys(t._legs).forEach(function(e){t._legs[e].setLatLngs(i)}))},_calcDistance:function(t,e){for(var i=e?e:0,o=t?t._pos:this._points.length-1,n=0;n<o;n++)i+=this._points[n].getLatLng().distanceTo(this._points[n+1].getLatLng());return i},_getFormatedDistance:function(){var t=this._calcDistance.apply(this,arguments),e="m";return t>1e3?(t/=1e3,e="km",t>1e3?(t=t.toFixed(),t=t.slice(0,-3)+" "+t.slice(-3)):t=t.toFixed(2).split(".").join(this.t("delimiter"))):t=Math.round(t),[t||0," ",this.t(e)].join("")},_updateDistance:function(){this._map&&this._points.length&&this._points[this._points.length-1].setText(this._getFormatedDistance())}}),DG.ruler=function(t,e){return new DG.Ruler(t,e)},DG.Ruler.LayeredMarker=DG.Marker.extend({options:{draggable:!1,keyboard:!1,riseOnHover:!0,pane:"rulerMarkerPane",textDirection:"auto",iconHTML:['<img class="dg-ruler__label-spacer" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" width="26" height="26" />','<div class="dg-ruler__label-container">','    <div class="dg-ruler__point"></div>','    <span class="dg-ruler__label-distance">0 км</span>','    <span class="dg-ruler__label-remove-link"></span>','    <div class="dg-ruler__remove-link-overlay"></div>',"</div>"].join("\n")},statics:{domClass:"dg-ruler__label"},addTo:function(t,e){return Object.keys(this._layers).forEach(function(t){e[t].addLayer(this._layers[t])},this),this._viewport=e,DG.Marker.prototype.addTo.call(this.on("move",this._onMove),t)},onRemove:function(t){return Object.keys(this._layers).forEach(function(t){this._viewport[t].removeLayer(this._layers[t])},this),this.off("move",this._onMove),this._viewport=null,this._style=null,DG.Marker.prototype.onRemove.call(this,t)},setText:function(t){return this._iconCollapsed&&this.expand(),this._iconNodes.label.innerHTML=t,this._iconNodes.label.setAttribute("dir",this.options.textDirection),this},setPointStyle:function(t){return this._style!==t&&Object.keys(this._style=t).forEach(function(e){this._layers[e].setStyle(t[e])},this),this},expand:function(){return this._iconCollapsed=!1,this._iconNodes.container.style.display="block",this._iconNodes.spacer.style.display="none",this},collapse:function(){return this._iconCollapsed=!0,this._iconNodes.container.style.display="none",this._iconNodes.spacer.style.display="block",this},querySelector:function(t){return this._icon.querySelector("."+DG.Ruler.LayeredMarker.domClass+"-"+t)},_onMove:function(t){var e=t.latlng;Object.keys(this._layers).forEach(function(t){this._layers[t].setLatLng(e)},this)},_initIcon:function(){DG.Marker.prototype._initIcon.call(this),this._iconCollapsed=!0,this._icon.style.width="",this._iconNodes={label:this.querySelector("distance"),spacer:this.querySelector("spacer"),container:this.querySelector("container")}},_setPos:function(t){L.DomUtil.setPosition(this._icon,t),this._shadow&&L.DomUtil.setPosition(this._shadow,t)},_afterInit:function(){this._layers=this.options.layers||null,this.options.icon=DG.divIcon({className:DG.Ruler.LayeredMarker.domClass,iconSize:[26,26],iconAnchor:[13,13],html:this.options.iconHTML})}}),DG.Ruler.LayeredMarker.addInitHook("_afterInit"),DG.Ruler.layeredMarker=function(t,e){return new DG.Ruler.LayeredMarker(t,e)};var rulerRenderer=DG.svg({pane:"rulerPane"}),hoverRenderer=DG.svg({pane:"rulerPane"});DG.Ruler.mergeOptions({pathStyles:{back:{color:"#fff",opacity:1,weight:12,pointerEvents:"none",noClip:!0,renderer:rulerRenderer,smoothFactor:0},middle:{color:"#0da5d5",opacity:1,weight:4,pointerEvents:"none",noClip:!0,renderer:rulerRenderer,smoothFactor:0},mouse:{color:"#fff",opacity:DG.Browser.vml?.1:0,weight:DG.Browser.touch?40:20,pointerEvents:"painted",noClip:!0,renderer:hoverRenderer,smoothFactor:0}},iconStyles:{large:{back:{color:"#fff",opacity:1,fillColor:"#fff",fillOpacity:1,weight:1,radius:13,renderer:rulerRenderer},middle:{color:"#0da5d5",opacity:1,fillColor:"#0da5d5",fillOpacity:1,weight:1,radius:9,renderer:rulerRenderer},front:{color:"#fff",opacity:1,fillColor:"#0da5d5",fillOpacity:1,weight:4,radius:5,renderer:rulerRenderer}},small:{back:{color:"#fff",opacity:1,fillColor:"#fff",fillOpacity:1,weight:1,radius:9,renderer:rulerRenderer},middle:{color:"#0da5d5",opacity:1,fillColor:"#0da5d5",fillOpacity:1,weight:1,radius:5,renderer:rulerRenderer},front:{color:"#fff",opacity:1,fillColor:"#0da5d5",fillOpacity:1,weight:4,radius:2,renderer:rulerRenderer}}}}),DG.Ruler.Dictionary.ru={km:"км",m:"м",delimiter:","},DG.Ruler.Dictionary.it={km:"km",m:"m",delimiter:","},DG.Ruler.Dictionary.cs={km:"km",m:"m",delimiter:","},DG.Ruler.Dictionary.es={km:"km",m:"m",delimiter:","},DG.Ruler.Dictionary.en={km:"km",m:"m",delimiter:"."},DG.Ruler.Dictionary.ar={km:"كم",m:"م",delimiter:"."},DG.Control.Ruler=DG.RoundControl.extend({options:{position:"topright",iconClass:"ruler"},statics:{Dictionary:{}},initialize:function(t){DG.setOptions(this,t),DG.extend(this,{_active:!1,_drawingHelper:null,_geoclickerNeedRestore:!1}).on(this._controlEvents,this)},_controlEvents:{add:function(){this._drawingHelper=DG.ruler([])},click:function(){this._active=!this._active,this._active?(this.setState("active"),this._startDrawing()):(this.setState(""),this._finishDrawing())},remove:function(){this.off(this._controlEvents,this),this._active&&(this._map.removeLayer(this._drawingHelper),this._active=!1),this._drawingHelper=null}},_startDrawing:function(){this._map.addLayer(this._drawingHelper).on("click",this._handleMapClick,this),this._map.fire("rulerstart")},_finishDrawing:function(){this._map.off("click",this._handleMapClick,this).removeLayer(this._drawingHelper),this._drawingHelper.setLatLngs([]),this._map.fire("rulerend")},_handleMapClick:function(t){this._drawingHelper.addLatLng(t.latlng)},_renderTranslation:function(){this._link.title=this.t("button_title")}}),DG.control.ruler=function(t){return new DG.Control.Ruler(t)},DG.Map.mergeOptions({rulerControl:!1}),DG.Map.addInitHook(function(){this.options.rulerControl&&(this.rulerControl=DG.control.ruler(this.options.rulerControl),this.addControl(this.rulerControl))}),DG.Control.Ruler.Dictionary.ru={button_title:"Линейка"},DG.Control.Ruler.Dictionary.it={button_title:"Righello"},DG.Control.Ruler.Dictionary.cs={button_title:"Pravítko"},DG.Control.Ruler.Dictionary.es={button_title:"Regla"
	},DG.Control.Ruler.Dictionary.en={button_title:"Ruler"},DG.Control.Ruler.Dictionary.ar={button_title:"مسطرة"},function(t){function e(t,e){return t.w('<div class="dg-attribution__copyright"><ul class="dg-attribution__links"><li class="dg-attribution__link-item"><a href="').f(e.get(["copyright_apilink"],!1),e,"h").w('" target="_blank" class="dg-attribution__link" dir="').f(e.get(["dir"],!1),e,"h").w('">').f(e.get(["work_on"],!1),e,"h").w('</a></li><li class="dg-attribution__link-item"><a href="').f(e.get(["copyright_license"],!1),e,"h").w('" target="_blank" class="dg-attribution__link">').f(e.get(["license_agreement"],!1),e,"h").w("</a></li></ul>").x(e.get(["logotype"],!1),e,{"else":i,block:a},{}).w("</div>")}function i(t,e){return t.s(e.get(["btn"],!1),e,{block:o},{})}function o(t,e){return t.w('<div class="dg-attribution__button-wrapper"><a class="dg-attribution__open2gis-button_name_').f(e.get(["name"],!1),e,"h").w(' dg-attribution__open2gis-button dg-attribution__open2gis-icon-button"').x(e.get(["open2gis_link"],!1),e,{"else":n,block:r},{}).w(">").f(e.get(["label"],!1),e,"h").w("</a></div>")}function n(t,e){return t.w('href="javascript:void(0)"')}function r(t,e){return t.w("href=").f(e.get(["open2gis_link"],!1),e,"h").w(' target="_blank" name=').f(e.get(["open2gis_name"],!1),e,"h")}function a(t,e){return t.w('<a href="').f(e.get(["copyright_logo"],!1),e,"h").w('" target="_blank" class="dg-attribution__logo-url"></a>')}return t.register("DGAttribution/copyright",e),e.__dustBody=!0,i.__dustBody=!0,o.__dustBody=!0,n.__dustBody=!0,r.__dustBody=!0,a.__dustBody=!0,e}(dust),function(t){function e(t,e){return t.w('<div class="dg-map-geoclicker__purpose dg-map-geoclicker__purpose_type_').f(e.get(["type"],!1),e,"h").w('">').f(e.get(["purpose"],!1),e,"h").w("</div>").s(e.get(["drilldown"],!1),e,{block:i},{})}function i(t,e){return t.w('<div class="dg-map-geoclicker__drilldown">').f(e.get(["drilldown"],!1),e,"h").w("</div>")}return t.register("DGGeoclicker/cityarea",e),e.__dustBody=!0,i.__dustBody=!0,e}(dust),function(t){function e(t,e){return t.w('<address class="dg-firm-card__address dg-firm-card__icon">').f(e.get(["address"],!1),e,"h").s(e.get(["comment"],!1),e,{block:i},{}).w("</address>")}function i(t,e){return t.w('<span class="dg-firm-card__comment">&mdash; ').f(e.getPath(!0,[]),e,"h").w("</span>")}return t.register("DGGeoclicker/firmCardAddr",e),e.__dustBody=!0,i.__dustBody=!0,e}(dust),function(t){function e(t,e){return t.s(e.get(["groups"],!1),e,{block:i},{})}function i(t,e){return t.s(e.get(["contacts"],!1),e,{block:o},{})}function o(t,e){return t.h("select",e,{block:n},{key:e.get(["type"],!1),type:"string"},"h")}function n(t,e){return t.h("eq",e,{block:r},{value:"phone",type:"string"},"h").h("eq",e,{block:s},{value:"fax",type:"string"},"h").h("eq",e,{block:u},{value:"website",type:"string"},"h").h("eq",e,{block:c},{value:"email",type:"string"},"h")}function r(t,e){return t.w('<div class="dg-firm-card__phone dg-firm-card__icon"><span class="dg-firm-card__phone-num">').f(e.get(["text"],!1),e,"h").s(e.get(["comment"],!1),e,{block:a},{}).w("</span></div>")}function a(t,e){return t.w('<span class="dg-firm-card__comment" title="').f(e.getPath(!0,[]),e,"h").w('">&mdash;&nbsp;&nbsp;').f(e.getPath(!0,[]),e,"h").w("</span>")}function s(t,e){return t.w('<div class="dg-firm-card__phone dg-firm-card__icon"><span class="dg-firm-card__phone-num">').f(e.get(["text"],!1),e,"h").s(e.get(["comment"],!1),e,{block:l},{}).w("</span></div>")}function l(t,e){return t.w('<span class="dg-firm-card__comment" title="').f(e.getPath(!0,[]),e,"h").w('">&mdash;&nbsp;&nbsp;').f(e.getPath(!0,[]),e,"h").w("</span>")}function u(t,e){return t.w('<div class="dg-firm-card__link dg-firm-card__site dg-firm-card__icon"><a href="').f(e.get(["url"],!1),e,"h").w('" target="_blank" class="dg-link_scheme_dark dg-firm-card__sitelink">').f(e.get(["text"],!1),e,"h").w("</a></div>")}function c(t,e){return t.w('<div class="dg-firm-card__link dg-firm-card__email dg-firm-card__icon"><a href="mailto:').f(e.get(["value"],!1),e,"h").w('">').f(e.get(["value"],!1),e,"h").w("</a></div>")}return t.register("DGGeoclicker/firmCardContacts",e),e.__dustBody=!0,i.__dustBody=!0,o.__dustBody=!0,n.__dustBody=!0,r.__dustBody=!0,a.__dustBody=!0,s.__dustBody=!0,l.__dustBody=!0,u.__dustBody=!0,c.__dustBody=!0,e}(dust),function(t){function e(t,e){return t.w('<div class="dg-popup__header-title dg-popup__header-title_for_firmcard" title="').f(e.get(["firmName"],!1),e,"h").w('">').f(e.get(["firmName"],!1),e,"h").w("</div>").x(e.get(["links"],!1),e,{block:i},{})}function i(t,e){return t.w('<div class="dg-popup__header-links">').s(e.get(["links"],!1),e,{block:o},{}).w("</div>")}function o(t,e){return t.h("eq",e,{"else":n,block:s},{key:l,value:"flamp_stars",type:"string"},"h")}function n(t,e){return t.w('<a class="dg-popup__header-link dg-popup__link dg-popup__link_type_').f(e.get(["name"],!1),e,"h").w('"').x(e.get(["href"],!1),e,{"else":r,block:a},{}).w(">").f(e.get(["label"],!1),e,"h").w("</a>")}function r(t,e){return t.w('href="javascript:void(0)"')}function a(t,e){return t.w("href=").f(e.get(["href"],!1),e,"h").w(' target="_blank"')}function s(t,e){return t.w('<div class="dg-popup__rating"><div class="dg-popup__rating-stars" style="width: ').f(e.get(["width"],!1),e,"h").w('%"></div></div>')}function l(t,e){return t.f(e.get(["name"],!1),e,"h")}return t.register("DGGeoclicker/firmCardHeader",e),e.__dustBody=!0,i.__dustBody=!0,o.__dustBody=!0,n.__dustBody=!0,r.__dustBody=!0,a.__dustBody=!0,s.__dustBody=!0,l.__dustBody=!0,e}(dust),function(t){function e(t,e){return t.s(e.get(["rubrics"],!1),e,{block:i},{})}function i(t,e){return t.w('<section class="dg-firm-card__rubrics">').x(e.get(["primary"],!1),e,{block:o},{}).x(e.get(["additional"],!1),e,{block:r},{}).w("</section>")}function o(t,e){return t.w('<ul class="dg-firm-card__rubrics-list dg-firm-card__rubrics-list_type_primary">').s(e.get(["primary"],!1),e,{block:n},{}).w("</ul>")}function n(t,e){return t.w('<li class="dg-firm-card__rubrics-list-item">').f(e.get(["name"],!1),e,"h").w("</li>")}function r(t,e){return t.w('<ul class="dg-firm-card__rubrics-list dg-firm-card__rubrics-list_type_additional">').s(e.get(["additional"],!1),e,{block:a},{}).w("</ul>")}function a(t,e){return t.w('<li class="dg-firm-card__rubrics-list-item">').f(e.get(["name"],!1),e,"h").w("</li>")}return t.register("DGGeoclicker/firmCardRubric",e),e.__dustBody=!0,i.__dustBody=!0,o.__dustBody=!0,n.__dustBody=!0,r.__dustBody=!0,a.__dustBody=!0,e}(dust),function(t){function e(t,e){return t.w('<div class="dg-firm-card__schedule dg-schedule dg-schedule_open_').x(e.getPath(!1,["forecast","open"]),e,{"else":i,block:o},{}).w(" dg-schedule_works-everyday_").x(e.getPath(!1,["schedule","everyday"]),e,{"else":n,block:r},{}).w('">').x(e.get(["schedule"],!1),e,{block:a},{}).w("</div>")}function i(t,e){return t.w("false")}function o(t,e){return t.w("true")}function n(t,e){return t.w("false")}function r(t,e){return t.w("true")}function a(t,e){return t.x(e.getPath(!1,["forecast","today"]),e,{block:s},{}).s(e.getPath(!1,["forecast","now"]),e,{block:h},{}).nx(e.getPath(!1,["schedule","everyday"]),e,{block:p},{})}function s(t,e){return t.w('<div class="dg-schedule__today"><div class="dg-schedule__today-inner">').f(e.getPath(!1,["forecast","today","text"]),e,"h").w("&nbsp;").x(e.getPath(!1,["forecast","today","from"]),e,{block:l},{}).x(e.getPath(!1,["schedule","lunch"]),e,{block:u},{}).w("</div></div>")}function l(t,e){return t.f(e.getPath(!1,["forecast","today","from"]),e,"h").w("&ndash;").f(e.getPath(!1,["forecast","today","to"]),e,"h")}function u(t,e){return t.w(",&nbsp;").f(e.getPath(!1,["forecast","today","lunchStr"]),e,"h").w("&nbsp;").s(e.getPath(!1,["schedule","lunch"]),e,{block:c},{})}function c(t,e){return t.f(e.get(["from"],!1),e,"h").w("&ndash;").f(e.get(["to"],!1),e,"h")}function h(t,e){return t.w('<div class="dg-schedule__now"><span class="dg-schedule__now-text">').f(e.getPath(!0,[]),e,"h").s(e.getPath(!1,["schedule","comment"]),e,{block:d},{}).w("</span></div>")}function d(t,e){return t.w(", ").f(e.getPath(!0,[]),e,"h")}function p(t,e){return t.x(e.getPath(!1,["schedule","week"]),e,{block:_},{})}function _(t,e){return t.x(e.getPath(!1,["schedule","week","evently"]),e,{block:m},{}).x(e.getPath(!1,["schedule","week","table"]),e,{block:k},{})}function m(t,e){return t.w('<div class="dg-schedule__table">').s(e.getPath(!1,["schedule","week","evently"]),e,{block:f},{}).w("</div>")}function f(t,e){return t.w('<div class="dg-schedule__string">').x(e.get(["alltime"],!1),e,{block:g},{}).x(e.get(["everyday"],!1),e,{"else":v,block:y},{}).x(e.get(["holiday"],!1),e,{"else":b,block:w},{}).w("</div>")}function g(t,e){return t.f(e.get(["alltimeStr"],!1),e,"h")}function v(t,e){return t.f(e.get(["dayList"],!1),e,"h")}function y(t,e){return t.f(e.getPath(!1,["forecast","today","text"]),e,"h")}function b(t,e){return t.w('<span class="schedule__string-time">&nbsp;').f(e.get(["from"],!1),e,"h").w("&ndash;").f(e.get(["to"],!1),e,"h").w("</span>").s(e.get(["lunch"],!1),e,{block:C},{})}function C(t,e){return t.w("<p>").f(e.get(["lunchStr"],!1),e,"h").w('&mdash;<span class="schedule__string-time">').f(e.get(["from"],!1),e,"h").w("&ndash;").f(e.get(["to"],!1),e,"h").w("</span></p>")}function w(t,e){return t.w('&nbsp;&mdash;<span class="schedule__string-time">&nbsp;').f(e.get(["holidayStr"],!1),e,"h").w("</span>")}function k(t,e){return t.w('<div><div class="dg-schedule__table"><div class="dg-schedule__tc dg-schedule__tc_pre"><div class="dg-schedule__day-name">&nbsp;</div><div class="dg-schedule__table-clock dg-schedule__td"></div>').x(e.getPath(!1,["schedule","week","hasLunch"]),e,{block:x},{}).w("</div>").s(e.getPath(!1,["schedule","week","table"]),e,{block:D},{}).w("</div>  </div>")}function x(t,e){return t.w('<div class="dg-schedule__table-lunch dg-schedule__td"></div>')}function D(t,e){return t.h("if",e,{block:L},{cond:z},"h").w('<div class="dg-schedule__tc').x(e.get(["active"],!1),e,{block:P},{}).w('"><div class="dg-schedule__day-name">').f(e.get(["key"],!1),e,"h").w('</div><div class="dg-schedule__td">').x(e.get(["from"],!1),e,{"else":E,block:G},{}).w("</div>").s(e.get(["lunch"],!1),e,{block:T},{}).w("</div> ").h("if",e,{block:M},{cond:S},"h")}function L(t,e){return t.w('<span class="dg-schedule__table-cell-group">')}function z(t,e){return t.w("(").f(e.get(["$idx"],!1),e,"h").w(" == ").f(e.get(["$len"],!1),e,"h").w(" - 2)")}function P(t,e){return t.w(" dg-schedule__tc_active_true")}function E(t,e){return t.w("&ndash;")}function G(t,e){return t.f(e.get(["from"],!1),e,"h").w(" ").f(e.get(["to"],!1),e,"h")}function T(t,e){return t.w('<div class="dg-schedule__td">').x(e.get(["from"],!1),e,{"else":A,block:O},{}).w("</div>")}function A(t,e){return t.w("&ndash;")}function O(t,e){return t.f(e.get(["from"],!1),e,"h").w(" ").f(e.get(["to"],!1),e,"h")}function M(t,e){return t.w("</span>")}function S(t,e){return t.w("(").f(e.get(["$idx"],!1),e,"h").w(" == ").f(e.get(["$len"],!1),e,"h").w(")")}return t.register("DGGeoclicker/firmCardSchedule",e),e.__dustBody=!0,i.__dustBody=!0,o.__dustBody=!0,n.__dustBody=!0,r.__dustBody=!0,a.__dustBody=!0,s.__dustBody=!0,l.__dustBody=!0,u.__dustBody=!0,c.__dustBody=!0,h.__dustBody=!0,d.__dustBody=!0,p.__dustBody=!0,_.__dustBody=!0,m.__dustBody=!0,f.__dustBody=!0,g.__dustBody=!0,v.__dustBody=!0,y.__dustBody=!0,b.__dustBody=!0,C.__dustBody=!0,w.__dustBody=!0,k.__dustBody=!0,x.__dustBody=!0,D.__dustBody=!0,L.__dustBody=!0,z.__dustBody=!0,P.__dustBody=!0,E.__dustBody=!0,G.__dustBody=!0,T.__dustBody=!0,A.__dustBody=!0,O.__dustBody=!0,M.__dustBody=!0,S.__dustBody=!0,e}(dust),function(t){function e(t,e){return t.w('<a id="').f(e.getPath(!1,["firm","id"]),e,"h").w('" class="dg-popup__link" href="#">').f(e.getPath(!1,["firm","name"]),e,"h").w("</a>")}return t.register("DGGeoclicker/firmlistItem",e),e.__dustBody=!0,e}(dust),function(t){function e(t,e){return t.x(e.get(["payments"],!1),e,{block:i},{})}function i(t,e){return t.w('<section class="dg-firm-card__aa"><ul class="dg-firm-card__aa-list">').s(e.get(["payments"],!1),e,{block:o},{}).w("</ul></section>")}function o(t,e){return t.w('<li class="dg-firm-card__aa-list-item">').f(e.getPath(!0,[]),e,"h").w("</li>")}return t.register("DGGeoclicker/frimCardPayments",e),e.__dustBody=!0,i.__dustBody=!0,o.__dustBody=!0,e}(dust),function(t){function e(t,e){return t.s(e.get(["address"],!1),e,{block:i},{}).s(e.get(["purpose"],!1),e,{block:r},{}).s(e.get(["attractions"],!1),e,{block:a},{})}function i(t,e){return t.w('<address class="dg-map-geoclicker__address">').s(e.getPath(!1,["address","header"]),e,{block:o},{}).s(e.getPath(!1,["address","drilldown"]),e,{block:n},{}).w("</address>")}function o(t,e){return t.w('<div class="dg-map-geoclicker__address-header">').f(e.getPath(!0,[]),e,"h").w("</div>")}function n(t,e){return t.w('<div class="dg-map-geoclicker__address-drilldown">').f(e.getPath(!0,[]),e,"h").w("</div>")}function r(t,e){return t.w('<div class="dg-map-geoclicker__purpose">').f(e.getPath(!0,[]),e,"h").w("</div>")}function a(t,e){return t.w('<div class="dg-map-geoclicker__purpose dg-map-geoclicker__purpose_type_sight">').f(e.getPath(!0,[]),e,"h").w("</div>")}return t.register("DGGeoclicker/house",e),e.__dustBody=!0,i.__dustBody=!0,o.__dustBody=!0,n.__dustBody=!0,r.__dustBody=!0,a.__dustBody=!0,e}(dust),function(t){function e(t,e){return t.w('<div class="dg-preloader dg-preloader_scheme_regular dg-preloader_animation_').x(e.get(["anim"],!1),e,{"else":i,block:o},{}).x(e.get(["small"],!1),e,{block:n},{}).w('"></div>')}function i(t,e){return t.w("false")}function o(t,e){return t.w("true")}function n(t,e){return t.w(" dg-preloader_size_small")}return t.register("DGGeoclicker/loader",e),e.__dustBody=!0,i.__dustBody=!0,o.__dustBody=!0,n.__dustBody=!0,e}(dust),function(t){function e(t,e){return t.w('<div class="dg-popup__footer-title"><a class="dg-popup__show-less-house-link" href="javascript:void(0)">').f(e.get(["hideFirmsText"],!1),e,"h").w("</a></div>")}return t.register("DGGeoclicker/popupFooter",e),e.__dustBody=!0,e}(dust),function(t){function e(t,e){return t.x(e.get(["btns"],!1),e,{block:i},{})}function i(t,e){return t.w('<footer class="dg-popup__footer-buttons">').s(e.get(["btns"],!1),e,{block:o},{}).w("</footer>")}function o(t,e){return t.w('<div class="dg-popup__footer-button-wrapper"><a class="dg-popup__button_name_').f(e.get(["name"],!1),e,"h").w(" dg-popup__footer-button").x(e.get(["icon"],!1),e,{block:n},{}).w('"').x(e.get(["href"],!1),e,{"else":r,block:a},{}).w(">").f(e.get(["label"],!1),e,"h").w("</a></div>")}function n(t,e){return t.w(" dg-popup__footer-icon-button")}function r(t,e){return t.w('href="javascript:void(0)"')}function a(t,e){return t.w("href=").f(e.get(["href"],!1),e,"h").w(' target="_blank"')}return t.register("DGGeoclicker/popupFooterBtns",e),e.__dustBody=!0,i.__dustBody=!0,o.__dustBody=!0,n.__dustBody=!0,r.__dustBody=!0,a.__dustBody=!0,e}(dust),function(t){function e(t,e){return t.s(e.get(["title"],!1),e,{block:i},{})}function i(t,e){return t.w('<div class="dg-popup__header-title">').f(e.getPath(!0,[]),e,"h").w("</div>")}return t.register("DGGeoclicker/popupHeader",e),e.__dustBody=!0,i.__dustBody=!0,e}(dust),function(t){function e(t,e){return t.s(e.get(["purpose"],!1),e,{block:i},{}).s(e.get(["address"],!1),e,{block:o},{}).s(e.get(["description"],!1),e,{block:a},{})}function i(t,e){return t.w('<div class="dg-map-geoclicker__purpose dg-map-geoclicker__purpose_type_sight">').f(e.getPath(!0,[]),e,"h").w("</div>")}function o(t,e){return t.w('<address class="dg-map-geoclicker__address">').s(e.getPath(!1,["address","header"]),e,{block:n},{}).s(e.getPath(!1,["address","drilldown"]),e,{block:r},{}).w("</address>")}function n(t,e){return t.w('<div class="dg-map-geoclicker__address-header">').f(e.getPath(!0,[]),e,"h").w("</div>")}function r(t,e){return t.w('<div class="dg-map-geoclicker__address-drilldown">').f(e.getPath(!0,[]),e,"h").w("</div>")}function a(t,e){return t.w('<div class="dg-map-geoclicker__sight-description">').f(e.getPath(!0,[]),e,"h").w("</div>").s(e.get(["showMoreText"],!1),e,{block:s},{})}function s(t,e){return t.w('<a class="dg-map-geoclicker__show-more-sights-link" href="javascript:void(0)">').f(e.getPath(!0,[]),e,"h").w("</a>")}return t.register("DGGeoclicker/sight",e),e.__dustBody=!0,i.__dustBody=!0,o.__dustBody=!0,n.__dustBody=!0,r.__dustBody=!0,a.__dustBody=!0,s.__dustBody=!0,e}(dust),DG.fallbackProjectsList=JSON.parse('[{"bounds":"POLYGON((89.710795 54.632572,89.917767 54.765465,90.308713 54.738921,90.33171 54.77873,90.400701 54.844991,90.515685 54.911144,90.768651 54.911144,90.860638 54.85823,90.929629 54.85823,90.929629 54.8185,90.952626 54.805248,90.929629 54.725643,90.906632 54.71236,90.906632 54.659186,91.06761 54.59262,91.136601 54.579294,91.136601 54.552628,91.205591 54.539289,91.274582 54.485888,91.251585 54.419038,91.274582 54.405655,91.596538 54.432417,91.619535 54.419038,91.757516 54.419038,91.872501 54.35208,91.872501 54.311852,91.826507 54.285012,91.826507 54.150548,91.757516 54.09664,91.780513 54.056163,91.80351 53.961562,91.849504 53.920953,91.826507 53.880305,91.826507 53.771716,91.849504 53.758122,91.826507 53.635583,91.80351 53.485328,91.941491 53.444257,91.964488 53.361995,91.872501 53.307066,91.826507 53.265822,91.80351 53.196994,91.665529 53.155645,91.619535 53.100449,91.642532 52.920575,91.665529 52.906708,91.688526 52.865079,91.665529 52.851193,91.596538 52.753872,91.458557 52.712096,91.297579 52.712096,91.297579 52.726026,91.021617 52.920575,90.768651 53.072825,90.653667 53.196994,90.653667 53.224539,90.69966 53.279574,90.768651 53.320805,90.791648 53.361995,90.906632 53.403146,90.929629 53.444257,91.044613 53.485328,91.044613 53.540028,90.69966 53.608304,90.446695 53.676469,90.33171 53.717316,90.193729 53.839617,90.216726 53.934494,90.193729 53.97509,90.124739 54.042661,89.986757 54.204386,89.96376 54.204386,89.96376 54.217835,89.917767 54.271585,89.825779 54.405655,89.710795 54.632572))","code":"abakan","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"69","name":"Абакан","time_zone":{"name":"Asia/Krasnoyarsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((39.876575 43.201679,39.876575 43.21844,40.014556 43.385799,40.037553 43.485993,40.083547 43.519355,40.106544 43.569362,40.221528 43.569362,40.244525 43.586022,40.405503 43.552697,40.520487 43.536028,40.543484 43.519355,40.612475 43.536028,40.635472 43.552697,40.658468 43.552697,40.727459 43.536028,40.842443 43.485993,40.934431 43.452614,40.980425 43.419216,41.210393 43.385799,41.210393 43.369084,41.325378 43.352364,41.417365 43.352364,41.440362 43.302177,41.463359 43.302177,41.60134 43.235197,41.693328 43.21844,41.716324 43.235197,41.739321 43.21844,41.854306 43.21844,41.877303 43.235197,42.038281 43.201679,42.107271 43.201679,42.130268 43.151368,42.107271 43.134588,42.038281 43.050621,41.900299 43.033813,41.900299 42.7136,41.946293 42.679797,41.923296 42.629058,41.854306 42.578277,41.831309 42.5444,41.785315 42.5444,41.785315 42.527455,41.716324 42.510505,41.578343 42.408709,41.279384 42.408709,41.256387 42.425686,41.23339 42.5444,41.210393 42.5444,41.210393 42.578277,41.049415 42.595208,41.026418 42.612135,40.957428 42.629058,40.842443 42.798028,40.773453 42.8149,40.750456 42.865487,40.681465 42.865487,40.405503 42.916033,40.336512 42.966538,40.267522 42.983364,40.198531 42.983364,40.06055 43.033813,39.968562 43.184913,39.876575 43.201679))","code":"abkhazia","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":false,"road_network":true,"truck_graph":true},"id":"248","name":"Абхазия","time_zone":{"name":"Asia/Tbilisi","offset":240},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((49.788226 44.903867,49.788226 45.017774,49.880214 45.163892,49.972201 45.196313,50.133179 45.212516,50.363148 45.212516,50.547123 45.147675,50.708101 45.098997,50.869079 45.131454,51.099048 45.309637,51.168039 45.390445,51.283023 45.503383,51.765957 45.616094,52.156904 45.551715,52.294885 45.567817,52.455863 45.616094,52.570848 45.776718,52.731826 45.88888,52.823813 46.000816,52.84681 46.016789,53.697694 46.016789,53.789682 46.080632,53.95066 46.160333,53.996654 46.239918,54.249619 46.255822,54.341607 46.255822,54.548579 46.303504,54.68656 46.319388,54.847538 46.367015,55.05451 46.367015,55.077507 46.382882,55.284479 46.367015,55.468454 46.493817,55.537444 46.477983,55.629432 46.4146,55.767413 46.4146,55.836403 46.398743,55.8594 46.287614,55.836403 46.27172,55.997382 46.22401,56.020378 46.208098,56.089369 46.192181,56.15836 46.144402,56.22735 46.128466,56.273344 46.144402,56.480316 46.128466,56.52631 46.080632,56.549306 46.000816,56.5953 45.920885,56.641294 45.66433,56.664291 45.648256,56.733281 45.180105,56.319338 45.082761,55.997382 45.001515,55.997382 41.3126,55.905394 41.3126,55.79041 41.260759,55.767413 41.278044,55.652428 41.260759,55.445457 41.24347,55.330472 41.364399,55.261482 41.416158,55.100504 41.605586,55.05451 41.691506,54.939525 41.811602,54.916529 41.845874,54.939525 41.897247,54.709557 42.068194,54.456591 42.221653,54.341607 42.272723,54.272616 42.340753,54.157632 42.357749,53.996654 42.323752,53.927663 42.323752,53.58271 42.272723,53.490723 42.238681,53.444729 42.238681,53.191763 42.153495,53.076779 42.136444,53.053782 42.119388,52.984791 42.085263,52.685832 41.897247,52.501857 41.76016,52.340879 41.708677,52.248892 41.708677,52.225895 41.76016,52.225895 41.99987,52.202898 42.119388,52.225895 42.20462,52.294885 42.289737,52.40987 42.476591,52.386873 42.5444,52.317882 42.595208,52.202898 42.629058,51.903938 42.662889,51.74296 42.7136,51.719963 42.764271,51.67397 42.798028,51.604979 42.899189,51.535989 42.949708,51.421004 42.966538,51.260026 42.983364,51.122045 43.033813,51.099048 43.050621,51.053054 43.117804,51.076051 43.452614,50.984064 43.519355,50.93807 43.602677,50.892076 43.635974,50.823086 43.768976,50.708101 43.934814,50.547123 44.116703,50.478132 44.13321,50.317154 44.149714,50.179173 44.199195,50.087186 44.281572,50.018195 44.380272,50.018195 44.544403,49.903211 44.757084,49.788226 44.903867))","code":"aktau","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"196","name":"Актау","time_zone":{"name":"Asia/Aqtau","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((56.871263 50.308299,56.871263 50.367011,56.89426 50.410998,57.078235 50.557325,57.193219 50.586536,57.285206 50.571932,57.308203 50.528096,57.377194 50.513474,57.538172 50.528096,57.584166 50.498848,57.745144 50.484218,57.768141 50.440299,57.745144 50.367011,57.768141 50.322984,57.745144 50.278916,57.69915 50.249514,57.676153 50.190657,57.607163 50.190657,57.492178 50.146466,57.446184 50.116983,57.354197 50.116983,57.285206 50.131727,57.170222 50.116983,57.055238 50.131727,56.940253 50.175931,56.940253 50.264217,56.871263 50.308299))","code":"aktobe","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"167","name":"Актобе","time_zone":{"name":"Asia/Aqtobe","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((73.727969 45.196313,73.727969 45.244908,73.773963 45.293462,74.003932 45.293462,74.003932 45.325808,73.980935 45.374293,73.911944 45.74463,73.980935 45.856857,74.026929 45.88888,74.049926 46.000816,74.16491 46.144402,74.739832 46.525471,75.015794 46.557107,75.33775 46.683467,75.521725 46.715011,75.590716 46.699241,75.797688 46.715011,75.820685 46.730776,76.07365 46.730776,76.211631 46.636117,76.372609 46.651905,76.4416 46.620324,76.533588 46.620324,76.533588 46.636117,76.602578 46.667688,76.625575 46.667688,76.763556 46.604527,76.855544 46.588725,76.901538 46.557107,76.924534 46.572919,76.924534 46.620324,77.039519 46.636117,77.108509 46.572919,77.131506 46.525471,77.200497 46.525471,77.292484 46.557107,77.315481 46.604527,77.453462 46.604527,77.54545 46.636117,77.54545 46.715011,77.522453 46.730776,77.522453 46.79379,77.476459 47.15469,77.614441 47.217206,77.798416 47.185957,77.890403 47.185957,78.005387 47.264045,78.074378 47.248437,78.120372 47.217206,78.189362 47.217206,78.258353 47.295248,78.327344 47.310843,78.465325 47.232824,78.603306 47.185957,78.672297 47.139049,78.741287 47.139049,78.833275 47.045108,79.040247 47.060777,79.270215 47.07644,79.707156 46.919596,79.868134 46.888172,80.098103 46.903887,80.1211 46.888172,80.19009 46.872453,80.213087 46.79379,80.305074 46.778043,80.374065 46.730776,80.420059 46.730776,80.443056 46.715011,80.650028 46.636117,80.856999 46.572919,81.155959 46.557107,81.247946 46.493817,81.385927 46.541292,81.477915 46.557107,81.546906 46.493817,81.523909 46.398743,81.569902 46.319388,81.684887 46.239918,81.753877 46.160333,81.868862 46.112526,81.960849 45.904885,81.983846 45.88888,82.052837 45.824815,82.121827 45.712524,82.144824 45.696464,82.259809 45.583914,82.282805 45.583914,82.39779 45.503383,82.420787 45.503383,82.420787 45.487263,82.535771 45.438875,82.558768 45.422736,82.604762 45.358136,82.604762 45.212516,82.489777 45.163892,82.420787 45.163892,82.420787 45.180105,82.305802 45.196313,82.282805 45.212516,82.075834 45.196313,82.052837 45.228714,81.937852 45.212516,81.822868 45.293462,81.776874 45.358136,81.66189 45.341974,81.500912 45.261097,81.431921 45.244908,81.408924 45.261097,81.132962 45.196313,81.109965 45.180105,81.017977 45.147675,80.902993 45.131454,80.879996 45.115228,80.765012 45.131454,80.650028 45.115228,80.627031 45.098997,80.489049 45.098997,80.397062 45.034027,80.282078 45.034027,80.213087 45.017774,80.144096 45.034027,79.937125 44.920153,80.006115 44.838676,80.029112 44.822367,80.167093 44.838676,80.236084 44.740751,80.351068 44.708073,80.420059 44.626296,80.397062 44.495212,80.374065 44.478806,80.420059 44.31449,80.420059 44.149714,80.466053 44.083674,80.466053 44.01756,80.535043 43.901683,80.535043 43.835366,80.696021 43.619328,80.742015 43.552697,80.765012 43.435917,80.742015 43.352364,80.719018 43.33564,80.788009 43.318911,80.811006 43.168143,80.811006 43.134588,80.742015 43.117804,80.719018 43.134588,80.627031 43.134588,80.55804 43.084221,80.420059 43.033813,80.443056 42.983364,80.581037 42.932873,80.604034 42.916033,80.581037 42.865487,80.535043 42.865487,80.397062 42.8149,80.282078 42.8149,80.259081 42.696701,80.19009 42.645975,80.213087 42.561341,80.236084 42.5444,80.259081 42.5444,80.236084 42.425686,80.305074 42.272723,80.305074 42.221653,80.236084 42.20462,80.167093 42.20462,80.1211 42.306747,80.006115 42.357749,79.937125 42.442659,79.799143 42.442659,79.707156 42.476591,79.546178 42.459627,79.45419 42.49355,79.431193 42.5444,79.408197 42.5444,79.339206 42.595208,79.178228 42.679797,79.178228 42.747385,79.155231 42.798028,79.132234 42.781152,78.902265 42.781152,78.810278 42.8149,78.695293 42.8149,78.511319 42.882341,78.465325 42.882341,78.304347 42.865487,78.005387 42.865487,77.660434 42.916033,77.591444 42.916033,77.568447 42.932873,77.246491 42.916033,77.131506 42.966538,77.016522 42.966538,76.993525 42.983364,76.763556 42.949708,76.740559 42.916033,76.533588 42.916033,76.418603 42.865487,76.349613 42.865487,76.280622 42.916033,76.211631 42.916033,76.188635 42.932873,76.027656 42.916033,76.00466 42.932873,75.912672 42.949708,75.797688 42.932873,75.774691 42.949708,75.613713 43.000185,75.63671 43.017001,75.613713 43.067423,75.544722 43.084221,75.360747 43.151368,75.291757 43.285439,75.291757 43.352364,75.406741 43.435917,75.406741 43.485993,75.383744 43.536028,75.176772 43.519355,75.038791 43.602677,74.992797 43.635974,75.107782 43.719135,75.26876 43.818776,75.26876 43.934814,75.314753 43.967926,75.314753 44.13321,75.199769 44.23216,74.946803 44.347391,74.739832 44.363834,74.509863 44.478806,74.509863 44.708073,74.325888 44.854981,74.2339 44.871281,74.141913 44.920153,74.095919 45.082761,74.072922 45.131454,74.003932 45.131454,73.750966 45.115228,73.727969 45.196313))","code":"almaty","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"flamp":false,"metro":true,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"67","name":"Алматы","time_zone":{"name":"Asia/Almaty","offset":360},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((51.535989 55.095794,51.558985 55.135251,51.627976 55.135251,51.811951 55.043123,51.880942 55.056298,52.04192 55.056298,52.225895 55.108951,52.386873 55.095794,52.547851 55.135251,52.639838 55.135251,52.869807 55.082633,52.984791 55.043123,52.984791 55.029945,53.076779 54.977188,53.191763 54.963988,53.237757 54.884696,53.076779 54.725643,53.007788 54.672486,52.984791 54.659186,52.984791 54.645881,52.938798 54.619259,52.961795 54.565963,52.984791 54.565963,52.984791 54.472527,52.915801 54.459161,52.639838 54.459161,52.570848 54.472527,52.501857 54.459161,52.47886 54.472527,52.386873 54.472527,52.340879 54.525945,52.294885 54.552628,52.225895 54.659186,52.156904 54.699073,52.087913 54.765465,51.857945 54.897922,51.535989 55.095794))","code":"almetevsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"108","name":"Альметьевск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((177.328874 64.723829,177.351871 64.753271,177.466856 64.74346,177.535846 64.74346,177.535846 64.704183,177.512849 64.635311,177.466856 64.635311,177.351871 64.674688,177.328874 64.723829))","code":"anadyr","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"truck_graph":true},"id":"155","name":"Анадырь","time_zone":{"name":"Asia/Anadyr","offset":720},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((40.819447 44.806053,40.819447 44.871281,40.888437 44.887576,40.888437 45.001515,40.86544 45.050277,40.888437 45.066521,40.888437 45.196313,40.934431 45.244908,41.026418 45.244908,41.049415 45.228714,41.279384 45.228714,41.348375 45.212516,41.348375 45.115228,41.325378 45.115228,41.302381 45.034027,41.348375 44.920153,41.302381 44.871281,41.325378 44.854981,41.325378 44.740751,41.279384 44.691727,41.210393 44.691727,41.118406 44.675376,41.072412 44.708073,40.934431 44.757084,40.819447 44.806053))","code":"armawir","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"truck_graph":true},"id":"106","name":"Армавир","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((39.462631 64.308265,39.462631 64.821843,39.531622 64.831625,40.612475 64.821843,40.819447 64.821843,41.210393 64.812058,41.302381 64.812058,41.325378 64.78268,41.302381 64.655007,41.302381 64.566264,41.279384 64.338158,41.279384 64.298293,41.210393 64.288318,41.049415 64.288318,40.198531 64.298293,39.531622 64.298293,39.462631 64.308265))","code":"arkhangelsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"49","name":"Архангельск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((40.520487 18.089269,40.520487 18.154838,40.635472 18.176688,40.681465 18.220381,41.210393 18.482309,41.325378 18.547729,41.371371 18.591328,41.394368 18.656706,41.60134 18.678493,41.60134 18.743837,41.624337 18.743837,41.578343 18.852688,41.463359 19.004961,41.509353 19.048442,41.555346 19.048442,41.624337 19.222252,41.716324 19.222252,41.831309 19.113642,41.900299 19.200535,41.923296 19.265675,41.923296 19.417568,41.854306 19.482621,41.831309 19.547649,41.831309 19.720927,41.739321 19.699277,41.762318 19.764217,41.785315 19.785858,41.785315 19.872391,41.831309 19.91564,41.900299 20.196469,41.96929 20.261205,42.015284 20.369037,42.107271 20.412148,42.130268 20.412148,42.153265 20.325913,42.222256 20.282777,42.291246 20.304346,42.314243 20.325913,42.406231 20.325913,42.429227 20.282777,42.544212 20.261205,42.636199 20.390594,42.70519 20.390594,42.70519 20.476793,42.797177 20.519875,42.912162 20.519875,42.981152 20.584474,43.07314 20.606001,43.165127 20.778109,43.234118 20.799608,43.44109 20.778109,43.625065 20.7351,43.625065 20.713591,43.740049 20.692079,43.80904 20.670565,43.87803 20.606001,43.993015 20.519875,44.039008 20.519875,44.039008 20.282777,44.062005 20.261205,44.085002 20.110114,44.107999 20.002103,44.17699 19.93726,44.222983 19.699277,44.222983 19.569319,44.153993 19.547649,44.153993 19.482621,44.222983 19.46094,44.337968 19.482621,44.383962 19.417568,44.383962 19.33079,44.452952 19.309088,44.452952 19.200535,44.383962 19.091912,44.383962 18.961469,44.314971 18.939718,44.24598 18.939718,44.199987 18.896209,44.130996 18.87445,44.107999 18.809156,44.107999 18.743837,43.993015 18.634916,43.970018 18.525925,43.947021 18.504119,43.947021 18.438682,43.87803 18.373221,43.855034 18.307735,43.855034 18.264064,43.763046 18.242224,43.763046 18.176688,43.717052 18.132984,43.671059 17.936181,43.625065 17.9143,43.602068 17.761061,43.625065 17.563846,43.671059 17.519991,43.717052 17.388363,43.602068 17.388363,43.464087 17.519991,43.395096 17.54192,43.326105 17.519991,43.303109 17.498059,43.280112 17.519991,43.257115 17.498059,43.188124 17.498059,43.165127 17.585769,43.07314 17.585769,43.004149 17.629608,42.981152 17.695347,42.889165 17.717254,42.866168 17.78296,42.728187 17.761061,42.70519 17.78296,42.498218 17.804857,42.406231 17.739159,42.360237 17.826751,42.245253 17.892417,42.245253 17.979934,42.222256 18.045543,42.084274 18.045543,42.084274 17.9143,42.038281 17.848643,41.96929 17.78296,41.279384 17.54192,41.210393 17.519991,40.911434 17.410307,40.86544 17.454189,40.750456 17.651524,40.612475 17.9143,40.589478 17.936181,40.520487 18.089269))","code":"asir","country_code":"sa","domain":"sa","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true},"id":"223","name":"Асир","time_zone":{"name":"Asia/Riyadh","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((71.129323 51.123677,71.129323 51.253399,71.336295 51.310935,71.382288 51.310935,71.635254 51.325308,71.681248 51.354041,71.750238 51.354041,71.750238 51.339677,71.842226 51.224603,71.865223 51.152536,71.88822 51.008062,71.796232 50.950147,71.612257 50.921162,71.382288 50.935657,71.267304 50.950147,71.15232 51.02253,71.129323 51.123677))","code":"nur_sultan","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"68","name":"Астана","time_zone":{"name":"Asia/Almaty","offset":360},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((47.62652 46.335269,47.62652 46.683467,47.718508 46.778043,47.787499 46.778043,47.810495 46.762292,47.879486 46.746536,47.902483 46.730776,47.948477 46.730776,47.948477 46.715011,48.132452 46.715011,48.316427 46.683467,48.36242 46.636117,48.408414 46.477983,48.36242 46.287614,48.36242 46.22401,48.408414 46.192181,48.408414 46.144402,48.36242 46.112526,48.36242 46.064678,48.270433 46.04872,48.247436 46.064678,48.201442 46.04872,47.971473 46.016789,47.833492 46.064678,47.764502 46.04872,47.695511 46.064678,47.62652 46.335269))","code":"astrakhan","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"8","name":"Астрахань","time_zone":{"name":"Europe/Astrakhan","offset":240},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((47.074595 47.946266,47.074595 47.992457,47.097592 48.007845,47.097592 48.023228,47.18958 48.084715,47.120589 48.100075,47.120589 48.238112,47.18958 48.222793,47.281567 48.222793,47.787499 48.161471,48.684376 48.100075,48.960339 48.053981,49.328289 47.946266,49.443273 47.930859,49.443273 48.007845,49.512264 48.023228,49.673242 48.007845,49.765229 48.007845,49.811223 48.038607,49.995198 48.038607,50.248164 48.207469,50.731098 48.421583,50.823086 48.421583,50.892076 48.467348,51.00706 48.513071,51.076051 48.619599,51.283023 48.634798,51.398007 48.665185,51.834948 48.619599,51.811951 48.528303,51.834948 48.513071,51.949932 48.528303,52.04192 48.467348,52.202898 48.482593,52.432867 48.406319,52.501857 48.406319,52.547851 48.467348,52.547851 48.634798,52.570848 48.649994,52.593845 48.74107,52.708829 48.771392,52.708829 48.983134,52.77782 48.998224,52.84681 49.043467,52.984791 49.02839,53.21476 49.02839,53.237757 49.013309,53.398735 49.043467,53.398735 49.11878,53.559713 49.178949,53.628704 49.224027,53.743688 49.163914,53.858673 49.11878,53.904666 49.11878,53.927663 49.163914,53.996654 49.163914,54.019651 48.968039,54.019651 48.892497,54.042647 48.756233,54.295613 48.710729,54.31861 48.695552,54.341607 48.695552,54.479588 48.634798,54.548579 48.649994,54.571576 48.695552,54.571576 48.771392,54.68656 48.786546,54.732554 48.786546,54.755551 48.74107,54.870535 48.725902,54.916529 48.695552,54.939525 48.589185,54.893532 48.467348,54.893532 48.345217,54.962522 48.268736,54.939525 48.161471,54.939525 48.100075,55.100504 47.961667,55.100504 47.822887,55.1235 47.776545,55.077507 47.668251,55.05451 47.575249,55.077507 47.559732,55.077507 47.450988,55.031513 47.419877,55.031513 47.373176,55.008516 47.201584,55.1235 47.060777,55.1235 47.013758,55.169494 46.982389,55.238485 46.872453,55.445457 46.730776,55.468454 46.730776,55.49145 46.715011,55.698422 46.651905,56.296341 46.509647,56.319338 46.382882,56.434322 46.239918,56.434322 46.208098,56.457319 46.192181,56.480316 46.128466,56.273344 46.144402,56.22735 46.128466,56.15836 46.144402,56.089369 46.192181,56.020378 46.208098,55.997382 46.22401,55.836403 46.27172,55.8594 46.287614,55.836403 46.398743,55.767413 46.4146,55.629432 46.4146,55.537444 46.477983,55.468454 46.493817,55.284479 46.367015,55.077507 46.382882,55.05451 46.367015,54.847538 46.367015,54.68656 46.319388,54.548579 46.303504,54.341607 46.255822,54.249619 46.255822,53.996654 46.239918,53.95066 46.160333,53.789682 46.080632,53.697694 46.016789,52.84681 46.016789,52.754823 46.208098,52.708829 46.367015,52.708829 46.430453,52.77782 46.604527,52.639838 46.683467,52.501857 46.651905,52.386873 46.604527,52.202898 46.604527,52.133907 46.620324,51.834948 46.572919,51.719963 46.572919,51.512992 46.604527,51.444001 46.651905,51.421004 46.730776,51.398007 46.730776,51.352014 46.825269,51.283023 46.841002,51.122045 46.730776,51.099048 46.730776,50.179173 46.096581,50.133179 46.080632,50.064189 46.096581,49.673242 46.144402,49.443273 46.208098,49.397279 46.239918,49.259298 46.287614,49.190308 46.382882,49.09832 46.382882,49.075323 46.398743,48.891348 46.462144,48.822358 46.477983,48.753367 46.557107,48.569392 46.557107,48.546395 46.604527,48.569392 46.620324,48.523398 46.651905,48.523398 46.699241,48.592389 46.715011,48.707373 46.715011,48.753367 46.683467,48.914345 46.699241,48.960339 46.730776,48.983336 46.730776,48.983336 46.778043,48.914345 46.888172,48.73037 47.07644,48.523398 47.404314,48.454408 47.404314,48.385417 47.482081,48.339423 47.513155,48.247436 47.637269,48.178445 47.71469,48.063461 47.761088,47.948477 47.745627,47.649517 47.761088,47.488539 47.807444,47.488539 47.822887,47.419549 47.822887,47.419549 47.776545,47.396552 47.699215,47.327561 47.699215,47.304564 47.71469,47.143586 47.791997,47.143586 47.838326,47.120589 47.915449,47.097592 47.930859,47.097592 47.946266,47.074595 47.946266))","code":"atyrau","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"168","name":"Атырау","time_zone":{"name":"Asia/Atyrau","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((77.039519 53.730922,77.108509 53.826046,77.131506 53.893859,77.085513 53.94803,77.085513 53.97509,77.154503 53.988613,77.246491 54.042661,77.315481 54.042661,77.338478 54.083152,77.315481 54.123603,77.292484 54.137078,77.315481 54.177476,77.361475 54.204386,77.384472 54.204386,77.384472 54.217835,77.775419 54.217835,77.798416 54.204386,77.890403 54.204386,77.9134 54.217835,78.028384 54.231279,78.028384 54.244719,78.120372 54.258154,78.120372 54.311852,78.212359 54.338675,78.327344 54.298434,78.327344 54.271585,78.35034 54.271585,78.327344 54.217835,78.304347 54.204386,78.304347 54.177476,78.327344 54.164014,78.35034 54.09664,78.235356 54.09664,78.235356 54.056163,78.258353 54.042661,78.235356 54.029156,78.166365 54.015646,78.166365 53.94803,78.074378 53.920953,77.98239 53.920953,77.959394 53.880305,77.9134 53.853184,77.9134 53.798889,77.867406 53.798889,77.798416 53.826046,77.683431 53.81247,77.660434 53.785305,77.54545 53.785305,77.499456 53.717316,77.384472 53.703705,77.361475 53.717316,77.246491 53.703705,77.1775 53.676469,77.108509 53.676469,77.062516 53.717316,77.039519 53.730922))","code":"bagan","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":false,"truck_graph":true},"id":"176","name":"Баган","time_zone":{"name":"Asia/Novosibirsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((49.512264 40.705231,49.535261 40.705231,49.581254 40.670355,49.742233 40.618007,49.857217 40.600548,50.041192 40.635461,50.225167 40.600548,50.317154 40.530669,50.386145 40.425713,50.432139 40.250422,50.409142 40.197746,50.340151 40.197746,50.041192 40.250422,49.719236 40.232868,49.696239 40.21531,49.604251 40.197746,49.535261 40.21531,49.535261 40.267972,49.558258 40.285517,49.535261 40.443217,49.512264 40.705231))","code":"baku","country_code":"az","domain":"az","flags":{"2gis_reviews":true,"flamp":false,"metro":true,"parking_layer":true,"public_transport":true,"road_network":true,"traffic":true},"id":"209","name":"Баку","time_zone":{"name":"Asia/Baku","offset":240},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((47.718508 51.967438,47.718508 52.052369,47.810495 52.052369,47.902483 52.024077,47.902483 51.981605,47.787499 51.967438,47.764502 51.953267,47.718508 51.967438))","code":"balakovo","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"truck_graph":true},"id":"121","name":"Балаково","time_zone":{"name":"Europe/Saratov","offset":240},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((77.407469 55.082633,77.407469 55.17467,77.522453 55.214049,77.660434 55.227167,77.683431 55.25339,77.591444 55.279595,77.591444 55.345033,77.660434 55.358108,77.844409 55.358108,77.9134 55.345033,78.120372 55.331954,78.28135 55.358108,78.373337 55.410363,78.442328 55.397306,78.534315 55.423416,78.626303 55.423416,78.695293 55.371178,78.741287 55.345033,78.902265 55.345033,78.925262 55.305783,78.902265 55.292691,78.925262 55.25339,78.948259 55.24028,78.925262 55.135251,78.971256 55.108951,78.994253 55.043123,78.994253 55.003575,78.695293 55.016762,78.695293 55.003575,78.488322 54.924361,78.419331 54.911144,78.373337 54.85823,78.189362 54.8185,77.959394 54.738921,77.959394 54.685782,77.936397 54.672486,77.890403 54.685782,77.775419 54.672486,77.614441 54.752195,77.614441 54.871465,77.522453 54.871465,77.499456 54.990384,77.476459 54.990384,77.407469 55.082633))","code":"barabinsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true,"truck_graph":true},"id":"177","name":"Барабинск","time_zone":{"name":"Asia/Novosibirsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((82.351796 53.457952,82.351796 53.512687,82.420787 53.512687,82.420787 53.49901,82.535771 53.49901,82.558768 53.512687,82.535771 53.553692,82.650755 53.635583,82.650755 53.690089,82.742743 53.744525,82.76574 53.798889,83.20268 54.056163,83.317665 54.056163,83.340661 53.94803,83.409652 53.934494,83.478643 54.002132,83.478643 54.069659,83.57063 54.110123,83.777602 54.110123,83.846593 54.123603,83.915583 54.09664,83.984574 54.110123,83.984574 54.029156,84.007571 53.961562,84.214543 53.961562,84.283533 53.853184,84.352524 53.853184,84.398518 53.798889,84.467508 53.798889,84.490505 53.758122,84.467508 53.717316,84.421514 53.676469,84.352524 53.676469,84.283533 53.662845,84.283533 53.621946,84.30653 53.608304,84.352524 53.540028,84.444511 53.540028,84.559496 53.52636,84.582493 53.540028,84.651483 53.553692,84.720474 53.540028,84.743471 53.49901,84.858455 53.485328,84.904449 53.430558,85.019433 53.430558,85.088424 53.389434,85.019433 53.34827,85.065427 53.265822,84.996436 53.210769,85.04243 53.183216,85.203408 53.196994,85.226405 53.210769,85.387383 53.224539,85.387383 53.128056,85.479371 53.114255,85.479371 53.072825,85.433377 53.017524,85.364386 53.017524,85.226405 52.989846,85.203408 52.948297,85.249402 52.920575,85.249402 52.865079,85.111421 52.767788,84.789464 52.767788,84.743471 52.712096,84.743471 52.67028,84.720474 52.600498,84.67448 52.558575,84.605489 52.516612,84.559496 52.530604,84.536499 52.586528,84.467508 52.586528,84.30653 52.544592,84.283533 52.530604,84.099558 52.460599,84.030568 52.460599,83.93858 52.628424,83.961577 52.64238,84.122555 52.67028,84.122555 52.698162,84.099558 52.767788,84.030568 52.809511,83.984574 52.878959,83.86959 52.865079,83.800599 52.878959,83.823596 52.948297,83.754605 52.989846,83.754605 53.059007,83.777602 53.072825,83.754605 53.128056,83.524636 53.141852,83.432649 53.169432,83.432649 53.210769,83.317665 53.196994,83.271671 53.155645,83.156687 53.128056,83.110693 53.100449,82.972712 53.059007,82.880724 53.003687,82.788737 52.989846,82.719746 53.017524,82.673752 53.045183,82.696749 53.114255,82.627758 53.210769,82.604762 53.224539,82.581765 53.265822,82.420787 53.361995,82.420787 53.389434,82.39779 53.389434,82.351796 53.457952))","code":"barnaul","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"4","name":"Барнаул","time_zone":{"name":"Asia/Barnaul","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((47.695511 30.564505,47.741505 30.584304,47.856489 30.524893,47.856489 30.465446,47.810495 30.425794,47.764502 30.445622,47.695511 30.564505))","code":"basra","country_code":"iq","domain":"iq","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":false},"id":"243","name":"Басра","time_zone":{"name":"Asia/Baghdad","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((50.294157 25.885932,50.294157 26.03067,50.317154 26.257754,50.340151 26.360827,50.386145 26.402031,50.386145 26.484394,50.409142 26.546128,50.478132 26.566699,50.501129 26.648944,50.616114 26.710589,50.777092 26.648944,50.823086 26.566699,50.823086 26.484394,50.869079 26.44322,50.93807 26.298994,50.93807 26.257754,50.915073 26.237128,50.915073 26.07199,50.846082 26.010004,50.823086 25.885932,50.869079 25.76173,50.846082 25.658129,50.823086 25.637398,50.800089 25.575183,50.731098 25.575183,50.57012 25.595925,50.547123 25.595925,50.409142 25.7203,50.340151 25.865241,50.294157 25.885932))","code":"bahrain","country_code":"bh","domain":"bh","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true},"id":"233","name":"Бахрейн","time_zone":{"name":"Asia/Bahrain","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((36.358053 50.630318,36.358053 50.67406,36.496035 50.703199,36.611019 50.688632,36.749 50.717761,36.932975 50.688632,36.932975 50.659484,36.886982 50.615729,36.840988 50.615729,36.726003 50.528096,36.68001 50.498848,36.565025 50.484218,36.427044 50.498848,36.427044 50.528096,36.450041 50.542712,36.38105 50.615729,36.358053 50.630318))","code":"belgorod","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"46","name":"Белгород","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((58.205081 53.907408,58.205081 53.961562,58.228078 54.002132,58.458047 54.015646,58.527037 54.002132,58.527037 53.920953,58.458047 53.907408,58.274072 53.893859,58.205081 53.907408))","code":"beloretsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":false,"road_network":false,"truck_graph":true},"id":"246","name":"Белорецк","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((84.467508 51.981605,84.513502 52.009924,84.536499 52.052369,84.513502 52.066509,84.490505 52.1089,84.559496 52.1089,84.559496 52.16536,84.513502 52.221748,84.513502 52.263992,84.559496 52.292132,84.605489 52.362405,84.605489 52.516612,84.67448 52.558575,84.720474 52.600498,84.858455 52.614463,84.881452 52.628424,84.950442 52.628424,85.088424 52.67028,85.134417 52.67028,85.157414 52.628424,85.249402 52.628424,85.295396 52.656332,85.364386 52.656332,85.433377 52.586528,85.479371 52.502615,85.571358 52.460599,85.870317 52.446585,86.008299 52.306195,86.238267 52.16536,86.238267 52.038225,86.21527 52.024077,86.100286 52.080644,85.939308 52.094774,85.916311 52.123022,85.77833 52.1089,85.709339 52.094774,85.686342 52.052369,85.594355 51.981605,85.571358 51.967438,85.548361 51.910728,85.41038 51.882346,85.157414 51.868148,85.134417 51.882346,84.973439 51.868148,84.927446 51.839739,84.858455 51.853946,84.766468 51.896539,84.651483 51.882346,84.605489 51.896539,84.559496 51.924912,84.490505 51.939092,84.467508 51.981605))","code":"biysk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"20","name":"Бийск","time_zone":{"name":"Asia/Barnaul","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((132.806932 48.725902,132.829928 48.862248,132.875922 48.892497,133.105891 48.756233,133.082894 48.710729,133.013903 48.710729,132.806932 48.725902))","code":"birobidzhan","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"truck_graph":true},"id":"157","name":"Биробиджан","time_zone":{"name":"Asia/Vladivostok","offset":600},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((70.876357 42.306747,70.876357 42.340753,70.945348 42.391727,70.991342 42.49355,71.060332 42.49355,71.037335 42.5444,71.014338 42.5444,71.014338 42.595208,71.15232 42.595208,71.175317 42.645975,71.267304 42.7136,71.267304 42.764271,71.336295 42.764271,71.428282 42.798028,71.497273 42.798028,71.612257 42.781152,71.704245 42.8149,71.865223 42.831767,72.003204 42.781152,72.049198 42.781152,72.118188 42.747385,72.279166 42.764271,72.348157 42.747385,72.509135 42.679797,72.624119 42.679797,72.716107 42.645975,72.854088 42.561341,72.877085 42.5444,73.084057 42.5444,73.107054 42.527455,73.222038 42.527455,73.291029 42.510505,73.337022 42.425686,73.498001 42.425686,73.498001 42.459627,73.42901 42.5444,73.475004 42.730495,73.520997 42.798028,73.520997 42.916033,73.543994 42.932873,73.566991 43.033813,73.612985 43.033813,73.635982 43.050621,73.704972 43.067423,73.819957 43.117804,73.888947 43.117804,73.957938 43.151368,73.957938 43.201679,74.095919 43.184913,74.16491 43.201679,74.2339 43.251949,74.302891 43.235197,74.463869 43.151368,74.578854 43.134588,74.716835 43.000185,74.854816 43.000185,74.9698 42.949708,75.130778 42.899189,75.130778 42.882341,75.360747 42.848629,75.452735 42.848629,75.475732 42.831767,75.7057 42.8149,75.774691 42.831767,75.797688 42.932873,75.912672 42.949708,76.00466 42.932873,76.027656 42.916033,76.188635 42.932873,76.211631 42.916033,76.280622 42.916033,76.349613 42.865487,76.418603 42.865487,76.533588 42.916033,76.740559 42.916033,76.763556 42.949708,76.993525 42.983364,77.016522 42.966538,77.131506 42.966538,77.246491 42.916033,77.568447 42.932873,77.591444 42.916033,77.660434 42.916033,78.005387 42.865487,78.258353 42.865487,78.511319 42.882341,78.695293 42.8149,78.810278 42.8149,78.902265 42.781152,79.132234 42.781152,79.155231 42.798028,79.178228 42.747385,79.178228 42.679797,79.339206 42.595208,79.408197 42.5444,79.431193 42.5444,79.45419 42.49355,79.546178 42.459627,79.707156 42.476591,79.799143 42.442659,79.937125 42.442659,80.006115 42.357749,80.098103 42.323752,80.167093 42.221653,80.144096 42.136444,80.213087 42.085263,80.213087 42.034041,80.075106 42.034041,80.006115 42.05112,79.983118 42.034041,79.868134 42.034041,79.776146 41.897247,79.661162 41.897247,79.592171 41.845874,79.431193 41.845874,79.316209 41.794459,79.224222 41.725842,79.155231 41.725842,79.132234 41.708677,79.063243 41.691506,79.040247 41.674331,78.971256 41.657152,78.856272 41.571186,78.764284 41.553979,78.695293 41.536767,78.672297 41.485105,78.557312 41.467875,78.534315 41.450641,78.373337 41.39891,78.212359 41.39891,78.143369 41.364399,78.143369 41.278044,78.028384 41.191574,77.936397 41.191574,77.798416 41.122316,77.798416 41.03564,77.660434 41.000938,77.522453 41.000938,77.361475 41.03564,77.338478 41.018291,77.154503 41.018291,77.108509 41.052984,76.970528 41.052984,76.740559 40.931478,76.717563 40.809749,76.648572 40.75751,76.648572 40.670355,76.625575 40.618007,76.556584 40.548146,76.533588 40.530669,76.533588 40.460717,76.418603 40.373174,76.349613 40.373174,76.303619 40.408205,76.234628 40.408205,76.188635 40.373174,76.096647 40.373174,75.935669 40.355652,75.935669 40.320593,75.682703 40.303058,75.682703 40.373174,75.7057 40.460717,75.63671 40.530669,75.613713 40.548146,75.613713 40.65291,75.498728 40.635461,75.245763 40.443217,75.130778 40.460717,75.107782 40.443217,74.9698 40.460717,74.90081 40.513188,74.693838 40.513188,74.60185 40.548146,74.578854 40.565618,74.555857 40.618007,74.417875 40.670355,74.371882 40.670355,74.187907 40.844551,74.049926 40.94885,74.072922 41.070324,73.911944 41.191574,73.911944 41.260759,73.957938 41.467875,73.934941 41.485105,73.934941 41.622779,73.911944 41.639968,73.888947 41.725842,73.957938 41.743003,73.957938 41.811602,73.911944 41.845874,73.750966 41.863003,73.773963 41.948579,73.750966 41.99987,73.658979 41.99987,73.360019 42.016958,73.314026 42.085263,73.199041 42.119388,73.038063 42.119388,73.015066 42.136444,72.946076 42.119388,72.877085 42.068194,72.808094 42.05112,72.69311 42.119388,72.670113 42.136444,72.463141 42.153495,72.348157 42.20462,72.302163 42.20462,72.279166 42.221653,72.210176 42.20462,72.187179 42.119388,72.164182 42.068194,72.095191 42.068194,71.88822 42.136444,71.704245 42.170541,71.704245 42.187583,71.58926 42.20462,71.428282 42.187583,71.405285 42.20462,71.244307 42.20462,71.175317 42.221653,71.129323 42.255704,71.060332 42.272723,70.991342 42.238681,70.945348 42.238681,70.876357 42.306747))","code":"bishkek","country_code":"kg","domain":"kg","flags":{"2gis_reviews":true,"flamp":false,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"112","name":"Бишкек","time_zone":{"name":"Asia/Bishkek","offset":360},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((127.264686 50.469583,127.310679 50.542712,127.333676 50.557325,127.333676 50.615729,127.310679 50.615729,127.310679 50.630318,127.333676 50.644903,127.356673 50.688632,127.37967 50.703199,127.448661 50.790506,127.494654 50.819572,127.471657 50.892159,127.517651 50.935657,127.517651 51.008062,127.563645 51.036993,127.563645 51.123677,127.678629 51.166958,127.770617 51.181376,127.839607 51.166958,127.931595 51.19579,127.931595 51.310935,128.000586 51.382755,128.023582 51.44013,128.092573 51.46879,128.253551 51.483114,128.345539 51.526057,128.391532 51.497433,128.391532 51.44013,128.460523 51.397106,128.48352 51.296558,128.506517 51.296558,128.529514 51.19579,128.575507 51.152536,128.575507 51.065906,128.621501 50.99359,128.667495 50.964632,128.667495 50.848621,128.529514 50.819572,128.414529 50.775966,128.299545 50.67406,128.18456 50.67406,128.138567 50.630318,128.138567 50.615729,128.11557 50.615729,128.11557 50.601134,128.069576 50.601134,128.000586 50.586536,128.000586 50.542712,128.069576 50.484218,128.000586 50.425651,127.885601 50.29361,127.770617 50.264217,127.770617 50.234807,127.678629 50.205378,127.586642 50.205378,127.540648 50.234807,127.425664 50.249514,127.402667 50.264217,127.333676 50.278916,127.310679 50.35234,127.333676 50.425651,127.264686 50.469583))","code":"blagoveshensk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"52","name":"Благовещенск","time_zone":{"name":"Asia/Yakutsk","offset":540},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((101.071249 55.967759,101.071249 56.224312,101.094246 56.491856,101.163237 56.50455,101.50819 56.491856,101.830146 56.491856,102.037118 56.479159,102.060115 56.44104,102.037118 56.249873,102.037118 56.134713,102.014121 55.967759,101.991124 55.929128,101.600177 55.942009,101.163237 55.942009,101.071249 55.967759))","code":"bratsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"51","name":"Братск","time_zone":{"name":"Asia/Irkutsk","offset":480},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((34.10436 53.155645,34.10436 53.293322,34.127357 53.307066,34.150354 53.403146,34.173351 53.444257,34.242341 53.444257,34.357326 53.485328,34.47231 53.471642,34.564298 53.375717,34.610291 53.252065,34.610291 53.183216,34.403319 53.141852,34.334329 53.169432,34.265338 53.155645,34.242341 53.141852,34.173351 53.128056,34.10436 53.155645))","code":"bryansk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"62","name":"Брянск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((31.068773 58.481344,31.114767 58.50538,31.137764 58.637286,31.206754 58.685128,31.344736 58.709025,31.505714 58.697079,31.505714 58.673174,31.528711 58.61334,31.620698 58.565399,31.620698 58.517392,31.597701 58.517392,31.551707 58.493364,31.436723 58.457292,31.367732 58.421182,31.275745 58.421182,31.252748 58.457292,31.09177 58.445259,31.068773 58.481344))","code":"v_novgorod","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"truck_graph":true},"id":"77","name":"Великий Новгород","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((76.142641 55.514667,76.142641 55.553709,76.211631 55.592713,76.211631 55.696535,76.188635 55.761284,76.234628 55.851751,76.372609 55.877561,76.372609 55.903353,76.395606 56.070585,76.349613 56.096249,76.349613 56.147525,76.280622 56.160334,76.211631 56.211525,76.211631 56.224312,76.280622 56.224312,76.326616 56.275417,76.395606 56.275417,76.4416 56.224312,76.533588 56.224312,76.625575 56.275417,76.717563 56.275417,76.786553 56.237095,76.924534 56.237095,76.993525 56.224312,77.223494 56.249873,77.200497 56.313702,77.1775 56.351948,77.246491 56.390156,77.292484 56.390156,77.292484 56.351948,77.315481 56.313702,77.430466 56.300945,77.568447 56.326455,77.660434 56.313702,77.706428 56.275417,77.706428 56.262647,77.637437 56.198733,77.660434 56.160334,77.729425 56.147525,77.798416 56.173138,77.867406 56.173138,77.867406 56.160334,77.752422 56.096249,77.637437 56.083419,77.568447 56.019206,77.499456 56.019206,77.430466 56.006351,77.430466 55.967759,77.522453 55.877561,77.54545 55.761284,77.499456 55.735397,77.499456 55.696535,77.430466 55.605706,77.407469 55.592713,77.154503 55.605706,77.085513 55.566715,76.970528 55.540699,76.832547 55.566715,76.763556 55.553709,76.694566 55.488617,76.602578 55.488617,76.602578 55.514667,76.418603 55.514667,76.395606 55.553709,76.303619 55.553709,76.280622 55.514667,76.142641 55.514667))","code":"vengerovo","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":false,"truck_graph":true},"id":"178","name":"Венгерово","time_zone":{"name":"Asia/Novosibirsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((131.381126 43.469306,131.404122 43.485993,131.565101 43.536028,131.634091 43.569362,131.703082 43.652615,131.841063 43.652615,131.910054 43.669252,131.979044 43.652615,132.048035 43.602677,132.346994 43.502676,132.369991 43.452614,132.369991 43.40251,132.255007 43.084221,132.117025 42.916033,131.956047 42.831767,131.818066 42.798028,131.680085 42.781152,131.565101 42.831767,131.588097 43.000185,131.473113 43.151368,131.404122 43.385799,131.381126 43.469306))","code":"vladivostok","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"25","name":"Владивосток","time_zone":{"name":"Asia/Vladivostok","offset":600},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((44.54494 42.747385,44.567937 42.882341,44.61393 42.983364,44.567937 43.017001,44.567937 43.067423,44.636927 43.117804,44.705918 43.101015,44.751911 43.000185,44.705918 42.848629,44.682921 42.798028,44.682921 42.730495,44.567937 42.730495,44.54494 42.747385))","code":"vladikavkaz","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"truck_graph":true},"id":"114","name":"Владикавказ","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((40.152537 56.070585,40.175534 56.211525,40.175534 56.313702,40.198531 56.453751,40.267522 56.466457,40.704462 56.466457,40.727459 56.428326,40.704462 56.390156,40.681465 56.198733,40.704462 56.109074,40.658468 56.083419,40.635472 56.019206,40.474493 56.019206,40.175534 56.032057,40.152537 56.070585))","code":"vladimir","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"59","name":"Владимир","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((43.87803 48.604394,43.947021 48.710729,43.924024 48.725902,43.901027 48.771392,43.924024 48.81684,44.062005 48.862248,44.085002 48.922727,44.199987 48.907614,44.291974 48.922727,44.314971 48.968039,44.360965 48.968039,44.567937 48.95294,44.590933 48.968039,44.61393 48.95294,44.682921 48.95294,44.866896 48.922727,44.935886 48.877375,45.050871 48.831981,45.073868 48.786546,45.004877 48.74107,44.98188 48.695552,45.027874 48.573971,44.98188 48.467348,45.027874 48.421583,45.027874 48.39105,44.958883 48.284042,44.728915 48.284042,44.61393 48.268736,44.590933 48.253426,44.360965 48.32993,44.24598 48.253426,44.17699 48.253426,44.062005 48.299342,43.970018 48.360499,43.993015 48.467348,43.970018 48.497834,43.901027 48.54353,43.87803 48.604394))","code":"volgograd","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"33","name":"Волгоград","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((42.015284 47.668251,42.038281 47.683735,42.107271 47.683735,42.130268 47.668251,42.176262 47.62177,42.383234 47.62177,42.383234 47.575249,42.314243 47.559732,42.314243 47.513155,42.291246 47.466537,42.130268 47.482081,42.061278 47.513155,42.015284 47.668251))","code":"volgodonsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"truck_graph":true},"id":"122","name":"Волгодонск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((37.668875 59.218851,37.78386 59.218851,37.78386 59.277644,37.875847 59.336337,38.036825 59.336337,38.059822 59.348063,38.2208 59.336337,38.335784 59.301133,38.427772 59.312872,38.58875 59.301133,38.611747 59.289391,38.841716 59.289391,39.048687 59.301133,39.232662 59.324606,39.301653 59.336337,39.370644 59.324606,39.462631 59.359785,39.531622 59.348063,39.554619 59.336337,39.6926 59.348063,39.784587 59.394928,39.945565 59.394928,39.991559 59.371503,40.083547 59.359785,40.12954 59.383218,40.244525 59.383218,40.221528 59.277644,40.198531 59.24238,40.313515 59.183526,40.290518 59.12457,40.244525 59.100959,40.221528 59.065512,40.152537 59.030028,40.037553 59.018192,39.945565 59.065512,39.669603 59.04186,39.209666 59.065512,38.818719 59.065512,38.795722 59.077332,38.58875 59.112766,38.358781 59.100959,38.266794 59.077332,37.875847 59.006352,37.714869 59.030028,37.691872 59.065512,37.668875 59.218851))","code":"vologda","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"truck_graph":true},"id":"78","name":"Вологда","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((38.9567 51.497433,39.002694 51.654644,38.9567 51.711677,39.025691 51.811313,39.025691 51.868148,39.048687 51.910728,39.163672 51.910728,39.255659 51.939092,39.39364 51.910728,39.508625 51.910728,39.531622 51.896539,39.669603 51.882346,39.669603 51.839739,39.623609 51.782868,39.600612 51.56896,39.577615 51.56896,39.600612 51.483114,39.531622 51.46879,39.278656 51.483114,39.094681 51.483114,39.048687 51.454462,38.979697 51.454462,38.9567 51.497433))","code":"voronezh","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"31","name":"Воронеж","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((45.34983 43.084221,45.34983 43.134588,45.418821 43.134588,45.579799 43.285439,45.579799 43.318911,45.487811 43.385799,45.579799 43.419216,45.71778 43.419216,45.740777 43.40251,45.855761 43.369084,45.970746 43.369084,45.993743 43.385799,46.039736 43.452614,46.338696 43.435917,46.338696 43.40251,46.407686 43.302177,46.407686 43.201679,46.200714 43.117804,46.177718 43.067423,46.062733 43.084221,45.901755 43.000185,45.671786 42.966538,45.648789 42.983364,45.579799 43.000185,45.533805 42.966538,45.464815 42.949708,45.395824 42.983364,45.395824 43.050621,45.34983 43.084221))","code":"grozny","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"truck_graph":true},"id":"115","name":"Грозный","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((40.911434 17.366415,40.911434 17.410307,41.210393 17.519991,41.279384 17.54192,41.96929 17.78296,42.038281 17.848643,42.084274 17.9143,42.084274 18.045543,42.222256 18.045543,42.245253 17.979934,42.245253 17.892417,42.360237 17.826751,42.406231 17.739159,42.498218 17.804857,42.70519 17.78296,42.728187 17.761061,42.866168 17.78296,42.889165 17.717254,42.981152 17.695347,43.004149 17.629608,43.07314 17.585769,43.165127 17.585769,43.188124 17.498059,43.257115 17.498059,43.280112 17.519991,43.303109 17.498059,43.280112 17.432249,43.280112 17.388363,43.303109 17.388363,43.349102 17.322513,43.234118 17.212711,43.188124 17.146799,43.257115 17.058879,43.234118 16.992912,43.211121 16.970918,43.188124 16.882916,43.257115 16.816887,43.280112 16.750835,43.257115 16.728813,43.257115 16.640698,43.188124 16.618663,43.165127 16.596626,43.119134 16.50845,43.004149 16.50845,42.958156 16.442293,42.935159 16.376112,42.820174 16.354047,42.797177 16.376112,42.544212 16.376112,42.429227 16.243684,42.475221 16.089071,42.383234 16.044874,42.130268 15.97856,42.061278 16.089071,41.992287 16.066974,41.808312 16.111166,41.785315 16.199521,41.716324 16.265761,41.60134 16.287836,41.486356 16.398175,41.394368 16.552543,41.325378 16.618663,41.23339 16.750835,41.210393 16.772855,41.210393 16.816887,41.1644 16.860909,40.911434 17.366415))","code":"jizan","country_code":"sa","domain":"sa","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true},"id":"227","name":"Джизан","time_zone":{"name":"Asia/Riyadh","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((49.006333 53.866747,49.006333 53.907408,49.02933 53.94803,49.167311 54.042661,49.236301 54.056163,49.236301 54.09664,49.167311 54.164014,49.09832 54.177476,49.09832 54.204386,49.121317 54.204386,49.144314 54.217835,49.144314 54.258154,49.167311 54.298434,49.236301 54.298434,49.259298 54.338675,49.328289 54.35208,49.604251 54.311852,49.627248 54.271585,49.742233 54.204386,49.765229 54.204386,49.788226 54.190933,49.880214 54.164014,49.903211 54.150548,49.903211 54.083152,49.811223 53.920953,49.811223 53.880305,49.788226 53.880305,49.719236 53.839617,49.627248 53.839617,49.604251 53.826046,49.581254 53.839617,49.351286 53.866747,49.328289 53.853184,49.259298 53.839617,49.213305 53.866747,49.006333 53.866747))","code":"dimitrovgrad","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"124","name":"Димитровград","time_zone":{"name":"Europe/Ulyanovsk","offset":240},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((78.879268 54.459161,78.879268 54.485888,79.01725 54.485888,79.063243 54.552628,79.08624 54.565963,79.08624 54.645881,79.132234 54.645881,79.132234 54.605942,79.201225 54.565963,79.431193 54.645881,79.45419 54.659186,79.569175 54.699073,79.569175 54.738921,79.477187 54.738921,79.431193 54.71236,79.362203 54.725643,79.293212 54.77873,79.316209 54.805248,79.431193 54.805248,79.546178 54.831748,79.569175 54.85823,79.661162 54.85823,79.707156 54.884696,79.776146 54.871465,79.868134 54.8185,79.960121 54.8185,80.144096 54.844991,80.167093 54.805248,80.167093 54.632572,80.213087 54.552628,80.351068 54.552628,80.397062 54.512597,80.397062 54.459161,80.328071 54.445791,80.213087 54.378876,80.075106 54.378876,80.029112 54.338675,80.029112 54.258154,79.914128 54.231279,79.891131 54.204386,79.477187 54.204386,79.45419 54.244719,79.431193 54.258154,79.431193 54.311852,79.362203 54.325266,79.247218 54.311852,79.224222 54.271585,79.178228 54.271585,79.109237 54.285012,78.948259 54.35208,78.948259 54.419038,78.879268 54.459161))","code":"dovolnoe","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":false,"truck_graph":true},"id":"179","name":"Довольное","time_zone":{"name":"Asia/Novosibirsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((59.699878 56.820507,59.722875 56.883381,59.722875 56.971227,59.745872 57.008812,59.814862 57.008812,59.860856 57.033848,59.998837 57.046359,60.113822 57.008812,60.2748 56.996288,60.389784 57.058866,60.64275 57.046359,60.665746 57.033848,60.757734 57.058866,60.895715 57.021332,60.941709 57.021332,60.964706 56.95869,60.987703 56.946149,60.964706 56.870815,60.987703 56.83309,61.125684 56.83309,61.263665 56.870815,61.424643 56.870815,61.516631 56.795328,61.493634 56.732306,61.401646 56.707067,61.217671 56.707067,61.125684 56.669178,61.102687 56.631251,61.033696 56.593285,61.033696 56.542605,61.125684 56.491856,61.125684 56.44104,61.148681 56.351948,61.125684 56.351948,61.102687 56.313702,61.148681 56.288183,61.171678 56.198733,61.125684 56.198733,61.056693 56.185938,61.033696 56.198733,60.918712 56.198733,60.895715 56.211525,60.734737 56.237095,60.665746 56.249873,60.688743 56.275417,60.665746 56.313702,60.596756 56.313702,60.527765 56.224312,60.435778 56.224312,60.412781 56.237095,60.435778 56.275417,60.435778 56.339204,60.458775 56.351948,60.435778 56.390156,60.182812 56.390156,60.113822 56.415607,60.113822 56.453751,60.090825 56.466457,60.067828 56.555281,59.952843 56.593285,59.814862 56.593285,59.745872 56.6186,59.745872 56.719689,59.699878 56.820507))","code":"ekaterinburg","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":true,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"9","name":"Екатеринбург","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((38.427772 52.628424,38.450769 52.67028,38.519759 52.656332,38.58875 52.656332,38.611747 52.614463,38.58875 52.572554,38.519759 52.572554,38.427772 52.628424))","code":"elets","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"126","name":"Елец","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((67.518814 47.900033,67.541811 47.946266,67.702789 47.930859,67.794777 47.900033,67.794777 47.745627,67.77178 47.699215,67.679792 47.699215,67.541811 47.853759,67.518814 47.900033))","code":"zhezkazgan","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"truck_graph":true},"id":"242","name":"Жезказган","time_zone":{"name":"Asia/Almaty","offset":360},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((77.936397 54.605942,77.936397 54.672486,77.959394 54.685782,77.959394 54.738921,78.189362 54.8185,78.373337 54.85823,78.419331 54.911144,78.488322 54.924361,78.695293 55.003575,78.695293 55.016762,78.994253 55.003575,79.178228 54.924361,79.178228 54.871465,79.270215 54.844991,79.293212 54.805248,79.316209 54.805248,79.293212 54.77873,79.362203 54.725643,79.431193 54.71236,79.477187 54.738921,79.569175 54.738921,79.569175 54.699073,79.45419 54.659186,79.431193 54.645881,79.201225 54.565963,79.132234 54.605942,79.132234 54.645881,79.08624 54.645881,79.08624 54.565963,79.063243 54.552628,79.01725 54.485888,78.879268 54.485888,78.879268 54.459161,78.948259 54.419038,78.948259 54.35208,78.810278 54.338675,78.787281 54.325266,78.71829 54.311852,78.672297 54.285012,78.488322 54.298434,78.442328 54.298434,78.419331 54.285012,78.35034 54.271585,78.327344 54.271585,78.327344 54.298434,78.212359 54.338675,78.189362 54.378876,78.097375 54.432417,78.120372 54.525945,77.936397 54.605942))","code":"zdvinsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":false,"truck_graph":true},"id":"180","name":"Здвинск","time_zone":{"name":"Asia/Novosibirsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((40.79645 57.046359,40.842443 57.096363,40.934431 57.096363,41.141403 57.083868,41.210393 57.07137,41.210393 56.98376,41.187396 56.971227,41.187396 56.933604,41.210393 56.933604,41.210393 56.908501,41.095409 56.870815,40.934431 56.870815,40.86544 56.883381,40.819447 56.908501,40.79645 57.046359))","code":"ivanovo","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"65","name":"Иваново","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((52.915801 56.845669,52.938798 56.858244,52.938798 57.021332,52.984791 57.046359,52.984791 57.058866,53.076779 57.058866,53.467726 57.046359,53.58271 56.996288,53.766685 56.946149,53.789682 56.807919,53.789682 56.795328,53.766685 56.782732,53.766685 56.707067,53.812679 56.605944,53.835676 56.605944,53.835676 56.593285,53.904666 56.555281,54.180629 56.479159,54.203626 56.479159,54.226622 56.466457,54.433594 56.402883,54.479588 56.402883,54.594572 56.326455,54.732554 56.313702,54.732554 56.288183,54.68656 56.249873,54.548579 56.224312,54.479588 56.160334,54.387601 56.147525,54.387601 56.083419,54.341607 56.032057,54.226622 56.032057,54.157632 56.070585,54.088641 56.083419,53.973657 56.160334,53.789682 56.275417,53.398735 56.428326,53.237757 56.466457,53.099776 56.529924,53.076779 56.529924,53.053782 56.567953,53.030785 56.580621,53.007788 56.65654,52.984791 56.65654,52.984791 56.669178,52.938798 56.681812,52.938798 56.782732,52.915801 56.845669))","code":"izhevsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"41","name":"Ижевск","time_zone":{"name":"Europe/Samara","offset":240},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((103.554911 52.767788,103.554911 52.809511,103.623902 52.823409,103.715889 52.823409,103.738886 52.7817,103.761883 52.712096,103.830874 52.684223,103.899864 52.67028,103.945858 52.64238,104.198824 52.64238,104.290811 52.739951,104.451789 52.823409,104.543777 52.865079,104.842736 52.948297,105.118699 52.962151,105.302674 53.003687,105.532642 53.114255,105.601633 53.114255,105.877595 52.948297,105.946586 52.920575,105.969583 52.920575,105.969583 52.906708,106.038573 52.892836,106.06157 52.878959,106.291539 52.837304,106.42952 52.865079,107.027439 53.307066,107.119426 53.334539,107.119426 53.34827,107.188417 53.361995,107.280404 53.416854,107.349395 53.416854,107.418386 53.471642,107.556367 53.649216,107.579364 53.662845,107.671351 53.662845,107.786336 53.581007,108.016304 53.403146,108.085295 53.361995,108.085295 53.320805,108.016304 53.238304,107.418386 52.934438,107.004442 52.712096,106.521508 52.502615,106.176555 52.362405,105.99258 52.179463,105.969583 52.16536,105.969583 52.137139,105.946586 52.137139,105.831602 51.995766,105.578636 51.839739,105.371664 51.768639,105.302674 51.754405,105.279677 51.740167,105.118699 51.711677,105.095702 51.697426,104.796742 51.654644,104.635764 51.640375,104.589771 51.611822,104.635764 51.46879,104.612767 51.425793,104.52078 51.44013,104.244817 51.46879,104.129833 51.483114,103.899864 51.554663,103.876868 51.56896,103.715889 51.583252,103.600905 51.597539,103.600905 51.654644,103.623902 51.668909,103.646899 51.740167,103.646899 51.882346,103.623902 52.348359,103.600905 52.474609,103.623902 52.488614,103.623902 52.64238,103.554911 52.767788))","code":"irkutsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"11","name":"Иркутск","time_zone":{"name":"Asia/Irkutsk","offset":480},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((69.427554 56.070585,69.427554 56.096249,69.450551 56.134713,69.542539 56.147525,69.565536 56.109074,69.542539 56.070585,69.427554 56.070585))","code":"ishim","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"public_transport":true,"road_network":false},"id":"205","name":"Ишим","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((47.580527 56.529924,47.580527 56.719689,47.603524 56.757527,47.971473 56.757527,48.086458 56.744919,48.155448 56.732306,48.132452 56.542605,48.109455 56.50455,47.902483 56.517239,47.649517 56.517239,47.580527 56.529924))","code":"yoshkarola","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"70","name":"Йошкар-Ола","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((40.911434 43.435917,40.980425 43.485993,41.072412 43.586022,41.348375 43.652615,41.463359 43.752367,41.53235 43.885111,41.60134 43.901683,41.923296 43.918251,42.061278 43.818776,42.153265 43.818776,42.383234 43.934814,42.452224 43.951372,42.452224 43.967926,42.498218 44.00102,42.498218 44.034095,42.590206 44.034095,42.613202 44.149714,42.567209 44.248635,42.590206 44.265106,42.613202 44.265106,42.774181 44.298034,42.889165 44.298034,42.912162 44.281572,43.027146 44.298034,43.234118 44.298034,43.303109 44.31449,43.395096 44.265106,43.533077 44.23216,43.556074 44.182706,43.533077 44.166212,43.533077 44.050626,43.51008 44.034095,43.533077 43.967926,43.602068 43.918251,43.602068 43.851952,43.464087 43.851952,43.44109 43.80218,43.579071 43.735753,43.602068 43.685884,43.579071 43.635974,43.464087 43.602677,43.280112 43.586022,43.165127 43.502676,43.050143 43.452614,43.050143 43.40251,42.935159 43.369084,42.70519 43.235197,42.590206 43.151368,42.498218 43.168143,42.406231 43.235197,42.314243 43.201679,42.199259 43.21844,42.176262 43.201679,42.038281 43.184913,41.923296 43.201679,41.900299 43.21844,41.808312 43.184913,41.716324 43.21844,41.693328 43.201679,41.53235 43.235197,41.486356 43.268696,41.371371 43.33564,41.302381 43.318911,41.210393 43.352364,41.210393 43.369084,41.095409 43.385799,40.934431 43.40251,40.911434 43.435917))","code":"minvody","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"89","name":"КавМинВоды","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((48.224439 55.890459,48.224439 55.929128,48.247436 55.942009,48.270433 55.980627,48.569392 55.967759,48.615386 55.993491,48.73037 55.993491,48.799361 56.006351,48.822358 56.019206,49.075323 56.006351,49.236301 55.993491,49.236301 56.006351,49.328289 56.019206,49.351286 56.006351,49.535261 56.006351,49.581254 55.954886,49.581254 55.916243,49.604251 55.877561,49.558258 55.825925,49.581254 55.735397,49.604251 55.696535,49.696239 55.696535,49.696239 55.631679,49.673242 55.566715,49.627248 55.527685,49.535261 55.527685,49.420276 55.566715,49.328289 55.553709,49.167311 55.462549,49.075323 55.462549,49.052326 55.501644,48.960339 55.579716,48.822358 55.579716,48.753367 55.540699,48.684376 55.540699,48.684376 55.566715,48.500402 55.566715,48.454408 55.540699,48.385417 55.540699,48.316427 55.553709,48.316427 55.696535,48.270433 55.722447,48.29343 55.825925,48.224439 55.890459))","code":"kazan","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":true,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"21","name":"Казань","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((19.524344 54.71236,19.547341 54.765465,19.570337 54.77873,19.570337 54.85823,19.547341 54.871465,19.593334 54.990384,19.685322 55.095794,19.754312 55.135251,19.961284 55.17467,20.21425 55.17467,20.375228 55.1878,20.421222 55.214049,20.559203 55.331954,20.65119 55.384244,20.720181 55.384244,20.720181 55.371178,21.01914 55.279595,21.134125 55.266495,21.134125 54.897922,21.180118 54.871465,21.180118 54.77873,21.134125 54.725643,21.157122 54.632572,21.180118 54.565963,21.157122 54.552628,20.835165 54.552628,20.789172 54.525945,20.674187 54.525945,20.490212 54.499245,20.375228 54.512597,20.352231 54.525945,20.168256 54.512597,20.145259 54.525945,19.984281 54.539289,19.823303 54.59262,19.547341 54.71236,19.524344 54.71236))","code":"kaliningrad","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"40","name":"Калининград","time_zone":{"name":"Europe/Kaliningrad","offset":120},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((35.898116 54.725643,35.94411 54.765465,36.105088 54.765465,36.151082 54.791991,36.220072 54.844991,36.197075 54.911144,36.243069 54.950783,36.38105 54.977188,36.404047 55.016762,36.450041 55.043123,36.542028 55.148395,36.657013 55.161535,36.703007 55.095794,36.634016 55.029945,36.611019 55.016762,36.611019 54.924361,36.542028 54.911144,36.542028 54.897922,36.473038 54.831748,36.496035 54.791991,36.473038 54.699073,36.473038 54.36548,36.427044 54.325266,36.31206 54.325266,36.151082 54.311852,36.128085 54.325266,35.990104 54.325266,35.921113 54.338675,35.921113 54.392268,35.898116 54.725643))","code":"kaluga","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"61","name":"Калуга","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((61.539628 56.428326,61.585621 56.466457,61.723602 56.491856,61.723602 56.529924,61.746599 56.567953,61.930574 56.567953,62.18354 56.580621,62.252531 56.567953,62.252531 56.313702,62.229534 56.275417,61.723602 56.275417,61.700606 56.313702,61.608618 56.313702,61.608618 56.326455,61.562624 56.364688,61.539628 56.428326))","code":"k_uralskiy","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"truck_graph":true},"id":"109","name":"Каменск-Уральский","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((45.303836 50.057963,45.303836 50.102235,45.372827 50.146466,45.487811 50.131727,45.464815 50.057963,45.441818 50.057963,45.418821 50.013649,45.326833 50.013649,45.303836 50.057963))","code":"kamyshin","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"truck_graph":true},"id":"127","name":"Камышин","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((72.670113 49.969295,72.670113 49.998869,72.831091 50.072725,72.831091 50.131727,72.900082 50.190657,73.015066 50.190657,73.314026 50.146466,73.383016 50.102235,73.406013 50.028425,73.406013 49.821152,73.383016 49.687435,73.222038 49.64278,73.015066 49.65767,72.923079 49.672555,72.877085 49.702311,72.785098 49.776621,72.762101 49.850817,72.670113 49.969295))","code":"karaganda","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"84","name":"Караганда","time_zone":{"name":"Asia/Almaty","offset":360},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((77.1775 53.662845,77.1775 53.676469,77.246491 53.703705,77.361475 53.717316,77.384472 53.703705,77.499456 53.717316,77.54545 53.785305,77.660434 53.785305,77.683431 53.81247,77.798416 53.826046,77.867406 53.798889,77.9134 53.798889,77.9134 53.853184,77.959394 53.880305,77.98239 53.920953,78.074378 53.920953,78.166365 53.94803,78.166365 54.015646,78.235356 54.029156,78.258353 54.042661,78.235356 54.056163,78.235356 54.09664,78.35034 54.09664,78.327344 54.164014,78.304347 54.177476,78.304347 54.204386,78.327344 54.217835,78.35034 54.271585,78.419331 54.285012,78.442328 54.298434,78.488322 54.298434,78.488322 54.285012,78.580309 54.204386,78.603306 54.204386,78.6493 54.110123,78.580309 54.083152,78.557312 54.069659,78.557312 54.002132,78.603306 53.97509,78.580309 53.907408,78.557312 53.893859,78.580309 53.826046,78.580309 53.798889,78.672297 53.676469,78.672297 53.649216,78.626303 53.621946,78.6493 53.553692,78.626303 53.512687,78.465325 53.512687,78.373337 53.485328,78.28135 53.485328,78.235356 53.540028,78.235356 53.581007,78.212359 53.621946,78.143369 53.581007,77.98239 53.581007,77.9134 53.553692,77.936397 53.49901,78.051381 53.485328,78.051381 53.444257,77.936397 53.444257,77.936397 53.375717,77.9134 53.361995,77.890403 53.307066,77.821412 53.320805,77.798416 53.334539,77.499456 53.485328,77.384472 53.553692,77.200497 53.649216,77.1775 53.662845))","code":"karasuk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"public_transport":false,"road_network":false,"truck_graph":true},"id":"181","name":"Карасук","time_zone":{"name":"Asia/Novosibirsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((79.569175 54.85823,79.592171 54.937574,79.569175 54.950783,79.569175 54.990384,79.730153 55.003575,79.82214 55.016762,79.914128 55.082633,79.914128 55.122103,79.845137 55.122103,79.82214 55.135251,79.868134 55.214049,79.868134 55.292691,80.006115 55.331954,80.006115 55.371178,80.213087 55.566715,80.328071 55.566715,80.374065 55.540699,80.489049 55.553709,80.650028 55.592713,80.742015 55.618695,80.856999 55.605706,81.063971 55.644659,81.086968 55.644659,81.086968 55.501644,81.132962 55.475585,81.132962 55.436465,80.971984 55.410363,80.948987 55.371178,80.92599 55.358108,80.856999 55.279595,80.765012 55.279595,80.604034 55.24028,80.604034 55.200927,80.581037 55.029945,80.535043 54.977188,80.466053 54.937574,80.512046 54.897922,80.581037 54.897922,80.604034 54.844991,80.535043 54.752195,80.489049 54.738921,80.512046 54.672486,80.673024 54.605942,80.673024 54.539289,80.581037 54.539289,80.512046 54.525945,80.512046 54.472527,80.466053 54.445791,80.397062 54.459161,80.397062 54.512597,80.351068 54.552628,80.213087 54.552628,80.167093 54.632572,80.167093 54.805248,80.144096 54.844991,79.960121 54.8185,79.868134 54.8185,79.776146 54.871465,79.707156 54.884696,79.661162 54.85823,79.569175 54.85823))","code":"kargat","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"public_transport":false,"road_network":false,"truck_graph":true},"id":"182","name":"Каргат","time_zone":{"name":"Asia/Novosibirsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((50.57012 25.512936,50.57012 25.595925,50.731098 25.575183,50.800089 25.575183,50.823086 25.637398,50.846082 25.658129,50.869079 25.76173,50.823086 25.885932,50.846082 26.010004,50.915073 26.07199,50.915073 26.237128,50.93807 26.257754,51.030057 26.298994,51.053054 26.360827,51.145042 26.402031,51.30602 26.402031,51.489995 26.319609,51.558985 26.237128,51.581982 26.175229,51.857945 26.07199,52.501857 25.885932,52.570848 25.865241,52.639838 25.76173,52.662835 25.69958,52.662835 25.616663,52.639838 25.595925,52.501857 25.097133,52.501857 25.076306,52.47886 25.013802,52.40987 25.013802,52.340879 24.99296,52.363876 24.867836,52.271888 24.8261,52.018923 24.763469,51.581982 24.659015,51.466998 24.638113,51.398007 24.617208,51.329017 24.512631,51.099048 24.470776,50.93807 24.533553,50.823086 24.742585,50.800089 24.888699,50.708101 24.930414,50.708101 25.03464,50.685104 25.055475,50.616114 25.42989,50.616114 25.47142,50.57012 25.512936))","code":"qatar","country_code":"qa","domain":"qa","flags":{"2gis_reviews":true,"flamp":false,"metro":true,"pedestrian_routing":true,"public_transport":true,"road_network":true},"id":"234","name":"Катар","time_zone":{"name":"Asia/Qatar","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((85.479371 55.462549,85.617352 55.618695,85.617352 55.657634,85.686342 55.670605,85.755333 55.657634,85.870317 55.657634,86.14628 55.709493,86.238267 55.761284,86.353252 55.748342,86.468236 55.592713,86.468236 55.475585,86.422242 55.318871,86.330255 55.292691,86.330255 55.24028,86.307258 55.200927,86.284261 55.214049,85.893314 55.214049,85.870317 55.200927,85.640349 55.214049,85.525364 55.25339,85.525364 55.318871,85.479371 55.462549))","code":"kemerovo","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"5","name":"Кемерово","time_zone":{"name":"Asia/Novokuznetsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((31.988648 35.065604,32.011645 35.122053,32.011645 35.159663,32.080635 35.272392,32.218617 35.328697,32.333601 35.328697,32.471582 35.384964,32.586567 35.40371,32.609563 35.422453,32.655557 35.422453,32.678554 35.516099,32.747545 35.572234,32.885526 35.62833,32.977513 35.62833,33.276473 35.572234,33.552435 35.572234,33.690416 35.62833,33.874391 35.665706,34.081363 35.759068,34.495307 35.908221,34.564298 35.926845,34.702279 35.926845,34.725276 35.908221,34.84026 35.852321,34.886254 35.703064,34.84026 35.590937,34.771269 35.478654,34.702279 35.459924,34.610291 35.384964,34.518304 35.328697,34.357326 35.253615,34.265338 35.159663,34.288335 35.14086,34.357326 35.009116,34.357326 34.914882,34.288335 34.801659,34.265338 34.782774,34.10436 34.726091,34.012373 34.744989,33.897388 34.726091,33.828398 34.707188,33.805401 34.650453,33.460448 34.517921,33.276473 34.480016,33.207482 34.385178,33.115495 34.347212,32.908523 34.347212,32.701551 34.423126,32.63256 34.423126,32.402592 34.498971,32.26461 34.555809,32.218617 34.59368,32.19562 34.59368,32.172623 34.650453,32.057639 34.820541,32.011645 34.971435,32.011645 35.046779,31.988648 35.065604))","code":"cyprus","country_code":"cy","domain":"com.cy","flags":{"2gis_reviews":true,"flamp":false,"gdpr":true,"has_net_booklet":true,"metro":false,"public_transport":true,"road_network":true},"id":"173","name":"Кипр","time_zone":{"name":"Europe/Nicosia","offset":180},"type":"region","zoom_level":{"max":19,"min":9}},{"bounds":"POLYGON((49.02933 58.385035,49.052326 58.445259,49.052326 58.5294,49.02933 58.756769,49.052326 58.792534,49.903211 58.792534,49.949204 58.732905,49.949204 58.601361,49.926208 58.589378,49.949204 58.445259,49.926208 58.409137,49.328289 58.409137,49.144314 58.385035,49.02933 58.385035))","code":"kirov","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"58","name":"Киров","time_zone":{"name":"Europe/Kirov","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((41.256387 56.339204,41.279384 56.402883,41.371371 56.402883,41.371371 56.364688,41.394368 56.351948,41.371371 56.300945,41.325378 56.300945,41.256387 56.339204))","code":"kovrov","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"truck_graph":true},"id":"129","name":"Ковров","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((74.371882 62.337097,74.394879 62.36911,74.555857 62.36911,74.60185 62.390433,74.716835 62.390433,74.762829 62.411741,74.854816 62.411741,74.831819 62.315736,74.785825 62.251561,74.716835 62.251561,74.60185 62.219423,74.53286 62.165783,74.463869 62.176518,74.417875 62.230139,74.417875 62.305049,74.371882 62.337097))","code":"kogalym","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"truck_graph":true},"id":"207","name":"Когалым","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((67.955755 53.334539,68.369698 53.430558,68.484683 53.416854,68.57667 53.389434,68.599667 53.389434,68.990614 53.320805,69.151592 53.334539,69.197586 53.389434,69.289573 53.389434,69.473548 53.361995,69.634526 53.375717,70.255442 53.252065,70.301435 53.252065,70.370426 53.224539,70.439417 53.224539,70.600395 53.183216,70.646389 53.183216,70.646389 53.169432,70.669385 53.169432,70.738376 53.155645,72.141185 52.753872,72.279166 52.544592,72.302163 52.530604,72.302163 52.474609,72.118188 52.362405,71.22131 51.868148,71.060332 51.768639,70.899354 51.725925,70.85336 51.740167,70.738376 51.882346,70.669385 51.981605,70.646389 51.995766,70.646389 52.024077,70.623392 52.038225,70.554401 52.123022,70.163454 52.614463,69.565536 52.823409,69.404558 52.892836,69.358564 52.920575,69.266576 52.920575,69.220583 52.892836,69.128595 52.892836,69.013611 52.906708,68.691654 52.851193,68.392695 52.837304,68.13973 52.823409,67.978751 53.059007,68.001748 53.169432,67.955755 53.334539))","code":"kokshetau","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"201","name":"Кокшетау","time_zone":{"name":"Asia/Almaty","offset":360},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((136.532425 50.703199,136.532425 50.761422,136.601415 50.761422,136.900375 50.717761,137.015359 50.717761,137.08435 50.703199,137.245328 50.717761,137.314318 50.630318,137.314318 50.615729,137.291322 50.542712,137.268325 50.528096,137.268325 50.39634,137.245328 50.29361,137.15334 50.190657,137.061353 50.161201,136.946368 50.175931,136.946368 50.190657,136.78539 50.190657,136.693403 50.220095,136.693403 50.308299,136.762393 50.381678,136.739397 50.484218,136.739397 50.630318,136.693403 50.630318,136.693403 50.659484,136.624412 50.67406,136.601415 50.688632,136.532425 50.703199))","code":"komsomolsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"94","name":"Комсомольск-на-Амуре","time_zone":{"name":"Asia/Vladivostok","offset":600},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((63.471365 53.169432,63.494362 53.265822,63.609346 53.307066,63.72433 53.293322,63.793321 53.279574,63.770324 53.196994,63.586349 53.08664,63.494362 53.08664,63.494362 53.155645,63.471365 53.169432))","code":"kostanay","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"203","name":"Костанай","time_zone":{"name":"Asia/Qostanay","offset":360},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((40.681465 57.752576,40.704462 57.8873,40.750456 57.936166,40.842443 57.936166,40.957428 57.923956,40.980425 57.936166,41.141403 57.923956,41.1644 57.8873,41.141403 57.850607,41.141403 57.777108,41.210393 57.764844,41.23339 57.752576,41.256387 57.691171,41.256387 57.641971,41.279384 57.641971,41.486356 57.555712,41.60134 57.543373,41.60134 57.493973,41.53235 57.45688,41.509353 57.469249,41.417365 57.469249,41.210393 57.481613,41.141403 57.481613,41.141403 57.50633,41.095409 57.531029,41.095409 57.617347,41.003421 57.666579,40.79645 57.678877,40.727459 57.691171,40.681465 57.752576))","code":"kostroma","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"34","name":"Кострома","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((79.868134 54.002132,79.914128 54.029156,79.937125 54.069659,79.868134 54.137078,79.891131 54.204386,79.914128 54.231279,80.029112 54.258154,80.029112 54.338675,80.075106 54.378876,80.213087 54.378876,80.328071 54.445791,80.397062 54.459161,80.466053 54.445791,80.512046 54.472527,80.512046 54.525945,80.581037 54.539289,80.673024 54.539289,80.673024 54.552628,80.788009 54.565963,80.902993 54.539289,80.92599 54.499245,81.040974 54.432417,80.994981 54.378876,80.971984 54.378876,80.834003 54.35208,80.834003 54.244719,80.742015 54.244719,80.696021 54.204386,80.673024 54.204386,80.673024 54.190933,80.55804 54.177476,80.535043 54.110123,80.374065 54.09664,80.351068 54.069659,80.236084 54.042661,80.19009 54.069659,80.075106 54.056163,80.075106 53.97509,79.937125 53.934494,79.891131 53.934494,79.868134 54.002132))","code":"kotchki","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":false,"truck_graph":true},"id":"183","name":"Кочки","time_zone":{"name":"Asia/Novosibirsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((38.565753 44.968984,38.58875 45.115228,38.657741 45.180105,38.680737 45.196313,38.657741 45.277282,38.703734 45.325808,38.841716 45.325808,38.864712 45.309637,39.094681 45.277282,39.163672 45.309637,39.232662 45.261097,39.32465 45.261097,39.39364 45.309637,39.462631 45.309637,39.623609 45.390445,39.646606 45.438875,39.899572 45.438875,40.014556 45.455009,40.06055 45.390445,40.06055 45.293462,40.12954 45.244908,40.106544 45.228714,40.106544 45.180105,40.083547 45.098997,39.968562 45.082761,39.784587 45.131454,39.669603 45.147675,39.623609 45.115228,39.508625 45.050277,39.485628 45.001515,39.600612 44.920153,39.623609 44.871281,39.554619 44.806053,39.600612 44.740751,39.554619 44.691727,39.485628 44.64266,39.462631 44.593552,39.370644 44.560791,39.370644 44.511614,39.416637 44.511614,39.416637 44.462395,39.370644 44.462395,39.278656 44.42956,39.255659 44.44598,39.094681 44.44598,39.025691 44.396706,38.9567 44.413135,38.9567 44.478806,38.818719 44.511614,38.795722 44.495212,38.680737 44.495212,38.657741 44.511614,38.634744 44.65902,38.657741 44.773411,38.634744 44.887576,38.565753 44.968984))","code":"krasnodar","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"23","name":"Краснодар","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((78.488322 54.285012,78.488322 54.298434,78.672297 54.285012,78.71829 54.311852,78.787281 54.325266,78.810278 54.338675,78.948259 54.35208,79.109237 54.285012,79.178228 54.271585,79.224222 54.271585,79.247218 54.311852,79.362203 54.325266,79.431193 54.311852,79.431193 54.258154,79.45419 54.244719,79.477187 54.204386,79.891131 54.204386,79.868134 54.137078,79.937125 54.069659,79.914128 54.029156,79.868134 54.002132,79.891131 53.934494,79.868134 53.920953,79.868134 53.826046,79.75315 53.826046,79.638165 53.81247,79.638165 53.771716,79.615168 53.730922,79.477187 53.690089,79.316209 53.703705,79.293212 53.690089,79.224222 53.676469,79.063243 53.690089,79.063243 53.662845,78.902265 53.676469,78.902265 53.662845,78.672297 53.649216,78.672297 53.676469,78.580309 53.798889,78.580309 53.826046,78.557312 53.893859,78.580309 53.907408,78.603306 53.97509,78.557312 54.002132,78.557312 54.069659,78.580309 54.083152,78.6493 54.110123,78.603306 54.204386,78.580309 54.204386,78.488322 54.285012))","code":"krasnozerskoe","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":false,"truck_graph":true},"id":"184","name":"Краснозёрское","time_zone":{"name":"Asia/Novosibirsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((90.170732 56.019206,90.216726 56.173138,90.193729 56.211525,90.193729 56.275417,90.170732 56.339204,90.285717 56.351948,90.469692 56.364688,90.584676 56.402883,90.653667 56.402883,90.906632 56.567953,90.99862 56.669178,91.136601 56.795328,91.43556 57.07137,91.504551 57.158773,91.596538 57.345373,91.73452 57.493973,91.73452 57.50633,91.757516 57.50633,91.780513 57.543373,91.895498 57.654277,92.056476 57.728026,92.079473 57.764844,91.964488 57.875073,91.941491 57.948372,91.918494 57.960574,91.849504 58.118823,91.872501 58.215858,91.826507 58.360916,91.918494 58.421182,92.033479 58.50538,92.102469 58.5294,92.217454 58.5294,92.378432 58.421182,92.470419 58.372978,92.677391 58.203743,92.999347 58.155242,93.183322 58.082366,93.252313 58.045872,93.252313 57.984966,93.229316 57.972772,93.252313 57.960574,93.252313 57.8873,93.27531 57.875073,93.321304 57.752576,93.321304 57.678877,93.367297 57.555712,93.321304 57.50633,93.298307 57.50633,93.27531 57.370182,93.298307 57.357779,93.459285 57.258411,93.482282 57.083868,93.413291 57.008812,93.413291 56.95869,93.551272 56.83309,93.64326 56.782732,93.64326 56.757527,93.758244 56.643897,93.804238 56.555281,94.057204 56.415607,94.172188 56.415607,94.195185 56.428326,94.333166 56.428326,95.48301 56.479159,95.804966 56.262647,95.850959 56.211525,95.850959 56.160334,95.597994 56.019206,95.253041 55.954886,95.069066 55.825925,94.74711 55.644659,94.770107 55.566715,94.74711 55.527685,94.563135 55.501644,94.494144 55.436465,94.287172 55.345033,94.287172 55.279595,94.195185 55.25339,94.195185 55.24028,94.172188 55.227167,94.103197 55.161535,94.103197 55.108951,94.057204 55.082633,94.034207 55.003575,93.965216 54.937574,93.827235 54.937574,93.71225 54.844991,93.620263 54.831748,93.620263 54.752195,93.551272 54.738921,93.482282 54.765465,93.482282 54.805248,93.3443 54.831748,93.321304 54.871465,93.229316 54.897922,93.229316 54.977188,93.160326 55.043123,93.137329 55.082633,93.137329 55.200927,92.976351 55.292691,92.838369 55.292691,92.309441 55.108951,91.43556 54.897922,90.952626 54.805248,90.929629 54.8185,90.929629 54.85823,90.860638 54.85823,90.768651 54.911144,90.515685 54.911144,90.538682 54.950783,90.653667 54.990384,90.860638 55.069467,90.975623 55.135251,91.021617 55.135251,91.136601 55.227167,91.297579 55.266495,91.665529 55.488617,91.849504 55.605706,91.872501 55.644659,91.872501 55.696535,91.849504 55.709493,91.780513 55.77422,91.665529 55.800081,91.481554 55.954886,91.182595 56.019206,91.021617 55.993491,90.584676 55.967759,90.469692 55.916243,90.400701 55.916243,90.354707 55.942009,90.170732 56.019206))","code":"krasnoyarsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"7","name":"Красноярск","time_zone":{"name":"Asia/Krasnoyarsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((32.172623 45.422736,32.241614 45.535609,32.356598 45.648256,32.402592 45.648256,32.609563 45.74463,32.724548 45.824815,32.793538 45.824815,33.184485 45.920885,33.529438 46.016789,33.575432 46.04872,33.621426 46.144402,33.621426 46.208098,33.828398 46.208098,33.989376 46.128466,34.10436 46.112526,34.196348 46.064678,34.265338 46.04872,34.334329 46.064678,34.403319 46.016789,34.426316 45.968857,34.495307 45.952871,34.564298 45.968857,34.610291 46.000816,34.794266 45.872871,34.794266 45.824815,34.932247 45.760676,35.139219 45.776718,35.254204 45.808787,35.323194 45.760676,35.323194 45.728579,35.438179 45.648256,35.507169 45.551715,35.57616 45.535609,35.64515 45.616094,35.783132 45.66433,35.898116 45.66433,35.990104 45.632177,36.289063 45.680399,36.519032 45.66433,36.542028 45.648256,36.634016 45.648256,36.657013 45.632177,36.68001 45.422736,36.657013 45.341974,36.611019 45.325808,36.588022 45.244908,36.542028 45.212516,36.542028 45.131454,36.588022 44.968984,36.611019 44.920153,36.542028 44.871281,36.450041 44.838676,36.38105 44.838676,36.289063 44.806053,36.059094 44.806053,36.036097 44.789734,35.806129 44.773411,35.64515 44.822367,35.57616 44.773411,35.392185 44.708073,35.369188 44.65902,35.323194 44.64266,35.323194 44.626296,35.162216 44.577174,35.047232 44.560791,35.024235 44.577174,34.863257 44.593552,34.794266 44.577174,34.679282 44.528011,34.564298 44.363834,34.495307 44.347391,34.449313 44.31449,34.334329 44.265106,34.288335 44.23216,34.196348 44.199195,34.081363 44.199195,34.081363 44.182706,33.966379 44.166212,33.851395 44.182706,33.828398 44.166212,33.73641 44.166212,33.552435 44.21568,33.414454 44.265106,33.36846 44.298034,33.276473 44.31449,33.138492 44.44598,33.069501 44.528011,33.069501 44.609926,33.138492 44.724414,33.230479 44.789734,33.230479 44.871281,33.253476 44.920153,33.00051 45.001515,32.816535 45.131454,32.724548 45.098997,32.586567 45.098997,32.310604 45.163892,32.241614 45.228714,32.19562 45.325808,32.172623 45.422736))","code":"crimea","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"public_transport":true,"road_network":true,"truck_graph":true},"id":"174","name":"Крым","time_zone":{"name":"Europe/Simferopol","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((46.591661 29.10832,46.614658 29.16858,46.683649 29.188658,46.706646 29.248871,46.867624 29.429295,46.890621 29.489366,46.913617 29.509381,46.936614 29.589404,46.982608 29.6094,47.005605 29.709319,47.074595 29.849039,47.097592 29.849039,47.097592 29.928792,47.212577 30.028393,47.396552 30.108002,47.741505 30.108002,47.764502 30.088105,47.92548 30.028393,47.948477 30.008481,48.155448 30.028393,48.316427 29.928792,48.477405 29.789183,48.592389 29.669363,48.592389 29.589404,48.684376 29.429295,48.684376 29.329099,48.66138 29.268934,48.753367 29.10832,48.753367 29.048025,48.868351 29.027919,48.983336 28.967577,49.02933 28.826643,48.960339 28.766184,48.73037 28.70569,48.707373 28.665341,48.569392 28.624977,48.431411 28.544201,48.408414 28.523998,47.718508 28.523998,47.62652 28.645161,47.603524 28.665341,47.603524 28.806494,47.55753 28.887067,47.465542 29.007809,47.327561 29.007809,47.304564 29.027919,47.097592 29.048025,47.028602 29.048025,46.913617 29.068128,46.614658 29.088226,46.591661 29.10832))","code":"kuwait","country_code":"kw","domain":"kw","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true},"id":"235","name":"Кувейт","time_zone":{"name":"Asia/Kuwait","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((77.407469 55.540699,77.407469 55.592713,77.430466 55.605706,77.499456 55.696535,77.499456 55.735397,77.54545 55.761284,77.522453 55.877561,77.430466 55.967759,77.430466 56.006351,77.499456 56.019206,77.568447 56.019206,77.637437 56.083419,77.752422 56.096249,77.867406 56.160334,77.867406 56.173138,77.936397 56.185938,78.166365 56.185938,78.235356 56.121896,78.212359 56.057747,78.212359 56.019206,78.258353 55.993491,78.258353 55.967759,78.212359 55.967759,78.028384 55.916243,78.028384 55.877561,78.097375 55.864658,78.212359 55.864658,78.35034 55.890459,78.488322 55.890459,78.488322 55.825925,78.511319 55.813005,78.626303 55.825925,78.695293 55.800081,78.810278 55.787153,78.833275 55.748342,78.902265 55.748342,78.925262 55.787153,78.971256 55.813005,78.994253 55.877561,79.01725 55.916243,79.109237 55.916243,79.109237 56.006351,79.293212 56.109074,79.362203 56.121896,79.408197 56.070585,79.523181 56.109074,79.638165 56.109074,79.684159 56.032057,79.684159 55.967759,79.707156 55.954886,79.684159 55.813005,79.730153 55.787153,79.730153 55.748342,79.615168 55.709493,79.615168 55.670605,79.523181 55.657634,79.500184 55.618695,79.3852 55.540699,79.316209 55.527685,79.270215 55.475585,79.155231 55.475585,79.08624 55.514667,79.01725 55.475585,78.971256 55.397306,78.994253 55.305783,78.925262 55.305783,78.902265 55.345033,78.741287 55.345033,78.695293 55.371178,78.626303 55.423416,78.534315 55.423416,78.442328 55.397306,78.373337 55.410363,78.28135 55.358108,78.120372 55.331954,77.9134 55.345033,77.844409 55.358108,77.821412 55.397306,77.706428 55.423416,77.568447 55.449509,77.54545 55.514667,77.407469 55.540699))","code":"kuibyshev","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":true,"road_network":true,"truck_graph":true},"id":"185","name":"Куйбышев","time_zone":{"name":"Asia/Novosibirsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((55.675425 52.67028,55.675425 52.684223,55.744416 52.726026,55.744416 52.767788,55.79041 52.878959,55.8594 52.892836,55.951388 52.892836,55.951388 52.851193,55.882397 52.7817,55.8594 52.712096,55.836403 52.67028,55.675425 52.67028))","code":"kumertau","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"public_transport":true,"road_network":true},"id":"210","name":"Кумертау","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((76.418603 54.123603,76.418603 54.164014,76.487594 54.177476,76.533588 54.164014,76.648572 54.164014,76.671569 54.150548,76.763556 54.204386,76.80955 54.244719,76.855544 54.325266,76.786553 54.378876,76.80955 54.405655,76.901538 54.419038,76.924534 54.485888,76.993525 54.539289,76.993525 54.579294,77.131506 54.605942,77.108509 54.672486,77.246491 54.71236,77.246491 54.725643,77.361475 54.765465,77.384472 54.77873,77.453462 54.791991,77.522453 54.844991,77.522453 54.871465,77.614441 54.871465,77.614441 54.752195,77.775419 54.672486,77.890403 54.685782,77.936397 54.672486,77.936397 54.605942,78.120372 54.525945,78.097375 54.432417,78.189362 54.378876,78.212359 54.338675,78.120372 54.311852,78.120372 54.258154,78.028384 54.244719,78.028384 54.231279,77.9134 54.217835,77.890403 54.204386,77.798416 54.204386,77.775419 54.217835,77.384472 54.217835,77.384472 54.204386,77.361475 54.204386,77.315481 54.177476,77.292484 54.137078,77.315481 54.123603,77.338478 54.083152,77.315481 54.042661,77.246491 54.042661,77.154503 53.988613,77.085513 53.97509,77.085513 53.94803,77.131506 53.893859,77.108509 53.826046,77.039519 53.730922,76.993525 53.744525,76.579581 53.961562,76.533588 53.97509,76.533588 54.002132,76.510591 54.015646,76.418603 54.123603))","code":"kupino","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":false,"truck_graph":true},"id":"186","name":"Купино","time_zone":{"name":"Asia/Novosibirsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((65.035152 55.475585,65.058149 55.488617,65.242124 55.527685,65.426099 55.527685,65.541083 55.514667,65.633071 55.436465,65.633071 55.423416,65.587077 55.384244,65.610074 55.318871,65.56408 55.24028,65.357108 55.24028,65.242124 55.279595,65.058149 55.358108,65.035152 55.475585))","code":"kurgan","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"10","name":"Курган","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((35.852122 51.554663,35.852122 51.597539,35.875119 51.611822,35.898116 51.797093,35.990104 51.853946,36.105088 51.839739,36.335057 51.853946,36.427044 51.825528,36.450041 51.697426,36.427044 51.697426,36.427044 51.611822,36.358053 51.56896,35.967107 51.554663,35.852122 51.554663))","code":"kursk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"73","name":"Курск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((65.380105 44.887576,65.518086 44.920153,65.656067 44.822367,65.633071 44.708073,65.56408 44.708073,65.449096 44.757084,65.426099 44.838676,65.403102 44.838676,65.380105 44.887576))","code":"kyzylorda","country_code":"kz","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"truck_graph":true},"id":"240","name":"Кызылорда","time_zone":{"name":"Asia/Oral","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((75.820685 56.415607,75.820685 56.491856,75.889675 56.517239,75.958666 56.529924,75.981663 56.567953,76.027656 56.631251,76.142641 56.631251,76.165638 56.669178,76.257625 56.694442,76.234628 56.883381,76.165638 56.946149,76.165638 56.98376,76.07365 57.208625,76.07365 57.233526,76.464597 57.221078,76.694566 57.221078,76.878541 57.171243,78.442328 57.171243,78.465325 57.1463,78.442328 57.108853,78.327344 56.95869,78.28135 56.946149,78.28135 56.908501,78.120372 56.870815,78.120372 56.770132,78.074378 56.732306,78.005387 56.744919,77.98239 56.782732,77.936397 56.807919,77.844409 56.757527,77.867406 56.669178,77.798416 56.65654,77.798416 56.567953,77.752422 56.542605,77.706428 56.567953,77.591444 56.567953,77.591444 56.50455,77.476459 56.466457,77.361475 56.402883,77.292484 56.390156,77.246491 56.390156,77.1775 56.351948,77.200497 56.313702,77.223494 56.249873,76.993525 56.224312,76.924534 56.237095,76.786553 56.237095,76.717563 56.275417,76.625575 56.275417,76.533588 56.224312,76.4416 56.224312,76.395606 56.275417,76.326616 56.275417,76.280622 56.224312,76.211631 56.224312,76.142641 56.262647,76.07365 56.262647,76.050653 56.351948,76.050653 56.402883,76.07365 56.44104,75.958666 56.44104,75.889675 56.402883,75.820685 56.415607))","code":"kyshtovka","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":false,"truck_graph":true},"id":"187","name":"Кыштовка","time_zone":{"name":"Asia/Novosibirsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((85.732336 54.445791,85.755333 54.459161,85.755333 54.738921,85.801327 54.765465,86.422242 54.77873,86.491233 54.765465,86.491233 54.204386,86.468236 54.190933,86.353252 54.177476,85.824324 54.177476,85.755333 54.217835,85.755333 54.35208,85.732336 54.445791))","code":"lenkuz","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"86","name":"Ленинск-Кузнецкий","time_zone":{"name":"Asia/Novokuznetsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((39.32465 52.600498,39.32465 52.64238,39.462631 52.739951,39.646606 52.739951,39.669603 52.726026,39.876575 52.712096,39.876575 52.614463,39.830581 52.614463,39.830581 52.572554,39.899572 52.516612,40.083547 52.516612,40.083547 52.474609,39.968562 52.432566,39.945565 52.432566,39.853578 52.488614,39.715597 52.488614,39.462631 52.474609,39.39364 52.488614,39.39364 52.586528,39.32465 52.600498))","code":"lipetsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"56","name":"Липецк","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((150.491526 59.465104,150.491526 59.511807,150.514522 59.511807,150.60651 59.546792,150.60651 59.663146,150.675501 59.709576,150.790485 59.732766,150.905469 59.732766,151.043451 59.709576,151.020454 59.628282,151.043451 59.570095,150.97446 59.465104,150.928466 59.430034,150.767488 59.418336,150.629507 59.441728,150.60651 59.453418,150.491526 59.465104))","code":"magadan","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"truck_graph":true},"id":"158","name":"Магадан","time_zone":{"name":"Asia/Magadan","offset":660},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((58.481044 53.334539,58.481044 53.361995,58.527037 53.403146,58.550034 53.907408,58.573031 53.920953,59.262937 53.920953,59.423915 53.907408,59.492906 53.893859,59.492906 53.81247,59.469909 53.252065,59.423915 53.224539,59.400918 53.238304,58.550034 53.238304,58.481044 53.334539))","code":"magnitogorsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"26","name":"Магнитогорск","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((39.255659 44.265106,39.278656 44.347391,39.278656 44.42956,39.301653 44.44598,39.416637 44.462395,39.416637 44.511614,39.370644 44.511614,39.370644 44.560791,39.462631 44.593552,39.485628 44.64266,39.554619 44.691727,39.600612 44.740751,39.554619 44.806053,39.623609 44.871281,39.600612 44.920153,39.485628 45.001515,39.508625 45.050277,39.623609 45.115228,39.807584 44.936435,39.876575 44.806053,39.922569 44.806053,40.083547 44.757084,40.12954 44.724414,40.336512 44.724414,40.382506 44.691727,40.543484 44.64266,40.658468 44.65902,40.727459 44.626296,40.727459 44.577174,40.773453 44.462395,40.79645 44.44598,40.888437 44.31449,40.888437 44.23216,40.819447 44.050626,40.750456 44.01756,40.750456 43.885111,40.635472 43.835366,40.451497 43.818776,40.359509 43.768976,40.290518 43.768976,40.221528 43.78558,40.175534 43.868534,40.106544 43.868534,40.037553 43.885111,39.968562 43.934814,39.76159 43.934814,39.715597 43.967926,39.439634 44.116703,39.416637 44.116703,39.255659 44.265106))","code":"maikop","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"truck_graph":true},"id":"131","name":"Майкоп","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((46.660652 42.865487,46.660652 42.916033,46.729642 42.932873,46.775636 43.067423,46.798633 43.067423,46.775636 43.151368,46.867624 43.184913,46.959611 43.184913,47.097592 43.134588,47.097592 43.117804,47.212577 43.117804,47.327561 43.201679,47.350558 43.285439,47.373555 43.469306,47.534533 43.719135,47.580527 43.918251,47.603524 44.00102,47.62652 44.01756,48.155448 44.034095,48.155448 43.918251,48.086458 43.818776,47.902483 43.702512,47.833492 43.502676,47.810495 43.485993,47.833492 43.369084,47.856489 43.352364,47.856489 43.21844,47.833492 43.201679,47.810495 43.117804,47.879486 43.033813,47.92548 43.033813,47.948477 42.966538,47.971473 42.966538,48.017467 42.8149,48.086458 42.764271,48.178445 42.645975,48.178445 42.595208,48.224439 42.561341,48.224439 42.5444,48.247436 42.5444,48.36242 42.442659,48.477405 42.272723,48.523398 42.238681,48.592389 42.136444,48.638383 42.102328,48.638383 42.068194,48.408414 41.982778,48.36242 41.948579,48.247436 41.948579,48.247436 42.016958,48.178445 42.102328,48.109455 42.102328,47.92548 42.272723,47.856489 42.37474,47.833492 42.425686,47.764502 42.5444,47.741505 42.5444,47.672514 42.595208,47.672514 42.645975,47.488539 42.7136,47.327561 42.7136,47.25857 42.696701,47.281567 42.645975,47.350558 42.629058,47.350558 42.578277,47.212577 42.578277,47.097592 42.629058,47.097592 42.645975,47.005605 42.696701,46.867624 42.781152,46.775636 42.848629,46.660652 42.865487))","code":"makhachkala","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"113","name":"Махачкала","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((36.68001 27.304765,36.749 27.325198,36.794994 27.325198,36.817991 27.386473,36.932975 27.406891,36.932975 27.447715,37.04796 27.468121,37.254931 27.468121,37.323922 27.406891,37.41591 27.406891,37.438906 27.447715,37.691872 27.468121,37.737866 27.427305,37.898844 27.447715,37.944838 27.406891,37.967834 27.141169,38.059822 27.141169,38.105816 27.18209,38.128813 27.18209,38.289791 27.079758,38.312788 27.018314,38.450769 26.956836,38.473766 26.854298,38.703734 26.813257,38.726731 26.792731,38.841716 26.813257,38.864712 26.83378,38.933703 26.813257,38.9567 26.792731,39.163672 26.792731,39.278656 26.751668,39.531622 26.772201,39.646606 26.772201,39.669603 26.710589,39.669603 26.628388,39.784587 26.566699,39.784587 26.504976,39.876575 26.381431,39.876575 26.237128,39.922569 26.195865,39.945565 26.133944,39.968562 26.113297,39.945565 25.968661,39.968562 25.823847,39.968562 25.575183,39.945565 25.388345,39.968562 25.367568,40.083547 25.346786,40.198531 25.367568,40.244525 25.284421,40.313515 25.284421,40.336512 25.346786,40.405503 25.326002,40.4285 25.305213,40.474493 25.305213,40.474493 25.409119,40.543484 25.42989,40.612475 25.409119,40.727459 25.409119,40.773453 25.47142,40.79645 25.533689,40.911434 25.595925,40.980425 25.575183,40.980425 25.554438,41.210393 25.512936,41.302381 25.512936,41.371371 25.49218,41.440362 25.409119,41.463359 25.346786,41.647334 25.201218,41.716324 25.180408,41.854306 25.222024,41.96929 25.117957,42.038281 24.972115,42.061278 24.951267,42.130268 24.721698,42.130268 24.700807,42.084274 24.659015,42.084274 24.5963,42.153265 24.324173,42.153265 24.219352,42.107271 24.135434,42.130268 24.030458,42.084274 23.988444,42.084274 23.925397,42.038281 23.841286,41.946293 23.841286,41.900299 23.757121,41.831309 23.757121,41.762318 23.778167,41.693328 23.757121,41.693328 23.693961,41.463359 23.651837,41.394368 23.588627,41.371371 23.504298,41.348375 23.356594,41.371371 23.208725,41.440362 23.145302,41.440362 23.08185,41.348375 23.08185,41.23339 23.018367,41.210393 23.018367,41.210393 23.039531,41.141403 23.039531,41.095409 22.976029,41.072412 22.912497,41.026418 22.870125,40.957428 22.891312,40.842443 22.870125,40.79645 22.785342,40.79645 22.700507,40.750456 22.615619,40.635472 22.573156,40.566481 22.636846,40.49749 22.636846,40.451497 22.594389,40.382506 22.573156,40.336512 22.530679,40.221528 22.530679,40.152537 22.551919,40.152537 22.65807,40.083547 22.764139,39.991559 22.764139,39.830581 22.82774,39.830581 22.848934,39.876575 22.912497,39.853578 23.018367,39.807584 23.08185,39.715597 23.08185,39.554619 23.103004,39.531622 23.039531,39.301653 23.018367,39.278656 23.08185,39.163672 23.145302,39.140675 23.208725,39.117678 23.314363,39.025691 23.33548,38.887709 23.419916,38.887709 23.483208,38.795722 23.483208,38.772725 23.462114,38.2208 23.208725,38.151809 23.229859,37.85285 23.504298,37.760863 23.6097,37.714869 23.693961,37.4849 23.988444,37.346919 24.093454,37.231935 24.156418,37.162944 24.156418,37.070956 24.198378,37.139947 24.303215,37.162944 24.324173,37.369916 24.554472,37.461903 24.659015,37.507897 24.700807,37.576888 24.679912,37.806856 24.679912,37.806856 24.78435,37.921841 24.805227,38.036825 24.805227,38.036825 24.867836,37.921841 24.930414,37.898844 25.013802,37.829853 25.076306,37.85285 25.180408,37.78386 25.263626,37.78386 25.42989,37.737866 25.533689,37.714869 25.554438,37.714869 25.595925,37.829853 25.658129,37.829853 25.741017,37.760863 25.782439,37.599885 25.803145,37.530894 25.885932,37.553891 25.947984,37.507897 26.07199,37.438906 26.092645,37.323922 26.257754,37.323922 26.319609,37.208938 26.319609,37.185941 26.381431,37.208938 26.44322,37.11695 26.525554,37.093953 26.587266,37.11695 26.73113,37.04796 26.83378,36.955972 26.854298,36.932975 26.956836,36.932975 27.05928,36.863985 27.079758,36.726003 27.202545,36.726003 27.263889,36.68001 27.304765))","code":"medina","country_code":"sa","domain":"sa","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true,"traffic":true},"id":"219","name":"Медина","time_zone":{"name":"Asia/Riyadh","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((38.2208 23.166447,38.2208 23.208725,38.772725 23.462114,38.795722 23.483208,38.887709 23.483208,38.887709 23.419916,39.025691 23.33548,39.117678 23.314363,39.140675 23.208725,39.163672 23.145302,39.278656 23.08185,39.301653 23.018367,39.531622 23.039531,39.554619 23.103004,39.715597 23.08185,39.807584 23.08185,39.853578 23.018367,39.876575 22.912497,39.830581 22.848934,39.830581 22.82774,39.991559 22.764139,40.083547 22.764139,40.152537 22.65807,40.152537 22.551919,40.221528 22.530679,40.336512 22.530679,40.382506 22.573156,40.451497 22.594389,40.49749 22.636846,40.566481 22.636846,40.635472 22.573156,40.750456 22.615619,40.79645 22.700507,40.79645 22.785342,40.842443 22.870125,40.957428 22.891312,41.026418 22.870125,41.072412 22.912497,41.095409 22.976029,41.141403 23.039531,41.210393 23.039531,41.210393 23.018367,41.23339 23.018367,41.348375 23.08185,41.440362 23.08185,41.440362 23.145302,41.371371 23.208725,41.348375 23.356594,41.371371 23.504298,41.394368 23.588627,41.463359 23.651837,41.693328 23.693961,41.831309 23.630771,42.015284 23.588627,42.176262 23.588627,42.176262 23.6097,42.245253 23.588627,42.291246 23.462114,42.406231 23.419916,42.406231 23.272118,42.429227 23.272118,42.452224 23.166447,42.475221 23.103004,42.70519 23.08185,42.728187 23.018367,42.751184 22.912497,42.774181 22.912497,42.774181 22.891312,42.866168 22.891312,42.935159 22.742931,42.958156 22.721721,43.142131 22.721721,43.234118 22.67929,43.165127 22.615619,43.188124 22.551919,43.211121 22.530679,43.234118 22.466939,43.349102 22.360642,43.303109 22.296824,43.326105 22.190396,43.349102 22.190396,43.372099 22.041262,43.487084 21.9773,43.487084 21.870631,43.464087 21.721161,43.487084 21.699795,43.487084 21.507363,43.671059 21.421755,43.671059 21.378932,43.579071 21.207517,43.579071 21.121734,43.694055 21.014436,43.80904 20.821105,43.832037 20.692079,43.80904 20.670565,43.740049 20.692079,43.625065 20.713591,43.625065 20.7351,43.44109 20.778109,43.234118 20.799608,43.165127 20.778109,43.07314 20.606001,42.981152 20.584474,42.912162 20.519875,42.797177 20.519875,42.70519 20.476793,42.70519 20.390594,42.636199 20.390594,42.544212 20.261205,42.429227 20.282777,42.406231 20.325913,42.314243 20.325913,42.291246 20.304346,42.222256 20.282777,42.153265 20.325913,42.130268 20.412148,42.107271 20.519875,42.107271 20.584474,41.96929 20.584474,41.946293 20.670565,41.877303 20.649047,41.854306 20.627526,41.739321 20.627526,41.60134 20.756606,41.53235 20.756606,41.486356 20.799608,41.394368 20.821105,41.325378 20.778109,41.325378 20.670565,41.279384 20.584474,41.279384 20.519875,41.210393 20.455248,41.210393 20.390594,41.187396 20.369037,41.118406 20.261205,41.072412 20.304346,41.095409 20.347476,41.049415 20.369037,41.026418 20.304346,40.980425 20.261205,40.842443 20.110114,40.842443 20.045316,40.911434 19.91564,41.026418 19.807495,41.026418 19.720927,41.095409 19.677625,41.1644 19.655969,41.187396 19.590986,41.141403 19.547649,41.210393 19.525976,41.256387 19.525976,41.279384 19.46094,41.394368 19.482621,41.555346 19.547649,41.555346 19.634311,41.578343 19.699277,41.739321 19.699277,41.831309 19.720927,41.831309 19.547649,41.854306 19.482621,41.923296 19.417568,41.923296 19.265675,41.900299 19.200535,41.831309 19.113642,41.716324 19.222252,41.624337 19.222252,41.555346 19.048442,41.509353 19.048442,41.463359 19.004961,41.578343 18.852688,41.624337 18.743837,41.60134 18.743837,41.60134 18.678493,41.394368 18.656706,41.371371 18.591328,41.325378 18.547729,41.210393 18.482309,40.681465 18.220381,40.635472 18.176688,40.520487 18.154838,40.49749 18.176688,40.4285 18.438682,40.175534 18.678493,40.06055 18.765613,39.991559 18.830924,39.922569 18.939718,39.876575 19.178816,39.784587 19.439255,39.715597 19.590986,39.32465 20.088518,39.094681 20.541411,39.071684 20.606001,38.9567 20.821105,38.933703 20.821105,38.818719 21.014436,38.795722 21.035902,38.611747 21.614301,38.542756 21.721161,38.496763 21.849288,38.519759 22.083888,38.611747 22.360642,38.58875 22.381908,38.473766 22.530679,38.404775 22.636846,38.381778 22.700507,38.381778 22.806543,38.358781 22.912497,38.358781 22.954855,38.2208 23.166447))","code":"mekka","country_code":"sa","domain":"sa","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true,"traffic":true},"id":"218","name":"Мекка","time_zone":{"name":"Asia/Riyadh","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((58.527037 55.200927,58.573031 55.24028,58.665019 55.305783,58.780003 55.331954,58.940981 55.331954,58.963978 55.292691,58.986975 55.279595,59.078962 55.292691,59.101959 55.305783,59.262937 55.266495,59.331928 55.266495,59.377922 55.345033,59.377922 55.384244,59.515903 55.436465,59.676881 55.553709,59.791865 55.553709,59.929847 55.670605,60.389784 56.006351,60.550762 56.019206,60.64275 56.032057,60.688743 55.993491,60.71174 55.954886,60.918712 55.929128,60.918712 55.877561,60.895715 55.864658,60.826725 55.813005,60.803728 55.77422,60.665746 55.787153,60.619753 55.748342,60.619753 55.657634,60.688743 55.631679,60.688743 55.488617,60.619753 55.397306,60.550762 55.318871,60.458775 55.24028,60.481771 55.17467,60.481771 55.043123,60.458775 54.897922,60.435778 54.897922,60.2748 54.844991,60.251803 54.791991,60.044831 54.645881,59.998837 54.59262,59.998837 54.552628,60.067828 54.472527,60.067828 54.419038,59.97584 54.285012,59.952843 54.271585,59.791865 54.258154,59.561897 54.231279,59.308931 54.258154,59.009972 54.35208,58.894987 54.392268,58.87199 54.392268,58.87199 54.405655,58.825997 54.405655,58.734009 54.485888,58.711012 54.525945,58.665019 54.552628,58.734009 54.765465,58.711012 54.805248,58.688015 54.8185,58.688015 54.924361,58.665019 54.963988,58.688015 54.963988,58.803 55.016762,58.803 55.056298,58.780003 55.069467,58.711012 55.135251,58.550034 55.161535,58.527037 55.200927))","code":"miass","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"87","name":"Миасс и Златоуст","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((27.067317 53.907408,27.090314 53.97509,27.159305 54.042661,27.251292 54.069659,27.389274 54.069659,27.642239 54.056163,27.757224 54.069659,27.78022 54.056163,27.895205 54.029156,27.987192 54.029156,27.987192 53.988613,28.010189 53.94803,28.07918 53.907408,28.07918 53.853184,28.056183 53.853184,27.872208 53.826046,27.849211 53.81247,27.71123 53.771716,27.642239 53.730922,27.550252 53.730922,27.527255 53.717316,27.366277 53.690089,27.297286 53.717316,27.320283 53.81247,27.251292 53.826046,27.113311 53.880305,27.067317 53.907408))","code":"minsk","country_code":"by","domain":"by","flags":{"2gis_reviews":true,"flamp":false,"metro":true,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"truck_graph":true},"id":"217","name":"Минск","time_zone":{"name":"Europe/Minsk","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((40.382506 52.989846,40.451497 53.003687,40.520487 53.003687,40.589478 52.920575,40.589478 52.865079,40.451497 52.837304,40.405503 52.851193,40.382506 52.989846))","code":"michurinsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":false,"road_network":false,"truck_graph":true},"id":"245","name":"Мичуринск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((36.726003 55.135251,36.794994 55.200927,36.955972 55.25339,36.978969 55.292691,36.955972 55.331954,36.863985 55.384244,36.794994 55.397306,36.817991 55.514667,36.794994 55.527685,36.771997 55.566715,36.794994 55.605706,36.771997 55.722447,36.771997 55.83884,36.794994 55.851751,36.771997 55.890459,36.794994 55.954886,36.749 56.070585,36.771997 56.134713,36.840988 56.185938,36.863985 56.198733,36.932975 56.198733,37.04796 56.262647,37.11695 56.249873,37.162944 56.198733,37.622881 56.224312,37.645878 56.237095,37.898844 56.224312,38.059822 56.237095,38.312788 56.224312,38.335784 56.237095,38.473766 56.237095,38.473766 56.249873,38.58875 56.249873,38.634744 56.224312,38.841716 56.224312,38.933703 56.313702,39.002694 56.313702,39.048687 56.249873,39.163672 56.185938,39.163672 56.134713,39.117678 56.109074,39.140675 55.980627,39.117678 55.967759,39.140675 55.851751,39.117678 55.83884,39.048687 55.761284,39.048687 55.683572,39.071684 55.670605,39.163672 55.644659,39.163672 55.579716,39.117678 55.553709,39.117678 55.475585,39.163672 55.436465,39.140675 55.397306,39.163672 55.331954,39.094681 55.266495,39.117678 55.095794,39.094681 55.095794,39.071684 55.029945,39.002694 55.016762,39.002694 54.977188,38.9567 54.977188,38.818719 55.029945,38.680737 55.029945,38.657741 54.990384,38.611747 54.990384,38.519759 55.043123,38.450769 55.043123,38.404775 55.016762,38.335784 55.003575,38.289791 55.029945,38.082819 55.016762,37.990831 55.043123,37.829853 55.029945,37.737866 55.003575,37.622881 55.016762,37.576888 54.990384,37.507897 54.990384,37.41591 54.963988,37.254931 54.977188,37.231935 55.003575,37.162944 55.003575,37.139947 55.016762,36.955972 55.082633,36.886982 55.069467,36.749 55.069467,36.726003 55.135251))","code":"moscow","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":true,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"32","name":"Москва","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"MULTIPOLYGON(((35.162216 55.954886,35.162216 55.980627,35.323194 56.070585,35.323194 56.109074,35.300197 56.109074,35.300197 56.134713,35.323194 56.147525,35.323194 56.160334,35.346191 56.173138,35.346191 56.198733,35.323194 56.198733,35.323194 56.224312,35.392185 56.237095,35.484172 56.249873,35.484172 56.390156,35.438179 56.390156,35.438179 56.428326,35.57616 56.453751,35.599157 56.466457,35.668147 56.453751,35.783132 56.390156,35.94411 56.377424,36.059094 56.377424,36.082091 56.364688,36.151082 56.402883,36.289063 56.428326,36.31206 56.44104,36.427044 56.466457,36.450041 56.479159,36.565025 56.491856,36.611019 56.517239,36.657013 56.517239,36.817991 56.580621,36.886982 56.580621,37.024963 56.542605,37.093953 56.542605,37.139947 56.580621,37.139947 56.643897,37.162944 56.681812,37.093953 56.744919,37.093953 56.770132,37.208938 56.770132,37.277928 56.757527,37.392913 56.795328,37.507897 56.795328,37.530894 56.83309,37.553891 56.845669,37.553891 56.921055,37.622881 56.933604,37.714869 56.95869,37.829853 56.908501,37.921841 56.883381,37.967834 56.883381,37.990831 56.820507,37.990831 56.782732,38.082819 56.757527,38.197803 56.770132,38.243797 56.770132,38.312788 56.757527,38.312788 56.669178,38.335784 56.669178,38.335784 56.555281,38.289791 56.542605,38.358781 56.453751,38.381778 56.44104,38.427772 56.364688,38.427772 56.288183,38.496763 56.249873,38.496763 56.237095,38.335784 56.237095,38.312788 56.224312,38.059822 56.237095,37.898844 56.224312,37.645878 56.237095,37.622881 56.224312,37.162944 56.198733,37.11695 56.249873,37.04796 56.262647,36.932975 56.198733,36.863985 56.198733,36.840988 56.185938,36.771997 56.134713,36.749 56.070585,36.794994 55.954886,36.771997 55.890459,36.794994 55.851751,36.771997 55.83884,36.771997 55.722447,36.794994 55.605706,36.771997 55.566715,36.794994 55.527685,36.817991 55.514667,36.794994 55.397306,36.863985 55.384244,36.978969 55.318871,36.978969 55.266495,36.817991 55.200927,36.794994 55.200927,36.794994 55.227167,36.771997 55.266495,36.703007 55.266495,36.634016 55.279595,36.611019 55.318871,36.588022 55.331954,36.542028 55.305783,36.473038 55.305783,36.404047 55.292691,36.38105 55.279595,36.31206 55.200927,36.266066 55.17467,36.243069 55.1878,36.128085 55.1878,36.105088 55.200927,35.921113 55.24028,35.852122 55.24028,35.760135 55.279595,35.599157 55.292691,35.507169 55.24028,35.415182 55.24028,35.323194 55.266495,35.323194 55.292691,35.277201 55.318871,35.300197 55.358108,35.300197 55.436465,35.323194 55.449509,35.323194 55.553709,35.300197 55.553709,35.323194 55.566715,35.323194 55.579716,35.392185 55.592713,35.369188 55.644659,35.346191 55.657634,35.346191 55.709493,35.323194 55.709493,35.323194 55.787153,35.300197 55.800081,35.254204 55.851751,35.231207 55.864658,35.162216 55.954886)),((37.162944 55.003575,37.231935 55.003575,37.254931 54.977188,37.41591 54.963988,37.507897 54.990384,37.576888 54.990384,37.622881 55.016762,37.737866 55.003575,37.829853 55.029945,37.990831 55.043123,38.082819 55.016762,38.289791 55.029945,38.335784 55.003575,38.404775 55.016762,38.450769 55.043123,38.519759 55.043123,38.611747 54.990384,38.657741 54.990384,38.680737 55.029945,38.818719 55.029945,38.9567 54.977188,39.002694 54.977188,39.002694 55.016762,39.071684 55.029945,39.094681 55.095794,39.117678 55.095794,39.094681 55.266495,39.163672 55.331954,39.140675 55.397306,39.163672 55.436465,39.117678 55.475585,39.117678 55.553709,39.163672 55.579716,39.163672 55.644659,39.071684 55.670605,39.048687 55.683572,39.048687 55.761284,39.117678 55.851751,39.140675 55.851751,39.209666 55.83884,39.301653 55.851751,39.301653 55.800081,39.370644 55.77422,39.462631 55.77422,39.508625 55.748342,39.554619 55.787153,39.669603 55.800081,39.784587 55.83884,39.876575 55.83884,39.899572 55.800081,39.899572 55.748342,40.014556 55.683572,40.083547 55.605706,40.06055 55.540699,40.083547 55.527685,40.152537 55.527685,40.198531 55.488617,40.152537 55.436465,40.198531 55.358108,40.198531 55.345033,40.152537 55.266495,40.083547 55.25339,40.014556 55.214049,39.807584 55.200927,39.738594 55.135251,39.853578 55.108951,39.830581 55.029945,39.76159 55.016762,39.738594 55.003575,39.646606 55.016762,39.508625 54.963988,39.462631 54.897922,39.485628 54.897922,39.416637 54.85823,39.347647 54.77873,39.347647 54.738921,39.232662 54.725643,39.232662 54.645881,39.117678 54.645881,38.979697 54.619259,38.864712 54.619259,38.795722 54.512597,38.795722 54.459161,38.841716 54.459161,38.933703 54.432417,38.910706 54.392268,38.818719 54.378876,38.703734 54.338675,38.703734 54.258154,38.657741 54.258154,38.634744 54.271585,38.519759 54.298434,38.519759 54.36548,38.404775 54.472527,38.404775 54.525945,38.473766 54.565963,38.496763 54.605942,38.450769 54.645881,38.381778 54.645881,38.174806 54.699073,38.059822 54.71236,38.036825 54.752195,38.013828 54.765465,37.967834 54.844991,37.898844 54.844991,37.78386 54.831748,37.760863 54.738921,37.714869 54.725643,37.599885 54.738921,37.530894 54.77873,37.438906 54.844991,37.323922 54.844991,37.254931 54.831748,37.254931 54.844991,37.185941 54.85823,37.162944 55.003575)))","code":"moscow_region","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"241","name":"Московская область","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((28.424133 68.529187,28.424133 68.562831,28.44713 68.571235,28.51612 68.613204,28.539117 68.646724,28.585111 68.663465,28.654102 68.721959,28.677098 68.721959,28.746089 68.81357,28.769086 68.863381,28.677098 68.87996,28.470127 68.87996,28.424133 68.904805,28.424133 68.921353,28.654102 68.979173,28.769086 69.02038,28.861073 69.045067,28.930064 69.05329,28.999055 69.05329,29.068045 69.028612,29.091042 69.05329,29.229023 69.118962,29.229023 69.151725,29.275017 69.184438,29.275017 69.225261,29.298014 69.233416,29.275017 69.241568,29.25202 69.266007,29.275017 69.306676,29.344008 69.314801,29.367005 69.322923,29.435995 69.331042,29.573976 69.331042,29.688961 69.37969,29.734955 69.395881,29.849939 69.428228,29.964923 69.420146,29.98792 69.412061,30.056911 69.452457,30.102904 69.484719,30.102904 69.516932,30.171895 69.557131,30.125901 69.613282,30.125901 69.637302,30.056911 69.645302,30.079908 69.669286,30.148898 69.677274,30.286879 69.6533,30.470854 69.581214,30.562842 69.549097,30.861801 69.54106,30.930792 69.581214,30.930792 69.629298,30.884798 69.701222,30.861801 69.709198,30.861801 69.73311,30.792811 69.788798,30.930792 69.876012,30.953789 69.907637,30.999782 69.923431,31.068773 69.978618,31.183757 70.017949,31.229751 70.025806,31.551707 70.112039,31.666692 70.135495,31.82767 70.158924,32.080635 70.158924,32.19562 70.151118,32.448585 70.112039,32.471582 70.104214,32.908523 69.994359,33.023507 69.970743,33.115495 69.970743,33.345463 69.931324,33.506441 69.89183,33.552435 69.876012,33.713413 69.76495,33.73641 69.709198,33.713413 69.68526,33.782404 69.629298,33.874391 69.60527,34.035369 69.597254,34.173351 69.597254,34.380323 69.581214,34.403319 69.573189,34.518304 69.557131,34.771269 69.500831,34.932247 69.460527,35.323194 69.460527,35.57616 69.436307,35.599157 69.428228,35.691144 69.428228,35.990104 69.403973,36.197075 69.371589,36.220072 69.363486,36.38105 69.314801,36.565025 69.282284,36.588022 69.274147,36.886982 69.200776,36.978969 69.168087,37.093953 69.143539,37.369916 69.045067,37.438906 69.028612,37.507897 69.02038,37.806856 68.962668,37.898844 68.929622,38.105816 68.863381,38.243797 68.81357,38.358781 68.730303,38.404775 68.713612,38.473766 68.663465,38.58875 68.621589,38.634744 68.596426,38.9567 68.546015,39.186669 68.48706,39.186669 68.478625,39.76159 68.385634,40.888437 68.546015,41.187396 68.588032,41.210393 68.588032,41.210393 68.596426,41.302381 68.596426,41.371371 68.520768,41.417365 68.444855,41.463359 68.394104,41.647334 68.15576,41.670331 68.130075,41.716324 68.070033,42.452224 67.069893,42.498218 66.989121,42.314243 66.862941,42.199259 66.826769,42.153265 66.808663,41.555346 66.608616,41.210393 66.480466,41.210393 66.471287,40.727459 66.296246,40.566481 66.231448,40.221528 66.110666,39.715597 65.90495,39.439634 65.867368,39.278656 65.839146,39.232662 65.839146,39.232662 65.829732,39.163672 65.829732,39.140675 65.820314,38.910706 65.79204,38.634744 65.744847,38.381778 65.707031,38.312788 65.697568,37.875847 65.707031,37.85285 65.71649,37.139947 65.744847,37.070956 65.754293,36.771997 65.763735,36.082091 65.79204,36.0131 65.79204,35.921113 65.829732,35.875119 65.829732,35.806129 65.857964,35.369188 65.998663,35.323194 66.008016,35.323194 66.017365,35.254204 66.036052,35.070229 66.092033,35.047232 66.101352,34.84026 66.157189,34.633288 66.222177,34.610291 66.231448,33.989376 66.40694,33.644423 66.489641,33.621426 66.498813,33.506441 66.507982,33.230479 66.553775,33.138492 66.553775,32.93152 66.581211,32.63256 66.581211,32.56357 66.572069,32.540573 66.507982,32.517576 66.480466,32.448585 66.480466,32.356598 66.462105,32.356598 66.351654,32.287607 66.342428,32.126629 66.351654,31.965651 66.351654,31.850667 66.360877,31.804673 66.397734,31.804673 66.462105,31.758679 66.498813,31.689689 66.498813,31.620698 66.507982,31.597701 66.562924,31.574704 66.645109,31.505714 66.654224,30.976786 66.663335,30.447858 66.654224,29.91893 66.663335,29.321011 66.663335,29.25202 66.690649,29.160033 66.76334,29.114039 66.772412,29.068045 66.844861,29.045048 66.853903,28.999055 66.935124,29.022052 66.944131,29.045048 67.007094,29.068045 67.016075,29.275017 67.13253,29.298014 67.16825,29.344008 67.186091,29.412998 67.230633,29.435995 67.239532,29.435995 67.248427,29.458992 67.248427,29.481989 67.292855,29.61997 67.354915,29.642967 67.381463,29.688961 67.399146,29.803945 67.478555,29.91893 67.531347,29.941926 67.57525,29.941926 67.601554,29.98792 67.636579,29.98792 67.671552,29.61997 67.810928,29.481989 67.932203,29.458992 67.958109,29.435995 67.958109,29.435995 67.983985,29.390001 68.00122,29.321011 68.061442,29.206027 68.087204,29.022052 68.121507,28.999055 68.130075,28.953061 68.130075,28.930064 68.13864,28.861073 68.147202,28.677098 68.181416,28.631105 68.198504,28.470127 68.436404,28.424133 68.529187))","code":"murmansk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"96","name":"Мурманская область","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((41.946293 55.514667,41.946293 55.631679,41.992287 55.631679,42.061278 55.618695,42.084274 55.553709,42.084274 55.501644,42.015284 55.501644,41.946293 55.514667))","code":"murom","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"truck_graph":true},"id":"132","name":"Муром","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((51.650973 55.566715,51.650973 55.618695,51.696967 55.644659,51.719963 55.709493,51.650973 55.825925,51.67397 55.851751,51.788954 55.851751,51.834948 55.877561,51.972929 55.877561,51.995926 55.864658,52.11091 55.851751,52.179901 55.877561,52.294885 55.864658,52.340879 55.877561,52.363876 55.864658,52.547851 55.864658,52.616841 55.83884,52.616841 55.618695,52.524854 55.553709,52.386873 55.540699,52.363876 55.553709,52.202898 55.553709,52.133907 55.540699,52.11091 55.553709,52.087913 55.540699,51.926935 55.540699,51.834948 55.566715,51.719963 55.553709,51.650973 55.566715))","code":"nabchelny","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"29","name":"Набережные Челны","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((43.602068 17.761061,43.625065 17.9143,43.671059 17.936181,43.717052 18.132984,43.763046 18.176688,43.763046 18.242224,43.855034 18.264064,43.855034 18.307735,43.87803 18.373221,43.947021 18.438682,43.947021 18.504119,43.970018 18.525925,43.993015 18.634916,44.107999 18.743837,44.107999 18.809156,44.130996 18.87445,44.199987 18.896209,44.24598 18.939718,44.314971 18.939718,44.383962 18.961469,44.383962 19.091912,44.452952 19.200535,44.452952 19.309088,44.383962 19.33079,44.383962 19.417568,44.590933 19.417568,45.073868 19.439255,45.119861 19.309088,45.119861 19.222252,45.165855 19.222252,45.372827 19.309088,46.292702 19.309088,47.097592 19.33079,51.972929 19.33079,51.995926 19.265675,51.995926 18.983216,51.926935 18.961469,51.168039 18.830924,50.639111 18.743837,50.432139 18.722059,49.926208 18.678493,49.121317 18.591328,48.592389 18.351395,48.224439 18.176688,48.109455 18.023676,47.764502 17.60769,47.718508 17.563846,47.603524 17.410307,47.603524 17.388363,47.511536 17.190743,47.488539 17.102844,47.327561 17.014904,47.304564 16.992912,47.18958 16.926922,47.005605 16.926922,46.936614 16.992912,46.729642 17.25664,46.568664 17.234677,46.361692 17.212711,45.901755 17.25664,45.740777 17.2786,45.395824 17.300558,45.28084 17.366415,45.257843 17.388363,45.211849 17.388363,45.188852 17.410307,44.61393 17.410307,44.61393 17.388363,44.039008 17.388363,43.970018 17.322513,43.717052 17.344466,43.694055 17.388363,43.717052 17.410307,43.671059 17.519991,43.625065 17.563846,43.602068 17.761061))","code":"najran","country_code":"sa","domain":"sa","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true},"id":"228","name":"Наджран","time_zone":{"name":"Etc/GMT+3","offset":-180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((44.705918 43.184913,44.705918 43.268696,44.728915 43.268696,44.843899 43.251949,44.866896 43.201679,44.843899 43.151368,44.774908 43.151368,44.705918 43.184913))","code":"nazran","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"truck_graph":true},"id":"154","name":"Назрань","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((43.487084 43.435917,43.51008 43.519355,43.717052 43.536028,43.717052 43.502676,43.648062 43.40251,43.533077 43.40251,43.487084 43.435917))","code":"nalchik","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"truck_graph":true},"id":"134","name":"Нальчик","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((52.915801 67.619073,52.915801 67.662814,52.984791 67.671552,53.007788 67.680288,53.122773 67.697748,53.191763 67.68902,53.168766 67.627827,53.053782 67.601554,52.915801 67.619073))","code":"naryanmar","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"truck_graph":true},"id":"159","name":"Нарьян-Мар","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((132.553966 42.8149,132.553966 42.865487,132.622957 42.949708,132.829928 42.949708,133.128888 42.966538,133.243872 42.916033,133.243872 42.7136,133.220875 42.662889,132.783935 42.662889,132.553966 42.8149))","code":"nahodka","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"82","name":"Находка","time_zone":{"name":"Asia/Vladivostok","offset":600},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((41.877303 44.708073,41.900299 44.708073,42.038281 44.675376,42.038281 44.593552,41.96929 44.577174,41.900299 44.593552,41.877303 44.708073))","code":"nevinnomyssk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"truck_graph":true},"id":"135","name":"Невинномысск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((34.679282 27.671976,34.702279 27.733058,34.932247 28.098832,35.047232 28.179947,35.116222 28.179947,35.323194 28.159674,35.369188 28.159674,35.507169 28.098832,35.64515 27.733058,35.622154 27.549708,35.323194 27.427305,35.300197 27.427305,35.254204 27.386473,35.20821 27.406891,34.909251 27.631235,34.679282 27.671976))","code":"neom","country_code":"sa","domain":"sa","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":true,"road_network":true},"id":"250","name":"Неом","time_zone":{"name":"Asia/Riyadh","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((75.015794 61.272399,75.038791 61.28345,75.061788 61.316581,75.153775 61.316581,75.26876 61.294498,75.291757 61.261343,75.521725 61.250284,75.567719 61.272399,75.659706 61.272399,75.682703 61.261343,75.774691 61.228154,76.142641 61.239221,76.257625 61.183847,76.993525 61.183847,77.108509 61.172761,77.131506 61.16167,77.292484 61.172761,77.315481 61.16167,77.54545 61.139478,77.614441 61.11727,77.867406 61.10616,77.9134 61.095046,77.844409 60.81593,77.844409 60.782272,77.821412 60.771044,77.821412 60.737338,77.637437 60.613447,77.384472 60.60216,77.315481 60.613447,77.154503 60.692342,77.016522 60.692342,76.947531 60.714848,76.878541 60.748578,76.80955 60.759813,76.740559 60.81593,76.671569 60.81593,76.602578 60.87195,76.533588 60.87195,76.510591 60.860754,75.912672 60.860754,75.521725 60.961376,75.314753 61.028282,75.245763 61.039419,75.222766 61.072807,75.061788 61.128376,75.061788 61.16167,75.038791 61.172761,75.015794 61.272399))","code":"nizhnevartovsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"12","name":"Нижневартовск","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((43.234118 56.453751,43.280112 56.580621,43.257115 56.593285,43.257115 56.65654,43.303109 56.65654,43.326105 56.669178,43.464087 56.681812,43.579071 56.6186,43.671059 56.6186,43.740049 56.555281,43.901027 56.567953,43.947021 56.517239,44.016012 56.517239,44.107999 56.491856,44.222983 56.491856,44.291974 56.479159,44.291974 56.390156,44.268977 56.377424,44.291974 56.237095,44.314971 56.224312,44.291974 56.134713,44.337968 56.096249,44.314971 56.057747,44.17699 56.057747,44.107999 56.032057,44.107999 55.967759,44.062005 55.890459,44.062005 55.735397,44.016012 55.631679,44.016012 55.540699,43.993015 55.475585,44.016012 55.436465,43.993015 55.371178,43.901027 55.305783,43.832037 55.305783,43.694055 55.371178,43.717052 55.475585,43.671059 55.527685,43.694055 55.527685,43.694055 55.566715,43.579071 55.579716,43.579071 55.605706,43.533077 55.631679,43.533077 55.696535,43.602068 55.748342,43.464087 55.825925,43.418093 56.006351,43.303109 56.032057,43.257115 56.185938,43.280112 56.224312,43.326105 56.262647,43.257115 56.300945,43.257115 56.364688,43.234118 56.453751))","code":"n_novgorod","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":true,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"19","name":"Нижний Новгород","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((58.642022 58.009341,58.848994 57.997155,58.87199 57.997155,58.940981 57.984966,59.055965 57.972772,59.469909 57.911742,59.745872 57.911742,59.768868 57.948372,59.768868 58.009341,59.791865 58.094522,60.113822 58.082366,60.182812 58.070205,60.251803 58.082366,60.320793 58.070205,60.34379 58.033699,60.435778 58.033699,60.527765 58.082366,60.596756 58.082366,60.619753 58.045872,60.527765 57.948372,60.458775 57.911742,60.389784 57.8873,60.320793 57.8873,60.251803 57.801625,60.228806 57.70346,60.159815 57.678877,60.021834 57.691171,59.699878 57.617347,59.584893 57.580379,59.400918 57.531029,59.308931 57.518682,59.308931 57.50633,59.262937 57.50633,59.23994 57.493973,59.078962 57.469249,59.078962 57.419749,59.009972 57.419749,58.986975 57.45688,58.963978 57.469249,58.87199 57.493973,58.87199 57.50633,58.803 57.50633,58.757006 57.543373,58.803 57.617347,58.780003 57.641971,58.711012 57.654277,58.711012 57.666579,58.848994 57.740303,58.848994 57.838368,58.757006 57.850607,58.688015 57.911742,58.665019 57.923956,58.642022 58.009341))","code":"ntagil","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"45","name":"Нижний Тагил","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((86.468236 53.97509,86.491233 54.015646,86.491233 54.069659,86.652211 54.110123,86.675208 54.123603,87.227133 54.123603,87.388111 54.190933,87.411108 54.204386,87.434105 54.204386,87.480098 54.231279,87.503095 54.271585,87.848048 54.231279,87.894042 54.204386,87.940036 54.204386,87.963033 54.190933,88.170004 54.110123,88.284989 54.069659,88.307986 54.069659,88.307986 54.056163,88.514958 53.988613,88.537954 53.97509,88.974895 53.81247,88.997892 53.744525,89.020889 53.744525,89.020889 53.703705,89.043886 53.635583,88.951898 53.608304,88.882907 53.608304,88.859911 53.594658,88.813917 53.581007,88.675936 53.512687,88.514958 53.416854,88.376976 53.403146,88.307986 53.389434,88.284989 53.389434,87.917039 53.34827,87.848048 53.334539,87.641076 53.320805,87.595083 53.416854,87.480098 53.49901,86.58322 53.49901,86.51423 53.512687,86.51423 53.920953,86.468236 53.97509))","code":"novokuznetsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"6","name":"Новокузнецк","time_zone":{"name":"Asia/Novokuznetsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((36.840988 44.887576,36.840988 44.903867,36.932975 45.098997,36.955972 45.115228,36.955972 45.212516,37.070956 45.244908,37.185941 45.244908,37.346919 45.228714,37.41591 45.196313,37.4849 45.212516,37.645878 45.212516,37.944838 45.228714,38.128813 45.196313,38.2208 45.196313,38.58875 45.228714,38.657741 45.180105,38.58875 45.115228,38.565753 44.968984,38.634744 44.887576,38.657741 44.773411,38.634744 44.65902,38.657741 44.511614,38.680737 44.495212,38.680737 44.44598,38.634744 44.380272,38.611747 44.330943,38.496763 44.149714,38.335784 44.166212,38.266794 44.182706,38.013828 44.265106,37.944838 44.347391,37.85285 44.396706,37.737866 44.44598,37.714869 44.462395,37.553891 44.462395,37.254931 44.560791,37.139947 44.64266,37.024963 44.822367,36.932975 44.871281,36.840988 44.887576))","code":"novorossiysk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"74","name":"Новороссийск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((80.948987 54.378876,81.040974 54.445791,81.201952 54.459161,81.270943 54.432417,81.339934 54.445791,81.546906 54.525945,81.523909 54.605942,81.592899 54.619259,81.707884 54.632572,81.684887 54.672486,81.615896 54.738921,81.592899 54.752195,81.523909 54.8185,81.569902 54.871465,81.477915 54.937574,81.408924 54.937574,81.362931 54.963988,81.431921 55.029945,81.454918 55.043123,81.431921 55.108951,81.454918 55.122103,81.454918 55.279595,81.408924 55.279595,81.385927 55.318871,81.431921 55.345033,81.546906 55.397306,81.868862 55.449509,82.075834 55.501644,82.121827 55.501644,82.121827 55.540699,82.02984 55.644659,81.937852 55.77422,81.822868 55.903353,81.730881 56.032057,81.592899 56.198733,81.569902 56.237095,81.592899 56.249873,81.868862 56.300945,82.144824 56.326455,82.282805 56.351948,82.351796 56.351948,82.420787 56.390156,82.489777 56.402883,82.742743 56.415607,82.811733 56.428326,82.811733 56.517239,82.880724 56.529924,83.041702 56.529924,83.110693 56.542605,83.271671 56.453751,83.271671 56.415607,83.156687 56.351948,83.13369 56.262647,83.087696 56.237095,83.087696 56.224312,83.20268 56.211525,83.179683 56.147525,83.156687 56.134713,83.156687 56.109074,83.248674 56.109074,83.271671 56.096249,83.248674 56.032057,83.317665 55.980627,83.386655 55.916243,83.409652 55.877561,83.294668 55.813005,83.225677 55.748342,83.248674 55.709493,83.409652 55.709493,83.593627 55.683572,83.616624 55.696535,83.662618 55.735397,83.662618 55.77422,83.731608 55.787153,83.754605 55.83884,83.915583 55.980627,83.984574 56.019206,84.145552 56.032057,84.168549 56.044904,84.237539 56.044904,84.329527 55.993491,84.375521 55.993491,84.398518 56.032057,84.467508 56.044904,84.536499 56.006351,84.513502 55.916243,84.490505 55.903353,84.490505 55.864658,84.536499 55.864658,84.559496 55.825925,84.605489 55.77422,84.536499 55.735397,84.605489 55.696535,84.67448 55.683572,84.697477 55.670605,84.789464 55.553709,84.743471 55.514667,84.743471 55.449509,84.67448 55.423416,84.651483 55.410363,84.67448 55.371178,84.812461 55.371178,84.904449 55.345033,84.904449 55.279595,84.881452 55.279595,84.858455 55.214049,84.927446 55.161535,84.927446 55.095794,84.858455 55.003575,84.881452 54.963988,84.996436 54.937574,84.996436 54.897922,85.065427 54.85823,85.065427 54.8185,84.950442 54.765465,84.927446 54.752195,84.927446 54.71236,84.996436 54.672486,84.996436 54.632572,84.950442 54.605942,84.973439 54.552628,84.996436 54.539289,85.088424 54.459161,85.111421 54.445791,85.065427 54.419038,84.881452 54.35208,84.858455 54.338675,84.766468 54.338675,84.628486 54.258154,84.582493 54.217835,84.582493 54.204386,84.490505 54.150548,84.375521 54.164014,84.191546 54.177476,84.007571 54.123603,83.984574 54.110123,83.915583 54.09664,83.846593 54.123603,83.777602 54.110123,83.57063 54.110123,83.478643 54.069659,83.478643 54.002132,83.409652 53.934494,83.340661 53.94803,83.317665 54.056163,83.20268 54.056163,82.76574 53.798889,82.742743 53.744525,82.650755 53.690089,82.650755 53.635583,82.535771 53.553692,82.558768 53.512687,82.535771 53.49901,82.420787 53.49901,82.420787 53.512687,82.351796 53.512687,82.328799 53.553692,82.190818 53.608304,82.167821 53.662845,82.075834 53.662845,81.937852 53.717316,81.822868 53.703705,81.753877 53.771716,81.753877 53.826046,81.845865 53.880305,81.845865 53.920953,81.822868 53.961562,81.638893 53.97509,81.592899 53.920953,81.546906 53.934494,81.592899 54.015646,81.546906 54.029156,81.477915 54.069659,81.29394 54.069659,81.247946 54.09664,81.132962 54.123603,81.086968 54.204386,81.063971 54.204386,81.063971 54.217835,81.017977 54.258154,80.994981 54.271585,80.971984 54.338675,80.948987 54.378876))","code":"novosibirsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":true,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"1","name":"Новосибирск","time_zone":{"name":"Asia/Novosibirsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((40.014556 47.342019,40.014556 47.388747,40.037553 47.482081,40.083547 47.544211,40.106544 47.559732,40.175534 47.544211,40.152537 47.435435,40.198531 47.435435,40.267522 47.419877,40.152537 47.326433,40.083547 47.326433,40.014556 47.342019))","code":"novocherkassk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"truck_graph":true},"id":"137","name":"Новочеркасск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((39.784587 47.776545,39.807584 47.791997,39.853578 47.884613,39.922569 47.884613,39.945565 47.869189,39.991559 47.822887,40.014556 47.71469,39.968562 47.71469,39.807584 47.730161,39.784587 47.776545))","code":"novoshakhtinsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"truck_graph":true},"id":"138","name":"Новошахтинск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((31.597701 29.988564,31.620698 30.048301,31.712685 30.048301,31.758679 30.088105,31.82767 30.108002,31.89666 30.068205,31.89666 29.849039,31.873664 29.849039,31.82767 29.888924,31.735682 29.888924,31.666692 29.988564,31.597701 29.988564))","code":"new_cairo","country_code":"eg","domain":"eg","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true},"id":"239","name":"Новый Каир","time_zone":{"name":"Africa/Cairo","offset":120},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((76.372609 66.092033,76.533588 66.157189,76.533588 66.166483,76.556584 66.175774,76.993525 66.185062,77.062516 66.13859,77.062516 66.110666,77.131506 66.064058,77.246491 66.036052,77.522453 66.036052,77.54545 66.045391,77.683431 66.092033,77.752422 66.092033,77.798416 66.073387,77.867406 66.082712,78.097375 66.129286,78.212359 66.13859,78.327344 66.092033,78.327344 66.073387,78.442328 65.998663,78.488322 65.979948,78.488322 65.970585,78.327344 65.867368,78.304347 65.857964,78.28135 65.829732,78.258353 65.829732,78.258353 65.810893,78.235356 65.801468,78.212359 65.773173,78.143369 65.735398,78.051381 65.725946,78.028384 65.697568,77.959394 65.688102,77.890403 65.659683,77.798416 65.659683,77.775419 65.650203,77.660434 65.640719,77.568447 65.678633,77.453462 65.707031,77.223494 65.801468,77.154503 65.801468,76.947531 65.79204,76.740559 65.820314,76.717563 65.829732,76.694566 65.829732,76.602578 65.886166,76.602578 65.89556,76.533588 65.90495,76.533588 65.914337,76.510591 65.914337,76.464597 65.9331,76.418603 66.02671,76.372609 66.092033))","code":"n_urengoy","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"truck_graph":true},"id":"139","name":"Новый Уренгой","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((85.985302 69.395881,85.985302 69.549097,86.054292 69.557131,86.58322 69.565161,87.043158 69.565161,88.307986 69.557131,88.537954 69.557131,88.560951 69.533021,88.537954 69.508883,88.537954 69.266007,88.514958 69.241568,88.307986 69.241568,87.963033 69.249717,86.031295 69.249717,86.008299 69.274147,85.985302 69.395881))","code":"norilsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"truck_graph":true},"id":"76","name":"Норильск","time_zone":{"name":"Asia/Krasnoyarsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((74.302891 63.662768,74.302891 63.845822,74.325888 63.876216,76.188635 63.876216,76.257625 63.866088,76.257625 63.662768,76.234628 63.303421,76.280622 63.28275,76.487594 63.272409,76.533588 63.272409,76.832547 63.262064,77.085513 63.251716,77.108509 63.241364,77.1775 63.096044,77.062516 62.970904,77.039519 62.970904,77.016522 62.981353,76.855544 62.991798,76.717563 63.023111,76.648572 63.033541,76.533588 63.002239,76.487594 62.981353,76.464597 62.981353,76.418603 62.960451,76.326616 62.960451,76.257625 63.023111,74.394879 63.023111,74.325888 63.033541,74.325888 63.303421,74.302891 63.662768))","code":"noyabrsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"103","name":"Ноябрьск","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((65.150136 62.00429,65.150136 62.047438,65.334111 62.1443,65.403102 62.176518,65.495089 62.294359,65.748055 62.294359,65.817046 62.283666,65.794049 62.262267,65.771052 62.18725,65.886036 62.112047,65.886036 62.090526,65.863039 62.07976,65.886036 62.00429,65.863039 61.971888,65.656067 61.971888,65.56408 61.993493,65.219127 61.993493,65.150136 62.00429))","code":"nyagan","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"public_transport":true,"road_network":true},"id":"202","name":"Нягань","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((51.444001 24.366077,51.444001 24.428906,51.581982 24.554472,51.581982 24.659015,52.018923 24.763469,52.271888 24.8261,52.363876 24.867836,52.340879 24.99296,52.40987 25.013802,52.47886 25.013802,52.501857 25.076306,52.639838 25.180408,52.84681 25.450657,52.869807 25.47142,52.938798 25.49218,52.984791 25.49218,54.111638 25.47142,54.203626 25.47142,55.1235 25.575183,55.284479 25.595925,55.376466 25.741017,55.42246 25.782439,55.514447 25.823847,55.767413 25.968661,55.79041 25.989334,55.8594 26.133944,55.882397 26.154588,55.905394 26.133944,55.997382 26.113297,56.043375 26.07199,56.181357 26.03067,56.15836 25.76173,56.15836 25.658129,56.22735 25.616663,56.296341 25.616663,56.296341 25.637398,56.457319 25.69958,56.549306 25.69958,56.572303 25.637398,56.5953 25.533689,56.5953 25.03464,56.52631 24.99296,56.342335 24.972115,56.319338 24.888699,56.22735 24.867836,56.181357 24.763469,56.112366 24.742585,56.043375 24.763469,56.043375 24.8261,55.997382 24.84697,56.043375 24.930414,56.020378 24.99296,55.8594 24.972115,55.813407 24.888699,55.836403 24.679912,55.79041 24.575388,55.767413 24.554472,55.79041 24.491705,55.836403 24.407967,55.836403 24.324173,55.813407 24.324173,55.79041 24.219352,55.951388 24.219352,55.997382 24.093454,55.997382 24.05146,55.79041 24.030458,55.767413 24.05146,55.629432 24.030458,55.583438 23.988444,55.514447 23.967432,55.560441 23.651837,55.537444 23.546469,55.468454 23.483208,55.307475 23.208725,55.284479 23.187588,55.215488 23.039531,55.215488 22.700507,55.1235 22.636846,54.916529 22.65807,54.893532 22.67929,54.341607 22.721721,54.272616 22.742931,53.835676 22.806543,53.674698 22.806543,53.14577 22.870125,52.984791 22.891312,52.869807 22.891312,52.84681 22.912497,52.662835 22.912497,52.662835 22.933677,52.570848 22.933677,52.340879 23.229859,52.156904 23.441017,52.018923 23.630771,51.765957 23.925397,51.67397 24.009453,51.581982 24.156418,51.581982 24.261291,51.535989 24.345126,51.444001 24.366077))","code":"dubai","country_code":"ae","domain":"ae","flags":{"2gis_reviews":true,"flamp":false,"metro":true,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"99","name":"ОАЭ","time_zone":{"name":"Asia/Dubai","offset":240},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((51.995926 18.939718,51.995926 19.004961,52.616841 19.200535,52.915801 19.309088,52.984791 19.33079,53.95066 19.655969,54.571576 19.850762,54.870535 19.958877,55.008516 20.002103,55.238485 20.692079,55.49145 21.485965,55.675425 21.998624,55.215488 22.700507,55.215488 23.039531,55.284479 23.187588,55.307475 23.208725,55.468454 23.483208,55.537444 23.546469,55.560441 23.651837,55.514447 23.967432,55.583438 23.988444,55.629432 24.030458,55.767413 24.05146,55.79041 24.030458,55.997382 24.05146,55.997382 24.093454,55.951388 24.219352,55.79041 24.219352,55.813407 24.324173,55.836403 24.324173,55.836403 24.407967,55.79041 24.491705,55.767413 24.554472,55.79041 24.575388,55.836403 24.679912,55.813407 24.888699,55.8594 24.972115,56.020378 24.99296,56.043375 24.930414,55.997382 24.84697,56.043375 24.8261,56.043375 24.763469,56.112366 24.742585,56.181357 24.763469,56.22735 24.867836,56.319338 24.888699,56.342335 24.972115,56.52631 24.99296,56.5953 25.03464,56.5953 25.533689,56.572303 25.637398,56.549306 25.69958,56.457319 25.69958,56.296341 25.637398,56.296341 25.616663,56.22735 25.616663,56.15836 25.658129,56.15836 25.76173,56.181357 26.03067,56.043375 26.07199,55.997382 26.113297,55.905394 26.133944,55.882397 26.154588,55.905394 26.257754,55.928391 26.278376,56.020378 26.422627,56.273344 26.607829,56.549306 26.73113,56.687288 26.669496,56.733281 26.628388,56.779275 26.546128,56.779275 26.422627,56.802272 26.154588,57.285206 24.909558,57.423188 24.533553,57.584166 24.428906,58.274072 24.05146,58.665019 23.862319,58.87199 23.736071,58.87199 23.715017,58.940981 23.693961,58.963978 23.6097,58.986975 23.588627,59.101959 23.462114,59.17095 23.356594,59.193947 23.33548,59.216944 23.272118,59.23994 23.25099,59.262937 23.187588,59.377922 23.124155,59.469909 22.933677,59.492906 22.912497,59.515903 22.912497,59.630887 22.785342,59.837859 22.764139,59.97584 22.700507,60.067828 22.530679,60.067828 22.232977,60.044831 22.211688,60.021834 22.105196,59.929847 21.998624,59.883853 21.934642,59.883853 21.849288,59.860856 21.827941,59.768868 21.721161,59.699878 21.614301,59.676881 21.528757,59.653884 21.507363,59.584893 21.400345,59.5389 21.271821,59.23994 21.121734,59.078962 20.95002,59.101959 20.799608,59.124956 20.778109,59.216944 20.519875,59.193947 20.369037,59.032969 20.218051,58.917984 20.066918,58.87199 20.045316,58.87199 20.023711,58.757006 19.958877,58.688015 19.93726,58.550034 19.93726,58.527037 19.958877,58.251075 20.110114,58.0671 20.110114,58.044103 19.91564,58.021106 19.894017,58.021106 19.720927,57.952116 19.61265,57.998109 19.374185,57.998109 19.309088,58.090097 19.004961,58.0671 18.896209,57.952116 18.787386,57.745144 18.722059,57.469181 18.722059,57.239213 18.678493,57.216216 18.656706,57.147225 18.656706,56.940253 18.56953,56.871263 18.460497,56.871263 18.416865,56.802272 18.176688,56.779275 18.154838,56.779275 18.089269,56.710285 17.936181,56.5953 17.870531,56.641294 17.54192,56.618297 17.410307,56.503313 17.300558,56.319338 17.25664,56.250347 17.2786,55.905394 17.25664,55.698422 17.25664,55.49145 17.212711,55.468454 17.102844,55.42246 17.058879,55.376466 16.992912,55.353469 16.970918,55.169494 16.816887,55.077507 16.772855,54.939525 16.750835,54.801544 16.706788,54.617569 16.750835,54.594572 16.772855,54.525582 16.816887,54.433594 16.794872,54.433594 16.816887,54.226622 16.794872,54.111638 16.728813,54.019651 16.684761,53.881669 16.662731,53.812679 16.596626,53.605707 16.530498,53.490723 16.530498,53.237757 16.464348,53.168766 16.464348,53.053782 16.684761,53.007788 16.816887,52.984791 16.838899,52.984791 16.882916,52.961795 16.90492,52.938798 16.970918,52.869807 17.124823,52.754823 17.2786,52.754823 17.366415,52.731826 17.388363,52.685832 17.519991,52.616841 17.673436,52.432867 18.023676,52.156904 18.634916,52.087913 18.743837,51.995926 18.939718))","code":"oman","country_code":"om","domain":"om","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true},"id":"237","name":"Оман","time_zone":{"name":"Asia/Muscat","offset":240},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((70.370426 57.345373,70.393423 57.407363,70.577398 57.45688,70.600395 57.493973,70.646389 57.493973,70.646389 57.50633,70.669385 57.50633,70.692382 57.518682,70.692382 57.555712,70.646389 57.580379,70.577398 57.605028,70.577398 57.666579,70.554401 57.70346,70.508407 57.728026,70.48541 57.764844,70.41642 57.777108,70.41642 57.875073,70.370426 57.899523,70.370426 57.936166,70.439417 57.948372,70.531404 58.106675,70.554401 58.118823,70.623392 58.203743,70.646389 58.215858,70.646389 58.252179,70.669385 58.264277,70.692382 58.31263,70.715379 58.31263,70.78437 58.457292,70.807367 58.46932,70.85336 58.5294,70.968345 58.517392,70.991342 58.50538,71.060332 58.50538,71.106326 58.46932,71.106326 58.445259,71.175317 58.433222,71.290301 58.397088,71.290301 58.348851,71.244307 58.324707,71.22131 58.264277,71.22131 58.106675,71.198313 58.094522,71.22131 58.058041,71.382288 58.070205,71.497273 58.070205,71.88822 58.106675,72.049198 58.106675,72.164182 58.021522,72.233173 58.009341,72.440145 58.009341,72.831091 57.997155,73.084057 58.130967,73.153048 58.155242,73.498001 58.143106,74.003932 58.143106,74.210904 58.130967,74.371882 58.203743,74.53286 58.264277,74.647844 58.300548,74.670841 58.348851,74.808822 58.409137,74.923807 58.433222,74.946803 58.493364,75.107782 58.565399,75.130778 58.565399,75.291757 58.50538,75.33775 58.46932,75.33775 58.433222,75.291757 58.433222,75.084785 58.348851,75.084785 58.324707,75.199769 58.240076,75.222766 58.203743,75.222766 58.179501,75.107782 58.143106,75.107782 58.094522,75.222766 58.070205,75.314753 58.021522,75.383744 58.009341,75.429738 57.984966,75.567719 57.936166,75.567719 57.70346,75.544722 57.666579,75.567719 57.629661,75.682703 57.629661,75.728697 57.592706,75.751694 57.531029,75.774691 57.50633,75.820685 57.407363,75.866678 57.38258,75.958666 57.394973,76.00466 57.357779,76.00466 57.332962,76.096647 57.233526,76.119644 57.1463,76.188635 56.98376,76.188635 56.946149,76.257625 56.883381,76.280622 56.694442,76.119644 56.6186,76.050653 56.6186,76.00466 56.555281,75.981663 56.542605,75.958666 56.50455,75.866678 56.50455,75.843681 56.466457,75.843681 56.415607,75.912672 56.428326,75.958666 56.453751,76.096647 56.453751,76.07365 56.364688,76.07365 56.313702,76.096647 56.275417,76.211631 56.262647,76.211631 56.224312,76.280622 56.185938,76.280622 56.147525,76.119644 56.134713,76.096647 56.147525,76.00466 56.147525,76.00466 56.121896,75.889675 56.121896,75.774691 56.109074,75.659706 56.044904,75.521725 56.019206,75.521725 55.980627,75.406741 55.929128,75.314753 55.903353,75.291757 55.83884,75.360747 55.787153,75.360747 55.748342,75.291757 55.735397,75.199769 55.735397,75.130778 55.748342,75.107782 55.735397,75.130778 55.670605,75.222766 55.657634,75.222766 55.618695,75.176772 55.592713,75.199769 55.553709,75.291757 55.553709,75.314753 55.514667,75.199769 55.449509,75.153775 55.384244,75.130778 55.384244,75.199769 55.318871,75.199769 55.279595,75.26876 55.24028,75.26876 55.200927,75.291757 55.1878,75.26876 55.17467,75.291757 55.108951,75.314753 55.095794,75.383744 55.043123,75.360747 54.897922,75.429738 54.897922,75.498728 54.911144,75.498728 54.831748,75.63671 54.805248,75.682703 54.725643,75.682703 54.685782,75.751694 54.685782,75.774691 54.699073,75.843681 54.645881,75.820685 54.565963,75.751694 54.539289,75.682703 54.539289,75.682703 54.137078,75.659706 54.110123,75.521725 54.110123,75.498728 54.09664,75.406741 54.083152,75.429738 53.988613,75.383744 53.961562,75.199769 53.866747,75.107782 53.81247,75.038791 53.798889,74.992797 53.826046,74.90081 53.826046,74.785825 53.81247,74.785825 53.758122,74.739832 53.758122,74.670841 53.744525,74.647844 53.676469,74.463869 53.676469,74.440872 53.635583,74.463869 53.540028,74.440872 53.52636,74.417875 53.471642,74.325888 53.471642,74.279894 53.540028,74.256897 53.581007,74.187907 53.594658,74.141913 53.567352,74.072922 53.567352,74.072922 53.594658,74.049926 53.635583,73.934941 53.649216,73.842954 53.594658,73.727969 53.608304,73.658979 53.594658,73.589988 53.52636,73.452007 53.444257,73.383016 53.457952,73.383016 53.52636,73.268032 53.567352,73.268032 53.649216,73.337022 53.703705,73.360019 53.717316,73.360019 53.771716,73.42901 53.785305,73.452007 53.866747,73.612985 53.866747,73.635982 53.853184,73.704972 53.866747,73.750966 54.002132,73.773963 54.015646,73.727969 54.056163,73.658979 54.056163,73.635982 54.015646,73.589988 54.015646,73.520997 54.002132,73.520997 53.94803,73.452007 53.961562,73.291029 53.94803,73.199041 53.97509,73.084057 53.97509,73.038063 54.042661,72.992069 54.042661,72.969073 54.09664,72.877085 54.09664,72.785098 54.123603,72.624119 54.123603,72.555129 54.110123,72.555129 54.042661,72.647116 54.042661,72.716107 54.002132,72.69311 53.961562,72.555129 53.97509,72.532132 53.934494,72.463141 53.920953,72.394151 53.934494,72.417148 54.015646,72.394151 54.110123,72.440145 54.110123,72.486138 54.137078,72.417148 54.150548,72.394151 54.164014,72.32516 54.177476,72.32516 54.204386,72.302163 54.311852,72.210176 54.35208,72.049198 54.36548,72.072195 54.325266,72.141185 54.285012,72.118188 54.244719,72.118188 54.204386,72.164182 54.204386,72.210176 54.177476,72.210176 54.137078,72.141185 54.137078,72.095191 54.164014,72.072195 54.204386,72.049198 54.204386,72.026201 54.217835,71.95721 54.231279,71.750238 54.244719,71.750238 54.137078,71.681248 54.09664,71.52027 54.110123,71.497273 54.123603,71.474276 54.164014,71.290301 54.177476,71.22131 54.110123,71.15232 54.110123,71.129323 54.150548,71.106326 54.164014,71.083329 54.204386,71.083329 54.258154,71.014338 54.271585,70.991342 54.311852,71.037335 54.338675,71.175317 54.311852,71.22131 54.36548,71.198313 54.459161,71.175317 54.459161,71.175317 54.579294,71.290301 54.619259,71.290301 54.645881,71.22131 54.699073,71.129323 54.699073,71.060332 54.765465,71.014338 54.844991,70.968345 54.871465,70.991342 54.911144,71.014338 54.977188,71.014338 55.069467,70.991342 55.108951,70.922351 55.122103,70.899354 55.1878,70.85336 55.214049,70.807367 55.292691,70.692382 55.292691,70.646389 55.266495,70.646389 55.25339,70.48541 55.266495,70.48541 55.318871,70.462414 55.410363,70.48541 55.423416,70.554401 55.488617,70.646389 55.501644,70.715379 55.540699,70.738376 55.579716,70.761373 55.592713,70.761373 55.618695,70.646389 55.618695,70.577398 55.631679,70.531404 55.683572,70.531404 55.722447,70.577398 55.748342,70.577398 55.800081,70.715379 55.800081,70.78437 55.83884,70.761373 55.851751,70.646389 55.83884,70.623392 55.825925,70.48541 55.851751,70.48541 55.890459,70.554401 55.903353,70.577398 55.916243,70.646389 55.929128,70.646389 55.942009,70.715379 55.954886,70.738376 55.993491,70.738376 56.032057,70.807367 56.044904,70.830364 56.006351,70.830364 55.980627,70.876357 55.980627,70.899354 56.096249,70.899354 56.134713,70.830364 56.147525,70.830364 56.198733,70.761373 56.237095,70.761373 56.262647,70.876357 56.300945,70.922351 56.300945,70.922351 56.377424,70.85336 56.402883,70.830364 56.390156,70.78437 56.390156,70.78437 56.453751,70.968345 56.453751,71.083329 56.517239,71.106326 56.605944,71.014338 56.669178,71.083329 56.681812,71.175317 56.643897,71.290301 56.643897,71.359292 56.631251,71.405285 56.681812,71.543267 56.669178,71.612257 56.757527,71.658251 56.757527,71.658251 56.858244,71.58926 56.946149,71.336295 57.07137,71.290301 57.096363,71.267304 57.1463,71.198313 57.183708,71.106326 57.208625,71.060332 57.332962,71.037335 57.345373,70.968345 57.370182,70.876357 57.357779,70.807367 57.370182,70.78437 57.357779,70.738376 57.308129,70.761373 57.245971,70.738376 57.233526,70.715379 57.196169,70.646389 57.196169,70.646389 57.208625,70.623392 57.208625,70.623392 57.233526,70.600395 57.270846,70.439417 57.283278,70.370426 57.345373))","code":"omsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"2","name":"Омск","time_zone":{"name":"Asia/Omsk","offset":360},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((54.824541 51.282176,54.824541 51.339677,54.893532 51.425793,54.916529 51.497433,54.916529 51.711677,54.847538 51.725925,54.870535 51.853946,54.985519 51.939092,55.077507 51.953267,55.1235 51.924912,55.330472 51.924912,55.42246 51.896539,55.514447 51.839739,55.514447 51.782868,55.606435 51.725925,55.583438 51.668909,55.537444 51.668909,55.49145 51.611822,55.514447 51.526057,55.49145 51.511747,55.42246 51.425793,55.238485 51.310935,55.1235 51.138109,55.031513 51.109241,54.916529 51.123677,54.824541 51.282176))","code":"orenburg","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"48","name":"Оренбург","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((58.343062 51.109241,58.366059 51.123677,58.343062 51.152536,58.412053 51.19579,58.389056 51.239003,58.343062 51.26779,58.343062 51.325308,58.734009 51.325308,58.87199 51.253399,58.87199 51.239003,58.940981 51.239003,59.009972 51.224603,59.009972 51.152536,59.078962 51.094801,59.055965 51.02253,58.986975 51.008062,58.87199 51.02253,58.87199 51.036993,58.803 51.036993,58.642022 51.02253,58.527037 51.080355,58.366059 51.065906,58.366059 51.094801,58.343062 51.109241))","code":"orsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"truck_graph":true},"id":"142","name":"Орск","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((35.852122 52.865079,35.852122 52.920575,35.875119 53.072825,35.967107 53.100449,36.266066 53.08664,36.31206 53.072825,36.31206 53.003687,36.335057 52.962151,36.31206 52.920575,36.174079 52.837304,36.0131 52.851193,35.94411 52.837304,35.852122 52.865079))","code":"orel","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true},"id":"71","name":"Орёл","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((72.69311 40.478212,72.69311 40.565618,72.785098 40.635461,72.877085 40.635461,72.900082 40.495702,72.854088 40.390692,72.739104 40.408205,72.69311 40.478212))","code":"osh","country_code":"kg","domain":"kg","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"171","name":"Ош","time_zone":{"name":"Asia/Bishkek","offset":360},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((76.625575 52.16536,76.648572 52.249915,76.671569 52.404515,76.717563 52.446585,76.993525 52.474609,77.223494 52.446585,77.223494 52.179463,77.246491 52.052369,77.223494 52.009924,76.993525 51.995766,76.832547 52.009924,76.763556 52.024077,76.671569 52.16536,76.625575 52.16536))","code":"pavlodar","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"111","name":"Павлодар","time_zone":{"name":"Asia/Qyzylorda","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((11.360454 45.115228,11.360454 45.309637,11.383451 45.680399,11.406448 45.728579,11.774398 45.728579,12.119351 45.712524,12.464304 45.712524,12.602285 45.680399,12.579289 45.082761,12.510298 45.066521,12.487301 45.082761,12.027364 45.082761,11.774398 45.098997,11.429445 45.098997,11.360454 45.115228))","code":"padova","country_code":"it","domain":"it","flags":{"2gis_reviews":false,"flamp":false,"gdpr":true,"metro":false,"public_transport":true,"road_network":false},"id":"66","name":"Падуя","time_zone":{"name":"Europe/Rome","offset":120},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((44.728915 53.155645,44.774908 53.169432,44.774908 53.252065,44.797905 53.265822,44.820902 53.334539,45.027874 53.375717,45.073868 53.34827,45.28084 53.34827,45.34983 53.334539,45.34983 53.238304,45.395824 53.155645,45.372827 53.059007,45.303836 53.017524,45.142858 53.031356,45.119861 53.059007,45.027874 53.059007,45.004877 53.045183,44.797905 53.059007,44.728915 53.155645))","code":"penza","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"42","name":"Пенза","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((55.537444 57.923956,55.583438 57.948372,55.606435 57.997155,55.537444 57.997155,55.560441 58.058041,55.560441 58.094522,55.652428 58.143106,55.675425 58.191624,55.744416 58.227969,55.813407 58.276371,55.905394 58.276371,56.043375 58.348851,56.112366 58.360916,56.15836 58.409137,56.089369 58.445259,56.089369 58.601361,56.204353 58.709025,56.22735 58.720967,56.296341 58.852061,56.296341 58.911485,56.250347 58.958951,56.250347 58.994508,56.181357 59.04186,56.204353 59.12457,56.22735 59.12457,56.204353 59.218851,56.388328 59.312872,56.457319 59.324606,56.457319 59.383218,56.342335 59.394928,56.342335 59.406634,56.411325 59.453418,56.52631 59.581741,56.5953 59.593382,56.664291 59.581741,56.687288 59.570095,56.779275 59.558445,56.848266 59.616653,56.940253 59.605019,56.986247 59.558445,57.147225 59.511807,57.285206 59.453418,57.285206 59.406634,57.239213 59.383218,57.170222 59.254139,57.170222 59.218851,57.101231 59.20708,57.101231 59.171743,57.055238 59.148164,57.032241 59.100959,56.986247 59.100959,56.917256 59.018192,56.96325 58.804448,56.917256 58.709025,56.848266 58.541404,56.848266 58.481344,56.917256 58.421182,56.89426 58.360916,56.89426 58.300548,56.848266 58.276371,56.848266 58.191624,56.802272 58.094522,56.825269 57.984966,56.756278 57.972772,56.756278 57.936166,56.802272 57.911742,56.802272 57.826124,56.733281 57.789369,56.618297 57.777108,56.457319 57.752576,56.457319 57.666579,56.273344 57.678877,56.250347 57.666579,56.043375 57.666579,55.974385 57.678877,55.974385 57.752576,55.882397 57.777108,55.721419 57.764844,55.698422 57.801625,55.629432 57.813876,55.560441 57.838368,55.583438 57.875073,55.537444 57.923956))","code":"perm","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"16","name":"Пермь","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((32.862529 61.863633,32.885526 62.06899,32.908523 62.090526,33.00051 62.101288,33.253476 62.090526,33.483445 62.036657,33.782404 62.025872,33.989376 62.015083,34.058366 62.047438,34.081363 62.101288,34.403319 62.155043,35.20821 62.155043,35.323194 62.122802,35.392185 62.101288,35.461176 61.982692,35.415182 61.809361,35.392185 61.798496,35.323194 61.798496,35.323194 61.787626,35.300197 61.787626,35.093226 61.754994,34.702279 61.689626,34.610291 61.689626,34.173351 61.70053,34.10436 61.711431,34.10436 61.831082,33.920385 61.863633,33.897388 61.874476,33.713413 61.885314,33.66742 61.863633,33.414454 61.874476,33.345463 61.863633,33.276473 61.831082,33.161488 61.841936,33.092498 61.831082,32.93152 61.831082,32.862529 61.863633))","code":"petrozavodsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"80","name":"Петрозаводск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((68.116733 54.950783,68.13973 54.963988,68.20872 54.963988,68.231717 55.029945,68.300708 55.069467,68.20872 55.122103,68.20872 55.161535,68.231717 55.200927,68.346701 55.1878,68.369698 55.200927,68.530676 55.200927,68.645661 55.214049,68.645661 55.24028,68.714651 55.318871,68.714651 55.358108,68.783642 55.371178,68.898626 55.331954,68.967617 55.318871,69.013611 55.318871,68.990614 55.358108,68.921623 55.371178,68.921623 55.423416,69.105598 55.423416,69.220583 55.331954,69.289573 55.331954,69.381561 55.384244,69.450551 55.345033,69.749511 55.345033,69.772507 55.331954,69.841498 55.318871,69.956482 55.214049,70.071467 55.200927,70.163454 55.161535,70.278439 55.161535,70.48541 55.279595,70.48541 55.266495,70.646389 55.25339,70.646389 55.266495,70.715379 55.292691,70.807367 55.292691,70.876357 55.1878,70.899354 55.17467,70.945348 55.108951,70.991342 55.108951,71.014338 55.043123,71.014338 54.977188,70.991342 54.911144,70.968345 54.871465,70.646389 54.844991,70.347429 54.8185,69.703517 54.791991,69.657523 54.71236,69.473548 54.499245,69.358564 54.485888,69.197586 54.485888,68.875629 54.579294,68.691654 54.605942,68.461686 54.725643,68.461686 54.791991,68.277711 54.85823,68.116733 54.950783))","code":"petropavlovsk","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"170","name":"Петропавловск","time_zone":{"name":"Asia/Almaty","offset":360},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((156.907653 53.059007,156.93065 53.072825,157.045634 53.169432,157.114625 53.169432,157.183615 53.196994,157.206612 53.252065,157.2986 53.320805,157.459578 53.334539,157.459578 53.375717,157.528568 53.416854,157.643553 53.403146,157.73554 53.403146,158.241471 53.361995,158.402449 53.375717,158.793396 53.361995,158.954374 53.320805,158.954374 53.307066,159.023365 53.265822,159.138349 53.128056,159.161346 53.114255,159.299327 52.948297,159.092355 52.823409,159.023365 52.739951,158.954374 52.712096,158.954374 52.64238,158.931377 52.628424,158.90838 52.572554,158.885384 52.558575,158.885384 52.488614,158.90838 52.474609,158.862387 52.446585,158.563427 52.432566,158.494437 52.432566,158.310462 52.376446,158.264468 52.348359,158.149484 52.348359,158.080493 52.376446,157.321596 52.64238,156.93065 52.962151,156.907653 53.059007))","code":"p_kamchatskiy","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"95","name":"Петропавловск-Камчатский","time_zone":{"name":"Asia/Kamchatka","offset":720},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((34.012373 59.546792,34.035369 59.581741,34.10436 59.581741,34.242341 59.523473,34.242341 59.488463,34.173351 59.476786,34.012373 59.546792))","code":"pikalevo","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"public_transport":true,"road_network":true},"id":"213","name":"Пикалево","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((14.212066 49.954501,14.212066 50.131727,14.235063 50.175931,14.649007 50.175931,14.717998 50.161201,14.717998 49.984084,14.695001 49.939703,14.235063 49.939703,14.212066 49.954501))","code":"praha","country_code":"cz","domain":"cz","flags":{"2gis_reviews":true,"flamp":false,"gdpr":true,"metro":true,"public_transport":true,"road_network":true},"id":"92","name":"Прага","time_zone":{"name":"Europe/Prague","offset":120},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((27.550252 57.826124,27.596246 57.850607,27.895205 57.850607,27.941199 57.875073,28.14817 57.911742,28.332145 57.8873,28.424133 57.8873,28.493124 57.862842,28.493124 57.764844,28.424133 57.728026,28.171167 57.715745,28.125174 57.740303,28.056183 57.752576,27.941199 57.715745,27.872208 57.70346,27.757224 57.752576,27.71123 57.777108,27.619242 57.789369,27.550252 57.826124))","code":"pskov","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"90","name":"Псков","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((83.93858 51.094801,83.961577 51.138109,84.076561 51.152536,84.099558 51.094801,84.145552 51.123677,84.168549 51.19579,84.191546 51.210199,84.214543 51.26779,84.329527 51.282176,84.398518 51.26779,84.536499 51.339677,84.628486 51.339677,84.697477 51.411452,84.904449 51.44013,84.973439 51.511747,85.134417 51.511747,85.157414 51.497433,85.272399 51.511747,85.272399 51.540363,85.433377 51.56896,85.479371 51.626101,85.479371 51.68317,85.594355 51.711677,85.617352 51.754405,85.617352 51.797093,85.548361 51.839739,85.594355 51.882346,85.594355 51.910728,85.548361 51.910728,85.571358 51.967438,85.594355 51.981605,85.686342 52.052369,85.709339 52.094774,85.77833 52.1089,85.916311 52.123022,85.939308 52.094774,86.100286 52.080644,86.21527 52.024077,86.238267 52.038225,86.399245 52.038225,86.445239 52.080644,86.445239 52.123022,86.629214 52.1089,86.790192 52.16536,86.767195 52.207657,86.744198 52.221748,86.767195 52.235833,86.767195 52.278064,86.698205 52.320254,86.652211 52.376446,86.675208 52.474609,86.652211 52.488614,86.652211 52.516612,86.767195 52.516612,86.790192 52.558575,86.813189 52.628424,86.905177 52.628424,86.905177 52.64238,87.020161 52.656332,87.135145 52.614463,87.181139 52.586528,87.31912 52.586528,87.388111 52.516612,87.411108 52.502615,87.61808 52.460599,87.641076 52.432566,87.779058 52.488614,87.848048 52.502615,87.894042 52.530604,88.032023 52.516612,88.193001 52.418543,88.284989 52.418543,88.307986 52.432566,88.307986 52.446585,88.42297 52.446585,88.445967 52.404515,88.445967 52.334309,88.399973 52.306195,88.376976 52.207657,88.376976 52.16536,88.353979 52.1089,88.307986 52.1089,88.215998 52.052369,88.147008 52.080644,88.078017 52.038225,88.078017 51.995766,88.009026 51.953267,87.963033 51.882346,87.940036 51.868148,87.894042 51.811313,87.986029 51.754405,88.078017 51.754405,88.101014 51.711677,88.009026 51.640375,87.986029 51.56896,87.940036 51.56896,87.940036 51.483114,88.009026 51.46879,88.078017 51.46879,88.101014 51.454462,88.170004 51.354041,88.284989 51.354041,88.307986 51.339677,88.42297 51.296558,88.537954 51.310935,88.698933 51.411452,88.675936 51.526057,88.767923 51.554663,88.813917 51.554663,88.836914 51.497433,88.997892 51.397106,88.974895 51.210199,89.043886 51.152536,89.043886 51.065906,89.204864 50.964632,89.273854 50.906663,89.388839 50.834099,89.641804 50.615729,89.641804 50.586536,89.802782 50.542712,89.825779 50.542712,89.848776 50.469583,89.825779 50.425651,89.710795 50.39634,89.687798 50.381678,89.618807 50.381678,89.572814 50.440299,89.503823 50.440299,89.480826 50.35234,89.411836 50.337664,89.365842 50.264217,89.342845 50.249514,89.342845 50.190657,89.503823 50.205378,89.52682 50.161201,89.52682 50.116983,89.572814 50.087482,89.52682 50.043196,89.59581 49.984084,89.641804 49.910093,89.664801 49.910093,89.641804 49.865643,89.687798 49.791469,89.733792 49.761768,89.733792 49.717182,89.618807 49.672555,89.503823 49.65767,89.388839 49.583177,89.296851 49.583177,89.227861 49.627886,89.204864 49.612988,89.250857 49.553349,89.135873 49.478697,88.974895 49.448804,88.905904 49.493636,88.882907 49.448804,88.813917 49.433851,88.79092 49.448804,88.698933 49.448804,88.606945 49.478697,88.445967 49.463753,88.42297 49.478697,88.353979 49.463753,88.238995 49.463753,88.170004 49.388964,88.193001 49.284068,88.032023 49.209006,87.963033 49.163914,87.802055 49.163914,87.802055 49.148874,87.733064 49.163914,87.664073 49.133829,87.526092 49.11878,87.503095 49.073606,87.434105 49.058539,87.273126 49.103727,87.296123 49.11878,87.296123 49.239044,87.181139 49.254057,87.066155 49.254057,86.95117 49.314061,86.95117 49.403931,86.836186 49.448804,86.836186 49.538427,86.744198 49.568265,86.675208 49.568265,86.606217 49.583177,86.629214 49.627886,86.698205 49.687435,86.767195 49.687435,86.767195 49.791469,86.698205 49.806313,86.629214 49.806313,86.606217 49.761768,86.537227 49.717182,86.51423 49.672555,86.399245 49.598085,86.330255 49.598085,86.261264 49.583177,86.261264 49.538427,86.21527 49.478697,86.14628 49.523501,86.077289 49.523501,86.054292 49.508571,85.962305 49.493636,85.916311 49.568265,85.824324 49.553349,85.801327 49.568265,85.663345 49.568265,85.617352 49.598085,85.502367 49.598085,85.433377 49.612988,85.272399 49.598085,85.203408 49.64278,85.203408 49.732048,85.157414 49.761768,85.111421 49.835987,85.04243 49.880464,84.973439 49.954501,85.019433 49.984084,85.04243 50.028425,84.950442 50.102235,84.835458 50.102235,84.835458 50.131727,84.766468 50.146466,84.697477 50.190657,84.490505 50.220095,84.490505 50.234807,84.352524 50.220095,84.260536 50.264217,84.237539 50.513474,84.191546 50.542712,84.122555 50.615729,84.099558 50.615729,84.099558 50.644903,84.30653 50.688632,84.490505 50.688632,84.536499 50.775966,84.559496 50.790506,84.559496 50.848621,84.490505 50.848621,84.444511 50.892159,84.467508 50.964632,84.352524 50.979114,84.329527 50.99359,84.214543 50.99359,83.984574 51.065906,83.93858 51.094801))","code":"gornoaltaysk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"27","name":"Республика Алтай","time_zone":{"name":"Asia/Barnaul","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((39.347647 47.045108,39.347647 47.295248,39.485628 47.326433,39.531622 47.357599,39.600612 47.373176,39.669603 47.419877,39.784587 47.435435,39.853578 47.450988,39.853578 47.513155,39.968562 47.513155,40.037553 47.482081,40.014556 47.388747,39.968562 47.373176,39.945565 47.310843,39.991559 47.185957,39.922569 47.139049,39.922569 47.092099,39.876575 47.060777,39.76159 47.045108,39.738594 47.060777,39.347647 47.045108))","code":"rostov","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"24","name":"Ростов-на-Дону","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((81.155959 51.511747,81.178956 51.554663,81.247946 51.56896,81.29394 51.554663,81.316937 51.511747,81.29394 51.46879,81.178956 51.46879,81.155959 51.511747))","code":"rubtsovsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"truck_graph":true},"id":"143","name":"Рубцовск","time_zone":{"name":"Asia/Barnaul","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((38.680737 58.070205,38.680737 58.118823,38.795722 58.106675,38.9567 58.106675,38.979697 58.021522,38.933703 57.997155,38.864712 57.997155,38.749728 58.058041,38.680737 58.070205))","code":"rybinsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"truck_graph":true},"id":"144","name":"Рыбинск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((39.347647 54.765465,39.347647 54.77873,39.39364 54.831748,39.462631 54.897922,39.76159 54.884696,40.014556 54.884696,40.083547 54.871465,40.083547 54.525945,40.06055 54.485888,39.462631 54.485888,39.39364 54.499245,39.39364 54.71236,39.370644 54.752195,39.347647 54.765465))","code":"ryazan","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"44","name":"Рязань","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((66.460958 66.507982,66.506952 66.617744,66.598939 66.635991,66.66793 66.635991,66.759917 66.617744,66.713924 66.581211,66.782914 66.535468,66.805911 66.471287,66.66793 66.452919,66.483955 66.498813,66.460958 66.507982))","code":"salekhard","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"truck_graph":true},"id":"160","name":"Салехард","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((49.535261 52.934438,49.650245 53.031356,49.788226 53.059007,49.811223 53.155645,49.788226 53.169432,49.788226 53.307066,49.719236 53.34827,49.673242 53.430558,49.696239 53.444257,49.788226 53.608304,49.811223 53.703705,49.903211 53.703705,50.018195 53.744525,50.133179 53.744525,50.317154 53.785305,50.432139 53.758122,50.524126 53.690089,50.57012 53.649216,50.57012 53.594658,50.662107 53.512687,50.800089 53.471642,50.984064 53.457952,51.099048 53.485328,51.37501 53.512687,51.604979 53.608304,51.627976 53.621946,51.857945 53.703705,51.949932 53.730922,52.087913 53.717316,52.11091 53.676469,52.225895 53.649216,52.202898 53.635583,52.202898 53.594658,52.133907 53.581007,51.972929 53.594658,51.857945 53.581007,51.719963 53.512687,51.535989 53.361995,51.444001 53.252065,51.260026 53.252065,51.053054 53.183216,51.00706 53.155645,50.869079 53.155645,50.777092 53.183216,50.639111 53.183216,50.547123 53.141852,50.547123 53.045183,50.409142 52.906708,49.995198 52.795608,49.604251 52.837304,49.558258 52.865079,49.535261 52.934438))","code":"samara","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":true,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"18","name":"Самара","time_zone":{"name":"Europe/Samara","offset":240},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((66.805911 39.633323,66.805911 39.70413,66.851905 39.757188,66.920895 39.774865,66.966889 39.739507,67.03588 39.739507,67.150864 39.686435,67.150864 39.526976,67.10487 39.526976,67.058877 39.562443,66.897899 39.58017,66.805911 39.633323))","code":"samarkand","country_code":"uz","domain":"uz","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"truck_graph":true},"id":"247","name":"Самарканд","time_zone":{"name":"Asia/Samarkand","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((28.309149 60.534358,28.309149 60.556975,28.562114 60.658553,28.562114 60.714848,28.631105 60.771044,28.700095 60.81593,28.769086 60.81593,28.88407 60.782272,28.861073 60.714848,28.976058 60.647283,29.045048 60.636008,29.091042 60.613447,29.206027 60.579575,29.229023 60.534358,29.275017 60.489078,29.344008 60.477748,29.344008 60.443734,29.435995 60.398327,29.435995 60.386965,29.458992 60.386965,29.504986 60.36423,29.573976 60.36423,29.642967 60.352856,29.895933 60.295929,30.079908 60.284532,30.217889 60.307322,30.424861 60.295929,30.585839 60.318712,30.792811 60.307322,30.976786 60.318712,30.976786 60.295929,31.045776 60.216064,31.09177 60.204638,31.160761 60.055748,31.160761 60.021293,31.137764 59.894649,31.206754 59.894649,31.229751 59.860026,31.114767 59.825367,31.09177 59.732766,31.045776 59.697974,31.068773 59.546792,30.999782 59.488463,30.930792 59.488463,30.815808 59.476786,30.792811 59.488463,30.677826 59.500137,30.631833 59.476786,30.539845 59.476786,30.424861 59.488463,30.332873 59.465104,30.171895 59.476786,30.125901 59.488463,30.056911 59.476786,29.941926 59.488463,29.826942 59.476786,29.527983 59.488463,29.458992 59.511807,29.458992 59.616653,29.435995 59.628282,29.435995 59.744355,29.458992 59.75594,29.458992 59.802241,29.435995 59.802241,29.435995 59.813806,29.390001 59.825367,29.412998 59.871571,29.435995 59.883112,29.435995 59.917711,29.412998 59.929237,29.344008 59.975297,28.401136 60.284532,28.355142 60.421039,28.332145 60.500404,28.309149 60.534358))","code":"spb","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":true,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"38","name":"Санкт-Петербург","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((-70.85336 -33.64176,-70.85336 -33.354102,-70.830364 -33.296456,-70.554401 -33.296456,-70.48541 -33.315676,-70.48541 -33.603461,-70.508407 -33.660903,-70.78437 -33.660903,-70.85336 -33.64176))","code":"santiago","country_code":"cl","domain":"cl","flags":{"2gis_reviews":false,"flamp":false,"gdpr":true,"metro":true,"public_transport":true,"road_network":true},"id":"101","name":"Сантьяго","time_zone":{"name":"America/Santiago","offset":-180},"type":"region","zoom_level":{"max":19,"min":9}},{"bounds":"POLYGON((44.843899 54.298434,44.958883 54.311852,45.119861 54.298434,45.487811 54.298434,45.533805 54.271585,45.510808 54.204386,45.510808 54.110123,45.694783 54.015646,45.786771 54.015646,45.809768 53.988613,45.786771 53.961562,45.71778 53.94803,45.648789 53.961562,45.533805 53.961562,45.464815 53.97509,45.28084 53.94803,45.28084 53.934494,45.257843 53.934494,45.211849 53.961562,45.050871 53.961562,44.935886 53.97509,44.866896 53.988613,44.866896 54.231279,44.843899 54.298434))","code":"saransk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"truck_graph":true},"id":"85","name":"Саранск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((45.303836 51.497433,45.326833 51.540363,45.487811 51.526057,45.556802 51.540363,45.556802 51.597539,45.533805 51.611822,45.510808 51.697426,45.579799 51.711677,45.671786 51.768639,45.740777 51.768639,45.809768 51.725925,46.016739 51.725925,46.08573 51.754405,46.08573 51.797093,46.200714 51.839739,46.407686 51.825528,46.430683 51.811313,46.407686 51.725925,46.522671 51.697426,46.568664 51.668909,46.522671 51.640375,46.499674 51.583252,46.407686 51.554663,46.361692 51.425793,46.361692 51.354041,46.338696 51.282176,46.223711 51.19579,46.108727 51.210199,45.947749 51.224603,45.648789 51.19579,45.556802 51.224603,45.487811 51.210199,45.372827 51.224603,45.34983 51.354041,45.372827 51.425793,45.326833 51.454462,45.303836 51.497433))","code":"saratov","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"43","name":"Саратов","time_zone":{"name":"Europe/Saratov","offset":240},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((77.292484 56.351948,77.292484 56.390156,77.361475 56.402883,77.476459 56.466457,77.591444 56.50455,77.591444 56.567953,77.706428 56.567953,77.752422 56.542605,77.798416 56.567953,77.798416 56.65654,77.867406 56.669178,77.844409 56.757527,77.936397 56.807919,77.98239 56.782732,78.005387 56.744919,78.074378 56.732306,78.120372 56.770132,78.120372 56.870815,78.28135 56.908501,78.28135 56.946149,78.327344 56.95869,78.442328 57.108853,79.08624 57.021332,79.3852 56.95869,79.546178 56.933604,79.592171 56.933604,79.592171 56.921055,79.75315 56.795328,79.960121 56.65654,80.259081 56.428326,80.535043 56.453751,80.535043 56.44104,80.489049 56.402883,80.374065 56.313702,80.259081 56.326455,79.75315 56.044904,79.684159 56.032057,79.638165 56.109074,79.523181 56.109074,79.408197 56.070585,79.362203 56.121896,79.293212 56.109074,79.109237 56.006351,79.109237 55.916243,79.01725 55.916243,78.994253 55.877561,78.971256 55.813005,78.925262 55.787153,78.902265 55.748342,78.833275 55.748342,78.810278 55.787153,78.695293 55.800081,78.626303 55.825925,78.511319 55.813005,78.488322 55.825925,78.488322 55.890459,78.35034 55.890459,78.212359 55.864658,78.097375 55.864658,78.028384 55.877561,78.028384 55.916243,78.212359 55.967759,78.258353 55.967759,78.258353 55.993491,78.212359 56.019206,78.212359 56.057747,78.235356 56.121896,78.166365 56.185938,77.936397 56.185938,77.867406 56.173138,77.798416 56.173138,77.729425 56.147525,77.660434 56.160334,77.637437 56.198733,77.706428 56.262647,77.706428 56.275417,77.660434 56.313702,77.568447 56.326455,77.430466 56.300945,77.315481 56.313702,77.292484 56.351948))","code":"severnoe","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"public_transport":false,"road_network":true,"truck_graph":true},"id":"188","name":"Северное","time_zone":{"name":"Asia/Novosibirsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((76.579581 49.418893,76.602578 49.463753,76.717563 49.493636,76.832547 49.508571,77.039519 49.553349,77.154503 49.65767,77.1775 49.702311,77.154503 49.835987,77.154503 49.9249,77.223494 49.939703,77.269487 49.969295,77.407469 50.013649,77.499456 50.057963,77.568447 50.102235,77.683431 50.146466,77.706428 50.220095,77.798416 50.220095,77.890403 50.161201,78.327344 50.057963,78.442328 50.043196,78.511319 50.057963,78.626303 50.102235,78.787281 50.308299,78.764284 50.381678,78.764284 50.440299,78.672297 50.469583,78.672297 50.601134,78.695293 50.615729,78.695293 50.644903,78.672297 50.688632,78.534315 50.688632,78.465325 50.717761,78.465325 50.834099,78.419331 50.834099,78.35034 50.877651,78.28135 50.877651,78.189362 51.02253,78.143369 51.02253,78.120372 51.065906,78.097375 51.080355,78.120372 51.094801,78.120372 51.152536,78.258353 51.19579,78.304347 51.224603,78.511319 51.224603,78.672297 51.296558,78.787281 51.310935,78.787281 51.354041,78.741287 51.411452,78.787281 51.454462,78.971256 51.454462,79.08624 51.511747,79.08624 51.597539,79.224222 51.626101,79.247218 51.68317,79.270215 51.697426,79.339206 51.711677,79.500184 51.497433,79.845137 51.051452,79.868134 51.008062,80.006115 50.834099,80.029112 50.790506,80.075106 50.775966,80.075106 50.834099,80.167093 50.834099,80.213087 50.906663,80.328071 50.921162,80.397062 50.935657,80.489049 51.008062,80.489049 51.109241,80.443056 51.138109,80.443056 51.19579,80.512046 51.210199,80.604034 51.210199,80.650028 51.296558,80.788009 51.296558,80.902993 51.26779,80.948987 51.224603,80.971984 51.210199,81.040974 51.19579,81.063971 51.181376,81.132962 51.19579,81.178956 51.166958,81.155959 51.080355,81.086968 51.036993,81.086968 50.950147,81.201952 50.950147,81.339934 50.979114,81.408924 50.964632,81.454918 50.848621,81.477915 50.834099,81.454918 50.775966,81.523909 50.746873,81.592899 50.746873,81.615896 50.688632,81.638893 50.688632,81.66189 50.615729,81.66189 50.557325,81.707884 50.528096,81.684887 50.39634,81.684887 50.308299,81.615896 50.29361,81.500912 50.308299,81.477915 50.322984,81.385927 50.322984,81.362931 50.278916,81.362931 50.234807,81.201952 50.249514,81.109965 50.220095,81.109965 50.175931,81.224949 50.131727,81.362931 50.131727,81.339934 49.969295,81.477915 49.954501,81.569902 49.895281,81.684887 49.865643,81.707884 49.821152,81.684887 49.776621,81.638893 49.74691,81.66189 49.732048,81.730881 49.732048,81.822868 49.627886,81.868862 49.612988,82.052837 49.523501,82.075834 49.433851,82.167821 49.388964,82.305802 49.388964,82.39779 49.329051,82.535771 49.329051,82.604762 49.269065,82.627758 49.224027,82.673752 49.19398,82.696749 49.088669,82.719746 49.013309,82.811733 48.968039,82.903721 48.968039,82.926718 48.922727,82.903721 48.877375,82.83473 48.831981,82.83473 48.756233,82.880724 48.756233,82.880724 48.81684,82.949715 48.801695,82.949715 48.756233,83.156687 48.756233,83.179683 48.710729,83.156687 48.680371,83.179683 48.665185,83.225677 48.589185,83.340661 48.54353,83.409652 48.528303,83.455646 48.452097,83.616624 48.406319,83.616624 48.360499,83.50164 48.284042,83.50164 48.253426,82.995708 47.961667,82.995708 47.807444,82.972712 47.791997,83.018705 47.699215,83.13369 47.637269,83.156687 47.62177,83.156687 47.544211,83.225677 47.466537,83.179683 47.295248,83.156687 47.217206,83.064699 47.217206,83.041702 47.170326,83.041702 47.123404,82.972712 47.013758,82.949715 46.966698,82.880724 46.762292,82.83473 46.730776,82.76574 46.541292,82.604762 46.27172,82.535771 46.160333,82.489777 45.984839,82.420787 45.952871,82.351796 45.904885,82.374793 45.808787,82.305802 45.696464,82.305802 45.632177,82.282805 45.583914,82.259809 45.583914,82.144824 45.696464,82.121827 45.712524,82.052837 45.824815,81.983846 45.88888,81.960849 45.904885,81.868862 46.112526,81.753877 46.160333,81.684887 46.239918,81.569902 46.319388,81.523909 46.398743,81.546906 46.493817,81.477915 46.557107,81.385927 46.541292,81.247946 46.493817,81.155959 46.557107,80.856999 46.572919,80.650028 46.636117,80.443056 46.715011,80.420059 46.730776,80.374065 46.730776,80.305074 46.778043,80.213087 46.79379,80.19009 46.872453,80.1211 46.888172,80.098103 46.903887,79.868134 46.888172,79.707156 46.919596,79.270215 47.07644,79.040247 47.060777,78.833275 47.045108,78.741287 47.139049,78.672297 47.139049,78.603306 47.185957,78.465325 47.232824,78.327344 47.310843,78.258353 47.295248,78.189362 47.217206,78.120372 47.217206,78.074378 47.248437,78.005387 47.264045,77.890403 47.185957,77.798416 47.185957,77.614441 47.217206,77.476459 47.15469,77.269487 47.170326,77.200497 47.139049,77.200497 47.092099,77.131506 47.07644,76.947531 47.15469,76.832547 47.217206,76.832547 47.264045,76.878541 47.373176,76.901538 47.419877,77.039519 47.419877,77.039519 47.450988,76.993525 47.683735,77.039519 47.838326,77.131506 47.869189,77.131506 47.915449,77.1775 47.946266,77.200497 48.038607,77.315481 48.053981,77.315481 48.100075,77.246491 48.115431,77.154503 48.115431,77.062516 48.161471,77.062516 48.222793,77.131506 48.238112,77.131506 48.284042,77.016522 48.284042,76.924534 48.345217,76.855544 48.360499,76.855544 48.39105,76.878541 48.406319,76.901538 48.452097,76.947531 48.497834,77.154503 48.497834,77.292484 48.619599,77.315481 48.665185,77.315481 48.801695,77.292484 48.847117,77.154503 48.847117,76.878541 48.81684,76.855544 48.847117,76.832547 48.983134,76.878541 49.02839,76.993525 49.02839,76.993525 49.073606,76.924534 49.133829,76.855544 49.133829,76.80955 49.224027,76.602578 49.329051,76.579581 49.418893),(83.156687 48.680371,83.087696 48.710729,83.041702 48.710729,83.041702 48.634798,83.110693 48.619599,83.156687 48.680371))","code":"semey","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"169","name":"Семей","time_zone":{"name":"Asia/Almaty","offset":360},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((28.033186 59.053688,28.033186 59.136369,28.102177 59.148164,28.217161 59.136369,28.240158 59.112766,28.194164 59.065512,28.033186 59.053688))","code":"slantsy","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"public_transport":true,"road_network":true},"id":"215","name":"Сланцы","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((31.758679 54.738921,31.758679 54.805248,31.804673 54.884696,31.988648 54.884696,32.057639 54.897922,32.172623 54.937574,32.241614 54.897922,32.26461 54.831748,32.26461 54.752195,32.172623 54.699073,32.057639 54.685782,31.804673 54.685782,31.758679 54.738921))","code":"smolensk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"truck_graph":true},"id":"63","name":"Смоленск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((38.496763 44.13321,38.496763 44.149714,38.611747 44.330943,38.634744 44.380272,38.680737 44.44598,38.680737 44.495212,38.795722 44.495212,38.818719 44.511614,38.9567 44.478806,38.9567 44.413135,39.025691 44.396706,39.094681 44.44598,39.255659 44.44598,39.278656 44.42956,39.278656 44.347391,39.255659 44.265106,39.416637 44.116703,39.439634 44.116703,39.715597 43.967926,39.76159 43.934814,39.968562 43.934814,40.037553 43.885111,40.106544 43.868534,40.175534 43.868534,40.221528 43.78558,40.290518 43.768976,40.359509 43.768976,40.451497 43.702512,40.474493 43.652615,40.612475 43.586022,40.658468 43.552697,40.658468 43.536028,40.566481 43.502676,40.49749 43.502676,40.451497 43.536028,40.290518 43.552697,40.290518 43.569362,40.12954 43.552697,40.037553 43.419216,40.014556 43.33564,39.991559 43.318911,39.899572 43.21844,39.830581 43.21844,39.6926 43.268696,39.623609 43.352364,39.508625 43.419216,39.485628 43.435917,39.232662 43.652615,39.163672 43.735753,39.094681 43.752367,39.025691 43.835366,38.9567 43.851952,38.726731 44.01756,38.657741 44.050626,38.565753 44.116703,38.496763 44.13321))","code":"sochi","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"30","name":"Сочи","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((41.670331 44.952712,41.693328 45.066521,41.670331 45.066521,41.670331 45.180105,41.716324 45.244908,41.808312 45.261097,41.900299 45.228714,41.96929 45.244908,41.992287 45.261097,42.153265 45.277282,42.222256 45.244908,42.33724 45.180105,42.360237 45.098997,42.291246 44.985252,42.130268 44.936435,42.084274 44.903867,41.693328 44.903867,41.670331 44.952712))","code":"stavropol","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"57","name":"Ставрополь","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((37.714869 51.26779,37.714869 51.310935,37.737866 51.325308,37.714869 51.3684,37.737866 51.411452,37.944838 51.425793,38.059822 51.3684,38.082819 51.354041,38.082819 51.339677,38.036825 51.310935,38.059822 51.210199,38.036825 51.19579,37.990831 51.109241,37.898844 51.109241,37.829853 51.19579,37.714869 51.26779))","code":"staroskol","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"truck_graph":true},"id":"60","name":"Старый Оскол","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((55.721419 53.444257,55.721419 53.49901,55.79041 53.553692,55.813407 53.567352,55.813407 53.676469,55.951388 53.758122,55.974385 53.744525,56.066372 53.744525,56.135363 53.717316,56.15836 53.581007,56.135363 53.567352,56.135363 53.34827,56.112366 53.307066,55.905394 53.307066,55.836403 53.334539,55.767413 53.416854,55.721419 53.444257))","code":"sterlitamak","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"54","name":"Стерлитамак","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((72.394151 61.19493,72.394151 61.39375,73.612985 61.404759,73.79696 61.415764,73.773963 61.360701,73.79696 61.261343,73.79696 61.028282,73.773963 60.994847,73.383016 60.994847,72.946076 60.983694,72.417148 60.983694,72.417148 61.005996,72.394151 61.19493))","code":"surgut","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"39","name":"Сургут","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((50.156176 61.591314,50.20217 61.65689,50.271161 61.70053,50.294157 61.711431,50.294157 61.787626,50.386145 61.798496,50.409142 61.809361,50.478132 61.971888,50.524126 62.00429,50.616114 62.00429,50.708101 61.96108,50.800089 61.96108,50.961067 61.950267,51.030057 61.939452,51.053054 61.89615,51.283023 61.874476,51.30602 61.831082,51.329017 61.820223,51.444001 61.809361,51.444001 61.754994,51.37501 61.678718,51.30602 61.689626,51.237029 61.667806,51.237029 61.624119,51.191035 61.580371,51.122045 61.591314,51.053054 61.580371,51.00706 61.525599,50.93807 61.525599,50.754095 61.547519,50.593117 61.514633,50.432139 61.514633,50.317154 61.569424,50.225167 61.569424,50.156176 61.591314))","code":"syktyvkar","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"72","name":"Сыктывкар","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((32.471582 60.136003,32.471582 60.170339,32.540573 60.170339,32.609563 60.158898,32.609563 60.12455,32.540573 60.12455,32.471582 60.136003))","code":"syasstroy","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"public_transport":false,"road_network":true},"id":"214","name":"Сясьстрой","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((34.426316 27.936419,34.47231 28.037956,34.449313 28.058252,34.47231 28.159674,34.449313 28.220481,34.518304 28.220481,34.518304 28.301504,34.541301 28.32175,34.656285 28.544201,34.656285 28.645161,34.702279 28.806494,34.702279 28.887067,34.748272 28.967577,34.748272 29.10832,34.771269 29.10832,34.84026 29.369189,34.932247 29.389229,34.955244 29.369189,35.047232 29.369189,35.277201 29.329099,35.323194 29.309048,35.507169 29.288993,35.737138 29.248871,35.852122 29.248871,35.990104 29.208733,36.082091 29.208733,36.128085 29.248871,36.473038 29.509381,36.703007 29.849039,36.726003 29.868984,36.863985 29.90886,37.024963 29.928792,37.461903 30.008481,37.507897 29.928792,37.576888 29.90886,37.645878 29.849039,37.714869 29.829091,37.714869 29.689343,37.737866 29.669363,37.714869 29.629392,37.737866 29.569404,37.944838 29.549401,37.990831 29.589404,38.036825 29.589404,38.197803 29.529393,38.197803 29.509381,38.312788 29.369189,38.312788 29.288993,38.2208 29.208733,38.197803 29.148497,38.197803 29.027919,38.266794 29.007809,38.335784 29.007809,38.404775 29.10832,38.404775 29.208733,38.473766 29.208733,38.542756 29.288993,38.565753 29.309048,38.634744 29.309048,38.680737 29.268934,38.749728 29.268934,38.772725 29.208733,38.772725 28.947456,38.910706 28.9072,39.002694 28.806494,39.025691 28.685517,39.048687 28.624977,39.186669 28.624977,39.209666 28.564401,39.209666 28.382465,39.186669 28.32175,39.140675 28.281254,39.140675 28.240743,39.186669 28.240743,39.186669 28.220481,39.232662 28.220481,39.255659 28.200216,39.39364 28.139397,39.39364 28.058252,39.301653 28.017656,39.209666 28.017656,39.255659 27.977045,39.531622 27.977045,39.623609 27.895777,39.738594 27.834786,39.830581 27.753411,39.922569 27.610859,39.922569 27.447715,39.945565 27.427305,39.922569 27.325198,39.991559 27.263889,40.037553 27.141169,40.014556 27.120702,39.922569 27.141169,39.853578 27.202545,39.76159 27.202545,39.738594 27.120702,39.807584 27.079758,39.830581 27.05928,39.807584 27.038799,39.669603 27.038799,39.600612 26.936336,39.531622 26.792731,39.531622 26.772201,39.278656 26.751668,39.163672 26.792731,38.9567 26.792731,38.933703 26.813257,38.864712 26.83378,38.841716 26.813257,38.726731 26.792731,38.703734 26.813257,38.473766 26.854298,38.450769 26.956836,38.312788 27.018314,38.289791 27.079758,38.128813 27.18209,38.105816 27.18209,38.059822 27.141169,37.967834 27.141169,37.944838 27.406891,37.898844 27.447715,37.737866 27.427305,37.691872 27.468121,37.438906 27.447715,37.41591 27.406891,37.323922 27.406891,37.254931 27.468121,37.04796 27.468121,36.932975 27.447715,36.932975 27.406891,36.817991 27.386473,36.794994 27.325198,36.749 27.325198,36.68001 27.304765,36.726003 27.263889,36.726003 27.202545,36.863985 27.079758,36.932975 27.05928,36.932975 26.956836,36.955972 26.854298,37.04796 26.83378,37.11695 26.73113,37.093953 26.587266,37.11695 26.525554,37.208938 26.44322,37.185941 26.381431,37.208938 26.319609,37.323922 26.319609,37.323922 26.257754,37.438906 26.092645,37.507897 26.07199,37.553891 25.947984,37.530894 25.885932,37.599885 25.803145,37.760863 25.782439,37.829853 25.741017,37.829853 25.658129,37.714869 25.595925,37.714869 25.554438,37.737866 25.533689,37.78386 25.42989,37.78386 25.263626,37.85285 25.180408,37.829853 25.076306,37.898844 25.013802,37.921841 24.930414,38.036825 24.867836,38.036825 24.805227,37.921841 24.805227,37.806856 24.78435,37.806856 24.679912,37.576888 24.679912,37.507897 24.700807,37.461903 24.659015,37.070956 24.219352,37.070956 24.198378,36.978969 24.219352,36.909978 24.366077,36.749 24.84697,36.726003 24.867836,36.634016 25.117957,36.450041 25.284421,36.266066 25.533689,36.243069 25.595925,36.243069 25.69958,36.289063 25.823847,36.266066 25.968661,36.128085 26.092645,36.036097 26.257754,35.898116 26.381431,35.829125 26.484394,35.806129 26.504976,35.599157 26.813257,35.530166 26.936336,35.507169 27.018314,35.346191 27.243445,35.323194 27.263889,35.323194 27.304765,35.254204 27.366052,35.254204 27.386473,35.300197 27.427305,35.323194 27.427305,35.622154 27.549708,35.64515 27.733058,35.507169 28.098832,35.369188 28.159674,35.323194 28.159674,35.116222 28.179947,35.047232 28.179947,34.932247 28.098832,34.702279 27.733058,34.679282 27.671976,34.518304 27.69234,34.449313 27.794106,34.449313 27.87545,34.426316 27.936419))","code":"tabuk","country_code":"sa","domain":"sa","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true},"id":"224","name":"Табук","time_zone":{"name":"Asia/Riyadh","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((38.795722 47.217206,38.818719 47.279649,38.9567 47.279649,38.979697 47.201584,38.9567 47.185957,38.864712 47.185957,38.795722 47.217206))","code":"taganrog","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"116","name":"Таганрог","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((41.23339 52.795608,41.256387 52.837304,41.417365 52.837304,41.509353 52.878959,41.555346 52.823409,41.624337 52.823409,41.647334 52.7817,41.624337 52.767788,41.60134 52.698162,41.624337 52.600498,41.578343 52.558575,41.325378 52.572554,41.256387 52.586528,41.256387 52.7817,41.23339 52.795608))","code":"tambov","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"81","name":"Тамбов","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((71.244307 42.781152,71.244307 42.949708,71.313298 42.966538,71.451279 42.966538,71.474276 42.916033,71.497273 42.899189,71.474276 42.8149,71.359292 42.8149,71.313298 42.781152,71.244307 42.781152))","code":"taraz","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"221","name":"Тараз","time_zone":{"name":"Asia/Almaty","offset":360},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((75.107782 55.371178,75.130778 55.410363,75.176772 55.423416,75.153775 55.462549,75.291757 55.501644,75.291757 55.540699,75.406741 55.553709,75.429738 55.540699,75.521725 55.501644,75.567719 55.501644,75.567719 55.436465,75.544722 55.423416,75.613713 55.397306,75.659706 55.423416,75.682703 55.462549,75.820685 55.488617,75.889675 55.527685,75.912672 55.527685,76.027656 55.488617,76.119644 55.488617,76.142641 55.514667,76.280622 55.514667,76.303619 55.553709,76.395606 55.553709,76.418603 55.514667,76.395606 55.475585,76.395606 55.436465,76.326616 55.410363,76.234628 55.410363,76.211631 55.371178,76.372609 55.279595,76.372609 55.200927,76.326616 55.200927,76.326616 55.135251,76.464597 55.082633,76.464597 55.056298,76.418603 55.043123,76.326616 55.003575,76.280622 54.977188,76.188635 54.937574,76.211631 54.85823,76.096647 54.791991,76.027656 54.791991,75.866678 54.765465,75.751694 54.725643,75.751694 54.685782,75.7057 54.659186,75.659706 54.685782,75.659706 54.738921,75.590716 54.805248,75.498728 54.805248,75.475732 54.871465,75.475732 54.897922,75.406741 54.884696,75.33775 54.884696,75.314753 54.911144,75.383744 55.003575,75.314753 55.069467,75.291757 55.082633,75.26876 55.122103,75.245763 55.135251,75.26876 55.1878,75.245763 55.200927,75.245763 55.24028,75.199769 55.25339,75.176772 55.318871,75.107782 55.371178))","code":"tatarsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true,"truck_graph":true},"id":"189","name":"Татарск","time_zone":{"name":"Asia/Novosibirsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((69.128595 41.226176,69.151592 41.3126,69.174589 41.329871,69.197586 41.381657,69.266576 41.39891,69.289573 41.450641,69.427554 41.485105,69.427554 41.553979,69.542539 41.571186,69.611529 41.657152,69.749511 41.691506,69.772507 41.708677,69.933486 41.708677,69.979479 41.777312,70.071467 41.794459,70.071467 41.82874,70.140457 41.845874,70.324432 41.982778,70.324432 42.034041,70.439417 42.085263,70.531404 42.085263,70.577398 42.016958,70.646389 42.016958,70.646389 42.034041,70.669385 42.034041,70.761373 41.965681,70.761373 41.931473,70.646389 41.880127,70.646389 41.863003,70.347429 41.639968,70.209448 41.605586,70.186451 41.553979,70.163454 41.553979,70.002476 41.450641,69.933486 41.39891,69.703517 41.39891,69.542539 41.364399,69.519542 41.347138,69.31257 41.174266,69.220583 41.174266,69.128595 41.226176))","code":"tashkent","country_code":"uz","domain":"uz","flags":{"2gis_reviews":true,"flamp":false,"metro":true,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"208","name":"Ташкент","time_zone":{"name":"Asia/Tashkent","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((35.530166 56.870815,35.530166 56.908501,35.553163 56.971227,35.691144 57.008812,35.737138 57.008812,35.806129 57.046359,35.898116 57.046359,36.31206 56.971227,36.358053 56.895943,36.335057 56.807919,36.335057 56.732306,36.266066 56.681812,36.082091 56.681812,35.829125 56.669178,35.622154 56.681812,35.553163 56.707067,35.57616 56.845669,35.530166 56.870815))","code":"tver","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"47","name":"Тверь","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((68.024745 57.899523,68.116733 57.923956,68.047742 57.972772,68.024745 57.984966,68.024745 58.324707,68.093736 58.336781,68.254714 58.348851,68.277711 58.336781,68.346701 58.360916,68.346701 58.397088,68.323705 58.433222,68.369698 58.457292,68.415692 58.517392,68.484683 58.50538,68.599667 58.50538,68.622664 58.517392,68.691654 58.50538,68.691654 58.46932,68.622664 58.433222,68.622664 58.143106,68.645661 58.082366,68.714651 58.082366,68.783642 58.009341,68.829636 58.009341,68.875629 58.033699,68.94462 58.021522,69.013611 57.960574,69.105598 57.911742,69.082601 57.875073,68.323705 57.838368,68.300708 57.850607,68.093736 57.862842,68.024745 57.899523))","code":"tobolsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"97","name":"Тобольск","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((47.948477 53.361995,48.017467 53.403146,48.040464 53.471642,48.132452 53.485328,48.339423 53.471642,48.408414 53.567352,48.339423 53.608304,48.36242 53.649216,48.454408 53.649216,48.523398 53.662845,48.477405 53.744525,48.546395 53.758122,48.66138 53.717316,48.73037 53.730922,48.799361 53.717316,48.914345 53.703705,48.983336 53.717316,49.006333 53.866747,49.213305 53.866747,49.259298 53.839617,49.328289 53.853184,49.351286 53.866747,49.581254 53.839617,49.604251 53.826046,49.627248 53.839617,49.719236 53.839617,49.788226 53.880305,49.811223 53.880305,49.857217 53.826046,49.857217 53.785305,49.811223 53.703705,49.788226 53.608304,49.696239 53.444257,49.673242 53.430558,49.719236 53.34827,49.788226 53.307066,49.788226 53.169432,49.811223 53.155645,49.788226 53.059007,49.650245 53.031356,49.581254 53.045183,49.46627 53.045183,49.397279 53.017524,49.351286 52.989846,49.190308 53.003687,49.190308 52.948297,49.006333 52.892836,48.960339 52.892836,48.937342 52.934438,48.822358 52.948297,48.753367 52.962151,48.73037 52.976001,48.523398 52.989846,48.523398 52.948297,48.408414 52.962151,48.339423 52.989846,48.339423 53.059007,48.29343 53.059007,48.224439 53.031356,48.155448 53.045183,48.178445 53.141852,48.109455 53.183216,48.155448 53.238304,48.040464 53.279574,48.040464 53.307066,47.971473 53.320805,47.948477 53.361995))","code":"togliatti","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"22","name":"Тольятти","time_zone":{"name":"Europe/Samara","offset":240},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((83.225677 55.748342,83.294668 55.813005,83.478643 55.916243,83.86959 56.185938,83.754605 56.567953,83.961577 56.681812,84.398518 56.744919,84.421514 56.782732,84.421514 56.83309,84.444511 56.921055,84.697477 56.908501,85.226405 56.883381,85.77833 56.98376,85.893314 57.046359,86.14628 57.158773,86.21527 57.158773,86.284261 57.096363,86.353252 56.98376,86.468236 56.946149,86.468236 56.908501,86.58322 56.883381,86.606217 56.845669,86.721202 56.858244,86.767195 56.820507,86.767195 56.782732,86.652211 56.782732,86.192274 56.845669,86.14628 56.757527,86.14628 56.643897,86.238267 56.643897,86.238267 56.631251,86.192274 56.605944,86.192274 56.567953,86.123283 56.555281,86.123283 56.517239,86.100286 56.479159,86.008299 56.479159,85.962305 56.428326,85.893314 56.428326,85.824324 56.415607,85.77833 56.339204,85.709339 56.339204,85.594355 56.300945,85.594355 56.249873,85.663345 56.237095,85.640349 56.211525,85.525364 56.211525,85.41038 56.198733,85.318392 56.224312,85.249402 56.224312,85.203408 56.198733,85.134417 56.198733,85.065427 56.134713,84.996436 56.121896,84.950442 56.147525,84.858455 56.147525,84.536499 56.070585,84.467508 56.044904,84.398518 56.032057,84.375521 55.993491,84.329527 55.993491,84.237539 56.044904,84.168549 56.044904,84.145552 56.032057,83.984574 56.019206,83.915583 55.980627,83.754605 55.83884,83.731608 55.787153,83.662618 55.77422,83.662618 55.735397,83.616624 55.696535,83.593627 55.683572,83.409652 55.709493,83.248674 55.709493,83.225677 55.748342))","code":"tomsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"3","name":"Томск","time_zone":{"name":"Asia/Tomsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((37.392913 54.244719,37.41591 54.311852,37.507897 54.311852,37.576888 54.325266,37.691872 54.311852,37.714869 54.325266,37.898844 54.311852,38.013828 54.35208,38.174806 54.35208,38.197803 54.36548,38.312788 54.35208,38.312788 54.325266,38.358781 54.325266,38.450769 54.244719,38.473766 54.204386,38.496763 54.204386,38.519759 54.137078,38.58875 54.123603,38.58875 54.002132,38.611747 53.988613,38.519759 53.893859,38.427772 53.826046,38.335784 53.826046,38.197803 53.866747,38.197803 53.893859,37.990831 53.907408,37.599885 53.907408,37.438906 53.893859,37.41591 54.015646,37.41591 54.204386,37.392913 54.244719))","code":"tula","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"36","name":"Тула","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((68.13973 43.235197,68.13973 43.302177,68.185723 43.352364,68.277711 43.352364,68.346701 43.385799,68.438689 43.536028,68.599667 43.552697,68.622664 43.502676,68.599667 43.452614,68.599667 43.318911,68.50768 43.285439,68.277711 43.21844,68.13973 43.235197))","code":"turkestan","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"truck_graph":true},"id":"232","name":"Туркестан","time_zone":{"name":"Asia/Almaty","offset":360},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((64.851177 57.295705,64.874174 57.38258,64.874174 57.45688,64.897171 57.45688,64.966161 57.444507,65.127139 57.407363,65.127139 57.38258,65.219127 57.38258,65.288118 57.345373,65.56408 57.295705,65.771052 57.308129,65.771052 57.345373,65.93203 57.345373,65.955027 57.295705,66.116005 57.258411,66.139002 57.245971,66.253986 57.258411,66.36897 57.245971,66.460958 57.245971,66.483955 57.283278,66.598939 57.295705,66.644933 57.357779,66.805911 57.357779,66.943892 57.38258,67.081874 57.50633,67.173861 57.568048,67.242852 57.543373,67.242852 57.50633,67.265848 57.481613,67.288845 57.419749,67.03588 57.158773,67.03588 56.946149,66.920895 56.757527,66.644933 56.707067,66.621936 56.593285,66.621936 56.415607,66.552945 56.402883,65.840042 56.415607,65.633071 56.415607,65.426099 56.428326,65.334111 56.402883,65.265121 56.415607,65.19613 56.453751,65.219127 56.491856,65.219127 56.580621,65.242124 56.845669,65.242124 56.895943,65.081146 56.895943,65.058149 56.933604,65.012155 57.021332,64.966161 57.171243,64.989158 57.208625,64.989158 57.221078,64.897171 57.295705,64.851177 57.295705))","code":"tyumen","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"13","name":"Тюмень","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((78.902265 55.292691,78.925262 55.305783,78.994253 55.305783,78.971256 55.397306,79.01725 55.475585,79.08624 55.514667,79.155231 55.475585,79.270215 55.475585,79.316209 55.527685,79.3852 55.540699,79.500184 55.618695,79.523181 55.657634,79.615168 55.670605,79.615168 55.709493,79.730153 55.748342,79.730153 55.787153,79.684159 55.813005,79.707156 55.954886,79.684159 55.967759,79.684159 56.032057,79.75315 56.044904,80.259081 56.326455,80.374065 56.313702,80.489049 56.402883,80.535043 56.44104,80.535043 56.453751,80.834003 56.491856,80.994981 56.517239,81.155959 56.529924,81.247946 56.529924,81.316937 56.466457,81.477915 56.326455,81.546906 56.237095,81.592899 56.237095,81.615896 56.198733,81.776874 56.006351,81.776874 55.967759,81.29394 55.813005,81.063971 55.735397,81.063971 55.644659,80.856999 55.605706,80.742015 55.618695,80.650028 55.592713,80.489049 55.553709,80.374065 55.540699,80.328071 55.566715,80.213087 55.566715,80.006115 55.371178,80.006115 55.331954,79.868134 55.292691,79.868134 55.214049,79.82214 55.135251,79.845137 55.122103,79.914128 55.122103,79.914128 55.082633,79.82214 55.016762,79.730153 55.003575,79.569175 54.990384,79.569175 54.950783,79.592171 54.937574,79.569175 54.85823,79.546178 54.831748,79.431193 54.805248,79.293212 54.805248,79.270215 54.844991,79.178228 54.871465,79.178228 54.924361,78.994253 55.003575,78.994253 55.043123,78.971256 55.108951,78.925262 55.135251,78.948259 55.24028,78.925262 55.25339,78.902265 55.292691))","code":"ubinskoe","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":false,"truck_graph":true},"id":"190","name":"Убинское","time_zone":{"name":"Asia/Novosibirsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((100.634309 51.711677,100.680302 51.768639,100.910271 51.768639,101.14024 51.797093,101.163237 51.782868,101.232227 51.768639,101.393205 51.797093,101.50819 51.797093,101.669168 51.839739,101.922133 51.853946,101.968127 51.882346,102.152102 51.939092,102.175099 51.953267,102.405068 51.981605,102.566046 51.924912,102.635036 51.882346,102.796015 51.896539,102.819011 51.939092,102.819011 51.967438,102.910999 51.910728,103.071977 51.896539,103.094974 51.853946,103.209958 51.825528,103.232955 51.811313,103.531914 51.725925,103.646899 51.740167,103.623902 51.668909,103.600905 51.654644,103.600905 51.597539,103.715889 51.583252,103.876868 51.56896,103.899864 51.554663,104.129833 51.483114,104.244817 51.46879,104.52078 51.44013,104.612767 51.425793,104.635764 51.46879,104.589771 51.611822,104.635764 51.640375,104.796742 51.654644,105.095702 51.697426,105.118699 51.711677,105.279677 51.740167,105.302674 51.754405,105.371664 51.768639,105.578636 51.839739,105.831602 51.995766,105.946586 52.137139,105.969583 52.137139,105.969583 52.16536,105.99258 52.179463,106.176555 52.362405,106.521508 52.502615,107.004442 52.712096,107.418386 52.934438,108.016304 53.238304,108.085295 53.320805,108.085295 53.361995,108.154286 53.457952,108.292267 53.676469,108.384254 53.758122,108.453245 53.853184,108.545232 53.920953,108.568229 53.94803,108.683214 54.042661,108.844192 54.190933,108.844192 54.204386,108.867189 54.204386,108.890185 54.231279,108.959176 54.271585,108.982173 54.258154,109.212142 54.217835,109.235139 54.204386,109.281132 54.204386,109.304129 54.190933,109.534098 54.150548,109.580092 54.110123,109.603088 54.069659,109.626085 54.056163,109.902048 54.015646,110.10902 53.94803,110.201007 53.934494,110.224004 53.893859,110.155013 53.853184,110.063026 53.839617,109.994035 53.771716,109.833057 53.676469,109.787063 53.608304,109.718073 53.581007,109.695076 53.567352,109.672079 53.457952,109.580092 53.403146,109.580092 53.334539,109.235139 52.906708,109.189145 52.865079,109.07416 52.851193,108.913182 52.7817,108.913182 52.753872,108.890185 52.753872,108.821195 52.656332,108.752204 52.614463,108.729207 52.544592,108.706211 52.502615,108.614223 52.502615,108.453245 52.390483,108.453245 52.362405,108.430248 52.348359,108.361257 52.263992,108.338261 52.249915,108.315264 52.193563,108.246273 52.179463,108.200279 52.137139,108.177282 52.052369,108.154286 52.038225,108.131289 51.939092,108.177282 51.896539,108.154286 51.853946,108.085295 51.811313,108.039301 51.711677,108.016304 51.668909,107.993308 51.654644,107.947314 51.583252,107.832329 51.56896,107.809333 51.583252,107.809333 51.597539,107.694348 51.611822,107.602361 51.56896,107.556367 51.540363,107.556367 51.497433,107.464379 51.454462,107.349395 51.454462,107.234411 51.3684,107.234411 51.282176,107.188417 51.166958,107.119426 51.080355,107.09643 50.950147,107.119426 50.863138,107.09643 50.819572,107.142423 50.761422,107.142423 50.615729,107.119426 50.586536,106.981445 50.586536,106.958448 50.542712,106.935451 50.469583,106.912455 50.454943,106.889458 50.410998,106.958448 50.337664,107.004442 50.249514,106.958448 50.220095,106.889458 50.234807,106.843464 50.264217,106.72848 50.308299,106.567501 50.322984,106.291539 50.29361,106.199552 50.308299,106.176555 50.322984,106.084567 50.322984,106.015577 50.39634,105.99258 50.410998,106.084567 50.819572,106.199552 50.892159,106.199552 51.094801,106.038573 51.138109,105.969583 51.152536,105.969583 51.166958,105.946586 51.166958,105.877595 51.181376,105.348667 51.325308,105.026711 51.26779,104.95772 51.239003,104.934724 51.19579,104.842736 51.166958,104.819739 51.109241,104.704755 51.065906,104.635764 51.065906,104.543777 51.008062,103.232955 51.02253,103.163965 51.036993,103.163965 51.094801,103.140968 51.138109,102.933996 51.138109,102.796015 51.109241,102.773018 51.065906,102.589043 51.065906,102.589043 51.109241,102.497055 51.123677,102.106108 51.138109,102.129105 51.210199,102.106108 51.224603,102.083112 51.26779,102.129105 51.310935,102.106108 51.354041,101.899137 51.397106,101.784152 51.411452,101.738159 51.44013,101.623174 51.425793,101.554184 51.46879,101.50819 51.483114,101.439199 51.44013,101.347212 51.44013,101.232227 51.511747,101.117243 51.511747,101.094246 51.554663,101.025256 51.554663,100.956265 51.597539,100.887274 51.597539,100.795287 51.654644,100.657306 51.697426,100.634309 51.711677))","code":"ulanude","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"37","name":"Улан-Удэ","time_zone":{"name":"Asia/Irkutsk","offset":480},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((47.99447 54.378876,48.063461 54.472527,48.270433 54.459161,48.385417 54.472527,48.845355 54.472527,48.914345 54.405655,49.006333 54.35208,49.167311 54.338675,49.259298 54.338675,49.236301 54.298434,49.167311 54.298434,49.144314 54.258154,49.144314 54.217835,49.121317 54.204386,48.960339 54.204386,48.937342 54.177476,48.822358 54.164014,48.799361 54.150548,48.592389 54.110123,48.569392 54.069659,48.270433 54.09664,48.247436 54.110123,48.086458 54.110123,48.017467 54.204386,48.017467 54.231279,48.040464 54.325266,48.017467 54.338675,47.99447 54.378876))","code":"ulyanovsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"55","name":"Ульяновск","time_zone":{"name":"Europe/Ulyanovsk","offset":240},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((49.926208 51.19579,50.018195 51.253399,50.179173 51.26779,50.20217 51.224603,50.271161 51.19579,50.340151 51.19579,50.455136 51.239003,50.915073 51.397106,50.984064 51.56896,50.961067 51.68317,51.030057 51.68317,51.053054 51.668909,51.191035 51.526057,51.352014 51.3684,51.352014 51.325308,51.466998 51.282176,51.535989 51.282176,51.74296 51.3684,51.880942 51.397106,51.995926 51.44013,52.156904 51.46879,52.432867 51.46879,52.501857 51.511747,52.593845 51.46879,52.662835 51.46879,52.731826 51.483114,52.800816 51.425793,52.869807 51.339677,52.984791 51.282176,52.984791 51.26779,53.122773 51.19579,53.122773 51.123677,52.984791 51.094801,52.823813 51.051452,52.570848 51.008062,52.11091 50.935657,51.972929 50.848621,51.972929 50.732319,51.995926 50.688632,51.903938 50.615729,51.880942 50.615729,51.857945 50.571932,51.788954 50.469583,51.398007 50.205378,51.283023 50.175931,51.122045 50.175931,50.984064 50.322984,50.984064 50.454943,51.053054 50.528096,51.053054 50.615729,51.076051 50.717761,51.099048 50.761422,51.076051 50.892159,51.099048 50.906663,51.076051 50.950147,50.478132 50.979114,50.248164 51.051452,50.133179 51.094801,49.972201 51.166958,49.926208 51.19579))","code":"uralsk","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"162","name":"Уральск","time_zone":{"name":"Asia/Oral","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((131.726079 43.768976,131.749076 43.818776,131.749076 43.918251,131.772072 43.967926,132.071032 43.967926,132.140022 43.951372,132.140022 43.768976,132.117025 43.719135,131.93305 43.719135,131.818066 43.702512,131.726079 43.768976))","code":"ussuriysk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"83","name":"Уссурийск","time_zone":{"name":"Asia/Vladivostok","offset":600},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((82.420787 49.865643,82.420787 49.939703,82.443784 49.939703,82.443784 50.013649,82.46678 50.057963,82.719746 50.057963,82.83473 50.072725,82.949715 50.028425,83.064699 49.954501,83.018705 49.850817,82.949715 49.74691,82.719746 49.776621,82.627758 49.806313,82.581765 49.835987,82.512774 49.835987,82.420787 49.865643))","code":"ustkam","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"91","name":"Усть-Каменогорск","time_zone":{"name":"Asia/Almaty","offset":360},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((75.084785 55.735397,75.084785 55.761284,75.291757 55.748342,75.33775 55.748342,75.33775 55.800081,75.26876 55.83884,75.291757 55.903353,75.452735 55.967759,75.498728 56.006351,75.521725 56.044904,75.659706 56.057747,75.728697 56.121896,75.981663 56.134713,76.027656 56.160334,76.142641 56.160334,76.165638 56.147525,76.280622 56.160334,76.349613 56.147525,76.349613 56.096249,76.395606 56.070585,76.372609 55.903353,76.372609 55.877561,76.234628 55.851751,76.188635 55.761284,76.211631 55.696535,76.211631 55.592713,76.142641 55.553709,76.142641 55.514667,76.119644 55.488617,76.027656 55.488617,75.912672 55.527685,75.889675 55.527685,75.820685 55.488617,75.682703 55.462549,75.659706 55.423416,75.613713 55.397306,75.544722 55.423416,75.567719 55.436465,75.567719 55.501644,75.521725 55.501644,75.429738 55.540699,75.406741 55.553709,75.291757 55.540699,75.176772 55.540699,75.130778 55.579716,75.199769 55.644659,75.107782 55.670605,75.084785 55.735397))","code":"ust_tarka","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true,"truck_graph":true},"id":"191","name":"Усть-Тарка","time_zone":{"name":"Asia/Novosibirsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((53.375738 54.472527,53.398735 54.565963,53.513719 54.659186,53.513719 54.672486,53.628704 54.685782,53.651701 54.659186,53.766685 54.645881,53.835676 54.605942,53.927663 54.605942,54.019651 54.632572,54.088641 54.605942,54.157632 54.619259,54.272616 54.619259,54.364604 54.672486,54.617569 54.672486,54.709557 54.725643,54.778547 54.725643,54.847538 54.738921,55.008516 54.805248,55.1235 54.8185,55.169494 54.791991,55.307475 54.791991,55.468454 54.831748,55.514447 54.831748,55.514447 54.85823,55.537444 54.871465,55.583438 54.963988,55.49145 54.990384,55.445457 55.056298,55.238485 55.069467,55.169494 55.108951,55.169494 55.161535,55.353469 55.266495,55.376466 55.305783,55.330472 55.331954,55.353469 55.397306,55.399463 55.423416,55.468454 55.501644,55.537444 55.501644,55.652428 55.436465,55.721419 55.436465,55.79041 55.397306,56.089369 55.384244,56.204353 55.397306,56.480316 55.397306,56.503313 55.462549,56.549306 55.462549,56.687288 55.410363,56.733281 55.305783,56.733281 55.25339,56.687288 55.148395,56.687288 55.095794,56.52631 55.029945,56.52631 54.977188,56.480316 54.937574,56.503313 54.791991,56.388328 54.672486,56.388328 54.632572,56.342335 54.605942,56.388328 54.565963,56.319338 54.445791,56.181357 54.445791,56.089369 54.419038,56.020378 54.419038,55.905394 54.459161,55.836403 54.472527,55.652428 54.525945,55.560441 54.525945,55.537444 54.512597,55.330472 54.485888,55.307475 54.472527,55.192491 54.472527,54.939525 54.459161,54.824541 54.472527,54.778547 54.445791,54.68656 54.445791,54.594572 54.472527,54.387601 54.499245,54.341607 54.485888,54.272616 54.445791,54.203626 54.445791,54.088641 54.459161,53.95066 54.378876,53.766685 54.378876,53.444729 54.432417,53.421732 54.432417,53.375738 54.472527))","code":"ufa","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"17","name":"Уфа","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((53.191763 63.468254,53.191763 63.499055,53.260754 63.550317,53.513719 63.621928,53.697694 63.69336,53.812679 63.683166,54.088641 63.642356,54.203626 63.601486,54.226622 63.570796,54.157632 63.529823,54.019651 63.365344,53.996654 63.355033,53.881669 63.355033,53.743688 63.385956,53.559713 63.375652,53.191763 63.468254))","code":"ukhta","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"truck_graph":true},"id":"204","name":"Ухта","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((134.87665 48.299342,134.87665 48.634798,135.198606 48.634798,135.267597 48.619599,135.267597 48.32993,135.2446 48.284042,135.152612 48.284042,135.129616 48.268736,134.945641 48.284042,134.87665 48.299342))","code":"khabarovsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"35","name":"Хабаровск","time_zone":{"name":"Asia/Vladivostok","offset":600},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((39.140675 28.240743,39.140675 28.281254,39.186669 28.32175,39.209666 28.382465,39.416637 28.402695,39.485628 28.443145,39.715597 28.483579,39.899572 28.645161,40.152537 28.70569,40.198531 28.746023,40.4285 28.846788,40.49749 28.866929,40.612475 28.92733,41.53235 28.92733,41.555346 28.887067,41.992287 28.866929,42.061278 28.9072,42.130268 28.9072,42.176262 28.866929,42.360237 28.826643,42.567209 28.806494,42.613202 28.70569,42.682193 28.665341,42.797177 28.645161,42.843171 28.604789,42.843171 28.50379,42.935159 28.443145,42.981152 28.443145,43.142131 28.382465,43.234118 28.402695,43.303109 28.523998,43.349102 28.523998,43.556074 28.443145,43.648062 28.443145,43.694055 28.402695,43.80904 28.382465,43.993015 28.422922,44.291974 28.443145,44.360965 28.32175,44.360965 28.240743,44.314971 28.240743,44.314971 28.220481,44.291974 28.220481,44.222983 28.159674,44.222983 28.037956,43.993015 27.834786,43.87803 27.834786,43.855034 27.814448,43.694055 27.794106,43.625065 27.773761,43.602068 27.753411,43.395096 27.610859,43.395096 27.529317,43.418093 27.508922,43.44109 27.325198,43.349102 27.243445,43.326105 27.18209,43.234118 27.141169,43.211121 27.120702,43.165127 27.05928,43.07314 26.956836,42.958156 26.915832,42.797177 26.792731,42.636199 26.648944,42.590206 26.525554,42.429227 26.463809,42.291246 26.463809,42.199259 26.34022,42.199259 26.237128,42.130268 26.216498,42.015284 26.133944,42.015284 26.051332,41.900299 25.989334,41.900299 25.947984,41.831309 25.865241,41.670331 25.865241,41.670331 25.782439,41.578343 25.741017,41.463359 25.741017,41.325378 25.616663,41.302381 25.512936,41.210393 25.512936,40.980425 25.554438,40.980425 25.575183,40.911434 25.595925,40.79645 25.533689,40.773453 25.47142,40.727459 25.409119,40.612475 25.409119,40.543484 25.42989,40.474493 25.409119,40.474493 25.305213,40.4285 25.305213,40.405503 25.326002,40.336512 25.346786,40.313515 25.284421,40.244525 25.284421,40.198531 25.367568,40.083547 25.346786,39.968562 25.367568,39.945565 25.388345,39.968562 25.575183,39.968562 25.823847,39.945565 25.968661,39.968562 26.113297,39.945565 26.133944,39.922569 26.195865,39.876575 26.237128,39.876575 26.381431,39.784587 26.504976,39.784587 26.566699,39.669603 26.628388,39.669603 26.710589,39.646606 26.772201,39.531622 26.772201,39.531622 26.792731,39.600612 26.936336,39.669603 27.038799,39.807584 27.038799,39.830581 27.05928,39.807584 27.079758,39.738594 27.120702,39.76159 27.202545,39.853578 27.202545,39.922569 27.141169,40.014556 27.120702,40.037553 27.141169,39.991559 27.263889,39.922569 27.325198,39.945565 27.427305,39.922569 27.447715,39.922569 27.610859,39.830581 27.753411,39.738594 27.834786,39.623609 27.895777,39.531622 27.977045,39.255659 27.977045,39.209666 28.017656,39.301653 28.017656,39.39364 28.058252,39.39364 28.139397,39.255659 28.200216,39.232662 28.220481,39.186669 28.220481,39.186669 28.240743,39.140675 28.240743))","code":"hail","country_code":"sa","domain":"sa","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true},"id":"225","name":"Хаиль","time_zone":{"name":"Asia/Riyadh","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((68.875629 60.983694,68.875629 61.017141,68.921623 61.017141,68.921623 61.039419,68.967617 61.083929,69.082601 61.11727,69.128595 61.095046,69.197586 61.083929,69.243579 61.10616,69.335567 61.095046,69.427554 61.028282,69.427554 61.017141,69.404558 61.005996,69.381561 60.972537,69.128595 60.916694,69.082601 60.916694,68.875629 60.983694))","code":"kh_mansiysk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"truck_graph":true},"id":"150","name":"Ханты-Мансийск","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((46.535458 43.259124,46.541148 43.268721,46.542462 43.281203,46.551959 43.28555,46.570952 43.290521,46.582537 43.295467,46.614005 43.287527,46.625543 43.279002,46.624817 43.277832,46.623827 43.277209,46.623305 43.276984,46.623237 43.276944,46.623074 43.276769,46.622766 43.276572,46.622732 43.276525,46.622625 43.276271,46.622621 43.276203,46.622647 43.276125,46.622711 43.276062,46.622963 43.275918,46.623027 43.275871,46.623199 43.275634,46.623789 43.275037,46.625778 43.272249,46.625821 43.272161,46.626035 43.271457,46.626035 43.271347,46.626005 43.270972,46.625958 43.270869,46.624806 43.269568,46.62414 43.268584,46.624036 43.268484,46.623677 43.268263,46.623593 43.268221,46.623523 43.268151,46.623473 43.268076,46.623347 43.267823,46.62324 43.267531,46.623181 43.26731,46.623152 43.267082,46.623161 43.266852,46.623462 43.265283,46.623497 43.265137,46.623462 43.264948,46.623419 43.264848,46.623064 43.263577,46.623069 43.263495,46.623106 43.263422,46.623204 43.263357,46.623269 43.263341,46.623564 43.263354,46.623654 43.263341,46.623731 43.263307,46.623808 43.263241,46.623863 43.263169,46.623893 43.263069,46.623919 43.262544,46.62395 43.262475,46.624113 43.262328,46.624143 43.262262,46.624139 43.262191,46.624678 43.258032,46.62469 43.257869,46.624669 43.257804,46.624626 43.257744,46.624559 43.257702,46.624507 43.257645,46.624366 43.257458,46.624331 43.257391,46.624315 43.257295,46.624336 43.257242,46.624503 43.257123,46.62721 43.254007,46.627539 43.253591,46.62849 43.252289,46.628756 43.251893,46.629256 43.250959,46.629297 43.250675,46.629256 43.250414,46.629093 43.250048,46.628929 43.249794,46.627447 43.248284,46.627302 43.247941,46.627059 43.246842,46.626978 43.246311,46.627091 43.243581,46.627285 43.243132,46.627657 43.24266,46.628142 43.242223,46.629257 43.241478,46.637533 43.236811,46.637887 43.236487,46.63813 43.236067,46.639324 43.233578,46.639408 43.23319,46.639412 43.232819,46.639301 43.232431,46.638616 43.231138,46.638462 43.230669,46.638506 43.230233,46.638793 43.229651,46.639169 43.229295,46.640385 43.228632,46.641357 43.228277,46.641667 43.228034,46.641888 43.227646,46.644849 43.216819,46.648661 43.209742,46.64652 43.208119,46.63438 43.204182,46.627887 43.202295,46.621346 43.20096,46.615262 43.199958,46.608873 43.199291,46.602332 43.198957,46.596399 43.199235,46.591075 43.199847,46.584382 43.201294,46.577994 43.203297,46.572213 43.205411,46.566585 43.208415,46.562281 43.21131,46.559207 43.213867,46.552417 43.22056,46.538973 43.238001,46.538182 43.242044,46.538182 43.243175,46.538681 43.249086,46.538631 43.250217,46.538332 43.251239,46.535458 43.259124))","code":"khasavyurt","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"public_transport":true,"road_network":true},"id":"151","name":"Хасавюрт","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((76.211631 55.371178,76.234628 55.410363,76.326616 55.410363,76.395606 55.436465,76.395606 55.475585,76.418603 55.514667,76.602578 55.514667,76.602578 55.488617,76.694566 55.488617,76.763556 55.553709,76.832547 55.566715,76.970528 55.540699,77.085513 55.566715,77.154503 55.605706,77.407469 55.592713,77.407469 55.540699,77.54545 55.514667,77.568447 55.449509,77.706428 55.423416,77.821412 55.397306,77.844409 55.358108,77.660434 55.358108,77.591444 55.345033,77.591444 55.279595,77.683431 55.25339,77.660434 55.227167,77.522453 55.214049,77.407469 55.17467,77.407469 55.082633,77.476459 54.990384,77.499456 54.990384,77.522453 54.871465,77.522453 54.844991,77.453462 54.791991,77.384472 54.77873,77.361475 54.765465,77.246491 54.725643,77.246491 54.738921,76.901538 54.884696,76.80955 55.016762,76.694566 55.016762,76.671569 55.003575,76.602578 54.990384,76.533588 55.016762,76.533588 55.029945,76.464597 55.056298,76.464597 55.082633,76.326616 55.135251,76.326616 55.200927,76.372609 55.200927,76.372609 55.279595,76.211631 55.371178))","code":"chany","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"public_transport":false,"road_network":true,"truck_graph":true},"id":"192","name":"Чаны","time_zone":{"name":"Asia/Novosibirsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((46.936614 56.211525,46.959611 56.249873,46.982608 56.249873,47.097592 56.288183,47.097592 56.300945,47.143586 56.326455,47.419549 56.326455,47.534533 56.313702,47.603524 56.300945,47.603524 56.134713,47.580527 56.121896,47.580527 56.006351,47.511536 55.967759,47.350558 55.980627,47.166583 55.980627,47.097592 55.993491,47.051599 55.993491,46.982608 56.006351,46.982608 56.070585,47.005605 56.083419,46.959611 56.173138,46.936614 56.211525))","code":"cheboksary","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"53","name":"Чебоксары","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((60.458775 54.897922,60.481771 55.043123,60.481771 55.17467,60.458775 55.24028,60.550762 55.318871,60.619753 55.397306,60.688743 55.488617,60.688743 55.631679,60.803728 55.696535,61.171678 55.761284,61.700606 55.735397,61.907577 55.592713,62.137546 55.410363,62.160543 55.410363,62.252531 55.358108,62.229534 55.345033,62.068556 55.292691,62.068556 55.25339,62.137546 55.24028,62.206537 55.1878,62.229534 55.122103,62.275527 55.095794,62.18354 54.990384,62.022562 54.977188,61.999565 54.937574,62.091552 54.884696,62.114549 54.8185,62.022562 54.738921,62.022562 54.725643,61.884581 54.311852,61.81559 54.204386,61.81559 54.190933,61.746599 54.09664,61.723602 54.029156,61.631615 54.015646,61.631615 53.988613,61.585621 53.988613,61.493634 54.029156,61.470637 54.083152,61.309659 54.083152,61.217671 54.110123,61.056693 54.190933,60.987703 54.177476,60.895715 54.190933,60.872718 54.177476,60.803728 54.164014,60.780731 54.204386,60.757734 54.204386,60.757734 54.217835,60.481771 54.699073,60.458775 54.897922))","code":"chelyabinsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"15","name":"Челябинск","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((42.015284 44.182706,42.015284 44.265106,42.107271 44.265106,42.107271 44.21568,42.084274 44.166212,42.015284 44.182706))","code":"cherkessk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"truck_graph":true},"id":"118","name":"Черкесск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((75.659706 54.137078,75.659706 54.539289,75.797688 54.565963,75.820685 54.645881,75.751694 54.685782,75.751694 54.725643,75.866678 54.765465,76.027656 54.791991,76.096647 54.791991,76.211631 54.85823,76.188635 54.937574,76.280622 54.977188,76.326616 55.003575,76.418603 55.043123,76.464597 55.056298,76.533588 55.029945,76.533588 55.016762,76.602578 54.990384,76.671569 55.003575,76.694566 55.016762,76.80955 55.016762,76.901538 54.884696,77.246491 54.738921,77.246491 54.71236,77.108509 54.672486,77.131506 54.605942,76.993525 54.579294,76.993525 54.539289,76.924534 54.485888,76.901538 54.419038,76.80955 54.405655,76.740559 54.392268,76.717563 54.35208,76.648572 54.325266,76.556584 54.325266,76.533588 54.311852,76.464597 54.298434,76.303619 54.338675,76.257625 54.338675,76.234628 54.298434,76.257625 54.258154,76.119644 54.217835,76.07365 54.217835,76.07365 54.204386,76.027656 54.204386,76.00466 54.190933,75.912672 54.177476,75.866678 54.150548,75.7057 54.110123,75.659706 54.137078))","code":"chistoozernoe","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true,"truck_graph":true},"id":"193","name":"Чистоозёрное","time_zone":{"name":"Asia/Novosibirsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((112.316719 52.052369,112.339716 52.123022,112.38571 52.207657,112.454701 52.221748,112.500694 52.249915,112.523691 52.320254,112.546688 52.348359,112.891641 52.334309,113.12161 52.418543,113.167604 52.446585,113.236594 52.460599,113.397572 52.460599,113.397572 52.432566,113.512557 52.334309,113.535553 52.320254,113.55855 52.263992,113.673535 52.221748,113.788519 52.207657,113.811516 52.16536,113.788519 51.953267,113.604544 51.839739,113.443566 51.811313,113.374575 51.782868,113.374575 51.740167,113.305585 51.740167,113.167604 51.825528,113.075616 51.825528,113.006625 51.868148,112.891641 51.896539,112.477697 51.924912,112.362713 51.967438,112.339716 52.038225,112.316719 52.052369))","code":"chita","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"64","name":"Чита","time_zone":{"name":"Asia/Chita","offset":540},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((80.466053 54.937574,80.535043 54.977188,80.581037 55.029945,80.604034 55.200927,80.604034 55.24028,80.765012 55.279595,80.856999 55.279595,80.92599 55.358108,80.948987 55.371178,80.971984 55.410363,81.132962 55.436465,81.132962 55.475585,81.086968 55.501644,81.086968 55.644659,81.063971 55.644659,81.063971 55.735397,81.29394 55.813005,81.776874 55.967759,81.822868 55.942009,81.845865 55.903353,82.006843 55.722447,82.052837 55.644659,82.167821 55.527685,82.144824 55.501644,81.799871 55.423416,81.546906 55.384244,81.454918 55.331954,81.408924 55.331954,81.431921 55.292691,81.477915 55.266495,81.477915 55.122103,81.454918 55.108951,81.500912 55.069467,81.408924 54.977188,81.408924 54.950783,81.523909 54.937574,81.592899 54.871465,81.569902 54.831748,81.546906 54.8185,81.66189 54.725643,81.730881 54.659186,81.707884 54.619259,81.638893 54.605942,81.615896 54.619259,81.546906 54.59262,81.569902 54.525945,81.523909 54.499245,81.385927 54.445791,81.29394 54.419038,81.224949 54.419038,81.201952 54.445791,81.040974 54.432417,80.92599 54.499245,80.902993 54.539289,80.765012 54.565963,80.742015 54.552628,80.673024 54.539289,80.673024 54.605942,80.512046 54.672486,80.489049 54.738921,80.535043 54.752195,80.604034 54.844991,80.581037 54.897922,80.512046 54.897922,80.466053 54.937574))","code":"chulym","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true,"truck_graph":true},"id":"166","name":"Чулым","time_zone":{"name":"Asia/Novosibirsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((40.083547 47.699215,40.083547 47.776545,40.12954 47.807444,40.152537 47.791997,40.359509 47.761088,40.359509 47.71469,40.175534 47.62177,40.152537 47.652762,40.083547 47.699215))","code":"shakhty","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"152","name":"Шахты","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((86.928173 53.471642,86.928173 53.49901,87.480098 53.49901,87.595083 53.416854,87.641076 53.320805,87.848048 53.334539,87.894042 53.252065,87.963033 53.252065,88.101014 53.196994,88.101014 53.141852,88.124011 53.128056,88.078017 52.948297,88.101014 52.934438,88.032023 52.795608,87.940036 52.726026,87.848048 52.726026,87.779058 52.753872,87.779058 52.837304,87.68707 52.892836,87.61808 52.906708,87.457101 52.892836,87.342117 53.003687,87.31912 53.059007,87.227133 53.141852,87.112148 53.210769,87.112148 53.279574,87.066155 53.307066,86.928173 53.471642))","code":"sheregesh","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"206","name":"Шерегеш","time_zone":{"name":"Asia/Novokuznetsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((68.737648 42.408709,68.737648 42.459627,68.829636 42.49355,68.898626 42.5444,68.921623 42.5444,68.921623 42.561341,69.036608 42.662889,69.128595 42.662889,69.220583 42.696701,69.381561 42.679797,69.404558 42.696701,69.519542 42.747385,69.542539 42.747385,69.565536 42.730495,69.496545 42.679797,69.496545 42.612135,69.611529 42.629058,69.749511 42.595208,69.818501 42.5444,69.818501 42.527455,69.864495 42.527455,69.979479 42.476591,70.002476 42.425686,70.025473 42.408709,70.071467 42.255704,69.956482 42.136444,69.887492 42.136444,69.68052 42.068194,69.450551 41.811602,69.450551 41.622779,69.381561 41.571186,69.059604 41.605586,69.013611 41.622779,68.94462 42.05112,68.737648 42.408709))","code":"shymkent","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"161","name":"Шымкент","time_zone":{"name":"Asia/Almaty","offset":360},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((44.659924 27.834786,44.659924 28.017656,44.728915 27.997352,44.774908 27.956734,44.820902 27.956734,44.91289 28.200216,44.91289 28.220481,45.004877 28.463364,45.073868 28.725858,45.050871 28.725858,45.050871 28.866929,45.027874 28.92733,45.050871 29.027919,45.073868 29.088226,45.142858 29.10832,45.165855 29.16858,45.28084 29.16858,45.395824 29.148497,46.292702 29.068128,46.476677 29.068128,46.499674 29.088226,46.568664 29.10832,46.637655 29.088226,47.074595 29.048025,47.097592 29.048025,47.304564 29.027919,47.327561 29.007809,47.465542 29.007809,47.55753 28.887067,47.603524 28.806494,47.603524 28.665341,47.62652 28.645161,47.718508 28.523998,48.408414 28.523998,48.431411 28.544201,48.569392 28.624977,48.707373 28.665341,48.753367 28.624977,49.144314 28.36223,49.167311 28.341992,49.236301 28.240743,49.236301 28.220481,49.259298 28.220481,49.282295 28.159674,49.512264 27.895777,49.604251 27.834786,49.650245 27.87545,49.765229 27.936419,49.926208 27.936419,49.972201 27.895777,50.363148 27.9161,50.432139 27.814448,50.432139 27.753411,50.363148 27.610859,50.20217 27.549708,50.064189 27.570096,50.087186 27.508922,50.156176 27.447715,50.386145 27.141169,50.409142 27.120702,50.455136 27.038799,50.478132 26.772201,50.478132 26.710589,50.501129 26.648944,50.478132 26.566699,50.409142 26.546128,50.386145 26.484394,50.386145 26.402031,50.340151 26.360827,50.317154 26.257754,50.294157 26.03067,50.294157 25.885932,50.340151 25.865241,50.409142 25.7203,50.547123 25.595925,50.57012 25.595925,50.57012 25.512936,50.616114 25.47142,50.616114 25.42989,50.685104 25.055475,50.708101 25.03464,50.708101 24.930414,50.800089 24.888699,50.823086 24.742585,50.93807 24.533553,51.099048 24.470776,51.329017 24.512631,51.398007 24.617208,51.466998 24.638113,51.581982 24.659015,51.581982 24.554472,51.444001 24.428906,51.444001 24.366077,51.535989 24.345126,51.581982 24.261291,51.581982 24.156418,51.67397 24.009453,51.765957 23.925397,52.018923 23.630771,52.156904 23.441017,52.340879 23.229859,52.570848 22.933677,52.662835 22.933677,52.662835 22.912497,52.84681 22.912497,52.869807 22.891312,52.984791 22.891312,53.14577 22.870125,53.674698 22.806543,53.835676 22.806543,54.272616 22.742931,54.341607 22.721721,54.893532 22.67929,54.916529 22.65807,55.1235 22.636846,55.215488 22.700507,55.675425 21.998624,55.49145 21.485965,55.238485 20.692079,55.008516 20.002103,54.870535 19.958877,54.571576 19.850762,53.95066 19.655969,52.984791 19.33079,52.915801 19.309088,52.616841 19.200535,51.995926 19.004961,51.995926 19.265675,51.972929 19.33079,47.534533 19.33079,47.580527 19.46094,47.603524 19.482621,48.178445 20.692079,48.178445 20.713591,47.948477 20.992967,47.879486 21.057364,47.902483 21.357516,47.833492 21.400345,47.856489 21.550147,47.971473 21.721161,48.040464 21.742523,48.086458 21.785239,48.201442 21.849288,48.201442 21.891971,47.948477 21.891971,47.810495 21.9773,47.810495 22.041262,47.879486 22.169101,47.902483 22.275545,47.92548 22.296824,47.99447 22.40317,48.040464 22.615619,48.086458 22.912497,48.086458 22.9972,48.109455 23.356594,48.086458 23.419916,48.132452 23.588627,48.132452 23.82025,48.109455 23.967432,48.155448 24.05146,48.155448 24.114445,48.109455 24.198378,48.109455 24.303215,48.086458 24.324173,47.99447 24.491705,47.99447 24.554472,47.833492 24.533553,47.741505 24.533553,47.741505 24.867836,47.62652 25.013802,47.62652 25.159595,47.764502 25.242827,47.718508 25.450657,47.649517 25.554438,47.672514 25.69958,47.695511 25.69958,47.695511 25.803145,47.62652 25.865241,47.62652 25.989334,47.580527 26.03067,47.603524 26.175229,47.580527 26.195865,47.534533 26.34022,47.511536 26.402031,47.281567 26.402031,47.074595 26.587266,47.005605 26.587266,46.913617 26.669496,46.798633 26.648944,46.637655 26.669496,46.522671 26.690045,46.315699 26.792731,46.246708 26.813257,46.223711 26.83378,46.154721 26.854298,46.131724 26.83378,46.062733 26.813257,45.855761 26.956836,45.740777 27.05928,45.579799 27.120702,45.579799 27.222997,45.395824 27.222997,45.28084 27.243445,45.165855 27.304765,45.119861 27.406891,45.096865 27.570096,45.073868 27.671976,45.004877 27.69234,44.91289 27.631235,44.866896 27.631235,44.705918 27.733058,44.659924 27.834786))","code":"dammam","country_code":"sa","domain":"sa","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true,"traffic":true},"id":"220","name":"Эд-Даммам","time_zone":{"name":"Asia/Riyadh","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((44.153993 46.255822,44.153993 46.335269,44.199987 46.382882,44.291974 46.382882,44.360965 46.367015,44.383962 46.319388,44.360965 46.303504,44.337968 46.255822,44.153993 46.255822))","code":"elista","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"truck_graph":true},"id":"153","name":"Элиста","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((37.024963 31.451463,37.024963 31.510299,37.185941 31.569098,37.300925 31.588689,37.461903 31.647439,37.622881 31.667014,37.645878 31.686585,37.898844 31.745273,37.967834 31.764827,37.967834 31.529903,37.990831 31.392589,37.944838 31.314034,37.944838 31.196079,38.013828 31.196079,38.082819 31.176405,38.128813 31.274732,38.197803 31.294385,38.289791 31.215748,38.266794 31.156728,38.197803 31.137046,38.174806 30.920278,38.243797 30.861073,38.312788 30.900547,38.404775 30.900547,38.58875 30.940004,38.887709 30.920278,38.910706 30.959727,39.117678 30.979445,39.370644 30.959727,39.416637 30.920278,39.531622 30.940004,39.554619 30.959727,39.646606 30.959727,39.76159 30.861073,39.830581 30.880812,39.853578 30.900547,39.922569 30.880812,40.106544 30.782078,40.12954 30.762319,40.244525 30.782078,40.267522 30.841331,40.451497 30.841331,40.474493 30.821584,40.635472 30.762319,40.773453 30.782078,41.026418 30.801833,41.118406 30.762319,41.118406 30.584304,41.187396 30.564505,41.210393 30.584304,41.210393 30.6041,41.371371 30.623891,41.624337 30.564505,41.624337 30.524893,41.60134 30.505082,41.578343 30.445622,41.624337 30.386127,41.739321 30.386127,41.831309 30.306743,41.900299 30.207422,41.96929 30.187546,41.96929 30.108002,41.854306 30.088105,41.785315 30.048301,41.739321 29.94872,41.647334 29.94872,41.53235 29.849039,41.463359 29.849039,41.440362 29.769223,41.463359 29.629392,41.486356 29.569404,41.555346 29.569404,41.555346 29.489366,41.60134 29.409264,41.647334 29.369189,41.647334 29.16858,41.509353 29.16858,41.440362 29.10832,41.417365 29.007809,41.417365 28.92733,40.612475 28.92733,40.49749 28.866929,40.4285 28.846788,40.198531 28.746023,40.152537 28.70569,39.899572 28.645161,39.715597 28.483579,39.485628 28.443145,39.416637 28.402695,39.209666 28.382465,39.209666 28.564401,39.186669 28.624977,39.048687 28.624977,39.025691 28.685517,39.002694 28.806494,38.910706 28.9072,38.772725 28.947456,38.772725 29.208733,38.749728 29.268934,38.680737 29.268934,38.634744 29.309048,38.565753 29.309048,38.542756 29.288993,38.473766 29.208733,38.404775 29.208733,38.404775 29.10832,38.335784 29.007809,38.266794 29.007809,38.197803 29.027919,38.197803 29.148497,38.2208 29.208733,38.312788 29.288993,38.312788 29.369189,38.197803 29.509381,38.197803 29.529393,38.036825 29.589404,37.990831 29.589404,37.944838 29.549401,37.737866 29.569404,37.714869 29.629392,37.737866 29.669363,37.714869 29.689343,37.714869 29.829091,37.645878 29.849039,37.576888 29.90886,37.507897 29.928792,37.461903 30.008481,37.507897 30.048301,37.507897 30.088105,37.668875 30.366287,37.691872 30.366287,37.944838 30.505082,37.829853 30.643679,37.78386 30.683242,37.714869 30.762319,37.438906 31.038576,37.070956 31.392589,37.024963 31.451463))","code":"el_jouf","country_code":"sa","domain":"sa","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":false},"id":"230","name":"Эль Джауф","time_zone":{"name":"Asia/Riyadh","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((41.302381 25.512936,41.325378 25.616663,41.463359 25.741017,41.578343 25.741017,41.670331 25.782439,41.670331 25.865241,41.831309 25.865241,41.900299 25.947984,41.900299 25.989334,42.015284 26.051332,42.015284 26.133944,42.130268 26.216498,42.199259 26.237128,42.199259 26.34022,42.291246 26.463809,42.429227 26.463809,42.590206 26.525554,42.636199 26.648944,42.797177 26.792731,42.958156 26.915832,43.07314 26.956836,43.165127 27.05928,43.211121 27.120702,43.234118 27.141169,43.326105 27.18209,43.349102 27.243445,43.44109 27.325198,43.418093 27.508922,43.395096 27.529317,43.395096 27.610859,43.602068 27.753411,43.625065 27.773761,43.694055 27.794106,43.855034 27.814448,43.87803 27.834786,43.993015 27.834786,44.222983 28.037956,44.222983 28.159674,44.291974 28.220481,44.406958 28.220481,44.54494 28.098832,44.659924 28.017656,44.659924 27.834786,44.705918 27.733058,44.866896 27.631235,44.91289 27.631235,44.98188 27.570096,44.889893 27.325198,44.866896 27.100232,44.843899 26.956836,44.797905 26.956836,44.705918 27.018314,44.590933 26.997825,44.498946 26.997825,44.406958 26.956836,44.383962 26.607829,44.406958 26.381431,44.498946 26.113297,44.61393 25.968661,44.797905 25.7203,44.797905 25.678856,44.774908 25.658129,44.728915 25.512936,44.659924 25.512936,44.521943 25.575183,44.452952 25.575183,44.360965 25.49218,44.199987 25.47142,44.085002 25.450657,43.993015 25.326002,43.786043 25.326002,43.671059 25.159595,43.625065 25.159595,43.579071 25.201218,43.487084 25.201218,43.326105 25.055475,43.142131 24.99296,43.119134 24.930414,43.188124 24.909558,43.165127 24.888699,43.142131 24.805227,43.211121 24.721698,43.165127 24.638113,43.096137 24.554472,42.935159 24.575388,42.866168 24.554472,42.797177 24.491705,42.567209 24.491705,42.475221 24.659015,42.452224 24.721698,42.130268 24.721698,42.061278 24.951267,42.038281 24.972115,41.96929 25.117957,41.854306 25.222024,41.716324 25.180408,41.647334 25.201218,41.463359 25.346786,41.440362 25.409119,41.371371 25.49218,41.302381 25.512936))","code":"qasim","country_code":"sa","domain":"sa","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":false},"id":"222","name":"Эль Касим","time_zone":{"name":"Asia/Riyadh","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((37.944838 31.196079,37.944838 31.314034,37.990831 31.392589,37.967834 31.529903,37.967834 31.764827,38.036825 31.784378,38.128813 31.803924,38.151809 31.823466,38.910706 31.999157,38.979697 32.018658,39.186669 32.155045,39.232662 32.174513,39.301653 32.135574,39.76159 32.057646,40.037553 32.018658,40.106544 31.999157,40.382506 31.960144,40.474493 31.921114,40.957428 31.647439,41.072412 31.588689,41.095409 31.569098,41.210393 31.510299,41.486356 31.35332,41.647334 31.294385,41.877303 31.196079,41.946293 31.176405,42.061278 31.11736,42.084274 31.11736,42.613202 30.742555,42.659196 30.703017,42.797177 30.6041,42.889165 30.544701,43.280112 30.267027,43.326105 30.227294,43.970018 29.769223,44.039008 29.709319,44.24598 29.569404,44.360965 29.469346,44.61393 29.288993,44.636927 29.268934,44.751911 29.188658,44.820902 29.188658,45.165855 29.16858,45.142858 29.10832,45.073868 29.088226,45.050871 29.027919,45.027874 28.92733,45.050871 28.866929,45.050871 28.725858,45.073868 28.725858,45.004877 28.463364,44.91289 28.220481,44.91289 28.200216,44.820902 27.956734,44.774908 27.956734,44.728915 27.997352,44.659924 28.017656,44.54494 28.098832,44.406958 28.220481,44.314971 28.220481,44.314971 28.240743,44.360965 28.240743,44.360965 28.32175,44.291974 28.443145,43.993015 28.422922,43.80904 28.382465,43.694055 28.402695,43.648062 28.443145,43.556074 28.443145,43.349102 28.523998,43.303109 28.523998,43.234118 28.402695,43.142131 28.382465,42.981152 28.443145,42.935159 28.443145,42.843171 28.50379,42.843171 28.604789,42.797177 28.645161,42.682193 28.665341,42.613202 28.70569,42.567209 28.806494,42.360237 28.826643,42.176262 28.866929,42.130268 28.9072,42.061278 28.9072,41.992287 28.866929,41.555346 28.887067,41.53235 28.92733,41.417365 28.92733,41.417365 29.007809,41.440362 29.10832,41.509353 29.16858,41.647334 29.16858,41.647334 29.369189,41.60134 29.409264,41.555346 29.489366,41.555346 29.569404,41.486356 29.569404,41.463359 29.629392,41.440362 29.769223,41.463359 29.849039,41.53235 29.849039,41.647334 29.94872,41.739321 29.94872,41.785315 30.048301,41.854306 30.088105,41.96929 30.108002,41.96929 30.187546,41.900299 30.207422,41.831309 30.306743,41.739321 30.386127,41.624337 30.386127,41.578343 30.445622,41.60134 30.505082,41.624337 30.524893,41.624337 30.564505,41.371371 30.623891,41.210393 30.6041,41.210393 30.584304,41.187396 30.564505,41.118406 30.584304,41.118406 30.762319,41.026418 30.801833,40.773453 30.782078,40.635472 30.762319,40.474493 30.821584,40.451497 30.841331,40.267522 30.841331,40.244525 30.782078,40.12954 30.762319,40.106544 30.782078,39.922569 30.880812,39.853578 30.900547,39.830581 30.880812,39.76159 30.861073,39.646606 30.959727,39.554619 30.959727,39.531622 30.940004,39.416637 30.920278,39.370644 30.959727,39.117678 30.979445,38.910706 30.959727,38.887709 30.920278,38.58875 30.940004,38.404775 30.900547,38.312788 30.900547,38.243797 30.861073,38.174806 30.920278,38.197803 31.137046,38.266794 31.156728,38.289791 31.215748,38.197803 31.294385,38.128813 31.274732,38.082819 31.176405,38.013828 31.196079,37.944838 31.196079))","code":"hudud_al_shamaliya","country_code":"sa","domain":"sa","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true},"id":"226","name":"Эль Худуд эш Шамалия","time_zone":{"name":"Asia/Riyadh","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((40.842443 20.045316,40.842443 20.110114,40.980425 20.261205,41.026418 20.304346,41.049415 20.369037,41.095409 20.347476,41.072412 20.304346,41.118406 20.261205,41.187396 20.369037,41.210393 20.390594,41.210393 20.455248,41.279384 20.519875,41.279384 20.584474,41.325378 20.670565,41.325378 20.778109,41.394368 20.821105,41.486356 20.799608,41.53235 20.756606,41.60134 20.756606,41.739321 20.627526,41.854306 20.627526,41.877303 20.649047,41.946293 20.670565,41.96929 20.584474,42.107271 20.584474,42.107271 20.519875,42.130268 20.412148,42.015284 20.369037,41.96929 20.261205,41.900299 20.196469,41.831309 19.91564,41.785315 19.872391,41.785315 19.785858,41.762318 19.764217,41.739321 19.699277,41.578343 19.699277,41.555346 19.634311,41.555346 19.547649,41.394368 19.482621,41.279384 19.46094,41.256387 19.525976,41.210393 19.525976,41.141403 19.547649,41.187396 19.590986,41.1644 19.655969,41.095409 19.677625,41.026418 19.720927,41.026418 19.807495,40.911434 19.91564,40.842443 20.045316))","code":"el_baha","country_code":"sa","domain":"sa","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":false},"id":"229","name":"Эль-Баха","time_zone":{"name":"Asia/Riyadh","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((41.693328 23.693961,41.693328 23.757121,41.762318 23.778167,41.831309 23.757121,41.900299 23.757121,41.946293 23.841286,42.038281 23.841286,42.084274 23.925397,42.084274 23.988444,42.130268 24.030458,42.107271 24.135434,42.153265 24.219352,42.153265 24.324173,42.084274 24.5963,42.084274 24.659015,42.130268 24.700807,42.130268 24.721698,42.452224 24.721698,42.475221 24.659015,42.567209 24.491705,42.797177 24.491705,42.866168 24.554472,42.935159 24.575388,43.096137 24.554472,43.165127 24.638113,43.211121 24.721698,43.142131 24.805227,43.165127 24.888699,43.188124 24.909558,43.119134 24.930414,43.142131 24.99296,43.326105 25.055475,43.487084 25.201218,43.579071 25.201218,43.625065 25.159595,43.671059 25.159595,43.786043 25.326002,43.993015 25.326002,44.085002 25.450657,44.199987 25.47142,44.360965 25.49218,44.452952 25.575183,44.521943 25.575183,44.659924 25.512936,44.728915 25.512936,44.774908 25.658129,44.797905 25.678856,44.797905 25.7203,44.61393 25.968661,44.498946 26.113297,44.406958 26.381431,44.383962 26.607829,44.406958 26.956836,44.498946 26.997825,44.590933 26.997825,44.705918 27.018314,44.797905 26.956836,44.843899 26.956836,44.866896 27.100232,44.889893 27.325198,44.98188 27.570096,44.91289 27.631235,45.004877 27.69234,45.073868 27.671976,45.096865 27.570096,45.119861 27.406891,45.165855 27.304765,45.28084 27.243445,45.395824 27.222997,45.579799 27.222997,45.579799 27.120702,45.740777 27.05928,45.855761 26.956836,46.062733 26.813257,46.131724 26.83378,46.154721 26.854298,46.223711 26.83378,46.246708 26.813257,46.315699 26.792731,46.522671 26.690045,46.637655 26.669496,46.798633 26.648944,46.913617 26.669496,47.005605 26.587266,47.074595 26.587266,47.281567 26.402031,47.511536 26.402031,47.534533 26.34022,47.580527 26.195865,47.603524 26.175229,47.580527 26.03067,47.62652 25.989334,47.62652 25.865241,47.695511 25.803145,47.695511 25.69958,47.672514 25.69958,47.649517 25.554438,47.718508 25.450657,47.764502 25.242827,47.62652 25.159595,47.62652 25.013802,47.741505 24.867836,47.741505 24.533553,47.833492 24.533553,47.99447 24.554472,47.99447 24.491705,48.086458 24.324173,48.109455 24.303215,48.109455 24.198378,48.155448 24.114445,48.155448 24.05146,48.109455 23.967432,48.132452 23.82025,48.132452 23.588627,48.086458 23.419916,48.109455 23.356594,48.086458 22.9972,48.086458 22.912497,48.040464 22.615619,47.99447 22.40317,47.92548 22.296824,47.902483 22.275545,47.879486 22.169101,47.810495 22.041262,47.810495 21.9773,47.948477 21.891971,48.201442 21.891971,48.201442 21.849288,48.086458 21.785239,48.040464 21.742523,47.971473 21.721161,47.856489 21.550147,47.833492 21.400345,47.902483 21.357516,47.879486 21.057364,47.948477 20.992967,48.178445 20.713591,48.178445 20.692079,47.603524 19.482621,47.580527 19.46094,47.534533 19.33079,47.097592 19.33079,46.292702 19.309088,45.372827 19.309088,45.165855 19.222252,45.119861 19.222252,45.119861 19.309088,45.073868 19.439255,44.590933 19.417568,44.383962 19.417568,44.337968 19.482621,44.222983 19.46094,44.153993 19.482621,44.153993 19.547649,44.222983 19.569319,44.222983 19.699277,44.17699 19.93726,44.107999 20.002103,44.085002 20.110114,44.062005 20.261205,44.039008 20.282777,44.039008 20.519875,43.993015 20.519875,43.87803 20.606001,43.80904 20.670565,43.832037 20.692079,43.80904 20.821105,43.694055 21.014436,43.579071 21.121734,43.579071 21.207517,43.671059 21.378932,43.671059 21.421755,43.487084 21.507363,43.487084 21.699795,43.464087 21.721161,43.487084 21.870631,43.487084 21.9773,43.372099 22.041262,43.349102 22.190396,43.326105 22.190396,43.303109 22.296824,43.349102 22.360642,43.234118 22.466939,43.211121 22.530679,43.188124 22.551919,43.165127 22.615619,43.234118 22.67929,43.142131 22.721721,42.958156 22.721721,42.935159 22.742931,42.866168 22.891312,42.774181 22.891312,42.774181 22.912497,42.751184 22.912497,42.728187 23.018367,42.70519 23.08185,42.475221 23.103004,42.452224 23.166447,42.429227 23.272118,42.406231 23.272118,42.406231 23.419916,42.291246 23.462114,42.245253 23.588627,42.176262 23.6097,42.176262 23.588627,42.015284 23.588627,41.831309 23.630771,41.693328 23.693961))","code":"riyadh","country_code":"sa","domain":"sa","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true,"traffic":true},"id":"216","name":"Эр-Рияд","time_zone":{"name":"Asia/Riyadh","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((141.499749 46.525471,141.499749 46.636117,141.545743 46.730776,141.614733 46.841002,141.63773 46.919596,141.660727 46.935301,141.729718 47.07644,141.729718 47.139049,141.706721 47.139049,141.63773 47.310843,141.63773 47.652762,141.683724 47.683735,141.752715 47.668251,141.982683 47.62177,142.097668 47.49762,142.166658 47.49762,142.281643 47.606268,142.350633 47.62177,142.350633 47.699215,142.419624 47.71469,142.419624 47.761088,142.350633 47.838326,142.350633 47.930859,142.442621 48.038607,142.465618 48.100075,142.442621 48.100075,142.396627 48.222793,142.396627 48.299342,142.442621 48.436842,142.465618 48.436842,142.488614 48.573971,142.442621 48.619599,142.442621 48.786546,142.465618 48.786546,142.511611 48.983134,142.534608 49.02839,142.488614 49.148874,142.488614 49.224027,142.511611 49.224027,142.557605 49.359017,142.534608 49.463753,142.787574 49.463753,142.856564 49.508571,142.925555 49.508571,143.086533 49.493636,143.086533 49.583177,143.017542 49.65767,143.040539 49.702311,143.224514 49.702311,143.523474 49.717182,143.592464 49.761768,143.753442 49.880464,143.822433 49.954501,143.91442 49.954501,144.029405 49.998869,144.259373 50.043196,144.305367 50.043196,144.328364 50.028425,144.328364 49.969295,144.351361 49.954501,144.466345 49.761768,144.466345 49.687435,144.558333 49.583177,144.558333 49.523501,144.604327 49.284068,144.627323 49.284068,144.65032 49.209006,144.94928 48.998224,145.01827 48.907614,145.01827 48.81684,145.064264 48.695552,145.064264 48.573971,144.972277 48.467348,144.765305 48.421583,144.673317 48.421583,144.489342 48.452097,144.397355 48.528303,144.328364 48.665185,144.305367 48.756233,144.098395 48.892497,143.868427 49.073606,143.661455 49.088669,143.638458 49.103727,143.500477 49.103727,143.339499 49.058539,143.316502 48.95294,143.293505 48.81684,143.270508 48.801695,143.10953 48.589185,143.040539 48.436842,143.017542 48.360499,142.994546 48.314638,142.902558 48.115431,142.902558 48.053981,142.856564 47.961667,142.856564 47.761088,142.925555 47.652762,143.063536 47.575249,143.155524 47.528685,143.178521 47.513155,143.247511 47.435435,143.270508 47.388747,143.293505 47.388747,143.362496 47.185957,143.362496 47.123404,143.54647 47.045108,143.638458 47.029435,143.707449 46.982389,143.799436 46.85673,143.822433 46.730776,143.84543 46.525471,143.891424 46.509647,143.937417 46.382882,143.91442 46.303504,143.776439 46.096581,143.776439 46.04872,143.707449 45.93688,143.638458 45.856857,143.500477 45.808787,143.362496 45.808787,143.178521 45.872871,143.10953 45.968857,143.086533 46.112526,143.086533 46.239918,143.017542 46.335269,142.902558 46.398743,142.833567 46.398743,142.672589 46.351144,142.580602 46.287614,142.534608 46.096581,142.465618 45.952871,142.37363 45.824815,142.304639 45.648256,142.281643 45.632177,141.913693 45.696464,141.752715 45.712524,141.706721 45.760676,141.729718 45.872871,141.683724 45.904885,141.614733 46.000816,141.614733 46.04872,141.591736 46.22401,141.56874 46.351144,141.545743 46.367015,141.522746 46.4146,141.499749 46.525471))","code":"yuzhnosakhalinsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"88","name":"Южно-Сахалинск","time_zone":{"name":"Asia/Sakhalin","offset":660},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((126.620773 62.155043,126.666767 62.18725,126.758754 62.18725,126.919733 62.240852,127.126704 62.262267,127.149701 62.272968,127.149701 62.305049,127.310679 62.337097,127.632636 62.422389,128.023582 62.390433,128.069576 62.411741,128.253551 62.560473,128.48352 62.655695,128.989451 62.708464,129.472385 63.05439,129.518379 63.064809,129.58737 63.075225,129.702354 63.064809,129.909326 63.064809,130.622229 62.876695,130.691219 62.866209,131.105163 62.824226,131.519107 62.666256,131.542104 62.634561,131.611094 62.58166,131.818066 62.379773,132.209013 62.176518,132.415985 62.165783,132.576963 62.155043,132.622957 62.112047,132.645954 61.993493,132.530969 61.96108,132.484975 61.885314,132.369991 61.765875,132.301 61.624119,132.346994 61.514633,132.645954 61.437762,132.852925 61.382738,132.875922 61.382738,132.875922 61.360701,132.760938 61.28345,132.737941 61.183847,132.071032 60.81593,131.657088 60.658553,131.588097 60.624729,131.519107 60.624729,131.427119 60.658553,131.289138 60.714848,130.76021 61.039419,130.32327 61.206009,130.277276 61.206009,129.518379 61.217083,128.575507 61.228154,128.460523 61.28345,128.391532 61.360701,128.368535 61.503663,128.299545 61.547519,128.046579 61.547519,127.908598 61.613188,127.770617 61.635047,127.563645 61.711431,127.517651 61.73322,127.37967 61.765875,127.264686 61.820223,127.126704 61.831082,126.988723 61.885314,126.689764 61.982692,126.64377 61.993493,126.64377 62.036657,126.666767 62.06899,126.620773 62.155043))","code":"yakutsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"50","name":"Якутск","time_zone":{"name":"Asia/Yakutsk","offset":540},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((39.669603 57.555712,39.715597 57.605028,39.715597 57.752576,39.807584 57.777108,40.014556 57.777108,40.014556 57.715745,40.037553 57.654277,40.083547 57.629661,40.198531 57.592706,40.198531 57.531029,40.152537 57.531029,40.106544 57.50633,40.06055 57.50633,40.06055 57.518682,39.6926 57.518682,39.669603 57.555712))","code":"yaroslavl","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"28","name":"Ярославль","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}}]'),
	DG.config={host:null,port:3e3,defaultSkin:"dark",defaultLang:"ru",trafficLayerMinZoom:10,trafficLayerUpdateInterval:3e5,ppLink2gis:"{gislink}/directions/tab/{rsType}/points/|{point}?m={center}%2F{zoom}&routeLink=true",openLink2gis:"{gislink}/?m={center}%2F{zoom}&openLink=true",ppnotLink:"http://2gis.{domain}/{projectCode}/center/{center}/zoom/{zoom}/routeTab/rsType/{rsType}/to/{point}╎{name}",photosLink:"http://2gis.{domain}/photos/{id}",poiLayerMinZoom:0,detectRetina:!1,webApiKey:"ruregt3044",webApiVersion:"2.0",regionListFields:"items.bounds,items.zoom_level,items.time_zone,items.code,items.flags,items.country_code,items.domain,items.default_pos",firmInfoFields:"items.reviews,items.links,items.external_content",geoAdditionalFields:"items.geometry.selection,items.links,items.adm_div,items.address,items.floors,items.description",geoclickerCatalogApiKey:"ruregt3044",projectLeaveMaxZoom:16,flampUrl:"http://flamp.ru/r/",flampGoogleAnalytics:"utm_source=api2gis&utm_medium=api&utm_campaign=geoclicker",gaCode:"UA-38243181-2",gaName:"mapsapi2gis",protocol:"https:",baseUrl:"//maps.api.2gis.ru/2.0",tileServer:"//tile{s}.maps.2gis.com/tiles?x={x}&y={y}&z={z}&v=1&ts=online_sd",retinaTileServer:"//tile{s}.maps.2gis.com/tiles?x={x}&y={y}&z={z}&v=1&ts=online_hd",previewTileServer:"//tile{s}.maps.2gis.com/tiles?x={x}&y={y}&z={z}&v=1&size=64&ts=online_sd",previewRetinaTileServer:"//tile{s}.maps.2gis.com/tiles?x={x}&y={y}&z={z}&v=1&size=64&ts=online_hd",arabicTileServer:"//tile{s}.maps.2gis.com/tiles?x={x}&y={y}&z={z}&v=1&ts=online_sd_ar",arabicRetinaTileServer:"//tile{s}.maps.2gis.com/tiles?x={x}&y={y}&z={z}&v=1&ts=online_hd_ar",arabicPreviewTileServer:"//tile{s}.maps.2gis.com/tiles?x={x}&y={y}&z={z}&v=1&size=64&ts=online_sd_ar",arabicPreviewRetinaTileServer:"//tile{s}.maps.2gis.com/tiles?x={x}&y={y}&z={z}&v=1&size=64&ts=online_hd_ar",trafficTileServer:"//traffic{s}.maps.2gis.com/{projectCode}/traffic/{z}/{x}/{y}/speed/{period}/{timestampString}",retinaTrafficTileServer:"//traffic{s}.maps.2gis.com/{projectCode}/traffic/{z}/{x}/{y}/speed/{period}/retina/{timestampString}",trafficMetaServer:"//meta{s}.maps.2gis.com/{projectCode}/meta/{z}/{x}/{y}/graph_speed/{period}/{timestampString}",retinaTrafficMetaServer:"//meta{s}.maps.2gis.com/{projectCode}/meta/{z}/{x}/{y}/graph_speed/{period}/retina/{timestampString}",trafficTimestampServer:"//traffic{s}.maps.2gis.com/{projectCode}/meta/speed/time/",trafficScoreServer:"//traffic{s}.maps.2gis.com/{projectCode}/meta/score/0/",poiMetaServer:"//tile{s}.maps.2gis.com/poi?x={x}&y={y}&z={z}&v=1&ts=online_sd",retinaPoiMetaServer:"//tile{s}.maps.2gis.com/poi?x={x}&y={y}&z={z}&v=1&ts=online_hd",arabicPoiMetaServer:"//tile{s}.maps.2gis.com/poi?x={x}&y={y}&z={z}&v=1&ts=online_sd_ar",arabicRetinaPoiMetaServer:"//tile{s}.maps.2gis.com/poi?x={x}&y={y}&z={z}&v=1&ts=online_hd_ar",webApiServer:"//catalog.api.2gis.ru",googleAnalytics:"https://www.google-analytics.com/analytics.js",loadProjectListTimeout:5e3},_dereq_("../../../dist/css/styles.full.dark.css")}).call(this,_dereq_("_process"))},{"../../../dist/css/styles.full.dark.css":1,"../../../vendors/baron":9,_process:8,"dustjs-helpers":4,"dustjs-linkedin":5,html5shiv:6,leaflet:7}],3:[function(t,e,i){"use strict";var o=[],n=function(t,e){var i=document.head||document.getElementsByTagName("head")[0],n=o[o.length-1];if(e=e||{},e.insertAt=e.insertAt||"bottom","top"===e.insertAt)n?n.nextSibling?i.insertBefore(t,n.nextSibling):i.appendChild(t):i.insertBefore(t,i.firstChild),o.push(t);else{if("bottom"!==e.insertAt)throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");i.appendChild(t)}};e.exports={createLink:function(t,e){var i=document.head||document.getElementsByTagName("head")[0],o=document.createElement("link");o.href=t,o.rel="stylesheet";for(var n in e)if(e.hasOwnProperty(n)){var r=e[n];o.setAttribute("data-"+n,r)}i.appendChild(o)},createStyle:function(t,e,i){i=i||{};var o=document.createElement("style");o.type="text/css";for(var r in e)if(e.hasOwnProperty(r)){var a=e[r];o.setAttribute("data-"+r,a)}o.sheet?(o.innerHTML=t,o.sheet.cssText=t,n(o,{insertAt:i.insertAt})):o.styleSheet?(n(o,{insertAt:i.insertAt}),o.styleSheet.cssText=t):(o.appendChild(document.createTextNode(t)),n(o,{insertAt:i.insertAt}))}}},{}],4:[function(t,e,i){!function(o,n){"function"==typeof define&&define.amd&&define.amd.dust===!0?define(["dust.core"],n):"object"==typeof i?e.exports=n(t("dustjs-linkedin")):n(o.dust)}(this,function(t){function e(e,i,o){o=o||"INFO",e=e?"{@"+e+"}: ":"",t.log(e+i,o)}function i(t){h[t]||(e(t,"Deprecation warning: "+t+" is deprecated and will be removed in a future version of dustjs-helpers","WARN"),e(null,"For help and a deprecation timeline, see https://github.com/linkedin/dustjs-helpers/wiki/Deprecated-Features#"+t.replace(/\W+/g,""),"WARN"),h[t]=!0)}function o(t){return t.stack.tail&&t.stack.tail.head&&"undefined"!=typeof t.stack.tail.head.__select__}function n(t){return o(t)&&t.get("__select__")}function r(t,e){var i,o=t.stack.head,n=t.rebase();t.stack&&t.stack.tail&&(n.stack=t.stack.tail);var r={isPending:!1,isResolved:!1,isDeferredComplete:!1,deferreds:[]};for(i in e)r[i]=e[i];return n.push({__select__:r}).push(o,t.stack.index,t.stack.of)}function a(t){var e,i;if(t.isDeferredPending=!0,t.deferreds.length)for(t.isDeferredComplete=!0,e=0,i=t.deferreds.length;e<i;e++)t.deferreds[e]();t.isDeferredPending=!1}function s(t,e){return"function"==typeof e?e.toString().replace(/(^\s+|\s+$)/gm,"").replace(/\n/gm,"").replace(/,\s*/gm,", ").replace(/\)\{/gm,") {"):e}function l(t,e){return function(i,o,n,r){return u(i,o,n,r,t,e)}}function u(t,i,o,r,a,s){var l,u,h,d,p=o.block,_=o["else"],m=n(i)||{};if(m.isResolved&&!m.isDeferredPending)return t;if(r.hasOwnProperty("key"))u=r.key;else{if(!m.hasOwnProperty("key"))return e(a,"No key specified","WARN"),t;u=m.key}return d=r.type||m.type,u=c(i.resolve(u),d),h=c(i.resolve(r.value),d),s(u,h)?(m.isPending||(l=!0,m.isPending=!0),p&&(t=t.render(p,i)),l&&(m.isResolved=!0)):_&&(t=t.render(_,i)),t}function c(t,e){switch(e&&(e=e.toLowerCase()),e){case"number":return+t;case"string":return String(t);case"boolean":return t="false"!==t&&t,Boolean(t);case"date":return new Date(t)}return t}var h={},d={tap:function(t,e,o){return i("tap"),o.resolve(t)},sep:function(t,e,i){var o=i.block;return e.stack.index===e.stack.of-1?t:o?o(t,e):t},first:function(t,e,i){return 0===e.stack.index?i.block(t,e):t},last:function(t,e,i){return e.stack.index===e.stack.of-1?i.block(t,e):t},contextDump:function(t,i,o,n){var r,a,l=i.resolve(n.to),u=i.resolve(n.key);switch(u){case"full":r=i.stack;break;default:r=i.stack.head}switch(a=JSON.stringify(r,s,2),l){case"console":e("contextDump",a);break;default:a=a.replace(/</g,"\\u003c"),t=t.write(a)}return t},math:function(t,i,o,s){var l,u=s.key,c=s.method,h=s.operand,d=s.round;if(!s.hasOwnProperty("key")||!s.method)return e("math","`key` or `method` was not provided","ERROR"),t;switch(u=parseFloat(i.resolve(u)),h=parseFloat(i.resolve(h)),c){case"mod":0===h&&e("math","Division by 0","ERROR"),l=u%h;break;case"add":l=u+h;break;case"subtract":l=u-h;break;case"multiply":l=u*h;break;case"divide":0===h&&e("math","Division by 0","ERROR"),l=u/h;break;case"ceil":case"floor":case"round":case"abs":l=Math[c](u);break;case"toint":l=parseInt(u,10);break;default:e("math","Method `"+c+"` is not supported","ERROR")}return"undefined"!=typeof l&&(d&&(l=Math.round(l)),o&&o.block?(i=r(i,{key:l}),t=t.render(o.block,i),a(n(i))):t=t.write(l)),t},select:function(t,i,o,s){var l=o.block,u={};return s.hasOwnProperty("key")&&(u.key=i.resolve(s.key)),s.hasOwnProperty("type")&&(u.type=s.type),l?(i=r(i,u),t=t.render(l,i),a(n(i))):e("select","Missing body block","WARN"),t},eq:l("eq",function(t,e){return t===e}),ne:l("ne",function(t,e){return t!==e}),lt:l("lt",function(t,e){return t<e}),lte:l("lte",function(t,e){return t<=e}),gt:l("gt",function(t,e){return t>e}),gte:l("gte",function(t,e){return t>=e}),any:function(t,i,o,r){var a=n(i);return a?a.isDeferredComplete?e("any","Must not be nested inside {@any} or {@none} block","ERROR"):t=t.map(function(t){a.deferreds.push(function(){a.isResolved&&(t=t.render(o.block,i)),t.end()})}):e("any","Must be used inside a {@select} block","ERROR"),t},none:function(t,i,o,r){var a=n(i);return a?a.isDeferredComplete?e("none","Must not be nested inside {@any} or {@none} block","ERROR"):t=t.map(function(t){a.deferreds.push(function(){a.isResolved||(t=t.render(o.block,i)),t.end()})}):e("none","Must be used inside a {@select} block","ERROR"),t},size:function(e,i,o,n){var r,a,s=n.key;if(s=i.resolve(n.key),s&&s!==!0)if(t.isArray(s))r=s.length;else if(!isNaN(parseFloat(s))&&isFinite(s))r=s;else if("object"==typeof s){r=0;for(a in s)s.hasOwnProperty(a)&&r++}else r=(s+"").length;else r=0;return e.write(r)}};for(var p in d)t.helpers[p]=d[p];return t})},{"dustjs-linkedin":5}],5:[function(_dereq_,module,exports){(function(process){!function(t,e){"function"==typeof define&&define.amd&&define.amd.dust===!0?define("dust.core",[],e):"object"==typeof exports?module.exports=e():t.dust=e()}(this,function(){function getTemplate(t,e){if(t)return"function"==typeof t&&t.template?t.template:dust.isTemplateFn(t)?t:e!==!1?dust.cache[t]:void 0}function load(t,e,i){if(!t)return e.setError(new Error("No template or template name provided to render"));var o=getTemplate(t,dust.config.cache);return o?o(e,Context.wrap(i,o.templateName)):dust.onLoad?e.map(function(e){function o(t,o){var r;if(t)return e.setError(t);if(r=getTemplate(o,!1)||getTemplate(n,dust.config.cache),!r){if(!dust.compile)return e.setError(new Error("Dust compiler not available"));r=dust.loadSource(dust.compile(o,n))}r(e,Context.wrap(i,r.templateName)).end()}var n=t;3===dust.onLoad.length?dust.onLoad(n,i.options,o):dust.onLoad(n,o)}):e.setError(new Error("Template Not Found: "+t))}function Context(t,e,i,o,n){void 0===t||t instanceof Stack||(t=new Stack(t)),this.stack=t,this.global=e,this.options=i,this.blocks=o,this.templateName=n,this._isContext=!0}function getWithResolvedData(t,e,i){return function(o){return t.push(o)._get(e,i)}}function Stack(t,e,i,o){this.tail=e,this.isObject=t&&"object"==typeof t,this.head=t,this.index=i,this.of=o}function Stub(t){this.head=new Chunk(this),this.callback=t,this.out=""}function Stream(){this.head=new Chunk(this)}function Chunk(t,e,i){this.root=t,this.next=e,this.data=[],this.flushable=!1,this.taps=i}function mapThenable(t,e,i,o,n){return t.map(function(t){e.then(function(e){try{n(t,e)}catch(i){dust.log(i,ERROR),t.setError(i)}},function(e){dust.log("Unhandled promise rejection in `"+i.getTemplateName()+"`",INFO),t.renderError(e,i,o).end()})})}function Tap(t,e){this.head=t,this.tail=e}var dust={version:"3.0.1"},NONE="NONE",ERROR="ERROR",WARN="WARN",INFO="INFO",DEBUG="DEBUG",EMPTY_FUNC=function(){};dust.config={whitespace:!1,amd:!1,cjs:!1,cache:!0},dust._aliases={write:"w",end:"e",map:"m",render:"r",reference:"f",section:"s",exists:"x",notexists:"nx",block:"b",partial:"p",helper:"h"},function(){var t,e,i={DEBUG:0,INFO:1,WARN:2,ERROR:3,NONE:4};"undefined"!=typeof console&&console.log?(t=console.log,e="function"==typeof t?function(){t.apply(console,arguments)}:function(){t(Array.prototype.slice.apply(arguments).join(" "))}):e=EMPTY_FUNC,dust.log=function(t,o){o=o||INFO,i[o]>=i[dust.debugLevel]&&(e("[DUST:"+o+"]",t),o===ERROR&&dust.debugLevel===DEBUG&&t instanceof Error&&t.stack&&e("[DUST:"+o+"]",t.stack))},dust.debugLevel=NONE,"undefined"!=typeof process&&process.env&&/\bdust\b/.test(process.env.DEBUG)&&(dust.debugLevel=DEBUG)}(),dust.helpers={},dust.cache={},dust.register=function(t,e){t&&(e.templateName=t,dust.config.cache!==!1&&(dust.cache[t]=e))},dust.render=function(t,e,i){var o=new Stub(i).head;try{load(t,o,e).end()}catch(n){o.setError(n)}},dust.stream=function(t,e){var i=new Stream,o=i.head;return dust.nextTick(function(){try{load(t,o,e).end()}catch(i){o.setError(i)}}),i},dust.loadSource=function(source){return eval(source)},Array.isArray?dust.isArray=Array.isArray:dust.isArray=function(t){return"[object Array]"===Object.prototype.toString.call(t)},dust.nextTick=function(){return function(t){setTimeout(t,0)}}(),dust.isEmpty=function(t){return 0!==t&&(!(!dust.isArray(t)||t.length)||!t)},dust.isEmptyObject=function(t){var e;if(null===t)return!1;if(void 0===t)return!1;if(t.length>0)return!1;for(e in t)if(Object.prototype.hasOwnProperty.call(t,e))return!1;return!0},dust.isTemplateFn=function(t){return"function"==typeof t&&t.__dustBody},dust.isThenable=function(t){return t&&("object"==typeof t||"function"==typeof t)&&"function"==typeof t.then},dust.isNonThenableFunction=function(t){return"function"==typeof t&&!dust.isThenable(t)},dust.isStreamable=function(t){return t&&"function"==typeof t.on&&"function"==typeof t.pipe},dust.filter=function(t,e,i,o){var n,r,a,s;if(i)for(n=0,r=i.length;n<r;n++)a=i[n],a.length&&(s=dust.filters[a],"s"===a?e=null:"function"==typeof s?t=s(t,o):dust.log("Invalid filter `"+a+"`",WARN));return e&&(t=dust.filters[e](t,o)),t},dust.filters={h:function(t){return dust.escapeHtml(t)},j:function(t){return dust.escapeJs(t)},u:encodeURI,uc:encodeURIComponent,js:function(t){return dust.escapeJSON(t)},jp:function(t){return JSON?JSON.parse(t):(dust.log("JSON is undefined; could not parse `"+t+"`",WARN),t)}},dust.makeBase=dust.context=function(t,e){return new Context((void 0),t,e)},dust.isContext=function(t){return"object"==typeof t&&t._isContext===!0},Context.wrap=function(t,e){return dust.isContext(t)?(t.templateName=e,t):new Context(t,{},{},null,e)},Context.prototype.get=function(t,e){return"string"==typeof t&&("."===t[0]&&(e=!0,t=t.substr(1)),t=t.split(".")),this._get(e,t)},Context.prototype._get=function(t,e){var i,o,n,r,a,s=this.stack||{},l=1;if(o=e[0],n=e.length,t&&0===n)r=s,s=s.head;else{if(t)s&&(s=s.head?s.head[o]:void 0);else{for(;s&&(!s.isObject||(r=s.head,i=s.head[o],void 0===i));)s=s.tail;s=void 0!==i?i:this.global&&this.global[o]}for(;s&&l<n;){if(dust.isThenable(s))return s.then(getWithResolvedData(this,t,e.slice(l)));r=s,s=s[e[l]],l++}}return dust.isNonThenableFunction(s)?(a=function(){try{return s.apply(r,arguments)}catch(t){throw dust.log(t,ERROR),t}},a.__dustBody=!!s.__dustBody,a):(void 0===s&&dust.log("Cannot find reference `{"+e.join(".")+"}` in template `"+this.getTemplateName()+"`",INFO),s)},Context.prototype.getPath=function(t,e){return this._get(t,e)},Context.prototype.push=function(t,e,i){return void 0===t?(dust.log("Not pushing an undefined variable onto the context",INFO),this):this.rebase(new Stack(t,this.stack,e,i))},Context.prototype.pop=function(){var t=this.current();return this.stack=this.stack&&this.stack.tail,t},Context.prototype.rebase=function(t){return new Context(t,this.global,this.options,this.blocks,this.getTemplateName())},Context.prototype.clone=function(){var t=this.rebase();return t.stack=this.stack,t},Context.prototype.current=function(){return this.stack&&this.stack.head},Context.prototype.getBlock=function(t){var e,i,o;if("function"==typeof t&&(t=t(new Chunk,this).data.join("")),e=this.blocks,!e)return dust.log("No blocks for context `"+t+"` in template `"+this.getTemplateName()+"`",DEBUG),!1;for(i=e.length;i--;)if(o=e[i][t])return o;return dust.log("Malformed template `"+this.getTemplateName()+"` was missing one or more blocks."),!1},Context.prototype.shiftBlocks=function(t){var e,i=this.blocks;return t?(e=i?i.concat([t]):[t],new Context(this.stack,this.global,this.options,e,this.getTemplateName())):this},Context.prototype.resolve=function(t){var e;return"function"!=typeof t?t:(e=(new Chunk).render(t,this),e instanceof Chunk?e.data.join(""):e)},Context.prototype.getTemplateName=function(){return this.templateName},Stub.prototype.flush=function(){for(var t=this.head;t;){if(!t.flushable)return t.error?(this.callback(t.error),dust.log("Rendering failed with error `"+t.error+"`",ERROR),void(this.flush=EMPTY_FUNC)):void 0;this.out+=t.data.join(""),t=t.next,this.head=t}this.callback(null,this.out)},Stream.prototype.flush=function(){for(var t=this.head;t;){if(!t.flushable)return t.error?(this.emit("error",t.error),this.emit("end"),dust.log("Streaming failed with error `"+t.error+"`",ERROR),void(this.flush=EMPTY_FUNC)):void 0;this.emit("data",t.data.join("")),t=t.next,this.head=t}this.emit("end")},Stream.prototype.emit=function(t,e){var i,o,n=this.events||{},r=n[t]||[];if(!r.length)return dust.log("Stream broadcasting, but no listeners for `"+t+"`",DEBUG),!1;for(r=r.slice(0),i=0,o=r.length;i<o;i++)r[i](e);return!0},Stream.prototype.on=function(t,e){var i=this.events=this.events||{},o=i[t]=i[t]||[];return"function"!=typeof e?dust.log("No callback function provided for `"+t+"` event listener",WARN):o.push(e),this},Stream.prototype.pipe=function(t){if("function"!=typeof t.write||"function"!=typeof t.end)return dust.log("Incompatible stream passed to `pipe`",WARN),this;var e=!1;return"function"==typeof t.emit&&t.emit("pipe",this),"function"==typeof t.on&&t.on("error",function(){e=!0}),this.on("data",function(i){if(!e)try{t.write(i,"utf8")}catch(o){dust.log(o,ERROR)}}).on("end",function(){if(!e)try{t.end(),e=!0}catch(i){dust.log(i,ERROR)}})},Chunk.prototype.write=function(t){var e=this.taps;return e&&(t=e.go(t)),this.data.push(t),this},Chunk.prototype.end=function(t){return t&&this.write(t),this.flushable=!0,this.root.flush(),this},Chunk.prototype.map=function(t){var e=new Chunk(this.root,this.next,this.taps),i=new Chunk(this.root,e,this.taps);this.next=i,this.flushable=!0;try{t(i)}catch(o){dust.log(o,ERROR),i.setError(o)}return e},Chunk.prototype.tap=function(t){var e=this.taps;return e?this.taps=e.push(t):this.taps=new Tap(t),this},Chunk.prototype.untap=function(){return this.taps=this.taps.tail,this},Chunk.prototype.render=function(t,e){return t(this,e)},Chunk.prototype.reference=function(t,e,i,o){return dust.isNonThenableFunction(t)?(t=t.apply(e.current(),[this,e,null,{auto:i,filters:o}]),t instanceof Chunk?t:this.reference(t,e,i,o)):dust.isThenable(t)?this.await(t,e,null,i,o):dust.isStreamable(t)?this.stream(t,e,null,i,o):dust.isEmpty(t)?this:this.write(dust.filter(t,i,o,e))},Chunk.prototype.section=function(t,e,i,o){var n,r,a,s=i.block,l=i["else"],u=this;if(dust.isNonThenableFunction(t)&&!dust.isTemplateFn(t)){try{t=t.apply(e.current(),[this,e,i,o])}catch(c){return dust.log(c,ERROR),this.setError(c)}if(t instanceof Chunk)return t}if(dust.isEmptyObject(i))return u;if(dust.isEmptyObject(o)||(e=e.push(o)),dust.isArray(t)){if(s){if(r=t.length,r>0){for(a=e.stack&&e.stack.head||{},a.$len=r,n=0;n<r;n++)a.$idx=n,u=s(u,e.push(t[n],n,r));return a.$idx=void 0,a.$len=void 0,u}if(l)return l(this,e)}}else{if(dust.isThenable(t))return this.await(t,e,i);if(dust.isStreamable(t))return this.stream(t,e,i);if(t===!0){if(s)return s(this,e)}else if(t||0===t){if(s)return s(this,e.push(t))}else if(l)return l(this,e)}return dust.log("Section without corresponding key in template `"+e.getTemplateName()+"`",DEBUG),this},Chunk.prototype.exists=function(t,e,i){var o=i.block,n=i["else"];if(dust.isThenable(t))return mapThenable(this,t,e,i,function(t,o){t.exists(o,e,i).end()});if(dust.isEmpty(t)){if(n)return n(this,e)}else{if(o)return o(this,e);dust.log("No block for exists check in template `"+e.getTemplateName()+"`",DEBUG)}return this},Chunk.prototype.notexists=function(t,e,i){var o=i.block,n=i["else"];if(dust.isThenable(t))return mapThenable(this,t,e,i,function(t,o){t.notexists(o,e,i).end()});if(dust.isEmpty(t)){if(o)return o(this,e);dust.log("No block for not-exists check in template `"+e.getTemplateName()+"`",DEBUG)}else if(n)return n(this,e);return this},Chunk.prototype.block=function(t,e,i){var o=t||i.block;return o?o(this,e):this},Chunk.prototype.partial=function(t,e,i,o){var n;return void 0===o&&(o=i,i=e),dust.isEmptyObject(o)||(i=i.clone(),n=i.pop(),i=i.push(o).push(n)),dust.isTemplateFn(t)?this.capture(t,e,function(t,e){load(t,e,i).end()}):load(t,this,i)},Chunk.prototype.helper=function(t,e,i,o,n){var r,a=this,s=o.filters;if(void 0===n&&(n="h"),!dust.helpers[t])return dust.log("Helper `"+t+"` does not exist",WARN),a;try{return r=dust.helpers[t](a,e,i,o),r instanceof Chunk?r:("string"==typeof s&&(s=s.split("|")),dust.isEmptyObject(i)?a.reference(r,e,n,s):a.section(r,e,i,o))}catch(l){return dust.log("Error in helper `"+t+"`: "+l.message,ERROR),a.setError(l)}},Chunk.prototype.await=function(t,e,i,o,n){return mapThenable(this,t,e,i,function(t,r){i?t.section(r,e,i).end():t.reference(r,e,o,n).end()})},Chunk.prototype.renderError=function(t,e,i){var o=i&&i.error;return o?this.render(o,e.push(t)):this},Chunk.prototype.stream=function(t,e,i,o,n){var r=i&&i.block;return this.map(function(a){var s=!1;t.on("data",function(t){s||(r?a=a.map(function(i){i.render(r,e.push(t)).end()}):i||(a=a.reference(t,e,o,n)))}).on("error",function(t){s||(a.renderError(t,e,i),dust.log("Unhandled stream error in `"+e.getTemplateName()+"`",INFO),s||(s=!0,a.end()))}).on("end",function(){s||(s=!0,a.end())})})},Chunk.prototype.capture=function(t,e,i){return this.map(function(o){var n=new Stub(function(t,e){t?o.setError(t):i(e,o)});t(n.head,e).end()})},Chunk.prototype.setError=function(t){return this.error=t,this.root.flush(),this};for(var f in Chunk.prototype)dust._aliases[f]&&(Chunk.prototype[dust._aliases[f]]=Chunk.prototype[f]);Tap.prototype.push=function(t){return new Tap(t,this)},Tap.prototype.go=function(t){for(var e=this;e;)t=e.head(t),e=e.tail;return t};var HCHARS=/[&<>"']/,AMP=/&/g,LT=/</g,GT=/>/g,QUOT=/\"/g,SQUOT=/\'/g;dust.escapeHtml=function(t){return"string"==typeof t||t&&"function"==typeof t.toString?("string"!=typeof t&&(t=t.toString()),HCHARS.test(t)?t.replace(AMP,"&amp;").replace(LT,"&lt;").replace(GT,"&gt;").replace(QUOT,"&quot;").replace(SQUOT,"&#39;"):t):t};var BS=/\\/g,FS=/\//g,CR=/\r/g,LS=/\u2028/g,PS=/\u2029/g,NL=/\n/g,LF=/\f/g,SQ=/'/g,DQ=/"/g,TB=/\t/g;return dust.escapeJs=function(t){return"string"==typeof t?t.replace(BS,"\\\\").replace(FS,"\\/").replace(DQ,'\\"').replace(SQ,"\\'").replace(CR,"\\r").replace(LS,"\\u2028").replace(PS,"\\u2029").replace(NL,"\\n").replace(LF,"\\f").replace(TB,"\\t"):t},dust.escapeJSON=function(t){return JSON?JSON.stringify(t).replace(LS,"\\u2028").replace(PS,"\\u2029").replace(LT,"\\u003c"):(dust.log("JSON is undefined; could not escape `"+t+"`",WARN),t)},dust})}).call(this,_dereq_("_process"))},{_process:8}],6:[function(t,e,i){!function(t,i){function o(t,e){var i=t.createElement("p"),o=t.getElementsByTagName("head")[0]||t.documentElement;return i.innerHTML="x<style>"+e+"</style>",o.insertBefore(i.lastChild,o.firstChild)}function n(){var t=b.elements;return"string"==typeof t?t.split(" "):t}function r(t,e){var i=b.elements;"string"!=typeof i&&(i=i.join(" ")),"string"!=typeof t&&(t=t.join(" ")),b.elements=i+" "+t,c(e)}function a(t){var e=y[t[g]];return e||(e={},v++,t[g]=v,y[v]=e),e}function s(t,e,o){if(e||(e=i),d)return e.createElement(t);o||(o=a(e));var n;return n=o.cache[t]?o.cache[t].cloneNode():f.test(t)?(o.cache[t]=o.createElem(t)).cloneNode():o.createElem(t),!n.canHaveChildren||m.test(t)||n.tagUrn?n:o.frag.appendChild(n)}function l(t,e){if(t||(t=i),d)return t.createDocumentFragment();e=e||a(t);for(var o=e.frag.cloneNode(),r=0,s=n(),l=s.length;r<l;r++)o.createElement(s[r]);return o}function u(t,e){e.cache||(e.cache={},e.createElem=t.createElement,e.createFrag=t.createDocumentFragment,e.frag=e.createFrag()),t.createElement=function(i){return b.shivMethods?s(i,t,e):e.createElem(i)},t.createDocumentFragment=Function("h,f","return function(){var n=f.cloneNode(),c=n.createElement;h.shivMethods&&("+n().join().replace(/[\w\-:]+/g,function(t){return e.createElem(t),e.frag.createElement(t),'c("'+t+'")'})+");return n}")(b,e.frag)}function c(t){t||(t=i);var e=a(t);return!b.shivCSS||h||e.hasCSS||(e.hasCSS=!!o(t,"article,aside,dialog,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}mark{background:#FF0;color:#000}template{display:none}")),d||u(t,e),t}var h,d,p="3.7.3-pre",_=t.html5||{},m=/^<|^(?:button|map|select|textarea|object|iframe|option|optgroup)$/i,f=/^(?:a|b|code|div|fieldset|h1|h2|h3|h4|h5|h6|i|label|li|ol|p|q|span|strong|style|table|tbody|td|th|tr|ul)$/i,g="_html5shiv",v=0,y={};!function(){try{var t=i.createElement("a");t.innerHTML="<xyz></xyz>",h="hidden"in t,d=1==t.childNodes.length||function(){i.createElement("a");var t=i.createDocumentFragment();return"undefined"==typeof t.cloneNode||"undefined"==typeof t.createDocumentFragment||"undefined"==typeof t.createElement}()}catch(e){h=!0,d=!0}}();var b={elements:_.elements||"abbr article aside audio bdi canvas data datalist details dialog figcaption figure footer header hgroup main mark meter nav output picture progress section summary template time video",version:p,shivCSS:_.shivCSS!==!1,supportsUnknownElements:d,shivMethods:_.shivMethods!==!1,type:"default",shivDocument:c,createElement:s,createDocumentFragment:l,addElements:r};t.html5=b,c(i),"object"==typeof e&&e.exports&&(e.exports=b)}("undefined"!=typeof window?window:this,document)},{}],7:[function(t,e,i){function o(){var t=window.L;n.noConflict=function(){return window.L=t,this},window.L=n}var n={version:"1.0.1"};"object"==typeof e&&"object"==typeof e.exports?e.exports=n:"function"==typeof define&&define.amd&&define(n),"undefined"!=typeof window&&o(),n.Util={extend:function(t){var e,i,o,n;for(i=1,o=arguments.length;i<o;i++){n=arguments[i];for(e in n)t[e]=n[e]}return t},create:Object.create||function(){function t(){}return function(e){return t.prototype=e,new t}}(),bind:function(t,e){var i=Array.prototype.slice;if(t.bind)return t.bind.apply(t,i.call(arguments,1));var o=i.call(arguments,2);return function(){return t.apply(e,o.length?o.concat(i.call(arguments)):arguments)}},stamp:function(t){return t._leaflet_id=t._leaflet_id||++n.Util.lastId,t._leaflet_id},lastId:0,throttle:function(t,e,i){var o,n,r,a;return a=function(){o=!1,n&&(r.apply(i,n),n=!1)},r=function(){o?n=arguments:(t.apply(i,arguments),setTimeout(a,e),o=!0)}},wrapNum:function(t,e,i){var o=e[1],n=e[0],r=o-n;return t===o&&i?t:((t-n)%r+r)%r+n},falseFn:function(){return!1},formatNum:function(t,e){var i=Math.pow(10,e||5);return Math.round(t*i)/i},trim:function(t){return t.trim?t.trim():t.replace(/^\s+|\s+$/g,"")},splitWords:function(t){return n.Util.trim(t).split(/\s+/)},setOptions:function(t,e){t.hasOwnProperty("options")||(t.options=t.options?n.Util.create(t.options):{});for(var i in e)t.options[i]=e[i];return t.options},getParamString:function(t,e,i){var o=[];for(var n in t)o.push(encodeURIComponent(i?n.toUpperCase():n)+"="+encodeURIComponent(t[n]));return(e&&e.indexOf("?")!==-1?"&":"?")+o.join("&")},template:function(t,e){return t.replace(n.Util.templateRe,function(t,i){var o=e[i];if(void 0===o)throw new Error("No value provided for variable "+t);return"function"==typeof o&&(o=o(e)),o})},templateRe:/\{ *([\w_\-]+) *\}/g,isArray:Array.isArray||function(t){return"[object Array]"===Object.prototype.toString.call(t)},indexOf:function(t,e){for(var i=0;i<t.length;i++)if(t[i]===e)return i;return-1},emptyImageUrl:"data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs="},function(){function t(t){return window["webkit"+t]||window["moz"+t]||window["ms"+t]}function e(t){var e=+new Date,o=Math.max(0,16-(e-i));return i=e+o,window.setTimeout(t,o)}var i=0,o=window.requestAnimationFrame||t("RequestAnimationFrame")||e,r=window.cancelAnimationFrame||t("CancelAnimationFrame")||t("CancelRequestAnimationFrame")||function(t){window.clearTimeout(t)};n.Util.requestAnimFrame=function(t,i,r){return r&&o===e?void t.call(i):o.call(window,n.bind(t,i))},n.Util.cancelAnimFrame=function(t){t&&r.call(window,t)}}(),n.extend=n.Util.extend,n.bind=n.Util.bind,n.stamp=n.Util.stamp,n.setOptions=n.Util.setOptions,n.Class=function(){},n.Class.extend=function(t){var e=function(){this.initialize&&this.initialize.apply(this,arguments),this.callInitHooks()},i=e.__super__=this.prototype,o=n.Util.create(i);o.constructor=e,e.prototype=o;for(var r in this)this.hasOwnProperty(r)&&"prototype"!==r&&(e[r]=this[r]);return t.statics&&(n.extend(e,t.statics),delete t.statics),t.includes&&(n.Util.extend.apply(null,[o].concat(t.includes)),delete t.includes),o.options&&(t.options=n.Util.extend(n.Util.create(o.options),t.options)),n.extend(o,t),o._initHooks=[],o.callInitHooks=function(){if(!this._initHooksCalled){i.callInitHooks&&i.callInitHooks.call(this),this._initHooksCalled=!0;for(var t=0,e=o._initHooks.length;t<e;t++)o._initHooks[t].call(this)}},e},n.Class.include=function(t){return n.extend(this.prototype,t),this},n.Class.mergeOptions=function(t){return n.extend(this.prototype.options,t),this},n.Class.addInitHook=function(t){var e=Array.prototype.slice.call(arguments,1),i="function"==typeof t?t:function(){this[t].apply(this,e)};return this.prototype._initHooks=this.prototype._initHooks||[],this.prototype._initHooks.push(i),this},n.Evented=n.Class.extend({on:function(t,e,i){if("object"==typeof t)for(var o in t)this._on(o,t[o],e);else{t=n.Util.splitWords(t);for(var r=0,a=t.length;r<a;r++)this._on(t[r],e,i)}return this},off:function(t,e,i){if(t)if("object"==typeof t)for(var o in t)this._off(o,t[o],e);else{t=n.Util.splitWords(t);for(var r=0,a=t.length;r<a;r++)this._off(t[r],e,i)}else delete this._events;return this},_on:function(t,e,i){this._events=this._events||{};var o=this._events[t];o||(o=[],this._events[t]=o),i===this&&(i=void 0);for(var n={fn:e,ctx:i},r=o,a=0,s=r.length;a<s;a++)if(r[a].fn===e&&r[a].ctx===i)return;r.push(n),o.count++},_off:function(t,e,i){var o,r,a;if(this._events&&(o=this._events[t])){if(!e){for(r=0,a=o.length;r<a;r++)o[r].fn=n.Util.falseFn;return void delete this._events[t]}if(i===this&&(i=void 0),o)for(r=0,a=o.length;r<a;r++){var s=o[r];if(s.ctx===i&&s.fn===e)return s.fn=n.Util.falseFn,this._firingCount&&(this._events[t]=o=o.slice()),void o.splice(r,1)}}},fire:function(t,e,i){if(!this.listens(t,i))return this;var o=n.Util.extend({},e,{type:t,target:this});if(this._events){var r=this._events[t];if(r){this._firingCount=this._firingCount+1||1;for(var a=0,s=r.length;a<s;a++){var l=r[a];l.fn.call(l.ctx||this,o)}this._firingCount--}}return i&&this._propagateEvent(o),this},listens:function(t,e){var i=this._events&&this._events[t];if(i&&i.length)return!0;if(e)for(var o in this._eventParents)if(this._eventParents[o].listens(t,e))return!0;return!1},once:function(t,e,i){if("object"==typeof t){for(var o in t)this.once(o,t[o],e);return this}var r=n.bind(function(){this.off(t,e,i).off(t,r,i)},this);return this.on(t,e,i).on(t,r,i)},addEventParent:function(t){return this._eventParents=this._eventParents||{},this._eventParents[n.stamp(t)]=t,this},removeEventParent:function(t){return this._eventParents&&delete this._eventParents[n.stamp(t)],this},_propagateEvent:function(t){for(var e in this._eventParents)this._eventParents[e].fire(t.type,n.extend({layer:t.target},t),!0)}});var r=n.Evented.prototype;r.addEventListener=r.on,r.removeEventListener=r.clearAllEventListeners=r.off,r.addOneTimeEventListener=r.once,r.fireEvent=r.fire,r.hasEventListeners=r.listens,n.Mixin={Events:r},function(){var t=navigator.userAgent.toLowerCase(),e=document.documentElement,i="ActiveXObject"in window,o=t.indexOf("webkit")!==-1,r=t.indexOf("phantom")!==-1,a=t.search("android [23]")!==-1,s=t.indexOf("chrome")!==-1,l=t.indexOf("gecko")!==-1&&!o&&!window.opera&&!i,u=0===navigator.platform.indexOf("Win"),c="undefined"!=typeof orientation||t.indexOf("mobile")!==-1,h=!window.PointerEvent&&window.MSPointerEvent,d=window.PointerEvent||h,p=i&&"transition"in e.style,_="WebKitCSSMatrix"in window&&"m11"in new window.WebKitCSSMatrix&&!a,m="MozPerspective"in e.style,f="OTransition"in e.style,g=!window.L_NO_TOUCH&&(d||"ontouchstart"in window||window.DocumentTouch&&document instanceof window.DocumentTouch);n.Browser={ie:i,ielt9:i&&!document.addEventListener,edge:"msLaunchUri"in navigator&&!("documentMode"in document),webkit:o,gecko:l,android:t.indexOf("android")!==-1,android23:a,chrome:s,safari:!s&&t.indexOf("safari")!==-1,win:u,ie3d:p,webkit3d:_,gecko3d:m,opera12:f,any3d:!window.L_DISABLE_3D&&(p||_||m)&&!f&&!r,mobile:c,mobileWebkit:c&&o,mobileWebkit3d:c&&_,
	mobileOpera:c&&window.opera,mobileGecko:c&&l,touch:!!g,msPointer:!!h,pointer:!!d,retina:(window.devicePixelRatio||window.screen.deviceXDPI/window.screen.logicalXDPI)>1}}(),n.Point=function(t,e,i){this.x=i?Math.round(t):t,this.y=i?Math.round(e):e},n.Point.prototype={clone:function(){return new n.Point(this.x,this.y)},add:function(t){return this.clone()._add(n.point(t))},_add:function(t){return this.x+=t.x,this.y+=t.y,this},subtract:function(t){return this.clone()._subtract(n.point(t))},_subtract:function(t){return this.x-=t.x,this.y-=t.y,this},divideBy:function(t){return this.clone()._divideBy(t)},_divideBy:function(t){return this.x/=t,this.y/=t,this},multiplyBy:function(t){return this.clone()._multiplyBy(t)},_multiplyBy:function(t){return this.x*=t,this.y*=t,this},scaleBy:function(t){return new n.Point(this.x*t.x,this.y*t.y)},unscaleBy:function(t){return new n.Point(this.x/t.x,this.y/t.y)},round:function(){return this.clone()._round()},_round:function(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this},floor:function(){return this.clone()._floor()},_floor:function(){return this.x=Math.floor(this.x),this.y=Math.floor(this.y),this},ceil:function(){return this.clone()._ceil()},_ceil:function(){return this.x=Math.ceil(this.x),this.y=Math.ceil(this.y),this},distanceTo:function(t){t=n.point(t);var e=t.x-this.x,i=t.y-this.y;return Math.sqrt(e*e+i*i)},equals:function(t){return t=n.point(t),t.x===this.x&&t.y===this.y},contains:function(t){return t=n.point(t),Math.abs(t.x)<=Math.abs(this.x)&&Math.abs(t.y)<=Math.abs(this.y)},toString:function(){return"Point("+n.Util.formatNum(this.x)+", "+n.Util.formatNum(this.y)+")"}},n.point=function(t,e,i){return t instanceof n.Point?t:n.Util.isArray(t)?new n.Point(t[0],t[1]):void 0===t||null===t?t:"object"==typeof t&&"x"in t&&"y"in t?new n.Point(t.x,t.y):new n.Point(t,e,i)},n.Bounds=function(t,e){if(t)for(var i=e?[t,e]:t,o=0,n=i.length;o<n;o++)this.extend(i[o])},n.Bounds.prototype={extend:function(t){return t=n.point(t),this.min||this.max?(this.min.x=Math.min(t.x,this.min.x),this.max.x=Math.max(t.x,this.max.x),this.min.y=Math.min(t.y,this.min.y),this.max.y=Math.max(t.y,this.max.y)):(this.min=t.clone(),this.max=t.clone()),this},getCenter:function(t){return new n.Point((this.min.x+this.max.x)/2,(this.min.y+this.max.y)/2,t)},getBottomLeft:function(){return new n.Point(this.min.x,this.max.y)},getTopRight:function(){return new n.Point(this.max.x,this.min.y)},getSize:function(){return this.max.subtract(this.min)},contains:function(t){var e,i;return t="number"==typeof t[0]||t instanceof n.Point?n.point(t):n.bounds(t),t instanceof n.Bounds?(e=t.min,i=t.max):e=i=t,e.x>=this.min.x&&i.x<=this.max.x&&e.y>=this.min.y&&i.y<=this.max.y},intersects:function(t){t=n.bounds(t);var e=this.min,i=this.max,o=t.min,r=t.max,a=r.x>=e.x&&o.x<=i.x,s=r.y>=e.y&&o.y<=i.y;return a&&s},overlaps:function(t){t=n.bounds(t);var e=this.min,i=this.max,o=t.min,r=t.max,a=r.x>e.x&&o.x<i.x,s=r.y>e.y&&o.y<i.y;return a&&s},isValid:function(){return!(!this.min||!this.max)}},n.bounds=function(t,e){return!t||t instanceof n.Bounds?t:new n.Bounds(t,e)},n.Transformation=function(t,e,i,o){this._a=t,this._b=e,this._c=i,this._d=o},n.Transformation.prototype={transform:function(t,e){return this._transform(t.clone(),e)},_transform:function(t,e){return e=e||1,t.x=e*(this._a*t.x+this._b),t.y=e*(this._c*t.y+this._d),t},untransform:function(t,e){return e=e||1,new n.Point((t.x/e-this._b)/this._a,(t.y/e-this._d)/this._c)}},n.DomUtil={get:function(t){return"string"==typeof t?document.getElementById(t):t},getStyle:function(t,e){var i=t.style[e]||t.currentStyle&&t.currentStyle[e];if((!i||"auto"===i)&&document.defaultView){var o=document.defaultView.getComputedStyle(t,null);i=o?o[e]:null}return"auto"===i?null:i},create:function(t,e,i){var o=document.createElement(t);return o.className=e||"",i&&i.appendChild(o),o},remove:function(t){var e=t.parentNode;e&&e.removeChild(t)},empty:function(t){for(;t.firstChild;)t.removeChild(t.firstChild)},toFront:function(t){t.parentNode.appendChild(t)},toBack:function(t){var e=t.parentNode;e.insertBefore(t,e.firstChild)},hasClass:function(t,e){if(void 0!==t.classList)return t.classList.contains(e);var i=n.DomUtil.getClass(t);return i.length>0&&new RegExp("(^|\\s)"+e+"(\\s|$)").test(i)},addClass:function(t,e){if(void 0!==t.classList)for(var i=n.Util.splitWords(e),o=0,r=i.length;o<r;o++)t.classList.add(i[o]);else if(!n.DomUtil.hasClass(t,e)){var a=n.DomUtil.getClass(t);n.DomUtil.setClass(t,(a?a+" ":"")+e)}},removeClass:function(t,e){void 0!==t.classList?t.classList.remove(e):n.DomUtil.setClass(t,n.Util.trim((" "+n.DomUtil.getClass(t)+" ").replace(" "+e+" "," ")))},setClass:function(t,e){void 0===t.className.baseVal?t.className=e:t.className.baseVal=e},getClass:function(t){return void 0===t.className.baseVal?t.className:t.className.baseVal},setOpacity:function(t,e){"opacity"in t.style?t.style.opacity=e:"filter"in t.style&&n.DomUtil._setOpacityIE(t,e)},_setOpacityIE:function(t,e){var i=!1,o="DXImageTransform.Microsoft.Alpha";try{i=t.filters.item(o)}catch(n){if(1===e)return}e=Math.round(100*e),i?(i.Enabled=100!==e,i.Opacity=e):t.style.filter+=" progid:"+o+"(opacity="+e+")"},testProp:function(t){for(var e=document.documentElement.style,i=0;i<t.length;i++)if(t[i]in e)return t[i];return!1},setTransform:function(t,e,i){var o=e||new n.Point(0,0);t.style[n.DomUtil.TRANSFORM]=(n.Browser.ie3d?"translate("+o.x+"px,"+o.y+"px)":"translate3d("+o.x+"px,"+o.y+"px,0)")+(i?" scale("+i+")":"")},setPosition:function(t,e){t._leaflet_pos=e,n.Browser.any3d?n.DomUtil.setTransform(t,e):(t.style.left=e.x+"px",t.style.top=e.y+"px")},getPosition:function(t){return t._leaflet_pos||new n.Point(0,0)}},function(){n.DomUtil.TRANSFORM=n.DomUtil.testProp(["transform","WebkitTransform","OTransform","MozTransform","msTransform"]);var t=n.DomUtil.TRANSITION=n.DomUtil.testProp(["webkitTransition","transition","OTransition","MozTransition","msTransition"]);if(n.DomUtil.TRANSITION_END="webkitTransition"===t||"OTransition"===t?t+"End":"transitionend","onselectstart"in document)n.DomUtil.disableTextSelection=function(){n.DomEvent.on(window,"selectstart",n.DomEvent.preventDefault)},n.DomUtil.enableTextSelection=function(){n.DomEvent.off(window,"selectstart",n.DomEvent.preventDefault)};else{var e=n.DomUtil.testProp(["userSelect","WebkitUserSelect","OUserSelect","MozUserSelect","msUserSelect"]);n.DomUtil.disableTextSelection=function(){if(e){var t=document.documentElement.style;this._userSelect=t[e],t[e]="none"}},n.DomUtil.enableTextSelection=function(){e&&(document.documentElement.style[e]=this._userSelect,delete this._userSelect)}}n.DomUtil.disableImageDrag=function(){n.DomEvent.on(window,"dragstart",n.DomEvent.preventDefault)},n.DomUtil.enableImageDrag=function(){n.DomEvent.off(window,"dragstart",n.DomEvent.preventDefault)},n.DomUtil.preventOutline=function(t){for(;t.tabIndex===-1;)t=t.parentNode;t&&t.style&&(n.DomUtil.restoreOutline(),this._outlineElement=t,this._outlineStyle=t.style.outline,t.style.outline="none",n.DomEvent.on(window,"keydown",n.DomUtil.restoreOutline,this))},n.DomUtil.restoreOutline=function(){this._outlineElement&&(this._outlineElement.style.outline=this._outlineStyle,delete this._outlineElement,delete this._outlineStyle,n.DomEvent.off(window,"keydown",n.DomUtil.restoreOutline,this))}}(),n.LatLng=function(t,e,i){if(isNaN(t)||isNaN(e))throw new Error("Invalid LatLng object: ("+t+", "+e+")");this.lat=+t,this.lng=+e,void 0!==i&&(this.alt=+i)},n.LatLng.prototype={equals:function(t,e){if(!t)return!1;t=n.latLng(t);var i=Math.max(Math.abs(this.lat-t.lat),Math.abs(this.lng-t.lng));return i<=(void 0===e?1e-9:e)},toString:function(t){return"LatLng("+n.Util.formatNum(this.lat,t)+", "+n.Util.formatNum(this.lng,t)+")"},distanceTo:function(t){return n.CRS.Earth.distance(this,n.latLng(t))},wrap:function(){return n.CRS.Earth.wrapLatLng(this)},toBounds:function(t){var e=180*t/40075017,i=e/Math.cos(Math.PI/180*this.lat);return n.latLngBounds([this.lat-e,this.lng-i],[this.lat+e,this.lng+i])},clone:function(){return new n.LatLng(this.lat,this.lng,this.alt)}},n.latLng=function(t,e,i){return t instanceof n.LatLng?t:n.Util.isArray(t)&&"object"!=typeof t[0]?3===t.length?new n.LatLng(t[0],t[1],t[2]):2===t.length?new n.LatLng(t[0],t[1]):null:void 0===t||null===t?t:"object"==typeof t&&"lat"in t?new n.LatLng(t.lat,"lng"in t?t.lng:t.lon,t.alt):void 0===e?null:new n.LatLng(t,e,i)},n.LatLngBounds=function(t,e){if(t)for(var i=e?[t,e]:t,o=0,n=i.length;o<n;o++)this.extend(i[o])},n.LatLngBounds.prototype={extend:function(t){var e,i,o=this._southWest,r=this._northEast;if(t instanceof n.LatLng)e=t,i=t;else{if(!(t instanceof n.LatLngBounds))return t?this.extend(n.latLng(t)||n.latLngBounds(t)):this;if(e=t._southWest,i=t._northEast,!e||!i)return this}return o||r?(o.lat=Math.min(e.lat,o.lat),o.lng=Math.min(e.lng,o.lng),r.lat=Math.max(i.lat,r.lat),r.lng=Math.max(i.lng,r.lng)):(this._southWest=new n.LatLng(e.lat,e.lng),this._northEast=new n.LatLng(i.lat,i.lng)),this},pad:function(t){var e=this._southWest,i=this._northEast,o=Math.abs(e.lat-i.lat)*t,r=Math.abs(e.lng-i.lng)*t;return new n.LatLngBounds(new n.LatLng(e.lat-o,e.lng-r),new n.LatLng(i.lat+o,i.lng+r))},getCenter:function(){return new n.LatLng((this._southWest.lat+this._northEast.lat)/2,(this._southWest.lng+this._northEast.lng)/2)},getSouthWest:function(){return this._southWest},getNorthEast:function(){return this._northEast},getNorthWest:function(){return new n.LatLng(this.getNorth(),this.getWest())},getSouthEast:function(){return new n.LatLng(this.getSouth(),this.getEast())},getWest:function(){return this._southWest.lng},getSouth:function(){return this._southWest.lat},getEast:function(){return this._northEast.lng},getNorth:function(){return this._northEast.lat},contains:function(t){t="number"==typeof t[0]||t instanceof n.LatLng?n.latLng(t):n.latLngBounds(t);var e,i,o=this._southWest,r=this._northEast;return t instanceof n.LatLngBounds?(e=t.getSouthWest(),i=t.getNorthEast()):e=i=t,e.lat>=o.lat&&i.lat<=r.lat&&e.lng>=o.lng&&i.lng<=r.lng},intersects:function(t){t=n.latLngBounds(t);var e=this._southWest,i=this._northEast,o=t.getSouthWest(),r=t.getNorthEast(),a=r.lat>=e.lat&&o.lat<=i.lat,s=r.lng>=e.lng&&o.lng<=i.lng;return a&&s},overlaps:function(t){t=n.latLngBounds(t);var e=this._southWest,i=this._northEast,o=t.getSouthWest(),r=t.getNorthEast(),a=r.lat>e.lat&&o.lat<i.lat,s=r.lng>e.lng&&o.lng<i.lng;return a&&s},toBBoxString:function(){return[this.getWest(),this.getSouth(),this.getEast(),this.getNorth()].join(",")},equals:function(t){return!!t&&(t=n.latLngBounds(t),this._southWest.equals(t.getSouthWest())&&this._northEast.equals(t.getNorthEast()))},isValid:function(){return!(!this._southWest||!this._northEast)}},n.latLngBounds=function(t,e){return t instanceof n.LatLngBounds?t:new n.LatLngBounds(t,e)},n.Projection={},n.Projection.LonLat={project:function(t){return new n.Point(t.lng,t.lat)},unproject:function(t){return new n.LatLng(t.y,t.x)},bounds:n.bounds([-180,-90],[180,90])},n.Projection.SphericalMercator={R:6378137,MAX_LATITUDE:85.0511287798,project:function(t){var e=Math.PI/180,i=this.MAX_LATITUDE,o=Math.max(Math.min(i,t.lat),-i),r=Math.sin(o*e);return new n.Point(this.R*t.lng*e,this.R*Math.log((1+r)/(1-r))/2)},unproject:function(t){var e=180/Math.PI;return new n.LatLng((2*Math.atan(Math.exp(t.y/this.R))-Math.PI/2)*e,t.x*e/this.R)},bounds:function(){var t=6378137*Math.PI;return n.bounds([-t,-t],[t,t])}()},n.CRS={latLngToPoint:function(t,e){var i=this.projection.project(t),o=this.scale(e);return this.transformation._transform(i,o)},pointToLatLng:function(t,e){var i=this.scale(e),o=this.transformation.untransform(t,i);return this.projection.unproject(o)},project:function(t){return this.projection.project(t)},unproject:function(t){return this.projection.unproject(t)},scale:function(t){return 256*Math.pow(2,t)},zoom:function(t){return Math.log(t/256)/Math.LN2},getProjectedBounds:function(t){if(this.infinite)return null;var e=this.projection.bounds,i=this.scale(t),o=this.transformation.transform(e.min,i),r=this.transformation.transform(e.max,i);return n.bounds(o,r)},infinite:!1,wrapLatLng:function(t){var e=this.wrapLng?n.Util.wrapNum(t.lng,this.wrapLng,!0):t.lng,i=this.wrapLat?n.Util.wrapNum(t.lat,this.wrapLat,!0):t.lat,o=t.alt;return n.latLng(i,e,o)}},n.CRS.Simple=n.extend({},n.CRS,{projection:n.Projection.LonLat,transformation:new n.Transformation(1,0,(-1),0),scale:function(t){return Math.pow(2,t)},zoom:function(t){return Math.log(t)/Math.LN2},distance:function(t,e){var i=e.lng-t.lng,o=e.lat-t.lat;return Math.sqrt(i*i+o*o)},infinite:!0}),n.CRS.Earth=n.extend({},n.CRS,{wrapLng:[-180,180],R:6371e3,distance:function(t,e){var i=Math.PI/180,o=t.lat*i,n=e.lat*i,r=Math.sin(o)*Math.sin(n)+Math.cos(o)*Math.cos(n)*Math.cos((e.lng-t.lng)*i);return this.R*Math.acos(Math.min(r,1))}}),n.CRS.EPSG3857=n.extend({},n.CRS.Earth,{code:"EPSG:3857",projection:n.Projection.SphericalMercator,transformation:function(){var t=.5/(Math.PI*n.Projection.SphericalMercator.R);return new n.Transformation(t,.5,(-t),.5)}()}),n.CRS.EPSG900913=n.extend({},n.CRS.EPSG3857,{code:"EPSG:900913"}),n.CRS.EPSG4326=n.extend({},n.CRS.Earth,{code:"EPSG:4326",projection:n.Projection.LonLat,transformation:new n.Transformation(1/180,1,-1/180,.5)}),n.Map=n.Evented.extend({options:{crs:n.CRS.EPSG3857,center:void 0,zoom:void 0,minZoom:void 0,maxZoom:void 0,layers:[],maxBounds:void 0,renderer:void 0,fadeAnimation:!0,markerZoomAnimation:!0,transform3DLimit:8388608,zoomSnap:1,zoomDelta:1,trackResize:!0},initialize:function(t,e){e=n.setOptions(this,e),this._initContainer(t),this._initLayout(),this._onResize=n.bind(this._onResize,this),this._initEvents(),e.maxBounds&&this.setMaxBounds(e.maxBounds),void 0!==e.zoom&&(this._zoom=this._limitZoom(e.zoom)),e.center&&void 0!==e.zoom&&this.setView(n.latLng(e.center),e.zoom,{reset:!0}),this._handlers=[],this._layers={},this._zoomBoundLayers={},this._sizeChanged=!0,this.callInitHooks(),this._addLayers(this.options.layers)},setView:function(t,e){return e=void 0===e?this.getZoom():e,this._resetView(n.latLng(t),e),this},setZoom:function(t,e){return this._loaded?this.setView(this.getCenter(),t,{zoom:e}):(this._zoom=t,this)},zoomIn:function(t,e){return t=t||(n.Browser.any3d?this.options.zoomDelta:1),this.setZoom(this._zoom+t,e)},zoomOut:function(t,e){return t=t||(n.Browser.any3d?this.options.zoomDelta:1),this.setZoom(this._zoom-t,e)},setZoomAround:function(t,e,i){var o=this.getZoomScale(e),r=this.getSize().divideBy(2),a=t instanceof n.Point?t:this.latLngToContainerPoint(t),s=a.subtract(r).multiplyBy(1-1/o),l=this.containerPointToLatLng(r.add(s));return this.setView(l,e,{zoom:i})},_getBoundsCenterZoom:function(t,e){e=e||{},t=t.getBounds?t.getBounds():n.latLngBounds(t);var i=n.point(e.paddingTopLeft||e.padding||[0,0]),o=n.point(e.paddingBottomRight||e.padding||[0,0]),r=this.getBoundsZoom(t,!1,i.add(o));r="number"==typeof e.maxZoom?Math.min(e.maxZoom,r):r;var a=o.subtract(i).divideBy(2),s=this.project(t.getSouthWest(),r),l=this.project(t.getNorthEast(),r),u=this.unproject(s.add(l).divideBy(2).add(a),r);return{center:u,zoom:r}},fitBounds:function(t,e){if(t=n.latLngBounds(t),!t.isValid())throw new Error("Bounds are not valid.");var i=this._getBoundsCenterZoom(t,e);return this.setView(i.center,i.zoom,e)},fitWorld:function(t){return this.fitBounds([[-90,-180],[90,180]],t)},panTo:function(t,e){return this.setView(t,this._zoom,{pan:e})},panBy:function(t){return this.fire("movestart"),this._rawPanBy(n.point(t)),this.fire("move"),this.fire("moveend")},setMaxBounds:function(t){return t=n.latLngBounds(t),t.isValid()?(this.options.maxBounds&&this.off("moveend",this._panInsideMaxBounds),this.options.maxBounds=t,this._loaded&&this._panInsideMaxBounds(),this.on("moveend",this._panInsideMaxBounds)):(this.options.maxBounds=null,this.off("moveend",this._panInsideMaxBounds))},setMinZoom:function(t){return this.options.minZoom=t,this._loaded&&this.getZoom()<this.options.minZoom?this.setZoom(t):this},setMaxZoom:function(t){return this.options.maxZoom=t,this._loaded&&this.getZoom()>this.options.maxZoom?this.setZoom(t):this},panInsideBounds:function(t,e){this._enforcingBounds=!0;var i=this.getCenter(),o=this._limitCenter(i,this._zoom,n.latLngBounds(t));return i.equals(o)||this.panTo(o,e),this._enforcingBounds=!1,this},invalidateSize:function(t){if(!this._loaded)return this;t=n.extend({animate:!1,pan:!0},t===!0?{animate:!0}:t);var e=this.getSize();this._sizeChanged=!0,this._lastCenter=null;var i=this.getSize(),o=e.divideBy(2).round(),r=i.divideBy(2).round(),a=o.subtract(r);return a.x||a.y?(t.animate&&t.pan?this.panBy(a):(t.pan&&this._rawPanBy(a),this.fire("move"),t.debounceMoveend?(clearTimeout(this._sizeTimer),this._sizeTimer=setTimeout(n.bind(this.fire,this,"moveend"),200)):this.fire("moveend")),this.fire("resize",{oldSize:e,newSize:i})):this},stop:function(){return this.setZoom(this._limitZoom(this._zoom)),this.options.zoomSnap||this.fire("viewreset"),this._stop()},addHandler:function(t,e){if(!e)return this;var i=this[t]=new e(this);return this._handlers.push(i),this.options[t]&&i.enable(),this},remove:function(){if(this._initEvents(!0),this._containerId!==this._container._leaflet_id)throw new Error("Map container is being reused by another instance");try{delete this._container._leaflet_id,delete this._containerId}catch(t){this._container._leaflet_id=void 0,this._containerId=void 0}n.DomUtil.remove(this._mapPane),this._clearControlPos&&this._clearControlPos(),this._clearHandlers(),this._loaded&&this.fire("unload");for(var e in this._layers)this._layers[e].remove();return this},createPane:function(t,e){var i="leaflet-pane"+(t?" leaflet-"+t.replace("Pane","")+"-pane":""),o=n.DomUtil.create("div",i,e||this._mapPane);return t&&(this._panes[t]=o),o},getCenter:function(){return this._checkIfLoaded(),this._lastCenter&&!this._moved()?this._lastCenter:this.layerPointToLatLng(this._getCenterLayerPoint())},getZoom:function(){return this._zoom},getBounds:function(){var t=this.getPixelBounds(),e=this.unproject(t.getBottomLeft()),i=this.unproject(t.getTopRight());return new n.LatLngBounds(e,i)},getMinZoom:function(){return void 0===this.options.minZoom?this._layersMinZoom||0:this.options.minZoom},getMaxZoom:function(){return void 0===this.options.maxZoom?void 0===this._layersMaxZoom?1/0:this._layersMaxZoom:this.options.maxZoom},getBoundsZoom:function(t,e,i){t=n.latLngBounds(t),i=n.point(i||[0,0]);var o=this.getZoom()||0,r=this.getMinZoom(),a=this.getMaxZoom(),s=t.getNorthWest(),l=t.getSouthEast(),u=this.getSize().subtract(i),c=this.project(l,o).subtract(this.project(s,o)),h=n.Browser.any3d?this.options.zoomSnap:1,d=Math.min(u.x/c.x,u.y/c.y);return o=this.getScaleZoom(d,o),h&&(o=Math.round(o/(h/100))*(h/100),o=e?Math.ceil(o/h)*h:Math.floor(o/h)*h),Math.max(r,Math.min(a,o))},getSize:function(){return this._size&&!this._sizeChanged||(this._size=new n.Point(this._container.clientWidth,this._container.clientHeight),this._sizeChanged=!1),this._size.clone()},getPixelBounds:function(t,e){var i=this._getTopLeftPoint(t,e);return new n.Bounds(i,i.add(this.getSize()))},getPixelOrigin:function(){return this._checkIfLoaded(),this._pixelOrigin},getPixelWorldBounds:function(t){return this.options.crs.getProjectedBounds(void 0===t?this.getZoom():t)},getPane:function(t){return"string"==typeof t?this._panes[t]:t},getPanes:function(){return this._panes},getContainer:function(){return this._container},getZoomScale:function(t,e){var i=this.options.crs;return e=void 0===e?this._zoom:e,i.scale(t)/i.scale(e)},getScaleZoom:function(t,e){var i=this.options.crs;e=void 0===e?this._zoom:e;var o=i.zoom(t*i.scale(e));return isNaN(o)?1/0:o},project:function(t,e){return e=void 0===e?this._zoom:e,this.options.crs.latLngToPoint(n.latLng(t),e)},unproject:function(t,e){return e=void 0===e?this._zoom:e,this.options.crs.pointToLatLng(n.point(t),e)},layerPointToLatLng:function(t){var e=n.point(t).add(this.getPixelOrigin());return this.unproject(e)},latLngToLayerPoint:function(t){var e=this.project(n.latLng(t))._round();return e._subtract(this.getPixelOrigin())},wrapLatLng:function(t){return this.options.crs.wrapLatLng(n.latLng(t))},distance:function(t,e){return this.options.crs.distance(n.latLng(t),n.latLng(e))},containerPointToLayerPoint:function(t){return n.point(t).subtract(this._getMapPanePos())},layerPointToContainerPoint:function(t){return n.point(t).add(this._getMapPanePos())},containerPointToLatLng:function(t){var e=this.containerPointToLayerPoint(n.point(t));return this.layerPointToLatLng(e)},latLngToContainerPoint:function(t){return this.layerPointToContainerPoint(this.latLngToLayerPoint(n.latLng(t)))},mouseEventToContainerPoint:function(t){return n.DomEvent.getMousePosition(t,this._container)},mouseEventToLayerPoint:function(t){return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(t))},mouseEventToLatLng:function(t){return this.layerPointToLatLng(this.mouseEventToLayerPoint(t))},_initContainer:function(t){var e=this._container=n.DomUtil.get(t);if(!e)throw new Error("Map container not found.");if(e._leaflet_id)throw new Error("Map container is already initialized.");n.DomEvent.addListener(e,"scroll",this._onScroll,this),this._containerId=n.Util.stamp(e)},_initLayout:function(){var t=this._container;this._fadeAnimated=this.options.fadeAnimation&&n.Browser.any3d,n.DomUtil.addClass(t,"leaflet-container"+(n.Browser.touch?" leaflet-touch":"")+(n.Browser.retina?" leaflet-retina":"")+(n.Browser.ielt9?" leaflet-oldie":"")+(n.Browser.safari?" leaflet-safari":"")+(this._fadeAnimated?" leaflet-fade-anim":""));var e=n.DomUtil.getStyle(t,"position");"absolute"!==e&&"relative"!==e&&"fixed"!==e&&(t.style.position="relative"),this._initPanes(),this._initControlPos&&this._initControlPos()},_initPanes:function(){var t=this._panes={};this._paneRenderers={},this._mapPane=this.createPane("mapPane",this._container),n.DomUtil.setPosition(this._mapPane,new n.Point(0,0)),this.createPane("tilePane"),this.createPane("shadowPane"),this.createPane("overlayPane"),this.createPane("markerPane"),this.createPane("tooltipPane"),this.createPane("popupPane"),this.options.markerZoomAnimation||(n.DomUtil.addClass(t.markerPane,"leaflet-zoom-hide"),n.DomUtil.addClass(t.shadowPane,"leaflet-zoom-hide"))},_resetView:function(t,e){n.DomUtil.setPosition(this._mapPane,new n.Point(0,0));var i=!this._loaded;this._loaded=!0,e=this._limitZoom(e),this.fire("viewprereset");var o=this._zoom!==e;this._moveStart(o)._move(t,e)._moveEnd(o),this.fire("viewreset"),i&&this.fire("load")},_moveStart:function(t){return t&&this.fire("zoomstart"),this.fire("movestart")},_move:function(t,e,i){void 0===e&&(e=this._zoom);var o=this._zoom!==e;return this._zoom=e,this._lastCenter=t,this._pixelOrigin=this._getNewPixelOrigin(t),(o||i&&i.pinch)&&this.fire("zoom",i),this.fire("move",i)},_moveEnd:function(t){return t&&this.fire("zoomend"),this.fire("moveend")},_stop:function(){return n.Util.cancelAnimFrame(this._flyToFrame),this._panAnim&&this._panAnim.stop(),this},_rawPanBy:function(t){n.DomUtil.setPosition(this._mapPane,this._getMapPanePos().subtract(t))},_getZoomSpan:function(){return this.getMaxZoom()-this.getMinZoom()},_panInsideMaxBounds:function(){this._enforcingBounds||this.panInsideBounds(this.options.maxBounds)},_checkIfLoaded:function(){if(!this._loaded)throw new Error("Set map center and zoom first.")},_initEvents:function(t){if(n.DomEvent){this._targets={},this._targets[n.stamp(this._container)]=this;var e=t?"off":"on";n.DomEvent[e](this._container,"click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress",this._handleDOMEvent,this),this.options.trackResize&&n.DomEvent[e](window,"resize",this._onResize,this),n.Browser.any3d&&this.options.transform3DLimit&&this[e]("moveend",this._onMoveEnd)}},_onResize:function(){n.Util.cancelAnimFrame(this._resizeRequest),this._resizeRequest=n.Util.requestAnimFrame(function(){this.invalidateSize({debounceMoveend:!0})},this)},_onScroll:function(){this._container.scrollTop=0,this._container.scrollLeft=0},_onMoveEnd:function(){var t=this._getMapPanePos();Math.max(Math.abs(t.x),Math.abs(t.y))>=this.options.transform3DLimit&&this._resetView(this.getCenter(),this.getZoom())},_findEventTargets:function(t,e){for(var i,o=[],r="mouseout"===e||"mouseover"===e,a=t.target||t.srcElement,s=!1;a;){if(i=this._targets[n.stamp(a)],i&&("click"===e||"preclick"===e)&&!t._simulated&&this._draggableMoved(i)){s=!0;break}if(i&&i.listens(e,!0)){if(r&&!n.DomEvent._isExternalTarget(a,t))break;if(o.push(i),r)break}if(a===this._container)break;a=a.parentNode}return o.length||s||r||!n.DomEvent._isExternalTarget(a,t)||(o=[this]),o},_handleDOMEvent:function(t){if(this._loaded&&!n.DomEvent._skipped(t)){var e="keypress"===t.type&&13===t.keyCode?"click":t.type;"mousedown"===e&&n.DomUtil.preventOutline(t.target||t.srcElement),this._fireDOMEvent(t,e)}},_fireDOMEvent:function(t,e,i){if("click"===t.type){var o=n.Util.extend({},t);o.type="preclick",this._fireDOMEvent(o,o.type,i)}if(!t._stopped&&(i=(i||[]).concat(this._findEventTargets(t,e)),i.length)){var r=i[0];"contextmenu"===e&&r.listens(e,!0)&&n.DomEvent.preventDefault(t);var a={originalEvent:t};if("keypress"!==t.type){var s=r instanceof n.Marker;a.containerPoint=s?this.latLngToContainerPoint(r.getLatLng()):this.mouseEventToContainerPoint(t),a.layerPoint=this.containerPointToLayerPoint(a.containerPoint),a.latlng=s?r.getLatLng():this.layerPointToLatLng(a.layerPoint)}for(var l=0;l<i.length;l++)if(i[l].fire(e,a,!0),a.originalEvent._stopped||i[l].options.nonBubblingEvents&&n.Util.indexOf(i[l].options.nonBubblingEvents,e)!==-1)return}},_draggableMoved:function(t){return t=t.dragging&&t.dragging.enabled()?t:this,t.dragging&&t.dragging.moved()||this.boxZoom&&this.boxZoom.moved()},_clearHandlers:function(){for(var t=0,e=this._handlers.length;t<e;t++)this._handlers[t].disable()},whenReady:function(t,e){return this._loaded?t.call(e||this,{target:this}):this.on("load",t,e),this},_getMapPanePos:function(){return n.DomUtil.getPosition(this._mapPane)||new n.Point(0,0)},_moved:function(){var t=this._getMapPanePos();return t&&!t.equals([0,0])},_getTopLeftPoint:function(t,e){var i=t&&void 0!==e?this._getNewPixelOrigin(t,e):this.getPixelOrigin();return i.subtract(this._getMapPanePos())},_getNewPixelOrigin:function(t,e){var i=this.getSize()._divideBy(2);return this.project(t,e)._subtract(i)._add(this._getMapPanePos())._round()},_latLngToNewLayerPoint:function(t,e,i){var o=this._getNewPixelOrigin(i,e);return this.project(t,e)._subtract(o)},_getCenterLayerPoint:function(){return this.containerPointToLayerPoint(this.getSize()._divideBy(2))},_getCenterOffset:function(t){return this.latLngToLayerPoint(t).subtract(this._getCenterLayerPoint())},_limitCenter:function(t,e,i){if(!i)return t;var o=this.project(t,e),r=this.getSize().divideBy(2),a=new n.Bounds(o.subtract(r),o.add(r)),s=this._getBoundsOffset(a,i,e);return s.round().equals([0,0])?t:this.unproject(o.add(s),e)},_limitOffset:function(t,e){if(!e)return t;var i=this.getPixelBounds(),o=new n.Bounds(i.min.add(t),i.max.add(t));return t.add(this._getBoundsOffset(o,e))},_getBoundsOffset:function(t,e,i){var o=n.bounds(this.project(e.getNorthEast(),i),this.project(e.getSouthWest(),i)),r=o.min.subtract(t.min),a=o.max.subtract(t.max),s=this._rebound(r.x,-a.x),l=this._rebound(r.y,-a.y);return new n.Point(s,l)},_rebound:function(t,e){return t+e>0?Math.round(t-e)/2:Math.max(0,Math.ceil(t))-Math.max(0,Math.floor(e))},_limitZoom:function(t){var e=this.getMinZoom(),i=this.getMaxZoom(),o=n.Browser.any3d?this.options.zoomSnap:1;return o&&(t=Math.round(t/o)*o),Math.max(e,Math.min(i,t))}}),n.map=function(t,e){return new n.Map(t,e)},n.Layer=n.Evented.extend({options:{pane:"overlayPane",nonBubblingEvents:[]},addTo:function(t){return t.addLayer(this),this},remove:function(){return this.removeFrom(this._map||this._mapToAdd)},removeFrom:function(t){return t&&t.removeLayer(this),this},getPane:function(t){return this._map.getPane(t?this.options[t]||t:this.options.pane)},addInteractiveTarget:function(t){return this._map._targets[n.stamp(t)]=this,this},removeInteractiveTarget:function(t){return delete this._map._targets[n.stamp(t)],this},_layerAdd:function(t){var e=t.target;if(e.hasLayer(this)){if(this._map=e,this._zoomAnimated=e._zoomAnimated,this.getEvents){var i=this.getEvents();e.on(i,this),this.once("remove",function(){e.off(i,this)},this)}this.onAdd(e),this.getAttribution&&this._map.attributionControl&&this._map.attributionControl.addAttribution(this.getAttribution()),this.fire("add"),e.fire("layeradd",{layer:this})}}}),n.Map.include({addLayer:function(t){var e=n.stamp(t);return this._layers[e]?this:(this._layers[e]=t,t._mapToAdd=this,t.beforeAdd&&t.beforeAdd(this),this.whenReady(t._layerAdd,t),this)},removeLayer:function(t){var e=n.stamp(t);return this._layers[e]?(this._loaded&&t.onRemove(this),t.getAttribution&&this.attributionControl&&this.attributionControl.removeAttribution(t.getAttribution()),delete this._layers[e],this._loaded&&(this.fire("layerremove",{layer:t}),t.fire("remove")),t._map=t._mapToAdd=null,this):this},hasLayer:function(t){return!!t&&n.stamp(t)in this._layers},eachLayer:function(t,e){for(var i in this._layers)t.call(e,this._layers[i]);return this},_addLayers:function(t){t=t?n.Util.isArray(t)?t:[t]:[];for(var e=0,i=t.length;e<i;e++)this.addLayer(t[e])},_addZoomLimit:function(t){!isNaN(t.options.maxZoom)&&isNaN(t.options.minZoom)||(this._zoomBoundLayers[n.stamp(t)]=t,this._updateZoomLevels())},_removeZoomLimit:function(t){var e=n.stamp(t);this._zoomBoundLayers[e]&&(delete this._zoomBoundLayers[e],this._updateZoomLevels())},_updateZoomLevels:function(){var t=1/0,e=-(1/0),i=this._getZoomSpan();for(var o in this._zoomBoundLayers){var n=this._zoomBoundLayers[o].options;t=void 0===n.minZoom?t:Math.min(t,n.minZoom),e=void 0===n.maxZoom?e:Math.max(e,n.maxZoom)}this._layersMaxZoom=e===-(1/0)?void 0:e,this._layersMinZoom=t===1/0?void 0:t,i!==this._getZoomSpan()&&this.fire("zoomlevelschange")}}),n.Projection.Mercator={R:6378137,R_MINOR:6356752.314245179,bounds:n.bounds([-20037508.34279,-15496570.73972],[20037508.34279,18764656.23138]),project:function(t){var e=Math.PI/180,i=this.R,o=t.lat*e,r=this.R_MINOR/i,a=Math.sqrt(1-r*r),s=a*Math.sin(o),l=Math.tan(Math.PI/4-o/2)/Math.pow((1-s)/(1+s),a/2);return o=-i*Math.log(Math.max(l,1e-10)),new n.Point(t.lng*e*i,o)},unproject:function(t){for(var e,i=180/Math.PI,o=this.R,r=this.R_MINOR/o,a=Math.sqrt(1-r*r),s=Math.exp(-t.y/o),l=Math.PI/2-2*Math.atan(s),u=0,c=.1;u<15&&Math.abs(c)>1e-7;u++)e=a*Math.sin(l),e=Math.pow((1-e)/(1+e),a/2),c=Math.PI/2-2*Math.atan(s*e)-l,l+=c;return new n.LatLng(l*i,t.x*i/o)}},n.CRS.EPSG3395=n.extend({},n.CRS.Earth,{code:"EPSG:3395",projection:n.Projection.Mercator,transformation:function(){var t=.5/(Math.PI*n.Projection.Mercator.R);return new n.Transformation(t,.5,(-t),.5)}()}),n.GridLayer=n.Layer.extend({options:{tileSize:256,opacity:1,updateWhenIdle:n.Browser.mobile,updateWhenZooming:!0,updateInterval:200,attribution:null,zIndex:1,bounds:null,minZoom:0,maxZoom:void 0,noWrap:!1,pane:"tilePane",className:"",keepBuffer:2},initialize:function(t){n.setOptions(this,t)},onAdd:function(){this._initContainer(),this._levels={},this._tiles={},this._resetView(),this._update()},beforeAdd:function(t){t._addZoomLimit(this)},onRemove:function(t){this._removeAllTiles(),n.DomUtil.remove(this._container),t._removeZoomLimit(this),this._container=null,this._tileZoom=null},bringToFront:function(){return this._map&&(n.DomUtil.toFront(this._container),this._setAutoZIndex(Math.max)),this},bringToBack:function(){return this._map&&(n.DomUtil.toBack(this._container),this._setAutoZIndex(Math.min)),this},getAttribution:function(){return this.options.attribution},getContainer:function(){return this._container},setOpacity:function(t){return this.options.opacity=t,this._updateOpacity(),this},setZIndex:function(t){return this.options.zIndex=t,this._updateZIndex(),this},isLoading:function(){return this._loading},redraw:function(){return this._map&&(this._removeAllTiles(),this._update()),this},getEvents:function(){
	var t={viewprereset:this._invalidateAll,viewreset:this._resetView,zoom:this._resetView,moveend:this._onMoveEnd};return this.options.updateWhenIdle||(this._onMove||(this._onMove=n.Util.throttle(this._onMoveEnd,this.options.updateInterval,this)),t.move=this._onMove),this._zoomAnimated&&(t.zoomanim=this._animateZoom),t},createTile:function(){return document.createElement("div")},getTileSize:function(){var t=this.options.tileSize;return t instanceof n.Point?t:new n.Point(t,t)},_updateZIndex:function(){this._container&&void 0!==this.options.zIndex&&null!==this.options.zIndex&&(this._container.style.zIndex=this.options.zIndex)},_setAutoZIndex:function(t){for(var e,i=this.getPane().children,o=-t(-(1/0),1/0),n=0,r=i.length;n<r;n++)e=i[n].style.zIndex,i[n]!==this._container&&e&&(o=t(o,+e));isFinite(o)&&(this.options.zIndex=o+t(-1,1),this._updateZIndex())},_updateOpacity:function(){if(this._map&&!n.Browser.ielt9){n.DomUtil.setOpacity(this._container,this.options.opacity);var t=+new Date,e=!1,i=!1;for(var o in this._tiles){var r=this._tiles[o];if(r.current&&r.loaded){var a=Math.min(1,(t-r.loaded)/200);n.DomUtil.setOpacity(r.el,a),a<1?e=!0:(r.active&&(i=!0),r.active=!0)}}i&&!this._noPrune&&this._pruneTiles(),e&&(n.Util.cancelAnimFrame(this._fadeFrame),this._fadeFrame=n.Util.requestAnimFrame(this._updateOpacity,this))}},_initContainer:function(){this._container||(this._container=n.DomUtil.create("div","leaflet-layer "+(this.options.className||"")),this._updateZIndex(),this.options.opacity<1&&this._updateOpacity(),this.getPane().appendChild(this._container))},_updateLevels:function(){var t=this._tileZoom,e=this.options.maxZoom;if(void 0!==t){for(var i in this._levels)this._levels[i].el.children.length||i===t?this._levels[i].el.style.zIndex=e-Math.abs(t-i):(n.DomUtil.remove(this._levels[i].el),this._removeTilesAtZoom(i),delete this._levels[i]);var o=this._levels[t],r=this._map;return o||(o=this._levels[t]={},o.el=n.DomUtil.create("div","leaflet-tile-container leaflet-zoom-animated",this._container),o.el.style.zIndex=e,o.origin=r.project(r.unproject(r.getPixelOrigin()),t).round(),o.zoom=t,this._setZoomTransform(o,r.getCenter(),r.getZoom()),n.Util.falseFn(o.el.offsetWidth)),this._level=o,o}},_pruneTiles:function(){if(this._map){var t,e,i=this._map.getZoom();if(i>this.options.maxZoom||i<this.options.minZoom)return void this._removeAllTiles();for(t in this._tiles)e=this._tiles[t],e.retain=e.current;for(t in this._tiles)if(e=this._tiles[t],e.current&&!e.active){var o=e.coords;this._retainParent(o.x,o.y,o.z,o.z-5)||this._retainChildren(o.x,o.y,o.z,o.z+2)}for(t in this._tiles)this._tiles[t].retain||this._removeTile(t)}},_removeTilesAtZoom:function(t){for(var e in this._tiles)this._tiles[e].coords.z===t&&this._removeTile(e)},_removeAllTiles:function(){for(var t in this._tiles)this._removeTile(t)},_invalidateAll:function(){for(var t in this._levels)n.DomUtil.remove(this._levels[t].el),delete this._levels[t];this._removeAllTiles(),this._tileZoom=null},_retainParent:function(t,e,i,o){var r=Math.floor(t/2),a=Math.floor(e/2),s=i-1,l=new n.Point((+r),(+a));l.z=+s;var u=this._tileCoordsToKey(l),c=this._tiles[u];return c&&c.active?(c.retain=!0,!0):(c&&c.loaded&&(c.retain=!0),s>o&&this._retainParent(r,a,s,o))},_retainChildren:function(t,e,i,o){for(var r=2*t;r<2*t+2;r++)for(var a=2*e;a<2*e+2;a++){var s=new n.Point(r,a);s.z=i+1;var l=this._tileCoordsToKey(s),u=this._tiles[l];u&&u.active?u.retain=!0:(u&&u.loaded&&(u.retain=!0),i+1<o&&this._retainChildren(r,a,i+1,o))}},_resetView:function(t){var e=t&&(t.pinch||t.flyTo);this._setView(this._map.getCenter(),this._map.getZoom(),e,e)},_animateZoom:function(t){this._setView(t.center,t.zoom,!0,t.noUpdate)},_setView:function(t,e,i,o){var n=Math.round(e);(void 0!==this.options.maxZoom&&n>this.options.maxZoom||void 0!==this.options.minZoom&&n<this.options.minZoom)&&(n=void 0);var r=this.options.updateWhenZooming&&n!==this._tileZoom;o&&!r||(this._tileZoom=n,this._abortLoading&&this._abortLoading(),this._updateLevels(),this._resetGrid(),void 0!==n&&this._update(t),i||this._pruneTiles(),this._noPrune=!!i),this._setZoomTransforms(t,e)},_setZoomTransforms:function(t,e){for(var i in this._levels)this._setZoomTransform(this._levels[i],t,e)},_setZoomTransform:function(t,e,i){var o=this._map.getZoomScale(i,t.zoom),r=t.origin.multiplyBy(o).subtract(this._map._getNewPixelOrigin(e,i)).round();n.Browser.any3d?n.DomUtil.setTransform(t.el,r,o):n.DomUtil.setPosition(t.el,r)},_resetGrid:function(){var t=this._map,e=t.options.crs,i=this._tileSize=this.getTileSize(),o=this._tileZoom,n=this._map.getPixelWorldBounds(this._tileZoom);n&&(this._globalTileRange=this._pxBoundsToTileRange(n)),this._wrapX=e.wrapLng&&!this.options.noWrap&&[Math.floor(t.project([0,e.wrapLng[0]],o).x/i.x),Math.ceil(t.project([0,e.wrapLng[1]],o).x/i.y)],this._wrapY=e.wrapLat&&!this.options.noWrap&&[Math.floor(t.project([e.wrapLat[0],0],o).y/i.x),Math.ceil(t.project([e.wrapLat[1],0],o).y/i.y)]},_onMoveEnd:function(){this._map&&!this._map._animatingZoom&&this._update()},_getTiledPixelBounds:function(t){var e=this._map,i=e._animatingZoom?Math.max(e._animateToZoom,e.getZoom()):e.getZoom(),o=e.getZoomScale(i,this._tileZoom),r=e.project(t,this._tileZoom).floor(),a=e.getSize().divideBy(2*o);return new n.Bounds(r.subtract(a),r.add(a))},_update:function(t){var e=this._map;if(e){var i=e.getZoom();if(void 0===t&&(t=e.getCenter()),void 0!==this._tileZoom){var o=this._getTiledPixelBounds(t),r=this._pxBoundsToTileRange(o),a=r.getCenter(),s=[],l=this.options.keepBuffer,u=new n.Bounds(r.getBottomLeft().subtract([l,-l]),r.getTopRight().add([l,-l]));for(var c in this._tiles){var h=this._tiles[c].coords;h.z===this._tileZoom&&u.contains(n.point(h.x,h.y))||(this._tiles[c].current=!1)}if(Math.abs(i-this._tileZoom)>1)return void this._setView(t,i);for(var d=r.min.y;d<=r.max.y;d++)for(var p=r.min.x;p<=r.max.x;p++){var _=new n.Point(p,d);if(_.z=this._tileZoom,this._isValidTile(_)){var m=this._tiles[this._tileCoordsToKey(_)];m?m.current=!0:s.push(_)}}if(s.sort(function(t,e){return t.distanceTo(a)-e.distanceTo(a)}),0!==s.length){this._loading||(this._loading=!0,this.fire("loading"));var f=document.createDocumentFragment();for(p=0;p<s.length;p++)this._addTile(s[p],f);this._level.el.appendChild(f)}}}},_isValidTile:function(t){var e=this._map.options.crs;if(!e.infinite){var i=this._globalTileRange;if(!e.wrapLng&&(t.x<i.min.x||t.x>i.max.x)||!e.wrapLat&&(t.y<i.min.y||t.y>i.max.y))return!1}if(!this.options.bounds)return!0;var o=this._tileCoordsToBounds(t);return n.latLngBounds(this.options.bounds).overlaps(o)},_keyToBounds:function(t){return this._tileCoordsToBounds(this._keyToTileCoords(t))},_tileCoordsToBounds:function(t){var e=this._map,i=this.getTileSize(),o=t.scaleBy(i),r=o.add(i),a=e.unproject(o,t.z),s=e.unproject(r,t.z);return this.options.noWrap||(a=e.wrapLatLng(a),s=e.wrapLatLng(s)),new n.LatLngBounds(a,s)},_tileCoordsToKey:function(t){return t.x+":"+t.y+":"+t.z},_keyToTileCoords:function(t){var e=t.split(":"),i=new n.Point((+e[0]),(+e[1]));return i.z=+e[2],i},_removeTile:function(t){var e=this._tiles[t];e&&(n.DomUtil.remove(e.el),delete this._tiles[t],this.fire("tileunload",{tile:e.el,coords:this._keyToTileCoords(t)}))},_initTile:function(t){n.DomUtil.addClass(t,"leaflet-tile");var e=this.getTileSize();t.style.width=e.x+"px",t.style.height=e.y+"px",t.onselectstart=n.Util.falseFn,t.onmousemove=n.Util.falseFn,n.Browser.ielt9&&this.options.opacity<1&&n.DomUtil.setOpacity(t,this.options.opacity),n.Browser.android&&!n.Browser.android23&&(t.style.WebkitBackfaceVisibility="hidden")},_addTile:function(t,e){var i=this._getTilePos(t),o=this._tileCoordsToKey(t),r=this.createTile(this._wrapCoords(t),n.bind(this._tileReady,this,t));this._initTile(r),this.createTile.length<2&&n.Util.requestAnimFrame(n.bind(this._tileReady,this,t,null,r)),n.DomUtil.setPosition(r,i),this._tiles[o]={el:r,coords:t,current:!0},e.appendChild(r),this.fire("tileloadstart",{tile:r,coords:t})},_tileReady:function(t,e,i){if(this._map){e&&this.fire("tileerror",{error:e,tile:i,coords:t});var o=this._tileCoordsToKey(t);i=this._tiles[o],i&&(i.loaded=+new Date,this._map._fadeAnimated?(n.DomUtil.setOpacity(i.el,0),n.Util.cancelAnimFrame(this._fadeFrame),this._fadeFrame=n.Util.requestAnimFrame(this._updateOpacity,this)):(i.active=!0,this._pruneTiles()),e||(n.DomUtil.addClass(i.el,"leaflet-tile-loaded"),this.fire("tileload",{tile:i.el,coords:t})),this._noTilesToLoad()&&(this._loading=!1,this.fire("load"),n.Browser.ielt9||!this._map._fadeAnimated?n.Util.requestAnimFrame(this._pruneTiles,this):setTimeout(n.bind(this._pruneTiles,this),250)))}},_getTilePos:function(t){return t.scaleBy(this.getTileSize()).subtract(this._level.origin)},_wrapCoords:function(t){var e=new n.Point(this._wrapX?n.Util.wrapNum(t.x,this._wrapX):t.x,this._wrapY?n.Util.wrapNum(t.y,this._wrapY):t.y);return e.z=t.z,e},_pxBoundsToTileRange:function(t){var e=this.getTileSize();return new n.Bounds(t.min.unscaleBy(e).floor(),t.max.unscaleBy(e).ceil().subtract([1,1]))},_noTilesToLoad:function(){for(var t in this._tiles)if(!this._tiles[t].loaded)return!1;return!0}}),n.gridLayer=function(t){return new n.GridLayer(t)},n.TileLayer=n.GridLayer.extend({options:{minZoom:0,maxZoom:18,maxNativeZoom:null,subdomains:"abc",errorTileUrl:"",zoomOffset:0,tms:!1,zoomReverse:!1,detectRetina:!1,crossOrigin:!1},initialize:function(t,e){this._url=t,e=n.setOptions(this,e),e.detectRetina&&n.Browser.retina&&e.maxZoom>0&&(e.tileSize=Math.floor(e.tileSize/2),e.zoomReverse?(e.zoomOffset--,e.minZoom++):(e.zoomOffset++,e.maxZoom--),e.minZoom=Math.max(0,e.minZoom)),"string"==typeof e.subdomains&&(e.subdomains=e.subdomains.split("")),n.Browser.android||this.on("tileunload",this._onTileRemove)},setUrl:function(t,e){return this._url=t,e||this.redraw(),this},createTile:function(t,e){var i=document.createElement("img");return n.DomEvent.on(i,"load",n.bind(this._tileOnLoad,this,e,i)),n.DomEvent.on(i,"error",n.bind(this._tileOnError,this,e,i)),this.options.crossOrigin&&(i.crossOrigin=""),i.alt="",i.src=this.getTileUrl(t),i},getTileUrl:function(t){var e={r:n.Browser.retina?"@2x":"",s:this._getSubdomain(t),x:t.x,y:t.y,z:this._getZoomForUrl()};if(this._map&&!this._map.options.crs.infinite){var i=this._globalTileRange.max.y-t.y;this.options.tms&&(e.y=i),e["-y"]=i}return n.Util.template(this._url,n.extend(e,this.options))},_tileOnLoad:function(t,e){n.Browser.ielt9?setTimeout(n.bind(t,this,null,e),0):t(null,e)},_tileOnError:function(t,e,i){var o=this.options.errorTileUrl;o&&(e.src=o),t(i,e)},getTileSize:function(){var t=this._map,e=n.GridLayer.prototype.getTileSize.call(this),i=this._tileZoom+this.options.zoomOffset,o=this.options.maxNativeZoom;return null!==o&&i>o?e.divideBy(t.getZoomScale(o,i)).round():e},_onTileRemove:function(t){t.tile.onload=null},_getZoomForUrl:function(){var t=this.options,e=this._tileZoom;return t.zoomReverse&&(e=t.maxZoom-e),e+=t.zoomOffset,null!==t.maxNativeZoom?Math.min(e,t.maxNativeZoom):e},_getSubdomain:function(t){var e=Math.abs(t.x+t.y)%this.options.subdomains.length;return this.options.subdomains[e]},_abortLoading:function(){var t,e;for(t in this._tiles)this._tiles[t].coords.z!==this._tileZoom&&(e=this._tiles[t].el,e.onload=n.Util.falseFn,e.onerror=n.Util.falseFn,e.complete||(e.src=n.Util.emptyImageUrl,n.DomUtil.remove(e)))}}),n.tileLayer=function(t,e){return new n.TileLayer(t,e)},n.TileLayer.WMS=n.TileLayer.extend({defaultWmsParams:{service:"WMS",request:"GetMap",layers:"",styles:"",format:"image/jpeg",transparent:!1,version:"1.1.1"},options:{crs:null,uppercase:!1},initialize:function(t,e){this._url=t;var i=n.extend({},this.defaultWmsParams);for(var o in e)o in this.options||(i[o]=e[o]);e=n.setOptions(this,e),i.width=i.height=e.tileSize*(e.detectRetina&&n.Browser.retina?2:1),this.wmsParams=i},onAdd:function(t){this._crs=this.options.crs||t.options.crs,this._wmsVersion=parseFloat(this.wmsParams.version);var e=this._wmsVersion>=1.3?"crs":"srs";this.wmsParams[e]=this._crs.code,n.TileLayer.prototype.onAdd.call(this,t)},getTileUrl:function(t){var e=this._tileCoordsToBounds(t),i=this._crs.project(e.getNorthWest()),o=this._crs.project(e.getSouthEast()),r=(this._wmsVersion>=1.3&&this._crs===n.CRS.EPSG4326?[o.y,i.x,i.y,o.x]:[i.x,o.y,o.x,i.y]).join(","),a=n.TileLayer.prototype.getTileUrl.call(this,t);return a+n.Util.getParamString(this.wmsParams,a,this.options.uppercase)+(this.options.uppercase?"&BBOX=":"&bbox=")+r},setParams:function(t,e){return n.extend(this.wmsParams,t),e||this.redraw(),this}}),n.tileLayer.wms=function(t,e){return new n.TileLayer.WMS(t,e)},n.ImageOverlay=n.Layer.extend({options:{opacity:1,alt:"",interactive:!1,attribution:null,crossOrigin:!1},initialize:function(t,e,i){this._url=t,this._bounds=n.latLngBounds(e),n.setOptions(this,i)},onAdd:function(){this._image||(this._initImage(),this.options.opacity<1&&this._updateOpacity()),this.options.interactive&&(n.DomUtil.addClass(this._image,"leaflet-interactive"),this.addInteractiveTarget(this._image)),this.getPane().appendChild(this._image),this._reset()},onRemove:function(){n.DomUtil.remove(this._image),this.options.interactive&&this.removeInteractiveTarget(this._image)},setOpacity:function(t){return this.options.opacity=t,this._image&&this._updateOpacity(),this},setStyle:function(t){return t.opacity&&this.setOpacity(t.opacity),this},bringToFront:function(){return this._map&&n.DomUtil.toFront(this._image),this},bringToBack:function(){return this._map&&n.DomUtil.toBack(this._image),this},setUrl:function(t){return this._url=t,this._image&&(this._image.src=t),this},setBounds:function(t){return this._bounds=t,this._map&&this._reset(),this},getAttribution:function(){return this.options.attribution},getEvents:function(){var t={zoom:this._reset,viewreset:this._reset};return this._zoomAnimated&&(t.zoomanim=this._animateZoom),t},getBounds:function(){return this._bounds},getElement:function(){return this._image},_initImage:function(){var t=this._image=n.DomUtil.create("img","leaflet-image-layer "+(this._zoomAnimated?"leaflet-zoom-animated":""));t.onselectstart=n.Util.falseFn,t.onmousemove=n.Util.falseFn,t.onload=n.bind(this.fire,this,"load"),this.options.crossOrigin&&(t.crossOrigin=""),t.src=this._url,t.alt=this.options.alt},_animateZoom:function(t){var e=this._map.getZoomScale(t.zoom),i=this._map._latLngToNewLayerPoint(this._bounds.getNorthWest(),t.zoom,t.center);n.DomUtil.setTransform(this._image,i,e)},_reset:function(){var t=this._image,e=new n.Bounds(this._map.latLngToLayerPoint(this._bounds.getNorthWest()),this._map.latLngToLayerPoint(this._bounds.getSouthEast())),i=e.getSize();n.DomUtil.setPosition(t,e.min),t.style.width=i.x+"px",t.style.height=i.y+"px"},_updateOpacity:function(){n.DomUtil.setOpacity(this._image,this.options.opacity)}}),n.imageOverlay=function(t,e,i){return new n.ImageOverlay(t,e,i)},n.Icon=n.Class.extend({initialize:function(t){n.setOptions(this,t)},createIcon:function(t){return this._createIcon("icon",t)},createShadow:function(t){return this._createIcon("shadow",t)},_createIcon:function(t,e){var i=this._getIconUrl(t);if(!i){if("icon"===t)throw new Error("iconUrl not set in Icon options (see the docs).");return null}var o=this._createImg(i,e&&"IMG"===e.tagName?e:null);return this._setIconStyles(o,t),o},_setIconStyles:function(t,e){var i=this.options,o=i[e+"Size"];"number"==typeof o&&(o=[o,o]);var r=n.point(o),a=n.point("shadow"===e&&i.shadowAnchor||i.iconAnchor||r&&r.divideBy(2,!0));t.className="leaflet-marker-"+e+" "+(i.className||""),a&&(t.style.marginLeft=-a.x+"px",t.style.marginTop=-a.y+"px"),r&&(t.style.width=r.x+"px",t.style.height=r.y+"px")},_createImg:function(t,e){return e=e||document.createElement("img"),e.src=t,e},_getIconUrl:function(t){return n.Browser.retina&&this.options[t+"RetinaUrl"]||this.options[t+"Url"]}}),n.icon=function(t){return new n.Icon(t)},n.Icon.Default=n.Icon.extend({options:{iconUrl:"marker-icon.png",iconRetinaUrl:"marker-icon-2x.png",shadowUrl:"marker-shadow.png",iconSize:[25,41],iconAnchor:[12,41],popupAnchor:[1,-34],tooltipAnchor:[16,-28],shadowSize:[41,41]},_getIconUrl:function(t){return n.Icon.Default.imagePath||(n.Icon.Default.imagePath=this._detectIconPath()),(this.options.imagePath||n.Icon.Default.imagePath)+n.Icon.prototype._getIconUrl.call(this,t)},_detectIconPath:function(){var t=n.DomUtil.create("div","leaflet-default-icon-path",document.body),e=n.DomUtil.getStyle(t,"background-image")||n.DomUtil.getStyle(t,"backgroundImage");return document.body.removeChild(t),0===e.indexOf("url")?e.replace(/^url\([\"\']?/,"").replace(/marker-icon\.png[\"\']?\)$/,""):""}}),n.Marker=n.Layer.extend({options:{icon:new n.Icon.Default,interactive:!0,draggable:!1,keyboard:!0,title:"",alt:"",zIndexOffset:0,opacity:1,riseOnHover:!1,riseOffset:250,pane:"markerPane",nonBubblingEvents:["click","dblclick","mouseover","mouseout","contextmenu"]},initialize:function(t,e){n.setOptions(this,e),this._latlng=n.latLng(t)},onAdd:function(t){this._zoomAnimated=this._zoomAnimated&&t.options.markerZoomAnimation,this._zoomAnimated&&t.on("zoomanim",this._animateZoom,this),this._initIcon(),this.update()},onRemove:function(t){this.dragging&&this.dragging.enabled()&&(this.options.draggable=!0,this.dragging.removeHooks()),this._zoomAnimated&&t.off("zoomanim",this._animateZoom,this),this._removeIcon(),this._removeShadow()},getEvents:function(){return{zoom:this.update,viewreset:this.update}},getLatLng:function(){return this._latlng},setLatLng:function(t){var e=this._latlng;return this._latlng=n.latLng(t),this.update(),this.fire("move",{oldLatLng:e,latlng:this._latlng})},setZIndexOffset:function(t){return this.options.zIndexOffset=t,this.update()},setIcon:function(t){return this.options.icon=t,this._map&&(this._initIcon(),this.update()),this._popup&&this.bindPopup(this._popup,this._popup.options),this},getElement:function(){return this._icon},update:function(){if(this._icon){var t=this._map.latLngToLayerPoint(this._latlng).round();this._setPos(t)}return this},_initIcon:function(){var t=this.options,e="leaflet-zoom-"+(this._zoomAnimated?"animated":"hide"),i=t.icon.createIcon(this._icon),o=!1;i!==this._icon&&(this._icon&&this._removeIcon(),o=!0,t.title&&(i.title=t.title),t.alt&&(i.alt=t.alt)),n.DomUtil.addClass(i,e),t.keyboard&&(i.tabIndex="0"),this._icon=i,t.riseOnHover&&this.on({mouseover:this._bringToFront,mouseout:this._resetZIndex});var r=t.icon.createShadow(this._shadow),a=!1;r!==this._shadow&&(this._removeShadow(),a=!0),r&&n.DomUtil.addClass(r,e),this._shadow=r,t.opacity<1&&this._updateOpacity(),o&&this.getPane().appendChild(this._icon),this._initInteraction(),r&&a&&this.getPane("shadowPane").appendChild(this._shadow)},_removeIcon:function(){this.options.riseOnHover&&this.off({mouseover:this._bringToFront,mouseout:this._resetZIndex}),n.DomUtil.remove(this._icon),this.removeInteractiveTarget(this._icon),this._icon=null},_removeShadow:function(){this._shadow&&n.DomUtil.remove(this._shadow),this._shadow=null},_setPos:function(t){n.DomUtil.setPosition(this._icon,t),this._shadow&&n.DomUtil.setPosition(this._shadow,t),this._zIndex=t.y+this.options.zIndexOffset,this._resetZIndex()},_updateZIndex:function(t){this._icon.style.zIndex=this._zIndex+t},_animateZoom:function(t){var e=this._map._latLngToNewLayerPoint(this._latlng,t.zoom,t.center).round();this._setPos(e)},_initInteraction:function(){if(this.options.interactive&&(n.DomUtil.addClass(this._icon,"leaflet-interactive"),this.addInteractiveTarget(this._icon),n.Handler.MarkerDrag)){var t=this.options.draggable;this.dragging&&(t=this.dragging.enabled(),this.dragging.disable()),this.dragging=new n.Handler.MarkerDrag(this),t&&this.dragging.enable()}},setOpacity:function(t){return this.options.opacity=t,this._map&&this._updateOpacity(),this},_updateOpacity:function(){var t=this.options.opacity;n.DomUtil.setOpacity(this._icon,t),this._shadow&&n.DomUtil.setOpacity(this._shadow,t)},_bringToFront:function(){this._updateZIndex(this.options.riseOffset)},_resetZIndex:function(){this._updateZIndex(0)}}),n.marker=function(t,e){return new n.Marker(t,e)},n.DivIcon=n.Icon.extend({options:{iconSize:[12,12],html:!1,bgPos:null,className:"leaflet-div-icon"},createIcon:function(t){var e=t&&"DIV"===t.tagName?t:document.createElement("div"),i=this.options;if(e.innerHTML=i.html!==!1?i.html:"",i.bgPos){var o=n.point(i.bgPos);e.style.backgroundPosition=-o.x+"px "+-o.y+"px"}return this._setIconStyles(e,"icon"),e},createShadow:function(){return null}}),n.divIcon=function(t){return new n.DivIcon(t)},n.DivOverlay=n.Layer.extend({options:{offset:[0,7],className:"",pane:"popupPane"},initialize:function(t,e){n.setOptions(this,t),this._source=e},onAdd:function(t){this._zoomAnimated=t._zoomAnimated,this._container||this._initLayout(),t._fadeAnimated&&n.DomUtil.setOpacity(this._container,0),clearTimeout(this._removeTimeout),this.getPane().appendChild(this._container),this.update(),t._fadeAnimated&&n.DomUtil.setOpacity(this._container,1),this.bringToFront()},onRemove:function(t){t._fadeAnimated?(n.DomUtil.setOpacity(this._container,0),this._removeTimeout=setTimeout(n.bind(n.DomUtil.remove,n.DomUtil,this._container),200)):n.DomUtil.remove(this._container)},getLatLng:function(){return this._latlng},setLatLng:function(t){return this._latlng=n.latLng(t),this._map&&(this._updatePosition(),this._adjustPan()),this},getContent:function(){return this._content},setContent:function(t){return this._content=t,this.update(),this},getElement:function(){return this._container},update:function(){this._map&&(this._container.style.visibility="hidden",this._updateContent(),this._updateLayout(),this._updatePosition(),this._container.style.visibility="",this._adjustPan())},getEvents:function(){var t={zoom:this._updatePosition,viewreset:this._updatePosition};return this._zoomAnimated&&(t.zoomanim=this._animateZoom),t},isOpen:function(){return!!this._map&&this._map.hasLayer(this)},bringToFront:function(){return this._map&&n.DomUtil.toFront(this._container),this},bringToBack:function(){return this._map&&n.DomUtil.toBack(this._container),this},_updateContent:function(){if(this._content){var t=this._contentNode,e="function"==typeof this._content?this._content(this._source||this):this._content;if("string"==typeof e)t.innerHTML=e;else{for(;t.hasChildNodes();)t.removeChild(t.firstChild);t.appendChild(e)}this.fire("contentupdate")}},_updatePosition:function(){if(this._map){var t=this._map.latLngToLayerPoint(this._latlng),e=n.point(this.options.offset),i=this._getAnchor();this._zoomAnimated?n.DomUtil.setPosition(this._container,t.add(i)):e=e.add(t).add(i);var o=this._containerBottom=-e.y,r=this._containerLeft=-Math.round(this._containerWidth/2)+e.x;this._container.style.bottom=o+"px",this._container.style.left=r+"px"}},_getAnchor:function(){return[0,0]}}),n.Popup=n.DivOverlay.extend({options:{maxWidth:300,minWidth:50,maxHeight:null,autoPan:!0,autoPanPaddingTopLeft:null,autoPanPaddingBottomRight:null,autoPanPadding:[5,5],keepInView:!1,closeButton:!0,autoClose:!0,className:""},openOn:function(t){return t.openPopup(this),this},onAdd:function(t){n.DivOverlay.prototype.onAdd.call(this,t),t.fire("popupopen",{popup:this}),this._source&&(this._source.fire("popupopen",{popup:this},!0),this._source instanceof n.Path||this._source.on("preclick",n.DomEvent.stopPropagation))},onRemove:function(t){n.DivOverlay.prototype.onRemove.call(this,t),t.fire("popupclose",{popup:this}),this._source&&(this._source.fire("popupclose",{popup:this},!0),this._source instanceof n.Path||this._source.off("preclick",n.DomEvent.stopPropagation))},getEvents:function(){var t=n.DivOverlay.prototype.getEvents.call(this);return("closeOnClick"in this.options?this.options.closeOnClick:this._map.options.closePopupOnClick)&&(t.preclick=this._close),this.options.keepInView&&(t.moveend=this._adjustPan),t},_close:function(){this._map&&this._map.closePopup(this)},_initLayout:function(){var t="leaflet-popup",e=this._container=n.DomUtil.create("div",t+" "+(this.options.className||"")+" leaflet-zoom-animated");if(this.options.closeButton){var i=this._closeButton=n.DomUtil.create("a",t+"-close-button",e);i.href="#close",i.innerHTML="&#215;",n.DomEvent.on(i,"click",this._onCloseButtonClick,this)}var o=this._wrapper=n.DomUtil.create("div",t+"-content-wrapper",e);this._contentNode=n.DomUtil.create("div",t+"-content",o),n.DomEvent.disableClickPropagation(o).disableScrollPropagation(this._contentNode).on(o,"contextmenu",n.DomEvent.stopPropagation),this._tipContainer=n.DomUtil.create("div",t+"-tip-container",e),this._tip=n.DomUtil.create("div",t+"-tip",this._tipContainer)},_updateLayout:function(){var t=this._contentNode,e=t.style;e.width="",e.whiteSpace="nowrap";var i=t.offsetWidth;i=Math.min(i,this.options.maxWidth),i=Math.max(i,this.options.minWidth),e.width=i+1+"px",e.whiteSpace="",e.height="";var o=t.offsetHeight,r=this.options.maxHeight,a="leaflet-popup-scrolled";r&&o>r?(e.height=r+"px",n.DomUtil.addClass(t,a)):n.DomUtil.removeClass(t,a),this._containerWidth=this._container.offsetWidth},_animateZoom:function(t){var e=this._map._latLngToNewLayerPoint(this._latlng,t.zoom,t.center),i=this._getAnchor();n.DomUtil.setPosition(this._container,e.add(i))},_adjustPan:function(){if(!(!this.options.autoPan||this._map._panAnim&&this._map._panAnim._inProgress)){var t=this._map,e=parseInt(n.DomUtil.getStyle(this._container,"marginBottom"),10)||0,i=this._container.offsetHeight+e,o=this._containerWidth,r=new n.Point(this._containerLeft,-i-this._containerBottom);r._add(n.DomUtil.getPosition(this._container));var a=t.layerPointToContainerPoint(r),s=n.point(this.options.autoPanPadding),l=n.point(this.options.autoPanPaddingTopLeft||s),u=n.point(this.options.autoPanPaddingBottomRight||s),c=t.getSize(),h=0,d=0;a.x+o+u.x>c.x&&(h=a.x+o-c.x+u.x),a.x-h-l.x<0&&(h=a.x-l.x),a.y+i+u.y>c.y&&(d=a.y+i-c.y+u.y),a.y-d-l.y<0&&(d=a.y-l.y),(h||d)&&t.fire("autopanstart").panBy([h,d])}},_onCloseButtonClick:function(t){this._close(),n.DomEvent.stop(t)},_getAnchor:function(){return n.point(this._source&&this._source._getPopupAnchor?this._source._getPopupAnchor():[0,0])}}),n.popup=function(t,e){return new n.Popup(t,e)},n.Map.mergeOptions({closePopupOnClick:!0}),n.Map.include({openPopup:function(t,e,i){return t instanceof n.Popup||(t=new n.Popup(i).setContent(t)),e&&t.setLatLng(e),this.hasLayer(t)?this:(this._popup&&this._popup.options.autoClose&&this.closePopup(),this._popup=t,this.addLayer(t))},closePopup:function(t){return t&&t!==this._popup||(t=this._popup,this._popup=null),t&&this.removeLayer(t),this}}),n.Layer.include({bindPopup:function(t,e){return t instanceof n.Popup?(n.setOptions(t,e),this._popup=t,t._source=this):(this._popup&&!e||(this._popup=new n.Popup(e,this)),this._popup.setContent(t)),this._popupHandlersAdded||(this.on({click:this._openPopup,remove:this.closePopup,move:this._movePopup}),this._popupHandlersAdded=!0),this},unbindPopup:function(){return this._popup&&(this.off({click:this._openPopup,remove:this.closePopup,move:this._movePopup}),this._popupHandlersAdded=!1,this._popup=null),this},openPopup:function(t,e){if(t instanceof n.Layer||(e=t,t=this),t instanceof n.FeatureGroup)for(var i in this._layers){t=this._layers[i];break}return e||(e=t.getCenter?t.getCenter():t.getLatLng()),this._popup&&this._map&&(this._popup._source=t,this._popup.update(),this._map.openPopup(this._popup,e)),this},closePopup:function(){return this._popup&&this._popup._close(),this},togglePopup:function(t){return this._popup&&(this._popup._map?this.closePopup():this.openPopup(t)),this},isPopupOpen:function(){return this._popup.isOpen()},setPopupContent:function(t){return this._popup&&this._popup.setContent(t),this},getPopup:function(){return this._popup},_openPopup:function(t){var e=t.layer||t.target;if(this._popup&&this._map)return n.DomEvent.stop(t),e instanceof n.Path?void this.openPopup(t.layer||t.target,t.latlng):void(this._map.hasLayer(this._popup)&&this._popup._source===e?this.closePopup():this.openPopup(e,t.latlng))},_movePopup:function(t){this._popup.setLatLng(t.latlng)}}),n.Marker.include({_getPopupAnchor:function(){return this.options.icon.options.popupAnchor||[0,0]}}),n.Tooltip=n.DivOverlay.extend({options:{pane:"tooltipPane",offset:[0,0],direction:"auto",permanent:!1,sticky:!1,interactive:!1,opacity:.9},onAdd:function(t){n.DivOverlay.prototype.onAdd.call(this,t),this.setOpacity(this.options.opacity),t.fire("tooltipopen",{tooltip:this}),this._source&&this._source.fire("tooltipopen",{tooltip:this},!0)},onRemove:function(t){n.DivOverlay.prototype.onRemove.call(this,t),t.fire("tooltipclose",{tooltip:this}),this._source&&this._source.fire("tooltipclose",{tooltip:this},!0)},getEvents:function(){var t=n.DivOverlay.prototype.getEvents.call(this);return n.Browser.touch&&!this.options.permanent&&(t.preclick=this._close),t},_close:function(){this._map&&this._map.closeTooltip(this)},_initLayout:function(){var t="leaflet-tooltip",e=t+" "+(this.options.className||"")+" leaflet-zoom-"+(this._zoomAnimated?"animated":"hide");this._contentNode=this._container=n.DomUtil.create("div",e)},_updateLayout:function(){},_adjustPan:function(){},_setPosition:function(t){var e=this._map,i=this._container,o=e.latLngToContainerPoint(e.getCenter()),r=e.layerPointToContainerPoint(t),a=this.options.direction,s=i.offsetWidth,l=i.offsetHeight,u=n.point(this.options.offset),c=this._getAnchor();"top"===a?t=t.add(n.point(-s/2+u.x,-l+u.y+c.y)):"bottom"===a?t=t.subtract(n.point(s/2-u.x,-u.y)):"center"===a?t=t.subtract(n.point(s/2+u.x,l/2-c.y+u.y)):"right"===a||"auto"===a&&r.x<o.x?(a="right",t=t.add([u.x+c.x,c.y-l/2+u.y])):(a="left",t=t.subtract(n.point(s+c.x-u.x,l/2-c.y-u.y))),n.DomUtil.removeClass(i,"leaflet-tooltip-right"),n.DomUtil.removeClass(i,"leaflet-tooltip-left"),n.DomUtil.removeClass(i,"leaflet-tooltip-top"),n.DomUtil.removeClass(i,"leaflet-tooltip-bottom"),n.DomUtil.addClass(i,"leaflet-tooltip-"+a),n.DomUtil.setPosition(i,t)},_updatePosition:function(){var t=this._map.latLngToLayerPoint(this._latlng);this._setPosition(t)},setOpacity:function(t){this.options.opacity=t,this._container&&n.DomUtil.setOpacity(this._container,t)},_animateZoom:function(t){var e=this._map._latLngToNewLayerPoint(this._latlng,t.zoom,t.center);this._setPosition(e)},_getAnchor:function(){return n.point(this._source&&this._source._getTooltipAnchor&&!this.options.sticky?this._source._getTooltipAnchor():[0,0])}}),n.tooltip=function(t,e){return new n.Tooltip(t,e)},n.Map.include({openTooltip:function(t,e,i){return t instanceof n.Tooltip||(t=new n.Tooltip(i).setContent(t)),e&&t.setLatLng(e),this.hasLayer(t)?this:this.addLayer(t)},closeTooltip:function(t){return t&&this.removeLayer(t),this}}),n.Layer.include({bindTooltip:function(t,e){return t instanceof n.Tooltip?(n.setOptions(t,e),this._tooltip=t,t._source=this):(this._tooltip&&!e||(this._tooltip=n.tooltip(e,this)),this._tooltip.setContent(t)),this._initTooltipInteractions(),this._tooltip.options.permanent&&this._map&&this._map.hasLayer(this)&&this.openTooltip(),this},unbindTooltip:function(){return this._tooltip&&(this._initTooltipInteractions(!0),this.closeTooltip(),this._tooltip=null),this},_initTooltipInteractions:function(t){if(t||!this._tooltipHandlersAdded){var e=t?"off":"on",i={remove:this.closeTooltip,move:this._moveTooltip};this._tooltip.options.permanent?i.add=this._openTooltip:(i.mouseover=this._openTooltip,i.mouseout=this.closeTooltip,this._tooltip.options.sticky&&(i.mousemove=this._moveTooltip),n.Browser.touch&&(i.click=this._openTooltip)),this[e](i),this._tooltipHandlersAdded=!t}},openTooltip:function(t,e){if(t instanceof n.Layer||(e=t,t=this),t instanceof n.FeatureGroup)for(var i in this._layers){t=this._layers[i];break}return e||(e=t.getCenter?t.getCenter():t.getLatLng()),this._tooltip&&this._map&&(this._tooltip._source=t,this._tooltip.update(),this._map.openTooltip(this._tooltip,e),this._tooltip.options.interactive&&this._tooltip._container&&(n.DomUtil.addClass(this._tooltip._container,"leaflet-clickable"),this.addInteractiveTarget(this._tooltip._container))),this},closeTooltip:function(){return this._tooltip&&(this._tooltip._close(),this._tooltip.options.interactive&&this._tooltip._container&&(n.DomUtil.removeClass(this._tooltip._container,"leaflet-clickable"),
	this.removeInteractiveTarget(this._tooltip._container))),this},toggleTooltip:function(t){return this._tooltip&&(this._tooltip._map?this.closeTooltip():this.openTooltip(t)),this},isTooltipOpen:function(){return this._tooltip.isOpen()},setTooltipContent:function(t){return this._tooltip&&this._tooltip.setContent(t),this},getTooltip:function(){return this._tooltip},_openTooltip:function(t){var e=t.layer||t.target;this._tooltip&&this._map&&this.openTooltip(e,this._tooltip.options.sticky?t.latlng:void 0)},_moveTooltip:function(t){var e,i,o=t.latlng;this._tooltip.options.sticky&&t.originalEvent&&(e=this._map.mouseEventToContainerPoint(t.originalEvent),i=this._map.containerPointToLayerPoint(e),o=this._map.layerPointToLatLng(i)),this._tooltip.setLatLng(o)}}),n.Marker.include({_getTooltipAnchor:function(){return this.options.icon.options.tooltipAnchor||[0,0]}}),n.LayerGroup=n.Layer.extend({initialize:function(t){this._layers={};var e,i;if(t)for(e=0,i=t.length;e<i;e++)this.addLayer(t[e])},addLayer:function(t){var e=this.getLayerId(t);return this._layers[e]=t,this._map&&this._map.addLayer(t),this},removeLayer:function(t){var e=t in this._layers?t:this.getLayerId(t);return this._map&&this._layers[e]&&this._map.removeLayer(this._layers[e]),delete this._layers[e],this},hasLayer:function(t){return!!t&&(t in this._layers||this.getLayerId(t)in this._layers)},clearLayers:function(){for(var t in this._layers)this.removeLayer(this._layers[t]);return this},invoke:function(t){var e,i,o=Array.prototype.slice.call(arguments,1);for(e in this._layers)i=this._layers[e],i[t]&&i[t].apply(i,o);return this},onAdd:function(t){for(var e in this._layers)t.addLayer(this._layers[e])},onRemove:function(t){for(var e in this._layers)t.removeLayer(this._layers[e])},eachLayer:function(t,e){for(var i in this._layers)t.call(e,this._layers[i]);return this},getLayer:function(t){return this._layers[t]},getLayers:function(){var t=[];for(var e in this._layers)t.push(this._layers[e]);return t},setZIndex:function(t){return this.invoke("setZIndex",t)},getLayerId:function(t){return n.stamp(t)}}),n.layerGroup=function(t){return new n.LayerGroup(t)},n.FeatureGroup=n.LayerGroup.extend({addLayer:function(t){return this.hasLayer(t)?this:(t.addEventParent(this),n.LayerGroup.prototype.addLayer.call(this,t),this.fire("layeradd",{layer:t}))},removeLayer:function(t){return this.hasLayer(t)?(t in this._layers&&(t=this._layers[t]),t.removeEventParent(this),n.LayerGroup.prototype.removeLayer.call(this,t),this.fire("layerremove",{layer:t})):this},setStyle:function(t){return this.invoke("setStyle",t)},bringToFront:function(){return this.invoke("bringToFront")},bringToBack:function(){return this.invoke("bringToBack")},getBounds:function(){var t=new n.LatLngBounds;for(var e in this._layers){var i=this._layers[e];t.extend(i.getBounds?i.getBounds():i.getLatLng())}return t}}),n.featureGroup=function(t){return new n.FeatureGroup(t)},n.Renderer=n.Layer.extend({options:{padding:.1},initialize:function(t){n.setOptions(this,t),n.stamp(this)},onAdd:function(){this._container||(this._initContainer(),this._zoomAnimated&&n.DomUtil.addClass(this._container,"leaflet-zoom-animated")),this.getPane().appendChild(this._container),this._update()},onRemove:function(){n.DomUtil.remove(this._container)},getEvents:function(){var t={viewreset:this._reset,zoom:this._onZoom,moveend:this._update};return this._zoomAnimated&&(t.zoomanim=this._onAnimZoom),t},_onAnimZoom:function(t){this._updateTransform(t.center,t.zoom)},_onZoom:function(){this._updateTransform(this._map.getCenter(),this._map.getZoom())},_updateTransform:function(t,e){var i=this._map.getZoomScale(e,this._zoom),o=n.DomUtil.getPosition(this._container),r=this._map.getSize().multiplyBy(.5+this.options.padding),a=this._map.project(this._center,e),s=this._map.project(t,e),l=s.subtract(a),u=r.multiplyBy(-i).add(o).add(r).subtract(l);n.Browser.any3d?n.DomUtil.setTransform(this._container,u,i):n.DomUtil.setPosition(this._container,u)},_reset:function(){this._update(),this._updateTransform(this._center,this._zoom)},_update:function(){var t=this.options.padding,e=this._map.getSize(),i=this._map.containerPointToLayerPoint(e.multiplyBy(-t)).round();this._bounds=new n.Bounds(i,i.add(e.multiplyBy(1+2*t)).round()),this._center=this._map.getCenter(),this._zoom=this._map.getZoom()}}),n.Map.include({getRenderer:function(t){var e=t.options.renderer||this._getPaneRenderer(t.options.pane)||this.options.renderer||this._renderer;return e||(e=this._renderer=this.options.preferCanvas&&n.canvas()||n.svg()),this.hasLayer(e)||this.addLayer(e),e},_getPaneRenderer:function(t){if("overlayPane"===t||void 0===t)return!1;var e=this._paneRenderers[t];return void 0===e&&(e=n.SVG&&n.svg({pane:t})||n.Canvas&&n.canvas({pane:t}),this._paneRenderers[t]=e),e}}),n.Path=n.Layer.extend({options:{stroke:!0,color:"#3388ff",weight:3,opacity:1,lineCap:"round",lineJoin:"round",dashArray:null,dashOffset:null,fill:!1,fillColor:null,fillOpacity:.2,fillRule:"evenodd",interactive:!0},beforeAdd:function(t){this._renderer=t.getRenderer(this)},onAdd:function(){this._renderer._initPath(this),this._reset(),this._renderer._addPath(this),this._renderer.on("update",this._update,this)},onRemove:function(){this._renderer._removePath(this),this._renderer.off("update",this._update,this)},getEvents:function(){return{zoomend:this._project,viewreset:this._reset}},redraw:function(){return this._map&&this._renderer._updatePath(this),this},setStyle:function(t){return n.setOptions(this,t),this._renderer&&this._renderer._updateStyle(this),this},bringToFront:function(){return this._renderer&&this._renderer._bringToFront(this),this},bringToBack:function(){return this._renderer&&this._renderer._bringToBack(this),this},getElement:function(){return this._path},_reset:function(){this._project(),this._update()},_clickTolerance:function(){return(this.options.stroke?this.options.weight/2:0)+(n.Browser.touch?10:0)}}),n.LineUtil={simplify:function(t,e){if(!e||!t.length)return t.slice();var i=e*e;return t=this._reducePoints(t,i),t=this._simplifyDP(t,i)},pointToSegmentDistance:function(t,e,i){return Math.sqrt(this._sqClosestPointOnSegment(t,e,i,!0))},closestPointOnSegment:function(t,e,i){return this._sqClosestPointOnSegment(t,e,i)},_simplifyDP:function(t,e){var i=t.length,o=typeof Uint8Array!=void 0+""?Uint8Array:Array,n=new o(i);n[0]=n[i-1]=1,this._simplifyDPStep(t,n,e,0,i-1);var r,a=[];for(r=0;r<i;r++)n[r]&&a.push(t[r]);return a},_simplifyDPStep:function(t,e,i,o,n){var r,a,s,l=0;for(a=o+1;a<=n-1;a++)s=this._sqClosestPointOnSegment(t[a],t[o],t[n],!0),s>l&&(r=a,l=s);l>i&&(e[r]=1,this._simplifyDPStep(t,e,i,o,r),this._simplifyDPStep(t,e,i,r,n))},_reducePoints:function(t,e){for(var i=[t[0]],o=1,n=0,r=t.length;o<r;o++)this._sqDist(t[o],t[n])>e&&(i.push(t[o]),n=o);return n<r-1&&i.push(t[r-1]),i},clipSegment:function(t,e,i,o,n){var r,a,s,l=o?this._lastCode:this._getBitCode(t,i),u=this._getBitCode(e,i);for(this._lastCode=u;;){if(!(l|u))return[t,e];if(l&u)return!1;r=l||u,a=this._getEdgeIntersection(t,e,r,i,n),s=this._getBitCode(a,i),r===l?(t=a,l=s):(e=a,u=s)}},_getEdgeIntersection:function(t,e,i,o,r){var a,s,l=e.x-t.x,u=e.y-t.y,c=o.min,h=o.max;return 8&i?(a=t.x+l*(h.y-t.y)/u,s=h.y):4&i?(a=t.x+l*(c.y-t.y)/u,s=c.y):2&i?(a=h.x,s=t.y+u*(h.x-t.x)/l):1&i&&(a=c.x,s=t.y+u*(c.x-t.x)/l),new n.Point(a,s,r)},_getBitCode:function(t,e){var i=0;return t.x<e.min.x?i|=1:t.x>e.max.x&&(i|=2),t.y<e.min.y?i|=4:t.y>e.max.y&&(i|=8),i},_sqDist:function(t,e){var i=e.x-t.x,o=e.y-t.y;return i*i+o*o},_sqClosestPointOnSegment:function(t,e,i,o){var r,a=e.x,s=e.y,l=i.x-a,u=i.y-s,c=l*l+u*u;return c>0&&(r=((t.x-a)*l+(t.y-s)*u)/c,r>1?(a=i.x,s=i.y):r>0&&(a+=l*r,s+=u*r)),l=t.x-a,u=t.y-s,o?l*l+u*u:new n.Point(a,s)}},n.Polyline=n.Path.extend({options:{smoothFactor:1,noClip:!1},initialize:function(t,e){n.setOptions(this,e),this._setLatLngs(t)},getLatLngs:function(){return this._latlngs},setLatLngs:function(t){return this._setLatLngs(t),this.redraw()},isEmpty:function(){return!this._latlngs.length},closestLayerPoint:function(t){for(var e,i,o=1/0,r=null,a=n.LineUtil._sqClosestPointOnSegment,s=0,l=this._parts.length;s<l;s++)for(var u=this._parts[s],c=1,h=u.length;c<h;c++){e=u[c-1],i=u[c];var d=a(t,e,i,!0);d<o&&(o=d,r=a(t,e,i))}return r&&(r.distance=Math.sqrt(o)),r},getCenter:function(){if(!this._map)throw new Error("Must add layer to map before using getCenter()");var t,e,i,o,n,r,a,s=this._rings[0],l=s.length;if(!l)return null;for(t=0,e=0;t<l-1;t++)e+=s[t].distanceTo(s[t+1])/2;if(0===e)return this._map.layerPointToLatLng(s[0]);for(t=0,o=0;t<l-1;t++)if(n=s[t],r=s[t+1],i=n.distanceTo(r),o+=i,o>e)return a=(o-e)/i,this._map.layerPointToLatLng([r.x-a*(r.x-n.x),r.y-a*(r.y-n.y)])},getBounds:function(){return this._bounds},addLatLng:function(t,e){return e=e||this._defaultShape(),t=n.latLng(t),e.push(t),this._bounds.extend(t),this.redraw()},_setLatLngs:function(t){this._bounds=new n.LatLngBounds,this._latlngs=this._convertLatLngs(t)},_defaultShape:function(){return n.Polyline._flat(this._latlngs)?this._latlngs:this._latlngs[0]},_convertLatLngs:function(t){for(var e=[],i=n.Polyline._flat(t),o=0,r=t.length;o<r;o++)i?(e[o]=n.latLng(t[o]),this._bounds.extend(e[o])):e[o]=this._convertLatLngs(t[o]);return e},_project:function(){var t=new n.Bounds;this._rings=[],this._projectLatlngs(this._latlngs,this._rings,t);var e=this._clickTolerance(),i=new n.Point(e,e);this._bounds.isValid()&&t.isValid()&&(t.min._subtract(i),t.max._add(i),this._pxBounds=t)},_projectLatlngs:function(t,e,i){var o,r,a=t[0]instanceof n.LatLng,s=t.length;if(a){for(r=[],o=0;o<s;o++)r[o]=this._map.latLngToLayerPoint(t[o]),i.extend(r[o]);e.push(r)}else for(o=0;o<s;o++)this._projectLatlngs(t[o],e,i)},_clipPoints:function(){var t=this._renderer._bounds;if(this._parts=[],this._pxBounds&&this._pxBounds.intersects(t)){if(this.options.noClip)return void(this._parts=this._rings);var e,i,o,r,a,s,l,u=this._parts;for(e=0,o=0,r=this._rings.length;e<r;e++)for(l=this._rings[e],i=0,a=l.length;i<a-1;i++)s=n.LineUtil.clipSegment(l[i],l[i+1],t,i,!0),s&&(u[o]=u[o]||[],u[o].push(s[0]),s[1]===l[i+1]&&i!==a-2||(u[o].push(s[1]),o++))}},_simplifyPoints:function(){for(var t=this._parts,e=this.options.smoothFactor,i=0,o=t.length;i<o;i++)t[i]=n.LineUtil.simplify(t[i],e)},_update:function(){this._map&&(this._clipPoints(),this._simplifyPoints(),this._updatePath())},_updatePath:function(){this._renderer._updatePoly(this)}}),n.polyline=function(t,e){return new n.Polyline(t,e)},n.Polyline._flat=function(t){return!n.Util.isArray(t[0])||"object"!=typeof t[0][0]&&"undefined"!=typeof t[0][0]},n.PolyUtil={},n.PolyUtil.clipPolygon=function(t,e,i){var o,r,a,s,l,u,c,h,d,p=[1,4,2,8],_=n.LineUtil;for(r=0,c=t.length;r<c;r++)t[r]._code=_._getBitCode(t[r],e);for(s=0;s<4;s++){for(h=p[s],o=[],r=0,c=t.length,a=c-1;r<c;a=r++)l=t[r],u=t[a],l._code&h?u._code&h||(d=_._getEdgeIntersection(u,l,h,e,i),d._code=_._getBitCode(d,e),o.push(d)):(u._code&h&&(d=_._getEdgeIntersection(u,l,h,e,i),d._code=_._getBitCode(d,e),o.push(d)),o.push(l));t=o}return t},n.Polygon=n.Polyline.extend({options:{fill:!0},isEmpty:function(){return!this._latlngs.length||!this._latlngs[0].length},getCenter:function(){if(!this._map)throw new Error("Must add layer to map before using getCenter()");var t,e,i,o,n,r,a,s,l,u=this._rings[0],c=u.length;if(!c)return null;for(r=a=s=0,t=0,e=c-1;t<c;e=t++)i=u[t],o=u[e],n=i.y*o.x-o.y*i.x,a+=(i.x+o.x)*n,s+=(i.y+o.y)*n,r+=3*n;return l=0===r?u[0]:[a/r,s/r],this._map.layerPointToLatLng(l)},_convertLatLngs:function(t){var e=n.Polyline.prototype._convertLatLngs.call(this,t),i=e.length;return i>=2&&e[0]instanceof n.LatLng&&e[0].equals(e[i-1])&&e.pop(),e},_setLatLngs:function(t){n.Polyline.prototype._setLatLngs.call(this,t),n.Polyline._flat(this._latlngs)&&(this._latlngs=[this._latlngs])},_defaultShape:function(){return n.Polyline._flat(this._latlngs[0])?this._latlngs[0]:this._latlngs[0][0]},_clipPoints:function(){var t=this._renderer._bounds,e=this.options.weight,i=new n.Point(e,e);if(t=new n.Bounds(t.min.subtract(i),t.max.add(i)),this._parts=[],this._pxBounds&&this._pxBounds.intersects(t)){if(this.options.noClip)return void(this._parts=this._rings);for(var o,r=0,a=this._rings.length;r<a;r++)o=n.PolyUtil.clipPolygon(this._rings[r],t,!0),o.length&&this._parts.push(o)}},_updatePath:function(){this._renderer._updatePoly(this,!0)}}),n.polygon=function(t,e){return new n.Polygon(t,e)},n.Rectangle=n.Polygon.extend({initialize:function(t,e){n.Polygon.prototype.initialize.call(this,this._boundsToLatLngs(t),e)},setBounds:function(t){return this.setLatLngs(this._boundsToLatLngs(t))},_boundsToLatLngs:function(t){return t=n.latLngBounds(t),[t.getSouthWest(),t.getNorthWest(),t.getNorthEast(),t.getSouthEast()]}}),n.rectangle=function(t,e){return new n.Rectangle(t,e)},n.CircleMarker=n.Path.extend({options:{fill:!0,radius:10},initialize:function(t,e){n.setOptions(this,e),this._latlng=n.latLng(t),this._radius=this.options.radius},setLatLng:function(t){return this._latlng=n.latLng(t),this.redraw(),this.fire("move",{latlng:this._latlng})},getLatLng:function(){return this._latlng},setRadius:function(t){return this.options.radius=this._radius=t,this.redraw()},getRadius:function(){return this._radius},setStyle:function(t){var e=t&&t.radius||this._radius;return n.Path.prototype.setStyle.call(this,t),this.setRadius(e),this},_project:function(){this._point=this._map.latLngToLayerPoint(this._latlng),this._updateBounds()},_updateBounds:function(){var t=this._radius,e=this._radiusY||t,i=this._clickTolerance(),o=[t+i,e+i];this._pxBounds=new n.Bounds(this._point.subtract(o),this._point.add(o))},_update:function(){this._map&&this._updatePath()},_updatePath:function(){this._renderer._updateCircle(this)},_empty:function(){return this._radius&&!this._renderer._bounds.intersects(this._pxBounds)}}),n.circleMarker=function(t,e){return new n.CircleMarker(t,e)},n.Circle=n.CircleMarker.extend({initialize:function(t,e,i){if("number"==typeof e&&(e=n.extend({},i,{radius:e})),n.setOptions(this,e),this._latlng=n.latLng(t),isNaN(this.options.radius))throw new Error("Circle radius cannot be NaN");this._mRadius=this.options.radius},setRadius:function(t){return this._mRadius=t,this.redraw()},getRadius:function(){return this._mRadius},getBounds:function(){var t=[this._radius,this._radiusY||this._radius];return new n.LatLngBounds(this._map.layerPointToLatLng(this._point.subtract(t)),this._map.layerPointToLatLng(this._point.add(t)))},setStyle:n.Path.prototype.setStyle,_project:function(){var t=this._latlng.lng,e=this._latlng.lat,i=this._map,o=i.options.crs;if(o.distance===n.CRS.Earth.distance){var r=Math.PI/180,a=this._mRadius/n.CRS.Earth.R/r,s=i.project([e+a,t]),l=i.project([e-a,t]),u=s.add(l).divideBy(2),c=i.unproject(u).lat,h=Math.acos((Math.cos(a*r)-Math.sin(e*r)*Math.sin(c*r))/(Math.cos(e*r)*Math.cos(c*r)))/r;(isNaN(h)||0===h)&&(h=a/Math.cos(Math.PI/180*e)),this._point=u.subtract(i.getPixelOrigin()),this._radius=isNaN(h)?0:Math.max(Math.round(u.x-i.project([c,t-h]).x),1),this._radiusY=Math.max(Math.round(u.y-s.y),1)}else{var d=o.unproject(o.project(this._latlng).subtract([this._mRadius,0]));this._point=i.latLngToLayerPoint(this._latlng),this._radius=this._point.x-i.latLngToLayerPoint(d).x}this._updateBounds()}}),n.circle=function(t,e,i){return new n.Circle(t,e,i)},n.SVG=n.Renderer.extend({getEvents:function(){var t=n.Renderer.prototype.getEvents.call(this);return t.zoomstart=this._onZoomStart,t},_initContainer:function(){this._container=n.SVG.create("svg"),this._container.setAttribute("pointer-events","none"),this._rootGroup=n.SVG.create("g"),this._container.appendChild(this._rootGroup)},_onZoomStart:function(){this._update()},_update:function(){if(!this._map._animatingZoom||!this._bounds){n.Renderer.prototype._update.call(this);var t=this._bounds,e=t.getSize(),i=this._container;this._svgSize&&this._svgSize.equals(e)||(this._svgSize=e,i.setAttribute("width",e.x),i.setAttribute("height",e.y)),n.DomUtil.setPosition(i,t.min),i.setAttribute("viewBox",[t.min.x,t.min.y,e.x,e.y].join(" ")),this.fire("update")}},_initPath:function(t){var e=t._path=n.SVG.create("path");t.options.className&&n.DomUtil.addClass(e,t.options.className),t.options.interactive&&n.DomUtil.addClass(e,"leaflet-interactive"),this._updateStyle(t)},_addPath:function(t){this._rootGroup.appendChild(t._path),t.addInteractiveTarget(t._path)},_removePath:function(t){n.DomUtil.remove(t._path),t.removeInteractiveTarget(t._path)},_updatePath:function(t){t._project(),t._update()},_updateStyle:function(t){var e=t._path,i=t.options;e&&(i.stroke?(e.setAttribute("stroke",i.color),e.setAttribute("stroke-opacity",i.opacity),e.setAttribute("stroke-width",i.weight),e.setAttribute("stroke-linecap",i.lineCap),e.setAttribute("stroke-linejoin",i.lineJoin),i.dashArray?e.setAttribute("stroke-dasharray",i.dashArray):e.removeAttribute("stroke-dasharray"),i.dashOffset?e.setAttribute("stroke-dashoffset",i.dashOffset):e.removeAttribute("stroke-dashoffset")):e.setAttribute("stroke","none"),i.fill?(e.setAttribute("fill",i.fillColor||i.color),e.setAttribute("fill-opacity",i.fillOpacity),e.setAttribute("fill-rule",i.fillRule||"evenodd")):e.setAttribute("fill","none"))},_updatePoly:function(t,e){this._setPath(t,n.SVG.pointsToPath(t._parts,e))},_updateCircle:function(t){var e=t._point,i=t._radius,o=t._radiusY||i,n="a"+i+","+o+" 0 1,0 ",r=t._empty()?"M0 0":"M"+(e.x-i)+","+e.y+n+2*i+",0 "+n+2*-i+",0 ";this._setPath(t,r)},_setPath:function(t,e){t._path.setAttribute("d",e)},_bringToFront:function(t){n.DomUtil.toFront(t._path)},_bringToBack:function(t){n.DomUtil.toBack(t._path)}}),n.extend(n.SVG,{create:function(t){return document.createElementNS("http://www.w3.org/2000/svg",t)},pointsToPath:function(t,e){var i,o,r,a,s,l,u="";for(i=0,r=t.length;i<r;i++){for(s=t[i],o=0,a=s.length;o<a;o++)l=s[o],u+=(o?"L":"M")+l.x+" "+l.y;u+=e?n.Browser.svg?"z":"x":""}return u||"M0 0"}}),n.Browser.svg=!(!document.createElementNS||!n.SVG.create("svg").createSVGRect),n.svg=function(t){return n.Browser.svg||n.Browser.vml?new n.SVG(t):null},n.Browser.vml=!n.Browser.svg&&function(){try{var t=document.createElement("div");t.innerHTML='<v:shape adj="1"/>';var e=t.firstChild;return e.style.behavior="url(#default#VML)",e&&"object"==typeof e.adj}catch(i){return!1}}(),n.SVG.include(n.Browser.vml?{_initContainer:function(){this._container=n.DomUtil.create("div","leaflet-vml-container")},_update:function(){this._map._animatingZoom||(n.Renderer.prototype._update.call(this),this.fire("update"))},_initPath:function(t){var e=t._container=n.SVG.create("shape");n.DomUtil.addClass(e,"leaflet-vml-shape "+(this.options.className||"")),e.coordsize="1 1",t._path=n.SVG.create("path"),e.appendChild(t._path),this._updateStyle(t)},_addPath:function(t){var e=t._container;this._container.appendChild(e),t.options.interactive&&t.addInteractiveTarget(e)},_removePath:function(t){var e=t._container;n.DomUtil.remove(e),t.removeInteractiveTarget(e)},_updateStyle:function(t){var e=t._stroke,i=t._fill,o=t.options,r=t._container;r.stroked=!!o.stroke,r.filled=!!o.fill,o.stroke?(e||(e=t._stroke=n.SVG.create("stroke")),r.appendChild(e),e.weight=o.weight+"px",e.color=o.color,e.opacity=o.opacity,o.dashArray?e.dashStyle=n.Util.isArray(o.dashArray)?o.dashArray.join(" "):o.dashArray.replace(/( *, *)/g," "):e.dashStyle="",e.endcap=o.lineCap.replace("butt","flat"),e.joinstyle=o.lineJoin):e&&(r.removeChild(e),t._stroke=null),o.fill?(i||(i=t._fill=n.SVG.create("fill")),r.appendChild(i),i.color=o.fillColor||o.color,i.opacity=o.fillOpacity):i&&(r.removeChild(i),t._fill=null)},_updateCircle:function(t){var e=t._point.round(),i=Math.round(t._radius),o=Math.round(t._radiusY||i);this._setPath(t,t._empty()?"M0 0":"AL "+e.x+","+e.y+" "+i+","+o+" 0,23592600")},_setPath:function(t,e){t._path.v=e},_bringToFront:function(t){n.DomUtil.toFront(t._container)},_bringToBack:function(t){n.DomUtil.toBack(t._container)}}:{}),n.Browser.vml&&(n.SVG.create=function(){try{return document.namespaces.add("lvml","urn:schemas-microsoft-com:vml"),function(t){return document.createElement("<lvml:"+t+' class="lvml">')}}catch(t){return function(t){return document.createElement("<"+t+' xmlns="urn:schemas-microsoft.com:vml" class="lvml">')}}}()),n.Canvas=n.Renderer.extend({onAdd:function(){n.Renderer.prototype.onAdd.call(this),this._layers=this._layers||{},this._draw()},_initContainer:function(){var t=this._container=document.createElement("canvas");n.DomEvent.on(t,"mousemove",n.Util.throttle(this._onMouseMove,32,this),this).on(t,"click dblclick mousedown mouseup contextmenu",this._onClick,this).on(t,"mouseout",this._handleMouseOut,this),this._ctx=t.getContext("2d")},_update:function(){if(!this._map._animatingZoom||!this._bounds){this._drawnLayers={},n.Renderer.prototype._update.call(this);var t=this._bounds,e=this._container,i=t.getSize(),o=n.Browser.retina?2:1;n.DomUtil.setPosition(e,t.min),e.width=o*i.x,e.height=o*i.y,e.style.width=i.x+"px",e.style.height=i.y+"px",n.Browser.retina&&this._ctx.scale(2,2),this._ctx.translate(-t.min.x,-t.min.y),this.fire("update")}},_initPath:function(t){this._updateDashArray(t),this._layers[n.stamp(t)]=t},_addPath:n.Util.falseFn,_removePath:function(t){t._removed=!0,this._requestRedraw(t)},_updatePath:function(t){this._redrawBounds=t._pxBounds,this._draw(!0),t._project(),t._update(),this._draw(),this._redrawBounds=null},_updateStyle:function(t){this._updateDashArray(t),this._requestRedraw(t)},_updateDashArray:function(t){if(t.options.dashArray){var e,i=t.options.dashArray.split(","),o=[];for(e=0;e<i.length;e++)o.push(Number(i[e]));t.options._dashArray=o}},_requestRedraw:function(t){if(this._map){var e=(t.options.weight||0)+1;this._redrawBounds=this._redrawBounds||new n.Bounds,this._redrawBounds.extend(t._pxBounds.min.subtract([e,e])),this._redrawBounds.extend(t._pxBounds.max.add([e,e])),this._redrawRequest=this._redrawRequest||n.Util.requestAnimFrame(this._redraw,this)}},_redraw:function(){this._redrawRequest=null,this._draw(!0),this._draw(),this._redrawBounds=null},_draw:function(t){this._clear=t;var e,i=this._redrawBounds;this._ctx.save(),i&&(this._ctx.beginPath(),this._ctx.rect(i.min.x,i.min.y,i.max.x-i.min.x,i.max.y-i.min.y),this._ctx.clip());for(var o in this._layers)e=this._layers[o],(!i||e._pxBounds&&e._pxBounds.intersects(i))&&e._updatePath(),t&&e._removed&&(delete e._removed,delete this._layers[o]);this._ctx.restore()},_updatePoly:function(t,e){var i,o,n,r,a=t._parts,s=a.length,l=this._ctx;if(s){for(this._drawnLayers[t._leaflet_id]=t,l.beginPath(),l.setLineDash&&l.setLineDash(t.options&&t.options._dashArray||[]),i=0;i<s;i++){for(o=0,n=a[i].length;o<n;o++)r=a[i][o],l[o?"lineTo":"moveTo"](r.x,r.y);e&&l.closePath()}this._fillStroke(l,t)}},_updateCircle:function(t){if(!t._empty()){var e=t._point,i=this._ctx,o=t._radius,n=(t._radiusY||o)/o;this._drawnLayers[t._leaflet_id]=t,1!==n&&(i.save(),i.scale(1,n)),i.beginPath(),i.arc(e.x,e.y/n,o,0,2*Math.PI,!1),1!==n&&i.restore(),this._fillStroke(i,t)}},_fillStroke:function(t,e){var i=this._clear,o=e.options;t.globalCompositeOperation=i?"destination-out":"source-over",o.fill&&(t.globalAlpha=i?1:o.fillOpacity,t.fillStyle=o.fillColor||o.color,t.fill(o.fillRule||"evenodd")),o.stroke&&0!==o.weight&&(t.globalAlpha=i?1:o.opacity,e._prevWeight=t.lineWidth=i?e._prevWeight+1:o.weight,t.strokeStyle=o.color,t.lineCap=o.lineCap,t.lineJoin=o.lineJoin,t.stroke())},_onClick:function(t){var e,i=this._map.mouseEventToLayerPoint(t),o=[];for(var r in this._layers)e=this._layers[r],e.options.interactive&&e._containsPoint(i)&&!this._map._draggableMoved(e)&&(n.DomEvent._fakeStop(t),o.push(e));o.length&&this._fireEvent(o,t)},_onMouseMove:function(t){if(this._map&&!this._map.dragging.moving()&&!this._map._animatingZoom){var e=this._map.mouseEventToLayerPoint(t);this._handleMouseOut(t,e),this._handleMouseHover(t,e)}},_handleMouseOut:function(t,e){var i=this._hoveredLayer;!i||"mouseout"!==t.type&&i._containsPoint(e)||(n.DomUtil.removeClass(this._container,"leaflet-interactive"),this._fireEvent([i],t,"mouseout"),this._hoveredLayer=null)},_handleMouseHover:function(t,e){var i,o;for(i in this._drawnLayers)o=this._drawnLayers[i],o.options.interactive&&o._containsPoint(e)&&(n.DomUtil.addClass(this._container,"leaflet-interactive"),this._fireEvent([o],t,"mouseover"),this._hoveredLayer=o);this._hoveredLayer&&this._fireEvent([this._hoveredLayer],t)},_fireEvent:function(t,e,i){this._map._fireDOMEvent(e,i||e.type,t)},_bringToFront:n.Util.falseFn,_bringToBack:n.Util.falseFn}),n.Browser.canvas=function(){return!!document.createElement("canvas").getContext}(),n.canvas=function(t){return n.Browser.canvas?new n.Canvas(t):null},n.Polyline.prototype._containsPoint=function(t,e){var i,o,r,a,s,l,u=this._clickTolerance();if(!this._pxBounds.contains(t))return!1;for(i=0,a=this._parts.length;i<a;i++)for(l=this._parts[i],o=0,s=l.length,r=s-1;o<s;r=o++)if((e||0!==o)&&n.LineUtil.pointToSegmentDistance(t,l[r],l[o])<=u)return!0;return!1},n.Polygon.prototype._containsPoint=function(t){var e,i,o,r,a,s,l,u,c=!1;if(!this._pxBounds.contains(t))return!1;for(r=0,l=this._parts.length;r<l;r++)for(e=this._parts[r],a=0,u=e.length,s=u-1;a<u;s=a++)i=e[a],o=e[s],i.y>t.y!=o.y>t.y&&t.x<(o.x-i.x)*(t.y-i.y)/(o.y-i.y)+i.x&&(c=!c);return c||n.Polyline.prototype._containsPoint.call(this,t,!0)},n.CircleMarker.prototype._containsPoint=function(t){return t.distanceTo(this._point)<=this._radius+this._clickTolerance()},n.GeoJSON=n.FeatureGroup.extend({initialize:function(t,e){n.setOptions(this,e),this._layers={},t&&this.addData(t)},addData:function(t){var e,i,o,r=n.Util.isArray(t)?t:t.features;if(r){for(e=0,i=r.length;e<i;e++)o=r[e],(o.geometries||o.geometry||o.features||o.coordinates)&&this.addData(o);return this}var a=this.options;if(a.filter&&!a.filter(t))return this;var s=n.GeoJSON.geometryToLayer(t,a);return s?(s.feature=n.GeoJSON.asFeature(t),s.defaultOptions=s.options,this.resetStyle(s),a.onEachFeature&&a.onEachFeature(t,s),this.addLayer(s)):this},resetStyle:function(t){return t.options=n.Util.extend({},t.defaultOptions),this._setLayerStyle(t,this.options.style),this},setStyle:function(t){return this.eachLayer(function(e){this._setLayerStyle(e,t)},this)},_setLayerStyle:function(t,e){"function"==typeof e&&(e=e(t.feature)),t.setStyle&&t.setStyle(e)}}),n.extend(n.GeoJSON,{geometryToLayer:function(t,e){var i,o,r,a,s="Feature"===t.type?t.geometry:t,l=s?s.coordinates:null,u=[],c=e&&e.pointToLayer,h=e&&e.coordsToLatLng||this.coordsToLatLng;if(!l&&!s)return null;switch(s.type){case"Point":return i=h(l),c?c(t,i):new n.Marker(i);case"MultiPoint":for(r=0,a=l.length;r<a;r++)i=h(l[r]),u.push(c?c(t,i):new n.Marker(i));return new n.FeatureGroup(u);case"LineString":case"MultiLineString":return o=this.coordsToLatLngs(l,"LineString"===s.type?0:1,h),new n.Polyline(o,e);case"Polygon":case"MultiPolygon":return o=this.coordsToLatLngs(l,"Polygon"===s.type?1:2,h),new n.Polygon(o,e);case"GeometryCollection":for(r=0,a=s.geometries.length;r<a;r++){var d=this.geometryToLayer({geometry:s.geometries[r],type:"Feature",properties:t.properties},e);d&&u.push(d)}return new n.FeatureGroup(u);default:throw new Error("Invalid GeoJSON object.")}},coordsToLatLng:function(t){return new n.LatLng(t[1],t[0],t[2])},coordsToLatLngs:function(t,e,i){for(var o,n=[],r=0,a=t.length;r<a;r++)o=e?this.coordsToLatLngs(t[r],e-1,i):(i||this.coordsToLatLng)(t[r]),n.push(o);return n},latLngToCoords:function(t){return void 0!==t.alt?[t.lng,t.lat,t.alt]:[t.lng,t.lat]},latLngsToCoords:function(t,e,i){for(var o=[],r=0,a=t.length;r<a;r++)o.push(e?n.GeoJSON.latLngsToCoords(t[r],e-1,i):n.GeoJSON.latLngToCoords(t[r]));return!e&&i&&o.push(o[0]),o},getFeature:function(t,e){return t.feature?n.extend({},t.feature,{geometry:e}):n.GeoJSON.asFeature(e)},asFeature:function(t){return"Feature"===t.type?t:{type:"Feature",properties:{},geometry:t}}});var a={toGeoJSON:function(){return n.GeoJSON.getFeature(this,{type:"Point",coordinates:n.GeoJSON.latLngToCoords(this.getLatLng())})}};n.Marker.include(a),n.Circle.include(a),n.CircleMarker.include(a),n.Polyline.prototype.toGeoJSON=function(){var t=!n.Polyline._flat(this._latlngs),e=n.GeoJSON.latLngsToCoords(this._latlngs,t?1:0);return n.GeoJSON.getFeature(this,{type:(t?"Multi":"")+"LineString",coordinates:e})},n.Polygon.prototype.toGeoJSON=function(){var t=!n.Polyline._flat(this._latlngs),e=t&&!n.Polyline._flat(this._latlngs[0]),i=n.GeoJSON.latLngsToCoords(this._latlngs,e?2:t?1:0,!0);return t||(i=[i]),n.GeoJSON.getFeature(this,{type:(e?"Multi":"")+"Polygon",coordinates:i})},n.LayerGroup.include({toMultiPoint:function(){var t=[];return this.eachLayer(function(e){t.push(e.toGeoJSON().geometry.coordinates)}),n.GeoJSON.getFeature(this,{type:"MultiPoint",coordinates:t})},toGeoJSON:function(){var t=this.feature&&this.feature.geometry&&this.feature.geometry.type;if("MultiPoint"===t)return this.toMultiPoint();var e="GeometryCollection"===t,i=[];return this.eachLayer(function(t){if(t.toGeoJSON){var o=t.toGeoJSON();i.push(e?o.geometry:n.GeoJSON.asFeature(o))}}),e?n.GeoJSON.getFeature(this,{geometries:i,type:"GeometryCollection"}):{type:"FeatureCollection",features:i}}}),n.geoJSON=function(t,e){return new n.GeoJSON(t,e)},n.geoJson=n.geoJSON;var s="_leaflet_events";n.DomEvent={on:function(t,e,i,o){if("object"==typeof e)for(var r in e)this._on(t,r,e[r],i);else{e=n.Util.splitWords(e);for(var a=0,s=e.length;a<s;a++)this._on(t,e[a],i,o)}return this},off:function(t,e,i,o){if("object"==typeof e)for(var r in e)this._off(t,r,e[r],i);else{e=n.Util.splitWords(e);for(var a=0,s=e.length;a<s;a++)this._off(t,e[a],i,o)}return this},_on:function(t,e,i,o){var r=e+n.stamp(i)+(o?"_"+n.stamp(o):"");if(t[s]&&t[s][r])return this;var a=function(e){return i.call(o||t,e||window.event)},l=a;return n.Browser.pointer&&0===e.indexOf("touch")?this.addPointerListener(t,e,a,r):n.Browser.touch&&"dblclick"===e&&this.addDoubleTapListener?this.addDoubleTapListener(t,a,r):"addEventListener"in t?"mousewheel"===e?t.addEventListener("onwheel"in t?"wheel":"mousewheel",a,!1):"mouseenter"===e||"mouseleave"===e?(a=function(e){e=e||window.event,n.DomEvent._isExternalTarget(t,e)&&l(e)},t.addEventListener("mouseenter"===e?"mouseover":"mouseout",a,!1)):("click"===e&&n.Browser.android&&(a=function(t){return n.DomEvent._filterClick(t,l)}),t.addEventListener(e,a,!1)):"attachEvent"in t&&t.attachEvent("on"+e,a),t[s]=t[s]||{},t[s][r]=a,this},_off:function(t,e,i,o){var r=e+n.stamp(i)+(o?"_"+n.stamp(o):""),a=t[s]&&t[s][r];return a?(n.Browser.pointer&&0===e.indexOf("touch")?this.removePointerListener(t,e,r):n.Browser.touch&&"dblclick"===e&&this.removeDoubleTapListener?this.removeDoubleTapListener(t,r):"removeEventListener"in t?"mousewheel"===e?t.removeEventListener("onwheel"in t?"wheel":"mousewheel",a,!1):t.removeEventListener("mouseenter"===e?"mouseover":"mouseleave"===e?"mouseout":e,a,!1):"detachEvent"in t&&t.detachEvent("on"+e,a),t[s][r]=null,this):this},stopPropagation:function(t){return t.stopPropagation?t.stopPropagation():t.originalEvent?t.originalEvent._stopped=!0:t.cancelBubble=!0,n.DomEvent._skipped(t),this},disableScrollPropagation:function(t){return n.DomEvent.on(t,"mousewheel",n.DomEvent.stopPropagation)},disableClickPropagation:function(t){var e=n.DomEvent.stopPropagation;return n.DomEvent.on(t,n.Draggable.START.join(" "),e),n.DomEvent.on(t,{click:n.DomEvent._fakeStop,dblclick:e})},preventDefault:function(t){return t.preventDefault?t.preventDefault():t.returnValue=!1,this},stop:function(t){return n.DomEvent.preventDefault(t).stopPropagation(t)},getMousePosition:function(t,e){if(!e)return new n.Point(t.clientX,t.clientY);var i=e.getBoundingClientRect();return new n.Point(t.clientX-i.left-e.clientLeft,t.clientY-i.top-e.clientTop)},_wheelPxFactor:n.Browser.win&&n.Browser.chrome?2:n.Browser.gecko?window.devicePixelRatio:1,getWheelDelta:function(t){return n.Browser.edge?t.wheelDeltaY/2:t.deltaY&&0===t.deltaMode?-t.deltaY/n.DomEvent._wheelPxFactor:t.deltaY&&1===t.deltaMode?20*-t.deltaY:t.deltaY&&2===t.deltaMode?60*-t.deltaY:t.deltaX||t.deltaZ?0:t.wheelDelta?(t.wheelDeltaY||t.wheelDelta)/2:t.detail&&Math.abs(t.detail)<32765?20*-t.detail:t.detail?t.detail/-32765*60:0;
	},_skipEvents:{},_fakeStop:function(t){n.DomEvent._skipEvents[t.type]=!0},_skipped:function(t){var e=this._skipEvents[t.type];return this._skipEvents[t.type]=!1,e},_isExternalTarget:function(t,e){var i=e.relatedTarget;if(!i)return!0;try{for(;i&&i!==t;)i=i.parentNode}catch(o){return!1}return i!==t},_filterClick:function(t,e){var i=t.timeStamp||t.originalEvent&&t.originalEvent.timeStamp,o=n.DomEvent._lastClick&&i-n.DomEvent._lastClick;return o&&o>100&&o<500||t.target._simulatedClick&&!t._simulated?void n.DomEvent.stop(t):(n.DomEvent._lastClick=i,void e(t))}},n.DomEvent.addListener=n.DomEvent.on,n.DomEvent.removeListener=n.DomEvent.off,n.Draggable=n.Evented.extend({options:{clickTolerance:3},statics:{START:n.Browser.touch?["touchstart","mousedown"]:["mousedown"],END:{mousedown:"mouseup",touchstart:"touchend",pointerdown:"touchend",MSPointerDown:"touchend"},MOVE:{mousedown:"mousemove",touchstart:"touchmove",pointerdown:"touchmove",MSPointerDown:"touchmove"}},initialize:function(t,e,i){this._element=t,this._dragStartTarget=e||t,this._preventOutline=i},enable:function(){this._enabled||(n.DomEvent.on(this._dragStartTarget,n.Draggable.START.join(" "),this._onDown,this),this._enabled=!0)},disable:function(){this._enabled&&(n.DomEvent.off(this._dragStartTarget,n.Draggable.START.join(" "),this._onDown,this),this._enabled=!1,this._moved=!1)},_onDown:function(t){if(!t._simulated&&this._enabled&&(this._moved=!1,!n.DomUtil.hasClass(this._element,"leaflet-zoom-anim")&&!(n.Draggable._dragging||t.shiftKey||1!==t.which&&1!==t.button&&!t.touches)&&this._enabled&&(n.Draggable._dragging=!0,this._preventOutline&&n.DomUtil.preventOutline(this._element),n.DomUtil.disableImageDrag(),n.DomUtil.disableTextSelection(),!this._moving))){this.fire("down");var e=t.touches?t.touches[0]:t;this._startPoint=new n.Point(e.clientX,e.clientY),n.DomEvent.on(document,n.Draggable.MOVE[t.type],this._onMove,this).on(document,n.Draggable.END[t.type],this._onUp,this)}},_onMove:function(t){if(!t._simulated&&this._enabled){if(t.touches&&t.touches.length>1)return void(this._moved=!0);var e=t.touches&&1===t.touches.length?t.touches[0]:t,i=new n.Point(e.clientX,e.clientY),o=i.subtract(this._startPoint);(o.x||o.y)&&(Math.abs(o.x)+Math.abs(o.y)<this.options.clickTolerance||(n.DomEvent.preventDefault(t),this._moved||(this.fire("dragstart"),this._moved=!0,this._startPos=n.DomUtil.getPosition(this._element).subtract(o),n.DomUtil.addClass(document.body,"leaflet-dragging"),this._lastTarget=t.target||t.srcElement,window.SVGElementInstance&&this._lastTarget instanceof SVGElementInstance&&(this._lastTarget=this._lastTarget.correspondingUseElement),n.DomUtil.addClass(this._lastTarget,"leaflet-drag-target")),this._newPos=this._startPos.add(o),this._moving=!0,n.Util.cancelAnimFrame(this._animRequest),this._lastEvent=t,this._animRequest=n.Util.requestAnimFrame(this._updatePosition,this,!0)))}},_updatePosition:function(){var t={originalEvent:this._lastEvent};this.fire("predrag",t),n.DomUtil.setPosition(this._element,this._newPos),this.fire("drag",t)},_onUp:function(t){if(!t._simulated&&this._enabled){n.DomUtil.removeClass(document.body,"leaflet-dragging"),this._lastTarget&&(n.DomUtil.removeClass(this._lastTarget,"leaflet-drag-target"),this._lastTarget=null);for(var e in n.Draggable.MOVE)n.DomEvent.off(document,n.Draggable.MOVE[e],this._onMove,this).off(document,n.Draggable.END[e],this._onUp,this);n.DomUtil.enableImageDrag(),n.DomUtil.enableTextSelection(),this._moved&&this._moving&&(n.Util.cancelAnimFrame(this._animRequest),this.fire("dragend",{distance:this._newPos.distanceTo(this._startPos)})),this._moving=!1,n.Draggable._dragging=!1}}}),n.Handler=n.Class.extend({initialize:function(t){this._map=t},enable:function(){return this._enabled?this:(this._enabled=!0,this.addHooks(),this)},disable:function(){return this._enabled?(this._enabled=!1,this.removeHooks(),this):this},enabled:function(){return!!this._enabled}}),n.Map.mergeOptions({dragging:!0,inertia:!n.Browser.android23,inertiaDeceleration:3400,inertiaMaxSpeed:1/0,easeLinearity:.2,worldCopyJump:!1,maxBoundsViscosity:0}),n.Map.Drag=n.Handler.extend({addHooks:function(){if(!this._draggable){var t=this._map;this._draggable=new n.Draggable(t._mapPane,t._container),this._draggable.on({down:this._onDown,dragstart:this._onDragStart,drag:this._onDrag,dragend:this._onDragEnd},this),this._draggable.on("predrag",this._onPreDragLimit,this),t.options.worldCopyJump&&(this._draggable.on("predrag",this._onPreDragWrap,this),t.on("zoomend",this._onZoomEnd,this),t.whenReady(this._onZoomEnd,this))}n.DomUtil.addClass(this._map._container,"leaflet-grab leaflet-touch-drag"),this._draggable.enable(),this._positions=[],this._times=[]},removeHooks:function(){n.DomUtil.removeClass(this._map._container,"leaflet-grab"),n.DomUtil.removeClass(this._map._container,"leaflet-touch-drag"),this._draggable.disable()},moved:function(){return this._draggable&&this._draggable._moved},moving:function(){return this._draggable&&this._draggable._moving},_onDown:function(){this._map._stop()},_onDragStart:function(){var t=this._map;if(this._map.options.maxBounds&&this._map.options.maxBoundsViscosity){var e=n.latLngBounds(this._map.options.maxBounds);this._offsetLimit=n.bounds(this._map.latLngToContainerPoint(e.getNorthWest()).multiplyBy(-1),this._map.latLngToContainerPoint(e.getSouthEast()).multiplyBy(-1).add(this._map.getSize())),this._viscosity=Math.min(1,Math.max(0,this._map.options.maxBoundsViscosity))}else this._offsetLimit=null;t.fire("movestart").fire("dragstart"),t.options.inertia&&(this._positions=[],this._times=[])},_onDrag:function(t){if(this._map.options.inertia){var e=this._lastTime=+new Date,i=this._lastPos=this._draggable._absPos||this._draggable._newPos;this._positions.push(i),this._times.push(e),e-this._times[0]>50&&(this._positions.shift(),this._times.shift())}this._map.fire("move",t).fire("drag",t)},_onZoomEnd:function(){var t=this._map.getSize().divideBy(2),e=this._map.latLngToLayerPoint([0,0]);this._initialWorldOffset=e.subtract(t).x,this._worldWidth=this._map.getPixelWorldBounds().getSize().x},_viscousLimit:function(t,e){return t-(t-e)*this._viscosity},_onPreDragLimit:function(){if(this._viscosity&&this._offsetLimit){var t=this._draggable._newPos.subtract(this._draggable._startPos),e=this._offsetLimit;t.x<e.min.x&&(t.x=this._viscousLimit(t.x,e.min.x)),t.y<e.min.y&&(t.y=this._viscousLimit(t.y,e.min.y)),t.x>e.max.x&&(t.x=this._viscousLimit(t.x,e.max.x)),t.y>e.max.y&&(t.y=this._viscousLimit(t.y,e.max.y)),this._draggable._newPos=this._draggable._startPos.add(t)}},_onPreDragWrap:function(){var t=this._worldWidth,e=Math.round(t/2),i=this._initialWorldOffset,o=this._draggable._newPos.x,n=(o-e+i)%t+e-i,r=(o+e+i)%t-e-i,a=Math.abs(n+i)<Math.abs(r+i)?n:r;this._draggable._absPos=this._draggable._newPos.clone(),this._draggable._newPos.x=a},_onDragEnd:function(t){var e=this._map,i=e.options,o=!i.inertia||this._times.length<2;if(e.fire("dragend",t),o)e.fire("moveend");else{var r=this._lastPos.subtract(this._positions[0]),a=(this._lastTime-this._times[0])/1e3,s=i.easeLinearity,l=r.multiplyBy(s/a),u=l.distanceTo([0,0]),c=Math.min(i.inertiaMaxSpeed,u),h=l.multiplyBy(c/u),d=c/(i.inertiaDeceleration*s),p=h.multiplyBy(-d/2).round();p.x||p.y?(p=e._limitOffset(p,e.options.maxBounds),n.Util.requestAnimFrame(function(){e.panBy(p,{duration:d,easeLinearity:s,noMoveStart:!0,animate:!0})})):e.fire("moveend")}}}),n.Map.addInitHook("addHandler","dragging",n.Map.Drag),n.Map.mergeOptions({doubleClickZoom:!0}),n.Map.DoubleClickZoom=n.Handler.extend({addHooks:function(){this._map.on("dblclick",this._onDoubleClick,this)},removeHooks:function(){this._map.off("dblclick",this._onDoubleClick,this)},_onDoubleClick:function(t){var e=this._map,i=e.getZoom(),o=e.options.zoomDelta,n=t.originalEvent.shiftKey?i-o:i+o;"center"===e.options.doubleClickZoom?e.setZoom(n):e.setZoomAround(t.containerPoint,n)}}),n.Map.addInitHook("addHandler","doubleClickZoom",n.Map.DoubleClickZoom),n.Map.mergeOptions({scrollWheelZoom:!0,wheelDebounceTime:40,wheelPxPerZoomLevel:60}),n.Map.ScrollWheelZoom=n.Handler.extend({addHooks:function(){n.DomEvent.on(this._map._container,"mousewheel",this._onWheelScroll,this),this._delta=0},removeHooks:function(){n.DomEvent.off(this._map._container,"mousewheel",this._onWheelScroll,this)},_onWheelScroll:function(t){var e=n.DomEvent.getWheelDelta(t),i=this._map.options.wheelDebounceTime;this._delta+=e,this._lastMousePos=this._map.mouseEventToContainerPoint(t),this._startTime||(this._startTime=+new Date);var o=Math.max(i-(+new Date-this._startTime),0);clearTimeout(this._timer),this._timer=setTimeout(n.bind(this._performZoom,this),o),n.DomEvent.stop(t)},_performZoom:function(){var t=this._map,e=t.getZoom(),i=this._map.options.zoomSnap||0;t._stop();var o=this._delta/(4*this._map.options.wheelPxPerZoomLevel),n=4*Math.log(2/(1+Math.exp(-Math.abs(o))))/Math.LN2,r=i?Math.ceil(n/i)*i:n,a=t._limitZoom(e+(this._delta>0?r:-r))-e;this._delta=0,this._startTime=null,a&&("center"===t.options.scrollWheelZoom?t.setZoom(e+a):t.setZoomAround(this._lastMousePos,e+a))}}),n.Map.addInitHook("addHandler","scrollWheelZoom",n.Map.ScrollWheelZoom),n.PosAnimation=n.Evented.extend({run:function(t,e,i,o){this.stop(),this._el=t,this._inProgress=!0,this._duration=i||.25,this._easeOutPower=1/Math.max(o||.5,.2),this._startPos=n.DomUtil.getPosition(t),this._offset=e.subtract(this._startPos),this._startTime=+new Date,this.fire("start"),this._animate()},stop:function(){this._inProgress&&(this._step(!0),this._complete())},_animate:function(){this._animId=n.Util.requestAnimFrame(this._animate,this),this._step()},_step:function(t){var e=+new Date-this._startTime,i=1e3*this._duration;e<i?this._runFrame(this._easeOut(e/i),t):(this._runFrame(1),this._complete())},_runFrame:function(t,e){var i=this._startPos.add(this._offset.multiplyBy(t));e&&i._round(),n.DomUtil.setPosition(this._el,i),this.fire("step")},_complete:function(){n.Util.cancelAnimFrame(this._animId),this._inProgress=!1,this.fire("end")},_easeOut:function(t){return 1-Math.pow(1-t,this._easeOutPower)}}),n.Map.include({setView:function(t,e,i){if(e=void 0===e?this._zoom:this._limitZoom(e),t=this._limitCenter(n.latLng(t),e,this.options.maxBounds),i=i||{},this._stop(),this._loaded&&!i.reset&&i!==!0){void 0!==i.animate&&(i.zoom=n.extend({animate:i.animate},i.zoom),i.pan=n.extend({animate:i.animate,duration:i.duration},i.pan));var o=this._zoom!==e?this._tryAnimatedZoom&&this._tryAnimatedZoom(t,e,i.zoom):this._tryAnimatedPan(t,i.pan);if(o)return clearTimeout(this._sizeTimer),this}return this._resetView(t,e),this},panBy:function(t,e){if(t=n.point(t).round(),e=e||{},!t.x&&!t.y)return this.fire("moveend");if(e.animate!==!0&&!this.getSize().contains(t))return this._resetView(this.unproject(this.project(this.getCenter()).add(t)),this.getZoom()),this;if(this._panAnim||(this._panAnim=new n.PosAnimation,this._panAnim.on({step:this._onPanTransitionStep,end:this._onPanTransitionEnd},this)),e.noMoveStart||this.fire("movestart"),e.animate!==!1){n.DomUtil.addClass(this._mapPane,"leaflet-pan-anim");var i=this._getMapPanePos().subtract(t).round();this._panAnim.run(this._mapPane,i,e.duration||.25,e.easeLinearity)}else this._rawPanBy(t),this.fire("move").fire("moveend");return this},_onPanTransitionStep:function(){this.fire("move")},_onPanTransitionEnd:function(){n.DomUtil.removeClass(this._mapPane,"leaflet-pan-anim"),this.fire("moveend")},_tryAnimatedPan:function(t,e){var i=this._getCenterOffset(t)._floor();return!((e&&e.animate)!==!0&&!this.getSize().contains(i))&&(this.panBy(i,e),!0)}}),n.Map.mergeOptions({zoomAnimation:!0,zoomAnimationThreshold:4});var l=n.DomUtil.TRANSITION&&n.Browser.any3d&&!n.Browser.mobileOpera;l&&n.Map.addInitHook(function(){this._zoomAnimated=this.options.zoomAnimation,this._zoomAnimated&&(this._createAnimProxy(),n.DomEvent.on(this._proxy,n.DomUtil.TRANSITION_END,this._catchTransitionEnd,this))}),n.Map.include(l?{_createAnimProxy:function(){var t=this._proxy=n.DomUtil.create("div","leaflet-proxy leaflet-zoom-animated");this._panes.mapPane.appendChild(t),this.on("zoomanim",function(e){var i=n.DomUtil.TRANSFORM,o=t.style[i];n.DomUtil.setTransform(t,this.project(e.center,e.zoom),this.getZoomScale(e.zoom,1)),o===t.style[i]&&this._animatingZoom&&this._onZoomTransitionEnd()},this),this.on("load moveend",function(){var e=this.getCenter(),i=this.getZoom();n.DomUtil.setTransform(t,this.project(e,i),this.getZoomScale(i,1))},this)},_catchTransitionEnd:function(t){this._animatingZoom&&t.propertyName.indexOf("transform")>=0&&this._onZoomTransitionEnd()},_nothingToAnimate:function(){return!this._container.getElementsByClassName("leaflet-zoom-animated").length},_tryAnimatedZoom:function(t,e,i){if(this._animatingZoom)return!0;if(i=i||{},!this._zoomAnimated||i.animate===!1||this._nothingToAnimate()||Math.abs(e-this._zoom)>this.options.zoomAnimationThreshold)return!1;var o=this.getZoomScale(e),r=this._getCenterOffset(t)._divideBy(1-1/o);return!(i.animate!==!0&&!this.getSize().contains(r))&&(n.Util.requestAnimFrame(function(){this._moveStart(!0)._animateZoom(t,e,!0)},this),!0)},_animateZoom:function(t,e,i,o){i&&(this._animatingZoom=!0,this._animateToCenter=t,this._animateToZoom=e,n.DomUtil.addClass(this._mapPane,"leaflet-zoom-anim")),this.fire("zoomanim",{center:t,zoom:e,noUpdate:o}),setTimeout(n.bind(this._onZoomTransitionEnd,this),250)},_onZoomTransitionEnd:function(){this._animatingZoom&&(n.DomUtil.removeClass(this._mapPane,"leaflet-zoom-anim"),this._animatingZoom=!1,this._move(this._animateToCenter,this._animateToZoom),n.Util.requestAnimFrame(function(){this._moveEnd(!0)},this))}}:{}),n.Map.include({flyTo:function(t,e,i){function o(t){var e=t?-1:1,i=t?g:f,o=g*g-f*f+e*b*b*v*v,n=2*i*b*v,r=o/n,a=Math.sqrt(r*r+1)-r,s=a<1e-9?-18:Math.log(a);return s}function r(t){return(Math.exp(t)-Math.exp(-t))/2}function a(t){return(Math.exp(t)+Math.exp(-t))/2}function s(t){return r(t)/a(t)}function l(t){return f*(a(C)/a(C+y*t))}function u(t){return f*(a(C)*s(C+y*t)-r(C))/b}function c(t){return 1-Math.pow(1-t,1.5)}function h(){var i=(Date.now()-w)/x,o=c(i)*k;i<=1?(this._flyToFrame=n.Util.requestAnimFrame(h,this),this._move(this.unproject(d.add(p.subtract(d).multiplyBy(u(o)/v)),m),this.getScaleZoom(f/l(o),m),{flyTo:!0})):this._move(t,e)._moveEnd(!0)}if(i=i||{},i.animate===!1||!n.Browser.any3d)return this.setView(t,e,i);this._stop();var d=this.project(this.getCenter()),p=this.project(t),_=this.getSize(),m=this._zoom;t=n.latLng(t),e=void 0===e?m:e;var f=Math.max(_.x,_.y),g=f*this.getZoomScale(m,e),v=p.distanceTo(d)||1,y=1.42,b=y*y,C=o(0),w=Date.now(),k=(o(1)-C)/y,x=i.duration?1e3*i.duration:1e3*k*.8;return this._moveStart(!0),h.call(this),this},flyToBounds:function(t,e){var i=this._getBoundsCenterZoom(t,e);return this.flyTo(i.center,i.zoom,e)}}),n.extend(n.DomEvent,{_touchstart:n.Browser.msPointer?"MSPointerDown":n.Browser.pointer?"pointerdown":"touchstart",_touchend:n.Browser.msPointer?"MSPointerUp":n.Browser.pointer?"pointerup":"touchend",addDoubleTapListener:function(t,e,i){function o(t){var e;if(e=n.Browser.pointer?n.DomEvent._pointersCount:t.touches.length,!(e>1)){var i=Date.now(),o=i-(a||i);s=t.touches?t.touches[0]:t,l=o>0&&o<=u,a=i}}function r(){if(l&&!s.cancelBubble){if(n.Browser.pointer){var t,i,o={};for(i in s)t=s[i],o[i]=t&&t.bind?t.bind(s):t;s=o}s.type="dblclick",e(s),a=null}}var a,s,l=!1,u=250,c="_leaflet_",h=this._touchstart,d=this._touchend;return t[c+h+i]=o,t[c+d+i]=r,t[c+"dblclick"+i]=e,t.addEventListener(h,o,!1),t.addEventListener(d,r,!1),n.Browser.edge||t.addEventListener("dblclick",e,!1),this},removeDoubleTapListener:function(t,e){var i="_leaflet_",o=t[i+this._touchstart+e],r=t[i+this._touchend+e],a=t[i+"dblclick"+e];return t.removeEventListener(this._touchstart,o,!1),t.removeEventListener(this._touchend,r,!1),n.Browser.edge||t.removeEventListener("dblclick",a,!1),this}}),n.extend(n.DomEvent,{POINTER_DOWN:n.Browser.msPointer?"MSPointerDown":"pointerdown",POINTER_MOVE:n.Browser.msPointer?"MSPointerMove":"pointermove",POINTER_UP:n.Browser.msPointer?"MSPointerUp":"pointerup",POINTER_CANCEL:n.Browser.msPointer?"MSPointerCancel":"pointercancel",TAG_WHITE_LIST:["INPUT","SELECT","OPTION"],_pointers:{},_pointersCount:0,addPointerListener:function(t,e,i,o){return"touchstart"===e?this._addPointerStart(t,i,o):"touchmove"===e?this._addPointerMove(t,i,o):"touchend"===e&&this._addPointerEnd(t,i,o),this},removePointerListener:function(t,e,i){var o=t["_leaflet_"+e+i];return"touchstart"===e?t.removeEventListener(this.POINTER_DOWN,o,!1):"touchmove"===e?t.removeEventListener(this.POINTER_MOVE,o,!1):"touchend"===e&&(t.removeEventListener(this.POINTER_UP,o,!1),t.removeEventListener(this.POINTER_CANCEL,o,!1)),this},_addPointerStart:function(t,e,i){var o=n.bind(function(t){if("mouse"!==t.pointerType&&t.pointerType!==t.MSPOINTER_TYPE_MOUSE){if(!(this.TAG_WHITE_LIST.indexOf(t.target.tagName)<0))return;n.DomEvent.preventDefault(t)}this._handlePointer(t,e)},this);if(t["_leaflet_touchstart"+i]=o,t.addEventListener(this.POINTER_DOWN,o,!1),!this._pointerDocListener){var r=n.bind(this._globalPointerUp,this);document.documentElement.addEventListener(this.POINTER_DOWN,n.bind(this._globalPointerDown,this),!0),document.documentElement.addEventListener(this.POINTER_MOVE,n.bind(this._globalPointerMove,this),!0),document.documentElement.addEventListener(this.POINTER_UP,r,!0),document.documentElement.addEventListener(this.POINTER_CANCEL,r,!0),this._pointerDocListener=!0}},_globalPointerDown:function(t){this._pointers[t.pointerId]=t,this._pointersCount++},_globalPointerMove:function(t){this._pointers[t.pointerId]&&(this._pointers[t.pointerId]=t)},_globalPointerUp:function(t){delete this._pointers[t.pointerId],this._pointersCount--},_handlePointer:function(t,e){t.touches=[];for(var i in this._pointers)t.touches.push(this._pointers[i]);t.changedTouches=[t],e(t)},_addPointerMove:function(t,e,i){var o=n.bind(function(t){(t.pointerType!==t.MSPOINTER_TYPE_MOUSE&&"mouse"!==t.pointerType||0!==t.buttons)&&this._handlePointer(t,e)},this);t["_leaflet_touchmove"+i]=o,t.addEventListener(this.POINTER_MOVE,o,!1)},_addPointerEnd:function(t,e,i){var o=n.bind(function(t){this._handlePointer(t,e)},this);t["_leaflet_touchend"+i]=o,t.addEventListener(this.POINTER_UP,o,!1),t.addEventListener(this.POINTER_CANCEL,o,!1)}}),n.Map.mergeOptions({touchZoom:n.Browser.touch&&!n.Browser.android23,bounceAtZoomLimits:!0}),n.Map.TouchZoom=n.Handler.extend({addHooks:function(){n.DomUtil.addClass(this._map._container,"leaflet-touch-zoom"),n.DomEvent.on(this._map._container,"touchstart",this._onTouchStart,this)},removeHooks:function(){n.DomUtil.removeClass(this._map._container,"leaflet-touch-zoom"),n.DomEvent.off(this._map._container,"touchstart",this._onTouchStart,this)},_onTouchStart:function(t){var e=this._map;if(t.touches&&2===t.touches.length&&!e._animatingZoom&&!this._zooming){var i=e.mouseEventToContainerPoint(t.touches[0]),o=e.mouseEventToContainerPoint(t.touches[1]);this._centerPoint=e.getSize()._divideBy(2),this._startLatLng=e.containerPointToLatLng(this._centerPoint),"center"!==e.options.touchZoom&&(this._pinchStartLatLng=e.containerPointToLatLng(i.add(o)._divideBy(2))),this._startDist=i.distanceTo(o),this._startZoom=e.getZoom(),this._moved=!1,this._zooming=!0,e._stop(),n.DomEvent.on(document,"touchmove",this._onTouchMove,this).on(document,"touchend",this._onTouchEnd,this),n.DomEvent.preventDefault(t)}},_onTouchMove:function(t){if(t.touches&&2===t.touches.length&&this._zooming){var e=this._map,i=e.mouseEventToContainerPoint(t.touches[0]),o=e.mouseEventToContainerPoint(t.touches[1]),r=i.distanceTo(o)/this._startDist;if(this._zoom=e.getScaleZoom(r,this._startZoom),!e.options.bounceAtZoomLimits&&(this._zoom<e.getMinZoom()&&r<1||this._zoom>e.getMaxZoom()&&r>1)&&(this._zoom=e._limitZoom(this._zoom)),"center"===e.options.touchZoom){if(this._center=this._startLatLng,1===r)return}else{var a=i._add(o)._divideBy(2)._subtract(this._centerPoint);if(1===r&&0===a.x&&0===a.y)return;this._center=e.unproject(e.project(this._pinchStartLatLng,this._zoom).subtract(a),this._zoom)}this._moved||(e._moveStart(!0),this._moved=!0),n.Util.cancelAnimFrame(this._animRequest);var s=n.bind(e._move,e,this._center,this._zoom,{pinch:!0,round:!1});this._animRequest=n.Util.requestAnimFrame(s,this,!0),n.DomEvent.preventDefault(t)}},_onTouchEnd:function(){return this._moved&&this._zooming?(this._zooming=!1,n.Util.cancelAnimFrame(this._animRequest),n.DomEvent.off(document,"touchmove",this._onTouchMove).off(document,"touchend",this._onTouchEnd),void(this._map.options.zoomAnimation?this._map._animateZoom(this._center,this._map._limitZoom(this._zoom),!0,this._map.options.zoomSnap):this._map._resetView(this._center,this._map._limitZoom(this._zoom)))):void(this._zooming=!1)}}),n.Map.addInitHook("addHandler","touchZoom",n.Map.TouchZoom),n.Map.mergeOptions({tap:!0,tapTolerance:15}),n.Map.Tap=n.Handler.extend({addHooks:function(){n.DomEvent.on(this._map._container,"touchstart",this._onDown,this)},removeHooks:function(){n.DomEvent.off(this._map._container,"touchstart",this._onDown,this)},_onDown:function(t){if(t.touches){if(n.DomEvent.preventDefault(t),this._fireClick=!0,t.touches.length>1)return this._fireClick=!1,void clearTimeout(this._holdTimeout);var e=t.touches[0],i=e.target;this._startPos=this._newPos=new n.Point(e.clientX,e.clientY),i.tagName&&"a"===i.tagName.toLowerCase()&&n.DomUtil.addClass(i,"leaflet-active"),this._holdTimeout=setTimeout(n.bind(function(){this._isTapValid()&&(this._fireClick=!1,this._onUp(),this._simulateEvent("contextmenu",e))},this),1e3),this._simulateEvent("mousedown",e),n.DomEvent.on(document,{touchmove:this._onMove,touchend:this._onUp},this)}},_onUp:function(t){if(clearTimeout(this._holdTimeout),n.DomEvent.off(document,{touchmove:this._onMove,touchend:this._onUp},this),this._fireClick&&t&&t.changedTouches){var e=t.changedTouches[0],i=e.target;i&&i.tagName&&"a"===i.tagName.toLowerCase()&&n.DomUtil.removeClass(i,"leaflet-active"),this._simulateEvent("mouseup",e),this._isTapValid()&&this._simulateEvent("click",e)}},_isTapValid:function(){return this._newPos.distanceTo(this._startPos)<=this._map.options.tapTolerance},_onMove:function(t){var e=t.touches[0];this._newPos=new n.Point(e.clientX,e.clientY),this._simulateEvent("mousemove",e)},_simulateEvent:function(t,e){var i=document.createEvent("MouseEvents");i._simulated=!0,e.target._simulatedClick=!0,i.initMouseEvent(t,!0,!0,window,1,e.screenX,e.screenY,e.clientX,e.clientY,!1,!1,!1,!1,0,null),e.target.dispatchEvent(i)}}),n.Browser.touch&&!n.Browser.pointer&&n.Map.addInitHook("addHandler","tap",n.Map.Tap),n.Map.mergeOptions({boxZoom:!0}),n.Map.BoxZoom=n.Handler.extend({initialize:function(t){this._map=t,this._container=t._container,this._pane=t._panes.overlayPane},addHooks:function(){n.DomEvent.on(this._container,"mousedown",this._onMouseDown,this)},removeHooks:function(){n.DomEvent.off(this._container,"mousedown",this._onMouseDown,this)},moved:function(){return this._moved},_resetState:function(){this._moved=!1},_onMouseDown:function(t){return!(!t.shiftKey||1!==t.which&&1!==t.button)&&(this._resetState(),n.DomUtil.disableTextSelection(),n.DomUtil.disableImageDrag(),this._startPoint=this._map.mouseEventToContainerPoint(t),void n.DomEvent.on(document,{contextmenu:n.DomEvent.stop,mousemove:this._onMouseMove,mouseup:this._onMouseUp,keydown:this._onKeyDown},this))},_onMouseMove:function(t){this._moved||(this._moved=!0,this._box=n.DomUtil.create("div","leaflet-zoom-box",this._container),n.DomUtil.addClass(this._container,"leaflet-crosshair"),this._map.fire("boxzoomstart")),this._point=this._map.mouseEventToContainerPoint(t);var e=new n.Bounds(this._point,this._startPoint),i=e.getSize();n.DomUtil.setPosition(this._box,e.min),this._box.style.width=i.x+"px",this._box.style.height=i.y+"px"},_finish:function(){this._moved&&(n.DomUtil.remove(this._box),n.DomUtil.removeClass(this._container,"leaflet-crosshair")),n.DomUtil.enableTextSelection(),n.DomUtil.enableImageDrag(),n.DomEvent.off(document,{contextmenu:n.DomEvent.stop,mousemove:this._onMouseMove,mouseup:this._onMouseUp,keydown:this._onKeyDown},this)},_onMouseUp:function(t){if((1===t.which||1===t.button)&&(this._finish(),this._moved)){setTimeout(n.bind(this._resetState,this),0);var e=new n.LatLngBounds(this._map.containerPointToLatLng(this._startPoint),this._map.containerPointToLatLng(this._point));this._map.fitBounds(e).fire("boxzoomend",{boxZoomBounds:e})}},_onKeyDown:function(t){27===t.keyCode&&this._finish()}}),n.Map.addInitHook("addHandler","boxZoom",n.Map.BoxZoom),n.Map.mergeOptions({keyboard:!0,keyboardPanDelta:80}),n.Map.Keyboard=n.Handler.extend({keyCodes:{left:[37],right:[39],down:[40],up:[38],zoomIn:[187,107,61,171],zoomOut:[189,109,54,173]},initialize:function(t){this._map=t,this._setPanDelta(t.options.keyboardPanDelta),this._setZoomDelta(t.options.zoomDelta)},addHooks:function(){var t=this._map._container;t.tabIndex<=0&&(t.tabIndex="0"),n.DomEvent.on(t,{focus:this._onFocus,blur:this._onBlur,mousedown:this._onMouseDown},this),this._map.on({focus:this._addHooks,blur:this._removeHooks},this)},removeHooks:function(){this._removeHooks(),n.DomEvent.off(this._map._container,{focus:this._onFocus,blur:this._onBlur,mousedown:this._onMouseDown},this),this._map.off({focus:this._addHooks,blur:this._removeHooks},this)},_onMouseDown:function(){if(!this._focused){var t=document.body,e=document.documentElement,i=t.scrollTop||e.scrollTop,o=t.scrollLeft||e.scrollLeft;this._map._container.focus(),window.scrollTo(o,i)}},_onFocus:function(){this._focused=!0,this._map.fire("focus")},_onBlur:function(){this._focused=!1,this._map.fire("blur")},_setPanDelta:function(t){var e,i,o=this._panKeys={},n=this.keyCodes;for(e=0,i=n.left.length;e<i;e++)o[n.left[e]]=[-1*t,0];for(e=0,i=n.right.length;e<i;e++)o[n.right[e]]=[t,0];for(e=0,i=n.down.length;e<i;e++)o[n.down[e]]=[0,t];for(e=0,i=n.up.length;e<i;e++)o[n.up[e]]=[0,-1*t]},_setZoomDelta:function(t){var e,i,o=this._zoomKeys={},n=this.keyCodes;for(e=0,i=n.zoomIn.length;e<i;e++)o[n.zoomIn[e]]=t;for(e=0,i=n.zoomOut.length;e<i;e++)o[n.zoomOut[e]]=-t},_addHooks:function(){n.DomEvent.on(document,"keydown",this._onKeyDown,this)},_removeHooks:function(){n.DomEvent.off(document,"keydown",this._onKeyDown,this)},_onKeyDown:function(t){if(!(t.altKey||t.ctrlKey||t.metaKey)){var e,i=t.keyCode,o=this._map;if(i in this._panKeys){if(o._panAnim&&o._panAnim._inProgress)return;e=this._panKeys[i],t.shiftKey&&(e=n.point(e).multiplyBy(3)),o.panBy(e),o.options.maxBounds&&o.panInsideBounds(o.options.maxBounds)}else if(i in this._zoomKeys)o.setZoom(o.getZoom()+(t.shiftKey?3:1)*this._zoomKeys[i]);else{if(27!==i)return;o.closePopup()}n.DomEvent.stop(t)}}}),n.Map.addInitHook("addHandler","keyboard",n.Map.Keyboard),n.Handler.MarkerDrag=n.Handler.extend({initialize:function(t){this._marker=t},addHooks:function(){var t=this._marker._icon;this._draggable||(this._draggable=new n.Draggable(t,t,(!0))),this._draggable.on({dragstart:this._onDragStart,drag:this._onDrag,dragend:this._onDragEnd},this).enable(),n.DomUtil.addClass(t,"leaflet-marker-draggable")},removeHooks:function(){this._draggable.off({dragstart:this._onDragStart,drag:this._onDrag,dragend:this._onDragEnd},this).disable(),this._marker._icon&&n.DomUtil.removeClass(this._marker._icon,"leaflet-marker-draggable")},moved:function(){return this._draggable&&this._draggable._moved},_onDragStart:function(){this._oldLatLng=this._marker.getLatLng(),this._marker.closePopup().fire("movestart").fire("dragstart")},_onDrag:function(t){var e=this._marker,i=e._shadow,o=n.DomUtil.getPosition(e._icon),r=e._map.layerPointToLatLng(o);i&&n.DomUtil.setPosition(i,o),e._latlng=r,t.latlng=r,t.oldLatLng=this._oldLatLng,e.fire("move",t).fire("drag",t)},_onDragEnd:function(t){delete this._oldLatLng,this._marker.fire("moveend").fire("dragend",t)}}),n.Control=n.Class.extend({options:{position:"topright"},initialize:function(t){n.setOptions(this,t)},getPosition:function(){return this.options.position},setPosition:function(t){var e=this._map;return e&&e.removeControl(this),this.options.position=t,e&&e.addControl(this),this},getContainer:function(){return this._container},addTo:function(t){this.remove(),this._map=t;var e=this._container=this.onAdd(t),i=this.getPosition(),o=t._controlCorners[i];return n.DomUtil.addClass(e,"leaflet-control"),i.indexOf("bottom")!==-1?o.insertBefore(e,o.firstChild):o.appendChild(e),this},remove:function(){return this._map?(n.DomUtil.remove(this._container),this.onRemove&&this.onRemove(this._map),this._map=null,this):this},_refocusOnMap:function(t){this._map&&t&&t.screenX>0&&t.screenY>0&&this._map.getContainer().focus()}}),n.control=function(t){return new n.Control(t)},n.Map.include({addControl:function(t){return t.addTo(this),this},removeControl:function(t){return t.remove(),this},_initControlPos:function(){function t(t,r){var a=i+t+" "+i+r;e[t+r]=n.DomUtil.create("div",a,o)}var e=this._controlCorners={},i="leaflet-",o=this._controlContainer=n.DomUtil.create("div",i+"control-container",this._container);t("top","left"),t("top","right"),t("bottom","left"),t("bottom","right")},_clearControlPos:function(){n.DomUtil.remove(this._controlContainer)}}),n.Control.Zoom=n.Control.extend({options:{position:"topleft",zoomInText:"+",zoomInTitle:"Zoom in",zoomOutText:"-",zoomOutTitle:"Zoom out"},onAdd:function(t){var e="leaflet-control-zoom",i=n.DomUtil.create("div",e+" leaflet-bar"),o=this.options;return this._zoomInButton=this._createButton(o.zoomInText,o.zoomInTitle,e+"-in",i,this._zoomIn),this._zoomOutButton=this._createButton(o.zoomOutText,o.zoomOutTitle,e+"-out",i,this._zoomOut),this._updateDisabled(),t.on("zoomend zoomlevelschange",this._updateDisabled,this),i},onRemove:function(t){t.off("zoomend zoomlevelschange",this._updateDisabled,this)},disable:function(){return this._disabled=!0,this._updateDisabled(),this},enable:function(){return this._disabled=!1,this._updateDisabled(),this},_zoomIn:function(t){!this._disabled&&this._map._zoom<this._map.getMaxZoom()&&this._map.zoomIn(this._map.options.zoomDelta*(t.shiftKey?3:1))},_zoomOut:function(t){!this._disabled&&this._map._zoom>this._map.getMinZoom()&&this._map.zoomOut(this._map.options.zoomDelta*(t.shiftKey?3:1))},_createButton:function(t,e,i,o,r){var a=n.DomUtil.create("a",i,o);return a.innerHTML=t,a.href="#",a.title=e,n.DomEvent.on(a,"mousedown dblclick",n.DomEvent.stopPropagation).on(a,"click",n.DomEvent.stop).on(a,"click",r,this).on(a,"click",this._refocusOnMap,this),a},_updateDisabled:function(){var t=this._map,e="leaflet-disabled";n.DomUtil.removeClass(this._zoomInButton,e),n.DomUtil.removeClass(this._zoomOutButton,e),(this._disabled||t._zoom===t.getMinZoom())&&n.DomUtil.addClass(this._zoomOutButton,e),(this._disabled||t._zoom===t.getMaxZoom())&&n.DomUtil.addClass(this._zoomInButton,e)}}),n.Map.mergeOptions({zoomControl:!0}),n.Map.addInitHook(function(){this.options.zoomControl&&(this.zoomControl=new n.Control.Zoom,this.addControl(this.zoomControl))}),n.control.zoom=function(t){return new n.Control.Zoom(t)},n.Control.Attribution=n.Control.extend({options:{position:"bottomright",prefix:'<a href="http://leafletjs.com" title="A JS library for interactive maps">Leaflet</a>'},initialize:function(t){n.setOptions(this,t),this._attributions={}},onAdd:function(t){t.attributionControl=this,this._container=n.DomUtil.create("div","leaflet-control-attribution"),n.DomEvent&&n.DomEvent.disableClickPropagation(this._container);for(var e in t._layers)t._layers[e].getAttribution&&this.addAttribution(t._layers[e].getAttribution());return this._update(),this._container},setPrefix:function(t){return this.options.prefix=t,this._update(),this},addAttribution:function(t){return t?(this._attributions[t]||(this._attributions[t]=0),this._attributions[t]++,this._update(),this):this},removeAttribution:function(t){return t?(this._attributions[t]&&(this._attributions[t]--,this._update()),this):this},_update:function(){if(this._map){var t=[];for(var e in this._attributions)this._attributions[e]&&t.push(e);var i=[];this.options.prefix&&i.push(this.options.prefix),t.length&&i.push(t.join(", ")),
	this._container.innerHTML=i.join(" | ")}}}),n.Map.mergeOptions({attributionControl:!0}),n.Map.addInitHook(function(){this.options.attributionControl&&(new n.Control.Attribution).addTo(this)}),n.control.attribution=function(t){return new n.Control.Attribution(t)},n.Control.Scale=n.Control.extend({options:{position:"bottomleft",maxWidth:100,metric:!0,imperial:!0},onAdd:function(t){var e="leaflet-control-scale",i=n.DomUtil.create("div",e),o=this.options;return this._addScales(o,e+"-line",i),t.on(o.updateWhenIdle?"moveend":"move",this._update,this),t.whenReady(this._update,this),i},onRemove:function(t){t.off(this.options.updateWhenIdle?"moveend":"move",this._update,this)},_addScales:function(t,e,i){t.metric&&(this._mScale=n.DomUtil.create("div",e,i)),t.imperial&&(this._iScale=n.DomUtil.create("div",e,i))},_update:function(){var t=this._map,e=t.getSize().y/2,i=t.distance(t.containerPointToLatLng([0,e]),t.containerPointToLatLng([this.options.maxWidth,e]));this._updateScales(i)},_updateScales:function(t){this.options.metric&&t&&this._updateMetric(t),this.options.imperial&&t&&this._updateImperial(t)},_updateMetric:function(t){var e=this._getRoundNum(t),i=e<1e3?e+" m":e/1e3+" km";this._updateScale(this._mScale,i,e/t)},_updateImperial:function(t){var e,i,o,n=3.2808399*t;n>5280?(e=n/5280,i=this._getRoundNum(e),this._updateScale(this._iScale,i+" mi",i/e)):(o=this._getRoundNum(n),this._updateScale(this._iScale,o+" ft",o/n))},_updateScale:function(t,e,i){t.style.width=Math.round(this.options.maxWidth*i)+"px",t.innerHTML=e},_getRoundNum:function(t){var e=Math.pow(10,(Math.floor(t)+"").length-1),i=t/e;return i=i>=10?10:i>=5?5:i>=3?3:i>=2?2:1,e*i}}),n.control.scale=function(t){return new n.Control.Scale(t)},n.Control.Layers=n.Control.extend({options:{collapsed:!0,position:"topright",autoZIndex:!0,hideSingleBase:!1},initialize:function(t,e,i){n.setOptions(this,i),this._layers=[],this._lastZIndex=0,this._handlingClick=!1;for(var o in t)this._addLayer(t[o],o);for(o in e)this._addLayer(e[o],o,!0)},onAdd:function(t){return this._initLayout(),this._update(),this._map=t,t.on("zoomend",this._checkDisabledLayers,this),this._container},onRemove:function(){this._map.off("zoomend",this._checkDisabledLayers,this);for(var t=0;t<this._layers.length;t++)this._layers[t].layer.off("add remove",this._onLayerChange,this)},addBaseLayer:function(t,e){return this._addLayer(t,e),this._map?this._update():this},addOverlay:function(t,e){return this._addLayer(t,e,!0),this._map?this._update():this},removeLayer:function(t){t.off("add remove",this._onLayerChange,this);var e=this._getLayer(n.stamp(t));return e&&this._layers.splice(this._layers.indexOf(e),1),this._map?this._update():this},expand:function(){n.DomUtil.addClass(this._container,"leaflet-control-layers-expanded"),this._form.style.height=null;var t=this._map.getSize().y-(this._container.offsetTop+50);return t<this._form.clientHeight?(n.DomUtil.addClass(this._form,"leaflet-control-layers-scrollbar"),this._form.style.height=t+"px"):n.DomUtil.removeClass(this._form,"leaflet-control-layers-scrollbar"),this._checkDisabledLayers(),this},collapse:function(){return n.DomUtil.removeClass(this._container,"leaflet-control-layers-expanded"),this},_initLayout:function(){var t="leaflet-control-layers",e=this._container=n.DomUtil.create("div",t);e.setAttribute("aria-haspopup",!0),n.DomEvent.disableClickPropagation(e),n.Browser.touch||n.DomEvent.disableScrollPropagation(e);var i=this._form=n.DomUtil.create("form",t+"-list");if(this.options.collapsed){n.Browser.android||n.DomEvent.on(e,{mouseenter:this.expand,mouseleave:this.collapse},this);var o=this._layersLink=n.DomUtil.create("a",t+"-toggle",e);o.href="#",o.title="Layers",n.Browser.touch?n.DomEvent.on(o,"click",n.DomEvent.stop).on(o,"click",this.expand,this):n.DomEvent.on(o,"focus",this.expand,this),n.DomEvent.on(i,"click",function(){setTimeout(n.bind(this._onInputClick,this),0)},this),this._map.on("click",this.collapse,this)}else this.expand();this._baseLayersList=n.DomUtil.create("div",t+"-base",i),this._separator=n.DomUtil.create("div",t+"-separator",i),this._overlaysList=n.DomUtil.create("div",t+"-overlays",i),e.appendChild(i)},_getLayer:function(t){for(var e=0;e<this._layers.length;e++)if(this._layers[e]&&n.stamp(this._layers[e].layer)===t)return this._layers[e]},_addLayer:function(t,e,i){t.on("add remove",this._onLayerChange,this),this._layers.push({layer:t,name:e,overlay:i}),this.options.autoZIndex&&t.setZIndex&&(this._lastZIndex++,t.setZIndex(this._lastZIndex))},_update:function(){if(!this._container)return this;n.DomUtil.empty(this._baseLayersList),n.DomUtil.empty(this._overlaysList);var t,e,i,o,r=0;for(i=0;i<this._layers.length;i++)o=this._layers[i],this._addItem(o),e=e||o.overlay,t=t||!o.overlay,r+=o.overlay?0:1;return this.options.hideSingleBase&&(t=t&&r>1,this._baseLayersList.style.display=t?"":"none"),this._separator.style.display=e&&t?"":"none",this},_onLayerChange:function(t){this._handlingClick||this._update();var e=this._getLayer(n.stamp(t.target)),i=e.overlay?"add"===t.type?"overlayadd":"overlayremove":"add"===t.type?"baselayerchange":null;i&&this._map.fire(i,e)},_createRadioElement:function(t,e){var i='<input type="radio" class="leaflet-control-layers-selector" name="'+t+'"'+(e?' checked="checked"':"")+"/>",o=document.createElement("div");return o.innerHTML=i,o.firstChild},_addItem:function(t){var e,i=document.createElement("label"),o=this._map.hasLayer(t.layer);t.overlay?(e=document.createElement("input"),e.type="checkbox",e.className="leaflet-control-layers-selector",e.defaultChecked=o):e=this._createRadioElement("leaflet-base-layers",o),e.layerId=n.stamp(t.layer),n.DomEvent.on(e,"click",this._onInputClick,this);var r=document.createElement("span");r.innerHTML=" "+t.name;var a=document.createElement("div");i.appendChild(a),a.appendChild(e),a.appendChild(r);var s=t.overlay?this._overlaysList:this._baseLayersList;return s.appendChild(i),this._checkDisabledLayers(),i},_onInputClick:function(){var t,e,i,o=this._form.getElementsByTagName("input"),n=[],r=[];this._handlingClick=!0;for(var a=o.length-1;a>=0;a--)t=o[a],e=this._getLayer(t.layerId).layer,i=this._map.hasLayer(e),t.checked&&!i?n.push(e):!t.checked&&i&&r.push(e);for(a=0;a<r.length;a++)this._map.removeLayer(r[a]);for(a=0;a<n.length;a++)this._map.addLayer(n[a]);this._handlingClick=!1,this._refocusOnMap()},_checkDisabledLayers:function(){for(var t,e,i=this._form.getElementsByTagName("input"),o=this._map.getZoom(),n=i.length-1;n>=0;n--)t=i[n],e=this._getLayer(t.layerId).layer,t.disabled=void 0!==e.options.minZoom&&o<e.options.minZoom||void 0!==e.options.maxZoom&&o>e.options.maxZoom},_expand:function(){return this.expand()},_collapse:function(){return this.collapse()}}),n.control.layers=function(t,e,i){return new n.Control.Layers(t,e,i)},n.Map.include({_defaultLocateOptions:{timeout:1e4,watch:!1},locate:function(t){if(t=this._locateOptions=n.extend({},this._defaultLocateOptions,t),!("geolocation"in navigator))return this._handleGeolocationError({code:0,message:"Geolocation not supported."}),this;var e=n.bind(this._handleGeolocationResponse,this),i=n.bind(this._handleGeolocationError,this);return t.watch?this._locationWatchId=navigator.geolocation.watchPosition(e,i,t):navigator.geolocation.getCurrentPosition(e,i,t),this},stopLocate:function(){return navigator.geolocation&&navigator.geolocation.clearWatch&&navigator.geolocation.clearWatch(this._locationWatchId),this._locateOptions&&(this._locateOptions.setView=!1),this},_handleGeolocationError:function(t){var e=t.code,i=t.message||(1===e?"permission denied":2===e?"position unavailable":"timeout");this._locateOptions.setView&&!this._loaded&&this.fitWorld(),this.fire("locationerror",{code:e,message:"Geolocation error: "+i+"."})},_handleGeolocationResponse:function(t){var e=t.coords.latitude,i=t.coords.longitude,o=new n.LatLng(e,i),r=o.toBounds(t.coords.accuracy),a=this._locateOptions;if(a.setView){var s=this.getBoundsZoom(r);this.setView(o,a.maxZoom?Math.min(s,a.maxZoom):s)}var l={latlng:o,bounds:r,timestamp:t.timestamp};for(var u in t.coords)"number"==typeof t.coords[u]&&(l[u]=t.coords[u]);this.fire("locationfound",l)}})},{}],8:[function(t,e,i){function o(){throw new Error("setTimeout has not been defined")}function n(){throw new Error("clearTimeout has not been defined")}function r(t){if(h===setTimeout)return setTimeout(t,0);if((h===o||!h)&&setTimeout)return h=setTimeout,setTimeout(t,0);try{return h(t,0)}catch(e){try{return h.call(null,t,0)}catch(e){return h.call(this,t,0)}}}function a(t){if(d===clearTimeout)return clearTimeout(t);if((d===n||!d)&&clearTimeout)return d=clearTimeout,clearTimeout(t);try{return d(t)}catch(e){try{return d.call(null,t)}catch(e){return d.call(this,t)}}}function s(){f&&_&&(f=!1,_.length?m=_.concat(m):g=-1,m.length&&l())}function l(){if(!f){var t=r(s);f=!0;for(var e=m.length;e;){for(_=m,m=[];++g<e;)_&&_[g].run();g=-1,e=m.length}_=null,f=!1,a(t)}}function u(t,e){this.fun=t,this.array=e}function c(){}var h,d,p=e.exports={};!function(){try{h="function"==typeof setTimeout?setTimeout:o}catch(t){h=o}try{d="function"==typeof clearTimeout?clearTimeout:n}catch(t){d=n}}();var _,m=[],f=!1,g=-1;p.nextTick=function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var i=1;i<arguments.length;i++)e[i-1]=arguments[i];m.push(new u(t,e)),1!==m.length||f||r(l)},u.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=c,p.addListener=c,p.once=c,p.off=c,p.removeListener=c,p.removeAllListeners=c,p.emit=c,p.prependListener=c,p.prependOnceListener=c,p.listeners=function(t){return[]},p.binding=function(t){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(t){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},{}],9:[function(t,e,o){!function(t,e){"use strict";function o(e,i,o){e._eventHandlers=e._eventHandlers||[{element:e.scroller,handler:function(t){e.scroll(t)},type:"scroll"},{element:e.bar,handler:function(t){t.preventDefault?t.preventDefault():t.returnValue=!1,e.selection(),e.drag.now=1},type:"touchstart mousedown"},{element:document,handler:function(){e.selection(1),e.drag.now=0},type:"mouseup blur touchend"},{element:e.bar,handler:function(t){2!=t.button&&e._pos0(t)},type:"touchstart mousedown"},{element:document,handler:function(t){e.drag.now&&e.drag(t)},type:"mousemove touchmove"},{element:t,handler:function(){e.update()},type:"resize"},{element:e.root,handler:function(){e.update()},type:"sizeChange"}],d(e._eventHandlers,function(t){t.element&&i(t.element,t.type,t.handler,o)})}function n(t,e,i){var o="data-baron-"+e;if("on"==i)t.setAttribute(o,"inited");else{if("off"!=i)return t.getAttribute(o);t.removeAttribute(o)}}function r(t){if(!n(t.root,t.direction)){var e=new _.prototype.constructor(t);return o(e,t.event,"on"),n(e.root,t.direction,"on"),e.update(),e}}function a(t){var e={};t=t||{};for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i]);return e}function s(t){var e=a(t);e.direction=e.direction||"v";var i=t.event||function(t,i,o,n){e.$(t)[n||"on"](i,o)};return e.event=function(t,e,o,n){d(t,function(t){i(t,e,o,n)})},e}function l(t){if(this.events&&this.events[t])for(var e=0;e<this.events[t].length;e++){var i=Array.prototype.slice.call(arguments,1);this.events[t][e].apply(this,i)}}if(t){var u=t.baron,c=t.jQuery,h={v:{x:"Y",pos:"top",crossPos:"left",size:"height",crossSize:"width",client:"clientHeight",crossClient:"clientWidth",offset:"offsetHeight",crossOffset:"offsetWidth",offsetPos:"offsetTop",scroll:"scrollTop",scrollSize:"scrollHeight"},h:{x:"X",pos:"left",crossPos:"top",size:"width",crossSize:"height",client:"clientWidth",crossClient:"clientHeight",offset:"offsetWidth",crossOffset:"offsetHeight",offsetPos:"offsetLeft",scroll:"scrollLeft",scrollSize:"scrollWidth"}},d=function(i,o){var n=0;for(i.length!==e&&i!==t||(i=[i]);i[n];)o.call(this,i[n],n),n++},p=function(e){var i,o,n=!1;return e=e||{},o=e.$||t.jQuery,n?e.root=i=this:i=o(e.root||e.scroller),new p.fn.constructor(i,e,o)};p.fn={constructor:function(t,e,i){var o=s(e);o.$=i,d.call(this,t,function(t,e){var i=a(o);o.root&&o.scroller?(i.scroller=o.$(o.scroller,t),i.scroller.length||(i.scroller=t)):i.scroller=t,i.root=t,this[e]=r(i),this.length=e+1}),this.params=o},dispose:function(){var t=this.params;d(this,function(e){e.dispose(t)}),this.params=null},update:function(){for(var t=0;this[t];)this[t].update.apply(this[t],arguments),t++},baron:function(t){return t.root=[],t.scroller=this.params.scroller,d.call(this,this,function(e){t.root.push(e.root)}),t.direction="v"==this.params.direction?"h":"v",t._chain=!0,p(t)}};var _={};_.prototype={constructor:function(t){function i(t,e){return c(t,e)[0]}function o(t){var e=this.barMinSize||20;t>0&&t<e&&(t=e),this.bar&&c(this.bar).css(this.origin.size,parseInt(t,10)+"px")}function n(t){this.bar&&c(this.bar).css(this.origin.pos,+t+"px")}function r(){return _[this.origin.client]-this.barTopLimit-this.bar[this.origin.offset]}function a(t){return t*r.call(this)+this.barTopLimit}function s(t){return(t-this.barTopLimit)/r.call(this)}function u(){return!1}var c,d,p,_,m,f,g,v,y;return y=v=(new Date).getTime(),c=this.$=t.$,this.event=t.event,this.events={},this.root=t.root,this.scroller=i(t.scroller),this.bar=i(t.bar,this.root),_=this.track=i(t.track,this.root),!this.track&&this.bar&&(_=this.bar.parentNode),this.clipper=this.scroller.parentNode,this.direction=t.direction,this.origin=h[this.direction],this.barOnCls=t.barOnCls,this.barTopLimit=0,g=1e3*t.pause||0,this.cursor=function(t){return t["client"+this.origin.x]||(((t.originalEvent||t).touches||{})[0]||{})["page"+this.origin.x]},this.pos=function(t){var i="page"+this.origin.x+"Offset",o=this.scroller[i]?i:this.origin.scroll;return t!==e&&(this.scroller[o]=t),this.scroller[o]},this.rpos=function(t){var e,i=this.scroller[this.origin.scrollSize]-this.scroller[this.origin.client];return e=t?this.pos(t*i):this.pos(),e/(i||1)},this.barOn=function(t){this.barOnCls&&(t||this.scroller[this.origin.client]>=this.scroller[this.origin.scrollSize]?c(this.root).removeClass(this.barOnCls):c(this.root).addClass(this.barOnCls))},this._pos0=function(t){p=this.cursor(t)-d},this.drag=function(t){this.scroller[this.origin.scroll]=s.call(this,this.cursor(t)-p)*(this.scroller[this.origin.scrollSize]-this.scroller[this.origin.client])},this.selection=function(t){this.event(document,"selectpos selectstart",u,t?"off":"on")},this.resize=function(){function e(){var e=i.scroller[i.origin.crossOffset]-i.scroller[i.origin.crossClient];t.freeze&&!i.clipper.style[i.origin.crossSize]&&c(i.clipper).css(i.origin.crossSize,i.clipper[i.origin.crossClient]-e+"px"),c(i.scroller).css(i.origin.crossSize,i.clipper[i.origin.crossClient]+e+"px"),Array.prototype.unshift.call(arguments,"resize"),l.apply(i,arguments),y=(new Date).getTime()}var i=this,o=0;(new Date).getTime()-y<g&&(clearTimeout(m),o=g),o?m=setTimeout(e,o):e()},this.scroll=function(){function t(){s.bar&&(i=(_[s.origin.client]-s.barTopLimit)*s.scroller[s.origin.client]/s.scroller[s.origin.scrollSize],e!=i&&(o.call(s,i),e=i),d=a.call(s,s.rpos()),n.call(s,d)),Array.prototype.unshift.call(arguments,"scroll"),l.apply(s,arguments),v=(new Date).getTime()}var e,i,r=0,s=this;(new Date).getTime()-v<g&&(clearTimeout(f),r=g),r?f=setTimeout(t,r):t()},this},update:function(t){return l.call(this,"upd",t),this.resize(1),this.barOn(),this.scroll(),this},dispose:function(t){o(this,this.event,"off"),n(this.root,t.direction,"off"),c(this.scroller).css(this.origin.crossSize,""),this.barOn(!0),l.call(this,"dispose")},on:function(t,e,i){for(var o=t.split(" "),n=0;n<o.length;n++)"init"==o[n]?e.call(this,i):(this.events[o[n]]=this.events[o[n]]||[],this.events[o[n]].push(function(t){e.call(this,t||i)}))}},p.fn.constructor.prototype=p.fn,_.prototype.constructor.prototype=_.prototype,p.noConflict=function(){return t.baron=u,p},p.version="0.6.6",c&&c.fn&&(c.fn.baron=p),t.baron=p;var m=function(t){function o(t,i){s<(l.minView||0)&&(i=e),i!==e?(i+="px",this.$(a[t]).css(this.origin.pos,i).addClass(l.outside)):this.$(a[t]).css(this.origin.pos,"").removeClass(l.outside)}function n(t){try{i=document.createEvent("WheelEvent"),i.initWebKitWheelEvent(t.originalEvent.wheelDeltaX,t.originalEvent.wheelDeltaY),d.dispatchEvent(i),t.preventDefault()}catch(t){}}function r(t){var e;for(var i in t)l[i]=t[i];if(a=this.$(l.elements,this.scroller)){s=this.scroller[this.origin.client];for(var o=0;o<a.length;o++)e={},e[this.origin.size]=a[o][this.origin.offset],a[o].parentNode!==this.scroller&&this.$(a[o].parentNode).css(e),e={},e[this.origin.crossSize]=a[o].parentNode[this.origin.crossClient],this.$(a[o]).css(e),s-=a[o][this.origin.offset],h[o]=a[o].parentNode[this.origin.offsetPos],u[o]=u[o-1]||0,c[o]=c[o-1]||Math.min(h[o],0),a[o-1]&&(u[o]+=a[o-1][this.origin.offset],c[o]+=a[o-1][this.origin.offset]),0==o&&0==h[o]||(this.event(a[o],"mousewheel",n,"off"),this.event(a[o],"mousewheel",n));l.limiter&&a[0]&&(this.track&&this.track!=this.scroller?(e={},e[this.origin.pos]=a[0].parentNode[this.origin.offset],this.$(this.track).css(e)):this.barTopLimit=a[0].parentNode[this.origin.offset],this.scroll()),l.limiter===!1&&(this.barTopLimit=0)}var r={element:a,handler:function(){for(var t,e=_(this)[0].parentNode,i=e.offsetTop,o=0;o<a.length;o++)a[o]===this&&(t=o);var n=i-u[t];l.scroll?l.scroll({x1:m.scroller.scrollTop,x2:n}):m.scroller.scrollTop=n},type:"click"};l.clickable&&(this._eventHandlers.push(r),p(r.element,r.type,r.handler,"off"),p(r.element,r.type,r.handler,"on"))}var a,s,l={outside:"",before:"",after:"",past:"",future:"",radius:0,minView:0},u=[],c=[],h=[],d=this.scroller,p=this.event,_=this.$,m=this;this.on("init",r,t),this.on("init scroll",function(){var t,i,n=[];if(a){for(var r,d=0;d<a.length;d++)t=0,h[d]-this.pos()<c[d]+l.radius?(t=1,i=u[d]):h[d]-this.pos()>c[d]+s-l.radius?(t=2,i=u[d]+s):(t=3,i=e),t!=n[d]&&(o.call(this,d,i),n[d]=t,r=!0);if(r)for(d=0;d<a.length;d++)1==n[d]&&l.past&&this.$(a[d]).addClass(l.past).removeClass(l.future),2==n[d]&&l.future&&this.$(a[d]).addClass(l.future).removeClass(l.past),3==n[d]&&(l.future||l.past)&&this.$(a[d]).removeClass(l.past).removeClass(l.future),n[d]!=n[d+1]&&1==n[d]&&l.before?this.$(a[d]).addClass(l.before).removeClass(l.after):n[d]!=n[d-1]&&2==n[d]&&l.after?this.$(a[d]).addClass(l.after).removeClass(l.before):this.$(a[d]).removeClass(l.before).removeClass(l.after)}}),this.on("resize upd",function(t){r.call(this,t&&t.fix)})};p.fn.fix=function(t){for(var e=0;this[e];)m.call(this[e],t),e++;return this};var f=function(t){var e,i,o,n,r=this;n=t.screen||.9,t.forward&&(e=this.$(t.forward,this.clipper),this.event(e,"click",function(){var e=r.pos()-t.delta||30;r.pos(e)})),t.backward&&(i=this.$(t.backward,this.clipper),this.event(i,"click",function(){var e=r.pos()+t.delta||30;r.pos(e)})),t.track&&(o=t.track===!0?this.track:this.$(t.track,this.clipper)[0],o&&this.event(o,"mousedown",function(t){var e=t["offset"+r.origin.x],i=r.bar[r.origin.offsetPos],o=0;e<i?o=-1:e>i+r.bar[r.origin.offset]&&(o=1);var a=r.pos()+o*n*r.scroller[r.origin.client];r.pos(a)}))};p.fn.controls=function(t){for(var e=0;this[e];)f.call(this[e],t),e++;return this};var g=function(t){function e(){return g.scroller[g.origin.scroll]+g.scroller[g.origin.offset]}function i(){return g.scroller[g.origin.scrollSize]}function o(){return g.scroller[g.origin.client]}function n(t,e){var i=5e-4*t;return Math.floor(e-i*(t+550))}function r(t){c=t,t?(a(),s=setInterval(a,200)):clearInterval(s)}function a(){var a,s,c={},w=e(),k=i(),x=1==v;if(s=0,v>0&&(s=40),a=n(b,s),w>=k-b&&v>-1?x&&(b+=a):b=0,b<0&&(b=0),c[d]=b+"px",o()<=i()){g.$(h).css(c);for(var D=0;D<m.length;D++)g.$(m[D].self).css(m[D].property,Math.min(b/p*100,100)+"%")}f&&b&&g.$(g.root).addClass(f),0==b&&t.onCollapse&&t.onCollapse(),v=0,l=setTimeout(function(){v=-1},C),_&&b>p&&!u&&(_(),u=!0),0==b?y++:y=0,y>1&&(r(!1),u=!1,f&&g.$(g.root).removeClass(f))}var s,l,u,c,h=this.$(t.block),d=t.size||this.origin.size,p=t.limit||80,_=t.onExpand,m=t.elements||[],f=t.inProgress||"",g=this,v=0,y=0,b=0,C=t.waiting||500;this.on("init",function(){r(!0)}),this.on("dispose",function(){r(!1)}),this.event(this.scroller,"mousewheel DOMMouseScroll",function(t){var o=t.wheelDelta<0||t.originalEvent&&t.originalEvent.wheelDelta<0||t.detail>0;o&&(v=1,clearTimeout(l),!c&&e()>=i()&&r(!0))})};p.fn.pull=function(t){for(var e=0;this[e];)g.call(this[e],t),e++;return this}}}(window)},{}]},{},[2])(2)});
	//# sourceMappingURL=script.full.js.map


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(3);
	
	var _require = __webpack_require__(72),
	    thenWithErrorHandling = _require.thenWithErrorHandling;
	
	module.exports = {
	    uploadDocument: function uploadDocument(_ref, state, output, _ref2) {
	        var file = _ref.file,
	            documentTypeId = _ref.documentTypeId;
	        var locator = _ref2.locator,
	            context = _ref2.context;
	
	        var API = locator.resolve('api');
	        var orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
	        var formData = new FormData();
	
	        formData.append('DocumentType' + documentTypeId + 'File', file);
	
	        var request = API.uploadFile(context, locator, { orderId: orderId, documentTypeId: documentTypeId, formData: formData });
	
	        request.then(function (data) {
	            var errors = _.get(data, 'errors');
	
	            if (errors > 0) {
	                output.error({ error: errors });
	                return;
	            }
	
	            output.success({ uploadedDocuments: _.get(data, 'uploadedDocuments') });
	        }).fail(function (xhr, status, error) {
	            output.errorTooBigFile(error);
	        });
	    },
	    uploadResultDocument: function uploadResultDocument(_ref3, state, output, _ref4) {
	        var file = _ref3.file;
	        var locator = _ref4.locator,
	            context = _ref4.context;
	
	        var API = locator.resolve('api');
	        var orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
	        var formData = new FormData();
	
	        formData.append('DocumentResultFile', file);
	
	        var request = API.uploadResultFile(context, locator, { orderId: orderId, formData: formData });
	
	        request.then(function (data) {
	            var errors = _.get(data, 'errors');
	
	            if (errors > 0) {
	                output.error({ error: errors });
	                return;
	            }
	
	            output.success({ uploadedDocuments: _.get(data, 'uploadedDocuments') });
	        }).fail(function (xhr, status, error) {
	            output.errorTooBigFile(error);
	        });
	    },
	    applyLocalChangesUploadDocs: function applyLocalChangesUploadDocs(args, state, output, _ref5) {
	        var locator = _ref5.locator,
	            context = _ref5.context;
	
	        var API = locator.resolve('api');
	        var orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
	        var documents = state.get(['account', 'orders', 'currentOrder', 'localChanges', 'necessaryDocuments', 'upload']);
	
	        var requests = [];
	        _.forEach(documents, function (doc) {
	            var formData = new FormData();
	            formData.append('DocumentType' + doc.documentTypeId + 'File', doc.file, doc.name);
	            var request = API.uploadFile(context, locator, { orderId: orderId, documentTypeId: doc.documentTypeId, formData: formData }).fail(function (xhr, status, error) {
	                output.errorTooBigFile(error);
	                return;
	            });
	            requests.push(request);
	        });
	
	        Promise.all(requests).then(function (values) {
	            var errors = _.map(values, function (x) {
	                return x.errors;
	            });
	            if (_.some(errors, function (x) {
	                return x > 0;
	            })) {
	                output.error();
	                return;
	            }
	            output.success({ uploadedDocuments: _.map(values, function (x) {
	                    return x.uploadedDocuments[0];
	                }) });
	        }).catch(function (error) {
	            return output.error({ error: error });
	        });
	    },
	    updateDocumentsInState: function updateDocumentsInState(_ref6, state) {
	        var uploadedDocuments = _ref6.uploadedDocuments;
	
	        var documents = state.get(['account', 'orders', 'currentOrder', 'necessaryDocuments']);
	        _.forEach(uploadedDocuments, function (uploaded) {
	            var documentIndex = _.findIndex(documents, { typeId: uploaded.typeId });
	            state.set(['account', 'orders', 'currentOrder', 'necessaryDocuments', documentIndex, 'id'], uploaded.id);
	            state.set(['account', 'orders', 'currentOrder', 'necessaryDocuments', documentIndex, 'name'], uploaded.name);
	        });
	    },
	    uploadDocumentLocal: function uploadDocumentLocal(_ref7, state) {
	        var documentTypeId = _ref7.documentTypeId,
	            file = _ref7.file;
	
	        var documents = state.get(['account', 'orders', 'currentOrder', 'necessaryDocuments']);
	        var newId = '1';
	
	        if (documents) {
	            var existingDocs = _.filter(documents, 'id');
	
	            if (existingDocs.length > 0) {
	                newId = _.max(_.map(existingDocs, function (x) {
	                    return x.id;
	                })) + 1;
	            }
	        }
	
	        var docs = state.get(['account', 'orders', 'currentOrder', 'localChanges', 'necessaryDocuments', 'upload']);
	
	        if (!docs) {
	            docs = [];
	        }
	
	        docs = _.concat(docs, { documentTypeId: documentTypeId, id: newId, name: file.name, file: file.slice(0, file.size, file.type) });
	        state.set(['account', 'orders', 'currentOrder', 'localChanges', 'necessaryDocuments', 'upload'], docs);
	
	        var documentIndex = _.findIndex(documents, { typeId: documentTypeId });
	        state.set(['account', 'orders', 'currentOrder', 'necessaryDocuments', documentIndex, 'id'], newId);
	        state.set(['account', 'orders', 'currentOrder', 'necessaryDocuments', documentIndex, 'name'], file.name);
	    },
	    addDocumentType: function addDocumentType(_ref8, state, output, _ref9) {
	        var path = _ref8.path,
	            value = _ref8.value;
	        var locator = _ref9.locator,
	            context = _ref9.context;
	
	        var orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
	        var documentTypeId = state.get(['account', 'orders', 'currentOrder', 'necessaryDocuments', Number(path), 'typeId']);
	        var API = locator.resolve('api');
	        var request = API.addDocumentType(context, locator, { orderId: orderId, documentTypeId: documentTypeId });
	
	        thenWithErrorHandling(request, function () {
	            return { documentTypeId: documentTypeId, isChecked: value };
	        }, output);
	    },
	    addDocumentTypeLocal: function addDocumentTypeLocal(_ref10, state, output, _ref11) {
	        var path = _ref10.path,
	            value = _ref10.value;
	        var locator = _ref11.locator,
	            context = _ref11.context;
	
	        var documentTypeId = state.get(['account', 'orders', 'currentOrder', 'necessaryDocuments', Number(path), 'typeId']);
	
	        var docs = state.get(['account', 'orders', 'currentOrder', 'localChanges', 'necessaryDocuments', 'addOrRemove']);
	        if (!docs) {
	            docs = [];
	        }
	        var indexLocal = _.findIndex(docs, { documentTypeId: documentTypeId });
	        if (indexLocal > -1) {
	            state.set(['account', 'orders', 'currentOrder', 'localChanges', 'necessaryDocuments', 'addOrRemove', indexLocal, 'value'], value);
	        } else {
	            docs = _.concat(docs, { documentTypeId: documentTypeId, value: value });
	            state.set(['account', 'orders', 'currentOrder', 'localChanges', 'necessaryDocuments', 'addOrRemove'], docs);
	        }
	
	        var index = _.findIndex(state.get(['account', 'orders', 'currentOrder', 'necessaryDocuments']), { 'typeId': documentTypeId });
	        state.set(['account', 'orders', 'currentOrder', 'necessaryDocuments', index, 'isChecked'], value);
	    },
	    applyLocalChangesAddOrRemoveDocTypes: function applyLocalChangesAddOrRemoveDocTypes(args, state, output, _ref12) {
	        var locator = _ref12.locator,
	            context = _ref12.context;
	
	        var orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
	        var documents = state.get(['account', 'orders', 'currentOrder', 'localChanges', 'necessaryDocuments', 'addOrRemove']);
	
	        var requests = [];
	        var API = locator.resolve('api');
	        _.forEach(documents, function (doc) {
	            if (doc.value === true) {
	                requests.push(API.addDocumentType(context, locator, { orderId: orderId, documentTypeId: doc.documentTypeId }));
	            } else {
	                requests.push(API.removeDocumentType(context, locator, { orderId: orderId, documentTypeId: doc.documentTypeId }));
	            }
	        });
	        Promise.all(requests).then(function (values) {
	            var statuses = _.map(values, function (x) {
	                return x.status.code;
	            });
	            if (_.some(statuses, function (x) {
	                return x !== 200;
	            })) {
	                output.error({ error: statuses });
	                return;
	            }
	            output.success();
	        }).catch(function (error) {
	            return output.error({ error: error });
	        });
	    },
	    removeDocumentType: function removeDocumentType(_ref13, state, output, _ref14) {
	        var path = _ref13.path,
	            value = _ref13.value;
	        var locator = _ref14.locator,
	            context = _ref14.context;
	
	        var orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
	        var documentTypeId = state.get(['account', 'orders', 'currentOrder', 'necessaryDocuments', Number(path), 'typeId']);
	        var API = locator.resolve('api');
	        var request = API.removeDocumentType(context, locator, { orderId: orderId, documentTypeId: documentTypeId });
	
	        thenWithErrorHandling(request, function () {
	            return { documentTypeId: documentTypeId, isChecked: false };
	        }, output);
	    },
	    isCheckboxChecked: function isCheckboxChecked(_ref15, state, output) {
	        var value = _ref15.value;
	
	        if (value === true) {
	            output.yes();
	        } else if (value === false) {
	            output.no();
	        }
	    },
	    deleteDocument: function deleteDocument(_ref16, state, output, _ref17) {
	        var documentId = _ref16.documentId;
	        var locator = _ref17.locator,
	            context = _ref17.context;
	
	        var API = locator.resolve('api');
	        var request = API.deleteDocument(context, locator, { documentId: documentId });
	
	        thenWithErrorHandling(request, function () {
	            return { documentId: documentId };
	        }, output);
	    },
	    applyLocalChangesDeleteDocs: function applyLocalChangesDeleteDocs(args, state, output, _ref18) {
	        var locator = _ref18.locator,
	            context = _ref18.context;
	
	        var API = locator.resolve('api');
	        var orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
	        var documents = state.get(['account', 'orders', 'currentOrder', 'localChanges', 'necessaryDocuments', 'delete']);
	
	        var requests = [];
	        _.forEach(documents, function (documentId) {
	            requests.push(API.deleteDocument(context, locator, { documentId: documentId }));
	        });
	
	        Promise.all(requests).then(function (values) {
	            var statuses = _.map(values, function (x) {
	                return x.status.code;
	            });
	            if (_.some(statuses, function (x) {
	                return x !== 200;
	            })) {
	                output.error({ error: statuses });
	                return;
	            }
	            output.success();
	        }).catch(function (error) {
	            return output.error({ error: error });
	        });
	    },
	    deleteDocumentLocal: function deleteDocumentLocal(_ref19, state) {
	        var documentId = _ref19.documentId;
	
	        var documents = state.get(['account', 'orders', 'currentOrder', 'necessaryDocuments']);
	        var documentIndex = _.findIndex(documents, { id: documentId });
	        state.unset(['account', 'orders', 'currentOrder', 'necessaryDocuments', documentIndex, 'id']);
	        state.unset(['account', 'orders', 'currentOrder', 'necessaryDocuments', documentIndex, 'name']);
	
	        var localUpload = state.get(['account', 'orders', 'currentOrder', 'localChanges', 'necessaryDocuments', 'upload']);
	        var localUploadIndex = _.findIndex(localUpload, { id: documentId });
	
	        if (localUploadIndex > -1) {
	            state.unset(['account', 'orders', 'currentOrder', 'localChanges', 'necessaryDocuments', 'upload', localUploadIndex]);
	        } else {
	            var docs = state.get(['account', 'orders', 'currentOrder', 'localChanges', 'necessaryDocuments', 'delete']);
	            if (!docs) {
	                docs = [];
	            }
	            docs = _.concat(docs, documentId);
	            state.set(['account', 'orders', 'currentOrder', 'localChanges', 'necessaryDocuments', 'delete'], docs);
	        }
	    },
	    deleteDocumentFromState: function deleteDocumentFromState(_ref20, state) {
	        var documentId = _ref20.documentId;
	
	        var documents = state.get(['account', 'orders', 'currentOrder', 'necessaryDocuments']);
	        var documentIndex = _.findIndex(documents, { id: documentId });
	        state.set(['account', 'orders', 'currentOrder', 'necessaryDocuments', documentIndex, 'id'], null);
	        state.set(['account', 'orders', 'currentOrder', 'necessaryDocuments', documentIndex, 'name'], null);
	    }
	};

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var computed = __webpack_require__(298);
	
	module.exports = {
	    setComputedFields: function setComputedFields(args, state) {
	        computed.formatUsersList(state);
	        computed.filterUsersList(state);
	    },
	    isUserSelected: function isUserSelected(_ref, state, output) {
	        var userId = _ref.userId;
	
	        if (userId) {
	            output.yes({ userId: userId });
	            return;
	        }
	
	        output.no();
	    }
	};

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(3);
	
	module.exports = {
	    getUser: function getUser(_ref, state, output, _ref2) {
	        var userId = _ref.userId;
	        var locator = _ref2.locator,
	            context = _ref2.context;
	
	        var API = locator.resolve('api');
	
	        var request = API.getUserById(context, locator, { userId: userId });
	
	        request.then(function (data) {
	            var code = _.get(data, 'status.code');
	
	            if (code === 200) {
	                var user = _.get(data, 'content');
	                output.success({ user: user });
	                return;
	            }
	
	            output.error({ error: code });
	        }).catch(function (error) {
	            return output.error({ error: error });
	        });
	    }
	};

/***/ }),
/* 291 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	    unauthorized: [{
	        name: 'orders',
	        id: 'orders'
	    }],
	    manager: [{
	        name: 'orders',
	        id: 'orders'
	    }, {
	        name: 'users',
	        id: 'users'
	    }, {
	        name: 'statistic',
	        id: 'statistic'
	    }],
	    client: [{
	        name: 'orders',
	        id: 'orders'
	    }, {
	        name: 'personal',
	        id: 'personal'
	    }]
	};

/***/ }),
/* 292 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	    login: [{
	        name: 'login',
	        id: 'login'
	    }],
	    registration: [{
	        name: 'registration',
	        id: 'registration'
	    }],
	    registrationExtra: [{
	        name: 'registration-extra',
	        id: 'registration-extra'
	    }],
	    restore: [{
	        name: 'restore',
	        id: 'restore'
	    }],
	    restoreChange: [{
	        name: 'restore-change',
	        id: 'restore-change'
	    }],
	    alert: [{
	        name: 'alert',
	        id: 'alert'
	    }]
	};

/***/ }),
/* 293 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	    unauthorized: {
	        order: [{
	            name: 'order',
	            id: 'order'
	        }],
	        bitrixMain: [{
	            name: 'bitrix-main',
	            id: 'bitrix-main'
	        }],
	        contacts: [{
	            name: 'contacts',
	            id: 'contacts'
	        }],
	        help: [{
	            name: 'help',
	            id: 'help'
	        }],
	        terms: [{
	            name: 'terms',
	            id: 'terms'
	        }],
	        account: [{
	            name: 'account',
	            id: 'account'
	        }],
	        video: [{
	            name: 'video',
	            id: 'video'
	        }]
	    },
	    client: {
	        order: [{
	            name: 'order',
	            id: 'order'
	        }],
	        bitrixMain: [{
	            name: 'bitrix-main',
	            id: 'bitrix-main'
	        }],
	        personal: [{
	            name: 'personal',
	            id: 'personal'
	        }],
	        account: [{
	            name: 'account',
	            id: 'account'
	        }],
	        contacts: [{
	            name: 'contacts',
	            id: 'contacts'
	        }],
	        help: [{
	            name: 'help',
	            id: 'help'
	        }],
	        terms: [{
	            name: 'terms',
	            id: 'terms'
	        }],
	        video: [{
	            name: 'video',
	            id: 'video'
	        }]
	    },
	    manager: {
	        order: [{
	            name: 'order',
	            id: 'order'
	        }],
	        bitrixMain: [{
	            name: 'bitrix-main',
	            id: 'bitrix-main'
	        }],
	        manager: [{
	            name: 'account',
	            id: 'account'
	        }],
	        contacts: [{
	            name: 'contacts',
	            id: 'contacts'
	        }],
	        help: [{
	            name: 'help',
	            id: 'help'
	        }],
	        terms: [{
	            name: 'terms',
	            id: 'terms'
	        }],
	        video: [{
	            name: 'video',
	            id: 'video'
	        }],
	        statistic: [{
	            name: 'statistic',
	            id: 'statistic'
	        }]
	    }
	};

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(3);
	
	var _require = __webpack_require__(15),
	    monkey = _require.monkey;
	
	var COMPONENTS = __webpack_require__(291);
	
	module.exports = {
	    subnavigationElements: function subnavigationElements(state) {
	        var TABS = [{
	            title: 'Заказы',
	            href: '/manager/orders',
	            subPage: 'orders'
	        }, {
	            title: 'Пользователи',
	            href: '/manager/users',
	            subPage: 'users'
	        }];
	
	        state.set(['subnavigation', 'elements'], monkey([['page', 'sub'], function (subPage) {
	            return _.map(TABS, function (tab) {
	                return Object.assign({
	                    isSelected: tab.subPage === subPage,
	                    isClickable: tab.subPage !== subPage
	                }, tab);
	            });
	        }]));
	    },
	    contentComponents: function contentComponents(state) {
	        state.set(['account', 'components'], monkey([['page', 'sub'], ['user', 'role'], function (subPage, role) {
	            return [_.find(COMPONENTS[role], { name: subPage })];
	        }]));
	    }
	};

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(3);
	var computed = __webpack_require__(15).monkey;
	var SCHEME = __webpack_require__(22);
	
	module.exports = {
	    computeChangePasswordButtonState: function computeChangePasswordButtonState(state) {
	        state.set(['account', 'passwordChangeForm', 'computed', 'isEnabled'], computed(['account', 'passwordChangeForm', 'error'], ['account', 'passwordChangeForm', 'computed', 'error', 'repeatPasswordNew'], ['account', 'passwordChangeForm'], function (error, repeatPassword, form) {
	            var requiredFields = ['password', 'passwordNew', 'repeatPasswordNew'];
	            var requiredKeys = _.keys(_.omitBy(form, function (key) {
	                return !key;
	            }));
	            var differenceLength = _.difference(requiredFields, requiredKeys).length;
	
	            return _.every([_.isEmpty(error), !repeatPassword, !differenceLength]);
	        }));
	    },
	    setRepeatPasswordError: function setRepeatPasswordError(state) {
	        state.set(['account', 'passwordChangeForm', 'computed', 'error', 'repeatPasswordNew'], computed(['account', 'passwordChangeForm', 'error', 'repeatPasswordNew'], ['account', 'passwordChangeForm', 'repeatPasswordNew'], ['account', 'passwordChangeForm', 'passwordNew'], function (errorRepeatPassword, repeatPassword, password) {
	            if (!repeatPassword) {
	                return;
	            }
	
	            if (errorRepeatPassword) {
	                return errorRepeatPassword;
	            }
	
	            if (repeatPassword !== password) {
	                return _.get(SCHEME.repeatPassword, 'properties.value.messages.repeat');
	            }
	        }));
	    }
	};

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(3);
	
	var _require = __webpack_require__(15),
	    monkey = _require.monkey;
	
	var _require2 = __webpack_require__(58),
	    Query = _require2.Query;
	
	module.exports = {
	    queryObject: function queryObject(state) {
	        state.set(['account', 'statistic', 'computed', 'query'], monkey(['account', 'statistic', 'isByBranch'], ['account', 'statistic', 'isTransposed'], function (isByBranch, isTransposed) {
	            var query = new Query();
	            query.values = _.omitBy({ isByBranch: isByBranch, isTransposed: isTransposed }, _.isUndefined);
	            return query.toString();
	        }));
	    }
	};

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(3);
	
	var _require = __webpack_require__(15),
	    monkey = _require.monkey;
	
	module.exports = {
	    isUserTypeSelectEnabled: function isUserTypeSelectEnabled(state) {
	        state.set(['account', 'userForm', 'computed', 'isUserTypeSelectEnabled'], monkey(['account', 'userForm', 'form', 'countryId'], function (countryId) {
	            return countryId === 1 || countryId === 4;
	        }));
	    },
	    saveButton: function saveButton(state) {
	        state.set(['account', 'userForm', 'computed', 'saveButton', 'isEnabled'], monkey(['account', 'userForm', 'error'], ['account', 'userForm', 'form'], ['account', 'userForm', 'computed', 'cancelButton', 'isEnabled'], function (error, form) {
	            var hasChanges = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	            var requiredFields = ['firstName', 'lastName', 'email', 'countryId', 'legalAddress'];
	            if (form && form.userType === 2) {
	                requiredFields = _.concat(requiredFields, ['organization']);
	                switch (form.countryId) {
	                    case 1:
	                        requiredFields = _.concat(requiredFields, ['inn10', 'kpp']);
	                        break;
	                    case 4:
	                        requiredFields = _.concat(requiredFields, ['bin']);
	                        break;
	                    default:
	                        break;
	                }
	            } else if (form && form.userType === 3) {
	                requiredFields = _.concat(requiredFields, ['organization']);
	                switch (form.countryId) {
	                    case 1:
	                        requiredFields = _.concat(requiredFields, ['inn12']);
	                        break;
	                    case 4:
	                        requiredFields = _.concat(requiredFields, ['bin']);
	                        break;
	                    default:
	                        break;
	                }
	            }
	            var requiredKeys = _.keys(_.omitBy(form, function (key) {
	                return !key;
	            }));
	            var differenceLength = _.difference(requiredFields, requiredKeys).length;
	            var requiredError = _.filter(_.keys(error), function (err) {
	                return requiredFields.includes(err);
	            });
	            return _.every([_.isEmpty(requiredError), !differenceLength]) && hasChanges;
	        }));
	    },
	    cancelButton: function cancelButton(state) {
	        state.set(['account', 'userForm', 'computed', 'cancelButton', 'isEnabled'], monkey(['account', 'userForm', 'original'], ['account', 'userForm', 'form'], function (original, form) {
	            var formClone = _.cloneDeep(form);
	            if (form) {
	                if (formClone.userType === 1) {
	                    formClone.inn = formClone.inn12;
	                    delete formClone.inn12;
	                    delete formClone.bin;
	                } else if (formClone.userType === 2) {
	                    formClone.inn = formClone.inn10 || formClone.bin;
	                    delete formClone.inn10;
	                    delete formClone.bin;
	                } else if (formClone.userType === 3) {
	                    formClone.inn = formClone.inn12 || formClone.bin;
	                    delete formClone.inn12;
	                    delete formClone.bin;
	                }
	                if (!formClone.inn) {
	                    formClone.inn = null;
	                }
	            }
	            return !_.isEqual(original, formClone);
	        }));
	    }
	};

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(3);
	
	var _require = __webpack_require__(15),
	    monkey = _require.monkey;
	
	var formatter = __webpack_require__(157);
	
	module.exports = {
	    formatUsersList: function formatUsersList(state) {
	        state.set(['account', 'users', 'computed', 'usersList'], monkey(['account', 'users', 'list', 'data'], ['account', 'userForm', 'original', 'id'], function () {
	            var usersList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	            var selectedUserId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	            return _.map(usersList, function (item) {
	                return {
	                    id: item.id,
	                    fullName: formatter.shortName(item) + ' (' + item.email + ')',
	                    isSelected: item.id === selectedUserId
	                };
	            });
	        }));
	    },
	    filterUsersList: function filterUsersList(state) {
	        state.set(['account', 'users', 'computed', 'usersListFiltered'], monkey(['account', 'users', 'computed', 'usersList'], ['account', 'users', 'list', 'filter'], function () {
	            var usersList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	            var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	            return _.filter(usersList, function (item) {
	                return isMatch(item.fullName, filter);
	            });
	        }));
	    }
	};
	
	function isMatch(value, filter) {
	    if (filter) {
	        return value.toLowerCase().indexOf(filter.toLowerCase()) !== -1;
	    }
	    return true;
	}

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var computed = __webpack_require__(15).monkey;
	
	var ERRORS_MAP = {
	    accessDenied: 'Email или пароль указаны неверно',
	    invalidValidation: 'Заполните логин или пароль',
	    internalError: 'Что-то пошло не так, попробуйте еще раз'
	};
	
	module.exports = {
	    errorMessage: function errorMessage(state) {
	        state.set(['login', 'computed', 'error', 'text'], computed(['login', 'error', 'errorType'], function (errorType) {
	            return ERRORS_MAP[errorType];
	        }));
	    },
	    errorState: function errorState(state) {
	        state.set(['login', 'computed', 'error', 'isError'], computed(['login', 'error', 'errorType'], function (errorType) {
	            return errorType;
	        }));
	    }
	};

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var computed = __webpack_require__(15).monkey;
	
	var _require = __webpack_require__(202),
	    isContinueEnabled = _require.isContinueEnabled;
	
	var ERRORS_MAP = {
	    passportUserAlreadyAssociated: 'Такой пользователь уже зарегистрирован',
	    internalError: 'Что-то пошло не так, попробуйте еще раз'
	};
	
	module.exports = {
	    registerButton: function registerButton(state) {
	        state.set(['registrationExtra', 'computed', 'registerButton', 'isEnabled'], computed(['registrationExtra', 'error'], ['registrationExtra', 'form'], ['registrationExtra', 'ui', 'registerButton', 'isDisabled'], function (error, form, isDisabled) {
	            return isContinueEnabled(error, form, isDisabled, []);
	        }));
	    },
	    errorState: function errorState(state) {
	        state.set(['registrationExtra', 'computed', 'error', 'isError'], computed(['registrationExtra', 'error', 'errorType'], function (errorType) {
	            return errorType;
	        }));
	    },
	    errorMessage: function errorMessage(state) {
	        state.set(['registrationExtra', 'computed', 'error', 'text'], computed(['registrationExtra', 'error', 'errorType'], function (errorType) {
	            return ERRORS_MAP[errorType];
	        }));
	    },
	    isUserTypeSelectEnabled: function isUserTypeSelectEnabled(state) {
	        state.set(['registrationExtra', 'computed', 'isUserTypeSelectEnabled'], computed(['registrationExtra', 'form', 'countryId'], function (countryId) {
	            return countryId === 1 || countryId === 4;
	        }));
	    }
	};

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(3);
	var computed = __webpack_require__(15).monkey;
	var SCHEME = __webpack_require__(22);
	
	var ERRORS_MAP = {
	    notFound: 'Такого аккаунта не существует',
	    internalError: 'Что-то пошло не так, попробуйте еще раз',
	    invalidToken: 'Невалидный токен'
	};
	
	module.exports = {
	    restoreButton: function restoreButton(state) {
	        state.set(['restoreChange', 'computed', 'restoreButton', 'isEnabled'], computed(['restoreChange', 'validation'], ['restoreChange', 'computed', 'validation', 'repeatPassword'], ['restoreChange', 'form'], ['restoreChange', 'ui', 'registerButton', 'isDisabled'], function (error, repeatPassword, form, isDisabled) {
	            var requiredFields = ['password', 'repeatPassword'];
	            var requiredKeys = _.keys(_.omitBy(form, function (key) {
	                return !key;
	            }));
	            var differenceLength = _.difference(requiredFields, requiredKeys).length;
	
	            return _.every([_.isEmpty(error), !repeatPassword, !differenceLength, !isDisabled]);
	        }));
	    },
	    setRepeatPasswordError: function setRepeatPasswordError(state) {
	        state.set(['restoreChange', 'computed', 'validation', 'repeatPassword'], computed(['restoreChange', 'validation', 'repeatPassword'], ['restoreChange', 'form', 'repeatPassword'], ['restoreChange', 'form', 'password'], function (errorRepeatPassword, repeatPassword, password) {
	            if (!repeatPassword) {
	                return;
	            }
	
	            if (errorRepeatPassword) {
	                return errorRepeatPassword;
	            }
	
	            if (repeatPassword !== password) {
	                return _.get(SCHEME.repeatPassword, 'properties.value.messages.repeat');
	            }
	        }));
	    },
	    errorState: function errorState(state) {
	        state.set(['restoreChange', 'computed', 'error', 'isError'], computed(['restoreChange', 'error', 'errorType'], function (errorType) {
	            return errorType;
	        }));
	    },
	    errorMessage: function errorMessage(state) {
	        state.set(['restoreChange', 'computed', 'error', 'text'], computed(['restoreChange', 'error', 'errorType'], function (errorType) {
	            return ERRORS_MAP[errorType];
	        }));
	    }
	};

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(3);
	var computed = __webpack_require__(15).monkey;
	
	var ERRORS_MAP = {
	    notFound: 'Такого аккаунта не существует',
	    internalError: 'Что-то пошло не так, попробуйте еще раз'
	};
	
	module.exports = {
	    restoreButton: function restoreButton(state) {
	        state.set(['restore', 'computed', 'restoreButton', 'isEnabled'], computed(['restore', 'error', 'email'], ['restore', 'form', 'email'], ['restore', 'ui', 'registerButton', 'isDisabled'], function (error, email, isDisabled) {
	            return _.every([!error, email, !isDisabled]);
	        }));
	    },
	    errorState: function errorState(state) {
	        state.set(['restore', 'computed', 'error', 'isError'], computed(['restore', 'error', 'errorType'], function (errorType) {
	            return errorType;
	        }));
	    },
	    errorMessage: function errorMessage(state) {
	        state.set(['restore', 'computed', 'error', 'text'], computed(['restore', 'error', 'errorType'], function (errorType) {
	            return ERRORS_MAP[errorType];
	        }));
	    }
	};

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _require = __webpack_require__(15),
	    monkey = _require.monkey;
	
	var _ = __webpack_require__(3);
	var numeral = __webpack_require__(195);
	
	module.exports = {
	    formatPrices: function formatPrices(state) {
	        state.set(['data', 'computed', 'prices'], monkey(['data', 'prices'], function () {
	            var prices = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	            if (prices.length == 0) {
	                return prices;
	            }
	
	            var result = _.map(prices, function (x) {
	                if (Array.isArray(x.name)) {
	                    var xNew = _.cloneDeep(x);
	                    xNew.name = 'Базовые поля (' + _.map(x.name, function (x) {
	                        return x.toLowerCase();
	                    }).join(", ") + ')';
	                    return xNew;
	                }
	                return x;
	            });
	
	            return result;
	        }));
	    },
	    formatDiscounts: function formatDiscounts(state) {
	        state.set(['data', 'computed', 'discounts'], monkey(['data', 'discounts'], function () {
	            var discounts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	            if (discounts.length == 0) {
	                return discounts;
	            }
	
	            var result = [];
	            for (var i = 0; i < discounts.length - 1; i++) {
	                result.push({
	                    lowerBound: '\u043E\u0442 ' + discounts[i].lowerBoundOfRowsAmount + ' \u0434\u043E ' + discounts[i + 1].lowerBoundOfRowsAmount,
	                    percentage: discounts[i].percentage
	                });
	            }
	            result.push({
	                lowerBound: 'более ' + discounts[discounts.length - 1].lowerBoundOfRowsAmount,
	                percentage: discounts[discounts.length - 1].percentage
	            });
	
	            return _.filter(result, function (x) {
	                return x.percentage > 0;
	            });
	        }));
	    },
	    formatExportColumns: function formatExportColumns(state) {
	        state.set(['data', 'computed', 'columns'], monkey(['data', 'columns'], function () {
	            var columns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	            var basic = _.filter(columns, function (x) {
	                return x.isBasic;
	            });
	            var optional = _.filter(columns, function (x) {
	                return x.isBasic == false;
	            });
	            return {
	                basic: _.map(basic, function (x) {
	                    return { name: x.name.toLowerCase() };
	                }),
	                optional: _.map(optional, function (x) {
	                    return { name: x.name.toLowerCase() };
	                })
	            };
	        }));
	    }
	};

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _require = __webpack_require__(15),
	    monkey = _require.monkey;
	
	var _ = __webpack_require__(3);
	
	var _require2 = __webpack_require__(57),
	    dfsRecursive = _require2.dfsRecursive,
	    getLeafs = _require2.getLeafs;
	
	function selectOptionalExportColumns(columns) {
	    return _.filter(columns, function (x) {
	        return x.isBasic == false;
	    });
	}
	
	function selectBasicExportColumns(columns) {
	    return _.filter(columns, function (x) {
	        return x.isBasic === true;
	    });
	}
	
	module.exports = {
	    setCitiesComputes: function setCitiesComputes(state) {
	        setTreeComputes(state, ['order', 'cities', 'tree'], ['order', 'originalParameters', 'cities']);
	    },
	    setBranchesComputes: function setBranchesComputes(state) {
	        setTreeComputes(state, ['order', 'branches', 'tree'], ['order', 'originalParameters', 'branches']);
	    },
	    setRubricsComputes: function setRubricsComputes(state) {
	        setTreeComputes(state, ['order', 'rubrics', 'tree'], ['order', 'originalParameters', 'rubrics']);
	        boolFilterRussianByCities(state, ['order', 'rubrics', 'tree']);
	    },
	    setLegalEntitiesComputes: function setLegalEntitiesComputes(state) {
	        setTreeComputes(state, ['order', 'addParams', 'legalEntities', 'tree'], ['order', 'originalParameters', 'legalEntities']);
	        boolFilterRussianByCities(state, ['order', 'addParams', 'legalEntities', 'tree']);
	    },
	    setPurposesComputes: function setPurposesComputes(state) {
	        setTreeComputes(state, ['order', 'addParams', 'purposes', 'tree'], ['order', 'originalParameters', 'purposes']);
	        boolFilterRussianByCities(state, ['order', 'addParams', 'purposes', 'tree']);
	    },
	    setMapClassesComputes: function setMapClassesComputes(state) {
	        setTreeComputes(state, ['order', 'addParams', 'mapClasses', 'tree'], ['order', 'originalParameters', 'mapClasses']);
	    },
	    setPaymentTypesComputes: function setPaymentTypesComputes(state) {
	        setTreeComputes(state, ['order', 'addParams', 'paymentTypes', 'tree'], ['order', 'originalParameters', 'paymentTypes']);
	        boolFilterRussianByCities(state, ['order', 'addParams', 'paymentTypes', 'tree']);
	    },
	    setNumberOfEmployeesComputes: function setNumberOfEmployeesComputes(state) {
	        setTreeComputes(state, ['order', 'addParams', 'numberOfEmployees', 'tree'], ['order', 'originalParameters', 'numberOfEmployees']);
	    },
	    setStatisticComputes: function setStatisticComputes(state) {
	        setStatisticTreeComputes(state, ['order', 'statistic', 'tree'], ['order', 'originalParameters', 'statistic']);
	    },
	    computeDataChangeTooltipState: function computeDataChangeTooltipState(state) {
	        state.set(['order', 'computed', 'showDataChangeTooltip'], monkey(['order', 'localStorageSelectedParamsWasOutdated'], ['order', 'draft', 'isNeedToConfirmDataChanged'], ['order', 'tooltip', 'hideDataChangeTooltip'], ['page', 'name'], function () {
	            var localStorageSelectedParamsWasOutdated = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	            var isNeedToConfirmDataChanged = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	            var hideDataChangeTooltip = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	            var pageName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	
	            if (pageName != 'order') {
	                return false;
	            }
	            if (hideDataChangeTooltip) {
	                return false;
	            } else if (localStorageSelectedParamsWasOutdated || isNeedToConfirmDataChanged) {
	                return true;
	            }
	            return false;
	        }));
	    },
	    computeIsExportColumnChecked: function computeIsExportColumnChecked(state, propertyName) {
	        state.set(['order', 'computed', 'exportColumns', 'byPropertyName', propertyName, 'isChecked'], monkey(['order', 'originalParameters', 'exportColumns', 'columns'], ['order', 'addParams', 'exportColumns'], function () {
	            var columns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	            var addParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	            var column = _.find(columns, { propertyName: propertyName });
	            if (column) {
	                if (addParams.hasOwnProperty(column.id)) {
	                    return addParams[column.id].isChecked;
	                }
	            }
	            return false;
	        }));
	    },
	    computeRubricsState: function computeRubricsState(state) {
	        state.set(['order', 'computed', 'hideRubrics'], monkey(['order', 'typeId'], function (typeId) {
	            return typeId && typeId === 3;
	        }));
	    },
	    formatExportColumnsBasic: function formatExportColumnsBasic(state) {
	        state.set(['order', 'computed', 'exportColumns', 'basic', 'view'], monkey(['order', 'originalParameters', 'exportColumns', 'columns'], function () {
	            var original = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	            var result = {};
	            _.forEach(selectBasicExportColumns(original), function (x) {
	                result[x.id] = x;
	            });
	            return result;
	        }));
	    },
	    formatExportColumnsBasicOrder: function formatExportColumnsBasicOrder(state) {
	        state.set(['order', 'computed', 'exportColumns', 'basic', 'viewOrder'], monkey(['order', 'originalParameters', 'exportColumns', 'columns'], function () {
	            var original = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	            var result = [];
	            _.forEach(selectBasicExportColumns(original), function (x) {
	                result.push({ id: x.id, name: x.name, propertyName: x.propertyName });
	            });
	            return result;
	        }));
	    },
	    setExportColumnAlwaysTrueForBasicColumnsCheckbox: function setExportColumnAlwaysTrueForBasicColumnsCheckbox(state) {
	        state.set(['order', 'computed', 'exportColumns', 'basic', 'alwaysTrue'], monkey(function () {
	            return true;
	        }));
	    },
	    formatExportColumnsOptionalOrder: function formatExportColumnsOptionalOrder(state) {
	        state.set(['order', 'computed', 'exportColumns', 'optional', 'viewOrder'], monkey(['order', 'originalParameters', 'exportColumns', 'columns'], function () {
	            var original = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	            var result = [];
	            _.forEach(selectOptionalExportColumns(original), function (x) {
	                result.push({ id: x.id, name: x.name, propertyName: x.propertyName });
	            });
	            return result;
	        }));
	    },
	    formatExportColumnsOptional: function formatExportColumnsOptional(state) {
	        state.set(['order', 'computed', 'exportColumns', 'optional', 'view'], monkey(['order', 'originalParameters', 'exportColumns', 'columns'], function () {
	            var original = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	            var result = {};
	            _.forEach(selectOptionalExportColumns(original), function (x) {
	                result[x.id] = _.clone(x);
	            });
	            return result;
	        }));
	    },
	    calculateOptionalExportColumnsValue: function calculateOptionalExportColumnsValue(state) {
	        state.set(['order', 'computed', 'exportColumns', 'optional', 'value'], monkey(['order', 'price', 'data', 'byColumns'], function () {
	            var price = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	            var result = {};
	            _.forEach(price, function (value, key) {
	                var column = {
	                    IsChecked: true,
	                    rowPrice: value.rowPrice,
	                    rowAmount: value.rowAmount
	                };
	                if (value.discountPercentage > 0) {
	                    column.discountPercentage = value.discountPercentage;
	                    column.rowPriceWithoutDiscount = value.rowPriceWithoutDiscount;
	                }
	                var columnId = parseInt(key, 10);
	                result[columnId] = column;
	            });
	
	            return result;
	        }));
	    },
	    isShowGreeder: function isShowGreeder(state) {
	        state.set(['order', 'computed', 'isShowGreeder'], monkey(['order', 'originalParameters', 'exportColumns', 'columns'], ['order', 'addParams', 'exportColumns'], ['order', 'typeId'], function () {
	            var columns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	            var selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	            var orderType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	            if (orderType !== 2) {
	                return false;
	            }
	            var innColumn = _.find(columns, { propertyName: 'Inn' });
	            if (innColumn && selected[innColumn.id]) {
	                return selected[innColumn.id].isChecked;
	            }
	            return false;
	        }));
	    },
	    isGosResSourceSelected: function isGosResSourceSelected(state) {
	        state.set(['order', 'computed', 'isGosResSourceSelected'], monkey(['order', 'addParams', 'greederColumns', 'source', 'egrip', 'isChecked'], ['order', 'addParams', 'greederColumns', 'source', 'egrul', 'isChecked'], function () {
	            var isEgrip = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	            var isEgrul = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	            return isEgrip || isEgrul;
	        }));
	    },
	    isOfflineOrder: function isOfflineOrder(state) {
	        state.set(['order', 'computed', 'isOfflineOrder'], monkey(['order', 'typeId'], function () {
	            var typeId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	            return typeId > 1;
	        }));
	    },
	    computeRubricsRecognizedInputValue: function computeRubricsRecognizedInputValue(state) {
	        state.set(['order', 'computed', 'treeUpload', 'rubrics', 'recognized'], monkey(['order', 'treeUpload', 'rubrics', 'recognized'], function () {
	            var recognizedRubrics = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	            return _.map(recognizedRubrics, 'name').join('\n');
	        }));
	    },
	    computeRubricsUnrecognizedInputValue: function computeRubricsUnrecognizedInputValue(state) {
	        state.set(['order', 'computed', 'treeUpload', 'rubrics', 'unrecognized'], monkey(['order', 'treeUpload', 'rubrics', 'unrecognized'], function () {
	            var unrecognizedRubrics = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	            return unrecognizedRubrics.join('\n');
	        }));
	    },
	    computeIsAnyUnrecognizedRubrics: function computeIsAnyUnrecognizedRubrics(state) {
	        state.set(['order', 'computed', 'treeUpload', 'rubrics', 'haveUnrecognized'], monkey(['order', 'treeUpload', 'rubrics', 'unrecognized'], function () {
	            var unrecognizedRubrics = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	            return unrecognizedRubrics && unrecognizedRubrics.length > 0;
	        }));
	    },
	    computeCitiesRecognizedInputValue: function computeCitiesRecognizedInputValue(state) {
	        state.set(['order', 'computed', 'treeUpload', 'cities', 'recognized'], monkey(['order', 'treeUpload', 'cities', 'recognized'], function () {
	            var recognized = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	            return _.map(recognized, 'name').join('\n');
	        }));
	    },
	    computeCitiesUnrecognizedInputValue: function computeCitiesUnrecognizedInputValue(state) {
	        state.set(['order', 'computed', 'treeUpload', 'cities', 'unrecognized'], monkey(['order', 'treeUpload', 'cities', 'unrecognized'], function () {
	            var unrecognized = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	            return unrecognized.join('\n');
	        }));
	    },
	    computeIsAnyUnrecognizedCities: function computeIsAnyUnrecognizedCities(state) {
	        state.set(['order', 'computed', 'treeUpload', 'cities', 'haveUnrecognized'], monkey(['order', 'treeUpload', 'cities', 'unrecognized'], function () {
	            var unrecognized = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	            return unrecognized && unrecognized.length > 0;
	        }));
	    }
	};
	
	function showDescendantsCount(state, basePath) {
	    state.set(basePath.concat('computed', 'showDescendantsCount'), monkey(['account', 'orders', 'computed', 'currentOrder', 'isEditable'], function () {
	        var isEditable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	        return isEditable;
	    }));
	}
	
	function setTreeComputes(state, basePath, srcDataPath) {
	    filteredItems(state, basePath, srcDataPath);
	    autoExpand(state, basePath);
	    computeShowSelectedOnly(state, basePath);
	    leafs(state, basePath, srcDataPath);
	    descendantLeafsCount(state, basePath, srcDataPath);
	    showDescendantsCount(state, basePath);
	    selectedDescendantLeafsCount(state, basePath, srcDataPath);
	}
	
	function setStatisticTreeComputes(state, basePath, srcDataPath) {
	    filteredItems(state, basePath, srcDataPath);
	}
	
	function descendantLeafsCount(state, basePath, srcDataPath) {
	    state.set(basePath.concat('computed', 'descendantLeafsCount'), monkey(srcDataPath, function (original) {
	        if (!original) {
	            return {};
	        }
	        var out = {};
	        dfsRecursive(original, '0', function (node) {
	            var children = node.children || [];
	            if (children.length === 0) {
	                out[node.code] = 1;
	            } else {
	                out[node.code] = _.sumBy(children, function (x) {
	                    return out[x];
	                });
	            }
	        });
	        return out;
	    }));
	}
	
	function selectedDescendantLeafsCount(state, basePath, srcDataPath) {
	    state.set(basePath.concat('computed', 'selectedDescendantLeafsCount'), monkey(srcDataPath, basePath.concat('selected'), function (original, selected) {
	        if (!original) {
	            return {};
	        }
	        var out = {};
	        dfsRecursive(original, '0', function (node) {
	            var children = node.children || [];
	            if (children.length === 0) {
	                if (_.get(selected, [node.code, 'value'], false)) {
	                    out[node.code] = 1;
	                } else {
	                    out[node.code] = 0;
	                }
	            } else {
	                out[node.code] = _.sumBy(children, function (x) {
	                    return out[x];
	                });
	            }
	        });
	        return out;
	    }));
	}
	
	function filteredItems(state, basePath, srcDataPath) {
	    state.set(basePath.concat('computed', 'items'), monkey(srcDataPath, basePath.concat('filter'), basePath.concat('boolFilters'), ['order', 'isDisabled'], ['order', 'typeId'], function (original, filter, boolFilters) {
	        var isDisabled = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	        var typeId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
	
	        if (!original) {
	            return {};
	        }
	        var result = original;
	        if (boolFilters && !isDisabled && typeId !== 1) {
	            Object.keys(boolFilters).forEach(function (key) {
	                if (boolFilters[key] === undefined) {
	                    return;
	                }
	                var selector = function selector(x) {
	                    return x[key] === boolFilters[key];
	                };
	                var out = {};
	                dfsRecursive(result, '0', function (node) {
	                    return filterNodeBySelector(node, selector, out);
	                });
	                result = out;
	            });
	        }
	
	        if (filter) {
	            var out = {};
	            dfsRecursive(result, '0', function (node) {
	                return filterNode(node, filter, out);
	            });
	            result = out;
	        }
	        return result;
	    }));
	}
	
	function boolFilterRussianByCities(state, basePath) {
	    state.set(basePath.concat(['boolFilters', 'isRussian']), monkey(['order', 'cities', 'tree', 'hasRussians'], ['order', 'cities', 'tree', 'hasNonRussians'], function () {
	        var hasRussians = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	        var hasNonRussians = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        if (hasRussians === true && hasNonRussians === false) {
	            return true;
	        }
	        return undefined;
	    }));
	    state.set(basePath.concat(['boolFilters', 'isNonRussian']), monkey(['order', 'cities', 'tree', 'hasRussians'], ['order', 'cities', 'tree', 'hasNonRussians'], function () {
	        var hasRussians = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	        var hasNonRussians = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        if (hasNonRussians === true && hasRussians === false) {
	            return true;
	        }
	        return undefined;
	    }));
	}
	
	function autoExpand(state, basePath) {
	    state.set(basePath.concat('computed', 'autoExpand'), monkey(basePath.concat('filter'), basePath.concat('showBranchTree'), function (filter, showBranchTree) {
	        return filter !== null || showBranchTree;
	    }));
	}
	
	function computeShowSelectedOnly(state, basePath) {
	    state.set(basePath.concat('computed', 'showSelectedOnly'), monkey(['order', 'isDisabled'], basePath.concat('showSelectedOnly'), function () {
	        var isDisabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	        var showSelectedOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	        return isDisabled || showSelectedOnly;
	    }));
	}
	
	function leafs(state, basePath, srcDataPath) {
	    state.set(basePath.concat('computed', 'leafs'), monkey(srcDataPath, function (original) {
	        return getLeafs(original);
	    }));
	}
	
	function filterNode(node, filter, out) {
	    var children = node.children || [];
	
	    var labelMatched = node.label && matches(node.label, filter);
	    var root = node.parentCode === null;
	
	    var filteredChildren = _.filter(children, function (x) {
	        return _.has(out, x);
	    });
	
	    if (root || filteredChildren.length > 0 || labelMatched) {
	        out[node.code] = {
	            label: node.label,
	            code: node.code,
	            parentCode: node.parentCode,
	            branchId: node.branchId,
	            isDefaultCity: node.isDefaultCity,
	            branchLink: node.branchLink,
	            branchName: node.branchName,
	            isBranchTreeRelated: node.isBranchTreeRelated,
	            children: filteredChildren
	        };
	    }
	}
	
	function filterNodeBySelector(node, selector, out) {
	    var children = node.children || [];
	    var root = node.parentCode === null;
	
	    var filteredChildren = _.filter(children, function (x) {
	        return _.has(out, x);
	    });
	
	    if (root || filteredChildren.length > 0 || selector(node) === true) {
	        out[node.code] = {
	            label: node.label,
	            code: node.code,
	            parentCode: node.parentCode,
	            branchId: node.branchId,
	            isDefaultCity: node.isDefaultCity,
	            branchLink: node.branchLink,
	            branchName: node.branchName,
	            isBranchTreeRelated: node.isBranchTreeRelated,
	            children: filteredChildren
	        };
	    }
	}
	
	function matches(value, filter) {
	    if (filter) {
	        return value.toLocaleLowerCase().indexOf(filter.toLocaleLowerCase()) > -1;
	    }
	    return true;
	}

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _require = __webpack_require__(15),
	    monkey = _require.monkey;
	
	var moment = __webpack_require__(34);
	
	var _require2 = __webpack_require__(4),
	    pluralize = _require2.pluralize;
	
	module.exports = {
	    firmsPluralized: function firmsPluralized(state) {
	        state.set(['order', 'price', 'computed', 'firmsPluralized'], monkey(['order', 'price', 'data', 'rowAmount'], function (amount) {
	            return pluralize(amount, ['фирма', 'фирмы', 'фирм']);
	        }));
	    },
	    isBasicPriceAnyDiscount: function isBasicPriceAnyDiscount(state) {
	        state.set(['order', 'price', 'computed', 'rowPriceWithoutDiscount'], monkey(['order', 'price', 'data', 'basic', 'rowPriceWithoutDiscount'], ['order', 'price', 'data', 'basic', 'rowPrice'], function (priceFull, priceDiscount) {
	            if (priceDiscount !== priceFull) {
	                return priceFull;
	            }
	        }));
	    },
	    datepicker: function datepicker(state) {
	        state.set(['order', 'addParams', 'computed', 'datepicker'], monkey(['order', 'addParams', 'datepicker', 'value'], ['order', 'addParams', 'datepicker', 'calendar'], ['order', 'addParams', 'datepicker', 'ui', 'isDisabled'], function (selectedDate, calendar, isDisabled) {
	            var today = moment().subtract(1, 'day').unix();
	            var title = selectedDate ? moment.unix(selectedDate).format('DD.MM.YYYY') : '';
	            var calendars = calendar ? calendar : [{ date: today }];
	
	            return {
	                mod: 'discounts',
	                withoutButton: true,
	                withInputs: false,
	                availableRange: {
	                    from: moment({ year: 2000, month: 0 }).unix(),
	                    till: today
	                },
	                calendars: calendars,
	                selectedDate: selectedDate,
	                title: { date: title },
	                isDisabled: isDisabled
	            };
	        }));
	        state.set(['order', 'addParams', 'computed', 'datepicker2'], monkey(['order', 'addParams', 'datepicker2', 'value'], ['order', 'addParams', 'datepicker2', 'calendar'], ['order', 'addParams', 'datepicker2', 'ui', 'isDisabled'], function (selectedDate, calendar, isDisabled) {
	            var today = moment().subtract(1, 'day').unix();
	            var title = selectedDate ? moment.unix(selectedDate).format('DD.MM.YYYY') : '';
	            var calendars = calendar ? calendar : [{ date: today }];
	
	            return {
	                mod: 'discounts',
	                withoutButton: true,
	                withInputs: false,
	                availableRange: {
	                    from: moment({ year: 2000, month: 0 }).unix(),
	                    till: today
	                },
	                calendars: calendars,
	                selectedDate: selectedDate,
	                title: { date: title },
	                isDisabled: isDisabled
	            };
	        }));
	    }
	};

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var computed = __webpack_require__(15).monkey;
	
	module.exports = {
	    promoText: function promoText(state) {
	        state.set(['slider', 'computed', 'text'], computed(['slider', 'page'], function () {
	            var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	
	            switch (page % 4) {
	                case 1:
	                    return {
	                        title: 'Точность',
	                        content: '\u0420\u0435\u0433\u0443\u043B\u044F\u0440\u043D\u0430\u044F \u0432\u044B\u0432\u0435\u0440\u043A\u0430 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u0438\u0441\u0442\u0430\u043C\u0438 call-\u0446\u0435\u043D\u0442\u0440\u0430\n                                    \u0438 \u043F\u0435\u0448\u0438\u043C\u0438 \u043A\u0430\u0440\u0442\u043E\u0433\u0440\u0430\u0444\u0430\u043C\u0438 \u043D\u0430 \u043C\u0435\u0441\u0442\u0430\u0445'
	                    };
	                case 2:
	                    return {
	                        title: 'Охват',
	                        content: '\u041F\u043E\u043B\u043D\u0430\u044F \u0438 \u0430\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043E 2,4 \u043C\u043B\u043D \u0440\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u0438\u0445 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0439 \u0438\u0437 270 \u0433\u043E\u0440\u043E\u0434\u043E\u0432\n                                 \u0420\u043E\u0441\u0441\u0438\u0438, \u0432\u043A\u043B\u044E\u0447\u0430\u044F \u0433\u043E\u0440\u043E\u0434\u0430-\u0441\u043F\u0443\u0442\u043D\u0438\u043A\u0438'
	                    };
	                case 3:
	                    return {
	                        title: 'Надежность',
	                        content: 'Data.2gis \u2014 \u043E\u0434\u0438\u043D \u0438\u0437 \u0421\u0435\u0440\u0432\u0438\u0441\u043E\u0432 2\u0413\u0418\u0421, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \n                            \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u043E\u0444\u0438\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u043C \u0434\u0430\u043D\u043D\u044B\u043C 2\u0413\u0418\u0421'
	                    };
	                case 0:
	                    return {
	                        title: 'Возможности',
	                        content: '\u0411\u043E\u043B\u0435\u0435 \u043F\u043E\u0434\u0440\u043E\u0431\u043D\u0430\u044F \u0432\u044B\u0431\u043E\u0440\u043A\u0430 (\u0441\u0440\u0435\u0434\u043D\u0438\u0439 \u0447\u0435\u043A, \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0444\u0438\u043B\u0438\u0430\u043B\u043E\u0432 \n                                \u0438\u043B\u0438 \u0434\u0440\u0443\u0433\u0438\u0435 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B \u0438 \u0434\u0430\u043D\u043D\u044B\u0435) \n                                \u0442\u0430\u043A\u0436\u0435 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B \u0432 \u041B\u0438\u0447\u043D\u043E\u043C \u043A\u0430\u0431\u0438\u043D\u0435\u0442\u0435'
	                    };
	                default:
	                    return {
	                        title: 'Точность',
	                        content: '\u0420\u0435\u0433\u0443\u043B\u044F\u0440\u043D\u0430\u044F \u0432\u044B\u0432\u0435\u0440\u043A\u0430 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u0438\u0441\u0442\u0430\u043C\u0438 call-\u0446\u0435\u043D\u0442\u0440\u0430\n                                    \u0438 \u043F\u0435\u0448\u0438\u043C\u0438 \u043A\u0430\u0440\u0442\u043E\u0433\u0440\u0430\u0444\u0430\u043C\u0438 \u043D\u0430 \u043C\u0435\u0441\u0442\u0430\u0445'
	                    };
	            }
	        }));
	    }
	};

/***/ }),
/* 307 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	    showMap: function showMap(args, state, output, _ref) {
	        var locator = _ref.locator;
	
	        var gismap = locator.resolve('gismap');
	        gismap.showMap();
	    }
	};

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(3);
	
	function tryUnsetAllSelected(_ref, state) {
	    var path = _ref.path,
	        propertyName = _ref.propertyName,
	        setAllFunction = _ref.setAllFunction;
	
	    var exportColumn = _.find(state.get(['order', 'originalParameters', 'exportColumns', 'columns']), { propertyName: propertyName });
	    if (exportColumn && path === exportColumn.id) {
	        setAllFunction({ value: false }, state);
	    }
	}
	
	function setExportColumnIsChecked(_ref2, state) {
	    var value = _ref2.value,
	        propertyName = _ref2.propertyName;
	
	    var exportColumn = _.find(state.get(['order', 'originalParameters', 'exportColumns', 'columns']), { propertyName: propertyName });
	    if (exportColumn) {
	        state.set(['order', 'addParams', 'exportColumns', exportColumn.id, 'isChecked'], value);
	    }
	}
	
	module.exports = {
	    tryUnsetAllSelected: tryUnsetAllSelected,
	    setExportColumnIsChecked: setExportColumnIsChecked
	};

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _require = __webpack_require__(15),
	    monkey = _require.monkey;
	
	var _ = __webpack_require__(3);
	
	var LINKS = {
	    client: [{
	        name: 'account',
	        href: '/account/orders',
	        title: 'Заказы'
	    }, {
	        name: 'contacts',
	        href: '/contacts',
	        title: 'О нас'
	    }],
	    manager: [{
	        name: 'manager',
	        href: '/manager/orders',
	        title: 'Панель менеджера'
	    }, {
	        name: 'contacts',
	        href: '/contacts',
	        title: 'О нас'
	    }],
	    unauthorized: [{
	        name: 'contacts',
	        href: '/contacts',
	        title: 'О нас'
	    }]
	};
	
	module.exports = {
	    setHeaderMenu: function setHeaderMenu(args, state) {
	        state.set(['header', 'menu'], monkey(['page', 'name'], ['user', 'role'], function (page, role) {
	            return _.chain(LINKS).get(role).map(function (link) {
	                return Object.assign({}, link, { isActive: link.name === page });
	            }).value();
	        }));
	    }
	};

/***/ }),
/* 310 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	    ifPaymentSuccessful: function ifPaymentSuccessful(_ref, state, output) {
	        var redirectType = _ref.redirectType;
	
	        if (redirectType === 'success') {
	            output.yes();
	        } else {
	            output.no();
	        }
	    },
	    fixOrderId: function fixOrderId(args) {
	        args.orderId = args.orderId.replace('DATUM', '');
	    }
	};

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(3);
	var computedPrice = __webpack_require__(303);
	
	var _require = __webpack_require__(72),
	    thenWithErrorHandling = _require.thenWithErrorHandling;
	
	module.exports = {
	    setComputedFields: function setComputedFields(args, state) {
	        computedPrice.formatPrices(state);
	        computedPrice.formatDiscounts(state);
	        computedPrice.formatExportColumns(state);
	    },
	    getPrices: function getPrices(args, state, output, _ref) {
	        var context = _ref.context,
	            locator = _ref.locator;
	
	        var api = locator.resolve('api');
	        var request = api.getPrices(context, locator, {});
	
	        thenWithErrorHandling(request, function (data) {
	            return { prices: _.get(data, 'content') };
	        }, output);
	    },
	    setPrices: function setPrices(_ref2, state) {
	        var prices = _ref2.prices;
	
	        state.set(['data'], prices);
	    },
	    getColumns: function getColumns(args, state, output, _ref3) {
	        var context = _ref3.context,
	            locator = _ref3.locator;
	
	        var api = locator.resolve('api');
	        var request = api.getColumns(context, locator, {});
	        thenWithErrorHandling(request, function (data) {
	            return { columns: _.get(data, 'content') };
	        }, output);
	    },
	    setColumns: function setColumns(_ref4, state) {
	        var columns = _ref4.columns;
	
	        state.set(['data', 'columns'], columns);
	    }
	};

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(3);
	
	module.exports = {
	    addVideo: function addVideo(args, state, output, _ref) {
	        var context = _ref.context;
	
	        var scheme = _.get(context, 'location.scheme');
	        var ytplayer = document.getElementById('ytplayer');
	        var iframe = document.createElement('iframe');
	        iframe.setAttribute('type', 'text/html');
	        iframe.setAttribute('width', '100%');
	        iframe.setAttribute('height', '100%');
	        iframe.setAttribute('src', scheme + '://www.youtube.com/embed/XzXUsfC_Jt8?origin=' + scheme + '://data.2gis.com');
	        iframe.setAttribute('frameborder', '0');
	        iframe.setAttribute('allowfullscreen', '');
	        ytplayer.parentNode.replaceChild(iframe, ytplayer);
	    }
	};

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(746);
	var Orders = __webpack_require__(334);
	var Users = __webpack_require__(351);
	
	var Content = function () {
	    function Content() {
	        _classCallCheck(this, Content);
	
	        this.template = __webpack_require__(878);
	    }
	
	    Content.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    return Content;
	}();
	
	module.exports = {
	    constructor: Content,
	    children: [{
	        name: 'orders',
	        component: Orders
	    }, {
	        name: 'users',
	        component: Users
	    }]
	};

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _require = __webpack_require__(44),
	    Subnavigation = _require.Subnavigation;
	
	var Content = __webpack_require__(313);
	var OrderCreator = __webpack_require__(315);
	var signals = __webpack_require__(493);
	var css = __webpack_require__(745);
	
	var Account = function () {
	    function Account() {
	        _classCallCheck(this, Account);
	
	        this.template = __webpack_require__(916);
	    }
	
	    Account.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    return Account;
	}();
	
	module.exports = {
	    constructor: Account,
	    children: [{
	        name: 'subnavigation',
	        component: Subnavigation,
	        watcher: {
	            tabs: ['subnavigation', 'elements']
	        },
	        props: {
	            signal: signals.setSubPage
	        }
	    }, {
	        name: 'content',
	        component: Content,
	        watcher: {
	            components: ['account', 'components']
	        }
	    }, {
	        name: 'order-creator',
	        component: OrderCreator
	    }]
	};

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Select = __webpack_require__(468);
	var signals = __webpack_require__(73);
	
	var OrderCreator = function () {
	    function OrderCreator() {
	        _classCallCheck(this, OrderCreator);
	
	        this.template = __webpack_require__(879);
	    }
	
	    OrderCreator.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data);
	        });
	    };
	
	    return OrderCreator;
	}();
	
	module.exports = {
	    constructor: OrderCreator,
	    children: [{
	        name: 'select',
	        component: Select,
	        props: {
	            signalOnSelect: signals.onCreateOrder,
	            signalOnToggle: signals.togglePopup
	        },
	        watcher: {
	            options: ['account', 'orders', 'createOrder', 'options'],
	            isDisable: ['account', 'orders', 'createOrder', 'isDisable'],
	            isOpen: ['account', 'popups', 'createOrder', 'isOpen'],
	            header: ['account', 'orders', 'createOrder', 'header']
	        }
	    }]
	};

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(747);
	var signals = __webpack_require__(62);
	var bitrix = __webpack_require__(29);
	
	var _require = __webpack_require__(4),
	    cut = _require.cut;
	
	var CONTINUE_BUTTON_SELECTOR = cut(css.continueButton);
	var CANCEL_BUTTON_SELECTOR = cut(css.cancelButton);
	var PAY_ONLINE_BUTTON_SELECTOR = cut(css.payOnlineButton);
	var SAVE_ALL_BUTTON_SELECTOR = cut(css.saveAllButton);
	var MAKE_ORDER_BUTTON_SELECTOR = cut(css.makeOrderButton);
	var REPEAT_ORDER_BUTTON_SELECTOR = cut(css.repeatOrderButton);
	
	var _require2 = __webpack_require__(44),
	    Checkbox = _require2.Checkbox;
	
	var PaymentForm = __webpack_require__(317);
	
	var _require3 = __webpack_require__(75),
	    onMakeOrderUnauthorized = _require3.onMakeOrderUnauthorized;
	
	var _require4 = __webpack_require__(11),
	    _redirect = _require4.redirect;
	
	var _require5 = __webpack_require__(90),
	    raiseEvent = _require5.raiseEvent;
	
	var ActionPanel = function () {
	    function ActionPanel() {
	        _classCallCheck(this, ActionPanel);
	
	        this.template = __webpack_require__(881);
	    }
	
	    ActionPanel.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    ActionPanel.prototype.bind = function bind() {
	        var _click;
	
	        return {
	            click: (_click = {}, _click[CONTINUE_BUTTON_SELECTOR] = this.moveOrderToNextState, _click[PAY_ONLINE_BUTTON_SELECTOR] = this.payOnline, _click[CANCEL_BUTTON_SELECTOR] = this.cancelOrder, _click[SAVE_ALL_BUTTON_SELECTOR] = this.applyLocalChanges, _click[MAKE_ORDER_BUTTON_SELECTOR] = this.makeOrder, _click[REPEAT_ORDER_BUTTON_SELECTOR] = this.repeatOrderButton, _click[cut(css.redirect)] = this.redirect, _click[cut(css.redirectToLeadsMapping)] = this.redirectToLeadsMapping, _click[cut(css.redirectToLeadsMappingFree)] = this.redirectToLeadsMappingFree, _click)
	        };
	    };
	
	    ActionPanel.prototype.makeOrder = function makeOrder() {
	        this.$context.signal(onMakeOrderUnauthorized);
	    };
	
	    ActionPanel.prototype.payOnline = function payOnline() {
	        this.$context.signal(signals.payOnline);
	    };
	
	    ActionPanel.prototype.moveOrderToNextState = function moveOrderToNextState() {
	        this.$context.signal(signals.tryMoveOrderToNextState);
	    };
	
	    ActionPanel.prototype.cancelOrder = function cancelOrder() {
	        this.$context.signal(signals.archiveOrder);
	    };
	
	    ActionPanel.prototype.applyLocalChanges = function applyLocalChanges() {
	        this.$context.signal(signals.applyLocalChanges);
	    };
	
	    ActionPanel.prototype.repeatOrderButton = function repeatOrderButton() {
	        this.$context.signal(signals.repeatOrder);
	    };
	
	    ActionPanel.prototype.redirect = function redirect(e) {
	        e.stopPropagation();
	        var url = e.currentTarget.getAttribute('cat-url');
	        this.$context.signal(_redirect, { url: url });
	    };
	
	    ActionPanel.prototype.redirectToLeadsMapping = function redirectToLeadsMapping() {
	        this.$context.signal(bitrix.redirectToLeadsMapping);
	    };
	
	    ActionPanel.prototype.redirectToLeadsMappingFree = function redirectToLeadsMappingFree() {
	        this.$context.signal(raiseEvent, { category: 'button_bitrix_export_free_page', action: 'click' });
	        this.$context.signal(bitrix.redirectToLeadsMapping, { isExportFree: true });
	    };
	
	    return ActionPanel;
	}();
	
	module.exports = {
	    constructor: ActionPanel,
	    children: [{
	        name: 'license-checkbox',
	        component: Checkbox,
	        props: {
	            signal: signals.licenseAccepted
	        },
	        watcher: {
	            value: ['account', 'orders', 'currentOrder', 'update', 'userAcceptLicenseAgreement']
	        }
	    }, {
	        name: 'payment-form',
	        component: PaymentForm,
	        watcher: {
	            url: ['account', 'orders', 'currentOrder', 'paymentForm', 'url'],
	            data: ['account', 'orders', 'currentOrder', 'paymentForm', 'data']
	        }
	    }]
	};

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(748);
	
	var PaymentForm = function () {
	    function PaymentForm() {
	        _classCallCheck(this, PaymentForm);
	
	        this.template = __webpack_require__(880);
	    }
	
	    PaymentForm.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    return PaymentForm;
	}();
	
	module.exports = {
	    constructor: PaymentForm
	};

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(749);
	
	var _require = __webpack_require__(4),
	    cut = _require.cut;
	
	var signals = __webpack_require__(29);
	var bitrix = __webpack_require__(29);
	
	var PrgoressBar = function () {
	    function PrgoressBar() {
	        _classCallCheck(this, PrgoressBar);
	
	        this.template = __webpack_require__(882);
	    }
	
	    PrgoressBar.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    PrgoressBar.prototype.bind = function bind() {
	        var _click;
	
	        this.$context.signal(bitrix.resize);
	        return {
	            click: (_click = {}, _click[cut(css.exportButton)] = this.exportButton, _click[cut(css.backButton)] = this.backButton, _click)
	        };
	    };
	
	    PrgoressBar.prototype.exportButton = function exportButton() {
	        this.$context.signal(signals.exportLeadsUsingMapping);
	    };
	
	    PrgoressBar.prototype.backButton = function backButton() {
	        this.$context.signal(signals.backToOrderPage);
	    };
	
	    return PrgoressBar;
	}();
	
	module.exports = {
	    constructor: PrgoressBar
	};

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(751);
	
	var ErrorTooltip = function () {
	    function ErrorTooltip() {
	        _classCallCheck(this, ErrorTooltip);
	
	        this.template = __webpack_require__(883);
	    }
	
	    ErrorTooltip.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    return ErrorTooltip;
	}();
	
	module.exports = {
	    constructor: ErrorTooltip
	};

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(752);
	
	var _require = __webpack_require__(44),
	    Select = _require.Select,
	    Text = _require.Text;
	
	var signals = __webpack_require__(29);
	var utils = __webpack_require__(11);
	
	var _require2 = __webpack_require__(4),
	    cut = _require2.cut;
	
	var SCHEMES = __webpack_require__(22);
	
	var FieldMapping = function () {
	    function FieldMapping() {
	        _classCallCheck(this, FieldMapping);
	
	        this.template = __webpack_require__(884);
	    }
	
	    FieldMapping.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    FieldMapping.prototype.bind = function bind() {
	        var _click;
	
	        this.$context.signal(signals.validateMapping);
	        return {
	            click: (_click = {}, _click[cut(css.toggleNew)] = this.toggleNew, _click)
	        };
	    };
	
	    FieldMapping.prototype.toggleNew = function toggleNew(e) {
	        e.stopPropagation();
	        var id = e.currentTarget.getAttribute('cat-id');
	        var path = ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'mapping', id, 'isNew'];
	        this.$context.signal(signals.toogleFieldMappingIsNew, { path: path });
	    };
	
	    return FieldMapping;
	}();
	
	module.exports = {
	    constructor: FieldMapping,
	    children: [{
	        name: 'select',
	        component: Select,
	        props: {
	            signalOnSelect: signals.selectHermesToBitrixLeadMapping,
	            signalOnToggle: utils.togglePopupFromArgs
	        },
	        watcher: function watcher(attributes) {
	            return {
	                options: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'mapping', attributes['cat-field'], 'bitrixFields'],
	                isDisable: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'mapping', attributes['cat-field'], 'isDisable'],
	                isOpen: ['account', 'popups', 'bitrixExportLeads', 'mapping', attributes['cat-field'], 'isOpen'],
	                isError: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'mapping', attributes['cat-field'], 'isError'],
	                header: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'mapping', attributes['cat-field'], 'header']
	            };
	        }
	    }, {
	        name: 'new-field',
	        component: Text,
	        props: {
	            signals: { inputText: signals.inputTextWithValidateMapping,
	                blurText: signals.blurTextWithValidateMapping },
	            placeholder: 'Введите название нового поля...',
	            scheme: SCHEMES.stringOnlyLettersAndDigitsNotEmpty,
	            hideTooltip: true
	        },
	        watcher: function watcher(attributes) {
	            return {
	                value: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'mapping', attributes['cat-field'], 'newLabel'],
	                error: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'mapping', attributes['cat-field'], 'error']
	            };
	        }
	    }]
	};

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(750);
	var ProgressBar = __webpack_require__(322);
	var ActionPanel = __webpack_require__(318);
	var Header = __webpack_require__(207);
	var FieldMapping = __webpack_require__(320);
	var ErrorTooltip = __webpack_require__(319);
	var RequiredFieldsMapping = __webpack_require__(323);
	
	var _require = __webpack_require__(44),
	    Checkbox = _require.Checkbox;
	
	var _require2 = __webpack_require__(29),
	    setIncludeExportedFreeLeads = _require2.setIncludeExportedFreeLeads;
	
	var OrdersOptions = function () {
	    function OrdersOptions() {
	        _classCallCheck(this, OrdersOptions);
	
	        this.template = __webpack_require__(887);
	    }
	
	    OrdersOptions.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    return OrdersOptions;
	}();
	
	module.exports = {
	    constructor: OrdersOptions,
	    children: [{
	        name: 'progress-bar',
	        component: ProgressBar
	    }, {
	        name: 'header',
	        component: Header,
	        props: {
	            hidePrice: true
	        },
	        watcher: {
	            id: ['account', 'orders', 'currentOrder', 'id'],
	            createDate: ['account', 'orders', 'computed', 'currentOrder', 'createDate'],
	            stateName: ['account', 'orders', 'computed', 'currentOrder', 'stateName']
	        }
	    }, {
	        name: 'action-panel',
	        component: ActionPanel,
	        watcher: {
	            isExportRunning: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'exportLeadsProgressLock'],
	            mappingError: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'isError'],
	            isExportDone: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'isExportDone'],
	            domain: ['bitrix', 'domain']
	        }
	    }, {
	        name: 'field-mapping',
	        component: FieldMapping,
	        watcher: function watcher(attributes) {
	            return {
	                id: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'mapping', attributes['cat-field'], 'id'],
	                isNew: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'mapping', attributes['cat-field'], 'isNew'],
	                hasFieldCreationRight: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'hasFieldCreationRight']
	            };
	        }
	    }, {
	        name: 'error-tooltip',
	        component: ErrorTooltip,
	        watcher: {
	            isTitleNotFilled: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'missRequiredFields'],
	            mappingDuplicate: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'duplicateError']
	        }
	    }, {
	        name: 'checkbox',
	        component: Checkbox,
	        props: {
	            signal: setIncludeExportedFreeLeads
	        },
	        watcher: {
	            value: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'isIncludeExportedFreeLeads']
	        }
	    }, {
	        name: 'required-fields-mapping',
	        component: RequiredFieldsMapping,
	        watcher: {
	            requiredBitrixFields: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'requiredBitrixFields']
	        }
	    }]
	};

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(753);
	
	var PrgoressBar = function () {
	    function PrgoressBar() {
	        _classCallCheck(this, PrgoressBar);
	
	        this.template = __webpack_require__(885);
	    }
	
	    PrgoressBar.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    return PrgoressBar;
	}();
	
	module.exports = {
	    constructor: PrgoressBar
	};

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(754);
	var accountUi = __webpack_require__(44);
	var SCHEMES = __webpack_require__(22);
	var signals = __webpack_require__(29);
	var utils = __webpack_require__(11);
	var accountUiSignal = __webpack_require__(226);
	
	var RequiredMapping = function () {
	    function RequiredMapping() {
	        _classCallCheck(this, RequiredMapping);
	
	        this.template = __webpack_require__(886);
	    }
	
	    RequiredMapping.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    return RequiredMapping;
	}();
	
	module.exports = {
	    constructor: RequiredMapping,
	    children: [{
	        name: 'required-field-value',
	        component: accountUi.Text,
	        props: {
	            signals: { inputText: signals.inputTextWithValidateMapping,
	                blurText: signals.blurTextWithValidateMapping },
	            position: 'leftToRight',
	            placeholder: 'Введите значение...'
	        },
	        watcher: function watcher(attributes) {
	            return {
	                value: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'requiredFields', attributes['cat-field'], 'value']
	            };
	        }
	    }, {
	        name: 'required-field-value-number',
	        component: accountUi.Text,
	        props: {
	            signals: { inputText: signals.inputTextWithValidateMapping,
	                blurText: signals.blurTextWithValidateMapping },
	            position: 'leftToRight',
	            placeholder: 'Введите значение...',
	            scheme: SCHEMES.numberOrEmpty
	        },
	        watcher: function watcher(attributes) {
	            return {
	                value: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'requiredFields', attributes['cat-field'], 'value'],
	                error: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'requiredFields', attributes['cat-field'], 'error']
	            };
	        }
	    }, {
	        name: 'checkbox',
	        component: accountUi.Checkbox,
	        props: {
	            signal: signals.setBitrixRequiredFieldValue
	        },
	        watcher: function watcher(attributes) {
	            return {
	                value: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'requiredFields', attributes['cat-path'], 'value']
	            };
	        }
	    }, {
	        name: 'select',
	        component: accountUi.Select,
	        props: {
	            signalOnSelect: signals.selectHermesLeadRequiredValue,
	            signalOnToggle: utils.togglePopupFromArgs
	        },
	        watcher: function watcher(attributes) {
	            return {
	                options: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'requiredFields', attributes['cat-field'], 'enumValues'],
	                isDisable: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'requiredFields', attributes['cat-field'], 'isDisable'],
	                isOpen: ['account', 'popups', 'bitrixExportLeads', 'requiredFields', attributes['cat-field'], 'isOpen'],
	                isError: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'requiredFields', attributes['cat-field'], 'isError']
	            };
	        }
	    }, {
	        name: 'datepicker',
	        component: accountUi.Datepicker,
	        props: {
	            scrollType: 'month',
	            toggleDropdown: accountUiSignal.togglePopup,
	            selectDate: signals.setDate(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'requiredFields']),
	            clearInput: signals.unsetDate(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'requiredFields']),
	            scrollPage: accountUiSignal.scrollPageDatepickerBase(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'requiredFields'])
	        },
	        watcher: function watcher(attributes) {
	            return {
	                id: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'computed', 'requiredFields', attributes['cat-id'], 'datepicker', 'id'],
	                mod: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'computed', 'requiredFields', attributes['cat-id'], 'datepicker', 'mod'],
	                withInputs: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'computed', 'requiredFields', attributes['cat-id'], 'datepicker', 'withInputs'],
	                withoutButton: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'computed', 'requiredFields', attributes['cat-id'], 'datepicker', 'withoutButton'],
	                selectedDate: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'computed', 'requiredFields', attributes['cat-id'], 'datepicker', 'selectedDate'],
	                calendars: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'computed', 'requiredFields', attributes['cat-id'], 'datepicker', 'calendars'],
	                range: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'computed', 'requiredFields', attributes['cat-id'], 'datepicker', 'range'],
	                availableRange: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'computed', 'requiredFields', attributes['cat-id'], 'datepicker', 'availableRange'],
	                title: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'computed', 'requiredFields', attributes['cat-id'], 'datepicker', 'title'],
	                isOpen: ['account', 'popups', 'bitrixExportLeads', 'requiredFields', attributes['cat-id'], 'isOpen'],
	                isDisabled: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'computed', 'requiredFields', attributes['cat-id'], 'datepicker', 'isDisabled']
	            };
	        }
	    }]
	};

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var signals = __webpack_require__(62);
	
	var _require = __webpack_require__(44),
	    Checkbox = _require.Checkbox;
	
	var _require2 = __webpack_require__(4),
	    cut = _require2.cut;
	
	var css = __webpack_require__(756);
	
	var LOAD_FILE_BUTTON_SELECTOR = cut(css.fileUploadInput);
	var DELETE_DOCUMENT_BUTTON_SELECTOR = cut(css.deleteDocumentButton);
	var DOWNLOAD_FILE_LINK_SELECTOR = cut(css.downloadFileLink);
	var DOWNLOAD_DRAFT_SELECTOR = cut(css.downloadDraftLink);
	
	var Documents = function () {
	    function Documents() {
	        _classCallCheck(this, Documents);
	
	        this.template = __webpack_require__(888);
	    }
	
	    Documents.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    Documents.prototype.bind = function bind() {
	        var _click, _change;
	
	        return {
	            click: (_click = {}, _click[DELETE_DOCUMENT_BUTTON_SELECTOR] = this.deleteDocument, _click[DOWNLOAD_FILE_LINK_SELECTOR] = this.downloadFile, _click[DOWNLOAD_DRAFT_SELECTOR] = this.downloadDraftFile, _click),
	            change: (_change = {}, _change[LOAD_FILE_BUTTON_SELECTOR] = this.uploadDocument, _change)
	        };
	    };
	
	    Documents.prototype.uploadDocument = function uploadDocument(e) {
	        var documentTypeId = Number(e.target.attributes['cat-documentTypeId'].value);
	        var file = e.target.files[0];
	
	        this.$context.signal(signals.uploadDocument, { documentTypeId: documentTypeId, file: file });
	    };
	
	    Documents.prototype.deleteDocument = function deleteDocument(e) {
	        var documentId = e.target.attributes['cat-documentId'].value;
	
	        this.$context.signal(signals.deleteDocument, { documentId: documentId });
	    };
	
	    Documents.prototype.downloadFile = function downloadFile(e) {
	        var fileId = Number(e.target.attributes['cat-id'].value);
	
	        this.$context.signal(signals.downloadFile, { fileId: fileId });
	    };
	
	    Documents.prototype.downloadDraftFile = function downloadDraftFile(e) {
	        var typeId = Number(e.target.attributes['cat-type-id'].value);
	        var orderId = e.target.attributes['cat-order-id'].value;
	
	        this.$context.signal(signals.downloadDraftFile, { orderId: orderId, typeId: typeId });
	    };
	
	    return Documents;
	}();
	
	module.exports = {
	    constructor: Documents,
	    children: [{
	        name: 'checkbox',
	        component: Checkbox,
	        props: {
	            signal: signals.setDocumentType
	        },
	        watcher: function watcher(attributes) {
	            return {
	                value: ['account', 'orders', 'currentOrder', 'necessaryDocuments', Number(attributes['cat-path']), 'isChecked']
	            };
	        }
	    }]
	};

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(757);
	
	var _require = __webpack_require__(4),
	    cut = _require.cut;
	
	var _require2 = __webpack_require__(224),
	    _onEdit = _require2.onEdit,
	    _onCancel = _require2.onCancel,
	    _onSave = _require2.onSave;
	
	var EDIT_SELECTOR = cut(css.edit);
	var SAVE_SELECTOR = cut(css.save);
	var CANCEL_SELECTOR = cut(css.cancel);
	
	var Controls = function () {
	    function Controls() {
	        _classCallCheck(this, Controls);
	
	        this.template = __webpack_require__(889);
	    }
	
	    Controls.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    Controls.prototype.bind = function bind() {
	        var _click;
	
	        return {
	            click: (_click = {}, _click[EDIT_SELECTOR] = this.onEdit, _click[SAVE_SELECTOR] = this.onSave, _click[CANCEL_SELECTOR] = this.onCancel, _click)
	        };
	    };
	
	    Controls.prototype.onEdit = function onEdit(e) {
	        e.preventDefault();
	        this.$context.signal(_onEdit);
	    };
	
	    Controls.prototype.onSave = function onSave(e) {
	        e.preventDefault();
	        this.$context.signal(_onSave);
	    };
	
	    Controls.prototype.onCancel = function onCancel(e) {
	        e.preventDefault();
	        this.$context.signal(_onCancel);
	    };
	
	    return Controls;
	}();
	
	module.exports = {
	    constructor: Controls
	};

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CustomOrder = __webpack_require__(150);
	var Controls = __webpack_require__(325);
	var css = __webpack_require__(758);
	
	var EditableOrder = function () {
	    function EditableOrder() {
	        _classCallCheck(this, EditableOrder);
	
	        this.template = __webpack_require__(890);
	    }
	
	    EditableOrder.prototype.render = function render() {
	        var isEditable = this.$context.props.isEditable;
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({ isEditable: isEditable }, data, { css: css });
	        });
	    };
	
	    return EditableOrder;
	}();
	
	module.exports = {
	    constructor: EditableOrder,
	    children: [{
	        name: 'custom-order',
	        component: CustomOrder,
	        props: {
	            isSmallTree: 'true',
	            dontUseMetric: 'true'
	        },
	        watcher: {
	            hideRubrics: ['order', 'computed', 'hideRubrics']
	        }
	    }, {
	        name: 'controls',
	        component: Controls,
	        watcher: {
	            isViewOnlyMode: ['order', 'isDisabled'],
	            isFilerValuesControlEnabled: ['account', 'orders', 'computed', 'componentsState', 'isFilerValuesControlEnabled']
	        }
	    }]
	};

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var signals = __webpack_require__(62);
	
	var _require = __webpack_require__(4),
	    cut = _require.cut;
	
	var css = __webpack_require__(759);
	
	var LOAD_FILE_RESULT_BUTTON_SELECTOR = cut(css.fileResultUploadInput);
	
	var ExportResultUpload = function () {
	    function ExportResultUpload() {
	        _classCallCheck(this, ExportResultUpload);
	
	        this.template = __webpack_require__(891);
	    }
	
	    ExportResultUpload.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    ExportResultUpload.prototype.bind = function bind() {
	        var _change;
	
	        return {
	            change: (_change = {}, _change[LOAD_FILE_RESULT_BUTTON_SELECTOR] = this.uploadResultDocument, _change)
	        };
	    };
	
	    ExportResultUpload.prototype.uploadResultDocument = function uploadResultDocument(e) {
	        var file = e.target.files[0];
	
	        this.$context.signal(signals.uploadResultDocument, { file: file });
	    };
	
	    return ExportResultUpload;
	}();
	
	module.exports = {
	    constructor: ExportResultUpload
	};

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(760);
	var signals = __webpack_require__(62);
	
	var _require = __webpack_require__(4),
	    cut = _require.cut;
	
	var DOWNLOAD_FILE_LINK_SELECTOR = cut(css.downloadFileLink);
	var DELETE_DOCUMENT_BUTTON_SELECTOR = cut(css.deleteDocumentButton);
	var DOWNLOAD_ALL_BUTTON_SELECTOR = cut(css.downloadAllButton);
	
	var ExportResult = function () {
	    function ExportResult() {
	        _classCallCheck(this, ExportResult);
	
	        this.template = __webpack_require__(892);
	    }
	
	    ExportResult.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    ExportResult.prototype.bind = function bind() {
	        var _click;
	
	        return {
	            click: (_click = {}, _click[DOWNLOAD_FILE_LINK_SELECTOR] = this.downloadFile, _click[DELETE_DOCUMENT_BUTTON_SELECTOR] = this.deleteDocument, _click[DOWNLOAD_ALL_BUTTON_SELECTOR] = this.downloadAll, _click)
	        };
	    };
	
	    ExportResult.prototype.downloadFile = function downloadFile(e) {
	        var fileId = Number(e.target.attributes['cat-id'].value);
	
	        this.$context.signal(signals.downloadFile, { fileId: fileId });
	    };
	
	    ExportResult.prototype.deleteDocument = function deleteDocument(e) {
	        var documentId = e.target.attributes['cat-documentId'].value;
	
	        this.$context.signal(signals.deleteResultDocument, { documentId: documentId });
	    };
	
	    ExportResult.prototype.downloadAll = function downloadAll() {
	        this.$context.signal(signals.downloadAll);
	    };
	
	    return ExportResult;
	}();
	
	module.exports = {
	    constructor: ExportResult
	};

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _ = __webpack_require__(3);
	var $ = __webpack_require__(12);
	var Documents = __webpack_require__(324);
	var ActionPanel = __webpack_require__(316);
	var ExportResult = __webpack_require__(328);
	var ExportResultUpload = __webpack_require__(327);
	var OrdersOptions = __webpack_require__(332);
	var css = __webpack_require__(755);
	var EditableOrder = __webpack_require__(326);
	var Price = __webpack_require__(208);
	var IndividualOrderParameters = __webpack_require__(330);
	var Header = __webpack_require__(207);
	var Overlay = __webpack_require__(156);
	var signals = __webpack_require__(63);
	var Preloader = __webpack_require__(101);
	var StatisticBlock = __webpack_require__(333);
	var ordersComputedActions = __webpack_require__(61);
	var currentOrderActions = __webpack_require__(23);
	
	var IS_STICKED = css.isSticked;
	var IS_STICKED2 = css.isSticked2;
	
	var Orders = function () {
	    function Orders() {
	        _classCallCheck(this, Orders);
	
	        this.template = __webpack_require__(899);
	    }
	
	    Orders.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    Orders.prototype.bind = function bind() {
	        this.$context.signal(signals.getExportResults);
	        this.$context.signal(signals.getOrderState);
	        this.$context.signal(signals.getHasBitrixLeads);
	
	        this.initScroller();
	    };
	
	    Orders.prototype.unbind = function unbind() {
	        $(window).unbind('scroll', this._scrollHandler);
	    };
	
	    Orders.prototype.initScroller = function initScroller() {
	        this.headerHeight = $('#orderHeader').offset().top;
	        this.wrapperElement = $('#orderHeader');
	
	        this.wrapperElement2 = $('#orderParametersHeader');
	        var wrapperElement2Offset = this.wrapperElement2.offset();
	        this.headerHeight2 = wrapperElement2Offset ? wrapperElement2Offset.top : 0;
	
	        this._scrollHandler = _.bind(this.scrollHandler, this);
	
	        $(window).scroll(this._scrollHandler);
	        this.scrollHandler();
	    };
	
	    Orders.prototype.scrollHandler = function scrollHandler() {
	        var topView = $(window).scrollTop();
	        var viewLessHeader = topView >= this.headerHeight;
	        var viewLessHeader2 = topView >= this.headerHeight2;
	
	        this.wrapperElement.toggleClass(IS_STICKED, viewLessHeader);
	        this.wrapperElement2.toggleClass(IS_STICKED2, viewLessHeader2);
	    };
	
	    return Orders;
	}();
	
	module.exports = {
	    constructor: Orders,
	    children: [{
	        name: 'overlay',
	        component: Overlay,
	        watcher: {
	            isLoading: ['account', 'orders', 'currentOrder', 'isLoading']
	        }
	    }, {
	        name: 'documents',
	        component: Documents,
	        watcher: {
	            documents: ['account', 'orders', 'currentOrder', 'necessaryDocuments'],
	            showNecessaryDocumentsAddDeleteButtons: ordersComputedActions.PATHS.showNecessaryDocumentsAddDeleteButtons,
	            showUploadFailTooltip: currentOrderActions.PATHS.showUploadFailTooltip,
	            showDocumentsWillBeUploadedTooltip: ['account', 'orders', 'computed', 'componentsState', 'showDocumentsWillBeUploadedTooltip'],
	            showBillDocumentMustBeAttached: currentOrderActions.PATHS.showBillDocumentMustBeAttached,
	            showBillDraftDownloadButton: ['account', 'orders', 'computed', 'componentsState', 'showBillDraftDownloadButton'],
	            orderId: ['account', 'orders', 'currentOrder', 'id']
	        }
	    }, {
	        name: 'action-panel',
	        component: ActionPanel,
	        watcher: {
	            showLicenseAgreementCheckbox: ['account', 'orders', 'computed', 'componentsState', 'showLicenseAgreementCheckbox'],
	            showLicenseMustBeAccepted: ['account', 'orders', 'currentOrder', 'tooltips', 'showLicenseMustBeAccepted'],
	            showContinueButton: ['account', 'orders', 'computed', 'componentsState', 'showContinueButton'],
	            showMakeOrderButton: ['account', 'orders', 'computed', 'componentsState', 'showMakeOrderButton'],
	            showPayOnlineButton: ['account', 'orders', 'computed', 'componentsState', 'showPayOnlineButton'],
	            showArchiveButton: ['account', 'orders', 'computed', 'componentsState', 'showArchiveButton'],
	            showSaveAllButton: ['account', 'orders', 'computed', 'componentsState', 'showSaveAllButton'],
	            continueButtonLabel: ['account', 'orders', 'computed', 'componentsState', 'continueButtonLabel'],
	            showRepeatButton: ['account', 'orders', 'computed', 'componentsState', 'showRepeatButton'],
	            showBitrixExportButton: ['account', 'orders', 'computed', 'componentsState', 'showBitrixExportButton'],
	            showFreeBitrixExportButton: ['account', 'orders', 'computed', 'componentsState', 'showFreeBitrixExportButton'],
	            disableContinue: ['account', 'orders', 'disableContinue'],
	            hasBitrixLeads: ['account', 'orders', 'currentOrder', 'hasBitrixLeads'],
	            isBitrix: ['bitrix', 'isBitrix'],
	            exportResult: ['account', 'orders', 'currentOrder', 'exportResult'],
	            isManager: ['user', 'isManager']
	        }
	    }, {
	        name: 'export-result',
	        component: ExportResult,
	        watcher: {
	            exportResult: ['account', 'orders', 'currentOrder', 'exportResult'],
	            showDownloadAllButton: ['account', 'orders', 'computed', 'componentsState', 'showDownloadAllButton'],
	            isCanDeleteResult: ordersComputedActions.PATHS.isCanDeleteResult
	        }
	    }, {
	        name: 'export-result-upload',
	        component: ExportResultUpload,
	        watcher: {
	            isExportResultMustBeAttached: currentOrderActions.PATHS.isExportResultMustBeAttached
	        }
	    }, {
	        name: 'custom-order',
	        component: EditableOrder,
	        watcher: {
	            isEditable: ['account', 'orders', 'computed', 'currentOrder', 'isEditable']
	        }
	    }, {
	        name: 'price',
	        component: Price,
	        watcher: {
	            isShowAsterisk: ordersComputedActions.PATHS.isShowSumCanChangeTooltip,
	            rowPrice: ['account', 'orders', 'computed', 'price', 'data', 'total', 'rowPrice'],
	            totalPrice: ['account', 'orders', 'computed', 'price', 'data', 'total', 'totalPrice'],
	            rowAmount: ['account', 'orders', 'computed', 'price', 'data', 'total', 'rowAmount'],
	            isLoading: ['account', 'orders', 'computed', 'price', 'isLoading']
	        }
	    }, {
	        name: 'individual-order-parameters',
	        component: IndividualOrderParameters,
	        watcher: {
	            showPriceMustBeBiggerThanZero: currentOrderActions.PATHS.showPriceMustBeBiggerThanZero,
	            orderAmountError: currentOrderActions.PATHS.orderAmountError
	        }
	    }, {
	        name: 'orders-options',
	        component: OrdersOptions,
	        watcher: {
	            showManager: ['account', 'orders', 'computed', 'componentsState', 'showManager'],
	            showUser: ['account', 'orders', 'computed', 'componentsState', 'showUser'],
	            showPaymentType: ['account', 'orders', 'computed', 'componentsState', 'showPaymentType'],
	            showManagerSelect: ['account', 'orders', 'computed', 'componentsState', 'showManagerSelect'],
	            showUserSelect: ['account', 'orders', 'computed', 'componentsState', 'showUserSelect'],
	            managerName: ['account', 'orders', 'computed', 'currentOrder', 'manager', 'fullName'],
	            managerEmail: ['account', 'orders', 'currentOrder', 'manager', 'email'],
	            userName: ['account', 'orders', 'computed', 'currentOrder', 'user', 'fullName'],
	            totalPrice: ['account', 'orders', 'computed', 'price', 'data', 'total', 'totalPrice'],
	            showUserMustBeSelected: ['account', 'orders', 'currentOrder', 'tooltips', 'showUserMustBeSelected'],
	            showPaymentTypeChangePanel: ['account', 'orders', 'computed', 'componentsState', 'showPaymentTypeChangePanel'],
	            onlinePaymentDisabled: ['account', 'orders', 'computed', 'componentsState', 'onlinePaymentDisabled'],
	            paymentName: ['account', 'orders', 'computed', 'currentOrder', 'paymentName'],
	            isManager: ['user', 'isManager'],
	            userId: ['account', 'orders', 'currentOrder', 'user', 'id']
	        }
	    }, {
	        name: 'header',
	        component: Header,
	        watcher: {
	            id: ['account', 'orders', 'currentOrder', 'id'],
	            createDate: ['account', 'orders', 'computed', 'currentOrder', 'createDate'],
	            stateName: ['account', 'orders', 'computed', 'currentOrder', 'stateName']
	        }
	    }, {
	        name: 'preloader',
	        component: Preloader,
	        props: {
	            size: 'medium'
	        }
	    }, {
	        name: 'statistic-block',
	        component: StatisticBlock,
	        watcher: {
	            id: ['account', 'orders', 'currentOrder', 'id'],
	            showOrderStatistic: ['account', 'orders', 'computed', 'componentsState', 'showOrderStatistic'],
	            isOrderChanging: ['account', 'orders', 'currentOrder', 'filterValuesChanged'],
	            orderCitiesTab: ['order', 'cities', 'tab']
	        }
	    }]
	};

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _require = __webpack_require__(24),
	    Text = _require.Text;
	
	var signals = __webpack_require__(62);
	var ordersComputedActions = __webpack_require__(61);
	var currentOrderActions = __webpack_require__(23);
	var SCHEMES = __webpack_require__(22);
	var css = __webpack_require__(762);
	
	var IndividualOrderParameters = function () {
	    function IndividualOrderParameters() {
	        _classCallCheck(this, IndividualOrderParameters);
	
	        this.template = __webpack_require__(894);
	    }
	
	    IndividualOrderParameters.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    return IndividualOrderParameters;
	}();
	
	module.exports = {
	    constructor: IndividualOrderParameters,
	    children: [{
	        name: 'order-amount-input',
	        component: Text,
	        props: {
	            signals: { inputText: signals.amountInputText, blurText: signals.amountInputBlur },
	            position: 'leftToRight',
	            scheme: SCHEMES.number
	        },
	        watcher: {
	            value: currentOrderActions.PATHS.orderAmount,
	            isDisabled: ordersComputedActions.PATHS.isDisabledAmountField
	        }
	    }]
	};

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _require = __webpack_require__(24),
	    Text = _require.Text;
	
	var formSignals = __webpack_require__(26);
	var css = __webpack_require__(763);
	
	var _require2 = __webpack_require__(4),
	    cut = _require2.cut;
	
	var signals = __webpack_require__(492);
	var SCHEMES = __webpack_require__(22);
	
	var SELECTOR_CREATE = cut(css.createBtn);
	
	var CreateUser = function () {
	    function CreateUser() {
	        _classCallCheck(this, CreateUser);
	
	        this.template = __webpack_require__(895);
	    }
	
	    CreateUser.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    CreateUser.prototype.bind = function bind() {
	        var _click;
	
	        return {
	            click: (_click = {}, _click[SELECTOR_CREATE] = this.onCreateUser, _click)
	        };
	    };
	
	    CreateUser.prototype.onCreateUser = function onCreateUser() {
	        this.$context.signal(signals.onCreateUserStub);
	    };
	
	    return CreateUser;
	}();
	
	module.exports = {
	    constructor: CreateUser,
	    children: [{
	        name: 'email-input',
	        component: Text,
	        props: {
	            placeholder: 'Создать по Email',
	            signals: {
	                inputText: formSignals.inputAndValidateText,
	                blurText: formSignals.blurText
	            },
	            position: 'leftToRight',
	            scheme: SCHEMES.email
	        },
	        watcher: {
	            value: ['account', 'orders', 'createUser', 'input', 'email']
	        }
	    }]
	};

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(764);
	
	var _require = __webpack_require__(24),
	    FilteredSelect = _require.FilteredSelect,
	    Text = _require.Text,
	    Select = _require.Select,
	    Radio = _require.Radio;
	
	var signals = __webpack_require__(62);
	
	var _require2 = __webpack_require__(26),
	    inputText = _require2.inputText,
	    blurText = _require2.blurText;
	
	var CreateUser = __webpack_require__(331);
	
	var _require3 = __webpack_require__(11),
	    _redirect = _require3.redirect;
	
	var _require4 = __webpack_require__(61),
	    PATHS = _require4.PATHS;
	
	var _require5 = __webpack_require__(4),
	    cut = _require5.cut;
	
	var OrdersOptions = function () {
	    function OrdersOptions() {
	        _classCallCheck(this, OrdersOptions);
	
	        this.template = __webpack_require__(896);
	    }
	
	    OrdersOptions.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            data.managerName = data.managerName || 'Не назначен';
	
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    OrdersOptions.prototype.bind = function bind() {
	        var _click;
	
	        return {
	            click: (_click = {}, _click[cut(css.redirect)] = this.redirect, _click)
	        };
	    };
	
	    OrdersOptions.prototype.redirect = function redirect(e) {
	        e.stopPropagation();
	        var url = e.currentTarget.getAttribute('cat-url');
	        this.$context.signal(_redirect, { url: url });
	    };
	
	    return OrdersOptions;
	}();
	
	module.exports = {
	    constructor: OrdersOptions,
	    children: [{
	        name: 'user-filtered-select',
	        component: FilteredSelect,
	        props: {
	            signalInputText: inputText,
	            signalBlurText: blurText,
	            signalOnSelect: signals.selectUser,
	            signalOnToggle: signals.togglePopup,
	            filterPlaceholder: 'Отфильтровать...'
	        },
	        watcher: {
	            options: PATHS.optionsFiltered,
	            isDisable: ['account', 'orders', 'computed', 'selectedUser', 'isDisable'],
	            isOpen: ['account', 'popups', 'userSelect', 'isOpen'],
	            header: ['account', 'orders', 'computed', 'selectedUser', 'header'],
	            filterValue: PATHS.usersListFilter
	        }
	    }, {
	        name: 'user-search',
	        component: CreateUser,
	        watcher: {
	            showCreateError: ['account', 'orders', 'createUser', 'error', 'createError'],
	            error: ['account', 'orders', 'createUser', 'error', 'email'],
	            isEnabled: ['account', 'orders', 'computed', 'createUserIsEnabled']
	        }
	    }, {
	        name: 'manager-select',
	        component: Select,
	        props: {
	            signalOnSelect: signals.selectManager,
	            signalOnToggle: signals.togglePopup
	        },
	        watcher: {
	            options: ['account', 'orders', 'computed', 'selectedManager', 'options'],
	            isDisable: ['account', 'orders', 'computed', 'selectedManager', 'isDisable'],
	            isOpen: ['account', 'popups', 'managerSelect', 'isOpen'],
	            header: ['account', 'orders', 'computed', 'selectedManager', 'header']
	        }
	    }, {
	        name: 'radio-invoice',
	        component: Radio,
	        props: {
	            signal: signals.selectPaymentType
	        },
	        watcher: {
	            value: ['account', 'orders', 'computed', 'paymentType', 'invoice']
	        }
	    }, {
	        name: 'radio-online',
	        component: Radio,
	        props: {
	            signal: signals.selectPaymentType
	        },
	        watcher: {
	            value: ['account', 'orders', 'computed', 'paymentType', 'online']
	        }
	    }, {
	        name: 'name',
	        component: Text,
	        props: {
	            signals: { inputText: signals.nameInputText, blurText: [] },
	            position: 'leftToRight'
	        },
	        watcher: {
	            value: ['account', 'orders', 'currentOrder', 'name'],
	            error: ['account', 'orders', 'currentOrder', 'error', 'name']
	        }
	    }]
	};

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(766);
	
	var _require = __webpack_require__(4),
	    cut = _require.cut;
	
	var utils = __webpack_require__(11);
	
	var ExportResult = function () {
	    function ExportResult() {
	        _classCallCheck(this, ExportResult);
	
	        this.template = __webpack_require__(898);
	    }
	
	    ExportResult.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    ExportResult.prototype.bind = function bind() {
	        var _click;
	
	        return {
	            click: (_click = {}, _click[cut(css.redirect)] = this.redirect, _click)
	        };
	    };
	
	    ExportResult.prototype.redirect = function redirect(e) {
	        e.stopPropagation();
	        var url = e.currentTarget.getAttribute('cat-url');
	        this.$context.signal(utils.redirect, { url: url });
	    };
	
	    return ExportResult;
	}();
	
	module.exports = {
	    constructor: ExportResult
	};

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var OrderWrapper = __webpack_require__(335);
	var OrdersNavigation = __webpack_require__(336);
	var css = __webpack_require__(776);
	
	var Orders = function () {
	    function Orders() {
	        _classCallCheck(this, Orders);
	
	        this.template = __webpack_require__(909);
	    }
	
	    Orders.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    return Orders;
	}();
	
	module.exports = {
	    constructor: Orders,
	    children: [{
	        name: 'order-wrapper',
	        component: OrderWrapper,
	        watcher: {
	            currentOrderId: ['account', 'orders', 'currentOrder', 'id'],
	            isOrderListInitialized: ['account', 'orders', 'list', 'initialized'],
	            showBitrixLeadMapping: ['account', 'orders', 'currentOrder', 'showBitrixLeadMapping']
	        }
	    }, {
	        name: 'orders-navigation',
	        component: OrdersNavigation,
	        watcher: {
	            isManager: ['user', 'isManager'],
	            isError: ['account', 'orders', 'list', 'isError']
	        }
	    }]
	};

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CurrentOrder = __webpack_require__(329);
	var css = __webpack_require__(767);
	
	var _require = __webpack_require__(4),
	    cut = _require.cut;
	
	var signals = __webpack_require__(62);
	var BitrixExportLeads = __webpack_require__(321);
	
	var _require2 = __webpack_require__(11),
	    _redirect = _require2.redirect;
	
	var ordersComputedActions = __webpack_require__(61);
	var currentOrderActions = __webpack_require__(23);
	
	var OrderWrapper = function () {
	    function OrderWrapper() {
	        _classCallCheck(this, OrderWrapper);
	
	        this.template = __webpack_require__(900);
	    }
	
	    OrderWrapper.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    OrderWrapper.prototype.bind = function bind() {
	        var _click;
	
	        this.$context.signal(signals.wrapperOnLoad);
	
	        return {
	            click: (_click = {}, _click[cut(css.redirect)] = this.redirect, _click)
	        };
	    };
	
	    OrderWrapper.prototype.redirect = function redirect(e) {
	        e.stopPropagation();
	        var url = e.currentTarget.getAttribute('cat-url');
	        this.$context.signal(_redirect, { url: url });
	    };
	
	    return OrderWrapper;
	}();
	
	module.exports = {
	    constructor: OrderWrapper,
	    children: [{
	        name: 'current-order',
	        component: CurrentOrder,
	        watcher: {
	            exportResult: ['account', 'orders', 'currentOrder', 'exportResult'],
	            necessaryDocuments: ['account', 'orders', 'currentOrder', 'necessaryDocuments'],
	            specialInfo: ['account', 'orders', 'computed', 'componentsState', 'specialInfo'],
	            showActionPanel: ['account', 'orders', 'computed', 'componentsState', 'showActionPanel'],
	            showSumCanChangeTooltip: ordersComputedActions.PATHS.isShowSumCanChangeTooltip,
	            showPriceMustBeBiggerThanZero: currentOrderActions.PATHS.showPriceMustBeBiggerThanZero,
	            showChangesMustBeSavedOrCancelled: ['account', 'orders', 'currentOrder', 'tooltips', 'showChangesMustBeSavedOrCancelled'],
	            showDataChangeTooltip: ['account', 'orders', 'computed', 'componentsState', 'showDataChangeTooltip'],
	            showDataOutdatedTooltip: ['account', 'orders', 'currentOrder', 'isDataOutdated'],
	            showExportResult: ['account', 'orders', 'computed', 'componentsState', 'showExportResult'],
	            isManager: ['user', 'isManager'],
	            freeLeadsAmount: ['account', 'orders', 'currentOrder', 'freeLeadsAmount'],
	            isShowOrderParameters: ordersComputedActions.PATHS.isShowOrderParameters,
	            isShowIndividualOrderParameters: ordersComputedActions.PATHS.isShowIndividualOrderParameters,
	            isShowResultUploadButton: ordersComputedActions.PATHS.isShowResultUploadButton,
	            isLoadingUploadResultDocument: ordersComputedActions.PATHS.isLoadingUploadResultDocument,
	            isShowUploadResultFailTooltip: currentOrderActions.PATHS.isShowUploadResultFailTooltip
	        }
	    }, {
	        name: 'leads',
	        component: BitrixExportLeads,
	        watcher: {
	            hermesFields: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'hermesFields'],
	            hasFieldCreationRight: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'hasFieldCreationRight'],
	            freeLeadsAmount: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'freeLeadsAmount'],
	            isOnlyFreeLeads: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'isOnlyFreeLeads']
	        }
	    }]
	};

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(774);
	var signals = __webpack_require__(73);
	
	var _require = __webpack_require__(62),
	    selectOrderType = _require.selectOrderType;
	
	var _require2 = __webpack_require__(4),
	    cut = _require2.cut;
	
	var _require3 = __webpack_require__(24),
	    Select = _require3.Select,
	    Radio = _require3.Radio;
	
	var OrderStateCollapser = __webpack_require__(339);
	var OrderManagerCollapser = __webpack_require__(337);
	var OrderTypeCollapser = __webpack_require__(341);
	var OrdersList = __webpack_require__(343);
	var TextFilter = __webpack_require__(344);
	
	var OrdersNavigation = function () {
	    function OrdersNavigation() {
	        _classCallCheck(this, OrdersNavigation);
	
	        this.template = __webpack_require__(907);
	    }
	
	    OrdersNavigation.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    OrdersNavigation.prototype.bind = function bind() {
	        var _click;
	
	        this.$context.signal(signals.onLoad);
	        return {
	            click: (_click = {}, _click[cut(css.clearFiltersButton)] = this.clearFilters, _click)
	        };
	    };
	
	    OrdersNavigation.prototype.clearFilters = function clearFilters() {
	        this.$context.signal(signals.clearFilters);
	    };
	
	    return OrdersNavigation;
	}();
	
	module.exports = {
	    constructor: OrdersNavigation,
	    children: [{
	        name: 'select',
	        component: Select,
	        props: {
	            signalOnSelect: signals.selectFilter,
	            signalOnToggle: signals.togglePopup
	        },
	        watcher: {
	            options: ['account', 'orders', 'computed', 'typeFilter', 'options'],
	            isDisabled: ['account', 'orders', 'computed', 'typeFilter', 'isDisabled'],
	            isOpen: ['account', 'popups', 'ordersFilter', 'isOpen']
	        }
	    }, {
	        name: 'order-state-collapser',
	        component: OrderStateCollapser
	    }, {
	        name: 'order-manager-collapser',
	        component: OrderManagerCollapser
	    }, {
	        name: 'order-type-collapser',
	        component: OrderTypeCollapser
	    }, {
	        name: 'text-filter',
	        component: TextFilter
	    }, {
	        name: 'orders-list',
	        component: OrdersList,
	        watcher: {
	            ordersList: ['account', 'orders', 'computed', 'ordersList'],
	            isManager: ['user', 'isManager']
	        }
	    }]
	};

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Collapse = __webpack_require__(148);
	var OrderManagerFilter = __webpack_require__(338);
	var Header = __webpack_require__(147);
	
	module.exports = module.exports = {
	    constructor: Collapse,
	    children: [{
	        name: 'content',
	        component: OrderManagerFilter
	    }, {
	        name: 'header',
	        component: Header,
	        props: {
	            title: 'Менеджер'
	        },
	        watcher: {
	            isActive: ['account', 'orders', 'computed', 'list', 'isAssignTypeFilterActive']
	        }
	    }]
	};

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var signals = __webpack_require__(73);
	var css = __webpack_require__(770);
	
	var _require = __webpack_require__(24),
	    Radio = _require.Radio;
	
	var RadioGroup = function () {
	    function RadioGroup() {
	        _classCallCheck(this, RadioGroup);
	
	        this.template = __webpack_require__(903);
	    }
	
	    RadioGroup.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    return RadioGroup;
	}();
	
	module.exports = {
	    constructor: RadioGroup,
	    children: [{
	        name: 'radio-any',
	        component: Radio,
	        props: {
	            signal: signals.checkAssigned
	        },
	        watcher: {
	            value: ['account', 'orders', 'computed', 'assignType', 'any']
	        }
	    }, {
	        name: 'radio-my',
	        component: Radio,
	        props: {
	            signal: signals.checkAssigned
	        },
	        watcher: {
	            value: ['account', 'orders', 'computed', 'assignType', 'my']
	        }
	    }, {
	        name: 'radio-unassigned',
	        component: Radio,
	        props: {
	            signal: signals.checkAssigned
	        },
	        watcher: {
	            value: ['account', 'orders', 'computed', 'assignType', 'unassigned']
	        }
	    }]
	};

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Collapse = __webpack_require__(148);
	var OrderStateFilter = __webpack_require__(340);
	var Header = __webpack_require__(147);
	
	module.exports = module.exports = {
	    constructor: Collapse,
	    children: [{
	        name: 'content',
	        component: OrderStateFilter,
	        watcher: {
	            orderStates: ['account', 'orders', 'list', 'statusFilterData']
	        }
	    }, {
	        name: 'header',
	        component: Header,
	        props: {
	            title: 'Статус заказа'
	        },
	        watcher: {
	            isActive: ['account', 'orders', 'computed', 'list', 'selectedStates']
	        }
	    }]
	};

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(771);
	
	var _require = __webpack_require__(44),
	    Checkbox = _require.Checkbox;
	
	var _require2 = __webpack_require__(73),
	    setStatusFilterItem = _require2.setStatusFilterItem;
	
	var OrderStateFilter = function () {
	    function OrderStateFilter() {
	        _classCallCheck(this, OrderStateFilter);
	
	        this.template = __webpack_require__(904);
	    }
	
	    OrderStateFilter.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    return OrderStateFilter;
	}();
	
	module.exports = {
	    constructor: OrderStateFilter,
	    children: [{
	        name: 'checkbox',
	        component: Checkbox,
	        props: {
	            signal: setStatusFilterItem
	        },
	        watcher: function watcher(attributes) {
	            return {
	                value: ['account', 'orders', 'list', 'stateFilter', attributes['cat-path'], 'isChecked']
	            };
	        }
	    }]
	};

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Collapse = __webpack_require__(148);
	var OrderTypeFilter = __webpack_require__(342);
	var Header = __webpack_require__(147);
	
	module.exports = module.exports = {
	    constructor: Collapse,
	    children: [{
	        name: 'content',
	        component: OrderTypeFilter,
	        watcher: {
	            orderStates: ['account', 'orders', 'list', 'typeFilterData']
	        }
	    }, {
	        name: 'header',
	        component: Header,
	        props: {
	            title: 'Тип заказа'
	        },
	        watcher: {
	            isActive: ['account', 'orders', 'computed', 'list', 'selectedTypes']
	        }
	    }]
	};

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(772);
	
	var _require = __webpack_require__(44),
	    Checkbox = _require.Checkbox;
	
	var _require2 = __webpack_require__(73),
	    setTypeFilterItem = _require2.setTypeFilterItem;
	
	var OrderTypeFilter = function () {
	    function OrderTypeFilter() {
	        _classCallCheck(this, OrderTypeFilter);
	
	        this.template = __webpack_require__(905);
	    }
	
	    OrderTypeFilter.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    return OrderTypeFilter;
	}();
	
	module.exports = {
	    constructor: OrderTypeFilter,
	    children: [{
	        name: 'checkbox',
	        component: Checkbox,
	        props: {
	            signal: setTypeFilterItem
	        },
	        watcher: function watcher(attributes) {
	            return {
	                value: ['account', 'orders', 'list', 'typeFilter', attributes['cat-path'], 'isChecked']
	            };
	        }
	    }]
	};

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(773);
	var signals = __webpack_require__(73);
	
	var _require = __webpack_require__(63),
	    _selectOrder = _require.selectOrder;
	
	var _require2 = __webpack_require__(4),
	    cut = _require2.cut;
	
	var _require3 = __webpack_require__(11),
	    _redirect = _require3.redirect;
	
	var $ = __webpack_require__(12);
	var _ = __webpack_require__(3);
	
	var LIST_WRAPPER_SELECTOR = cut(css.listWrapper);
	var LIST_SELECTOR = cut(css.list);
	var LINK_SELECTOR = cut(css.link);
	var SCROLLBAR_SELECTOR = cut(css.scrollbar);
	var SCROLLTRACK_SELECTOR = cut(css.scrolltrack);
	var LIST_CONTENT = cut(css.listContent);
	
	var OrdersList = function () {
	    function OrdersList() {
	        _classCallCheck(this, OrdersList);
	
	        this.template = __webpack_require__(906);
	    }
	
	    OrdersList.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    OrdersList.prototype.bind = function bind() {
	        var _click;
	
	        this.initBaron();
	        this.handleWindowScroll();
	
	        var $el = $(this.$context.element);
	
	        this.$wrapper = $el.find(LIST_SELECTOR);
	        this.$scrollContent = this.$wrapper.find(LIST_CONTENT);
	
	        this._scrollHanlder = _.bind(_.debounce(this.updateScroll, 100), this);
	        this.$wrapper.on('scroll', this._scrollHanlder);
	
	        return {
	            click: (_click = {}, _click[LINK_SELECTOR] = this.selectOrder, _click)
	        };
	    };
	
	    OrdersList.prototype.unbind = function unbind() {
	        if (this.$wrapper) {
	            this.$wrapper.off('scroll', this._scrollHanlder);
	        }
	
	        $(LIST_WRAPPER_SELECTOR).off('mouseenter', this.blockWindowScroll);
	        $(LIST_WRAPPER_SELECTOR).off('mouseleave', this.unblockWindowScroll);
	        $('body').off('mouseenter', this.unblockWindowScroll);
	    };
	
	    OrdersList.prototype.initBaron = function initBaron() {
	        var baron = __webpack_require__(64);
	        var elementId = this.$context.attributes.id;
	
	        baron({
	            root: '#' + elementId + ' ' + LIST_WRAPPER_SELECTOR,
	            scroller: LIST_SELECTOR,
	            bar: SCROLLBAR_SELECTOR,
	            track: SCROLLTRACK_SELECTOR,
	            $: $
	        });
	    };
	
	    OrdersList.prototype.handleWindowScroll = function handleWindowScroll() {
	        $(LIST_WRAPPER_SELECTOR).on('mouseenter', this.blockWindowScroll);
	        $(LIST_WRAPPER_SELECTOR).on('mouseleave', this.unblockWindowScroll);
	        $('body').on('mouseenter', this.unblockWindowScroll);
	    };
	
	    OrdersList.prototype.selectOrder = function selectOrder(e) {
	        e.stopPropagation();
	        e.preventDefault();
	
	        var orderId = e.currentTarget.getAttribute('cat-id');
	
	        this.$context.signal(_selectOrder, { orderId: orderId });
	    };
	
	    OrdersList.prototype.updateScroll = function updateScroll() {
	        var wrapperHeight = this.$wrapper.outerHeight();
	        var contentHeight = this.$scrollContent.outerHeight();
	        var scrollTop = this.$wrapper.scrollTop();
	
	        if (scrollTop + wrapperHeight >= contentHeight - 100) {
	            this.$context.signal(signals.scrolledToBottom);
	        }
	    };
	
	    OrdersList.prototype.blockWindowScroll = function blockWindowScroll() {
	        var x = window.scrollX || window.pageXOffset || document.body.scrollLeft;
	        var y = window.scrollY || window.pageYOffset || document.body.scrollTop;
	
	        window.onscroll = function () {
	            window.scrollTo(x, y);
	        };
	    };
	
	    OrdersList.prototype.unblockWindowScroll = function unblockWindowScroll() {
	        window.onscroll = null;
	    };
	
	    OrdersList.prototype.redirect = function redirect(e) {
	        e.stopPropagation();
	        var url = e.currentTarget.getAttribute('cat-url');
	        this.$context.signal(_redirect, { url: url });
	    };
	
	    return OrdersList;
	}();
	
	module.exports = {
	    constructor: OrdersList
	};

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _ = __webpack_require__(3);
	
	var _require = __webpack_require__(4),
	    cut = _require.cut;
	
	var css = __webpack_require__(775);
	
	var _require2 = __webpack_require__(73),
	    filterOrdersListByText = _require2.filterOrdersListByText,
	    setTextFilterValue = _require2.setTextFilterValue;
	
	var minLength = 2;
	
	var SELECTOR_FILTER = cut(css.filter);
	
	var Filter = function () {
	    function Filter() {
	        _classCallCheck(this, Filter);
	
	        this.template = __webpack_require__(908);
	    }
	
	    Filter.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    Filter.prototype.bind = function bind() {
	        var _input;
	
	        this.initFilter();
	        return {
	            input: (_input = {}, _input[SELECTOR_FILTER] = _.debounce(this.filterChange, 500), _input)
	        };
	    };
	
	    Filter.prototype.initFilter = function initFilter() {
	        this.$context.signal(setTextFilterValue, { id: 'managerOrderTextFilter', path: ['account', 'orders', 'list', 'filterText'] });
	    };
	
	    Filter.prototype.filterChange = function filterChange(e) {
	        e.stopPropagation();
	        var textFilterValue = e.currentTarget.value;
	        this.$context.signal(filterOrdersListByText, { textFilterValue: textFilterValue, minLength: minLength });
	    };
	
	    return Filter;
	}();
	
	module.exports = {
	    constructor: Filter
	};

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(777);
	
	var _require = __webpack_require__(4),
	    cut = _require.cut;
	
	var utils = __webpack_require__(11);
	var signals = __webpack_require__(102);
	var preloader = __webpack_require__(101);
	
	var ActionPanel = function () {
	    function ActionPanel() {
	        _classCallCheck(this, ActionPanel);
	
	        this.template = __webpack_require__(910);
	    }
	
	    ActionPanel.prototype.bind = function bind() {
	        var _click;
	
	        return {
	            click: (_click = {}, _click[cut(css.redirect)] = this.redirect, _click[cut(css.switchModeButton)] = this.switchModeButton, _click[cut(css.downloadExcel)] = this.downloadExcel, _click)
	        };
	    };
	
	    ActionPanel.prototype.render = function render() {
	        var props = this.$context.props;
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, props, { css: css });
	        });
	    };
	
	    ActionPanel.prototype.switchModeButton = function switchModeButton(e) {
	        e.stopPropagation();
	        this.$context.signal(signals.switchCityBranchMode);
	    };
	
	    ActionPanel.prototype.redirect = function redirect(e) {
	        e.stopPropagation();
	        var url = e.currentTarget.getAttribute('cat-url');
	        this.$context.signal(utils.redirect, { url: url });
	    };
	
	    ActionPanel.prototype.downloadExcel = function downloadExcel(e) {
	        e.stopPropagation();
	        this.$context.signal(signals.downloadExcel);
	    };
	
	    return ActionPanel;
	}();
	
	module.exports = {
	    constructor: ActionPanel,
	    children: [{
	        name: 'preloader',
	        component: preloader,
	        props: {
	            size: 'big'
	        }
	    }]
	};

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(782);
	var signals = __webpack_require__(102);
	var Scrollable = __webpack_require__(348);
	var ActionPanel = __webpack_require__(345);
	var _ = __webpack_require__(3);
	var $ = __webpack_require__(12);
	
	var Statistic = function () {
	    function Statistic() {
	        _classCallCheck(this, Statistic);
	
	        this.template = __webpack_require__(915);
	    }
	
	    Statistic.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    Statistic.prototype.bind = function bind() {
	        this.getStatisticChunk();
	
	        var scrollable = document.getElementById('scrollable');
	
	        scrollable.addEventListener('scroll', _.bind(_.debounce(this.getStatisticChunk, 50), this), false);
	
	        scrollable.addEventListener('scroll', _.bind(_.debounce(this.updateHeaderPosition, 50), this), false);
	
	        window.addEventListener('resize', this.updateScrollableMaxHeight, false);
	        this.isListenersInit = true;
	
	        this.updateHeaderPosition();
	        this.updateScrollableMaxHeight();
	    };
	
	    Statistic.prototype.updateHeaderPosition = function updateHeaderPosition() {
	        var target = document.getElementById('scrollable');
	        var topHeaderOffset = target.scrollTop;
	        var headerLeftOffsetLeft = target.scrollLeft;
	        this.$context.signal(signals.updateHeaderPosition, { topHeaderOffset: topHeaderOffset, headerLeftOffsetLeft: headerLeftOffsetLeft });
	    };
	
	    Statistic.prototype.updateScrollableMaxHeight = function updateScrollableMaxHeight() {
	        var headerHeight = 80;
	        var actionPanelHeight = 50;
	        var scrollableMaxHeight = $(window).height() - headerHeight - actionPanelHeight;
	        var scrollable = document.getElementById('scrollable');
	        scrollable.style.maxHeight = scrollableMaxHeight + 'px';
	        scrollable.style.minHeight = scrollableMaxHeight + 'px';
	    };
	
	    Statistic.prototype.getStatisticChunk = function getStatisticChunk() {
	        this.$context.signal(signals.getStatisticChunk);
	    };
	
	    return Statistic;
	}();
	
	module.exports = {
	    constructor: Statistic,
	    children: [{
	        name: 'scrollable',
	        component: Scrollable,
	        watcher: {
	            orderId: ['account', 'statistic', 'orderId'],
	            data: ['account', 'statistic', 'data'],
	            topOffset: ['account', 'statistic', 'topOffset'],
	            leftOffset: ['account', 'statistic', 'leftOffset'],
	            headerTopOffset: ['account', 'statistic', 'header', 'topOffset'],
	            headerLeftOffsetLeft: ['account', 'statistic', 'header', 'left', 'offset', 'left'],
	            height: ['account', 'statistic', 'height'],
	            width: ['account', 'statistic', 'width'],
	            yStartIndex: ['account', 'statistic', 'yStartIndex']
	        }
	    }, {
	        name: 'action-panel',
	        component: ActionPanel,
	        watcher: {
	            isByBranch: ['account', 'statistic', 'isByBranch'],
	            downloadExcelLock: ['account', 'statistic', 'downloadExcelLock']
	        }
	    }]
	};

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(778);
	var signals = __webpack_require__(102);
	
	var _require = __webpack_require__(4),
	    cut = _require.cut;
	
	var CornerHeader = function () {
	    function CornerHeader() {
	        _classCallCheck(this, CornerHeader);
	
	        this.template = __webpack_require__(911);
	        this.isListenersInit = false;
	    }
	
	    CornerHeader.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    CornerHeader.prototype.bind = function bind() {
	        var _click;
	
	        return {
	            click: (_click = {}, _click[cut(css.transpose)] = this.transpose, _click)
	        };
	    };
	
	    CornerHeader.prototype.transpose = function transpose() {
	        this.$context.signal(signals.toggleTranspose);
	    };
	
	    return CornerHeader;
	}();
	
	module.exports = {
	    constructor: CornerHeader
	};

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(780);
	var leftHeader = __webpack_require__(349);
	var topHeader = __webpack_require__(350);
	var cornerHeader = __webpack_require__(347);
	var preloader = __webpack_require__(101);
	
	var Statistic = function () {
	    function Statistic() {
	        _classCallCheck(this, Statistic);
	
	        this.template = __webpack_require__(913);
	    }
	
	    Statistic.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            data.yStartIndexIsEven = data.yStartIndex % 2 === 0;
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    return Statistic;
	}();
	
	module.exports = {
	    constructor: Statistic,
	    children: [{
	        name: 'left-header',
	        component: leftHeader,
	        watcher: {
	            items: ['account', 'statistic', 'header', 'left', 'data'],
	            yStartIndex: ['account', 'statistic', 'yStartIndex']
	        }
	    }, {
	        name: 'top-header',
	        component: topHeader,
	        watcher: {
	            items: ['account', 'statistic', 'header', 'top', 'data']
	        }
	    }, {
	        name: 'corner-header',
	        component: cornerHeader
	    }, {
	        name: 'preloader',
	        component: preloader,
	        props: {
	            size: 'big'
	        }
	    }]
	};

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(779);
	var signals = __webpack_require__(102);
	
	var _require = __webpack_require__(4),
	    cut = _require.cut;
	
	var LeftHeader = function () {
	    function LeftHeader() {
	        _classCallCheck(this, LeftHeader);
	
	        this.template = __webpack_require__(912);
	        this.isListenersInit = false;
	    }
	
	    LeftHeader.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            data.yStartIndexIsEven = data.yStartIndex % 2 === 0;
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    LeftHeader.prototype.bind = function bind() {
	        var _click;
	
	        return {
	            click: (_click = {}, _click[cut(css.expandable)] = this.expandItem, _click)
	        };
	    };
	
	    LeftHeader.prototype.expandItem = function expandItem(e) {
	        var id = e.target.attributes['cat-id'].value;
	        this.$context.signal(signals.toggleItem(['account', 'statistic', 'yExtended'], id));
	    };
	
	    return LeftHeader;
	}();
	
	module.exports = {
	    constructor: LeftHeader
	};

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(781);
	var signals = __webpack_require__(102);
	
	var _require = __webpack_require__(4),
	    cut = _require.cut;
	
	var LeftHeader = function () {
	    function LeftHeader() {
	        _classCallCheck(this, LeftHeader);
	
	        this.template = __webpack_require__(914);
	        this.isListenersInit = false;
	    }
	
	    LeftHeader.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    LeftHeader.prototype.bind = function bind() {
	        var _click;
	
	        return {
	            click: (_click = {}, _click[cut(css.expandable)] = this.expandItem, _click)
	        };
	    };
	
	    LeftHeader.prototype.expandItem = function expandItem(e) {
	        var id = e.target.attributes['cat-id'].value;
	        this.$context.signal(signals.toggleItem(['account', 'statistic', 'xExtended'], id));
	    };
	
	    return LeftHeader;
	}();
	
	module.exports = {
	    constructor: LeftHeader
	};

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(785);
	var UsersList = __webpack_require__(353);
	var SelectedUser = __webpack_require__(352);
	
	var Users = function () {
	    function Users() {
	        _classCallCheck(this, Users);
	
	        this.template = __webpack_require__(918);
	    }
	
	    Users.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    return Users;
	}();
	
	module.exports = {
	    constructor: Users,
	    children: [{
	        name: 'users-list',
	        component: UsersList,
	        watcher: {
	            usersList: ['account', 'users', 'computed', 'usersListFiltered']
	        }
	    }, {
	        name: 'selected-user',
	        component: SelectedUser,
	        watcher: {
	            selectedUser: ['account', 'userForm', 'original']
	        }
	    }]
	};

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(783);
	var UserForm = __webpack_require__(213);
	var Overlay = __webpack_require__(156);
	var formatter = __webpack_require__(157);
	
	var SelectedUser = function () {
	    function SelectedUser() {
	        _classCallCheck(this, SelectedUser);
	
	        this.template = __webpack_require__(917);
	    }
	
	    SelectedUser.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            var fullName = formatter.fullName(data['selectedUser']);
	            return Object.assign({}, data, { fullName: fullName }, { css: css });
	        });
	    };
	
	    return SelectedUser;
	}();
	
	module.exports = {
	    constructor: SelectedUser,
	    children: [{
	        name: 'user-form',
	        component: UserForm,
	        props: {
	            disableEditing: true
	        },
	        watcher: {
	            userType: ['account', 'userForm', 'form', 'userType']
	        }
	    }, {
	        name: 'overlay',
	        component: Overlay,
	        watcher: {
	            isLoading: ['account', 'users', 'selectedUserIsLoading']
	        }
	    }]
	};

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(784);
	
	var _require = __webpack_require__(4),
	    cut = _require.cut;
	
	var Filter = __webpack_require__(354);
	
	var $ = __webpack_require__(12);
	
	var LIST_WRAPPER_SELECTOR = cut(css.listWrapper);
	var LIST_SELECTOR = cut(css.list);
	var SCROLLBAR_SELECTOR = cut(css.scrollbar);
	var SCROLLTRACK_SELECTOR = cut(css.scrolltrack);
	var LIST_CONTENT = cut(css.listContent);
	
	var _require2 = __webpack_require__(11),
	    _redirect = _require2.redirect;
	
	var UsersList = function () {
	    function UsersList() {
	        _classCallCheck(this, UsersList);
	
	        this.template = __webpack_require__(919);
	    }
	
	    UsersList.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    UsersList.prototype.bind = function bind() {
	        var _mouseenter, _mouseleave, _click;
	
	        this.initBaron();
	
	        var $el = $(this.$context.element);
	
	        this.$wrapper = $el.find(LIST_SELECTOR);
	        this.$scrollContent = this.$wrapper.find(LIST_CONTENT);
	
	        return {
	            mouseenter: (_mouseenter = {}, _mouseenter[LIST_WRAPPER_SELECTOR] = this.blockWindowScroll, _mouseenter),
	            mouseleave: (_mouseleave = {}, _mouseleave[LIST_WRAPPER_SELECTOR] = this.unblockWindowScroll, _mouseleave),
	            click: (_click = {}, _click[cut(css.redirect)] = this.redirect, _click)
	        };
	    };
	
	    UsersList.prototype.redirect = function redirect(e) {
	        e.stopPropagation();
	        var url = e.currentTarget.getAttribute('cat-url');
	        this.$context.signal(_redirect, { url: url });
	    };
	
	    UsersList.prototype.unbind = function unbind() {
	        if (this.$wrapper) {
	            this.$wrapper.off('scroll', this._scrollHanlder);
	        }
	    };
	
	    UsersList.prototype.initBaron = function initBaron() {
	        var baron = __webpack_require__(64);
	        var elementId = this.$context.attributes.id;
	
	        baron({
	            root: '#' + elementId + ' ' + LIST_WRAPPER_SELECTOR,
	            scroller: LIST_SELECTOR,
	            bar: SCROLLBAR_SELECTOR,
	            track: SCROLLTRACK_SELECTOR,
	            $: $
	        });
	    };
	
	    UsersList.prototype.blockWindowScroll = function blockWindowScroll() {
	        var x = window.scrollX || window.pageXOffset || document.body.scrollLeft;
	        var y = window.scrollY || window.pageYOffset || document.body.scrollTop;
	
	        window.onscroll = function () {
	            window.scrollTo(x, y);
	        };
	    };
	
	    UsersList.prototype.unblockWindowScroll = function unblockWindowScroll() {
	        window.onscroll = null;
	    };
	
	    return UsersList;
	}();
	
	module.exports = {
	    constructor: UsersList,
	    children: [{
	        name: 'users-filter',
	        component: Filter
	    }]
	};

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _require = __webpack_require__(24),
	    Text = _require.Text;
	
	var _require2 = __webpack_require__(26),
	    inputText = _require2.inputText,
	    blurText = _require2.blurText;
	
	var Filter = function () {
	    function Filter() {
	        _classCallCheck(this, Filter);
	
	        this.template = __webpack_require__(920);
	    }
	
	    Filter.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data);
	        });
	    };
	
	    return Filter;
	}();
	
	module.exports = {
	    constructor: Filter,
	    children: [{
	        name: 'filter-input',
	        component: Text,
	        props: {
	            signals: { inputText: inputText, blurText: blurText },
	            position: 'leftToRight',
	            placeholder: 'Отфильтровать...'
	        },
	        watcher: {
	            value: ['account', 'users', 'list', 'filter']
	        }
	    }]
	};

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(786);
	
	var _require = __webpack_require__(4),
	    cut = _require.cut;
	
	var _require2 = __webpack_require__(11),
	    _redirect = _require2.redirect;
	
	var Alert = function () {
	    function Alert() {
	        _classCallCheck(this, Alert);
	
	        this.template = __webpack_require__(921);
	    }
	
	    Alert.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    Alert.prototype.bind = function bind() {
	        var _click;
	
	        return {
	            click: (_click = {}, _click[cut(css.redirect)] = this.redirect, _click)
	        };
	    };
	
	    Alert.prototype.redirect = function redirect(e) {
	        e.stopPropagation();
	        var url = e.currentTarget.getAttribute('cat-url');
	        this.$context.signal(_redirect, { url: url });
	    };
	
	    return Alert;
	}();
	
	module.exports = {
	    constructor: Alert
	};

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(787);
	var Login = __webpack_require__(359);
	var Registration = __webpack_require__(361);
	var RegistrationExtra = __webpack_require__(360);
	var Restore = __webpack_require__(363);
	var RestoreChange = __webpack_require__(362);
	var Alert = __webpack_require__(355);
	
	var Content = function () {
	    function Content() {
	        _classCallCheck(this, Content);
	
	        this.template = __webpack_require__(922);
	    }
	
	    Content.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    return Content;
	}();
	
	module.exports = {
	    constructor: Content,
	    children: [{
	        name: 'login',
	        component: Login,
	        watcher: {
	            isDisabled: ['login', 'ui', 'loginButton', 'isDisabled'],
	            email: ['login', 'tooltip', 'emailNotConfirmed', 'username'],
	            showEmailNotConfirmedTooltip: ['login', 'tooltip', 'emailNotConfirmed', 'show'],
	            showEmailNotConfirmedMailResendTooltip: ['login', 'tooltip', 'emailNotConfirmedMailResend', 'show'],
	            showAlreadyRegisteredTooltip: ['login', 'tooltip', 'showAlreadyRegisteredTooltip'],
	            utm: ['utm']
	        }
	    }, {
	        name: 'registration',
	        component: Registration,
	        watcher: {
	            isEnabled: ['registration', 'computed', 'registerButton', 'isEnabled'],
	            showToS: ['registration', 'showToS'],
	            userType: ['registration', 'form', 'userType']
	        }
	    }, {
	        name: 'registration-extra',
	        component: RegistrationExtra,
	        watcher: {
	            isEnabled: ['registrationExtra', 'computed', 'registerButton', 'isEnabled'],
	            showToS: ['registrationExtra', 'showToS'],
	            userType: ['registrationExtra', 'form', 'userType'],
	            isBitrix: ['bitrix', 'isBitrix']
	        }
	    }, {
	        name: 'restore',
	        component: Restore,
	        watcher: {
	            isEnabled: ['restore', 'computed', 'restoreButton', 'isEnabled']
	        }
	    }, {
	        name: 'restore-change',
	        component: RestoreChange,
	        watcher: {
	            isEnabled: ['restoreChange', 'computed', 'restoreButton', 'isEnabled']
	        }
	    }, {
	        name: 'alert',
	        component: Alert,
	        watcher: {
	            email: ['auth', 'computed', 'userData', 'email'],
	            type: ['auth', 'alert', 'type']
	        }
	    }]
	};

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Content = __webpack_require__(356);
	var signals = __webpack_require__(495);
	
	var Auth = function () {
	    function Auth() {
	        _classCallCheck(this, Auth);
	
	        this.template = __webpack_require__(930);
	    }
	
	    Auth.prototype.bind = function bind() {
	        this.$context.signal(signals.checkForAuthCookie);
	    };
	
	    Auth.prototype.render = function render() {
	        return this.$context.getWatcherData();
	    };
	
	    return Auth;
	}();
	
	module.exports = {
	    constructor: Auth,
	    children: [{
	        name: 'content',
	        component: Content,
	        watcher: {
	            components: ['page', 'components']
	        }
	    }]
	};

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var $ = __webpack_require__(12);
	var css = __webpack_require__(789);
	
	var _require = __webpack_require__(24),
	    Text = _require.Text;
	
	var _require2 = __webpack_require__(26),
	    inputText = _require2.inputText,
	    blurText = _require2.blurText;
	
	var LoginForm = function () {
	    function LoginForm() {
	        _classCallCheck(this, LoginForm);
	
	        this.template = __webpack_require__(924);
	    }
	
	    LoginForm.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    LoginForm.prototype.bind = function bind() {
	        this.focusFirstField();
	    };
	
	    LoginForm.prototype.focusFirstField = function focusFirstField() {
	        var focused = $(':focus');
	        var email = $('input[id="text-email-field"]');
	
	        if (!focused.length || focused[0].tagName != 'INPUT') {
	            email.focus();
	        }
	    };
	
	    return LoginForm;
	}();
	
	module.exports = {
	    constructor: LoginForm,
	    children: [{
	        name: 'text-email',
	        component: Text,
	        props: {
	            placeholder: 'Email',
	            signals: { inputText: inputText, blurText: blurText }
	        },
	        watcher: {
	            value: ['login', 'form', 'username']
	        }
	    }, {
	        name: 'text-password',
	        component: Text,
	        props: {
	            placeholder: 'Пароль',
	            type: 'password',
	            signals: { inputText: inputText, blurText: blurText }
	        },
	        watcher: {
	            value: ['login', 'form', 'password']
	        }
	    }]
	};

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(790);
	var Form = __webpack_require__(358);
	var Error = __webpack_require__(88);
	
	var _require = __webpack_require__(4),
	    cut = _require.cut;
	
	var signals = __webpack_require__(496);
	
	var _require2 = __webpack_require__(11),
	    _redirect = _require2.redirect;
	
	var SELECTOR_FORM = cut(css.form);
	var SELECTOR_WAIT_SUBMIT = cut(css.waitSubmit);
	var SELECTOR_REGISTRATION_BUTTON = cut(css.registrationButton);
	var SEND_CONFIRMATION_MAIL_LINK = cut(css.sendConfirmationMail);
	
	var Login = function () {
	    function Login() {
	        _classCallCheck(this, Login);
	
	        this.template = __webpack_require__(925);
	    }
	
	    Login.prototype.bind = function bind() {
	        var _submit, _click;
	
	        return {
	            submit: (_submit = {}, _submit[SELECTOR_FORM] = this.submit, _submit),
	            click: (_click = {}, _click[SELECTOR_WAIT_SUBMIT] = this.logout, _click[SELECTOR_REGISTRATION_BUTTON] = this.register, _click[SEND_CONFIRMATION_MAIL_LINK] = this.sendConfirmationMail, _click[cut(css.redirect)] = this.redirect, _click)
	        };
	    };
	
	    Login.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    Login.prototype.submit = function submit(e) {
	        e.preventDefault();
	        this.$context.signal(signals.clickLoginButton);
	    };
	
	    Login.prototype.register = function register(e) {
	        this.$context.signal(signals.clickRegisterButton);
	        var url = e.currentTarget.getAttribute('cat-url');
	        this.$context.signal(_redirect, { url: url });
	    };
	
	    Login.prototype.redirect = function redirect(e) {
	        e.stopPropagation();
	        var url = e.currentTarget.getAttribute('cat-url');
	        this.$context.signal(_redirect, { url: url });
	    };
	
	    Login.prototype.logout = function logout(e) {
	        e.preventDefault();
	        this.$context.signal(signals.clickLogoutButton);
	    };
	
	    Login.prototype.sendConfirmationMail = function sendConfirmationMail(e) {
	        e.preventDefault();
	        this.$context.signal(signals.sendConfirmationMail);
	    };
	
	    return Login;
	}();
	
	module.exports = {
	    constructor: Login,
	    children: [{
	        name: 'error',
	        component: Error,
	        watcher: {
	            isError: ['login', 'computed', 'error', 'isError'],
	            text: ['login', 'computed', 'error', 'text']
	        }
	    }, {
	        name: 'login-form',
	        component: Form
	    }]
	};

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(791);
	var Error = __webpack_require__(88);
	var ToS = __webpack_require__(209);
	var UserSharedDataForm = __webpack_require__(155);
	var LegalEntityForm = __webpack_require__(153);
	var SoleProprietorForm = __webpack_require__(154);
	var IndividualForm = __webpack_require__(152);
	
	var _require = __webpack_require__(4),
	    cut = _require.cut;
	
	var signals = __webpack_require__(497);
	var SUBMIT = cut(css.submit);
	
	var _require2 = __webpack_require__(11),
	    _redirect = _require2.redirect;
	
	var RegistrationExtra = function () {
	    function RegistrationExtra() {
	        _classCallCheck(this, RegistrationExtra);
	
	        this.template = __webpack_require__(926);
	    }
	
	    RegistrationExtra.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    RegistrationExtra.prototype.bind = function bind() {
	        var _click;
	
	        return {
	            click: (_click = {}, _click[SUBMIT] = this.handleNext, _click[cut(css.redirect)] = this.redirect, _click)
	        };
	    };
	
	    RegistrationExtra.prototype.handleNext = function handleNext() {
	        this.$context.signal(signals.showToS);
	    };
	
	    RegistrationExtra.prototype.redirect = function redirect(e) {
	        e.stopPropagation();
	        var url = e.currentTarget.getAttribute('cat-url');
	        this.$context.signal(_redirect, { url: url });
	    };
	
	    return RegistrationExtra;
	}();
	
	module.exports = {
	    constructor: RegistrationExtra,
	    children: [{
	        name: 'error',
	        component: Error,
	        watcher: {
	            isError: ['registrationExtra', 'computed', 'error', 'isError'],
	            text: ['registrationExtra', 'computed', 'error', 'text']
	        }
	    }, {
	        name: 'error-country',
	        component: Error,
	        props: {
	            text: 'Выберите страну'
	        },
	        watcher: {
	            isError: ['auth', 'isCountryError']
	        }
	    }, {
	        name: 'user-shared-data-form',
	        component: UserSharedDataForm(['registrationExtra'], signals.selectUserType, signals.selectCountry),
	        props: {
	            formPath: 'registrationExtra',
	            hideEmail: true
	        },
	        watcher: {
	            isUserTypeSelectEnabled: ['registrationExtra', 'computed', 'isUserTypeSelectEnabled']
	        }
	    }, {
	        name: 'individual-form',
	        component: IndividualForm(['registrationExtra']),
	        props: {
	            formPath: 'registrationExtra'
	        },
	        watcher: {
	            userCountryId: ['registrationExtra', 'form', 'countryId']
	        }
	    }, {
	        name: 'legal-entity-form',
	        component: LegalEntityForm(['registrationExtra']),
	        props: {
	            formPath: 'registrationExtra'
	        },
	        watcher: {
	            userCountryId: ['registrationExtra', 'form', 'countryId']
	        }
	    }, {
	        name: 'sole-proprietor-form',
	        component: SoleProprietorForm(['registrationExtra']),
	        props: {
	            formPath: 'registrationExtra'
	        },
	        watcher: {
	            userCountryId: ['registrationExtra', 'form', 'countryId']
	        }
	    }, {
	        name: 'individual-form',
	        component: IndividualForm(['registration']),
	        props: {
	            formPath: 'registration'
	        },
	        watcher: {
	            userCountryId: ['registration', 'form', 'countryId']
	        }
	    }, {
	        name: 'tos',
	        component: ToS,
	        props: {
	            signals: {
	                accept: signals.registrationExtra,
	                cancel: signals.cancelToS
	            }
	        }
	    }]
	};

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(792);
	
	var _require = __webpack_require__(24),
	    Text = _require.Text;
	
	var _require2 = __webpack_require__(26),
	    inputText = _require2.inputText,
	    blurText = _require2.blurText;
	
	var Error = __webpack_require__(88);
	var ToS = __webpack_require__(209);
	var UserSharedDataForm = __webpack_require__(155);
	var LegalEntityForm = __webpack_require__(153);
	var SoleProprietorForm = __webpack_require__(154);
	var IndividualForm = __webpack_require__(152);
	
	var _require3 = __webpack_require__(4),
	    cut = _require3.cut;
	
	var signals = __webpack_require__(498);
	var SCHEMES = __webpack_require__(22);
	var SUBMIT = cut(css.submit);
	
	var _require4 = __webpack_require__(11),
	    _redirect = _require4.redirect;
	
	var Registration = function () {
	    function Registration() {
	        _classCallCheck(this, Registration);
	
	        this.template = __webpack_require__(927);
	    }
	
	    Registration.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    Registration.prototype.bind = function bind() {
	        var _click;
	
	        return {
	            click: (_click = {}, _click[SUBMIT] = this.handleNext, _click[cut(css.redirect)] = this.redirect, _click)
	        };
	    };
	
	    Registration.prototype.handleNext = function handleNext() {
	        this.$context.signal(signals.showToS);
	    };
	
	    Registration.prototype.redirect = function redirect(e) {
	        e.stopPropagation();
	        var url = e.currentTarget.getAttribute('cat-url');
	        this.$context.signal(_redirect, { url: url });
	    };
	
	    return Registration;
	}();
	
	module.exports = {
	    constructor: Registration,
	    children: [{
	        name: 'tos',
	        component: ToS,
	        props: {
	            signals: {
	                accept: signals.registration,
	                cancel: signals.cancelToS
	            }
	        }
	    }, {
	        name: 'error',
	        component: Error,
	        props: {
	            text: 'Что-то пошло не так. Пожалуйста, нажмите кнопку еще раз.'
	        },
	        watcher: {
	            isError: ['auth', 'isError']
	        }
	    }, {
	        name: 'error-country',
	        component: Error,
	        props: {
	            text: 'Выберите страну'
	        },
	        watcher: {
	            isError: ['auth', 'isCountryError']
	        }
	    }, {
	        name: 'text-email',
	        component: Text,
	        props: {
	            signals: { inputText: inputText, blurText: blurText },
	            position: 'leftToRight',
	            scheme: SCHEMES.email
	        },
	        watcher: {
	            value: ['registration', 'form', 'email'],
	            error: ['registration', 'error', 'email']
	        }
	    }, {
	        name: 'text-password',
	        component: Text,
	        props: {
	            signals: { inputText: inputText, blurText: blurText },
	            scheme: SCHEMES.password,
	            position: 'leftToRight',
	            type: 'password'
	        },
	        watcher: {
	            value: ['registration', 'form', 'password'],
	            error: ['registration', 'error', 'password']
	        }
	    }, {
	        name: 'text-repeat-password',
	        component: Text,
	        props: {
	            signals: { inputText: inputText, blurText: blurText },
	            scheme: SCHEMES.repeatPassword,
	            position: 'leftToRight',
	            type: 'password'
	        },
	        watcher: {
	            value: ['registration', 'form', 'repeatPassword'],
	            error: ['registration', 'computed', 'error', 'repeatPassword']
	        }
	    }, {
	        name: 'user-shared-data-form',
	        component: UserSharedDataForm(['registration'], signals.selectUserType, signals.selectCountry),
	        props: {
	            formPath: 'registration',
	            hideEmail: true
	        },
	        watcher: {
	            isUserTypeSelectEnabled: ['registration', 'computed', 'isUserTypeSelectEnabled']
	        }
	    }, {
	        name: 'legal-entity-form',
	        component: LegalEntityForm(['registration']),
	        props: {
	            formPath: 'registration'
	        },
	        watcher: {
	            userCountryId: ['registration', 'form', 'countryId']
	        }
	    }, {
	        name: 'sole-proprietor-form',
	        component: SoleProprietorForm(['registration']),
	        props: {
	            formPath: 'registration'
	        },
	        watcher: {
	            userCountryId: ['registration', 'form', 'countryId']
	        }
	    }, {
	        name: 'individual-form',
	        component: IndividualForm(['registration']),
	        props: {
	            formPath: 'registration'
	        },
	        watcher: {
	            userCountryId: ['registration', 'form', 'countryId']
	        }
	    }]
	};

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(793);
	
	var _require = __webpack_require__(24),
	    Text = _require.Text;
	
	var _require2 = __webpack_require__(26),
	    inputText = _require2.inputText,
	    blurText = _require2.blurText;
	
	var Error = __webpack_require__(88);
	
	var _require3 = __webpack_require__(4),
	    cut = _require3.cut;
	
	var signals = __webpack_require__(499);
	var SCHEMES = __webpack_require__(22);
	var SUBMIT = cut(css.submit);
	
	var RestoreChange = function () {
	    function RestoreChange() {
	        _classCallCheck(this, RestoreChange);
	
	        this.template = __webpack_require__(928);
	    }
	
	    RestoreChange.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    RestoreChange.prototype.bind = function bind() {
	        var _click;
	
	        return {
	            click: (_click = {}, _click[SUBMIT] = this.handleChangePassword, _click)
	        };
	    };
	
	    RestoreChange.prototype.handleChangePassword = function handleChangePassword() {
	        this.$context.signal(signals.passwordChange);
	    };
	
	    return RestoreChange;
	}();
	
	module.exports = {
	    constructor: RestoreChange,
	    children: [{
	        name: 'error',
	        component: Error,
	        watcher: {
	            isError: ['restoreChange', 'computed', 'error', 'isError'],
	            text: ['restoreChange', 'computed', 'error', 'text']
	        }
	    }, {
	        name: 'text-password',
	        component: Text,
	        props: {
	            signals: { inputText: inputText, blurText: blurText },
	            placeholder: 'Введите новый пароль',
	            scheme: SCHEMES.password,
	            position: 'leftToRight',
	            type: 'password'
	        },
	        watcher: {
	            value: ['restoreChange', 'form', 'password'],
	            error: ['restoreChange', 'validation', 'password']
	        }
	    }, {
	        name: 'text-repeat-password',
	        component: Text,
	        props: {
	            signals: { inputText: inputText, blurText: blurText },
	            placeholder: 'Повторите пароль',
	            scheme: SCHEMES.repeatPassword,
	            position: 'leftToRight',
	            type: 'password'
	        },
	        watcher: {
	            value: ['restoreChange', 'form', 'repeatPassword'],
	            error: ['restoreChange', 'computed', 'validation', 'repeatPassword']
	        }
	    }]
	};

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(794);
	var SCHEMES = __webpack_require__(22);
	
	var _require = __webpack_require__(24),
	    Text = _require.Text;
	
	var Error = __webpack_require__(88);
	
	var _require2 = __webpack_require__(26),
	    inputText = _require2.inputText,
	    blurText = _require2.blurText;
	
	var signals = __webpack_require__(500);
	
	var _require3 = __webpack_require__(4),
	    cut = _require3.cut;
	
	var _require4 = __webpack_require__(11),
	    _redirect = _require4.redirect;
	
	var SUBMIT = cut(css.submit);
	
	var Restore = function () {
	    function Restore() {
	        _classCallCheck(this, Restore);
	
	        this.template = __webpack_require__(929);
	    }
	
	    Restore.prototype.bind = function bind() {
	        var _click;
	
	        return {
	            click: (_click = {}, _click[SUBMIT] = this.handleRestore, _click[cut(css.redirect)] = this.redirect, _click)
	        };
	    };
	
	    Restore.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    Restore.prototype.handleRestore = function handleRestore() {
	        this.$context.signal(signals.restore);
	    };
	
	    Restore.prototype.redirect = function redirect(e) {
	        e.stopPropagation();
	        var url = e.currentTarget.getAttribute('cat-url');
	        this.$context.signal(_redirect, { url: url });
	    };
	
	    return Restore;
	}();
	
	module.exports = {
	    constructor: Restore,
	    children: [{
	        name: 'text-email',
	        component: Text,
	        props: {
	            signals: { inputText: inputText, blurText: blurText },
	            placeholder: 'Email',
	            position: 'leftToRight',
	            scheme: SCHEMES.email
	        },
	        watcher: {
	            value: ['restore', 'form', 'email'],
	            error: ['restore', 'error', 'email']
	        }
	    }, {
	        name: 'error',
	        component: Error,
	        watcher: {
	            isError: ['restore', 'computed', 'error', 'isError'],
	            text: ['restore', 'computed', 'error', 'text']
	        }
	    }]
	};

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var signals = __webpack_require__(75);
	var signalsBitrix = __webpack_require__(29);
	
	var _require = __webpack_require__(90),
	    raiseEvent = _require.raiseEvent;
	
	var CustomOrder = __webpack_require__(150);
	var Discounts = __webpack_require__(151);
	var css = __webpack_require__(796);
	
	var _require2 = __webpack_require__(4),
	    cut = _require2.cut;
	
	var DOWNLOAD_SAMPLE_BUTTON = cut(css.actionsButton);
	var MANAGER_MAIL_TO_LINK = cut(css.managerLink);
	
	var Order = function () {
	    function Order() {
	        _classCallCheck(this, Order);
	
	        this.template = __webpack_require__(932);
	        this.intervalId = null;
	    }
	
	    Order.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    Order.prototype.bind = function bind() {
	        var _click;
	
	        this.$context.signal(signalsBitrix.onLoad);
	
	        return {
	            click: (_click = {}, _click[DOWNLOAD_SAMPLE_BUTTON] = this.downloadSampleEvent, _click[MANAGER_MAIL_TO_LINK] = this.mailToManager, _click)
	        };
	    };
	
	    Order.prototype.downloadSampleEvent = function downloadSampleEvent() {
	        this.$context.signal(raiseEvent, { category: 'button_download_sample_fetching', action: 'click' });
	    };
	
	    Order.prototype.mailToManager = function mailToManager() {
	        this.$context.signal(raiseEvent, { category: 'link_letter_manager', action: 'click' });
	    };
	
	    return Order;
	}();
	
	module.exports = {
	    constructor: Order,
	    children: [{
	        name: 'custom-order',
	        component: CustomOrder,
	        props: {
	            showReset: true,
	            showOrderButton: true,
	            onReset: signals.onReset,
	            isSmallTree: 'false',
	            dontUseMetric: 'false'
	        },
	        watcher: {
	            hideRubrics: ['order', 'computed', 'hideRubrics']
	        }
	    }, {
	        name: 'discounts',
	        component: Discounts,
	        watcher: {
	            prices: ['data', 'computed', 'discounts']
	        }
	    }]
	};

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(798);
	
	var Discount = function () {
	    function Discount() {
	        _classCallCheck(this, Discount);
	
	        this.template = __webpack_require__(933);
	    }
	
	    Discount.prototype.render = function render() {
	        var props = this.$context.props;
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, props, { css: css });
	        });
	    };
	
	    return Discount;
	}();
	
	module.exports = {
	    constructor: Discount
	};

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PurposeTree = __webpack_require__(211);
	var LegalTree = __webpack_require__(210);
	
	var Discount = function () {
	    function Discount() {
	        _classCallCheck(this, Discount);
	
	        this.template = __webpack_require__(934);
	    }
	
	    Discount.prototype.render = function render() {
	        var props = this.$context.props;
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, props);
	        });
	    };
	
	    return Discount;
	}();
	
	module.exports = {
	    constructor: Discount,
	    children: [{
	        name: 'purpose-tree',
	        component: PurposeTree,
	        watcher: {
	            isShowed: ['order', 'computed', 'exportColumns', 'byPropertyName', 'Purpose', 'isChecked']
	        },
	        parentPropsMap: {
	            isSmallTree: 'isSmallTree'
	        }
	    }, {
	        name: 'legal-tree',
	        component: LegalTree,
	        watcher: {
	            isShowed: ['order', 'computed', 'exportColumns', 'byPropertyName', 'LegalForm', 'isChecked']
	        },
	        parentPropsMap: {
	            isSmallTree: 'isSmallTree'
	        }
	    }]
	};

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _require = __webpack_require__(44),
	    Checkbox = _require.Checkbox,
	    Datepicker = _require.Datepicker,
	    Text = _require.Text,
	    Select = _require.Select;
	
	var PurposeTree = __webpack_require__(211);
	var LegalTree = __webpack_require__(210);
	var PaymentTree = __webpack_require__(371);
	var css = __webpack_require__(799);
	var signalsAddParams = __webpack_require__(116);
	var filials = __webpack_require__(502);
	var accountUi = __webpack_require__(226);
	var utils = __webpack_require__(11);
	var mapClasses = __webpack_require__(504);
	var numberOfEmployees = __webpack_require__(505);
	var filterableTreeFactory = __webpack_require__(89);
	var SCHEMES = __webpack_require__(22);
	
	var AdditionalParameters = function () {
	    function AdditionalParameters() {
	        _classCallCheck(this, AdditionalParameters);
	
	        this.template = __webpack_require__(935);
	    }
	
	    AdditionalParameters.prototype.render = function render() {
	        var isSmallTree = this.$context.props.isSmallTree === 'true';
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css }, { isSmallTree: isSmallTree });
	        });
	    };
	
	    return AdditionalParameters;
	}();
	
	module.exports = {
	    constructor: AdditionalParameters,
	    children: [{
	        name: 'checkbox-is-must',
	        component: Checkbox,
	        props: {
	            signal: signalsAddParams.setExportColumnIsMustBeFilled
	        },
	        watcher: function watcher(attributes) {
	            return {
	                value: ['order', 'addParams', 'exportColumns', attributes['cat-path'], 'isMustBeFilled']
	            };
	        }
	    }, {
	        name: 'datepicker-two',
	        component: Datepicker,
	        props: {
	            scrollType: 'month',
	            scrollPage: accountUi.scrollPageDatepicker(['order', 'addParams', 'datepicker2', 'calendar']),
	            toggleDropdown: utils.togglePopup('datepicker2'),
	            selectDate: signalsAddParams.selectDate('datepicker2', false),
	            clearInput: signalsAddParams.clearDatepicker(['order', 'addParams', 'datepicker2', 'value'])
	        },
	        watcher: {
	            mod: ['order', 'addParams', 'computed', 'datepicker2', 'mod'],
	            withInputs: ['order', 'addParams', 'computed', 'datepicker2', 'withInputs'],
	            withoutButton: ['order', 'addParams', 'computed', 'datepicker2', 'withoutButton'],
	            selectedDate: ['order', 'addParams', 'computed', 'datepicker2', 'selectedDate'],
	            calendars: ['order', 'addParams', 'computed', 'datepicker2', 'calendars'],
	            range: ['order', 'addParams', 'computed', 'datepicker2', 'range'],
	            availableRange: ['order', 'addParams', 'computed', 'datepicker2', 'availableRange'],
	            title: ['order', 'addParams', 'computed', 'datepicker2', 'title'],
	            isOpen: ['order', 'popups', 'datepicker2', 'isOpen'],
	            isDisabled: ['order', 'addParams', 'computed', 'datepicker2', 'isDisabled']
	        }
	    }, {
	        name: 'datepicker',
	        component: Datepicker,
	        props: {
	            scrollType: 'month',
	            scrollPage: accountUi.scrollPageDatepicker(['order', 'addParams', 'datepicker', 'calendar']),
	            toggleDropdown: utils.togglePopup('datepicker'),
	            selectDate: signalsAddParams.selectDate('datepicker', true),
	            clearInput: signalsAddParams.clearDatepicker(['order', 'addParams', 'datepicker', 'value'])
	        },
	        watcher: {
	            mod: ['order', 'addParams', 'computed', 'datepicker', 'mod'],
	            withInputs: ['order', 'addParams', 'computed', 'datepicker', 'withInputs'],
	            withoutButton: ['order', 'addParams', 'computed', 'datepicker', 'withoutButton'],
	            selectedDate: ['order', 'addParams', 'computed', 'datepicker', 'selectedDate'],
	            calendars: ['order', 'addParams', 'computed', 'datepicker', 'calendars'],
	            range: ['order', 'addParams', 'computed', 'datepicker', 'range'],
	            availableRange: ['order', 'addParams', 'computed', 'datepicker', 'availableRange'],
	            title: ['order', 'addParams', 'computed', 'datepicker', 'title'],
	            isOpen: ['order', 'popups', 'datepicker', 'isOpen'],
	            isDisabled: ['order', 'addParams', 'computed', 'datepicker', 'isDisabled']
	        }
	    }, {
	        name: 'purpose-tree',
	        component: PurposeTree,
	        watcher: {
	            isShowed: ['order', 'computed', 'exportColumns', 'byPropertyName', 'Purpose', 'isChecked']
	        },
	        parentPropsMap: {
	            isSmallTree: 'isSmallTree'
	        }
	    }, {
	        name: 'legal-tree',
	        component: LegalTree,
	        watcher: {
	            isShowed: ['order', 'computed', 'exportColumns', 'byPropertyName', 'LegalForm', 'isChecked']
	        },
	        parentPropsMap: {
	            isSmallTree: 'isSmallTree'
	        }
	    }, {
	        name: 'payment-tree',
	        component: PaymentTree,
	        watcher: {
	            isShowed: ['order', 'computed', 'exportColumns', 'byPropertyName', 'PaymentTypes', 'isChecked']
	        },
	        parentPropsMap: {
	            isSmallTree: 'isSmallTree'
	        }
	    }, {
	        name: 'map-classes-tree',
	        component: filterableTreeFactory({
	            basePath: ['order', 'addParams', 'mapClasses', 'tree']
	        }),
	        watcher: {
	            isDisabled: ['order', 'isDisabled']
	        },
	        props: {
	            id: 'mapClasses',
	            onItemCheck: mapClasses.onItemCheck,
	            onSetAll: mapClasses.onSetAll,
	            minFilterLength: 2,
	            showOnlyTree: true,
	            isInnerTree: true
	        },
	        parentPropsMap: {
	            isSmallTree: 'isSmallTree'
	        }
	    }, {
	        name: 'number-of-employees-tree',
	        component: filterableTreeFactory({
	            basePath: ['order', 'addParams', 'numberOfEmployees', 'tree']
	        }),
	        watcher: {
	            isDisabled: ['order', 'isDisabled']
	        },
	        props: {
	            id: 'numberOfEmployees',
	            onItemCheck: numberOfEmployees.onItemCheck,
	            onSetAll: numberOfEmployees.onSetAll,
	            minFilterLength: 2,
	            showOnlyTree: true,
	            isInnerTree: true
	        },
	        parentPropsMap: {
	            isSmallTree: 'isSmallTree'
	        }
	    }, {
	        name: 'text',
	        component: Text,
	        props: {
	            signals: {
	                inputText: signalsAddParams.inputText,
	                blurText: signalsAddParams.blurText
	            },
	            position: 'leftToRight',
	            scheme: SCHEMES.number
	        },
	        watcher: function watcher(attributes) {
	            return {
	                value: ['order', 'addParams', 'exportColumns', attributes['cat-path'], 'value', attributes['cat-index']],
	                error: ['order', 'addParams', 'exportColumns', attributes['cat-path'], 'error', attributes['cat-index']]
	            };
	        }
	    }, {
	        name: 'number-of-filials-select',
	        component: Select,
	        props: {
	            signalOnSelect: filials.selectFilialsNumber,
	            signalOnToggle: utils.togglePopupFromArgs
	        },
	        watcher: {
	            options: ['order', 'addParams', 'numberOfFilials', 'options'],
	            isDisable: ['order', 'addParams', 'numberOfFilials', 'isDisable'],
	            isOpen: ['order', 'addParams', 'numberOfFilials', 'isOpen'],
	            isError: ['order', 'addParams', 'numberOfFilials', 'isError'],
	            header: ['order', 'addParams', 'numberOfFilials', 'header']
	        }
	    }]
	};

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(800);
	var signalsAddParams = __webpack_require__(116);
	
	var _require = __webpack_require__(4),
	    cut = _require.cut;
	
	var Actions = function () {
	    function Actions() {
	        _classCallCheck(this, Actions);
	
	        this.template = __webpack_require__(936);
	    }
	
	    Actions.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    Actions.prototype.bind = function bind() {
	        var _click;
	
	        return {
	            click: (_click = {}, _click[cut(css.setAll)] = this.setAll, _click[cut(css.clearAll)] = this.clearAll, _click)
	        };
	    };
	
	    Actions.prototype.setAll = function setAll(e) {
	        e.preventDefault();
	        this.$context.signal(signalsAddParams.setAllGreederColumns, { value: true });
	    };
	
	    Actions.prototype.clearAll = function clearAll(e) {
	        e.preventDefault();
	        this.$context.signal(signalsAddParams.setAllGreederColumns, { value: false });
	    };
	
	    return Actions;
	}();
	
	module.exports = {
	    constructor: Actions
	};

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(801);
	
	var _require = __webpack_require__(44),
	    Checkbox = _require.Checkbox;
	
	var ActionsPanel = __webpack_require__(368);
	var signalsAddParams = __webpack_require__(116);
	
	var CitiesHeader = function () {
	    function CitiesHeader() {
	        _classCallCheck(this, CitiesHeader);
	
	        this.template = __webpack_require__(937);
	    }
	
	    CitiesHeader.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    return CitiesHeader;
	}();
	
	module.exports = {
	    constructor: CitiesHeader,
	    children: [{
	        name: 'checkbox',
	        component: Checkbox,
	        props: {
	            signal: signalsAddParams.setGreederColumnIsChecked
	        },
	        watcher: function watcher(attributes) {
	            return {
	                value: ['order', 'addParams', 'greederColumns', 'value', attributes['cat-path'], 'isChecked']
	            };
	        }
	    }, {
	        name: 'checkbox-source',
	        component: Checkbox,
	        props: {
	            signal: signalsAddParams.setGreederColumnSource
	        },
	        watcher: function watcher(attributes) {
	            return {
	                value: ['order', 'addParams', 'greederColumns', 'source', attributes['cat-path'], 'isChecked']
	            };
	        }
	    }, {
	        name: 'actions',
	        component: ActionsPanel
	    }]
	};

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _require = __webpack_require__(44),
	    Checkbox = _require.Checkbox;
	
	var GreederColumns = __webpack_require__(369);
	var Discount = __webpack_require__(365);
	var Filter = __webpack_require__(367);
	var FilterMulticolumn = __webpack_require__(366);
	var Price = __webpack_require__(372);
	var css = __webpack_require__(797);
	var signalsAddParams = __webpack_require__(116);
	
	var AdditionalParameters = function () {
	    function AdditionalParameters() {
	        _classCallCheck(this, AdditionalParameters);
	
	        this.template = __webpack_require__(942);
	    }
	
	    AdditionalParameters.prototype.render = function render() {
	        var isSmallTree = this.$context.props.isSmallTree === 'true';
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css }, { isSmallTree: isSmallTree });
	        });
	    };
	
	    return AdditionalParameters;
	}();
	
	module.exports = {
	    constructor: AdditionalParameters,
	    children: [{
	        name: 'checkbox',
	        component: Checkbox,
	        props: {
	            signal: signalsAddParams.setExportColumnIsChecked
	        },
	        watcher: function watcher(attributes) {
	            return {
	                value: ['order', 'addParams', 'exportColumns', attributes['cat-path'], 'isChecked']
	            };
	        }
	    }, {
	        name: 'checkbox-basic',
	        component: Checkbox,
	        watcher: {
	            value: ['order', 'computed', 'exportColumns', 'basic', 'alwaysTrue']
	        }
	    }, {
	        name: 'discount',
	        component: Discount,
	        watcher: function watcher(attributes) {
	            return {
	                discountPercentage: ['order', 'computed', 'exportColumns', 'optional', 'value', attributes['cat-path'], 'discountPercentage'],
	                rowAmount: ['order', 'computed', 'exportColumns', 'optional', 'value', attributes['cat-path'], 'rowAmount'],
	                isUseDiscounts: ['order', 'computed', 'exportColumns', 'optional', 'value', attributes['cat-path'], 'isUseDiscounts']
	            };
	        }
	    }, {
	        name: 'discount-basic',
	        component: Discount,
	        props: {
	            isUseDiscounts: true
	        },
	        watcher: {
	            discountPercentage: ['order', 'price', 'data', 'basic', 'discountPercentage'],
	            rowAmount: ['order', 'price', 'data', 'total', 'rowAmount']
	        }
	    }, {
	        name: 'checkbox-only-head-cards',
	        component: Checkbox,
	        props: {
	            signal: signalsAddParams.toggleOnlyHeadCards
	        },
	        watcher: {
	            value: ['order', 'addParams', 'onlyHeadCards']
	        }
	    }, {
	        name: 'greeder-columns',
	        component: GreederColumns,
	        watcher: {
	            columns: ['order', 'addParams', 'greederColumns', 'view', 'gosReg'],
	            columnsRosstat: ['order', 'addParams', 'greederColumns', 'view', 'rosstat'],
	            columnsKz: ['order', 'addParams', 'greederColumns', 'view', 'brr'],
	            isShow: ['order', 'computed', 'isShowGreeder'],
	            isDisabled: ['order', 'isDisabled'],
	            isGosResSourceSelected: ['order', 'computed', 'isGosResSourceSelected']
	        }
	    }, {
	        name: 'filter',
	        component: Filter,
	        watcher: function watcher(attributes) {
	            return {
	                hasFilter: ['order', 'computed', 'exportColumns', attributes['cat-type'], 'view', attributes['cat-path'], 'hasFilter'],
	                filterType: ['order', 'computed', 'exportColumns', attributes['cat-type'], 'view', attributes['cat-path'], 'filterType'],
	                propertyName: ['order', 'computed', 'exportColumns', attributes['cat-type'], 'view', attributes['cat-path'], 'propertyName'],
	                filterName: ['order', 'computed', 'exportColumns', attributes['cat-type'], 'view', attributes['cat-path'], 'filterName'],
	                id: ['order', 'computed', 'exportColumns', attributes['cat-type'], 'view', attributes['cat-path'], 'id'],
	                isDisabled: ['order', 'isDisabled']
	            };
	        },
	        parentPropsMap: {
	            isSmallTree: 'isSmallTree'
	        }
	    }, {
	        name: 'filter-multicolumn',
	        component: FilterMulticolumn,
	        watcher: function watcher(attributes) {
	            return {
	                propertyName: ['order', 'computed', 'exportColumns', attributes['cat-type'], 'view', attributes['cat-path'], 'propertyName']
	            };
	        },
	        parentPropsMap: {
	            isSmallTree: 'isSmallTree'
	        }
	    }, {
	        name: 'price',
	        component: Price,
	        watcher: function watcher(attributes) {
	            return {
	                rowPrice: ['order', 'computed', 'exportColumns', 'optional', 'value', attributes['cat-path'], 'rowPrice'],
	                rowPriceWithoutDiscount: ['order', 'computed', 'exportColumns', 'optional', 'value', attributes['cat-path'], 'rowPriceWithoutDiscount']
	            };
	        }
	    }, {
	        name: 'price-basic',
	        component: Price,
	        watcher: {
	            rowPrice: ['order', 'price', 'data', 'basic', 'rowPrice'],
	            rowPriceWithoutDiscount: ['order', 'price', 'computed', 'rowPriceWithoutDiscount']
	        }
	    }, {
	        name: 'checkbox-archive-inn',
	        component: Checkbox,
	        props: {
	            signal: signalsAddParams.toggleArchiveInn
	        },
	        watcher: {
	            value: ['order', 'addParams', 'includeArchiveInn']
	        }
	    }]
	};

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(803);
	var filterableTreeFactory = __webpack_require__(89);
	var paymentTypes = __webpack_require__(506);
	
	var Discount = function () {
	    function Discount() {
	        _classCallCheck(this, Discount);
	
	        this.template = __webpack_require__(939);
	    }
	
	    Discount.prototype.render = function render() {
	        var props = this.$context.props;
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, props, { css: css });
	        });
	    };
	
	    return Discount;
	}();
	
	module.exports = {
	    constructor: Discount,
	    children: [{
	        name: 'payment-types-tree',
	        component: filterableTreeFactory({
	            basePath: ['order', 'addParams', 'paymentTypes', 'tree']
	        }),
	        watcher: {
	            isDisabled: ['order', 'isDisabled']
	        },
	        props: {
	            id: 'paymentTypes',
	            onItemCheck: paymentTypes.onItemCheck,
	            onSetAll: paymentTypes.onSetAll,
	            minFilterLength: 2,
	            showOnlyTree: true,
	            isInnerTree: true
	        },
	        parentPropsMap: {
	            isSmallTree: 'isSmallTree'
	        }
	    }]
	};

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(804);
	
	var Discount = function () {
	    function Discount() {
	        _classCallCheck(this, Discount);
	
	        this.template = __webpack_require__(940);
	    }
	
	    Discount.prototype.render = function render() {
	        var props = this.$context.props;
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, props, { css: css });
	        });
	    };
	
	    return Discount;
	}();
	
	module.exports = {
	    constructor: Discount
	};

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(806);
	
	var CitiesHeader = function () {
	    function CitiesHeader() {
	        _classCallCheck(this, CitiesHeader);
	
	        this.template = __webpack_require__(943);
	    }
	
	    CitiesHeader.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    return CitiesHeader;
	}();
	
	module.exports = {
	    constructor: CitiesHeader
	};

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Content = __webpack_require__(370);
	var Header = __webpack_require__(373);
	var Collapse = __webpack_require__(149);
	
	module.exports = {
	    constructor: Collapse,
	    children: [{
	        name: 'content',
	        component: Content,
	        parentPropsMap: {
	            isSmallTree: 'isSmallTree'
	        },
	        watcher: {
	            isDisabled: ['order', 'isDisabled'],
	            basicColumns: ['order', 'computed', 'exportColumns', 'basic', 'viewOrder'],
	            optionalColumns: ['order', 'computed', 'exportColumns', 'optional', 'viewOrder'],
	            isOfflineOrder: ['order', 'computed', 'isOfflineOrder']
	        }
	    }, {
	        name: 'header',
	        component: Header
	    }]
	};

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(807);
	
	var _require = __webpack_require__(4),
	    cut = _require.cut;
	
	var SELECTOR_TOGGLE_FILTER = cut(css.button);
	
	var _require2 = __webpack_require__(227),
	    toggleCalcOnlyDefaultCities = _require2.toggleCalcOnlyDefaultCities;
	
	var BranchFilter = function () {
	    function BranchFilter() {
	        _classCallCheck(this, BranchFilter);
	
	        this.template = __webpack_require__(944);
	    }
	
	    BranchFilter.prototype.render = function render() {
	        var _this = this;
	
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css }, _this.$context.props);
	        });
	    };
	
	    BranchFilter.prototype.bind = function bind() {
	        var _click;
	
	        return {
	            click: (_click = {}, _click[SELECTOR_TOGGLE_FILTER] = this.toggleFilter, _click)
	        };
	    };
	
	    BranchFilter.prototype.toggleFilter = function toggleFilter(e) {
	        e.stopPropagation();
	        this.$context.signal(toggleCalcOnlyDefaultCities);
	    };
	
	    return BranchFilter;
	}();
	
	module.exports = {
	    constructor: BranchFilter
	};

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var cities = __webpack_require__(117);
	var css = __webpack_require__(809);
	
	var _require = __webpack_require__(4),
	    cut = _require.cut;
	
	var SELECTOR_TOGGLE_FILTER_TYPE = cut(css.button);
	
	var Tooltip = function () {
	    function Tooltip() {
	        _classCallCheck(this, Tooltip);
	
	        this.template = __webpack_require__(945);
	    }
	
	    Tooltip.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    Tooltip.prototype.bind = function bind() {
	        var _click;
	
	        return {
	            click: (_click = {}, _click[SELECTOR_TOGGLE_FILTER_TYPE] = this.toggleFilterType, _click)
	        };
	    };
	
	    Tooltip.prototype.toggleFilterType = function toggleFilterType(e) {
	        e.stopPropagation();
	        this.$context.signal(cities.toggleFilterType);
	    };
	
	    return Tooltip;
	}();
	
	module.exports = {
	    constructor: Tooltip
	};

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(808);
	var filterableTreeFactory = __webpack_require__(89);
	var mapFilter = __webpack_require__(378);
	var branchFilter = __webpack_require__(375);
	var cities = __webpack_require__(117);
	var branches = __webpack_require__(227);
	
	var _require = __webpack_require__(117),
	    toggleMapFilter = _require.toggleMapFilter;
	
	var _require2 = __webpack_require__(159),
	    _selectTab = _require2.selectTab;
	
	var bitrix = __webpack_require__(29);
	var FilterByList = __webpack_require__(376);
	var TreeInput = __webpack_require__(379);
	
	var _require3 = __webpack_require__(4),
	    cut = _require3.cut;
	
	var CitiesContent = function () {
	    function CitiesContent() {
	        _classCallCheck(this, CitiesContent);
	
	        this.template = __webpack_require__(947);
	    }
	
	    CitiesContent.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            var result = Object.assign({ css: css }, data);
	            if (result.tab === undefined) {
	                result.tab = 'default';
	            }
	            return result;
	        });
	    };
	
	    CitiesContent.prototype.bind = function bind() {
	        var _click;
	
	        this.$context.signal(bitrix.resizeIfAccountPage);
	        return {
	            click: (_click = {}, _click[cut(css.toggleFilterType)] = this.toggleFilter, _click[cut(css.tab)] = this.selectTab, _click)
	        };
	    };
	
	    CitiesContent.prototype.toggleFilter = function toggleFilter(e) {
	        e.stopPropagation();
	        this.$context.signal(toggleMapFilter);
	    };
	
	    CitiesContent.prototype.selectTab = function selectTab(e) {
	        e.stopPropagation();
	        var tabId = e.currentTarget.getAttribute('cat-id');
	        this.$context.signal(_selectTab, { tabId: tabId });
	    };
	
	    return CitiesContent;
	}();
	
	module.exports = {
	    constructor: CitiesContent,
	    children: [{
	        name: 'filterable-tree',
	        component: filterableTreeFactory({
	            basePath: ['order', 'cities', 'tree']
	        }),
	        watcher: {
	            isDisabled: ['order', 'isDisabled']
	        },
	        props: {
	            id: 'cities',
	            onItemCheck: cities.onItemCheck,
	            onSetAll: cities.onSetAll,
	            minFilterLength: 3
	        },
	        parentPropsMap: {
	            isSmallTree: 'isSmallTree'
	        }
	    }, {
	        name: 'branches-tree',
	        component: filterableTreeFactory({
	            basePath: ['order', 'branches', 'tree'],
	            customFilter: {
	                component: branchFilter,
	                watcher: {
	                    isCalcOnlyDefaultCities: ['order', 'cities', 'calcOnlyDefaultCities']
	                }
	            }
	        }),
	        watcher: {
	            isDisabled: ['order', 'isDisabled']
	        },
	        props: {
	            id: 'branches',
	            onItemCheck: branches.onItemCheck,
	            onSetAll: branches.onSetAll,
	            minFilterLength: 3
	        },
	        parentPropsMap: {
	            isSmallTree: 'isSmallTree'
	        }
	    }, {
	        name: 'map-filter',
	        component: mapFilter,
	        watcher: {
	            mapFilter: ['order', 'cities', 'mapFilterInit'],
	            isDisabled: ['order', 'isDisabled']
	        }
	    }, {
	        name: 'filter-by-list',
	        component: FilterByList,
	        watcher: {
	            isDisabled: ['order', 'isDisabled'],
	            showFilterTreeInput: ['order', 'cities', 'tree', 'showFilterTreeInput']
	        }
	    }, {
	        name: 'tree-input',
	        component: TreeInput,
	        props: {
	            treeId: 'cities',
	            basePath: ['order', 'branches', 'tree']
	        },
	        watcher: {
	            haveUnrecognized: ['order', 'computed', 'treeUpload', 'cities', 'haveUnrecognized'],
	            unrecognized: ['order', 'computed', 'treeUpload', 'cities', 'unrecognized'],
	            recognized: ['order', 'computed', 'treeUpload', 'cities', 'recognized'],
	            showFilterTreeInput: ['order', 'cities', 'tree', 'showFilterTreeInput']
	        }
	    }]
	};

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(810);
	var $ = __webpack_require__(12);
	
	var _require = __webpack_require__(30),
	    setMapFilter = _require.setMapFilter;
	
	var _require2 = __webpack_require__(4),
	    cut = _require2.cut;
	
	var SELECTOR_MAP = cut(css.map);
	var SELECTOR_SEARCH = cut(css.search);
	var mymap = void 0;
	var editMode = void 0;
	var editModeTimerId = void 0;
	
	var MapFilter = function () {
	    function MapFilter() {
	        _classCallCheck(this, MapFilter);
	
	        this.template = __webpack_require__(946);
	    }
	
	    MapFilter.prototype.render = function render() {
	        var _this = this;
	
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css }, _this.$context.props);
	        });
	    };
	
	    MapFilter.prototype.bind = function bind() {
	        var _change, _input, _keyup;
	
	        var polygon = void 0;
	        this.$context.getWatcherData().then(function (data) {
	            var DG = __webpack_require__(287);
	            DG.then(function () {
	                return DG.plugin('/static/assets/leaflet.draw/leaflet.draw.js');
	            }).then(function () {
	                var mapParent = document.getElementById('mapid-parent');
	                var newMapDiv = document.createElement('div');
	                newMapDiv.setAttribute('id', 'mapid');
	                newMapDiv.className = SELECTOR_MAP.substring(1);
	                mapParent.replaceChild(newMapDiv, document.getElementById('mapid'));
	
	                mymap = DG.map('mapid', { wheelPxPerZoomLevel: 50 });
	                mymap.setView([55.000462844547805, 82.92549133300783], 11);
	
	                L.drawLocal.draw.handlers.rectangle.tooltip.start = "Зажмите кнопку мыши, чтобы начать рисовать";
	                L.drawLocal.draw.handlers.simpleshape.tooltip.end = "Отпустите кнопку, чтобы закончить рисовать";
	
	                if (data.mapFilter) {
	                    var coordinates = JSON.parse(data.mapFilter).coordinates;
	                    var leftUpper = coordinates[0][0];
	                    var rightBottom = coordinates[0][2];
	                    var bounds = [[leftUpper[1], leftUpper[0]], [rightBottom[1], rightBottom[0]]];
	
	                    polygon = DG.rectangle(bounds);
	                    polygon.addTo(mymap);
	
	                    mymap.fitBounds(bounds);
	                    if (!data.isDisabled) {
	                        polygon.editing.enable();
	                    }
	                }
	
	                if (!data.isDisabled) {
	                    var _DispatchMapFilterChanged = function _DispatchMapFilterChanged() {
	                        editMode = false;
	                        if (polygon) {
	                            var element = document.getElementById('mapid');
	                            var detail = JSON.stringify(polygon.toGeoJSON().geometry);
	
	                            var event = void 0;
	
	                            if (document.createEvent) {
	                                event = document.createEvent("CustomEvent");
	                                event.initCustomEvent("change", true, true, detail);
	                            } else {
	                                event = new CustomEvent('change', { bubbles: true, cancelable: true, detail: detail });
	                            }
	
	                            element.dispatchEvent(event);
	                        }
	                    };
	
	                    var onEdit = function onEdit() {
	                        editMode = true;
	                        if (editModeTimerId) {
	                            clearTimeout(editModeTimerId);
	                            editModeTimerId = undefined;
	                        }
	                        editModeTimerId = setTimeout(_DispatchMapFilterChanged, 500);
	                    };
	
	                    mymap.on('click', function (e) {
	                        if (editMode) {
	                            return;
	                        }
	
	                        if (polygon) {
	                            var leftTop = polygon._bounds._southWest;
	                            var _rightBottom = polygon._bounds._northEast;
	
	                            if (e.latlng.lng >= leftTop.lng && e.latlng.lng <= _rightBottom.lng && e.latlng.lat >= leftTop.lat && e.latlng.lat <= _rightBottom.lat) {
	                                return;
	                            }
	
	                            mymap.removeLayer(polygon);
	                        }
	
	                        var newPolygon = new L.Draw.Rectangle(mymap);
	                        newPolygon.enable();
	                    });
	
	                    mymap.on('draw:created', function (e) {
	                        polygon = e.layer;
	                        mymap.addLayer(polygon);
	                        polygon.editing.enable();
	                        _DispatchMapFilterChanged();
	                    });
	
	                    mymap.on('draw:editresize', onEdit);
	                    mymap.on('draw:editmove', onEdit);
	                }
	            });
	        });
	
	        return {
	            change: (_change = {}, _change['#mapid'] = this.filterChanged, _change),
	            input: (_input = {}, _input['#citySelect'] = this.citySelected, _input),
	            keyup: (_keyup = {}, _keyup[SELECTOR_SEARCH] = this.searchChanged, _keyup)
	        };
	    };
	
	    MapFilter.prototype.citySelected = function citySelected(e) {
	        e.stopPropagation();
	        $.getJSON('https://catalog.api.2gis.ru/2.0/geo/search', {
	            q: e.currentTarget.value,
	            fields: 'items.geometry.centroid',
	            type: 'adm_div.city,adm_div.settlement',
	            limit: 1,
	            key: 'rujlnh2071'
	        }).done(function (data) {
	            if (typeof data.result !== 'undefined') {
	                var geo = data.result.items[0].geometry.centroid;
	                geo = geo.replace('POINT(', '').replace(')', '').split(' ');
	                mymap.setView([geo[1], geo[0]], 11);
	            }
	        });
	    };
	
	    MapFilter.prototype.filterChanged = function filterChanged(e) {
	        e.stopPropagation();
	        this.$context.signal(setMapFilter, { mapFilter: e.detail });
	    };
	
	    MapFilter.prototype.searchChanged = function searchChanged(e) {
	        e.stopPropagation();
	        document.getElementById("cityname").innerHTML = '';
	        $.getJSON('https://catalog.api.2gis.ru/2.0/geo/search', {
	            q: e.currentTarget.value,
	            fields: 'items.geometry.centroid',
	            type: 'adm_div.city,adm_div.settlement',
	            limit: 1,
	            key: 'rujlnh2071'
	        }).done(function (data) {
	            if (typeof data.result !== 'undefined') {
	                document.getElementById("cityname").innerHTML = '<option value="' + data.result.items[0].name + '">';
	                var geo = data.result.items[0].geometry.centroid;
	                geo = geo.replace('POINT(', '').replace(')', '').split(' ');
	                mymap.setView([geo[1], geo[0]], 11);
	            }
	        });
	    };
	
	    return MapFilter;
	}();
	
	module.exports = {
	    constructor: MapFilter
	};

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _require = __webpack_require__(4),
	    cut = _require.cut;
	
	var css = __webpack_require__(812);
	var signals = __webpack_require__(159);
	var Tooltip = __webpack_require__(380);
	
	var TreeInput = function () {
	    function TreeInput() {
	        _classCallCheck(this, TreeInput);
	
	        this.template = __webpack_require__(948);
	    }
	
	    TreeInput.prototype.render = function render() {
	        var _this = this;
	
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css }, _this.$context.props);
	        });
	    };
	
	    TreeInput.prototype.bind = function bind() {
	        var _click;
	
	        return {
	            click: (_click = {}, _click[cut(css.filterButton)] = this.uploadTreeValues, _click[cut(css.downloadButton)] = this.downloadList, _click)
	        };
	    };
	
	    TreeInput.prototype.uploadTreeValues = function uploadTreeValues(e) {
	        e.stopPropagation();
	        var treeInputId = e.currentTarget.attributes['cat-id'].value;
	        var treeInputUnrecognizedId = e.currentTarget.attributes['cat-id-unrecognized'].value;
	        var treeInput = document.getElementById(treeInputId).value;
	
	        var inputUnrecognized = document.getElementById(treeInputUnrecognizedId);
	        if (inputUnrecognized) {
	            treeInput = treeInput.concat('\n', inputUnrecognized.value);
	        }
	
	        this.$context.signal(signals.uploadTreeInputCities, { treeInput: treeInput, treeInputId: treeInputId, treeId: this.$context.props.treeId, basePath: this.$context.props.basePath });
	    };
	
	    TreeInput.prototype.downloadList = function downloadList(e) {
	        e.stopPropagation();
	        this.$context.signal(signals.downloadCitiesFile);
	    };
	
	    return TreeInput;
	}();
	
	module.exports = {
	    constructor: TreeInput,
	    children: [{
	        name: 'tooltip',
	        component: Tooltip,
	        watcher: {
	            haveUnrecognized: ['order', 'computed', 'treeUpload', 'cities', 'haveUnrecognized'],
	            recognizeAll: ['order', 'treeUpload', 'cities', 'recognizeAll']
	        }
	    }]
	};

/***/ }),
/* 380 */
[1063, 811, 949],
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(813);
	var CountHeader = __webpack_require__(212);
	
	var CitiesHeader = function () {
	    function CitiesHeader() {
	        _classCallCheck(this, CitiesHeader);
	
	        this.template = __webpack_require__(950);
	    }
	
	    CitiesHeader.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    return CitiesHeader;
	}();
	
	module.exports = {
	    constructor: CitiesHeader,
	    children: [{
	        name: 'cities-count',
	        component: CountHeader,
	        props: {
	            pluralized: ['город', 'города', 'городов'],
	            defaultTitle: 'Выберите город'
	        },
	        watcher: {
	            leafs: ['order', 'cities', 'tree', 'computed', 'leafs'],
	            selected: ['order', 'cities', 'tree', 'selected']
	        }
	    }, {
	        name: 'branches-count',
	        component: CountHeader,
	        props: {
	            pluralized: ['проект', 'проекта', 'проектов'],
	            defaultTitle: 'Выберите проект'
	        },
	        watcher: {
	            leafs: ['order', 'branches', 'tree', 'computed', 'leafs'],
	            selected: ['order', 'branches', 'tree', 'selected']
	        }
	    }]
	};

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Content = __webpack_require__(377);
	var Header = __webpack_require__(381);
	var Collapse = __webpack_require__(149);
	
	module.exports = module.exports = {
	    constructor: Collapse,
	    children: [{
	        name: 'content',
	        component: Content,
	        parentPropsMap: {
	            isSmallTree: 'isSmallTree'
	        },
	        watcher: {
	            tab: ['order', 'cities', 'tab'],
	            isDisabled: ['order', 'isDisabled'],
	            isManager: ['user', 'isManager']
	        }
	    }, {
	        name: 'header',
	        component: Header,
	        watcher: {
	            tab: ['order', 'cities', 'tab']
	        }
	    }]
	};

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(816);
	var CHECKBOX = '.' + css.checkbox;
	
	var Checkbox = function () {
	    function Checkbox() {
	        _classCallCheck(this, Checkbox);
	
	        this.template = __webpack_require__(952);
	    }
	
	    Checkbox.prototype.render = function render() {
	        var _this = this;
	
	        return this.$context.getWatcherData().then(function (data) {
	            var attributes = _this.$context.attributes;
	            return Object.assign({}, data, attributes, { css: css });
	        });
	    };
	
	    Checkbox.prototype.bind = function bind() {
	        var _change;
	
	        return {
	            change: (_change = {}, _change[CHECKBOX] = this.onChange, _change)
	        };
	    };
	
	    Checkbox.prototype.onChange = function onChange(e) {
	        e.stopPropagation();
	
	        var signal = this.$context.props.signal;
	        var path = this.$context.attributes['cat-path'];
	        var value = e.currentTarget.checked;
	
	        this.$context.signal(signal, { path: path, value: value });
	    };
	
	    return Checkbox;
	}();
	
	module.exports = {
	    constructor: Checkbox
	};

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _require = __webpack_require__(4),
	    cut = _require.cut;
	
	var css = __webpack_require__(817);
	
	var SELECTOR_UNSELECT = cut(css.unselect);
	var SELECTOR_SELECT = cut(css.select);
	var SELECTOR_SHOW_SELECTED_ONLY = cut(css.showSelectedOnly);
	
	var Controls = function () {
	    function Controls() {
	        _classCallCheck(this, Controls);
	
	        this.template = __webpack_require__(953);
	    }
	
	    Controls.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    Controls.prototype.bind = function bind() {
	        var _click;
	
	        return {
	            click: (_click = {}, _click[SELECTOR_UNSELECT] = this.onUnselect, _click[SELECTOR_SELECT] = this.onSelect, _click[SELECTOR_SHOW_SELECTED_ONLY] = this.onShowSelectedOnly, _click)
	        };
	    };
	
	    Controls.prototype.onUnselect = function onUnselect(e) {
	        e.stopPropagation();
	
	        var signal = this.$context.props.onSetAll;
	        this.$context.signal(signal, { value: false });
	    };
	
	    Controls.prototype.onSelect = function onSelect(e) {
	        e.stopPropagation();
	
	        var signal = this.$context.props.onSetAll;
	        this.$context.signal(signal, { value: true });
	    };
	
	    Controls.prototype.onShowSelectedOnly = function onShowSelectedOnly(e) {
	        e.stopPropagation();
	
	        var basePath = this.$context.props.basePath;
	        var treeId = this.$context.props.treeId;
	        var signal = this.$context.props.onShowSelectedOnly;
	        this.$context.signal(signal, { basePath: basePath, treeId: treeId });
	    };
	
	    return Controls;
	}();
	
	module.exports = function (customFilter) {
	    var children = undefined;
	
	    if (customFilter) {
	        customFilter.name = 'custom-filter';
	        children = [customFilter];
	    }
	
	    return {
	        constructor: Controls,
	        children: children
	    };
	};

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _ = __webpack_require__(3);
	var Simple = __webpack_require__(386);
	
	var Filter = function () {
	    function Filter() {
	        _classCallCheck(this, Filter);
	
	        this.template = __webpack_require__(956);
	    }
	
	    Filter.prototype.render = function render() {
	        var _this = this;
	
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, _this.$context.props);
	        });
	    };
	
	    return Filter;
	}();
	
	module.exports = {
	    constructor: Filter,
	    children: [{
	        name: 'simple',
	        component: Simple,
	        parentPropsMap: {
	            onFilter: 'onFilter',
	            basePath: 'basePath',
	            minLength: 'minLength',
	            treeId: 'treeId'
	        }
	    }]
	};

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _ = __webpack_require__(3);
	
	var _require = __webpack_require__(4),
	    cut = _require.cut;
	
	var css = __webpack_require__(819);
	var signals = __webpack_require__(228);
	
	var SELECTOR_FILTER = cut(css.filter);
	
	var Filter = function () {
	    function Filter() {
	        _classCallCheck(this, Filter);
	
	        this.template = __webpack_require__(955);
	    }
	
	    Filter.prototype.render = function render() {
	        var _this = this;
	
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css }, { treeId: _this.$context.props.treeId });
	        });
	    };
	
	    Filter.prototype.bind = function bind() {
	        var _input;
	
	        this.initFilter();
	        return {
	            input: (_input = {}, _input[SELECTOR_FILTER] = _.debounce(this.filterChange, 100), _input)
	        };
	    };
	
	    Filter.prototype.initFilter = function initFilter() {
	        var basePath = this.$context.props.basePath;
	        var treeId = this.$context.props.treeId;
	        this.$context.signal(signals.initFilter, { basePath: basePath, treeId: treeId });
	    };
	
	    Filter.prototype.filterChange = function filterChange(e) {
	        e.stopPropagation();
	        var value = e.currentTarget.value;
	        var minLength = this.$context.props.minLength;
	        var basePath = this.$context.props.basePath;
	        var signal = this.$context.props.onFilter;
	
	        this.$context.signal(signal, { basePath: basePath, value: value, minLength: minLength });
	    };
	
	    return Filter;
	}();
	
	module.exports = {
	    constructor: Filter
	};

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(821);
	
	var SelectionCount = function () {
	    function SelectionCount() {
	        _classCallCheck(this, SelectionCount);
	
	        this.template = __webpack_require__(957);
	    }
	
	    SelectionCount.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    return SelectionCount;
	}();
	
	module.exports = {
	    constructor: SelectionCount
	};

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Checkbox = __webpack_require__(383);
	var SelectionCount = __webpack_require__(387);
	var cities = __webpack_require__(117);
	
	var _require = __webpack_require__(4),
	    cut = _require.cut;
	
	var css = __webpack_require__(822);
	var _ = __webpack_require__(3);
	
	var SELECTOR_EXPANDER = cut(css.expandable);
	var SELECTOR_BRANCH_BUTTON = cut(css.branchButton);
	
	var Tree = function () {
	    function Tree() {
	        _classCallCheck(this, Tree);
	
	        this.template = __webpack_require__(959);
	    }
	
	    Tree.prototype.render = function render() {
	        var _this = this;
	
	        var root = this.$context.attributes['cat-root'];
	        return this.$context.getWatcherData().then(function (data) {
	            var showNoSelectionMessage = root && data.showSelectedOnly && !_.get(data, 'item.children.length');
	            var shouldExpand = root || data.autoExpand || data.expand;
	            var isVisible = root || data.showSelectedOnly && data.isSelected || !data.showSelectedOnly;
	            var checkboxIdPrefix = _this.$context.props.checkboxIdPrefix;
	            var isSmallTree = _this.$context.props.isSmallTree === 'true';
	            return Object.assign({}, data, { root: root }, {
	                shouldExpand: shouldExpand,
	                isVisible: isVisible,
	                checkboxIdPrefix: checkboxIdPrefix,
	                showNoSelectionMessage: showNoSelectionMessage,
	                isSmallTree: isSmallTree
	            }, { css: css });
	        });
	    };
	
	    Tree.prototype.bind = function bind() {
	        var _click;
	
	        return {
	            click: (_click = {}, _click[SELECTOR_EXPANDER] = this.switchCollapse, _click[SELECTOR_BRANCH_BUTTON] = this.selectBranch, _click)
	        };
	    };
	
	    Tree.prototype.switchCollapse = function switchCollapse(e) {
	        e.preventDefault();
	        e.stopPropagation();
	
	        var signal = this.$context.props.onSubTreeCollapse;
	        var nodeId = this.$context.attributes['cat-id'];
	        var basePath = this.$context.props.basePath;
	        this.$context.signal(signal, { basePath: basePath, nodeId: nodeId });
	    };
	
	    Tree.prototype.selectBranch = function selectBranch(e) {
	        e.preventDefault();
	        e.stopPropagation();
	
	        var branchId = Number(e.currentTarget.attributes['cat-branch-id'].value);
	        var basePath = this.$context.props.basePath;
	        this.$context.signal(cities.onBranchCheck, { basePath: basePath, branchId: branchId, value: true });
	    };
	
	    return Tree;
	}();
	
	module.exports = function (basePath) {
	    return {
	        constructor: Tree,
	        children: [{
	            name: 'tree',
	            recursive: true
	        }, {
	            name: 'checkbox',
	            component: Checkbox,
	            watcher: function watcher(attributes) {
	                var nodeId = attributes['cat-path'];
	                return {
	                    value: basePath.concat('selected', nodeId, 'value'),
	                    indeterminate: basePath.concat('selected', nodeId, 'indeterminate')
	                };
	            },
	
	            props: {},
	            parentPropsMap: {
	                signal: 'onItemCheck'
	            }
	        }, {
	            name: 'selection-count',
	            component: SelectionCount,
	            watcher: function watcher(attributes) {
	                var nodeId = attributes['cat-path'];
	                return {
	                    total: basePath.concat('computed', 'descendantLeafsCount', nodeId),
	                    selected: basePath.concat('computed', 'selectedDescendantLeafsCount', nodeId)
	                };
	            }
	        }]
	    };
	};

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _require = __webpack_require__(229),
	    _toggleFilterType = _require.toggleFilterType;
	
	var css = __webpack_require__(823);
	
	var _require2 = __webpack_require__(4),
	    cut = _require2.cut;
	
	var SELECTOR_TOGGLE_FILTER_TYPE = cut(css.button);
	
	var Tooltip = function () {
	    function Tooltip() {
	        _classCallCheck(this, Tooltip);
	
	        this.template = __webpack_require__(960);
	    }
	
	    Tooltip.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    Tooltip.prototype.bind = function bind() {
	        var _click;
	
	        return {
	            click: (_click = {}, _click[SELECTOR_TOGGLE_FILTER_TYPE] = this.toggleFilterType, _click)
	        };
	    };
	
	    Tooltip.prototype.toggleFilterType = function toggleFilterType(e) {
	        e.stopPropagation();
	        this.$context.signal(_toggleFilterType);
	    };
	
	    return Tooltip;
	}();
	
	module.exports = {
	    constructor: Tooltip
	};

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var filterableTreeFactory = __webpack_require__(89);
	var rubrics = __webpack_require__(229);
	var TreeInput = __webpack_require__(391);
	var FilterByList = __webpack_require__(389);
	var css = __webpack_require__(824);
	
	var id = 'rubrics';
	var basePath = ['order', 'rubrics', 'tree'];
	
	var Rubrics = function () {
	    function Rubrics() {
	        _classCallCheck(this, Rubrics);
	
	        this.template = __webpack_require__(961);
	    }
	
	    Rubrics.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({ css: css }, data);
	        });
	    };
	
	    return Rubrics;
	}();
	
	module.exports = {
	    constructor: Rubrics,
	    children: [{
	        name: 'filterable-tree',
	        component: filterableTreeFactory({
	            basePath: basePath
	        }),
	        watcher: {
	            isDisabled: ['order', 'isDisabled']
	        },
	        props: {
	            id: id,
	            onItemCheck: rubrics.onItemCheck,
	            onSetAll: rubrics.onSetAll,
	            minFilterLength: 3
	        },
	        parentPropsMap: {
	            isSmallTree: 'isSmallTree'
	        }
	    }, {
	        name: 'filter-by-list',
	        component: FilterByList,
	        watcher: {
	            isDisabled: ['order', 'isDisabled'],
	            showFilterTreeInput: basePath.concat('showFilterTreeInput')
	        }
	    }, {
	        name: 'tree-input',
	        component: TreeInput,
	        props: {
	            treeId: id,
	            basePath: basePath
	        },
	        watcher: {
	            haveUnrecognizedRubrics: ['order', 'computed', 'treeUpload', 'rubrics', 'haveUnrecognized'],
	            unrecognizedRubrics: ['order', 'computed', 'treeUpload', 'rubrics', 'unrecognized'],
	            recognizedRubrics: ['order', 'computed', 'treeUpload', 'rubrics', 'recognized'],
	            showFilterTreeInput: basePath.concat('showFilterTreeInput')
	        }
	    }]
	};

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _require = __webpack_require__(4),
	    cut = _require.cut;
	
	var css = __webpack_require__(826);
	var signals = __webpack_require__(159);
	var Tooltip = __webpack_require__(392);
	
	var TreeInput = function () {
	    function TreeInput() {
	        _classCallCheck(this, TreeInput);
	
	        this.template = __webpack_require__(962);
	    }
	
	    TreeInput.prototype.render = function render() {
	        var _this = this;
	
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css }, _this.$context.props);
	        });
	    };
	
	    TreeInput.prototype.bind = function bind() {
	        var _click;
	
	        return {
	            click: (_click = {}, _click[cut(css.filterButton)] = this.uploadTreeValues, _click[cut(css.downloadButton)] = this.downloadList, _click)
	        };
	    };
	
	    TreeInput.prototype.uploadTreeValues = function uploadTreeValues(e) {
	        e.stopPropagation();
	        var treeInputId = e.currentTarget.attributes['cat-id'].value;
	        var treeInputUnrecognizedId = e.currentTarget.attributes['cat-id-unrecognized'].value;
	        var treeInput = document.getElementById(treeInputId).value;
	
	        var inputUnrecognized = document.getElementById(treeInputUnrecognizedId);
	        if (inputUnrecognized) {
	            treeInput = treeInput.concat('\n', inputUnrecognized.value);
	        }
	
	        this.$context.signal(signals.uploadTreeInputRubrics, { treeInput: treeInput, treeInputId: treeInputId, treeId: this.$context.props.treeId, basePath: this.$context.props.basePath });
	    };
	
	    TreeInput.prototype.downloadList = function downloadList(e) {
	        e.stopPropagation();
	        this.$context.signal(signals.downloadRubricsFile);
	    };
	
	    return TreeInput;
	}();
	
	module.exports = {
	    constructor: TreeInput,
	    children: [{
	        name: 'tooltip',
	        component: Tooltip,
	        watcher: {
	            haveUnrecognizedRubrics: ['order', 'computed', 'treeUpload', 'rubrics', 'haveUnrecognized'],
	            recognizeAllRubrics: ['order', 'treeUpload', 'rubrics', 'recognizeAll']
	        }
	    }]
	};

/***/ }),
/* 392 */
[1063, 825, 963],
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(827);
	var CountHeader = __webpack_require__(212);
	
	var RubricsHeader = function () {
	    function RubricsHeader() {
	        _classCallCheck(this, RubricsHeader);
	
	        this.template = __webpack_require__(964);
	    }
	
	    RubricsHeader.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    return RubricsHeader;
	}();
	
	module.exports = {
	    constructor: RubricsHeader,
	    children: [{
	        name: 'count-header',
	        component: CountHeader,
	        props: {
	            pluralized: ['рубрика', 'рубрики', 'рубрик'],
	            defaultTitle: 'Выберите рубрику'
	        },
	        watcher: {
	            leafs: ['order', 'rubrics', 'tree', 'computed', 'leafs'],
	            selected: ['order', 'rubrics', 'tree', 'selected']
	        }
	    }]
	};

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Content = __webpack_require__(390);
	var Header = __webpack_require__(393);
	var Collapse = __webpack_require__(149);
	
	module.exports = {
	    constructor: Collapse,
	    children: [{
	        name: 'content',
	        component: Content,
	        parentPropsMap: {
	            isSmallTree: 'isSmallTree'
	        },
	        watcher: {
	            isDisabled: ['order', 'isDisabled']
	        }
	    }, {
	        name: 'header',
	        component: Header
	    }]
	};

/***/ }),
/* 395 */
[1063, 828, 966],
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(829);
	
	var Prices = function () {
	    function Prices() {
	        _classCallCheck(this, Prices);
	
	        this.template = __webpack_require__(968);
	    }
	
	    Prices.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    return Prices;
	}();
	
	module.exports = {
	    constructor: Prices
	};

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(830);
	
	var _require = __webpack_require__(4),
	    cut = _require.cut;
	
	var signals = __webpack_require__(225);
	var bitrix = __webpack_require__(29);
	
	var SAVE_BUTTON_SELECTOR = cut(css.saveButton);
	var CANCEL_BUTTON_SELECTOR = cut(css.cancelButton);
	
	var ActionsPanel = function () {
	    function ActionsPanel() {
	        _classCallCheck(this, ActionsPanel);
	
	        this.template = __webpack_require__(972);
	    }
	
	    ActionsPanel.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    ActionsPanel.prototype.bind = function bind() {
	        var _click;
	
	        this.$context.signal(bitrix.resize);
	        return {
	            click: (_click = {}, _click[SAVE_BUTTON_SELECTOR] = this.save, _click[CANCEL_BUTTON_SELECTOR] = this.cancel, _click)
	        };
	    };
	
	    ActionsPanel.prototype.save = function save() {
	        this.$context.signal(signals.onSaveUserInfoChange);
	    };
	
	    ActionsPanel.prototype.cancel = function cancel() {
	        this.$context.signal(signals.onCancelUserInfoChange);
	    };
	
	    return ActionsPanel;
	}();
	
	module.exports = {
	    constructor: ActionsPanel
	};

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(832);
	var signals = __webpack_require__(501);
	
	var Contacts = function () {
	    function Contacts() {
	        _classCallCheck(this, Contacts);
	
	        this.template = __webpack_require__(975);
	    }
	
	    Contacts.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    Contacts.prototype.bind = function bind() {
	        this.$context.signal(signals.onLoad);
	    };
	
	    return Contacts;
	}();
	
	module.exports = {
	    constructor: Contacts
	};

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(833);
	
	var _require = __webpack_require__(4),
	    cut = _require.cut;
	
	var SELECTOR_STATE = cut(css.state);
	
	var Devtools = function () {
	    function Devtools(serviceLocator) {
	        _classCallCheck(this, Devtools);
	
	        this._locator = serviceLocator;
	        this.template = __webpack_require__(976);
	    }
	
	    Devtools.prototype.render = function render() {
	        return { css: css };
	    };
	
	    Devtools.prototype.bind = function bind() {
	        var _click;
	
	        this._history = this._locator.resolve('history');
	
	        return {
	            click: (_click = {}, _click[SELECTOR_STATE] = this.logStateTree, _click)
	        };
	    };
	
	    Devtools.prototype.logStateTree = function logStateTree(e) {
	        e.preventDefault();
	        e.stopPropagation();
	
	        this._history.logTree();
	    };
	
	    return Devtools;
	}();
	
	module.exports = {
	    constructor: Devtools
	};

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(834);
	
	var _require = __webpack_require__(4),
	    cut = _require.cut;
	
	var COLLAPSER_SELECTOR = cut(css.collapserHead);
	var Prices = __webpack_require__(396);
	var Discounts = __webpack_require__(151);
	var bitrix = __webpack_require__(29);
	
	var _require2 = __webpack_require__(11),
	    _redirect = _require2.redirect;
	
	var Help = function () {
	    function Help() {
	        _classCallCheck(this, Help);
	
	        this.template = __webpack_require__(977);
	    }
	
	    Help.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    Help.prototype.bind = function bind() {
	        var _click;
	
	        return {
	            click: (_click = {}, _click[COLLAPSER_SELECTOR] = this.collapserClick, _click[cut(css.redirect)] = this.redirect, _click)
	        };
	    };
	
	    Help.prototype.redirect = function redirect(e) {
	        e.stopPropagation();
	        var url = e.currentTarget.getAttribute('cat-url');
	        this.$context.signal(_redirect, { url: url });
	    };
	
	    Help.prototype.collapserClick = function collapserClick(e) {
	        var classList = e.currentTarget.parentNode.classList;
	
	        if (!classList.contains(css.clicked)) {
	            classList.add(css.clicked);
	        } else {
	            classList.remove(css.clicked);
	        }
	        this.$context.signal(bitrix.resize);
	    };
	
	    return Help;
	}();
	
	module.exports = {
	    constructor: Help,
	    children: [{
	        name: 'prices',
	        component: Prices,
	        watcher: {
	            prices: ['data', 'computed', 'prices']
	        }
	    }, {
	        name: 'discounts',
	        component: Discounts,
	        watcher: {
	            prices: ['data', 'computed', 'discounts']
	        }
	    }]
	};

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(835);
	var Order = __webpack_require__(411);
	var BitrixMain = __webpack_require__(364);
	var Account = __webpack_require__(314);
	var Contacts = __webpack_require__(398);
	var Help = __webpack_require__(400);
	var Terms = __webpack_require__(418);
	var Overlay = __webpack_require__(156);
	var Video = __webpack_require__(419);
	var Statistic = __webpack_require__(346);
	
	var Content = function () {
	    function Content() {
	        _classCallCheck(this, Content);
	
	        this.template = __webpack_require__(978);
	    }
	
	    Content.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    return Content;
	}();
	
	module.exports = {
	    constructor: Content,
	    children: [{
	        name: 'bitrix-main',
	        component: BitrixMain
	    }, {
	        name: 'order',
	        component: Order
	    }, {
	        name: 'account',
	        component: Account,
	        watcher: {
	            isManager: ['user', 'isManager'],
	            ordersTabIsSelected: ['subnavigation', 'elements', 0, 'isSelected']
	        }
	    }, {
	        name: 'personal',
	        component: __webpack_require__(416),
	        watcher: {
	            isBitrix: ['bitrix', 'isBitrix']
	        }
	    }, {
	        name: 'contacts',
	        component: Contacts
	    }, {
	        name: 'help',
	        component: Help,
	        watcher: {
	            onlinePaymentPriceLimit: ['data', 'onlinePaymentPriceLimit'],
	            basicColumns: ['data', 'computed', 'columns', 'basic'],
	            optionalColumns: ['data', 'computed', 'columns', 'optional'],
	            isBitrix: ['bitrix', 'isBitrix'],
	            role: ['user', 'role']
	        }
	    }, {
	        name: 'terms',
	        component: Terms
	    }, {
	        name: 'video',
	        component: Video
	    }, {
	        name: 'overlay',
	        component: Overlay,
	        watcher: {
	            isLoading: ['isLoading']
	        }
	    }, {
	        name: 'statistic',
	        component: Statistic
	    }]
	};

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _ = __webpack_require__(3);
	var css = __webpack_require__(836);
	var Head = __webpack_require__(405);
	var Devtools = __webpack_require__(399);
	var Layout = __webpack_require__(408);
	var singals = __webpack_require__(509);
	
	var Document = function () {
	    function Document(locator) {
	        _classCallCheck(this, Document);
	
	        this.config = locator.resolve('config');
	        this.template = __webpack_require__(979);
	    }
	
	    Document.prototype.bind = function bind() {
	        var _this = this;
	
	        document.body.addEventListener('click', function () {
	            _this.$context.signal(singals.closePopups);
	        }, false);
	    };
	
	    Document.prototype.render = function render() {
	        var envVars = this.config;
	
	        var data = {
	            isRelease: envVars.isRelease,
	            css: css
	        };
	
	        if (this.$context.isBrowser) {
	            return data;
	        }
	
	        var deniedEnvVars = __webpack_require__(420).denied;
	        var vars = _.omit(envVars, deniedEnvVars);
	
	        data.ENV = JSON.stringify(vars);
	
	        return data;
	    };
	
	    return Document;
	}();
	
	module.exports = {
	    constructor: Document,
	    children: [{
	        name: 'head',
	        component: Head,
	        watcher: {
	            title: ['title'],
	            description: ['description']
	        }
	    }, {
	        name: 'devtools',
	        component: Devtools
	    }, {
	        name: 'layout',
	        component: Layout,
	        watcher: {
	            layout: ['layout'],
	            atCenter: ['page', 'ui', 'atCenter']
	        }
	    }]
	};

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(837);
	
	var _require = __webpack_require__(4),
	    cut = _require.cut;
	
	var utils = __webpack_require__(11);
	
	var ErrorPage = function () {
	    function ErrorPage() {
	        _classCallCheck(this, ErrorPage);
	
	        this.template = __webpack_require__(980);
	    }
	
	    ErrorPage.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            var errorType = data.errorType;
	
	            data[errorType] = true;
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    ErrorPage.prototype.bind = function bind() {
	        var _click;
	
	        return {
	            click: (_click = {}, _click[cut(css.redirect)] = this.redirect, _click)
	        };
	    };
	
	    ErrorPage.prototype.redirect = function redirect(e) {
	        e.stopPropagation();
	        var url = e.currentTarget.getAttribute('cat-url');
	        this.$context.signal(utils.redirect, { url: url });
	    };
	
	    return ErrorPage;
	}();
	
	module.exports = {
	    constructor: ErrorPage
	};

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(838);
	
	var _require = __webpack_require__(11),
	    _redirect = _require.redirect;
	
	var _require2 = __webpack_require__(4),
	    cut = _require2.cut;
	
	var Footer = function () {
	    function Footer() {
	        _classCallCheck(this, Footer);
	
	        this.template = __webpack_require__(981);
	    }
	
	    Footer.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    Footer.prototype.bind = function bind() {
	        var _click;
	
	        return {
	            click: (_click = {}, _click[cut(css.redirect)] = this.redirect, _click)
	        };
	    };
	
	    Footer.prototype.redirect = function redirect(e) {
	        e.stopPropagation();
	        var url = e.currentTarget.getAttribute('cat-url');
	        this.$context.signal(_redirect, { url: url });
	    };
	
	    return Footer;
	}();
	
	module.exports = {
	    constructor: Footer
	};

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Head = function () {
	    function Head() {
	        _classCallCheck(this, Head);
	
	        this.template = __webpack_require__(982);
	    }
	
	    Head.prototype.render = function render() {
	        return this.$context.getWatcherData();
	    };
	
	    return Head;
	}();
	
	module.exports = {
	    constructor: Head,
	    watcher: {
	        title: ['title'],
	        description: ['description']
	    }
	};

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(839);
	
	var _require = __webpack_require__(4),
	    cut = _require.cut;
	
	var UserMenu = __webpack_require__(407);
	
	var _require2 = __webpack_require__(11),
	    _redirect = _require2.redirect;
	
	var Header = function () {
	    function Header() {
	        _classCallCheck(this, Header);
	
	        this.template = __webpack_require__(983);
	    }
	
	    Header.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    Header.prototype.bind = function bind() {
	        var _click;
	
	        return {
	            click: (_click = {}, _click[cut(css.redirect)] = this.redirect, _click)
	        };
	    };
	
	    Header.prototype.redirect = function redirect(e) {
	        e.stopPropagation();
	        var url = e.currentTarget.getAttribute('cat-url');
	        this.$context.signal(_redirect, { url: url });
	    };
	
	    return Header;
	}();
	
	module.exports = {
	    constructor: Header,
	    children: [{
	        name: 'user-menu',
	        component: UserMenu,
	        watcher: {
	            email: ['user', 'email'],
	            isManager: ['user', 'isManager'],
	            isOpen: ['header', 'ui', 'settings', 'isOpen'],
	            utm: ['utm'],
	            isBitrix: ['bitrix', 'isBitrix']
	        }
	    }]
	};

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(840);
	var signals = __webpack_require__(508);
	
	var _require = __webpack_require__(4),
	    cut = _require.cut;
	
	var _require2 = __webpack_require__(11),
	    _redirect = _require2.redirect;
	
	var SELECTOR_DROPDOWN = cut(css.title);
	var SELECTOR_LOGOUT = cut(css.logout);
	
	var UserMenu = function () {
	    function UserMenu() {
	        _classCallCheck(this, UserMenu);
	
	        this.template = __webpack_require__(984);
	    }
	
	    UserMenu.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    UserMenu.prototype.bind = function bind() {
	        var _click;
	
	        return {
	            click: (_click = {}, _click[SELECTOR_DROPDOWN] = this.clickDropdown, _click[SELECTOR_LOGOUT] = this.clickLogout, _click[cut(css.redirect)] = this.redirect, _click)
	        };
	    };
	
	    UserMenu.prototype.clickDropdown = function clickDropdown(e) {
	        e.stopPropagation();
	        this.$context.signal(signals.clickSettings);
	    };
	
	    UserMenu.prototype.clickLogout = function clickLogout(e) {
	        e.preventDefault();
	        this.$context.signal(signals.clickSettings);
	        this.$context.signal(signals.clickLogout);
	    };
	
	    UserMenu.prototype.redirect = function redirect(e) {
	        e.stopPropagation();
	        this.$context.signal(signals.clickSettings);
	        var url = e.currentTarget.getAttribute('cat-url');
	        this.$context.signal(_redirect, { url: url });
	    };
	
	    return UserMenu;
	}();
	
	module.exports = {
	    constructor: UserMenu
	};

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(841);
	var Header = __webpack_require__(406);
	var OrderHeader = __webpack_require__(409);
	var Content = __webpack_require__(401);
	var Auth = __webpack_require__(357);
	var ErrorPage = __webpack_require__(403);
	var Payment = __webpack_require__(415);
	var Footer = __webpack_require__(404);
	
	var Layout = function () {
	    function Layout() {
	        _classCallCheck(this, Layout);
	
	        this.template = __webpack_require__(985);
	    }
	
	    Layout.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    return Layout;
	}();
	
	module.exports = {
	    constructor: Layout,
	    children: [{
	        name: 'header',
	        component: Header,
	        watcher: {
	            email: ['user', 'email'],
	            links: ['header', 'menu'],
	            utm: ['utm'],
	            layout: ['layout'],
	            isBitrix: ['bitrix', 'isBitrix'],
	            isManager: ['user', 'isManager']
	        }
	    }, {
	        name: 'order-header',
	        component: OrderHeader
	    }, {
	        name: 'content',
	        component: Content,
	        watcher: {
	            components: ['page', 'components']
	        }
	    }, {
	        name: 'auth',
	        component: Auth
	    }, {
	        name: 'error-page',
	        component: ErrorPage,
	        watcher: {
	            errorType: ['errorType'],
	            isBitrix: ['bitrix', 'isBitrix']
	        }
	    }, {
	        name: 'payment',
	        component: Payment
	    }, {
	        name: 'footer',
	        component: Footer,
	        watcher: {
	            isBitrix: ['bitrix', 'isBitrix'],
	            year: ['footer', 'year'],
	            utm: 'utm'
	        }
	    }]
	};

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var $ = __webpack_require__(12);
	var _ = __webpack_require__(3);
	var css = __webpack_require__(844);
	
	var _require = __webpack_require__(4),
	    cut = _require.cut;
	
	var Price = __webpack_require__(410);
	var MakeOrderButton = __webpack_require__(214);
	
	var IS_STICKED = css.isSticked;
	var WRAPPER = cut(css.wrapper);
	
	var OrderHeader = function () {
	    function OrderHeader() {
	        _classCallCheck(this, OrderHeader);
	
	        this.template = __webpack_require__(990);
	    }
	
	    OrderHeader.prototype.bind = function bind() {
	        this.initScroller();
	    };
	
	    OrderHeader.prototype.unbind = function unbind() {
	        $(window).unbind('scroll', this._scrollHandler);
	    };
	
	    OrderHeader.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    OrderHeader.prototype.initScroller = function initScroller() {
	        var header = $(this.$context.getComponentById('header').$context.element);
	        this.headerHeight = header.height();
	        this.wrapperElement = $(this.$context.element).find(WRAPPER);
	        this._scrollHandler = _.bind(this.scrollHandler, this);
	
	        $(window).scroll(this._scrollHandler);
	        this.scrollHandler();
	    };
	
	    OrderHeader.prototype.scrollHandler = function scrollHandler() {
	        var topView = $(window).scrollTop();
	        var viewLessHeader = topView >= this.headerHeight;
	
	        this.wrapperElement.toggleClass(IS_STICKED, viewLessHeader);
	    };
	
	    return OrderHeader;
	}();
	
	module.exports = {
	    constructor: OrderHeader,
	    children: [{
	        name: 'price',
	        component: Price,
	        watcher: {
	            rowPrice: ['order', 'price', 'data', 'total', 'rowPrice'],
	            totalPrice: ['order', 'price', 'data', 'total', 'totalPrice'],
	            noDiscountTotalPrice: ['order', 'price', 'data', 'total', 'totalPriceWithoutDiscount'],
	            discountPercentage: ['order', 'price', 'data', 'total', 'discountPercentage'],
	            rowAmount: ['order', 'price', 'data', 'total', 'rowAmount'],
	            firmsPluralized: ['order', 'price', 'computed', 'firmsPluralized'],
	            isLoading: ['order', 'price', 'isLoading'],
	            isError: ['order', 'price', 'isError'],
	            tooltipIsShow: ['order', 'price', 'tooltipIsShow']
	        }
	    }, {
	        name: 'make-order-button',
	        component: MakeOrderButton,
	        watcher: {
	            totalPrice: ['order', 'price', 'data', 'total', 'totalPrice'],
	            isZero: ['order', 'price', 'isZero']
	        },
	        props: {
	            isUp: true
	        }
	    }]
	};

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(846);
	var Preloader = __webpack_require__(101);
	
	var _require = __webpack_require__(4),
	    cut = _require.cut;
	
	var signals = __webpack_require__(75);
	
	var WARNING = cut(css.warning);
	
	var Price = function () {
	    function Price() {
	        _classCallCheck(this, Price);
	
	        this.template = __webpack_require__(989);
	    }
	
	    Price.prototype.bind = function bind() {
	        var _mouseenter, _mouseleave;
	
	        return {
	            mouseenter: (_mouseenter = {}, _mouseenter[WARNING] = this.showTooltip, _mouseenter),
	            mouseleave: (_mouseleave = {}, _mouseleave[WARNING] = this.hideTooltip, _mouseleave)
	        };
	    };
	
	    Price.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    Price.prototype.showTooltip = function showTooltip() {
	        this.$context.signal(signals.showTooltip);
	    };
	
	    Price.prototype.hideTooltip = function hideTooltip() {
	        this.$context.signal(signals.hideTooltip);
	    };
	
	    return Price;
	}();
	
	module.exports = {
	    constructor: Price,
	    children: [{
	        name: 'preloader',
	        component: Preloader,
	        props: {
	            size: 'medium'
	        }
	    }]
	};

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var signals = __webpack_require__(75);
	
	var _require = __webpack_require__(90),
	    raiseEvent = _require.raiseEvent;
	
	var CustomOrder = __webpack_require__(150);
	var Discounts = __webpack_require__(151);
	var Slider = __webpack_require__(412);
	var css = __webpack_require__(847);
	
	var _require2 = __webpack_require__(4),
	    cut = _require2.cut;
	
	var COST_BUTTON_SELECTOR = cut(css.costButton);
	var DOWNLOAD_SAMPLE_BUTTON = cut(css.actionsButton);
	var MANAGER_MAIL_TO_LINK = cut(css.managerLink);
	
	var Order = function () {
	    function Order() {
	        _classCallCheck(this, Order);
	
	        this.template = __webpack_require__(993);
	        this.intervalId = null;
	    }
	
	    Order.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    Order.prototype.bind = function bind() {
	        var _click;
	
	        this.$context.signal(signals.onLoad);
	
	        return {
	            click: (_click = {}, _click[COST_BUTTON_SELECTOR] = this.handleCostButton, _click[DOWNLOAD_SAMPLE_BUTTON] = this.downloadSampleEvent, _click[MANAGER_MAIL_TO_LINK] = this.mailToManager, _click)
	        };
	    };
	
	    Order.prototype.handleCostButton = function handleCostButton(e) {
	        e.preventDefault();
	
	        this.$context.signal(raiseEvent, { category: 'button_price_to_choice_fetching', action: 'click' });
	        this.$context.signal(signals.clickCostButton);
	    };
	
	    Order.prototype.downloadSampleEvent = function downloadSampleEvent() {
	        this.$context.signal(raiseEvent, { category: 'button_download_sample_fetching', action: 'click' });
	    };
	
	    Order.prototype.mailToManager = function mailToManager() {
	        this.$context.signal(raiseEvent, { category: 'link_letter_manager', action: 'click' });
	    };
	
	    return Order;
	}();
	
	module.exports = {
	    constructor: Order,
	    children: [{
	        name: 'custom-order',
	        component: CustomOrder,
	        props: {
	            showReset: true,
	            showOrderButton: true,
	            onReset: signals.onReset,
	            isSmallTree: 'false',
	            dontUseMetric: 'false'
	        },
	        watcher: {
	            hideRubrics: ['order', 'computed', 'hideRubrics']
	        }
	    }, {
	        name: 'slider',
	        component: Slider,
	        watcher: {
	            cityPos: ['slider', 'positions', 'city'],
	            buildingsPos: ['slider', 'positions', 'buildings'],
	            cloudsPos: ['slider', 'positions', 'clouds'],
	            noAnimation: ['slider', 'noAnimation'],
	            page: ['slider', 'page']
	        }
	    }, {
	        name: 'discounts',
	        component: Discounts,
	        watcher: {
	            prices: ['data', 'computed', 'discounts']
	        }
	    }]
	};

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(849);
	var signals = __webpack_require__(510);
	var Message = __webpack_require__(413);
	
	var _require = __webpack_require__(4),
	    cut = _require.cut;
	
	var CONTENT_SELECTOR = cut(css.wrapper);
	
	var Slider = function () {
	    function Slider() {
	        _classCallCheck(this, Slider);
	
	        this.template = __webpack_require__(992);
	    }
	
	    Slider.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    Slider.prototype.bind = function bind() {
	        var _click;
	
	        this.setIntervalSlider();
	
	        return {
	            click: (_click = {}, _click[CONTENT_SELECTOR] = this.onClickSlider, _click)
	        };
	    };
	
	    Slider.prototype.unbind = function unbind() {
	        clearInterval(this.intervalId);
	    };
	
	    Slider.prototype.onClickSlider = function onClickSlider() {
	        this.$context.signal(signals.sliderNextView);
	    };
	
	    Slider.prototype.setIntervalSlider = function setIntervalSlider() {
	        var _this = this;
	
	        this.intervalId = setInterval(function () {
	            _this.$context.signal(signals.sliderNextView);
	        }, 5000);
	    };
	
	    return Slider;
	}();
	
	module.exports = {
	    constructor: Slider,
	    children: [{
	        name: 'message',
	        component: Message,
	        watcher: {
	            title: ['slider', 'computed', 'text', 'title'],
	            content: ['slider', 'computed', 'text', 'content']
	        }
	    }]
	};

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(848);
	
	var Message = function () {
	    function Message() {
	        _classCallCheck(this, Message);
	
	        this.template = __webpack_require__(991);
	    }
	
	    Message.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    return Message;
	}();
	
	module.exports = {
	    constructor: Message
	};

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(850);
	var signals = __webpack_require__(528);
	
	var _require = __webpack_require__(4),
	    cut = _require.cut;
	
	var _require2 = __webpack_require__(11),
	    _redirect = _require2.redirect;
	
	var Alert = function () {
	    function Alert() {
	        _classCallCheck(this, Alert);
	
	        this.template = __webpack_require__(994);
	    }
	
	    Alert.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            var alertType = data.alertType;
	
	            data[alertType] = true;
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    Alert.prototype.bind = function bind() {
	        var _click;
	
	        this.$context.signal(signals.onRedirect);
	        return {
	            click: (_click = {}, _click[cut(css.redirect)] = this.redirect, _click)
	        };
	    };
	
	    Alert.prototype.redirect = function redirect(e) {
	        e.stopPropagation();
	        var url = e.currentTarget.getAttribute('cat-url');
	        this.$context.signal(_redirect, { url: url });
	    };
	
	    return Alert;
	}();
	
	module.exports = {
	    constructor: Alert
	};

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Alert = __webpack_require__(414);
	
	var Payment = function () {
	    function Payment() {
	        _classCallCheck(this, Payment);
	
	        this.template = __webpack_require__(995);
	    }
	
	    Payment.prototype.render = function render() {
	        return this.$context.getWatcherData();
	    };
	
	    return Payment;
	}();
	
	module.exports = {
	    constructor: Payment,
	    children: [{
	        name: 'alert',
	        component: Alert,
	        watcher: {
	            alertType: ['payment', 'alertType'],
	            redirectLink: ['payment', 'redirectLink']
	        }
	    }]
	};

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(852);
	var UserForm = __webpack_require__(213);
	var PasswordChange = __webpack_require__(417);
	
	var Personal = function () {
	    function Personal() {
	        _classCallCheck(this, Personal);
	
	        this.template = __webpack_require__(997);
	    }
	
	    Personal.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    return Personal;
	}();
	
	module.exports = {
	    constructor: Personal,
	    children: [{
	        name: 'user-form',
	        component: UserForm,
	        watcher: {
	            userType: ['account', 'userForm', 'form', 'userType']
	        }
	    }, {
	        name: 'password-change',
	        component: PasswordChange,
	        watcher: {
	            isEnabled: ['account', 'passwordChangeForm', 'computed', 'isEnabled'],
	            passwordChanged: ['account', 'passwordChangeForm', 'passwordChanged'],
	            result: ['account', 'passwordChangeForm', 'result']
	        }
	    }]
	};

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(851);
	var SCHEMES = __webpack_require__(22);
	
	var _require = __webpack_require__(26),
	    inputText = _require.inputText,
	    blurText = _require.blurText;
	
	var _require2 = __webpack_require__(24),
	    Text = _require2.Text;
	
	var _require3 = __webpack_require__(4),
	    cut = _require3.cut;
	
	var CHANGE_PASSWORD_BUTTON = cut(css.submit);
	var signals = __webpack_require__(494);
	
	var PasswordChange = function () {
	    function PasswordChange() {
	        _classCallCheck(this, PasswordChange);
	
	        this.template = __webpack_require__(996);
	    }
	
	    PasswordChange.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    PasswordChange.prototype.bind = function bind() {
	        var _click;
	
	        return {
	            click: (_click = {}, _click[CHANGE_PASSWORD_BUTTON] = this.save, _click)
	        };
	    };
	
	    PasswordChange.prototype.save = function save() {
	        this.$context.signal(signals.changePassword);
	    };
	
	    return PasswordChange;
	}();
	
	module.exports = {
	    constructor: PasswordChange,
	    children: [{
	        name: 'text-password',
	        component: Text,
	        props: {
	            signals: { inputText: inputText, blurText: blurText },
	            scheme: SCHEMES.password,
	            position: 'leftToRight',
	            type: 'password'
	        },
	        watcher: {
	            value: ['account', 'passwordChangeForm', 'password'],
	            error: ['account', 'passwordChangeForm', 'error', 'password']
	        }
	    }, {
	        name: 'text-password-new',
	        component: Text,
	        props: {
	            signals: { inputText: inputText, blurText: blurText },
	            scheme: SCHEMES.password,
	            position: 'leftToRight',
	            type: 'password'
	        },
	        watcher: {
	            value: ['account', 'passwordChangeForm', 'passwordNew'],
	            error: ['account', 'passwordChangeForm', 'error', 'passwordNew']
	        }
	    }, {
	        name: 'text-repeat-password-new',
	        component: Text,
	        props: {
	            signals: { inputText: inputText, blurText: blurText },
	            scheme: SCHEMES.repeatPassword,
	            position: 'leftToRight',
	            type: 'password'
	        },
	        watcher: {
	            value: ['account', 'passwordChangeForm', 'repeatPasswordNew'],
	            error: ['account', 'passwordChangeForm', 'computed', 'error', 'repeatPasswordNew']
	        }
	    }]
	};

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(853);
	var bitrix = __webpack_require__(29);
	
	var Terms = function () {
	    function Terms() {
	        _classCallCheck(this, Terms);
	
	        this.template = __webpack_require__(998);
	    }
	
	    Terms.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    Terms.prototype.bind = function bind() {
	        this.$context.signal(bitrix.resize);
	    };
	
	    return Terms;
	}();
	
	module.exports = {
	    constructor: Terms
	};

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(854);
	var video = __webpack_require__(529);
	
	var Video = function () {
	    function Video() {
	        _classCallCheck(this, Video);
	
	        this.template = __webpack_require__(999);
	    }
	
	    Video.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    Video.prototype.bind = function bind() {
	        this.$context.signal(video.onLoad);
	    };
	
	    return Video;
	}();
	
	module.exports = {
	    constructor: Video
	};

/***/ }),
/* 420 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.denied = ['port'];

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var parser = __webpack_require__(1057);
	var _ = __webpack_require__(3);
	
	exports.scrollTo = function (to, duration) {
	    var browser = parser(window.navigator.userAgent).browser;
	    var body = _.includes(['Firefox', 'IE', 'Chrome'], browser.name) ? document.documentElement : document.body;
	    var scrollTo = Math.min(body.scrollHeight - body.clientHeight, to);
	
	    function scrollTick(tmpTo, tmpDuration) {
	        var diffTop = body.scrollTop;
	        var difference = tmpTo - diffTop;
	        var perTick = Math.round(difference / tmpDuration * 10);
	
	        setTimeout(function () {
	            var previousTop, top;
	
	            previousTop = body.scrollTop;
	            body.scrollTop += perTick;
	            top = body.scrollTop;
	
	            if (top == Math.round(tmpTo) || top == previousTop) {
	                return;
	            }
	
	            scrollTick(tmpTo, tmpDuration - 10);
	        }, 10);
	    }
	
	    scrollTick(scrollTo, duration);
	};

/***/ }),
/* 422 */
[1064, 855, 1000],
/* 423 */
[1065, 856, 1001],
/* 424 */
[1066, 857, 1002],
/* 425 */
[1067, 858, 422, 1003],
/* 426 */
[1068, 859, 1004],
/* 427 */
[1070, 860, 1005],
/* 428 */
[1071, 861, 1006],
/* 429 */
[1072, 862, 1007],
/* 430 */
[1073, 863, 1008],
/* 431 */
[1074, 864, 1009],
/* 432 */
/***/ (function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	module.exports = {
	  create: function create(actions) {
	    analyze(actions);
	
	    return function (state) {
	      var services = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	      var asyncActionResults = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
	
	      return new Promise(function (resolve, reject) {
	        var promise = { resolve: resolve, reject: reject };
	        var start = Date.now();
	
	        checkArgs(args, promise);
	
	        var tree = staticTree(actions);
	
	        var signal = {
	          args: args,
	          asyncActionResults: asyncActionResults,
	          branches: tree.branches,
	          isExecuting: true,
	          duration: 0
	        };
	
	        runBranch(0, { tree: tree, args: args, signal: signal, promise: promise, start: start, state: state, services: services });
	      });
	    };
	  }
	};
	
	function runBranch(index, options) {
	  var tree = options.tree,
	      signal = options.signal,
	      start = options.start,
	      promise = options.promise;
	
	  var currentBranch = tree.branches[index];
	
	  if (!currentBranch && tree.branches === signal.branches) {
	    if (tree.branches[index - 1]) {
	      tree.branches[index - 1].duration = Date.now() - start;
	    }
	
	    signal.isExecuting = false;
	
	    if (promise) {
	      promise.resolve(signal);
	    }
	
	    return;
	  }
	
	  if (!currentBranch) {
	    return;
	  }
	
	  if (Array.isArray(currentBranch)) {
	    return runAsyncBranch(index, currentBranch, options);
	  } else {
	    return runSyncBranch(index, currentBranch, options);
	  }
	}
	
	function runAsyncBranch(index, currentBranch, options) {
	  var tree = options.tree,
	      args = options.args,
	      signal = options.signal,
	      state = options.state,
	      promise = options.promise,
	      start = options.start,
	      services = options.services;
	
	
	  var promises = currentBranch.map(function (action) {
	    var actionFunc = tree.actions[action.actionIndex];
	    var actionArgs = createActionArgs(args, action, state, true);
	    var outputs = action.outputs ? Object.keys(action.outputs) : [];
	
	    action.isExecuting = true;
	    action.args = merge({}, args);
	
	    var nextActionPromise;
	    var foundResult = signal.asyncActionResults.find(function (result) {
	      return isEqualArrays(result.outputPath, action.path);
	    });
	
	    if (foundResult) {
	      nextActionPromise = Promise.resolve(foundResult);
	    } else {
	      var next = createNextAsyncAction(actionFunc, outputs);
	      actionFunc.apply(null, actionArgs.concat(next.fn, services));
	      nextActionPromise = next.promise;
	    }
	
	    return nextActionPromise.then(function (result) {
	      action.hasExecuted = true;
	      action.isExecuting = false;
	      action.output = result.args;
	
	      signal.asyncActionResults.push({
	        outputPath: action.path,
	        path: result.path,
	        args: result.args
	      });
	
	      merge(args, result.args);
	
	      if (result.path) {
	        action.outputPath = result.path;
	        var output = action.outputs[result.path];
	
	        return runBranch(0, {
	          args: args, signal: signal, state: state, start: start, promise: promise, services: services,
	          tree: {
	            actions: tree.actions,
	            branches: output
	          }
	        });
	      }
	    }).catch(function (e) {
	      return promise.reject(e);
	    });
	  });
	
	  return Promise.all(promises).then(function () {
	    return runBranch(index + 1, options);
	  });
	}
	
	function runSyncBranch(index, currentBranch, options) {
	  var args = options.args,
	      tree = options.tree,
	      signal = options.signal,
	      state = options.state,
	      start = options.start,
	      promise = options.promise,
	      services = options.services;
	
	
	  try {
	    var action = currentBranch;
	    var actionFunc = tree.actions[action.actionIndex];
	    var actionArgs = createActionArgs(args, action, state, false);
	    var outputs = action.outputs ? Object.keys(action.outputs) : [];
	
	    action.mutations = [];
	    action.args = merge({}, args);
	
	    var next = createNextSyncAction(actionFunc, outputs);
	    actionFunc.apply(null, actionArgs.concat(next, services));
	
	    var result = next._result || {};
	    merge(args, result.args);
	
	    action.isExecuting = false;
	    action.hasExecuted = true;
	    action.output = result.args;
	
	    if (result.path) {
	      action.outputPath = result.path;
	      var output = action.outputs[result.path];
	
	      var runResult = runBranch(0, {
	        args: args, signal: signal, state: state, start: start, promise: promise, services: services,
	        tree: {
	          actions: tree.actions,
	          branches: output
	        }
	      });
	
	      if (runResult && runResult.then) {
	        return runResult.then(function () {
	          return runBranch(index + 1, options);
	        });
	      }
	
	      return runBranch(index + 1, options);
	    }
	    return runBranch(index + 1, options);
	  } catch (e) {
	    promise.reject(e);
	  }
	}
	
	function addOutputs(next, outputs) {
	  if (Array.isArray(outputs)) {
	    outputs.forEach(function (key) {
	      next[key] = next.bind(null, key);
	    });
	  }
	
	  return next;
	}
	
	function createNextFunction(action, resolver) {
	  return function next() {
	    var path = typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string' ? arguments.length <= 0 ? undefined : arguments[0] : null;
	    var arg = path ? arguments.length <= 1 ? undefined : arguments[1] : arguments.length <= 0 ? undefined : arguments[0];
	
	    var result = {
	      path: path ? path : action.defaultOutput,
	      args: arg
	    };
	
	    if (resolver) {
	      resolver(result);
	    } else {
	      next._result = result;
	    }
	  };
	}
	
	function createNextSyncAction(actionFunc, outputs) {
	  var next = createNextFunction(actionFunc);
	  next = addOutputs(next, outputs);
	
	  return next;
	}
	
	function createNextAsyncAction(actionFunc, outputs) {
	  var resolver = null;
	  var promise = new Promise(function (resolve) {
	    return resolver = resolve;
	  });
	  var fn = createNextFunction(actionFunc, resolver);
	  addOutputs(fn, outputs);
	
	  return { fn: fn, promise: promise };
	}
	
	function createActionArgs(args, action, state, isAsync) {
	  var stateMethods = getStateMutatorsAndAccessors(state, action, isAsync);
	  return [args, stateMethods];
	}
	
	function getStateMutatorsAndAccessors(state, action, isAsync) {
	  var mutators = ['apply', 'concat', 'deepMerge', 'push', 'merge', 'unset', 'set', 'splice', 'unshift'];
	
	  var accessors = ['get', 'exists'];
	
	  var methods = [];
	
	  if (isAsync) {
	    methods = methods.concat(accessors);
	  } else {
	    methods = methods.concat(mutators);
	    methods = methods.concat(accessors);
	  }
	
	  return methods.reduce(function (stateMethods, methodName) {
	    var method = state[methodName].bind(state);
	
	    stateMethods[methodName] = function () {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      var path = [];
	      var firstArg = args[0];
	
	      if (Array.isArray(firstArg)) {
	        path = args.shift();
	      } else if (typeof firstArg === 'string') {
	        path = [args.shift()];
	      }
	
	      if (args.length === 0) {
	        return method.apply(null, [path.slice()]);
	      }
	
	      action.mutations.push({
	        name: methodName,
	        path: path.slice(),
	        args: args
	      });
	
	      return method.apply(null, [path.slice()].concat(args));
	    };
	
	    return stateMethods;
	  }, Object.create(null));
	}
	
	function staticTree(signalActions) {
	  var actions = [];
	  var branches = transformBranch(signalActions, [], [], actions, false);
	  return { actions: actions, branches: branches };
	}
	
	function transformBranch(action) {
	  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    args[_key2 - 1] = arguments[_key2];
	  }
	
	  return Array.isArray(action) ? transformAsyncBranch.apply(null, [action].concat(args)) : transformSyncBranch.apply(null, [action].concat(args));
	}
	
	function transformAsyncBranch(action, parentAction, path, actions, isSync) {
	  action = action.slice();
	  isSync = !isSync;
	  return action.map(function (subAction, index) {
	    path.push(index);
	    var result = transformBranch(subAction, action, path, actions, isSync);
	    path.pop();
	    return result;
	  }).filter(function (branch) {
	    return !!branch;
	  });
	}
	
	function transformSyncBranch(action, parentAction, path, actions, isSync) {
	  var branch = {
	    name: getFunctionName(action),
	    args: {},
	    output: null,
	    duration: 0,
	    mutations: [],
	    isAsync: !isSync,
	    outputPath: null,
	    isExecuting: false,
	    hasExecuted: false,
	    path: path.slice(),
	    outputs: null,
	    actionIndex: actions.indexOf(action) === -1 ? actions.push(action) - 1 : actions.indexOf(action)
	  };
	
	  var nextAction = parentAction[parentAction.indexOf(action) + 1];
	  if (!Array.isArray(nextAction) && (typeof nextAction === 'undefined' ? 'undefined' : _typeof(nextAction)) === 'object') {
	    parentAction.splice(parentAction.indexOf(nextAction), 1);
	
	    branch.outputs = Object.keys(nextAction).reduce(function (paths, key) {
	      path = path.concat('outputs', key);
	      paths[key] = transformBranch(nextAction[key], parentAction, path, actions, false);
	      path.pop();
	      path.pop();
	      return paths;
	    }, {});
	  }
	
	  return branch;
	}
	
	function analyze(actions) {
	  if (!Array.isArray(actions)) {
	    throw new Error('State: Signal actions should be array');
	  }
	
	  actions.forEach(function (action, index) {
	    if (typeof action === 'undefined' || typeof action === 'string') {
	      throw new Error('\n            State: Action number "' + index + '" in signal does not exist.\n            Check that you have spelled it correctly!\n          ');
	    }
	
	    if (Array.isArray(action)) {
	      analyze(action);
	    } else if (Object.prototype.toString.call(action) === "[object Object]") {
	      Object.keys(action).forEach(function (output) {
	        analyze(action[output]);
	      });
	    }
	  });
	}
	
	function checkArgs(args, promise) {
	  try {
	    JSON.stringify(args);
	  } catch (e) {
	    promise.reject('State - Could not serialize arguments to signal. Please check signal.');
	  }
	}
	
	function getFunctionName(fn) {
	  var name = fn.toString();
	  name = name.substr('function '.length);
	  name = name.substr(0, name.indexOf('('));
	  return name;
	}
	
	function merge(target, source) {
	  source = source || {};
	  return Object.keys(source).reduce(function (targetKey, key) {
	    targetKey[key] = source[key];
	    return target;
	  }, target);
	}
	
	function isEqualArrays(first, second) {
	  if (!Array.isArray(first) || !Array.isArray(second)) {
	    return false;
	  }
	
	  if (first.length !== second.length) {
	    return false;
	  }
	
	  return first.every(function (element, index) {
	    return element === second[index];
	  });
	}

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var LinkWrapper = __webpack_require__(434);
	
	module.exports = {
	  register: function register(locator) {
	    locator.register('linkWrapper', LinkWrapper, true);
	    var wrapper = locator.resolve('linkWrapper');
	    wrapper.wrapDocument();
	  }
	};

/***/ }),
/* 434 */
/***/ (function(module, exports) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MOUSE_PRIMARY_KEY = 0;
	var HREF_ATTRIBUTE_NAME = 'href';
	var TARGET_ATTRIBUTE_NAME = 'target';
	var A_TAG_NAME = 'A';
	var BODY_TAG_NAME = 'BODY';
	
	var LinkWrapper = function () {
	  function LinkWrapper(locator) {
	    _classCallCheck(this, LinkWrapper);
	
	    this._requestRouter = locator.resolve('requestRouter');
	    this._window = locator.resolve('window');
	    this._bus = locator.resolve('eventBus');
	  }
	
	  LinkWrapper.prototype.wrapDocument = function wrapDocument() {
	    var _this = this;
	
	    this._window.document.body.addEventListener('click', function (event) {
	      if (event.defaultPrevented) {
	        return;
	      }
	      if (event.target.tagName === A_TAG_NAME) {
	        _this._linkClickHandler(event, event.target);
	      } else {
	        var link = closestLink(event.target);
	        if (!link) {
	          return;
	        }
	        _this._linkClickHandler(event, link);
	      }
	    });
	  };
	
	  LinkWrapper.prototype._linkClickHandler = function _linkClickHandler(event, element) {
	    var _this2 = this;
	
	    var targetAttribute = element.getAttribute(TARGET_ATTRIBUTE_NAME);
	    if (targetAttribute) {
	      return;
	    }
	
	    if (event.button !== MOUSE_PRIMARY_KEY || event.ctrlKey || event.altKey || event.shiftKey || event.metaKey) {
	      return;
	    }
	
	    var locationString = element.getAttribute(HREF_ATTRIBUTE_NAME);
	    if (!locationString) {
	      return;
	    }
	
	    event.preventDefault();
	
	    this._requestRouter.go(locationString).catch(function (reason) {
	      return _this2._bus.emit('error', reason);
	    });
	  };
	
	  return LinkWrapper;
	}();
	
	function closestLink(element) {
	  while (element && element.nodeName !== A_TAG_NAME && element.nodeName !== BODY_TAG_NAME) {
	    element = element.parentNode;
	  }
	  return element && element.nodeName === A_TAG_NAME ? element : null;
	}
	
	module.exports = LinkWrapper;

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var morphdom = __webpack_require__(1047);
	var errorHelper = __webpack_require__(439);
	var moduleHelper = __webpack_require__(158);
	var uuid = __webpack_require__(285);
	var LocalContextProvider = __webpack_require__(437);
	var StateManager = __webpack_require__(438);
	
	var ERROR_MISSED_REQUIRED_COMPONENTS = 'Document component is not register.';
	
	var SPECIAL_IDS = {
	  $$head: '$$head',
	  $$document: '$$document'
	};
	
	var TAG_NAMES = {
	  HEAD: 'HEAD',
	  STYLE: 'STYLE',
	  SCRIPT: 'SCRIPT',
	  LINK: 'LINK'
	};
	
	var NON_BUBBLING_EVENTS = {
	  abort: true,
	  blur: true,
	  error: true,
	  focus: true,
	  load: true,
	  mouseenter: true,
	  mouseleave: true,
	  resize: true,
	  unload: true
	};
	
	var DocumentRenderer = function () {
	  function DocumentRenderer(locator) {
	    var _this = this;
	
	    _classCallCheck(this, DocumentRenderer);
	
	    this._locator = locator;
	    this._window = locator.resolve('window');
	    this._eventBus = locator.resolve('eventBus');
	    this._config = locator.resolve('config');
	
	    this._isUpdating = false;
	    this._isSilentUpdateQueued = false;
	    this._currentRoutingContext = null;
	
	    this._componentInstances = Object.create(null);
	    this._componentElements = Object.create(null);
	    this._componentBindings = Object.create(null);
	    this._componentWatchers = Object.create(null);
	    this._componentSlotContents = Object.create(null);
	    this._currentChangedComponents = Object.create(null);
	
	    this._stateManager = new StateManager(locator);
	    this._localContextProvider = new LocalContextProvider(locator);
	
	    this._eventBus.on('componentStateChanged', function (componentId) {
	      _this._currentChangedComponents[componentId] = true;
	
	      Promise.resolve().then(function () {
	        return _this._updateComponents();
	      });
	    });
	  }
	
	  DocumentRenderer.prototype.initWithState = function initWithState(routingContext) {
	    var _this2 = this;
	
	    var args = routingContext.args;
	    var signal = args.signal;
	
	    var document = this._locator.resolve('documentComponent');
	
	    if (!document) {
	      this._eventBus.emit('error', ERROR_MISSED_REQUIRED_COMPONENTS);
	      return Promise.resolve();
	    }
	
	    var patchedRoutingContext = this._patchRoutingContext(routingContext);
	
	    this._currentRoutingContext = patchedRoutingContext;
	    this._stateManager.setRoutingContext(patchedRoutingContext);
	
	    return Promise.resolve().then(function () {
	      if (!signal) {
	        return;
	      }
	
	      var cache = Array.isArray(_this2._window.CATBEE_CACHE) ? _this2._window.CATBEE_CACHE : [];
	      return _this2._stateManager.signal(signal, args, cache);
	    }).then(function () {
	      _this2._stateManager.tree.commit();
	      var documentElement = _this2._window.document.documentElement;
	      var action = function action(element) {
	        return _this2._initializeComponent(element);
	      };
	      return _this2._traverseComponentsWithContext([documentElement], action, document);
	    }).catch(function (e) {
	      return _this2._eventBus.emit('error', e);
	    });
	  };
	
	  DocumentRenderer.prototype.updateState = function updateState(routingContext) {
	    var _this3 = this;
	
	    var args = routingContext.args;
	    var signal = args.signal;
	
	
	    var patchedRoutingContext = this._patchRoutingContext(routingContext);
	
	    this._currentRoutingContext = patchedRoutingContext;
	    this._stateManager.setRoutingContext(patchedRoutingContext);
	
	    return Promise.resolve().then(function () {
	      if (!signal || _this3._isSilentUpdateQueued) {
	        return;
	      }
	
	      var updateSignal = _this3._stateManager.signal(signal, args);
	
	      _this3._eventBus.emit('stateUpdated', {
	        routingContext: routingContext,
	        signal: updateSignal
	      });
	
	      return updateSignal;
	    }).then(function () {
	      _this3._isSilentUpdateQueued = false;
	    }).catch(function (e) {
	      return _this3._eventBus.emit('error', e);
	    });
	  };
	
	  DocumentRenderer.prototype.renderComponent = function renderComponent(rootElement, rootContext, renderingContext) {
	    var _this4 = this;
	
	    var componentName = moduleHelper.getOriginalComponentName(rootElement.tagName);
	    this._eventBus.emit('componentRender', componentName);
	
	    var action = function action(element) {
	      var id = _this4._getId(element);
	      var localContext = _this4._localContextProvider.getContextById(id);
	      var hadChildrenNodes = element.children.length > 0;
	
	      if (!renderingContext) {
	        renderingContext = _this4._createRenderingContext();
	        renderingContext.rootIds[id] = true;
	      }
	
	      if (!localContext) {
	        return null;
	      }
	
	      renderingContext.renderedIds[id] = true;
	
	      var instance = _this4._componentInstances[id];
	      var ComponentConstructor = localContext.constructor;
	
	      if (!instance) {
	        ComponentConstructor.prototype.$context = _this4._getComponentContext(localContext, element);
	        instance = new ComponentConstructor(_this4._locator);
	        instance.$context = ComponentConstructor.prototype.$context;
	        _this4._componentInstances[id] = instance;
	      }
	
	      _this4._componentElements[id] = element;
	
	      return Promise.resolve().then(function () {
	        if (!(id in renderingContext.rootIds) || !hadChildrenNodes) {
	          return null;
	        }
	
	        return _this4._unbindAll(element, renderingContext);
	      }).catch(function (reason) {
	        return _this4._eventBus.emit('error', reason);
	      }).then(function () {
	        return _this4._bindWatcher(element);
	      }).then(function () {
	        var renderMethod = moduleHelper.getMethodToInvoke(instance, 'render');
	        return moduleHelper.getSafePromise(renderMethod);
	      }).then(function (dataContext) {
	        return instance.template(dataContext);
	      }).catch(function (reason) {
	        return _this4._handleRenderError(element, reason);
	      }).then(function (html) {
	        var isHead = element.tagName === TAG_NAMES.HEAD;
	
	        if (html === '' && isHead) {
	          return null;
	        }
	
	        var tmpElement = element.cloneNode(false);
	        tmpElement.innerHTML = html;
	
	        if (isHead) {
	          _this4._mergeHead(element, tmpElement);
	          return null;
	        }
	
	        morphdom(element, tmpElement, {
	          onNodeAdded: function onNodeAdded(node) {
	            if (moduleHelper.isSlotNode(node)) {
	              var slotContentTemplate = _this4._componentSlotContents[id];
	
	              if (!slotContentTemplate) {
	                return;
	              }
	
	              var slotContent = slotContentTemplate.cloneNode(true);
	
	              while (node.firstChild) {
	                node.removeChild(node.firstChild);
	              }
	
	              node.appendChild(slotContent);
	
	              var nestedComponents = _this4._findNestedComponents(node);
	
	              nestedComponents.forEach(function (component) {
	                component.$parentId = _this4._localContextProvider.getParentById(id);
	              });
	
	              return false;
	            }
	
	            if (moduleHelper.isComponentNode(node)) {
	              var _id = _this4._getId(node);
	              var clonedNode = node.cloneNode(true);
	              var childNodes = Array.from(clonedNode.childNodes);
	
	              if (childNodes.length) {
	                _this4._componentSlotContents[_id] = childNodes.reduce(function (fragment, child) {
	                  fragment.appendChild(child);
	                  return fragment;
	                }, _this4._window.document.createDocumentFragment());
	              }
	            }
	          },
	
	          onBeforeElChildrenUpdated: function onBeforeElChildrenUpdated(foundElement, foundTmpElement) {
	            if (moduleHelper.isSlotNode(foundElement)) {
	              var slotContentTemplate = _this4._componentSlotContents[id];
	
	              if (!slotContentTemplate) {
	                return true;
	              }
	
	              var slotContent = slotContentTemplate.cloneNode(true);
	
	              while (foundElement.firstChild) {
	                foundElement.removeChild(foundElement.firstChild);
	              }
	
	              foundElement.appendChild(slotContent);
	
	              var nestedComponents = _this4._findNestedComponents(foundElement);
	
	              nestedComponents.forEach(function (component) {
	                component.$parentId = _this4._localContextProvider.getParentById(id);
	              });
	
	              return false;
	            }
	
	            if (foundElement !== element && moduleHelper.isComponentNode(foundElement)) {
	              var childNodes = Array.from(foundTmpElement.childNodes);
	              var _id2 = _this4._getId(foundElement);
	
	              if (childNodes.length) {
	                _this4._componentSlotContents[_id2] = childNodes.reduce(function (fragment, child) {
	                  fragment.appendChild(child);
	                  return fragment;
	                }, _this4._window.document.createDocumentFragment());
	              }
	            }
	
	            return foundElement === element || !moduleHelper.isComponentNode(foundElement);
	          }
	        });
	      }).then(function () {
	        _this4._eventBus.emit('componentRendered', componentName);
	        return _this4._bindComponent(element);
	      }).catch(function (reason) {
	        return _this4._eventBus.emit('error', reason);
	      });
	    };
	
	    return this._traverseComponentsWithContext([rootElement], action, rootContext);
	  };
	
	  DocumentRenderer.prototype.collectGarbage = function collectGarbage() {
	    var _this5 = this;
	
	    return Promise.resolve().then(function () {
	      var context = {
	        roots: []
	      };
	
	      Object.keys(_this5._componentElements).forEach(function (id) {
	        if (SPECIAL_IDS.hasOwnProperty(id)) {
	          return;
	        }
	
	        var current = _this5._componentElements[id];
	        while (current !== _this5._window.document.documentElement) {
	          if (current.parentElement === null) {
	            context.roots.push(current);
	            break;
	          }
	
	          if (moduleHelper.isComponentNode(current.parentElement)) {
	            break;
	          }
	          current = current.parentElement;
	        }
	      });
	
	      return _this5._removeDetachedComponents(context);
	    });
	  };
	
	  DocumentRenderer.prototype.createComponent = function createComponent(tagName, component) {
	    var _this6 = this;
	
	    var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    if (typeof tagName !== 'string' || (typeof attributes === 'undefined' ? 'undefined' : _typeof(attributes)) !== 'object' || Array.isArray(attributes)) {
	      return Promise.reject(new Error('Tag name should be a string and attributes should be an object'));
	    }
	
	    return Promise.resolve().then(function () {
	      var componentName = moduleHelper.getOriginalComponentName(tagName);
	
	      if (moduleHelper.isHeadComponent(componentName) || moduleHelper.isDocumentComponent(componentName)) {
	        return Promise.reject(new Error('Component for tag "' + tagName + '" not found'));
	      }
	
	      var safeTagName = moduleHelper.getTagNameForComponentName(componentName);
	      var element = _this6._window.document.createElement(safeTagName);
	
	      Object.keys(attributes).forEach(function (attributeName) {
	        return element.setAttribute(attributeName, attributes[attributeName]);
	      });
	
	      return _this6.renderComponent(element, component).then(function () {
	        return element;
	      });
	    });
	  };
	
	  DocumentRenderer.prototype.getComponentById = function getComponentById(id) {
	    var element = this._window.document.getElementById(id);
	    return this.getComponentByElement(element);
	  };
	
	  DocumentRenderer.prototype.getComponentByElement = function getComponentByElement(element) {
	    if (!element) {
	      return null;
	    }
	    var id = element[moduleHelper.COMPONENT_ID];
	    if (!id) {
	      return null;
	    }
	    return this._componentInstances[id] || null;
	  };
	
	  DocumentRenderer.prototype._getComponentContext = function _getComponentContext(localContext, element) {
	    var _this7 = this;
	
	    var componentContext = Object.create(this._currentRoutingContext);
	    var name = moduleHelper.getOriginalComponentName(element.tagName);
	    var id = this._getId(element);
	
	    Object.defineProperties(componentContext, {
	      name: {
	        get: function get() {
	          return name;
	        },
	        enumerable: true
	      },
	      attributes: {
	        get: function get() {
	          return attributesToObject(element.attributes);
	        },
	        enumerable: true
	      }
	    });
	
	    componentContext.element = element;
	    componentContext.getComponentById = function (id) {
	      return _this7.getComponentById(id);
	    };
	    componentContext.getComponentByElement = function (element) {
	      return _this7.getComponentByElement(element);
	    };
	    componentContext.createComponent = function (tagName, descriptor, attributes) {
	      return _this7.createComponent(tagName, descriptor, attributes);
	    };
	    componentContext.collectGarbage = function () {
	      return _this7.collectGarbage();
	    };
	    componentContext.signal = function (actions, args) {
	      return _this7._stateManager.signal(actions, args);
	    };
	    componentContext.props = localContext.props;
	    componentContext.state = this._stateManager.tree;
	    componentContext.forceUpdate = function () {
	      return _this7._eventBus.emit('componentStateChanged', id);
	    };
	
	    componentContext.getWatcherData = function () {
	      var watcher = _this7._componentWatchers[id];
	
	      if (!watcher) {
	        var stub = Object.create(null);
	        return Promise.resolve(stub);
	      }
	
	      return Promise.resolve(watcher.get());
	    };
	
	    return Object.freeze(componentContext);
	  };
	
	  DocumentRenderer.prototype._createRenderingContext = function _createRenderingContext(changedComponentsIds) {
	    return {
	      config: this._config,
	      renderedIds: Object.create(null),
	      unboundIds: Object.create(null),
	      isHeadRendered: false,
	      bindMethods: [],
	      routingContext: this._currentRoutingContext,
	      rootIds: Object.create(null),
	      roots: changedComponentsIds ? this._findRenderingRoots(changedComponentsIds) : []
	    };
	  };
	
	  DocumentRenderer.prototype._traverseComponents = function _traverseComponents(elements, action) {
	    var _this8 = this;
	
	    if (elements.length === 0) {
	      return Promise.resolve();
	    }
	
	    var root = elements.shift();
	
	    return Promise.resolve().then(function () {
	      return action(root);
	    }).then(function () {
	      var nestedElements = _this8._findNestedComponents(root);
	      elements = elements.concat(nestedElements);
	      return _this8._traverseComponents(elements, action);
	    });
	  };
	
	  DocumentRenderer.prototype._traverseComponentsWithContext = function _traverseComponentsWithContext(elements, action, rootContext) {
	    var _this9 = this;
	
	    if (elements.length === 0) {
	      return Promise.resolve();
	    }
	
	    var root = elements.shift();
	    var id = this._getId(root);
	
	    if (!rootContext && root.$parentId) {
	      rootContext = this._localContextProvider.getContextByTagName(root.tagName, root.$parentId);
	    }
	
	    this._localContextProvider.setContextById(id, rootContext, root.$parentId);
	
	    return Promise.resolve().then(function () {
	      return action(root);
	    }).then(function () {
	      var nestedComponents = _this9._findNestedComponents(root);
	      elements = elements.concat(nestedComponents);
	      return _this9._traverseComponentsWithContext(elements, action);
	    });
	  };
	
	  DocumentRenderer.prototype._initializeComponent = function _initializeComponent(element) {
	    var _this10 = this;
	
	    return Promise.resolve().then(function () {
	      var id = _this10._getId(element);
	      var localContext = _this10._localContextProvider.getContextById(id);
	
	      if (!localContext) {
	        return;
	      }
	
	      var ComponentConstructor = localContext.constructor;
	      ComponentConstructor.prototype.$context = _this10._getComponentContext(localContext, element);
	
	      var instance = new ComponentConstructor(_this10._locator);
	      instance.$context = ComponentConstructor.prototype.$context;
	
	      _this10._componentElements[id] = element;
	      _this10._componentInstances[id] = instance;
	
	      return _this10._rehydrateComponent(element).then(function () {
	        return _this10._bindWatcher(element);
	      }).then(function () {
	        return _this10._bindComponent(element);
	      });
	    });
	  };
	
	  DocumentRenderer.prototype._rehydrateComponent = function _rehydrateComponent(element) {
	    var _this11 = this;
	
	    return Promise.resolve().then(function () {
	      var slot = findSlot(element);
	      var id = _this11._getId(element);
	
	      if (!slot || slot.childNodes.length === 0) {
	        return;
	      }
	
	      var collectorNode = slot.cloneNode(true);
	      var collectorTreeWalker = _this11._window.document.createTreeWalker(collectorNode, _this11._window.NodeFilter.SHOW_ALL, null, false);
	      var nestedComponents = _this11._findNestedComponents(slot);
	
	      nestedComponents.forEach(function (component) {
	        return component.$parentId = _this11._localContextProvider.getParentById(id);
	      });
	
	      while (collectorTreeWalker.nextNode()) {
	        var isComponent = moduleHelper.isComponentNode(collectorTreeWalker.currentNode);
	
	        if (isComponent) {
	          var currentNode = collectorTreeWalker.currentNode;
	
	          while (currentNode.firstChild) {
	            currentNode.removeChild(currentNode.firstChild);
	          }
	        }
	      }
	
	      var childNodes = Array.from(collectorNode.childNodes);
	
	      _this11._componentSlotContents[id] = childNodes.reduce(function (fragment, child) {
	        fragment.appendChild(child);
	        return fragment;
	      }, _this11._window.document.createDocumentFragment());
	    });
	  };
	
	  DocumentRenderer.prototype._bindComponent = function _bindComponent(element) {
	    var _this12 = this;
	
	    var id = this._getId(element);
	    var instance = this._componentInstances[id];
	
	    if (!instance) {
	      return Promise.resolve();
	    }
	
	    var bindMethod = moduleHelper.getMethodToInvoke(instance, 'bind');
	
	    return moduleHelper.getSafePromise(bindMethod).then(function (bindings) {
	      if (!bindings || (typeof bindings === 'undefined' ? 'undefined' : _typeof(bindings)) !== 'object') {
	        return;
	      }
	
	      _this12._componentBindings[id] = Object.create(null);
	
	      Object.keys(bindings).forEach(function (eventName) {
	        eventName = eventName.toLowerCase();
	
	        if (eventName in _this12._componentBindings[id]) {
	          return;
	        }
	
	        var selectorHandlers = Object.create(null);
	
	        Object.keys(bindings[eventName]).forEach(function (selector) {
	          var handler = bindings[eventName][selector];
	
	          if (typeof handler !== 'function') {
	            return;
	          }
	
	          selectorHandlers[selector] = handler.bind(instance);
	        });
	
	        _this12._componentBindings[id][eventName] = {
	          handler: _this12._createBindingHandler(element, selectorHandlers),
	          selectorHandlers: selectorHandlers
	        };
	
	        element.addEventListener(eventName, _this12._componentBindings[id][eventName].handler, NON_BUBBLING_EVENTS.hasOwnProperty(eventName));
	      });
	    }).then(function () {
	      var componentName = moduleHelper.getOriginalComponentName(element.tagName);
	      _this12._eventBus.emit('componentBound', componentName);
	    });
	  };
	
	  DocumentRenderer.prototype._bindWatcher = function _bindWatcher(element) {
	    var _this13 = this;
	
	    var componentName = moduleHelper.getOriginalComponentName(element.tagName);
	
	    return Promise.resolve().then(function () {
	      var id = _this13._getId(element);
	      var attributes = attributesToObject(element.attributes);
	      var localContext = _this13._localContextProvider.getContextById(id);
	      var watcherDefinition = localContext.watcher;
	
	      if (!watcherDefinition) {
	        return;
	      }
	
	      if (typeof watcherDefinition === 'function') {
	        watcherDefinition = watcherDefinition.apply(null, [attributes]);
	      }
	
	      var watcher = _this13._stateManager.getWatcher(watcherDefinition);
	      watcher.on('update', function () {
	        _this13._eventBus.emit('componentStateChanged', id);
	      });
	      _this13._componentWatchers[id] = watcher;
	    }).then(function () {
	      _this13._eventBus.emit('componentBindWatcher', componentName);
	    });
	  };
	
	  DocumentRenderer.prototype._createBindingHandler = function _createBindingHandler(componentRoot, selectorHandlers) {
	    var _this14 = this;
	
	    var selectors = Object.keys(selectorHandlers);
	
	    return function (event) {
	      var element = event.target;
	      var dispatchedEvent = createCustomEvent(event, function () {
	        return element;
	      });
	      var targetMatches = getMatchesMethod(element);
	
	      var isHandled = selectors.some(function (selector) {
	        if (targetMatches(selector)) {
	          selectorHandlers[selector](dispatchedEvent);
	          return true;
	        }
	        return false;
	      });
	
	      if (isHandled || !event.bubbles) {
	        return;
	      }
	
	      while (element.parentElement && element !== componentRoot) {
	        element = element.parentElement;
	        targetMatches = getMatchesMethod(element);
	        isHandled = _this14._tryDispatchEvent(selectors, targetMatches, selectorHandlers, dispatchedEvent);
	
	        if (isHandled) {
	          break;
	        }
	      }
	    };
	  };
	
	  DocumentRenderer.prototype._tryDispatchEvent = function _tryDispatchEvent(selectors, matchPredicate, handlers, event) {
	    return selectors.some(function (selector) {
	      if (!matchPredicate(selector)) {
	        return false;
	      }
	      handlers[selector](event);
	      return true;
	    });
	  };
	
	  DocumentRenderer.prototype._unbindAll = function _unbindAll(element, renderingContext) {
	    var _this15 = this;
	
	    var action = function action(innerElement) {
	      var id = _this15._getId(innerElement);
	      renderingContext.unboundIds[id] = true;
	      return _this15._unbindComponent(innerElement).then(function () {
	        return _this15._unbindWatcher(innerElement);
	      });
	    };
	
	    return this._traverseComponents([element], action);
	  };
	
	  DocumentRenderer.prototype._unbindComponent = function _unbindComponent(element) {
	    var _this16 = this;
	
	    var id = this._getId(element);
	    var instance = this._componentInstances[id];
	
	    if (!instance) {
	      return Promise.resolve();
	    }
	
	    if (id in this._componentBindings) {
	      Object.keys(this._componentBindings[id]).forEach(function (eventName) {
	        element.removeEventListener(eventName, _this16._componentBindings[id][eventName].handler, NON_BUBBLING_EVENTS.hasOwnProperty(eventName));
	      });
	      delete this._componentBindings[id];
	    }
	
	    var unbindMethod = moduleHelper.getMethodToInvoke(instance, 'unbind');
	    return moduleHelper.getSafePromise(unbindMethod).then(function () {
	      var componentName = moduleHelper.getOriginalComponentName(element.tagName);
	      _this16._eventBus.emit('componentUnbound', componentName);
	    }).catch(function (reason) {
	      return _this16._eventBus.emit('error', reason);
	    });
	  };
	
	  DocumentRenderer.prototype._unbindWatcher = function _unbindWatcher(element) {
	    var id = this._getId(element);
	    var watcher = this._componentWatchers[id];
	
	    if (!watcher) {
	      return;
	    }
	
	    watcher.off('update');
	    watcher.release();
	    delete this._componentWatchers[id];
	
	    var componentName = moduleHelper.getOriginalComponentName(element.tagName);
	    this._eventBus.emit('componentUnbindWatcher', componentName);
	  };
	
	  DocumentRenderer.prototype._collectRenderingGarbage = function _collectRenderingGarbage(renderingContext) {
	    var _this17 = this;
	
	    Object.keys(renderingContext.unboundIds).forEach(function (id) {
	      if (id in renderingContext.renderedIds) {
	        return;
	      }
	
	      _this17._removeComponentById(id);
	    });
	  };
	
	  DocumentRenderer.prototype._removeComponentById = function _removeComponentById(id) {
	    delete this._componentElements[id];
	    delete this._componentInstances[id];
	    delete this._componentBindings[id];
	    delete this._componentSlotContents[id];
	  };
	
	  DocumentRenderer.prototype._removeDetachedComponents = function _removeDetachedComponents(context) {
	    var _this18 = this;
	
	    if (context.roots.length === 0) {
	      return Promise.resolve();
	    }
	    var root = context.roots.pop();
	    return this._traverseComponents([root], function (element) {
	      return _this18._removeDetachedComponent(element);
	    }).then(function () {
	      return _this18._removeDetachedComponents(context);
	    });
	  };
	
	  DocumentRenderer.prototype._removeDetachedComponent = function _removeDetachedComponent(element) {
	    var _this19 = this;
	
	    var id = this._getId(element);
	    return this._unbindComponent(element).then(function () {
	      return _this19._removeComponentById(id);
	    });
	  };
	
	  DocumentRenderer.prototype._mergeHead = function _mergeHead(head, newHead) {
	    if (!newHead) {
	      return;
	    }
	
	    var headSet = Object.create(null);
	
	    for (var i = 0; i < head.childNodes.length; i++) {
	      var current = head.childNodes[i];
	      if (!isTagImmutable(current)) {
	        head.removeChild(current);
	        i--;
	        continue;
	      }
	
	      headSet[this._getElementKey(current)] = true;
	    }
	
	    for (var _i = 0; _i < newHead.children.length; _i++) {
	      var _current = newHead.children[_i];
	      if (this._getElementKey(_current) in headSet) {
	        continue;
	      }
	
	      head.appendChild(_current);
	
	      _i--;
	    }
	  };
	
	  DocumentRenderer.prototype._updateComponents = function _updateComponents() {
	    var _this20 = this;
	
	    if (this._isUpdating) {
	      return Promise.resolve();
	    }
	
	    this._isUpdating = true;
	
	    var changedComponentsIds = Object.keys(this._currentChangedComponents);
	    var renderingContext = this._createRenderingContext(changedComponentsIds);
	
	    Object.keys(this._componentInstances).forEach(function (id) {
	      var instance = _this20._componentInstances[id];
	      var context = _this20._localContextProvider.getContextById(id);
	      instance.$context = _this20._getComponentContext(context, instance.$context.element);
	    });
	
	    this._currentChangedComponents = Object.create(null);
	
	    var promises = renderingContext.roots.map(function (root) {
	      var id = _this20._getId(root);
	      renderingContext.rootIds[id] = true;
	      return _this20.renderComponent(root, null, renderingContext);
	    });
	
	    return Promise.all(promises).catch(function (reason) {
	      return _this20._eventBus.emit('error', reason);
	    }).then(function () {
	      return _this20._collectRenderingGarbage(renderingContext);
	    }).then(function () {
	      _this20._isUpdating = false;
	    });
	  };
	
	  DocumentRenderer.prototype._findRenderingRoots = function _findRenderingRoots() {
	    var _this21 = this;
	
	    var changedComponentsIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    var lastRoot;
	    var lastRootId;
	    var current;
	    var currentId;
	    var roots = [];
	    var rootsSet = Object.create(null);
	
	    changedComponentsIds.map(function (componentId) {
	      return {
	        id: componentId,
	        element: _this21._componentElements[componentId]
	      };
	    }).filter(function (component) {
	      return component.element;
	    }).forEach(function (component) {
	      current = component.element;
	      currentId = component.id;
	
	      lastRoot = current;
	      lastRootId = currentId;
	
	      while (current.parentElement) {
	        current = current.parentElement;
	        currentId = _this21._getId(current);
	
	        if (!changedComponentsIds.find(function (id) {
	          return currentId === id;
	        })) {
	          continue;
	        }
	
	        lastRoot = current;
	        lastRootId = currentId;
	      }
	
	      if (lastRootId in rootsSet) {
	        return;
	      }
	
	      rootsSet[lastRootId] = true;
	      roots.push(lastRoot);
	    });
	
	    return roots;
	  };
	
	  DocumentRenderer.prototype._handleRenderError = function _handleRenderError(element, error) {
	    var _this22 = this;
	
	    this._eventBus.emit('error', error);
	
	    return Promise.resolve().then(function () {
	      if (element.tagName === TAG_NAMES.HEAD) {
	        return '';
	      }
	
	      if (!_this22._config.isRelease && error instanceof Error) {
	        return errorHelper.prettyPrint(error, _this22._window.navigator.userAgent);
	      }
	
	      return '';
	    }).catch(function () {
	      return '';
	    });
	  };
	
	  DocumentRenderer.prototype._getId = function _getId(element) {
	    if (element === this._window.document.documentElement) {
	      return SPECIAL_IDS.$$document;
	    }
	
	    if (element === this._window.document.head) {
	      return SPECIAL_IDS.$$head;
	    }
	
	    if (!element[moduleHelper.COMPONENT_ID]) {
	      element[moduleHelper.COMPONENT_ID] = uuid.v4();
	
	      while (element[moduleHelper.COMPONENT_ID] in this._componentInstances) {
	        element[moduleHelper.COMPONENT_ID] = uuid.v4();
	      }
	    }
	    return element[moduleHelper.COMPONENT_ID];
	  };
	
	  DocumentRenderer.prototype._getElementKey = function _getElementKey(element) {
	    var attributes = [];
	
	    switch (element.nodeName) {
	      case TAG_NAMES.LINK:
	        attributes.push('href=' + element.getAttribute('href'));
	        break;
	      case TAG_NAMES.SCRIPT:
	        attributes.push('src=' + element.getAttribute('src'));
	        break;
	    }
	
	    return '<' + element.nodeName + ' ' + attributes.sort().join(' ') + '>' + element.textContent + '</' + element.nodeName + '>';
	  };
	
	  DocumentRenderer.prototype._patchRoutingContext = function _patchRoutingContext(routingContext) {
	    var _this23 = this;
	
	    var patchedRoutingContext = Object.create(routingContext);
	
	    patchedRoutingContext.redirect = function (uriString) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      _this23._isSilentUpdateQueued = options.silent;
	      routingContext.redirect.apply(routingContext, [uriString]);
	    };
	
	    return patchedRoutingContext;
	  };
	
	  DocumentRenderer.prototype._findNestedComponents = function _findNestedComponents(root) {
	    var elements = [];
	    var rootId = this._getId(root);
	    var queue = [root];
	
	    while (queue.length > 0) {
	      var currentChildren = queue.shift().children;
	
	      if (!currentChildren) {
	        continue;
	      }
	
	      Array.prototype.forEach.call(currentChildren, function (currentChild) {
	        if (!moduleHelper.isComponentNode(currentChild)) {
	          queue.push(currentChild);
	          return;
	        }
	
	        if (!currentChild.$parentId) {
	          currentChild.$parentId = rootId;
	        }
	
	        elements.push(currentChild);
	      });
	    }
	
	    return elements;
	  };
	
	  return DocumentRenderer;
	}();
	
	function createCustomEvent(event, currentTargetGetter) {
	  var catEvent = Object.create(event);
	  var keys = [];
	  var properties = {};
	
	  for (var key in event) {
	    keys.push(key);
	  }
	
	  keys.forEach(function (key) {
	    if (typeof event[key] === 'function') {
	      properties[key] = {
	        get: function get() {
	          return event[key].bind(event);
	        }
	      };
	      return;
	    }
	
	    properties[key] = {
	      get: function get() {
	        return event[key];
	      },
	      set: function set(value) {
	        event[key] = value;
	      }
	    };
	  });
	
	  properties.currentTarget = {
	    get: currentTargetGetter
	  };
	
	  Object.defineProperties(catEvent, properties);
	  Object.seal(catEvent);
	  Object.freeze(catEvent);
	
	  return catEvent;
	}
	
	function getMatchesMethod(element) {
	  var method = element.matches || element.webkitMatchesSelector || element.mozMatchesSelector || element.oMatchesSelector || element.msMatchesSelector;
	
	  return method.bind(element);
	}
	
	function attributesToObject(attributes) {
	  var result = Object.create(null);
	  Array.prototype.forEach.call(attributes, function (current) {
	    result[current.name] = current.value;
	  });
	  return result;
	}
	
	function isTagImmutable(element) {
	  return element.nodeName === TAG_NAMES.SCRIPT || element.nodeName === TAG_NAMES.STYLE || element.nodeName === TAG_NAMES.LINK && element.getAttribute('rel') === 'stylesheet';
	}
	
	function findSlot(root) {
	  var slot = null;
	  var queue = [root];
	
	  while (queue.length > 0) {
	    var currentChildren = queue.shift().children;
	
	    if (!currentChildren) {
	      continue;
	    }
	
	    if (slot !== null) {
	      break;
	    }
	
	    Array.prototype.forEach.call(currentChildren, function (currentChild) {
	      if (moduleHelper.isComponentNode(currentChild)) {
	        return;
	      }
	
	      if (moduleHelper.isSlotNode(currentChild)) {
	        slot = currentChild;
	      }
	
	      queue.push(currentChild);
	    });
	  }
	
	  return slot;
	}
	
	module.exports = DocumentRenderer;

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var DocumentRenderer = __webpack_require__(435);
	var moduleHelper = __webpack_require__(158);
	
	module.exports = {
	  register: function register(locator, document) {
	    locator.register('documentRenderer', DocumentRenderer, true);
	    locator.registerInstance('documentComponent', Object.assign({ name: moduleHelper.DOCUMENT_COMPONENT_NAME }, document));
	  },
	
	  DocumentRenderer: DocumentRenderer
	};

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var uuid = __webpack_require__(285);
	var moduleHelper = __webpack_require__(158);
	
	var LocalContextProvider = function () {
	  function LocalContextProvider() {
	    _classCallCheck(this, LocalContextProvider);
	
	    this._storage = Object.create(null);
	
	    this._currentId = null;
	  }
	
	  LocalContextProvider.prototype.setContext = function setContext(context, parentId) {
	    var id = uuid.v4();
	    this._storage[id] = {
	      context: context,
	      parentId: parentId
	    };
	    this._currentId = id;
	  };
	
	  LocalContextProvider.prototype.setContextById = function setContextById(id, context, parentId) {
	    this._storage[id] = {
	      context: context,
	      parentId: parentId
	    };
	    this._currentId = id;
	  };
	
	  LocalContextProvider.prototype.getContextById = function getContextById(id) {
	    var storage = this._storage[id] || {};
	    return storage.context;
	  };
	
	  LocalContextProvider.prototype.getParentById = function getParentById(id) {
	    var storage = this._storage[id] || {};
	    return storage.parentId;
	  };
	
	  LocalContextProvider.prototype.getCurrentId = function getCurrentId() {
	    return this._currentId;
	  };
	
	  LocalContextProvider.prototype.getCurrentContext = function getCurrentContext() {
	    if (!this._currentId) {
	      return null;
	    }
	
	    return this._storage[this._currentId].context;
	  };
	
	  LocalContextProvider.prototype.getContextByTagName = function getContextByTagName(tagName, parentId) {
	    var parentContext = this._storage[parentId];
	    var componentName = moduleHelper.getOriginalComponentName(tagName);
	
	    if (!parentContext) {
	      return null;
	    }
	
	    var children = parentContext.context.children;
	
	
	    if (!children) {
	      return null;
	    }
	
	    var child = children.find(function (child) {
	      return child.name === componentName;
	    });
	
	    if (!child) {
	      return null;
	    }
	
	    if (child.recursive) {
	      return this._storage[parentId].context;
	    }
	
	    var name = child.name,
	        component = child.component,
	        watcher = child.watcher;
	
	    var props = this._getProps(child.props, child.parentPropsMap, parentId);
	
	    return Object.assign({ name: name, watcher: watcher, props: props }, component);
	  };
	
	  LocalContextProvider.prototype._getProps = function _getProps(props, parentPropsMap, parentId) {
	    var componentProps = Object.create(null);
	    var inheritedFromParentProps = void 0;
	
	    if ((typeof parentPropsMap === 'undefined' ? 'undefined' : _typeof(parentPropsMap)) === 'object') {
	      var parentProps = this._storage[parentId].context.props;
	
	      inheritedFromParentProps = Object.keys(parentPropsMap).reduce(function (props, key) {
	        var _Object$assign;
	
	        var value = parentProps[parentPropsMap[key]];
	
	        if (!value) {
	          return;
	        }
	
	        return Object.assign(props, (_Object$assign = {}, _Object$assign[key] = value, _Object$assign));
	      }, {});
	    }
	
	    return Object.assign(componentProps, props, inheritedFromParentProps);
	  };
	
	  return LocalContextProvider;
	}();
	
	module.exports = LocalContextProvider;

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Baobab = __webpack_require__(15);
	var appstate = __webpack_require__(432);
	
	var StateManager = function () {
	  function StateManager(locator) {
	    _classCallCheck(this, StateManager);
	
	    this._locator = locator;
	    this._eventBus = locator.resolve('eventBus');
	    this._config = locator.resolve('config');
	    this._currentRoutingContext = null;
	
	    this.tree = new Baobab({}, this._config.baobab);
	
	    this.signal = this.signal.bind(this);
	  }
	
	  StateManager.prototype.signal = function signal(actions) {
	    var _this = this;
	
	    var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var asyncActionResults = arguments[2];
	
	    var signal = appstate.create(actions);
	
	    return signal(this.tree, {
	      locator: this._locator,
	      context: this._currentRoutingContext,
	      tree: this.tree
	    }, args, asyncActionResults).then(function (result) {
	      _this._eventBus.emit('signalEnd', result);
	      return result.asyncActionResults;
	    }).catch(function (error) {
	      _this._eventBus.emit('error', error);
	    });
	  };
	
	  StateManager.prototype.setRoutingContext = function setRoutingContext(routingContext) {
	    this._currentRoutingContext = routingContext;
	    return Promise.resolve();
	  };
	
	  StateManager.prototype.getWatcher = function getWatcher(definition) {
	    return this.tree.watch(definition);
	  };
	
	  StateManager.prototype.project = function project(definition) {
	    return this.tree.project(definition);
	  };
	
	  return StateManager;
	}();
	
	module.exports = StateManager;

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var util = __webpack_require__(284);
	var escape = __webpack_require__(440);
	
	var TITLE = 'Catbee@1.0.0 (<a href="https://github.com/catbee/catbee-web-components/issues "target="_blank">report an issue</a>)';
	var ERROR_MESSAGE_REGEXP = /^(?:[\w$]+): (?:.+)\r?\n/i;
	var ERROR_MESSAGE_FORMAT = '<span style="color: red; font-size: 16pt; font-weight: bold;">%s%s</span>';
	
	module.exports = {
	  prettyPrint: function prettyPrint(error, userAgent) {
	    if (!error || (typeof error === 'undefined' ? 'undefined' : _typeof(error)) !== 'object') {
	      return '';
	    }
	
	    var dateString = new Date().toUTCString() + ';<br/>';
	    var userAgentString = userAgent ? userAgent + ';<br/>' : '';
	    var name = typeof error.name === 'string' ? error.name + ': ' : '';
	    var message = String(error.message || '');
	    var stack = String(error.stack || '').replace(ERROR_MESSAGE_REGEXP, '');
	    var fullMessage = util.format(ERROR_MESSAGE_FORMAT, escape(name), escape(message));
	
	    return '<div style="background-color: white; font-size: 12pt;">' + dateString + userAgentString + TITLE + '<br/><br/>' + fullMessage + '<br/><br/>' + escape(stack) + '</div>';
	  }
	};

/***/ }),
/* 440 */
/***/ (function(module, exports) {

	'use strict';
	
	var AMP = /&/g;
	var LT = /</g;
	var GT = />/g;
	var QUOT = /\"/g;
	var SINGLE_QUOT = /\'/g;
	var NEW_LINE = /\r?\n/g;
	
	module.exports = function escape(value) {
	  return value.replace(AMP, '&amp;').replace(LT, '&lt;').replace(GT, '&gt;').replace(QUOT, '&quot;').replace(SINGLE_QUOT, '&#39;').replace(NEW_LINE, '<br/>');
	};

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Catbee = __webpack_require__(442);
	var BootstrapperBase = __webpack_require__(448);
	var ModuleApiProvider = __webpack_require__(445);
	var CookieWrapper = __webpack_require__(443);
	
	var Bootstrapper = function (_BootstrapperBase) {
	  _inherits(Bootstrapper, _BootstrapperBase);
	
	  function Bootstrapper() {
	    _classCallCheck(this, Bootstrapper);
	
	    var _this = _possibleConstructorReturn(this, _BootstrapperBase.call(this, Catbee));
	
	    _this.create = _this.create.bind(_this);
	    return _this;
	  }
	
	  Bootstrapper.prototype.configure = function configure(configObject, locator) {
	    _BootstrapperBase.prototype.configure.call(this, configObject, locator);
	
	    locator.register('moduleApiProvider', ModuleApiProvider, true);
	    locator.register('cookieWrapper', CookieWrapper, true);
	    locator.registerInstance('window', window);
	  };
	
	  return Bootstrapper;
	}(BootstrapperBase);
	
	module.exports = new Bootstrapper();

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CatbeeBase = __webpack_require__(449);
	
	var Catbee = function (_CatbeeBase) {
	  _inherits(Catbee, _CatbeeBase);
	
	  function Catbee() {
	    _classCallCheck(this, Catbee);
	
	    var _this = _possibleConstructorReturn(this, _CatbeeBase.call(this));
	
	    _this._router = null;
	    return _this;
	  }
	
	  Catbee.prototype.wrapDocument = function wrapDocument() {
	    this._router = this.locator.resolve('requestRouter');
	  };
	
	  Catbee.prototype.startWhenReady = function startWhenReady() {
	    var _this2 = this;
	
	    if (window.catbee) {
	      return Promise.resolve();
	    }
	
	    return new Promise(function (resolve) {
	      window.document.addEventListener('DOMContentLoaded', function () {
	        _this2.wrapDocument();
	        window.catbee = _this2;
	        resolve();
	      });
	    });
	  };
	
	  return Catbee;
	}(CatbeeBase);
	
	module.exports = Catbee;

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CookieWrapperBase = __webpack_require__(450);
	
	var CookieWrapper = function (_CookieWrapperBase) {
	  _inherits(CookieWrapper, _CookieWrapperBase);
	
	  function CookieWrapper(locator) {
	    _classCallCheck(this, CookieWrapper);
	
	    var _this = _possibleConstructorReturn(this, _CookieWrapperBase.call(this));
	
	    _this._window = locator.resolve('window');
	    return _this;
	  }
	
	  CookieWrapper.prototype.getCookieString = function getCookieString() {
	    return this._window.document.cookie ? this._window.document.cookie.toString() : '';
	  };
	
	  CookieWrapper.prototype.set = function set(cookieSetup) {
	    var cookie = this._convertToCookieSetup(cookieSetup);
	    this._window.document.cookie = cookie;
	    return cookie;
	  };
	
	  return CookieWrapper;
	}(CookieWrapperBase);
	
	module.exports = CookieWrapper;

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var URI = __webpack_require__(58).URI;
	
	var ERROR_DOCUMENT_RENDERER = 'Document renderer must be register in service locator.';
	
	var RequestRouter = function () {
	  function RequestRouter(locator) {
	    var _this = this;
	
	    _classCallCheck(this, RequestRouter);
	
	    this._eventBus = locator.resolve('eventBus');
	
	    this._window = locator.resolve('window');
	
	    this._urlArgsProvider = locator.resolve('urlArgsProvider');
	
	    this._contextFactory = locator.resolve('contextFactory');
	
	    this._location = null;
	
	    this._referrer = '';
	
	    this._isStateInitialized = false;
	
	    this._isHistorySupported = this._window.history && this._window.history.pushState instanceof Function;
	
	    try {
	      this._documentRenderer = locator.resolve('documentRenderer');
	    } catch (e) {
	      this._eventBus.emit('error', new Error(ERROR_DOCUMENT_RENDERER));
	      return;
	    }
	
	    this._wrapDocument();
	
	    this._changeState(new URI(this._window.location.toString())).catch(function (reason) {
	      return _this._handleError(reason);
	    });
	  }
	
	  RequestRouter.prototype.route = function route() {
	    var _this2 = this;
	
	    return Promise.resolve().then(function () {
	      var newLocation = new URI(_this2._window.location.toString());
	      var newAuthority = newLocation.authority ? newLocation.authority.toString() : null;
	      var currentAuthority = _this2._location.authority ? _this2._location.authority.toString() : null;
	
	      if (newLocation.scheme !== _this2._location.scheme || newAuthority !== currentAuthority) {
	        return Promise.resolve();
	      }
	
	      var newQuery = newLocation.query ? newLocation.query.toString() : null;
	      var currentQuery = _this2._location.query ? _this2._location.query.toString() : null;
	
	      if (newLocation.path === _this2._location.path && newQuery === currentQuery) {
	        _this2._location = newLocation;
	        return Promise.resolve();
	      }
	
	      return _this2._changeState(newLocation);
	    });
	  };
	
	  RequestRouter.prototype.go = function go(locationString) {
	    var _this3 = this;
	
	    return Promise.resolve().then(function () {
	      var location = new URI(locationString);
	      location = location.resolveRelative(_this3._location);
	      locationString = location.toString();
	
	      var currentAuthority = _this3._location.authority ? _this3._location.authority.toString() : null;
	      var newAuthority = location.authority ? location.authority.toString() : null;
	
	      if (!_this3._isHistorySupported || location.scheme !== _this3._location.scheme || newAuthority !== currentAuthority) {
	        _this3._window.location.assign(locationString);
	        return Promise.resolve();
	      }
	
	      var args = _this3._urlArgsProvider.getArgsByUri(location);
	
	      if (!args) {
	        _this3._window.location.assign(locationString);
	        return Promise.resolve();
	      }
	
	      _this3._window.history.pushState({}, '', locationString);
	      return _this3.route();
	    });
	  };
	
	  RequestRouter.prototype._changeState = function _changeState(newLocation) {
	    var _this4 = this;
	
	    return Promise.resolve().then(function () {
	      _this4._location = newLocation;
	      var args = _this4._urlArgsProvider.getArgsByUri(newLocation);
	
	      var routingContext = _this4._contextFactory.create({
	        args: args,
	        headers: null,
	        referrer: _this4._referrer || _this4._window.document.referrer,
	        location: _this4._location,
	        userAgent: _this4._window.navigator.userAgent
	      });
	
	      if (!_this4._isStateInitialized) {
	        _this4._isStateInitialized = true;
	        return _this4._documentRenderer.initWithState(routingContext);
	      }
	
	      if (!args) {
	        window.location.reload();
	        return Promise.resolve();
	      }
	
	      return _this4._documentRenderer.updateState(routingContext);
	    }).then(function () {
	      _this4._referrer = _this4._location;
	    });
	  };
	
	  RequestRouter.prototype._wrapDocument = function _wrapDocument() {
	    var _this5 = this;
	
	    if (!this._isHistorySupported) {
	      return;
	    }
	
	    this._window.addEventListener('popstate', function () {
	      _this5.route().catch(_this5._handleError.bind(_this5));
	    });
	  };
	
	  RequestRouter.prototype._handleError = function _handleError(error) {
	    this._eventBus.emit('error', error);
	  };
	
	  return RequestRouter;
	}();
	
	module.exports = RequestRouter;

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propertyHelper = __webpack_require__(219);
	var ModuleApiProviderBase = __webpack_require__(218);
	
	var ModuleApiProvider = function (_ModuleApiProviderBas) {
	  _inherits(ModuleApiProvider, _ModuleApiProviderBas);
	
	  function ModuleApiProvider(locator) {
	    _classCallCheck(this, ModuleApiProvider);
	
	    var _this = _possibleConstructorReturn(this, _ModuleApiProviderBas.call(this, locator));
	
	    propertyHelper.defineReadOnly(_this, 'isBrowser', true);
	    propertyHelper.defineReadOnly(_this, 'isServer', false);
	    return _this;
	  }
	
	  ModuleApiProvider.prototype.notFound = function notFound() {
	    var window = this.locator.resolve('window');
	    window.location.reload();
	    return Promise.resolve();
	  };
	
	  ModuleApiProvider.prototype.redirect = function redirect(uriString, options) {
	    var requestRouter = this.locator.resolve('requestRouter');
	    return requestRouter.go(uriString, options);
	  };
	
	  ModuleApiProvider.prototype.clearFragment = function clearFragment() {
	    var window = this.locator.resolve('window');
	    var position = window.document.body.scrollTop;
	
	    window.location.hash = '';
	    window.document.body.scrollTop = position;
	
	    return Promise.resolve();
	  };
	
	  return ModuleApiProvider;
	}(ModuleApiProviderBase);
	
	module.exports = ModuleApiProvider;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(441);

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var propertyHelper = __webpack_require__(219);
	
	var ContextFactory = function () {
	  function ContextFactory(locator) {
	    _classCallCheck(this, ContextFactory);
	
	    this._serviceLocator = locator;
	  }
	
	  ContextFactory.prototype.create = function create(additional) {
	    var apiProvider = this._serviceLocator.resolve('moduleApiProvider');
	    var context = Object.create(apiProvider);
	
	    Object.keys(additional).forEach(function (key) {
	      return propertyHelper.defineReadOnly(context, key, additional[key]);
	    });
	
	    return context;
	  };
	
	  return ContextFactory;
	}();
	
	module.exports = ContextFactory;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var URLArgsProvider = __webpack_require__(452);
	var RequestRouter = __webpack_require__(444);
	var ContextFactory = __webpack_require__(447);
	var ModuleApiProviderBase = __webpack_require__(218);
	var EventEmitter = __webpack_require__(744).EventEmitter;
	
	var BootstrapperBase = function () {
	  function BootstrapperBase(catbeeConstructor) {
	    _classCallCheck(this, BootstrapperBase);
	
	    this._catbeeConstructor = catbeeConstructor;
	  }
	
	  BootstrapperBase.prototype.create = function create(configObject) {
	    configObject = configObject || {};
	    var catbee = new this._catbeeConstructor();
	    this.configure(configObject, catbee.locator);
	    return catbee;
	  };
	
	  BootstrapperBase.prototype.configure = function configure(configObject, locator) {
	    var eventBus = new EventEmitter();
	    eventBus.setMaxListeners(0);
	
	    locator.registerInstance('eventBus', eventBus);
	    locator.registerInstance('config', configObject);
	    locator.register('urlArgsProvider', URLArgsProvider, true);
	    locator.register('contextFactory', ContextFactory, true);
	    locator.register('requestRouter', RequestRouter, true);
	  };
	
	  return BootstrapperBase;
	}();
	
	module.exports = BootstrapperBase;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ServiceLocator = __webpack_require__(453);
	
	var CatbeeBase = function () {
	  function CatbeeBase() {
	    _classCallCheck(this, CatbeeBase);
	
	    this.version = '3.0.0';
	
	    this.locator = new ServiceLocator();
	
	    this.locator.registerInstance('serviceLocator', this.locator);
	    this.locator.registerInstance('catbee', this);
	  }
	
	  CatbeeBase.prototype.registerRoute = function registerRoute(definition) {
	    if (!definition || (typeof definition === 'undefined' ? 'undefined' : _typeof(definition)) !== 'object') {
	      return;
	    }
	
	    this.locator.registerInstance('routeDefinition', definition);
	  };
	
	  return CatbeeBase;
	}();
	
	module.exports = CatbeeBase;

/***/ }),
/* 450 */
/***/ (function(module, exports) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CookieWrapperBase = function () {
	  function CookieWrapperBase() {
	    _classCallCheck(this, CookieWrapperBase);
	  }
	
	  CookieWrapperBase.prototype.getAll = function getAll() {
	    var string = this.getCookieString();
	    return this._parseCookieString(string);
	  };
	
	  CookieWrapperBase.prototype.get = function get(name) {
	    if (typeof name !== 'string') {
	      return '';
	    }
	
	    return this.getAll()[name] || '';
	  };
	
	  CookieWrapperBase.prototype._parseCookieString = function _parseCookieString(string) {
	    var cookie = Object.create(null);
	
	    if (typeof string !== 'string') {
	      return cookie;
	    }
	
	    string.split(/; */).forEach(function (cookiePair) {
	      var equalsIndex = cookiePair.indexOf('=');
	      if (equalsIndex < 0) {
	        return;
	      }
	
	      var key = cookiePair.substr(0, equalsIndex).trim();
	      var value = cookiePair.substr(equalsIndex + 1, cookiePair.length).trim();
	
	      value = value.replace(/^"|"$/g, '');
	      cookie[key] = value;
	    });
	
	    return cookie;
	  };
	
	  CookieWrapperBase.prototype._convertToCookieSetup = function _convertToCookieSetup(cookieSetup) {
	    if (typeof cookieSetup.key !== 'string' || typeof cookieSetup.value !== 'string') {
	      throw new Error('Wrong key or value');
	    }
	
	    var cookie = cookieSetup.key + '=' + cookieSetup.value;
	
	    if (typeof cookieSetup.maxAge === 'number') {
	      cookie += '; Max-Age=' + cookieSetup.maxAge.toFixed();
	      if (!cookieSetup.expires) {
	        cookieSetup.expires = new Date(Date.now() + cookieSetup.maxAge * 1000);
	      }
	    }
	
	    if (cookieSetup.expires instanceof Date) {
	      cookie += '; Expires=' + cookieSetup.expires.toUTCString();
	    }
	
	    if (typeof cookieSetup.path === 'string') {
	      cookie += '; Path=' + cookieSetup.path;
	    }
	
	    if (typeof cookieSetup.domain === 'string') {
	      cookie += '; Domain=' + cookieSetup.domain;
	    }
	
	    cookie += '; SameSite=None';
	    cookie += '; Secure';
	
	    if (typeof cookieSetup.httpOnly === 'boolean' && cookieSetup.httpOnly) {
	      cookie += '; HttpOnly';
	    }
	
	    return cookie;
	  };
	
	  return CookieWrapperBase;
	}();
	
	module.exports = CookieWrapperBase;

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var util = __webpack_require__(284);
	var catberryUri = __webpack_require__(58);
	var URI = catberryUri.URI;
	
	var URI_PATH_REPLACEMENT_REG_EXP_SOURCE = '([^\\/\\\\]*)';
	var URI_QUERY_REPLACEMENT_REG_EXP_SOURCE = '([^&?=]*)';
	var PATH_END_SLASH_REG_EXP = /(.+)\/($|\?|#)/;
	var EXPRESSION_ESCAPE_REG_EXP = /[\-\[\]\{\}\(\)\*\+\?\.\\\^\$\|]/g;
	var IDENTIFIER_REG_EXP_SOURCE = '[$A-Z_][\\dA-Z_$]*';
	var PARAMETER_REG_EXP = new RegExp(':' + IDENTIFIER_REG_EXP_SOURCE, 'gi');
	var SLASHED_BRACKETS_REG_EXP = /\\\[|\\\]/;
	
	var NO_OP_MAPPER = {
	  expression: /^$/,
	  map: function map() {
	    return null;
	  }
	};
	
	module.exports = {
	  removeEndSlash: function removeEndSlash(uriPath) {
	    if (!uriPath || typeof uriPath !== 'string') {
	      return '';
	    }
	    if (uriPath === '/') {
	      return uriPath;
	    }
	    return uriPath.replace(PATH_END_SLASH_REG_EXP, '$1$2');
	  },
	  compileRoute: function compileRoute(routeExpression) {
	    if (routeExpression) {
	      switch (Object.getPrototypeOf(routeExpression)) {
	        case String.prototype:
	          return compileStringRouteExpression(routeExpression);
	        case RegExp.prototype:
	          return compileRegexExpressionRoute(routeExpression);
	      }
	    }
	    return NO_OP_MAPPER;
	  }
	};
	
	function createUriPathMapper(expression, parameters) {
	  return function (uriPath, args) {
	    var matches = uriPath.match(expression);
	    if (!matches || matches.length < 2) {
	      return args;
	    }
	
	    matches = matches.splice(1);
	
	    parameters.forEach(function (parameter, index) {
	      var value = matches[index];
	
	      try {
	        value = decodeURIComponent(value);
	      } catch (e) {}
	
	      args[parameter.name] = value;
	    });
	  };
	}
	
	function createUriQueryMapper(query) {
	  var parameters = extractQueryParameters(query);
	  return function (queryValues, args) {
	    queryValues = queryValues || Object.create(null);
	
	    Object.keys(queryValues).forEach(function (queryKey) {
	      var parameter = parameters[queryKey];
	
	      if (!parameter) {
	        return;
	      }
	
	      var value = util.isArray(queryValues[queryKey]) ? queryValues[queryKey].map(parameter.map).filter(function (value) {
	        return value !== null;
	      }) : parameter.map(queryValues[queryKey]);
	
	      if (value === null) {
	        return;
	      }
	
	      args[parameter.name] = value;
	    });
	  };
	}
	
	function createUriQueryValueMapper(expression) {
	  return function (value) {
	    value = value.toString();
	    var matches = value.match(expression);
	    if (!matches || matches.length === 0) {
	      return null;
	    }
	
	    var mappedValue = matches[matches.length - 1];
	    try {
	      mappedValue = decodeURIComponent(mappedValue);
	    } catch (e) {}
	
	    return mappedValue;
	  };
	}
	
	function getParameterDescriptor(parameter) {
	  var parts = parameter.split(SLASHED_BRACKETS_REG_EXP);
	
	  return {
	    name: parts[0].trim().substring(1)
	  };
	}
	
	function extractQueryParameters(query) {
	  return Object.keys(query.values).reduce(function (queryParameters, name) {
	    if (util.isArray(query.values[name])) {
	      return queryParameters;
	    }
	
	    var escaped = query.values[name].replace(EXPRESSION_ESCAPE_REG_EXP, '\\$&');
	
	    var regExpSource = '^' + escaped.replace(PARAMETER_REG_EXP, URI_QUERY_REPLACEMENT_REG_EXP_SOURCE) + '$';
	    var queryParameterMatches = escaped.match(PARAMETER_REG_EXP);
	
	    if (!queryParameterMatches || queryParameterMatches.length === 0) {
	      return;
	    }
	
	    var parameter = getParameterDescriptor(queryParameterMatches[queryParameterMatches.length - 1]);
	    var expression = new RegExp(regExpSource, 'i');
	    parameter.map = createUriQueryValueMapper(expression);
	    queryParameters[name] = parameter;
	    return queryParameters;
	  }, Object.create(null));
	}
	
	function compileStringRouteExpression(routeExpression) {
	  var routeUri = new URI(routeExpression);
	  routeUri.path = module.exports.removeEndSlash(routeUri.path);
	  if (!routeUri) {
	    return null;
	  }
	
	  var escaped = routeUri.path.replace(EXPRESSION_ESCAPE_REG_EXP, '\\$&');
	
	  var regExpSource = '^' + escaped.replace(PARAMETER_REG_EXP, URI_PATH_REPLACEMENT_REG_EXP_SOURCE) + '$';
	  var expression = new RegExp(regExpSource, 'i');
	  var pathParameterMatches = escaped.match(PARAMETER_REG_EXP);
	  var pathParameters = pathParameterMatches ? pathParameterMatches.map(getParameterDescriptor) : null;
	
	  var pathMapper = pathParameters ? createUriPathMapper(expression, pathParameters) : null;
	  var queryMapper = routeUri.query ? createUriQueryMapper(routeUri.query) : null;
	
	  return {
	    expression: expression,
	    map: function map(uri) {
	      var args = Object.create(null);
	
	      if (pathMapper) {
	        pathMapper(uri.path, args);
	      }
	
	      if (queryMapper && uri.query) {
	        queryMapper(uri.query.values, args);
	      }
	
	      return args;
	    }
	  };
	}
	
	function compileRegexExpressionRoute(expression) {
	  return {
	    expression: expression,
	    map: function map() {
	      return Object.create(null);
	    }
	  };
	}

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var routeHelper = __webpack_require__(451);
	var catberryUri = __webpack_require__(58);
	var URI = catberryUri.URI;
	
	var URLArgsProvider = function () {
	  function URLArgsProvider(locator) {
	    _classCallCheck(this, URLArgsProvider);
	
	    this._uriMappers = getUriMappers(locator);
	  }
	
	  URLArgsProvider.prototype.getArgsByUri = function getArgsByUri(location) {
	    if (this._uriMappers.length === 0) {
	      return null;
	    }
	
	    location = location.clone();
	    location.path = routeHelper.removeEndSlash(location.path);
	
	    var args = getArgs(this._uriMappers, location);
	    return runPostMapping(args, this._uriMappers, location);
	  };
	
	  return URLArgsProvider;
	}();
	
	function getUriMappers(serviceLocator) {
	  var routeDefinitions;
	
	  try {
	    routeDefinitions = serviceLocator.resolveAll('routeDefinition');
	  } catch (e) {
	    routeDefinitions = [];
	  }
	
	  return routeDefinitions.map(function (route) {
	    var mapper = routeHelper.compileRoute(route.expression);
	
	    return {
	      expression: mapper.expression,
	      map: route.map || noop,
	      argsMap: function argsMap(uri) {
	        var args = mapper.map(uri);
	        Object.assign(args, route.args);
	        return args;
	      }
	    };
	  });
	}
	
	function getArgs(uriMappers, location) {
	  var args = null;
	
	  uriMappers.some(function (mapper) {
	    if (mapper.expression.test(location.path)) {
	      args = mapper.argsMap(location) || Object.create(null);
	      return true;
	    }
	    return false;
	  });
	
	  return args;
	}
	
	function runPostMapping(args, uriMappers, location) {
	  uriMappers.some(function (mapper) {
	    if (mapper.expression.test(location.path)) {
	      args = mapper.map(args);
	      return true;
	    }
	    return false;
	  });
	
	  return args;
	}
	
	function noop(data) {
	  return data;
	}
	
	module.exports = URLArgsProvider;

/***/ }),
/* 453 */
/***/ (function(module, exports) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ServiceLocator = function () {
		function ServiceLocator() {
			_classCallCheck(this, ServiceLocator);
	
			this._registrations = Object.create(null);
		}
	
		ServiceLocator.prototype.register = function register(type, implementation, isSingleton) {
			this._throwIfNotFunction(type, implementation);
			this._throwIfNotString(type);
	
			this._initializeRegistration(type);
	
			this._registrations[type].unshift({
				Implementation: implementation,
				isSingleton: Boolean(isSingleton),
				singleInstance: null
			});
		};
	
		ServiceLocator.prototype.registerInstance = function registerInstance(type, instance) {
			this._throwIfNotString(type);
			this._initializeRegistration(type);
	
			this._registrations[type].unshift({
				Implementation: instance.constructor,
				isSingleton: true,
				singleInstance: instance
			});
		};
	
		ServiceLocator.prototype.resolve = function resolve(type) {
			this._throwIfNotString(type);
			this._throwIfNoType(type);
			var firstRegistration = this._registrations[type][0];
			return this._createInstance(firstRegistration);
		};
	
		ServiceLocator.prototype.resolveAll = function resolveAll(type) {
			var _this = this;
	
			this._throwIfNotString(type);
			this._throwIfNoType(type);
			return this._registrations[type].map(function (registration) {
				return _this._createInstance(registration);
			});
		};
	
		ServiceLocator.prototype.unregister = function unregister(type) {
			this._throwIfNotString(type);
			this._registrations[type] = [];
		};
	
		ServiceLocator.prototype.has = function has(type) {
			this._throwIfNotString(type);
	
			return type in this._registrations && this._registrations[type].length > 0;
		};
	
		ServiceLocator.prototype._createInstance = function _createInstance(registration) {
			if (registration.isSingleton && registration.singleInstance !== null) {
				return registration.singleInstance;
			}
	
			var instance = new registration.Implementation(this);
	
			if (registration.isSingleton) {
				registration.singleInstance = instance;
			}
	
			return instance;
		};
	
		ServiceLocator.prototype._initializeRegistration = function _initializeRegistration(type) {
			if (type in this._registrations) {
				return;
			}
			this._registrations[type] = [];
		};
	
		ServiceLocator.prototype._throwIfNoType = function _throwIfNoType(type) {
			if (type in this._registrations && this._registrations[type].length > 0) {
				return;
			}
			throw new Error('Type "' + type + '" not registered');
		};
	
		ServiceLocator.prototype._throwIfNotFunction = function _throwIfNotFunction(type, Implementation) {
			if (Implementation instanceof Function) {
				return;
			}
	
			throw new Error('Constructor for type ' + type + ' should be a function');
		};
	
		ServiceLocator.prototype._throwIfNotString = function _throwIfNotString(type) {
			if (typeof type === 'string') {
				return;
			}
	
			throw new Error('Type name "' + type + '" should be a string');
		};
	
		return ServiceLocator;
	}();
	
	module.exports = ServiceLocator;

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UHRBase = __webpack_require__(456);
	
	var NON_SAFE_HEADERS = {
		cookie: true,
		'accept-charset': true
	};
	
	var UHR = function (_UHRBase) {
		_inherits(UHR, _UHRBase);
	
		function UHR(locator) {
			_classCallCheck(this, UHR);
	
			var _this = _possibleConstructorReturn(this, _UHRBase.call(this));
	
			_this.window = locator.resolve('window');
			return _this;
		}
	
		UHR.prototype._doRequest = function _doRequest(parameters) {
			var _this2 = this;
	
			Object.keys(parameters.headers).forEach(function (name) {
				if (NON_SAFE_HEADERS.hasOwnProperty(name.toLowerCase())) {
					delete parameters.headers[name];
				}
			});
	
			return new Promise(function (fulfill, reject) {
				var xhr = new _this2.window.XMLHttpRequest();
				var requestError = null;
	
				xhr.onabort = function () {
					requestError = new Error('Request aborted');
					reject(requestError);
				};
				xhr.ontimeout = function () {
					requestError = new Error('Request timeout');
					reject(requestError);
				};
				xhr.onerror = function () {
					requestError = new Error(xhr.statusText || 'Connection error');
					reject(requestError);
				};
				xhr.onreadystatechange = function () {
					if (xhr.readyState !== 4) {
						return;
					}
					if (requestError) {
						return;
					}
					var status = _this2._getStatusObject(xhr);
					var content = _this2.convertResponse(status.headers, xhr.responseText);
					fulfill({
						status: status,
						content: content
					});
				};
	
				var user = parameters.uri.authority.userInfo ? parameters.uri.authority.userInfo.user : null;
				var password = parameters.uri.authority.userInfo ? parameters.uri.authority.userInfo.password : null;
				xhr.open(parameters.method, parameters.uri.toString(), true, user || undefined, password || undefined);
				xhr.timeout = parameters.timeout;
	
				if (parameters.withCredentials) {
					xhr.withCredentials = true;
				}
	
				Object.keys(parameters.headers).forEach(function (headerName) {
					return xhr.setRequestHeader(headerName, parameters.headers[headerName]);
				});
	
				xhr.send(parameters.data);
			});
		};
	
		UHR.prototype._getStatusObject = function _getStatusObject(xhr) {
			var headers = {};
	
			if (!xhr) {
				return {
					code: 0,
					text: '',
					headers: headers
				};
			}
	
			xhr.getAllResponseHeaders().split('\n').forEach(function (header) {
				var delimiterIndex = header.indexOf(':');
				if (delimiterIndex <= 0) {
					return;
				}
				var headerName = header.substring(0, delimiterIndex).trim().toLowerCase();
				headers[headerName] = header.substring(delimiterIndex + 1).trim();
			});
	
			return {
				code: xhr.status === 1223 ? 204 : xhr.status,
				text: xhr.status === 1223 ? 'No Content' : xhr.statusText,
				headers: headers
			};
		};
	
		return UHR;
	}(UHRBase);
	
	module.exports = UHR;

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var UHR = __webpack_require__(454);
	
	module.exports = {
		register: function register(locator) {
			locator.register('uhr', UHR, true);
		},
		UHR: UHR
	};

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var catberryUri = __webpack_require__(58);
	var Query = catberryUri.Query;
	var URI = catberryUri.URI;
	
	var DEFAULT_TIMEOUT = 30000;
	var HTTP_PROTOCOL_REGEXP = /^(http)s?$/i;
	
	var UHRBase = function () {
		function UHRBase() {
			_classCallCheck(this, UHRBase);
		}
	
		UHRBase.prototype.get = function get(url, parameters) {
			return this.request(this._normalizeOptions(UHRBase.METHODS.GET, url, parameters));
		};
	
		UHRBase.prototype.post = function post(url, parameters) {
			return this.request(this._normalizeOptions(UHRBase.METHODS.POST, url, parameters));
		};
	
		UHRBase.prototype.put = function put(url, parameters) {
			return this.request(this._normalizeOptions(UHRBase.METHODS.PUT, url, parameters));
		};
	
		UHRBase.prototype.patch = function patch(url, parameters) {
			return this.request(this._normalizeOptions(UHRBase.METHODS.PATCH, url, parameters));
		};
	
		UHRBase.prototype.delete = function _delete(url, parameters) {
			return this.request(this._normalizeOptions(UHRBase.METHODS.DELETE, url, parameters));
		};
	
		UHRBase.prototype.request = function request(parameters) {
			var _this = this;
	
			return this._validateRequest(parameters).then(function (validated) {
				return _this._doRequest(validated);
			});
		};
	
		UHRBase.prototype._validateRequest = function _validateRequest(parameters) {
			if (!parameters || (typeof parameters === 'undefined' ? 'undefined' : _typeof(parameters)) !== 'object') {
				return Promise.reject(new Error('Request parameters argument should be an object'));
			}
	
			var validated = Object.create(parameters);
	
			if (typeof parameters.url !== 'string') {
				return Promise.reject(new Error('"parameters.url" is a required parameter'));
			}
	
			validated.uri = new URI(validated.url);
			if (!validated.uri.scheme) {
				return Promise.reject(new Error('"parameters.url" should contain a protocol (scheme)'));
			}
			if (!HTTP_PROTOCOL_REGEXP.test(validated.uri.scheme)) {
				return Promise.reject(new Error('"' + validated.uri.scheme + '" protocol (scheme) is unsupported'));
			}
			if (!validated.uri.authority || !validated.uri.authority.host) {
				return Promise.reject(new Error('"parameters.url" should contain a host'));
			}
			if (typeof validated.method !== 'string' || !(validated.method in UHRBase.METHODS)) {
				return Promise.reject(new Error('HTTP method is a required parameter'));
			}
	
			validated.timeout = validated.timeout || DEFAULT_TIMEOUT;
			if (typeof validated.timeout !== 'number') {
				return Promise.reject(new Error('Timeout should be a number'));
			}
	
			validated.headers = this.createHeaders(validated.headers);
	
			if (!this._isUpstreamRequest(parameters.method) && validated.data && _typeof(validated.data) === 'object') {
	
				var dataKeys = Object.keys(validated.data);
	
				if (dataKeys.length > 0 && !validated.uri.query) {
					validated.uri.query = new Query('');
				}
	
				dataKeys.forEach(function (key) {
					validated.uri.query.values[key] = validated.data[key];
				});
				validated.data = null;
			} else {
				var dataAndHeaders = this._getDataToSend(validated.headers, validated.data);
				validated.headers = dataAndHeaders.headers;
				validated.data = dataAndHeaders.data;
			}
	
			return Promise.resolve(validated);
		};
	
		UHRBase.prototype._getDataToSend = function _getDataToSend(headers, data) {
			var found = this._findContentType(headers);
			var contentTypeHeader = found.name;
			var contentType = found.type;
	
			if (!data || (typeof data === 'undefined' ? 'undefined' : _typeof(data)) !== 'object') {
				data = data ? String(data) : '';
				if (!contentType) {
					headers[contentTypeHeader] = UHRBase.PLAIN_TEXT_ENTITY_CONTENT_TYPE;
				}
				return {
					headers: headers,
					data: data
				};
			}
	
			if (contentType === UHRBase.TYPES.JSON) {
				return {
					headers: headers,
					data: JSON.stringify(data)
				};
			}
	
			headers[contentTypeHeader] = UHRBase.URL_ENCODED_ENTITY_CONTENT_TYPE;
	
			var query = new Query();
			query.values = data;
			return {
				headers: headers,
				data: query.toString().replace(/\+/g, '%2B').replace(/%20/g, '+')
			};
		};
	
		UHRBase.prototype.createHeaders = function createHeaders(parameterHeaders) {
			if (!parameterHeaders || (typeof parameterHeaders === 'undefined' ? 'undefined' : _typeof(parameterHeaders)) !== 'object') {
				parameterHeaders = {};
			}
	
			var headers = {};
	
			Object.keys(UHRBase.DEFAULT_GENERAL_HEADERS).forEach(function (headerName) {
				headers[headerName] = UHRBase.DEFAULT_GENERAL_HEADERS[headerName];
			});
	
			Object.keys(parameterHeaders).forEach(function (headerName) {
				if (parameterHeaders[headerName] === null || parameterHeaders[headerName] === undefined) {
					delete headers[headerName];
					return;
				}
				headers[headerName] = parameterHeaders[headerName];
			});
	
			return headers;
		};
	
		UHRBase.prototype._doRequest = function _doRequest(parameters) {};
	
		UHRBase.prototype.convertResponse = function convertResponse(headers, responseData) {
			if (typeof responseData !== 'string') {
				responseData = '';
			}
			var found = this._findContentType(headers);
			var contentType = found.type || UHRBase.TYPES.PLAIN_TEXT;
	
			switch (contentType) {
				case UHRBase.TYPES.JSON:
					try {
						return JSON.parse(responseData) || {};
					} catch (e) {
						return {};
					}
				case UHRBase.TYPES.URL_ENCODED:
					try {
						var query = new Query(responseData.replace('+', '%20'));
						return query.values || {};
					} catch (e) {
						return {};
					}
				default:
					return responseData;
			}
		};
	
		UHRBase.prototype._isUpstreamRequest = function _isUpstreamRequest(method) {
			return method === UHRBase.METHODS.POST || method === UHRBase.METHODS.PUT || method === UHRBase.METHODS.PATCH;
		};
	
		UHRBase.prototype._normalizeOptions = function _normalizeOptions(method, url, parameters) {
			parameters = parameters || {};
			var normalParameters = Object.create(parameters);
			normalParameters.method = method;
			normalParameters.url = url;
			return normalParameters;
		};
	
		UHRBase.prototype._findContentType = function _findContentType(headers) {
			var contentTypeString = '';
			var contentTypeHeader = 'Content-Type';
	
			Object.keys(headers).forEach(function (key) {
				if (key.toLowerCase() !== 'content-type') {
					return;
				}
				contentTypeHeader = key;
				contentTypeString = headers[key];
			});
	
			var typeAndParameters = contentTypeString.split(';');
			var contentType = typeAndParameters[0].toLowerCase();
			return {
				name: contentTypeHeader,
				type: contentType
			};
		};
	
		_createClass(UHRBase, null, [{
			key: 'METHODS',
			get: function get() {
				return {
					GET: 'GET',
					HEAD: 'HEAD',
					POST: 'POST',
					PUT: 'PUT',
					PATCH: 'PATCH',
					DELETE: 'DELETE',
					OPTIONS: 'OPTIONS',
					TRACE: 'TRACE',
					CONNECT: 'CONNECT'
				};
			}
		}, {
			key: 'TYPES',
			get: function get() {
				return {
					URL_ENCODED: 'application/x-www-form-urlencoded',
					JSON: 'application/json',
					PLAIN_TEXT: 'text/plain',
					HTML: 'text/html'
				};
			}
		}, {
			key: 'CHARSET',
			get: function get() {
				return 'UTF-8';
			}
		}, {
			key: 'DEFAULT_GENERAL_HEADERS',
			get: function get() {
				return {
					Accept: UHRBase.TYPES.JSON + '; q=0.7, ' + UHRBase.TYPES.HTML + '; q=0.2, ' + UHRBase.TYPES.PLAIN_TEXT + '; q=0.1',
					'Accept-Charset': UHRBase.CHARSET + '; q=1'
				};
			}
		}, {
			key: 'CHARSET_PARAMETER',
			get: function get() {
				return '; charset=' + UHRBase.CHARSET;
			}
		}, {
			key: 'URL_ENCODED_ENTITY_CONTENT_TYPE',
			get: function get() {
				return UHRBase.TYPES.URL_ENCODED + UHRBase.CHARSET_PARAMETER;
			}
		}, {
			key: 'JSON_ENTITY_CONTENT_TYPE',
			get: function get() {
				return UHRBase.TYPES.JSON + UHRBase.CHARSET_PARAMETER;
			}
		}, {
			key: 'PLAIN_TEXT_ENTITY_CONTENT_TYPE',
			get: function get() {
				return UHRBase.TYPES.PLAIN_TEXT + UHRBase.CHARSET_PARAMETER;
			}
		}]);
	
		return UHRBase;
	}();
	
	module.exports = UHRBase;

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var percentEncodingHelper = __webpack_require__(115);
	
	var Authority = __webpack_require__(220);
	var Query = __webpack_require__(221);
	
	var URI_PARSE_REGEXP = new RegExp('^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?');
	
	var SCHEME_REGEXP = /^[a-z]+[a-z\d\+\.-]*$/i;
	var ERROR_SCHEME = 'URI scheme must satisfy expression ' + SCHEME_REGEXP.toString();
	
	var URI = function () {
		URI.createAuthority = function createAuthority(string) {
			return new Authority(string);
		};
	
		URI.prototype.createAuthority = function createAuthority(string) {
			return URI.createAuthority(string);
		};
	
		URI.createUserInfo = function createUserInfo(string) {
			return Authority.createUserInfo(string);
		};
	
		URI.prototype.createUserInfo = function createUserInfo(string) {
			return URI.createUserInfo(string);
		};
	
		URI.createQuery = function createQuery(string) {
			return new Query(string);
		};
	
		URI.prototype.createQuery = function createQuery(string) {
			return URI.createQuery(string);
		};
	
		function URI(uriString) {
			_classCallCheck(this, URI);
	
			this.scheme = null;
	
			this.authority = null;
	
			this.path = null;
	
			this.query = null;
	
			this.fragment = null;
	
			if (typeof uriString !== 'string') {
				uriString = '';
			}
	
			var matches = uriString.match(URI_PARSE_REGEXP);
	
			if (matches) {
				if (typeof matches[2] === 'string') {
					this.scheme = percentEncodingHelper.decode(matches[2]);
				}
				if (typeof matches[4] === 'string') {
					this.authority = URI.createAuthority(matches[4]);
				}
				if (typeof matches[5] === 'string') {
					this.path = percentEncodingHelper.decodePath(matches[5]);
				}
				if (typeof matches[7] === 'string') {
					this.query = URI.createQuery(matches[7]);
				}
				if (typeof matches[9] === 'string') {
					this.fragment = percentEncodingHelper.decode(matches[9]);
				}
			}
		}
	
		URI.prototype.resolveRelative = function resolveRelative(baseUri) {
			if (!baseUri.scheme) {
				throw new Error('Scheme component is required to be present in a base URI');
			}
	
			return transformReference(baseUri, this);
		};
	
		URI.prototype.clone = function clone() {
			var uri = new URI();
	
			if (typeof this.scheme === 'string') {
				uri.scheme = this.scheme;
			}
	
			if (this.authority) {
				uri.authority = this.authority.clone();
			}
	
			if (typeof this.path === 'string') {
				uri.path = this.path;
			}
	
			if (this.query) {
				uri.query = this.query.clone();
			}
	
			if (typeof this.fragment === 'string') {
				uri.fragment = this.fragment;
			}
	
			return uri;
		};
	
		URI.prototype.toString = function toString() {
			var result = '';
	
			if (this.scheme !== undefined && this.scheme !== null) {
				var scheme = String(this.scheme);
				if (!SCHEME_REGEXP.test(scheme)) {
					throw new Error(ERROR_SCHEME);
				}
				result += scheme + ':';
			}
	
			if (this.authority instanceof Authority) {
				result += '//' + this.authority.toString();
			}
	
			var path = this.path === undefined || this.path === null ? '' : String(this.path);
			result += percentEncodingHelper.encodePath(path);
	
			if (this.query instanceof Query) {
				result += '?' + this.query.toString();
			}
	
			if (this.fragment !== undefined && this.fragment !== null) {
				var fragment = String(this.fragment);
				result += '#' + percentEncodingHelper.encodeFragment(fragment);
			}
	
			return result;
		};
	
		return URI;
	}();
	
	function transformReference(baseUri, referenceUri) {
		var targetUri = new URI('');
	
		if (referenceUri.scheme) {
			targetUri.scheme = referenceUri.scheme;
			targetUri.authority = referenceUri.authority ? referenceUri.authority.clone() : referenceUri.authority;
			targetUri.path = removeDotSegments(referenceUri.path);
			targetUri.query = referenceUri.query ? referenceUri.query.clone() : referenceUri.query;
		} else {
			if (referenceUri.authority) {
				targetUri.authority = referenceUri.authority ? referenceUri.authority.clone() : referenceUri.authority;
				targetUri.path = removeDotSegments(referenceUri.path);
				targetUri.query = referenceUri.query ? referenceUri.query.clone() : referenceUri.query;
			} else {
				if (referenceUri.path === '') {
					targetUri.path = baseUri.path;
					if (referenceUri.query) {
						targetUri.query = referenceUri.query.clone();
					} else {
						targetUri.query = baseUri.query ? baseUri.query.clone() : baseUri.query;
					}
				} else {
					if (referenceUri.path[0] === '/') {
						targetUri.path = removeDotSegments(referenceUri.path);
					} else {
						targetUri.path = merge(baseUri, referenceUri);
						targetUri.path = removeDotSegments(targetUri.path);
					}
					targetUri.query = referenceUri.query ? referenceUri.query.clone() : referenceUri.query;
				}
				targetUri.authority = baseUri.authority ? baseUri.authority.clone() : baseUri.authority;
			}
			targetUri.scheme = baseUri.scheme;
		}
	
		targetUri.fragment = referenceUri.fragment;
		return targetUri;
	}
	
	function merge(baseUri, referenceUri) {
		if (baseUri.authority && baseUri.path === '') {
			return '/' + referenceUri.path;
		}
	
		var segmentsString = baseUri.path.indexOf('/') !== -1 ? baseUri.path.replace(/\/[^\/]+$/, '/') : '';
	
		return segmentsString + referenceUri.path;
	}
	
	function removeDotSegments(uriPath) {
		if (!uriPath) {
			return '';
		}
	
		var inputBuffer = uriPath;
		var newBuffer = '';
		var nextSegment = '';
		var outputBuffer = '';
	
		while (inputBuffer.length !== 0) {
			newBuffer = inputBuffer.replace(/^\.?\.\//, '');
			if (newBuffer !== inputBuffer) {
				inputBuffer = newBuffer;
				continue;
			}
	
			newBuffer = inputBuffer.replace(/^((\/\.\/)|(\/\.$))/, '/');
			if (newBuffer !== inputBuffer) {
				inputBuffer = newBuffer;
				continue;
			}
	
			newBuffer = inputBuffer.replace(/^((\/\.\.\/)|(\/\.\.$))/, '/');
			if (newBuffer !== inputBuffer) {
				outputBuffer = outputBuffer.replace(/\/[^\/]+$/, '');
				inputBuffer = newBuffer;
				continue;
			}
	
			if (inputBuffer === '.' || inputBuffer === '..') {
				break;
			}
	
			nextSegment = /^\/?[^\/]*(\/|$)/.exec(inputBuffer)[0];
			nextSegment = nextSegment.replace(/([^\/])(\/$)/, '$1');
			inputBuffer = inputBuffer.substring(nextSegment.length);
			outputBuffer += nextSegment;
		}
	
		return outputBuffer;
	}
	
	module.exports = URI;

/***/ }),
/* 458 */
[1064, 865, 1010],
/* 459 */
[1065, 866, 1011],
/* 460 */
[1066, 867, 1012],
/* 461 */
[1067, 868, 458, 1013],
/* 462 */
[1068, 869, 1014],
/* 463 */
[1070, 870, 1015],
/* 464 */
[1071, 871, 1016],
/* 465 */
[1072, 872, 1017],
/* 466 */
[1073, 873, 1018],
/* 467 */
[1074, 874, 1019],
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(875);
	var $ = __webpack_require__(12);
	var _ = __webpack_require__(3);
	
	var SELECT = '.' + css.select;
	var OPTION = '.' + css.option;
	var INPUT = '.' + css.input;
	var DROPDOWN = '.' + css.dropdown;
	var OPTIONS = '.' + css.options;
	var SCROLLBAR = '.' + css.scrollbar;
	var SCROLLTRACK = '.' + css.scrolltrack;
	var IS_HIGHLIGHTED = '.' + css.isHighlighted;
	var IS_UP = '.' + css.isUp;
	var IS_DISABLED = '.' + css.isDisabled;
	
	var Select = function () {
	    function Select() {
	        _classCallCheck(this, Select);
	
	        this.template = __webpack_require__(1020);
	    }
	
	    Select.prototype.render = function render() {
	        var skinName = _.get(this.$context.attributes, 'cat-skin');
	        var skin = _.get(css, skinName);
	
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { skin: skin });
	        }).then(function (data) {
	            return Object.assign({ css: css }, data);
	        });
	    };
	
	    Select.prototype.bind = function bind() {
	        var _click, _mouseenter, _keydown, _keyup;
	
	        this.fillUI();
	        return {
	            click: (_click = {}, _click[SELECT] = this.clickOnSelect, _click[OPTION] = this.clickOnItem, _click),
	            mouseenter: (_mouseenter = {}, _mouseenter[OPTION] = this.enterItem, _mouseenter),
	            keydown: (_keydown = {}, _keydown[INPUT] = this.prevent, _keydown),
	            keyup: (_keyup = {}, _keyup[INPUT] = this.keyHandler, _keyup)
	        };
	    };
	
	    Select.prototype.fillUI = function fillUI() {
	        var $el = $(this.$context.element);
	        var wrapper = _.get(this.$context.attributes, 'cat-wrapper');
	        this.$select = $el.find(INPUT);
	        this.$dropdown = $el.find(DROPDOWN);
	        this.$itemWrapper = $el.find(OPTIONS);
	        this.$items = $el.find(OPTION);
	
	        var activeItem = this.$items.filter(IS_HIGHLIGHTED.substring(1));
	        this._selected = activeItem.length ? activeItem.index() : 0;
	
	        if (wrapper) {
	            this.$wrapper = $(wrapper);
	        }
	    };
	
	    Select.prototype.initBaron = function initBaron() {
	        var baron = __webpack_require__(64);
	        var elementId = this.$context.attributes.id;
	
	        baron({
	            root: '#' + elementId + ' ' + DROPDOWN,
	            scroller: OPTIONS,
	            bar: SCROLLBAR,
	            track: SCROLLTRACK,
	            $: $
	        });
	    };
	
	    Select.prototype.prevent = function prevent(e) {
	        if (_.includes([38, 40], e.keyCode)) {
	            e.preventDefault();
	        }
	    };
	
	    Select.prototype.clickOnSelect = function clickOnSelect(e) {
	        var _this = this;
	
	        e.preventDefault();
	        e.stopPropagation();
	
	        var $el = $(SELECT);
	        var name = $(this.$context.element).attr('cat-name');
	        var signalOnToggle = this.$context.props.signalOnToggle;
	
	        if ($el.hasClass(IS_DISABLED.substring(1))) {
	            return;
	        }
	
	        this.$context.signal(signalOnToggle, { name: name });
	
	        _.defer(function () {
	            _this.calculateDropdownHeight();
	        });
	    };
	
	    Select.prototype.clickOnItem = function clickOnItem(e) {
	        this.selectValue(e);
	    };
	
	    Select.prototype.keyHandler = function keyHandler(e) {
	        var signalOnToggle = this.$context.props.signalOnToggle;
	        var name = $(this.$context.element).attr('cat-name');
	
	        switch (e.keyCode) {
	            case 13:
	                this.$context.signal(signalOnToggle, { name: name });
	                this.selectValue(e);
	                break;
	            case 27:
	                break;
	            case 38:
	                e.stopPropagation();
	                if (this._current > 0) {
	                    this._current--;
	                }
	                break;
	            case 40:
	                e.stopPropagation();
	                if (this._current + 1 < this.$items.length) {
	                    this._current++;
	                }
	                break;
	            default:
	                break;
	        }
	
	        if (_.includes([38, 40], e.keyCode)) {
	            this.changeHighlight(this._current);
	        }
	    };
	
	    Select.prototype.enterItem = function enterItem(e) {
	        var index = $(e.target).index();
	        this.changeHighlight(index);
	    };
	
	    Select.prototype.selectValue = function selectValue(e) {
	        var $currentItem = this.$items.filter(IS_HIGHLIGHTED)[0];
	        var selectedValue = $currentItem.getAttribute('cat-value');
	        var signalOnSelect = this.$context.props.signalOnSelect;
	        var field = _.get(this.$context.attributes, 'cat-field');
	        var ctx = this.$context;
	
	        if (signalOnSelect && $currentItem) {
	            ctx.signal(signalOnSelect, { selectedValue: selectedValue, field: field, ctx: ctx });
	        }
	    };
	
	    Select.prototype.changeHighlight = function changeHighlight(index) {
	        this.$items.removeClass(IS_HIGHLIGHTED.substring(1));
	        this.$items.eq(index).addClass(IS_HIGHLIGHTED.substring(1));
	        this._current = index;
	    };
	
	    Select.prototype.calculateDropdownHeight = function calculateDropdownHeight() {
	        var selectHeight = $(this.$select).outerHeight();
	        var offsetTop = $(this.$select).offset().top;
	        var scrollTop = $(window).scrollTop();
	        var viewportHeight = $(window).height();
	        var viewportTop = offsetTop - scrollTop;
	        var viewportBottom = viewportHeight - (offsetTop + selectHeight - scrollTop);
	        var itemsHeight = this.$items.eq(0).outerHeight() * this.$items.length;
	
	        var height = itemsHeight < viewportBottom - 30 ? viewportBottom : _.max([viewportTop, viewportBottom]);
	        this.$itemWrapper.css('maxHeight', height - 20);
	        this.$dropdown.toggleClass(IS_UP.substring(1), height === viewportTop);
	    };
	
	    return Select;
	}();
	
	module.exports = {
	    constructor: Select
	};

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoggerBase = __webpack_require__(471);
	
	var Logger = function (_LoggerBase) {
	  _inherits(Logger, _LoggerBase);
	
	  function Logger(locator) {
	    _classCallCheck(this, Logger);
	
	    var _this = _possibleConstructorReturn(this, _LoggerBase.call(this));
	
	    _this._transports = [];
	
	    _this._config = locator.resolve('config');
	    _this._config.logger = _this._config.logger || {};
	
	    _this.addEnrichment(function (log) {
	      log.from = 'Browser';
	    });
	
	    _this.addTransport(Logger._consoleTransport);
	
	    _this._setLevels(_this._config.logger.levels);
	
	    _this.debug = _this.debug.bind(_this);
	    _this.trace = _this.trace.bind(_this);
	    _this.info = _this.info.bind(_this);
	    _this.warn = _this.warn.bind(_this);
	    _this.error = _this.error.bind(_this);
	    _this.fatal = _this.fatal.bind(_this);
	    _this.onerror = _this.onerror.bind(_this);
	    return _this;
	  }
	
	  Logger.prototype.addTransport = function addTransport(transport) {
	    if (typeof transport !== 'function') {
	      throw new TypeError('Transport must be a function');
	    }
	
	    this._transports.push(transport);
	  };
	
	  Logger.prototype.removeTransport = function removeTransport(transport) {
	    var index = this._transports.indexOf(transport);
	
	    if (index === -1) {
	      this.info('Transport not found. Remove nothing');
	      return;
	    }
	
	    this._transports.splice(index, 1);
	  };
	
	  Logger.prototype.dropTransports = function dropTransports() {
	    this._transports = [];
	  };
	
	  Logger.prototype.onerror = function onerror(_ref) {
	    var message = _ref.message,
	        filename = _ref.filename,
	        lineno = _ref.lineno,
	        colno = _ref.colno,
	        error = _ref.error;
	
	    this._send('error', message, {
	      stack: error.stack,
	      filename: filename,
	      line: lineno + ':' + colno
	    });
	  };
	
	  Logger.prototype.trace = function trace(message) {
	    var meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    if (!this._levels.trace) {
	      return;
	    }
	
	    this._message('trace', message, meta);
	  };
	
	  Logger.prototype.debug = function debug(message) {
	    var meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    if (!this._levels.debug) {
	      return;
	    }
	
	    this._message('debug', message, meta);
	  };
	
	  Logger.prototype.info = function info(message) {
	    var meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    if (!this._levels.info) {
	      return;
	    }
	
	    this._message('info', message, meta);
	  };
	
	  Logger.prototype.warn = function warn(message) {
	    var meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    if (!this._levels.warn) {
	      return;
	    }
	
	    this._message('warn', message, meta);
	  };
	
	  Logger.prototype.error = function error(message) {
	    var meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    if (!this._levels.error) {
	      return;
	    }
	
	    this._error('error', message, meta);
	  };
	
	  Logger.prototype.fatal = function fatal(message) {
	    var meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    if (!this._levels.fatal) {
	      return;
	    }
	
	    this._error('fatal', message, meta);
	  };
	
	  Logger._consoleTransport = function _consoleTransport(level, log) {
	    var map = {
	      trace: 'log',
	      debug: 'log',
	      info: 'info',
	      warn: 'warn',
	      error: 'error',
	      fatal: 'error'
	    };
	
	    if (console[map[level]]) {
	      console[map[level]]('[' + level.toUpperCase() + ']', log.stack || log.message);
	    }
	  };
	
	  Logger.prototype.log = function log(level, _log) {
	    this._transports.forEach(function (transport) {
	      return transport(level, _log);
	    });
	  };
	
	  return Logger;
	}(LoggerBase);
	
	module.exports = Logger;

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var prettyHrtime = __webpack_require__(1048);
	var Logger = __webpack_require__(469);
	
	module.exports = {
	    register: function register(locator) {
	        locator.register('logger', Logger, true);
	
	        var eventBus = locator.resolve('eventBus');
	        var logger = locator.resolve('logger');
	
	        eventBus.on('error', function (error) {
	            var api = locator.resolve('api');
	            var context = {
	                getAuthHeaders: function getAuthHeaders() {
	                    return new Promise(function (resolve, reject) {
	                        resolve({});
	                    });
	                },
	
	                cookie: {
	                    get: function get() {
	                        return '';
	                    }
	                }
	            };
	
	            api.logOnWebApi(context, locator, {
	                level: 'info',
	                message: error
	            });
	
	            logger.error(error);
	        }).on('serverRequest', function (_ref) {
	            var _ref$requestInfo = _ref.requestInfo,
	                requestInfo = _ref$requestInfo === undefined ? {} : _ref$requestInfo;
	            var method = requestInfo.method,
	                uriPath = requestInfo.uriPath,
	                address = requestInfo.address,
	                port = requestInfo.port;
	
	
	            logger.trace('Request to ' + method + ' "' + uriPath + '" from ' + address + ':' + port);
	        }).on('serverRequestFinish', function (_ref2) {
	            var _ref2$requestInfo = _ref2.requestInfo,
	                requestInfo = _ref2$requestInfo === undefined ? {} : _ref2$requestInfo,
	                _ref2$requestDuration = _ref2.requestDuration,
	                requestDuration = _ref2$requestDuration === undefined ? -1 : _ref2$requestDuration;
	            var method = requestInfo.method,
	                uriPath = requestInfo.uriPath,
	                address = requestInfo.address,
	                port = requestInfo.port;
	
	
	            logger.trace('Response from ' + method + ' "' + uriPath + '" to ' + address + ':' + port + ' (' + prettyHrtime(requestDuration) + ')');
	        });
	    }
	};

/***/ }),
/* 471 */
/***/ (function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LoggerBase = function () {
	  function LoggerBase() {
	    _classCallCheck(this, LoggerBase);
	
	    this._levels = {
	      debug: true,
	      trace: true,
	      info: true,
	      warn: true,
	      error: true,
	      fatal: true
	    };
	
	    this._enrichments = [];
	  }
	
	  LoggerBase.prototype._setLevels = function _setLevels(levels) {
	    var _this = this;
	
	    if ((typeof levels === 'undefined' ? 'undefined' : _typeof(levels)) === 'object') {
	      this._levels = levels;
	    }
	
	    if (typeof levels === 'string') {
	      this._levels = {};
	
	      levels.toLowerCase().split(',').forEach(function (level) {
	        _this._levels[level] = true;
	      });
	    }
	  };
	
	  LoggerBase.prototype._errorFormatter = function _errorFormatter(error) {
	    var fields = {};
	    var message = void 0;
	
	    if (error instanceof Error) {
	      fields.stack = error.stack;
	      message = error.name + ': ' + error.message;
	    } else if ((typeof error === 'undefined' ? 'undefined' : _typeof(error)) === 'object') {
	      message = error.message;
	      delete error.message;
	      fields = error;
	      fields.stack = error.stack || new Error(error).stack;
	    } else if (typeof error === 'string') {
	      fields.stack = new Error(error).stack;
	      message = error;
	    }
	
	    return { message: message, fields: fields };
	  };
	
	  LoggerBase.prototype.addEnrichment = function addEnrichment(enrichment) {
	    if (typeof enrichment !== 'function') {
	      throw new TypeError('Enrichment must be a function');
	    }
	
	    this._enrichments.push(enrichment);
	  };
	
	  LoggerBase.prototype.removeEnrichment = function removeEnrichment(enrichment) {
	    var index = this._enrichments.indexOf(enrichment);
	
	    if (index === -1) {
	      this.log('info', 'Enrichment not found. Remove nothing');
	      return;
	    }
	
	    this._enrichments.splice(index, 1);
	  };
	
	  LoggerBase.prototype.dropEnrichments = function dropEnrichments() {
	    this._enrichments = [];
	  };
	
	  LoggerBase.prototype._enrichLog = function _enrichLog(log, level) {
	    this._enrichments.forEach(function (enrich) {
	      return enrich(log, level);
	    });
	  };
	
	  LoggerBase.prototype._error = function _error(level, error) {
	    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    var _errorFormatter2 = this._errorFormatter(error),
	        message = _errorFormatter2.message,
	        fields = _errorFormatter2.fields;
	
	    var meta = Object.assign({}, fields, data);
	
	    this._send(level, message, meta);
	  };
	
	  LoggerBase.prototype._message = function _message(level, message) {
	    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    this._send(level, message, data);
	  };
	
	  LoggerBase.prototype._send = function _send(level, message) {
	    var meta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    var log = Object.assign({}, { message: message }, meta);
	
	    this._enrichLog(log, level);
	
	    this.log(level, log);
	  };
	
	  LoggerBase.prototype.log = function log() {
	    throw new ReferenceError('Logger must realize log(level: string, log: Object) method');
	  };
	
	  return LoggerBase;
	}();
	
	module.exports = LoggerBase;

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var account = [{
	    expression: '/account/orders?type=:type&showLocal=:showLocal',
	    args: {
	        signal: __webpack_require__(232),
	        page: 'account',
	        subPage: 'orders'
	    }
	}, {
	    expression: '/account/orders/:orderId?type=:type',
	    args: {
	        signal: __webpack_require__(232),
	        page: 'account',
	        subPage: 'orders'
	    }
	}, {
	    expression: '/account/personal',
	    args: {
	        signal: __webpack_require__(525),
	        page: 'personal'
	    }
	}];
	
	var manager = [{
	    expression: '/manager/orders?status=:status&assigned=:assigned&text=:text&type=:type',
	    args: {
	        signal: __webpack_require__(234),
	        page: 'manager',
	        subPage: 'orders'
	    }
	}, {
	    expression: '/manager/orders/:orderId?status=:status&assigned=:assigned&text=:text&type=:type',
	    args: {
	        signal: __webpack_require__(234),
	        page: 'manager',
	        subPage: 'orders'
	    }
	}, {
	    expression: '/manager/users',
	    args: {
	        signal: __webpack_require__(235),
	        page: 'manager',
	        subPage: 'users'
	    }
	}, {
	    expression: '/manager/users/:userId',
	    args: {
	        signal: __webpack_require__(235),
	        page: 'manager',
	        subPage: 'users'
	    }
	}, {
	    expression: '/manager/orders/:orderId/statistic?isByBranch=:isByBranch&isTransposed=:isTransposed',
	    args: {
	        signal: __webpack_require__(511),
	        page: 'statistic'
	    }
	}];
	
	var auth = [{
	    expression: '/login',
	    args: {
	        signal: __webpack_require__(513),
	        page: 'login'
	    }
	}, {
	    expression: '/registration',
	    args: {
	        signal: __webpack_require__(515),
	        page: 'registration'
	    }
	}, {
	    expression: '/registration/extra',
	    args: {
	        signal: __webpack_require__(514),
	        page: 'registrationExtra'
	    }
	}, {
	    expression: '/restorePassword',
	    args: {
	        signal: __webpack_require__(517),
	        page: 'restore'
	    }
	}, {
	    expression: '/restorePassword/:restoreToken',
	    args: {
	        signal: __webpack_require__(516),
	        page: 'restoreChange'
	    }
	}, {
	    expression: '/auth/confirmed',
	    args: {
	        signal: __webpack_require__(512),
	        page: 'confirmed'
	    }
	}, {
	    expression: '/auth/invalidToken',
	    args: {
	        signal: __webpack_require__(233),
	        page: 'passportError'
	    }
	}, {
	    expression: '/auth/serviceUnavailable',
	    args: {
	        signal: __webpack_require__(233),
	        page: 'passportError'
	    }
	}];
	
	var payments = [{
	    expression: '/payment/:redirectType?orderNumber=:orderId',
	    args: {
	        signal: __webpack_require__(524),
	        page: 'payment'
	    }
	}];
	
	var notFound = [{
	    expression: /^.*$/,
	    args: {
	        signal: __webpack_require__(520).notFound,
	        page: '404'
	    }
	}];
	
	var routes = [{
	    expression: '/',
	    args: {
	        signal: __webpack_require__(523),
	        page: 'order'
	    }
	}, {
	    expression: '/bitrix?DOMAIN=:bitrixDomain',
	    args: {
	        signal: __webpack_require__(518),
	        page: 'bitrixMain'
	    }
	}, {
	    expression: '/contacts',
	    args: {
	        signal: __webpack_require__(519),
	        page: 'contacts'
	    }
	}, {
	    expression: '/help',
	    args: {
	        signal: __webpack_require__(522),
	        page: 'help'
	    }
	}, {
	    expression: '/terms',
	    args: {
	        signal: __webpack_require__(526),
	        page: 'terms'
	    }
	}, {
	    expression: '/video',
	    args: {
	        signal: __webpack_require__(527),
	        page: 'video'
	    }
	}, {
	    expression: '/health',
	    args: {
	        signal: __webpack_require__(521),
	        page: 'health'
	    }
	}].concat(account, manager, auth, payments, notFound);
	
	module.exports = {
	    register: function register(cat) {
	        routes.reverse().forEach(function (route) {
	            return cat.registerRoute(route);
	        });
	    }
	};

/***/ }),
/* 473 */
/***/ (function(module, exports) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Analytics = function () {
	    function Analytics(locator) {
	        _classCallCheck(this, Analytics);
	
	        this._window = locator.resolve('window');
	        this._locator = locator;
	    }
	
	    Analytics.prototype.event = function event() {
	        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        var role = data.role;
	
	        if (!role || role === 'client' || role === 'unauthorized') {
	            for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	                args[_key - 1] = arguments[_key];
	            }
	
	            this._locator.resolve('ga').event(data, args);
	            this._locator.resolve('ya').event(data, args);
	        }
	    };
	
	    Analytics.prototype.pageview = function pageview() {
	        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        var location = data.location || this._window.location.href;
	        var page = data.page || this._window.location.pathname;
	        var title = data.title || this._window.document.title;
	        var role = data.role;
	
	        if (!role || role === 'client' || role === 'unauthorized') {
	            this._locator.resolve('ga').pageview({ location: location, page: page, title: title });
	            this._locator.resolve('ya').pageview(page, { title: title });
	        }
	    };
	
	    return Analytics;
	}();
	
	module.exports = Analytics;

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var GoogleTracker = __webpack_require__(475);
	var YandexTracker = __webpack_require__(476);
	var Analytics = __webpack_require__(473);
	
	module.exports = {
	    register: function register(locator) {
	        locator.register('ga', GoogleTracker, true);
	        locator.register('ya', YandexTracker, true);
	        locator.register('analytics', Analytics, true);
	    }
	};

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BaseTracker = __webpack_require__(223);
	
	var GoogleTracker = function (_BaseTracker) {
	    _inherits(GoogleTracker, _BaseTracker);
	
	    function GoogleTracker(locator) {
	        _classCallCheck(this, GoogleTracker);
	
	        var _this = _possibleConstructorReturn(this, _BaseTracker.call(this));
	
	        _this._window = locator.resolve('window');
	        _this._config = locator.resolve('config');
	        _this._logger = locator.resolve('logger');
	
	        _this._init();
	        return _this;
	    }
	
	    GoogleTracker.prototype._init = function _init() {
	        this._registerTracker();
	
	        var key = this._domainConfig(this._config.analytics.google.keys);
	
	        var beacon = this._config.analytics.google.beacon;
	        var ga = this._window[beacon];
	
	        ga('create', key, 'auto');
	        ga('require', 'displayfeatures');
	        ga('set', 'checkProtocolTask', null);
	        ga('send', 'pageview');
	
	        this._initPromise = new Promise(function (res) {
	            ga(res);
	        });
	    };
	
	    GoogleTracker.prototype._event = function _event() {
	        var _window;
	
	        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	        var args = arguments[1];
	
	        var beacon = this._config.analytics.google.beacon;
	
	        (_window = this._window)[beacon].apply(_window, ['send', 'event'].concat(args));
	    };
	
	    GoogleTracker.prototype._pageview = function _pageview() {
	        var _window2;
	
	        var beacon = this._config.analytics.google.beacon;
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        (_window2 = this._window)[beacon].apply(_window2, ['send', 'pageview'].concat(args));
	    };
	
	    GoogleTracker.prototype._registerTracker = function _registerTracker() {
	        var window = this._window;
	        var document = this._window.document;
	
	        var url = this._config.analytics.google.url;
	        var beacon = this._config.analytics.google.beacon;
	
	        function googleTracker() {
	            window[beacon].q = window[beacon].q || [];
	            window[beacon].q.push(arguments);
	        }
	
	        window['GoogleAnalyticsObject'] = beacon;
	        window[beacon] = window[beacon] || googleTracker;
	
	        window[beacon].l = 1 * new Date();
	
	        var script = document.createElement('script');
	        script.async = 1;
	        script.src = url;
	
	        var firstScriptNode = document.getElementsByTagName('script')[0];
	        firstScriptNode.parentNode.insertBefore(script, firstScriptNode);
	    };
	
	    return GoogleTracker;
	}(BaseTracker);
	
	module.exports = GoogleTracker;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BaseTracker = __webpack_require__(223);
	
	var YandexTracker = function (_BaseTracker) {
	    _inherits(YandexTracker, _BaseTracker);
	
	    function YandexTracker(locator) {
	        _classCallCheck(this, YandexTracker);
	
	        var _this = _possibleConstructorReturn(this, _BaseTracker.call(this));
	
	        _this._window = locator.resolve('window');
	        _this._config = locator.resolve('config');
	        _this._logger = locator.resolve('logger');
	
	        _this._counterKey = null;
	
	        _this._initPromise = new Promise(function (res) {
	            _this._registerTracker(res);
	        });
	        return _this;
	    }
	
	    YandexTracker.prototype._event = function _event() {
	        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	        var args = arguments[1];
	
	        var target = args[0];
	        this._window[this._counterKey].reachGoal(target);
	    };
	
	    YandexTracker.prototype._pageview = function _pageview() {
	        var _window$_counterKey;
	
	        (_window$_counterKey = this._window[this._counterKey]).hit.apply(_window$_counterKey, arguments);
	    };
	
	    YandexTracker.prototype._registerTracker = function _registerTracker(cb) {
	        var _this2 = this;
	
	        var window = this._window;
	        var document = this._window.document;
	
	        var beacon = this._config.analytics.yandex.beacon;
	
	        var initYATracker = function initYATracker() {
	            try {
	                var key = _this2._domainConfig(_this2._config.analytics.yandex.keys);
	
	                _this2._counterKey = 'yaCounter' + key;
	
	                window[_this2._counterKey] = new _this2._window.Ya.Metrika({
	                    id: key,
	                    clickmap: true,
	                    trackLinks: true,
	                    accurateTrackBounce: true,
	                    webvisor: true
	                });
	            } catch (e) {
	                _this2._logger.error(new Error('Yandex Analytics init failed'));
	            }
	        };
	
	        window[beacon] = window[beacon] || [];
	        window[beacon].push(initYATracker);
	        window[beacon].push(cb);
	
	        var firstScriptNode = document.getElementsByTagName('script')[0];
	        var script = document.createElement('script');
	
	        function bindScriptNode() {
	            var beforeNode = firstScriptNode;
	            if (firstScriptNode.src.includes('google')) {
	                beforeNode = firstScriptNode.nextSibling;
	            }
	            firstScriptNode.parentNode.insertBefore(script, beforeNode);
	        }
	
	        script.type = 'text/javascript';
	        script.async = true;
	        script.src = this._config.analytics.yandex.url;
	
	        if (window.opera == '[object Opera]') {
	            document.addEventListener('DOMContentLoaded', bindScriptNode, false);
	        } else {
	            bindScriptNode();
	        }
	    };
	
	    return YandexTracker;
	}(BaseTracker);
	
	module.exports = YandexTracker;

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _ = __webpack_require__(3);
	var $ = __webpack_require__(12);
	var qs = __webpack_require__(1050);
	var cookie = __webpack_require__(27);
	var errorConverter = __webpack_require__(215);
	var DEFAULT_TIMEOUT = 60000;
	var BITRIX_TOKEN = 'bitrix_access_token';
	var BITRIX_DOMAIN = 'bitrix_domain';
	var BITRIX_MEMBER_ID = 'bitrix_member_id';
	
	function setBitrixCookie(auth, context) {
	    var expires = new Date(Date.now() + 45 * 60 * 1000);
	
	    context.cookie.set({
	        key: BITRIX_TOKEN,
	        value: _.get(auth, 'access_token'),
	        path: '/',
	        expires: expires
	    });
	
	    context.cookie.set({
	        key: BITRIX_DOMAIN,
	        value: _.get(auth, 'domain'),
	        path: '/',
	        expires: expires
	    });
	
	    context.cookie.set({
	        key: BITRIX_MEMBER_ID,
	        value: _.get(auth, 'member_id'),
	        path: '/',
	        expires: expires
	    });
	}
	
	var API = function () {
	    function API(locator) {
	        _classCallCheck(this, API);
	
	        this._uhr = locator.resolve('uhr');
	        this._config = locator.resolve('config');
	        this._logger = locator.resolve('logger');
	    }
	
	    API.prototype.getAuthHeaders = function getAuthHeaders(context, locator, options, api) {
	        if (options.noAuthorizationToken === true) {
	            return new Promise(function (resolve, reject) {
	                resolve({});
	            });
	        }
	
	        var classContext = this;
	
	        if (locator) {
	            var bitrix = void 0;
	            try {
	                bitrix = locator.resolve('bitrix');
	            } catch (ex) {}
	
	            if (bitrix && bitrix._bx) {
	                var bitrixToken = context.cookie.get(BITRIX_TOKEN);
	                if (bitrixToken) {
	                    return new Promise(function (resolve, reject) {
	                        var auth = {
	                            Authorization: 'Bearer ' + bitrixToken,
	                            AuthorizationProvider: 'Bitrix',
	                            BitrixDomain: context.cookie.get(BITRIX_DOMAIN),
	                            BitrixMemberId: context.cookie.get(BITRIX_MEMBER_ID)
	                        };
	                        resolve(auth);
	                    });
	                } else {
	                    if (this.refreshAuthPromise) {
	                        return this.refreshAuthPromise;
	                    }
	                    this.refreshAuthPromise = new Promise(function (resolve, reject) {
	                        function greet(newAuth) {
	                            setBitrixCookie(newAuth, context);
	                            bitrixToken = _.get(newAuth, 'access_token');
	                            var domain = _.get(newAuth, 'domain');
	                            var memberId = _.get(newAuth, 'member_id');
	
	                            if (!domain || domain.length <= 0) {
	                                this.logOnWebApi(context, locator, {
	                                    level: 'error',
	                                    message: 'bitrix.refreshAuth returned empty domain newAuth=' + JSON.stringify(newAuth)
	                                });
	                            }
	                            var auth = {
	                                Authorization: 'Bearer ' + bitrixToken,
	                                AuthorizationProvider: 'Bitrix',
	                                BitrixDomain: domain,
	                                BitrixMemberId: memberId
	                            };
	                            this.refreshAuthPromise = null;
	                            resolve(auth);
	                        }
	                        bitrix.refreshAuth(_.bind(greet, classContext));
	                    });
	                    return this.refreshAuthPromise;
	                }
	            }
	        }
	
	        var token = options.token || context.cookie.get('access_token');
	        return new Promise(function (resolve, reject) {
	            if (token) {
	                resolve({
	                    Authorization: 'Bearer ' + token,
	                    AuthorizationProvider: 'TwoGis'
	                });
	            } else {
	                var refreshToken = context.cookie.get('refresh_token');
	                if (!refreshToken) {
	                    resolve({});
	                    return;
	                }
	                var methodParams = {
	                    grant_type: 'refresh',
	                    client_id: 'hermes',
	                    refresh_token: refreshToken
	                };
	
	                var request = api.refreshToken(context, { methodParams: methodParams });
	                request.then(function (data) {
	                    var code = _.get(data, 'status.code');
	                    var authResponse = _.get(data, 'content');
	                    if (code !== 200) {
	                        reject(code);
	                        return;
	                    }
	
	                    cookie.setSessionToken({ auth: authResponse }, null, null, { context: context });
	                    resolve({
	                        Authorization: 'Bearer ' + authResponse.access_token,
	                        AuthorizationProvider: 'TwoGis'
	                    });
	                });
	            }
	        });
	    };
	
	    API.prototype.authUser = function authUser(context, _ref) {
	        var loginData = _ref.loginData;
	
	        var options = {
	            headers: {
	                'Content-Type': 'application/x-www-form-urlencoded'
	            },
	            noAuthorizationToken: true
	        };
	
	        return this._auth('POST', 'oauth/token', loginData, context, options);
	    };
	
	    API.prototype.refreshToken = function refreshToken(context, _ref2) {
	        var methodParams = _ref2.methodParams;
	
	        var options = {
	            headers: {
	                'Content-Type': 'application/x-www-form-urlencoded'
	
	            },
	            noAuthorizationToken: true
	        };
	
	        return this._auth('POST', 'oauth/token', methodParams, context, options);
	    };
	
	    API.prototype.registerAuthUser = function registerAuthUser(context, _ref3) {
	        var registerData = _ref3.registerData,
	            queryData = _ref3.queryData;
	
	        var query = qs.stringify(queryData);
	
	        var options = {
	            headers: {
	                'Content-Type': 'application/x-www-form-urlencoded'
	            }
	        };
	
	        return this._auth('POST', 'users?' + query, registerData, context, options);
	    };
	
	    API.prototype.sendConfirmationMail = function sendConfirmationMail(context, _ref4) {
	        var queryData = _ref4.queryData;
	
	        var query = qs.stringify(queryData);
	
	        var options = {
	            headers: {
	                'Content-Type': 'application/x-www-form-urlencoded'
	            }
	        };
	
	        return this._auth('POST', 'users/me/confirmation?' + query, { grant_type: 'email' }, context, options);
	    };
	
	    API.prototype.registerHermesUser = function registerHermesUser(context, locator, _ref5) {
	        var registerData = _ref5.registerData,
	            token = _ref5.token;
	
	        var options = {
	            token: token
	        };
	
	        return this._export('POST', 'api/user/register', registerData, context, locator, options);
	    };
	
	    API.prototype.registerStubHermesUser = function registerStubHermesUser(context, locator, _ref6) {
	        var registerData = _ref6.registerData;
	
	        return this._export('POST', 'api/user/register/stub', registerData, context, locator);
	    };
	
	    API.prototype.restorePassword = function restorePassword(context, _ref7) {
	        var restoreData = _ref7.restoreData,
	            queryData = _ref7.queryData;
	
	        var query = qs.stringify(queryData);
	
	        var options = {
	            headers: {
	                'Content-Type': 'application/x-www-form-urlencoded'
	            }
	        };
	
	        return this._auth('POST', 'users/recovery?' + query, restoreData, context, options);
	    };
	
	    API.prototype.passwordChange = function passwordChange(context, _ref8) {
	        var password = _ref8.password,
	            restoreToken = _ref8.restoreToken;
	
	        var options = {
	            headers: {
	                'Content-Type': 'application/x-www-form-urlencoded'
	            }
	        };
	
	        return this._auth('POST', 'l/' + restoreToken + '/password_change', { password: password }, context, options);
	    };
	
	    API.prototype.passwordChangeActual = function passwordChangeActual(context, _ref9) {
	        var password = _ref9.password,
	            passwordNew = _ref9.passwordNew;
	
	        var accessToken = context.cookie.get('access_token');
	        var formData = {
	            password: password,
	            password_new: passwordNew,
	            flush_sessions: 0
	        };
	        var options = {
	            headers: {
	                'Content-Type': 'application/x-www-form-urlencoded'
	            },
	            noAuthorizationToken: true
	        };
	
	        return this._auth('PUT', 'users/me/password?access_token=' + accessToken, formData, context, options);
	    };
	
	    API.prototype.logOnWebApi = function logOnWebApi(context, locator, _ref10) {
	        var level = _ref10.level,
	            message = _ref10.message;
	
	        var options = {
	            disableLogging: true,
	            noAuthorizationToken: true
	        };
	        return this._export('POST', 'api/logger?level=' + level, JSON.stringify(errorConverter.convert(message)), context, locator, options);
	    };
	
	    API.prototype.getCurrentUser = function getCurrentUser(context, locator, _ref11) {
	        var dropCache = _ref11.dropCache,
	            token = _ref11.token;
	
	        var options = {
	            dropCache: dropCache,
	            token: token
	        };
	
	        return this._export('GET', 'api/user', {}, context, locator, options);
	    };
	
	    API.prototype.getBitrixUser = function getBitrixUser(context, locator) {
	        return this._export('GET', 'api/user/bitrix', {}, context, locator);
	    };
	
	    API.prototype.getUserById = function getUserById(context, locator, _ref12) {
	        var userId = _ref12.userId;
	
	        return this._export('GET', 'api/users/' + userId, {}, context, locator);
	    };
	
	    API.prototype.updateUserInfo = function updateUserInfo(context, locator, _ref13) {
	        var userId = _ref13.userId,
	            data = _ref13.data;
	
	        return this._export('PUT', 'api/users/' + userId, data, context, locator);
	    };
	
	    API.prototype.getOrderPrice = function getOrderPrice(context, locator, parameters, orderTypeId) {
	        var options = {
	            timeout: 60000
	        };
	        return this._export('POST', 'api/data/calculatePrice/' + orderTypeId, parameters, context, locator, options);
	    };
	
	    API.prototype.getAvailableParameters = function getAvailableParameters(context, locator) {
	        var options = {
	            timeout: 60000
	        };
	        return this._export('GET', 'api/data/availableParameters', {}, context, locator, options);
	    };
	
	    API.prototype.uploadTreeInputRubrics = function uploadTreeInputRubrics(context, locator, treeInput) {
	        return this._export('POST', 'api/data/selectRubrics', JSON.stringify(treeInput), context, locator);
	    };
	
	    API.prototype.uploadTreeInputCities = function uploadTreeInputCities(context, locator, treeInput, orderTypeId) {
	        return this._export('POST', 'api/data/selectCities?orderTypeId=' + orderTypeId, JSON.stringify(treeInput), context, locator);
	    };
	
	    API.prototype.getPrices = function getPrices(context, locator) {
	        return this._export('GET', 'api/data/prices', {}, context, locator);
	    };
	
	    API.prototype.getColumns = function getColumns(context, locator) {
	        return this._export('GET', 'api/data/columns', {}, context, locator);
	    };
	
	    API.prototype.getDocumentTypes = function getDocumentTypes(context, locator) {
	        return this._export('GET', 'api/data/documentTypes', {}, context, locator);
	    };
	
	    API.prototype.getStatisticChunk = function getStatisticChunk(context, locator, _ref14) {
	        var orderId = _ref14.orderId,
	            xStartIndex = _ref14.xStartIndex,
	            yStartIndex = _ref14.yStartIndex,
	            xAmount = _ref14.xAmount,
	            yAmount = _ref14.yAmount,
	            xExtended = _ref14.xExtended,
	            yExtended = _ref14.yExtended,
	            isTransposed = _ref14.isTransposed,
	            isByBranch = _ref14.isByBranch;
	
	        return this._export('POST', 'api/order/statistic/' + orderId, {
	            xStartIndex: xStartIndex,
	            yStartIndex: yStartIndex,
	            xAmount: xAmount,
	            yAmount: yAmount,
	            xExtended: xExtended,
	            yExtended: yExtended,
	            isTransposed: isTransposed,
	            isByBranch: isByBranch
	        }, context, locator);
	    };
	
	    API.prototype.getExportResults = function getExportResults(context, locator, orderId) {
	        return this._export('GET', 'api/order/' + orderId + '/exportResults', {}, context, locator);
	    };
	
	    API.prototype.getOrderState = function getOrderState(context, locator, orderId) {
	        return this._export('GET', 'api/order/' + orderId + '/state', {}, context, locator);
	    };
	
	    API.prototype.getHasBitrixLeads = function getHasBitrixLeads(context, locator, orderId) {
	        return this._export('GET', 'api/order/' + orderId + '/hasBitrixLeads', {}, context, locator);
	    };
	
	    API.prototype.isBackendInStandardState = function isBackendInStandardState(context, locator) {
	        return this._export('GET', 'api/state/isExportAllowed', {}, context, locator);
	    };
	
	    API.prototype.getUserOrder = function getUserOrder(context, locator, _ref15) {
	        var orderId = _ref15.orderId;
	
	        var orderIdString = '';
	        if (orderId) {
	            orderIdString = orderId;
	        }
	
	        return this._export('GET', 'api/order/' + orderIdString, {}, context, locator);
	    };
	
	    API.prototype.getUserDraftOrder = function getUserDraftOrder(context, locator) {
	        return this._export('GET', 'api/order/draft', {}, context, locator);
	    };
	
	    API.prototype.getOrders = function getOrders(context, locator, _ref16) {
	        var queryData = _ref16.queryData;
	
	        var query = qs.stringify(queryData);
	
	        return this._export('GET', 'api/orders?' + query, {}, context, locator);
	    };
	
	    API.prototype.getUsers = function getUsers(context, locator) {
	        return this._export('GET', 'api/users', {}, context, locator);
	    };
	
	    API.prototype.getManagers = function getManagers(context, locator) {
	        return this._export('GET', 'api/managers', {}, context, locator);
	    };
	
	    API.prototype.setPaymentType = function setPaymentType(context, locator, _ref17) {
	        var paymentId = _ref17.paymentId,
	            orderId = _ref17.orderId;
	
	        return this._export('PUT', 'api/order/' + orderId + '/paymentType/' + paymentId, {}, context, locator);
	    };
	
	    API.prototype.updateOrderAmount = function updateOrderAmount(context, locator, _ref18) {
	        var orderId = _ref18.orderId,
	            amount = _ref18.amount;
	
	        return this._export('PUT', 'api/order/' + orderId + '/amount', amount, context, locator);
	    };
	
	    API.prototype.setName = function setName(context, locator, _ref19) {
	        var name = _ref19.name,
	            orderId = _ref19.orderId;
	
	        return this._export('PUT', 'api/order/' + orderId + '/name', JSON.stringify(name), context, locator);
	    };
	
	    API.prototype.setUser = function setUser(context, locator, _ref20) {
	        var userId = _ref20.userId,
	            orderId = _ref20.orderId;
	
	        return this._export('PUT', 'api/order/' + orderId + '/user/' + userId, {}, context, locator);
	    };
	
	    API.prototype.setManager = function setManager(context, locator, _ref21) {
	        var managerId = _ref21.managerId,
	            orderId = _ref21.orderId;
	
	        return this._export('PUT', 'api/order/' + orderId + '/manager/' + managerId, {}, context, locator);
	    };
	
	    API.prototype.moveOrderToNextState = function moveOrderToNextState(context, locator, _ref22) {
	        var orderId = _ref22.orderId,
	            apiArgs = _ref22.apiArgs;
	
	        return this._export('POST', 'api/manageOrders/' + orderId + '/moveOrderToNextState', apiArgs, context, locator);
	    };
	
	    API.prototype.acceptLicenseAgreement = function acceptLicenseAgreement(context, locator, _ref23) {
	        var orderId = _ref23.orderId;
	
	        return this._export('POST', 'api/manageOrders/' + orderId + '/acceptLicenseAgreement', {}, context, locator);
	    };
	
	    API.prototype.confirmDataChanged = function confirmDataChanged(context, locator, _ref24) {
	        var orderId = _ref24.orderId;
	
	        return this._export('POST', 'api/manageOrders/' + orderId + '/confirmDataChanged', {}, context, locator);
	    };
	
	    API.prototype.archiveOrder = function archiveOrder(context, locator, _ref25) {
	        var orderId = _ref25.orderId;
	
	        return this._export('POST', 'api/manageOrders/' + orderId + '/archive', {}, context, locator);
	    };
	
	    API.prototype.uploadFile = function uploadFile(context, locator, _ref26) {
	        var orderId = _ref26.orderId,
	            documentTypeId = _ref26.documentTypeId,
	            formData = _ref26.formData;
	
	        var token = context.cookie.get('access_token');
	
	        return $.ajax({
	            url: this.getExportApiUrl(context) + 'api/attachment/upload/' + orderId + '/' + documentTypeId,
	            type: 'POST',
	            headers: { Authorization: 'Bearer ' + token },
	            data: formData,
	            async: true,
	            cache: false,
	            contentType: false,
	            processData: false
	        });
	    };
	
	    API.prototype.uploadResultFile = function uploadResultFile(context, locator, _ref27) {
	        var orderId = _ref27.orderId,
	            formData = _ref27.formData;
	
	        var token = context.cookie.get('access_token');
	
	        return $.ajax({
	            url: this.getExportApiUrl(context) + 'api/attachment/upload/' + orderId + '/result',
	            type: 'POST',
	            headers: { Authorization: 'Bearer ' + token },
	            data: formData,
	            async: true,
	            cache: false,
	            contentType: false,
	            processData: false
	        });
	    };
	
	    API.prototype.getExportApiUrl = function getExportApiUrl(context) {
	        var endpoint = this._config.exportAPI;
	        var base = endpoint.endsWith('/') ? endpoint : endpoint + '/';
	        return this.getUrl(context, base);
	    };
	
	    API.prototype.downloadRubricsFile = function downloadRubricsFile(context, locator) {
	        var url = this.getExportApiUrl(context) + 'api/data/downloadRubrics';
	        return this.downloadFileByUrl(context, locator, url);
	    };
	
	    API.prototype.downloadCitiesFile = function downloadCitiesFile(context, locator, orderTypeId) {
	        var url = this.getExportApiUrl(context) + 'api/data/downloadCities/' + orderTypeId;
	        return this.downloadFileByUrl(context, locator, url);
	    };
	
	    API.prototype.downloadFile = function downloadFile(context, locator, _ref28, onProgressHandler) {
	        var fileId = _ref28.fileId,
	            fileName = _ref28.fileName;
	
	        var url = this.getExportApiUrl(context) + 'api/attachment/download/' + fileId;
	        var authPromise = this.getAuthHeaders(context, locator, {}, this);
	        return authPromise.then(function (authHeaders) {
	            return new Promise(function (resolve, reject) {
	                var request = new XMLHttpRequest();
	                request.open('GET', url, true);
	                _.each(Object.keys(authHeaders), function (key) {
	                    request.setRequestHeader(key, authHeaders[key]);
	                });
	                request.responseType = 'arraybuffer';
	                request.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
	                request.onload = function () {
	                    var type = request.getResponseHeader('Content-Type');
	                    resolve({ code: this.status, content: request.response, contentType: type });
	                };
	                if (onProgressHandler) {
	                    request.onprogress = onProgressHandler;
	                }
	                request.onerror = function () {
	                    reject({
	                        status: this.status,
	                        statusText: request.statusText
	                    });
	                };
	                request.send();
	            });
	        });
	    };
	
	    API.prototype.downloadFileByUrl = function downloadFileByUrl(context, locator, url) {
	        var authPromise = this.getAuthHeaders(context, locator, {}, this);
	        return authPromise.then(function (authHeaders) {
	            return new Promise(function (resolve, reject) {
	                var request = new XMLHttpRequest();
	                request.open('GET', url, true);
	                _.each(Object.keys(authHeaders), function (key) {
	                    request.setRequestHeader(key, authHeaders[key]);
	                });
	                request.responseType = 'arraybuffer';
	                request.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
	                request.onload = function () {
	                    var type = request.getResponseHeader('Content-Type');
	                    var contentDisposition = request.getResponseHeader('Content-Disposition');
	                    resolve({
	                        code: this.status,
	                        content: request.response,
	                        contentType: type,
	                        contentDisposition: contentDisposition
	                    });
	                };
	                request.onerror = function () {
	                    reject({
	                        status: this.status,
	                        statusText: request.statusText
	                    });
	                };
	                request.send();
	            });
	        });
	    };
	
	    API.prototype.downloadDraftFile = function downloadDraftFile(context, locator, _ref29) {
	        var orderId = _ref29.orderId,
	            typeId = _ref29.typeId;
	
	        var url = this.getExportApiUrl(context) + 'api/order/' + orderId + '/documents/drafts/' + typeId;
	        return this.downloadFileByUrl(context, locator, url);
	    };
	
	    API.prototype.downloadStatisticFile = function downloadStatisticFile(context, locator, _ref30) {
	        var orderId = _ref30.orderId,
	            isTransposed = _ref30.isTransposed,
	            isByBranch = _ref30.isByBranch;
	
	        var url = this.getExportApiUrl(context) + 'api/order/statistic/' + orderId + '/excel?isTransposed=' + isTransposed + '&isByBranch=' + isByBranch;
	        return this.downloadFileByUrl(context, locator, url);
	    };
	
	    API.prototype.addDocumentType = function addDocumentType(context, locator, _ref31) {
	        var orderId = _ref31.orderId,
	            documentTypeId = _ref31.documentTypeId;
	
	        return this._export('PATCH', 'api/order/' + orderId + '/addDocumentType/' + documentTypeId, {}, context, locator);
	    };
	
	    API.prototype.removeDocumentType = function removeDocumentType(context, locator, _ref32) {
	        var orderId = _ref32.orderId,
	            documentTypeId = _ref32.documentTypeId;
	
	        return this._export('PATCH', 'api/order/' + orderId + '/removeDocumentType/' + documentTypeId, {}, context, locator);
	    };
	
	    API.prototype.deleteDocument = function deleteDocument(context, locator, _ref33) {
	        var documentId = _ref33.documentId;
	
	        return this._export('DELETE', 'api/attachment/delete/' + documentId, {}, context, locator);
	    };
	
	    API.prototype.postOrderParameters = function postOrderParameters(context, locator, _ref34) {
	        var selectedParameters = _ref34.selectedParameters;
	
	        return this._export('POST', 'api/order', selectedParameters, context, locator);
	    };
	
	    API.prototype.updateOrderParameters = function updateOrderParameters(context, locator, _ref35) {
	        var orderId = _ref35.orderId,
	            selectedParameters = _ref35.selectedParameters;
	
	        return this._export('PUT', 'api/order/' + orderId, selectedParameters, context, locator);
	    };
	
	    API.prototype.getOnlinePaymentForm = function getOnlinePaymentForm(context, locator, _ref36) {
	        var orderId = _ref36.orderId;
	
	        return this._export('GET', 'api/payment/' + orderId + '/form', {}, context, locator);
	    };
	
	    API.prototype.isEmailAssociated = function isEmailAssociated(context, locator, email) {
	        return this._export('GET', 'api/user/isEmailAssociated?email=' + email, {}, context, locator);
	    };
	
	    API.prototype.getCountries = function getCountries(context, locator) {
	        return this._export('GET', 'api/user/getCountries', {}, context, locator);
	    };
	
	    API.prototype.repeatOrder = function repeatOrder(context, locator, _ref37) {
	        var orderId = _ref37.orderId;
	
	        var options = {
	            timeout: 1200000
	        };
	
	        return this._export('POST', 'api/order/repeat/' + orderId, {}, context, locator, options);
	    };
	
	    API.prototype.exportLeads = function exportLeads(context, locator, _ref38) {
	        var orderId = _ref38.orderId,
	            leadMapping = _ref38.leadMapping,
	            isExportFree = _ref38.isExportFree,
	            isIncludeExportedFreeLeads = _ref38.isIncludeExportedFreeLeads;
	
	        var body = {};
	        if (leadMapping) {
	            body = leadMapping;
	        }
	        var isExportFreeArg = isExportFree !== undefined ? isExportFree : false;
	        var isIncludeExportedArg = isIncludeExportedFreeLeads !== undefined ? isIncludeExportedFreeLeads : false;
	        return this._export('POST', 'api/bitrix/exportLeads/' + orderId + '?isExportFree=' + isExportFreeArg + ('&isIncludeExportedFreeLeads=' + isIncludeExportedArg), body, context, locator);
	    };
	
	    API.prototype.getLeadFields = function getLeadFields(context, locator, _ref39) {
	        var orderId = _ref39.orderId;
	
	        return this._export('GET', 'api/bitrix/leadFields/' + orderId, {}, context, locator);
	    };
	
	    API.prototype.getExportJobProgress = function getExportJobProgress(context, locator, _ref40) {
	        var exportJobId = _ref40.exportJobId;
	
	        return this._export('GET', 'api/bitrix/jobProgress/' + exportJobId, {}, context, locator);
	    };
	
	    API.prototype._request = function _request(endpoint) {
	        var _this = this;
	
	        var base = endpoint.endsWith('/') ? endpoint : endpoint + '/';
	        var config = this._config;
	
	        return function (method, slug, data, context, locator) {
	            var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
	
	            var url = _this.getUrl(context, base, slug);
	            var authPromise = _this.getAuthHeaders(context, locator, options, _this);
	
	            var params = void 0;
	            var promisesChain = authPromise.then(function (auth) {
	                var headers = Object.assign({ 'Content-Type': 'application/json' }, auth);
	
	                var defaults = {
	                    url: url,
	                    method: method,
	                    data: _.isObject(data) ? _.omitBy(data, _.isUndefined) : data,
	                    headers: headers
	                };
	
	                var paramsData = {
	                    headers: _.omitBy(options.headers, _.isUndefined),
	                    timeout: _.get(options, 'timeout', DEFAULT_TIMEOUT),
	                    withCredentials: options.withCredentials
	                };
	
	                params = _.chain(paramsData).defaultsDeep(defaults).omitBy(_.isUndefined).value();
	            }).then(function () {
	                return _this._uhr.request(params);
	            }).then(function (response) {
	                params.data = _.omit(params.data, 'password');
	                return response;
	            });
	
	            if (options.disableLogging !== true) {
	                promisesChain = promisesChain.then(function (response) {
	                    return _this._logApiResponseError(context, response, params);
	                }).then(function (response) {
	                    return _this._logApiResponseError(context, response, params);
	                }).then(function (response) {
	                    return _this._logApiResponseWarn(context, response, params);
	                }).then(function (response) {
	                    return _this._logApiTimeoutError(context, response, params);
	                }).catch(function (error) {
	                    return _this._logApiRequestError(context, error, params);
	                });
	            }
	
	            return promisesChain;
	        };
	    };
	
	    API.prototype._logApiResponseError = function _logApiResponseError(context, response, params) {
	        var method = _.get(params, 'method');
	        var apiParams = _.get(params, 'data');
	        var apiScheme = context.location.scheme;
	        var apiUrl = this._getRequestURL(params);
	        var codeHttp = _.get(response, 'status.code');
	        var codeMeta = _.get(response, 'content.meta.code');
	        var userReferrer = _.result(context, 'referrer.toString');
	        var userHRef = _.result(context, 'location.toString');
	        var userAgent = _.get(context, 'userAgent');
	
	        if (this._isErrorCode(codeHttp)) {
	            var text = _.get(response, 'status.text', codeHttp);
	            var message = 'HttpError: ' + text;
	
	            this._logger.error(message, {
	                codeHttp: codeHttp, codeMeta: codeMeta,
	                method: method, apiScheme: apiScheme,
	                apiUrl: apiUrl, apiParams: apiParams,
	                userReferrer: userReferrer, userHRef: userHRef,
	                userAgent: userAgent
	            });
	        } else if (this._isErrorCode(codeMeta)) {
	            var error = _.get(response, 'content.meta.error');
	            var _text = _.get(error, 'message', codeMeta);
	            var _message = 'ApiError: ' + _text;
	
	            this._logger.error(_message, {
	                codeHttp: codeHttp, codeMeta: codeMeta,
	                method: method, error: error, apiScheme: apiScheme,
	                apiUrl: apiUrl, apiParams: apiParams,
	                userReferrer: userReferrer, userHRef: userHRef,
	                userAgent: userAgent
	            });
	        }
	
	        return response;
	    };
	
	    API.prototype._logApiTimeoutError = function _logApiTimeoutError(context, response, params) {
	        var method = _.get(params, 'method');
	        var apiParams = _.get(params, 'data');
	        var apiScheme = context.location.scheme;
	        var apiUrl = this._getRequestURL(params);
	        var codeHttp = _.get(response, 'status.code');
	        var userReferrer = _.result(context, 'referrer.toString');
	        var userHRef = _.result(context, 'location.toString');
	        var userAgent = _.get(context, 'userAgent');
	
	        if (codeHttp === 0) {
	            var message = 'HttpError: Timeout';
	
	            this._logger.error(message, {
	                codeHttp: codeHttp,
	                method: method, apiScheme: apiScheme,
	                apiUrl: apiUrl, apiParams: apiParams,
	                userReferrer: userReferrer, userHRef: userHRef,
	                userAgent: userAgent
	            });
	        }
	
	        return response;
	    };
	
	    API.prototype._logApiResponseWarn = function _logApiResponseWarn(context, response, params) {
	        var method = _.get(params, 'method');
	        var apiParams = _.get(params, 'data');
	        var apiScheme = context.location.scheme;
	        var apiUrl = this._getRequestURL(params);
	        var codeHttp = _.get(response, 'status.code');
	        var codeMeta = _.get(response, 'content.meta.code');
	        var userReferrer = _.result(context, 'referrer.toString');
	        var userHRef = _.result(context, 'location.toString');
	        var userAgent = _.get(context, 'userAgent');
	
	        if (this._isWarnCode(codeHttp)) {
	            var text = _.get(response, 'status.text', codeHttp);
	            var message = 'HttpError: ' + text;
	
	            this._logger.warn(message, {
	                codeHttp: codeHttp, codeMeta: codeMeta,
	                method: method, apiScheme: apiScheme,
	                apiUrl: apiUrl, apiParams: apiParams,
	                userReferrer: userReferrer, userHRef: userHRef,
	                userAgent: userAgent
	            });
	        } else if (this._isWarnCode(codeMeta)) {
	            var error = _.get(response, 'content.meta.error');
	            var _text2 = _.get(error, 'message', codeMeta);
	            var _message2 = 'ApiError: ' + _text2;
	
	            this._logger.warn(_message2, {
	                codeHttp: codeHttp, codeMeta: codeMeta,
	                method: method, error: error, apiScheme: apiScheme,
	                apiUrl: apiUrl, apiParams: apiParams,
	                userReferrer: userReferrer, userHRef: userHRef,
	                userAgent: userAgent
	            });
	        }
	        return response;
	    };
	
	    API.prototype._logApiRequestError = function _logApiRequestError(context, error, params) {
	        var data = {};
	        var message = '';
	        var method = _.get(params, 'method');
	        var apiParams = _.get(params, 'data');
	        var apiScheme = context.location.scheme;
	        var apiUrl = this._getRequestURL(params);
	        var userReferrer = _.result(context, 'referrer.toString');
	        var userHRef = _.result(context, 'location.toString');
	        var userAgent = _.get(context, 'userAgent');
	
	        if (_.isError(error)) {
	            data.stack = error.stack;
	            message = error.name + ': ' + error.message;
	        } else {
	            message = JSON.stringify(error);
	        }
	
	        message = message || 'requestError';
	
	        this._logger.error(message, Object.assign({
	            method: method, error: error,
	            apiParams: apiParams, apiScheme: apiScheme, apiUrl: apiUrl,
	            userReferrer: userReferrer, userHRef: userHRef, userAgent: userAgent
	        }, data));
	    };
	
	    API.prototype._getRequestURL = function _getRequestURL(params) {
	        var apiUrl = _.get(params, 'url');
	        var apiParams = _.get(params, 'data');
	
	        if (_.isEmpty(apiParams)) {
	            return apiUrl;
	        }
	
	        if (_.isString(apiParams)) {
	            return apiUrl + '?' + apiParams;
	        }
	
	        var queryStr = _.chain(apiParams).map(function (value, key) {
	            return key + '=' + value;
	        }).join('&').value();
	
	        return apiUrl + '?' + queryStr;
	    };
	
	    API.prototype._isErrorCode = function _isErrorCode(code) {
	        return (/[345][0-9]{2}/.test(code) && !this._isWarnCode(code)
	        );
	    };
	
	    API.prototype._isWarnCode = function _isWarnCode(code) {
	        return (/401|403|404/.test(code)
	        );
	    };
	
	    API.prototype.getUrl = function getUrl(context, endpoint) {
	        var slug = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	        var base = endpoint.endsWith('/') ? endpoint : endpoint + '/';
	
	        var scheme = _.get(context, 'location.scheme') === 'https' ? 'https://' : 'http://';
	
	        return (/^http[s]?:\/\/.+/.test(base) ? '' + base + slug : '' + scheme + base + slug
	        );
	    };
	
	    _createClass(API, [{
	        key: '_export',
	        get: function get() {
	            return this._request(this._config.exportAPI);
	        }
	    }, {
	        key: '_auth',
	        get: function get() {
	            var _this2 = this;
	
	            return function (method, slug, data, context) {
	                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	
	                return _this2._request(_this2._config.authAPI)(method, slug, data, context, null, options);
	            };
	        }
	    }]);
	
	    return API;
	}();
	
	module.exports = API;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var API = __webpack_require__(477);
	
	module.exports = {
	    register: function register(locator) {
	        locator.register('api', API, true);
	    }
	};

/***/ }),
/* 479 */
/***/ (function(module, exports) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BitrixApi = function () {
	    function BitrixApi(locator) {
	        _classCallCheck(this, BitrixApi);
	
	        this._bx = locator.resolve('window').BX24;
	    }
	
	    BitrixApi.prototype.getAuth = function getAuth() {
	        return this._bx.getAuth();
	    };
	
	    BitrixApi.prototype.getCurrentUser = function getCurrentUser(callbackHandler) {
	        return this._bx.callMethod('user.current', {}, callbackHandler);
	    };
	
	    BitrixApi.prototype.refreshAuth = function refreshAuth(callbackHandler) {
	        return this._bx.refreshAuth(callbackHandler);
	    };
	
	    BitrixApi.prototype.resize = function resize(w, h) {
	        this._bx.resizeWindow(w, h);
	    };
	
	    BitrixApi.prototype.fitWindow = function fitWindow(callbackHandler) {
	        this._bx.fitWindow(function () {
	            return callbackHandler();
	        });
	    };
	
	    BitrixApi.prototype.scroll = function scroll() {
	        var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	        this._bx.scrollParentWindow(position);
	    };
	
	    BitrixApi.prototype.init = function init(responseHandler) {
	        this._bx.init(responseHandler);
	    };
	
	    BitrixApi.prototype.registerTracker = function registerTracker() {
	        var window = this._window;
	        var document = this._window.document;
	
	        var script = document.createElement('script');
	        script.type = 'text/javascript';
	        script.async = true;
	        script.src = this._config.analytics.yandex.url;
	
	        var firstScriptNode = document.getElementsByTagName('script')[0];
	        function bindScriptNode() {
	            firstScriptNode.parentNode.insertBefore(script, firstScriptNode);
	        }
	
	        if (window.opera == '[object Opera]') {
	            document.addEventListener('DOMContentLoaded', bindScriptNode, false);
	        } else {
	            bindScriptNode();
	        }
	    };
	
	    return BitrixApi;
	}();
	
	module.exports = BitrixApi;

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var BitrixApi = __webpack_require__(479);
	
	module.exports = {
	    register: function register(locator) {
	        locator.register('bitrix', BitrixApi, true);
	    }
	};

/***/ }),
/* 481 */
/***/ (function(module, exports) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GismapApi = function () {
	    function GismapApi(locator) {
	        _classCallCheck(this, GismapApi);
	
	        this._dg = locator.resolve('window').DG;
	    }
	
	    GismapApi.prototype.showMap = function showMap() {
	        var map = void 0;
	        var _dg = this._dg;
	        _dg.then(function () {
	            map = _dg.map('map', {
	                center: [54.980166, 82.898141],
	                zoom: 16
	            });
	
	            _dg.marker([54.980166, 82.898141]).addTo(map).bindPopup('<div style="color: #ffc84b; font: 22px/24px Arial,sans-serif;">2ГИС, городской информационный сервис</div>' + '<div style="margin-top: 10px; font: 16px/18px Arial,sans-serif;">Карла Маркса площадь, 7</div>');
	        });
	    };
	
	    GismapApi.prototype.register = function register() {
	        var window = this._window;
	        var document = this._window.document;
	
	        var script = document.createElement('script');
	        script.type = 'text/javascript';
	        script.async = true;
	        script.src = this._config.analytics.yandex.url;
	
	        var firstScriptNode = document.getElementsByTagName('script')[0];
	        function bindScriptNode() {
	            firstScriptNode.parentNode.insertBefore(script, firstScriptNode);
	        }
	
	        if (window.opera == '[object Opera]') {
	            document.addEventListener('DOMContentLoaded', bindScriptNode, false);
	        } else {
	            bindScriptNode();
	        }
	    };
	
	    return GismapApi;
	}();
	
	module.exports = GismapApi;

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var GismapApi = __webpack_require__(481);
	
	module.exports = {
	    register: function register(locator) {
	        locator.register('gismap', GismapApi, true);
	    }
	};

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Handlebars = __webpack_require__(1);
	
	module.exports = {
	    register: function register(locator) {
	        locator.registerInstance('handlebars', Handlebars);
	    }
	};

/***/ }),
/* 484 */
/***/ (function(module, exports) {

	'use strict';
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _arguments = arguments;
	
	module.exports = function (left, operator, right, options) {
	  if (_arguments.length < 3) {
	    throw new Error('Handlebars Helper "compare" needs 2 parameters');
	  }
	
	  if (options === undefined) {
	    options = right;
	    right = operator;
	    operator = '===';
	  }
	
	  var operators = {
	    '==': function _(l, r) {
	      return l == r;
	    },
	    '===': function _(l, r) {
	      return l === r;
	    },
	    '!=': function _(l, r) {
	      return l != r;
	    },
	    '!==': function _(l, r) {
	      return l !== r;
	    },
	    '<': function _(l, r) {
	      return l < r;
	    },
	    '>': function _(l, r) {
	      return l > r;
	    },
	    '<=': function _(l, r) {
	      return l <= r;
	    },
	    '>=': function _(l, r) {
	      return l >= r;
	    },
	    'typeof': function _typeof(l, r) {
	      return (typeof l === 'undefined' ? 'undefined' : _typeof2(l)) == r;
	    }
	  };
	
	  if (!operators[operator]) {
	    throw new Error('Handlebars Helper "compare" doesn\'t know the operator ' + operator);
	  }
	
	  var result = operators[operator](left, right);
	
	  if (result) {
	    return options.fn(undefined);
	  } else {
	    return options.inverse(undefined);
	  }
	};

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var numeral = __webpack_require__(195);
	
	module.exports = function (value) {
	    return numeral(value).format('0,0.00').split(',').join(' ');
	};

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var compare = __webpack_require__(484);
	var currencyFormat = __webpack_require__(485);
	var intFormat = __webpack_require__(487);
	var patchQuery = __webpack_require__(488);
	
	module.exports = {
	    register: function register(locator) {
	        try {
	            var Handlebars = locator.resolve('handlebars');
	
	            Handlebars.registerHelper('compare', compare);
	            Handlebars.registerHelper('currencyFormat', currencyFormat);
	            Handlebars.registerHelper('intFormat', intFormat);
	            Handlebars.registerHelper('json', function (obj) {
	                return JSON.stringify(obj);
	            });
	            Handlebars.registerHelper('patchQuery', patchQuery);
	        } catch (e) {
	            locator.resolve('eventBus').emit('error', e);
	        }
	    }
	};

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var numeral = __webpack_require__(195);
	
	module.exports = function (value) {
	    return numeral(value).format('0,0').split(',').join(' ');
	};

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _require = __webpack_require__(4),
	    patchQuery = _require.patchQuery;
	
	module.exports = function (location, params) {
	    return patchQuery(location, params);
	};

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _ = __webpack_require__(3);
	var styles = __webpack_require__(490);
	
	var History = function () {
	    function History(serviceLocator) {
	        var _this = this;
	
	        _classCallCheck(this, History);
	
	        this._locator = serviceLocator;
	        this._eventBus = serviceLocator.resolve('eventBus');
	        this._logger = serviceLocator.resolve('logger');
	        this._window = serviceLocator.resolve('window');
	        this._history = [];
	        this._currentIndex = 0;
	        this._clear = JSON.parse(this._window.localStorage.getItem('DEBUGGER_CLEAR_CONSOLE'));
	        this._tracking = JSON.parse(this._window.localStorage.getItem('DEBUGGER_TRACKING'));
	
	        if (JSON.parse(this._window.localStorage.getItem('DEBUGGER_ENABLED'))) {
	            this._eventBus.on('signalEnd', function (result) {
	                return _this._remember(result);
	            });
	        }
	    }
	
	    History.prototype.logTree = function logTree() {
	        console.time(name);
	
	        var tree = this._getTree();
	        var data = tree.get();
	
	        if (this._clear) {
	            console.clear();
	        }
	
	        console.log('%cCurrent state:', styles.header);
	        console.info(data);
	    };
	
	    History.prototype.logSignal = function logSignal() {
	        var _this2 = this;
	
	        if (this._clear) {
	            console.clear();
	        }
	
	        var signal = this._history[this._currentIndex];
	        var size = Object.keys(this._history).length;
	
	        console.log('%cSignal "' + signal.name + '" (' + (this._currentIndex + 1) + ' of ' + size + ')', styles.header);
	        this._logArgs(signal);
	        console.log('%cSignal actions:', styles.header);
	
	        signal.branches.forEach(function (branch) {
	            var isAsync = Array.isArray(branch);
	
	            if (isAsync) {
	                branch.forEach(function (asyncBranch) {
	                    _this2._logBranch(asyncBranch);
	                });
	            } else {
	                _this2._logBranch(branch);
	            }
	        });
	    };
	
	    History.prototype.goNextSignal = function goNextSignal() {
	        var size = Object.keys(this._history).length;
	        var current = this._currentIndex;
	
	        if (current + 1 >= size) {
	            this.logSignal();
	            return;
	        }
	
	        this._currentIndex += 1;
	        this.logSignal();
	    };
	
	    History.prototype.goPreviousSignal = function goPreviousSignal() {
	        var current = this._currentIndex;
	
	        if (current <= 0) {
	            this.logSignal();
	            return;
	        }
	
	        this._currentIndex -= 1;
	        this.logSignal();
	    };
	
	    History.prototype._logArgs = function _logArgs(signal) {
	        console.log('%cSignal run with next args:', styles.header);
	        console.info(signal.args);
	    };
	
	    History.prototype._logBranch = function _logBranch(branch) {
	        var _this3 = this;
	
	        if (branch.outputPath) {
	            console.groupCollapsed('%c' + branch.name + ' \xB7 %cOutput to "' + branch.outputPath + '"', styles.action, styles.output);
	        } else {
	            console.log('%c' + branch.name, styles.action);
	        }
	
	        _.each(branch.mutations, function (mutation) {
	            var name = _.capitalize(mutation.name);
	            var path = mutation.path.join('.');
	            var args = _.first(mutation.args);
	
	            console.log('%c' + name + ' \xB7 ' + path + ' \xB7 %c%o', styles.group, styles.sub, args);
	        });
	
	        if (branch.outputPath) {
	            var output = branch.outputs[branch.outputPath];
	            output.forEach(function (outputBranch) {
	                var isAsync = Array.isArray(outputBranch);
	
	                if (isAsync) {
	                    outputBranch.forEach(function (asyncBranch) {
	                        _this3._logBranch(asyncBranch);
	                    });
	                } else {
	                    _this3._logBranch(outputBranch);
	                }
	            });
	
	            console.groupEnd();
	        }
	    };
	
	    History.prototype._getTree = function _getTree() {
	        var renderer = this._locator.resolve('documentRenderer');
	        return renderer._stateManager.tree;
	    };
	
	    History.prototype._remember = function _remember(result) {
	        this._history.push(result);
	
	        if (this._tracking) {
	            this._currentIndex = Object.keys(this._history).length - 1;
	        }
	
	        this.logSignal();
	    };
	
	    return History;
	}();
	
	module.exports = {
	    register: function register(locator) {
	        locator.register('history', History, true);
	    }
	};

/***/ }),
/* 490 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = {
	  header: "\n    border-left: 6px solid gold;\n    font-family: Helvetica;\n    font-weight: bold;\n    font-size: 14px;\n    line-height: 26px;\n    display: block;\n    padding-left: 8px;\n  ",
	
	  sub: "\n    font-family: Helvetica;\n    font-size: 13px;\n    line-height: 16px;\n  ",
	
	  dump: "\n    font-family: Helvetica;\n    font-size: 13px;\n    line-height: 18px;\n  ",
	
	  group: "\n    font-family: Helvetica;\n    font-size: 13px;\n    line-height: 28px;\n    font-weight: normal;\n    border-left: 9px solid royalblue;\n    padding-left: 8px;\n    color: #333;\n  ",
	
	  action: "\n    font-family: Helvetica;\n    font-size: 13px;\n    line-height: 26px;\n    font-weight: normal;\n    color: #000;\n    border-left: 6px solid green;\n    padding: 0 0 0 8px;\n  ",
	
	  output: "\n    font-family: Helvetica;\n    font-size: 11px;\n    line-height: 26px;\n    font-weight: normal;\n    color: #000;\n  "
	};

/***/ }),
/* 491 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	    register: function register(locator) {
	        var config = locator.resolve('config');
	        var window = locator.resolve('window');
	        var logger = locator.resolve('logger');
	        var uhr = locator.resolve('uhr');
	
	        var headers = {
	            'Content-Type': 'application/json'
	        };
	
	        logger.addEnrichment(function (log) {
	            log.userHRef = window.location.href;
	        });
	        logger.addEnrichment(function (log) {
	            log.userAgent = window.navigator.userAgent;
	        });
	        logger.addEnrichment(function (log) {
	            log.userReferrer = window.document.referrer;
	        });
	
	        var protocol = window.location.protocol;
	        var host = window.location.host;
	        var url = config.logger.url;
	
	        logger.addTransport(function (level, log) {
	            if (!/(error|fatal|warn)/.test(level)) {
	                return;
	            }
	
	            var options = {
	                headers: headers,
	                data: {
	                    log: log, level: level
	                }
	            };
	            uhr.post(protocol + '//' + host + '/external/' + url, options);
	        });
	    }
	};

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var orders = __webpack_require__(41);
	var utils = __webpack_require__(5);
	var currentOrderGroups = __webpack_require__(118);
	var accountGroups = __webpack_require__(63);
	var user = __webpack_require__(28);
	
	module.exports = {
	    onCreateUserStub: [[orders.createUserStub, {
	        success: [utils.set(['account', 'orders', 'createUser', 'notFound'], false), utils.setFromArgsToState('user', ['account', 'orders', 'currentOrder', 'localChanges', 'selectedUser'])].concat(accountGroups.getUsersList, [[user.isManager, {
	            true: [utils.set(['account', 'orders', 'currentOrder', 'tooltips', 'showUserMustBeSelected'], false)],
	            false: [].concat(currentOrderGroups.setUserGroup)
	        }]]),
	        error: [utils.set(['account', 'orders', 'createUser', 'error', 'createError'], true)]
	    }]]
	};

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	var redirect = __webpack_require__(35);
	
	module.exports = {
	    setSubPage: [utils.setFromArgsToState('subPage', ['page', 'sub']), utils.setArgByFunction('url', function (args) {
	        return '/manager/' + args['subPage'];
	    }), redirect.redirectFromArgs]
	};

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var passwordChange = __webpack_require__(198);
	var utils = __webpack_require__(5);
	
	module.exports = {
	    changePassword: [passwordChange.ifChangePasswordInProcess, {
	        no: [utils.set(['account', 'passwordChangeForm', 'inProcess'], true), [passwordChange.changePassword, {
	            success: [utils.set(['account', 'passwordChangeForm', 'result'], { success: true })],
	            wrongPassword: [utils.set(['account', 'passwordChangeForm', 'result'], { error: true,
	                reason: 'прежний пароль введён неверно' })],
	            error: [utils.set(['account', 'passwordChangeForm', 'result'], { error: true,
	                reason: 'что-то пошло не так, попробуйте снова' })]
	        }], utils.set(['account', 'passwordChangeForm', 'inProcess'], false)],
	        yes: []
	    }]
	};

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var userGroups = __webpack_require__(45);
	var redirect = __webpack_require__(35);
	
	module.exports = {
	    checkForAuthCookie: [].concat(userGroups.checkAuthCookie([redirect.redirectToRoot]))
	};

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	var redirect = __webpack_require__(35);
	var login = __webpack_require__(139);
	var cookie = __webpack_require__(27);
	var user = __webpack_require__(28);
	
	var _require = __webpack_require__(230),
	    loginSuccess = _require.loginSuccess;
	
	var registrationExtra = __webpack_require__(140);
	var analytics = __webpack_require__(7);
	
	module.exports = {
	    clickLoginButton: [utils.set(['login', 'ui', 'loginButton', 'isDisabled'], true), [login.loginUser, {
	        success: [[user.getUser, {
	            allowed: [].concat(loginSuccess),
	            401: [utils.set(['login', 'error', 'errorType'], 'accessDenied')],
	            403: [cookie.setRegisterExtraToken, utils.setFromArgsToState('username', ['login', 'tooltip', 'emailNotConfirmed', 'username']), utils.set(['login', 'tooltip', 'emailNotConfirmed', 'show'], true)],
	            404: [cookie.setRegisterExtraToken, redirect.redirect('/registration/extra')],
	            denied: [utils.set(['login', 'error', 'errorType'], 'internalError')]
	        }]],
	        invalidValidation: [utils.set(['login', 'error', 'errorType'], 'invalidValidation')],
	        accessDenied: [utils.set(['login', 'error', 'errorType'], 'accessDenied')],
	        error: [utils.set(['login', 'error', 'errorType'], 'internalError')]
	    }], utils.set(['login', 'ui', 'loginButton', 'isDisabled'], false)],
	    clickRegisterButton: [analytics.argsValueEvent({ category: 'button_start_registration', action: 'click' }), login.passLoginInfoToRegistrationForm],
	    sendConfirmationMail: [registrationExtra.sendConfirmationMail, utils.unset(['login', 'tooltip', 'emailNotConfirmed', 'show']), utils.set(['login', 'tooltip', 'emailNotConfirmedMailResend', 'show'], true)]
	};

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var registrationExtra = __webpack_require__(140);
	var utils = __webpack_require__(5);
	var redirect = __webpack_require__(35);
	var cookie = __webpack_require__(27);
	var authGroup = __webpack_require__(161);
	var analytics = __webpack_require__(7);
	
	var _require = __webpack_require__(68),
	    selectUserType = _require.selectUserType;
	
	var bitrix = __webpack_require__(29);
	
	module.exports = {
	    showToS: [analytics.argsValueEvent({ category: 'popup_agreement', action: 'see' }), utils.set(['registrationExtra', 'showToS'], true)],
	    cancelToS: [utils.set(['registrationExtra', 'showToS'], false), registrationExtra.declinePersonalDataProcessing],
	    registrationExtra: [registrationExtra.acceptPersonalDataProcessing, utils.set(['registrationExtra', 'ui', 'registerButton', 'isDisabled'], true), utils.set(['registrationExtra', 'form', 'isAcceptPersonalDataProcessing'], true), [registrationExtra.registerHermesUser, {
	        emailAlreadySend: [utils.set(['page', 'name'], 'alert'), utils.set(['auth', 'alert', 'type'], 'registrationSuccess'), analytics.argsValueEvent({ category: 'post_successful_registration', action: 'see' }), cookie.setSessionToken, cookie.unsetRegisterExtraToken].concat(authGroup.createOrderAfterLoginIfNeededOrRedirect),
	        emailNotConfirmed: [registrationExtra.sendConfirmationMail, utils.set(['page', 'name'], 'alert'), utils.set(['auth', 'alert', 'type'], 'approveRegistration'), analytics.argsValueEvent({ category: 'post_registration_after_email_validation', action: 'see' }), redirect.redirect('/', 15000)],
	        passportUserAlreadyAssociated: [utils.set(['registrationExtra', 'error', 'errorType'], 'passportUserAlreadyAssociated')],
	        ok: [].concat(bitrix.getUser, [utils.unset(['account', 'orders', 'currentOrder']), utils.unset(['account', 'orders', 'list'])], authGroup.createOrderAfterLoginIfNeededOrRedirect),
	        wrongCountryId: [utils.set(['auth', 'isCountryError'], true)],
	        error: [utils.set(['registrationExtra', 'error', 'errorType'], 'internalError')]
	    }], utils.set(['registrationExtra', 'ui', 'registerButton', 'isDisabled'], false), utils.set(['registrationExtra', 'showToS'], false)],
	    setRegistrationProperty: [registrationExtra.setRegistrationProperty],
	    selectUserType: [selectUserType(['registrationExtra'])],
	    selectCountry: [utils.setArgByFunction('selectedValue', function (args) {
	        return Number(args['selectedValue']);
	    }), utils.setFromArgsToState('selectedValue', ['registrationExtra', 'form', 'countryId']), [utils.isEqual(['registrationExtra', 'computed', 'isUserTypeSelectEnabled'], false), {
	        yes: [utils.set(['registrationExtra', 'form', 'userType'], 1), utils.unset(['registration', 'userTypeRadio']), utils.set(['registrationExtra', 'userTypeRadio', 1], true)],
	        no: []
	    }]]
	};

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(3);
	var SHCEME = __webpack_require__(22);
	var emailAlreadyUsed = _.get(SHCEME, 'email.properties.value.messages.emailAlreadyUsed');
	
	var registration = __webpack_require__(97);
	var utils = __webpack_require__(5);
	var redirect = __webpack_require__(35);
	var cookie = __webpack_require__(27);
	var authGroup = __webpack_require__(161);
	var login = __webpack_require__(139);
	var user = __webpack_require__(28);
	
	var _require = __webpack_require__(230),
	    loginSuccess = _require.loginSuccess;
	
	var analytics = __webpack_require__(7);
	
	var _require2 = __webpack_require__(68),
	    selectUserType = _require2.selectUserType;
	
	var showLoginWithTooltip = [redirect.redirect('/login'), utils.set(['login', 'tooltip', 'showAlreadyRegisteredTooltip'], true), utils.unset(['login', 'form', 'password'])];
	
	var registerHermesUser = [[registration.registerHermesUser, {
	    emailAlreadySend: [utils.set(['page', 'name'], 'alert'), utils.set(['auth', 'alert', 'type'], 'registrationSuccess'), analytics.argsValueEvent({ category: 'post_successful_registration', action: 'see' }), cookie.setSessionToken, cookie.unsetRegisterExtraToken].concat(authGroup.createOrderAfterLoginIfNeededOrRedirect),
	    emailNotConfirmed: [utils.set(['page', 'name'], 'alert'), utils.set(['auth', 'alert', 'type'], 'approveRegistration'), analytics.argsValueEvent({ category: 'post_registration_after_email_validation', action: 'see' }), redirect.redirect('/', 15000)],
	    passportUserAlreadyAssociated: [utils.set(['registration', 'error', 'email'], emailAlreadyUsed)],
	    wrongCountryId: [utils.set(['auth', 'isCountryError'], true)],
	    error: [utils.set(['auth', 'isError'], true)]
	}]];
	
	module.exports = {
	    showToS: [analytics.argsValueEvent({ category: 'popup_agreement', action: 'see' }), utils.set(['registration', 'showToS'], true)],
	    cancelToS: [utils.set(['registration', 'showToS'], false), registration.declinePersonalDataProcessing],
	    registration: [registration.acceptPersonalDataProcessing, utils.set(['registration', 'ui', 'registerButton', 'isDisabled'], true), utils.set(['registration', 'form', 'isAcceptPersonalDataProcessing'], true), [registration.debouncedRegisterAuthUser, {
	        success: [].concat(registerHermesUser),
	        emailAlreadyUsed: [registration.fillLoginForm, [login.loginUser, {
	            success: [[user.getUser, {
	                allowed: [].concat(loginSuccess),
	                403: [redirect.redirect('/login'), utils.setFromArgsToState('username', ['login', 'tooltip', 'emailNotConfirmed', 'username']), utils.set(['login', 'tooltip', 'emailNotConfirmed', 'show'], true)],
	                404: [].concat(registerHermesUser),
	                denied: [utils.set(['auth', 'isError'], true)]
	            }]],
	            invalidValidation: [].concat(showLoginWithTooltip),
	            accessDenied: [utils.setArgFromState('email', ['registration', 'form', 'email']), [user.isEmailAssociated, {
	                yes: [utils.set(['registration', 'error', 'email'], 'Пользователь с таким email<br> уже зарегистрирован')],
	                no: [].concat(showLoginWithTooltip),
	                error: []
	            }]],
	            error: [utils.set(['auth', 'isError'], true)]
	        }]],
	        error: [utils.set(['auth', 'isError'], true)]
	    }], utils.set(['registration', 'ui', 'registerButton', 'isDisabled'], false), utils.set(['registration', 'showToS'], false)],
	    setRegistrationProperty: [registration.setRegistrationProperty],
	    selectUserType: [selectUserType(['registration'])],
	    selectCountry: [utils.setArgByFunction('selectedValue', function (args) {
	        return Number(args['selectedValue']);
	    }), utils.setFromArgsToState('selectedValue', ['registration', 'form', 'countryId']), [utils.isEqual(['registration', 'computed', 'isUserTypeSelectEnabled'], false), {
	        yes: [utils.set(['registration', 'form', 'userType'], 1), utils.unset(['registration', 'userTypeRadio']), utils.set(['registration', 'userTypeRadio', 1], true)],
	        no: []
	    }]]
	};

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var restoreChange = __webpack_require__(200);
	var utils = __webpack_require__(5);
	
	module.exports = {
	    passwordChange: [utils.set(['restoreChange', 'ui', 'restoreButton', 'isDisabled'], true), [restoreChange.passwordChange, {
	        success: [utils.set(['page', 'name'], 'alert'), utils.set(['auth', 'alert', 'type'], 'changePasswordSuccess')],
	        invalidToken: [utils.set(['restoreChange', 'error', 'errorType'], 'invalidToken')],
	        notFound: [utils.set(['restoreChange', 'error', 'errorType'], 'notFound')],
	        error: [utils.set(['restoreChange', 'error', 'errorType'], 'internalError')]
	    }], utils.set(['restoreChange', 'ui', 'restoreButton', 'isDisabled'], false)]
	};

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var restore = __webpack_require__(201);
	var utils = __webpack_require__(5);
	
	module.exports = {
	    restore: [utils.set(['restore', 'ui', 'restoreButton', 'isDisabled'], true), [restore.restorePassword, {
	        success: [utils.set(['page', 'name'], 'alert'), utils.set(['auth', 'alert', 'type'], 'approveRestore')],
	        notFound: [utils.set(['restore', 'error', 'errorType'], 'notFound')],
	        error: [utils.set(['restore', 'error', 'errorType'], 'internalError')]
	    }], utils.set(['restore', 'ui', 'restoreButton', 'isDisabled'], false)]
	};

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _require = __webpack_require__(307),
	    showMap = _require.showMap;
	
	var bitrix = __webpack_require__(70);
	
	module.exports = {
	    onLoad: [showMap, bitrix.resize]
	};

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var filials = __webpack_require__(203);
	var order = __webpack_require__(30);
	
	module.exports = {
	    selectFilialsNumber: [filials.selectFilialsNumber].concat(order.calcPriceGroup)
	};

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var legalEntities = __webpack_require__(112);
	
	var _require = __webpack_require__(30),
	    calcPriceGroup = _require.calcPriceGroup;
	
	var analytics = __webpack_require__(7);
	var utils = __webpack_require__(5);
	
	module.exports = {
	    onItemCheck: [legalEntities.changeValue, utils.setArg('category', 'checkbox_type_ownership'), [analytics.fillEventFromTreeChecked, {
	        filled: [analytics.raiseArgsValueEvent],
	        noEvent: []
	    }]].concat(calcPriceGroup),
	
	    onSetAll: [legalEntities.setAll].concat(calcPriceGroup)
	};

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var mapClasses = __webpack_require__(144);
	
	var _require = __webpack_require__(30),
	    calcPriceGroup = _require.calcPriceGroup;
	
	var analytics = __webpack_require__(7);
	var utils = __webpack_require__(5);
	
	module.exports = {
	    onItemCheck: [mapClasses.changeValue].concat(calcPriceGroup),
	
	    onSetAll: [mapClasses.setAll].concat(calcPriceGroup)
	};

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var paymentTypes = __webpack_require__(145);
	
	var _require = __webpack_require__(30),
	    calcPriceGroup = _require.calcPriceGroup;
	
	var analytics = __webpack_require__(7);
	var utils = __webpack_require__(5);
	
	module.exports = {
	    onItemCheck: [paymentTypes.changeValue, utils.setArg('category', 'checkbox_number_of_employees'), [analytics.fillEventFromTreeChecked, {
	        filled: [analytics.raiseArgsValueEvent],
	        noEvent: []
	    }]].concat(calcPriceGroup),
	
	    onSetAll: [paymentTypes.setAll].concat(calcPriceGroup)
	};

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var paymentTypes = __webpack_require__(146);
	
	var _require = __webpack_require__(30),
	    calcPriceGroup = _require.calcPriceGroup;
	
	var analytics = __webpack_require__(7);
	var utils = __webpack_require__(5);
	
	module.exports = {
	    onItemCheck: [paymentTypes.changeValue, utils.setArg('category', 'checkbox_payment_type'), [analytics.fillEventFromTreeChecked, {
	        filled: [analytics.raiseArgsValueEvent],
	        noEvent: []
	    }]].concat(calcPriceGroup),
	
	    onSetAll: [paymentTypes.setAll].concat(calcPriceGroup)
	};

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var purposes = __webpack_require__(113);
	
	var _require = __webpack_require__(30),
	    calcPriceGroup = _require.calcPriceGroup;
	
	var analytics = __webpack_require__(7);
	var utils = __webpack_require__(5);
	
	module.exports = {
	    onItemCheck: [purposes.changeValue].concat(calcPriceGroup),
	
	    onSetAll: [purposes.setAll].concat(calcPriceGroup)
	};

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	var redirect = __webpack_require__(35);
	var cookie = __webpack_require__(27);
	
	module.exports = {
	    clickSettings: [utils.togglePopup('settings')],
	
	    clickLogout: [cookie.unsetSessionToken, utils.unset('user'), utils.set(['user', 'role'], 'unauthorized'), redirect.redirect('/login')]
	};

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	
	module.exports = {
	    closePopups: [utils.set('popups.active', [])]
	};

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var slider = __webpack_require__(206);
	
	module.exports = {
	    sliderNextView: [slider.asyncAnimation, {
	        no: [slider.sliderNextView]
	    }]
	};

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	var content = __webpack_require__(20);
	var userGroup = __webpack_require__(45);
	var layoutGroup = __webpack_require__(36);
	var analytics = __webpack_require__(7);
	var seo = __webpack_require__(21);
	var page = __webpack_require__(43);
	var statistic = __webpack_require__(199);
	
	module.exports = [].concat(userGroup.checkAuthCookie([].concat(userGroup.getUser)), userGroup.access('manager', [page.cleanup(), analytics.parseUtmFromQuery, utils.set(['user', 'role'], 'manager'), utils.set('layout', 'footless')].concat(layoutGroup.setMainLayoutBlocks, [seo.setDashboardMeta('Статистика заказа', 'Статистика заказа'), content.setComponentsByLink, statistic.setComputedFields, utils.setFromArgsToState('orderId', ['account', 'statistic', 'orderId']), utils.setFromArgsToState('isByBranch', ['account', 'statistic', 'isByBranch']), utils.setFromArgsToState('isTransposed', ['account', 'statistic', 'isTransposed'])])));

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	var redirect = __webpack_require__(35);
	var footer = __webpack_require__(56);
	var seo = __webpack_require__(21);
	var auth = __webpack_require__(69);
	var analytics = __webpack_require__(7);
	
	module.exports = [analytics.parseUtmFromQuery, utils.set('layout', 'auth'), seo.setDashboardMeta('Почта подтверждена', 'Почта подтверждена'), utils.set(['page', 'name'], 'alert'), utils.set(['auth', 'alert', 'type'], 'emailConfirmed'), auth.setComputedFields, analytics.pageview, analytics.argsValueEvent({ category: 'post_successful_registration', action: 'see' }), footer.setCopyrightYear, redirect.redirect('/login', 5000)];

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	var analytics = __webpack_require__(7);
	var auth = __webpack_require__(69);
	var cookie = __webpack_require__(27);
	var page = __webpack_require__(43);
	var footer = __webpack_require__(56);
	var login = __webpack_require__(139);
	var seo = __webpack_require__(21);
	
	module.exports = [analytics.parseUtmFromQuery, utils.set('layout', 'auth'), utils.set('page.ui.atCenter', true), cookie.checkExistCookie, {
	    exist: [utils.set(['page', 'name'], 'alert'), utils.set(['auth', 'alert', 'type'], 'redirect')],
	    notExist: [page.setCurrentPage]
	}, seo.setDashboardMeta('Авторизация - Библиотека данных', 'Авторизация в библиотеке данных'), auth.setComputedFields, login.setComputedFields, analytics.pageview, footer.setCopyrightYear];

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	var analytics = __webpack_require__(7);
	var auth = __webpack_require__(69);
	
	var _require = __webpack_require__(68),
	    initUserType = _require.initUserType;
	
	var cookie = __webpack_require__(27);
	var registration = __webpack_require__(97);
	var registrationExtra = __webpack_require__(140);
	var page = __webpack_require__(43);
	var footer = __webpack_require__(56);
	var seo = __webpack_require__(21);
	var bitrix = __webpack_require__(70);
	var error = __webpack_require__(19);
	
	module.exports = [analytics.parseUtmFromQuery, utils.set('layout', 'auth'), [registration.getCountries, {
	    success: [utils.setFromArgsToState('countries', ['registrationExtra', 'countries'])],
	    error: [error.internalError('registration.getCountries')]
	}], utils.setPopupVisibility('registrationCountryDropdown', ['registrationExtra', 'popups', 'countryDropdown', 'isOpen']), seo.setDashboardMeta('Регистрация - Библиотека данных', 'Регистрация в библиотеке данных'), auth.setComputedFields, registrationExtra.setComputedFields, initUserType(['registrationExtra']), [utils.isEqual(['bitrix', 'isBitrix'], true), {
	    no: [[cookie.checkExistCookie, {
	        exist: [utils.set(['page', 'name'], 'alert'), utils.set(['auth', 'alert', 'type'], 'redirect')],
	        notExist: [page.setCurrentPage]
	    }]],
	    yes: [page.setCurrentPage, [bitrix.getCurrentUser, {
	        success: [bitrix.fillRegistrationForm],
	        error: [utils.consoleLog('getCurrentUser - error')]
	    }], utils.consoleLog('isBitrix - yes')]
	}], analytics.pageview, footer.setCopyrightYear, bitrix.resize, bitrix.scrollTop];

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	var analytics = __webpack_require__(7);
	var auth = __webpack_require__(69);
	var cookie = __webpack_require__(27);
	var registration = __webpack_require__(97);
	var page = __webpack_require__(43);
	var footer = __webpack_require__(56);
	var seo = __webpack_require__(21);
	
	var _require = __webpack_require__(68),
	    initUserType = _require.initUserType;
	
	var error = __webpack_require__(19);
	
	module.exports = [analytics.parseUtmFromQuery, utils.set('layout', 'auth'), [cookie.checkExistCookie, {
	    exist: [utils.set(['page', 'name'], 'alert'), utils.set(['auth', 'alert', 'type'], 'redirect')],
	    notExist: [page.setCurrentPage]
	}], [registration.getCountries, {
	    success: [utils.setFromArgsToState('countries', ['registration', 'countries'])],
	    error: [error.internalError('registration.getCountries')]
	}], utils.setPopupVisibility('registrationCountryDropdown', ['registration', 'popups', 'countryDropdown', 'isOpen']), seo.setDashboardMeta('Регистрация - Библиотека данных', 'Регистрация в библиотеке данных'), auth.setComputedFields, registration.setComputedFields, initUserType(['registration']), analytics.pageview, footer.setCopyrightYear];

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	var analytics = __webpack_require__(7);
	var auth = __webpack_require__(69);
	var cookie = __webpack_require__(27);
	var page = __webpack_require__(43);
	var restoreChange = __webpack_require__(200);
	var footer = __webpack_require__(56);
	var seo = __webpack_require__(21);
	
	module.exports = [analytics.parseUtmFromQuery, utils.set('layout', 'auth'), cookie.checkExistCookie, {
	    exist: [utils.set(['page', 'name'], 'alert'), utils.set(['auth', 'alert', 'type'], 'redirect')],
	    notExist: [page.setCurrentPage]
	}, seo.setDashboardMeta('Восстановление пароля - Библиотека данных', 'Восстановление пароля в Библиотеке данных'), auth.setComputedFields, restoreChange.setComputedFields, utils.setFromArgsToState('restoreToken', 'restoreToken'), analytics.pageview, footer.setCopyrightYear];

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	var analytics = __webpack_require__(7);
	var auth = __webpack_require__(69);
	var cookie = __webpack_require__(27);
	var page = __webpack_require__(43);
	var restore = __webpack_require__(201);
	var footer = __webpack_require__(56);
	var seo = __webpack_require__(21);
	
	module.exports = [analytics.parseUtmFromQuery, utils.set('layout', 'auth'), cookie.checkExistCookie, {
	    exist: [utils.set(['page', 'name'], 'alert'), utils.set(['auth', 'alert', 'type'], 'redirect')],
	    notExist: [page.setCurrentPage]
	}, seo.setDashboardMeta('Восстановление пароля - Библиотека данных', 'Восстановление пароля в Библиотеке данных'), auth.setComputedFields, restore.setComputedFields, analytics.pageview, footer.setCopyrightYear];

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var seo = __webpack_require__(21);
	var cookie = __webpack_require__(27);
	var utils = __webpack_require__(5);
	var page = __webpack_require__(43);
	var content = __webpack_require__(20);
	var price = __webpack_require__(71);
	var layoutGroup = __webpack_require__(36);
	var analytics = __webpack_require__(7);
	var pricesGroup = __webpack_require__(162);
	
	module.exports = [page.cleanup(), analytics.parseUtmFromQuery, utils.set('layout', 'order'), utils.set(['bitrix', 'isBitrix'], true), utils.setFromArgsToState('bitrixDomain', ['bitrix', 'domain']), [utils.isEqual(['user', 'role'], undefined), {
	    yes: [utils.set(['user', 'role'], 'unauthorized')],
	    no: []
	}], [utils.isArgNotNull('bitrixDomain'), {
	    yes: [cookie.getArgFromCookie('bitrixDomainCookie', 'bitrix_domain'), [utils.isArgsEqual('bitrixDomainCookie', 'bitrixDomain'), {
	        yes: [],
	        no: [cookie.unsetCookie({ key: 'bitrix_access_token' }), cookie.unsetCookie({ key: 'bitrix_domain' }), cookie.unsetCookie({ key: 'bitrix_member_id' })]
	    }]],
	    no: []
	}]].concat(layoutGroup.setMainLayoutBlocks, [seo.setDashboardMeta('Данные об организациях: база телефонов, email адресов организаций - Библиотека данных', 'Официальная библиотека данных 2ГИС: актуальные номера телефонов, email адреса фирм и организаций.'), content.setComponentsByLink, utils.setPopupVisibility('datepicker', ['order', 'popups', 'datepicker', 'isOpen']), utils.setPopupVisibility('datepicker2', ['order', 'popups', 'datepicker2', 'isOpen']), price.setIsLoading(true), content.setIsLoading(true), analytics.pageview, pricesGroup.getPrices], pricesGroup.setComputedFields);

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	var analytics = __webpack_require__(7);
	var content = __webpack_require__(20);
	var layoutGroup = __webpack_require__(36);
	var userGroup = __webpack_require__(45);
	var seo = __webpack_require__(21);
	
	module.exports = [analytics.parseUtmFromQuery].concat(userGroup.checkAuthCookie([].concat(userGroup.getUser)), [utils.set('layout', 'main')], layoutGroup.setMainLayoutBlocks, [seo.setDashboardMeta('Контактная информация - Библиотека данных', 'Информация о библиотеке данных'), content.setComponentsByLink, analytics.pageview]);

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var analytics = __webpack_require__(7);
	var error = __webpack_require__(19);
	
	exports.notFound = [analytics.parseUtmFromQuery, analytics.pageview, error.notFound('default 404 page', true)];

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var seo = __webpack_require__(21);
	var utils = __webpack_require__(5);
	var content = __webpack_require__(20);
	var layoutGroup = __webpack_require__(36);
	
	module.exports = [utils.set('layout', 'empty')];

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	var analytics = __webpack_require__(7);
	var content = __webpack_require__(20);
	var layoutGroup = __webpack_require__(36);
	var userGroup = __webpack_require__(45);
	var seo = __webpack_require__(21);
	var pricesGroup = __webpack_require__(162);
	var page = __webpack_require__(43);
	var bitrix = __webpack_require__(70);
	
	module.exports = [page.cleanup(), analytics.parseUtmFromQuery].concat(userGroup.checkAuthCookie([].concat(userGroup.getUser)), [utils.set('layout', 'main')], layoutGroup.setMainLayoutBlocks, [seo.setDashboardMeta('FAQ - Библиотека данных', 'Ответы на часто возникающие вопросы'), content.setComponentsByLink, analytics.pageview, pricesGroup.getPrices, pricesGroup.getColumns], pricesGroup.setComputedFields, [bitrix.resize]);

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var seo = __webpack_require__(21);
	var utils = __webpack_require__(5);
	var page = __webpack_require__(43);
	var content = __webpack_require__(20);
	var price = __webpack_require__(71);
	var layoutGroup = __webpack_require__(36);
	var userGroup = __webpack_require__(45);
	var analytics = __webpack_require__(7);
	var slider = __webpack_require__(206);
	var pricesGroup = __webpack_require__(162);
	
	var DEFAULT_POSITIONS = {
	    city: 0,
	    buildings: 0,
	    clouds: 0
	};
	
	var START_PAGE = 1;
	
	var setDefaults = [utils.set(['slider', 'positions'], DEFAULT_POSITIONS), utils.set(['slider', 'page'], START_PAGE)];
	
	module.exports = [page.cleanup(), analytics.parseUtmFromQuery, utils.set('layout', 'order')].concat(userGroup.checkAuthCookie([].concat(userGroup.getUser)), layoutGroup.setMainLayoutBlocks, setDefaults, [slider.setComputedFields, seo.setDashboardMeta('Данные об организациях: база телефонов, email адресов организаций - Библиотека данных', 'Официальная библиотека данных 2ГИС: актуальные номера телефонов, email адреса фирм и организаций.'), content.setComponentsByLink, utils.setPopupVisibility('datepicker', ['order', 'popups', 'datepicker', 'isOpen']), utils.setPopupVisibility('datepicker2', ['order', 'popups', 'datepicker2', 'isOpen']), price.setIsLoading(true), content.setIsLoading(true), analytics.pageview, pricesGroup.getPrices], pricesGroup.setComputedFields);

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	var page = __webpack_require__(43);
	var footer = __webpack_require__(56);
	var order = __webpack_require__(100);
	var analytics = __webpack_require__(7);
	var payment = __webpack_require__(310);
	var seo = __webpack_require__(21);
	
	module.exports = [payment.fixOrderId, analytics.parseUtmFromQuery, utils.set('layout', 'payment'), utils.set('page.ui.atCenter', true), page.setCurrentPage, footer.setCopyrightYear, order.setOrderLocationToState(['payment', 'redirectLink']), utils.setFromArgsToState('redirectType', 'payment.alertType'), [payment.ifPaymentSuccessful, {
	    yes: [seo.setDashboardMeta('Успешная оплата', 'Оплата успешно завершена'), analytics.argsValueEvent({ category: 'post_successful_payment', action: 'see' })],
	    no: [seo.setDashboardMeta('Оплата не прошла', 'Не удалось завершить оплату')]
	}], analytics.pageview];

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	var content = __webpack_require__(20);
	var userGroup = __webpack_require__(45);
	var layoutGroup = __webpack_require__(36);
	var userForm = __webpack_require__(68);
	var passwordChange = __webpack_require__(198);
	var analytics = __webpack_require__(7);
	var seo = __webpack_require__(21);
	var registration = __webpack_require__(97);
	var error = __webpack_require__(19);
	
	module.exports = [analytics.parseUtmFromQuery].concat(userGroup.checkAuthCookie([].concat(userGroup.getUser)), userGroup.access('account', [utils.set('layout', 'main')].concat(layoutGroup.setMainLayoutBlocks, [[registration.getCountries, {
	    success: [utils.setFromArgsToState('countries', ['account', 'userForm', 'countries'])],
	    error: [error.internalError('personal.getCountries')]
	}], utils.setPopupVisibility('registrationCountryDropdown', ['account', 'userForm', 'popups', 'countryDropdown', 'isOpen']), seo.setDashboardMeta('Информация обо мне - Библиотека данных', 'Редактирование личной информации'), content.setComponentsByLink, [userForm.getCurrentUserData, {
	    success: [userForm.setComputedFields, userForm.initUserForm, passwordChange.setComputedFields, passwordChange.resetUserForm]
	}], analytics.pageview])));

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	var analytics = __webpack_require__(7);
	var content = __webpack_require__(20);
	var layoutGroup = __webpack_require__(36);
	var userGroup = __webpack_require__(45);
	var seo = __webpack_require__(21);
	
	module.exports = [analytics.parseUtmFromQuery].concat(userGroup.checkAuthCookie([].concat(userGroup.getUser)), [utils.set('layout', 'main')], layoutGroup.setMainLayoutBlocks, [seo.setDashboardMeta('Правила оказания онлайн-услуг - Библиотека данных', 'Правил оказания онлайн-услуг по формированию и предоставлению выборки данных в Библиотеке данных'), content.setComponentsByLink, analytics.pageview, utils.scrollTop]);

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	var analytics = __webpack_require__(7);
	var content = __webpack_require__(20);
	var layoutGroup = __webpack_require__(36);
	var userGroup = __webpack_require__(45);
	var seo = __webpack_require__(21);
	
	module.exports = [analytics.parseUtmFromQuery].concat(userGroup.checkAuthCookie([].concat(userGroup.getUser)), [utils.set('layout', 'main')], layoutGroup.setMainLayoutBlocks, [seo.setDashboardMeta('Обучающие видеоуроки - Библиотека данных', 'Обучающие видеоуроки о библиотеке данных'), content.setComponentsByLink, analytics.pageview]);

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	var redirect = __webpack_require__(35);
	
	module.exports = {
	    onRedirect: [utils.setArgFromState('url', ['payment', 'redirectLink']), utils.setArg('delay', 5000), redirect.redirectFromArgs]
	};

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var video = __webpack_require__(312);
	var bitrix = __webpack_require__(70);
	
	module.exports = {
	    onLoad: [video.addVideo, bitrix.resize]
	};

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(734);
	
	__webpack_require__(531);
	
	__webpack_require__(535);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 531 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _emmett = _interopRequireDefault(__webpack_require__(191));
	
	var _cursor = _interopRequireDefault(__webpack_require__(236));
	
	var _type = _interopRequireDefault(__webpack_require__(91));
	
	var _helpers = __webpack_require__(103);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	/**
	 * Watcher class.
	 *
	 * @constructor
	 * @param {Baobab} tree     - The watched tree.
	 * @param {object} mapping  - A mapping of the paths to watch in the tree.
	 */
	var Watcher =
	/*#__PURE__*/
	function (_Emitter) {
	  _inherits(Watcher, _Emitter);
	
	  function Watcher(tree, mapping) {
	    var _this;
	
	    _classCallCheck(this, Watcher);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Watcher).call(this)); // Properties
	
	    _this.tree = tree;
	    _this.mapping = null;
	    _this.state = {
	      killed: false
	    }; // Initializing
	
	    _this.refresh(mapping); // Listening
	
	
	    _this.handler = function (e) {
	      if (_this.state.killed) return;
	
	      var watchedPaths = _this.getWatchedPaths();
	
	      if ((0, _helpers.solveUpdate)(e.data.paths, watchedPaths)) return _this.emit('update');
	    };
	
	    _this.tree.on('update', _this.handler);
	
	    return _this;
	  }
	  /**
	   * Method used to get the current watched paths.
	   *
	   * @return {array} - The array of watched paths.
	   */
	
	
	  _createClass(Watcher, [{
	    key: "getWatchedPaths",
	    value: function getWatchedPaths() {
	      var _this2 = this;
	
	      var rawPaths = Object.keys(this.mapping).map(function (k) {
	        var v = _this2.mapping[k]; // Watcher mappings can accept a cursor
	
	        if (v instanceof _cursor["default"]) return v.solvedPath;
	        return _this2.mapping[k];
	      });
	      return rawPaths.reduce(function (cp, p) {
	        // Handling path polymorphisms
	        p = [].concat(p); // Dynamic path?
	
	        if (_type["default"].dynamicPath(p)) p = (0, _helpers.getIn)(_this2.tree._data, p).solvedPath;
	        if (!p) return cp; // Facet path?
	
	        var monkeyPath = _type["default"].monkeyPath(_this2.tree._monkeys, p);
	
	        if (monkeyPath) return cp.concat((0, _helpers.getIn)(_this2.tree._monkeys, monkeyPath).data.relatedPaths());
	        return cp.concat([p]);
	      }, []);
	    }
	    /**
	     * Method used to return a map of the watcher's cursors.
	     *
	     * @return {object} - TMap of relevant cursors.
	     */
	
	  }, {
	    key: "getCursors",
	    value: function getCursors() {
	      var _this3 = this;
	
	      var cursors = {};
	      Object.keys(this.mapping).forEach(function (k) {
	        var path = _this3.mapping[k];
	        if (path instanceof _cursor["default"]) cursors[k] = path;else cursors[k] = _this3.tree.select(path);
	      });
	      return cursors;
	    }
	    /**
	     * Method used to refresh the watcher's mapping.
	     *
	     * @param  {object}  mapping  - The new mapping to apply.
	     * @return {Watcher}          - Itself for chaining purposes.
	     */
	
	  }, {
	    key: "refresh",
	    value: function refresh(mapping) {
	      if (!_type["default"].watcherMapping(mapping)) throw (0, _helpers.makeError)('Baobab.watch: invalid mapping.', {
	        mapping: mapping
	      });
	      this.mapping = mapping; // Creating the get method
	
	      var projection = {};
	
	      for (var k in mapping) {
	        projection[k] = mapping[k] instanceof _cursor["default"] ? mapping[k].path : mapping[k];
	      }
	
	      this.get = this.tree.project.bind(this.tree, projection);
	    }
	    /**
	     * Methods releasing the watcher from memory.
	     */
	
	  }, {
	    key: "release",
	    value: function release() {
	      this.tree.off('update', this.handler);
	      this.state.killed = true;
	      this.kill();
	    }
	  }]);
	
	  return Watcher;
	}(_emmett["default"]);
	
	exports["default"] = Watcher;

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(135);
	
	var $apply = __webpack_require__(238);
	var $call = __webpack_require__(163);
	var $reflectApply = __webpack_require__(534);
	
	/** @type {import('./actualApply')} */
	module.exports = $reflectApply || bind.call($call, $apply);


/***/ }),
/* 534 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./reflectApply')} */
	module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(542);
	module.exports = __webpack_require__(47).RegExp.escape;


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(10);
	var isArray = __webpack_require__(123);
	var SPECIES = __webpack_require__(13)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(9);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(6);
	var toPrimitive = __webpack_require__(54);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(80);
	var gOPS = __webpack_require__(127);
	var pIE = __webpack_require__(106);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(107)('native-function-to-string', Function.toString);


/***/ }),
/* 541 */
/***/ (function(module, exports) {

	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(2);
	var $re = __webpack_require__(541)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(2);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(242) });
	
	__webpack_require__(65)('copyWithin');


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $every = __webpack_require__(51)(4);
	
	$export($export.P + $export.F * !__webpack_require__(49)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(2);
	
	$export($export.P, 'Array', { fill: __webpack_require__(165) });
	
	__webpack_require__(65)('fill');


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $filter = __webpack_require__(51)(2);
	
	$export($export.P + $export.F * !__webpack_require__(49)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(2);
	var $find = __webpack_require__(51)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(65)(KEY);


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(2);
	var $find = __webpack_require__(51)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(65)(KEY);


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $forEach = __webpack_require__(51)(0);
	var STRICT = __webpack_require__(49)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(48);
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(18);
	var call = __webpack_require__(253);
	var isArrayIter = __webpack_require__(173);
	var toLength = __webpack_require__(14);
	var createProperty = __webpack_require__(167);
	var getIterFn = __webpack_require__(189);
	
	$export($export.S + $export.F * !__webpack_require__(125)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $indexOf = __webpack_require__(120)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(49)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(123) });


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(2);
	var toIObject = __webpack_require__(40);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(105) != Object || !__webpack_require__(49)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toIObject = __webpack_require__(40);
	var toInteger = __webpack_require__(50);
	var toLength = __webpack_require__(14);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(49)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $map = __webpack_require__(51)(1);
	
	$export($export.P + $export.F * !__webpack_require__(49)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var createProperty = __webpack_require__(167);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(9)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $reduce = __webpack_require__(244);
	
	$export($export.P + $export.F * !__webpack_require__(49)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $reduce = __webpack_require__(244);
	
	$export($export.P + $export.F * !__webpack_require__(49)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var html = __webpack_require__(171);
	var cof = __webpack_require__(46);
	var toAbsoluteIndex = __webpack_require__(84);
	var toLength = __webpack_require__(14);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(9)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $some = __webpack_require__(51)(3);
	
	$export($export.P + $export.F * !__webpack_require__(49)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var aFunction = __webpack_require__(25);
	var toObject = __webpack_require__(18);
	var fails = __webpack_require__(9);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(49)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(83)('Array');


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(2);
	var toISOString = __webpack_require__(537);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(18);
	var toPrimitive = __webpack_require__(54);
	
	$export($export.P + $export.F * __webpack_require__(9)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(13)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(31)(proto, TO_PRIMITIVE, __webpack_require__(538));


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(32)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(2);
	
	$export($export.P, 'Function', { bind: __webpack_require__(245) });


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(10);
	var getPrototypeOf = __webpack_require__(39);
	var HAS_INSTANCE = __webpack_require__(13)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(17).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(17).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(16) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(2);
	var log1p = __webpack_require__(256);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(2);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(2);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(2);
	var sign = __webpack_require__(177);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(2);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(2);
	var $expm1 = __webpack_require__(176);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { fround: __webpack_require__(255) });


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(2);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(2);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(9)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(256) });


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { sign: __webpack_require__(177) });


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(2);
	var expm1 = __webpack_require__(176);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(9)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(2);
	var expm1 = __webpack_require__(176);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(8);
	var has = __webpack_require__(37);
	var cof = __webpack_require__(46);
	var inheritIfRequired = __webpack_require__(172);
	var toPrimitive = __webpack_require__(54);
	var fails = __webpack_require__(9);
	var gOPN = __webpack_require__(79).f;
	var gOPD = __webpack_require__(38).f;
	var dP = __webpack_require__(17).f;
	var $trim = __webpack_require__(95).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(78)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(16) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(32)(global, NUMBER, $Number);
	}


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(2);
	var _isFinite = __webpack_require__(8).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(252) });


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(2);
	var isInteger = __webpack_require__(252);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var $parseFloat = __webpack_require__(264);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var $parseInt = __webpack_require__(265);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toInteger = __webpack_require__(50);
	var aNumberValue = __webpack_require__(241);
	var repeat = __webpack_require__(184);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(9)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $fails = __webpack_require__(9);
	var aNumberValue = __webpack_require__(241);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(2);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(258) });


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(78) });


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(16), 'Object', { defineProperties: __webpack_require__(259) });


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(16), 'Object', { defineProperty: __webpack_require__(17).f });


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(10);
	var meta = __webpack_require__(67).onFreeze;
	
	__webpack_require__(53)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(40);
	var $getOwnPropertyDescriptor = __webpack_require__(38).f;
	
	__webpack_require__(53)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(53)('getOwnPropertyNames', function () {
	  return __webpack_require__(260).f;
	});


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(18);
	var $getPrototypeOf = __webpack_require__(39);
	
	__webpack_require__(53)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(10);
	
	__webpack_require__(53)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(10);
	
	__webpack_require__(53)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(10);
	
	__webpack_require__(53)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(2);
	$export($export.S, 'Object', { is: __webpack_require__(268) });


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(18);
	var $keys = __webpack_require__(80);
	
	__webpack_require__(53)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(10);
	var meta = __webpack_require__(67).onFreeze;
	
	__webpack_require__(53)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(10);
	var meta = __webpack_require__(67).onFreeze;
	
	__webpack_require__(53)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(2);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(181).set });


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(92);
	var test = {};
	test[__webpack_require__(13)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(32)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var $parseFloat = __webpack_require__(264);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var $parseInt = __webpack_require__(265);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(66);
	var global = __webpack_require__(8);
	var ctx = __webpack_require__(48);
	var classof = __webpack_require__(92);
	var $export = __webpack_require__(2);
	var isObject = __webpack_require__(10);
	var aFunction = __webpack_require__(25);
	var anInstance = __webpack_require__(76);
	var forOf = __webpack_require__(77);
	var speciesConstructor = __webpack_require__(108);
	var task = __webpack_require__(186).set;
	var microtask = __webpack_require__(178)();
	var newPromiseCapabilityModule = __webpack_require__(179);
	var perform = __webpack_require__(266);
	var userAgent = __webpack_require__(133);
	var promiseResolve = __webpack_require__(267);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(13)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(82)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(94)($Promise, PROMISE);
	__webpack_require__(83)(PROMISE);
	Wrapper = __webpack_require__(47)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(125)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(2);
	var aFunction = __webpack_require__(25);
	var anObject = __webpack_require__(6);
	var rApply = (__webpack_require__(8).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(9)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(2);
	var create = __webpack_require__(78);
	var aFunction = __webpack_require__(25);
	var anObject = __webpack_require__(6);
	var isObject = __webpack_require__(10);
	var fails = __webpack_require__(9);
	var bind = __webpack_require__(245);
	var rConstruct = (__webpack_require__(8).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(17);
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(6);
	var toPrimitive = __webpack_require__(54);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(9)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(2);
	var gOPD = __webpack_require__(38).f;
	var anObject = __webpack_require__(6);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(6);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(174)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(38);
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(6);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(2);
	var getProto = __webpack_require__(39);
	var anObject = __webpack_require__(6);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(38);
	var getPrototypeOf = __webpack_require__(39);
	var has = __webpack_require__(37);
	var $export = __webpack_require__(2);
	var isObject = __webpack_require__(10);
	var anObject = __webpack_require__(6);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(6);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(263) });


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(6);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(2);
	var setProto = __webpack_require__(181);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(17);
	var gOPD = __webpack_require__(38);
	var getPrototypeOf = __webpack_require__(39);
	var has = __webpack_require__(37);
	var $export = __webpack_require__(2);
	var createDesc = __webpack_require__(81);
	var anObject = __webpack_require__(6);
	var isObject = __webpack_require__(10);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
	      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
	      existingDescriptor.value = V;
	      dP.f(receiver, propertyKey, existingDescriptor);
	    } else dP.f(receiver, propertyKey, createDesc(0, V));
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(8);
	var inheritIfRequired = __webpack_require__(172);
	var dP = __webpack_require__(17).f;
	var gOPN = __webpack_require__(79).f;
	var isRegExp = __webpack_require__(124);
	var $flags = __webpack_require__(104);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(16) && (!CORRECT_NEW || __webpack_require__(9)(function () {
	  re2[__webpack_require__(13)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(32)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(83)('RegExp');


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(6);
	var toLength = __webpack_require__(14);
	var advanceStringIndex = __webpack_require__(164);
	var regExpExec = __webpack_require__(128);
	
	// @@match logic
	__webpack_require__(122)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
	  return [
	    // `String.prototype.match` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.match
	    function match(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[MATCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	    },
	    // `RegExp.prototype[@@match]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
	    function (regexp) {
	      var res = maybeCallNative($match, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      if (!rx.global) return regExpExec(rx, S);
	      var fullUnicode = rx.unicode;
	      rx.lastIndex = 0;
	      var A = [];
	      var n = 0;
	      var result;
	      while ((result = regExpExec(rx, S)) !== null) {
	        var matchStr = String(result[0]);
	        A[n] = matchStr;
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	        n++;
	      }
	      return n === 0 ? null : A;
	    }
	  ];
	});


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(6);
	var toObject = __webpack_require__(18);
	var toLength = __webpack_require__(14);
	var toInteger = __webpack_require__(50);
	var advanceStringIndex = __webpack_require__(164);
	var regExpExec = __webpack_require__(128);
	var max = Math.max;
	var min = Math.min;
	var floor = Math.floor;
	var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
	var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;
	
	var maybeToString = function (it) {
	  return it === undefined ? it : String(it);
	};
	
	// @@replace logic
	__webpack_require__(122)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
	  return [
	    // `String.prototype.replace` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
	    function replace(searchValue, replaceValue) {
	      var O = defined(this);
	      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	      return fn !== undefined
	        ? fn.call(searchValue, O, replaceValue)
	        : $replace.call(String(O), searchValue, replaceValue);
	    },
	    // `RegExp.prototype[@@replace]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
	    function (regexp, replaceValue) {
	      var res = maybeCallNative($replace, regexp, this, replaceValue);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var functionalReplace = typeof replaceValue === 'function';
	      if (!functionalReplace) replaceValue = String(replaceValue);
	      var global = rx.global;
	      if (global) {
	        var fullUnicode = rx.unicode;
	        rx.lastIndex = 0;
	      }
	      var results = [];
	      while (true) {
	        var result = regExpExec(rx, S);
	        if (result === null) break;
	        results.push(result);
	        if (!global) break;
	        var matchStr = String(result[0]);
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	      }
	      var accumulatedResult = '';
	      var nextSourcePosition = 0;
	      for (var i = 0; i < results.length; i++) {
	        result = results[i];
	        var matched = String(result[0]);
	        var position = max(min(toInteger(result.index), S.length), 0);
	        var captures = [];
	        // NOTE: This is equivalent to
	        //   captures = result.slice(1).map(maybeToString)
	        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
	        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
	        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
	        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
	        var namedCaptures = result.groups;
	        if (functionalReplace) {
	          var replacerArgs = [matched].concat(captures, position, S);
	          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
	          var replacement = String(replaceValue.apply(undefined, replacerArgs));
	        } else {
	          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
	        }
	        if (position >= nextSourcePosition) {
	          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
	          nextSourcePosition = position + matched.length;
	        }
	      }
	      return accumulatedResult + S.slice(nextSourcePosition);
	    }
	  ];
	
	    // https://tc39.github.io/ecma262/#sec-getsubstitution
	  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
	    var tailPos = position + matched.length;
	    var m = captures.length;
	    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
	    if (namedCaptures !== undefined) {
	      namedCaptures = toObject(namedCaptures);
	      symbols = SUBSTITUTION_SYMBOLS;
	    }
	    return $replace.call(replacement, symbols, function (match, ch) {
	      var capture;
	      switch (ch.charAt(0)) {
	        case '$': return '$';
	        case '&': return matched;
	        case '`': return str.slice(0, position);
	        case "'": return str.slice(tailPos);
	        case '<':
	          capture = namedCaptures[ch.slice(1, -1)];
	          break;
	        default: // \d\d?
	          var n = +ch;
	          if (n === 0) return match;
	          if (n > m) {
	            var f = floor(n / 10);
	            if (f === 0) return match;
	            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
	            return match;
	          }
	          capture = captures[n - 1];
	      }
	      return capture === undefined ? '' : capture;
	    });
	  }
	});


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(6);
	var sameValue = __webpack_require__(268);
	var regExpExec = __webpack_require__(128);
	
	// @@search logic
	__webpack_require__(122)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
	  return [
	    // `String.prototype.search` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.search
	    function search(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[SEARCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	    },
	    // `RegExp.prototype[@@search]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
	    function (regexp) {
	      var res = maybeCallNative($search, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      var previousLastIndex = rx.lastIndex;
	      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
	      var result = regExpExec(rx, S);
	      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
	      return result === null ? -1 : result.index;
	    }
	  ];
	});


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isRegExp = __webpack_require__(124);
	var anObject = __webpack_require__(6);
	var speciesConstructor = __webpack_require__(108);
	var advanceStringIndex = __webpack_require__(164);
	var toLength = __webpack_require__(14);
	var callRegExpExec = __webpack_require__(128);
	var regexpExec = __webpack_require__(180);
	var fails = __webpack_require__(9);
	var $min = Math.min;
	var $push = [].push;
	var $SPLIT = 'split';
	var LENGTH = 'length';
	var LAST_INDEX = 'lastIndex';
	var MAX_UINT32 = 0xffffffff;
	
	// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
	var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });
	
	// @@split logic
	__webpack_require__(122)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
	  var internalSplit;
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    // based on es5-shim implementation, need to rework it
	    internalSplit = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return $split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var match, lastIndex, lastLength;
	      while (match = regexpExec.call(separatorCopy, string)) {
	        lastIndex = separatorCopy[LAST_INDEX];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    internalSplit = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
	    };
	  } else {
	    internalSplit = $split;
	  }
	
	  return [
	    // `String.prototype.split` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.split
	    function split(separator, limit) {
	      var O = defined(this);
	      var splitter = separator == undefined ? undefined : separator[SPLIT];
	      return splitter !== undefined
	        ? splitter.call(separator, O, limit)
	        : internalSplit.call(String(O), separator, limit);
	    },
	    // `RegExp.prototype[@@split]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
	    //
	    // NOTE: This cannot be properly polyfilled in engines that don't support
	    // the 'y' flag.
	    function (regexp, limit) {
	      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var C = speciesConstructor(rx, RegExp);
	
	      var unicodeMatching = rx.unicode;
	      var flags = (rx.ignoreCase ? 'i' : '') +
	                  (rx.multiline ? 'm' : '') +
	                  (rx.unicode ? 'u' : '') +
	                  (SUPPORTS_Y ? 'y' : 'g');
	
	      // ^(? + rx + ) is needed, in combination with some S slicing, to
	      // simulate the 'y' flag.
	      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
	      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      if (lim === 0) return [];
	      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
	      var p = 0;
	      var q = 0;
	      var A = [];
	      while (q < S.length) {
	        splitter.lastIndex = SUPPORTS_Y ? q : 0;
	        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
	        var e;
	        if (
	          z === null ||
	          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
	        ) {
	          q = advanceStringIndex(S, q, unicodeMatching);
	        } else {
	          A.push(S.slice(p, q));
	          if (A.length === lim) return A;
	          for (var i = 1; i <= z.length - 1; i++) {
	            A.push(z[i]);
	            if (A.length === lim) return A;
	          }
	          q = p = e;
	        }
	      }
	      A.push(S.slice(p));
	      return A;
	    }
	  ];
	});


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(274);
	var anObject = __webpack_require__(6);
	var $flags = __webpack_require__(104);
	var DESCRIPTORS = __webpack_require__(16);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(32)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(9)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(33)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(33)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(33)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(33)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $at = __webpack_require__(131)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(2);
	var toLength = __webpack_require__(14);
	var context = __webpack_require__(183);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(170)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(33)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(33)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(33)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var toAbsoluteIndex = __webpack_require__(84);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(2);
	var context = __webpack_require__(183);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(170)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(33)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(131)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(175)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(33)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var toIObject = __webpack_require__(40);
	var toLength = __webpack_require__(14);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(184)
	});


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(33)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(2);
	var toLength = __webpack_require__(14);
	var context = __webpack_require__(183);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(170)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(33)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(33)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(33)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(95)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(8);
	var has = __webpack_require__(37);
	var DESCRIPTORS = __webpack_require__(16);
	var $export = __webpack_require__(2);
	var redefine = __webpack_require__(32);
	var META = __webpack_require__(67).KEY;
	var $fails = __webpack_require__(9);
	var shared = __webpack_require__(107);
	var setToStringTag = __webpack_require__(94);
	var uid = __webpack_require__(85);
	var wks = __webpack_require__(13);
	var wksExt = __webpack_require__(271);
	var wksDefine = __webpack_require__(188);
	var enumKeys = __webpack_require__(539);
	var isArray = __webpack_require__(123);
	var anObject = __webpack_require__(6);
	var isObject = __webpack_require__(10);
	var toObject = __webpack_require__(18);
	var toIObject = __webpack_require__(40);
	var toPrimitive = __webpack_require__(54);
	var createDesc = __webpack_require__(81);
	var _create = __webpack_require__(78);
	var gOPNExt = __webpack_require__(260);
	var $GOPD = __webpack_require__(38);
	var $GOPS = __webpack_require__(127);
	var $DP = __webpack_require__(17);
	var $keys = __webpack_require__(80);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(79).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(106).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(66)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(31)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $typed = __webpack_require__(132);
	var buffer = __webpack_require__(187);
	var anObject = __webpack_require__(6);
	var toAbsoluteIndex = __webpack_require__(84);
	var toLength = __webpack_require__(14);
	var isObject = __webpack_require__(10);
	var ArrayBuffer = __webpack_require__(8).ArrayBuffer;
	var speciesConstructor = __webpack_require__(108);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(9)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < fin) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(83)(ARRAY_BUFFER);


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	$export($export.G + $export.W + $export.F * !__webpack_require__(132).ABV, {
	  DataView: __webpack_require__(187).DataView
	});


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(60)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(60)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(60)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(60)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(60)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(60)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(60)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(60)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(60)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(248);
	var validate = __webpack_require__(86);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(121)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(2);
	var flattenIntoArray = __webpack_require__(249);
	var toObject = __webpack_require__(18);
	var toLength = __webpack_require__(14);
	var aFunction = __webpack_require__(25);
	var arraySpeciesCreate = __webpack_require__(166);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(65)('flatMap');


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(2);
	var flattenIntoArray = __webpack_require__(249);
	var toObject = __webpack_require__(18);
	var toLength = __webpack_require__(14);
	var toInteger = __webpack_require__(50);
	var arraySpeciesCreate = __webpack_require__(166);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(65)('flatten');


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(2);
	var $includes = __webpack_require__(120)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(65)('includes');


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(2);
	var microtask = __webpack_require__(178)();
	var process = __webpack_require__(8).process;
	var isNode = __webpack_require__(46)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(2);
	var cof = __webpack_require__(46);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(2);
	
	$export($export.G, { global: __webpack_require__(8) });


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(129)('Map');


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(130)('Map');


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(2);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(247)('Map') });


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	var scale = __webpack_require__(257);
	var fround = __webpack_require__(255);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { scale: __webpack_require__(257) });


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	} });


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(18);
	var aFunction = __webpack_require__(25);
	var $defineProperty = __webpack_require__(17);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(16) && $export($export.P + __webpack_require__(126), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(18);
	var aFunction = __webpack_require__(25);
	var $defineProperty = __webpack_require__(17);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(16) && $export($export.P + __webpack_require__(126), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(2);
	var $entries = __webpack_require__(262)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(2);
	var ownKeys = __webpack_require__(263);
	var toIObject = __webpack_require__(40);
	var gOPD = __webpack_require__(38);
	var createProperty = __webpack_require__(167);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(18);
	var toPrimitive = __webpack_require__(54);
	var getPrototypeOf = __webpack_require__(39);
	var getOwnPropertyDescriptor = __webpack_require__(38).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(16) && $export($export.P + __webpack_require__(126), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(18);
	var toPrimitive = __webpack_require__(54);
	var getPrototypeOf = __webpack_require__(39);
	var getOwnPropertyDescriptor = __webpack_require__(38).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(16) && $export($export.P + __webpack_require__(126), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(2);
	var $values = __webpack_require__(262)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export = __webpack_require__(2);
	var global = __webpack_require__(8);
	var core = __webpack_require__(47);
	var microtask = __webpack_require__(178)();
	var OBSERVABLE = __webpack_require__(13)('observable');
	var aFunction = __webpack_require__(25);
	var anObject = __webpack_require__(6);
	var anInstance = __webpack_require__(76);
	var redefineAll = __webpack_require__(82);
	var hide = __webpack_require__(31);
	var forOf = __webpack_require__(77);
	var RETURN = forOf.RETURN;
	
	var getMethod = function (fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function (subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function (subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function (subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function (observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  } if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() { closeSubscription(this); }
	});
	
	var SubscriptionObserver = function (subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function (value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () { return this; });
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(83)('Observable');


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(2);
	var core = __webpack_require__(47);
	var global = __webpack_require__(8);
	var speciesConstructor = __webpack_require__(108);
	var promiseResolve = __webpack_require__(267);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(2);
	var newPromiseCapability = __webpack_require__(179);
	var perform = __webpack_require__(266);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(59);
	var anObject = __webpack_require__(6);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	} });


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(59);
	var anObject = __webpack_require__(6);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	  if (metadataMap.size) return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	} });


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(275);
	var from = __webpack_require__(243);
	var metadata = __webpack_require__(59);
	var anObject = __webpack_require__(6);
	var getPrototypeOf = __webpack_require__(39);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function (O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(59);
	var anObject = __webpack_require__(6);
	var getPrototypeOf = __webpack_require__(39);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(59);
	var anObject = __webpack_require__(6);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(59);
	var anObject = __webpack_require__(6);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(59);
	var anObject = __webpack_require__(6);
	var getPrototypeOf = __webpack_require__(39);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(59);
	var anObject = __webpack_require__(6);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	var $metadata = __webpack_require__(59);
	var anObject = __webpack_require__(6);
	var aFunction = __webpack_require__(25);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	  return function decorator(target, targetKey) {
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	} });


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(129)('Set');


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(130)('Set');


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(2);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(247)('Set') });


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(2);
	var $at = __webpack_require__(131)(true);
	var $fails = __webpack_require__(9);
	
	var FORCED = $fails(function () {
	  return '𠮷'.at(0) !== '𠮷';
	});
	
	$export($export.P + $export.F * FORCED, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export = __webpack_require__(2);
	var defined = __webpack_require__(52);
	var toLength = __webpack_require__(14);
	var isRegExp = __webpack_require__(124);
	var getFlags = __webpack_require__(104);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function (regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(174)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(2);
	var $pad = __webpack_require__(269);
	var userAgent = __webpack_require__(133);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(2);
	var $pad = __webpack_require__(269);
	var userAgent = __webpack_require__(133);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(95)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(95)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(188)('asyncIterator');


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(188)('observable');


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(2);
	
	$export($export.S, 'System', { global: __webpack_require__(8) });


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(129)('WeakMap');


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(130)('WeakMap');


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(129)('WeakSet');


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(130)('WeakSet');


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(190);
	var getKeys = __webpack_require__(80);
	var redefine = __webpack_require__(32);
	var global = __webpack_require__(8);
	var hide = __webpack_require__(31);
	var Iterators = __webpack_require__(93);
	var wks = __webpack_require__(13);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var $task = __webpack_require__(186);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(8);
	var $export = __webpack_require__(2);
	var userAgent = __webpack_require__(133);
	var slice = [].slice;
	var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(662);
	__webpack_require__(601);
	__webpack_require__(603);
	__webpack_require__(602);
	__webpack_require__(605);
	__webpack_require__(607);
	__webpack_require__(612);
	__webpack_require__(606);
	__webpack_require__(604);
	__webpack_require__(614);
	__webpack_require__(613);
	__webpack_require__(609);
	__webpack_require__(610);
	__webpack_require__(608);
	__webpack_require__(600);
	__webpack_require__(611);
	__webpack_require__(615);
	__webpack_require__(616);
	__webpack_require__(568);
	__webpack_require__(570);
	__webpack_require__(569);
	__webpack_require__(618);
	__webpack_require__(617);
	__webpack_require__(588);
	__webpack_require__(598);
	__webpack_require__(599);
	__webpack_require__(589);
	__webpack_require__(590);
	__webpack_require__(591);
	__webpack_require__(592);
	__webpack_require__(593);
	__webpack_require__(594);
	__webpack_require__(595);
	__webpack_require__(596);
	__webpack_require__(597);
	__webpack_require__(571);
	__webpack_require__(572);
	__webpack_require__(573);
	__webpack_require__(574);
	__webpack_require__(575);
	__webpack_require__(576);
	__webpack_require__(577);
	__webpack_require__(578);
	__webpack_require__(579);
	__webpack_require__(580);
	__webpack_require__(581);
	__webpack_require__(582);
	__webpack_require__(583);
	__webpack_require__(584);
	__webpack_require__(585);
	__webpack_require__(586);
	__webpack_require__(587);
	__webpack_require__(649);
	__webpack_require__(654);
	__webpack_require__(661);
	__webpack_require__(652);
	__webpack_require__(644);
	__webpack_require__(645);
	__webpack_require__(650);
	__webpack_require__(655);
	__webpack_require__(657);
	__webpack_require__(640);
	__webpack_require__(641);
	__webpack_require__(642);
	__webpack_require__(643);
	__webpack_require__(646);
	__webpack_require__(647);
	__webpack_require__(648);
	__webpack_require__(651);
	__webpack_require__(653);
	__webpack_require__(656);
	__webpack_require__(658);
	__webpack_require__(659);
	__webpack_require__(660);
	__webpack_require__(563);
	__webpack_require__(565);
	__webpack_require__(564);
	__webpack_require__(567);
	__webpack_require__(566);
	__webpack_require__(552);
	__webpack_require__(550);
	__webpack_require__(556);
	__webpack_require__(553);
	__webpack_require__(559);
	__webpack_require__(561);
	__webpack_require__(549);
	__webpack_require__(555);
	__webpack_require__(546);
	__webpack_require__(560);
	__webpack_require__(544);
	__webpack_require__(558);
	__webpack_require__(557);
	__webpack_require__(551);
	__webpack_require__(554);
	__webpack_require__(543);
	__webpack_require__(545);
	__webpack_require__(548);
	__webpack_require__(547);
	__webpack_require__(562);
	__webpack_require__(190);
	__webpack_require__(634);
	__webpack_require__(273);
	__webpack_require__(639);
	__webpack_require__(274);
	__webpack_require__(635);
	__webpack_require__(636);
	__webpack_require__(637);
	__webpack_require__(638);
	__webpack_require__(619);
	__webpack_require__(272);
	__webpack_require__(275);
	__webpack_require__(276);
	__webpack_require__(674);
	__webpack_require__(663);
	__webpack_require__(664);
	__webpack_require__(669);
	__webpack_require__(672);
	__webpack_require__(673);
	__webpack_require__(667);
	__webpack_require__(670);
	__webpack_require__(668);
	__webpack_require__(671);
	__webpack_require__(665);
	__webpack_require__(666);
	__webpack_require__(620);
	__webpack_require__(621);
	__webpack_require__(622);
	__webpack_require__(623);
	__webpack_require__(624);
	__webpack_require__(627);
	__webpack_require__(625);
	__webpack_require__(626);
	__webpack_require__(628);
	__webpack_require__(629);
	__webpack_require__(630);
	__webpack_require__(631);
	__webpack_require__(633);
	__webpack_require__(632);
	__webpack_require__(677);
	__webpack_require__(675);
	__webpack_require__(676);
	__webpack_require__(718);
	__webpack_require__(721);
	__webpack_require__(720);
	__webpack_require__(722);
	__webpack_require__(723);
	__webpack_require__(719);
	__webpack_require__(724);
	__webpack_require__(725);
	__webpack_require__(699);
	__webpack_require__(702);
	__webpack_require__(698);
	__webpack_require__(696);
	__webpack_require__(697);
	__webpack_require__(700);
	__webpack_require__(701);
	__webpack_require__(683);
	__webpack_require__(717);
	__webpack_require__(682);
	__webpack_require__(716);
	__webpack_require__(728);
	__webpack_require__(730);
	__webpack_require__(681);
	__webpack_require__(715);
	__webpack_require__(727);
	__webpack_require__(729);
	__webpack_require__(680);
	__webpack_require__(726);
	__webpack_require__(679);
	__webpack_require__(684);
	__webpack_require__(685);
	__webpack_require__(686);
	__webpack_require__(687);
	__webpack_require__(688);
	__webpack_require__(690);
	__webpack_require__(689);
	__webpack_require__(691);
	__webpack_require__(692);
	__webpack_require__(693);
	__webpack_require__(695);
	__webpack_require__(694);
	__webpack_require__(704);
	__webpack_require__(705);
	__webpack_require__(706);
	__webpack_require__(707);
	__webpack_require__(709);
	__webpack_require__(708);
	__webpack_require__(711);
	__webpack_require__(710);
	__webpack_require__(712);
	__webpack_require__(713);
	__webpack_require__(714);
	__webpack_require__(678);
	__webpack_require__(703);
	__webpack_require__(733);
	__webpack_require__(732);
	__webpack_require__(731);
	module.exports = __webpack_require__(47);


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var callBind = __webpack_require__(239);
	var gOPD = __webpack_require__(277);
	
	var hasProtoAccessor;
	try {
		// eslint-disable-next-line no-extra-parens, no-proto
		hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ ([]).__proto__ === Array.prototype;
	} catch (e) {
		if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') {
			throw e;
		}
	}
	
	// eslint-disable-next-line no-extra-parens
	var desc = !!hasProtoAccessor && gOPD && gOPD(Object.prototype, /** @type {keyof typeof Object.prototype} */ ('__proto__'));
	
	var $Object = Object;
	var $getPrototypeOf = $Object.getPrototypeOf;
	
	/** @type {import('./get')} */
	module.exports = desc && typeof desc.get === 'function'
		? callBind([desc.get])
		: typeof $getPrototypeOf === 'function'
			? /** @type {import('./get')} */ function getDunder(value) {
				// eslint-disable-next-line eqeqeq
				return $getPrototypeOf(value == null ? value : $Object(value));
			}
			: false;


/***/ }),
/* 736 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('.')} */
	var $defineProperty = Object.defineProperty || false;
	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
		} catch (e) {
			// IE 8 has a broken defineProperty
			$defineProperty = false;
		}
	}
	
	module.exports = $defineProperty;


/***/ }),
/* 737 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./eval')} */
	module.exports = EvalError;


/***/ }),
/* 738 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('.')} */
	module.exports = Error;


/***/ }),
/* 739 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./range')} */
	module.exports = RangeError;


/***/ }),
/* 740 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./ref')} */
	module.exports = ReferenceError;


/***/ }),
/* 741 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./syntax')} */
	module.exports = SyntaxError;


/***/ }),
/* 742 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./uri')} */
	module.exports = URIError;


/***/ }),
/* 743 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('.')} */
	module.exports = Object;


/***/ }),
/* 744 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ }),
/* 745 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"content":"account__content-3nRgr blocks__content--MOaB","orderCreator":"account__orderCreator-3gYjM"};

/***/ }),
/* 746 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"content__block-1kcGS"};

/***/ }),
/* 747 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"licenseBlock":"action-panel__licenseBlock-37HCA","licenseCheckbox":"action-panel__licenseCheckbox-1OqN9","continueButton":"action-panel__continueButton-2T9lf blocks__huge-2XOet blocks__green-2w7kK blocks__button-1iODk","makeOrderButton":"action-panel__makeOrderButton-xp_s2 blocks__huge-2XOet blocks__green-2w7kK blocks__button-1iODk","payOnlineButton":"action-panel__payOnlineButton-PgvSG blocks__huge-2XOet blocks__green-2w7kK blocks__button-1iODk","saveAllButton":"action-panel__saveAllButton-O4W4R blocks__huge-2XOet blocks__green-2w7kK blocks__button-1iODk","cancelAllButton":"action-panel__cancelAllButton-jNqi2 blocks__huge-2XOet blocks__white-2DChO blocks__button-1iODk","cancelButton":"action-panel__cancelButton-29csO blocks__huge-2XOet blocks__white-2DChO blocks__button-1iODk","repeatOrderButton":"action-panel__repeatOrderButton-1nUBV blocks__huge-2XOet blocks__blue-tjpdI blocks__button-1iODk","redirectToLeadsMapping":"action-panel__redirectToLeadsMapping-1kUn6 blocks__huge-2XOet blocks__blue-tjpdI blocks__button-1iODk","redirectToLeadsMappingFree":"action-panel__redirectToLeadsMappingFree-11H8u blocks__huge-2XOet blocks__blue-tjpdI blocks__button-1iODk","tooltip":"action-panel__tooltip-1cJVu blocks__tooltip-20lA1 blocks__leftToRight-v7Jyh blocks__error-2TffC blocks__isShown--23z3","licenseTooltip":"action-panel__licenseTooltip-JmWPi","tooltipWrapper":"action-panel__tooltipWrapper-8HnvZ","repeatTooltipWrapper":"action-panel__repeatTooltipWrapper-2dwVz","repeatTooltip":"action-panel__repeatTooltip-2Wz6b blocks__tooltip-20lA1 blocks__isShown--23z3","bitrixFreeTooltip":"action-panel__bitrixFreeTooltip-150PD","link":"action-panel__link-2sbR3","redirect":"action-panel__redirect-XDYwG"};

/***/ }),
/* 748 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"paymentForm":"payment-form__paymentForm-1vOqU","payOnline":"payment-form__payOnline-L-a5C blocks__huge-2XOet blocks__green-2w7kK blocks__button-1iODk"};

/***/ }),
/* 749 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"exportButton":"action-panel__exportButton-29-qy blocks__huge-2XOet blocks__green-2w7kK blocks__button-1iODk","backButton":"action-panel__backButton-Amj9H blocks__huge-2XOet blocks__white-2DChO blocks__button-1iODk","openCrmLeadButton":"action-panel__openCrmLeadButton-35NPa blocks__huge-2XOet blocks__white-2DChO blocks__button-1iODk"};

/***/ }),
/* 750 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"content":"bitrix-export-leads__content-MdjIh","field":"bitrix-export-leads__field-d_wKE","title":"bitrix-export-leads__title-3raqM","listBox":"bitrix-export-leads__listBox-2LL8h","controls":"bitrix-export-leads__controls-3-TcY","header":"bitrix-export-leads__header-2F-9l","fields":"bitrix-export-leads__fields-1ZT_B","line":"bitrix-export-leads__line-2Rxt3","progress":"bitrix-export-leads__progress-2KmGo","tooltip":"bitrix-export-leads__tooltip-tAnCI","error":"bitrix-export-leads__error-2ETiB","checkboxBlock":"bitrix-export-leads__checkboxBlock-2pTWj","mainTitle":"bitrix-export-leads__mainTitle-YnMqa"};

/***/ }),
/* 751 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"error":"error-tooltip__error-3R77x"};

/***/ }),
/* 752 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"toggleNew":"field-mapping__toggleNew-26Br_","delete":"field-mapping__delete-Y-9d2","control":"field-mapping__control-3r3IY","tooltipWrapper":"field-mapping__tooltipWrapper-1d6ol","tooltip":"field-mapping__tooltip-pG8XZ blocks__tooltip-20lA1 blocks__isShown--23z3"};

/***/ }),
/* 753 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"progressBar":"progress-bar__progressBar-3zGi0","progressBarInner":"progress-bar__progressBarInner-DtzZ_","progressPercentage":"progress-bar__progressPercentage-j74TP","progressName":"progress-bar__progressName-_vFZ3"};

/***/ }),
/* 754 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"field":"required-fields-mapping__field-1i3V7 bitrix-export-leads__field-d_wKE","title":"required-fields-mapping__title-3mrI6 bitrix-export-leads__title-3raqM","listBox":"required-fields-mapping__listBox-12nKu bitrix-export-leads__listBox-2LL8h","content":"required-fields-mapping__content-33MDR","description":"required-fields-mapping__description-30eZO"};

/***/ }),
/* 755 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"order":"current-order__order-1JbCs","optionsBlock":"current-order__optionsBlock-3ntCI","headerWrapper":"current-order__headerWrapper-QO-QS","header":"current-order__header-1ZHHc","isSticked":"current-order__isSticked-1_eHk","isSticked2":"current-order__isSticked2-2kmvj","individualOrderParameters":"current-order__individualOrderParameters-wa14r","orderParameters":"current-order__orderParameters-oiC5p","orderParametersHeader":"current-order__orderParametersHeader-1AxGt","orderParametersHeaderName":"current-order__orderParametersHeaderName-wor-a","orderParametersHeaderPrice":"current-order__orderParametersHeaderPrice-2bwdH","line":"current-order__line-38znF","specialInfo":"current-order__specialInfo-3Bb7q blocks__tooltip-20lA1 blocks__isShown--23z3","documentsBlock":"current-order__documentsBlock-1rf-l","documentsHeader":"current-order__documentsHeader-NPANU","exportResultBlock":"current-order__exportResultBlock-3zoLS","uploadWrapper":"current-order__uploadWrapper-G1hfl","uploadFailTooltip":"current-order__uploadFailTooltip-2ZVr9 blocks__tooltip-20lA1 blocks__error-2TffC blocks__isShown--23z3","preloaderWrapper":"current-order__preloaderWrapper-2trV3","buttonsBlock":"current-order__buttonsBlock-SARlK","footnoteBlock":"current-order__footnoteBlock-1CdGZ","footnote":"current-order__footnote-1qfim","tooltip":"current-order__tooltip-3TYRd blocks__tooltip-20lA1 blocks__leftToRight-v7Jyh blocks__error-2TffC blocks__isShown--23z3","tooltipWrapper":"current-order__tooltipWrapper-2HaQP","dataChangedTooltip":"current-order__dataChangedTooltip-x0563 blocks__tooltip-20lA1 blocks__error-2TffC blocks__isShown--23z3","dataOutdatedTooltip":"current-order__dataOutdatedTooltip-21ALu blocks__tooltip-20lA1 blocks__isShown--23z3","orderDate":"current-order__orderDate-jIle8","userName":"current-order__userName-3Bl2O","border":"current-order__border-15VXk","gray":"current-order__gray-34DPY","white":"current-order__white-3dF7i"};

/***/ }),
/* 756 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"documentRow":"documents__documentRow-KU0S8","rowCell":"documents__rowCell-1ARbQ","checkbox":"documents__checkbox-1408X","documentTypeName":"documents__documentTypeName-2kn57","fileDownload":"documents__fileDownload-3o1V1","downloadFileName":"documents__downloadFileName-3KLT0","fileUpload":"documents__fileUpload-28Z31","fileUploadButton":"documents__fileUploadButton-22H2T blocks__big-2DxLx blocks__white-2DChO blocks__button-1iODk","fileUploadButtonLabel":"documents__fileUploadButtonLabel-h2GPZ","fileUploadInput":"documents__fileUploadInput-1RpfY","deleteDocumentButton":"documents__deleteDocumentButton-2lF6_","loadFileButton":"documents__loadFileButton-3oSWC","downloadFileLink":"documents__downloadFileLink-3RVQi","downloadDraftLink":"documents__downloadDraftLink-2MJIU","uploadFailTooltip":"documents__uploadFailTooltip-2ypav blocks__tooltip-20lA1 blocks__error-2TffC blocks__isShown--23z3","documentsWillBeUploadedTooltip":"documents__documentsWillBeUploadedTooltip-nosSE blocks__tooltip-20lA1 blocks__isShown--23z3","fieldset":"documents__fieldset-pXU-P","checkboxDisabled":"documents__checkboxDisabled-30VP2"};

/***/ }),
/* 757 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"toolbox":"controls__toolbox-1E1vw","edit":"controls__edit-168il blocks__button-1iODk blocks__mini-Jb_UB","save":"controls__save-2UcbR blocks__button-1iODk blocks__mini-Jb_UB","cancel":"controls__cancel-1MgPY blocks__button-1iODk blocks__mini-Jb_UB"};

/***/ }),
/* 758 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"controls":"editable-order__controls-1PfBO"};

/***/ }),
/* 759 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"export-result-upload__wrapper-2o0DA","fileUploadButton":"export-result-upload__fileUploadButton-2Jbir blocks__big-2DxLx blocks__white-2DChO blocks__button-1iODk","fileUploadButtonLabel":"export-result-upload__fileUploadButtonLabel-2R7WU","fileResultUploadInput":"export-result-upload__fileResultUploadInput-98EtA","uploadFailTooltip":"export-result-upload__uploadFailTooltip-SKtJS blocks__tooltip-20lA1 blocks__error-2TffC blocks__isShown--23z3"};

/***/ }),
/* 760 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"downloadFileName":"export-result__downloadFileName-3iOz-","downloadFileLink":"export-result__downloadFileLink-2aSPD","downloadAllButton":"export-result__downloadAllButton-2xTQb blocks__big-2DxLx blocks__white-2DChO blocks__button-1iODk","progressBar":"export-result__progressBar-1v1AI","progressBarInner":"export-result__progressBarInner-2e1X9","progressPercentage":"export-result__progressPercentage-1Fqau","progressName":"export-result__progressName-3lIJo","deleteDocumentButton":"export-result__deleteDocumentButton-2CzC3"};

/***/ }),
/* 761 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"column":"header__column-ylg9q","subRow":"header__subRow-xmgXY","id":"header__id-38ZcP","orderBlock":"header__orderBlock-1kLvD","orderDate":"header__orderDate-P0I2Q","priceBlock":"header__priceBlock-37P40"};

/***/ }),
/* 762 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"field":"individual-order-parameters__field-Ax3w0","title":"individual-order-parameters__title-3Le6S","control":"individual-order-parameters__control-12uj6","tooltip":"individual-order-parameters__tooltip-1tCkQ blocks__tooltip-20lA1 blocks__leftToRight-v7Jyh blocks__error-2TffC blocks__isShown--23z3","tooltipWrapper":"individual-order-parameters__tooltipWrapper-2EtHm","message":"individual-order-parameters__message-289D8"};

/***/ }),
/* 763 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"search":"create-user__search-3TAYL","inlineInput":"create-user__inlineInput-25x9z","searchBtn":"create-user__searchBtn-1a2d4 blocks__button-1iODk blocks__green-2w7kK","createBtn":"create-user__createBtn-I5LRt blocks__button-1iODk blocks__blue-tjpdI","message":"create-user__message-2XO_h"};

/***/ }),
/* 764 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"field":"orders-options__field-TKJXj","button":"orders-options__button-2Elz3","title":"orders-options__title-3zvud","controls":"orders-options__controls-35kGp","label":"orders-options__label-aULOS","isDisabled":"orders-options__isDisabled-1F30u","name":"orders-options__name-2mXxf","tooltip":"orders-options__tooltip-1DxUs blocks__tooltip-20lA1 blocks__leftToRight-v7Jyh blocks__error-2TffC blocks__isShown--23z3","tooltipWrapper":"orders-options__tooltipWrapper-1W9El","link":"orders-options__link-10YM7","redirect":"orders-options__redirect-2ssfj"};

/***/ }),
/* 765 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"headerPreloader":"price__headerPreloader-2cZCo","headerPriceValue":"price__headerPriceValue-2-AEU","multiplySymbol":"price__multiplySymbol-3xbPm","rouble":"price__rouble-3Iz78","asterisk":"price__asterisk-UA4oq"};

/***/ }),
/* 766 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"statistickBlock":"statistic-block__statistickBlock-3ZA9-","statisticButton":"statistic-block__statisticButton-2tD0l blocks__huge-2XOet blocks__white-2DChO blocks__button-1iODk","redirect":"statistic-block__redirect-2sqnL"};

/***/ }),
/* 767 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"white":"order-wrapper__white-2GKOg","noneSelected":"order-wrapper__noneSelected-3Io0s","message":"order-wrapper__message-1PhUe","messageFootnote":"order-wrapper__messageFootnote-jgOml","link":"order-wrapper__link-3Qbao","redirect":"order-wrapper__redirect-pPnfe","messageTitle":"order-wrapper__messageTitle-2V1-O","messageDescription":"order-wrapper__messageDescription-jszLM"};

/***/ }),
/* 768 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"panel":"collapse__panel-3XnN6","wrapper":"collapse__wrapper-5v8QZ","innerWrapper":"collapse__innerWrapper-3qB0I","headerClickable":"collapse__headerClickable-142CT","header":"collapse__header-1KVb3","collapsed":"collapse__collapsed-1oQ2v","content":"collapse__content-1ntD7","arrow":"collapse__arrow-3_Vl1"};

/***/ }),
/* 769 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"active":"header__active-3PYZQ"};

/***/ }),
/* 770 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"buttons":"order-manager-filter__buttons-2oQhW","button":"order-manager-filter__button-3i4XN","label":"order-manager-filter__label-1Tk2C","radio":"order-manager-filter__radio-DH3B6"};

/***/ }),
/* 771 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"row":"order-state-filter__row-uGV6a"};

/***/ }),
/* 772 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"row":"order-type-filter__row-3o_Xf"};

/***/ }),
/* 773 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"orderList":"orders-list__orderList-bqeec","list":"orders-list__list-3Rni2","listWrapper":"orders-list__listWrapper-DDO_U","link":"orders-list__link-Qpgyr","order":"orders-list__order-3KREH","orderState":"orders-list__orderState-19wKu","listContent":"orders-list__listContent-2tOUF","info":"orders-list__info-K6sQV","stateGray":"orders-list__stateGray-3Mm-0","stateGreen":"orders-list__stateGreen-3FaSv","stateBlue":"orders-list__stateBlue-3vEI6","stateYellow":"orders-list__stateYellow-2XSGq","stateOrange":"orders-list__stateOrange-h4id1","stateLightGray":"orders-list__stateLightGray-2M05T","bordered":"orders-list__bordered-bpvNQ","stateRoyalBlue":"orders-list__stateRoyalBlue-2LgW-","stateDarkGreen":"orders-list__stateDarkGreen-adnVZ","stateBlack":"orders-list__stateBlack-3jzdC","notFound":"orders-list__notFound-9knbo","subTitle":"orders-list__subTitle-2qMmA","preloader":"orders-list__preloader-1HuIM","linkActive":"orders-list__linkActive-Q_IiT","scrolltrack":"orders-list__scrolltrack-3svFS blocks__track-36t1M","scrollbar":"orders-list__scrollbar-321aO blocks__bar-tYA-d","tooltipWrapper":"orders-list__tooltipWrapper-1OWBc","tooltip":"orders-list__tooltip-1XQDz blocks__tooltip-20lA1 blocks__isShown--23z3","highligth":"orders-list__highligth-MMphR","noPadding":"orders-list__noPadding-2kYhM","redirect":"orders-list__redirect-2W0zu"};

/***/ }),
/* 774 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"orderList":"orders-navigation__orderList-2hMC9","head":"orders-navigation__head-1G6Ku","controls":"orders-navigation__controls-1k1QV","radio":"orders-navigation__radio-1EgMT","clearFiltersButton":"orders-navigation__clearFiltersButton-O5NUE blocks__grey-2yo9d blocks__button-1iODk"};

/***/ }),
/* 775 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"text-filter__wrapper-3nBR9","filter":"text-filter__filter-1Ukak blocks__base-3OSxK"};

/***/ }),
/* 776 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"content":"orders__content-CiN8o blocks__content--MOaB","order":"orders__order-KpHWl","ordersList":"orders__ordersList-3V-pz"};

/***/ }),
/* 777 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"actionPanel":"action-panel__actionPanel-2zTZd","actions":"action-panel__actions-9JNk7","backToOrderButton":"action-panel__backToOrderButton-1ndSv blocks__big-2DxLx blocks__white-2DChO blocks__button-1iODk","switchModeButton":"action-panel__switchModeButton-2QXdk blocks__big-2DxLx blocks__white-2DChO blocks__button-1iODk","downloadExcel":"action-panel__downloadExcel-hDYF2 blocks__big-2DxLx blocks__white-2DChO blocks__button-1iODk","redirect":"action-panel__redirect-13T0n","preloader":"action-panel__preloader-35mWp"};

/***/ }),
/* 778 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"headerItem":"corner-header__headerItem-1CRaQ scrollable__headerItem-12O8r","actionsPanel":"corner-header__actionsPanel-1HFds","transpose":"corner-header__transpose-3ZS1r"};

/***/ }),
/* 779 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"headerItem":"left-header__headerItem-34cfb scrollable__headerItem-12O8r","level1":"left-header__level1-1MCDv","level2":"left-header__level2-3Y0aD","level3":"left-header__level3-2n-Kw","level2line":"left-header__level2line-3lwKy","level3line":"left-header__level3line-1nKFB","expandable":"left-header__expandable-8ubKf","hidden":"left-header__hidden-M4Z4B"};

/***/ }),
/* 780 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"scrollable":"scrollable__scrollable-1ULQe","grid":"scrollable__grid-u1-1X","gridContent":"scrollable__gridContent-3nsX0","headerTop":"scrollable__headerTop-kar6q","headerLeft":"scrollable__headerLeft-jlShg","headerCorner":"scrollable__headerCorner-1Osxl","row":"scrollable__row-2iTnn","hidden":"scrollable__hidden-1hs-f","cell":"scrollable__cell-3bnem","headerItem":"scrollable__headerItem-12O8r","actionPanel":"scrollable__actionPanel-2nkLA","actions":"scrollable__actions-1zC50","backToOrderButton":"scrollable__backToOrderButton-3zRol blocks__big-2DxLx blocks__white-2DChO blocks__button-1iODk","redirect":"scrollable__redirect-3H7Or","preloader":"scrollable__preloader-1JOqq"};

/***/ }),
/* 781 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"top-header__container-2jizC","headerItem":"top-header__headerItem-3TUn1 scrollable__headerItem-12O8r","level1":"top-header__level1-3Qjk8","level2":"top-header__level2-3CW8C","level3":"top-header__level3-2_TQn","level2line":"top-header__level2line-qBJ5z","level3line":"top-header__level3line-SdM-e","expandable":"top-header__expandable-1m6it"};

/***/ }),
/* 782 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"scrollable":"statistic__scrollable-3O7Vl","grid":"statistic__grid-1yerm","gridContent":"statistic__gridContent-2SsQj","headerTop":"statistic__headerTop-1jL2B","headerLeft":"statistic__headerLeft-3SrqJ","row":"statistic__row-1qd6g","hidden":"statistic__hidden-1qTZB","cell":"statistic__cell-1EKEW","headerItem":"statistic__headerItem-2J_ek"};

/***/ }),
/* 783 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"selected-user__wrapper-3B6Nc","header":"selected-user__header-37M6E","line":"selected-user__line-FrlTy","block":"selected-user__block-3ExgK","noneSelected":"selected-user__noneSelected-2Sfhd","message":"selected-user__message-3VD0U"};

/***/ }),
/* 784 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"usersList":"users-list__usersList-1nY5Q","head":"users-list__head-3OjtZ","controls":"users-list__controls-2nC1T","list":"users-list__list-NMmZj","listWrapper":"users-list__listWrapper-1XKAA","link":"users-list__link-14zHW","user":"users-list__user-35MWB","listContent":"users-list__listContent-1sQ5N","info":"users-list__info-9TwV0","notFound":"users-list__notFound-3RvaM","preloader":"users-list__preloader-1KfoH","linkActive":"users-list__linkActive-3ZTAQ","scrolltrack":"users-list__scrolltrack-3BFMG blocks__track-36t1M","scrollbar":"users-list__scrollbar-WQ-sM blocks__bar-tYA-d","redirect":"users-list__redirect-xJip6"};

/***/ }),
/* 785 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"content":"users__content-1o-Qr blocks__content--MOaB","usersList":"users__usersList-2pNXQ","user":"users__user-1PxBA"};

/***/ }),
/* 786 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"alert__block-2RO9k","icon":"alert__icon-1Ky4f","check":"alert__check-1wZxo","link":"alert__link-31-fW","title":"alert__title-15a0P","text":"alert__text-2Yr8D","redirect":"alert__redirect-26TKQ"};

/***/ }),
/* 787 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"content__block-2SFJf"};

/***/ }),
/* 788 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"message":"error__message-1OXxI","animation":"error__animation-3GJcb","fadeIn":"error__fadeIn-1AMYu"};

/***/ }),
/* 789 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"field":"form__field-35dAI"};

/***/ }),
/* 790 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"login__block-3IXZz","fadeInUp":"login__fadeInUp-fnneT","wait":"login__wait-30D2e","waitText":"login__waitText-3xQU2","waitCreate":"login__waitCreate-53PAx","waitSubmit":"login__waitSubmit-3Y0Tv blocks__green-2w7kK blocks__button-1iODk","form":"login__form-34h4J","formWrapper":"login__formWrapper-1YHai","formControls":"login__formControls-3WbiC","formSubmit":"login__formSubmit-PWcre blocks__green-2w7kK blocks__button-1iODk","formForgotWrapper":"login__formForgotWrapper-2KTzj","formForgot":"login__formForgot-2svH0","formRecaptcha":"login__formRecaptcha-1WH_5","title":"login__title-2VvCz","registration":"login__registration-24XDr","registrationText":"login__registrationText-2W_JZ","registrationButton":"login__registrationButton-1cfYT blocks__blue-tjpdI blocks__button-1iODk","alreadyRegisteredTooltip":"login__alreadyRegisteredTooltip-2Wsvn blocks__tooltip-20lA1 blocks__isShown--23z3","link":"login__link-2DDP2","sendConfirmationMail":"login__sendConfirmationMail-2ytWk","redirect":"login__redirect-2UmNE"};

/***/ }),
/* 791 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"registration-extra__block-1le73","autocomplete":"registration-extra__autocomplete-2XtSc","label":"registration-extra__label-22CTS","twoLineLabel":"registration-extra__twoLineLabel-2hXGm","title":"registration-extra__title-3tcL0","submit":"registration-extra__submit-2p7ii blocks__blue-tjpdI blocks__button-1iODk","field":"registration-extra__field-Hbq0y","info":"registration-extra__info-1T73g","require":"registration-extra__require-2Hk5C","zoomInLeft":"registration-extra__zoomInLeft-11sdE","button":"registration-extra__button-3mSSJ blocks__button-1iODk","link":"registration-extra__link-2lDeI","simpleLink":"registration-extra__simpleLink-35jV4","separator":"registration-extra__separator-Uv5D2","errorWrapper":"registration-extra__errorWrapper-2WRjq","fieldset":"registration-extra__fieldset-1fRtU","twoLineRequire":"registration-extra__twoLineRequire-13ErO","redirect":"registration-extra__redirect-BtxpG","privacy":"registration-extra__privacy-gom4Q"};

/***/ }),
/* 792 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"registration__block-1fyul","autocomplete":"registration__autocomplete-3y_Iq","tooltip":"registration__tooltip-3bsDV","label":"registration__label-3FBxn","twoLineLabel":"registration__twoLineLabel-31qSL","title":"registration__title-2Y8nK","submit":"registration__submit-aR2Ps blocks__blue-tjpdI blocks__button-1iODk","field":"registration__field-3hTGY","require":"registration__require-wFQKz","zoomInLeft":"registration__zoomInLeft-3yuq4","twoLineRequire":"registration__twoLineRequire-39ALn","button":"registration__button-AFRJF blocks__button-1iODk","link":"registration__link-3JEEz","simpleLink":"registration__simpleLink-1p-qo","separator":"registration__separator-3jIq0","errorWrapper":"registration__errorWrapper-3euvP","fieldset":"registration__fieldset-1rQEJ","redirect":"registration__redirect-15bhv","privacy":"registration__privacy-2uUx2"};

/***/ }),
/* 793 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"restore-change__block-3NCEp","title":"restore-change__title-3DrEV","field":"restore-change__field-BWL_5","description":"restore-change__description-1-atW","submit":"restore-change__submit-2nwOb blocks__blue-tjpdI blocks__button-1iODk"};

/***/ }),
/* 794 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"restore__block-3trD2","title":"restore__title-ct_Sy","inputGroup":"restore__inputGroup-2SVWV","tooltipWrapper":"restore__tooltipWrapper-1C1qe","description":"restore__description-21Oly","submit":"restore__submit-1rWSh blocks__blue-tjpdI blocks__button-1iODk","button":"restore__button-3z5Ez blocks__button-1iODk","link":"restore__link-22kR2","redirect":"restore__redirect-1-JKH"};

/***/ }),
/* 795 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"accept":"tos__accept-vCxjn blocks__huge-2XOet blocks__blue-tjpdI blocks__button-1iODk","cancel":"tos__cancel-2JyaT blocks__huge-2XOet blocks__grey-2yo9d blocks__button-1iODk","modal":"tos__modal-1Tfw_","container":"tos__container-pwIcr","animatetop":"tos__animatetop-3ATHq","modal-content":"tos__modal-content-ar-v9","top-scroll-area":"tos__top-scroll-area-xpBwu","actions":"tos__actions-1fnBS","header":"tos__header-2McbW","section-header":"tos__section-header-2vp5y","section":"tos__section-3Tus0","link":"tos__link-1w8io","scrollDisabled":"tos__scrollDisabled-3yDbc"};

/***/ }),
/* 796 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"content":"bitrixMain__content-2TwUR blocks__content--MOaB","head":"bitrixMain__head-1gMOg","actions":"bitrixMain__actions-2PLgc","actionsWrapper":"bitrixMain__actionsWrapper-3tPH5 blocks__content--MOaB","actionsBlock":"bitrixMain__actionsBlock-3j7Ga","actionsBlockHeader":"bitrixMain__actionsBlockHeader-3VFUn","actionsImage":"bitrixMain__actionsImage-1tBcp","catalog":"bitrixMain__catalog-1yt8A","directory":"bitrixMain__directory-2aJ1g","board":"bitrixMain__board-osYTO","actionsDescription":"bitrixMain__actionsDescription-3zHe9","actionsControls":"bitrixMain__actionsControls-32on2","actionsButton":"bitrixMain__actionsButton-21OOZ blocks__button-1iODk blocks__blue-tjpdI","clients":"bitrixMain__clients-3t9ph","clientsWrapper":"bitrixMain__clientsWrapper-z0lx0 blocks__content--MOaB","clientsHeader":"bitrixMain__clientsHeader-23PyQ","clientsBlock":"bitrixMain__clientsBlock-1ldcD","dhlLogo":"bitrixMain__dhlLogo-3nYlz","felderLogo":"bitrixMain__felderLogo-2yJZF","rionLogo":"bitrixMain__rionLogo-1WB18","fusoLogo":"bitrixMain__fusoLogo-1ufn_","taxiLogo":"bitrixMain__taxiLogo-2UcXs","payment":"bitrixMain__payment-3nUDS","paymentWrapper":"bitrixMain__paymentWrapper-2oY0r blocks__content--MOaB","cost":"bitrixMain__cost-15MiW","costHeader":"bitrixMain__costHeader-X4UqL","costHeaderTitle":"bitrixMain__costHeaderTitle-2T8zn","costHeaderInfo":"bitrixMain__costHeaderInfo-2NsKB","costControls":"bitrixMain__costControls-23lgh","costButton":"bitrixMain__costButton-11MLX blocks__button-1iODk blocks__blue-tjpdI","paymentMethodsHeader":"bitrixMain__paymentMethodsHeader-yErQo","paymentMethodsBlock":"bitrixMain__paymentMethodsBlock-2DVRS","paymentMethodsImage":"bitrixMain__paymentMethodsImage-1LGZV","bankCard":"bitrixMain__bankCard-2XhsF","invoice":"bitrixMain__invoice-TjEr3","webmoney":"bitrixMain__webmoney-3lDat","cash":"bitrixMain__cash-X6vMI","sms":"bitrixMain__sms-1b8ip","paymentMethodsInfo":"bitrixMain__paymentMethodsInfo-2k0qF","manager":"bitrixMain__manager-2bira","managerWrapper":"bitrixMain__managerWrapper-tGR4m blocks__content--MOaB","managerImage":"bitrixMain__managerImage-ufKYD","managerHeader":"bitrixMain__managerHeader-2XjS8","managerControls":"bitrixMain__managerControls-1-MY4","managerLink":"bitrixMain__managerLink-1qMI_","tooltipWrapper":"bitrixMain__tooltipWrapper-3j18M","tooltip":"bitrixMain__tooltip-3BKtA","info":"bitrixMain__info-9m_Y4"};

/***/ }),
/* 797 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"item":"content__item-2Hmdu","parameters":"content__parameters-1yomK","small":"content__small-3OVu-","fieldset":"content__fieldset-3juyy","title":"content__title-2YYOU","checkboxDisabled":"content__checkboxDisabled-1goet","firstColumn":"content__firstColumn-3be0A","basicColumns":"content__basicColumns-1LTsn","basicColumn":"content__basicColumn-3a_kt","basicColumnsWrapper":"content__basicColumnsWrapper-3zAHD","line":"content__line-3ShAE","basicSecondColumn":"content__basicSecondColumn-2viU-","secondColumn":"content__secondColumn-1Em7k","thirdColumn":"content__thirdColumn-1bVWh","fourthColumn":"content__fourthColumn-3ofWU","lineFull":"content__lineFull-3nyP9","treeWrapper":"content__treeWrapper-12zvR","treeWrapperTreeOnly":"content__treeWrapperTreeOnly-398H7","black":"content__black-NcTpX","info":"content__info-1wjaw","basicField":"content__basicField-1hDF7","tooltipWrapper":"content__tooltipWrapper-2FC7Y","tooltip":"content__tooltip-2qaaU blocks__tooltip-20lA1 blocks__leftToRight-v7Jyh blocks__isShown--23z3","count":"content__count-1UgbE","checkbox":"content__checkbox-3Jn73","checkbox-label":"content__checkbox-label-1ZyhA"};

/***/ }),
/* 798 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"discount":"discount__discount-2HXge","discountGray":"discount__discountGray-3MgTt","discountLabel":"discount__discountLabel-1qzuP","discountBlock":"discount__discountBlock-2b1LP","tooltipWrapper":"discount__tooltipWrapper-cwEbV content__tooltipWrapper-2FC7Y","tooltip":"discount__tooltip-1EHVn content__tooltip-2qaaU blocks__tooltip-20lA1 blocks__leftToRight-v7Jyh blocks__isShown--23z3","count":"discount__count-1eDlB","noDiscountTooltip":"discount__noDiscountTooltip-2inSx"};

/***/ }),
/* 799 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"fieldset":"filter__fieldset-3_nD- content__fieldset-3juyy","datePickerWrapper":"filter__datePickerWrapper-1G2c7","dataFilter":"filter__dataFilter-3WBev","dataFilterLabel":"filter__dataFilterLabel-2CjNN","checkbox":"filter__checkbox-2kA0F content__checkbox-3Jn73","textInput":"filter__textInput-1He-5","textInputLabel":"filter__textInputLabel-3KdOU","treeWrapperTreeOnly":"filter__treeWrapperTreeOnly-3x37P content__treeWrapperTreeOnly-398H7"};

/***/ }),
/* 800 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"button":"actions__button-gGRUd blocks__button-1iODk blocks__mini-Jb_UB","setAll":"actions__setAll-2_Kvk","clearAll":"actions__clearAll-2YZSR"};

/***/ }),
/* 801 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"item":"greeder-columns__item-2N_BN content__item-2Hmdu","title":"greeder-columns__title-15Hsz content__title-2YYOU","firstColumn":"greeder-columns__firstColumn-1tYmJ content__firstColumn-3be0A","secondColumn":"greeder-columns__secondColumn-2RaPM content__secondColumn-1Em7k","thirdColumn":"greeder-columns__thirdColumn-1QPNY content__thirdColumn-1bVWh","fourthColumn":"greeder-columns__fourthColumn-1Br6J content__fourthColumn-3ofWU","fieldset":"greeder-columns__fieldset-3yy0M content__fieldset-3juyy","checkbox":"greeder-columns__checkbox-3sKJb content__checkbox-3Jn73","bold":"greeder-columns__bold-1XBT9","tooltip":"greeder-columns__tooltip-1Ix7F","tooltiptext":"greeder-columns__tooltiptext-ThM3U blocks__tooltip-20lA1 blocks__isShown--23z3","info":"greeder-columns__info-2MroR","link":"greeder-columns__link-QkXXf","actions":"greeder-columns__actions-2HG1r","greeder":"greeder-columns__greeder-1JeyB","line":"greeder-columns__line-elImz content__line-3ShAE"};

/***/ }),
/* 802 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"treeWrapper":"legal-tree__treeWrapper-1wyBV content__treeWrapper-12zvR"};

/***/ }),
/* 803 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"treeWrapperTreeOnly":"payment-tree__treeWrapperTreeOnly-2ek2p content__treeWrapperTreeOnly-398H7"};

/***/ }),
/* 804 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"noDiscount":"price__noDiscount-zosBj","totalPrice":"price__totalPrice-2Q0MM","rouble":"price__rouble-1so9F","lineThrough":"price__lineThrough-VY_qD","priceContent":"price__priceContent-3rBwa"};

/***/ }),
/* 805 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"treeWrapper":"purpose-tree__treeWrapper-_-5QV content__treeWrapper-12zvR"};

/***/ }),
/* 806 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"title":"header__title-1wIyM"};

/***/ }),
/* 807 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"button":"branch-filter__button-1lZ2t blocks__button-1iODk blocks__mini-Jb_UB blocks__white-2DChO","switched":"branch-filter__switched-Nt6Jh"};

/***/ }),
/* 808 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"toolbox":"content__toolbox-3mCDo","button":"content__button-lyLt1 blocks__button-1iODk blocks__mini-Jb_UB blocks__white-2DChO","switched":"content__switched-1d0d8","toggleFilterType":"content__toggleFilterType-2G-G1","content":"content__content-2KmAm","tab":"content__tab-3YQ2I blocks__button-1iODk blocks__mini-Jb_UB blocks__white-2DChO","selected":"content__selected-O9OA8","unselected":"content__unselected-PeWlU"};

/***/ }),
/* 809 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"toolbox":"filter-by-list__toolbox-3L0O1","button":"filter-by-list__button-3uDK_ blocks__button-1iODk blocks__mini-Jb_UB blocks__white-2DChO","switched":"filter-by-list__switched-Nbz7s"};

/***/ }),
/* 810 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"content":"map-filter__content-2iXx4","map":"map-filter__map-LMacP","geometry":"map-filter__geometry-2z_qK","wrapper":"map-filter__wrapper-1vtrP","search":"map-filter__search-3Iy4D blocks__base-3OSxK"};

/***/ }),
/* 811 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"error":"tree-input-tooltip__error-wesHA","success":"tree-input-tooltip__success-3VVkg"};

/***/ }),
/* 812 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"tree-input__wrapper-1pug-","downloadButtonWrapper":"tree-input__downloadButtonWrapper-2ndPu","buttonWrapper":"tree-input__buttonWrapper-5IURY","filterButton":"tree-input__filterButton-37sgo blocks__button-1iODk blocks__blue-tjpdI","downloadButton":"tree-input__downloadButton-33vu6 blocks__green-2w7kK blocks__button-1iODk","line":"tree-input__line-G5Ark","title":"tree-input__title-3Xw1H","unrecognized":"tree-input__unrecognized-3Gi3r","recognized":"tree-input__recognized-3bCcm"};

/***/ }),
/* 813 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"title":"header__title-3Cwkd"};

/***/ }),
/* 814 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"panel":"collapse__panel-1Wq3q","wide":"collapse__wide-1zfoJ","collapsed":"collapse__collapsed-3uaTp","wrapper":"collapse__wrapper-1pkbd","headerClickable":"collapse__headerClickable-2RAwi","header":"collapse__header-2pZDP","content":"collapse__content-1sASj","arrow":"collapse__arrow-O7nyZ"};

/***/ }),
/* 815 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"link":"custom-order__link-31zhV","tools":"custom-order__tools-36hB8","controlPanel":"custom-order__controlPanel-183HD","buttonsPanel":"custom-order__buttonsPanel-2aHi5","info":"custom-order__info-2BQRV","orderButton":"custom-order__orderButton-TLJqA","reset":"custom-order__reset-SbmBN","button":"custom-order__button-4NZS4 blocks__button-1iODk blocks__mini-Jb_UB"};

/***/ }),
/* 816 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"checkbox__wrapper-11OVv","checkbox":"checkbox__checkbox-3cRpJ","title":"checkbox__title-1OiE3","indeterminate":"checkbox__indeterminate-e_9zs","label":"checkbox__label-2GOVt"};

/***/ }),
/* 817 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"toolbox":"controls__toolbox-15U05","button":"controls__button-1M7M9 blocks__button-1iODk blocks__mini-Jb_UB blocks__white-2DChO","switched":"controls__switched-1m_i2","unselect":"controls__unselect-1mOHS","select":"controls__select-16Spq","showSelectedOnly":"controls__showSelectedOnly-PtGe1","buttonsBlock":"controls__buttonsBlock-2aACD","button1":"controls__button1-3ALah","button2":"controls__button2-2vFhT","button3":"controls__button3-2ul1b"};

/***/ }),
/* 818 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"title":"count-header__title-3wWza"};

/***/ }),
/* 819 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"simple__wrapper-29_lv","filter":"simple__filter-3pfR5 blocks__base-3OSxK"};

/***/ }),
/* 820 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"content":"filterable-tree__content-2EBO4","tree":"filterable-tree__tree-3qjtl","fieldset":"filterable-tree__fieldset-3mE1J","contentTree":"filterable-tree__contentTree-2_zjn","small":"filterable-tree__small-2J6eu","innerTree":"filterable-tree__innerTree-59Lkk","innerTreeSmall":"filterable-tree__innerTreeSmall-2pM-O","scrolltrack":"filterable-tree__scrolltrack-Hjadg blocks__track-36t1M","scrollbar":"filterable-tree__scrollbar-E1Znp blocks__bar-tYA-d"};

/***/ }),
/* 821 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"childrenCount":"selection-count__childrenCount-j5WDK"};

/***/ }),
/* 822 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"expandable":"tree__expandable-Z1Hhh","list":"tree__list-2I0Lj","root":"tree__root-11PuV","listItem":"tree__listItem-ASaI9","noSelection":"tree__noSelection-3vfHe","branchButton":"tree__branchButton-1nGE1 blocks__button-1iODk blocks__mini-Jb_UB","tooltipWrapper":"tree__tooltipWrapper-2uzUQ","tooltip":"tree__tooltip-i0ITl blocks__tooltip-20lA1 blocks__leftToRight-v7Jyh blocks__isShown--23z3","tooltipSmall":"tree__tooltipSmall-jUN4L","info":"tree__info-q5Lgw","tooltipSelector":"tree__tooltipSelector-3Bml0","vertical":"tree__vertical-3ex9p"};

/***/ }),
/* 823 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"toolbox":"filter-by-list__toolbox-2rqd5","button":"filter-by-list__button-2rRhB blocks__button-1iODk blocks__mini-Jb_UB blocks__white-2DChO","switched":"filter-by-list__switched-2Qlc7"};

/***/ }),
/* 824 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"content":"content__content-1Nrgs"};

/***/ }),
/* 825 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"error":"tree-input-tooltip__error-1X7hv","success":"tree-input-tooltip__success-1YKzi"};

/***/ }),
/* 826 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"tree-input__wrapper-2o5sL","downloadButtonWrapper":"tree-input__downloadButtonWrapper-39ClA","buttonWrapper":"tree-input__buttonWrapper-Ygia2","filterButton":"tree-input__filterButton-3DGjg blocks__button-1iODk blocks__blue-tjpdI","downloadButton":"tree-input__downloadButton-2Cl6V blocks__green-2w7kK blocks__button-1iODk","line":"tree-input__line-3XKam","title":"tree-input__title-2rAD_","unrecognized":"tree-input__unrecognized-1Vpip","recognized":"tree-input__recognized-2ouFX"};

/***/ }),
/* 827 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"title":"header__title-EnyCR"};

/***/ }),
/* 828 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"dataChangedTooltip":"tooltip__dataChangedTooltip-_VrR7 blocks__tooltip-20lA1 blocks__error-2TffC blocks__isShown--23z3"};

/***/ }),
/* 829 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"noDiscounts":"prices__noDiscounts-2Tz-k","rouble":"prices__rouble-2Ny3L"};

/***/ }),
/* 830 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"saveButton":"actions-panel__saveButton-1yqQx blocks__huge-2XOet blocks__green-2w7kK blocks__button-1iODk","cancelButton":"actions-panel__cancelButton-3zydw blocks__huge-2XOet blocks__white-2DChO blocks__button-1iODk"};

/***/ }),
/* 831 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"title":"user-form__title-GFMSe","description":"user-form__description-2e4MK","buttonsBlock":"user-form__buttonsBlock-qoCd6","fieldset":"user-form__fieldset-1Sdl3","individual":"user-form__individual-1SNuV"};

/***/ }),
/* 832 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"content":"contacts__content-18v46 blocks__content--MOaB","listItem":"contacts__listItem-1jaEO","phoneText":"contacts__phoneText-2KlAN","phone":"contacts__phone-IDTq9","mail":"contacts__mail-2nM5G","address":"contacts__address-3csXK","addressText":"contacts__addressText-24dsS","listTitle":"contacts__listTitle-2kD6Q","phoneNumber":"contacts__phoneNumber-3-zrU","map":"contacts__map-2GGjW","text":"contacts__text-2zEq4"};

/***/ }),
/* 833 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"devtools__container-1MTx3","button":"devtools__button-1xJKx blocks__big-2DxLx blocks__green-2w7kK blocks__button-1iODk","state":"devtools__state-9lkSc devtools__button-1xJKx blocks__big-2DxLx blocks__green-2w7kK blocks__button-1iODk"};

/***/ }),
/* 834 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"content":"help__content-1PQ4O blocks__content--MOaB","title":"help__title-1nM7v","collapser":"help__collapser-17mox","clicked":"help__clicked-zpW0d","collapserHead":"help__collapserHead-3HAQs","collapserText":"help__collapserText-1PLe9","link":"help__link-28RgP","cost":"help__cost-3fmON","sampleDownloadButton":"help__sampleDownloadButton-a-C1p blocks__button-1iODk blocks__green-2w7kK","thirdLevelList":"help__thirdLevelList-1S1Sk","secondLevelList":"help__secondLevelList-n4tuV","clarification":"help__clarification-3vlB5","note":"help__note-30JHN","redirect":"help__redirect-3JUHP"};

/***/ }),
/* 835 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"content__block-17AHD"};

/***/ }),
/* 836 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"layout":"document__layout-2OlNR"};

/***/ }),
/* 837 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"errorPage":"error-page__errorPage-2eCpy","head":"error-page__head-8hMPh","logo":"error-page__logo-3XzLe","titleWrapper":"error-page__titleWrapper-hMxlz","title":"error-page__title-SKp7H","titleText":"error-page__titleText-zgxmn","error":"error-page__error-B0jzg","errorTitle":"error-page__errorTitle-3_r6A","errorDescription":"error-page__errorDescription-26mNn","link":"error-page__link-1Tmi6","image":"error-page__image-kqGmf","_404":"error-page___404-31FwV","_503":"error-page___503-1dWTZ","_regLinkTimeout":"error-page___regLinkTimeout-3e6gn","_500":"error-page___500-22qT8","_403":"error-page___403-3a6dk","redirect":"error-page__redirect-106OS"};

/***/ }),
/* 838 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"footer__wrapper-3nbrv","block":"footer__block-2syT4","content":"footer__content-35ZaE blocks__content--MOaB","info":"footer__info-6Wggz","row":"footer__row-2L0qJ","column":"footer__column-1VJdq","link":"footer__link-1_Xww","copyRight":"footer__copyRight-3n63p","redirect":"footer__redirect-17Hld"};

/***/ }),
/* 839 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"content":"header__content-1Sr64 blocks__content--MOaB","inline-block-element":"header__inline-block-element-3tBRb","logo":"header__logo-gr1fb","menu":"header__menu-1ESln","menuSmall":"header__menuSmall-2ADM7","link":"header__link-2Hmkp","isActive":"header__isActive-3RDen","phone":"header__phone-omfm4","phoneLink":"header__phoneLink-1SKLV","freeCall":"header__freeCall-IQ9bv","user":"header__user-G7LrQ","userMenu":"header__userMenu-BttS7","login":"header__login-cGmCC blocks__button-1iODk blocks__green-2w7kK","redirect":"header__redirect-4pPF0"};

/***/ }),
/* 840 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"user-menu__block-VdrYp","title":"user-menu__title-2vJpL","link":"user-menu__link-2ajk5","item":"user-menu__item-1TPiw","fadeLink":"user-menu__fadeLink-35Ifd","dropdown":"user-menu__dropdown-2guyY","isOpen":"user-menu__isOpen-2P7lV","dropdownAppearance":"user-menu__dropdownAppearance-mPYQQ","logout":"user-menu__logout-3DOG8","redirect":"user-menu__redirect-fIBwZ"};

/***/ }),
/* 841 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"flex":"layout__flex-1AULx","grey":"layout__grey-1A9sm","white":"layout__white-20FN7","blue":"layout__blue-1E33N","centred":"layout__centred-2ePTO","block":"layout__block-3Y9gx","container":"layout__container-5HQH5","headContainer":"layout__headContainer-fQL7M"};

/***/ }),
/* 842 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"overlay":"overlay__overlay-ccjqX","isLoading":"overlay__isLoading-1OxGj"};

/***/ }),
/* 843 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"preloader":"preloader__preloader-2JIoP","point":"preloader__point--G5Zj","loading":"preloader__loading-KwLcH","small":"preloader__small-2cwTf","medium":"preloader__medium-1XeBW","big":"preloader__big-34i3m"};

/***/ }),
/* 844 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"header__block-Cc7T8","wrapper":"header__wrapper-NcMKX","content":"header__content-2xRNn blocks__content--MOaB","price":"header__price-RuUkR","order":"header__order-yNQmE","isSticked":"header__isSticked-_Be36"};

/***/ }),
/* 845 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"button":"make-order-button__button-3HFWW","normal":"make-order-button__normal-u8mlN blocks__green-2w7kK blocks__medium-2_Kpp blocks__button-1iODk","big":"make-order-button__big--u6bF blocks__green-2w7kK blocks__huge-2XOet blocks__button-1iODk","tooltipWrapper":"make-order-button__tooltipWrapper-gYgq0","tooltip":"make-order-button__tooltip-1WbvB blocks__tooltip-20lA1 blocks__isShown--23z3","tooltipBig":"make-order-button__tooltipBig-2_tXv"};

/***/ }),
/* 846 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"content":"price__content-2X8sF","preloader":"price__preloader-3dJ2s","wrapper":"price__wrapper-pNg_i","isLoading":"price__isLoading-fuuAx","link":"price__link-3w7dU","tooltip":"price__tooltip-25mpl blocks__tooltip-20lA1","topToBottom":"price__topToBottom-3XgJH blocks__topToBottom-3LrIB blocks__topToBottomAnimation-3qZT0","priceBlock":"price__priceBlock-PZvDN","priceContent":"price__priceContent-344sY","noDiscountBlock":"price__noDiscountBlock-RjQ3F","title":"price__title-1OdU1","titleWithRuble":"price__titleWithRuble-1fYod","totalPrice":"price__totalPrice-3ZK6W","noDiscount":"price__noDiscount-3DAWU","lineThrough":"price__lineThrough-3Y2te","rouble":"price__rouble-b24E3","bigRouble":"price__bigRouble-UkTLQ","black":"price__black-1sI5p","font14":"price__font14-3ck1E","warning":"price__warning-383j7","inlineBlock":"price__inlineBlock-3HNvk","hidden":"price__hidden-3E-mr","noRoubleBlock":"price__noRoubleBlock-3NhFH"};

/***/ }),
/* 847 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"content":"order__content-3xD0R blocks__content--MOaB","head":"order__head-2P_fW","actions":"order__actions-rDokF","actionsWrapper":"order__actionsWrapper-CpYrd blocks__content--MOaB","actionsBlock":"order__actionsBlock-1F0iE","actionsBlockHeader":"order__actionsBlockHeader-nYX7S","actionsImage":"order__actionsImage-3D39g","catalog":"order__catalog-2cCm6","directory":"order__directory-2gojj","board":"order__board-3KqGz","actionsDescription":"order__actionsDescription-3VvWd","actionsControls":"order__actionsControls-47x9U","actionsButton":"order__actionsButton-BCD2s blocks__button-1iODk blocks__blue-tjpdI","clients":"order__clients-1XGzh","clientsWrapper":"order__clientsWrapper-sLusE blocks__content--MOaB","clientsHeader":"order__clientsHeader-3BEXE","clientsBlock":"order__clientsBlock-3Y5Jh","dhlLogo":"order__dhlLogo-3iii_","felderLogo":"order__felderLogo-KwSaG","rionLogo":"order__rionLogo-NpOuc","fusoLogo":"order__fusoLogo-1tfMh","taxiLogo":"order__taxiLogo-qGLRn","payment":"order__payment-1xMW4","paymentWrapper":"order__paymentWrapper-39Cst blocks__content--MOaB","cost":"order__cost-ux4lQ","costHeader":"order__costHeader-17xe-","costHeaderTitle":"order__costHeaderTitle-1SxxF","costHeaderInfo":"order__costHeaderInfo-ZqENI","costControls":"order__costControls-1hKlo","costButton":"order__costButton-22zwE blocks__button-1iODk blocks__blue-tjpdI","paymentMethodsHeader":"order__paymentMethodsHeader-2tLcS","paymentMethodsContainer":"order__paymentMethodsContainer-3khlj","paymentMethodsBlock":"order__paymentMethodsBlock-3oajk","paymentMethodsImage":"order__paymentMethodsImage-2EunJ","bankCard":"order__bankCard-1h6YK","invoice":"order__invoice-30xrE","webmoney":"order__webmoney-la779","cash":"order__cash-18Xcm","sms":"order__sms-Hrf1o","paymentMethodsInfo":"order__paymentMethodsInfo-ZroBr","manager":"order__manager-wMn8G","managerWrapper":"order__managerWrapper-2HKeR blocks__content--MOaB","managerImage":"order__managerImage-18_DT","managerHeader":"order__managerHeader-1p9FW","managerControls":"order__managerControls-2pkSr","managerLink":"order__managerLink-7VpXr","tooltipWrapper":"order__tooltipWrapper-1C4Rf","tooltip":"order__tooltip-1RBhS","info":"order__info-1Q1RK"};

/***/ }),
/* 848 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"message":"message__message-S2Cqg","title":"message__title-2JG4C","content":"message__content-2TuHQ"};

/***/ }),
/* 849 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"slider__wrapper-3uzua","slider":"slider__slider-26bNu","layer":"slider__layer-MviXD","noAnimation":"slider__noAnimation-3jCbA","city":"slider__city-3nXJq","buildings":"slider__buildings-25s7L","clouds":"slider__clouds-3Q4qu","content":"slider__content-1hxeQ blocks__content--MOaB","airship":"slider__airship-1Gnbn","hang":"slider__hang-2y7Bz","icon":"slider__icon-3_QQq","showIcon":"slider__showIcon-3djRu","iconOk":"slider__iconOk-2h2-v slider__icon-3_QQq","iconOk2":"slider__iconOk2-1QpNG slider__icon-3_QQq","iconOkMedium":"slider__iconOkMedium-336DN slider__icon-3_QQq","iconOkMedium2":"slider__iconOkMedium2-2mSSp slider__icon-3_QQq","iconBad":"slider__iconBad-2uHjF","flip":"slider__flip-WvsXX","showFlip":"slider__showFlip-3eS3-","iconBadSmall":"slider__iconBadSmall-1xzDY","pins":"slider__pins-37hhO","pin":"slider__pin-1YXUI","showPin":"slider__showPin-3d9OC","pinSmall":"slider__pinSmall-SSlR9 slider__pin-1YXUI","pinSmall2":"slider__pinSmall2-1H-nR slider__pin-1YXUI","pinBig":"slider__pinBig-2vbFp slider__pin-1YXUI","pinBig2":"slider__pinBig2-syRYi slider__pin-1YXUI","pinMedium":"slider__pinMedium-uCSIU slider__pin-1YXUI","pinMedium2":"slider__pinMedium2-lQCqC slider__pin-1YXUI","pinMedium3":"slider__pinMedium3-1F-wn slider__pin-1YXUI","reliability":"slider__reliability-1GWvY","showReliability":"slider__showReliability-3bcmh","reliabilityWrapper":"slider__reliabilityWrapper-1mcit","reliabilityPin":"slider__reliabilityPin-Ychj1 slider__reliability-1GWvY","showReliabilityPin":"slider__showReliabilityPin-1Oef3","reliabilityShield":"slider__reliabilityShield-bE-w6 slider__reliability-1GWvY","reliabilityPromo":"slider__reliabilityPromo-2merj slider__reliability-1GWvY","reliabilityPromo2":"slider__reliabilityPromo2-1COrH slider__reliability-1GWvY","capability":"slider__capability-34aWe","showCapability":"slider__showCapability-2l59Q","capabilityLeft":"slider__capabilityLeft-3gce9 slider__capability-34aWe","capabilityRight":"slider__capabilityRight-3kUI0 slider__capability-34aWe","capabilityOk":"slider__capabilityOk-L4dNU slider__capability-34aWe","capabilityList":"slider__capabilityList-2PItN slider__capability-34aWe"};

/***/ }),
/* 850 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"alert":"alert__alert-3eiyN","alertTitle":"alert__alertTitle-3uy9S","alertDescription":"alert__alertDescription--GzUr","link":"alert__link-1sbIg","image":"alert__image-25QI2","success":"alert__success-1NFz7","fail":"alert__fail-16zyb","redirect":"alert__redirect-3MYNH"};

/***/ }),
/* 851 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"autocomplete":"password-change__autocomplete-1yC9E","section":"password-change__section-PxZPH","label":"password-change__label-1oK2G","title":"password-change__title-MvnmQ user-form__title-GFMSe","field":"password-change__field-3NAWr","submit":"password-change__submit-3jyW0 blocks__huge-2XOet blocks__green-2w7kK blocks__button-1iODk","passwordChangeTooltip":"password-change__passwordChangeTooltip-1sOox","passwordChanged":"password-change__passwordChanged-3C5l_ blocks__tooltip-20lA1 blocks__success-3JdUF blocks__isShown--23z3","passwordNotChanged":"password-change__passwordNotChanged-3XC_s blocks__tooltip-20lA1 blocks__error-2TffC blocks__isShown--23z3","asterisk":"password-change__asterisk-1rIEP"};

/***/ }),
/* 852 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"content":"personal__content-34rYU blocks__content--MOaB","user":"personal__user-Iux77"};

/***/ }),
/* 853 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"content":"terms__content-3HL56 blocks__content--MOaB","title":"terms__title-3VZXn","link":"terms__link-Debjz"};

/***/ }),
/* 854 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"content":"video__content-tBzgE blocks__content--MOaB","title":"video__title-3q_DX","videoContainer":"video__videoContainer-5Tyl3"};

/***/ }),
/* 855 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"content":"calendar__content-iTPbt","monthName":"calendar__monthName-2n4UZ","weekTitleText":"calendar__weekTitleText-CVI2u","table":"calendar__table-3-MVD","item":"calendar__item-3kGio","_notInPeriod":"calendar___notInPeriod-3ubBX","itemText":"calendar__itemText-ROiDf","year":"calendar__year-17tDE","_isDisabled":"calendar___isDisabled-2oUEe","month":"calendar__month-3RpLQ","_isInRange":"calendar___isInRange-2iUc2","_isBoundOfRange":"calendar___isBoundOfRange--Lbr5"};

/***/ }),
/* 856 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"check-list-select__wrapper-1JTGF","select":"check-list-select__select-2H5cy","isDisabled":"check-list-select__isDisabled-3X608","selectTitle":"check-list-select__selectTitle-1i1Yu","dropdown":"check-list-select__dropdown-y-Y8H","isOpen":"check-list-select__isOpen-2OFTU","bottomAppearance":"check-list-select__bottomAppearance-1DPhK","content":"check-list-select__content-1jkDl","options":"check-list-select__options-1GN1Z","option":"check-list-select__option-uEstu","optionWrapper":"check-list-select__optionWrapper-1_VFf","checkbox":"check-list-select__checkbox-1pDY8","label":"check-list-select__label-J9FwR","button":"check-list-select__button-2EcUe"};

/***/ }),
/* 857 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"checkbox__wrapper-3Rypw","checkbox":"checkbox__checkbox-5tfMb","title":"checkbox__title-1H2QJ","label":"checkbox__label-2cfnX"};

/***/ }),
/* 858 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"datepicker__wrapper-21LAX","appearButton":"datepicker__appearButton-2EJoJ","clearButton":"datepicker__clearButton-3_rNd","appearButtonFrom":"datepicker__appearButtonFrom-wa8Xn","appearButtonTo":"datepicker__appearButtonTo-3oRKg","isDisabled":"datepicker__isDisabled-D9e2Q","container":"datepicker__container-2CM2S","twodatepickers":"datepicker__twodatepickers--XuXd","threedatepickers":"datepicker__threedatepickers-2DEKL","isOpen":"datepicker__isOpen-1zTDh","content":"datepicker__content-VV9mb","selectButton":"datepicker__selectButton-2HEY_","navigation":"datepicker__navigation-n9_lP","calendar":"datepicker__calendar-2LSRL","arrow":"datepicker__arrow-1nOF1","left":"datepicker__left-1D254","right":"datepicker__right-Vhwfa","inActive":"datepicker__inActive-x64lF","panel":"datepicker__panel-3UGBx","periods":"datepicker__periods-1uCH2","isHidden":"datepicker__isHidden-3S0oL","period":"datepicker__period-2TVZn","error":"datepicker__error-3H49S","isDisable":"datepicker__isDisable--cm4Z","from":"datepicker__from-2bd-2","till":"datepicker__till-2JYDz","discounts":"datepicker__discounts-3Rm5k","noSelect":"datepicker__noSelect-2nEca"};

/***/ }),
/* 859 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"select":"filtered-select__select-2B_DI","isDisabled":"filtered-select__isDisabled-1ODtZ","input":"filtered-select__input-3TmnW","error":"filtered-select__error-3USIs","small":"filtered-select__small-1ZwPT","title":"filtered-select__title-3Zkhr","arrow":"filtered-select__arrow-2gS4B","dropdown":"filtered-select__dropdown-HOPoV","isUp":"filtered-select__isUp-3TZNz","isOpen":"filtered-select__isOpen-2k9nB","bottomAppearance":"filtered-select__bottomAppearance-1Jd2v","topAppearance":"filtered-select__topAppearance-1dihz","textfieldWrapper":"filtered-select__textfieldWrapper-36U8A","textfield":"filtered-select__textfield-1e6d6","options":"filtered-select__options-N1VX9","option":"filtered-select__option-30iMs","isHighlighted":"filtered-select__isHighlighted-3hO47","scrolltrack":"filtered-select__scrolltrack-32WMi","scrollbar":"filtered-select__scrollbar-u81Tb","subtitle":"filtered-select__subtitle-61kkq","isAdding":"filtered-select__isAdding-3sfoo","big":"filtered-select__big-Nmex0","square":"filtered-select__square-2c0Xw","circle":"filtered-select__circle-3-0YY","yellow-green":"filtered-select__yellow-green-1cVAi","transparent":"filtered-select__transparent-dTvc7","green":"filtered-select__green-1zSKQ","blue":"filtered-select__blue-3sdfs","orange":"filtered-select__orange-2p0-K","ocean":"filtered-select__ocean-R26kg","yellow":"filtered-select__yellow-ScCZL","violet":"filtered-select__violet-3RJxN","pink":"filtered-select__pink-2Dfw6","gray":"filtered-select__gray-12dVp"};

/***/ }),
/* 860 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"radio__wrapper-3tCMN","radio":"radio__radio-1_9rG","title":"radio__title-3b5lT","label":"radio__label-1LtlI"};

/***/ }),
/* 861 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"segmented-select__block-3l84T","options":"segmented-select__options-hZNG1","option":"segmented-select__option-13lzZ","button":"segmented-select__button-13YzL","isHighlighted":"segmented-select__isHighlighted-1_SsK","isDisabled":"segmented-select__isDisabled-1zWZd","_square":"segmented-select___square-1tM99","_circle":"segmented-select___circle-2GYZe","_small":"segmented-select___small-3BXj4","_yellow-green":"segmented-select___yellow-green-3B2Wd","_transparent":"segmented-select___transparent-2EhLG","_green":"segmented-select___green-3QHHF","_blue":"segmented-select___blue-1ou7B","_orange":"segmented-select___orange-1b2Hz","_ocean":"segmented-select___ocean-ThVlQ","_yellow":"segmented-select___yellow-36ivX","_violet":"segmented-select___violet-2gG70","_pink":"segmented-select___pink-1MO-v","extra":"segmented-select__extra-2xD-F"};

/***/ }),
/* 862 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"select":"select__select-D0zlN","isDisabled":"select__isDisabled-_wUUL","input":"select__input-2YqcI","error":"select__error-2m2fz","small":"select__small-223O0","title":"select__title-1dfLu","arrow":"select__arrow-2a95o","dropdown":"select__dropdown-32uoT","isUp":"select__isUp-gsZNN","isOpen":"select__isOpen-1j_y3","bottomAppearance":"select__bottomAppearance-RAoay","topAppearance":"select__topAppearance-16ap_","options":"select__options-g99_w","option":"select__option-Qz3vK","isHighlighted":"select__isHighlighted-1pnKO","scrolltrack":"select__scrolltrack-1KFcZ","scrollbar":"select__scrollbar-3wQZc","subtitle":"select__subtitle-xIIau","isAdding":"select__isAdding-20bt-","big":"select__big-2ucS5","square":"select__square-9il1Q","circle":"select__circle-MWlKa","yellow-green":"select__yellow-green-1UVhk","transparent":"select__transparent-Ek2ts","green":"select__green-3OBCO","blue":"select__blue-1MFYb","orange":"select__orange-3dFiS","ocean":"select__ocean-cbM3K","yellow":"select__yellow-2W3rW","violet":"select__violet-3Y3PM","pink":"select__pink-25sD4","gray":"select__gray-1KZyc"};

/***/ }),
/* 863 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"subnavigation__block-1dIxa","container":"subnavigation__container-Up_Cc","underlined":"subnavigation__underlined-1oAwV","item":"subnavigation__item-1PmjL","isSelected":"subnavigation__isSelected-f6Xmf","isClickable":"subnavigation__isClickable-Bipan"};

/***/ }),
/* 864 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"text__block-WswKx","textfield":"text__textfield-ZlgwD","isDisabled":"text__isDisabled-104-7","limit":"text__limit-37ccF","tooltip":"text__tooltip-3kAXg","showLimit":"text__showLimit-1iFZ- text__textfield-ZlgwD","popupMode":"text__popupMode-2ysyr","hasError":"text__hasError-noYp_","tooltipWrapper":"text__tooltipWrapper-1GkVE","leftToRightWrapper":"text__leftToRightWrapper-2h2CI","topToBottomWrapper":"text__topToBottomWrapper-EneVf","topToBottom":"text__topToBottom-EtcPX","leftToRight":"text__leftToRight-1i4Nu"};

/***/ }),
/* 865 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"content":"calendar__content-2p0-O","monthName":"calendar__monthName-2RBZi","weekTitleText":"calendar__weekTitleText-ebHPL","table":"calendar__table-vSKQT","item":"calendar__item-26cWO","_notInPeriod":"calendar___notInPeriod-3hWrJ","itemText":"calendar__itemText-2UwjO","year":"calendar__year-2o1AS","_isDisabled":"calendar___isDisabled-3kb53","month":"calendar__month-1yXVZ","_isInRange":"calendar___isInRange-To4Q7","_isBoundOfRange":"calendar___isBoundOfRange-1wLQA"};

/***/ }),
/* 866 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"check-list-select__wrapper-H_Yeo","select":"check-list-select__select-33Jy7","isDisabled":"check-list-select__isDisabled-daan-","selectTitle":"check-list-select__selectTitle-2lwOe","dropdown":"check-list-select__dropdown-3-VBy","isOpen":"check-list-select__isOpen-3LSXk","bottomAppearance":"check-list-select__bottomAppearance-3RCts","content":"check-list-select__content-12SAR","options":"check-list-select__options-1H-Mt","option":"check-list-select__option-3Ff-g","optionWrapper":"check-list-select__optionWrapper-2itXN","checkbox":"check-list-select__checkbox-2f6Rz","label":"check-list-select__label-2FEOa","button":"check-list-select__button-2ZHCr"};

/***/ }),
/* 867 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"checkbox__wrapper-ePc3E","checkbox":"checkbox__checkbox-2cDWr","title":"checkbox__title-2nZRM","label":"checkbox__label-3VR3L"};

/***/ }),
/* 868 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"datepicker__wrapper-2oeLT","appearButton":"datepicker__appearButton-2DxEk","clearButton":"datepicker__clearButton-2m_B7","appearButtonFrom":"datepicker__appearButtonFrom-1jCiY","appearButtonTo":"datepicker__appearButtonTo-2dMh5","isDisabled":"datepicker__isDisabled-zfJFj","container":"datepicker__container-Z5LHK","twodatepickers":"datepicker__twodatepickers-Pr9Nb","threedatepickers":"datepicker__threedatepickers-2qd29","isOpen":"datepicker__isOpen-3M3eh","content":"datepicker__content-bHin0","selectButton":"datepicker__selectButton-3ftR3","navigation":"datepicker__navigation-3RPi6","calendar":"datepicker__calendar-3enSR","arrow":"datepicker__arrow-35DwS","left":"datepicker__left-3ObFD","right":"datepicker__right-399y7","inActive":"datepicker__inActive-331wn","panel":"datepicker__panel-1sHt8","periods":"datepicker__periods-QG2nQ","isHidden":"datepicker__isHidden-S0gGL","period":"datepicker__period-2fmPV","error":"datepicker__error-2I9xm","isDisable":"datepicker__isDisable-wob8i","from":"datepicker__from-27RfB","till":"datepicker__till-2ZX6U","discounts":"datepicker__discounts-1wVV9","noSelect":"datepicker__noSelect-3Ik6U"};

/***/ }),
/* 869 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"select":"filtered-select__select-3RY89","isDisabled":"filtered-select__isDisabled-3PjKO","input":"filtered-select__input-2Vsm6","error":"filtered-select__error-2SpRU","small":"filtered-select__small-3Pqj2","title":"filtered-select__title-1j2ds","arrow":"filtered-select__arrow-1pPLp","dropdown":"filtered-select__dropdown-aJWAW","isUp":"filtered-select__isUp-IFDZ9","isOpen":"filtered-select__isOpen-3Vbt6","bottomAppearance":"filtered-select__bottomAppearance-3zhsX","topAppearance":"filtered-select__topAppearance-sN4k_","textfieldWrapper":"filtered-select__textfieldWrapper-hD464","textfield":"filtered-select__textfield-1YMv6","options":"filtered-select__options-3ddgx","option":"filtered-select__option-1i0Vo","isHighlighted":"filtered-select__isHighlighted-36rbA","scrolltrack":"filtered-select__scrolltrack-3Ved5","scrollbar":"filtered-select__scrollbar-31anE","subtitle":"filtered-select__subtitle-2Os2t","isAdding":"filtered-select__isAdding-33Ots","big":"filtered-select__big-2TNRX","square":"filtered-select__square-3tG4U","circle":"filtered-select__circle-15C6V","yellow-green":"filtered-select__yellow-green-3uSc2","transparent":"filtered-select__transparent-3VGCq","green":"filtered-select__green-1XmLL","blue":"filtered-select__blue-_1795","orange":"filtered-select__orange-Tg44n","ocean":"filtered-select__ocean-14oWR","yellow":"filtered-select__yellow-3eo8E","violet":"filtered-select__violet-_eEXn","pink":"filtered-select__pink-3vdE2","gray":"filtered-select__gray-19AdD"};

/***/ }),
/* 870 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"radio__wrapper-1Lco_","radio":"radio__radio-3_Xob","title":"radio__title-1Ws42","label":"radio__label-1Fb1A"};

/***/ }),
/* 871 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"segmented-select__block-1g36x","options":"segmented-select__options-3LAII","option":"segmented-select__option-3WnRS","button":"segmented-select__button-1vffN","isHighlighted":"segmented-select__isHighlighted-dA18j","isDisabled":"segmented-select__isDisabled-3Mc2Y","_square":"segmented-select___square-EOUN_","_circle":"segmented-select___circle-2AnFy","_small":"segmented-select___small-w2yaO","_yellow-green":"segmented-select___yellow-green-NDQcW","_transparent":"segmented-select___transparent-1K5PC","_green":"segmented-select___green-3BZWq","_blue":"segmented-select___blue-1fA9W","_orange":"segmented-select___orange-UNR7G","_ocean":"segmented-select___ocean-1bC4V","_yellow":"segmented-select___yellow-2du5V","_violet":"segmented-select___violet-nxtaz","_pink":"segmented-select___pink-2gZJx","extra":"segmented-select__extra-UwboH"};

/***/ }),
/* 872 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"select":"select__select-2nNDt","isDisabled":"select__isDisabled-1Py2o","input":"select__input-2c11k","error":"select__error-1jFTV","small":"select__small-3TdjB","title":"select__title-nHIth","arrow":"select__arrow-2uYqY","dropdown":"select__dropdown-saEYi","isUp":"select__isUp-mGT9R","isOpen":"select__isOpen-1lR1O","bottomAppearance":"select__bottomAppearance-2F9Ma","topAppearance":"select__topAppearance-2UTFp","options":"select__options-tYCnT","option":"select__option-o5UlD","isHighlighted":"select__isHighlighted-Vz0XQ","scrolltrack":"select__scrolltrack-2-3iW","scrollbar":"select__scrollbar-3BQ1c","subtitle":"select__subtitle-1eh2p","isAdding":"select__isAdding-3P1-q","big":"select__big-2NERx","square":"select__square-3jbf2","circle":"select__circle-HJb8Q","yellow-green":"select__yellow-green-78vFt","transparent":"select__transparent-FAFF9","green":"select__green-3EsVf","blue":"select__blue-YVEG6","orange":"select__orange-2yN_h","ocean":"select__ocean-1w3ka","yellow":"select__yellow-1NCmi","violet":"select__violet-2Rl2h","pink":"select__pink-1Kbm_","gray":"select__gray-3r65z"};

/***/ }),
/* 873 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"subnavigation__block-3aOlW","container":"subnavigation__container-3aMSK","underlined":"subnavigation__underlined-3yJAS","item":"subnavigation__item-3Bsyp","isSelected":"subnavigation__isSelected-1FXId","isClickable":"subnavigation__isClickable-2mzbZ"};

/***/ }),
/* 874 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"block":"text__block-8eLMj","textfield":"text__textfield-QsmC2","isDisabled":"text__isDisabled-3x614","limit":"text__limit-2_iX2","tooltip":"text__tooltip-MDzVg","showLimit":"text__showLimit-1hooH text__textfield-QsmC2","popupMode":"text__popupMode-3BiRz","hasError":"text__hasError-1kvWK","tooltipWrapper":"text__tooltipWrapper-1Epb1","leftToRightWrapper":"text__leftToRightWrapper-wlc-4","topToBottomWrapper":"text__topToBottomWrapper-3HiCz","topToBottom":"text__topToBottom-1AMW7","leftToRight":"text__leftToRight-2BqxE"};

/***/ }),
/* 875 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"select":"button-like-select__select-1azfi","isDisabled":"button-like-select__isDisabled-bCKbJ","input":"button-like-select__input-1gdXM","small":"button-like-select__small-1Yc4Z","title":"button-like-select__title-2VPBR","isOpen":"button-like-select__isOpen-1UPhW","arrow":"button-like-select__arrow-3WfR5","dropdown":"button-like-select__dropdown-3fPqJ","topToBottom":"button-like-select__topToBottom-2fU86","topToBottomAnimation":"button-like-select__topToBottomAnimation-2eYTk","isUp":"button-like-select__isUp-64qp9","bottomAppearance":"button-like-select__bottomAppearance-2Oqrh","topAppearance":"button-like-select__topAppearance-3sbDJ","options":"button-like-select__options-3bm56","option":"button-like-select__option-3OBZ0","isHighlighted":"button-like-select__isHighlighted-1wt14","scrolltrack":"button-like-select__scrolltrack-1EI2I","scrollbar":"button-like-select__scrollbar-27CpJ","subtitle":"button-like-select__subtitle-1Ae8f","isAdding":"button-like-select__isAdding-2VVRA","big":"button-like-select__big-1FG6Y","square":"button-like-select__square-2TxXf","circle":"button-like-select__circle-2tOmz","yellow-green":"button-like-select__yellow-green-2_pZm","transparent":"button-like-select__transparent-36-5a","green":"button-like-select__green-1d54x","blue":"button-like-select__blue-1r-N1","orange":"button-like-select__orange-SNgCY","ocean":"button-like-select__ocean-1ez2P","yellow":"button-like-select__yellow-2X7Gl","violet":"button-like-select__violet-1jYjR","pink":"button-like-select__pink-1qpv1","gray":"button-like-select__gray-3xZSa"};

/***/ }),
/* 876 */
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint no-invalid-this: 1 */
	
	var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
	var toStr = Object.prototype.toString;
	var max = Math.max;
	var funcType = '[object Function]';
	
	var concatty = function concatty(a, b) {
	    var arr = [];
	
	    for (var i = 0; i < a.length; i += 1) {
	        arr[i] = a[i];
	    }
	    for (var j = 0; j < b.length; j += 1) {
	        arr[j + a.length] = b[j];
	    }
	
	    return arr;
	};
	
	var slicy = function slicy(arrLike, offset) {
	    var arr = [];
	    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
	        arr[j] = arrLike[i];
	    }
	    return arr;
	};
	
	var joiny = function (arr, joiner) {
	    var str = '';
	    for (var i = 0; i < arr.length; i += 1) {
	        str += arr[i];
	        if (i + 1 < arr.length) {
	            str += joiner;
	        }
	    }
	    return str;
	};
	
	module.exports = function bind(that) {
	    var target = this;
	    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
	        throw new TypeError(ERROR_MESSAGE + target);
	    }
	    var args = slicy(arguments, 1);
	
	    var bound;
	    var binder = function () {
	        if (this instanceof bound) {
	            var result = target.apply(
	                this,
	                concatty(args, arguments)
	            );
	            if (Object(result) === result) {
	                return result;
	            }
	            return this;
	        }
	        return target.apply(
	            that,
	            concatty(args, arguments)
	        );
	
	    };
	
	    var boundLength = max(0, target.length - args.length);
	    var boundArgs = [];
	    for (var i = 0; i < boundLength; i++) {
	        boundArgs[i] = '$' + i;
	    }
	
	    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
	
	    if (target.prototype) {
	        var Empty = function Empty() {};
	        Empty.prototype = target.prototype;
	        bound.prototype = new Empty();
	        Empty.prototype = null;
	    }
	
	    return bound;
	};


/***/ }),
/* 877 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./gOPD')} */
	module.exports = Object.getOwnPropertyDescriptor;


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", alias4=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <cat-"
	    + alias4(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"name","hash":{},"data":data,"loc":{"start":{"line":3,"column":13},"end":{"line":3,"column":21}}}) : helper)))
	    + " id=\""
	    + alias4(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":3,"column":26},"end":{"line":3,"column":32}}}) : helper)))
	    + "\"\n            "
	    + ((stack1 = lookupProperty(helpers,"each").call(alias1,(depth0 != null ? lookupProperty(depth0,"attributes") : depth0),{"name":"each","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":12},"end":{"line":4,"column":63}}})) != null ? stack1 : "")
	    + ">\n            </cat-"
	    + alias4(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"name","hash":{},"data":data,"loc":{"start":{"line":5,"column":18},"end":{"line":5,"column":26}}}) : helper)))
	    + ">\n";
	},"2":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", alias4=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return " "
	    + alias4(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"name","hash":{},"data":data,"loc":{"start":{"line":4,"column":33},"end":{"line":4,"column":41}}}) : helper)))
	    + "=\""
	    + alias4(((helper = (helper = lookupProperty(helpers,"value") || (depth0 != null ? lookupProperty(depth0,"value") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"value","hash":{},"data":data,"loc":{"start":{"line":4,"column":43},"end":{"line":4,"column":52}}}) : helper)))
	    + "\" ";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"block") : stack1), depth0))
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"components") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":6,"column":13}}})) != null ? stack1 : "")
	    + "</div>\n";
	},"useData":true});

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    return "<cat-select id=\"managerOrderCreate\" cat-name=\"createOrder\"></cat-select>\n";
	},"useData":true});

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <input name=\""
	    + alias1(((helper = (helper = lookupProperty(helpers,"key") || (data && lookupProperty(data,"key"))) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"key","hash":{},"data":data,"loc":{"start":{"line":3,"column":21},"end":{"line":3,"column":29}}}) : helper)))
	    + "\" value=\""
	    + alias1(container.lambda(depth0, depth0))
	    + "\" type=\"hidden\"/>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression, alias3=container.lambda, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<form action=\""
	    + alias2(((helper = (helper = lookupProperty(helpers,"url") || (depth0 != null ? lookupProperty(depth0,"url") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"url","hash":{},"data":data,"loc":{"start":{"line":1,"column":14},"end":{"line":1,"column":21}}}) : helper)))
	    + "\" method=\"post\" class=\""
	    + alias2(alias3(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"paymentForm") : stack1), depth0))
	    + "\" target=\"_blank\">\n"
	    + ((stack1 = lookupProperty(helpers,"each").call(alias1,(depth0 != null ? lookupProperty(depth0,"data") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":4,"column":13}}})) != null ? stack1 : "")
	    + "    <input class=\""
	    + alias2(alias3(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"payOnline") : stack1), depth0))
	    + "\" type=\"submit\" value=\"Оплатить\">\n</form>\n";
	},"useData":true});

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"licenseBlock") : stack1), depth0))
	    + "\">\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"licenseCheckbox") : stack1), depth0))
	    + "\">\n            <cat-license-checkbox id=\"userAcceptLicenseAgreement\" cat-path=\"userAcceptLicenseAgreement\"\n                                  cat-title=\"Я ознакомился и согласен с условиями\">\n            </cat-license-checkbox>\n            <a href=\"/terms\" target=\"_blank\" class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"link")), depth0))
	    + "\">оферты на заключение договора на предоставление доступа к сервису Data.2gis</a>\n        </div>\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"showLicenseMustBeAccepted") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":8},"end":{"line":13,"column":15}}})) != null ? stack1 : "")
	    + "    </div>\n";
	},"2":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"tooltipWrapper") : stack1), depth0))
	    + "\">\n                <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"tooltip") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"licenseTooltip") : stack1), depth0))
	    + "\">Необходимо принять лицензионное соглашение</div>\n            </div>\n";
	},"4":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <button class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"saveAllButton") : stack1), depth0))
	    + "\">Сохранить</button>\n        <button class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"cancelAllButton") : stack1), depth0))
	    + "\" onClick=\"history.go(0)\" VALUE=\"Refresh\">Отменить</button>\n";
	},"6":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"disableContinue") : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.program(9, data, 0),"data":data,"loc":{"start":{"line":22,"column":8},"end":{"line":31,"column":15}}})) != null ? stack1 : "");
	},"7":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"repeatTooltipWrapper")), depth0))
	    + "\">\n                <button class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"continueButton") : stack1), depth0))
	    + "\" disabled>"
	    + alias2(((helper = (helper = lookupProperty(helpers,"continueButtonLabel") || (depth0 != null ? lookupProperty(depth0,"continueButtonLabel") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"continueButtonLabel","hash":{},"data":data,"loc":{"start":{"line":24,"column":64},"end":{"line":24,"column":87}}}) : helper)))
	    + "</button>\n                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"repeatTooltip")), depth0))
	    + "\">\n                    В данный момент недоступно. Пожалуйста, повторите через 5 минут.\n                </div>\n            </div>\n";
	},"9":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <button class=\""
	    + alias1(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"continueButton") : stack1), depth0))
	    + "\">"
	    + alias1(((helper = (helper = lookupProperty(helpers,"continueButtonLabel") || (depth0 != null ? lookupProperty(depth0,"continueButtonLabel") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"continueButtonLabel","hash":{},"data":data,"loc":{"start":{"line":30,"column":51},"end":{"line":30,"column":74}}}) : helper)))
	    + "</button>\n";
	},"11":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"showPayOnlineButton") : depth0),{"name":"if","hash":{},"fn":container.program(12, data, 0),"inverse":container.program(14, data, 0),"data":data,"loc":{"start":{"line":32,"column":4},"end":{"line":36,"column":4}}})) != null ? stack1 : "");
	},"12":function(container,depth0,helpers,partials,data) {
	    return "        <cat-payment-form></cat-payment-form>\n";
	},"14":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"showMakeOrderButton") : depth0),{"name":"if","hash":{},"fn":container.program(15, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":34,"column":4},"end":{"line":36,"column":4}}})) != null ? stack1 : "");
	},"15":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <button class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"makeOrderButton") : stack1), depth0))
	    + "\">Продолжить</button>\n    ";
	},"17":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <button class=\""
	    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"redirectToLeadsMapping")), depth0))
	    + "\">Экспорт лидов в Битрикс24</button>\n";
	},"19":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"showRepeatButton") : depth0),{"name":"if","hash":{},"fn":container.program(20, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":41,"column":8},"end":{"line":48,"column":15}}})) != null ? stack1 : "");
	},"20":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"repeatTooltipWrapper")), depth0))
	    + "\">\n                <button class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"repeatOrderButton") : stack1), depth0))
	    + "\">Повторить</button>\n                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"repeatTooltip")), depth0))
	    + "\">\n                    Создать заказ с теми же параметрами\n                </div>\n            </div>\n";
	},"22":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <button class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"cancelButton") : stack1), depth0))
	    + "\">Удалить</button>\n";
	},"24":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"repeatTooltipWrapper")), depth0))
	    + "\">\n            <button class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"redirectToLeadsMappingFree")), depth0))
	    + "\" "
	    + ((stack1 = lookupProperty(helpers,"unless").call(alias3,(depth0 != null ? lookupProperty(depth0,"hasBitrixLeads") : depth0),{"name":"unless","hash":{},"fn":container.program(25, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":55,"column":69},"end":{"line":55,"column":114}}})) != null ? stack1 : "")
	    + ">\n                Попробовать бесплатно\n            </button>\n            <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"repeatTooltip")), depth0))
	    + " "
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"bitrixFreeTooltip")), depth0))
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"hasBitrixLeads") : depth0),{"name":"if","hash":{},"fn":container.program(27, data, 0),"inverse":container.program(29, data, 0),"data":data,"loc":{"start":{"line":59,"column":16},"end":{"line":63,"column":23}}})) != null ? stack1 : "")
	    + "            </div>\n        </div>\n";
	},"25":function(container,depth0,helpers,partials,data) {
	    return "disabled";
	},"27":function(container,depth0,helpers,partials,data) {
	    return "                    Экспортировать часть организаций бесплатно в Битрикс24\n";
	},"29":function(container,depth0,helpers,partials,data) {
	    return "                    Возможность бесплатного экспорта в Битрикс24 будет доступна через несколько секунд\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"showLicenseAgreementCheckbox") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":15,"column":7}}})) != null ? stack1 : "")
	    + "<div>\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"showSaveAllButton") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":17,"column":4},"end":{"line":20,"column":11}}})) != null ? stack1 : "")
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"showContinueButton") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.program(11, data, 0),"data":data,"loc":{"start":{"line":21,"column":4},"end":{"line":36,"column":11}}})) != null ? stack1 : "")
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"showBitrixExportButton") : depth0),{"name":"if","hash":{},"fn":container.program(17, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":37,"column":4},"end":{"line":39,"column":11}}})) != null ? stack1 : "")
	    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,(depth0 != null ? lookupProperty(depth0,"showSaveAllButton") : depth0),{"name":"unless","hash":{},"fn":container.program(19, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":40,"column":4},"end":{"line":49,"column":15}}})) != null ? stack1 : "")
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"showArchiveButton") : depth0),{"name":"if","hash":{},"fn":container.program(22, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":50,"column":4},"end":{"line":52,"column":11}}})) != null ? stack1 : "")
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"showFreeBitrixExportButton") : depth0),{"name":"if","hash":{},"fn":container.program(24, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":53,"column":4},"end":{"line":66,"column":11}}})) != null ? stack1 : "")
	    + "</div>\n\n\n";
	},"useData":true});

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "    <a href=\"https://"
	    + alias1(((helper = (helper = lookupProperty(helpers,"domain") || (depth0 != null ? lookupProperty(depth0,"domain") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"domain","hash":{},"data":data,"loc":{"start":{"line":3,"column":21},"end":{"line":3,"column":31}}}) : helper)))
	    + "/crm/lead/list/\">\n        <button class=\""
	    + alias1(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"openCrmLeadButton")), depth0))
	    + "\">На страницу лидов</button>\n    </a>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "    <button class=\""
	    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"exportButton")), depth0))
	    + "\" "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"isExportRunning") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":47},"end":{"line":7,"column":85}}})) != null ? stack1 : "")
	    + "\n        "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"mappingError") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":8},"end":{"line":8,"column":43}}})) != null ? stack1 : "")
	    + ">Экспорт</button>\n";
	},"4":function(container,depth0,helpers,partials,data) {
	    return "disabled";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<button class=\""
	    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"backButton")), depth0))
	    + "\">Назад к заказу</button>\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isExportDone") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":2,"column":0},"end":{"line":9,"column":7}}})) != null ? stack1 : "");
	},"useData":true});

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "    <span class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"error") : stack1), depth0))
	    + "\">Необходимо экспортировать данные в обязательные поля:\n"
	    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isTitleNotFilled") : depth0),{"name":"each","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":5,"column":13}}})) != null ? stack1 : "")
	    + "    </span>\n";
	},"2":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        "
	    + container.escapeExpression(container.lambda(depth0, depth0))
	    + ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),(data && lookupProperty(data,"last")),{"name":"unless","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":16},"end":{"line":4,"column":46}}})) != null ? stack1 : "")
	    + "\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    return ", ";
	},"5":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"mappingDuplicate") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":4},"end":{"line":10,"column":11}}})) != null ? stack1 : "");
	},"6":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <span class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"error") : stack1), depth0))
	    + "\">Нельзя экспортировать несколько полей выборки в одно поле Битрикс.</span>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isTitleNotFilled") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(5, data, 0),"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":11,"column":7}}})) != null ? stack1 : "");
	},"useData":true});

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), alias4=container.hooks.helperMissing, alias5="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"control") : stack1), depth0))
	    + "\">\n            <cat-new-field id=\"lead-text-"
	    + alias2(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":4,"column":41},"end":{"line":4,"column":47}}}) : helper)))
	    + "\"\n                           path=\"account.orders.currentOrder.bitrixExportLeads.mapping."
	    + alias2(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":5,"column":87},"end":{"line":5,"column":93}}}) : helper)))
	    + ".newLabel\"\n                           error-path=\"account.orders.currentOrder.bitrixExportLeads.mapping."
	    + alias2(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":6,"column":93},"end":{"line":6,"column":99}}}) : helper)))
	    + ".error\"\n                           cat-field=\""
	    + alias2(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":7,"column":38},"end":{"line":7,"column":44}}}) : helper)))
	    + "\"></cat-new-field>\n        </div>\n        <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"tooltipWrapper")), depth0))
	    + "\">\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"toggleNew") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"delete") : stack1), depth0))
	    + "\" cat-id=\""
	    + alias2(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":10,"column":66},"end":{"line":10,"column":72}}}) : helper)))
	    + "\">\n            </div>\n            <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"tooltip")), depth0))
	    + "\">\n                Выбрать из существующих полей\n            </div>\n        </div>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.escapeExpression, alias2=depth0 != null ? depth0 : (container.nullContext || {}), alias3=container.hooks.helperMissing, alias4="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias1(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"control") : stack1), depth0))
	    + "\">\n            <cat-select id=\"leads"
	    + alias1(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":18,"column":33},"end":{"line":18,"column":39}}}) : helper)))
	    + "\" cat-name=\"leads"
	    + alias1(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":18,"column":56},"end":{"line":18,"column":62}}}) : helper)))
	    + "\" cat-field=\""
	    + alias1(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":18,"column":75},"end":{"line":18,"column":81}}}) : helper)))
	    + "\"></cat-select>\n        </div>\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias2,(depth0 != null ? lookupProperty(depth0,"hasFieldCreationRight") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":20,"column":8},"end":{"line":28,"column":15}}})) != null ? stack1 : "");
	},"4":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"tooltipWrapper")), depth0))
	    + "\">\n                <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"toggleNew") : stack1), depth0))
	    + "\" cat-id=\""
	    + alias2(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"id","hash":{},"data":data,"loc":{"start":{"line":22,"column":55},"end":{"line":22,"column":61}}}) : helper)))
	    + "\">\n                </div>\n                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"tooltip")), depth0))
	    + "\">\n                    Создать новое поле\n                </div>\n            </div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div>\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isNew") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":29,"column":11}}})) != null ? stack1 : "")
	    + "</div>\n\n";
	},"useData":true});

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"progressBar")), depth0))
	    + "\" id=\"export-leads-progress-bar\">\n    <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"progressBarInner")), depth0))
	    + "\" id=\"export-leads-progress-bar-inner\"></div>\n    <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"progressPercentage")), depth0))
	    + "\" id=\"export-leads-progress-percentage\">0%</div>\n    <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"progressName")), depth0))
	    + "\" id=\"export-leads-progress-name\"></div>\n</div>\n";
	},"useData":true});

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"content") : stack1), depth0))
	    + "\">\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"description") : stack1), depth0))
	    + "\">\n        Если в выборке нет подходящих данных для обязательного поля, укажите значение поля ниже:\n    </div>\n"
	    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"requiredBitrixFields") : depth0),{"name":"each","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":4},"end":{"line":36,"column":13}}})) != null ? stack1 : "")
	    + "</div>\n";
	},"2":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), alias4=container.hooks.helperMissing, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"field")), depth0))
	    + "\">\n            <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"title")), depth0))
	    + "\">\n                "
	    + alias2(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : alias4),(typeof helper === "function" ? helper.call(alias3,{"name":"name","hash":{},"data":data,"loc":{"start":{"line":9,"column":16},"end":{"line":9,"column":24}}}) : helper)))
	    + "\n            </div>\n            <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"listBox")), depth0))
	    + "\">\n"
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"type") : depth0),"===","number",{"name":"compare","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":12,"column":16},"end":{"line":17,"column":28}}})) != null ? stack1 : "")
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"type") : depth0),"===","string",{"name":"compare","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":18,"column":16},"end":{"line":22,"column":28}}})) != null ? stack1 : "")
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"type") : depth0),"===","boolean",{"name":"compare","hash":{},"fn":container.program(7, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":23,"column":16},"end":{"line":26,"column":28}}})) != null ? stack1 : "")
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"type") : depth0),"===","datetime",{"name":"compare","hash":{},"fn":container.program(9, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":27,"column":16},"end":{"line":29,"column":28}}})) != null ? stack1 : "")
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"type") : depth0),"===","enumeration",{"name":"compare","hash":{},"fn":container.program(11, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":30,"column":16},"end":{"line":33,"column":28}}})) != null ? stack1 : "")
	    + "            </div>\n        </div>\n";
	},"3":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                    <cat-required-field-value-number id=\"lead-required-field-"
	    + alias2(alias1((depths[1] != null ? lookupProperty(depths[1],"id") : depths[1]), depth0))
	    + "\"\n                              path=\"account.orders.currentOrder.bitrixExportLeads.requiredFields."
	    + alias2(alias1((depths[1] != null ? lookupProperty(depths[1],"id") : depths[1]), depth0))
	    + ".value\"\n                              error-path=\"account.orders.currentOrder.bitrixExportLeads.requiredFields."
	    + alias2(alias1((depths[1] != null ? lookupProperty(depths[1],"id") : depths[1]), depth0))
	    + ".error\"\n                              cat-field=\""
	    + alias2(alias1((depths[1] != null ? lookupProperty(depths[1],"id") : depths[1]), depth0))
	    + "\"></cat-required-field-value-number>\n";
	},"5":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                    <cat-required-field-value id=\"lead-required-field-"
	    + alias2(alias1((depths[1] != null ? lookupProperty(depths[1],"id") : depths[1]), depth0))
	    + "\"\n                              path=\"account.orders.currentOrder.bitrixExportLeads.requiredFields."
	    + alias2(alias1((depths[1] != null ? lookupProperty(depths[1],"id") : depths[1]), depth0))
	    + ".value\"\n                              cat-field=\""
	    + alias2(alias1((depths[1] != null ? lookupProperty(depths[1],"id") : depths[1]), depth0))
	    + "\"></cat-required-field-value>\n";
	},"7":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                    <cat-checkbox id=\"lead-required-field-"
	    + alias2(alias1((depths[1] != null ? lookupProperty(depths[1],"id") : depths[1]), depth0))
	    + "\" cat-path=\""
	    + alias2(alias1((depths[1] != null ? lookupProperty(depths[1],"id") : depths[1]), depth0))
	    + "\">\n                    </cat-checkbox>\n";
	},"9":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                    <cat-datepicker cat-id=\""
	    + alias2(alias1((depths[1] != null ? lookupProperty(depths[1],"id") : depths[1]), depth0))
	    + "\" id=\""
	    + alias2(alias1((depths[1] != null ? lookupProperty(depths[1],"id") : depths[1]), depth0))
	    + "\"></cat-datepicker>\n";
	},"11":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                    <cat-select id=\"lead-required-field-"
	    + alias2(alias1((depths[1] != null ? lookupProperty(depths[1],"id") : depths[1]), depth0))
	    + "\" cat-name=\"lead-required-field-"
	    + alias2(alias1((depths[1] != null ? lookupProperty(depths[1],"id") : depths[1]), depth0))
	    + "\"\n                                cat-field=\""
	    + alias2(alias1((depths[1] != null ? lookupProperty(depths[1],"id") : depths[1]), depth0))
	    + "\"></cat-select>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"requiredBitrixFields") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":38,"column":7}}})) != null ? stack1 : "");
	},"useData":true,"useDepths":true});

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "                <li>Чтобы экспортировать в новое поле, нажмите \"+\" и введите название нового поля.</li>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    return "                <li>Для экспорта в новое поле обратитесь к администратору портала, чтобы он создал новое поле\n                    лида, либо выдал вам \"Разрешение изменять настройки\" в CRM.\n                </li>\n                <li>При наличии \"Разрешения изменять настройки\" в CRM на этой странице появится возможность выгружать\n                    данные в новые поля.\n                </li>\n";
	},"5":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), alias4=container.hooks.helperMissing, alias5="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"field")), depth0))
	    + "\">\n                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"title")), depth0))
	    + "\">\n                    "
	    + alias2(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"name","hash":{},"data":data,"loc":{"start":{"line":27,"column":20},"end":{"line":27,"column":28}}}) : helper)))
	    + "\n                </div>\n                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"listBox")), depth0))
	    + "\">\n                    <cat-field-mapping cat-field=\""
	    + alias2(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":30,"column":50},"end":{"line":30,"column":56}}}) : helper)))
	    + "\"></cat-field-mapping>\n                </div>\n            </div>\n";
	},"7":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"freeLeadsAmount") : depth0),">",0,{"name":"compare","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":35,"column":12},"end":{"line":40,"column":24}}})) != null ? stack1 : "");
	},"8":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"checkboxBlock")), depth0))
	    + "\">\n                    <cat-checkbox id=\"includeExportedFreeLeads\" cat-title=\"Повторно выгрузить бесплатные лиды\">\n                    </cat-checkbox>\n                </div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"content") : stack1), depth0))
	    + "\">\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"header") : stack1), depth0))
	    + "\">\n        <cat-header></cat-header>\n    </div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"line") : stack1), depth0))
	    + "\"></div>\n    <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"tooltip")), depth0))
	    + "\">\n        <h2 class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"mainTitle") : stack1), depth0))
	    + "\">Инструкция к экспорту в Битрикс</h2>\n        <ol>\n            <li>Выберите в какие поля экспортировать данные.</li>\n            <li>Чтобы не экпортировать данные, выберите \"не экспортировать\".</li>\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"hasFieldCreationRight") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":11,"column":12},"end":{"line":20,"column":19}}})) != null ? stack1 : "")
	    + "        </ol>\n    </div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"fields") : stack1), depth0))
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"each").call(alias3,(depth0 != null ? lookupProperty(depth0,"hermesFields") : depth0),{"name":"each","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":24,"column":8},"end":{"line":33,"column":17}}})) != null ? stack1 : "")
	    + ((stack1 = lookupProperty(helpers,"unless").call(alias3,(depth0 != null ? lookupProperty(depth0,"isOnlyFreeLeads") : depth0),{"name":"unless","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":34,"column":8},"end":{"line":41,"column":19}}})) != null ? stack1 : "")
	    + "        <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"error")), depth0))
	    + "\">\n            <cat-error-tooltip></cat-error-tooltip>\n        </div>\n        <cat-required-fields-mapping></cat-required-fields-mapping>\n    </div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"line") : stack1), depth0))
	    + "\"></div>\n    <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"controls")), depth0))
	    + "\">\n        <cat-action-panel></cat-action-panel>\n        <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"progress")), depth0))
	    + "\">\n            <cat-progress-bar></cat-progress-bar>\n        </div>\n    </div>\n</div>\n";
	},"useData":true});

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"uploadFailTooltip") : stack1), depth0))
	    + "\">\n            Не удалось загрузить файл, возможно размер файла больше 250 МБ.\n        </div>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"uploadFailTooltip") : stack1), depth0))
	    + "\">\n            Необходимо прикрепить документ \"Счёт-оферта\"\n        </div>\n";
	},"5":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div>\n            <span class=\""
	    + alias1(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"downloadDraftLink")), depth0))
	    + "\" cat-order-id=\""
	    + alias1(((helper = (helper = lookupProperty(helpers,"orderId") || (depth0 != null ? lookupProperty(depth0,"orderId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"orderId","hash":{},"data":data,"loc":{"start":{"line":14,"column":72},"end":{"line":14,"column":83}}}) : helper)))
	    + "\" cat-type-id=\"1\">Черновик Счета-Оферты</span>\n        </div>\n";
	},"7":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), alias4=container.hooks.helperMissing, alias5="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div>\n            <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"documentRow")), depth0))
	    + "\">\n                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"documentTypeName")), depth0))
	    + " "
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"rowCell")), depth0))
	    + "\">\n                    <fieldset class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"fieldset")), depth0))
	    + "\" "
	    + ((stack1 = lookupProperty(helpers,"unless").call(alias3,(depth0 != null ? lookupProperty(depth0,"isCheckable") : depth0),{"name":"unless","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":21,"column":61},"end":{"line":21,"column":103}}})) != null ? stack1 : "")
	    + ">\n                        <cat-checkbox id=\"documentType"
	    + alias2(((helper = (helper = lookupProperty(helpers,"typeId") || (depth0 != null ? lookupProperty(depth0,"typeId") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"typeId","hash":{},"data":data,"loc":{"start":{"line":22,"column":54},"end":{"line":22,"column":64}}}) : helper)))
	    + "\"\n                                      class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"checkbox")), depth0))
	    + "\n                                          "
	    + ((stack1 = lookupProperty(helpers,"unless").call(alias3,(depth0 != null ? lookupProperty(depth0,"isCheckable") : depth0),{"name":"unless","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":24,"column":42},"end":{"line":24,"column":106}}})) != null ? stack1 : "")
	    + "\"\n                                      cat-path=\""
	    + alias2(((helper = (helper = lookupProperty(helpers,"key") || (data && lookupProperty(data,"key"))) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"key","hash":{},"data":data,"loc":{"start":{"line":25,"column":48},"end":{"line":25,"column":56}}}) : helper)))
	    + "\" cat-title=\""
	    + alias2(((helper = (helper = lookupProperty(helpers,"typeName") || (depth0 != null ? lookupProperty(depth0,"typeName") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"typeName","hash":{},"data":data,"loc":{"start":{"line":25,"column":69},"end":{"line":25,"column":81}}}) : helper)))
	    + "\">\n                        </cat-checkbox>\n                    </fieldset>\n                </div>\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isChecked") : depth0),{"name":"if","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":29,"column":16},"end":{"line":55,"column":23}}})) != null ? stack1 : "")
	    + "            </div>\n        </div>\n";
	},"8":function(container,depth0,helpers,partials,data) {
	    return "disabled";
	},"10":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"checkboxDisabled")), depth0));
	},"12":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"id") : depth0),{"name":"if","hash":{},"fn":container.program(13, data, 0),"inverse":container.program(17, data, 0),"data":data,"loc":{"start":{"line":30,"column":20},"end":{"line":54,"column":27}}})) != null ? stack1 : "");
	},"13":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), alias4=container.hooks.helperMissing, alias5="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                        <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"fileDownload")), depth0))
	    + " "
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"rowCell")), depth0))
	    + "\">\n                            <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"downloadFileName")), depth0))
	    + "\">\n                                <span class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"downloadFileLink")), depth0))
	    + "\" cat-id=\""
	    + alias2(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":33,"column":85},"end":{"line":33,"column":91}}}) : helper)))
	    + "\">"
	    + alias2(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"name","hash":{},"data":data,"loc":{"start":{"line":33,"column":93},"end":{"line":33,"column":101}}}) : helper)))
	    + "</span>\n                            </div>\n                        </div>\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"showNecessaryDocumentsAddDeleteButtons")),{"name":"if","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":36,"column":24},"end":{"line":40,"column":31}}})) != null ? stack1 : "");
	},"14":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isDeletable") : depth0),{"name":"if","hash":{},"fn":container.program(15, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":37,"column":28},"end":{"line":39,"column":35}}})) != null ? stack1 : "");
	},"15":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"deleteDocumentButton")), depth0))
	    + " "
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"rowCell")), depth0))
	    + "\" cat-documentId=\""
	    + alias2(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"id","hash":{},"data":data,"loc":{"start":{"line":38,"column":118},"end":{"line":38,"column":124}}}) : helper)))
	    + "\"></div>\n";
	},"17":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"showNecessaryDocumentsAddDeleteButtons")),{"name":"if","hash":{},"fn":container.program(18, data, 0),"inverse":container.program(21, data, 0),"data":data,"loc":{"start":{"line":41,"column":20},"end":{"line":54,"column":20}}})) != null ? stack1 : "");
	},"18":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isUploadable") : depth0),{"name":"if","hash":{},"fn":container.program(19, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":42,"column":24},"end":{"line":49,"column":31}}})) != null ? stack1 : "");
	},"19":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                            <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"rowCell")), depth0))
	    + "\">\n                                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"fileUpload")), depth0))
	    + " "
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"fileUploadButton")), depth0))
	    + "\">\n                                    <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"fileUploadButtonLabel")), depth0))
	    + "\">Прикрепить файл</div>\n                                    <input type=\"file\" class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"fileUploadInput")), depth0))
	    + "\" cat-documentTypeId=\""
	    + alias2(((helper = (helper = lookupProperty(helpers,"typeId") || (depth0 != null ? lookupProperty(depth0,"typeId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"typeId","hash":{},"data":data,"loc":{"start":{"line":46,"column":113},"end":{"line":46,"column":123}}}) : helper)))
	    + "\" accept=\".pdf\"/>\n                                </div>\n                            </div>\n";
	},"21":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"showDocumentsWillBeUploadedTooltip")),{"name":"if","hash":{},"fn":container.program(22, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":50,"column":20},"end":{"line":54,"column":20}}})) != null ? stack1 : "");
	},"22":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                        <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"documentsWillBeUploadedTooltip")), depth0))
	    + " "
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"rowCell")), depth0))
	    + "\">\n                            Документы скоро будут загружены\n                        </div>\n                    ";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div>\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"showUploadFailTooltip") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":6,"column":11}}})) != null ? stack1 : "")
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"showBillDocumentMustBeAttached") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":4},"end":{"line":11,"column":11}}})) != null ? stack1 : "")
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"showBillDraftDownloadButton") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":12,"column":4},"end":{"line":16,"column":11}}})) != null ? stack1 : "")
	    + ((stack1 = lookupProperty(helpers,"each").call(alias1,(depth0 != null ? lookupProperty(depth0,"documents") : depth0),{"name":"each","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":17,"column":4},"end":{"line":58,"column":13}}})) != null ? stack1 : "")
	    + "</div>\n";
	},"useData":true});

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <button class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"edit") : stack1), depth0))
	    + "\">Изменить</button>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <button class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"save") : stack1), depth0))
	    + "\" "
	    + ((stack1 = lookupProperty(helpers,"unless").call(alias3,(depth0 != null ? lookupProperty(depth0,"isFilerValuesControlEnabled") : depth0),{"name":"unless","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":37},"end":{"line":5,"column":95}}})) != null ? stack1 : "")
	    + ">Сохранить</button>\n        <button class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"cancel") : stack1), depth0))
	    + "\" "
	    + ((stack1 = lookupProperty(helpers,"unless").call(alias3,(depth0 != null ? lookupProperty(depth0,"isFilerValuesControlEnabled") : depth0),{"name":"unless","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":39},"end":{"line":6,"column":97}}})) != null ? stack1 : "")
	    + ">Отменить</button>\n";
	},"4":function(container,depth0,helpers,partials,data) {
	    return "disabled";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"toolbox") : stack1), depth0))
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isViewOnlyMode") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":7,"column":11}}})) != null ? stack1 : "")
	    + "</div>\n";
	},"useData":true});

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "        <cat-controls></cat-controls>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"controls") : stack1), depth0))
	    + "\">\n            <cat-controls></cat-controls>\n        </div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div>\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"isEditable") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":4,"column":11}}})) != null ? stack1 : "")
	    + "    <cat-custom-order></cat-custom-order>\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"isEditable") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":4},"end":{"line":10,"column":11}}})) != null ? stack1 : "")
	    + "</div>\n";
	},"useData":true});

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"uploadFailTooltip") : stack1), depth0))
	    + "\">\n            Необходимо прикрепить результат выборки\n        </div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"wrapper")), depth0))
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isExportResultMustBeAttached") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":6,"column":11}}})) != null ? stack1 : "")
	    + "\n    <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"fileUploadButton")), depth0))
	    + "\">\n        <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"fileUploadButtonLabel")), depth0))
	    + "\">Загрузить выборку</div>\n        <input type=\"file\" class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"fileResultUploadInput")), depth0))
	    + "\" accept=\".zip,.xls,.xlsx\" />\n    </div>\n</div>";
	},"useData":true});

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), alias4=container.hooks.helperMissing, alias5="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"downloadFileName")), depth0))
	    + "\">\n    <span class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"downloadFileLink")), depth0))
	    + "\" cat-id=\""
	    + alias2(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":3,"column":57},"end":{"line":3,"column":63}}}) : helper)))
	    + "\">"
	    + alias2(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"name","hash":{},"data":data,"loc":{"start":{"line":3,"column":65},"end":{"line":3,"column":73}}}) : helper)))
	    + "</span>\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"isCanDeleteResult")),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":4},"end":{"line":6,"column":11}}})) != null ? stack1 : "")
	    + "</div>\n";
	},"2":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias1(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"deleteDocumentButton")), depth0))
	    + "\" cat-documentId=\""
	    + alias1(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"id","hash":{},"data":data,"loc":{"start":{"line":5,"column":72},"end":{"line":5,"column":78}}}) : helper)))
	    + "\"></div>\n";
	},"4":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div>\n    <button class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"downloadAllButton")), depth0))
	    + "\" id=\"export-result-download-all-button\">Скачать всё</button>\n    <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"progressBar")), depth0))
	    + "\" id=\"download-all-progress-bar\">\n        <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"progressBarInner")), depth0))
	    + "\" id=\"download-all-progress-bar-inner\"></div>\n        <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"progressPercentage")), depth0))
	    + "\" id=\"download-all-progress-percentage\">0%</div>\n        <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"progressName")), depth0))
	    + "\" id=\"download-all-progress-name\"></div>\n    </div><br>\n</div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"each").call(alias1,(depth0 != null ? lookupProperty(depth0,"exportResult") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":8,"column":9}}})) != null ? stack1 : "")
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"showDownloadAllButton") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":0},"end":{"line":18,"column":7}}})) != null ? stack1 : "");
	},"useData":true});

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"column")), depth0))
	    + " "
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"priceBlock")), depth0))
	    + "\">\n    <cat-price cat-header></cat-price>\n</div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), alias4=container.hooks.helperMissing, alias5="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"column")), depth0))
	    + " "
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"id")), depth0))
	    + "\">\n    № "
	    + alias2(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":2,"column":6},"end":{"line":2,"column":12}}}) : helper)))
	    + "\n</div>\n<div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"column")), depth0))
	    + " "
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"orderBlock")), depth0))
	    + "\">\n    <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"subRow")), depth0))
	    + "\">\n        "
	    + alias2(((helper = (helper = lookupProperty(helpers,"stateName") || (depth0 != null ? lookupProperty(depth0,"stateName") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"stateName","hash":{},"data":data,"loc":{"start":{"line":6,"column":8},"end":{"line":6,"column":21}}}) : helper)))
	    + "\n    </div>\n    <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"subRow")), depth0))
	    + " "
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"orderDate")), depth0))
	    + "\">\n        от "
	    + alias2(((helper = (helper = lookupProperty(helpers,"createDate") || (depth0 != null ? lookupProperty(depth0,"createDate") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"createDate","hash":{},"data":data,"loc":{"start":{"line":9,"column":11},"end":{"line":9,"column":25}}}) : helper)))
	    + "\n    </div>\n</div>\n"
	    + ((stack1 = lookupProperty(helpers,"unless").call(alias3,(depth0 != null ? lookupProperty(depth0,"hidePrice") : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":12,"column":0},"end":{"line":16,"column":11}}})) != null ? stack1 : "");
	},"useData":true});

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                <div class=\""
	    + alias1(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"message") : stack1), depth0))
	    + "\">"
	    + alias1(((helper = (helper = lookupProperty(helpers,"orderAmountError") || (depth0 != null ? lookupProperty(depth0,"orderAmountError") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"orderAmountError","hash":{},"data":data,"loc":{"start":{"line":13,"column":45},"end":{"line":13,"column":65}}}) : helper)))
	    + "</div>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"tooltipWrapper") : stack1), depth0))
	    + "\">\n                <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"tooltip") : stack1), depth0))
	    + "\">Стоимость должна быть больше ноля</div>\n            </div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"field") : stack1), depth0))
	    + "\">\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"title") : stack1), depth0))
	    + "\">\n            Сумма заказа\n        </div>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"control") : stack1), depth0))
	    + "\">\n            <cat-order-amount-input\n                path=\"account.orders.currentOrder.amount\"\n                error-path=\"account.orders.currentOrder.errors.amount\"\n            ></cat-order-amount-input>\n\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"orderAmountError") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":12,"column":12},"end":{"line":14,"column":19}}})) != null ? stack1 : "")
	    + "        </div>\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"showPriceMustBeBiggerThanZero") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":8},"end":{"line":20,"column":15}}})) != null ? stack1 : "")
	    + "    </div>\n</div>";
	},"useData":true});

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "disabled=\"true\"";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias1(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"message") : stack1), depth0))
	    + "\">"
	    + alias1(((helper = (helper = lookupProperty(helpers,"error") || (depth0 != null ? lookupProperty(depth0,"error") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"error","hash":{},"data":data,"loc":{"start":{"line":12,"column":37},"end":{"line":12,"column":46}}}) : helper)))
	    + "</div>\n";
	},"5":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"message") : stack1), depth0))
	    + "\">Не удалось создать пользователя!</div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"search") : stack1), depth0))
	    + "\">\n    <div>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"inlineInput") : stack1), depth0))
	    + "\">\n            <cat-email-input id=\"user-email\"\n                         path=\"account.orders.createUser.input.email\"\n                         error-path=\"account.orders.createUser.error.email\">\n            </cat-email-input>\n        </div>\n        <button class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"createBtn") : stack1), depth0))
	    + "\" "
	    + ((stack1 = lookupProperty(helpers,"unless").call(alias3,(depth0 != null ? lookupProperty(depth0,"isEnabled") : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":42},"end":{"line":9,"column":89}}})) != null ? stack1 : "")
	    + ">Создать</button>\n    </div>\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"error") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":11,"column":4},"end":{"line":13,"column":11}}})) != null ? stack1 : "")
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"showCreateError") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":4},"end":{"line":16,"column":11}}})) != null ? stack1 : "")
	    + "</div>\n";
	},"useData":true});

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"field") : stack1), depth0))
	    + "\">\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"title") : stack1), depth0))
	    + "\">\n        Название\n    </div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"controls") : stack1), depth0))
	    + "\">\n        <cat-name path=\"account.orders.currentOrder.name\" error-path=\"account.orders.currentOrder.error.name\">\n        </cat-name>\n    </div>\n</div>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"field") : stack1), depth0))
	    + "\">\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"title") : stack1), depth0))
	    + "\">\n        Пользователь\n    </div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"controls") : stack1), depth0))
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"showUserSelect") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.program(7, data, 0),"data":data,"loc":{"start":{"line":19,"column":8},"end":{"line":37,"column":15}}})) != null ? stack1 : "")
	    + "    </div>\n</div>\n";
	},"4":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <cat-user-filtered-select id=\"managerUserSelect\" cat-name=\"userSelect\" path=\"account.orders.computed.filter\"></cat-user-filtered-select>\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"showUserMustBeSelected") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":21,"column":12},"end":{"line":25,"column":19}}})) != null ? stack1 : "")
	    + "            <cat-user-search></cat-user-search>\n";
	},"5":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"tooltipWrapper") : stack1), depth0))
	    + "\">\n                    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"tooltip") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"licenseTooltip") : stack1), depth0))
	    + "\">Необходимо выбрать пользователя</div>\n                </div>\n";
	},"7":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"name")), depth0))
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isManager") : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.program(10, data, 0),"data":data,"loc":{"start":{"line":29,"column":16},"end":{"line":35,"column":23}}})) != null ? stack1 : "")
	    + "            </div>\n";
	},"8":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), alias4=container.hooks.helperMissing, alias5="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                    <a class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"redirect")), depth0))
	    + " "
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"link")), depth0))
	    + "\" cat-url=\"/manager/users/"
	    + alias2(((helper = (helper = lookupProperty(helpers,"userId") || (depth0 != null ? lookupProperty(depth0,"userId") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"userId","hash":{},"data":data,"loc":{"start":{"line":30,"column":97},"end":{"line":30,"column":107}}}) : helper)))
	    + "\">\n                        "
	    + alias2(((helper = (helper = lookupProperty(helpers,"userName") || (depth0 != null ? lookupProperty(depth0,"userName") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"userName","hash":{},"data":data,"loc":{"start":{"line":31,"column":24},"end":{"line":31,"column":36}}}) : helper)))
	    + "\n                    </a>\n";
	},"10":function(container,depth0,helpers,partials,data) {
	    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                    "
	    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"userName") || (depth0 != null ? lookupProperty(depth0,"userName") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"userName","hash":{},"data":data,"loc":{"start":{"line":34,"column":20},"end":{"line":34,"column":32}}}) : helper)))
	    + "\n";
	},"12":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"field") : stack1), depth0))
	    + "\">\n\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"title") : stack1), depth0))
	    + "\">\n        Менеджер\n    </div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"controls") : stack1), depth0))
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"showManagerSelect") : depth0),{"name":"if","hash":{},"fn":container.program(13, data, 0),"inverse":container.program(15, data, 0),"data":data,"loc":{"start":{"line":49,"column":8},"end":{"line":60,"column":15}}})) != null ? stack1 : "")
	    + "    </div>\n</div>\n";
	},"13":function(container,depth0,helpers,partials,data) {
	    return "            <cat-manager-select id=\"managerManagerSelect\" cat-name=\"managerSelect\"></cat-manager-select>\n";
	},"15":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"name") : stack1), depth0))
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"managerName") : depth0),{"name":"if","hash":{},"fn":container.program(16, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":53,"column":16},"end":{"line":58,"column":23}}})) != null ? stack1 : "")
	    + "            </div>\n";
	},"16":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                    "
	    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"managerName") || (depth0 != null ? lookupProperty(depth0,"managerName") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"managerName","hash":{},"data":data,"loc":{"start":{"line":54,"column":20},"end":{"line":54,"column":35}}}) : helper)))
	    + "\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"managerEmail") : depth0),{"name":"if","hash":{},"fn":container.program(17, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":55,"column":20},"end":{"line":57,"column":27}}})) != null ? stack1 : "");
	},"17":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", alias4=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                        <a target=\"_top\" href=\"mailto:"
	    + alias4(((helper = (helper = lookupProperty(helpers,"managerEmail") || (depth0 != null ? lookupProperty(depth0,"managerEmail") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"managerEmail","hash":{},"data":data,"loc":{"start":{"line":56,"column":54},"end":{"line":56,"column":70}}}) : helper)))
	    + "\" class=\""
	    + alias4(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"link")), depth0))
	    + "\">("
	    + alias4(((helper = (helper = lookupProperty(helpers,"managerEmail") || (depth0 != null ? lookupProperty(depth0,"managerEmail") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"managerEmail","hash":{},"data":data,"loc":{"start":{"line":56,"column":100},"end":{"line":56,"column":116}}}) : helper)))
	    + ")</a>\n";
	},"19":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"field") : stack1), depth0))
	    + "\">\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"title") : stack1), depth0))
	    + "\">\n        Способ оплаты\n    </div>\n\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"controls") : stack1), depth0))
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"showPaymentTypeChangePanel") : depth0),{"name":"if","hash":{},"fn":container.program(20, data, 0),"inverse":container.program(23, data, 0),"data":data,"loc":{"start":{"line":72,"column":4},"end":{"line":85,"column":11}}})) != null ? stack1 : "")
	    + "    </div>\n</div>\n";
	},"20":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"button") : stack1), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"onlinePaymentDisabled") : depth0),{"name":"if","hash":{},"fn":container.program(21, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":73,"column":35},"end":{"line":73,"column":89}}})) != null ? stack1 : "")
	    + "\">\n            <cat-radio-online cat-key=\"online\" name=\"payment\"></cat-radio-online>\n            <label for=\"radio-online\" class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"label") : stack1), depth0))
	    + "\">Онлайн оплата</label>\n        </div>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"button") : stack1), depth0))
	    + "\">\n            <cat-radio-invoice cat-key=\"invoice\" name=\"payment\"></cat-radio-invoice>\n            <label for=\"radio-invoice\" class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"label") : stack1), depth0))
	    + "\">Счёт</label>\n        </div>\n";
	},"21":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"isDisabled") : stack1), depth0));
	},"23":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias1(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"name") : stack1), depth0))
	    + "\">\n            "
	    + alias1(((helper = (helper = lookupProperty(helpers,"paymentName") || (depth0 != null ? lookupProperty(depth0,"paymentName") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"paymentName","hash":{},"data":data,"loc":{"start":{"line":83,"column":12},"end":{"line":83,"column":27}}}) : helper)))
	    + "\n        </div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"isManager") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":11,"column":7}}})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"showUser") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":13,"column":0},"end":{"line":40,"column":7}}})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"showManager") : depth0),{"name":"if","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":42,"column":0},"end":{"line":63,"column":7}}})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"showPaymentType") : depth0),{"name":"if","hash":{},"fn":container.program(19, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":65,"column":0},"end":{"line":88,"column":7}}})) != null ? stack1 : "");
	},"useData":true});

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isLoading") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(4, data, 0),"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":11,"column":11}}})) != null ? stack1 : "");
	},"2":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"headerPreloader")), depth0))
	    + "\">\n            <cat-preloader></cat-preloader>\n        </div>\n";
	},"4":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div>\n            <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"headerPriceValue")), depth0))
	    + "\">"
	    + alias2((lookupProperty(helpers,"currencyFormat")||(depth0 && lookupProperty(depth0,"currencyFormat"))||container.hooks.helperMissing).call(alias3,(depth0 != null ? lookupProperty(depth0,"totalPrice") : depth0),{"name":"currencyFormat","hash":{},"data":data,"loc":{"start":{"line":8,"column":56},"end":{"line":8,"column":85}}}))
	    + "</div>\n            <span class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"rouble")), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isShowAsterisk") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":46},"end":{"line":9,"column":97}}})) != null ? stack1 : "")
	    + "\">a</span>\n        </div>\n";
	},"5":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"asterisk")), depth0));
	},"7":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isLoading") : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.program(10, data, 0),"data":data,"loc":{"start":{"line":13,"column":4},"end":{"line":20,"column":11}}})) != null ? stack1 : "");
	},"8":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"preloader")), depth0))
	    + "\">\n            <cat-preloader-small></cat-preloader-small>\n        </div>\n";
	},"10":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        "
	    + alias3(((helper = (helper = lookupProperty(helpers,"rowAmount") || (depth0 != null ? lookupProperty(depth0,"rowAmount") : depth0)) != null ? helper : alias2),(typeof helper === "function" ? helper.call(alias1,{"name":"rowAmount","hash":{},"data":data,"loc":{"start":{"line":18,"column":8},"end":{"line":18,"column":21}}}) : helper)))
	    + " строк <span class=\""
	    + alias3(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"multiplySymbol")), depth0))
	    + "\">х</span>\n        "
	    + alias3((lookupProperty(helpers,"currencyFormat")||(depth0 && lookupProperty(depth0,"currencyFormat"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"rowPrice") : depth0),{"name":"currencyFormat","hash":{},"data":data,"loc":{"start":{"line":19,"column":8},"end":{"line":19,"column":35}}}))
	    + " Р = "
	    + alias3((lookupProperty(helpers,"currencyFormat")||(depth0 && lookupProperty(depth0,"currencyFormat"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"totalPrice") : depth0),{"name":"currencyFormat","hash":{},"data":data,"loc":{"start":{"line":19,"column":40},"end":{"line":19,"column":69}}}))
	    + " Р\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isHeader") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(7, data, 0),"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":21,"column":7}}})) != null ? stack1 : "");
	},"useData":true});

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), alias4=container.hooks.helperMissing, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"statistickBlock") : stack1), depth0))
	    + "\">\n    <button class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"redirect") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"statisticButton") : stack1), depth0))
	    + "\"\n            cat-url=\"/manager/orders/"
	    + alias2(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias4),(typeof helper === "function" ? helper.call(alias3,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":4,"column":37},"end":{"line":4,"column":43}}}) : helper)))
	    + "/statistic"
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"orderCitiesTab") : depth0),"===","branches",{"name":"compare","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":53},"end":{"line":4,"column":125}}})) != null ? stack1 : "")
	    + "\"\n            "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isOrderChanging") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":12},"end":{"line":5,"column":50}}})) != null ? stack1 : "")
	    + ">\n        Посмотреть статистику\n    </button>\n</div>\n";
	},"2":function(container,depth0,helpers,partials,data) {
	    return "?isByBranch=true";
	},"4":function(container,depth0,helpers,partials,data) {
	    return "disabled";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"showOrderStatistic") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":9,"column":7}}})) != null ? stack1 : "");
	},"useData":true});

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias1(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"specialInfo") : stack1), depth0))
	    + "\">\n            "
	    + alias1(((helper = (helper = lookupProperty(helpers,"specialInfo") || (depth0 != null ? lookupProperty(depth0,"specialInfo") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"specialInfo","hash":{},"data":data,"loc":{"start":{"line":11,"column":12},"end":{"line":11,"column":27}}}) : helper)))
	    + "\n        </div>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"line") : stack1), depth0))
	    + "\"></div>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"orderParameters") : stack1), depth0))
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"showDataOutdatedTooltip") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.program(6, data, 0),"data":data,"loc":{"start":{"line":19,"column":12},"end":{"line":30,"column":19}}})) != null ? stack1 : "")
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(alias3,(depth0 != null ? lookupProperty(depth0,"freeLeadsAmount") : depth0),">",0,{"name":"compare","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":31,"column":12},"end":{"line":36,"column":24}}})) != null ? stack1 : "")
	    + "            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"orderParametersHeader") : stack1), depth0))
	    + "\">\n                <div id=\"orderParametersHeader\" class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"orderParametersHeader2") : stack1), depth0))
	    + "\">\n                    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"orderParametersHeaderName") : stack1), depth0))
	    + "\">Стандартная выборка</div>\n                    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"orderParametersHeaderPrice") : stack1), depth0))
	    + "\">\n                        <cat-price></cat-price>\n                    </div>\n                </div>\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"showChangesMustBeSavedOrCancelled") : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0),"inverse":container.program(13, data, 0),"data":data,"loc":{"start":{"line":44,"column":16},"end":{"line":54,"column":23}}})) != null ? stack1 : "")
	    + "            </div>\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"orderParametersContent") : stack1), depth0))
	    + "\">\n                <cat-custom-order></cat-custom-order>\n            </div>\n            <cat-statistic-block></cat-statistic-block>\n        </div>\n";
	},"4":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"dataOutdatedTooltip") : stack1), depth0))
	    + "\">\n                    После того как вы сформировали заказ, мы обновили данные.\n                    Для формирования самых свежих данных нажмите кнопку \"Повторить\".\n                </div>\n";
	},"6":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"showDataChangeTooltip") : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":25,"column":16},"end":{"line":29,"column":23}}})) != null ? stack1 : "");
	},"7":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                    <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"dataChangedTooltip") : stack1), depth0))
	    + "\">\n                        Мы обновили данные, пожалуйста, проверьте заказ.\n                    </div>\n";
	},"9":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"dataOutdatedTooltip")), depth0))
	    + "\">\n                    Из этого заказа было бесплатно экспортировано "
	    + alias2(alias1(((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"freeLeadsAmount")), depth0))
	    + " строк в качестве лидов в Битрикс24,\n                    их стоимость вычтена из цены заказа.\n                </div>\n";
	},"11":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"tooltipWrapper") : stack1), depth0))
	    + "\">\n                        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"tooltip") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"licenseTooltip") : stack1), depth0))
	    + "\">Нужно сохранить или отменить изменения параметров</div>\n                    </div>\n";
	},"13":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"showPriceMustBeBiggerThanZero")),{"name":"if","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":49,"column":20},"end":{"line":53,"column":27}}})) != null ? stack1 : "");
	},"14":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                        <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"tooltipWrapper")), depth0))
	    + "\">\n                            <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"tooltip")), depth0))
	    + " "
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"licenseTooltip")), depth0))
	    + "\">Стоимость должна быть больше ноля</div>\n                        </div>\n";
	},"16":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"line") : stack1), depth0))
	    + "\"></div>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"orderParameters") : stack1), depth0))
	    + "\">\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"orderParametersHeader") : stack1), depth0))
	    + "\">\n                <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"orderParametersHeader2") : stack1), depth0))
	    + "\">\n                    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"orderParametersHeaderName") : stack1), depth0))
	    + "\">Индивидуальная выборка</div>\n                </div>\n            </div>\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"individualOrderParameters") : stack1), depth0))
	    + "\">\n                <cat-individual-order-parameters></cat-individual-order-parameters>\n            </div>\n        </div>\n";
	},"18":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"line") : stack1), depth0))
	    + "\"></div>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"documentsBlock") : stack1), depth0))
	    + "\">\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"documentsHeader") : stack1), depth0))
	    + "\">\n                Документы\n            </div>\n            <cat-documents></cat-documents>\n        </div>\n";
	},"20":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"line") : stack1), depth0))
	    + "\"></div>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"exportResultBlock") : stack1), depth0))
	    + "\">\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"documentsHeader") : stack1), depth0))
	    + "\">\n                Результат выборки\n            </div>\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isShowUploadResultFailTooltip") : depth0),{"name":"if","hash":{},"fn":container.program(21, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":90,"column":12},"end":{"line":94,"column":19}}})) != null ? stack1 : "")
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isShowResultUploadButton") : depth0),{"name":"if","hash":{},"fn":container.program(23, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":95,"column":12},"end":{"line":105,"column":19}}})) != null ? stack1 : "")
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"exportResult") : depth0),{"name":"if","hash":{},"fn":container.program(28, data, 0),"inverse":container.program(30, data, 0),"data":data,"loc":{"start":{"line":106,"column":12},"end":{"line":119,"column":19}}})) != null ? stack1 : "")
	    + "        </div>\n";
	},"21":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"uploadFailTooltip") : stack1), depth0))
	    + "\">\n                    Не удалось загрузить файл, возможно размер файла больше 250 МБ.\n                </div>\n";
	},"23":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"uploadWrapper")), depth0))
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isLoadingUploadResultDocument") : depth0),{"name":"if","hash":{},"fn":container.program(24, data, 0),"inverse":container.program(26, data, 0),"data":data,"loc":{"start":{"line":97,"column":20},"end":{"line":103,"column":27}}})) != null ? stack1 : "")
	    + "                </div>\n";
	},"24":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                        <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"preloaderWrapper")), depth0))
	    + "\">\n                            <cat-preloader></cat-preloader>\n                        </div>\n";
	},"26":function(container,depth0,helpers,partials,data) {
	    return "                        <cat-export-result-upload></cat-export-result-upload>\n";
	},"28":function(container,depth0,helpers,partials,data) {
	    return "                <cat-export-result></cat-export-result>\n";
	},"30":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isManager") : depth0),{"name":"if","hash":{},"fn":container.program(31, data, 0),"inverse":container.program(34, data, 0),"data":data,"loc":{"start":{"line":109,"column":16},"end":{"line":118,"column":23}}})) != null ? stack1 : "");
	},"31":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isShowResultUploadButton") : depth0),{"name":"unless","hash":{},"fn":container.program(32, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":110,"column":20},"end":{"line":114,"column":31}}})) != null ? stack1 : "");
	},"32":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                        <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"preloader")), depth0))
	    + "\">\n                            <cat-preloader></cat-preloader>\n                        </div>\n";
	},"34":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                    Выборка станет доступна в течении 24 часов после оплаты. Если что-то пошло не так, пожалуйста,\n                    напишите в <a class=\""
	    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"link")), depth0))
	    + "\" target=\"_top\" href=\"mailto:support.data@2gis.com\">тех. поддержку</a>.\n";
	},"36":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"line") : stack1), depth0))
	    + "\"></div>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"buttonsBlock") : stack1), depth0))
	    + "\">\n            <cat-action-panel></cat-action-panel>\n        </div>\n";
	},"38":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "    <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"footnote") : stack1), depth0))
	    + "\">\n        Непосредственно перед заказом сумма может измениться\n    </div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"order") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"border") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"white") : stack1), depth0))
	    + "\">\n    <cat-overlay></cat-overlay>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"headerWrapper") : stack1), depth0))
	    + "\">\n        <div id=\"orderHeader\" class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"header") : stack1), depth0))
	    + "\">\n            <cat-header></cat-header>\n        </div>\n    </div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"optionsBlock") : stack1), depth0))
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"specialInfo") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":8},"end":{"line":13,"column":15}}})) != null ? stack1 : "")
	    + "        <cat-orders-options></cat-orders-options>\n    </div>\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isShowOrderParameters") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":4},"end":{"line":61,"column":11}}})) != null ? stack1 : "")
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isShowIndividualOrderParameters") : depth0),{"name":"if","hash":{},"fn":container.program(16, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":62,"column":4},"end":{"line":74,"column":11}}})) != null ? stack1 : "")
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"necessaryDocuments") : depth0),{"name":"if","hash":{},"fn":container.program(18, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":75,"column":4},"end":{"line":83,"column":11}}})) != null ? stack1 : "")
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"showExportResult") : depth0),{"name":"if","hash":{},"fn":container.program(20, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":84,"column":4},"end":{"line":121,"column":11}}})) != null ? stack1 : "")
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"showActionPanel") : depth0),{"name":"if","hash":{},"fn":container.program(36, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":122,"column":4},"end":{"line":127,"column":11}}})) != null ? stack1 : "")
	    + "</div>\n<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"footnoteBlock") : stack1), depth0))
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"showSumCanChangeTooltip") : depth0),{"name":"if","hash":{},"fn":container.program(38, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":130,"column":0},"end":{"line":134,"column":7}}})) != null ? stack1 : "")
	    + "</div>\n";
	},"useData":true});

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "    <cat-leads></cat-leads>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isOrderListInitialized") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":4},"end":{"line":28,"column":11}}})) != null ? stack1 : "");
	},"4":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"currentOrderId") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.program(7, data, 0),"data":data,"loc":{"start":{"line":5,"column":8},"end":{"line":27,"column":15}}})) != null ? stack1 : "");
	},"5":function(container,depth0,helpers,partials,data) {
	    return "            <cat-current-order></cat-current-order>\n";
	},"7":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"noneSelected")), depth0))
	    + " "
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"white")), depth0))
	    + "\">\n                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"message")), depth0))
	    + "\">\n                    <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"messageTitle")), depth0))
	    + "\">\n                        У Вас пока нет заказов.\n                    </div>\n                    <span class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"messageDescription")), depth0))
	    + "\">\n                    Чтобы создать заказ, перейдите на\n                        <a class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"link")), depth0))
	    + " "
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"redirect")), depth0))
	    + "\" cat-url=\"/\">страницу \"Данные\"</a>,\n                    выберите параметры и нажмите кнопку \"Оформить заказ\".<br>\n                </span>\n                    <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"messageFootnote")), depth0))
	    + "\">\n                        <p>Если произошла ошибка и мы потеряли Ваши заказы, сообщите об этом в\n                            <a class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"link")), depth0))
	    + "\" target=\"_top\" href=\"mailto:support.data@2gis.com\">\n                                службу поддержки\n                            </a>.\n                        </p>\n                    </div>\n                </div>\n            </div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"showBitrixLeadMapping") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":29,"column":7}}})) != null ? stack1 : "")
	    + "\n";
	},"useData":true});

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"active")), depth0))
	    + "\"></div>";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(((helper = (helper = lookupProperty(helpers,"title") || (depth0 != null ? lookupProperty(depth0,"title") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"title","hash":{},"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":9}}}) : helper)))
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"isActive") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":9},"end":{"line":1,"column":72}}})) != null ? stack1 : "")
	    + "\n\n";
	},"useData":true});

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            "
	    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"title") || (depth0 != null ? lookupProperty(depth0,"title") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"title","hash":{},"data":data,"loc":{"start":{"line":4,"column":12},"end":{"line":4,"column":21}}}) : helper)))
	    + "\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    return "            <cat-header></cat-header>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"panel") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"collapsed") : stack1), depth0))
	    + "\">\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"header") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"headerClickable") : stack1), depth0))
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"title") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":3,"column":8},"end":{"line":7,"column":15}}})) != null ? stack1 : "")
	    + "        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"arrow") : stack1), depth0))
	    + "\"></div>\n    </div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"content") : stack1), depth0))
	    + "\">\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"wrapper") : stack1), depth0))
	    + "\">\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"innerWrapper") : stack1), depth0))
	    + "\">\n                <cat-content></cat-content>\n            </div>\n        </div>\n    </div>\n</div>\n\n";
	},"useData":true});

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"buttons") : stack1), depth0))
	    + "\">\n\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"button") : stack1), depth0))
	    + "\">\n        <span class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"label") : stack1), depth0))
	    + "\">\n            <cat-radio-any cat-key=\"any\" name=\"assign\"></cat-radio-any>\n            <label for=\"radio-any\">Все</label>\n        </span>\n    </div>\n\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"button") : stack1), depth0))
	    + "\">\n        <span class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"label") : stack1), depth0))
	    + "\">\n            <cat-radio-my cat-key=\"my\" name=\"assign\"></cat-radio-my>\n            <label for=\"radio-my\">Назначенные на меня</label>\n        </span>\n    </div>\n\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"button") : stack1), depth0))
	    + "\">\n        <span class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"label") : stack1), depth0))
	    + "\">\n            <cat-radio-unassigned cat-key=\"unassigned\" name=\"assign\"></cat-radio-unassigned>\n            <label for=\"radio-unassigned\">Неназначенные</label>\n        </span>\n    </div>\n\n</div>\n";
	},"useData":true});

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.escapeExpression, alias2=depth0 != null ? depth0 : (container.nullContext || {}), alias3=container.hooks.helperMissing, alias4="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "    <div class=\""
	    + alias1(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"row")), depth0))
	    + "\">\n        <cat-checkbox id=\"orderStateFilter"
	    + alias1(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":3,"column":42},"end":{"line":3,"column":48}}}) : helper)))
	    + "\" cat-path=\""
	    + alias1(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":3,"column":60},"end":{"line":3,"column":66}}}) : helper)))
	    + "\" cat-title=\""
	    + alias1(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"name","hash":{},"data":data,"loc":{"start":{"line":3,"column":79},"end":{"line":3,"column":87}}}) : helper)))
	    + "\"></cat-checkbox>\n    </div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"orderStates") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":5,"column":9}}})) != null ? stack1 : "");
	},"useData":true});

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.escapeExpression, alias2=depth0 != null ? depth0 : (container.nullContext || {}), alias3=container.hooks.helperMissing, alias4="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "    <div class=\""
	    + alias1(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"row")), depth0))
	    + "\">\n        <cat-checkbox id=\"orderTypeFilter"
	    + alias1(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":3,"column":41},"end":{"line":3,"column":47}}}) : helper)))
	    + "\" cat-path=\""
	    + alias1(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":3,"column":59},"end":{"line":3,"column":65}}}) : helper)))
	    + "\" cat-title=\""
	    + alias1(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"name","hash":{},"data":data,"loc":{"start":{"line":3,"column":78},"end":{"line":3,"column":86}}}) : helper)))
	    + "\"></cat-checkbox>\n    </div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"orderStates") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":5,"column":9}}})) != null ? stack1 : "");
	},"useData":true});

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"noPadding") : stack1), depth0));
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"ordersList") : depth0),{"name":"each","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":16},"end":{"line":72,"column":25}}})) != null ? stack1 : "");
	},"4":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), alias4=container.hooks.helperMissing, alias5="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                    <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"order")), depth0))
	    + "\">\n                        <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"tooltipWrapper")), depth0))
	    + "\">\n                            <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"orderState")), depth0))
	    + " "
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"info")), depth0))
	    + "\n                                "
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"stateId") : depth0),"==",1,{"name":"compare","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":12,"column":32},"end":{"line":12,"column":94}}})) != null ? stack1 : "")
	    + "\n                                "
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"stateId") : depth0),"==",2,{"name":"compare","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":13,"column":32},"end":{"line":13,"column":94}}})) != null ? stack1 : "")
	    + "\n                                "
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"stateId") : depth0),"==",3,{"name":"compare","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":32},"end":{"line":14,"column":96}}})) != null ? stack1 : "")
	    + "\n                                "
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"stateId") : depth0),"==",4,{"name":"compare","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":15,"column":32},"end":{"line":15,"column":96}}})) != null ? stack1 : "")
	    + "\n                                "
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"stateId") : depth0),"==",5,{"name":"compare","hash":{},"fn":container.program(13, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":32},"end":{"line":16,"column":95}}})) != null ? stack1 : "")
	    + "\n                                "
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"stateId") : depth0),"==",6,{"name":"compare","hash":{},"fn":container.program(15, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":17,"column":32},"end":{"line":17,"column":99}}})) != null ? stack1 : "")
	    + "\n                                "
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"stateId") : depth0),"==",7,{"name":"compare","hash":{},"fn":container.program(17, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":18,"column":32},"end":{"line":18,"column":93}}})) != null ? stack1 : "")
	    + "\n                                "
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"stateId") : depth0),"==",1001,{"name":"compare","hash":{},"fn":container.program(19, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":19,"column":32},"end":{"line":19,"column":102}}})) != null ? stack1 : "")
	    + "\n                                "
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"stateId") : depth0),"==",1002,{"name":"compare","hash":{},"fn":container.program(21, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":20,"column":32},"end":{"line":20,"column":102}}})) != null ? stack1 : "")
	    + "\n                                "
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"stateId") : depth0),"==",1003,{"name":"compare","hash":{},"fn":container.program(23, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":21,"column":32},"end":{"line":21,"column":98}}})) != null ? stack1 : "")
	    + "\n                                "
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"stateId") : depth0),"==",2001,{"name":"compare","hash":{},"fn":container.program(19, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":22,"column":32},"end":{"line":22,"column":102}}})) != null ? stack1 : "")
	    + "\n                                "
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"stateId") : depth0),"==",2002,{"name":"compare","hash":{},"fn":container.program(21, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":23,"column":32},"end":{"line":23,"column":102}}})) != null ? stack1 : "")
	    + "\n                                "
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"stateId") : depth0),"==",2003,{"name":"compare","hash":{},"fn":container.program(23, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":24,"column":32},"end":{"line":24,"column":98}}})) != null ? stack1 : "")
	    + "\n                                "
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"stateId") : depth0),"==",3001,{"name":"compare","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":25,"column":32},"end":{"line":25,"column":97}}})) != null ? stack1 : "")
	    + "\n                                "
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"stateId") : depth0),"==",3002,{"name":"compare","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":26,"column":32},"end":{"line":26,"column":97}}})) != null ? stack1 : "")
	    + "\n                                "
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"stateId") : depth0),"==",3003,{"name":"compare","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":27,"column":32},"end":{"line":27,"column":99}}})) != null ? stack1 : "")
	    + "\n                                "
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"stateId") : depth0),"==",3004,{"name":"compare","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":28,"column":32},"end":{"line":28,"column":99}}})) != null ? stack1 : "")
	    + "\n                                "
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"stateId") : depth0),"==",3005,{"name":"compare","hash":{},"fn":container.program(13, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":29,"column":32},"end":{"line":29,"column":98}}})) != null ? stack1 : "")
	    + "\n                                "
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"stateId") : depth0),"==",3006,{"name":"compare","hash":{},"fn":container.program(15, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":30,"column":32},"end":{"line":30,"column":102}}})) != null ? stack1 : "")
	    + "\n                                \">\n                            </div>\n                            <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"tooltip")), depth0))
	    + "\">\n                                "
	    + alias2(((helper = (helper = lookupProperty(helpers,"stateName") || (depth0 != null ? lookupProperty(depth0,"stateName") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"stateName","hash":{},"data":data,"loc":{"start":{"line":34,"column":32},"end":{"line":34,"column":45}}}) : helper)))
	    + "\n                            </div>\n                        </div>\n                        <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"info")), depth0))
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isSelected") : depth0),{"name":"if","hash":{},"fn":container.program(25, data, 0),"inverse":container.program(32, data, 0),"data":data,"loc":{"start":{"line":38,"column":28},"end":{"line":54,"column":35}}})) != null ? stack1 : "")
	    + "                            <span class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"subTitle")), depth0))
	    + "\">от "
	    + alias2(((helper = (helper = lookupProperty(helpers,"createDate") || (depth0 != null ? lookupProperty(depth0,"createDate") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"createDate","hash":{},"data":data,"loc":{"start":{"line":55,"column":68},"end":{"line":55,"column":82}}}) : helper)))
	    + "</span>\n\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"userNameMarkedup") : depth0),{"name":"if","hash":{},"fn":container.program(39, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":57,"column":28},"end":{"line":59,"column":35}}})) != null ? stack1 : "")
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"userEmailMarkedup") : depth0),{"name":"if","hash":{},"fn":container.program(41, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":60,"column":28},"end":{"line":62,"column":35}}})) != null ? stack1 : "")
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"nameMarkedup") : depth0),{"name":"if","hash":{},"fn":container.program(43, data, 0),"inverse":container.program(45, data, 0),"data":data,"loc":{"start":{"line":63,"column":28},"end":{"line":69,"column":35}}})) != null ? stack1 : "")
	    + "                        </div>\n                    </div>\n";
	},"5":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"stateGray")), depth0));
	},"7":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"stateBlue")), depth0));
	},"9":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"stateYellow")), depth0));
	},"11":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"stateOrange")), depth0));
	},"13":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"stateGreen")), depth0));
	},"15":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"stateLightGray")), depth0));
	},"17":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"bordered")), depth0));
	},"19":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"stateRoyalBlue")), depth0));
	},"21":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"stateDarkGreen")), depth0));
	},"23":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"stateBlack")), depth0));
	},"25":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.escapeExpression, alias2=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                                <span class=\""
	    + alias1(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"linkActive")), depth0))
	    + "\" cat-id=\""
	    + alias1(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(alias2,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":39,"column":79},"end":{"line":39,"column":85}}}) : helper)))
	    + "\">№\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias2,(depth0 != null ? lookupProperty(depth0,"idMarkedup") : depth0),{"name":"if","hash":{},"fn":container.program(26, data, 0),"inverse":container.program(30, data, 0),"data":data,"loc":{"start":{"line":40,"column":32},"end":{"line":44,"column":39}}})) != null ? stack1 : "")
	    + "</span>\n";
	},"26":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                                    <span>"
	    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"idMarkedup") : depth0),{"name":"each","hash":{},"fn":container.program(27, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":41,"column":42},"end":{"line":41,"column":150}}})) != null ? stack1 : "")
	    + "</span>\n";
	},"27":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<span class=\""
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"isHighlited") : depth0),{"name":"if","hash":{},"fn":container.program(28, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":41,"column":75},"end":{"line":41,"column":124}}})) != null ? stack1 : "")
	    + "\">"
	    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"text","hash":{},"data":data,"loc":{"start":{"line":41,"column":126},"end":{"line":41,"column":134}}}) : helper)))
	    + "</span>";
	},"28":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"highligth")), depth0));
	},"30":function(container,depth0,helpers,partials,data) {
	    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                                    "
	    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"id","hash":{},"data":data,"loc":{"start":{"line":43,"column":36},"end":{"line":43,"column":42}}}) : helper)))
	    + "\n                                ";
	},"32":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), alias4=container.hooks.helperMissing, alias5="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                                <span class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"link")), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"redirect") : stack1), depth0))
	    + "\" cat-url=\"/"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"isManager")),{"name":"if","hash":{},"fn":container.program(33, data, 0),"inverse":container.program(35, data, 0),"data":data,"loc":{"start":{"line":46,"column":92},"end":{"line":46,"column":144}}})) != null ? stack1 : "")
	    + "/orders/"
	    + alias2(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":46,"column":152},"end":{"line":46,"column":158}}}) : helper)))
	    + "?"
	    + alias2(alias1(((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"query")), depth0))
	    + "\" cat-id=\""
	    + alias2(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":46,"column":184},"end":{"line":46,"column":190}}}) : helper)))
	    + "\">\n                                №\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"idMarkedup") : depth0),{"name":"if","hash":{},"fn":container.program(26, data, 0),"inverse":container.program(37, data, 0),"data":data,"loc":{"start":{"line":48,"column":32},"end":{"line":52,"column":39}}})) != null ? stack1 : "")
	    + "                                </span>\n";
	},"33":function(container,depth0,helpers,partials,data) {
	    return "manager";
	},"35":function(container,depth0,helpers,partials,data) {
	    return "account";
	},"37":function(container,depth0,helpers,partials,data) {
	    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                                    "
	    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"id","hash":{},"data":data,"loc":{"start":{"line":51,"column":36},"end":{"line":51,"column":42}}}) : helper)))
	    + "\n";
	},"39":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                                <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"subTitle")), depth0))
	    + "\">"
	    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"userNameMarkedup") : depth0),{"name":"each","hash":{},"fn":container.program(27, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":58,"column":68},"end":{"line":58,"column":182}}})) != null ? stack1 : "")
	    + "</div>\n";
	},"41":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                                <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"subTitle")), depth0))
	    + "\">"
	    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"userEmailMarkedup") : depth0),{"name":"each","hash":{},"fn":container.program(27, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":61,"column":68},"end":{"line":61,"column":183}}})) != null ? stack1 : "")
	    + "</div>\n";
	},"43":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                                <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"subTitle")), depth0))
	    + "\">"
	    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"nameMarkedup") : depth0),{"name":"each","hash":{},"fn":container.program(27, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":64,"column":68},"end":{"line":64,"column":178}}})) != null ? stack1 : "")
	    + "</div>\n";
	},"45":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"name") : depth0),{"name":"if","hash":{},"fn":container.program(46, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":66,"column":32},"end":{"line":68,"column":39}}})) != null ? stack1 : "");
	},"46":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                                    <div class=\""
	    + alias1(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"subTitle")), depth0))
	    + "\">"
	    + alias1(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":67,"column":72},"end":{"line":67,"column":80}}}) : helper)))
	    + "</div>\n";
	},"48":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"notFound") : stack1), depth0))
	    + "\">Заказов не найдено</div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"listWrapper") : stack1), depth0))
	    + "\">\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"scrolltrack") : stack1), depth0))
	    + "\">\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"scrollbar") : stack1), depth0))
	    + "\"></div>\n    </div>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"list") : stack1), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"unless").call(alias3,(depth0 != null ? lookupProperty(depth0,"ordersList") : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":33},"end":{"line":5,"column":83}}})) != null ? stack1 : "")
	    + "\">\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"listContent") : stack1), depth0))
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"ordersList") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":16},"end":{"line":73,"column":23}}})) != null ? stack1 : "")
	    + "            </div>\n        </div>\n"
	    + ((stack1 = lookupProperty(helpers,"unless").call(alias3,(depth0 != null ? lookupProperty(depth0,"ordersList") : depth0),{"name":"unless","hash":{},"fn":container.program(48, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":76,"column":4},"end":{"line":78,"column":15}}})) != null ? stack1 : "")
	    + "</div>\n\n";
	},"useData":true});

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "    <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"orderList") : stack1), depth0))
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"isManager") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(4, data, 0),"data":data,"loc":{"start":{"line":3,"column":8},"end":{"line":12,"column":15}}})) != null ? stack1 : "")
	    + "\n        <cat-orders-list id=\"ordersList\"></cat-orders-list>\n\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"isManager") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":8},"end":{"line":20,"column":15}}})) != null ? stack1 : "")
	    + "    </div>\n";
	},"2":function(container,depth0,helpers,partials,data) {
	    return "            <cat-order-state-collapser></cat-order-state-collapser>\n            <cat-order-manager-collapser></cat-order-manager-collapser>\n            <cat-order-type-collapser></cat-order-type-collapser>\n            <cat-text-filter></cat-text-filter>\n";
	},"4":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"head") : stack1), depth0))
	    + "\">\n                <cat-select id=\"ordersFilter\" cat-name=\"ordersFilter\"></cat-select>\n            </div>\n";
	},"6":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"controls") : stack1), depth0))
	    + "\">\n                <button class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"clearFiltersButton") : stack1), depth0))
	    + "\">Очистить фильтр</button>\n            </div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isError") : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":22,"column":11}}})) != null ? stack1 : "");
	},"useData":true});

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"wrapper") : stack1), depth0))
	    + "\">\n    <input type=\"text\" class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"filter") : stack1), depth0))
	    + "\" id=\"managerOrderTextFilter\" placeholder=\"Имя, email или номер...\">\n</div>\n\n";
	},"useData":true});

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"content") : stack1), depth0))
	    + "\">\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"order") : stack1), depth0))
	    + "\">\n        <cat-order-wrapper></cat-order-wrapper>\n    </div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"ordersList") : stack1), depth0))
	    + "\">\n        <cat-orders-navigation></cat-orders-navigation>\n    </div>\n</div>\n";
	},"useData":true});

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "Статистика по нас.пунктам\n            ";
	},"3":function(container,depth0,helpers,partials,data) {
	    return "Статистика по проектам\n";
	},"5":function(container,depth0,helpers,partials,data) {
	    return "disabled";
	},"7":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"preloader") : stack1), depth0))
	    + "\">\n                <cat-preloader></cat-preloader>\n            </div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"actionPanel") : stack1), depth0))
	    + "\">\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"actions") : stack1), depth0))
	    + "\">\n        <button class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"backToOrderButton") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"redirect") : stack1), depth0))
	    + "\" cat-url=\"./\">Назад к заказу</button>\n        <button class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"switchModeButton") : stack1), depth0))
	    + "\">\n            "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isByBranch") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":5,"column":12},"end":{"line":7,"column":19}}})) != null ? stack1 : "")
	    + "        </button>\n        <button class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"downloadExcel") : stack1), depth0))
	    + "\" "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"downloadExcelLock") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":46},"end":{"line":9,"column":86}}})) != null ? stack1 : "")
	    + ">Скачать Excel-файл</button>\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"downloadExcelLock") : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":10,"column":8},"end":{"line":14,"column":15}}})) != null ? stack1 : "")
	    + "    </div>\n</div>\n";
	},"useData":true});

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"headerItem") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"actionsPanel") : stack1), depth0))
	    + "\">\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"transpose") : stack1), depth0))
	    + "\"></div>\n</div>\n";
	},"useData":true});

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "    <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"headerItem")), depth0))
	    + " "
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"hidden")), depth0))
	    + "\"></div>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", alias4=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "    <div cat-id=\""
	    + alias4(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":5,"column":17},"end":{"line":5,"column":23}}}) : helper)))
	    + "\" class=\""
	    + alias4(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"headerItem")), depth0))
	    + "\n        "
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"level") : depth0),"===",1,{"name":"compare","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":8},"end":{"line":6,"column":66}}})) != null ? stack1 : "")
	    + "\n        "
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"level") : depth0),"===",2,{"name":"compare","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":8},"end":{"line":7,"column":66}}})) != null ? stack1 : "")
	    + "\n        "
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"level") : depth0),"===",3,{"name":"compare","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":8},"end":{"line":8,"column":66}}})) != null ? stack1 : "")
	    + "\n        "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"isExpandable") : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":8},"end":{"line":9,"column":59}}})) != null ? stack1 : "")
	    + "\">\n"
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"level") : depth0),"===",2,{"name":"compare","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":10,"column":8},"end":{"line":12,"column":20}}})) != null ? stack1 : "")
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"level") : depth0),"===",3,{"name":"compare","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":13,"column":8},"end":{"line":16,"column":20}}})) != null ? stack1 : "")
	    + "        "
	    + alias4(((helper = (helper = lookupProperty(helpers,"label") || (depth0 != null ? lookupProperty(depth0,"label") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"label","hash":{},"data":data,"loc":{"start":{"line":17,"column":8},"end":{"line":17,"column":17}}}) : helper)))
	    + "\n    </div>\n";
	},"4":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"level1")), depth0));
	},"6":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"level2")), depth0));
	},"8":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"level3")), depth0));
	},"10":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"expandable")), depth0));
	},"12":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <span class=\""
	    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"level2line")), depth0))
	    + "\"></span>\n";
	},"14":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <span class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"level2line")), depth0))
	    + "\"></span>\n            <span class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"level3line")), depth0))
	    + "\"></span>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"yStartIndexIsEven") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":3,"column":7}}})) != null ? stack1 : "")
	    + ((stack1 = lookupProperty(helpers,"each").call(alias1,(depth0 != null ? lookupProperty(depth0,"items") : depth0),{"name":"each","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":0},"end":{"line":19,"column":9}}})) != null ? stack1 : "");
	},"useData":true});

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), alias4=container.hooks.helperMissing, alias5="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"grid")), depth0))
	    + "\" style=\"height:"
	    + alias2(((helper = (helper = lookupProperty(helpers,"height") || (depth0 != null ? lookupProperty(depth0,"height") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"height","hash":{},"data":data,"loc":{"start":{"line":2,"column":46},"end":{"line":2,"column":56}}}) : helper)))
	    + "px; width:"
	    + alias2(((helper = (helper = lookupProperty(helpers,"width") || (depth0 != null ? lookupProperty(depth0,"width") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"width","hash":{},"data":data,"loc":{"start":{"line":2,"column":66},"end":{"line":2,"column":75}}}) : helper)))
	    + "px\">\n    <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"headerTop")), depth0))
	    + "\" style=\"top:"
	    + alias2(((helper = (helper = lookupProperty(helpers,"headerTopOffset") || (depth0 != null ? lookupProperty(depth0,"headerTopOffset") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"headerTopOffset","hash":{},"data":data,"loc":{"start":{"line":3,"column":52},"end":{"line":3,"column":71}}}) : helper)))
	    + "px; left:"
	    + alias2(((helper = (helper = lookupProperty(helpers,"leftOffset") || (depth0 != null ? lookupProperty(depth0,"leftOffset") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"leftOffset","hash":{},"data":data,"loc":{"start":{"line":3,"column":80},"end":{"line":3,"column":94}}}) : helper)))
	    + "px\">\n        <cat-top-header></cat-top-header>\n    </div>\n    <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"headerLeft")), depth0))
	    + "\" style=\"top:"
	    + alias2(((helper = (helper = lookupProperty(helpers,"topOffset") || (depth0 != null ? lookupProperty(depth0,"topOffset") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"topOffset","hash":{},"data":data,"loc":{"start":{"line":6,"column":53},"end":{"line":6,"column":66}}}) : helper)))
	    + "px; left:"
	    + alias2(((helper = (helper = lookupProperty(helpers,"headerLeftOffsetLeft") || (depth0 != null ? lookupProperty(depth0,"headerLeftOffsetLeft") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"headerLeftOffsetLeft","hash":{},"data":data,"loc":{"start":{"line":6,"column":75},"end":{"line":6,"column":99}}}) : helper)))
	    + "px\">\n        <cat-left-header></cat-left-header>\n    </div>\n    <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"headerCorner")), depth0))
	    + "\" style=\"top:"
	    + alias2(((helper = (helper = lookupProperty(helpers,"headerTopOffset") || (depth0 != null ? lookupProperty(depth0,"headerTopOffset") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"headerTopOffset","hash":{},"data":data,"loc":{"start":{"line":9,"column":55},"end":{"line":9,"column":74}}}) : helper)))
	    + "px; left:"
	    + alias2(((helper = (helper = lookupProperty(helpers,"headerLeftOffsetLeft") || (depth0 != null ? lookupProperty(depth0,"headerLeftOffsetLeft") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"headerLeftOffsetLeft","hash":{},"data":data,"loc":{"start":{"line":9,"column":83},"end":{"line":9,"column":107}}}) : helper)))
	    + "px\">\n        <cat-corner-header></cat-corner-header>\n    </div>\n    <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"gridContent")), depth0))
	    + "\" style=\"top:"
	    + alias2(((helper = (helper = lookupProperty(helpers,"topOffset") || (depth0 != null ? lookupProperty(depth0,"topOffset") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"topOffset","hash":{},"data":data,"loc":{"start":{"line":12,"column":54},"end":{"line":12,"column":67}}}) : helper)))
	    + "px; left:"
	    + alias2(((helper = (helper = lookupProperty(helpers,"leftOffset") || (depth0 != null ? lookupProperty(depth0,"leftOffset") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"leftOffset","hash":{},"data":data,"loc":{"start":{"line":12,"column":76},"end":{"line":12,"column":90}}}) : helper)))
	    + "px\">\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"yStartIndexIsEven") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":13,"column":8},"end":{"line":15,"column":15}}})) != null ? stack1 : "")
	    + ((stack1 = lookupProperty(helpers,"each").call(alias3,(depth0 != null ? lookupProperty(depth0,"data") : depth0),{"name":"each","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":8},"end":{"line":22,"column":17}}})) != null ? stack1 : "")
	    + "    </div>\n</div>\n";
	},"2":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"row")), depth0))
	    + " "
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"hidden")), depth0))
	    + "\"></div>\n";
	},"4":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"row")), depth0))
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"each","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":18,"column":16},"end":{"line":20,"column":25}}})) != null ? stack1 : "")
	    + "            </div>\n";
	},"5":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                    <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"cell")), depth0))
	    + "\">"
	    + alias2(alias1(depth0, depth0))
	    + "</div>\n";
	},"7":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "    <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"preloader") : stack1), depth0))
	    + "\">\n        <cat-preloader></cat-preloader>\n    </div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"data") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(7, data, 0),"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":29,"column":7}}})) != null ? stack1 : "");
	},"useData":true});

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", alias4=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "    <div cat-id=\""
	    + alias4(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":3,"column":17},"end":{"line":3,"column":23}}}) : helper)))
	    + "\" class=\""
	    + alias4(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"headerItem")), depth0))
	    + "\n        "
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"level") : depth0),"===",1,{"name":"compare","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":8},"end":{"line":4,"column":66}}})) != null ? stack1 : "")
	    + "\n        "
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"level") : depth0),"===",2,{"name":"compare","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":8},"end":{"line":5,"column":66}}})) != null ? stack1 : "")
	    + "\n        "
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"level") : depth0),"===",3,{"name":"compare","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":8},"end":{"line":6,"column":66}}})) != null ? stack1 : "")
	    + "\n        "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"isExpandable") : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":8},"end":{"line":7,"column":59}}})) != null ? stack1 : "")
	    + "\">\n"
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"level") : depth0),"===",2,{"name":"compare","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":8},"end":{"line":10,"column":20}}})) != null ? stack1 : "")
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"level") : depth0),"===",3,{"name":"compare","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":11,"column":8},"end":{"line":13,"column":70}}})) != null ? stack1 : "")
	    + "\n        "
	    + alias4(((helper = (helper = lookupProperty(helpers,"label") || (depth0 != null ? lookupProperty(depth0,"label") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"label","hash":{},"data":data,"loc":{"start":{"line":14,"column":8},"end":{"line":14,"column":17}}}) : helper)))
	    + "\n    </div>\n";
	},"2":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"level1")), depth0));
	},"4":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"level2")), depth0));
	},"6":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"level3")), depth0));
	},"8":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"expandable")), depth0));
	},"10":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <span class=\""
	    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"level2line")), depth0))
	    + "\"></span>\n";
	},"12":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <span class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"level2line")), depth0))
	    + "\"></span>\n            <span class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"level3line")), depth0))
	    + "\"></span>";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"container") : stack1), depth0))
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"items") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":0},"end":{"line":16,"column":9}}})) != null ? stack1 : "")
	    + "</div>\n";
	},"useData":true});

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias1(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"scrollable") : stack1), depth0))
	    + "\" id=\"scrollable\" style=\"max-height: "
	    + alias1(((helper = (helper = lookupProperty(helpers,"scrollableMaxHeight") || (depth0 != null ? lookupProperty(depth0,"scrollableMaxHeight") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"scrollableMaxHeight","hash":{},"data":data,"loc":{"start":{"line":1,"column":67},"end":{"line":1,"column":90}}}) : helper)))
	    + "px\">\n    <cat-scrollable></cat-scrollable>\n</div>\n<cat-action-panel></cat-action-panel>\n";
	},"useData":true});

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "    <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"content") : stack1), depth0))
	    + "\">\n        <cat-subnavigation></cat-subnavigation>\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"ordersTabIsSelected") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":8},"end":{"line":8,"column":15}}})) != null ? stack1 : "")
	    + "    </div>\n";
	},"2":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"orderCreator") : stack1), depth0))
	    + "\">\n            <cat-order-creator></cat-order-creator>\n        </div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isManager") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":10,"column":7}}})) != null ? stack1 : "")
	    + "<cat-content></cat-content>\n";
	},"useData":true});

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"loading") : stack1), depth0))
	    + "\">\n            <cat-overlay></cat-overlay>\n        </div>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"header") : stack1), depth0))
	    + "\">\n            "
	    + alias2(((helper = (helper = lookupProperty(helpers,"fullName") || (depth0 != null ? lookupProperty(depth0,"fullName") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"fullName","hash":{},"data":data,"loc":{"start":{"line":7,"column":12},"end":{"line":7,"column":24}}}) : helper)))
	    + "\n        </div>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"line") : stack1), depth0))
	    + "\"></div>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"block") : stack1), depth0))
	    + "\">\n            <cat-user-form></cat-user-form>\n        </div>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"noneSelected") : stack1), depth0))
	    + "\">\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"message") : stack1), depth0))
	    + "\">\n                выберите пользователя из списка\n            </div>\n        </div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"wrapper") : stack1), depth0))
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"selectedUser") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":19,"column":11}}})) != null ? stack1 : "")
	    + "</div>\n";
	},"useData":true});

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"content") : stack1), depth0))
	    + "\">\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"usersList") : stack1), depth0))
	    + "\">\n        <cat-users-list id=\"users-list\"></cat-users-list>\n    </div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"user") : stack1), depth0))
	    + "\">\n        <cat-selected-user></cat-selected-user>\n    </div>\n</div>\n";
	},"useData":true});

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"usersList") : stack1), depth0))
	    + "\">\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"head") : stack1), depth0))
	    + "\">\n            <cat-users-filter></cat-users-filter>\n        </div>\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"usersList") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.program(8, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":6,"column":8},"end":{"line":35,"column":15}}})) != null ? stack1 : "")
	    + "    </div>\n";
	},"2":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"listWrapper") : stack1), depth0))
	    + "\">\n                <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"scrolltrack") : stack1), depth0))
	    + "\">\n                    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"scrollbar") : stack1), depth0))
	    + "\"></div>\n                </div>\n                <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"list") : stack1), depth0))
	    + "\">\n                    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"listContent") : stack1), depth0))
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"usersList") : depth0),{"name":"each","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":13,"column":24},"end":{"line":29,"column":33}}})) != null ? stack1 : "")
	    + "                    </div>\n                </div>\n            </div>\n";
	},"3":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                            <div class=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"user") : stack1), depth0))
	    + "\">\n                                <div class=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"info") : stack1), depth0))
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isSelected") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.program(6, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":16,"column":36},"end":{"line":26,"column":43}}})) != null ? stack1 : "")
	    + "                                </div>\n                            </div>\n";
	},"4":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.escapeExpression, alias2=depth0 != null ? depth0 : (container.nullContext || {}), alias3=container.hooks.helperMissing, alias4="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                                        <span class=\""
	    + alias1(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"linkActive")), depth0))
	    + "\" cat-id=\""
	    + alias1(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":17,"column":87},"end":{"line":17,"column":93}}}) : helper)))
	    + "\" title=\""
	    + alias1(((helper = (helper = lookupProperty(helpers,"fullName") || (depth0 != null ? lookupProperty(depth0,"fullName") : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"fullName","hash":{},"data":data,"loc":{"start":{"line":17,"column":102},"end":{"line":17,"column":114}}}) : helper)))
	    + "\">\n                                            "
	    + alias1(((helper = (helper = lookupProperty(helpers,"fullName") || (depth0 != null ? lookupProperty(depth0,"fullName") : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"fullName","hash":{},"data":data,"loc":{"start":{"line":18,"column":44},"end":{"line":18,"column":56}}}) : helper)))
	    + "\n                                        </span>\n";
	},"6":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", alias4=container.escapeExpression, alias5=container.lambda, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                                        <a cat-url=\"/manager/users/"
	    + alias4(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":21,"column":67},"end":{"line":21,"column":73}}}) : helper)))
	    + "\"\n                                           class=\""
	    + alias4(alias5(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"link")), depth0))
	    + " "
	    + alias4(alias5(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"redirect")), depth0))
	    + "\"\n                                           cat-id=\""
	    + alias4(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":23,"column":51},"end":{"line":23,"column":57}}}) : helper)))
	    + "\" title=\""
	    + alias4(((helper = (helper = lookupProperty(helpers,"fullName") || (depth0 != null ? lookupProperty(depth0,"fullName") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"fullName","hash":{},"data":data,"loc":{"start":{"line":23,"column":66},"end":{"line":23,"column":78}}}) : helper)))
	    + "\">\n                                            "
	    + alias4(((helper = (helper = lookupProperty(helpers,"fullName") || (depth0 != null ? lookupProperty(depth0,"fullName") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"fullName","hash":{},"data":data,"loc":{"start":{"line":24,"column":44},"end":{"line":24,"column":56}}}) : helper)))
	    + "\n                                        </a>\n";
	},"8":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"notFound") : stack1), depth0))
	    + "\">Пользователей не найдено</div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isError") : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":37,"column":11}}})) != null ? stack1 : "");
	},"useData":true,"useDepths":true});

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    return "<div class=\"\">\n    <cat-filter-input id=\"text-name\" path=\"account.users.list.filter\"></cat-filter-input>\n</div>\n";
	},"useData":true});

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"icon") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"check") : stack1), depth0))
	    + "\"></div>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"title") : stack1), depth0))
	    + "\">\n            Регистрация почти закончена!\n        </div>\n\n        <div class=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"text") : stack1), depth0))
	    + "\">\n            На Ваш email\n            <a class=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"link") : stack1), depth0))
	    + "\">"
	    + alias2(alias1((depths[1] != null ? lookupProperty(depths[1],"email") : depths[1]), depth0))
	    + "</a>\n            отправлено письмо со ссылкой для активации аккаунта.<br> Пожалуйста, проверьте почту.\n        </div>\n";
	},"3":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"icon") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"check") : stack1), depth0))
	    + "\"></div>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"title") : stack1), depth0))
	    + "\">\n            Вы успешно зарегистрировались\n        </div>\n\n        <div class=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"text") : stack1), depth0))
	    + "\">\n            Пройдите по ссылке, чтобы попасть на страницу <a class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"redirect")), depth0))
	    + " "
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"link")), depth0))
	    + "\"\n                                                             cat-url=\"/\">заказа</a>.\n        </div>\n";
	},"5":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"icon") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"check") : stack1), depth0))
	    + "\"></div>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"title") : stack1), depth0))
	    + "\">\n            Вы успешно авторизовались\n        </div>\n\n        <div class=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"text") : stack1), depth0))
	    + "\">\n            Сейчас вас перенаправят на основной раздел сайта\n        </div>\n";
	},"7":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"icon") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"check") : stack1), depth0))
	    + "\"></div>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"title") : stack1), depth0))
	    + "\">\n            Необходимо подтвердить восстановление пароля\n        </div>\n\n        <div class=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"text") : stack1), depth0))
	    + "\">\n            На Ваш email\n            <a class=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"link") : stack1), depth0))
	    + "\">"
	    + alias2(alias1((depths[1] != null ? lookupProperty(depths[1],"email") : depths[1]), depth0))
	    + "</a>\n            отправлено письмо с инструкциями по восстановлению пароля.<br> Пожалуйста, проверьте почту.\n        </div>\n";
	},"9":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"icon") : stack1), depth0))
	    + "\"></div>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"title") : stack1), depth0))
	    + "\">\n            Вы уже залогинены\n        </div>\n\n        <div class=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"text") : stack1), depth0))
	    + "\">\n            Сейчас вас перенаправят на основной раздел сайта\n        </div>\n";
	},"11":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"icon") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"check") : stack1), depth0))
	    + "\"></div>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"title") : stack1), depth0))
	    + "\">\n            Пароль успешно изменен\n        </div>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"text") : stack1), depth0))
	    + "\">\n            Теперь вы можете воспользоваться новым паролем на странице\n            <a cat-url=\"/login\" class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"redirect")), depth0))
	    + " "
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"link")), depth0))
	    + "\">логина</a>.\n        </div>\n";
	},"13":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"icon") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"check") : stack1), depth0))
	    + "\"></div>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"title") : stack1), depth0))
	    + "\">\n            Почта подтверждена!\n        </div>\n\n        <div class=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"text") : stack1), depth0))
	    + "\">\n            Вы можете авторизоваться на странице\n            <a cat-url=\"/login\" class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"redirect")), depth0))
	    + " "
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"link")), depth0))
	    + "\">логина</a>.\n        </div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"block") : stack1), depth0))
	    + "\">\n"
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"type") : depth0),"===","approveRegistration",{"name":"compare","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":13,"column":16}}})) != null ? stack1 : "")
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"type") : depth0),"===","registrationSuccess",{"name":"compare","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":4},"end":{"line":24,"column":16}}})) != null ? stack1 : "")
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"type") : depth0),"===","loginSuccess",{"name":"compare","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":25,"column":4},"end":{"line":34,"column":16}}})) != null ? stack1 : "")
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"type") : depth0),"===","approveRestore",{"name":"compare","hash":{},"fn":container.program(7, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":35,"column":4},"end":{"line":46,"column":16}}})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"type") : depth0),"===","redirect",{"name":"compare","hash":{},"fn":container.program(9, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":48,"column":4},"end":{"line":57,"column":16}}})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"type") : depth0),"===","changePasswordSuccess",{"name":"compare","hash":{},"fn":container.program(11, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":59,"column":4},"end":{"line":68,"column":16}}})) != null ? stack1 : "")
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"type") : depth0),"===","emailConfirmed",{"name":"compare","hash":{},"fn":container.program(13, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":69,"column":4},"end":{"line":79,"column":16}}})) != null ? stack1 : "")
	    + "</div>\n";
	},"useData":true,"useDepths":true});

/***/ }),
/* 922 */
878,
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"message") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"animation") : stack1), depth0))
	    + "\">\n       "
	    + alias2(((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":3,"column":7},"end":{"line":3,"column":15}}}) : helper)))
	    + "\n    </div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isError") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":5,"column":7}}})) != null ? stack1 : "");
	},"useData":true});

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"field") : stack1), depth0))
	    + "\">\n    <cat-text-email id=\"text-email\" path=\"login.form.username\" erroPath=\"login.error.username\"></cat-text-email>\n</div>\n<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"field") : stack1), depth0))
	    + "\">\n    <cat-text-password id=\"text-password\" path=\"login.form.password\" erroPath=\"login.error.password\"></cat-text-password>\n</div>\n";
	},"useData":true});

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"alreadyRegisteredTooltip") : stack1), depth0))
	    + "\">\n            Этот email зарегистрирован в одном из\n            <a class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"link") : stack1), depth0))
	    + "\" target=\"_blank\" href=\"http://info.2gis.ru/novosibirsk/products/2gis\">продуктов 2GIS</a>.\n            Пожалуйста, авторизуйтесь, используя логин/пароль учетной записи в\n            <a class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"link") : stack1), depth0))
	    + "\" target=\"_blank\" href=\"http://info.2gis.ru/novosibirsk/products/2gis\">2GIS</a>.\n        </div>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"alreadyRegisteredTooltip") : stack1), depth0))
	    + "\">\n                Мы ещё раз отправили Вам письмо для подтверждения почты на адрес "
	    + alias2(((helper = (helper = lookupProperty(helpers,"email") || (depth0 != null ? lookupProperty(depth0,"email") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"email","hash":{},"data":data,"loc":{"start":{"line":18,"column":81},"end":{"line":18,"column":90}}}) : helper)))
	    + "\n                Пожалуйста, проверьте почту. <a class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"link") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"sendConfirmationMail") : stack1), depth0))
	    + "\">Выслать письмо повторно.</a>\n            </div>\n";
	},"5":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"showEmailNotConfirmedTooltip") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":22,"column":12},"end":{"line":27,"column":19}}})) != null ? stack1 : "");
	},"6":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"alreadyRegisteredTooltip") : stack1), depth0))
	    + "\">\n                    Вы еще не подтвердили свою почту "
	    + alias2(((helper = (helper = lookupProperty(helpers,"email") || (depth0 != null ? lookupProperty(depth0,"email") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"email","hash":{},"data":data,"loc":{"start":{"line":24,"column":53},"end":{"line":24,"column":62}}}) : helper)))
	    + ".\n                    Пожалуйста, проверьте почту. <a class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"link") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"sendConfirmationMail") : stack1), depth0))
	    + "\">Выслать письмо повторно.</a>\n                </div>\n";
	},"8":function(container,depth0,helpers,partials,data) {
	    return "disabled=\"true\"";
	},"10":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                <span class=\""
	    + alias1(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"registrationButton") : stack1), depth0))
	    + "\" cat-url=\""
	    + alias1((lookupProperty(helpers,"patchQuery")||(depth0 && lookupProperty(depth0,"patchQuery"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"/registration/extra",((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"utm")),{"name":"patchQuery","hash":{},"data":data,"loc":{"start":{"line":49,"column":66},"end":{"line":49,"column":112}}}))
	    + "\">\n                    Регистрация\n                </span>\n";
	},"12":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                <span class=\""
	    + alias1(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"registrationButton") : stack1), depth0))
	    + "\" cat-url=\""
	    + alias1((lookupProperty(helpers,"patchQuery")||(depth0 && lookupProperty(depth0,"patchQuery"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"/registration",((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"utm")),{"name":"patchQuery","hash":{},"data":data,"loc":{"start":{"line":53,"column":66},"end":{"line":53,"column":106}}}))
	    + "\">\n                    Регистрация\n                </span>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"block") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"fadeInUp") : stack1), depth0))
	    + "\">\n    <form class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"form") : stack1), depth0))
	    + "\">\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"title") : stack1), depth0))
	    + "\">\n            Войти\n        </div>\n\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"showAlreadyRegisteredTooltip") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":8},"end":{"line":14,"column":15}}})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"showEmailNotConfirmedMailResendTooltip") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.program(5, data, 0),"data":data,"loc":{"start":{"line":16,"column":8},"end":{"line":28,"column":15}}})) != null ? stack1 : "")
	    + "\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"formWrapper") : stack1), depth0))
	    + "\">\n            <cat-login-form id=\"login-form\"></cat-login-form>\n        </div>\n\n        <cat-error></cat-error>\n\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"formForgotWrapper") : stack1), depth0))
	    + "\">\n            <span class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"formForgot") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"redirect") : stack1), depth0))
	    + "\" cat-url=\""
	    + alias2((lookupProperty(helpers,"patchQuery")||(depth0 && lookupProperty(depth0,"patchQuery"))||container.hooks.helperMissing).call(alias3,"/restorePassword",((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"utm")),{"name":"patchQuery","hash":{},"data":data,"loc":{"start":{"line":37,"column":71},"end":{"line":37,"column":114}}}))
	    + "\" >\n                Забыли пароль?\n            </span>\n        </div>\n\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"formControls") : stack1), depth0))
	    + "\">\n            <button class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"formSubmit") : stack1), depth0))
	    + "\" type=\"submit\" "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isDisabled") : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":43,"column":61},"end":{"line":43,"column":101}}})) != null ? stack1 : "")
	    + ">\n                Войти\n            </button>\n\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"registration") : stack1), depth0))
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isBitrix") : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.program(12, data, 0),"data":data,"loc":{"start":{"line":48,"column":16},"end":{"line":56,"column":23}}})) != null ? stack1 : "")
	    + "            </div>\n        </div>\n    </form>\n</div>\n";
	},"useData":true});

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "    <a cat-url=\"/login\" class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"button") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"redirect") : stack1), depth0))
	    + "\">\n        <span class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"link") : stack1), depth0))
	    + "\">Войти</span>\n    </a>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"title") : stack1), depth0))
	    + "\">\n        Вы уже зарегистрированы в проектах 2ГИС\n    </div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"info") : stack1), depth0))
	    + "\">\n        Пожалуйста, заполните дополнительную информацию.\n    </div>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    return "            <cat-individual-form></cat-individual-form>\n";
	},"5":function(container,depth0,helpers,partials,data) {
	    return "            <cat-legal-entity-form></cat-legal-entity-form>\n";
	},"7":function(container,depth0,helpers,partials,data) {
	    return "            <cat-sole-proprietor-form></cat-sole-proprietor-form>\n";
	},"9":function(container,depth0,helpers,partials,data) {
	    return "disabled=\"true\"";
	},"11":function(container,depth0,helpers,partials,data) {
	    return "    <cat-tos></cat-tos>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), alias4=container.hooks.helperMissing, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"block") : stack1), depth0))
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"unless").call(alias3,(depth0 != null ? lookupProperty(depth0,"isBitrix") : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":12,"column":15}}})) != null ? stack1 : "")
	    + "\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"autocomplete") : stack1), depth0))
	    + "\">\n        <cat-user-shared-data-form></cat-user-shared-data-form>\n\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"separator") : stack1), depth0))
	    + "\"></div>\n"
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"userType") : depth0),"===",1,{"name":"compare","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":18,"column":8},"end":{"line":20,"column":20}}})) != null ? stack1 : "")
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"userType") : depth0),"===",2,{"name":"compare","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":21,"column":8},"end":{"line":23,"column":20}}})) != null ? stack1 : "")
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"userType") : depth0),"===",3,{"name":"compare","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":24,"column":8},"end":{"line":26,"column":20}}})) != null ? stack1 : "")
	    + "\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"section") : stack1), depth0))
	    + "\">\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"label") : stack1), depth0))
	    + "\"></div>\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"field") : stack1), depth0))
	    + " \">\n                <cat-error></cat-error>\n                <cat-error-country></cat-error-country>\n\n                <button class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"submit") : stack1), depth0))
	    + "\" type=\"submit\" "
	    + ((stack1 = lookupProperty(helpers,"unless").call(alias3,(depth0 != null ? lookupProperty(depth0,"isEnabled") : depth0),{"name":"unless","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":34,"column":61},"end":{"line":34,"column":108}}})) != null ? stack1 : "")
	    + ">\n                    Далее\n                </button>\n                <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"privacy") : stack1), depth0))
	    + "\">\n                    Нажимая кнопку «Далее», вы принимаете условия \n                    <a href=\"https://law.2gis.ru/licensing-agreement\" target=\"_blank\">Лицензионного соглашения</a>. Условия и цели обработки персональных данных определены в\n                    <a href=\"https://law.2gis.ru/privacy\" target=\"_blank\">Политике конфиденциальности</a>.\n                    <br/>\n                    <a href=\"https://law.2gis.ru/personal-data-dublgis\" target=\"_blank\">Политика обработки персональных данных</a>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"showToS") : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":49,"column":0},"end":{"line":51,"column":7}}})) != null ? stack1 : "");
	},"useData":true});

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "            <cat-individual-form></cat-individual-form>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    return "            <cat-legal-entity-form></cat-legal-entity-form>\n";
	},"5":function(container,depth0,helpers,partials,data) {
	    return "            <cat-sole-proprietor-form></cat-sole-proprietor-form>\n";
	},"7":function(container,depth0,helpers,partials,data) {
	    return "disabled=\"true\"";
	},"9":function(container,depth0,helpers,partials,data) {
	    return "    <cat-tos></cat-tos>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), alias4=container.hooks.helperMissing, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"block") : stack1), depth0))
	    + "\">\n    <a cat-url=\"/login\" class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"button") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"redirect") : stack1), depth0))
	    + "\">\n        <span class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"link") : stack1), depth0))
	    + "\">Войти</span>\n    </a>\n\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"title") : stack1), depth0))
	    + "\">\n        Регистрация\n    </div>\n\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"autocomplete") : stack1), depth0))
	    + "\">\n        <cat-user-shared-data-form></cat-user-shared-data-form>\n\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"separator") : stack1), depth0))
	    + "\"></div>\n"
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"userType") : depth0),"===",1,{"name":"compare","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":8},"end":{"line":16,"column":20}}})) != null ? stack1 : "")
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"userType") : depth0),"===",2,{"name":"compare","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":17,"column":8},"end":{"line":19,"column":20}}})) != null ? stack1 : "")
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"userType") : depth0),"===",3,{"name":"compare","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":20,"column":8},"end":{"line":22,"column":20}}})) != null ? stack1 : "")
	    + "\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"separator") : stack1), depth0))
	    + "\"></div>\n\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"section") : stack1), depth0))
	    + "\">\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"label") : stack1), depth0))
	    + "\">\n                <span class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"require") : stack1), depth0))
	    + "\">Email</span>\n            </div>\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"field") : stack1), depth0))
	    + " \">\n                <cat-text-email id=\"text-email\" path=\"registration.form.email\"\n                                error-path=\"registration.error.email\"></cat-text-email>\n            </div>\n        </div>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"section") : stack1), depth0))
	    + "\">\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"label") : stack1), depth0))
	    + "\">\n                <span class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"require") : stack1), depth0))
	    + "\">Пароль</span>\n            </div>\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"field") : stack1), depth0))
	    + " \">\n                <cat-text-password id=\"text-pass\" path=\"registration.form.password\"\n                                   error-path=\"registration.error.password\"></cat-text-password>\n            </div>\n        </div>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"section") : stack1), depth0))
	    + "\">\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"label") : stack1), depth0))
	    + "\">\n                <span class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"require") : stack1), depth0))
	    + "\">Повторите пароль</span>\n            </div>\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"field") : stack1), depth0))
	    + " \">\n                <cat-text-repeat-password id=\"text-rep-pass\" path=\"registration.form.repeatPassword\"\n                                          error-path=\"registration.error.repeatPassword\"></cat-text-repeat-password>\n            </div>\n        </div>\n\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"section") : stack1), depth0))
	    + "\">\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"label") : stack1), depth0))
	    + "\"></div>\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"field") : stack1), depth0))
	    + " \">\n                <cat-error></cat-error>\n                <cat-error-country></cat-error-country>\n                <button class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"submit") : stack1), depth0))
	    + "\" type=\"submit\" "
	    + ((stack1 = lookupProperty(helpers,"unless").call(alias3,(depth0 != null ? lookupProperty(depth0,"isEnabled") : depth0),{"name":"unless","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":59,"column":61},"end":{"line":59,"column":108}}})) != null ? stack1 : "")
	    + ">\n                    Далее\n                </button>\n                <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"privacy") : stack1), depth0))
	    + "\">\n                    Нажимая кнопку «Далее», вы принимаете условия \n                    <a href=\"https://law.2gis.ru/licensing-agreement\" target=\"_blank\">Лицензионного соглашения</a>. Условия и цели обработки персональных данных определены в\n                    <a href=\"https://law.2gis.ru/privacy\" target=\"_blank\">Политике конфиденциальности</a>.\n                    <br/>\n                    <a href=\"https://law.2gis.ru/personal-data-dublgis\" target=\"_blank\">Политика обработки персональных данных</a>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"showToS") : depth0),{"name":"if","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":74,"column":0},"end":{"line":76,"column":7}}})) != null ? stack1 : "");
	},"useData":true});

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "disabled=\"true\"";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"block") : stack1), depth0))
	    + "\">\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"container") : stack1), depth0))
	    + "\">\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"title") : stack1), depth0))
	    + "\">\n            Восстановление пароля\n        </div>\n\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"field") : stack1), depth0))
	    + "\">\n            <cat-text-password id=\"text-password\" path=\"restoreChange.form.password\" error-path=\"restoreChange.validation.password\"></cat-text-password>\n        </div>\n\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"field") : stack1), depth0))
	    + "\">\n            <cat-text-repeat-password id=\"text-repeat-password\" path=\"restoreChange.form.repeatPassword\" error-path=\"restoreChange.validation.repeatPassword\"></cat-text-repeat-password>\n        </div>\n\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"errorWrapper") : stack1), depth0))
	    + "\">\n            <cat-error></cat-error>\n        </div>\n\n        <button class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"submit") : stack1), depth0))
	    + "\" type=\"submit\" "
	    + ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isEnabled") : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":19,"column":53},"end":{"line":19,"column":100}}})) != null ? stack1 : "")
	    + ">\n            Восстановить пароль\n        </button>\n    </div>\n</div>\n";
	},"useData":true});

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "disabled=\"true\"";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"block") : stack1), depth0))
	    + "\">\n    <a cat-url=\"/login\" class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"button") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"redirect") : stack1), depth0))
	    + "\">\n        <span class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"link") : stack1), depth0))
	    + "\">Войти</span>\n    </a>\n\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"title") : stack1), depth0))
	    + "\">\n        Восстановление пароля\n    </div>\n\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"description") : stack1), depth0))
	    + "\">\n        На ваш адрес эл.почты будет отправлено письмо с инструкциями </br>\n        по восстановлению пароля\n    </div>\n\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"inputGroup") : stack1), depth0))
	    + "\">\n        <cat-text-email id=\"text-email\" path=\"restore.form.email\" error-path=\"restore.error.email\"></cat-text-email>\n    </div>\n\n    <cat-error></cat-error>\n\n    <button class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"submit") : stack1), depth0))
	    + "\" "
	    + ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isEnabled") : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":21,"column":35},"end":{"line":21,"column":82}}})) != null ? stack1 : "")
	    + ">\n        Восстановить пароль\n    </button>\n</div>\n";
	},"useData":true});

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    return "<cat-content></cat-content>\n";
	},"useData":true});

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\"tos\">\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"modal") : stack1), depth0))
	    + "\">\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"container") : stack1), depth0))
	    + "\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"tos-header\">\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"modal-content") : stack1), depth0))
	    + "\">\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"top-scroll-area") : stack1), depth0))
	    + "\">\n                <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"header") : stack1), depth0))
	    + "\" id=\"tos-header\">\n                    Политика конфиденциальности и Соглашение об использовании\n                </div>\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"section") : stack1), depth0))
	    + "\">\n                <p>Нажимая \"Согласен\", Вы  соглашаетесь с\n                    <a href=\"http://law.2gis.ru/rules\" class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"link") : stack1), depth0))
	    + "\" target=\"_blank\" >Соглашением об использовании сервисов 2ГИС</a>,\n                    даете ООО «ДубльГИС» согласие на обработку персональных данных на условиях и в целях, определенных\n                    <a href=\"http://law.2gis.ru/privacy\" class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"link") : stack1), depth0))
	    + "\" target=\"_blank\" >Политикой конфиденциальности</a>,\n                    которая описывает порядок обработки и защиты персональной информации\n                    о Пользователях, включая следующие моменты:</p>\n            </div>\n            <div>\n                <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"section") : stack1), depth0))
	    + "\">\n                <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"section-header") : stack1), depth0))
	    + "\">Какие данные нам нужны и зачем</div>\n                <p>\n                <ul>\n                    <li>если Вам не нужны закрывающие документы, нам нужны только Ваши имя, фамилия, для того, чтобы\n                        знать как к Вам обращаться, и адрес электронной почты, для того чтобы идентифицировать Вас;</li>\n                    <li>указанный номер телефона и город поможет нам общаться легче;</li>\n                    <li>если закрывающие документы необходимы, необходимо заполнить поля: Организация,\n                        Юридический адрес, ИНН, КПП, на которые будут выписаны документы;</li>\n                    <li>также мы храним информацию о Ваших заказах.</li>\n                </ul>\n                </p>\n                </div>\n                <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"section") : stack1), depth0))
	    + "\">\n                <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"section-header") : stack1), depth0))
	    + "\">Соглашение</div>\n                <p>\n                    <ul>\n                        <li>мы не размещаем контент, нарушающий действующее законодательство и ожидаем этого же от Вас;</li>\n                        <li>в случае нарушений действующего законодательства или условий Соглашения, мы оставляем за\n                            собой право заблокировать или удалить Вашу учетную запись;</li>\n                        <li>мы делаем все возможное, чтобы наш продукт был удобным для Вас и всегда стабильно работал,\n                            но может случится, что сайт не оправдает Ваши ожидания или будет недоступен.</li>\n                    </ul>\n                </p>\n                </div>\n            </div>\n                </div>\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"actions") : stack1), depth0))
	    + "\">\n                <button class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"cancel") : stack1), depth0))
	    + "\">\n                    Отмена\n                </button>\n                <button class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"accept") : stack1), depth0))
	    + "\" type=\"submit\">\n                    Согласен\n                </button>\n            </div>\n            </div>\n        </div>\n    </div>\n</div>\n";
	},"useData":true});

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<script src=\"//api.bitrix24.com/api/v1/\"></script>\n\n<section class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"content") : stack1), depth0))
	    + "\">\n    <h1 class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"head") : stack1), depth0))
	    + "\">\n        Сформировать выборку данных с помощью сервиса Дата2ГИС\n    </h1>\n\n    <cat-custom-order></cat-custom-order>\n</section>\n\n<section class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"actions") : stack1), depth0))
	    + "\">\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"actionsWrapper") : stack1), depth0))
	    + "\">\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"actionsControls") : stack1), depth0))
	    + "\">\n            <a download type=\"text/csv\" href=\"/static/document/data2gis_example.xlsx\"\n               target=\"_blank\" class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"actionsButton") : stack1), depth0))
	    + "\">\n                Скачать пример выборки\n            </a>\n        </div>\n    </div>\n</section>\n\n<section class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"payment") : stack1), depth0))
	    + "\">\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"paymentWrapper") : stack1), depth0))
	    + "\">\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"cost") : stack1), depth0))
	    + "\">\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"costHeader") : stack1), depth0))
	    + "\">\n                <span class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"costHeaderTitle") : stack1), depth0))
	    + "\">\n                    Скидки\n                </span>\n                <br>\n                <span class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"costHeaderInfo") : stack1), depth0))
	    + "\">\n                    Цена выборки зависит от количества строк, чем их больше, тем цена ниже.\n                    <span class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"tooltipWrapper")), depth0))
	    + "\">\n                        <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"info")), depth0))
	    + "\"></div>\n                        <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"tooltip")), depth0))
	    + "\">\n                            Скидка применятся к полям независимо\n                        </div>\n                    </span>\n                </span>\n            </div>\n            <cat-discounts></cat-discounts>\n        </div>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"paymentMethods") : stack1), depth0))
	    + "\">\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"paymentMethodsHeader") : stack1), depth0))
	    + "\">\n                Способы оплаты\n            </div>\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"paymentMethodsBlocks") : stack1), depth0))
	    + "\">\n                <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"paymentMethodsBlock") : stack1), depth0))
	    + "\">\n                    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"paymentMethodsImage") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"bankCard") : stack1), depth0))
	    + "\"></div>\n                    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"paymentMethodsInfo") : stack1), depth0))
	    + "\">\n                        Банковская карта\n                    </div>\n                </div>\n                <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"paymentMethodsBlock") : stack1), depth0))
	    + "\">\n                    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"paymentMethodsImage") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"invoice") : stack1), depth0))
	    + "\"></div>\n                    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"paymentMethodsInfo") : stack1), depth0))
	    + "\">\n                        Счет на оплату\n                    </div>\n                </div>\n                <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"paymentMethodsBlock") : stack1), depth0))
	    + "\">\n                    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"paymentMethodsImage") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"webmoney") : stack1), depth0))
	    + "\"></div>\n                    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"paymentMethodsInfo") : stack1), depth0))
	    + "\">\n                        Электронные деньги\n                    </div>\n                </div>\n                <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"paymentMethodsBlock") : stack1), depth0))
	    + "\">\n                    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"paymentMethodsImage") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"cash") : stack1), depth0))
	    + "\"></div>\n                    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"paymentMethodsInfo") : stack1), depth0))
	    + "\">\n                        Наличные\n                    </div>\n                </div>\n                <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"paymentMethodsBlock") : stack1), depth0))
	    + "\">\n                    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"paymentMethodsImage") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"sms") : stack1), depth0))
	    + "\"></div>\n                    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"paymentMethodsInfo") : stack1), depth0))
	    + "\">\n                        SMS\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</section>\n\n<section class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"manager") : stack1), depth0))
	    + "\">\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"managerWrapper") : stack1), depth0))
	    + "\">\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"managerImage") : stack1), depth0))
	    + "\">\n        </div>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"managerHeader") : stack1), depth0))
	    + "\">\n            Более подробная выборка (средний чек, количество филиалов или другие параметры и данные) также доступны в Личном кабинете\n        </div>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"managerControls") : stack1), depth0))
	    + "\">\n            <a target=\"_top\" href=\"mailto:content.data@2gis.com\" class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"managerLink") : stack1), depth0))
	    + "\">\n                Написать менеджеру\n            </a>\n        </div>\n    </div>\n</section>\n";
	},"useData":true});

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "    <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"discount")), depth0))
	    + "\">"
	    + alias2(alias1(((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"discountPercentage")), depth0))
	    + "%</div>\n    <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"discountLabel")), depth0))
	    + "\">скидка<br> за объём\n        <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"count")), depth0))
	    + "\">\n            "
	    + alias2((lookupProperty(helpers,"intFormat")||(depth0 && lookupProperty(depth0,"intFormat"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"rowAmount")),{"name":"intFormat","hash":{},"data":data,"loc":{"start":{"line":5,"column":12},"end":{"line":5,"column":41}}}))
	    + " шт.\n        </div>\n    </div>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"isUseDiscounts")),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.program(7, data, 0),"data":data,"loc":{"start":{"line":9,"column":4},"end":{"line":29,"column":11}}})) != null ? stack1 : "");
	},"4":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"discountBlock")), depth0))
	    + " "
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"tooltipWrapper")), depth0))
	    + "\">\n            <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"discount")), depth0))
	    + " "
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"discountGray")), depth0))
	    + "\">%</div>\n            <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"discountLabel")), depth0))
	    + "\">\n                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"noDiscountTooltip")), depth0))
	    + "\">\n                    скидка<br> за объём\n                </div>\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"rowAmount")),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":16},"end":{"line":20,"column":23}}})) != null ? stack1 : "")
	    + "            </div>\n        </div>\n";
	},"5":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                    <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"discountLabel")), depth0))
	    + " "
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"count")), depth0))
	    + "\">\n                        "
	    + alias2((lookupProperty(helpers,"intFormat")||(depth0 && lookupProperty(depth0,"intFormat"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"rowAmount")),{"name":"intFormat","hash":{},"data":data,"loc":{"start":{"line":18,"column":24},"end":{"line":18,"column":53}}}))
	    + " шт.\n                    </div>\n";
	},"7":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"rowAmount")),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":24,"column":8},"end":{"line":28,"column":15}}})) != null ? stack1 : "");
	},"8":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"discountLabel")), depth0))
	    + " "
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"count")), depth0))
	    + "\">\n                "
	    + alias2((lookupProperty(helpers,"intFormat")||(depth0 && lookupProperty(depth0,"intFormat"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"rowAmount")),{"name":"intFormat","hash":{},"data":data,"loc":{"start":{"line":26,"column":16},"end":{"line":26,"column":45}}}))
	    + " шт.\n            </div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"discountPercentage") : depth0),">",0,{"name":"compare","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":30,"column":12}}})) != null ? stack1 : "");
	},"useData":true});

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "    <cat-legal-tree></cat-legal-tree>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    return "    <cat-purpose-tree></cat-purpose-tree>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<!-- деревья, которые не влазят во вторую колонку, помещаются ниже на место 2,3,4 колонки-->\n"
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"propertyName") : depth0),"==","LegalForm",{"name":"compare","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":0},"end":{"line":4,"column":12}}})) != null ? stack1 : "")
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"propertyName") : depth0),"==","Purpose",{"name":"compare","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":0},"end":{"line":7,"column":12}}})) != null ? stack1 : "");
	},"useData":true});

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "    <fieldset class=\""
	    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"fieldset")), depth0))
	    + "\" "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"isDisabled")),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":45},"end":{"line":2,"column":84}}})) != null ? stack1 : "")
	    + ">\n"
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"filterType") : depth0),"==","IsInRangeDatetime",{"name":"compare","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":8},"end":{"line":14,"column":20}}})) != null ? stack1 : "")
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"filterType") : depth0),"==","IsTrue",{"name":"compare","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":15,"column":8},"end":{"line":20,"column":20}}})) != null ? stack1 : "")
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"filterType") : depth0),"==","IsInRangeDouble",{"name":"compare","hash":{},"fn":container.program(8, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":21,"column":8},"end":{"line":42,"column":20}}})) != null ? stack1 : "")
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"propertyName") : depth0),"==","PaymentTypes",{"name":"compare","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":43,"column":8},"end":{"line":45,"column":20}}})) != null ? stack1 : "")
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"propertyName") : depth0),"==","MapClass",{"name":"compare","hash":{},"fn":container.program(12, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":46,"column":8},"end":{"line":50,"column":20}}})) != null ? stack1 : "")
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"propertyName") : depth0),"==","NumberOfEmployees",{"name":"compare","hash":{},"fn":container.program(14, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":51,"column":8},"end":{"line":55,"column":20}}})) != null ? stack1 : "")
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"propertyName") : depth0),"==","NumberOfFilials",{"name":"compare","hash":{},"fn":container.program(16, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":56,"column":8},"end":{"line":59,"column":20}}})) != null ? stack1 : "")
	    + "    </fieldset>\n";
	},"2":function(container,depth0,helpers,partials,data) {
	    return "disabled";
	},"4":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"datePickerWrapper")), depth0))
	    + "\">\n                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"dataFilter")), depth0))
	    + "\">\n                    <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"dataFilterLabel")), depth0))
	    + "\">От </div>\n                    <cat-datepicker></cat-datepicker>\n                </div>\n                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"dataFilter")), depth0))
	    + "\">\n                    <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"dataFilterLabel")), depth0))
	    + "\">До </div>\n                    <cat-datepicker-two></cat-datepicker-two>\n                </div>\n            </div>\n";
	},"6":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <span class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"checkbox")), depth0))
	    + "\">\n                <cat-checkbox-is-must id=\"isMustBeFilled"
	    + alias2(alias1((depths[1] != null ? lookupProperty(depths[1],"id") : depths[1]), depth0))
	    + "\" cat-path=\""
	    + alias2(alias1((depths[1] != null ? lookupProperty(depths[1],"id") : depths[1]), depth0))
	    + "\" cat-title=\""
	    + alias2(alias1((depths[1] != null ? lookupProperty(depths[1],"filterName") : depths[1]), depth0))
	    + "\">\n                </cat-checkbox-is-must>\n            </span>\n";
	},"8":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"textInputLabel")), depth0))
	    + "\">\n                От\n            </div>\n            <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"textInput")), depth0))
	    + "\">\n                <cat-text cat-path=\""
	    + alias2(alias1((depths[1] != null ? lookupProperty(depths[1],"id") : depths[1]), depth0))
	    + "\"\n                          cat-index=\"0\"\n                          path=\"order.addParams.exportColumns."
	    + alias2(alias1((depths[1] != null ? lookupProperty(depths[1],"id") : depths[1]), depth0))
	    + ".value.0\"\n                          error-path=\"order.addParams.exportColumns."
	    + alias2(alias1((depths[1] != null ? lookupProperty(depths[1],"id") : depths[1]), depth0))
	    + ".error.0\">\n                </cat-text>\n            </div>\n            <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"textInputLabel")), depth0))
	    + "\">\n                До\n            </div>\n            <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"textInput")), depth0))
	    + "\">\n                <cat-text cat-path=\""
	    + alias2(alias1((depths[1] != null ? lookupProperty(depths[1],"id") : depths[1]), depth0))
	    + "\"\n                          cat-index=\"1\"\n                          path=\"order.addParams.exportColumns."
	    + alias2(alias1((depths[1] != null ? lookupProperty(depths[1],"id") : depths[1]), depth0))
	    + ".value.1\"\n                          error-path=\"order.addParams.exportColumns."
	    + alias2(alias1((depths[1] != null ? lookupProperty(depths[1],"id") : depths[1]), depth0))
	    + ".error.1\">\n                </cat-text>\n            </div>\n";
	},"10":function(container,depth0,helpers,partials,data) {
	    return "            <cat-payment-tree></cat-payment-tree>\n";
	},"12":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"treeWrapperTreeOnly")), depth0))
	    + "\">\n                <cat-map-classes-tree id=\"map-classes\"></cat-map-classes-tree>\n            </div>\n";
	},"14":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"treeWrapperTreeOnly")), depth0))
	    + "\">\n                <cat-number-of-employees-tree></cat-number-of-employees-tree>\n            </div>\n";
	},"16":function(container,depth0,helpers,partials,data) {
	    return "            <cat-number-of-filials-select cat-name=\"numberOfFilialsPopup\">\n            </cat-number-of-filials-select>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"hasFilter") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":61,"column":7}}})) != null ? stack1 : "");
	},"useData":true,"useDepths":true});

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<button class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"button") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"setAll") : stack1), depth0))
	    + "\">Выделить все</button>\n<button class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"button") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"clearAll") : stack1), depth0))
	    + "\">Снять все</button>\n";
	},"useData":true});

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"columns") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":46,"column":11}}})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"columnsRosstat") : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":48,"column":4},"end":{"line":70,"column":11}}})) != null ? stack1 : "")
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"columnsKz") : depth0),{"name":"if","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":71,"column":4},"end":{"line":93,"column":11}}})) != null ? stack1 : "");
	},"2":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "    <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"line")), depth0))
	    + "\"></div>\n    <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"greeder")), depth0))
	    + "\">\n        <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"item")), depth0))
	    + " "
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"title")), depth0))
	    + "\">\n            <span>Государственные данные (</span>\n            <fieldset class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"fieldset")), depth0))
	    + "\" "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"isDisabled")),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":53},"end":{"line":7,"column":92}}})) != null ? stack1 : "")
	    + ">\n                <span class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"checkbox")), depth0))
	    + "\">\n                    <cat-checkbox-source id=\"egrip\" cat-path=\"egrip\" cat-title=\"ЕГРИП\">\n                    </cat-checkbox-source>\n                </span>\n                <span class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"checkbox")), depth0))
	    + "\">\n                    <cat-checkbox-source id=\"egrul\" cat-path=\"egrul\" cat-title=\"ЕГРЮЛ\">\n                    </cat-checkbox-source>\n                </span>\n            </fieldset>\n            <span>)</span>\n            <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"tooltip")), depth0))
	    + "\">\n                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"info")), depth0))
	    + "\"></div>\n                <span class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"tooltiptext")), depth0))
	    + "\">Данные получены из официального источника\n                    <a class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"link")), depth0))
	    + "\" target=\"_blank\" href=\"https://www.nalog.ru\" rel=\"nofollow\">\n                        https://www.nalog.ru\n                    </a>\n                </span>\n            </div>\n        </div>\n"
	    + ((stack1 = lookupProperty(helpers,"unless").call(alias3,((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"isDisabled")),{"name":"unless","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":27,"column":8},"end":{"line":33,"column":19}}})) != null ? stack1 : "")
	    + ((stack1 = lookupProperty(helpers,"each").call(alias3,(depth0 != null ? lookupProperty(depth0,"columns") : depth0),{"name":"each","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":34,"column":8},"end":{"line":45,"column":17}}})) != null ? stack1 : "");
	},"3":function(container,depth0,helpers,partials,data) {
	    return "disabled";
	},"5":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"isGosResSourceSelected")),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":28,"column":12},"end":{"line":32,"column":19}}})) != null ? stack1 : "");
	},"6":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"actions")), depth0))
	    + "\" >\n                    <cat-actions></cat-actions>\n                </div>\n";
	},"8":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isEnabled") : depth0),{"name":"if","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":35,"column":12},"end":{"line":44,"column":19}}})) != null ? stack1 : "");
	},"9":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), alias4=container.hooks.helperMissing, alias5="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"item")), depth0))
	    + "\">\n                    <fieldset class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"fieldset")), depth0))
	    + "\" "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"isDisabled")),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":37,"column":61},"end":{"line":37,"column":100}}})) != null ? stack1 : "")
	    + ">\n                        <span class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"checkbox")), depth0))
	    + "\">\n                            <cat-checkbox id=\"greederColumn"
	    + alias2(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":39,"column":59},"end":{"line":39,"column":65}}}) : helper)))
	    + "\" cat-path=\""
	    + alias2(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":39,"column":77},"end":{"line":39,"column":83}}}) : helper)))
	    + "\" cat-title=\""
	    + alias2(((helper = (helper = lookupProperty(helpers,"title") || (depth0 != null ? lookupProperty(depth0,"title") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"title","hash":{},"data":data,"loc":{"start":{"line":39,"column":96},"end":{"line":39,"column":105}}}) : helper)))
	    + "\">\n                            </cat-checkbox>\n                        </span>\n                    </fieldset>\n                </div>\n";
	},"11":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"item")), depth0))
	    + " "
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"title")), depth0))
	    + "\">Бухгалтерские данные\n            <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"tooltip")), depth0))
	    + "\">\n                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"info")), depth0))
	    + "\"></div>\n                <span class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"tooltiptext")), depth0))
	    + "\">Данные получены из официального источника\n                    <a class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"link")), depth0))
	    + "\" target=\"_blank\" href=\"http://www.gks.ru/\" rel=\"nofollow\">\n                        http://www.gks.ru/\n                    </a>\n                </span>\n            </div>\n        </div>\n"
	    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"columnsRosstat") : depth0),{"name":"each","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":59,"column":8},"end":{"line":68,"column":17}}})) != null ? stack1 : "")
	    + "        </div>\n";
	},"12":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), alias4=container.hooks.helperMissing, alias5="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"item")), depth0))
	    + "\">\n                <fieldset class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"fieldset")), depth0))
	    + "\" "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"isDisabled")),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":61,"column":57},"end":{"line":61,"column":96}}})) != null ? stack1 : "")
	    + ">\n                        <span class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"checkbox")), depth0))
	    + "\">\n                            <cat-checkbox id=\"greederColumn"
	    + alias2(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":63,"column":59},"end":{"line":63,"column":65}}}) : helper)))
	    + "\" cat-path=\""
	    + alias2(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":63,"column":77},"end":{"line":63,"column":83}}}) : helper)))
	    + "\" cat-title=\""
	    + alias2(((helper = (helper = lookupProperty(helpers,"title") || (depth0 != null ? lookupProperty(depth0,"title") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"title","hash":{},"data":data,"loc":{"start":{"line":63,"column":96},"end":{"line":63,"column":105}}}) : helper)))
	    + "\">\n                            </cat-checkbox>\n                        </span>\n                </fieldset>\n            </div>\n";
	},"14":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"item")), depth0))
	    + " "
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"title")), depth0))
	    + "\">Государственные данные Казахстана\n            <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"tooltip")), depth0))
	    + "\">\n                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"info")), depth0))
	    + "\"></div>\n                <span class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"tooltiptext")), depth0))
	    + "\">Данные получены из официального источника\n                    <a class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"link")), depth0))
	    + "\" target=\"_blank\" href=\"http://stat.gov.kz\" rel=\"nofollow\">\n                        http://stat.gov.kz\n                    </a>\n                </span>\n            </div>\n        </div>\n"
	    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"columnsKz") : depth0),{"name":"each","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":82,"column":8},"end":{"line":91,"column":17}}})) != null ? stack1 : "")
	    + "        </div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isShow") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":94,"column":7}}})) != null ? stack1 : "")
	    + "\n";
	},"useData":true});

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "    <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"treeWrapper")), depth0))
	    + "\">\n        <cat-legal-tree id=\"purpose-tree\"></cat-legal-tree>\n    </div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isShowed") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":5,"column":7}}})) != null ? stack1 : "");
	},"useData":true});

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "    <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"treeWrapperTreeOnly")), depth0))
	    + "\">\n        <cat-payment-types-tree id=\"payment-types\"></cat-payment-types-tree>\n    </div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isShowed") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":5,"column":7}}})) != null ? stack1 : "");
	},"useData":true});

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "    <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"priceContent")), depth0))
	    + " "
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"noDiscount")), depth0))
	    + "\">\n        <span class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"lineThrough")), depth0))
	    + "\">"
	    + alias2((lookupProperty(helpers,"currencyFormat")||(depth0 && lookupProperty(depth0,"currencyFormat"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"rowPriceWithoutDiscount") : depth0),{"name":"currencyFormat","hash":{},"data":data,"loc":{"start":{"line":7,"column":48},"end":{"line":7,"column":90}}}))
	    + "</span>\n        <span class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"rouble")), depth0))
	    + "\">a</span>\n    </div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"totalPrice")), depth0))
	    + "\">\n    "
	    + alias2((lookupProperty(helpers,"currencyFormat")||(depth0 && lookupProperty(depth0,"currencyFormat"))||container.hooks.helperMissing).call(alias3,(depth0 != null ? lookupProperty(depth0,"rowPrice") : depth0),{"name":"currencyFormat","hash":{},"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":2,"column":31}}}))
	    + "\n    <span class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"rouble")), depth0))
	    + " "
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"black")), depth0))
	    + "\">a</span>\n</div>\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"rowPriceWithoutDiscount") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":0},"end":{"line":10,"column":7}}})) != null ? stack1 : "");
	},"useData":true});

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "    <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"treeWrapper")), depth0))
	    + "\">\n        <cat-purpose-tree id=\"purpose-tree\"></cat-purpose-tree>\n    </div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isShowed") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":5,"column":7}}})) != null ? stack1 : "");
	},"useData":true});

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"small") : stack1), depth0));
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"line")), depth0))
	    + " "
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"lineFull")), depth0))
	    + "\"></div>\n        <div id=\"basicColumnsTitle\" class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"item")), depth0))
	    + " "
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"title")), depth0))
	    + " "
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"basicColumnsTitle")), depth0))
	    + "\">\n            Минимальный набор\n        </div>\n        <div id=\"basicColumnsWrapper\" class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"basicColumnsWrapper")), depth0))
	    + "\">\n            <div id=\"basicColumns\" class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"item")), depth0))
	    + " "
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"basicColumns")), depth0))
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"basicColumns") : depth0),{"name":"each","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":16},"end":{"line":42,"column":25}}})) != null ? stack1 : "")
	    + "            </div>\n        </div>\n";
	},"4":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), alias4=container.hooks.helperMissing, alias5="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                    <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"basicColumn")), depth0))
	    + "\">\n                        <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"firstColumn")), depth0))
	    + "\">\n                            <fieldset class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"fieldset")), depth0))
	    + "\" disabled>\n                                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"basicField")), depth0))
	    + "\">\n                                    <cat-checkbox-basic cat-title=\""
	    + alias2(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"name","hash":{},"data":data,"loc":{"start":{"line":14,"column":67},"end":{"line":14,"column":75}}}) : helper)))
	    + "\"></cat-checkbox-basic>\n                                </div>\n                            </fieldset>\n                        </div>\n                        <div class=\""
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(data && lookupProperty(data,"first")),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.program(7, data, 0),"data":data,"loc":{"start":{"line":18,"column":36},"end":{"line":18,"column":122}}})) != null ? stack1 : "")
	    + "\">\n"
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"propertyName") : depth0),"==","FirmName",{"name":"compare","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":19,"column":28},"end":{"line":28,"column":40}}})) != null ? stack1 : "")
	    + "                            <cat-filter cat-path=\""
	    + alias2(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":29,"column":50},"end":{"line":29,"column":56}}}) : helper)))
	    + "\" cat-type=\"basic\"></cat-filter>\n                        </div>\n                        <!-- первая строка для базовых колонок особоая, тут две дополнительные колонки для цены и скидки -->\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(data && lookupProperty(data,"first")),{"name":"if","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":32,"column":24},"end":{"line":39,"column":31}}})) != null ? stack1 : "")
	    + "                        <cat-filter-multicolumn cat-path=\""
	    + alias2(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":40,"column":58},"end":{"line":40,"column":64}}}) : helper)))
	    + "\" cat-type=\"basic\"></cat-filter-multicolumn>\n                    </div>\n";
	},"5":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"secondColumn")), depth0));
	},"7":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"basicSecondColumn")), depth0));
	},"9":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                                <fieldset class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"fieldset")), depth0))
	    + "\" "
	    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"isDisabled")),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":20,"column":73},"end":{"line":20,"column":112}}})) != null ? stack1 : "")
	    + ">\n                                <span class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"checkbox")), depth0))
	    + "\">\n                                    <cat-checkbox-only-head-cards id=\"isOnlyHeadCards\"\n                                                                  cat-path=\"order.addParams.onlyHeadCards\"\n                                                                  cat-title=\"Выгружать только один филиал фирмы\">\n                                    </cat-checkbox-only-head-cards>\n                                </span>\n                                </fieldset>\n";
	},"10":function(container,depth0,helpers,partials,data) {
	    return "disabled";
	},"12":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                            <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"thirdColumn")), depth0))
	    + "\">\n                                <cat-price-basic></cat-price-basic>\n                            </div>\n                            <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"fourthColumn")), depth0))
	    + "\">\n                                <cat-discount-basic></cat-discount-basic>\n                            </div>\n";
	},"14":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"line")), depth0))
	    + " "
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"lineFull")), depth0))
	    + "\"></div>\n        <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"item")), depth0))
	    + " "
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"title")), depth0))
	    + "\">\n            Дополните выборку\n            <span class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"tooltipWrapper")), depth0))
	    + "\">\n                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"info")), depth0))
	    + "\"></div>\n                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"tooltip")), depth0))
	    + "\">\n                    Вы платите только за заполненные дополнительные поля\n                </div>\n            </span>\n        </div>\n"
	    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"optionalColumns") : depth0),{"name":"each","hash":{},"fn":container.program(15, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":57,"column":8},"end":{"line":88,"column":17}}})) != null ? stack1 : "");
	},"15":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), alias4=container.hooks.helperMissing, alias5="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"item")), depth0))
	    + "\">\n                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"firstColumn")), depth0))
	    + "\">\n                    <fieldset class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"fieldset")), depth0))
	    + "\" "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"isDisabled")),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":60,"column":61},"end":{"line":60,"column":100}}})) != null ? stack1 : "")
	    + ">\n                        <span class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"checkbox")), depth0))
	    + "\">\n                            <cat-checkbox id=\"exportColumn"
	    + alias2(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":62,"column":58},"end":{"line":62,"column":64}}}) : helper)))
	    + "\" cat-path=\""
	    + alias2(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":62,"column":76},"end":{"line":62,"column":82}}}) : helper)))
	    + "\" cat-title=\""
	    + alias2(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"name","hash":{},"data":data,"loc":{"start":{"line":62,"column":95},"end":{"line":62,"column":103}}}) : helper)))
	    + "\">\n                            </cat-checkbox>\n                        </span>\n                    </fieldset>\n                </div>\n                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"secondColumn")), depth0))
	    + "\">\n"
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"propertyName") : depth0),"==","Inn",{"name":"compare","hash":{},"fn":container.program(16, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":68,"column":20},"end":{"line":73,"column":32}}})) != null ? stack1 : "")
	    + "                    <cat-filter cat-path=\""
	    + alias2(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":74,"column":42},"end":{"line":74,"column":48}}}) : helper)))
	    + "\" cat-type=\"optional\"></cat-filter>\n                </div>\n                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"thirdColumn")), depth0))
	    + "\">\n                    <cat-price cat-path=\""
	    + alias2(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":77,"column":41},"end":{"line":77,"column":47}}}) : helper)))
	    + "\"></cat-price>\n                </div>\n                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"fourthColumn")), depth0))
	    + "\">\n                    <cat-discount cat-path=\""
	    + alias2(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":80,"column":44},"end":{"line":80,"column":50}}}) : helper)))
	    + "\"></cat-discount>\n                </div>\n                <cat-filter-multicolumn cat-path=\""
	    + alias2(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":82,"column":50},"end":{"line":82,"column":56}}}) : helper)))
	    + "\" cat-type=\"optional\"></cat-filter-multicolumn>\n            </div>\n"
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"propertyName") : depth0),"==","Inn",{"name":"compare","hash":{},"fn":container.program(18, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":84,"column":12},"end":{"line":86,"column":24}}})) != null ? stack1 : "")
	    + "            <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"line")), depth0))
	    + "\"></div>\n";
	},"16":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                        <span class=\""
	    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"checkbox")), depth0))
	    + "\">\n                            <cat-checkbox-archive-inn id=\"archiveInn\" cat-title=\"Включить ликвидированные\">\n                            </cat-checkbox>\n                        </span>\n";
	},"18":function(container,depth0,helpers,partials,data) {
	    return "                <cat-greeder-columns></cat-greeder-columns>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"parameters") : stack1), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"isSmallTree") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":31},"end":{"line":1,"column":70}}})) != null ? stack1 : "")
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"basicColumns") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":45,"column":11}}})) != null ? stack1 : "")
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"optionalColumns") : depth0),{"name":"if","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":46,"column":4},"end":{"line":89,"column":11}}})) != null ? stack1 : "")
	    + "</div>\n";
	},"useData":true});

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<span class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"title") : stack1), depth0))
	    + "\">Настройте выборку</span>\n";
	},"useData":true});

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"switched") : stack1), depth0));
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<button class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"button") : stack1), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isCalcOnlyDefaultCities") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":30},"end":{"line":1,"column":84}}})) != null ? stack1 : "")
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"button") : stack1), depth0))
	    + "\">\n    Только основной город\n</button>\n";
	},"useData":true});

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"toolbox") : stack1), depth0))
	    + "\">\n    <button class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"button") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"toggleFilterType") : stack1), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"showFilterTreeInput") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":59},"end":{"line":3,"column":109}}})) != null ? stack1 : "")
	    + "\">Фильтровать по списку</button>\n</div>\n";
	},"2":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"switched") : stack1), depth0));
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isDisabled") : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":5,"column":11}}})) != null ? stack1 : "");
	},"useData":true});

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"wrapper") : stack1), depth0))
	    + "\">\n            <input type=\"text\" id=\"citySelect\" class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"search") : stack1), depth0))
	    + "\"\n                   placeholder=\"Начните вводить, чтобы найти город...\" list=\"cityname\">\n        </div>\n        <datalist id=\"cityname\">\n        </datalist>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<link rel=\"stylesheet\" href=\"/static/assets/leaflet.draw/leaflet.draw.css\" />\n<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"content") : stack1), depth0))
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isDisabled") : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":10,"column":15}}})) != null ? stack1 : "")
	    + "    <div id=\"mapid-parent\">\n        <div id=\"mapid\" class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"map") : stack1), depth0))
	    + "\"></div>\n    </div>\n</div>\n";
	},"useData":true});

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isManager") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(7, data, 0),"data":data,"loc":{"start":{"line":3,"column":8},"end":{"line":24,"column":15}}})) != null ? stack1 : "");
	},"2":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), alias4=container.hooks.helperMissing, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"toolbox")), depth0))
	    + "\">\n                <button cat-id=\"default\" class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"tab")), depth0))
	    + "\n                    "
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"tab") : depth0),"===","default",{"name":"compare","hash":{},"fn":container.program(3, data, 0),"inverse":container.program(5, data, 0),"data":data,"loc":{"start":{"line":6,"column":20},"end":{"line":6,"column":118}}})) != null ? stack1 : "")
	    + "\">\n                    По нас.пунктам\n                </button>\n                <button cat-id=\"branches\" class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"tab")), depth0))
	    + "\n                    "
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"tab") : depth0),"===","branches",{"name":"compare","hash":{},"fn":container.program(3, data, 0),"inverse":container.program(5, data, 0),"data":data,"loc":{"start":{"line":10,"column":20},"end":{"line":10,"column":119}}})) != null ? stack1 : "")
	    + "\">\n                    По проектам\n                </button>\n                <button cat-id=\"map\" class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"tab")), depth0))
	    + "\n                    "
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"tab") : depth0),"===","map",{"name":"compare","hash":{},"fn":container.program(3, data, 0),"inverse":container.program(5, data, 0),"data":data,"loc":{"start":{"line":14,"column":20},"end":{"line":14,"column":114}}})) != null ? stack1 : "")
	    + "\">\n                    По карте\n                </button>\n            </div>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"selected")), depth0));
	},"5":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"unselected")), depth0));
	},"7":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <!--<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"toolbox") : stack1), depth0))
	    + "\">\n                <button class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"button") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"toggleFilterType") : stack1), depth0))
	    + " "
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"tab") : depth0),"===","map",{"name":"compare","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":20,"column":71},"end":{"line":20,"column":133}}})) != null ? stack1 : "")
	    + "\">\n                    Фильтровать по карте\n                </button>\n            </div>-->\n";
	},"9":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"isDisabled")),{"name":"unless","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":28,"column":8},"end":{"line":31,"column":19}}})) != null ? stack1 : "")
	    + "        <cat-filterable-tree id=\"cities\"></cat-filterable-tree>\n";
	},"10":function(container,depth0,helpers,partials,data) {
	    return "            <cat-filter-by-list></cat-filter-by-list>\n            <cat-tree-input></cat-tree-input>\n";
	},"12":function(container,depth0,helpers,partials,data) {
	    return "        <cat-branches-tree id=\"branches\"></cat-branches-tree>\n";
	},"14":function(container,depth0,helpers,partials,data) {
	    return "        <cat-map-filter></cat-map-filter>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"content")), depth0))
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,(depth0 != null ? lookupProperty(depth0,"isDisabled") : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":25,"column":15}}})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"tab") : depth0),"===","default",{"name":"compare","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":27,"column":4},"end":{"line":33,"column":16}}})) != null ? stack1 : "")
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"tab") : depth0),"===","branches",{"name":"compare","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":34,"column":4},"end":{"line":36,"column":16}}})) != null ? stack1 : "")
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"tab") : depth0),"===","map",{"name":"compare","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":37,"column":4},"end":{"line":39,"column":16}}})) != null ? stack1 : "")
	    + "</div>\n\n";
	},"useData":true});

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), alias4=container.hooks.helperMissing, alias5="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"line") : stack1), depth0))
	    + "\"></div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"title") : stack1), depth0))
	    + "\">Скачайте список населённых пунктов</div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"buttonWrapper") : stack1), depth0))
	    + "\">\n        <button class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"downloadButton") : stack1), depth0))
	    + "\">Скачать</button>\n    </div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"line") : stack1), depth0))
	    + "\"></div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"title") : stack1), depth0))
	    + "\">Вставьте выбранные населённые пункты</div>\n    <cat-tooltip></cat-tooltip>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"wrapper") : stack1), depth0))
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"haveUnrecognized") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(5, data, 0),"data":data,"loc":{"start":{"line":12,"column":8},"end":{"line":24,"column":15}}})) != null ? stack1 : "")
	    + "    </div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"buttonWrapper") : stack1), depth0))
	    + "\">\n        <button class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"filterButton") : stack1), depth0))
	    + "\" cat-id=\""
	    + alias2(((helper = (helper = lookupProperty(helpers,"treeId") || (depth0 != null ? lookupProperty(depth0,"treeId") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"treeId","hash":{},"data":data,"loc":{"start":{"line":27,"column":53},"end":{"line":27,"column":63}}}) : helper)))
	    + "TreeInput\" cat-id-unrecognized=\""
	    + alias2(((helper = (helper = lookupProperty(helpers,"treeId") || (depth0 != null ? lookupProperty(depth0,"treeId") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"treeId","hash":{},"data":data,"loc":{"start":{"line":27,"column":95},"end":{"line":27,"column":105}}}) : helper)))
	    + "TreeInputRecognized\">Фильтровать</button>\n    </div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"line") : stack1), depth0))
	    + "\"></div>\n";
	},"2":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", alias4=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <textarea id=\""
	    + alias4(((helper = (helper = lookupProperty(helpers,"treeId") || (depth0 != null ? lookupProperty(depth0,"treeId") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"treeId","hash":{},"data":data,"loc":{"start":{"line":13,"column":26},"end":{"line":13,"column":36}}}) : helper)))
	    + "TreeInput\" class=\""
	    + alias4(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"unrecognized") : stack1), depth0))
	    + "\"\n                      autocomplete=\"off\" spellcheck=\"false\"\n                      placeholder=\"Вставьте сюда населённые пункты из списка по одному в строке...\">"
	    + alias4(((helper = (helper = lookupProperty(helpers,"unrecognized") || (depth0 != null ? lookupProperty(depth0,"unrecognized") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"unrecognized","hash":{},"data":data,"loc":{"start":{"line":15,"column":100},"end":{"line":15,"column":116}}}) : helper)))
	    + "</textarea>\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"recognized") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":12},"end":{"line":20,"column":19}}})) != null ? stack1 : "");
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", alias4=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                <textarea id=\""
	    + alias4(((helper = (helper = lookupProperty(helpers,"treeId") || (depth0 != null ? lookupProperty(depth0,"treeId") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"treeId","hash":{},"data":data,"loc":{"start":{"line":17,"column":30},"end":{"line":17,"column":40}}}) : helper)))
	    + "TreeInputRecognized\" class=\""
	    + alias4(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"recognized") : stack1), depth0))
	    + "\"\n                          autocomplete=\"off\" spellcheck=\"false\"\n                >"
	    + alias4(((helper = (helper = lookupProperty(helpers,"recognized") || (depth0 != null ? lookupProperty(depth0,"recognized") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"recognized","hash":{},"data":data,"loc":{"start":{"line":19,"column":17},"end":{"line":19,"column":31}}}) : helper)))
	    + "</textarea>\n";
	},"5":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", alias4=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <textarea id=\""
	    + alias4(((helper = (helper = lookupProperty(helpers,"treeId") || (depth0 != null ? lookupProperty(depth0,"treeId") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"treeId","hash":{},"data":data,"loc":{"start":{"line":22,"column":26},"end":{"line":22,"column":36}}}) : helper)))
	    + "TreeInput\" autocomplete=\"off\" spellcheck=\"false\"\n                      placeholder=\"Вставьте сюда населённые пункты из списка по одному в строке...\">"
	    + alias4(((helper = (helper = lookupProperty(helpers,"recognized") || (depth0 != null ? lookupProperty(depth0,"recognized") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"recognized","hash":{},"data":data,"loc":{"start":{"line":23,"column":100},"end":{"line":23,"column":114}}}) : helper)))
	    + "</textarea>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div></div><!--Пустой див не убирать, а то кнопки начнуть генерить событие click дважды, какая-то фича catbee-->\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"showFilterTreeInput") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":0},"end":{"line":30,"column":7}}})) != null ? stack1 : "");
	},"useData":true});

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"error") : stack1), depth0))
	    + "\">\n    Не удалось распознать некоторые населённые пункты:\n</div>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "    <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"success") : stack1), depth0))
	    + "\">\n        Все населённые пункты отмечены:\n    </div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"haveUnrecognized") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":5,"column":7}}})) != null ? stack1 : "")
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"recognizeAll") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":0},"end":{"line":10,"column":7}}})) != null ? stack1 : "");
	},"useData":true});

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "    <span class=\""
	    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"title")), depth0))
	    + "\">Выберите город</span>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"tab")),"===","branches",{"name":"compare","hash":{},"fn":container.program(4, data, 0),"inverse":container.program(6, data, 0),"data":data,"loc":{"start":{"line":4,"column":4},"end":{"line":8,"column":16}}})) != null ? stack1 : "");
	},"4":function(container,depth0,helpers,partials,data) {
	    return "        <cat-branches-count></cat-branches-count>\n";
	},"6":function(container,depth0,helpers,partials,data) {
	    return "        <cat-cities-count></cat-cities-count>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"tab") : depth0),"===","map",{"name":"compare","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":9,"column":12}}})) != null ? stack1 : "");
	},"useData":true});

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"wide") : stack1), depth0));
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"headerClickable") : stack1), depth0));
	},"5":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"arrow") : stack1), depth0))
	    + "\"></div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"panel") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"collapsed") : stack1), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isWide") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":44},"end":{"line":1,"column":77}}})) != null ? stack1 : "")
	    + "\">\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"header") : stack1), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"unless").call(alias3,(depth0 != null ? lookupProperty(depth0,"isStatisticLoading") : depth0),{"name":"unless","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":31},"end":{"line":2,"column":95}}})) != null ? stack1 : "")
	    + "\">\n        <cat-header></cat-header>\n"
	    + ((stack1 = lookupProperty(helpers,"unless").call(alias3,(depth0 != null ? lookupProperty(depth0,"isStatisticLoading") : depth0),{"name":"unless","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":8},"end":{"line":6,"column":19}}})) != null ? stack1 : "")
	    + "    </div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"content") : stack1), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isWide") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":32},"end":{"line":8,"column":65}}})) != null ? stack1 : "")
	    + "\">\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"wrapper") : stack1), depth0))
	    + "\">\n            <cat-content></cat-content>\n        </div>\n    </div>\n</div>\n\n";
	},"useData":true});

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"indeterminate") : stack1), depth0));
	},"3":function(container,depth0,helpers,partials,data) {
	    return "checked";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), alias4=container.hooks.helperMissing, alias5="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"wrapper") : stack1), depth0))
	    + "\">\n  <span class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"label") : stack1), depth0))
	    + "\">\n    <input\n      type=\"checkbox\"\n      id=\"checkbox-"
	    + alias2(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":5,"column":19},"end":{"line":5,"column":25}}}) : helper)))
	    + "\"\n      class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"checkbox") : stack1), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"indeterminate") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":30},"end":{"line":6,"column":79}}})) != null ? stack1 : "")
	    + "\"\n      "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"value") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":6},"end":{"line":7,"column":33}}})) != null ? stack1 : "")
	    + ">\n    <label for=\"checkbox-"
	    + alias2(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":8,"column":25},"end":{"line":8,"column":31}}}) : helper)))
	    + "\" class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"title") : stack1), depth0))
	    + "\"></label>\n  </span>\n</div>\n";
	},"useData":true});

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"switched") : stack1), depth0));
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"toolbox") : stack1), depth0))
	    + "\">\n    <button class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"unselect") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"button") : stack1), depth0))
	    + "\">Снять все</button>\n    <button class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"select") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"button") : stack1), depth0))
	    + "\">Выделить все</button>\n    <cat-custom-filter></cat-custom-filter>\n    <button class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"showSelectedOnly") : stack1), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"showSelectedOnly") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":44},"end":{"line":5,"column":91}}})) != null ? stack1 : "")
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"button") : stack1), depth0))
	    + "\">Показать отмеченные</button>\n</div>\n";
	},"useData":true});

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<span class=\""
	    + alias1(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"title") : stack1), depth0))
	    + "\">"
	    + alias1(((helper = (helper = lookupProperty(helpers,"title") || (depth0 != null ? lookupProperty(depth0,"title") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"title","hash":{},"data":data,"loc":{"start":{"line":1,"column":28},"end":{"line":1,"column":37}}}) : helper)))
	    + "</span>\n";
	},"useData":true});

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"wrapper") : stack1), depth0))
	    + "\">\n    <input type=\"text\" id=\""
	    + alias2(((helper = (helper = lookupProperty(helpers,"treeId") || (depth0 != null ? lookupProperty(depth0,"treeId") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"treeId","hash":{},"data":data,"loc":{"start":{"line":2,"column":27},"end":{"line":2,"column":37}}}) : helper)))
	    + "Filter\" class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"filter") : stack1), depth0))
	    + "\" placeholder=\"Начните вводить, чтобы отфильтровать список...\">\n</div>\n\n";
	},"useData":true});

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "    <cat-simple></cat-simple>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"hideFilter") : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":3,"column":11}}})) != null ? stack1 : "");
	},"useData":true});

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.escapeExpression, alias2=depth0 != null ? depth0 : (container.nullContext || {}), alias3=container.hooks.helperMissing, alias4="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<span class=\""
	    + alias1(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"childrenCount") : stack1), depth0))
	    + "\">выбрано "
	    + alias1(((helper = (helper = lookupProperty(helpers,"selected") || (depth0 != null ? lookupProperty(depth0,"selected") : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"selected","hash":{},"data":data,"loc":{"start":{"line":1,"column":44},"end":{"line":1,"column":56}}}) : helper)))
	    + " из "
	    + alias1(((helper = (helper = lookupProperty(helpers,"total") || (depth0 != null ? lookupProperty(depth0,"total") : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"total","hash":{},"data":data,"loc":{"start":{"line":1,"column":60},"end":{"line":1,"column":69}}}) : helper)))
	    + "</span>\n";
	},"useData":true});

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <cat-filter></cat-filter>\n"
	    + ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isDisabled") : depth0),{"name":"unless","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":8},"end":{"line":6,"column":19}}})) != null ? stack1 : "");
	},"2":function(container,depth0,helpers,partials,data) {
	    return "            <cat-controls></cat-controls>\n";
	},"4":function(container,depth0,helpers,partials,data) {
	    return "disabled";
	},"6":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isInnerTree") : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.program(9, data, 0),"data":data,"loc":{"start":{"line":15,"column":20},"end":{"line":19,"column":27}}})) != null ? stack1 : "");
	},"7":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                        "
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"innerTreeSmall") : stack1), depth0))
	    + "\n";
	},"9":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                        "
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"small") : stack1), depth0))
	    + "\n";
	},"11":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isInnerTree") : depth0),{"name":"if","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":21,"column":20},"end":{"line":23,"column":27}}})) != null ? stack1 : "")
	    + "                ";
	},"12":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                        "
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"innerTree") : stack1), depth0))
	    + "\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"content") : stack1), depth0))
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"unless").call(alias3,(depth0 != null ? lookupProperty(depth0,"showOnlyTree") : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":7,"column":15}}})) != null ? stack1 : "")
	    + "    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"tree") : stack1), depth0))
	    + "\">\n        <fieldset class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"fieldset") : stack1), depth0))
	    + "\" "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isDisabled") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":43},"end":{"line":9,"column":76}}})) != null ? stack1 : "")
	    + ">\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"scrolltrack") : stack1), depth0))
	    + "\">\n                <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"scrollbar") : stack1), depth0))
	    + "\"></div>\n            </div>\n            <cat-tree cat-id=\"0\" class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"contentTree") : stack1), depth0))
	    + "\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isSmallTreeBool") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.program(11, data, 0),"data":data,"loc":{"start":{"line":14,"column":16},"end":{"line":24,"column":23}}})) != null ? stack1 : "")
	    + "\"\n                      cat-root=\"true\"></cat-tree>\n        </fieldset>\n    </div>\n</div>\n";
	},"useData":true});

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"unless").call(alias1,(depth0 != null ? lookupProperty(depth0,"root") : depth0),{"name":"unless","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":28,"column":15}}})) != null ? stack1 : "")
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"showNoSelectionMessage") : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":29,"column":4},"end":{"line":33,"column":11}}})) != null ? stack1 : "")
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"shouldExpand") : depth0),{"name":"if","hash":{},"fn":container.program(13, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":34,"column":4},"end":{"line":40,"column":11}}})) != null ? stack1 : "");
	},"2":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <li class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"listItem")), depth0))
	    + "\">\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"listItem") : stack1), depth0))
	    + "\">\n                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"vertical")), depth0))
	    + "\">\n                    <cat-checkbox id=\""
	    + alias2(((helper = (helper = lookupProperty(helpers,"checkboxIdPrefix") || (depth0 != null ? lookupProperty(depth0,"checkboxIdPrefix") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(alias3,{"name":"checkboxIdPrefix","hash":{},"data":data,"loc":{"start":{"line":6,"column":38},"end":{"line":6,"column":58}}}) : helper)))
	    + "."
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"item") : depth0)) != null ? lookupProperty(stack1,"code") : stack1), depth0))
	    + "\" cat-path=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"item") : depth0)) != null ? lookupProperty(stack1,"code") : stack1), depth0))
	    + "\">\n                    </cat-checkbox>\n                </div>\n                <span class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"vertical")), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,((stack1 = (depth0 != null ? lookupProperty(depth0,"item") : depth0)) != null ? lookupProperty(stack1,"children") : stack1),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":52},"end":{"line":9,"column":100}}})) != null ? stack1 : "")
	    + "\">"
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"item") : depth0)) != null ? lookupProperty(stack1,"label") : stack1), depth0))
	    + "</span>\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"showDescendantsCount") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":10,"column":16},"end":{"line":14,"column":23}}})) != null ? stack1 : "")
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,((stack1 = (depth0 != null ? lookupProperty(depth0,"item") : depth0)) != null ? lookupProperty(stack1,"isDefaultCity") : stack1),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":15,"column":16},"end":{"line":25,"column":23}}})) != null ? stack1 : "")
	    + "            </div>\n        </li>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return " "
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"expandable") : stack1), depth0))
	    + " ";
	},"5":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"item") : depth0)) != null ? lookupProperty(stack1,"children") : stack1),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":11,"column":20},"end":{"line":13,"column":27}}})) != null ? stack1 : "");
	},"6":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                        <cat-selection-count cat-path=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"item") : depth0)) != null ? lookupProperty(stack1,"code") : stack1), depth0))
	    + "\" class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"vertical")), depth0))
	    + "\"></cat-selection-count>\n";
	},"8":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                    <button class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"branchButton") : stack1), depth0))
	    + "\" cat-branch-id=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"item") : depth0)) != null ? lookupProperty(stack1,"branchId") : stack1), depth0))
	    + "\">Выбрать проект</button>\n                    <span class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"tooltipWrapper")), depth0))
	    + "\">\n                        <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"info")), depth0))
	    + "\"></div>\n                        <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"tooltipSelector")), depth0))
	    + "\"></div>\n                        <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"tooltip")), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"isSmallTree")),{"name":"if","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":20,"column":58},"end":{"line":20,"column":116}}})) != null ? stack1 : "")
	    + "\">\n                            Выбрать все города, входящие в проект\n                            <a href=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"item") : depth0)) != null ? lookupProperty(stack1,"branchLink") : stack1), depth0))
	    + "\" target=\"_blank\">"
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"item") : depth0)) != null ? lookupProperty(stack1,"branchName") : stack1), depth0))
	    + "</a>\n                        </div>\n                    </span>\n";
	},"9":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"tooltipSmall")), depth0));
	},"11":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"noSelection") : stack1), depth0))
	    + "\">\n            Ничего не выбрано\n        </div>\n";
	},"13":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <ul class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"list") : stack1), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"root") : depth0),{"name":"if","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":35,"column":32},"end":{"line":35,"column":63}}})) != null ? stack1 : "")
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"each").call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"item") : depth0)) != null ? lookupProperty(stack1,"children") : stack1),{"name":"each","hash":{},"fn":container.program(16, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":36,"column":12},"end":{"line":38,"column":21}}})) != null ? stack1 : "")
	    + "        </ul>\n";
	},"14":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"root") : stack1), depth0));
	},"16":function(container,depth0,helpers,partials,data) {
	    return "                <cat-tree cat-id=\""
	    + container.escapeExpression(container.lambda(depth0, depth0))
	    + "\"></cat-tree>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isVisible") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":41,"column":7}}})) != null ? stack1 : "");
	},"useData":true});

/***/ }),
/* 960 */
945,
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "        <cat-filter-by-list></cat-filter-by-list>\n        <cat-tree-input></cat-tree-input>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"content")), depth0))
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"isDisabled")),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":5,"column":15}}})) != null ? stack1 : "")
	    + "    <cat-filterable-tree id=\"rubrics\"></cat-filterable-tree>\n</div>\n";
	},"useData":true});

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), alias4=container.hooks.helperMissing, alias5="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"line") : stack1), depth0))
	    + "\"></div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"title") : stack1), depth0))
	    + "\">Скачайте список рубрик</div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"buttonWrapper") : stack1), depth0))
	    + "\">\n        <button class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"downloadButton") : stack1), depth0))
	    + "\">Скачать</button>\n    </div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"line") : stack1), depth0))
	    + "\"></div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"title") : stack1), depth0))
	    + "\">Вставьте выбранные рубрики</div>\n    <cat-tooltip></cat-tooltip>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"wrapper") : stack1), depth0))
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"haveUnrecognizedRubrics") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(5, data, 0),"data":data,"loc":{"start":{"line":12,"column":8},"end":{"line":24,"column":15}}})) != null ? stack1 : "")
	    + "    </div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"buttonWrapper") : stack1), depth0))
	    + "\">\n        <button class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"filterButton") : stack1), depth0))
	    + "\" cat-id=\""
	    + alias2(((helper = (helper = lookupProperty(helpers,"treeId") || (depth0 != null ? lookupProperty(depth0,"treeId") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"treeId","hash":{},"data":data,"loc":{"start":{"line":27,"column":53},"end":{"line":27,"column":63}}}) : helper)))
	    + "TreeInput\" cat-id-unrecognized=\""
	    + alias2(((helper = (helper = lookupProperty(helpers,"treeId") || (depth0 != null ? lookupProperty(depth0,"treeId") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"treeId","hash":{},"data":data,"loc":{"start":{"line":27,"column":95},"end":{"line":27,"column":105}}}) : helper)))
	    + "TreeInputRecognized\">Фильтровать</button>\n    </div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"line") : stack1), depth0))
	    + "\"></div>\n";
	},"2":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", alias4=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <textarea id=\""
	    + alias4(((helper = (helper = lookupProperty(helpers,"treeId") || (depth0 != null ? lookupProperty(depth0,"treeId") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"treeId","hash":{},"data":data,"loc":{"start":{"line":13,"column":26},"end":{"line":13,"column":36}}}) : helper)))
	    + "TreeInput\" class=\""
	    + alias4(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"unrecognized") : stack1), depth0))
	    + "\"\n                      autocomplete=\"off\" spellcheck=\"false\"\n                      placeholder=\"Вставьте сюда рубрики из списка по одной в строке...\">"
	    + alias4(((helper = (helper = lookupProperty(helpers,"unrecognizedRubrics") || (depth0 != null ? lookupProperty(depth0,"unrecognizedRubrics") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"unrecognizedRubrics","hash":{},"data":data,"loc":{"start":{"line":15,"column":89},"end":{"line":15,"column":112}}}) : helper)))
	    + "</textarea>\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"recognizedRubrics") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":12},"end":{"line":20,"column":19}}})) != null ? stack1 : "");
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", alias4=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                <textarea id=\""
	    + alias4(((helper = (helper = lookupProperty(helpers,"treeId") || (depth0 != null ? lookupProperty(depth0,"treeId") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"treeId","hash":{},"data":data,"loc":{"start":{"line":17,"column":30},"end":{"line":17,"column":40}}}) : helper)))
	    + "TreeInputRecognized\" class=\""
	    + alias4(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"recognized") : stack1), depth0))
	    + "\"\n                          autocomplete=\"off\" spellcheck=\"false\"\n                >"
	    + alias4(((helper = (helper = lookupProperty(helpers,"recognizedRubrics") || (depth0 != null ? lookupProperty(depth0,"recognizedRubrics") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"recognizedRubrics","hash":{},"data":data,"loc":{"start":{"line":19,"column":17},"end":{"line":19,"column":38}}}) : helper)))
	    + "</textarea>\n";
	},"5":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", alias4=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <textarea id=\""
	    + alias4(((helper = (helper = lookupProperty(helpers,"treeId") || (depth0 != null ? lookupProperty(depth0,"treeId") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"treeId","hash":{},"data":data,"loc":{"start":{"line":22,"column":26},"end":{"line":22,"column":36}}}) : helper)))
	    + "TreeInput\" autocomplete=\"off\" spellcheck=\"false\"\n                      placeholder=\"Вставьте сюда рубрики из списка по одной в строке...\">"
	    + alias4(((helper = (helper = lookupProperty(helpers,"recognizedRubrics") || (depth0 != null ? lookupProperty(depth0,"recognizedRubrics") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"recognizedRubrics","hash":{},"data":data,"loc":{"start":{"line":23,"column":89},"end":{"line":23,"column":110}}}) : helper)))
	    + "</textarea>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div></div><!--Пустой див не убирать, а то кнопки начнуть генерить событие click дважды, какая-то фича catbee-->\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"showFilterTreeInput") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":0},"end":{"line":30,"column":7}}})) != null ? stack1 : "");
	},"useData":true});

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"error") : stack1), depth0))
	    + "\">\n    Не удалось распознать некоторые рубрики:\n</div>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "    <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"success") : stack1), depth0))
	    + "\">\n        Все рубрики отмечены:\n    </div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"haveUnrecognizedRubrics") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":5,"column":7}}})) != null ? stack1 : "")
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"recognizeAllRubrics") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":0},"end":{"line":10,"column":7}}})) != null ? stack1 : "");
	},"useData":true});

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    return "<cat-count-header></cat-count-header>\n";
	},"useData":true});

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "        <cat-rubrics-collapse></cat-rubrics-collapse>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"controlPanel") : stack1), depth0))
	    + "\">\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"info") : stack1), depth0))
	    + "\">\n            Для формирования выборки просто выберите нужные параметры и нажмите кнопку «Получить данные»\n        </div>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"buttonsPanel") : stack1), depth0))
	    + "\">\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"orderButton") : stack1), depth0))
	    + "\">\n                <cat-make-order-button></cat-make-order-button>\n            </div>\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"showReset") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":17,"column":12},"end":{"line":21,"column":19}}})) != null ? stack1 : "")
	    + "        </div>\n    </div>\n";
	},"4":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"tools") : stack1), depth0))
	    + "\">\n                    <button class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"button") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"reset") : stack1), depth0))
	    + "\">Очистить все</button>\n                </div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div>\n    <cat-tooltip></cat-tooltip>\n    <cat-cities-collapse></cat-cities-collapse>\n"
	    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,(depth0 != null ? lookupProperty(depth0,"hideRubrics") : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":4},"end":{"line":6,"column":15}}})) != null ? stack1 : "")
	    + "    <cat-additional-parameters-collapse></cat-additional-parameters-collapse>\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"showOrderButton") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":4},"end":{"line":24,"column":11}}})) != null ? stack1 : "")
	    + "</div>\n";
	},"useData":true});

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "    <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"dataChangedTooltip") : stack1), depth0))
	    + "\">\n        Мы обновили данные, пожалуйста, проверьте заказ.\n    </div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"showDataChangedTooltip") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":5,"column":7}}})) != null ? stack1 : "");
	},"useData":true});

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", alias4=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <tr>\n            <td>"
	    + alias4(((helper = (helper = lookupProperty(helpers,"lowerBound") || (depth0 != null ? lookupProperty(depth0,"lowerBound") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"lowerBound","hash":{},"data":data,"loc":{"start":{"line":15,"column":16},"end":{"line":15,"column":30}}}) : helper)))
	    + "</td>\n            <td>"
	    + alias4(((helper = (helper = lookupProperty(helpers,"percentage") || (depth0 != null ? lookupProperty(depth0,"percentage") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"percentage","hash":{},"data":data,"loc":{"start":{"line":16,"column":16},"end":{"line":16,"column":30}}}) : helper)))
	    + "%</td>\n        </tr>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<table>\n    <thead>\n        <tr>\n            <th>\n                Количество заполненный полей, шт.\n            </th>\n            <th>\n                Процент снижения\n            </th>\n        </tr>\n    </thead>\n    <tbody>\n"
	    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"prices") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":13,"column":8},"end":{"line":18,"column":17}}})) != null ? stack1 : "")
	    + "    </tbody>\n</table>\n";
	},"useData":true});

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <tr>\n            <td>"
	    + alias3(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : alias2),(typeof helper === "function" ? helper.call(alias1,{"name":"name","hash":{},"data":data,"loc":{"start":{"line":15,"column":16},"end":{"line":15,"column":24}}}) : helper)))
	    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,(depth0 != null ? lookupProperty(depth0,"isUseDiscounts") : depth0),{"name":"unless","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":15,"column":24},"end":{"line":15,"column":108}}})) != null ? stack1 : "")
	    + "</td>\n            <td>"
	    + alias3((lookupProperty(helpers,"currencyFormat")||(depth0 && lookupProperty(depth0,"currencyFormat"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"price") : depth0),{"name":"currencyFormat","hash":{},"data":data,"loc":{"start":{"line":16,"column":16},"end":{"line":16,"column":40}}}))
	    + " <span class=\""
	    + alias3(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"rouble")), depth0))
	    + "\">a</span></td>\n        </tr>\n";
	},"2":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<span class=\""
	    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"noDiscounts")), depth0))
	    + "\"></span>";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<table>\n    <thead>\n        <tr>\n            <th>\n                Название поля\n            </th>\n            <th>\n                Цена за экземпляр\n            </th>\n        </tr>\n    </thead>\n    <tbody>\n"
	    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"prices") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":13,"column":8},"end":{"line":18,"column":17}}})) != null ? stack1 : "")
	    + "    </tbody>\n</table>\n";
	},"useData":true});

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<fieldset disabled=\"true\" class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"fieldset") : stack1), depth0))
	    + "\">\n";
	},"3":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"section")), depth0))
	    + "\">\n    <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"label")), depth0))
	    + "\">\n        ИНН\n    </div>\n    <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"field")), depth0))
	    + "\">\n        <cat-text-inn12 id=\"form.inn12\" path=\""
	    + alias2(alias1((depths[1] != null ? lookupProperty(depths[1],"formPath") : depths[1]), depth0))
	    + ".form.inn12\"\n                        error-path=\""
	    + alias2(alias1((depths[1] != null ? lookupProperty(depths[1],"formPath") : depths[1]), depth0))
	    + ".error.inn12\"></cat-text-inn12>\n    </div>\n</div>\n";
	},"5":function(container,depth0,helpers,partials,data) {
	    return "</fieldset>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.lambda, alias3=container.escapeExpression, alias4=container.hooks.helperMissing, alias5="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"disableEditing") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":3,"column":7}}})) != null ? stack1 : "")
	    + "<div class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"section") : stack1), depth0))
	    + "\">\n    <div class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"label") : stack1), depth0))
	    + "\">\n       Адрес<span class=\""
	    + alias3(alias2(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"asterisk")), depth0))
	    + "\">*</span>\n    </div>\n    <div class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"field") : stack1), depth0))
	    + "\">\n        <cat-text-legal-address id=\"form.legalAddress\" path=\""
	    + alias3(((helper = (helper = lookupProperty(helpers,"formPath") || (depth0 != null ? lookupProperty(depth0,"formPath") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias1,{"name":"formPath","hash":{},"data":data,"loc":{"start":{"line":9,"column":61},"end":{"line":9,"column":73}}}) : helper)))
	    + ".form.legalAddress\"\n                                error-path=\""
	    + alias3(((helper = (helper = lookupProperty(helpers,"formPath") || (depth0 != null ? lookupProperty(depth0,"formPath") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias1,{"name":"formPath","hash":{},"data":data,"loc":{"start":{"line":10,"column":44},"end":{"line":10,"column":56}}}) : helper)))
	    + ".error.legalAddress\"></cat-text-legal-address>\n    </div>\n</div>\n"
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias1,(depth0 != null ? lookupProperty(depth0,"userCountryId") : depth0),"===",1,{"name":"compare","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":13,"column":0},"end":{"line":23,"column":12}}})) != null ? stack1 : "")
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"disableEditing") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":24,"column":0},"end":{"line":26,"column":7}}})) != null ? stack1 : "");
	},"useData":true,"useDepths":true});

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "    <fieldset disabled=\"true\" class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"fieldset") : stack1), depth0))
	    + "\">\n";
	},"3":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"section")), depth0))
	    + "\">\n    <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"label")), depth0))
	    + "\">\n        ИНН<span class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"asterisk")), depth0))
	    + "\">*</span>\n    </div>\n    <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"field")), depth0))
	    + "\">\n        <cat-text-inn10 id=\"form.inn10\" path=\""
	    + alias2(alias1((depths[1] != null ? lookupProperty(depths[1],"formPath") : depths[1]), depth0))
	    + ".form.inn10\" error-path=\""
	    + alias2(alias1((depths[1] != null ? lookupProperty(depths[1],"formPath") : depths[1]), depth0))
	    + ".error.inn10\">\n        </cat-text-inn10>\n    </div>\n</div>\n<div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"section")), depth0))
	    + "\">\n    <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"label")), depth0))
	    + "\">\n        КПП<span class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"asterisk")), depth0))
	    + "\">*</span>\n    </div>\n    <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"field")), depth0))
	    + "\">\n        <cat-text-kpp id=\"form.kpp\" path=\""
	    + alias2(alias1((depths[1] != null ? lookupProperty(depths[1],"formPath") : depths[1]), depth0))
	    + ".form.kpp\" error-path=\""
	    + alias2(alias1((depths[1] != null ? lookupProperty(depths[1],"formPath") : depths[1]), depth0))
	    + ".error.kpp\"></cat-text-kpp>\n    </div>\n</div>\n";
	},"5":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"section")), depth0))
	    + "\">\n    <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"label")), depth0))
	    + "\">\n        БИН<span class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"asterisk")), depth0))
	    + "\">*</span>\n    </div>\n    <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"field")), depth0))
	    + "\">\n        <cat-text-bin id=\"form.bin\" path=\""
	    + alias2(alias1((depths[1] != null ? lookupProperty(depths[1],"formPath") : depths[1]), depth0))
	    + ".form.bin\" error-path=\""
	    + alias2(alias1((depths[1] != null ? lookupProperty(depths[1],"formPath") : depths[1]), depth0))
	    + ".error.bin\">\n        </cat-text-bin>\n    </div>\n</div>\n";
	},"7":function(container,depth0,helpers,partials,data) {
	    return "    </fieldset>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.lambda, alias3=container.escapeExpression, alias4=container.hooks.helperMissing, alias5="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"disableEditing") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":3,"column":7}}})) != null ? stack1 : "")
	    + "<div class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"section") : stack1), depth0))
	    + "\">\n    <div class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"label") : stack1), depth0))
	    + " "
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"twoLineLabel") : stack1), depth0))
	    + "\">\n        Наименование организации<span class=\""
	    + alias3(alias2(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"asterisk")), depth0))
	    + "\">*</span>\n    </div>\n    <div class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"field") : stack1), depth0))
	    + "\">\n        <cat-text-org id=\"form.organization\" path=\""
	    + alias3(((helper = (helper = lookupProperty(helpers,"formPath") || (depth0 != null ? lookupProperty(depth0,"formPath") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias1,{"name":"formPath","hash":{},"data":data,"loc":{"start":{"line":9,"column":51},"end":{"line":9,"column":63}}}) : helper)))
	    + ".form.organization\"\n                      error-path=\""
	    + alias3(((helper = (helper = lookupProperty(helpers,"formPath") || (depth0 != null ? lookupProperty(depth0,"formPath") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias1,{"name":"formPath","hash":{},"data":data,"loc":{"start":{"line":10,"column":34},"end":{"line":10,"column":46}}}) : helper)))
	    + ".error.organization\"></cat-text-org>\n    </div>\n</div>\n<div class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"section") : stack1), depth0))
	    + "\">\n    <div class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"label") : stack1), depth0))
	    + "\">\n        Юридический адрес<span class=\""
	    + alias3(alias2(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"asterisk")), depth0))
	    + "\">*</span>\n    </div>\n    <div class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"field") : stack1), depth0))
	    + "\">\n        <cat-text-legal-address id=\"form.legalAddress\" path=\""
	    + alias3(((helper = (helper = lookupProperty(helpers,"formPath") || (depth0 != null ? lookupProperty(depth0,"formPath") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias1,{"name":"formPath","hash":{},"data":data,"loc":{"start":{"line":18,"column":61},"end":{"line":18,"column":73}}}) : helper)))
	    + ".form.legalAddress\"\n                                error-path=\""
	    + alias3(((helper = (helper = lookupProperty(helpers,"formPath") || (depth0 != null ? lookupProperty(depth0,"formPath") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias1,{"name":"formPath","hash":{},"data":data,"loc":{"start":{"line":19,"column":44},"end":{"line":19,"column":56}}}) : helper)))
	    + ".error.legalAddress\"></cat-text-legal-address>\n    </div>\n</div>\n"
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias1,(depth0 != null ? lookupProperty(depth0,"userCountryId") : depth0),"===",1,{"name":"compare","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":22,"column":0},"end":{"line":40,"column":12}}})) != null ? stack1 : "")
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias1,(depth0 != null ? lookupProperty(depth0,"userCountryId") : depth0),"===",4,{"name":"compare","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":41,"column":0},"end":{"line":51,"column":12}}})) != null ? stack1 : "")
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"disableEditing") : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":52,"column":0},"end":{"line":54,"column":7}}})) != null ? stack1 : "");
	},"useData":true,"useDepths":true});

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<fieldset disabled=\"true\" class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"fieldset") : stack1), depth0))
	    + "\">\n";
	},"3":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"section")), depth0))
	    + "\">\n    <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"label")), depth0))
	    + "\">\n        ИНН<span class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"asterisk")), depth0))
	    + "\">*</span>\n    </div>\n    <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"field")), depth0))
	    + "\">\n        <cat-text-inn12 id=\"form.inn12\" path=\""
	    + alias2(alias1((depths[1] != null ? lookupProperty(depths[1],"formPath") : depths[1]), depth0))
	    + ".form.inn12\"\n                        error-path=\""
	    + alias2(alias1((depths[1] != null ? lookupProperty(depths[1],"formPath") : depths[1]), depth0))
	    + ".error.inn12\"></cat-text-inn12>\n    </div>\n</div>\n";
	},"5":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"section")), depth0))
	    + "\">\n            <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"label")), depth0))
	    + "\">\n                БИН<span class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"asterisk")), depth0))
	    + "\">*</span>\n            </div>\n            <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"field")), depth0))
	    + "\">\n                <cat-text-bin id=\"form.bin\" path=\""
	    + alias2(alias1((depths[1] != null ? lookupProperty(depths[1],"formPath") : depths[1]), depth0))
	    + ".form.bin\" error-path=\""
	    + alias2(alias1((depths[1] != null ? lookupProperty(depths[1],"formPath") : depths[1]), depth0))
	    + ".error.bin\">\n                </cat-text-bin>\n            </div>\n        </div>\n";
	},"7":function(container,depth0,helpers,partials,data) {
	    return "</fieldset>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.lambda, alias3=container.escapeExpression, alias4=container.hooks.helperMissing, alias5="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"disableEditing") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":3,"column":7}}})) != null ? stack1 : "")
	    + "<div class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"section") : stack1), depth0))
	    + "\">\n    <div class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"label") : stack1), depth0))
	    + " "
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"twoLineLabel") : stack1), depth0))
	    + "\">\n        Наименование организации<span class=\""
	    + alias3(alias2(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"asterisk")), depth0))
	    + "\">*</span>\n    </div>\n    <div class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"field") : stack1), depth0))
	    + "\">\n        <cat-text-org id=\"form.organization\" path=\""
	    + alias3(((helper = (helper = lookupProperty(helpers,"formPath") || (depth0 != null ? lookupProperty(depth0,"formPath") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias1,{"name":"formPath","hash":{},"data":data,"loc":{"start":{"line":9,"column":51},"end":{"line":9,"column":63}}}) : helper)))
	    + ".form.organization\"\n                      error-path=\""
	    + alias3(((helper = (helper = lookupProperty(helpers,"formPath") || (depth0 != null ? lookupProperty(depth0,"formPath") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias1,{"name":"formPath","hash":{},"data":data,"loc":{"start":{"line":10,"column":34},"end":{"line":10,"column":46}}}) : helper)))
	    + ".error.organization\"></cat-text-org>\n    </div>\n</div>\n<div class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"section") : stack1), depth0))
	    + "\">\n    <div class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"label") : stack1), depth0))
	    + "\">\n        Юридический адрес<span class=\""
	    + alias3(alias2(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"asterisk")), depth0))
	    + "\">*</span>\n    </div>\n    <div class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"field") : stack1), depth0))
	    + "\">\n        <cat-text-legal-address id=\"form.legalAddress\" path=\""
	    + alias3(((helper = (helper = lookupProperty(helpers,"formPath") || (depth0 != null ? lookupProperty(depth0,"formPath") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias1,{"name":"formPath","hash":{},"data":data,"loc":{"start":{"line":18,"column":61},"end":{"line":18,"column":73}}}) : helper)))
	    + ".form.legalAddress\"\n                                error-path=\""
	    + alias3(((helper = (helper = lookupProperty(helpers,"formPath") || (depth0 != null ? lookupProperty(depth0,"formPath") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias1,{"name":"formPath","hash":{},"data":data,"loc":{"start":{"line":19,"column":44},"end":{"line":19,"column":56}}}) : helper)))
	    + ".error.legalAddress\"></cat-text-legal-address>\n    </div>\n</div>\n"
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias1,(depth0 != null ? lookupProperty(depth0,"userCountryId") : depth0),"===",1,{"name":"compare","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":22,"column":0},"end":{"line":32,"column":12}}})) != null ? stack1 : "")
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias1,(depth0 != null ? lookupProperty(depth0,"userCountryId") : depth0),"===",4,{"name":"compare","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":33,"column":0},"end":{"line":43,"column":12}}})) != null ? stack1 : "")
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"disableEditing") : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":44,"column":0},"end":{"line":46,"column":7}}})) != null ? stack1 : "");
	},"useData":true,"useDepths":true});

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "disabled=\"true\"";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div>\n    <button class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"saveButton") : stack1), depth0))
	    + "\" "
	    + ((stack1 = lookupProperty(helpers,"unless").call(alias3,(depth0 != null ? lookupProperty(depth0,"isSaveEnabled") : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":39},"end":{"line":2,"column":90}}})) != null ? stack1 : "")
	    + ">\n        Сохранить\n    </button>\n    <button class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"cancelButton") : stack1), depth0))
	    + "\" "
	    + ((stack1 = lookupProperty(helpers,"unless").call(alias3,(depth0 != null ? lookupProperty(depth0,"isCancelEnabled") : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":41},"end":{"line":5,"column":94}}})) != null ? stack1 : "")
	    + ">\n        Отменить\n    </button>\n</div>\n";
	},"useData":true});

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "    <cat-individual-form></cat-individual-form>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    return "    <cat-legal-entity-form></cat-legal-entity-form>\n";
	},"5":function(container,depth0,helpers,partials,data) {
	    return "    <cat-sole-proprietor-form></cat-sole-proprietor-form>\n";
	},"7":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "    <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"buttonsBlock") : stack1), depth0))
	    + "\">\n        <cat-actions-panel></cat-actions-panel>\n    </div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), alias4=container.hooks.helperMissing, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"title") : stack1), depth0))
	    + "\">\n    Личная информация\n</div>\n<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"individual") : stack1), depth0))
	    + "\">\n    <cat-user-shared-data-form></cat-user-shared-data-form>\n</div>\n\n<div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"title")), depth0))
	    + "\">\n    Данные для документов\n</div>\n<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"description") : stack1), depth0))
	    + "\">\n    Укажите реквизиты компании, которая будет оплачивать счет - сервис сформирует счет на указанную компанию.\n</div>\n\n"
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"userType") : depth0),"===",1,{"name":"compare","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":15,"column":0},"end":{"line":17,"column":12}}})) != null ? stack1 : "")
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"userType") : depth0),"===",2,{"name":"compare","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":18,"column":0},"end":{"line":20,"column":12}}})) != null ? stack1 : "")
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"userType") : depth0),"===",3,{"name":"compare","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":21,"column":0},"end":{"line":23,"column":12}}})) != null ? stack1 : "")
	    + "\n<cat-error></cat-error>\n\n"
	    + ((stack1 = lookupProperty(helpers,"unless").call(alias3,(depth0 != null ? lookupProperty(depth0,"disableEditing") : depth0),{"name":"unless","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":27,"column":0},"end":{"line":31,"column":11}}})) != null ? stack1 : "");
	},"useData":true});

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<fieldset disabled=\"true\" class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"fieldset") : stack1), depth0))
	    + "\">\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    return "</fieldset>\n";
	},"5":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), alias4=container.hooks.helperMissing, alias5="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"section") : stack1), depth0))
	    + "\">\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"label") : stack1), depth0))
	    + "\">\n        Email<span class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"asterisk")), depth0))
	    + "\">*</span>\n    </div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"field") : stack1), depth0))
	    + " \">\n        <fieldset "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"disableEmail") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":67,"column":18},"end":{"line":67,"column":60}}})) != null ? stack1 : "")
	    + " class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"fieldset") : stack1), depth0))
	    + "\">\n            <cat-text-email path=\""
	    + alias2(((helper = (helper = lookupProperty(helpers,"formPath") || (depth0 != null ? lookupProperty(depth0,"formPath") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"formPath","hash":{},"data":data,"loc":{"start":{"line":68,"column":34},"end":{"line":68,"column":46}}}) : helper)))
	    + ".form.email\" error-path=\""
	    + alias2(((helper = (helper = lookupProperty(helpers,"formPath") || (depth0 != null ? lookupProperty(depth0,"formPath") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"formPath","hash":{},"data":data,"loc":{"start":{"line":68,"column":71},"end":{"line":68,"column":83}}}) : helper)))
	    + ".error.email\"></cat-text-email>\n        </fieldset>\n    </div>\n</div>\n";
	},"6":function(container,depth0,helpers,partials,data) {
	    return "disabled=\"true\"";
	},"8":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"section") : stack1), depth0))
	    + "\">\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"label") : stack1), depth0))
	    + "\">\n        Заказчик\n    </div>\n\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"field") : stack1), depth0))
	    + "\">\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"radioButton") : stack1), depth0))
	    + "\">\n            <cat-user-type cat-key=\"1\" name=\"userType\"></cat-user-type>\n            <label>Физическое лицо</label>\n        </div>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"radioButton") : stack1), depth0))
	    + "\">\n            <cat-user-type cat-key=\"2\" name=\"userType\"></cat-user-type>\n            <label>Юридическое лицо</label>\n        </div>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"radioButton") : stack1), depth0))
	    + "\">\n            <cat-user-type cat-key=\"3\" name=\"userType\"></cat-user-type>\n            <label>Индивидуальный предприниматель</label>\n        </div>\n    </div>\n</div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.lambda, alias3=container.escapeExpression, alias4=container.hooks.helperMissing, alias5="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"disableEditing") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":3,"column":7}}})) != null ? stack1 : "")
	    + "<div class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"section") : stack1), depth0))
	    + "\">\n    <div class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"label") : stack1), depth0))
	    + "\">\n        Фамилия<span class=\""
	    + alias3(alias2(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"asterisk")), depth0))
	    + "\">*</span>\n    </div>\n    <div class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"field") : stack1), depth0))
	    + " \">\n        <cat-text-last-name id=\"form.lastName\" path=\""
	    + alias3(((helper = (helper = lookupProperty(helpers,"formPath") || (depth0 != null ? lookupProperty(depth0,"formPath") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias1,{"name":"formPath","hash":{},"data":data,"loc":{"start":{"line":9,"column":53},"end":{"line":9,"column":65}}}) : helper)))
	    + ".form.lastName\"\n                            error-path=\""
	    + alias3(((helper = (helper = lookupProperty(helpers,"formPath") || (depth0 != null ? lookupProperty(depth0,"formPath") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias1,{"name":"formPath","hash":{},"data":data,"loc":{"start":{"line":10,"column":40},"end":{"line":10,"column":52}}}) : helper)))
	    + ".error.lastName\">\n        </cat-text-last-name>\n    </div>\n</div>\n<div class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"section") : stack1), depth0))
	    + "\">\n    <div class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"label") : stack1), depth0))
	    + "\">\n        Имя<span class=\""
	    + alias3(alias2(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"asterisk")), depth0))
	    + "\">*</span>\n    </div>\n    <div class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"field") : stack1), depth0))
	    + " \">\n        <cat-text-first-name id=\"form.firstName\" path=\""
	    + alias3(((helper = (helper = lookupProperty(helpers,"formPath") || (depth0 != null ? lookupProperty(depth0,"formPath") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias1,{"name":"formPath","hash":{},"data":data,"loc":{"start":{"line":19,"column":55},"end":{"line":19,"column":67}}}) : helper)))
	    + ".form.firstName\"\n                             error-path=\""
	    + alias3(((helper = (helper = lookupProperty(helpers,"formPath") || (depth0 != null ? lookupProperty(depth0,"formPath") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias1,{"name":"formPath","hash":{},"data":data,"loc":{"start":{"line":20,"column":41},"end":{"line":20,"column":53}}}) : helper)))
	    + ".error.firstName\">\n        </cat-text-first-name>\n    </div>\n</div>\n<div class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"section") : stack1), depth0))
	    + "\">\n    <div class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"label") : stack1), depth0))
	    + "\">\n        <span>Отчество</span>\n    </div>\n    <div class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"field") : stack1), depth0))
	    + " \">\n        <cat-text-middle-name id=\"form.middleName\" path=\""
	    + alias3(((helper = (helper = lookupProperty(helpers,"formPath") || (depth0 != null ? lookupProperty(depth0,"formPath") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias1,{"name":"formPath","hash":{},"data":data,"loc":{"start":{"line":29,"column":57},"end":{"line":29,"column":69}}}) : helper)))
	    + ".form.middleName\"></cat-text-middle-name>\n    </div>\n</div>\n<div class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"section") : stack1), depth0))
	    + "\">\n    <div class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"label") : stack1), depth0))
	    + "\">\n        <span>Телефон</span>\n    </div>\n    <div class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"field") : stack1), depth0))
	    + "\">\n        <cat-text-phone id=\"form.phone\" path=\""
	    + alias3(((helper = (helper = lookupProperty(helpers,"formPath") || (depth0 != null ? lookupProperty(depth0,"formPath") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias1,{"name":"formPath","hash":{},"data":data,"loc":{"start":{"line":37,"column":46},"end":{"line":37,"column":58}}}) : helper)))
	    + ".form.phone\" error-path=\""
	    + alias3(((helper = (helper = lookupProperty(helpers,"formPath") || (depth0 != null ? lookupProperty(depth0,"formPath") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias1,{"name":"formPath","hash":{},"data":data,"loc":{"start":{"line":37,"column":83},"end":{"line":37,"column":95}}}) : helper)))
	    + ".error.phone\">\n        </cat-text-phone>\n    </div>\n</div>\n    <div class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"section") : stack1), depth0))
	    + "\">\n        <div class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"label") : stack1), depth0))
	    + "\">\n            Страна<span class=\""
	    + alias3(alias2(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"asterisk")), depth0))
	    + "\">*</span>\n        </div>\n        <div class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"field") : stack1), depth0))
	    + "\">\n            <cat-country-dropdown cat-name=\"registrationCountryDropdown\"></cat-country-dropdown>\n        </div>\n    </div>\n<div class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"section") : stack1), depth0))
	    + "\">\n    <div class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"label") : stack1), depth0))
	    + "\">\n        <span>Город</span>\n    </div>\n    <div class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"field") : stack1), depth0))
	    + "\">\n        <cat-text-city id=\"form.city\" path=\""
	    + alias3(((helper = (helper = lookupProperty(helpers,"formPath") || (depth0 != null ? lookupProperty(depth0,"formPath") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias1,{"name":"formPath","hash":{},"data":data,"loc":{"start":{"line":54,"column":44},"end":{"line":54,"column":56}}}) : helper)))
	    + ".form.city\" error-path=\""
	    + alias3(((helper = (helper = lookupProperty(helpers,"formPath") || (depth0 != null ? lookupProperty(depth0,"formPath") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias1,{"name":"formPath","hash":{},"data":data,"loc":{"start":{"line":54,"column":80},"end":{"line":54,"column":92}}}) : helper)))
	    + ".error.city\">\n        </cat-text-city>\n    </div>\n</div>\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"disableEditing") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":58,"column":0},"end":{"line":60,"column":7}}})) != null ? stack1 : "")
	    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,(depth0 != null ? lookupProperty(depth0,"hideEmail") : depth0),{"name":"unless","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":61,"column":0},"end":{"line":72,"column":11}}})) != null ? stack1 : "")
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"disableEditing") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":73,"column":0},"end":{"line":75,"column":7}}})) != null ? stack1 : "")
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"isUserTypeSelectEnabled") : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":76,"column":0},"end":{"line":97,"column":7}}})) != null ? stack1 : "")
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"disableEditing") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":98,"column":0},"end":{"line":100,"column":7}}})) != null ? stack1 : "");
	},"useData":true});

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"content") : stack1), depth0))
	    + "\">\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"listItem") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"mail") : stack1), depth0))
	    + "\">\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"listTitle") : stack1), depth0))
	    + "\">\n            <a target=\"_top\" href=\"mailto:content.data@2gis.com\">content.data@2gis.com</a>\n        </div>\n    </div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"listItem") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"phone") : stack1), depth0))
	    + "\">\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"phoneText") : stack1), depth0))
	    + "\">звоните</div>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"phoneNumber") : stack1), depth0))
	    + "\">8 (800) 775-1230</div>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"phoneText") : stack1), depth0))
	    + "\">пишите WhatsApp, Telegram</div>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"phoneNumber") : stack1), depth0))
	    + "\">8 (966) 500-0050</div>\n    </div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"listItem") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"address") : stack1), depth0))
	    + "\">\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"addressText") : stack1), depth0))
	    + "\">\n            г. Новосибирск, Карла Маркса площадь, 7 (МФК «Сан Сити»),<br>\n            13 этаж (<a target=\"_blank\" href=\"http://go.2gis.com/vdik1\">показать в справочнике</a>)\n        </div>\n    </div>\n\n    <div id=\"map\" class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"map") : stack1), depth0))
	    + "\"></div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"text") : stack1), depth0))
	    + "\">\n        Data.2gis — один из Сервисов 2ГИС, который предоставляет доступ к официальным данным 2ГИС.\n    </div>\n</div>\n";
	},"useData":true});

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"container") : stack1), depth0))
	    + "\">\n  <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"state") : stack1), depth0))
	    + "\"></div>\n</div>\n";
	},"useData":true});

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                <li>базовые поля:\n                    <ul>\n"
	    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"basicColumns") : depth0),{"name":"each","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":123,"column":20},"end":{"line":125,"column":29}}})) != null ? stack1 : "")
	    + "                    </ul>\n                </li>\n";
	},"2":function(container,depth0,helpers,partials,data) {
	    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                        <li>"
	    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":124,"column":28},"end":{"line":124,"column":36}}}) : helper)))
	    + "</li>\n";
	},"4":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                <li>дополнительные поля по Вашему выбору:\n                    <ul>\n"
	    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"optionalColumns") : depth0),{"name":"each","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":132,"column":24},"end":{"line":134,"column":33}}})) != null ? stack1 : "")
	    + "                    </ul>\n                </li>\n";
	},"5":function(container,depth0,helpers,partials,data) {
	    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                            <li>"
	    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":133,"column":32},"end":{"line":133,"column":40}}}) : helper)))
	    + "</li>\n";
	},"7":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "	<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"collapser") : stack1), depth0))
	    + "\">\n        <span class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"collapserHead") : stack1), depth0))
	    + "\">Что значит \"Этот email зарегистрирован в одном из продуктов 2GIS\"?</span>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"collapserText") : stack1), depth0))
	    + "\">\n            <p>Это значит, что Вы уже регистрировались на сайте\n                <a class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"link") : stack1), depth0))
	    + "\" target=\"_blank\" href=\"http://info.2gis.ru/\" rel=\"nofollow\">2ГИС</a> или в\n                <a class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"link") : stack1), depth0))
	    + "\" target=\"_blank\" href=\"http://account.2gis.ru/\" rel=\"nofollow\">Личном кабинете для компаний</a>.\n            </p>\n            <p>Чтобы войти на сайт, воспользуйтесь учетными данными, используемыми в этих сервисах.\n"
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"role") : depth0),"===","unauthorized",{"name":"compare","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":174,"column":16},"end":{"line":177,"column":28}}})) != null ? stack1 : "")
	    + "            </p>\n        </div>\n    </div>\n";
	},"8":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                    Если вы забыли пароль, пожалуйста, нажмите кнопку\n                    <a cat-url=\"/restorePassword\" class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"link")), depth0))
	    + " "
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"redirect")), depth0))
	    + "\">забыли пароль</a>.\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), alias4=container.hooks.helperMissing, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"content") : stack1), depth0))
	    + "\">\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"title") : stack1), depth0))
	    + "\">Вопросы и ответы</div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"collapser") : stack1), depth0))
	    + "\">\n        <span class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"collapserHead") : stack1), depth0))
	    + "\">Как сделать заказ?</span>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"collapserText") : stack1), depth0))
	    + "\">\n            <ol>\n                <li>\n                    <p>Выберите <strong>параметры выборки</strong>:</p>\n                    <ol class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"secondLevelList") : stack1), depth0))
	    + "\">\n                        <li><p>с помощью <strong>фильтра \"Города\"</strong> отметьте населенные пункты, в которых\n                            находятся интересующие Вас компании, например, Москва.</p>\n                        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"clarification") : stack1), depth0))
	    + "\">\n                            В выпадающем списке на первом уровне отображаются субъекты РФ, на втором населенные пункты\n                            этих субъектов. Если Вы желаете приобрести данные всех предприятий Московской области,\n                            отметьте соответствующее значение на 1 уровне.\n                            <p>Обратите внимание, города федерального значения, как самостоятельные субъекты отображаются\n                            на первом уровне.</p>\n                        </div>\n                        </li>\n                        <li><p>в <strong>фильтре \"Рубрики\"</strong> выберите сферы деятельности фирм, например, Кафе.</p>\n                            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"clarification") : stack1), depth0))
	    + "\">\n                            Рубрикатор трехуровневый, если Вас интересует вся сфера \"Досуг / Развлечения / Общественное питание\",\n                                Вы можете выбрать соответствующую рубрику 1 уровня, если хочется уточнить запрос, то\n                                можно выбрать сферу деятельности \"Кафе\".\n                                <p>Количество организаций (строк) и стоимость подсчитывается динамически, как только Вы\n                                выбрали города и рубрики.</p>\n                            </div>\n                        </li>\n                        <li>\n                            <p>с помощью \"<strong>Параметров выборки</strong>\" вы можете настроить какие данные\n                                Вас интересуют:</p>\n                            <ol class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"thirdLevelList") : stack1), depth0))
	    + "\">\n                                <li>в первой колонке выберите какие данные выгружать,</li>\n                                <li>во второй колонке отфильтруйте строки (например, только те строчки, где телефоны\n                                    есть - в этом случае организации без телефонов в выборку не попадут).</li>\n                            </ol>\n                        </li>\n                    </ol>\n                </li>\n                <li>После выбора параметров, нажмите кнопку \"<strong>Оформить заказ</strong>\".</li>\n                <li>\n                    Для оформления заказа укажите:\n                    <ol class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"secondLevelList") : stack1), depth0))
	    + "\">\n                        <li>\n                            <strong>способ оплаты</strong>. На нашем сайте вы можете оплатить выборку:\n                            <ol class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"thirdLevelList") : stack1), depth0))
	    + "\">\n                                <li>\n                                    <p><strong>онлайн</strong>: банковской картой, электронными деньгами, наличными,\n                                    в личном кабинете банка, списать деньги с баланса телефона или оплатить в кредит\n                                    с помощью платежного терминала Яндекса.</p>\n                                    <p class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"clarification") : stack1), depth0))
	    + "\">\n                                        Все доступные способы оплаты можно посмотреть\n                                        <a href=\"https://kassa.yandex.ru/payments\" class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"link") : stack1), depth0))
	    + "\" rel=\"nofollow\">здесь</a>.\n                                        Нельзя выбрать этот способ оплаты для заказа стоимостью более\n                                        "
	    + alias2((lookupProperty(helpers,"intFormat")||(depth0 && lookupProperty(depth0,"intFormat"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"onlinePaymentPriceLimit") : depth0),{"name":"intFormat","hash":{},"data":data,"loc":{"start":{"line":55,"column":40},"end":{"line":55,"column":77}}}))
	    + " Р, из-за ограничений законодательства.\n                                    </p>\n                                </li>\n                                <li>или мы выставим Вам <strong>счет-оферту</strong>, который можно будет\n                                    оплатить в любом банке.</li>\n                            </ol>\n                        </li>\n                        <li>если вам нужны дополнительные <strong>документы</strong>, отметьте их в списке и мы\n                            прикрепим нужные документы к Вашему заказу.</li>\n                    </ol>\n                </li>\n                <li>Если Вы выбрали<strong> онлайн оплату</strong>, то Вам откроется страница Яндекса, подробно\n                    прочитать как оплатить заказ с помощью платежного терминала можно\n                    <a href=\"https://kassa.yandex.ru/payments\" class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"link") : stack1), depth0))
	    + "\" rel=\"nofollow\">здесь</a>.\n                    Ваша выборка будет доступна Вам на странице \"Заказы\" сразу* после оплаты.</li>\n                <li>Если Вы выбрали <strong>оплату по счету</strong>, в течении рабочих суток мы прикрепим к Вашему\n                    заказу счет, который Вы сможете оплатить в любом банке. Так же, после оплаты, выборка будет доступна\n                    Вам в течении рабочих суток после оплаты на странице \"Заказы\".<br>\n                    <span class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"note") : stack1), depth0))
	    + "\"><em>*в редких ситуациях файл может быть не готов сразу, в любом случае\n                        мы гарантируем Вам получение файла в течении 10 дней</em></span></li>\n            </ol>\n        </div>\n    </div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"collapser") : stack1), depth0))
	    + "\">\n        <span class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"collapserHead") : stack1), depth0))
	    + "\">Почему я не могу выбрать онлайн оплату?</span>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"collapserText") : stack1), depth0))
	    + "\">\n            <p>Согласно закону онлайн-оплата с помощью банковских карт не может превышать\n                "
	    + alias2((lookupProperty(helpers,"intFormat")||(depth0 && lookupProperty(depth0,"intFormat"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"onlinePaymentPriceLimit") : depth0),{"name":"intFormat","hash":{},"data":data,"loc":{"start":{"line":82,"column":16},"end":{"line":82,"column":53}}}))
	    + " Р.</p>\n            <p>Пожалуйста, выберите способ оплаты \"счет\".</p>\n        </div>\n    </div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"collapser") : stack1), depth0))
	    + "\">\n        <span class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"collapserHead") : stack1), depth0))
	    + "\">Сколько стоит выборка?</span>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"collapserText") : stack1), depth0))
	    + "\">\n            <p>Вы платите только за заполненные дополнительные поля</p>\n            <p><em>т.е. если в Вашей выборке 1000 базовых строк и 800 телефонов, Вы заплатите: 1000 * стоимость\n                базового поля + 800 * стоимость телефона</em></p>\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"cost") : stack1), depth0))
	    + "\">\n                <p>\n                    <cat-prices></cat-prices>\n                    <em>*&nbsp;к полю не применяется снижение цены за объем заказа</em>\n                </p>\n                <p>Цена выборки зависит от количества строк, чем их больше, тем цена ниже.\n                    Скидка применятся к полям независимо.</p>\n                <p><cat-discounts></cat-discounts></p>\n                <p><strong>Формула расчета:</strong></p>\n                <p>кол-во базовых строк * цена базовой строки - процент снижения за объем + сумма (кол-во заполненных\n                    дополнительных полей * цена доп. поля - процент снижения за объем(если применим))</p>\n            </div>\n        </div>\n    </div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"collapser") : stack1), depth0))
	    + "\">\n        <span class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"collapserHead") : stack1), depth0))
	    + "\">Что значит \"данные были обновлены\"?</span>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"collapserText") : stack1), depth0))
	    + "\">\n            <p>Это значит, что после того, как вы начали формировать заказ мы обновили данные. Возможно, поменялось\n                количество организаций, подходящих под Ваши параметры, или изменились сами параметры, например,\n                добавилась рубрика.</p>\n            <p>Пожалуйста, проверьте Ваш заказ.</p>\n        </div>\n    </div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"collapser") : stack1), depth0))
	    + "\">\n        <span class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"collapserHead") : stack1), depth0))
	    + "\">Что входит в выборку?</span>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"collapserText") : stack1), depth0))
	    + "\">\n            <p>В выборку (.csv файл) входят:</p>\n            <ul>\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"basicColumns") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":120,"column":16},"end":{"line":128,"column":23}}})) != null ? stack1 : "")
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"optionalColumns") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":129,"column":16},"end":{"line":137,"column":23}}})) != null ? stack1 : "")
	    + "            </ul>\n            <p>Если у компании несколько контактов, например, факультеты университетов, в выборке будет одна\n                строчка с указанием всех контактов.</p>\n            <p>Отдельные филиалы организаций, например, отделения банков, будут в разных строках.</p>\n			<a download type=\"text/csv\" href=\"/static/document/data2gis_example.xlsx\"\n               target=\"_blank\" class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"sampleDownloadButton") : stack1), depth0))
	    + "\">Скачать пример</a>\n            <p>Если Вас интересует более подробная выборка, например, средний чек, количество филиалов или другие\n                параметры, <a cat-url=\"/contacts\" class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"link") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"redirect") : stack1), depth0))
	    + "\" rel=\"nofollow\">свяжитесь</a> с нашими менеджерами.\n            </p>\n        </div>\n    </div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"collapser") : stack1), depth0))
	    + "\">\n        <span class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"collapserHead") : stack1), depth0))
	    + "\">Где мы берем данные?</span>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"collapserText") : stack1), depth0))
	    + "\">\n            <p>Библиотека данных - один из продуктов компании\n                <a class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"link") : stack1), depth0))
	    + "\" target=\"_blank\" href=\"http://info.2gis.ru/\" rel=\"nofollow\">2ГИС</a>\n                и использует данные 2ГИС.\n            </p>\n        </div>\n    </div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"collapser") : stack1), depth0))
	    + "\">\n        <span class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"collapserHead") : stack1), depth0))
	    + "\">Как часто обновляются данные?</span>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"collapserText") : stack1), depth0))
	    + "\">\n            <p>Данные на сайте обновляются раз в сутки, ежедневно тысячи сотрудников 2ГИС обеспечивают полноту, точность\n                и актуальность предоставляемой информации, каждая компания выверяется как минимум 2 раза в год.</p>\n        </div>\n    </div>\n"
	    + ((stack1 = lookupProperty(helpers,"unless").call(alias3,(depth0 != null ? lookupProperty(depth0,"isBitrix") : depth0),{"name":"unless","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":165,"column":4},"end":{"line":181,"column":15}}})) != null ? stack1 : "")
	    + "</div>\n";
	},"useData":true});

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", alias4=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <cat-"
	    + alias4(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"name","hash":{},"data":data,"loc":{"start":{"line":4,"column":13},"end":{"line":4,"column":21}}}) : helper)))
	    + " id=\""
	    + alias4(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":4,"column":26},"end":{"line":4,"column":32}}}) : helper)))
	    + "\"\n            "
	    + ((stack1 = lookupProperty(helpers,"each").call(alias1,(depth0 != null ? lookupProperty(depth0,"attributes") : depth0),{"name":"each","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":12},"end":{"line":5,"column":63}}})) != null ? stack1 : "")
	    + ">\n            </cat-"
	    + alias4(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"name","hash":{},"data":data,"loc":{"start":{"line":6,"column":18},"end":{"line":6,"column":26}}}) : helper)))
	    + ">\n";
	},"2":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", alias4=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return " "
	    + alias4(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"name","hash":{},"data":data,"loc":{"start":{"line":5,"column":33},"end":{"line":5,"column":41}}}) : helper)))
	    + "=\""
	    + alias4(((helper = (helper = lookupProperty(helpers,"value") || (depth0 != null ? lookupProperty(depth0,"value") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"value","hash":{},"data":data,"loc":{"start":{"line":5,"column":43},"end":{"line":5,"column":52}}}) : helper)))
	    + "\" ";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<cat-overlay></cat-overlay>\n<div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"block") : stack1), depth0))
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"components") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":7,"column":13}}})) != null ? stack1 : "")
	    + "</div>\n";
	},"useData":true});

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "        <cat-devtools id=\"devtools\"></cat-devtools>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <script>\n            var ENV = "
	    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"ENV") || (depth0 != null ? lookupProperty(depth0,"ENV") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ENV","hash":{},"data":data,"loc":{"start":{"line":16,"column":22},"end":{"line":16,"column":31}}}) : helper))) != null ? stack1 : "")
	    + ";\n        </script>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<!DOCTYPE html>\n<html id=\"hermes_body\">\n<head>\n    <meta name=\"google-site-verification\" content=\"wgsXZSPJ43_BilgDAXs1hhniB--4cwFS4rWRK7Z07Zs\" />\n</head>\n<body>\n    <script src=\"https://maps.api.2gis.ru/2.0/loader.js?pkg=full\"></script>\n    <cat-layout id=\"layout\" class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"layout") : stack1), depth0))
	    + "\"></cat-layout>\n\n"
	    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,(depth0 != null ? lookupProperty(depth0,"isRelease") : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":10,"column":4},"end":{"line":12,"column":15}}})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"ENV") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":4},"end":{"line":18,"column":11}}})) != null ? stack1 : "")
	    + "\n    <script src=\"/public/bundle.js\"></script>\n\n    <!-- Jivo Live Chat -->\n    <script src=\"//code.jivo.ru/widget/FdVw9XPMTL\" async></script>\n    <!-- /Jivo Live Chat -->\n</body>\n</html>\n";
	},"useData":true});

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"head") : stack1), depth0))
	    + "\">\n        <a cat-url=\"/\" class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"logo") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"redirect") : stack1), depth0))
	    + "\"></a>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"titleWrapper") : stack1), depth0))
	    + "\">\n        <a cat-url=\"/\" class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"title") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"redirect") : stack1), depth0))
	    + "\">\n            <span class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"titleText") : stack1), depth0))
	    + "\">Контент</span>\n        </a>\n        </div>\n    </div>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"error") : stack1), depth0))
	    + "\">\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"image") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"_403") : stack1), depth0))
	    + "\"></div>\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"errorTitle") : stack1), depth0))
	    + "\">\n                Доступ запрещен\n            </div>\n        <span class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"errorDescription") : stack1), depth0))
	    + "\">\n            Доступ к этому разделу ограничен\n           <br><br>\n           Напишите в\n            <a class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"link") : stack1), depth0))
	    + "\" target=\"_top\" href=\"mailto:support.data@2gis.com\">техподдержку</a>,\n            если доступ был закрыт по ошибке.\n        </span>\n        </div>\n";
	},"5":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"error") : stack1), depth0))
	    + "\">\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"image") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"_404") : stack1), depth0))
	    + "\"></div>\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"errorTitle") : stack1), depth0))
	    + "\">\n                Нет такой страницы\n            </div>\n        <span class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"errorDescription") : stack1), depth0))
	    + "\">\n            Быть может её и вовсе не существовало. Начните с\n            <a class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"link") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"redirect") : stack1), depth0))
	    + "\" cat-url=\"/\">\n                главной страницы\n            </a>.<br>\n            Если вы перешли сюда по нашей ссылке, сообщите об этом в\n            <a class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"link") : stack1), depth0))
	    + "\" target=\"_top\" href=\"mailto:support.data@2gis.com\">\n                службу поддержки\n            </a>.\n        </span>\n\n        </div>\n";
	},"7":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"error") : stack1), depth0))
	    + "\">\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"image") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"_500") : stack1), depth0))
	    + "\"></div>\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"errorTitle") : stack1), depth0))
	    + "\">\n                Что-то пошло не так,<br>\n                но мы уже чиним\n            </div>\n        <span class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"errorDescription") : stack1), depth0))
	    + "\">\n            Если вам только спросить — напишите нашим\n            <a target=\"_top\" class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"link") : stack1), depth0))
	    + "\" href=\"mailto:content.data@2gis.com\">\n                менеджерам\n            </a>\n            <div>\n                Или попробуйте\n                <a class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"link") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"redirect") : stack1), depth0))
	    + "\" cat-url='' onclick='location.reload(true); return false;'>\n                    обновить страницу\n                </a>\n            </div>\n        </span>\n        </div>\n";
	},"9":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"error") : stack1), depth0))
	    + "\">\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"image") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"_503") : stack1), depth0))
	    + "\"></div>\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"errorTitle") : stack1), depth0))
	    + "\">\n                Технические работы\n            </div>\n        <span class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"errorDescription") : stack1), depth0))
	    + "\">\n            Мы делаем наш сайт еще удобней для Вас.<br>\n            Возвращайтесь чуть позже — скоро все заработает.<br>\n            Если вам только спросить — напишите нашим\n            <a class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"link") : stack1), depth0))
	    + "\" target=\"_top\" href=\"mailto:content.data@2gis.com\">\n                менеджерам\n            </a>\n        </span>\n        </div>\n";
	},"11":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"error") : stack1), depth0))
	    + "\">\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"image") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"_500") : stack1), depth0))
	    + "\"></div>\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"errorTitle") : stack1), depth0))
	    + "\">\n                Что-то пошло не так,<br>\n                но мы уже чиним\n            </div>\n            <span class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"errorDescription") : stack1), depth0))
	    + "\">\n            Что-то пошло не так. Попробуйте перейти по ссылке ещё раз или отправьте новое письмо с подтверждением.\n            </span>\n        </div>\n";
	},"13":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"error") : stack1), depth0))
	    + "\">\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"image") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"_500") : stack1), depth0))
	    + "\"></div>\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"errorTitle") : stack1), depth0))
	    + "\">\n                Ваш Битрикс24 недоступен,<br>\n                работа приложения невозможна.\n            </div>\n            <span class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"errorDescription") : stack1), depth0))
	    + "\">\n                Для работы приложения необходимо обеспечить внешний доступ<br>\n                к REST-API вашего Битрикс24, обратитесь к вашему администратору.\n            </span>\n        </div>\n";
	},"15":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"error") : stack1), depth0))
	    + "\">\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"image") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"_500") : stack1), depth0))
	    + "\"></div>\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"errorTitle") : stack1), depth0))
	    + "\">\n                Сертификат вашего Битрикс24 недействителен,<br>\n                работа приложения невозможна.\n            </div>\n            <span class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"errorDescription") : stack1), depth0))
	    + "\">\n                Необходимо заменить сертификат вашего Битрикс24 на действительный,<br>\n                обратитесь к вашему администратору.\n            </span>\n        </div>\n";
	},"17":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"error") : stack1), depth0))
	    + "\">\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"image") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"_500") : stack1), depth0))
	    + "\"></div>\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"errorTitle") : stack1), depth0))
	    + "\">\n                В настройках вашего браузера запрещена работа с cookie,<br>\n                работа с сайтом невозможна.\n            </div>\n            <span class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"errorDescription") : stack1), depth0))
	    + "\">\n                В настройках вашего браузера разрешите сайтам сохранять и изменять cookie"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isBitrix") : depth0),{"name":"if","hash":{},"fn":container.program(18, data, 0),"inverse":container.program(20, data, 0),"data":data,"loc":{"start":{"line":137,"column":89},"end":{"line":137,"column":122}}})) != null ? stack1 : "")
	    + "\n                "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isBitrix") : depth0),{"name":"if","hash":{},"fn":container.program(22, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":138,"column":16},"end":{"line":138,"column":131}}})) != null ? stack1 : "")
	    + "\n            </span>\n        </div>\n";
	},"18":function(container,depth0,helpers,partials,data) {
	    return ",";
	},"20":function(container,depth0,helpers,partials,data) {
	    return ".";
	},"22":function(container,depth0,helpers,partials,data) {
	    return "<br>а также уберить запрет сторонним сайтам сохранять и просматривать cookie, если он задан.";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"errorPage") : stack1), depth0))
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"isErrorPage") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":11,"column":11}}})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"accessDenied") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":13,"column":4},"end":{"line":27,"column":11}}})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"notFound") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":29,"column":4},"end":{"line":47,"column":11}}})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"internalError") : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":49,"column":4},"end":{"line":69,"column":11}}})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"serviceUnavailable") : depth0),{"name":"if","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":71,"column":4},"end":{"line":86,"column":11}}})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"passportError") : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":88,"column":4},"end":{"line":99,"column":11}}})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"unavailableError") : depth0),{"name":"if","hash":{},"fn":container.program(13, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":101,"column":4},"end":{"line":113,"column":11}}})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"certificateError") : depth0),{"name":"if","hash":{},"fn":container.program(15, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":115,"column":4},"end":{"line":127,"column":11}}})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"cookieDisabled") : depth0),{"name":"if","hash":{},"fn":container.program(17, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":129,"column":4},"end":{"line":141,"column":11}}})) != null ? stack1 : "")
	    + "</div>\n";
	},"useData":true});

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"row") : stack1), depth0))
	    + "\">\n                    <a cat-url=\""
	    + alias2((lookupProperty(helpers,"patchQuery")||(depth0 && lookupProperty(depth0,"patchQuery"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"/video",(depth0 != null ? lookupProperty(depth0,"utm") : depth0),{"name":"patchQuery","hash":{},"data":data,"loc":{"start":{"line":13,"column":32},"end":{"line":13,"column":59}}}))
	    + "\" class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"link") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"redirect") : stack1), depth0))
	    + "\" target=\"_self\">Видеоуроки</a>\n                </div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), alias4=container.hooks.helperMissing, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"wrapper") : stack1), depth0))
	    + "\">\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"content") : stack1), depth0))
	    + "\">\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"block") : stack1), depth0))
	    + "\">\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"column") : stack1), depth0))
	    + "\">\n                <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"row") : stack1), depth0))
	    + "\">\n                    <a cat-url=\""
	    + alias2((lookupProperty(helpers,"patchQuery")||(depth0 && lookupProperty(depth0,"patchQuery"))||alias4).call(alias3,"/help",(depth0 != null ? lookupProperty(depth0,"utm") : depth0),{"name":"patchQuery","hash":{},"data":data,"loc":{"start":{"line":6,"column":32},"end":{"line":6,"column":58}}}))
	    + "\" class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"link") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"redirect") : stack1), depth0))
	    + "\">FAQ</a>\n                </div>\n                <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"row") : stack1), depth0))
	    + "\">\n                    <a cat-url=\""
	    + alias2((lookupProperty(helpers,"patchQuery")||(depth0 && lookupProperty(depth0,"patchQuery"))||alias4).call(alias3,"/contacts",(depth0 != null ? lookupProperty(depth0,"utm") : depth0),{"name":"patchQuery","hash":{},"data":data,"loc":{"start":{"line":9,"column":32},"end":{"line":9,"column":62}}}))
	    + "\" class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"link") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"redirect") : stack1), depth0))
	    + "\" target=\"_self\">О нас</a>\n                </div>\n"
	    + ((stack1 = lookupProperty(helpers,"unless").call(alias3,(depth0 != null ? lookupProperty(depth0,"isBitrix") : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":11,"column":16},"end":{"line":15,"column":27}}})) != null ? stack1 : "")
	    + "            </div>\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"column") : stack1), depth0))
	    + "\">\n                <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"row") : stack1), depth0))
	    + "\">\n                    <a href=\"http://law.2gis.ru/rules\" class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"link") : stack1), depth0))
	    + "\" target=\"_blank\">Соглашение об использовании</a>\n                </div>\n                <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"row") : stack1), depth0))
	    + "\">\n                    <a href=\"http://law.2gis.ru/privacy\" class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"link") : stack1), depth0))
	    + "\" target=\"_blank\">Политика конфиденциальности</a>\n                </div>\n                <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"row") : stack1), depth0))
	    + "\">\n                    <a cat-url=\"/terms\" class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"link") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"redirect") : stack1), depth0))
	    + "\">Правила сервиса</a>\n                </div>\n            </div>\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"column") : stack1), depth0))
	    + "\">\n                <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"row") : stack1), depth0))
	    + "\">\n                    <a href=\"https://dev.2gis.ru/vectormaps/?utm_source=redirect_data_2gis_com\" class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"link") : stack1), depth0))
	    + "\" target=\"_blank\">Векторные карты</a>\n                </div>\n                <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"row") : stack1), depth0))
	    + "\">\n                    <a href=\"https://dev.2gis.ru/pro/?utm_source=redirect_data_2gis_com\" class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"link") : stack1), depth0))
	    + "\" target=\"_blank\">2ГИС Про</a>\n                </div>\n                <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"row") : stack1), depth0))
	    + "\">\n                    <a href=\"https://dev.2gis.ru/api/?utm_source=redirect_data_2gis_com\" class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"link") : stack1), depth0))
	    + "\" target=\"_blank\">API и SDK</a>\n                </div>\n                <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"row") : stack1), depth0))
	    + "\">\n                    <a href=\"https://dev.2gis.ru/telemarketing?utm_source=redirect_data_2gis_com\" class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"link") : stack1), depth0))
	    + "\" target=\"_blank\">Телемаркетинг</a>\n                </div>\n                <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"row") : stack1), depth0))
	    + "\">\n                    <a href=\"https://dev.2gis.ru/#form/?utm_source=redirect_data_2gis_com\" class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"link") : stack1), depth0))
	    + "\" target=\"_blank\">Нужны иные виды данных?</a>\n                </div>\n            </div>\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"copyRight") : stack1), depth0))
	    + "\">\n                © "
	    + alias2(((helper = (helper = lookupProperty(helpers,"year") || (depth0 != null ? lookupProperty(depth0,"year") : depth0)) != null ? helper : alias4),(typeof helper === "function" ? helper.call(alias3,{"name":"year","hash":{},"data":data,"loc":{"start":{"line":46,"column":18},"end":{"line":46,"column":26}}}) : helper)))
	    + ", 2ГИС\n            </div>\n        </div>\n    </div>\n</div>\n\n";
	},"useData":true});

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", alias4=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<meta charset=\"utf-8\"/>\n<meta http-equiv=\"X-UA-Compatible\" content=\"IE=edge\">\n<title>"
	    + alias4(((helper = (helper = lookupProperty(helpers,"title") || (depth0 != null ? lookupProperty(depth0,"title") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"title","hash":{},"data":data,"loc":{"start":{"line":3,"column":7},"end":{"line":3,"column":16}}}) : helper)))
	    + "</title>\n<meta name=\"description\" content=\""
	    + alias4(((helper = (helper = lookupProperty(helpers,"description") || (depth0 != null ? lookupProperty(depth0,"description") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"description","hash":{},"data":data,"loc":{"start":{"line":4,"column":34},"end":{"line":4,"column":49}}}) : helper)))
	    + "\">\n<link rel=\"stylesheet\" href=\"/public/bundle.css\" />\n";
	},"useData":true});

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression((lookupProperty(helpers,"patchQuery")||(depth0 && lookupProperty(depth0,"patchQuery"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"/bitrix",((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"utm")),{"name":"patchQuery","hash":{},"data":data,"loc":{"start":{"line":3,"column":34},"end":{"line":3,"column":68}}}));
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression((lookupProperty(helpers,"patchQuery")||(depth0 && lookupProperty(depth0,"patchQuery"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"/",((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"utm")),{"name":"patchQuery","hash":{},"data":data,"loc":{"start":{"line":3,"column":76},"end":{"line":3,"column":104}}}));
	},"5":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"menuSmall") : stack1), depth0));
	},"7":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"isActive")), depth0));
	},"9":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), alias4=container.hooks.helperMissing, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"link")), depth0))
	    + " "
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"redirect")), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isActive") : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":11,"column":66},"end":{"line":11,"column":111}}})) != null ? stack1 : "")
	    + "\"\n                 cat-url=\""
	    + alias2((lookupProperty(helpers,"patchQuery")||(depth0 && lookupProperty(depth0,"patchQuery"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"href") : depth0),((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"utm")),{"name":"patchQuery","hash":{},"data":data,"loc":{"start":{"line":12,"column":26},"end":{"line":12,"column":55}}}))
	    + "\">\n                "
	    + alias2(((helper = (helper = lookupProperty(helpers,"title") || (depth0 != null ? lookupProperty(depth0,"title") : depth0)) != null ? helper : alias4),(typeof helper === "function" ? helper.call(alias3,{"name":"title","hash":{},"data":data,"loc":{"start":{"line":13,"column":16},"end":{"line":13,"column":25}}}) : helper)))
	    + "\n            </div>\n";
	},"11":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"user")), depth0))
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"email")),{"name":"if","hash":{},"fn":container.program(12, data, 0),"inverse":container.program(14, data, 0),"data":data,"loc":{"start":{"line":35,"column":12},"end":{"line":50,"column":19}}})) != null ? stack1 : "")
	    + "        </div>\n";
	},"12":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"userMenu")), depth0))
	    + "\">\n                    <cat-user-menu></cat-user-menu>\n                </div>\n";
	},"14":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"isBitrix")),{"name":"if","hash":{},"fn":container.program(15, data, 0),"inverse":container.program(17, data, 0),"data":data,"loc":{"start":{"line":40,"column":16},"end":{"line":49,"column":23}}})) != null ? stack1 : "");
	},"15":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                    <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"login")), depth0))
	    + " "
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"redirect")), depth0))
	    + "\"\n                         cat-url=\""
	    + alias2((lookupProperty(helpers,"patchQuery")||(depth0 && lookupProperty(depth0,"patchQuery"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"/registration/extra",((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"utm")),{"name":"patchQuery","hash":{},"data":data,"loc":{"start":{"line":42,"column":34},"end":{"line":42,"column":80}}}))
	    + "\">\n                        Регистрация\n                    </div>\n";
	},"17":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                    <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"login")), depth0))
	    + " "
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"redirect")), depth0))
	    + "\" cat-url=\""
	    + alias2((lookupProperty(helpers,"patchQuery")||(depth0 && lookupProperty(depth0,"patchQuery"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"/login",((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"utm")),{"name":"patchQuery","hash":{},"data":data,"loc":{"start":{"line":46,"column":85},"end":{"line":46,"column":118}}}))
	    + "\">\n                        Вход/Регистрация\n                    </div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"content") : stack1), depth0))
	    + "\">\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"logo") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"redirect")), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"logoLink") : stack1), depth0))
	    + "\"\n         cat-url=\""
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isBitrix") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":3,"column":18},"end":{"line":3,"column":111}}})) != null ? stack1 : "")
	    + "\">\n    </div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"menu") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"inline-block-element") : stack1), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isManager") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":58},"end":{"line":5,"column":99}}})) != null ? stack1 : "")
	    + "\">\n        <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"link")), depth0))
	    + " "
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"redirect")), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isActive") : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":62},"end":{"line":6,"column":107}}})) != null ? stack1 : "")
	    + "\"\n             cat-url=\""
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isBitrix") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":7,"column":22},"end":{"line":7,"column":115}}})) != null ? stack1 : "")
	    + "\">\n            Данные\n        </div>\n"
	    + ((stack1 = lookupProperty(helpers,"each").call(alias3,(depth0 != null ? lookupProperty(depth0,"links") : depth0),{"name":"each","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":10,"column":8},"end":{"line":15,"column":17}}})) != null ? stack1 : "")
	    + "    </div>\n\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"phone") : stack1), depth0))
	    + "\">\n        <div>\n            <a class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"phoneLink") : stack1), depth0))
	    + "\" href=\"tel:+78007751230\" rel=\"nofollow\">8 800 775-12-30</a>\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"freeCall") : stack1), depth0))
	    + "\">\n                звонок по России бесплатный\n            </div>\n        </div>\n        <div>\n            <a class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"phoneLink") : stack1), depth0))
	    + "\" href=\"tel:+79665000050\" rel=\"nofollow\">8 966 500-00-50</a>\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"freeCall") : stack1), depth0))
	    + "\">\n                WhatsApp, Telegram\n            </div>\n        </div>\n    </div>\n\n"
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(alias3,(depth0 != null ? lookupProperty(depth0,"layout") : depth0),"!==","auth",{"name":"compare","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":33,"column":4},"end":{"line":52,"column":16}}})) != null ? stack1 : "")
	    + "</div>\n";
	},"useData":true});

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"fadeLink") : stack1), depth0));
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"isOpen") : stack1), depth0));
	},"5":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"item")), depth0))
	    + "\">\n                <span class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"link")), depth0))
	    + " "
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"redirect")), depth0))
	    + "\" cat-url=\""
	    + alias2((lookupProperty(helpers,"patchQuery")||(depth0 && lookupProperty(depth0,"patchQuery"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"/account/personal",(depth0 != null ? lookupProperty(depth0,"utm") : depth0),{"name":"patchQuery","hash":{},"data":data,"loc":{"start":{"line":7,"column":81},"end":{"line":7,"column":119}}}))
	    + "\">\n                    Обо мне\n                </span>\n            </div>\n";
	},"7":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"item") : stack1), depth0))
	    + "\">\n                <a class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"logout") : stack1), depth0))
	    + "\">Выйти</a>\n            </div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"block") : stack1), depth0))
	    + "\">\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"title") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"dropdownLink") : stack1), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isOpen") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":51},"end":{"line":2,"column":88}}})) != null ? stack1 : "")
	    + "\">"
	    + alias2(((helper = (helper = lookupProperty(helpers,"email") || (depth0 != null ? lookupProperty(depth0,"email") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(alias3,{"name":"email","hash":{},"data":data,"loc":{"start":{"line":2,"column":90},"end":{"line":2,"column":99}}}) : helper)))
	    + "</div>\n\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"dropdown") : stack1), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isOpen") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":33},"end":{"line":4,"column":68}}})) != null ? stack1 : "")
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"unless").call(alias3,(depth0 != null ? lookupProperty(depth0,"isManager") : depth0),{"name":"unless","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":8},"end":{"line":11,"column":19}}})) != null ? stack1 : "")
	    + ((stack1 = lookupProperty(helpers,"unless").call(alias3,(depth0 != null ? lookupProperty(depth0,"isBitrix") : depth0),{"name":"unless","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":12,"column":8},"end":{"line":16,"column":19}}})) != null ? stack1 : "")
	    + "    </div>\n</div>\n";
	},"useData":true});

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "    <cat-header id=\"header\"></cat-header>\n    <cat-content id=\"content\" class=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"flex") : stack1), depth0))
	    + "\"></cat-content>\n    <cat-footer id=\"footer\" class=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"block") : stack1), depth0))
	    + "\"></cat-footer>\n";
	},"3":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "    <cat-header id=\"header\"></cat-header>\n    <cat-content id=\"content\" class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"flex") : stack1), depth0))
	    + "\"></cat-content>\n";
	},"5":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "    <cat-header id=\"header\"></cat-header>\n    <cat-order-header id=\"order-header\"></cat-order-header>\n    <cat-content id=\"content\" class=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"flex") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"blue") : stack1), depth0))
	    + "\"></cat-content>\n    <cat-footer id=\"footer\" class=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"block") : stack1), depth0))
	    + "\"></cat-footer>\n";
	},"7":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "    <cat-error-page id=\"error-page\" class=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"flex") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"centred") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"white") : stack1), depth0))
	    + "\"></cat-error-page>\n";
	},"9":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "    <cat-header id=\"header\"></cat-header>\n    <cat-auth id=\"auth\" class=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"flex") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"grey") : stack1), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? lookupProperty(depths[1],"atCenter") : depths[1]),{"name":"if","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":25,"column":63},"end":{"line":25,"column":107}}})) != null ? stack1 : "")
	    + "\"></cat-auth>\n    <cat-footer id=\"footer\"></cat-footer>\n";
	},"10":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"centred") : stack1), depth0));
	},"12":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "    <cat-header id=\"header\"></cat-header>\n    <cat-payment id=\"payment\" class=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"flex") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"centred") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"white") : stack1), depth0))
	    + "\"></cat-payment>\n    <cat-footer id=\"footer\"></cat-footer>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"layout") : depth0),"===","main",{"name":"compare","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":5,"column":12}}})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"layout") : depth0),"===","footless",{"name":"compare","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":0},"end":{"line":10,"column":12}}})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"layout") : depth0),"===","order",{"name":"compare","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":12,"column":0},"end":{"line":17,"column":12}}})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"layout") : depth0),"===","error",{"name":"compare","hash":{},"fn":container.program(7, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":19,"column":0},"end":{"line":21,"column":12}}})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"layout") : depth0),"===","auth",{"name":"compare","hash":{},"fn":container.program(9, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":23,"column":0},"end":{"line":27,"column":12}}})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"layout") : depth0),"===","payment",{"name":"compare","hash":{},"fn":container.program(12, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":29,"column":0},"end":{"line":33,"column":12}}})) != null ? stack1 : "");
	},"useData":true,"useDepths":true});

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"isLoading") : stack1), depth0));
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"overlay") : stack1), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isLoading") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":28},"end":{"line":1,"column":69}}})) != null ? stack1 : "")
	    + "\"></div>\n";
	},"useData":true});

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(lookupProperty(helpers,"lookup").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"css") : depth0),(depth0 != null ? lookupProperty(depth0,"size") : depth0),{"name":"lookup","hash":{},"data":data,"loc":{"start":{"line":1,"column":42},"end":{"line":1,"column":61}}}));
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"preloader") : stack1), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"size") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":30},"end":{"line":1,"column":68}}})) != null ? stack1 : "")
	    + "\">\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"point") : stack1), depth0))
	    + "\"></div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"point") : stack1), depth0))
	    + "\"></div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"point") : stack1), depth0))
	    + "\"></div>\n</div>\n";
	},"useData":true});

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"big") : stack1), depth0));
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"normal") : stack1), depth0));
	},"5":function(container,depth0,helpers,partials,data) {
	    return "disabled";
	},"7":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"tooltip")), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isBig") : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":42},"end":{"line":4,"column":80}}})) != null ? stack1 : "")
	    + "\">\n            Увы, мы пока не знаем организаций, подходящих под Ваши фильтры\n        </div>\n";
	},"8":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"tooltipBig") : stack1), depth0));
	},"10":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"totalPrice") : depth0),{"name":"unless","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":8},"end":{"line":12,"column":19}}})) != null ? stack1 : "");
	},"11":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"tooltip")), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isBig") : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":46},"end":{"line":9,"column":84}}})) != null ? stack1 : "")
	    + "\">\n                Вы не отметили города или рубрики\n            </div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"tooltipWrapper")), depth0))
	    + "\">\n    <button class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"button") : stack1), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isBig") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":2,"column":34},"end":{"line":2,"column":87}}})) != null ? stack1 : "")
	    + "\" "
	    + ((stack1 = lookupProperty(helpers,"unless").call(alias3,(depth0 != null ? lookupProperty(depth0,"totalPrice") : depth0),{"name":"unless","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":89},"end":{"line":2,"column":130}}})) != null ? stack1 : "")
	    + ">Получить данные</button>\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isZero") : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.program(10, data, 0),"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":13,"column":11}}})) != null ? stack1 : "")
	    + "</div>\n";
	},"useData":true});

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"tooltip") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"topToBottom") : stack1), depth0))
	    + "\">\n            Что-то пошло не так. <br>\n            Повторите попытку или обратитесь к вашему менеджеру.\n        </div>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.lambda, alias3=container.escapeExpression, alias4=container.hooks.helperMissing, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"isLoading") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":8},"end":{"line":12,"column":15}}})) != null ? stack1 : "")
	    + "        <div class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"wrapper") : stack1), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"isLoading") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":13,"column":36},"end":{"line":13,"column":77}}})) != null ? stack1 : "")
	    + "\">\n            <div class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"priceBlock") : stack1), depth0))
	    + "\">\n                <div>\n                    <div class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"title") : stack1), depth0))
	    + "\">\n                        Сумма заказа\n                    </div>\n                    <div class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"priceContent") : stack1), depth0))
	    + "\">\n                        <span class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"totalPrice") : stack1), depth0))
	    + "\">"
	    + alias3((lookupProperty(helpers,"currencyFormat")||(depth0 && lookupProperty(depth0,"currencyFormat"))||alias4).call(alias1,(depth0 != null ? lookupProperty(depth0,"totalPrice") : depth0),{"name":"currencyFormat","hash":{},"data":data,"loc":{"start":{"line":20,"column":57},"end":{"line":20,"column":86}}}))
	    + "</span>\n                        <span class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"rouble") : stack1), depth0))
	    + " "
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"black") : stack1), depth0))
	    + " "
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"bigRouble") : stack1), depth0))
	    + "\">a</span>\n                    </div>\n                </div>\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"discountPercentage") : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":24,"column":16},"end":{"line":31,"column":23}}})) != null ? stack1 : "")
	    + "            </div>\n            <div class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"priceBlock") : stack1), depth0))
	    + "\">\n                <div class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"title") : stack1), depth0))
	    + "\">\n                    Количество строк\n                </div>\n                <div class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"priceContent") : stack1), depth0))
	    + " "
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"noRoubleBlock") : stack1), depth0))
	    + "\">\n                    "
	    + alias3((lookupProperty(helpers,"intFormat")||(depth0 && lookupProperty(depth0,"intFormat"))||alias4).call(alias1,(depth0 != null ? lookupProperty(depth0,"rowAmount") : depth0),{"name":"intFormat","hash":{},"data":data,"loc":{"start":{"line":38,"column":20},"end":{"line":38,"column":43}}}))
	    + "\n                </div>\n            </div>\n            <div class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"priceBlock") : stack1), depth0))
	    + "\">\n                <div class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"title") : stack1), depth0))
	    + " "
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"titleWithRuble") : stack1), depth0))
	    + "\">\n                    <span class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"rouble") : stack1), depth0))
	    + " "
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"font14") : stack1), depth0))
	    + "\">a</span> за строку\n                </div>\n                <div class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"priceContent") : stack1), depth0))
	    + "\">\n                    "
	    + alias3((lookupProperty(helpers,"currencyFormat")||(depth0 && lookupProperty(depth0,"currencyFormat"))||alias4).call(alias1,(depth0 != null ? lookupProperty(depth0,"rowPrice") : depth0),{"name":"currencyFormat","hash":{},"data":data,"loc":{"start":{"line":46,"column":20},"end":{"line":46,"column":47}}}))
	    + " <span class=\""
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"rouble") : stack1), depth0))
	    + " "
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"black") : stack1), depth0))
	    + " "
	    + alias3(alias2(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"bigRouble") : stack1), depth0))
	    + "\">a</span>\n                </div>\n            </div>\n        </div>\n";
	},"4":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"preloader") : stack1), depth0))
	    + "\">\n                <cat-preloader></cat-preloader>\n            </div>\n";
	},"6":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"isLoading") : stack1), depth0));
	},"8":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"priceContent") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"noDiscountBlock") : stack1), depth0))
	    + "\">\n                    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"totalPrice") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"noDiscount") : stack1), depth0))
	    + "\">\n                        <span class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"lineThrough") : stack1), depth0))
	    + "\">"
	    + alias2((lookupProperty(helpers,"currencyFormat")||(depth0 && lookupProperty(depth0,"currencyFormat"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"noDiscountTotalPrice") : depth0),{"name":"currencyFormat","hash":{},"data":data,"loc":{"start":{"line":27,"column":58},"end":{"line":27,"column":97}}}))
	    + "</span>\n                        <span class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"rouble") : stack1), depth0))
	    + "\">a</span>\n                    </div>\n                </div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"content") : stack1), depth0))
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isError") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":50,"column":11}}})) != null ? stack1 : "")
	    + "\n</div>\n\n";
	},"useData":true});

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"block") : stack1), depth0))
	    + "\">\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"wrapper") : stack1), depth0))
	    + "\">\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"content") : stack1), depth0))
	    + "\">\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"price") : stack1), depth0))
	    + "\">\n                <cat-price></cat-price>\n            </div>\n\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"order") : stack1), depth0))
	    + "\">\n                <cat-make-order-button></cat-make-order-button>\n            </div>\n        </div>\n    </div>\n</div>\n";
	},"useData":true});

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), alias4=container.hooks.helperMissing, alias5="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"message") : stack1), depth0))
	    + "\">\n   <h3 class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"title") : stack1), depth0))
	    + "\">"
	    + alias2(((helper = (helper = lookupProperty(helpers,"title") || (depth0 != null ? lookupProperty(depth0,"title") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"title","hash":{},"data":data,"loc":{"start":{"line":2,"column":29},"end":{"line":2,"column":38}}}) : helper)))
	    + "</h3>\n   <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"content") : stack1), depth0))
	    + "\">"
	    + alias2(((helper = (helper = lookupProperty(helpers,"content") || (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"content","hash":{},"data":data,"loc":{"start":{"line":3,"column":32},"end":{"line":3,"column":43}}}) : helper)))
	    + "</div>\n</div>\n";
	},"useData":true});

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"noAnimation") : stack1), depth0));
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"icons")), depth0))
	    + "\">\n                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"iconOk")), depth0))
	    + "\"></div>\n                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"iconOk2")), depth0))
	    + "\"></div>\n                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"iconOkMedium")), depth0))
	    + "\"></div>\n                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"iconOkMedium2")), depth0))
	    + "\"></div>\n                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"iconBad")), depth0))
	    + "\"></div>\n                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"iconBadSmall")), depth0))
	    + "\"></div>\n            </div>\n";
	},"5":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"pins")), depth0))
	    + "\">\n                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"pinSmall")), depth0))
	    + "\"></div>\n                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"pinSmall2")), depth0))
	    + "\"></div>\n                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"pinMedium")), depth0))
	    + "\"></div>\n                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"pinMedium2")), depth0))
	    + "\"></div>\n                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"pinMedium3")), depth0))
	    + "\"></div>\n                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"pinBig")), depth0))
	    + "\"></div>\n                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"pinBig")), depth0))
	    + "\"></div>\n            </div>\n";
	},"7":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"reliabilityWrapper")), depth0))
	    + "\">\n                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"reliabilityPin")), depth0))
	    + "\"></div>\n                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"reliabilityShield")), depth0))
	    + "\"></div>\n                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"reliabilityPromo")), depth0))
	    + "\"></div>\n                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"reliabilityPromo2")), depth0))
	    + "\"></div>\n            </div>\n";
	},"9":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"capabilitiesWrapper")), depth0))
	    + "\">\n                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"capabilityLeft")), depth0))
	    + "\"></div>\n                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"capabilityRight")), depth0))
	    + "\"></div>\n                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"capabilityOk")), depth0))
	    + "\"></div>\n                <div class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"capabilityList")), depth0))
	    + "\"></div>\n            </div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), alias4=container.hooks.helperMissing, alias5="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"wrapper") : stack1), depth0))
	    + "\">\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"slider") : stack1), depth0))
	    + "\">\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"layer") : stack1), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"noAnimation") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":34},"end":{"line":3,"column":79}}})) != null ? stack1 : "")
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"city") : stack1), depth0))
	    + "\"\n             style=\"background-position: calc(50% - "
	    + alias2(((helper = (helper = lookupProperty(helpers,"cityPos") || (depth0 != null ? lookupProperty(depth0,"cityPos") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"cityPos","hash":{},"data":data,"loc":{"start":{"line":4,"column":52},"end":{"line":4,"column":63}}}) : helper)))
	    + "px), bottom;\"></div>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"layer") : stack1), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"noAnimation") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":34},"end":{"line":5,"column":79}}})) != null ? stack1 : "")
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"buildings") : stack1), depth0))
	    + "\"\n             style=\"background-position: calc(50% - "
	    + alias2(((helper = (helper = lookupProperty(helpers,"buildingsPos") || (depth0 != null ? lookupProperty(depth0,"buildingsPos") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"buildingsPos","hash":{},"data":data,"loc":{"start":{"line":6,"column":52},"end":{"line":6,"column":68}}}) : helper)))
	    + "px), bottom;\"></div>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"layer") : stack1), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"noAnimation") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":34},"end":{"line":7,"column":79}}})) != null ? stack1 : "")
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"clouds") : stack1), depth0))
	    + "\"\n             style=\"background-position: calc(50% - "
	    + alias2(((helper = (helper = lookupProperty(helpers,"cloudsPos") || (depth0 != null ? lookupProperty(depth0,"cloudsPos") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"cloudsPos","hash":{},"data":data,"loc":{"start":{"line":8,"column":52},"end":{"line":8,"column":65}}}) : helper)))
	    + "px), bottom;\"></div>\n    </div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"content") : stack1), depth0))
	    + "\">\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"airship") : stack1), depth0))
	    + "\"></div>\n\n        <cat-message></cat-message>\n\n"
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"page") : depth0),"===",1,{"name":"compare","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":15,"column":8},"end":{"line":24,"column":20}}})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"page") : depth0),"===",2,{"name":"compare","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":26,"column":8},"end":{"line":36,"column":20}}})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"page") : depth0),"===",3,{"name":"compare","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":38,"column":8},"end":{"line":45,"column":20}}})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"page") : depth0),"===",4,{"name":"compare","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":47,"column":8},"end":{"line":54,"column":20}}})) != null ? stack1 : "")
	    + "    </div>\n</div>\n";
	},"useData":true});

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<section class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"content") : stack1), depth0))
	    + "\">\n    <h1 class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"head") : stack1), depth0))
	    + "\">\n        Сформировать выборку данных с помощью сервиса Дата2ГИС\n    </h1>\n\n    <cat-custom-order></cat-custom-order>\n</section>\n\n<cat-slider></cat-slider>\n\n<section class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"actions") : stack1), depth0))
	    + "\">\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"actionsWrapper") : stack1), depth0))
	    + "\">\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"actionsBlock") : stack1), depth0))
	    + "\">\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"actionsBlockHeader") : stack1), depth0))
	    + "\">\n                <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"actionsImage") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"catalog") : stack1), depth0))
	    + "\"></div>\n            </div>\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"actionsDescription") : stack1), depth0))
	    + "\">\n                Формируйте клиентскую базу\n                для корпоративных продаж\n                на рынке B2B\n            </div>\n        </div>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"actionsBlock") : stack1), depth0))
	    + "\">\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"actionsBlockHeader") : stack1), depth0))
	    + "\">\n                <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"actionsImage") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"directory") : stack1), depth0))
	    + "\"></div>\n            </div>\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"actionsDescription") : stack1), depth0))
	    + "\">\n                Актуализируйте контактную информацию собственной клиентской базы\n            </div>\n        </div>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"actionsBlock") : stack1), depth0))
	    + "\">\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"actionsBlockHeader") : stack1), depth0))
	    + "\">\n                <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"actionsImage") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"board") : stack1), depth0))
	    + "\"></div>\n            </div>\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"actionsDescription") : stack1), depth0))
	    + "\">\n                Отслеживайте новые компании\n                на вашем рынке за указанный период времени\n            </div>\n        </div>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"actionsControls") : stack1), depth0))
	    + "\">\n            <a download type=\"text/csv\" href=\"/static/document/data2gis_example.xlsx\"\n               target=\"_blank\" class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"actionsButton") : stack1), depth0))
	    + "\">\n                Скачать пример выборки\n            </a>\n        </div>\n    </div>\n</section>\n\n<section class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"payment") : stack1), depth0))
	    + "\">\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"paymentWrapper") : stack1), depth0))
	    + "\">\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"paymentMethods") : stack1), depth0))
	    + "\">\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"paymentMethodsHeader") : stack1), depth0))
	    + "\">\n                Способы оплаты\n            </div>\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"paymentMethodsContainer") : stack1), depth0))
	    + "\">\n                <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"paymentMethodsBlock") : stack1), depth0))
	    + "\">\n                    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"paymentMethodsImage") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"bankCard") : stack1), depth0))
	    + "\"></div>\n                    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"paymentMethodsInfo") : stack1), depth0))
	    + "\">\n                        Банковская карта\n                    </div>\n                </div>\n                <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"paymentMethodsBlock") : stack1), depth0))
	    + "\">\n                    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"paymentMethodsImage") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"invoice") : stack1), depth0))
	    + "\"></div>\n                    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"paymentMethodsInfo") : stack1), depth0))
	    + "\">\n                        Счет на оплату\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</section>\n\n<section class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"manager") : stack1), depth0))
	    + "\">\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"managerWrapper") : stack1), depth0))
	    + "\">\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"managerImage") : stack1), depth0))
	    + "\">\n        </div>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"managerHeader") : stack1), depth0))
	    + "\">\n            Более подробная выборка (средний чек, количество филиалов или другие параметры и данные) также доступны в Личном кабинете\n        </div>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"managerControls") : stack1), depth0))
	    + "\">\n            <a target=\"_top\" href=\"mailto:content.data@2gis.com\" class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"managerLink") : stack1), depth0))
	    + "\">\n                Написать менеджеру\n            </a>\n        </div>\n    </div>\n</section>\n";
	},"useData":true});

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"alert") : stack1), depth0))
	    + "\">\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"image") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"fail") : stack1), depth0))
	    + "\"></div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"alertTitle") : stack1), depth0))
	    + "\">\n        К сожалению, не удалось завершить оплату.\n    </div>\n    <span class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"alertDescription") : stack1), depth0))
	    + "\">\n        <p>\n        Попробуйте еще раз или свяжитесь с <a class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"link") : stack1), depth0))
	    + "\" target=\"_top\" href=\"mailto:content.data@2gis.com\">нашими менеджерами</a>.\n        </p>\n        <p>\n        Сейчас вы будете перенаправлены на страницу заказа.\n        Если не хотите ждать, нажмите <a cat-url=\""
	    + alias2(((helper = (helper = lookupProperty(helpers,"redirectLink") || (depth0 != null ? lookupProperty(depth0,"redirectLink") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"redirectLink","hash":{},"data":data,"loc":{"start":{"line":13,"column":50},"end":{"line":13,"column":66}}}) : helper)))
	    + "\" class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"redirect") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"link") : stack1), depth0))
	    + "\">ссылку</a>.\n        </p>\n    </span>\n</div>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"alert") : stack1), depth0))
	    + "\">\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"image") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"success") : stack1), depth0))
	    + "\"></div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"alertTitle") : stack1), depth0))
	    + "\">\n        Поздравляем! Оплата успешно завершена.\n    </div>\n    <span class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"alertDescription") : stack1), depth0))
	    + "\">\n        <p>\n        Сейчас Вы будете перенаправлены на страницу заказа.\n        Если не хотите ждать, нажмите <a cat-url=\""
	    + alias2(((helper = (helper = lookupProperty(helpers,"redirectLink") || (depth0 != null ? lookupProperty(depth0,"redirectLink") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"redirectLink","hash":{},"data":data,"loc":{"start":{"line":28,"column":50},"end":{"line":28,"column":66}}}) : helper)))
	    + "\" class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"redirect") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"link") : stack1), depth0))
	    + "\">ссылку</a>.\n        </p>\n    </span>\n</div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"fail") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":17,"column":7}}})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"success") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":19,"column":0},"end":{"line":32,"column":7}}})) != null ? stack1 : "");
	},"useData":true});

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    return "<cat-alert></cat-alert>\n";
	},"useData":true});

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"passwordChangeTooltip") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"passwordChanged") : stack1), depth0))
	    + "\">\n             Пароль изменён!\n        </div>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"result") : depth0)) != null ? lookupProperty(stack1,"error") : stack1),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":4},"end":{"line":13,"column":4}}})) != null ? stack1 : "");
	},"4":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"passwordChangeTooltip") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"passwordNotChanged") : stack1), depth0))
	    + "\">\n            Пароль не был изменён, "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"result") : depth0)) != null ? lookupProperty(stack1,"reason") : stack1), depth0))
	    + "\n        </div>\n    ";
	},"6":function(container,depth0,helpers,partials,data) {
	    return "disabled=\"true\"";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"title") : stack1), depth0))
	    + "\">\n        Изменить пароль\n    </div>\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,((stack1 = (depth0 != null ? lookupProperty(depth0,"result") : depth0)) != null ? lookupProperty(stack1,"success") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":5,"column":4},"end":{"line":13,"column":11}}})) != null ? stack1 : "")
	    + "    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"autocomplete") : stack1), depth0))
	    + "\">\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"section") : stack1), depth0))
	    + "\">\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"label") : stack1), depth0))
	    + "\">\n                Старый пароль<span class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"asterisk")), depth0))
	    + "\">*</span>\n            </div>\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"field") : stack1), depth0))
	    + " \">\n                <cat-text-password id=\"text-pass\" path=\"account.passwordChangeForm.password\"\n                                       error-path=\"account.passwordChangeForm.error.password\"></cat-text-password>\n            </div>\n        </div>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"section") : stack1), depth0))
	    + "\">\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"label") : stack1), depth0))
	    + "\">\n                Новый пароль<span class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"asterisk")), depth0))
	    + "\">*</span>\n            </div>\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"field") : stack1), depth0))
	    + " \">\n                <cat-text-password-new id=\"text-pass-new\" path=\"account.passwordChangeForm.passwordNew\"\n                                   error-path=\"account.passwordChangeForm.error.passwordNew\"></cat-text-password-new>\n            </div>\n        </div>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"section") : stack1), depth0))
	    + "\">\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"label") : stack1), depth0))
	    + "\">\n                Повторите пароль<span class=\""
	    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"asterisk")), depth0))
	    + "\">*</span>\n            </div>\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"field") : stack1), depth0))
	    + " \">\n                <cat-text-repeat-password-new id=\"text-rep-pass-new\" path=\"account.passwordChangeForm.repeatPasswordNew\"\n                                          error-path=\"account.passwordChangeForm.error.repeatPasswordNew\"></cat-text-repeat-password-new>\n            </div>\n        </div>\n    </div>\n    <button class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"submit") : stack1), depth0))
	    + "\" type=\"submit\" "
	    + ((stack1 = lookupProperty(helpers,"unless").call(alias3,(depth0 != null ? lookupProperty(depth0,"isEnabled") : depth0),{"name":"unless","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":43,"column":49},"end":{"line":43,"column":96}}})) != null ? stack1 : "")
	    + ">\n        Изменить пароль\n    </button>\n</div>\n";
	},"useData":true});

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "        <cat-password-change></cat-password-change>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"content") : stack1), depth0))
	    + "\">\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"user") : stack1), depth0))
	    + "\">\n        <cat-user-form></cat-user-form>\n"
	    + ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isBitrix") : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":8},"end":{"line":6,"column":19}}})) != null ? stack1 : "")
	    + "    </div>\n</div>\n";
	},"useData":true});

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"content") : stack1), depth0))
	    + "\">\n    <p align=\"CENTER\" style=\"margin-top: 0.19in; margin-bottom: 0.19in; line-height: 18px;\"><font face=\"Arial, serif\"><font size=\"3\"><b>ОФЕРТА на&nbsp;заключение договора на&nbsp;предоставление доступа к&nbsp;сервису Data.2gis</b><br></font></font><br><br></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%\"><font face=\"Arial, serif\"><font size=\"2\">1. Определения и термины</font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%\"><font face=\"Arial, serif\"><font size=\"2\">1.1. В&nbsp;целях настоящего документа нижеприведенные термины используются в&nbsp;следующем значении:</font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\"><font face=\"Arial, serif\"><font size=\"2\">1.1.1 Сервис &laquo;Data.2gis&raquo;, Сервис&nbsp;&mdash; сервис, включенный в&nbsp;Единый реестр российских программ для электронных вычислительных машин и&nbsp;баз данных&nbsp;&mdash; запись &#8470;&nbsp;24359 от&nbsp;18.10.2024&nbsp;г., предоставляющий возможность формирования и&nbsp;получения по&nbsp;Заказу Пользователя данных из&nbsp;Городского Информационного Справочника &laquo;2ГИС&raquo;, объединяющего базу данных по&nbsp;организациям города и&nbsp;цифровой план (карту) конкретного города, по&nbsp;определенным параметрам.</font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\"><font face=\"Arial, serif\"><font size=\"2\">1.1.2 Договор&nbsp;&mdash; договор на&nbsp;предоставление доступа к&nbsp;сервису Data.2gis, позволяющего получать данные из&nbsp;Городского Информационного Справочника &laquo;2ГИС&raquo; с&nbsp;использованием <nobr>интернет-сайта</nobr> data.2gis.com, заключенный между Правообладателем и&nbsp;Пользователем посредством Акцепта Оферты Пользователем.</font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\"><font face=\"Arial, serif\"><font size=\"2\">1.1.3 Заказ&nbsp;&mdash; данные из&nbsp;Городского Информационного Справочника &laquo;2ГИС&raquo;, сформированные по&nbsp;выбранным Пользователем параметрам, либо по&nbsp;параметрам, согласованным Сторонами в&nbsp;отдельном документе, доступные в&nbsp;Личном кабинете.</font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\"><font face=\"Arial, serif\"><font size=\"2\">1.1.4 Личный кабинет&nbsp;&mdash; раздел сервиса Data.2gis, в&nbsp;котором доступны данные, сформированные по&nbsp;Заказам Пользователя, а&nbsp;также закрывающие документы, а&nbsp;также файлы, предоставленные в&nbsp;соответствии с&nbsp;отдельным Договором между Правообладателем и&nbsp;Пользователем.</font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\"><font face=\"Arial, serif\"><font size=\"2\">1.1.5 Правообладатель&nbsp;&mdash; Общество с&nbsp;ограниченной ответственностью &laquo;ДубльГИС&raquo; (ОГРН 1045401929847, место нахождения: 630048, г. Новосибирск, пл. Карла Маркса, д.&nbsp;7), режим работы: понедельник&nbsp;&mdash; пятница с&nbsp;09-00 до&nbsp;18-00, выходные: суббота, воскресенье.</font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\"><font face=\"Arial, serif\"><font size=\"2\">1.1.6 Пользователь&nbsp;&mdash; зарегистрированное в&nbsp;качестве пользователя на&nbsp;Сайте дееспособное физическое лицо, выступающее от&nbsp;своего имени и&nbsp;в&nbsp;собственных интересах либо от&nbsp;имени и&nbsp;в&nbsp;интересах представляемого им&nbsp;юридического лица.</font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\"><font face=\"Arial, serif\"><font size=\"2\">1.1.7 Рабочий день&nbsp;&mdash; любой день недели за&nbsp;исключением субботы, воскресенья и&nbsp;нерабочих праздничных дней, установленных в&nbsp;соответствии с&nbsp;законодательством Российской Федерации.</font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\"><font face=\"Arial, serif\"><font size=\"2\">1.1.8 Сайт&nbsp;&mdash; интернет-сайт, размещенный в&nbsp;сети Интернет в&nbsp;домене по&nbsp;адресу data.2gis.com и&nbsp;(или) находящийся под его управлением.</font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\"><font face=\"Arial, serif\"><font size=\"2\">1.1.9 Стороны&nbsp;&mdash; Пользователь и&nbsp;Правообладатель по&nbsp;заключенному в&nbsp;соответствии с&nbsp;Офертой Договору.</font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\"><font face=\"Arial, serif\"><font size=\"2\">1.1.10 Счет&nbsp;&mdash; составляемый Правообладателем документ для оплаты доступа к&nbsp;Сервису, в&nbsp;котором указываются номер Заказа и&nbsp;стоимость доступа, которая определяется в&nbsp;соответствии с&nbsp;критериями Заказа (перечнем предоставляемых данных). Выставление Счета&nbsp;&mdash; составление Счета Правообладателем или переадресация Пользователя на&nbsp;сайт платежного агента или оператора электронных денежных средств для онлайн-оплаты Заказа.</font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\"><font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">1.2. В&nbsp;настоящей Оферте могут быть использованы термины, определение которых не&nbsp;содержится в&nbsp;п.1.1. Оферты. В&nbsp;этом случае толкование такого термина производится в&nbsp;соответствии с&nbsp;текстом настоящей Оферты. В&nbsp;случае отсутствия однозначного толкования термина или определения в&nbsp;тексте Оферты следует руководствоваться его толкованием, определенным: в&nbsp;первую очередь&nbsp;&mdash; документами, образующими Договор между Сторонами, во&nbsp;вторую очередь&nbsp;&mdash; законодательством Российской Федерации, и&nbsp;в&nbsp;последующем&nbsp;&mdash; обычаями делового оборота и&nbsp;научной доктриной.</font></font></font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\"><font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">1.3. Любая ссылка в&nbsp;настоящей Оферте на&nbsp;пункт (раздел Оферты) и&nbsp;(или) их&nbsp;условия, означает соответствующую ссылку на&nbsp;настоящую Оферту (их&nbsp;раздел) и&nbsp;(или) их&nbsp;условия.</font></font></font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%\">\n        <font face=\"Arial, serif\"><font size=\"2\">2. Предмет и&nbsp;порядок заключения Договора</font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%\">\n        <font face=\"Arial, serif\"><font size=\"2\">2.1. Правообладатель обязуется при наличии технической возможности предоставлять доступ к&nbsp;Сервису &laquo;Data.2gis&raquo; по&nbsp;предоставлению данных из&nbsp;Городского Информационного Справочника &laquo;2ГИС&raquo; на&nbsp;Сайте на&nbsp;условиях настоящей Оферты.</font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%\">\n        <font face=\"Arial, serif\"><font size=\"2\">2.2. Все информационные материалы, размещаемые в&nbsp;Городском Информационном Справочнике &laquo;2ГИС&raquo;, предоставлены третьими лицами. Правообладатель прилагает все усилия к&nbsp;тому, чтобы информация, размещённая в&nbsp;Городском Информационном Справочнике &laquo;2ГИС&raquo;, была точной, однако Правообладатель, не&nbsp;обеспечивает дополнительных гарантий и&nbsp;не&nbsp;выражает никаких заверений, что результаты, полученные с&nbsp;ее&nbsp;помощью, будут точны и&nbsp;будут отвечать ожиданиям Пользователя.</font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%\">\n        <font face=\"Arial, serif\"><font size=\"2\">2.3. Данные из&nbsp;Городского Информационного Справочника &laquo;2ГИС&raquo; по&nbsp;Заказу Пользователя формируются исходя из&nbsp;объема информации, размещённой в&nbsp;Городском Информационном Справочнике &laquo;2ГИС&raquo; на&nbsp;дату загрузки данных в&nbsp;Личный кабинет.</font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%\">\n        <font face=\"Arial, serif\"><font size=\"2\">2.4. Территория, состав данных, наименование рубрик Городского Информационного Справочника &laquo;2ГИС&raquo; и&nbsp;иные критерии формирования данных, количество материалов (записей) представляемых данных, вид предоставляемых данных, сроки передачи обновленных данных, формат предоставления доступа к&nbsp;Сервису &laquo;Data.2gis&raquo; и&nbsp;данным, периодичность предоставления обновлений данных, а&nbsp;также стоимость доступа к&nbsp;Сервису &laquo;Data.2gis&raquo; указываются в&nbsp;Заказе.</font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">2.5. Пользователю необходимо пройти процедуру регистрации и/или авторизации в&nbsp;Личном кабинете. Пользователь самостоятельно выбирает пароль для входа в&nbsp;Личный кабинет, при этом, логин для входа в&nbsp;Личный кабинет присваивается Исполнителем, если иное не&nbsp;предусмотрено формой регистрации. Пользователь самостоятельно несет ответственность за&nbsp;все действия (в&nbsp;том числе за&nbsp;действия работников и/или уполномоченных представителей), совершенные с&nbsp;использованием логина и&nbsp;пароля с&nbsp;момента регистрации в&nbsp;Личном кабинете.</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">2.6. Любые действия, совершенные с&nbsp;использованием логина и&nbsp;пароля для доступа в&nbsp;Личный кабинет, считаются совершенными Пользователем, за&nbsp;исключением случаев, когда Пользователь, в&nbsp;порядке, предусмотренном&nbsp;п.&nbsp;2.11&nbsp;Оферты, уведомил Исполнителя о&nbsp;несанкционированном доступе третьих лиц к&nbsp;логину и&nbsp;паролю Пользователя, их&nbsp;утраты Пользователем. Пользователь самостоятельно несет ответственность за&nbsp;все действия и&nbsp;их&nbsp;последствия в&nbsp;рамках и/или в&nbsp;связи с&nbsp;исполнением Договора под его учетной записью, включая случаи передачи Пользователем данных для доступа третьим лицам на&nbsp;любых условиях.</font></font></font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">2.7. В&nbsp;случае несанкционированного доступа к&nbsp;логину и&nbsp;паролю, их&nbsp;утраты или раскрытия третьим лицам Пользователь обязан незамедлительно сообщить об&nbsp;этом Исполнителю в&nbsp;письменной форме с&nbsp;одновременным направлением электронного письма с&nbsp;указанного в&nbsp;своей учетной записи в&nbsp;Личном кабинете адреса электронной почты. В&nbsp;целях безопасности, Пользователь обязан самостоятельно осуществлять безопасное завершение работы под своей учетной записью по&nbsp;окончании каждой сессии работы в&nbsp;Личном кабинете. Правообладатель не&nbsp;отвечает за&nbsp;возможную потерю или порчу данных, а&nbsp;также другие последствия любого характера, включая расходы и/или упущенную выгоду, которые могут произойти из-за нарушения Пользователем настоящего раздела Оферты.</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">2.8. На&nbsp;основании сформированного Пользователем Заказа Правообладатель обеспечивает выставление Пользователю Счета на&nbsp;оплату, содержащего сведения номере Заказа и&nbsp;стоимости доступа к&nbsp;Сервису &laquo;Data.2gis&raquo; в&nbsp;соответствии с&nbsp;выбранными параметрами Заказа. Выставление Счета Правообладателем признается офертой (предложением заключить Договор) на&nbsp;условиях, указанных в&nbsp;Счете, Заказе и&nbsp;настоящей Оферте.</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%\">\n        <font face=\"Arial, serif\"><font size=\"2\">2.9. Оферта акцептуется Пользователем с&nbsp;момента регистрации Пользователя в&nbsp;Личном кабинете. Регистрация пользователя в&nbsp;Личном кабинете производится на&nbsp;безвозмездной основе, полный функционал Сервиса &laquo;Data.2gis&raquo; предоставляется Пользователю после оплаты доступа к&nbsp;Сервису &laquo;Data.2gis&raquo;. Обязательство по&nbsp;оплате предоставления доступа к&nbsp;Сервису &laquo;Data.2gis&raquo; по&nbsp;конкретному Заказу возникает с&nbsp;момента выставления Счета по&nbsp;отдельному Заказу Пользователя.</font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">2.10. На&nbsp;основании настоящей Оферты Пользователем может быть сделано неограниченное количество Заказов, в&nbsp;том числе с&nbsp;совпадающими полностью или частично сроками действия.</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">2.11. Обязательным условием предоставления Правообладателем доступа к&nbsp;Сервису является безоговорочное принятие и&nbsp;соблюдение Пользователем, применяемых к&nbsp;отношениям Сторон по&nbsp;Договору требований и&nbsp;положений, определенных следующими документами (&laquo;Обязательные документы&raquo;):</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">2.11.1. Соглашение об&nbsp;использовании сервисов 2ГИС и&nbsp;указанные в&nbsp;нем документы, размещенные и/или доступные в&nbsp;сети Интернет по&nbsp;адресу <a target=\"_blank\" href=\"https://law.2gis.ru/rules\"><font color=\"#00000a\"><font face=\"Arial, serif\"><font size=\"2\">https://law.2gis.ru/rules</font></font></font></a> и&nbsp;предусматривающие общие условия регистрации на&nbsp;Сайте и&nbsp;использования сервисов Правообладателя;</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">2.11.2. Политика конфиденциальности, размещенная и/или доступная в&nbsp;сети Интернет по&nbsp;адресу <a target=\"_blank\" href=\"https://law.2gis.ru/privacy\"><font color=\"#00000a\"><font face=\"Arial, serif\"><font size=\"2\">https://law.2gis.ru/privacy</font></font></font></a>, и&nbsp;содержащая правила предоставления и&nbsp;использования конфиденциальной информации, включая обработку персональных данных Пользователя.</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">2.12. Указанные в&nbsp;п.2.11. Правил Обязательные документы составляют неотъемлемую часть заключаемого в&nbsp;соответствии с&nbsp;Правилами Договора.</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\"><span style=\"font-weight: normal\">3. Порядок предоставления доступа к&nbsp;Сервису Data.2gis</span></font></font><font face=\"Arial, serif\"><font size=\"2\"></font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">3.1. Для того чтобы получить доступ к&nbsp;Сервису &laquo;Data.2gis&raquo; и&nbsp;данным с&nbsp;использованием Сервиса, Пользователю необходимо сформировать на&nbsp;Сайте Заказ, в&nbsp;котором указываются:</font></font></font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">3.1.1. населенный пункт, в&nbsp;котором расположены организации, данные о&nbsp;которых интересуют Пользователя;</font></font></font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">3.1.2. рубрики Городского Информационного Справочника &laquo;2ГИС&raquo;, к&nbsp;которым относятся организации, данные о&nbsp;которых интересуют Пользователя;</font></font></font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">3.1.3. состав данных;</font></font></font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">3.1.4. количество материалов (опционально);</font></font></font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">3.1.5. формат предоставления доступа посредством Сервиса &laquo;Data.2gis&raquo; (ссылка для загрузки архивного файла в&nbsp;векторном формате или в&nbsp;формате электронной таблицы Excel)</font></font></font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">3.1.6. периодичность предоставления обновлений данных;</font></font></font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">3.1.7. срок предоставления услуг доступа к&nbsp;Сервису &laquo;Data.2gis&raquo;;</font></font></font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">3.1.8. территория;</font></font></font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">3.1.9. доступные дополнительные параметры необходимые для получения данных (наличие интернет-сайта, адреса электронной почты и&nbsp;т.&nbsp;д.).При неуказании Пользователем дополнительных параметров данных Пользователю предоставляются данные с&nbsp;минимальным набором параметров, являющимся обязательным и&nbsp;включающим наименование организации (название фирмы), рубрику, субъект, район субъекта, город, район города, почтовый индекс, улицу, номер дома, этаж, офис и&nbsp;количество филиалов.</font></font></font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">3.2. Заказ может быть составлен с&nbsp;использованием формы обратной связи.</font></font></font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">3.3. На&nbsp;основании полученного Заказа Правообладатель обеспечивает выставление Пользователю Счета на&nbsp;оплату Услуг, содержащего сведения о&nbsp;номере Заказа и&nbsp;стоимости.</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">3.4. Данные, сформированные посредством доступа к&nbsp;Сервису &laquo;Data.2gis&raquo;, доступны в&nbsp;Личном кабинете Пользователя в&nbsp;формате электронной таблицы Excel или ссылки для загрузки архивного файла в&nbsp;векторном формате в&nbsp;соответствии с&nbsp;параметрами, предусмотренными в&nbsp;соответствующем Заказе, не&nbsp;позднее, чем через&nbsp;10 (десять) рабочих дней с&nbsp;момента получения Правообладателем денежных средств в&nbsp;оплату доступа к&nbsp;Сервису в&nbsp;полном объеме по&nbsp;соответствующему Счету.</font></font></font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">3.5. Данные предоставляются Пользователю путем размещения в&nbsp;Личном кабинете в&nbsp;разделе &laquo;Заказы&raquo; ссылки для загрузки архивного файла, содержащего данные в&nbsp;формате электронной таблицы Excel, ссылки для загрузки архивного файла в&nbsp;векторном формате, либо в&nbsp;ином формате (в&nbsp;случае, если данные не&nbsp;могут быть предоставлены в&nbsp;формате Excel). Ссылка активна в&nbsp;течение&nbsp;3 (трех) месяцев после оплаты Заказа.</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\"><span style=\"font-weight: normal\">4. Права и&nbsp;обязанности Сторон</span></font></font><font face=\"Arial, serif\"><font size=\"2\">\n        </font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">4.1. \n        </font></font><font face=\"Arial, serif\"><font size=\"2\"><span style=\"font-weight: normal\">Правообладатель обязуется:</span></font></font><font face=\"Arial, serif\"><font size=\"2\">\n        </font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">4.1.1. предоставить Пользователю доступ к&nbsp;Сервису для формирования данных в&nbsp;формате электронной таблицы Excel или ссылки для загрузки архивного файла в&nbsp;векторном формате в&nbsp;соответствии с&nbsp;параметрами, предусмотренными в&nbsp;соответствующем Заказе;</font></font></font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">4.1.2. предоставлять доступ к&nbsp;Сервису в&nbsp;полном соответствии с&nbsp;Договором, включая Обязательные документы, и&nbsp;требованиями законодательства Российской Федерации.</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">4.2.\n        </font></font><font face=\"Arial, serif\"><font size=\"2\"><span style=\"font-weight: normal\">Правообладатель вправе:</span></font></font><font face=\"Arial, serif\"><font size=\"2\">\n        </font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">4.2.1. не&nbsp;предоставлять доступ к&nbsp;Сервису в&nbsp;случае отсутствия оплаты;</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">4.2.2. приостановить доступ к&nbsp;Сервису в&nbsp;случае нарушения Пользователем требований, предусмотренных Договором, Обязательными документами, а&nbsp;также в&nbsp;иных случаях, установленных законодательством Российской Федерации;</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">4.2.3. осуществлять ограничение отдельных действий Пользователя, если такие действия создают угрозу для нормального функционирования Сервиса и/или Сайта;</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">4.2.4. изменять в&nbsp;одностороннем порядке Обязательные документы без предварительного уведомления Пользователя;</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">4.2.5. привлекать третьих лиц для исполнения своих обязательств по&nbsp;заключенному Договору;</font></font></font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">4.2.6. осуществлять иные права, предусмотренные действующим законодательством Российской Федерации, а&nbsp;также настоящими Правилами, включая Обязательные документы.</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">4.3.\n        </font></font><font face=\"Arial, serif\"><font size=\"2\"><span style=\"font-weight: normal\">Пользователь обязуется:</span></font></font><font face=\"Arial, serif\"><font size=\"2\">\n        </font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">4.3.1. осуществить проверку Заказа до&nbsp;совершения оплаты;</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">4.3.2. оплатить доступ к&nbsp;Сервису по&nbsp;Договору в&nbsp;полном объеме в&nbsp;установленные сроки;</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">4.3.3. проверять наличие уведомлений по&nbsp;адресу электронной почты Пользователя, а&nbsp;также просматривать на&nbsp;Сайте информацию о&nbsp;ходе предоставления доступа к&nbsp;Сервису и&nbsp;формирования данных;</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">4.3.4. в&nbsp;течение срока действия Договора, а&nbsp;также после окончания срока действия Договора не&nbsp;публиковать полученные с&nbsp;помощью Сервиса данные в&nbsp;открытой печати, не&nbsp;предоставлять к&nbsp;ним доступ в&nbsp;иной форме неограниченному кругу лиц, не&nbsp;передавать третьим лицам и&nbsp;использовать их&nbsp;только для решения собственных задач; обеспечивать защиту данных от&nbsp;копирования и&nbsp;извлечения из&nbsp;них материалов в&nbsp;любой форме;</font></font></font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">4.3.5. в&nbsp;отдельных случаях, согласованных Сторонами в&nbsp;отдельном документе, может быть ограничен срок использования данных, полученных с&nbsp;помощью Сервиса;</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">4.3.6. выполнять иные обязанности, предусмотренные Договором, включая Обязательные документы, а&nbsp;также действующим законодательством Российской Федерации.</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">4.4.\n        </font></font><font face=\"Arial, serif\"><font size=\"2\"><span style=\"font-weight: normal\">Пользователь вправе:</span></font></font><font face=\"Arial, serif\"><font size=\"2\">\n        </font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">4.4.1. проверять ход и&nbsp;качество формирования данных по&nbsp;размещенным Заказам путем просмотра уведомлений по&nbsp;адресу электронной почты Пользователя и&nbsp;информации на&nbsp;Сайте;</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">4.4.2. осуществлять иные права, предусмотренные Договором, включая Обязательные документы, а&nbsp;также действующим законодательством Российской Федерации.</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\"><span style=\"font-weight: normal\">5. Стоимость доступа и&nbsp;порядок расчетов</span></font></font><font face=\"Arial, serif\"><font size=\"2\">\n        </font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">5.1. Стоимость доступа к&nbsp;Сервису зависит от&nbsp;параметров Заказа и&nbsp;определяется в&nbsp;соответствии с&nbsp;тарифами Правообладателя, действующими на&nbsp;дату принятия Заказа, и&nbsp;указывается в&nbsp;Счете. НДС не&nbsp;облагается на&nbsp;основании&nbsp;пп.&nbsp;26&nbsp;п.&nbsp;2&nbsp;ст.&nbsp;149 Налогового кодекса Российской Федерации в&nbsp;связи с&nbsp;включением в&nbsp;Единый реестр российских программ для электронных вычислительных машин и&nbsp;баз данных&nbsp;&mdash; запись &#8470; &#8470;&nbsp;24359 от&nbsp;18.10.2024г.</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">5.2. Оплата производится Пользователем путем внесения аванса в&nbsp;размере 100% в&nbsp;течение&nbsp;10 (десяти) рабочих дней с&nbsp;даты выставления Счета. При отсутствии оплаты по&nbsp;выставленному Счету в&nbsp;течение&nbsp;10 (десяти) рабочих дней, Правообладатель вправе не&nbsp;принимать оплату по&nbsp;данному Счету и&nbsp;аннулировать Счет вместе с&nbsp;соответствующим Заказом.</font></font></font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">5.3. Расчеты по&nbsp;Договору производятся с&nbsp;использованием указанных на&nbsp;Сайте способов оплаты.</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">5.4. Пользователь считается исполнившим свои обязательства по&nbsp;оплате доступа к&nbsp;Сервису с&nbsp;момента поступления денежных средств на&nbsp;расчетный счет Правообладателя в&nbsp;установленном размере, если иное не&nbsp;предусмотрено законодательством Российской Федерации.\n        </font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">5.5. Оплата производится Пользователем с&nbsp;указанием номера Заказа, а&nbsp;также данных, идентифицирующих Пользователя: фамилия, имя и&nbsp;отчество Пользователя&nbsp;&mdash; физического лица или наименование юридического лица, от&nbsp;имени которого действует Пользователь.</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">При отсутствии&nbsp;и (или) неправильном указании перечисленных в&nbsp;настоящем пункте данных, Правообладатель вправе считать, что обязательство по&nbsp;оплате не&nbsp;исполнено Пользователем надлежащим образом, либо самостоятельно идентифицировать платеж согласно данным собственного учета. Правообладатель не&nbsp;несет ответственность за&nbsp;убытки, которые могут возникнуть у&nbsp;Пользователя&nbsp;и (или) третьих лиц, в&nbsp;случае неправильного указания назначения платежа&nbsp;и (или) иных реквизитов.</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\"><span style=\"font-weight: normal\">6. Закрывающие документы</span></font></font><font face=\"Arial, serif\"><font size=\"2\">\n        </font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">6.1. В&nbsp;день окончания формирования данных согласно&nbsp;п.&nbsp;3.4 настоящих Правил Правообладатель составляет первичный учетный документ (далее&nbsp;&mdash; &laquo;Первичный документ&raquo;) Первичным документом является односторонний акт оказания услуг, подписанный Правообладателем, в&nbsp;момент предоставления доступа к&nbsp;Сервису и&nbsp;соответствующему Заказу Пользователя в&nbsp;электронном виде в&nbsp;разделе &laquo;Заказы&raquo; не&nbsp;позднее&nbsp;5 (пяти) рабочих дней с&nbsp;даты его составления. При этом акт, подписанный Правообладателем в&nbsp;одностороннем порядке, имеет полную юридическую силу.</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">6.2. Стороны признают и&nbsp;безоговорочно соглашаются с&nbsp;тем, что сведения о&nbsp;сформированных данных указываются в&nbsp;Первичном документе на&nbsp;основе данных внутренней учетной системы Правообладателя, а&nbsp;данные Пользователя (фамилия, имя, отчество или наименование юридического лица) указываются в&nbsp;Первичном документе в&nbsp;соответствии с&nbsp;данными, указанными Пользователем при регистрации на&nbsp;Сайте.</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">6.3. Пользователь вправе по&nbsp;запросу получить Первичный документ на&nbsp;бумажном носителе средствами почтовой связи или с&nbsp;использованием электронного документооборота.</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">6.4. В&nbsp;случае непредставления Пользователем Правообладателю письменных возражений по&nbsp;составленному Первичному документу до&nbsp;15 (пятнадцатого) числа месяца, следующего за&nbsp;датой размещения данных в&nbsp;Личном кабинете, доступ к&nbsp;Сервису считается предоставленным Пользователю в&nbsp;полном объеме по&nbsp;соответствующему Заказу без замечаний.</font></font></font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\"><a name=\"_GoBack\"></a>\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\"><span style=\"font-weight: normal\">7. Гарантии сторон</span></font></font></font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">7.1. Правообладатель гарантирует:</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">7.1.1. принадлежность ему Сервиса, Сайта и&nbsp;данных из&nbsp;</font></font><font face=\"Arial, serif\"><font size=\"2\">Городского Информационного Справочника &laquo;2ГИС&raquo;</font></font><font face=\"Arial, serif\"><font size=\"2\"> в&nbsp;объеме, необходимом для надлежащего исполнения обязательств по&nbsp;Договору;</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">7.1.2. предоставление доступа к&nbsp;Сервису по&nbsp;Договору в&nbsp;полном соответствии с&nbsp;настоящими Правилами и&nbsp;Обязательными документами.</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">7.2. Правообладатель не&nbsp;предоставляет никаких гарантий и&nbsp;не&nbsp;принимает на&nbsp;себя никаких обязательств в&nbsp;отношении:</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">7.2.1. точности, полноты, актуальности данных из&nbsp;</font></font><font face=\"Arial, serif\"><font size=\"2\">Городского Информационного Справочника &laquo;2ГИС&raquo;</font></font><font face=\"Arial, serif\"><font size=\"2\">, их&nbsp;соответствия требованиям или ожиданиям Пользователя&nbsp;и (или) их&nbsp;пригодности для определенной цели;</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">7.2.2. предоставления непрерывного доступа к&nbsp;Сайту, отсутствия ошибок в&nbsp;его программном обеспечении, возможности и&nbsp;сроков их&nbsp;устранения.</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">7.3. Пользователь гарантирует:</font></font></font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">7.3.1. обеспечение конфиденциальности своих регистрационных данных (логина и&nbsp;пароля). Пользователь не&nbsp;имеет права передавать свои регистрационные данные (логин и&nbsp;пароль) третьим лицам, несет полную ответственность за&nbsp;их&nbsp;сохранность, самостоятельно выбирая способ их&nbsp;хранения. Любые действия, совершенные с&nbsp;использованием регистрационных данных Пользователя, считаются совершенными таким Пользователем.</font></font></font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%\">\n        <font face=\"Arial, serif\"><font size=\"2\">8. Ответственность сторон</font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%\">\n        <font face=\"Arial, serif\"><font size=\"2\">8.1. За&nbsp;неисполнение или ненадлежащее исполнение обязательств по&nbsp;Договору Стороны несут ответственность в&nbsp;соответствии с&nbsp;действующим законодательством Российской Федерации и&nbsp;положениями настоящих Правил.</font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%\">\n        <font face=\"Arial, serif\"><font size=\"2\">8.2. В&nbsp;случае нарушения Пользователем обязательств, предусмотренных&nbsp;п.&nbsp;4.3.4 настоящих Правил, Правообладатель вправе потребовать от&nbsp;Пользователя уплаты штрафной неустойки в&nbsp;размере 30000 (тридцать тысяч) рублей за&nbsp;каждый случай такого нарушения.</font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%\">\n        <font face=\"Arial, serif\"><font size=\"2\">8.3. Ответственность Правообладателя по&nbsp;Договору ограничивается возмещением причиненного Пользователю реального ущерба в&nbsp;сумме, не&nbsp;превышающей оплаченную стоимость доступа по&nbsp;соответствующему Заказу.</font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%\">\n        <font face=\"Arial, serif\"><font size=\"2\">8.4. Уплата любых неустоек в&nbsp;случае неисполнения&nbsp;и (или) ненадлежащего исполнения Стороной обязательств, предусмотренных Договором, не&nbsp;освобождает Сторону от&nbsp;обязанности надлежащего исполнения таких обязательств.\n        </font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%\">\n        <font face=\"Arial, serif\"><font size=\"2\">8.5. Пункты настоящих Правил, предусматривающие уплату неустойки, штрафов, пени, применяются по&nbsp;требованию Стороны, обладающей правом на&nbsp;их&nbsp;взыскание. Непредъявленные штрафные санкции не&nbsp;начисляются и&nbsp;не&nbsp;уплачиваются.</font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\"><span style=\"font-weight: normal\">9. Обстоятельства непреодолимой силы (форс-мажор)</span></font></font><font face=\"Arial, serif\"><font size=\"2\">\n        </font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">9.1. Стороны освобождаются от&nbsp;ответственности за&nbsp;частичное или полное неисполнение обязательств по&nbsp;Договору, вызванное обстоятельствами непреодолимой силы, возникшими после его заключения. К&nbsp;таким обстоятельствам, в&nbsp;частности, стороны относят: стихийные бедствия; природные и&nbsp;промышленные катастрофы; террористические акты; военные действия; гражданские беспорядки; принятие органами государственной власти или органами местного самоуправления актов, содержащих запреты или ограничения в&nbsp;отношении деятельности сторон по&nbsp;Договору; или иными обстоятельствами которые не&nbsp;зависят от&nbsp;воли Сторон и&nbsp;делают невозможным исполнение обязательств по&nbsp;Договору (сбои, возникшие в&nbsp;телекоммуникационных и&nbsp;энергетических сетях, действие вредоносных программ, а&nbsp;также недобросовестные действия третьих лиц, выразившиеся в&nbsp;действиях, направленных на&nbsp;несанкционированный доступ и&nbsp;(или) выведение из&nbsp;строя программного и&nbsp;(или) аппаратного комплекса любой из&nbsp;Сторон <nobr>и т. д.</nobr>).</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">9.2. При наступлении обстоятельств непреодолимой силы, препятствующих исполнению обязательств по&nbsp;Договору, срок оказания Сторонами своих обязательств переносится соразмерно времени действия таких обстоятельств, а&nbsp;также времени, требуемого для устранения их&nbsp;последствий, но&nbsp;не&nbsp;более&nbsp;60 (шестидесяти) календарных дней. В&nbsp;случае если обстоятельства непреодолимой силы продолжают действовать свыше указанного срока, либо когда при их&nbsp;наступлении обеим Сторонам становится очевидным, что они будут действовать более этого срока, Договор прекращает свое действие.</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\"><span style=\"font-weight: normal\">10. Уведомления</span></font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\"><span style=\"font-weight: normal\">10.1. Пользователь соглашается получать на&nbsp;адрес электронной почты, указанный им&nbsp;при регистрации на&nbsp;Сайте или в&nbsp;ходе исполнения Договора, информационные сообщения (далее&nbsp;&mdash; &laquo;Уведомления&raquo;) на&nbsp;нижеследующих условиях:</span></font></font></font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\"><span style=\"font-weight: normal\">10.1.1. Правообладатель обязуется использовать Уведомления исключительно для информирования Пользователя о&nbsp;ходе исполнения заключенного Договора, его изменении или досрочном прекращении, изменениях в&nbsp;работе Сервиса и/или Сайта, а&nbsp;также проводимых акциях, скидках и&nbsp;новых возможностях в&nbsp;Продуктах 2ГИС.</span></font></font></font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\"><span style=\"font-weight: normal\">10.1.2. Правообладатель обязуется не&nbsp;сопровождать Уведомления рекламными сообщениями от&nbsp;третьих лиц.</span></font></font></font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\"><span style=\"font-weight: normal\">11. Срок действия и&nbsp;изменение условий Оферты</span></font></font><font face=\"Arial, serif\"><font size=\"2\">\n        </font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">11.1. Оферта вступает в&nbsp;силу с&nbsp;момента размещения на&nbsp;Сайте и&nbsp;действует до&nbsp;момента ее&nbsp;отзыва и/или изменения в&nbsp;соответствии, если иной срок действия не&nbsp;определен Офертой или Обязательными документами.</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">11.2. Оферта может быть изменена и/или отозвана в&nbsp;любой момент. Сведения об&nbsp;изменении или отзыве Оферты доводятся до&nbsp;Пользователя по&nbsp;выбору Владельца сервиса посредством размещения на&nbsp;Сайте либо путем направления соответствующего уведомления на&nbsp;электронный адрес, указанный Пользователем в&nbsp;Счёт-оферте.</font></font></font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">11.3. В&nbsp;случае отзыва Оферты или внесения в&nbsp;нее изменений, последние вступают в&nbsp;силу с&nbsp;момента доведения об&nbsp;этом сведений до&nbsp;Пользователя, если иной срок вступления их&nbsp;в&nbsp;силу не&nbsp;определен Офертой или дополнительно при таком сообщении.</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">11.4. Пользователь соглашается и&nbsp;признает, что внесение изменений в&nbsp;Оферту влечет за&nbsp;собой внесение этих изменений в&nbsp;заключенный и&nbsp;действующий между Пользователем и&nbsp;Владельцем сервиса Договор.</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">11.5. В&nbsp;случае отзыва Оферты Владельцем сервиса в&nbsp;течение срока действия Договора, Договор считается прекращенным с&nbsp;момента ее&nbsp;отзыва, если иное не&nbsp;оговорено Владельцем сервиса при отзыве Оферты.</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\"><span style=\"font-weight: normal\">12. Заключительные положения</span></font></font><font face=\"Arial, serif\"><font size=\"2\">\n        </font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">12.1. Договор, его заключение и&nbsp;исполнение регулируется действующим законодательством Российской Федерации. Все вопросы, не&nbsp;урегулированные Договором в&nbsp;соответствии с&nbsp;настоящей Офертой или урегулированные не&nbsp;полностью, регулируются в&nbsp;соответствии с&nbsp;материальным правом Российской Федерации.</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">12.2. Стороны согласовали, что к&nbsp;взаимоотношениям Сторон применяются следующие положения:</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">12.2.1. положения Оговорки о&nbsp;соблюдении антикоррупционного законодательства, размещенной по&nbsp;адресу: <a target=\"_blank\" href=\"https://law.2gis.ru/clause/anti-corruption-clause\"><font color=\"#00000a\"><font face=\"Arial, serif\"><font size=\"2\">https://law.2gis.ru/clause/anti-corruption-clause</font></font></font></a>;</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">12.2.2. положения Оговорки о&nbsp;конфиденциальности, размещенной по&nbsp;адресу: <a target=\"_blank\" href=\"https://law.2gis.ru/clause/privacy-clause\"><font color=\"#00000a\"><font face=\"Arial, serif\"><font size=\"2\">https://law.2gis.ru/clause/privacy-clause</font></font></font></a>;</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">12.2.3. положения Оговорки о&nbsp;персональных данных, размещенной по&nbsp;адресу: <a target=\"_blank\" href=\"https://law.2gis.ru/clause/personal-data-clause\"><font color=\"#00000a\"><font face=\"Arial, serif\"><font size=\"2\">https://law.2gis.ru/clause/personal-data-clause</font></font></font></a>.</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">12.3. Все уведомления и&nbsp;прочие документы по&nbsp;Договору, если иное не&nbsp;предусмотрено Офертой, должны направляться по&nbsp;адресам электронной почты уполномоченных лиц Сторон, указанным в&nbsp;Счёте.</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">12.4. Если какое-то из&nbsp;положений Оферты будет признано недействительным, то&nbsp;законность&nbsp;/ действительность ее&nbsp;остальных положений от&nbsp;этого не&nbsp;утрачивается.</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">12.5. Действующая редакция Оферты размещена на&nbsp;Сайте в&nbsp;сети Интернет по&nbsp;адресу: <a target=\"_blank\" href=\"https://data.2gis.com/terms\"><font color=\"#00000a\"><font face=\"Arial, serif\"><font size=\"2\">https://data.2gis.com/terms</font></font></font></a></font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\"><span style=\"font-weight: normal\">13. Реквизиты Правообладателя</span></font></font><font face=\"Arial, serif\"><font size=\"2\"></font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-bottom: 0in; line-height: 100%\"><font face=\"Times New Roman, serif\">\n        <font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\"><span style=\"font-weight: normal\">ООО &laquo;ДубльГИС&raquo;</span></font></font><font face=\"Arial, serif\"><font size=\"2\">\n    </font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-bottom: 0in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">ОГРН 1045401929847, ИНН 5405276278, КПП 540401001</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-bottom: 0in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">Адрес: Российская Федерация, 630048, г. Новосибирск, пл. Карла Маркса, д.&nbsp;7</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-bottom: 0in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">р/с 40702810744050005734 Сибирский банк ОАО &laquo;Сбербанк России&raquo; г. Новосибирск</font></font></font></font>\n    </p>\n    <p align=\"JUSTIFY\" style=\"margin-bottom: 0.12in; line-height: 100%\"><font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">к/с 30101810500000000641&nbsp;БИК 045004641</font></font></font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.12in; margin-bottom: 0.12in; line-height: 100%\">\n        <font face=\"Times New Roman, serif\"><font size=\"3\"><font face=\"Arial, serif\"><font size=\"2\">Все юридически значимые сообщения следует направлять в&nbsp;ООО &laquo;ДубльГИС&raquo; по&nbsp;адресу: </font></font>\n            <font face=\"Arial, serif\"><font size=\"2\">630032, г. Новосибирск, а/я 35.</font></font></font></font></p>\n    <p align=\"JUSTIFY\" style=\"margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%\"><font face=\"Arial, serif\"><font size=\"2\">Редакция от&nbsp;29.11.2024</font></font></p>\n</div>\n";
	},"useData":true});

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"content") : stack1), depth0))
	    + "\">\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"videoContainer") : stack1), depth0))
	    + "\">\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"title") : stack1), depth0))
	    + "\">Видеоурок об основных функциях сервиса</div>\n        <div id=\"ytplayer\"></div>\n    </div>\n</div>\n";
	},"useData":true});

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "    <tr class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"weekTitles") : stack1), depth0))
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"daysLabels") : depth0),{"name":"each","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":6},"end":{"line":13,"column":15}}})) != null ? stack1 : "")
	    + "    </tr>\n";
	},"2":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "      <td class=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"weekTitle") : stack1), depth0))
	    + "\">\n        <div class=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"weekTitleText") : stack1), depth0))
	    + "\">"
	    + alias2(alias1(depth0, depth0))
	    + "</div>\n      </td>\n";
	},"4":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "    <tr>\n"
	    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"each","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":19,"column":6},"end":{"line":30,"column":15}}})) != null ? stack1 : "")
	    + "    </tr>\n";
	},"5":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), alias4=container.hooks.helperMissing, alias5="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "      <td class=\""
	    + alias2(alias1(((stack1 = (depths[2] != null ? lookupProperty(depths[2],"css") : depths[2])) != null ? lookupProperty(stack1,"item") : stack1), depth0))
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isHidden") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":20,"column":35},"end":{"line":20,"column":85}}})) != null ? stack1 : "")
	    + "\">\n        <div class=\""
	    + alias2(alias1(((stack1 = (depths[2] != null ? lookupProperty(depths[2],"css") : depths[2])) != null ? lookupProperty(stack1,"itemText") : stack1), depth0))
	    + "\n          "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depths[2] != null ? lookupProperty(depths[2],"mode") : depths[2]),{"name":"if","hash":{},"fn":container.program(8, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":22,"column":10},"end":{"line":22,"column":66}}})) != null ? stack1 : "")
	    + "\n          "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isDisabled") : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":23,"column":10},"end":{"line":23,"column":60}}})) != null ? stack1 : "")
	    + "\n          "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isInRange") : depth0),{"name":"if","hash":{},"fn":container.program(12, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":24,"column":10},"end":{"line":24,"column":58}}})) != null ? stack1 : "")
	    + "\n          "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isBoundOfRange") : depth0),{"name":"if","hash":{},"fn":container.program(14, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":25,"column":10},"end":{"line":25,"column":68}}})) != null ? stack1 : "")
	    + "\"\n          cat-date=\""
	    + alias2(((helper = (helper = lookupProperty(helpers,"unixDate") || (depth0 != null ? lookupProperty(depth0,"unixDate") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"unixDate","hash":{},"data":data,"loc":{"start":{"line":26,"column":20},"end":{"line":26,"column":32}}}) : helper)))
	    + "\">\n            "
	    + alias2(((helper = (helper = lookupProperty(helpers,"date") || (depth0 != null ? lookupProperty(depth0,"date") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"date","hash":{},"data":data,"loc":{"start":{"line":27,"column":12},"end":{"line":27,"column":20}}}) : helper)))
	    + "\n        </div>\n      </td>\n";
	},"6":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return " "
	    + container.escapeExpression(container.lambda(((stack1 = (depths[2] != null ? lookupProperty(depths[2],"css") : depths[2])) != null ? lookupProperty(stack1,"_notInPeriod") : stack1), depth0));
	},"8":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(lookupProperty(helpers,"lookup").call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[2] != null ? lookupProperty(depths[2],"css") : depths[2]),(depths[2] != null ? lookupProperty(depths[2],"mode") : depths[2]),{"name":"lookup","hash":{},"data":data,"loc":{"start":{"line":22,"column":28},"end":{"line":22,"column":59}}}));
	},"10":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = (depths[2] != null ? lookupProperty(depths[2],"css") : depths[2])) != null ? lookupProperty(stack1,"_isDisabled") : stack1), depth0));
	},"12":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = (depths[2] != null ? lookupProperty(depths[2],"css") : depths[2])) != null ? lookupProperty(stack1,"_isInRange") : stack1), depth0));
	},"14":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = (depths[2] != null ? lookupProperty(depths[2],"css") : depths[2])) != null ? lookupProperty(stack1,"_isBoundOfRange") : stack1), depth0));
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"content") : stack1), depth0))
	    + "\">\n  <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"monthName") : stack1), depth0))
	    + "\">\n    "
	    + alias2(((helper = (helper = lookupProperty(helpers,"periodTitle") || (depth0 != null ? lookupProperty(depth0,"periodTitle") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(alias3,{"name":"periodTitle","hash":{},"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":3,"column":19}}}) : helper)))
	    + "\n  </div>\n\n  <table class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"table") : stack1), depth0))
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"daysLabels") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":4},"end":{"line":15,"column":11}}})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = lookupProperty(helpers,"each").call(alias3,(depth0 != null ? lookupProperty(depth0,"content") : depth0),{"name":"each","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":17,"column":4},"end":{"line":32,"column":13}}})) != null ? stack1 : "")
	    + "  </table>\n</div>\n";
	},"useData":true,"useDepths":true});

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"isDisabled") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"isDisabled") : stack1), depth0));
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"isOpen") : stack1), depth0));
	},"5":function(container,depth0,helpers,partials,data) {
	    return "checked";
	},"7":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), alias4=container.hooks.helperMissing, alias5="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "                    <li class=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"option") : stack1), depth0))
	    + "\">\n                      <span class=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"optionWrapper") : stack1), depth0))
	    + "\">\n                        <input type=\"checkbox\"\n                               cat-key=\""
	    + alias2(((helper = (helper = lookupProperty(helpers,"key") || (depth0 != null ? lookupProperty(depth0,"key") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"key","hash":{},"data":data,"loc":{"start":{"line":22,"column":40},"end":{"line":22,"column":47}}}) : helper)))
	    + "\"\n                               class=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"checkbox") : stack1), depth0))
	    + "\"\n                               id=\"input-option"
	    + alias2(((helper = (helper = lookupProperty(helpers,"key") || (data && lookupProperty(data,"key"))) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"key","hash":{},"data":data,"loc":{"start":{"line":24,"column":47},"end":{"line":24,"column":55}}}) : helper)))
	    + "\"\n                            "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isSelected") : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":25,"column":28},"end":{"line":25,"column":61}}})) != null ? stack1 : "")
	    + ">\n                        <label class=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"label") : stack1), depth0))
	    + "\" for=\"input-option"
	    + alias2(((helper = (helper = lookupProperty(helpers,"key") || (data && lookupProperty(data,"key"))) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"key","hash":{},"data":data,"loc":{"start":{"line":26,"column":73},"end":{"line":26,"column":81}}}) : helper)))
	    + "\">"
	    + alias2(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"name","hash":{},"data":data,"loc":{"start":{"line":26,"column":83},"end":{"line":26,"column":91}}}) : helper)))
	    + "</label>\n                      </span>\n                    </li>\n";
	},"8":function(container,depth0,helpers,partials,data) {
	    return " checked";
	},"10":function(container,depth0,helpers,partials,data) {
	    return "disabled";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), alias4=container.hooks.helperMissing, alias5="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"wrapper") : stack1), depth0))
	    + "\">\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"select") : stack1), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isDisabled") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":31},"end":{"line":2,"column":93}}})) != null ? stack1 : "")
	    + "\">\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"selectTitle") : stack1), depth0))
	    + "\">"
	    + alias2(((helper = (helper = lookupProperty(helpers,"title") || (depth0 != null ? lookupProperty(depth0,"title") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"title","hash":{},"data":data,"loc":{"start":{"line":3,"column":41},"end":{"line":3,"column":50}}}) : helper)))
	    + "</div>\n    </div>\n\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"dropdown") : stack1), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isOpen") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":33},"end":{"line":6,"column":68}}})) != null ? stack1 : "")
	    + "\">\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"scrollTrack") : stack1), depth0))
	    + "\">\n            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"scrollbar") : stack1), depth0))
	    + "\"></div>\n        </div>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"content") : stack1), depth0))
	    + "\">\n            <ul class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"options") : stack1), depth0))
	    + "\">\n                <li class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"option") : stack1), depth0))
	    + "\">\n                    <span class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"optionWrapper") : stack1), depth0))
	    + "\">\n                      <input type=\"checkbox\" class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"checkbox") : stack1), depth0))
	    + "\" id=\"allOptions\" "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"allSelected") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":86},"end":{"line":14,"column":119}}})) != null ? stack1 : "")
	    + ">\n                      <label class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"label") : stack1), depth0))
	    + "\" for=\"allOptions\">"
	    + alias2(((helper = (helper = lookupProperty(helpers,"allOptionsText") || (depth0 != null ? lookupProperty(depth0,"allOptionsText") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"allOptionsText","hash":{},"data":data,"loc":{"start":{"line":15,"column":68},"end":{"line":15,"column":86}}}) : helper)))
	    + "</label>\n                    </span>\n                </li>\n"
	    + ((stack1 = lookupProperty(helpers,"each").call(alias3,(depth0 != null ? lookupProperty(depth0,"options") : depth0),{"name":"each","hash":{},"fn":container.program(7, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":18,"column":16},"end":{"line":29,"column":25}}})) != null ? stack1 : "")
	    + "            </ul>\n\n            <button class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"button") : stack1), depth0))
	    + "\" "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"allUnchecked") : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":32,"column":43},"end":{"line":32,"column":78}}})) != null ? stack1 : "")
	    + ">"
	    + alias2(((helper = (helper = lookupProperty(helpers,"buttonText") || (depth0 != null ? lookupProperty(depth0,"buttonText") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"buttonText","hash":{},"data":data,"loc":{"start":{"line":32,"column":79},"end":{"line":32,"column":93}}}) : helper)))
	    + "</button>\n        </div>\n    </div>\n</div>\n";
	},"useData":true,"useDepths":true});

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "checked";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), alias4=container.hooks.helperMissing, alias5="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"wrapper") : stack1), depth0))
	    + "\">\n  <span class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"label") : stack1), depth0))
	    + "\">\n    <input\n      type=\"checkbox\"\n      id=\"checkbox-"
	    + alias2(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":5,"column":19},"end":{"line":5,"column":25}}}) : helper)))
	    + "\"\n      class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"checkbox") : stack1), depth0))
	    + "\"\n      "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"value") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":6},"end":{"line":7,"column":33}}})) != null ? stack1 : "")
	    + ">\n    <label for=\"checkbox-"
	    + alias2(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":8,"column":25},"end":{"line":8,"column":31}}}) : helper)))
	    + "\" class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"title") : stack1), depth0))
	    + "\">"
	    + alias2(((helper = (helper = lookupProperty(helpers,"title") || (depth0 != null ? lookupProperty(depth0,"title") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"title","hash":{},"data":data,"loc":{"start":{"line":8,"column":55},"end":{"line":8,"column":64}}}) : helper)))
	    + "</label>\n  </span>\n</div>\n";
	},"useData":true});

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return " "
	    + container.escapeExpression(lookupProperty(helpers,"lookup").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"css") : depth0),(depth0 != null ? lookupProperty(depth0,"mod") : depth0),{"name":"lookup","hash":{},"data":data,"loc":{"start":{"line":1,"column":56},"end":{"line":1,"column":74}}}));
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return " "
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"isDisabled") : stack1), depth0));
	},"5":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "      <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"clearButton") : stack1), depth0))
	    + "\"></div>\n";
	},"7":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "      <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"appearButtonFrom") : stack1), depth0))
	    + "\">\n        "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"title") : depth0)) != null ? lookupProperty(stack1,"from") : stack1), depth0))
	    + "\n      </div>\n      &ndash;\n      <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"appearButtonTo") : stack1), depth0))
	    + "\">\n        "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"title") : depth0)) != null ? lookupProperty(stack1,"till") : stack1), depth0))
	    + "\n      </div>\n";
	},"9":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "      "
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"title") : depth0)) != null ? lookupProperty(stack1,"date") : stack1), depth0))
	    + "\n";
	},"11":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return " "
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"isOpen") : stack1), depth0));
	},"13":function(container,depth0,helpers,partials,data) {
	    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(lookupProperty(helpers,"lookup").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"css") : depth0),(depth0 != null ? lookupProperty(depth0,"mod") : depth0),{"name":"lookup","hash":{},"data":data,"loc":{"start":{"line":20,"column":79},"end":{"line":20,"column":97}}}));
	},"15":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), alias4=container.hooks.helperMissing, alias5="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "          <cat-calendar\n            id=\"calendar-"
	    + alias2(alias1((depths[1] != null ? lookupProperty(depths[1],"id") : depths[1]), depth0))
	    + alias2(((helper = (helper = lookupProperty(helpers,"key") || (data && lookupProperty(data,"key"))) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"key","hash":{},"data":data,"loc":{"start":{"line":30,"column":34},"end":{"line":30,"column":42}}}) : helper)))
	    + "\"\n            cat-datepicker-id=\""
	    + alias2(alias1((depths[1] != null ? lookupProperty(depths[1],"id") : depths[1]), depth0))
	    + "\"\n            cat-type=\""
	    + alias2(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"type","hash":{},"data":data,"loc":{"start":{"line":32,"column":22},"end":{"line":32,"column":30}}}) : helper)))
	    + "\"\n            cat-afrom=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"availableRange") : depths[1])) != null ? lookupProperty(stack1,"from") : stack1), depth0))
	    + "\"\n            cat-atill=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"availableRange") : depths[1])) != null ? lookupProperty(stack1,"till") : stack1), depth0))
	    + "\"\n            cat-rfrom=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"range") : depths[1])) != null ? lookupProperty(stack1,"from") : stack1), depth0))
	    + "\"\n            cat-rtill=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"range") : depths[1])) != null ? lookupProperty(stack1,"till") : stack1), depth0))
	    + "\"\n            cat-selected-date=\""
	    + alias2(alias1((depths[1] != null ? lookupProperty(depths[1],"selectedDate") : depths[1]), depth0))
	    + "\"\n            cat-select-date=\""
	    + alias2(alias1((depths[1] != null ? lookupProperty(depths[1],"selectDateSignal") : depths[1]), depth0))
	    + "\"\n            cat-date=\""
	    + alias2(((helper = (helper = lookupProperty(helpers,"date") || (depth0 != null ? lookupProperty(depth0,"date") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"date","hash":{},"data":data,"loc":{"start":{"line":39,"column":22},"end":{"line":39,"column":30}}}) : helper)))
	    + "\"\n            class=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"calendar") : stack1), depth0))
	    + "\">\n          </cat-calendar>\n";
	},"17":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "          <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"periods") : stack1), depth0))
	    + "\">\n            <input class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"period") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"from") : stack1), depth0))
	    + "\"\n                   type=\"text\" value=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"selectorDates") : depth0)) != null ? lookupProperty(stack1,"from") : stack1), depth0))
	    + "\">\n            &nbsp;&ndash;&nbsp;\n            <input class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"period") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"till") : stack1), depth0))
	    + "\"\n                   type=\"text\" value=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"selectorDates") : depth0)) != null ? lookupProperty(stack1,"till") : stack1), depth0))
	    + "\">\n          </div>\n";
	},"19":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "          <div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"selectButton") : stack1), depth0))
	    + "\">\n            Выбрать\n          </div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"wrapper") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"noSelect") : stack1), depth0))
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"mod") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":44},"end":{"line":1,"column":81}}})) != null ? stack1 : "")
	    + "\">\n  <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"appearButton") : stack1), depth0))
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isDisabled") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":34},"end":{"line":2,"column":78}}})) != null ? stack1 : "")
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,((stack1 = (depth0 != null ? lookupProperty(depth0,"title") : depth0)) != null ? lookupProperty(stack1,"date") : stack1),{"name":"if","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":5,"column":11}}})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,((stack1 = (depth0 != null ? lookupProperty(depth0,"title") : depth0)) != null ? lookupProperty(stack1,"from") : stack1),{"name":"if","hash":{},"fn":container.program(7, data, 0, blockParams, depths),"inverse":container.program(9, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":7,"column":4},"end":{"line":17,"column":11}}})) != null ? stack1 : "")
	    + "  </div>\n\n  <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"container") : stack1), depth0))
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isOpen") : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":20,"column":31},"end":{"line":20,"column":67}}})) != null ? stack1 : "")
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"mod") : depth0),{"name":"if","hash":{},"fn":container.program(13, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":20,"column":68},"end":{"line":20,"column":104}}})) != null ? stack1 : "")
	    + "\">\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"content") : stack1), depth0))
	    + "\">\n      <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"navigation") : stack1), depth0))
	    + "\">\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"arrow") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"left") : stack1), depth0))
	    + "\"></div>\n        <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"arrow") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"right") : stack1), depth0))
	    + "\"></div>\n      </div>\n\n      <div>\n"
	    + ((stack1 = lookupProperty(helpers,"each").call(alias3,(depth0 != null ? lookupProperty(depth0,"calendars") : depth0),{"name":"each","hash":{},"fn":container.program(15, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":28,"column":8},"end":{"line":42,"column":17}}})) != null ? stack1 : "")
	    + "      </div>\n\n      <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"panel") : stack1), depth0))
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"withInputs") : depth0),{"name":"if","hash":{},"fn":container.program(17, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":46,"column":8},"end":{"line":54,"column":15}}})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = lookupProperty(helpers,"unless").call(alias3,(depth0 != null ? lookupProperty(depth0,"withoutButton") : depth0),{"name":"unless","hash":{},"fn":container.program(19, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":56,"column":8},"end":{"line":60,"column":19}}})) != null ? stack1 : "")
	    + "      </div>\n    </div>\n  </div>\n</div>\n";
	},"useData":true,"useDepths":true});

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(((helper = (helper = lookupProperty(helpers,"skin") || (depth0 != null ? lookupProperty(depth0,"skin") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"skin","hash":{},"data":data,"loc":{"start":{"line":1,"column":39},"end":{"line":1,"column":47}}}) : helper)));
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"isDisabled") : stack1), depth0));
	},"5":function(container,depth0,helpers,partials,data) {
	    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(lookupProperty(helpers,"lookup").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"css") : depth0),(depth0 != null ? lookupProperty(depth0,"sizeMod") : depth0),{"name":"lookup","hash":{},"data":data,"loc":{"start":{"line":2,"column":75},"end":{"line":2,"column":97}}}));
	},"7":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"error")), depth0));
	},"9":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isActive") : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":10},"end":{"line":9,"column":17}}})) != null ? stack1 : "");
	},"10":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "              "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"form") : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":14},"end":{"line":7,"column":55}}})) != null ? stack1 : "")
	    + "\n              "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"color") : depth0),{"name":"if","hash":{},"fn":container.program(13, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":14},"end":{"line":8,"column":57}}})) != null ? stack1 : "")
	    + "\n";
	},"11":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(lookupProperty(helpers,"lookup").call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? lookupProperty(depths[1],"css") : depths[1]),(depth0 != null ? lookupProperty(depth0,"form") : depth0),{"name":"lookup","hash":{},"data":data,"loc":{"start":{"line":7,"column":26},"end":{"line":7,"column":48}}}));
	},"13":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(lookupProperty(helpers,"lookup").call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? lookupProperty(depths[1],"css") : depths[1]),(depth0 != null ? lookupProperty(depth0,"color") : depth0),{"name":"lookup","hash":{},"data":data,"loc":{"start":{"line":8,"column":27},"end":{"line":8,"column":50}}}));
	},"15":function(container,depth0,helpers,partials,data) {
	    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "      "
	    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"header") || (depth0 != null ? lookupProperty(depth0,"header") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"header","hash":{},"data":data,"loc":{"start":{"line":13,"column":6},"end":{"line":13,"column":16}}}) : helper)))
	    + "\n";
	},"17":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"options") : depth0),{"name":"each","hash":{},"fn":container.program(18, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":15,"column":6},"end":{"line":17,"column":15}}})) != null ? stack1 : "");
	},"18":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        "
	    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isActive") : depth0),{"name":"if","hash":{},"fn":container.program(19, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":8},"end":{"line":16,"column":40}}})) != null ? stack1 : "")
	    + "\n";
	},"19":function(container,depth0,helpers,partials,data) {
	    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(((helper = (helper = lookupProperty(helpers,"title") || (depth0 != null ? lookupProperty(depth0,"title") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"title","hash":{},"data":data,"loc":{"start":{"line":16,"column":24},"end":{"line":16,"column":33}}}) : helper)));
	},"21":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"isOpen") : stack1), depth0));
	},"23":function(container,depth0,helpers,partials,data) {
	    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "name=\""
	    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":28,"column":26},"end":{"line":28,"column":34}}}) : helper)))
	    + "-field\"";
	},"25":function(container,depth0,helpers,partials,data) {
	    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "placeholder=\""
	    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"filterPlaceholder") || (depth0 != null ? lookupProperty(depth0,"filterPlaceholder") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"filterPlaceholder","hash":{},"data":data,"loc":{"start":{"line":29,"column":46},"end":{"line":29,"column":67}}}) : helper)))
	    + "\"";
	},"27":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, helper, alias1=container.escapeExpression, alias2=depth0 != null ? depth0 : (container.nullContext || {}), alias3=container.hooks.helperMissing, alias4="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias1(container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"option") : stack1), depth0))
	    + "\n        "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias2,(depth0 != null ? lookupProperty(depth0,"form") : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":37,"column":8},"end":{"line":37,"column":49}}})) != null ? stack1 : "")
	    + "\n        "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias2,(depth0 != null ? lookupProperty(depth0,"color") : depth0),{"name":"if","hash":{},"fn":container.program(13, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":38,"column":8},"end":{"line":38,"column":51}}})) != null ? stack1 : "")
	    + "\n        "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias2,(depth0 != null ? lookupProperty(depth0,"isActive") : depth0),{"name":"if","hash":{},"fn":container.program(28, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":39,"column":8},"end":{"line":39,"column":56}}})) != null ? stack1 : "")
	    + "\"\n         cat-value=\""
	    + alias1(((helper = (helper = lookupProperty(helpers,"value") || (depth0 != null ? lookupProperty(depth0,"value") : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"value","hash":{},"data":data,"loc":{"start":{"line":40,"column":20},"end":{"line":40,"column":29}}}) : helper)))
	    + "\">\n            <span title=\""
	    + alias1(((helper = (helper = lookupProperty(helpers,"title") || (depth0 != null ? lookupProperty(depth0,"title") : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"title","hash":{},"data":data,"loc":{"start":{"line":41,"column":25},"end":{"line":41,"column":34}}}) : helper)))
	    + "\">"
	    + alias1(((helper = (helper = lookupProperty(helpers,"title") || (depth0 != null ? lookupProperty(depth0,"title") : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"title","hash":{},"data":data,"loc":{"start":{"line":41,"column":36},"end":{"line":41,"column":45}}}) : helper)))
	    + "</span>\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias2,(depth0 != null ? lookupProperty(depth0,"subtitle") : depth0),{"name":"if","hash":{},"fn":container.program(30, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":42,"column":10},"end":{"line":46,"column":17}}})) != null ? stack1 : "")
	    + "        </div>\n";
	},"28":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return " "
	    + container.escapeExpression(container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"isHighlighted") : stack1), depth0));
	},"30":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, helper, alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <div class=\""
	    + alias1(container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"subtitle") : stack1), depth0))
	    + "\">\n              "
	    + alias1(((helper = (helper = lookupProperty(helpers,"subtitle") || (depth0 != null ? lookupProperty(depth0,"subtitle") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"subtitle","hash":{},"data":data,"loc":{"start":{"line":44,"column":14},"end":{"line":44,"column":26}}}) : helper)))
	    + "\n            </div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), alias4=container.hooks.helperMissing, alias5="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"select") : stack1), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"skin") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":27},"end":{"line":1,"column":54}}})) != null ? stack1 : "")
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isDisabled") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":55},"end":{"line":1,"column":98}}})) != null ? stack1 : "")
	    + "\">\n  <input type=\"text\" value=\"\" readonly class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"input") : stack1), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"sizeMod") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":60},"end":{"line":2,"column":104}}})) != null ? stack1 : "")
	    + "\n      "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isError") : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":6},"end":{"line":3,"column":47}}})) != null ? stack1 : "")
	    + "\" />\n  <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"title") : stack1), depth0))
	    + "\n"
	    + ((stack1 = lookupProperty(helpers,"each").call(alias3,(depth0 != null ? lookupProperty(depth0,"options") : depth0),{"name":"each","hash":{},"fn":container.program(9, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":6},"end":{"line":10,"column":15}}})) != null ? stack1 : "")
	    + "      "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"sizeMod") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":11,"column":6},"end":{"line":11,"column":50}}})) != null ? stack1 : "")
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"header") : depth0),{"name":"if","hash":{},"fn":container.program(15, data, 0, blockParams, depths),"inverse":container.program(17, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":12,"column":4},"end":{"line":18,"column":11}}})) != null ? stack1 : "")
	    + "    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"arrow") : stack1), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"sizeMod") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":19,"column":30},"end":{"line":19,"column":74}}})) != null ? stack1 : "")
	    + "\"></div>\n  </div>\n  <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"dropdown") : stack1), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isOpen") : depth0),{"name":"if","hash":{},"fn":container.program(21, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":21,"column":31},"end":{"line":21,"column":66}}})) != null ? stack1 : "")
	    + "\">\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"textfieldWrapper") : stack1), depth0))
	    + "\">\n      <input\n        id=\""
	    + alias2(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":24,"column":12},"end":{"line":24,"column":18}}}) : helper)))
	    + "-field\"\n        type=\"text\"\n        value=\""
	    + alias2(((helper = (helper = lookupProperty(helpers,"filterValue") || (depth0 != null ? lookupProperty(depth0,"filterValue") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"filterValue","hash":{},"data":data,"loc":{"start":{"line":26,"column":15},"end":{"line":26,"column":30}}}) : helper)))
	    + "\"\n        class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"textfield") : stack1), depth0))
	    + "\"\n        "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"name") : depth0),{"name":"if","hash":{},"fn":container.program(23, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":28,"column":8},"end":{"line":28,"column":48}}})) != null ? stack1 : "")
	    + "\n        "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"filterPlaceholder") : depth0),{"name":"if","hash":{},"fn":container.program(25, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":29,"column":8},"end":{"line":29,"column":75}}})) != null ? stack1 : "")
	    + " />\n    </div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"scrolltrack") : stack1), depth0))
	    + "\">\n      <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"scrollbar") : stack1), depth0))
	    + "\"></div>\n    </div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"options") : stack1), depth0))
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"each").call(alias3,(depth0 != null ? lookupProperty(depth0,"options") : depth0),{"name":"each","hash":{},"fn":container.program(27, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":35,"column":6},"end":{"line":48,"column":15}}})) != null ? stack1 : "")
	    + "    </div>\n  </div>\n</div>\n";
	},"useData":true,"useDepths":true});

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "checked";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), alias4=container.hooks.helperMissing, alias5="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"wrapper") : stack1), depth0))
	    + "\">\n  <span class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"label") : stack1), depth0))
	    + "\">\n    <input\n            type=\"radio\"\n            id=\"radio-"
	    + alias2(((helper = (helper = lookupProperty(helpers,"cat-key") || (depth0 != null ? lookupProperty(depth0,"cat-key") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"cat-key","hash":{},"data":data,"loc":{"start":{"line":5,"column":22},"end":{"line":5,"column":33}}}) : helper)))
	    + "\"\n            class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"radio") : stack1), depth0))
	    + "\"\n            name=\""
	    + alias2(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"name","hash":{},"data":data,"loc":{"start":{"line":7,"column":18},"end":{"line":7,"column":26}}}) : helper)))
	    + "\"\n            "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"value") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":12},"end":{"line":8,"column":39}}})) != null ? stack1 : "")
	    + ">\n    <label for=\"radio-"
	    + alias2(((helper = (helper = lookupProperty(helpers,"cat-key") || (depth0 != null ? lookupProperty(depth0,"cat-key") : depth0)) != null ? helper : alias4),(typeof helper === alias5 ? helper.call(alias3,{"name":"cat-key","hash":{},"data":data,"loc":{"start":{"line":9,"column":22},"end":{"line":9,"column":33}}}) : helper)))
	    + "\" class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"title") : stack1), depth0))
	    + "\"></label>\n  </span>\n</div>\n";
	},"useData":true});

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(lookupProperty(helpers,"lookup").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"css") : depth0),(depth0 != null ? lookupProperty(depth0,"size") : depth0),{"name":"lookup","hash":{},"data":data,"loc":{"start":{"line":1,"column":38},"end":{"line":1,"column":57}}}));
	},"3":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "      <li class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"option") : stack1), depth0))
	    + "\n        "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"isDisabled") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":8},"end":{"line":5,"column":54}}})) != null ? stack1 : "")
	    + "\n        "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"isActive") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":8},"end":{"line":6,"column":55}}})) != null ? stack1 : "")
	    + "\n        "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"form") : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":8},"end":{"line":7,"column":49}}})) != null ? stack1 : "")
	    + "\n        "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"color") : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":8},"end":{"line":8,"column":51}}})) != null ? stack1 : "")
	    + "\" >\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"url") : depth0),{"name":"if","hash":{},"fn":container.program(12, data, 0, blockParams, depths),"inverse":container.program(14, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":9,"column":8},"end":{"line":15,"column":15}}})) != null ? stack1 : "")
	    + "      </li>\n";
	},"4":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"isDisabled") : stack1), depth0));
	},"6":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"isHighlighted") : stack1), depth0));
	},"8":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(lookupProperty(helpers,"lookup").call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? lookupProperty(depths[1],"css") : depths[1]),(depth0 != null ? lookupProperty(depth0,"form") : depth0),{"name":"lookup","hash":{},"data":data,"loc":{"start":{"line":7,"column":20},"end":{"line":7,"column":42}}}));
	},"10":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(lookupProperty(helpers,"lookup").call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? lookupProperty(depths[1],"css") : depths[1]),(depth0 != null ? lookupProperty(depth0,"color") : depth0),{"name":"lookup","hash":{},"data":data,"loc":{"start":{"line":8,"column":21},"end":{"line":8,"column":44}}}));
	},"12":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", alias4=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "          <a href=\""
	    + alias4(((helper = (helper = lookupProperty(helpers,"url") || (depth0 != null ? lookupProperty(depth0,"url") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"url","hash":{},"data":data,"loc":{"start":{"line":10,"column":19},"end":{"line":10,"column":26}}}) : helper)))
	    + "\" class=\""
	    + alias4(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"button")), depth0))
	    + "\" cat-key=\""
	    + alias4(((helper = (helper = lookupProperty(helpers,"key") || (depth0 != null ? lookupProperty(depth0,"key") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"key","hash":{},"data":data,"loc":{"start":{"line":10,"column":66},"end":{"line":10,"column":73}}}) : helper)))
	    + "\">\n            "
	    + alias4(((helper = (helper = lookupProperty(helpers,"title") || (depth0 != null ? lookupProperty(depth0,"title") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"title","hash":{},"data":data,"loc":{"start":{"line":11,"column":12},"end":{"line":11,"column":21}}}) : helper)))
	    + "\n          </a>\n";
	},"14":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.escapeExpression, alias2=depth0 != null ? depth0 : (container.nullContext || {}), alias3=container.hooks.helperMissing, alias4="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "          <div class=\""
	    + alias1(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"button")), depth0))
	    + "\" cat-key=\""
	    + alias1(((helper = (helper = lookupProperty(helpers,"key") || (depth0 != null ? lookupProperty(depth0,"key") : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"key","hash":{},"data":data,"loc":{"start":{"line":14,"column":53},"end":{"line":14,"column":60}}}) : helper)))
	    + "\">"
	    + alias1(((helper = (helper = lookupProperty(helpers,"title") || (depth0 != null ? lookupProperty(depth0,"title") : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"title","hash":{},"data":data,"loc":{"start":{"line":14,"column":62},"end":{"line":14,"column":71}}}) : helper)))
	    + "</div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"block") : stack1), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"size") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":26},"end":{"line":1,"column":64}}})) != null ? stack1 : "")
	    + "\">\n  <ul class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"options") : stack1), depth0))
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"each").call(alias3,(depth0 != null ? lookupProperty(depth0,"tabs") : depth0),{"name":"each","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":17,"column":13}}})) != null ? stack1 : "")
	    + "  </ul>\n</div>\n";
	},"useData":true,"useDepths":true});

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(((helper = (helper = lookupProperty(helpers,"skin") || (depth0 != null ? lookupProperty(depth0,"skin") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"skin","hash":{},"data":data,"loc":{"start":{"line":1,"column":39},"end":{"line":1,"column":47}}}) : helper)));
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"isDisabled") : stack1), depth0));
	},"5":function(container,depth0,helpers,partials,data) {
	    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(lookupProperty(helpers,"lookup").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"css") : depth0),(depth0 != null ? lookupProperty(depth0,"sizeMod") : depth0),{"name":"lookup","hash":{},"data":data,"loc":{"start":{"line":2,"column":75},"end":{"line":2,"column":97}}}));
	},"7":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"error")), depth0));
	},"9":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isActive") : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":10},"end":{"line":9,"column":17}}})) != null ? stack1 : "");
	},"10":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "              "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"form") : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":14},"end":{"line":7,"column":55}}})) != null ? stack1 : "")
	    + "\n              "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"color") : depth0),{"name":"if","hash":{},"fn":container.program(13, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":14},"end":{"line":8,"column":57}}})) != null ? stack1 : "")
	    + "\n";
	},"11":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(lookupProperty(helpers,"lookup").call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? lookupProperty(depths[1],"css") : depths[1]),(depth0 != null ? lookupProperty(depth0,"form") : depth0),{"name":"lookup","hash":{},"data":data,"loc":{"start":{"line":7,"column":26},"end":{"line":7,"column":48}}}));
	},"13":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(lookupProperty(helpers,"lookup").call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? lookupProperty(depths[1],"css") : depths[1]),(depth0 != null ? lookupProperty(depth0,"color") : depth0),{"name":"lookup","hash":{},"data":data,"loc":{"start":{"line":8,"column":27},"end":{"line":8,"column":50}}}));
	},"15":function(container,depth0,helpers,partials,data) {
	    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "      "
	    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"header") || (depth0 != null ? lookupProperty(depth0,"header") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"header","hash":{},"data":data,"loc":{"start":{"line":13,"column":6},"end":{"line":13,"column":16}}}) : helper)))
	    + "\n";
	},"17":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"options") : depth0),{"name":"each","hash":{},"fn":container.program(18, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":15,"column":6},"end":{"line":17,"column":15}}})) != null ? stack1 : "");
	},"18":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        "
	    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isActive") : depth0),{"name":"if","hash":{},"fn":container.program(19, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":8},"end":{"line":16,"column":40}}})) != null ? stack1 : "")
	    + "\n";
	},"19":function(container,depth0,helpers,partials,data) {
	    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(((helper = (helper = lookupProperty(helpers,"title") || (depth0 != null ? lookupProperty(depth0,"title") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"title","hash":{},"data":data,"loc":{"start":{"line":16,"column":24},"end":{"line":16,"column":33}}}) : helper)));
	},"21":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"isOpen") : stack1), depth0));
	},"23":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, helper, alias1=container.escapeExpression, alias2=depth0 != null ? depth0 : (container.nullContext || {}), alias3=container.hooks.helperMissing, alias4="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias1(container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"option") : stack1), depth0))
	    + "\n        "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias2,(depth0 != null ? lookupProperty(depth0,"form") : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":28,"column":8},"end":{"line":28,"column":49}}})) != null ? stack1 : "")
	    + "\n        "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias2,(depth0 != null ? lookupProperty(depth0,"color") : depth0),{"name":"if","hash":{},"fn":container.program(13, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":29,"column":8},"end":{"line":29,"column":51}}})) != null ? stack1 : "")
	    + "\n        "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias2,(depth0 != null ? lookupProperty(depth0,"isActive") : depth0),{"name":"if","hash":{},"fn":container.program(24, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":30,"column":8},"end":{"line":30,"column":56}}})) != null ? stack1 : "")
	    + "\"\n         cat-value=\""
	    + alias1(((helper = (helper = lookupProperty(helpers,"value") || (depth0 != null ? lookupProperty(depth0,"value") : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"value","hash":{},"data":data,"loc":{"start":{"line":31,"column":20},"end":{"line":31,"column":29}}}) : helper)))
	    + "\">\n            <span title=\""
	    + alias1(((helper = (helper = lookupProperty(helpers,"title") || (depth0 != null ? lookupProperty(depth0,"title") : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"title","hash":{},"data":data,"loc":{"start":{"line":32,"column":25},"end":{"line":32,"column":34}}}) : helper)))
	    + "\">"
	    + alias1(((helper = (helper = lookupProperty(helpers,"title") || (depth0 != null ? lookupProperty(depth0,"title") : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"title","hash":{},"data":data,"loc":{"start":{"line":32,"column":36},"end":{"line":32,"column":45}}}) : helper)))
	    + "</span>\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias2,(depth0 != null ? lookupProperty(depth0,"subtitle") : depth0),{"name":"if","hash":{},"fn":container.program(26, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":33,"column":10},"end":{"line":37,"column":17}}})) != null ? stack1 : "")
	    + "        </div>\n";
	},"24":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return " "
	    + container.escapeExpression(container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"isHighlighted") : stack1), depth0));
	},"26":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, helper, alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <div class=\""
	    + alias1(container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"subtitle") : stack1), depth0))
	    + "\">\n              "
	    + alias1(((helper = (helper = lookupProperty(helpers,"subtitle") || (depth0 != null ? lookupProperty(depth0,"subtitle") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"subtitle","hash":{},"data":data,"loc":{"start":{"line":35,"column":14},"end":{"line":35,"column":26}}}) : helper)))
	    + "\n            </div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"select") : stack1), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"skin") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":27},"end":{"line":1,"column":54}}})) != null ? stack1 : "")
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isDisabled") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":55},"end":{"line":1,"column":98}}})) != null ? stack1 : "")
	    + "\">\n  <input type=\"text\" value=\"\" readonly class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"input") : stack1), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"sizeMod") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":60},"end":{"line":2,"column":104}}})) != null ? stack1 : "")
	    + "\n      "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isError") : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":6},"end":{"line":3,"column":47}}})) != null ? stack1 : "")
	    + "\" />\n  <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"title") : stack1), depth0))
	    + "\n"
	    + ((stack1 = lookupProperty(helpers,"each").call(alias3,(depth0 != null ? lookupProperty(depth0,"options") : depth0),{"name":"each","hash":{},"fn":container.program(9, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":6},"end":{"line":10,"column":15}}})) != null ? stack1 : "")
	    + "      "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"sizeMod") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":11,"column":6},"end":{"line":11,"column":50}}})) != null ? stack1 : "")
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"header") : depth0),{"name":"if","hash":{},"fn":container.program(15, data, 0, blockParams, depths),"inverse":container.program(17, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":12,"column":4},"end":{"line":18,"column":11}}})) != null ? stack1 : "")
	    + "    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"arrow") : stack1), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"sizeMod") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":19,"column":30},"end":{"line":19,"column":74}}})) != null ? stack1 : "")
	    + "\"></div>\n  </div>\n  <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"dropdown") : stack1), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isOpen") : depth0),{"name":"if","hash":{},"fn":container.program(21, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":21,"column":31},"end":{"line":21,"column":66}}})) != null ? stack1 : "")
	    + "\">\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"scrolltrack") : stack1), depth0))
	    + "\">\n      <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"scrollbar") : stack1), depth0))
	    + "\"></div>\n    </div>\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"options") : stack1), depth0))
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"each").call(alias3,(depth0 != null ? lookupProperty(depth0,"options") : depth0),{"name":"each","hash":{},"fn":container.program(23, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":26,"column":6},"end":{"line":39,"column":15}}})) != null ? stack1 : "")
	    + "    </div>\n  </div>\n</div>\n";
	},"useData":true,"useDepths":true});

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"underlined") : stack1), depth0));
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isClickable") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.program(7, data, 0),"data":data,"loc":{"start":{"line":4,"column":6},"end":{"line":11,"column":13}}})) != null ? stack1 : "");
	},"4":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", alias4=container.escapeExpression, alias5=container.lambda, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <a href=\""
	    + alias4(((helper = (helper = lookupProperty(helpers,"href") || (depth0 != null ? lookupProperty(depth0,"href") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"href","hash":{},"data":data,"loc":{"start":{"line":5,"column":17},"end":{"line":5,"column":25}}}) : helper)))
	    + "\"\n           cat-page=\""
	    + alias4(((helper = (helper = lookupProperty(helpers,"subPage") || (depth0 != null ? lookupProperty(depth0,"subPage") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"subPage","hash":{},"data":data,"loc":{"start":{"line":6,"column":21},"end":{"line":6,"column":32}}}) : helper)))
	    + "\"\n           class=\""
	    + alias4(alias5(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"item")), depth0))
	    + " "
	    + alias4(alias5(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"isClickable")), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"isSelected") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":63},"end":{"line":7,"column":112}}})) != null ? stack1 : "")
	    + "\">"
	    + alias4(((helper = (helper = lookupProperty(helpers,"title") || (depth0 != null ? lookupProperty(depth0,"title") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"title","hash":{},"data":data,"loc":{"start":{"line":7,"column":114},"end":{"line":7,"column":123}}}) : helper)))
	    + "</a>\n";
	},"5":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"isSelected")), depth0));
	},"7":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.escapeExpression, alias2=depth0 != null ? depth0 : (container.nullContext || {}), alias3=container.hooks.helperMissing, alias4="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <span class=\""
	    + alias1(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"item")), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias2,(depth0 != null ? lookupProperty(depth0,"isSelected") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":40},"end":{"line":9,"column":89}}})) != null ? stack1 : "")
	    + "\"\n              cat-page=\""
	    + alias1(((helper = (helper = lookupProperty(helpers,"subPage") || (depth0 != null ? lookupProperty(depth0,"subPage") : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"subPage","hash":{},"data":data,"loc":{"start":{"line":10,"column":24},"end":{"line":10,"column":35}}}) : helper)))
	    + "\">"
	    + alias1(((helper = (helper = lookupProperty(helpers,"title") || (depth0 != null ? lookupProperty(depth0,"title") : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"title","hash":{},"data":data,"loc":{"start":{"line":10,"column":37},"end":{"line":10,"column":46}}}) : helper)))
	    + "</span>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"block") : stack1), depth0))
	    + "\">\n  <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"container") : stack1), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"underlined") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":32},"end":{"line":2,"column":75}}})) != null ? stack1 : "")
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"each").call(alias3,(depth0 != null ? lookupProperty(depth0,"tabs") : depth0),{"name":"each","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":12,"column":13}}})) != null ? stack1 : "")
	    + "  </div>\n</div>\n";
	},"useData":true});

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(lookupProperty(helpers,"lookup").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"css") : depth0),(depth0 != null ? lookupProperty(depth0,"mod") : depth0),{"name":"lookup","hash":{},"data":data,"loc":{"start":{"line":2,"column":15},"end":{"line":2,"column":33}}}));
	},"3":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <textarea\n                id=\""
	    + alias2(alias1(((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"id")), depth0))
	    + "-field\"\n                class=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"textfield") : stack1), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"error")),{"name":"if","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":44},"end":{"line":6,"column":92}}})) != null ? stack1 : "")
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,((stack1 = (depths[1] != null ? lookupProperty(depths[1],"limit") : depths[1])) != null ? lookupProperty(stack1,"show") : stack1),{"name":"if","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":93},"end":{"line":6,"column":144}}})) != null ? stack1 : "")
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"isDisabled")),{"name":"if","hash":{},"fn":container.program(8, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":145},"end":{"line":6,"column":200}}})) != null ? stack1 : "")
	    + "\"\n                "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depths[1] != null ? lookupProperty(depths[1],"name") : depths[1]),{"name":"if","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":16},"end":{"line":7,"column":53}}})) != null ? stack1 : "")
	    + "\n            "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"placeholder")),{"name":"if","hash":{},"fn":container.program(12, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":12},"end":{"line":8,"column":79}}})) != null ? stack1 : "")
	    + "\n            "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depths[1] != null ? lookupProperty(depths[1],"rows") : depths[1]),{"name":"if","hash":{},"fn":container.program(14, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":12},"end":{"line":9,"column":56}}})) != null ? stack1 : "")
	    + "\n            "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depths[1] != null ? lookupProperty(depths[1],"maxlength") : depths[1]),{"name":"if","hash":{},"fn":container.program(16, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":10,"column":12},"end":{"line":10,"column":71}}})) != null ? stack1 : "")
	    + ">"
	    + alias2(alias1((depths[1] != null ? lookupProperty(depths[1],"value") : depths[1]), depth0))
	    + "</textarea>\n";
	},"4":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"hasError")), depth0));
	},"6":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = (depths[2] != null ? lookupProperty(depths[2],"css") : depths[2])) != null ? lookupProperty(stack1,"showLimit") : stack1), depth0));
	},"8":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"css"))) && lookupProperty(stack1,"isDisabled")), depth0));
	},"10":function(container,depth0,helpers,partials,data) {
	    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "name=\""
	    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":7,"column":37},"end":{"line":7,"column":45}}}) : helper)))
	    + "\"";
	},"12":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "placeholder=\""
	    + container.escapeExpression(container.lambda(((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"placeholder")), depth0))
	    + "\"";
	},"14":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "rows=\""
	    + container.escapeExpression(container.lambda((depths[2] != null ? lookupProperty(depths[2],"rows") : depths[2]), depth0))
	    + "\" ";
	},"16":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return " maxlength=\""
	    + container.escapeExpression(container.lambda((depths[2] != null ? lookupProperty(depths[2],"maxlength") : depths[2]), depth0))
	    + "\"";
	},"18":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <input\n                id=\""
	    + alias2(alias1(((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"id")), depth0))
	    + "-field\"\n                "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"type")),{"name":"if","hash":{},"fn":container.program(19, data, 0, blockParams, depths),"inverse":container.program(21, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":14,"column":16},"end":{"line":14,"column":79}}})) != null ? stack1 : "")
	    + "\n                value=\""
	    + alias2(alias1((depths[1] != null ? lookupProperty(depths[1],"value") : depths[1]), depth0))
	    + "\"\n                class=\""
	    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"textfield") : stack1), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"error")),{"name":"if","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":44},"end":{"line":16,"column":92}}})) != null ? stack1 : "")
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,((stack1 = (depths[1] != null ? lookupProperty(depths[1],"limit") : depths[1])) != null ? lookupProperty(stack1,"show") : stack1),{"name":"if","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":93},"end":{"line":16,"column":144}}})) != null ? stack1 : "")
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"isDisabled")),{"name":"if","hash":{},"fn":container.program(8, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":145},"end":{"line":16,"column":200}}})) != null ? stack1 : "")
	    + "\"\n                "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depths[1] != null ? lookupProperty(depths[1],"name") : depths[1]),{"name":"if","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":17,"column":16},"end":{"line":17,"column":53}}})) != null ? stack1 : "")
	    + "\n            "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"placeholder")),{"name":"if","hash":{},"fn":container.program(12, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":18,"column":12},"end":{"line":18,"column":79}}})) != null ? stack1 : "")
	    + "\n            "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depths[1] != null ? lookupProperty(depths[1],"maxlength") : depths[1]),{"name":"if","hash":{},"fn":container.program(16, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":19,"column":12},"end":{"line":19,"column":71}}})) != null ? stack1 : "")
	    + "/>\n";
	},"19":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "type="
	    + container.escapeExpression(container.lambda(((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"type")), depth0));
	},"21":function(container,depth0,helpers,partials,data) {
	    return "type=\"text\"";
	},"23":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"hideTooltip") : depth0),{"name":"unless","hash":{},"fn":container.program(24, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":23,"column":8},"end":{"line":33,"column":19}}})) != null ? stack1 : "");
	},"24":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), alias4=container.hooks.helperMissing, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"tooltipWrapper") : stack1), depth0))
	    + "\n                "
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"position") : depth0),"===","leftToRight",{"name":"compare","hash":{},"fn":container.program(25, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":25,"column":16},"end":{"line":25,"column":98}}})) != null ? stack1 : "")
	    + "\n                "
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"position") : depth0),"===","topToBottom",{"name":"compare","hash":{},"fn":container.program(27, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":26,"column":16},"end":{"line":26,"column":98}}})) != null ? stack1 : "")
	    + "\">\n                <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"tooltip") : stack1), depth0))
	    + "\n                    "
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"position") : depth0),"===","topToBottom",{"name":"compare","hash":{},"fn":container.program(29, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":28,"column":20},"end":{"line":28,"column":95}}})) != null ? stack1 : "")
	    + "\n                    "
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"position") : depth0),"===","leftToRight",{"name":"compare","hash":{},"fn":container.program(31, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":29,"column":20},"end":{"line":29,"column":95}}})) != null ? stack1 : "")
	    + "\">\n                    "
	    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"error") || (depth0 != null ? lookupProperty(depth0,"error") : depth0)) != null ? helper : alias4),(typeof helper === "function" ? helper.call(alias3,{"name":"error","hash":{},"data":data,"loc":{"start":{"line":30,"column":20},"end":{"line":30,"column":31}}}) : helper))) != null ? stack1 : "")
	    + "\n                </div>\n            </div>\n";
	},"25":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"leftToRightWrapper") : stack1), depth0));
	},"27":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"topToBottomWrapper") : stack1), depth0));
	},"29":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"topToBottom") : stack1), depth0));
	},"31":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"leftToRight") : stack1), depth0));
	},"33":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <span class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"limit") : stack1), depth0))
	    + "\">"
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"limit") : depth0)) != null ? lookupProperty(stack1,"number") : stack1), depth0))
	    + "</span>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"block") : stack1), depth0))
	    + "\n    "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"mod") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":2,"column":40}}})) != null ? stack1 : "")
	    + "\">\n"
	    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(alias1,(depth0 != null ? lookupProperty(depth0,"type") : depth0),"===","textarea",{"name":"compare","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.program(18, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":20,"column":16}}})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"error") : depth0),{"name":"if","hash":{},"fn":container.program(23, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":22,"column":4},"end":{"line":34,"column":11}}})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"limit") : depth0)) != null ? lookupProperty(stack1,"show") : stack1),{"name":"if","hash":{},"fn":container.program(33, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":36,"column":4},"end":{"line":38,"column":11}}})) != null ? stack1 : "")
	    + "</div>\n";
	},"useData":true,"useDepths":true});

/***/ }),
/* 1010 */
1000,
/* 1011 */
1001,
/* 1012 */
1002,
/* 1013 */
1003,
/* 1014 */
1004,
/* 1015 */
1005,
/* 1016 */
1006,
/* 1017 */
1007,
/* 1018 */
1008,
/* 1019 */
1009,
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(1);
	module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(((helper = (helper = lookupProperty(helpers,"skin") || (depth0 != null ? lookupProperty(depth0,"skin") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"skin","hash":{},"data":data,"loc":{"start":{"line":1,"column":39},"end":{"line":1,"column":47}}}) : helper)));
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"isDisabled") : stack1), depth0));
	},"5":function(container,depth0,helpers,partials,data) {
	    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(lookupProperty(helpers,"lookup").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"css") : depth0),(depth0 != null ? lookupProperty(depth0,"sizeMod") : depth0),{"name":"lookup","hash":{},"data":data,"loc":{"start":{"line":2,"column":75},"end":{"line":2,"column":97}}}));
	},"7":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"isOpen") : stack1), depth0));
	},"9":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isActive") : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":10},"end":{"line":9,"column":17}}})) != null ? stack1 : "");
	},"10":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "              "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"form") : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":14},"end":{"line":7,"column":55}}})) != null ? stack1 : "")
	    + "\n              "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"color") : depth0),{"name":"if","hash":{},"fn":container.program(13, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":14},"end":{"line":8,"column":57}}})) != null ? stack1 : "")
	    + "\n";
	},"11":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(lookupProperty(helpers,"lookup").call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? lookupProperty(depths[1],"css") : depths[1]),(depth0 != null ? lookupProperty(depth0,"form") : depth0),{"name":"lookup","hash":{},"data":data,"loc":{"start":{"line":7,"column":26},"end":{"line":7,"column":48}}}));
	},"13":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(lookupProperty(helpers,"lookup").call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? lookupProperty(depths[1],"css") : depths[1]),(depth0 != null ? lookupProperty(depth0,"color") : depth0),{"name":"lookup","hash":{},"data":data,"loc":{"start":{"line":8,"column":27},"end":{"line":8,"column":50}}}));
	},"15":function(container,depth0,helpers,partials,data) {
	    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "      "
	    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"header") || (depth0 != null ? lookupProperty(depth0,"header") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"header","hash":{},"data":data,"loc":{"start":{"line":13,"column":6},"end":{"line":13,"column":16}}}) : helper)))
	    + "\n";
	},"17":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"options") : depth0),{"name":"each","hash":{},"fn":container.program(18, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":15,"column":6},"end":{"line":17,"column":15}}})) != null ? stack1 : "");
	},"18":function(container,depth0,helpers,partials,data) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        "
	    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isActive") : depth0),{"name":"if","hash":{},"fn":container.program(19, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":8},"end":{"line":16,"column":40}}})) != null ? stack1 : "")
	    + "\n";
	},"19":function(container,depth0,helpers,partials,data) {
	    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return container.escapeExpression(((helper = (helper = lookupProperty(helpers,"title") || (depth0 != null ? lookupProperty(depth0,"title") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"title","hash":{},"data":data,"loc":{"start":{"line":16,"column":24},"end":{"line":16,"column":33}}}) : helper)));
	},"21":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, helper, alias1=container.escapeExpression, alias2=depth0 != null ? depth0 : (container.nullContext || {}), alias3=container.hooks.helperMissing, alias4="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "        <div class=\""
	    + alias1(container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"option") : stack1), depth0))
	    + "\n        "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias2,(depth0 != null ? lookupProperty(depth0,"form") : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":25,"column":8},"end":{"line":25,"column":49}}})) != null ? stack1 : "")
	    + "\n        "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias2,(depth0 != null ? lookupProperty(depth0,"color") : depth0),{"name":"if","hash":{},"fn":container.program(13, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":26,"column":8},"end":{"line":26,"column":51}}})) != null ? stack1 : "")
	    + "\n        "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias2,(depth0 != null ? lookupProperty(depth0,"isActive") : depth0),{"name":"if","hash":{},"fn":container.program(22, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":27,"column":8},"end":{"line":27,"column":56}}})) != null ? stack1 : "")
	    + "\"\n         cat-value=\""
	    + alias1(((helper = (helper = lookupProperty(helpers,"value") || (depth0 != null ? lookupProperty(depth0,"value") : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"value","hash":{},"data":data,"loc":{"start":{"line":28,"column":20},"end":{"line":28,"column":29}}}) : helper)))
	    + "\">\n            <span title=\""
	    + alias1(((helper = (helper = lookupProperty(helpers,"title") || (depth0 != null ? lookupProperty(depth0,"title") : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"title","hash":{},"data":data,"loc":{"start":{"line":29,"column":25},"end":{"line":29,"column":34}}}) : helper)))
	    + "\">"
	    + alias1(((helper = (helper = lookupProperty(helpers,"title") || (depth0 != null ? lookupProperty(depth0,"title") : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"title","hash":{},"data":data,"loc":{"start":{"line":29,"column":36},"end":{"line":29,"column":45}}}) : helper)))
	    + "</span>\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias2,(depth0 != null ? lookupProperty(depth0,"subtitle") : depth0),{"name":"if","hash":{},"fn":container.program(24, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":30,"column":10},"end":{"line":34,"column":17}}})) != null ? stack1 : "")
	    + "        </div>\n";
	},"22":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return " "
	    + container.escapeExpression(container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"isHighlighted") : stack1), depth0));
	},"24":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, helper, alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "            <div class=\""
	    + alias1(container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"subtitle") : stack1), depth0))
	    + "\">\n              "
	    + alias1(((helper = (helper = lookupProperty(helpers,"subtitle") || (depth0 != null ? lookupProperty(depth0,"subtitle") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"subtitle","hash":{},"data":data,"loc":{"start":{"line":32,"column":14},"end":{"line":32,"column":26}}}) : helper)))
	    + "\n            </div>\n";
	},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"select") : stack1), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"skin") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":27},"end":{"line":1,"column":54}}})) != null ? stack1 : "")
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isDisabled") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":55},"end":{"line":1,"column":98}}})) != null ? stack1 : "")
	    + "\">\n  <input type=\"text\" value=\"\" readonly class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"input") : stack1), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"sizeMod") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":60},"end":{"line":2,"column":104}}})) != null ? stack1 : "")
	    + "\" />\n  <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"title") : stack1), depth0))
	    + "\n      "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isOpen") : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":6},"end":{"line":4,"column":41}}})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = lookupProperty(helpers,"each").call(alias3,(depth0 != null ? lookupProperty(depth0,"options") : depth0),{"name":"each","hash":{},"fn":container.program(9, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":6},"end":{"line":10,"column":15}}})) != null ? stack1 : "")
	    + "      "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"sizeMod") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":11,"column":6},"end":{"line":11,"column":50}}})) != null ? stack1 : "")
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"header") : depth0),{"name":"if","hash":{},"fn":container.program(15, data, 0, blockParams, depths),"inverse":container.program(17, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":12,"column":4},"end":{"line":18,"column":11}}})) != null ? stack1 : "")
	    + "    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"arrow") : stack1), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isOpen") : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":19,"column":30},"end":{"line":19,"column":65}}})) != null ? stack1 : "")
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"sizeMod") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":19,"column":66},"end":{"line":19,"column":110}}})) != null ? stack1 : "")
	    + "\"></div>\n  </div>\n  <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"dropdown") : stack1), depth0))
	    + " "
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"topToBottom") : stack1), depth0))
	    + " "
	    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"isOpen") : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":21,"column":51},"end":{"line":21,"column":86}}})) != null ? stack1 : "")
	    + "\">\n    <div class=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"css") : depth0)) != null ? lookupProperty(stack1,"options") : stack1), depth0))
	    + "\">\n"
	    + ((stack1 = lookupProperty(helpers,"each").call(alias3,(depth0 != null ? lookupProperty(depth0,"options") : depth0),{"name":"each","hash":{},"fn":container.program(21, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":23,"column":6},"end":{"line":36,"column":15}}})) != null ? stack1 : "")
	    + "    </div>\n  </div>\n</div>\n";
	},"useData":true,"useDepths":true});

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// istanbul ignore next
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _handlebarsBase = __webpack_require__(278);
	
	var base = _interopRequireWildcard(_handlebarsBase);
	
	// Each of these augment the Handlebars object. No need to setup here.
	// (This is done to easily share code between commonjs and browse envs)
	
	var _handlebarsSafeString = __webpack_require__(1035);
	
	var _handlebarsSafeString2 = _interopRequireDefault(_handlebarsSafeString);
	
	var _handlebarsException = __webpack_require__(87);
	
	var _handlebarsException2 = _interopRequireDefault(_handlebarsException);
	
	var _handlebarsUtils = __webpack_require__(55);
	
	var Utils = _interopRequireWildcard(_handlebarsUtils);
	
	var _handlebarsRuntime = __webpack_require__(1034);
	
	var runtime = _interopRequireWildcard(_handlebarsRuntime);
	
	var _handlebarsNoConflict = __webpack_require__(1033);
	
	var _handlebarsNoConflict2 = _interopRequireDefault(_handlebarsNoConflict);
	
	// For compatibility and usage outside of module systems, make the Handlebars object a namespace
	function create() {
	  var hb = new base.HandlebarsEnvironment();
	
	  Utils.extend(hb, base);
	  hb.SafeString = _handlebarsSafeString2['default'];
	  hb.Exception = _handlebarsException2['default'];
	  hb.Utils = Utils;
	  hb.escapeExpression = Utils.escapeExpression;
	
	  hb.VM = runtime;
	  hb.template = function (spec) {
	    return runtime.template(spec, hb);
	  };
	
	  return hb;
	}
	
	var inst = create();
	inst.create = create;
	
	_handlebarsNoConflict2['default'](inst);
	
	inst['default'] = inst;
	
	exports['default'] = inst;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.registerDefaultDecorators = registerDefaultDecorators;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _decoratorsInline = __webpack_require__(1023);
	
	var _decoratorsInline2 = _interopRequireDefault(_decoratorsInline);
	
	function registerDefaultDecorators(instance) {
	  _decoratorsInline2['default'](instance);
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2RlY29yYXRvcnMuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Z0NBQTJCLHFCQUFxQjs7OztBQUV6QyxTQUFTLHlCQUF5QixDQUFDLFFBQVEsRUFBRTtBQUNsRCxnQ0FBZSxRQUFRLENBQUMsQ0FBQztDQUMxQiIsImZpbGUiOiJkZWNvcmF0b3JzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHJlZ2lzdGVySW5saW5lIGZyb20gJy4vZGVjb3JhdG9ycy9pbmxpbmUnO1xuXG5leHBvcnQgZnVuY3Rpb24gcmVnaXN0ZXJEZWZhdWx0RGVjb3JhdG9ycyhpbnN0YW5jZSkge1xuICByZWdpc3RlcklubGluZShpbnN0YW5jZSk7XG59XG4iXX0=


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__(55);
	
	exports['default'] = function (instance) {
	  instance.registerDecorator('inline', function (fn, props, container, options) {
	    var ret = fn;
	    if (!props.partials) {
	      props.partials = {};
	      ret = function (context, options) {
	        // Create a new partials stack frame prior to exec.
	        var original = container.partials;
	        container.partials = _utils.extend({}, original, props.partials);
	        var ret = fn(context, options);
	        container.partials = original;
	        return ret;
	      };
	    }
	
	    props.partials[options.args[0]] = options.fn;
	
	    return ret;
	  });
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2RlY29yYXRvcnMvaW5saW5lLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7cUJBQXVCLFVBQVU7O3FCQUVsQixVQUFTLFFBQVEsRUFBRTtBQUNoQyxVQUFRLENBQUMsaUJBQWlCLENBQUMsUUFBUSxFQUFFLFVBQVMsRUFBRSxFQUFFLEtBQUssRUFBRSxTQUFTLEVBQUUsT0FBTyxFQUFFO0FBQzNFLFFBQUksR0FBRyxHQUFHLEVBQUUsQ0FBQztBQUNiLFFBQUksQ0FBQyxLQUFLLENBQUMsUUFBUSxFQUFFO0FBQ25CLFdBQUssQ0FBQyxRQUFRLEdBQUcsRUFBRSxDQUFDO0FBQ3BCLFNBQUcsR0FBRyxVQUFTLE9BQU8sRUFBRSxPQUFPLEVBQUU7O0FBRS9CLFlBQUksUUFBUSxHQUFHLFNBQVMsQ0FBQyxRQUFRLENBQUM7QUFDbEMsaUJBQVMsQ0FBQyxRQUFRLEdBQUcsY0FBTyxFQUFFLEVBQUUsUUFBUSxFQUFFLEtBQUssQ0FBQyxRQUFRLENBQUMsQ0FBQztBQUMxRCxZQUFJLEdBQUcsR0FBRyxFQUFFLENBQUMsT0FBTyxFQUFFLE9BQU8sQ0FBQyxDQUFDO0FBQy9CLGlCQUFTLENBQUMsUUFBUSxHQUFHLFFBQVEsQ0FBQztBQUM5QixlQUFPLEdBQUcsQ0FBQztPQUNaLENBQUM7S0FDSDs7QUFFRCxTQUFLLENBQUMsUUFBUSxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUMsR0FBRyxPQUFPLENBQUMsRUFBRSxDQUFDOztBQUU3QyxXQUFPLEdBQUcsQ0FBQztHQUNaLENBQUMsQ0FBQztDQUNKIiwiZmlsZSI6ImlubGluZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGV4dGVuZCB9IGZyb20gJy4uL3V0aWxzJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24oaW5zdGFuY2UpIHtcbiAgaW5zdGFuY2UucmVnaXN0ZXJEZWNvcmF0b3IoJ2lubGluZScsIGZ1bmN0aW9uKGZuLCBwcm9wcywgY29udGFpbmVyLCBvcHRpb25zKSB7XG4gICAgbGV0IHJldCA9IGZuO1xuICAgIGlmICghcHJvcHMucGFydGlhbHMpIHtcbiAgICAgIHByb3BzLnBhcnRpYWxzID0ge307XG4gICAgICByZXQgPSBmdW5jdGlvbihjb250ZXh0LCBvcHRpb25zKSB7XG4gICAgICAgIC8vIENyZWF0ZSBhIG5ldyBwYXJ0aWFscyBzdGFjayBmcmFtZSBwcmlvciB0byBleGVjLlxuICAgICAgICBsZXQgb3JpZ2luYWwgPSBjb250YWluZXIucGFydGlhbHM7XG4gICAgICAgIGNvbnRhaW5lci5wYXJ0aWFscyA9IGV4dGVuZCh7fSwgb3JpZ2luYWwsIHByb3BzLnBhcnRpYWxzKTtcbiAgICAgICAgbGV0IHJldCA9IGZuKGNvbnRleHQsIG9wdGlvbnMpO1xuICAgICAgICBjb250YWluZXIucGFydGlhbHMgPSBvcmlnaW5hbDtcbiAgICAgICAgcmV0dXJuIHJldDtcbiAgICAgIH07XG4gICAgfVxuXG4gICAgcHJvcHMucGFydGlhbHNbb3B0aW9ucy5hcmdzWzBdXSA9IG9wdGlvbnMuZm47XG5cbiAgICByZXR1cm4gcmV0O1xuICB9KTtcbn1cbiJdfQ==


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__(55);
	
	exports['default'] = function (instance) {
	  instance.registerHelper('blockHelperMissing', function (context, options) {
	    var inverse = options.inverse,
	        fn = options.fn;
	
	    if (context === true) {
	      return fn(this);
	    } else if (context === false || context == null) {
	      return inverse(this);
	    } else if (_utils.isArray(context)) {
	      if (context.length > 0) {
	        if (options.ids) {
	          options.ids = [options.name];
	        }
	
	        return instance.helpers.each(context, options);
	      } else {
	        return inverse(this);
	      }
	    } else {
	      if (options.data && options.ids) {
	        var data = _utils.createFrame(options.data);
	        data.contextPath = _utils.appendContextPath(options.data.contextPath, options.name);
	        options = { data: data };
	      }
	
	      return fn(context, options);
	    }
	  });
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2hlbHBlcnMvYmxvY2staGVscGVyLW1pc3NpbmcuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7OztxQkFBd0QsVUFBVTs7cUJBRW5ELFVBQVMsUUFBUSxFQUFFO0FBQ2hDLFVBQVEsQ0FBQyxjQUFjLENBQUMsb0JBQW9CLEVBQUUsVUFBUyxPQUFPLEVBQUUsT0FBTyxFQUFFO0FBQ3ZFLFFBQUksT0FBTyxHQUFHLE9BQU8sQ0FBQyxPQUFPO1FBQzNCLEVBQUUsR0FBRyxPQUFPLENBQUMsRUFBRSxDQUFDOztBQUVsQixRQUFJLE9BQU8sS0FBSyxJQUFJLEVBQUU7QUFDcEIsYUFBTyxFQUFFLENBQUMsSUFBSSxDQUFDLENBQUM7S0FDakIsTUFBTSxJQUFJLE9BQU8sS0FBSyxLQUFLLElBQUksT0FBTyxJQUFJLElBQUksRUFBRTtBQUMvQyxhQUFPLE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQztLQUN0QixNQUFNLElBQUksZUFBUSxPQUFPLENBQUMsRUFBRTtBQUMzQixVQUFJLE9BQU8sQ0FBQyxNQUFNLEdBQUcsQ0FBQyxFQUFFO0FBQ3RCLFlBQUksT0FBTyxDQUFDLEdBQUcsRUFBRTtBQUNmLGlCQUFPLENBQUMsR0FBRyxHQUFHLENBQUMsT0FBTyxDQUFDLElBQUksQ0FBQyxDQUFDO1NBQzlCOztBQUVELGVBQU8sUUFBUSxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUMsT0FBTyxFQUFFLE9BQU8sQ0FBQyxDQUFDO09BQ2hELE1BQU07QUFDTCxlQUFPLE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQztPQUN0QjtLQUNGLE1BQU07QUFDTCxVQUFJLE9BQU8sQ0FBQyxJQUFJLElBQUksT0FBTyxDQUFDLEdBQUcsRUFBRTtBQUMvQixZQUFJLElBQUksR0FBRyxtQkFBWSxPQUFPLENBQUMsSUFBSSxDQUFDLENBQUM7QUFDckMsWUFBSSxDQUFDLFdBQVcsR0FBRyx5QkFDakIsT0FBTyxDQUFDLElBQUksQ0FBQyxXQUFXLEVBQ3hCLE9BQU8sQ0FBQyxJQUFJLENBQ2IsQ0FBQztBQUNGLGVBQU8sR0FBRyxFQUFFLElBQUksRUFBRSxJQUFJLEVBQUUsQ0FBQztPQUMxQjs7QUFFRCxhQUFPLEVBQUUsQ0FBQyxPQUFPLEVBQUUsT0FBTyxDQUFDLENBQUM7S0FDN0I7R0FDRixDQUFDLENBQUM7Q0FDSiIsImZpbGUiOiJibG9jay1oZWxwZXItbWlzc2luZy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGFwcGVuZENvbnRleHRQYXRoLCBjcmVhdGVGcmFtZSwgaXNBcnJheSB9IGZyb20gJy4uL3V0aWxzJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24oaW5zdGFuY2UpIHtcbiAgaW5zdGFuY2UucmVnaXN0ZXJIZWxwZXIoJ2Jsb2NrSGVscGVyTWlzc2luZycsIGZ1bmN0aW9uKGNvbnRleHQsIG9wdGlvbnMpIHtcbiAgICBsZXQgaW52ZXJzZSA9IG9wdGlvbnMuaW52ZXJzZSxcbiAgICAgIGZuID0gb3B0aW9ucy5mbjtcblxuICAgIGlmIChjb250ZXh0ID09PSB0cnVlKSB7XG4gICAgICByZXR1cm4gZm4odGhpcyk7XG4gICAgfSBlbHNlIGlmIChjb250ZXh0ID09PSBmYWxzZSB8fCBjb250ZXh0ID09IG51bGwpIHtcbiAgICAgIHJldHVybiBpbnZlcnNlKHRoaXMpO1xuICAgIH0gZWxzZSBpZiAoaXNBcnJheShjb250ZXh0KSkge1xuICAgICAgaWYgKGNvbnRleHQubGVuZ3RoID4gMCkge1xuICAgICAgICBpZiAob3B0aW9ucy5pZHMpIHtcbiAgICAgICAgICBvcHRpb25zLmlkcyA9IFtvcHRpb25zLm5hbWVdO1xuICAgICAgICB9XG5cbiAgICAgICAgcmV0dXJuIGluc3RhbmNlLmhlbHBlcnMuZWFjaChjb250ZXh0LCBvcHRpb25zKTtcbiAgICAgIH0gZWxzZSB7XG4gICAgICAgIHJldHVybiBpbnZlcnNlKHRoaXMpO1xuICAgICAgfVxuICAgIH0gZWxzZSB7XG4gICAgICBpZiAob3B0aW9ucy5kYXRhICYmIG9wdGlvbnMuaWRzKSB7XG4gICAgICAgIGxldCBkYXRhID0gY3JlYXRlRnJhbWUob3B0aW9ucy5kYXRhKTtcbiAgICAgICAgZGF0YS5jb250ZXh0UGF0aCA9IGFwcGVuZENvbnRleHRQYXRoKFxuICAgICAgICAgIG9wdGlvbnMuZGF0YS5jb250ZXh0UGF0aCxcbiAgICAgICAgICBvcHRpb25zLm5hbWVcbiAgICAgICAgKTtcbiAgICAgICAgb3B0aW9ucyA9IHsgZGF0YTogZGF0YSB9O1xuICAgICAgfVxuXG4gICAgICByZXR1cm4gZm4oY29udGV4dCwgb3B0aW9ucyk7XG4gICAgfVxuICB9KTtcbn1cbiJdfQ==


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _utils = __webpack_require__(55);
	
	var _exception = __webpack_require__(87);
	
	var _exception2 = _interopRequireDefault(_exception);
	
	exports['default'] = function (instance) {
	  instance.registerHelper('each', function (context, options) {
	    if (!options) {
	      throw new _exception2['default']('Must pass iterator to #each');
	    }
	
	    var fn = options.fn,
	        inverse = options.inverse,
	        i = 0,
	        ret = '',
	        data = undefined,
	        contextPath = undefined;
	
	    if (options.data && options.ids) {
	      contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]) + '.';
	    }
	
	    if (_utils.isFunction(context)) {
	      context = context.call(this);
	    }
	
	    if (options.data) {
	      data = _utils.createFrame(options.data);
	    }
	
	    function execIteration(field, index, last) {
	      if (data) {
	        data.key = field;
	        data.index = index;
	        data.first = index === 0;
	        data.last = !!last;
	
	        if (contextPath) {
	          data.contextPath = contextPath + field;
	        }
	      }
	
	      ret = ret + fn(context[field], {
	        data: data,
	        blockParams: _utils.blockParams([context[field], field], [contextPath + field, null])
	      });
	    }
	
	    if (context && typeof context === 'object') {
	      if (_utils.isArray(context)) {
	        for (var j = context.length; i < j; i++) {
	          if (i in context) {
	            execIteration(i, i, i === context.length - 1);
	          }
	        }
	      } else if (typeof Symbol === 'function' && context[Symbol.iterator]) {
	        var newContext = [];
	        var iterator = context[Symbol.iterator]();
	        for (var it = iterator.next(); !it.done; it = iterator.next()) {
	          newContext.push(it.value);
	        }
	        context = newContext;
	        for (var j = context.length; i < j; i++) {
	          execIteration(i, i, i === context.length - 1);
	        }
	      } else {
	        (function () {
	          var priorKey = undefined;
	
	          Object.keys(context).forEach(function (key) {
	            // We're running the iterations one step out of sync so we can detect
	            // the last iteration without have to scan the object twice and create
	            // an itermediate keys array.
	            if (priorKey !== undefined) {
	              execIteration(priorKey, i - 1);
	            }
	            priorKey = key;
	            i++;
	          });
	          if (priorKey !== undefined) {
	            execIteration(priorKey, i - 1, true);
	          }
	        })();
	      }
	    }
	
	    if (i === 0) {
	      ret = inverse(this);
	    }
	
	    return ret;
	  });
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _exception = __webpack_require__(87);
	
	var _exception2 = _interopRequireDefault(_exception);
	
	exports['default'] = function (instance) {
	  instance.registerHelper('helperMissing', function () /* [args, ]options */{
	    if (arguments.length === 1) {
	      // A missing field in a {{foo}} construct.
	      return undefined;
	    } else {
	      // Someone is actually trying to call something, blow up.
	      throw new _exception2['default']('Missing helper: "' + arguments[arguments.length - 1].name + '"');
	    }
	  });
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2hlbHBlcnMvaGVscGVyLW1pc3NpbmcuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozt5QkFBc0IsY0FBYzs7OztxQkFFckIsVUFBUyxRQUFRLEVBQUU7QUFDaEMsVUFBUSxDQUFDLGNBQWMsQ0FBQyxlQUFlLEVBQUUsaUNBQWdDO0FBQ3ZFLFFBQUksU0FBUyxDQUFDLE1BQU0sS0FBSyxDQUFDLEVBQUU7O0FBRTFCLGFBQU8sU0FBUyxDQUFDO0tBQ2xCLE1BQU07O0FBRUwsWUFBTSwyQkFDSixtQkFBbUIsR0FBRyxTQUFTLENBQUMsU0FBUyxDQUFDLE1BQU0sR0FBRyxDQUFDLENBQUMsQ0FBQyxJQUFJLEdBQUcsR0FBRyxDQUNqRSxDQUFDO0tBQ0g7R0FDRixDQUFDLENBQUM7Q0FDSiIsImZpbGUiOiJoZWxwZXItbWlzc2luZy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBFeGNlcHRpb24gZnJvbSAnLi4vZXhjZXB0aW9uJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24oaW5zdGFuY2UpIHtcbiAgaW5zdGFuY2UucmVnaXN0ZXJIZWxwZXIoJ2hlbHBlck1pc3NpbmcnLCBmdW5jdGlvbigvKiBbYXJncywgXW9wdGlvbnMgKi8pIHtcbiAgICBpZiAoYXJndW1lbnRzLmxlbmd0aCA9PT0gMSkge1xuICAgICAgLy8gQSBtaXNzaW5nIGZpZWxkIGluIGEge3tmb299fSBjb25zdHJ1Y3QuXG4gICAgICByZXR1cm4gdW5kZWZpbmVkO1xuICAgIH0gZWxzZSB7XG4gICAgICAvLyBTb21lb25lIGlzIGFjdHVhbGx5IHRyeWluZyB0byBjYWxsIHNvbWV0aGluZywgYmxvdyB1cC5cbiAgICAgIHRocm93IG5ldyBFeGNlcHRpb24oXG4gICAgICAgICdNaXNzaW5nIGhlbHBlcjogXCInICsgYXJndW1lbnRzW2FyZ3VtZW50cy5sZW5ndGggLSAxXS5uYW1lICsgJ1wiJ1xuICAgICAgKTtcbiAgICB9XG4gIH0pO1xufVxuIl19


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _utils = __webpack_require__(55);
	
	var _exception = __webpack_require__(87);
	
	var _exception2 = _interopRequireDefault(_exception);
	
	exports['default'] = function (instance) {
	  instance.registerHelper('if', function (conditional, options) {
	    if (arguments.length != 2) {
	      throw new _exception2['default']('#if requires exactly one argument');
	    }
	    if (_utils.isFunction(conditional)) {
	      conditional = conditional.call(this);
	    }
	
	    // Default behavior is to render the positive path if the value is truthy and not empty.
	    // The `includeZero` option may be set to treat the condtional as purely not empty based on the
	    // behavior of isEmpty. Effectively this determines if 0 is handled by the positive path or negative.
	    if (!options.hash.includeZero && !conditional || _utils.isEmpty(conditional)) {
	      return options.inverse(this);
	    } else {
	      return options.fn(this);
	    }
	  });
	
	  instance.registerHelper('unless', function (conditional, options) {
	    if (arguments.length != 2) {
	      throw new _exception2['default']('#unless requires exactly one argument');
	    }
	    return instance.helpers['if'].call(this, conditional, {
	      fn: options.inverse,
	      inverse: options.fn,
	      hash: options.hash
	    });
	  });
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 1028 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	exports['default'] = function (instance) {
	  instance.registerHelper('log', function () /* message, options */{
	    var args = [undefined],
	        options = arguments[arguments.length - 1];
	    for (var i = 0; i < arguments.length - 1; i++) {
	      args.push(arguments[i]);
	    }
	
	    var level = 1;
	    if (options.hash.level != null) {
	      level = options.hash.level;
	    } else if (options.data && options.data.level != null) {
	      level = options.data.level;
	    }
	    args[0] = level;
	
	    instance.log.apply(instance, args);
	  });
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2hlbHBlcnMvbG9nLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7cUJBQWUsVUFBUyxRQUFRLEVBQUU7QUFDaEMsVUFBUSxDQUFDLGNBQWMsQ0FBQyxLQUFLLEVBQUUsa0NBQWlDO0FBQzlELFFBQUksSUFBSSxHQUFHLENBQUMsU0FBUyxDQUFDO1FBQ3BCLE9BQU8sR0FBRyxTQUFTLENBQUMsU0FBUyxDQUFDLE1BQU0sR0FBRyxDQUFDLENBQUMsQ0FBQztBQUM1QyxTQUFLLElBQUksQ0FBQyxHQUFHLENBQUMsRUFBRSxDQUFDLEdBQUcsU0FBUyxDQUFDLE1BQU0sR0FBRyxDQUFDLEVBQUUsQ0FBQyxFQUFFLEVBQUU7QUFDN0MsVUFBSSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQztLQUN6Qjs7QUFFRCxRQUFJLEtBQUssR0FBRyxDQUFDLENBQUM7QUFDZCxRQUFJLE9BQU8sQ0FBQyxJQUFJLENBQUMsS0FBSyxJQUFJLElBQUksRUFBRTtBQUM5QixXQUFLLEdBQUcsT0FBTyxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUM7S0FDNUIsTUFBTSxJQUFJLE9BQU8sQ0FBQyxJQUFJLElBQUksT0FBTyxDQUFDLElBQUksQ0FBQyxLQUFLLElBQUksSUFBSSxFQUFFO0FBQ3JELFdBQUssR0FBRyxPQUFPLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQztLQUM1QjtBQUNELFFBQUksQ0FBQyxDQUFDLENBQUMsR0FBRyxLQUFLLENBQUM7O0FBRWhCLFlBQVEsQ0FBQyxHQUFHLE1BQUEsQ0FBWixRQUFRLEVBQVEsSUFBSSxDQUFDLENBQUM7R0FDdkIsQ0FBQyxDQUFDO0NBQ0oiLCJmaWxlIjoibG9nLmpzIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24oaW5zdGFuY2UpIHtcbiAgaW5zdGFuY2UucmVnaXN0ZXJIZWxwZXIoJ2xvZycsIGZ1bmN0aW9uKC8qIG1lc3NhZ2UsIG9wdGlvbnMgKi8pIHtcbiAgICBsZXQgYXJncyA9IFt1bmRlZmluZWRdLFxuICAgICAgb3B0aW9ucyA9IGFyZ3VtZW50c1thcmd1bWVudHMubGVuZ3RoIC0gMV07XG4gICAgZm9yIChsZXQgaSA9IDA7IGkgPCBhcmd1bWVudHMubGVuZ3RoIC0gMTsgaSsrKSB7XG4gICAgICBhcmdzLnB1c2goYXJndW1lbnRzW2ldKTtcbiAgICB9XG5cbiAgICBsZXQgbGV2ZWwgPSAxO1xuICAgIGlmIChvcHRpb25zLmhhc2gubGV2ZWwgIT0gbnVsbCkge1xuICAgICAgbGV2ZWwgPSBvcHRpb25zLmhhc2gubGV2ZWw7XG4gICAgfSBlbHNlIGlmIChvcHRpb25zLmRhdGEgJiYgb3B0aW9ucy5kYXRhLmxldmVsICE9IG51bGwpIHtcbiAgICAgIGxldmVsID0gb3B0aW9ucy5kYXRhLmxldmVsO1xuICAgIH1cbiAgICBhcmdzWzBdID0gbGV2ZWw7XG5cbiAgICBpbnN0YW5jZS5sb2coLi4uYXJncyk7XG4gIH0pO1xufVxuIl19


/***/ }),
/* 1029 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	exports['default'] = function (instance) {
	  instance.registerHelper('lookup', function (obj, field, options) {
	    if (!obj) {
	      // Note for 5.0: Change to "obj == null" in 5.0
	      return obj;
	    }
	    return options.lookupProperty(obj, field);
	  });
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2hlbHBlcnMvbG9va3VwLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7cUJBQWUsVUFBUyxRQUFRLEVBQUU7QUFDaEMsVUFBUSxDQUFDLGNBQWMsQ0FBQyxRQUFRLEVBQUUsVUFBUyxHQUFHLEVBQUUsS0FBSyxFQUFFLE9BQU8sRUFBRTtBQUM5RCxRQUFJLENBQUMsR0FBRyxFQUFFOztBQUVSLGFBQU8sR0FBRyxDQUFDO0tBQ1o7QUFDRCxXQUFPLE9BQU8sQ0FBQyxjQUFjLENBQUMsR0FBRyxFQUFFLEtBQUssQ0FBQyxDQUFDO0dBQzNDLENBQUMsQ0FBQztDQUNKIiwiZmlsZSI6Imxvb2t1cC5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uKGluc3RhbmNlKSB7XG4gIGluc3RhbmNlLnJlZ2lzdGVySGVscGVyKCdsb29rdXAnLCBmdW5jdGlvbihvYmosIGZpZWxkLCBvcHRpb25zKSB7XG4gICAgaWYgKCFvYmopIHtcbiAgICAgIC8vIE5vdGUgZm9yIDUuMDogQ2hhbmdlIHRvIFwib2JqID09IG51bGxcIiBpbiA1LjBcbiAgICAgIHJldHVybiBvYmo7XG4gICAgfVxuICAgIHJldHVybiBvcHRpb25zLmxvb2t1cFByb3BlcnR5KG9iaiwgZmllbGQpO1xuICB9KTtcbn1cbiJdfQ==


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _utils = __webpack_require__(55);
	
	var _exception = __webpack_require__(87);
	
	var _exception2 = _interopRequireDefault(_exception);
	
	exports['default'] = function (instance) {
	  instance.registerHelper('with', function (context, options) {
	    if (arguments.length != 2) {
	      throw new _exception2['default']('#with requires exactly one argument');
	    }
	    if (_utils.isFunction(context)) {
	      context = context.call(this);
	    }
	
	    var fn = options.fn;
	
	    if (!_utils.isEmpty(context)) {
	      var data = options.data;
	      if (options.data && options.ids) {
	        data = _utils.createFrame(options.data);
	        data.contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]);
	      }
	
	      return fn(context, {
	        data: data,
	        blockParams: _utils.blockParams([context], [data && data.contextPath])
	      });
	    } else {
	      return options.inverse(this);
	    }
	  });
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createNewLookupObject = createNewLookupObject;
	
	var _utils = __webpack_require__(55);
	
	/**
	 * Create a new object with "null"-prototype to avoid truthy results on prototype properties.
	 * The resulting object can be used with "object[property]" to check if a property exists
	 * @param {...object} sources a varargs parameter of source objects that will be merged
	 * @returns {object}
	 */
	
	function createNewLookupObject() {
	  for (var _len = arguments.length, sources = Array(_len), _key = 0; _key < _len; _key++) {
	    sources[_key] = arguments[_key];
	  }
	
	  return _utils.extend.apply(undefined, [Object.create(null)].concat(sources));
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2ludGVybmFsL2NyZWF0ZS1uZXctbG9va3VwLW9iamVjdC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztxQkFBdUIsVUFBVTs7Ozs7Ozs7O0FBUTFCLFNBQVMscUJBQXFCLEdBQWE7b0NBQVQsT0FBTztBQUFQLFdBQU87OztBQUM5QyxTQUFPLGdDQUFPLE1BQU0sQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUFDLFNBQUssT0FBTyxFQUFDLENBQUM7Q0FDaEQiLCJmaWxlIjoiY3JlYXRlLW5ldy1sb29rdXAtb2JqZWN0LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgZXh0ZW5kIH0gZnJvbSAnLi4vdXRpbHMnO1xuXG4vKipcbiAqIENyZWF0ZSBhIG5ldyBvYmplY3Qgd2l0aCBcIm51bGxcIi1wcm90b3R5cGUgdG8gYXZvaWQgdHJ1dGh5IHJlc3VsdHMgb24gcHJvdG90eXBlIHByb3BlcnRpZXMuXG4gKiBUaGUgcmVzdWx0aW5nIG9iamVjdCBjYW4gYmUgdXNlZCB3aXRoIFwib2JqZWN0W3Byb3BlcnR5XVwiIHRvIGNoZWNrIGlmIGEgcHJvcGVydHkgZXhpc3RzXG4gKiBAcGFyYW0gey4uLm9iamVjdH0gc291cmNlcyBhIHZhcmFyZ3MgcGFyYW1ldGVyIG9mIHNvdXJjZSBvYmplY3RzIHRoYXQgd2lsbCBiZSBtZXJnZWRcbiAqIEByZXR1cm5zIHtvYmplY3R9XG4gKi9cbmV4cG9ydCBmdW5jdGlvbiBjcmVhdGVOZXdMb29rdXBPYmplY3QoLi4uc291cmNlcykge1xuICByZXR1cm4gZXh0ZW5kKE9iamVjdC5jcmVhdGUobnVsbCksIC4uLnNvdXJjZXMpO1xufVxuIl19


/***/ }),
/* 1032 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.wrapHelper = wrapHelper;
	
	function wrapHelper(helper, transformOptionsFn) {
	  if (typeof helper !== 'function') {
	    // This should not happen, but apparently it does in https://github.com/wycats/handlebars.js/issues/1639
	    // We try to make the wrapper least-invasive by not wrapping it, if the helper is not a function.
	    return helper;
	  }
	  var wrapper = function wrapper() /* dynamic arguments */{
	    var options = arguments[arguments.length - 1];
	    arguments[arguments.length - 1] = transformOptionsFn(options);
	    return helper.apply(this, arguments);
	  };
	  return wrapper;
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2ludGVybmFsL3dyYXBIZWxwZXIuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBTyxTQUFTLFVBQVUsQ0FBQyxNQUFNLEVBQUUsa0JBQWtCLEVBQUU7QUFDckQsTUFBSSxPQUFPLE1BQU0sS0FBSyxVQUFVLEVBQUU7OztBQUdoQyxXQUFPLE1BQU0sQ0FBQztHQUNmO0FBQ0QsTUFBSSxPQUFPLEdBQUcsU0FBVixPQUFPLDBCQUFxQztBQUM5QyxRQUFNLE9BQU8sR0FBRyxTQUFTLENBQUMsU0FBUyxDQUFDLE1BQU0sR0FBRyxDQUFDLENBQUMsQ0FBQztBQUNoRCxhQUFTLENBQUMsU0FBUyxDQUFDLE1BQU0sR0FBRyxDQUFDLENBQUMsR0FBRyxrQkFBa0IsQ0FBQyxPQUFPLENBQUMsQ0FBQztBQUM5RCxXQUFPLE1BQU0sQ0FBQyxLQUFLLENBQUMsSUFBSSxFQUFFLFNBQVMsQ0FBQyxDQUFDO0dBQ3RDLENBQUM7QUFDRixTQUFPLE9BQU8sQ0FBQztDQUNoQiIsImZpbGUiOiJ3cmFwSGVscGVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGZ1bmN0aW9uIHdyYXBIZWxwZXIoaGVscGVyLCB0cmFuc2Zvcm1PcHRpb25zRm4pIHtcbiAgaWYgKHR5cGVvZiBoZWxwZXIgIT09ICdmdW5jdGlvbicpIHtcbiAgICAvLyBUaGlzIHNob3VsZCBub3QgaGFwcGVuLCBidXQgYXBwYXJlbnRseSBpdCBkb2VzIGluIGh0dHBzOi8vZ2l0aHViLmNvbS93eWNhdHMvaGFuZGxlYmFycy5qcy9pc3N1ZXMvMTYzOVxuICAgIC8vIFdlIHRyeSB0byBtYWtlIHRoZSB3cmFwcGVyIGxlYXN0LWludmFzaXZlIGJ5IG5vdCB3cmFwcGluZyBpdCwgaWYgdGhlIGhlbHBlciBpcyBub3QgYSBmdW5jdGlvbi5cbiAgICByZXR1cm4gaGVscGVyO1xuICB9XG4gIGxldCB3cmFwcGVyID0gZnVuY3Rpb24oLyogZHluYW1pYyBhcmd1bWVudHMgKi8pIHtcbiAgICBjb25zdCBvcHRpb25zID0gYXJndW1lbnRzW2FyZ3VtZW50cy5sZW5ndGggLSAxXTtcbiAgICBhcmd1bWVudHNbYXJndW1lbnRzLmxlbmd0aCAtIDFdID0gdHJhbnNmb3JtT3B0aW9uc0ZuKG9wdGlvbnMpO1xuICAgIHJldHVybiBoZWxwZXIuYXBwbHkodGhpcywgYXJndW1lbnRzKTtcbiAgfTtcbiAgcmV0dXJuIHdyYXBwZXI7XG59XG4iXX0=


/***/ }),
/* 1033 */
/***/ (function(module, exports) {

	/* global globalThis */
	'use strict';
	
	exports.__esModule = true;
	
	exports['default'] = function (Handlebars) {
	  /* istanbul ignore next */
	  // https://mathiasbynens.be/notes/globalthis
	  (function () {
	    if (typeof globalThis === 'object') return;
	    Object.prototype.__defineGetter__('__magic__', function () {
	      return this;
	    });
	    __magic__.globalThis = __magic__; // eslint-disable-line no-undef
	    delete Object.prototype.__magic__;
	  })();
	
	  var $Handlebars = globalThis.Handlebars;
	
	  /* istanbul ignore next */
	  Handlebars.noConflict = function () {
	    if (globalThis.Handlebars === Handlebars) {
	      globalThis.Handlebars = $Handlebars;
	    }
	    return Handlebars;
	  };
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL25vLWNvbmZsaWN0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O3FCQUNlLFVBQVMsVUFBVSxFQUFFOzs7QUFHbEMsR0FBQyxZQUFXO0FBQ1YsUUFBSSxPQUFPLFVBQVUsS0FBSyxRQUFRLEVBQUUsT0FBTztBQUMzQyxVQUFNLENBQUMsU0FBUyxDQUFDLGdCQUFnQixDQUFDLFdBQVcsRUFBRSxZQUFXO0FBQ3hELGFBQU8sSUFBSSxDQUFDO0tBQ2IsQ0FBQyxDQUFDO0FBQ0gsYUFBUyxDQUFDLFVBQVUsR0FBRyxTQUFTLENBQUM7QUFDakMsV0FBTyxNQUFNLENBQUMsU0FBUyxDQUFDLFNBQVMsQ0FBQztHQUNuQyxDQUFBLEVBQUcsQ0FBQzs7QUFFTCxNQUFNLFdBQVcsR0FBRyxVQUFVLENBQUMsVUFBVSxDQUFDOzs7QUFHMUMsWUFBVSxDQUFDLFVBQVUsR0FBRyxZQUFXO0FBQ2pDLFFBQUksVUFBVSxDQUFDLFVBQVUsS0FBSyxVQUFVLEVBQUU7QUFDeEMsZ0JBQVUsQ0FBQyxVQUFVLEdBQUcsV0FBVyxDQUFDO0tBQ3JDO0FBQ0QsV0FBTyxVQUFVLENBQUM7R0FDbkIsQ0FBQztDQUNIIiwiZmlsZSI6Im5vLWNvbmZsaWN0LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLyogZ2xvYmFsIGdsb2JhbFRoaXMgKi9cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uKEhhbmRsZWJhcnMpIHtcbiAgLyogaXN0YW5idWwgaWdub3JlIG5leHQgKi9cbiAgLy8gaHR0cHM6Ly9tYXRoaWFzYnluZW5zLmJlL25vdGVzL2dsb2JhbHRoaXNcbiAgKGZ1bmN0aW9uKCkge1xuICAgIGlmICh0eXBlb2YgZ2xvYmFsVGhpcyA9PT0gJ29iamVjdCcpIHJldHVybjtcbiAgICBPYmplY3QucHJvdG90eXBlLl9fZGVmaW5lR2V0dGVyX18oJ19fbWFnaWNfXycsIGZ1bmN0aW9uKCkge1xuICAgICAgcmV0dXJuIHRoaXM7XG4gICAgfSk7XG4gICAgX19tYWdpY19fLmdsb2JhbFRoaXMgPSBfX21hZ2ljX187IC8vIGVzbGludC1kaXNhYmxlLWxpbmUgbm8tdW5kZWZcbiAgICBkZWxldGUgT2JqZWN0LnByb3RvdHlwZS5fX21hZ2ljX187XG4gIH0pKCk7XG5cbiAgY29uc3QgJEhhbmRsZWJhcnMgPSBnbG9iYWxUaGlzLkhhbmRsZWJhcnM7XG5cbiAgLyogaXN0YW5idWwgaWdub3JlIG5leHQgKi9cbiAgSGFuZGxlYmFycy5ub0NvbmZsaWN0ID0gZnVuY3Rpb24oKSB7XG4gICAgaWYgKGdsb2JhbFRoaXMuSGFuZGxlYmFycyA9PT0gSGFuZGxlYmFycykge1xuICAgICAgZ2xvYmFsVGhpcy5IYW5kbGViYXJzID0gJEhhbmRsZWJhcnM7XG4gICAgfVxuICAgIHJldHVybiBIYW5kbGViYXJzO1xuICB9O1xufVxuIl19


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.checkRevision = checkRevision;
	exports.template = template;
	exports.wrapProgram = wrapProgram;
	exports.resolvePartial = resolvePartial;
	exports.invokePartial = invokePartial;
	exports.noop = noop;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// istanbul ignore next
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _utils = __webpack_require__(55);
	
	var Utils = _interopRequireWildcard(_utils);
	
	var _exception = __webpack_require__(87);
	
	var _exception2 = _interopRequireDefault(_exception);
	
	var _base = __webpack_require__(278);
	
	var _helpers = __webpack_require__(279);
	
	var _internalWrapHelper = __webpack_require__(1032);
	
	var _internalProtoAccess = __webpack_require__(280);
	
	function checkRevision(compilerInfo) {
	  var compilerRevision = compilerInfo && compilerInfo[0] || 1,
	      currentRevision = _base.COMPILER_REVISION;
	
	  if (compilerRevision >= _base.LAST_COMPATIBLE_COMPILER_REVISION && compilerRevision <= _base.COMPILER_REVISION) {
	    return;
	  }
	
	  if (compilerRevision < _base.LAST_COMPATIBLE_COMPILER_REVISION) {
	    var runtimeVersions = _base.REVISION_CHANGES[currentRevision],
	        compilerVersions = _base.REVISION_CHANGES[compilerRevision];
	    throw new _exception2['default']('Template was precompiled with an older version of Handlebars than the current runtime. ' + 'Please update your precompiler to a newer version (' + runtimeVersions + ') or downgrade your runtime to an older version (' + compilerVersions + ').');
	  } else {
	    // Use the embedded version info since the runtime doesn't know about this revision yet
	    throw new _exception2['default']('Template was precompiled with a newer version of Handlebars than the current runtime. ' + 'Please update your runtime to a newer version (' + compilerInfo[1] + ').');
	  }
	}
	
	function template(templateSpec, env) {
	  /* istanbul ignore next */
	  if (!env) {
	    throw new _exception2['default']('No environment passed to template');
	  }
	  if (!templateSpec || !templateSpec.main) {
	    throw new _exception2['default']('Unknown template object: ' + typeof templateSpec);
	  }
	
	  templateSpec.main.decorator = templateSpec.main_d;
	
	  // Note: Using env.VM references rather than local var references throughout this section to allow
	  // for external users to override these as pseudo-supported APIs.
	  env.VM.checkRevision(templateSpec.compiler);
	
	  // backwards compatibility for precompiled templates with compiler-version 7 (<4.3.0)
	  var templateWasPrecompiledWithCompilerV7 = templateSpec.compiler && templateSpec.compiler[0] === 7;
	
	  function invokePartialWrapper(partial, context, options) {
	    if (options.hash) {
	      context = Utils.extend({}, context, options.hash);
	      if (options.ids) {
	        options.ids[0] = true;
	      }
	    }
	    partial = env.VM.resolvePartial.call(this, partial, context, options);
	
	    var extendedOptions = Utils.extend({}, options, {
	      hooks: this.hooks,
	      protoAccessControl: this.protoAccessControl
	    });
	
	    var result = env.VM.invokePartial.call(this, partial, context, extendedOptions);
	
	    if (result == null && env.compile) {
	      options.partials[options.name] = env.compile(partial, templateSpec.compilerOptions, env);
	      result = options.partials[options.name](context, extendedOptions);
	    }
	    if (result != null) {
	      if (options.indent) {
	        var lines = result.split('\n');
	        for (var i = 0, l = lines.length; i < l; i++) {
	          if (!lines[i] && i + 1 === l) {
	            break;
	          }
	
	          lines[i] = options.indent + lines[i];
	        }
	        result = lines.join('\n');
	      }
	      return result;
	    } else {
	      throw new _exception2['default']('The partial ' + options.name + ' could not be compiled when running in runtime-only mode');
	    }
	  }
	
	  // Just add water
	  var container = {
	    strict: function strict(obj, name, loc) {
	      if (!obj || !(name in obj)) {
	        throw new _exception2['default']('"' + name + '" not defined in ' + obj, {
	          loc: loc
	        });
	      }
	      return container.lookupProperty(obj, name);
	    },
	    lookupProperty: function lookupProperty(parent, propertyName) {
	      var result = parent[propertyName];
	      if (result == null) {
	        return result;
	      }
	      if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	        return result;
	      }
	
	      if (_internalProtoAccess.resultIsAllowed(result, container.protoAccessControl, propertyName)) {
	        return result;
	      }
	      return undefined;
	    },
	    lookup: function lookup(depths, name) {
	      var len = depths.length;
	      for (var i = 0; i < len; i++) {
	        var result = depths[i] && container.lookupProperty(depths[i], name);
	        if (result != null) {
	          return depths[i][name];
	        }
	      }
	    },
	    lambda: function lambda(current, context) {
	      return typeof current === 'function' ? current.call(context) : current;
	    },
	
	    escapeExpression: Utils.escapeExpression,
	    invokePartial: invokePartialWrapper,
	
	    fn: function fn(i) {
	      var ret = templateSpec[i];
	      ret.decorator = templateSpec[i + '_d'];
	      return ret;
	    },
	
	    programs: [],
	    program: function program(i, data, declaredBlockParams, blockParams, depths) {
	      var programWrapper = this.programs[i],
	          fn = this.fn(i);
	      if (data || depths || blockParams || declaredBlockParams) {
	        programWrapper = wrapProgram(this, i, fn, data, declaredBlockParams, blockParams, depths);
	      } else if (!programWrapper) {
	        programWrapper = this.programs[i] = wrapProgram(this, i, fn);
	      }
	      return programWrapper;
	    },
	
	    data: function data(value, depth) {
	      while (value && depth--) {
	        value = value._parent;
	      }
	      return value;
	    },
	    mergeIfNeeded: function mergeIfNeeded(param, common) {
	      var obj = param || common;
	
	      if (param && common && param !== common) {
	        obj = Utils.extend({}, common, param);
	      }
	
	      return obj;
	    },
	    // An empty object to use as replacement for null-contexts
	    nullContext: Object.seal({}),
	
	    noop: env.VM.noop,
	    compilerInfo: templateSpec.compiler
	  };
	
	  function ret(context) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    var data = options.data;
	
	    ret._setup(options);
	    if (!options.partial && templateSpec.useData) {
	      data = initData(context, data);
	    }
	    var depths = undefined,
	        blockParams = templateSpec.useBlockParams ? [] : undefined;
	    if (templateSpec.useDepths) {
	      if (options.depths) {
	        depths = context != options.depths[0] ? [context].concat(options.depths) : options.depths;
	      } else {
	        depths = [context];
	      }
	    }
	
	    function main(context /*, options*/) {
	      return '' + templateSpec.main(container, context, container.helpers, container.partials, data, blockParams, depths);
	    }
	
	    main = executeDecorators(templateSpec.main, main, container, options.depths || [], data, blockParams);
	    return main(context, options);
	  }
	
	  ret.isTop = true;
	
	  ret._setup = function (options) {
	    if (!options.partial) {
	      var mergedHelpers = Utils.extend({}, env.helpers, options.helpers);
	      wrapHelpersToPassLookupProperty(mergedHelpers, container);
	      container.helpers = mergedHelpers;
	
	      if (templateSpec.usePartial) {
	        // Use mergeIfNeeded here to prevent compiling global partials multiple times
	        container.partials = container.mergeIfNeeded(options.partials, env.partials);
	      }
	      if (templateSpec.usePartial || templateSpec.useDecorators) {
	        container.decorators = Utils.extend({}, env.decorators, options.decorators);
	      }
	
	      container.hooks = {};
	      container.protoAccessControl = _internalProtoAccess.createProtoAccessControl(options);
	
	      var keepHelperInHelpers = options.allowCallsToHelperMissing || templateWasPrecompiledWithCompilerV7;
	      _helpers.moveHelperToHooks(container, 'helperMissing', keepHelperInHelpers);
	      _helpers.moveHelperToHooks(container, 'blockHelperMissing', keepHelperInHelpers);
	    } else {
	      container.protoAccessControl = options.protoAccessControl; // internal option
	      container.helpers = options.helpers;
	      container.partials = options.partials;
	      container.decorators = options.decorators;
	      container.hooks = options.hooks;
	    }
	  };
	
	  ret._child = function (i, data, blockParams, depths) {
	    if (templateSpec.useBlockParams && !blockParams) {
	      throw new _exception2['default']('must pass block params');
	    }
	    if (templateSpec.useDepths && !depths) {
	      throw new _exception2['default']('must pass parent depths');
	    }
	
	    return wrapProgram(container, i, templateSpec[i], data, 0, blockParams, depths);
	  };
	  return ret;
	}
	
	function wrapProgram(container, i, fn, data, declaredBlockParams, blockParams, depths) {
	  function prog(context) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    var currentDepths = depths;
	    if (depths && context != depths[0] && !(context === container.nullContext && depths[0] === null)) {
	      currentDepths = [context].concat(depths);
	    }
	
	    return fn(container, context, container.helpers, container.partials, options.data || data, blockParams && [options.blockParams].concat(blockParams), currentDepths);
	  }
	
	  prog = executeDecorators(fn, prog, container, depths, data, blockParams);
	
	  prog.program = i;
	  prog.depth = depths ? depths.length : 0;
	  prog.blockParams = declaredBlockParams || 0;
	  return prog;
	}
	
	/**
	 * This is currently part of the official API, therefore implementation details should not be changed.
	 */
	
	function resolvePartial(partial, context, options) {
	  if (!partial) {
	    if (options.name === '@partial-block') {
	      partial = options.data['partial-block'];
	    } else {
	      partial = options.partials[options.name];
	    }
	  } else if (!partial.call && !options.name) {
	    // This is a dynamic partial that returned a string
	    options.name = partial;
	    partial = options.partials[partial];
	  }
	  return partial;
	}
	
	function invokePartial(partial, context, options) {
	  // Use the current closure context to save the partial-block if this partial
	  var currentPartialBlock = options.data && options.data['partial-block'];
	  options.partial = true;
	  if (options.ids) {
	    options.data.contextPath = options.ids[0] || options.data.contextPath;
	  }
	
	  var partialBlock = undefined;
	  if (options.fn && options.fn !== noop) {
	    (function () {
	      options.data = _base.createFrame(options.data);
	      // Wrapper function to get access to currentPartialBlock from the closure
	      var fn = options.fn;
	      partialBlock = options.data['partial-block'] = function partialBlockWrapper(context) {
	        var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	        // Restore the partial-block from the closure for the execution of the block
	        // i.e. the part inside the block of the partial call.
	        options.data = _base.createFrame(options.data);
	        options.data['partial-block'] = currentPartialBlock;
	        return fn(context, options);
	      };
	      if (fn.partials) {
	        options.partials = Utils.extend({}, options.partials, fn.partials);
	      }
	    })();
	  }
	
	  if (partial === undefined && partialBlock) {
	    partial = partialBlock;
	  }
	
	  if (partial === undefined) {
	    throw new _exception2['default']('The partial ' + options.name + ' could not be found');
	  } else if (partial instanceof Function) {
	    return partial(context, options);
	  }
	}
	
	function noop() {
	  return '';
	}
	
	function initData(context, data) {
	  if (!data || !('root' in data)) {
	    data = data ? _base.createFrame(data) : {};
	    data.root = context;
	  }
	  return data;
	}
	
	function executeDecorators(fn, prog, container, depths, data, blockParams) {
	  if (fn.decorator) {
	    var props = {};
	    prog = fn.decorator(prog, props, container, depths && depths[0], data, blockParams, depths);
	    Utils.extend(prog, props);
	  }
	  return prog;
	}
	
	function wrapHelpersToPassLookupProperty(mergedHelpers, container) {
	  Object.keys(mergedHelpers).forEach(function (helperName) {
	    var helper = mergedHelpers[helperName];
	    mergedHelpers[helperName] = passLookupPropertyOption(helper, container);
	  });
	}
	
	function passLookupPropertyOption(helper, container) {
	  var lookupProperty = container.lookupProperty;
	  return _internalWrapHelper.wrapHelper(helper, function (options) {
	    return Utils.extend({ lookupProperty: lookupProperty }, options);
	  });
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 1035 */
/***/ (function(module, exports) {

	// Build out our basic SafeString type
	'use strict';
	
	exports.__esModule = true;
	function SafeString(string) {
	  this.string = string;
	}
	
	SafeString.prototype.toString = SafeString.prototype.toHTML = function () {
	  return '' + this.string;
	};
	
	exports['default'] = SafeString;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL3NhZmUtc3RyaW5nLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7QUFDQSxTQUFTLFVBQVUsQ0FBQyxNQUFNLEVBQUU7QUFDMUIsTUFBSSxDQUFDLE1BQU0sR0FBRyxNQUFNLENBQUM7Q0FDdEI7O0FBRUQsVUFBVSxDQUFDLFNBQVMsQ0FBQyxRQUFRLEdBQUcsVUFBVSxDQUFDLFNBQVMsQ0FBQyxNQUFNLEdBQUcsWUFBVztBQUN2RSxTQUFPLEVBQUUsR0FBRyxJQUFJLENBQUMsTUFBTSxDQUFDO0NBQ3pCLENBQUM7O3FCQUVhLFVBQVUiLCJmaWxlIjoic2FmZS1zdHJpbmcuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBCdWlsZCBvdXQgb3VyIGJhc2ljIFNhZmVTdHJpbmcgdHlwZVxuZnVuY3Rpb24gU2FmZVN0cmluZyhzdHJpbmcpIHtcbiAgdGhpcy5zdHJpbmcgPSBzdHJpbmc7XG59XG5cblNhZmVTdHJpbmcucHJvdG90eXBlLnRvU3RyaW5nID0gU2FmZVN0cmluZy5wcm90b3R5cGUudG9IVE1MID0gZnVuY3Rpb24oKSB7XG4gIHJldHVybiAnJyArIHRoaXMuc3RyaW5nO1xufTtcblxuZXhwb3J0IGRlZmF1bHQgU2FmZVN0cmluZztcbiJdfQ==


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var origSymbol = typeof Symbol !== 'undefined' && Symbol;
	var hasSymbolSham = __webpack_require__(1037);
	
	/** @type {import('.')} */
	module.exports = function hasNativeSymbols() {
		if (typeof origSymbol !== 'function') { return false; }
		if (typeof Symbol !== 'function') { return false; }
		if (typeof origSymbol('foo') !== 'symbol') { return false; }
		if (typeof Symbol('bar') !== 'symbol') { return false; }
	
		return hasSymbolSham();
	};


/***/ }),
/* 1037 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./shams')} */
	/* eslint complexity: [2, 18], max-statements: [2, 33] */
	module.exports = function hasSymbols() {
		if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
		if (typeof Symbol.iterator === 'symbol') { return true; }
	
		/** @type {{ [k in symbol]?: unknown }} */
		var obj = {};
		var sym = Symbol('test');
		var symObj = Object(sym);
		if (typeof sym === 'string') { return false; }
	
		if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
		if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }
	
		// temp disabled per https://github.com/ljharb/object.assign/issues/17
		// if (sym instanceof Symbol) { return false; }
		// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
		// if (!(symObj instanceof Symbol)) { return false; }
	
		// if (typeof Symbol.prototype.toString !== 'function') { return false; }
		// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
	
		var symVal = 42;
		obj[sym] = symVal;
		for (var _ in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
		if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }
	
		if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }
	
		var syms = Object.getOwnPropertySymbols(obj);
		if (syms.length !== 1 || syms[0] !== sym) { return false; }
	
		if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }
	
		if (typeof Object.getOwnPropertyDescriptor === 'function') {
			// eslint-disable-next-line no-extra-parens
			var descriptor = /** @type {PropertyDescriptor} */ (Object.getOwnPropertyDescriptor(obj, sym));
			if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
		}
	
		return true;
	};


/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var call = Function.prototype.call;
	var $hasOwn = Object.prototype.hasOwnProperty;
	var bind = __webpack_require__(135);
	
	/** @type {import('.')} */
	module.exports = bind.call(call, $hasOwn);


/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	 jQuery Masked Input Plugin
	 Copyright (c) 2007 - 2015 Josh Bush (digitalbush.com)
	 Licensed under the MIT license (http://digitalbush.com/projects/masked-input-plugin/#license)
	 Version: 1.4.1
	 */
	var $ = __webpack_require__(12);
	
	/*
	 jQuery Masked Input Plugin
	 Copyright (c) 2007 - 2015 Josh Bush (digitalbush.com)
	 Licensed under the MIT license (http://digitalbush.com/projects/masked-input-plugin/#license)
	 Version: 1.4.1
	 */
	!function(factory) {
	   true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(12) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory("object" == typeof exports ? require("jquery") : jQuery);
	}(function($) {
	  var caretTimeoutId, ua = navigator.userAgent, iPhone = /iphone/i.test(ua), chrome = /chrome/i.test(ua), android = /android/i.test(ua);
	  $.mask = {
	    definitions: {
	      "9": "[0-9]",
	      a: "[A-Za-z]",
	      "*": "[A-Za-z0-9]"
	    },
	    autoclear: !0,
	    dataName: "rawMaskFn",
	    placeholder: "_"
	  }, $.fn.extend({
	    caret: function(begin, end) {
	      var range;
	      if (0 !== this.length && !this.is(":hidden") && this.get(0) === document.activeElement) return "number" == typeof begin ? (end = "number" == typeof end ? end : begin,
	        this.each(function() {
	          this.setSelectionRange ? this.setSelectionRange(begin, end) : this.createTextRange && (range = this.createTextRange(),
	            range.collapse(!0), range.moveEnd("character", end), range.moveStart("character", begin),
	            range.select());
	        })) : (this[0].setSelectionRange ? (begin = this[0].selectionStart, end = this[0].selectionEnd) : document.selection && document.selection.createRange && (range = document.selection.createRange(),
	        begin = 0 - range.duplicate().moveStart("character", -1e5), end = begin + range.text.length),
	      {
	        begin: begin,
	        end: end
	      });
	    },
	    unmask: function() {
	      return this.trigger("unmask");
	    },
	    mask: function(mask, settings) {
	      var input, defs, tests, partialPosition, firstNonMaskPos, lastRequiredNonMaskPos, len, oldVal;
	      if (!mask && this.length > 0) {
	        input = $(this[0]);
	        var fn = input.data($.mask.dataName);
	        return fn ? fn() : void 0;
	      }
	      return settings = $.extend({
	        autoclear: $.mask.autoclear,
	        placeholder: $.mask.placeholder,
	        completed: null
	      }, settings), defs = $.mask.definitions, tests = [], partialPosition = len = mask.length,
	        firstNonMaskPos = null, mask = String(mask), $.each(mask.split(""), function(i, c) {
	        "?" == c ? (len--, partialPosition = i) : defs[c] ? (tests.push(new RegExp(defs[c])),
	        null === firstNonMaskPos && (firstNonMaskPos = tests.length - 1), partialPosition > i && (lastRequiredNonMaskPos = tests.length - 1)) : tests.push(null);
	      }), this.trigger("unmask").each(function() {
	        function tryFireCompleted() {
	          if (settings.completed) {
	            for (var i = firstNonMaskPos; lastRequiredNonMaskPos >= i; i++) if (tests[i] && buffer[i] === getPlaceholder(i)) return;
	            settings.completed.call(input);
	          }
	        }
	        function getPlaceholder(i) {
	          return i < settings.placeholder.length ? settings.placeholder.charAt(i) : settings.placeholder.charAt(0);
	        }
	        function seekNext(pos) {
	          for (;++pos < len && !tests[pos]; ) ;
	          return pos;
	        }
	        function seekPrev(pos) {
	          for (;--pos >= 0 && !tests[pos]; ) ;
	          return pos;
	        }
	        function shiftL(begin, end) {
	          var i, j;
	          if (!(0 > begin)) {
	            for (i = begin, j = seekNext(end); len > i; i++) if (tests[i]) {
	              if (!(len > j && tests[i].test(buffer[j]))) break;
	              buffer[i] = buffer[j], buffer[j] = getPlaceholder(j), j = seekNext(j);
	            }
	            writeBuffer(), input.caret(Math.max(firstNonMaskPos, begin));
	          }
	        }
	        function shiftR(pos) {
	          var i, c, j, t;
	          for (i = pos, c = getPlaceholder(pos); len > i; i++) if (tests[i]) {
	            if (j = seekNext(i), t = buffer[i], buffer[i] = c, !(len > j && tests[j].test(t))) break;
	            c = t;
	          }
	        }
	        function androidInputEvent(e) {
	          var curVal = input.val(), pos = input.caret();
	          if (oldVal && oldVal.length && oldVal.length > curVal.length) {
	            for (checkVal(!0); pos.begin > 0 && !tests[pos.begin - 1]; ) pos.begin--;
	            if (0 === pos.begin) for (;pos.begin < firstNonMaskPos && !tests[pos.begin]; ) pos.begin++;
	            input.caret(pos.begin, pos.begin);
	          } else {
	            var lastEnteredValue = (checkVal(!0), curVal.charAt(pos.begin));
	            pos.begin < len && (tests[pos.begin] ? tests[pos.begin].test(lastEnteredValue) && pos.begin++ : (pos.begin++,
	            tests[pos.begin].test(lastEnteredValue) && pos.begin++)), input.caret(pos.begin, pos.begin);
	          }
	          tryFireCompleted();
	        }
	        function blurEvent(e) {
	          checkVal(), input.val() != focusText && input.change();
	        }
	        function keydownEvent(e) {
	          if (!input.prop("readonly")) {
	            var pos, begin, end, k = e.which || e.keyCode;
	            oldVal = input.val(), 8 === k || 46 === k || iPhone && 127 === k ? (pos = input.caret(),
	              begin = pos.begin, end = pos.end, end - begin === 0 && (begin = 46 !== k ? seekPrev(begin) : end = seekNext(begin - 1),
	              end = 46 === k ? seekNext(end) : end), clearBuffer(begin, end), shiftL(begin, end - 1),
	              e.preventDefault()) : 13 === k ? blurEvent.call(this, e) : 27 === k && (input.val(focusText),
	              input.caret(0, checkVal()), e.preventDefault());
	          }
	        }
	        function keypressEvent(e) {
	          if (!input.prop("readonly")) {
	            var p, c, next, k = e.which || e.keyCode, pos = input.caret();
	            if (!(e.ctrlKey || e.altKey || e.metaKey || 40 > k) && k && 13 !== k) {
	              if (pos.end - pos.begin !== 0 && (clearBuffer(pos.begin, pos.end), shiftL(pos.begin, pos.end - 1)),
	                  p = seekNext(pos.begin - 1), len > p && (c = String.fromCharCode(k), tests[p].test(c))) {
	                if (shiftR(p), buffer[p] = c, writeBuffer(), next = seekNext(p), android) {
	                  var proxy = function() {
	                    $.proxy($.fn.caret, input, next)();
	                  };
	                  setTimeout(proxy, 0);
	                } else input.caret(next);
	                pos.begin <= lastRequiredNonMaskPos && tryFireCompleted();
	              }
	              e.preventDefault();
	            }
	          }
	        }
	        function clearBuffer(start, end) {
	          var i;
	          for (i = start; end > i && len > i; i++) tests[i] && (buffer[i] = getPlaceholder(i));
	        }
	        function writeBuffer() {
	          input.val(buffer.join(""));
	        }
	        function checkVal(allow) {
	          var i, c, pos, test = input.val(), lastMatch = -1;
	          for (i = 0, pos = 0; len > i; i++) if (tests[i]) {
	            for (buffer[i] = getPlaceholder(i); pos++ < test.length; ) if (c = test.charAt(pos - 1),
	                tests[i].test(c)) {
	              buffer[i] = c, lastMatch = i;
	              break;
	            }
	            if (pos > test.length) {
	              clearBuffer(i + 1, len);
	              break;
	            }
	          } else buffer[i] === test.charAt(pos) && pos++, partialPosition > i && (lastMatch = i);
	          return allow ? writeBuffer() : partialPosition > lastMatch + 1 ? settings.autoclear || buffer.join("") === defaultBuffer ? (input.val() && input.val(""),
	            clearBuffer(0, len)) : writeBuffer() : (writeBuffer(), input.val(input.val().substring(0, lastMatch + 1))),
	            partialPosition ? i : firstNonMaskPos;
	        }
	        var input = $(this), buffer = $.map(mask.split(""), function(c, i) {
	          return "?" != c ? defs[c] ? getPlaceholder(i) : c : void 0;
	        }), defaultBuffer = buffer.join(""), focusText = input.val();
	        input.data($.mask.dataName, function() {
	          return $.map(buffer, function(c, i) {
	            return tests[i] && c != getPlaceholder(i) ? c : null;
	          }).join("");
	        }), input.one("unmask", function() {
	          input.off(".mask").removeData($.mask.dataName);
	        }).on("focus.mask", function() {
	          if (!input.prop("readonly")) {
	            clearTimeout(caretTimeoutId);
	            var pos;
	            focusText = input.val(), pos = checkVal(), caretTimeoutId = setTimeout(function() {
	              input.get(0) === document.activeElement && (writeBuffer(), pos == mask.replace("?", "").length ? input.caret(0, pos) : input.caret(pos));
	            }, 10);
	          }
	        }).on("blur.mask", blurEvent).on("keydown.mask", keydownEvent).on("keypress.mask", keypressEvent).on("input.mask paste.mask", function() {
	          input.prop("readonly") || setTimeout(function() {
	            var pos = checkVal(!0);
	            input.caret(pos), tryFireCompleted();
	          }, 0);
	        }), chrome && android && input.off("input.mask").on("input.mask", androidInputEvent),
	          checkVal();
	      });
	    }
	  });
	});


/***/ }),
/* 1040 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./abs')} */
	module.exports = Math.abs;


/***/ }),
/* 1041 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./abs')} */
	module.exports = Math.floor;


/***/ }),
/* 1042 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./max')} */
	module.exports = Math.max;


/***/ }),
/* 1043 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./min')} */
	module.exports = Math.min;


/***/ }),
/* 1044 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./pow')} */
	module.exports = Math.pow;


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
	    if (typeof root === "undefined") {
	        root = {};
	    }
	    if (true) {
	        // AMD. Register as an anonymous module unless amdModuleId is set
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(34)], __WEBPACK_AMD_DEFINE_RESULT__ = function (a0) {
	            return (root['DateRange'] = factory(a0));
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        // Node. Does not work with strict CommonJS, but
	        // only CommonJS-like environments that support module.exports,
	        // like Node.
	        module.exports = factory(require("moment"));
	    } else {
	        root['DateRange'] = factory(moment);
	    }
	}(this, function (moment) {
	
	//-----------------------------------------------------------------------------
	// Contstants
	//-----------------------------------------------------------------------------
	
	
	
	    var INTERVALS = {
	        year:   true,
	        month:  true,
	        week:   true,
	        day:    true,
	        hour:   true,
	        minute: true,
	        second: true
	    };
	
	
	//-----------------------------------------------------------------------------
	// Date Ranges
	//-----------------------------------------------------------------------------
	
	    /**
	     * DateRange class to store ranges and query dates.
	     *
	     * @constructor
	     * @param {(Moment|Date)} start Start of interval
	     * @param {(Moment|Date)} end End of interval
	     *//**
	     * DateRange class to store ranges and query dates.
	     *
	     * @constructor
	     * @param {!Array} range Array containing start and end dates.
	     *//**
	     * DateRange class to store ranges and query dates.
	     *
	     * @constructor
	     * @param {!String} range String formatted as an IS0 8601 time interval
	     */
	    function DateRange(start, end) {
	        var parts;
	        var s = start;
	        var e = end;
	
	        if (arguments.length === 1 || end === undefined) {
	            if (typeof start === 'object' && start.length === 2) {
	                s = start[0];
	                e = start[1];
	            }
	            else if (typeof start === 'string') {
	                parts = start.split('/');
	                s = parts[0];
	                e = parts[1];
	            }
	        }
	
	        this.start = (s === null) ? moment(-8640000000000000) : moment(s);
	        this.end   = (e === null) ? moment(8640000000000000) : moment(e);
	    }
	
	    /**
	     * Constructor for prototype.
	     *
	     * @type {DateRange}
	     */
	    DateRange.prototype.constructor = DateRange;
	
	    /**
	     * Deep clone range.
	     *
	     * @return {!DateRange}
	     */
	    DateRange.prototype.clone = function() {
	        return moment().range(this.start, this.end);
	    };
	
	    /**
	     * Determine if the current interval contains a given moment/date/range.
	     *
	     * @param {(Moment|Date|DateRange)} other Date to check
	     * @param {!boolean} exclusive True if the to value is exclusive
	     *
	     * @return {!boolean}
	     */
	    DateRange.prototype.contains = function(other, exclusive) {
	        var start = this.start;
	        var end   = this.end;
	
	        if (other instanceof DateRange) {
	            return start <= other.start && (end > other.end || (end.isSame(other.end) && !exclusive));
	        }
	        else {
	            return start <= other && (end > other || (end.isSame(other) && !exclusive));
	        }
	    };
	
	    /**
	     * Determine if the current date range overlaps a given date range.
	     *
	     * @param {!DateRange} range Date range to check
	     *
	     * @return {!boolean}
	     */
	    DateRange.prototype.overlaps = function(range) {
	        return this.intersect(range) !== null;
	    };
	
	    /**
	     * Determine the intersecting periods from one or more date ranges.
	     *
	     * @param {!DateRange} other A date range to intersect with this one
	     *
	     * @return {DateRange} Returns the intersecting date or `null` if the ranges do
	     *                     not intersect
	     */
	    DateRange.prototype.intersect = function(other) {
	        var start = this.start;
	        var end   = this.end;
	
	        if ((start <= other.start) && (other.start < end) && (end < other.end)) {
	            return new DateRange(other.start, end);
	        }
	        else if ((other.start < start) && (start < other.end) && (other.end <= end)) {
	            return new DateRange(start, other.end);
	        }
	        else if ((other.start < start) && (start <= end) && (end < other.end)) {
	            return this;
	        }
	        else if ((start <= other.start) && (other.start <= other.end) && (other.end <= end)) {
	            return other;
	        }
	
	        return null;
	    };
	
	    /**
	     * Merge date ranges if they intersect.
	     *
	     * @param {!DateRange} other A date range to add to this one
	     *
	     * @return {DateRange} Returns the new `DateRange` or `null` if they do not
	     *                     overlap
	     */
	    DateRange.prototype.add = function(other) {
	        if (this.overlaps(other)) {
	            return new DateRange(moment.min(this.start, other.start), moment.max(this.end, other.end));
	        }
	
	        return null;
	    };
	
	    /**
	     * Subtract one range from another.
	     *
	     * @param {!DateRange} other A date range to substract from this one
	     *
	     * @return {!Array<DateRange>}
	     */
	    DateRange.prototype.subtract = function(other) {
	        var start = this.start;
	        var end   = this.end;
	
	        if (this.intersect(other) === null) {
	            return [this];
	        }
	        else if ((other.start <= start) && (start < end) && (end <= other.end)) {
	            return [];
	        }
	        else if ((other.start <= start) && (start < other.end) && (other.end < end)) {
	            return [new DateRange(other.end, end)];
	        }
	        else if ((start < other.start) && (other.start < end) && (end <= other.end)) {
	            return [new DateRange(start, other.start)];
	        }
	        else if ((start < other.start) && (other.start < other.end) && (other.end < end)) {
	            return [new DateRange(start, other.start), new DateRange(other.end, end)];
	        }
	        else if ((start < other.start) && (other.start < end) && (other.end < end)) {
	            return [new DateRange(start, other.start), new DateRange(other.start, end)];
	        }
	    };
	
	    /**
	     * Build a n array of dates.
	     *
	     * @param {(!DateRange|String)} range Date range to be used for iteration or
	     *                                    shorthand string (shorthands:
	     *                                    http://momentjs.com/docs/#/manipulating/add/)
	     * @param {!boolean} exclusive Indicate that the end of the range should not
	     *                             be included in the iter.
	     *
	     * @return {!Array}
	     */
	    DateRange.prototype.toArray = function(by, exclusive) {
	        var acc = [];
	        this.by(by, function(unit) {
	            acc.push(unit);
	        }, exclusive);
	        return acc;
	    };
	
	    /**
	     * Iterate over the date range by a given date range, executing a function
	     * for each sub-range.
	     *
	     * @param {(!DateRange|String)} range Date range to be used for iteration or
	     *                                    shorthand string (shorthands:
	     *                                    http://momentjs.com/docs/#/manipulating/add/)
	     * @param {!DateRange~by} hollaback Callback
	     * @param {!boolean} exclusive Indicate that the end of the range should not
	     *                             be included in the iter.
	     *
	     * @return {DateRange} `this`
	     */
	    DateRange.prototype.by = function(range, hollaback, exclusive) {
	        if (typeof range === 'string') {
	            _byString.call(this, range, hollaback, exclusive);
	        }
	        else {
	            _byRange.call(this, range, hollaback, exclusive);
	        }
	        return this;
	    };
	
	
	    /**
	     * Callback executed for each sub-range.
	     *
	     * @callback DateRange~by
	     *
	     * @param {!Moment} current Current moment object for iteration
	     */
	
	    /**
	     * @private
	     */
	    function _byString(interval, hollaback, exclusive) {
	        var current = moment(this.start);
	
	        while (this.contains(current, exclusive)) {
	            hollaback.call(this, current.clone());
	            current.add(1, interval);
	        }
	    }
	
	    /**
	     * @private
	     */
	    function _byRange(interval, hollaback, exclusive) {
	        var div = this / interval;
	        var l = Math.floor(div);
	
	        if (l === Infinity) { return; }
	        if (l === div && exclusive) {
	            l--;
	        }
	
	        for (var i = 0; i <= l; i++) {
	            hollaback.call(this, moment(this.start.valueOf() + interval.valueOf() * i));
	        }
	    }
	
	    /**
	     * Date range formatted as an [ISO8601 Time
	     * Interval](http://en.wikipedia.org/wiki/ISO_8601#Time_intervals).
	     *
	     * @return {!String}
	     */
	    DateRange.prototype.toString = function() {
	        return this.start.format() + '/' + this.end.format();
	    };
	
	    /**
	     * Date range in milliseconds. Allows basic coercion math of date ranges.
	     *
	     * @return {!number}
	     */
	    DateRange.prototype.valueOf = function() {
	        return this.end - this.start;
	    };
	
	    /**
	     * Center date of the range.
	     *
	     * @return {!Moment}
	     */
	    DateRange.prototype.center = function() {
	        var center = this.start + this.diff() / 2;
	        return moment(center);
	    };
	
	    /**
	     * Date range toDate
	     *
	     * @return {!Array<Date>}
	     */
	    DateRange.prototype.toDate = function() {
	        return [this.start.toDate(), this.end.toDate()];
	    };
	
	    /**
	     * Determine if this date range is the same as another.
	     *
	     * @param {!DateRange} other Another date range to compare to
	     *
	     * @return {!boolean}
	     */
	    DateRange.prototype.isSame = function(other) {
	        return this.start.isSame(other.start) && this.end.isSame(other.end);
	    };
	
	    /**
	     * The difference of the end vs start.
	     *
	     * @param {number} unit Unit of difference, if no unit is passed in
	     *                      milliseconds are returned. E.g.: `"days"`, `"months"`,
	     *                      etc...
	     *
	     * @return {!number}
	     */
	    DateRange.prototype.diff = function(unit) {
	        return this.end.diff(this.start, unit);
	    };
	
	
	//-----------------------------------------------------------------------------
	// Moment Extensions
	//-----------------------------------------------------------------------------
	
	    /**
	     * Build a date range.
	     *
	     * @param {(Moment|Date)} start Start of range
	     * @param {(Moment|Date)} end End of range
	     *
	     * @this {Moment}
	     *
	     * @return {!DateRange}
	     */
	    moment.range = function(start, end) {
	        if (start in INTERVALS) {
	            return new DateRange(moment(this).startOf(start), moment(this).endOf(start));
	        }
	        else {
	            return new DateRange(start, end);
	        }
	    };
	
	    /**
	     * Expose constructor
	     *
	     * @const
	     */
	    moment.range.constructor = DateRange;
	
	    /**
	     * @deprecated
	     */
	    moment.fn.range = moment.range;
	
	    /**
	     * Check if the current moment is within a given date range.
	     *
	     * @param {!DateRange} range Date range to check
	     *
	     * @this {Moment}
	     *
	     * @return {!boolean}
	     */
	    moment.fn.within = function(range) {
	        return range.contains(this._d);
	    };
	
	
	//-----------------------------------------------------------------------------
	// Export
	//-----------------------------------------------------------------------------
	
	
	
	    return DateRange;
	
	}));


/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./ru": 194,
		"./ru.js": 194
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1046;


/***/ }),
/* 1047 */
/***/ (function(module, exports) {

	'use strict';
	
	var DOCUMENT_FRAGMENT_NODE = 11;
	
	function morphAttrs(fromNode, toNode) {
	    var toNodeAttrs = toNode.attributes;
	    var attr;
	    var attrName;
	    var attrNamespaceURI;
	    var attrValue;
	    var fromValue;
	
	    // document-fragments dont have attributes so lets not do anything
	    if (toNode.nodeType === DOCUMENT_FRAGMENT_NODE || fromNode.nodeType === DOCUMENT_FRAGMENT_NODE) {
	      return;
	    }
	
	    // update attributes on original DOM element
	    for (var i = toNodeAttrs.length - 1; i >= 0; i--) {
	        attr = toNodeAttrs[i];
	        attrName = attr.name;
	        attrNamespaceURI = attr.namespaceURI;
	        attrValue = attr.value;
	
	        if (attrNamespaceURI) {
	            attrName = attr.localName || attrName;
	            fromValue = fromNode.getAttributeNS(attrNamespaceURI, attrName);
	
	            if (fromValue !== attrValue) {
	                if (attr.prefix === 'xmlns'){
	                    attrName = attr.name; // It's not allowed to set an attribute with the XMLNS namespace without specifying the `xmlns` prefix
	                }
	                fromNode.setAttributeNS(attrNamespaceURI, attrName, attrValue);
	            }
	        } else {
	            fromValue = fromNode.getAttribute(attrName);
	
	            if (fromValue !== attrValue) {
	                fromNode.setAttribute(attrName, attrValue);
	            }
	        }
	    }
	
	    // Remove any extra attributes found on the original DOM element that
	    // weren't found on the target element.
	    var fromNodeAttrs = fromNode.attributes;
	
	    for (var d = fromNodeAttrs.length - 1; d >= 0; d--) {
	        attr = fromNodeAttrs[d];
	        attrName = attr.name;
	        attrNamespaceURI = attr.namespaceURI;
	
	        if (attrNamespaceURI) {
	            attrName = attr.localName || attrName;
	
	            if (!toNode.hasAttributeNS(attrNamespaceURI, attrName)) {
	                fromNode.removeAttributeNS(attrNamespaceURI, attrName);
	            }
	        } else {
	            if (!toNode.hasAttribute(attrName)) {
	                fromNode.removeAttribute(attrName);
	            }
	        }
	    }
	}
	
	var range; // Create a range object for efficently rendering strings to elements.
	var NS_XHTML = 'http://www.w3.org/1999/xhtml';
	
	var doc = typeof document === 'undefined' ? undefined : document;
	var HAS_TEMPLATE_SUPPORT = !!doc && 'content' in doc.createElement('template');
	var HAS_RANGE_SUPPORT = !!doc && doc.createRange && 'createContextualFragment' in doc.createRange();
	
	function createFragmentFromTemplate(str) {
	    var template = doc.createElement('template');
	    template.innerHTML = str;
	    return template.content.childNodes[0];
	}
	
	function createFragmentFromRange(str) {
	    if (!range) {
	        range = doc.createRange();
	        range.selectNode(doc.body);
	    }
	
	    var fragment = range.createContextualFragment(str);
	    return fragment.childNodes[0];
	}
	
	function createFragmentFromWrap(str) {
	    var fragment = doc.createElement('body');
	    fragment.innerHTML = str;
	    return fragment.childNodes[0];
	}
	
	/**
	 * This is about the same
	 * var html = new DOMParser().parseFromString(str, 'text/html');
	 * return html.body.firstChild;
	 *
	 * @method toElement
	 * @param {String} str
	 */
	function toElement(str) {
	    str = str.trim();
	    if (HAS_TEMPLATE_SUPPORT) {
	      // avoid restrictions on content for things like `<tr><th>Hi</th></tr>` which
	      // createContextualFragment doesn't support
	      // <template> support not available in IE
	      return createFragmentFromTemplate(str);
	    } else if (HAS_RANGE_SUPPORT) {
	      return createFragmentFromRange(str);
	    }
	
	    return createFragmentFromWrap(str);
	}
	
	/**
	 * Returns true if two node's names are the same.
	 *
	 * NOTE: We don't bother checking `namespaceURI` because you will never find two HTML elements with the same
	 *       nodeName and different namespace URIs.
	 *
	 * @param {Element} a
	 * @param {Element} b The target element
	 * @return {boolean}
	 */
	function compareNodeNames(fromEl, toEl) {
	    var fromNodeName = fromEl.nodeName;
	    var toNodeName = toEl.nodeName;
	    var fromCodeStart, toCodeStart;
	
	    if (fromNodeName === toNodeName) {
	        return true;
	    }
	
	    fromCodeStart = fromNodeName.charCodeAt(0);
	    toCodeStart = toNodeName.charCodeAt(0);
	
	    // If the target element is a virtual DOM node or SVG node then we may
	    // need to normalize the tag name before comparing. Normal HTML elements that are
	    // in the "http://www.w3.org/1999/xhtml"
	    // are converted to upper case
	    if (fromCodeStart <= 90 && toCodeStart >= 97) { // from is upper and to is lower
	        return fromNodeName === toNodeName.toUpperCase();
	    } else if (toCodeStart <= 90 && fromCodeStart >= 97) { // to is upper and from is lower
	        return toNodeName === fromNodeName.toUpperCase();
	    } else {
	        return false;
	    }
	}
	
	/**
	 * Create an element, optionally with a known namespace URI.
	 *
	 * @param {string} name the element name, e.g. 'div' or 'svg'
	 * @param {string} [namespaceURI] the element's namespace URI, i.e. the value of
	 * its `xmlns` attribute or its inferred namespace.
	 *
	 * @return {Element}
	 */
	function createElementNS(name, namespaceURI) {
	    return !namespaceURI || namespaceURI === NS_XHTML ?
	        doc.createElement(name) :
	        doc.createElementNS(namespaceURI, name);
	}
	
	/**
	 * Copies the children of one DOM element to another DOM element
	 */
	function moveChildren(fromEl, toEl) {
	    var curChild = fromEl.firstChild;
	    while (curChild) {
	        var nextChild = curChild.nextSibling;
	        toEl.appendChild(curChild);
	        curChild = nextChild;
	    }
	    return toEl;
	}
	
	function syncBooleanAttrProp(fromEl, toEl, name) {
	    if (fromEl[name] !== toEl[name]) {
	        fromEl[name] = toEl[name];
	        if (fromEl[name]) {
	            fromEl.setAttribute(name, '');
	        } else {
	            fromEl.removeAttribute(name);
	        }
	    }
	}
	
	var specialElHandlers = {
	    OPTION: function(fromEl, toEl) {
	        var parentNode = fromEl.parentNode;
	        if (parentNode) {
	            var parentName = parentNode.nodeName.toUpperCase();
	            if (parentName === 'OPTGROUP') {
	                parentNode = parentNode.parentNode;
	                parentName = parentNode && parentNode.nodeName.toUpperCase();
	            }
	            if (parentName === 'SELECT' && !parentNode.hasAttribute('multiple')) {
	                if (fromEl.hasAttribute('selected') && !toEl.selected) {
	                    // Workaround for MS Edge bug where the 'selected' attribute can only be
	                    // removed if set to a non-empty value:
	                    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/12087679/
	                    fromEl.setAttribute('selected', 'selected');
	                    fromEl.removeAttribute('selected');
	                }
	                // We have to reset select element's selectedIndex to -1, otherwise setting
	                // fromEl.selected using the syncBooleanAttrProp below has no effect.
	                // The correct selectedIndex will be set in the SELECT special handler below.
	                parentNode.selectedIndex = -1;
	            }
	        }
	        syncBooleanAttrProp(fromEl, toEl, 'selected');
	    },
	    /**
	     * The "value" attribute is special for the <input> element since it sets
	     * the initial value. Changing the "value" attribute without changing the
	     * "value" property will have no effect since it is only used to the set the
	     * initial value.  Similar for the "checked" attribute, and "disabled".
	     */
	    INPUT: function(fromEl, toEl) {
	        syncBooleanAttrProp(fromEl, toEl, 'checked');
	        syncBooleanAttrProp(fromEl, toEl, 'disabled');
	
	        if (fromEl.value !== toEl.value) {
	            fromEl.value = toEl.value;
	        }
	
	        if (!toEl.hasAttribute('value')) {
	            fromEl.removeAttribute('value');
	        }
	    },
	
	    TEXTAREA: function(fromEl, toEl) {
	        var newValue = toEl.value;
	        if (fromEl.value !== newValue) {
	            fromEl.value = newValue;
	        }
	
	        var firstChild = fromEl.firstChild;
	        if (firstChild) {
	            // Needed for IE. Apparently IE sets the placeholder as the
	            // node value and vise versa. This ignores an empty update.
	            var oldValue = firstChild.nodeValue;
	
	            if (oldValue == newValue || (!newValue && oldValue == fromEl.placeholder)) {
	                return;
	            }
	
	            firstChild.nodeValue = newValue;
	        }
	    },
	    SELECT: function(fromEl, toEl) {
	        if (!toEl.hasAttribute('multiple')) {
	            var selectedIndex = -1;
	            var i = 0;
	            // We have to loop through children of fromEl, not toEl since nodes can be moved
	            // from toEl to fromEl directly when morphing.
	            // At the time this special handler is invoked, all children have already been morphed
	            // and appended to / removed from fromEl, so using fromEl here is safe and correct.
	            var curChild = fromEl.firstChild;
	            var optgroup;
	            var nodeName;
	            while(curChild) {
	                nodeName = curChild.nodeName && curChild.nodeName.toUpperCase();
	                if (nodeName === 'OPTGROUP') {
	                    optgroup = curChild;
	                    curChild = optgroup.firstChild;
	                } else {
	                    if (nodeName === 'OPTION') {
	                        if (curChild.hasAttribute('selected')) {
	                            selectedIndex = i;
	                            break;
	                        }
	                        i++;
	                    }
	                    curChild = curChild.nextSibling;
	                    if (!curChild && optgroup) {
	                        curChild = optgroup.nextSibling;
	                        optgroup = null;
	                    }
	                }
	            }
	
	            fromEl.selectedIndex = selectedIndex;
	        }
	    }
	};
	
	var ELEMENT_NODE = 1;
	var DOCUMENT_FRAGMENT_NODE$1 = 11;
	var TEXT_NODE = 3;
	var COMMENT_NODE = 8;
	
	function noop() {}
	
	function defaultGetNodeKey(node) {
	  if (node) {
	    return (node.getAttribute && node.getAttribute('id')) || node.id;
	  }
	}
	
	function morphdomFactory(morphAttrs) {
	
	  return function morphdom(fromNode, toNode, options) {
	    if (!options) {
	      options = {};
	    }
	
	    if (typeof toNode === 'string') {
	      if (fromNode.nodeName === '#document' || fromNode.nodeName === 'HTML' || fromNode.nodeName === 'BODY') {
	        var toNodeHtml = toNode;
	        toNode = doc.createElement('html');
	        toNode.innerHTML = toNodeHtml;
	      } else {
	        toNode = toElement(toNode);
	      }
	    } else if (toNode.nodeType === DOCUMENT_FRAGMENT_NODE$1) {
	      toNode = toNode.firstElementChild;
	    }
	
	    var getNodeKey = options.getNodeKey || defaultGetNodeKey;
	    var onBeforeNodeAdded = options.onBeforeNodeAdded || noop;
	    var onNodeAdded = options.onNodeAdded || noop;
	    var onBeforeElUpdated = options.onBeforeElUpdated || noop;
	    var onElUpdated = options.onElUpdated || noop;
	    var onBeforeNodeDiscarded = options.onBeforeNodeDiscarded || noop;
	    var onNodeDiscarded = options.onNodeDiscarded || noop;
	    var onBeforeElChildrenUpdated = options.onBeforeElChildrenUpdated || noop;
	    var skipFromChildren = options.skipFromChildren || noop;
	    var addChild = options.addChild || function(parent, child){ return parent.appendChild(child); };
	    var childrenOnly = options.childrenOnly === true;
	
	    // This object is used as a lookup to quickly find all keyed elements in the original DOM tree.
	    var fromNodesLookup = Object.create(null);
	    var keyedRemovalList = [];
	
	    function addKeyedRemoval(key) {
	      keyedRemovalList.push(key);
	    }
	
	    function walkDiscardedChildNodes(node, skipKeyedNodes) {
	      if (node.nodeType === ELEMENT_NODE) {
	        var curChild = node.firstChild;
	        while (curChild) {
	
	          var key = undefined;
	
	          if (skipKeyedNodes && (key = getNodeKey(curChild))) {
	            // If we are skipping keyed nodes then we add the key
	            // to a list so that it can be handled at the very end.
	            addKeyedRemoval(key);
	          } else {
	            // Only report the node as discarded if it is not keyed. We do this because
	            // at the end we loop through all keyed elements that were unmatched
	            // and then discard them in one final pass.
	            onNodeDiscarded(curChild);
	            if (curChild.firstChild) {
	              walkDiscardedChildNodes(curChild, skipKeyedNodes);
	            }
	          }
	
	          curChild = curChild.nextSibling;
	        }
	      }
	    }
	
	    /**
	    * Removes a DOM node out of the original DOM
	    *
	    * @param  {Node} node The node to remove
	    * @param  {Node} parentNode The nodes parent
	    * @param  {Boolean} skipKeyedNodes If true then elements with keys will be skipped and not discarded.
	    * @return {undefined}
	    */
	    function removeNode(node, parentNode, skipKeyedNodes) {
	      if (onBeforeNodeDiscarded(node) === false) {
	        return;
	      }
	
	      if (parentNode) {
	        parentNode.removeChild(node);
	      }
	
	      onNodeDiscarded(node);
	      walkDiscardedChildNodes(node, skipKeyedNodes);
	    }
	
	    // // TreeWalker implementation is no faster, but keeping this around in case this changes in the future
	    // function indexTree(root) {
	    //     var treeWalker = document.createTreeWalker(
	    //         root,
	    //         NodeFilter.SHOW_ELEMENT);
	    //
	    //     var el;
	    //     while((el = treeWalker.nextNode())) {
	    //         var key = getNodeKey(el);
	    //         if (key) {
	    //             fromNodesLookup[key] = el;
	    //         }
	    //     }
	    // }
	
	    // // NodeIterator implementation is no faster, but keeping this around in case this changes in the future
	    //
	    // function indexTree(node) {
	    //     var nodeIterator = document.createNodeIterator(node, NodeFilter.SHOW_ELEMENT);
	    //     var el;
	    //     while((el = nodeIterator.nextNode())) {
	    //         var key = getNodeKey(el);
	    //         if (key) {
	    //             fromNodesLookup[key] = el;
	    //         }
	    //     }
	    // }
	
	    function indexTree(node) {
	      if (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE$1) {
	        var curChild = node.firstChild;
	        while (curChild) {
	          var key = getNodeKey(curChild);
	          if (key) {
	            fromNodesLookup[key] = curChild;
	          }
	
	          // Walk recursively
	          indexTree(curChild);
	
	          curChild = curChild.nextSibling;
	        }
	      }
	    }
	
	    indexTree(fromNode);
	
	    function handleNodeAdded(el) {
	      onNodeAdded(el);
	
	      var curChild = el.firstChild;
	      while (curChild) {
	        var nextSibling = curChild.nextSibling;
	
	        var key = getNodeKey(curChild);
	        if (key) {
	          var unmatchedFromEl = fromNodesLookup[key];
	          // if we find a duplicate #id node in cache, replace `el` with cache value
	          // and morph it to the child node.
	          if (unmatchedFromEl && compareNodeNames(curChild, unmatchedFromEl)) {
	            curChild.parentNode.replaceChild(unmatchedFromEl, curChild);
	            morphEl(unmatchedFromEl, curChild);
	          } else {
	            handleNodeAdded(curChild);
	          }
	        } else {
	          // recursively call for curChild and it's children to see if we find something in
	          // fromNodesLookup
	          handleNodeAdded(curChild);
	        }
	
	        curChild = nextSibling;
	      }
	    }
	
	    function cleanupFromEl(fromEl, curFromNodeChild, curFromNodeKey) {
	      // We have processed all of the "to nodes". If curFromNodeChild is
	      // non-null then we still have some from nodes left over that need
	      // to be removed
	      while (curFromNodeChild) {
	        var fromNextSibling = curFromNodeChild.nextSibling;
	        if ((curFromNodeKey = getNodeKey(curFromNodeChild))) {
	          // Since the node is keyed it might be matched up later so we defer
	          // the actual removal to later
	          addKeyedRemoval(curFromNodeKey);
	        } else {
	          // NOTE: we skip nested keyed nodes from being removed since there is
	          //       still a chance they will be matched up later
	          removeNode(curFromNodeChild, fromEl, true /* skip keyed nodes */);
	        }
	        curFromNodeChild = fromNextSibling;
	      }
	    }
	
	    function morphEl(fromEl, toEl, childrenOnly) {
	      var toElKey = getNodeKey(toEl);
	
	      if (toElKey) {
	        // If an element with an ID is being morphed then it will be in the final
	        // DOM so clear it out of the saved elements collection
	        delete fromNodesLookup[toElKey];
	      }
	
	      if (!childrenOnly) {
	        // optional
	        var beforeUpdateResult = onBeforeElUpdated(fromEl, toEl);
	        if (beforeUpdateResult === false) {
	          return;
	        } else if (beforeUpdateResult instanceof HTMLElement) {
	          fromEl = beforeUpdateResult;
	          // reindex the new fromEl in case it's not in the same
	          // tree as the original fromEl
	          // (Phoenix LiveView sometimes returns a cloned tree,
	          //  but keyed lookups would still point to the original tree)
	          indexTree(fromEl);
	        }
	
	        // update attributes on original DOM element first
	        morphAttrs(fromEl, toEl);
	        // optional
	        onElUpdated(fromEl);
	
	        if (onBeforeElChildrenUpdated(fromEl, toEl) === false) {
	          return;
	        }
	      }
	
	      if (fromEl.nodeName !== 'TEXTAREA') {
	        morphChildren(fromEl, toEl);
	      } else {
	        specialElHandlers.TEXTAREA(fromEl, toEl);
	      }
	    }
	
	    function morphChildren(fromEl, toEl) {
	      var skipFrom = skipFromChildren(fromEl, toEl);
	      var curToNodeChild = toEl.firstChild;
	      var curFromNodeChild = fromEl.firstChild;
	      var curToNodeKey;
	      var curFromNodeKey;
	
	      var fromNextSibling;
	      var toNextSibling;
	      var matchingFromEl;
	
	      // walk the children
	      outer: while (curToNodeChild) {
	        toNextSibling = curToNodeChild.nextSibling;
	        curToNodeKey = getNodeKey(curToNodeChild);
	
	        // walk the fromNode children all the way through
	        while (!skipFrom && curFromNodeChild) {
	          fromNextSibling = curFromNodeChild.nextSibling;
	
	          if (curToNodeChild.isSameNode && curToNodeChild.isSameNode(curFromNodeChild)) {
	            curToNodeChild = toNextSibling;
	            curFromNodeChild = fromNextSibling;
	            continue outer;
	          }
	
	          curFromNodeKey = getNodeKey(curFromNodeChild);
	
	          var curFromNodeType = curFromNodeChild.nodeType;
	
	          // this means if the curFromNodeChild doesnt have a match with the curToNodeChild
	          var isCompatible = undefined;
	
	          if (curFromNodeType === curToNodeChild.nodeType) {
	            if (curFromNodeType === ELEMENT_NODE) {
	              // Both nodes being compared are Element nodes
	
	              if (curToNodeKey) {
	                // The target node has a key so we want to match it up with the correct element
	                // in the original DOM tree
	                if (curToNodeKey !== curFromNodeKey) {
	                  // The current element in the original DOM tree does not have a matching key so
	                  // let's check our lookup to see if there is a matching element in the original
	                  // DOM tree
	                  if ((matchingFromEl = fromNodesLookup[curToNodeKey])) {
	                    if (fromNextSibling === matchingFromEl) {
	                      // Special case for single element removals. To avoid removing the original
	                      // DOM node out of the tree (since that can break CSS transitions, etc.),
	                      // we will instead discard the current node and wait until the next
	                      // iteration to properly match up the keyed target element with its matching
	                      // element in the original tree
	                      isCompatible = false;
	                    } else {
	                      // We found a matching keyed element somewhere in the original DOM tree.
	                      // Let's move the original DOM node into the current position and morph
	                      // it.
	
	                      // NOTE: We use insertBefore instead of replaceChild because we want to go through
	                      // the `removeNode()` function for the node that is being discarded so that
	                      // all lifecycle hooks are correctly invoked
	                      fromEl.insertBefore(matchingFromEl, curFromNodeChild);
	
	                      // fromNextSibling = curFromNodeChild.nextSibling;
	
	                      if (curFromNodeKey) {
	                        // Since the node is keyed it might be matched up later so we defer
	                        // the actual removal to later
	                        addKeyedRemoval(curFromNodeKey);
	                      } else {
	                        // NOTE: we skip nested keyed nodes from being removed since there is
	                        //       still a chance they will be matched up later
	                        removeNode(curFromNodeChild, fromEl, true /* skip keyed nodes */);
	                      }
	
	                      curFromNodeChild = matchingFromEl;
	                      curFromNodeKey = getNodeKey(curFromNodeChild);
	                    }
	                  } else {
	                    // The nodes are not compatible since the "to" node has a key and there
	                    // is no matching keyed node in the source tree
	                    isCompatible = false;
	                  }
	                }
	              } else if (curFromNodeKey) {
	                // The original has a key
	                isCompatible = false;
	              }
	
	              isCompatible = isCompatible !== false && compareNodeNames(curFromNodeChild, curToNodeChild);
	              if (isCompatible) {
	                // We found compatible DOM elements so transform
	                // the current "from" node to match the current
	                // target DOM node.
	                // MORPH
	                morphEl(curFromNodeChild, curToNodeChild);
	              }
	
	            } else if (curFromNodeType === TEXT_NODE || curFromNodeType == COMMENT_NODE) {
	              // Both nodes being compared are Text or Comment nodes
	              isCompatible = true;
	              // Simply update nodeValue on the original node to
	              // change the text value
	              if (curFromNodeChild.nodeValue !== curToNodeChild.nodeValue) {
	                curFromNodeChild.nodeValue = curToNodeChild.nodeValue;
	              }
	
	            }
	          }
	
	          if (isCompatible) {
	            // Advance both the "to" child and the "from" child since we found a match
	            // Nothing else to do as we already recursively called morphChildren above
	            curToNodeChild = toNextSibling;
	            curFromNodeChild = fromNextSibling;
	            continue outer;
	          }
	
	          // No compatible match so remove the old node from the DOM and continue trying to find a
	          // match in the original DOM. However, we only do this if the from node is not keyed
	          // since it is possible that a keyed node might match up with a node somewhere else in the
	          // target tree and we don't want to discard it just yet since it still might find a
	          // home in the final DOM tree. After everything is done we will remove any keyed nodes
	          // that didn't find a home
	          if (curFromNodeKey) {
	            // Since the node is keyed it might be matched up later so we defer
	            // the actual removal to later
	            addKeyedRemoval(curFromNodeKey);
	          } else {
	            // NOTE: we skip nested keyed nodes from being removed since there is
	            //       still a chance they will be matched up later
	            removeNode(curFromNodeChild, fromEl, true /* skip keyed nodes */);
	          }
	
	          curFromNodeChild = fromNextSibling;
	        } // END: while(curFromNodeChild) {}
	
	        // If we got this far then we did not find a candidate match for
	        // our "to node" and we exhausted all of the children "from"
	        // nodes. Therefore, we will just append the current "to" node
	        // to the end
	        if (curToNodeKey && (matchingFromEl = fromNodesLookup[curToNodeKey]) && compareNodeNames(matchingFromEl, curToNodeChild)) {
	          // MORPH
	          if(!skipFrom){ addChild(fromEl, matchingFromEl); }
	          morphEl(matchingFromEl, curToNodeChild);
	        } else {
	          var onBeforeNodeAddedResult = onBeforeNodeAdded(curToNodeChild);
	          if (onBeforeNodeAddedResult !== false) {
	            if (onBeforeNodeAddedResult) {
	              curToNodeChild = onBeforeNodeAddedResult;
	            }
	
	            if (curToNodeChild.actualize) {
	              curToNodeChild = curToNodeChild.actualize(fromEl.ownerDocument || doc);
	            }
	            addChild(fromEl, curToNodeChild);
	            handleNodeAdded(curToNodeChild);
	          }
	        }
	
	        curToNodeChild = toNextSibling;
	        curFromNodeChild = fromNextSibling;
	      }
	
	      cleanupFromEl(fromEl, curFromNodeChild, curFromNodeKey);
	
	      var specialElHandler = specialElHandlers[fromEl.nodeName];
	      if (specialElHandler) {
	        specialElHandler(fromEl, toEl);
	      }
	    } // END: morphChildren(...)
	
	    var morphedNode = fromNode;
	    var morphedNodeType = morphedNode.nodeType;
	    var toNodeType = toNode.nodeType;
	
	    if (!childrenOnly) {
	      // Handle the case where we are given two DOM nodes that are not
	      // compatible (e.g. <div> --> <span> or <div> --> TEXT)
	      if (morphedNodeType === ELEMENT_NODE) {
	        if (toNodeType === ELEMENT_NODE) {
	          if (!compareNodeNames(fromNode, toNode)) {
	            onNodeDiscarded(fromNode);
	            morphedNode = moveChildren(fromNode, createElementNS(toNode.nodeName, toNode.namespaceURI));
	          }
	        } else {
	          // Going from an element node to a text node
	          morphedNode = toNode;
	        }
	      } else if (morphedNodeType === TEXT_NODE || morphedNodeType === COMMENT_NODE) { // Text or comment node
	        if (toNodeType === morphedNodeType) {
	          if (morphedNode.nodeValue !== toNode.nodeValue) {
	            morphedNode.nodeValue = toNode.nodeValue;
	          }
	
	          return morphedNode;
	        } else {
	          // Text node to something else
	          morphedNode = toNode;
	        }
	      }
	    }
	
	    if (morphedNode === toNode) {
	      // The "to node" was not compatible with the "from node" so we had to
	      // toss out the "from node" and use the "to node"
	      onNodeDiscarded(fromNode);
	    } else {
	      if (toNode.isSameNode && toNode.isSameNode(morphedNode)) {
	        return;
	      }
	
	      morphEl(morphedNode, toNode, childrenOnly);
	
	      // We now need to loop over any keyed nodes that might need to be
	      // removed. We only do the removal if we know that the keyed node
	      // never found a match. When a keyed node is matched up we remove
	      // it out of fromNodesLookup and we use fromNodesLookup to determine
	      // if a keyed node has been matched up or not
	      if (keyedRemovalList) {
	        for (var i=0, len=keyedRemovalList.length; i<len; i++) {
	          var elToRemove = fromNodesLookup[keyedRemovalList[i]];
	          if (elToRemove) {
	            removeNode(elToRemove, elToRemove.parentNode, false);
	          }
	        }
	      }
	    }
	
	    if (!childrenOnly && morphedNode !== fromNode && fromNode.parentNode) {
	      if (morphedNode.actualize) {
	        morphedNode = morphedNode.actualize(fromNode.ownerDocument || doc);
	      }
	      // If we had to swap out the from node with a new node because the old
	      // node was not compatible with the target node then we need to
	      // replace the old DOM node in the original DOM tree. This is only
	      // possible if the original DOM node was part of a DOM tree which
	      // we know is the case if it has a parent node.
	      fromNode.parentNode.replaceChild(morphedNode, fromNode);
	    }
	
	    return morphedNode;
	  };
	}
	
	var morphdom = morphdomFactory(morphAttrs);
	
	module.exports = morphdom;


/***/ }),
/* 1048 */
/***/ (function(module, exports) {

	/*jshint node:true */
	
	"use strict";
	
	var minimalDesc = ['h', 'min', 's', 'ms', 'μs', 'ns'];
	var verboseDesc = ['hour', 'minute', 'second', 'millisecond', 'microsecond', 'nanosecond'];
	var convert = [60*60, 60, 1, 1e6, 1e3, 1];
	
	module.exports = function (source, opts) {
		var verbose, precise, i, spot, sourceAtStep, valAtStep, decimals, strAtStep, results, totalSeconds;
	
		verbose = false;
		precise = false;
		if (opts) {
			verbose = opts.verbose || false;
			precise = opts.precise || false;
		}
	
		if (!Array.isArray(source) || source.length !== 2) {
			return '';
		}
		if (typeof source[0] !== 'number' || typeof source[1] !== 'number') {
			return '';
		}
	
		// normalize source array due to changes in node v5.4+
		if (source[1] < 0) {
			totalSeconds = source[0] + source[1] / 1e9;
			source[0] = parseInt(totalSeconds);
			source[1] = parseFloat((totalSeconds % 1).toPrecision(9)) * 1e9;
		}
	
		results = '';
	
		// foreach unit
		for (i = 0; i < 6; i++) {
			spot = i < 3 ? 0 : 1; // grabbing first or second spot in source array
			sourceAtStep = source[spot];
			if (i !== 3 && i !== 0) {
				sourceAtStep = sourceAtStep % convert[i-1]; // trim off previous portions
			}
			if (i === 2) {
				sourceAtStep += source[1]/1e9; // get partial seconds from other portion of the array
			}
			valAtStep = sourceAtStep / convert[i]; // val at this unit
			if (valAtStep >= 1) {
				if (verbose) {
					valAtStep = Math.floor(valAtStep); // deal in whole units, subsequent laps will get the decimal portion
				}
				if (!precise) {
					// don't fling too many decimals
					decimals = valAtStep >= 10 ? 0 : 2;
					strAtStep = valAtStep.toFixed(decimals);
				} else {
					strAtStep = valAtStep.toString();
				}
				if (strAtStep.indexOf('.') > -1 && strAtStep[strAtStep.length-1] === '0') {
					strAtStep = strAtStep.replace(/\.?0+$/,''); // remove trailing zeros
				}
				if (results) {
					results += ' '; // append space if we have a previous value
				}
				results += strAtStep; // append the value
				// append units
				if (verbose) {
					results += ' '+verboseDesc[i];
					if (strAtStep !== '1') {
						results += 's';
					}
				} else {
					results += ' '+minimalDesc[i];
				}
				if (!verbose) {
					break; // verbose gets as many groups as necessary, the rest get only one
				}
			}
		}
	
		return results;
	};


/***/ }),
/* 1049 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var stringify = __webpack_require__(1052);
	var parse = __webpack_require__(1051);
	var formats = __webpack_require__(196);
	
	module.exports = {
	    formats: formats,
	    parse: parse,
	    stringify: stringify
	};


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(282);
	
	var has = Object.prototype.hasOwnProperty;
	var isArray = Array.isArray;
	
	var defaults = {
	    allowDots: false,
	    allowEmptyArrays: false,
	    allowPrototypes: false,
	    allowSparse: false,
	    arrayLimit: 20,
	    charset: 'utf-8',
	    charsetSentinel: false,
	    comma: false,
	    decodeDotInKeys: false,
	    decoder: utils.decode,
	    delimiter: '&',
	    depth: 5,
	    duplicates: 'combine',
	    ignoreQueryPrefix: false,
	    interpretNumericEntities: false,
	    parameterLimit: 1000,
	    parseArrays: true,
	    plainObjects: false,
	    strictDepth: false,
	    strictNullHandling: false
	};
	
	var interpretNumericEntities = function (str) {
	    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
	        return String.fromCharCode(parseInt(numberStr, 10));
	    });
	};
	
	var parseArrayValue = function (val, options) {
	    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
	        return val.split(',');
	    }
	
	    return val;
	};
	
	// This is what browsers will submit when the ✓ character occurs in an
	// application/x-www-form-urlencoded body and the encoding of the page containing
	// the form is iso-8859-1, or when the submitted form has an accept-charset
	// attribute of iso-8859-1. Presumably also with other charsets that do not contain
	// the ✓ character, such as us-ascii.
	var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
	
	// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
	var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
	
	var parseValues = function parseQueryStringValues(str, options) {
	    var obj = { __proto__: null };
	
	    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
	    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
	    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
	    var parts = cleanStr.split(options.delimiter, limit);
	    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
	    var i;
	
	    var charset = options.charset;
	    if (options.charsetSentinel) {
	        for (i = 0; i < parts.length; ++i) {
	            if (parts[i].indexOf('utf8=') === 0) {
	                if (parts[i] === charsetSentinel) {
	                    charset = 'utf-8';
	                } else if (parts[i] === isoSentinel) {
	                    charset = 'iso-8859-1';
	                }
	                skipIndex = i;
	                i = parts.length; // The eslint settings do not allow break;
	            }
	        }
	    }
	
	    for (i = 0; i < parts.length; ++i) {
	        if (i === skipIndex) {
	            continue;
	        }
	        var part = parts[i];
	
	        var bracketEqualsPos = part.indexOf(']=');
	        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
	
	        var key;
	        var val;
	        if (pos === -1) {
	            key = options.decoder(part, defaults.decoder, charset, 'key');
	            val = options.strictNullHandling ? null : '';
	        } else {
	            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
	            val = utils.maybeMap(
	                parseArrayValue(part.slice(pos + 1), options),
	                function (encodedVal) {
	                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
	                }
	            );
	        }
	
	        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
	            val = interpretNumericEntities(String(val));
	        }
	
	        if (part.indexOf('[]=') > -1) {
	            val = isArray(val) ? [val] : val;
	        }
	
	        var existing = has.call(obj, key);
	        if (existing && options.duplicates === 'combine') {
	            obj[key] = utils.combine(obj[key], val);
	        } else if (!existing || options.duplicates === 'last') {
	            obj[key] = val;
	        }
	    }
	
	    return obj;
	};
	
	var parseObject = function (chain, val, options, valuesParsed) {
	    var leaf = valuesParsed ? val : parseArrayValue(val, options);
	
	    for (var i = chain.length - 1; i >= 0; --i) {
	        var obj;
	        var root = chain[i];
	
	        if (root === '[]' && options.parseArrays) {
	            obj = options.allowEmptyArrays && (leaf === '' || (options.strictNullHandling && leaf === null))
	                ? []
	                : [].concat(leaf);
	        } else {
	            obj = options.plainObjects ? { __proto__: null } : {};
	            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
	            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
	            var index = parseInt(decodedRoot, 10);
	            if (!options.parseArrays && decodedRoot === '') {
	                obj = { 0: leaf };
	            } else if (
	                !isNaN(index)
	                && root !== decodedRoot
	                && String(index) === decodedRoot
	                && index >= 0
	                && (options.parseArrays && index <= options.arrayLimit)
	            ) {
	                obj = [];
	                obj[index] = leaf;
	            } else if (decodedRoot !== '__proto__') {
	                obj[decodedRoot] = leaf;
	            }
	        }
	
	        leaf = obj;
	    }
	
	    return leaf;
	};
	
	var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
	    if (!givenKey) {
	        return;
	    }
	
	    // Transform dot notation to bracket notation
	    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
	
	    // The regex chunks
	
	    var brackets = /(\[[^[\]]*])/;
	    var child = /(\[[^[\]]*])/g;
	
	    // Get the parent
	
	    var segment = options.depth > 0 && brackets.exec(key);
	    var parent = segment ? key.slice(0, segment.index) : key;
	
	    // Stash the parent if it exists
	
	    var keys = [];
	    if (parent) {
	        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
	        if (!options.plainObjects && has.call(Object.prototype, parent)) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	
	        keys.push(parent);
	    }
	
	    // Loop through children appending to the array until we hit depth
	
	    var i = 0;
	    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
	        i += 1;
	        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	        keys.push(segment[1]);
	    }
	
	    // If there's a remainder, check strictDepth option for throw, else just add whatever is left
	
	    if (segment) {
	        if (options.strictDepth === true) {
	            throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
	        }
	        keys.push('[' + key.slice(segment.index) + ']');
	    }
	
	    return parseObject(keys, val, options, valuesParsed);
	};
	
	var normalizeParseOptions = function normalizeParseOptions(opts) {
	    if (!opts) {
	        return defaults;
	    }
	
	    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
	        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
	    }
	
	    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') {
	        throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
	    }
	
	    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') {
	        throw new TypeError('Decoder has to be a function.');
	    }
	
	    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
	        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
	    }
	    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;
	
	    var duplicates = typeof opts.duplicates === 'undefined' ? defaults.duplicates : opts.duplicates;
	
	    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') {
	        throw new TypeError('The duplicates option must be either combine, first, or last');
	    }
	
	    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;
	
	    return {
	        allowDots: allowDots,
	        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
	        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
	        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
	        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
	        charset: charset,
	        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
	        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
	        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : defaults.decodeDotInKeys,
	        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
	        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
	        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
	        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
	        duplicates: duplicates,
	        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
	        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
	        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
	        parseArrays: opts.parseArrays !== false,
	        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
	        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : defaults.strictDepth,
	        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
	    };
	};
	
	module.exports = function (str, opts) {
	    var options = normalizeParseOptions(opts);
	
	    if (str === '' || str === null || typeof str === 'undefined') {
	        return options.plainObjects ? { __proto__: null } : {};
	    }
	
	    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
	    var obj = options.plainObjects ? { __proto__: null } : {};
	
	    // Iterate over the keys and setup the new object
	
	    var keys = Object.keys(tempObj);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
	        obj = utils.merge(obj, newObj, options);
	    }
	
	    if (options.allowSparse === true) {
	        return obj;
	    }
	
	    return utils.compact(obj);
	};


/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var getSideChannel = __webpack_require__(1056);
	var utils = __webpack_require__(282);
	var formats = __webpack_require__(196);
	var has = Object.prototype.hasOwnProperty;
	
	var arrayPrefixGenerators = {
	    brackets: function brackets(prefix) {
	        return prefix + '[]';
	    },
	    comma: 'comma',
	    indices: function indices(prefix, key) {
	        return prefix + '[' + key + ']';
	    },
	    repeat: function repeat(prefix) {
	        return prefix;
	    }
	};
	
	var isArray = Array.isArray;
	var push = Array.prototype.push;
	var pushToArray = function (arr, valueOrArray) {
	    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
	};
	
	var toISO = Date.prototype.toISOString;
	
	var defaultFormat = formats['default'];
	var defaults = {
	    addQueryPrefix: false,
	    allowDots: false,
	    allowEmptyArrays: false,
	    arrayFormat: 'indices',
	    charset: 'utf-8',
	    charsetSentinel: false,
	    commaRoundTrip: false,
	    delimiter: '&',
	    encode: true,
	    encodeDotInKeys: false,
	    encoder: utils.encode,
	    encodeValuesOnly: false,
	    filter: void undefined,
	    format: defaultFormat,
	    formatter: formats.formatters[defaultFormat],
	    // deprecated
	    indices: false,
	    serializeDate: function serializeDate(date) {
	        return toISO.call(date);
	    },
	    skipNulls: false,
	    strictNullHandling: false
	};
	
	var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
	    return typeof v === 'string'
	        || typeof v === 'number'
	        || typeof v === 'boolean'
	        || typeof v === 'symbol'
	        || typeof v === 'bigint';
	};
	
	var sentinel = {};
	
	var stringify = function stringify(
	    object,
	    prefix,
	    generateArrayPrefix,
	    commaRoundTrip,
	    allowEmptyArrays,
	    strictNullHandling,
	    skipNulls,
	    encodeDotInKeys,
	    encoder,
	    filter,
	    sort,
	    allowDots,
	    serializeDate,
	    format,
	    formatter,
	    encodeValuesOnly,
	    charset,
	    sideChannel
	) {
	    var obj = object;
	
	    var tmpSc = sideChannel;
	    var step = 0;
	    var findFlag = false;
	    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
	        // Where object last appeared in the ref tree
	        var pos = tmpSc.get(object);
	        step += 1;
	        if (typeof pos !== 'undefined') {
	            if (pos === step) {
	                throw new RangeError('Cyclic object value');
	            } else {
	                findFlag = true; // Break while
	            }
	        }
	        if (typeof tmpSc.get(sentinel) === 'undefined') {
	            step = 0;
	        }
	    }
	
	    if (typeof filter === 'function') {
	        obj = filter(prefix, obj);
	    } else if (obj instanceof Date) {
	        obj = serializeDate(obj);
	    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
	        obj = utils.maybeMap(obj, function (value) {
	            if (value instanceof Date) {
	                return serializeDate(value);
	            }
	            return value;
	        });
	    }
	
	    if (obj === null) {
	        if (strictNullHandling) {
	            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
	        }
	
	        obj = '';
	    }
	
	    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
	        if (encoder) {
	            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
	            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
	        }
	        return [formatter(prefix) + '=' + formatter(String(obj))];
	    }
	
	    var values = [];
	
	    if (typeof obj === 'undefined') {
	        return values;
	    }
	
	    var objKeys;
	    if (generateArrayPrefix === 'comma' && isArray(obj)) {
	        // we need to join elements in
	        if (encodeValuesOnly && encoder) {
	            obj = utils.maybeMap(obj, encoder);
	        }
	        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
	    } else if (isArray(filter)) {
	        objKeys = filter;
	    } else {
	        var keys = Object.keys(obj);
	        objKeys = sort ? keys.sort(sort) : keys;
	    }
	
	    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);
	
	    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;
	
	    if (allowEmptyArrays && isArray(obj) && obj.length === 0) {
	        return adjustedPrefix + '[]';
	    }
	
	    for (var j = 0; j < objKeys.length; ++j) {
	        var key = objKeys[j];
	        var value = typeof key === 'object' && key && typeof key.value !== 'undefined'
	            ? key.value
	            : obj[key];
	
	        if (skipNulls && value === null) {
	            continue;
	        }
	
	        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
	        var keyPrefix = isArray(obj)
	            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix
	            : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');
	
	        sideChannel.set(object, step);
	        var valueSideChannel = getSideChannel();
	        valueSideChannel.set(sentinel, sideChannel);
	        pushToArray(values, stringify(
	            value,
	            keyPrefix,
	            generateArrayPrefix,
	            commaRoundTrip,
	            allowEmptyArrays,
	            strictNullHandling,
	            skipNulls,
	            encodeDotInKeys,
	            generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder,
	            filter,
	            sort,
	            allowDots,
	            serializeDate,
	            format,
	            formatter,
	            encodeValuesOnly,
	            charset,
	            valueSideChannel
	        ));
	    }
	
	    return values;
	};
	
	var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
	    if (!opts) {
	        return defaults;
	    }
	
	    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
	        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
	    }
	
	    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') {
	        throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
	    }
	
	    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
	        throw new TypeError('Encoder has to be a function.');
	    }
	
	    var charset = opts.charset || defaults.charset;
	    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
	        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
	    }
	
	    var format = formats['default'];
	    if (typeof opts.format !== 'undefined') {
	        if (!has.call(formats.formatters, opts.format)) {
	            throw new TypeError('Unknown format option provided.');
	        }
	        format = opts.format;
	    }
	    var formatter = formats.formatters[format];
	
	    var filter = defaults.filter;
	    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
	        filter = opts.filter;
	    }
	
	    var arrayFormat;
	    if (opts.arrayFormat in arrayPrefixGenerators) {
	        arrayFormat = opts.arrayFormat;
	    } else if ('indices' in opts) {
	        arrayFormat = opts.indices ? 'indices' : 'repeat';
	    } else {
	        arrayFormat = defaults.arrayFormat;
	    }
	
	    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
	        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
	    }
	
	    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;
	
	    return {
	        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
	        allowDots: allowDots,
	        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
	        arrayFormat: arrayFormat,
	        charset: charset,
	        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
	        commaRoundTrip: !!opts.commaRoundTrip,
	        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
	        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
	        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : defaults.encodeDotInKeys,
	        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
	        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
	        filter: filter,
	        format: format,
	        formatter: formatter,
	        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
	        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
	        sort: typeof opts.sort === 'function' ? opts.sort : null,
	        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
	    };
	};
	
	module.exports = function (object, opts) {
	    var obj = object;
	    var options = normalizeStringifyOptions(opts);
	
	    var objKeys;
	    var filter;
	
	    if (typeof options.filter === 'function') {
	        filter = options.filter;
	        obj = filter('', obj);
	    } else if (isArray(options.filter)) {
	        filter = options.filter;
	        objKeys = filter;
	    }
	
	    var keys = [];
	
	    if (typeof obj !== 'object' || obj === null) {
	        return '';
	    }
	
	    var generateArrayPrefix = arrayPrefixGenerators[options.arrayFormat];
	    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;
	
	    if (!objKeys) {
	        objKeys = Object.keys(obj);
	    }
	
	    if (options.sort) {
	        objKeys.sort(options.sort);
	    }
	
	    var sideChannel = getSideChannel();
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	        var value = obj[key];
	
	        if (options.skipNulls && value === null) {
	            continue;
	        }
	        pushToArray(keys, stringify(
	            value,
	            key,
	            generateArrayPrefix,
	            commaRoundTrip,
	            options.allowEmptyArrays,
	            options.strictNullHandling,
	            options.skipNulls,
	            options.encodeDotInKeys,
	            options.encode ? options.encoder : null,
	            options.filter,
	            options.sort,
	            options.allowDots,
	            options.serializeDate,
	            options.format,
	            options.formatter,
	            options.encodeValuesOnly,
	            options.charset,
	            sideChannel
	        ));
	    }
	
	    var joined = keys.join(options.delimiter);
	    var prefix = options.addQueryPrefix === true ? '?' : '';
	
	    if (options.charsetSentinel) {
	        if (options.charset === 'iso-8859-1') {
	            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
	            prefix += 'utf8=%26%2310003%3B&';
	        } else {
	            // encodeURIComponent('✓')
	            prefix += 'utf8=%E2%9C%93&';
	        }
	    }
	
	    return joined.length > 0 ? prefix + joined : '';
	};


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {(function (exports) {
	  exports.validate = validate;
	  exports.mixin = mixin;
	
	  //
	  // ### function validate (object, schema, options)
	  // #### {Object} object the object to validate.
	  // #### {Object} schema (optional) the JSON Schema to validate against.
	  // #### {Object} options (optional) options controlling the validation
	  //      process. See {@link #validate.defaults) for details.
	  // Validate <code>object</code> against a JSON Schema.
	  // If <code>object</code> is self-describing (i.e. has a
	  // <code>$schema</code> property), it will also be validated
	  // against the referenced schema. [TODO]: This behaviour bay be
	  // suppressed by setting the {@link #validate.options.???}
	  // option to <code>???</code>.[/TODO]
	  //
	  // If <code>schema</code> is not specified, and <code>object</code>
	  // is not self-describing, validation always passes.
	  //
	  // <strong>Note:</strong> in order to pass options but no schema,
	  // <code>schema</code> <em>must</em> be specified in the call to
	  // <code>validate()</code>; otherwise, <code>options</code> will
	  // be interpreted as the schema. <code>schema</code> may be passed
	  // as <code>null</code>, <code>undefinded</code>, or the empty object
	  // (<code>{}</code>) in this case.
	  //
	  function validate(object, schema, options) {
	    options = mixin({}, validate.defaults, options);
	    var errors = [];
	
	    if (schema.type === 'array')
	      validateProperty(object, object, '', schema, options, errors);
	    else
	      validateObject(object, schema, options, errors);
	
	    //
	    // TODO: self-described validation
	    // if (! options.selfDescribing) { ... }
	    //
	
	    return {
	      valid: !(errors.length),
	      errors: errors
	    };
	  };
	
	  /**
	   * Default validation options. Defaults can be overridden by
	   * passing an 'options' hash to {@link #validate}. They can
	   * also be set globally be changing the values in
	   * <code>validate.defaults</code> directly.
	   */
	  validate.defaults = {
	      /**
	       * <p>
	       * Enforce 'format' constraints.
	       * </p><p>
	       * <em>Default: <code>true</code></em>
	       * </p>
	       */
	      validateFormats: true,
	      /**
	       * <p>
	       * When {@link #validateFormats} is <code>true</code>,
	       * treat unrecognized formats as validation errors.
	       * </p><p>
	       * <em>Default: <code>false</code></em>
	       * </p>
	       *
	       * @see validation.formats for default supported formats.
	       */
	      validateFormatsStrict: false,
	      /**
	       * <p>
	       * When {@link #validateFormats} is <code>true</code>,
	       * also validate formats defined in {@link #validate.formatExtensions}.
	       * </p><p>
	       * <em>Default: <code>true</code></em>
	       * </p>
	       */
	      validateFormatExtensions: true,
	      /**
	       * <p>
	       * When {@link #additionalProperties} is <code>true</code>,
	       * allow additional unvisited properties on the object.
	       * </p><p>
	       * <em>Default: <code>true</code></em>
	       * </p>
	       */
	      additionalProperties: true
	  };
	
	  /**
	   * Default messages to include with validation errors.
	   */
	  validate.messages = {
	      required:             "is required",
	      allowEmpty:           "must not be empty",
	      minLength:            "is too short (minimum is %{expected} characters)",
	      maxLength:            "is too long (maximum is %{expected} characters)",
	      pattern:              "invalid input",
	      minimum:              "must be greater than or equal to %{expected}",
	      maximum:              "must be less than or equal to %{expected}",
	      exclusiveMinimum:     "must be greater than %{expected}",
	      exclusiveMaximum:     "must be less than %{expected}",
	      divisibleBy:          "must be divisible by %{expected}",
	      minItems:             "must contain more than %{expected} items",
	      maxItems:             "must contain less than %{expected} items",
	      uniqueItems:          "must hold a unique set of values",
	      format:               "is not a valid %{expected}",
	      conform:              "must conform to given constraint",
	      type:                 "must be of %{expected} type",
	      additionalProperties: "must not exist"
	  };
	  validate.messages['enum'] = "must be present in given enumerator";
	
	  /**
	   *
	   */
	  validate.formats = {
	    'email':          /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i,
	    'ip-address':     /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/i,
	    'ipv6':           /^([0-9A-Fa-f]{1,4}:){7}[0-9A-Fa-f]{1,4}$/,
	    'date-time':      /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:.\d{1,3})?Z$/,
	    'date':           /^\d{4}-\d{2}-\d{2}$/,
	    'time':           /^\d{2}:\d{2}:\d{2}$/,
	    'color':          /^#[a-z0-9]{6}|#[a-z0-9]{3}|(?:rgb\(\s*(?:[+-]?\d+%?)\s*,\s*(?:[+-]?\d+%?)\s*,\s*(?:[+-]?\d+%?)\s*\))aqua|black|blue|fuchsia|gray|green|lime|maroon|navy|olive|orange|purple|red|silver|teal|white|yellow$/i,
	    //'style':        (not supported)
	    //'phone':        (not supported)
	    //'uri':          (not supported)
	    'host-name':      /^(([a-zA-Z]|[a-zA-Z][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z]|[A-Za-z][A-Za-z0-9\-]*[A-Za-z0-9])/,
	    'utc-millisec':   {
	      test: function (value) {
	        return typeof(value) === 'number' && value >= 0;
	      }
	    },
	    'regex':          {
	      test: function (value) {
	        try { new RegExp(value) }
	        catch (e) { return false }
	
	        return true;
	      }
	    }
	  };
	
	  /**
	   *
	   */
	  validate.formatExtensions = {
	    'url': /^(https?|ftp|git):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i
	  };
	
	  function mixin(obj) {
	    var sources = Array.prototype.slice.call(arguments, 1);
	    while (sources.length) {
	      var source = sources.shift();
	      if (!source) { continue }
	
	      if (typeof(source) !== 'object') {
	        throw new TypeError('mixin non-object');
	      }
	
	      for (var p in source) {
	        if (source.hasOwnProperty(p)) {
	          obj[p] = source[p];
	        }
	      }
	    }
	
	    return obj;
	  };
	
	  function validateObject(object, schema, options, errors) {
	    var props, allProps = Object.keys(object),
	        visitedProps = [];
	
	    // see 5.2
	    if (schema.properties) {
	      props = schema.properties;
	      for (var p in props) {
	        if (props.hasOwnProperty(p)) {
	          visitedProps.push(p);
	          validateProperty(object, object[p], p, props[p], options, errors);
	        }
	      }
	    }
	
	    // see 5.3
	    if (schema.patternProperties) {
	      props = schema.patternProperties;
	      for (var p in props) {
	        if (props.hasOwnProperty(p)) {
	          var re = new RegExp(p);
	
	          // Find all object properties that are matching `re`
	          for (var k in object) {
	            if (object.hasOwnProperty(k)) {
	              if (re.exec(k) !== null) {
	                validateProperty(object, object[k], k, props[p], options, errors);
	                visitedProps.push(k);
	              }
	            }
	          }
	        }
	      }
	    }
	
	    //if additionalProperties is not defined set default value
	    if (schema.additionalProperties === undefined) {
	      schema.additionalProperties = options.additionalProperties;
	    }
	
	    // see 5.4
	    if (undefined !== schema.additionalProperties) {
	      var i, l;
	
	      var unvisitedProps = allProps.filter(function(k){
	        return -1 === visitedProps.indexOf(k);
	      });
	
	      // Prevent additional properties; each unvisited property is therefore an error
	      if (schema.additionalProperties === false && unvisitedProps.length > 0) {
	        for (i = 0, l = unvisitedProps.length; i < l; i++) {
	          error("additionalProperties", unvisitedProps[i], object[unvisitedProps[i]], false, errors);
	        }
	      }
	      // additionalProperties is a schema and validate unvisited properties against that schema
	      else if (typeof schema.additionalProperties == "object" && unvisitedProps.length > 0) {
	        for (i = 0, l = unvisitedProps.length; i < l; i++) {
	          validateProperty(object, object[unvisitedProps[i]], unvisitedProps[i], schema.unvisitedProperties, options, errors);
	        }
	      }
	    }
	
	  };
	
	  function validateProperty(object, value, property, schema, options, errors) {
	    var format,
	        valid,
	        spec,
	        type;
	
	    function constrain(name, value, assert) {
	      if (schema[name] !== undefined && !assert(value, schema[name])) {
	        error(name, property, value, schema, errors);
	      }
	    }
	
	    if (value === undefined) {
	      if (schema.required && schema.type !== 'any') {
	        return error('required', property, undefined, schema, errors);
	      } else {
	        return;
	      }
	    }
	
	    if (options.cast) {
	      if (('integer' === schema.type || 'number' === schema.type) && value == +value) {
	        value = +value;
	        object[property] = value;
	      }
	
	      if ('boolean' === schema.type) {
	        if ('true' === value || '1' === value || 1 === value) {
	          value = true;
	          object[property] = value;
	        }
	
	        if ('false' === value || '0' === value || 0 === value) {
	          value = false;
	          object[property] = value;
	        }
	      }
	    }
	
	    if (schema.format && options.validateFormats) {
	      format = schema.format;
	
	      if (options.validateFormatExtensions) { spec = validate.formatExtensions[format] }
	      if (!spec) { spec = validate.formats[format] }
	      if (!spec) {
	        if (options.validateFormatsStrict) {
	          return error('format', property, value, schema, errors);
	        }
	      }
	      else {
	        if (!spec.test(value)) {
	          return error('format', property, value, schema, errors);
	        }
	      }
	    }
	
	    if (schema['enum'] && schema['enum'].indexOf(value) === -1) {
	      error('enum', property, value, schema, errors);
	    }
	
	    // Dependencies (see 5.8)
	    if (typeof schema.dependencies === 'string' &&
	        object[schema.dependencies] === undefined) {
	      error('dependencies', property, null, schema, errors);
	    }
	
	    if (isArray(schema.dependencies)) {
	      for (var i = 0, l = schema.dependencies.length; i < l; i++) {
	        if (object[schema.dependencies[i]] === undefined) {
	          error('dependencies', property, null, schema, errors);
	        }
	      }
	    }
	
	    if (typeof schema.dependencies === 'object') {
	      validateObject(object, schema.dependencies, options, errors);
	    }
	
	    checkType(value, schema.type, function(err, type) {
	      if (err) return error('type', property, typeof value, schema, errors);
	
	      constrain('conform', value, function (a, e) { return e(a, object) });
	
	      switch (type || (isArray(value) ? 'array' : typeof value)) {
	        case 'string':
	          constrain('allowEmpty', value,        function (a, e) { return e ? e : a !== '' });
	          constrain('minLength',  value.length, function (a, e) { return a >= e });
	          constrain('maxLength',  value.length, function (a, e) { return a <= e });
	          constrain('pattern',    value,        function (a, e) {
	            e = typeof e === 'string'
	              ? e = new RegExp(e)
	              : e;
	            return e.test(a)
	          });
	          break;
	        case 'integer':
	        case 'number':
	          constrain('minimum',     value, function (a, e) { return a >= e });
	          constrain('maximum',     value, function (a, e) { return a <= e });
	          constrain('exclusiveMinimum', value, function (a, e) { return a > e });
	          constrain('exclusiveMaximum', value, function (a, e) { return a < e });
	          constrain('divisibleBy', value, function (a, e) {
	            var multiplier = Math.max((a - Math.floor(a)).toString().length - 2, (e - Math.floor(e)).toString().length - 2);
	            multiplier = multiplier > 0 ? Math.pow(10, multiplier) : 1;
	            return (a * multiplier) % (e * multiplier) === 0
	          });
	          break;
	        case 'array':
	          constrain('items', value, function (a, e) {
	            var nestedErrors;
	            for (var i = 0, l = a.length; i < l; i++) {
	              nestedErrors = [];
	              validateProperty(object, a[i], property, e, options, nestedErrors);
	              nestedErrors.forEach(function (err) {
	                err.property =
	                  (property ? property + '.' : '') +
	                  i +
	                  (err.property ? '.' + err.property.replace(property + '.', '') : '');
	              });
	              nestedErrors.unshift(0, 0);
	              Array.prototype.splice.apply(errors, nestedErrors);
	            }
	            return true;
	          });
	          constrain('minItems', value, function (a, e) { return a.length >= e });
	          constrain('maxItems', value, function (a, e) { return a.length <= e });
	          constrain('uniqueItems', value, function (a, e) {
	            if (!e) return true;
	
	            var h = {};
	
	            for (var i = 0, l = a.length; i < l; i++) {
	              var key = JSON.stringify(a[i]);
	              if (h[key]) return false;
	              h[key] = true;
	            }
	
	            return true;
	          });
	          break;
	        case 'object':
	          // Recursive validation
	          if (schema.properties || schema.patternProperties || schema.additionalProperties) {
	            var nestedErrors = [];
	            validateObject(value, schema, options, nestedErrors);
	            nestedErrors.forEach(function (e) {
	              e.property = property + '.' + e.property
	            });
	            nestedErrors.unshift(0, 0);
	            Array.prototype.splice.apply(errors, nestedErrors);
	          }
	          break;
	      }
	    });
	  };
	
	  function checkType(val, type, callback) {
	    var result = false,
	        types = isArray(type) ? type : [type];
	
	    // No type - no check
	    if (type === undefined) return callback(null, type);
	
	    // Go through available types
	    // And fine first matching
	    for (var i = 0, l = types.length; i < l; i++) {
	      type = types[i].toLowerCase().trim();
	      if (type === 'string' ? typeof val === 'string' :
	          type === 'array' ? isArray(val) :
	          type === 'object' ? val && typeof val === 'object' &&
	                             !isArray(val) :
	          type === 'number' ? typeof val === 'number' :
	          type === 'integer' ? typeof val === 'number' && Math.floor(val) === val :
	          type === 'null' ? val === null :
	          type === 'boolean'? typeof val === 'boolean' :
	          type === 'date' ? isDate(val) :
	          type === 'any' ? typeof val !== 'undefined' : false) {
	        return callback(null, type);
	      }
	    };
	
	    callback(true);
	  };
	
	  function error(attribute, property, actual, schema, errors) {
	    var lookup = { expected: schema[attribute], actual: actual, attribute: attribute, property: property };
	    var message = schema.messages && schema.messages[attribute] || schema.message || validate.messages[attribute] || "no default message";
	    message = message.replace(/%\{([a-z]+)\}/ig, function (_, match) { return lookup[match.toLowerCase()] || ''; });
	    errors.push({
	      attribute: attribute,
	      property:  property,
	      expected:  schema[attribute],
	      actual:    actual,
	      message:   message
	    });
	  };
	
	  function isArray(value) {
	    var s = typeof value;
	    if (s === 'object') {
	      if (value) {
	        if (typeof value.length === 'number' &&
	           !(value.propertyIsEnumerable('length')) &&
	           typeof value.splice === 'function') {
	           return true;
	        }
	      }
	    }
	    return false;
	  }
	
	  function isDate(value) {
	    var s = typeof value;
	    if (s === 'object') {
	      if (value) {
	        if (typeof value.getTime === 'function') {
	          return true;
	        }
	      }
	    }
	
	    return false;
	  }
	
	})(typeof module === 'object' && module && module.exports ? module.exports : window);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(197)(module)))

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var inspect = __webpack_require__(136);
	
	var $TypeError = __webpack_require__(96);
	
	/*
	* This function traverses the list returning the node corresponding to the given key.
	*
	* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
	* By doing so, all the recently used nodes can be accessed relatively quickly.
	*/
	/** @type {import('./list.d.ts').listGetNode} */
	// eslint-disable-next-line consistent-return
	var listGetNode = function (list, key, isDelete) {
		/** @type {typeof list | NonNullable<(typeof list)['next']>} */
		var prev = list;
		/** @type {(typeof list)['next']} */
		var curr;
		// eslint-disable-next-line eqeqeq
		for (; (curr = prev.next) != null; prev = curr) {
			if (curr.key === key) {
				prev.next = curr.next;
				if (!isDelete) {
					// eslint-disable-next-line no-extra-parens
					curr.next = /** @type {NonNullable<typeof list.next>} */ (list.next);
					list.next = curr; // eslint-disable-line no-param-reassign
				}
				return curr;
			}
		}
	};
	
	/** @type {import('./list.d.ts').listGet} */
	var listGet = function (objects, key) {
		if (!objects) {
			return void undefined;
		}
		var node = listGetNode(objects, key);
		return node && node.value;
	};
	/** @type {import('./list.d.ts').listSet} */
	var listSet = function (objects, key, value) {
		var node = listGetNode(objects, key);
		if (node) {
			node.value = value;
		} else {
			// Prepend the new node to the beginning of the list
			objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ ({ // eslint-disable-line no-param-reassign, no-extra-parens
				key: key,
				next: objects.next,
				value: value
			});
		}
	};
	/** @type {import('./list.d.ts').listHas} */
	var listHas = function (objects, key) {
		if (!objects) {
			return false;
		}
		return !!listGetNode(objects, key);
	};
	/** @type {import('./list.d.ts').listDelete} */
	// eslint-disable-next-line consistent-return
	var listDelete = function (objects, key) {
		if (objects) {
			return listGetNode(objects, key, true);
		}
	};
	
	/** @type {import('.')} */
	module.exports = function getSideChannelList() {
		/** @typedef {ReturnType<typeof getSideChannelList>} Channel */
		/** @typedef {Parameters<Channel['get']>[0]} K */
		/** @typedef {Parameters<Channel['set']>[1]} V */
	
		/** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;
	
		/** @type {Channel} */
		var channel = {
			assert: function (key) {
				if (!channel.has(key)) {
					throw new $TypeError('Side channel does not contain ' + inspect(key));
				}
			},
			'delete': function (key) {
				var root = $o && $o.next;
				var deletedNode = listDelete($o, key);
				if (deletedNode && root && root === deletedNode) {
					$o = void undefined;
				}
				return !!deletedNode;
			},
			get: function (key) {
				return listGet($o, key);
			},
			has: function (key) {
				return listHas($o, key);
			},
			set: function (key, value) {
				if (!$o) {
					// Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
					$o = {
						next: void undefined
					};
				}
				// eslint-disable-next-line no-extra-parens
				listSet(/** @type {NonNullable<typeof $o>} */ ($o), key, value);
			}
		};
		// @ts-expect-error TODO: figure out why this is erroring
		return channel;
	};


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(193);
	var callBound = __webpack_require__(240);
	var inspect = __webpack_require__(136);
	var getSideChannelMap = __webpack_require__(283);
	
	var $TypeError = __webpack_require__(96);
	var $WeakMap = GetIntrinsic('%WeakMap%', true);
	
	/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */
	var $weakMapGet = callBound('WeakMap.prototype.get', true);
	/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */
	var $weakMapSet = callBound('WeakMap.prototype.set', true);
	/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */
	var $weakMapHas = callBound('WeakMap.prototype.has', true);
	/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */
	var $weakMapDelete = callBound('WeakMap.prototype.delete', true);
	
	/** @type {import('.')} */
	module.exports = $WeakMap
		? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
			/** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */
			/** @typedef {Parameters<Channel['get']>[0]} K */
			/** @typedef {Parameters<Channel['set']>[1]} V */
	
			/** @type {WeakMap<K & object, V> | undefined} */ var $wm;
			/** @type {Channel | undefined} */ var $m;
	
			/** @type {Channel} */
			var channel = {
				assert: function (key) {
					if (!channel.has(key)) {
						throw new $TypeError('Side channel does not contain ' + inspect(key));
					}
				},
				'delete': function (key) {
					if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
						if ($wm) {
							return $weakMapDelete($wm, key);
						}
					} else if (getSideChannelMap) {
						if ($m) {
							return $m['delete'](key);
						}
					}
					return false;
				},
				get: function (key) {
					if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
						if ($wm) {
							return $weakMapGet($wm, key);
						}
					}
					return $m && $m.get(key);
				},
				has: function (key) {
					if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
						if ($wm) {
							return $weakMapHas($wm, key);
						}
					}
					return !!$m && $m.has(key);
				},
				set: function (key, value) {
					if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
						if (!$wm) {
							$wm = new $WeakMap();
						}
						$weakMapSet($wm, key, value);
					} else if (getSideChannelMap) {
						if (!$m) {
							$m = getSideChannelMap();
						}
						// eslint-disable-next-line no-extra-parens
						/** @type {NonNullable<typeof $m>} */ ($m).set(key, value);
					}
				}
			};
	
			// @ts-expect-error TODO: figure out why this is erroring
			return channel;
		}
		: getSideChannelMap;


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $TypeError = __webpack_require__(96);
	var inspect = __webpack_require__(136);
	var getSideChannelList = __webpack_require__(1054);
	var getSideChannelMap = __webpack_require__(283);
	var getSideChannelWeakMap = __webpack_require__(1055);
	
	var makeChannel = getSideChannelWeakMap || getSideChannelMap || getSideChannelList;
	
	/** @type {import('.')} */
	module.exports = function getSideChannel() {
		/** @typedef {ReturnType<typeof getSideChannel>} Channel */
	
		/** @type {Channel | undefined} */ var $channelData;
	
		/** @type {Channel} */
		var channel = {
			assert: function (key) {
				if (!channel.has(key)) {
					throw new $TypeError('Side channel does not contain ' + inspect(key));
				}
			},
			'delete': function (key) {
				return !!$channelData && $channelData['delete'](key);
			},
			get: function (key) {
				return $channelData && $channelData.get(key);
			},
			has: function (key) {
				return !!$channelData && $channelData.has(key);
			},
			set: function (key, value) {
				if (!$channelData) {
					$channelData = makeChannel();
				}
	
				$channelData.set(key, value);
			}
		};
		// @ts-expect-error TODO: figure out why this is erroring
		return channel;
	};


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;(function (window, undefined) {
	
	  'use strict';
	
	  //////////////
	  // Constants
	  /////////////
	
	
	  var LIBVERSION  = '0.7.10',
	    EMPTY       = '',
	    UNKNOWN     = '?',
	    FUNC_TYPE   = 'function',
	    UNDEF_TYPE  = 'undefined',
	    OBJ_TYPE    = 'object',
	    STR_TYPE    = 'string',
	    MAJOR       = 'major', // deprecated
	    MODEL       = 'model',
	    NAME        = 'name',
	    TYPE        = 'type',
	    VENDOR      = 'vendor',
	    VERSION     = 'version',
	    ARCHITECTURE= 'architecture',
	    CONSOLE     = 'console',
	    MOBILE      = 'mobile',
	    TABLET      = 'tablet',
	    SMARTTV     = 'smarttv',
	    WEARABLE    = 'wearable',
	    EMBEDDED    = 'embedded';
	
	
	  ///////////
	  // Helper
	  //////////
	
	  var util = {
	    extend : function (regexes, extensions) {
	      for (var i in extensions) {
	        if ("browser cpu device engine os".indexOf(i) !== -1 && extensions[i].length % 2 === 0) {
	          regexes[i] = extensions[i].concat(regexes[i]);
	        }
	      }
	      return regexes;
	    },
	    has : function (str1, str2) {
	      if (typeof str1 === "string") {
	        return str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1;
	      } else {
	        return false;
	      }
	    },
	    lowerize : function (str) {
	      return str.toLowerCase();
	    },
	    major : function (version) {
	      return typeof(version) === STR_TYPE ? version.split(".")[0] : undefined;
	    }
	  };
	
	  ///////////////
	  // String map
	  //////////////
	
	  var maps = {
	    browser : {
	      oldsafari : {
	        version : {
	          '1.0'   : '/8',
	          '1.2'   : '/1',
	          '1.3'   : '/3',
	          '2.0'   : '/412',
	          '2.0.2' : '/416',
	          '2.0.3' : '/417',
	          '2.0.4' : '/419',
	          '?'     : '/'
	        }
	      }
	    }
	  };
	
	  ///////////////
	  // Map helper
	  //////////////
	
	
	  var mapper = {
	
	    rgx : function () {
	
	      var result, i = 0, j, k, p, q, matches, match, args = arguments;
	
	      // loop through all regexes maps
	      while (i < args.length && !matches) {
	
	        var regex = args[i],       // even sequence (0,2,4,..)
	          props = args[i + 1];   // odd sequence (1,3,5,..)
	
	        // construct object barebones
	        if (typeof result === UNDEF_TYPE) {
	          result = {};
	          for (p in props) {
	            if (props.hasOwnProperty(p)){
	              q = props[p];
	              if (typeof q === OBJ_TYPE) {
	                result[q[0]] = undefined;
	              } else {
	                result[q] = undefined;
	              }
	            }
	          }
	        }
	
	        // try matching uastring with regexes
	        j = k = 0;
	        while (j < regex.length && !matches) {
	          matches = regex[j++].exec(this.getUA());
	          if (!!matches) {
	            for (p = 0; p < props.length; p++) {
	              match = matches[++k];
	              q = props[p];
	              // check if given property is actually array
	              if (typeof q === OBJ_TYPE && q.length > 0) {
	                if (q.length == 2) {
	                  if (typeof q[1] == FUNC_TYPE) {
	                    // assign modified match
	                    result[q[0]] = q[1].call(this, match);
	                  } else {
	                    // assign given value, ignore regex match
	                    result[q[0]] = q[1];
	                  }
	                } else if (q.length == 3) {
	                  // check whether function or regex
	                  if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
	                    // call function (usually string mapper)
	                    result[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
	                  } else {
	                    // sanitize match using given regex
	                    result[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
	                  }
	                } else if (q.length == 4) {
	                  result[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
	                }
	              } else {
	                result[q] = match ? match : undefined;
	              }
	            }
	          }
	        }
	        i += 2;
	      }
	      return result;
	    },
	
	    str : function (str, map) {
	
	      for (var i in map) {
	        // check if array
	        if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
	          for (var j = 0; j < map[i].length; j++) {
	            if (util.has(map[i][j], str)) {
	              return (i === UNKNOWN) ? undefined : i;
	            }
	          }
	        } else if (util.has(map[i], str)) {
	          return (i === UNKNOWN) ? undefined : i;
	        }
	      }
	      return str;
	    }
	  };
	
	  var regexes = {
	
	      browser: [[
	
	        // Presto based
	        /(opera\smini)\/([\w\.-]+)/i,                                       // Opera Mini
	        /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,                      // Opera Mobi/Tablet
	        /(opera).+version\/([\w\.]+)/i,                                     // Opera > 9.80
	        /(opera)[\/\s]+([\w\.]+)/i                                          // Opera < 9.80
	
	      ], [NAME, VERSION], [
	
	        /\s(opr)\/([\w\.]+)/i                                               // Opera Webkit
	      ], [[NAME, 'Opera'], VERSION], [
	
	        // Mixed
	        /(kindle)\/([\w\.]+)/i,                                             // Kindle
	        /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]+)*/i,
	        // Lunascape/Maxthon/Netfront/Jasmine/Blazer
	
	        // Trident based
	        /(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,
	        // Avant/IEMobile/SlimBrowser/Baidu
	        /(?:ms|\()(ie)\s([\w\.]+)/i,                                        // Internet Explorer
	
	        // Webkit/KHTML based
	        /(rekonq)\/([\w\.]+)*/i,                                            // Rekonq
	        /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs)\/([\w\.-]+)/i
	        // Chromium/Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS
	      ], [NAME, VERSION], [
	
	        /(trident).+rv[:\s]([\w\.]+).+like\sgecko/i                         // IE11
	      ], [[NAME, 'IE'], VERSION], [
	
	        /(edge)\/((\d+)?[\w\.]+)/i                                          // Microsoft Edge
	      ], [NAME, VERSION], [
	
	        /(yabrowser)\/([\w\.]+)/i                                           // Yandex
	      ], [[NAME, 'Yandex'], VERSION], [
	
	        /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
	      ], [[NAME, /_/g, ' '], VERSION], [
	
	        /(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i,
	        // Chrome/OmniWeb/Arora/Tizen/Nokia
	        /(qqbrowser)[\/\s]?([\w\.]+)/i
	        // QQBrowser
	      ], [NAME, VERSION], [
	
	        /(uc\s?browser)[\/\s]?([\w\.]+)/i,
	        /ucweb.+(ucbrowser)[\/\s]?([\w\.]+)/i,
	        /JUC.+(ucweb)[\/\s]?([\w\.]+)/i
	        // UCBrowser
	      ], [[NAME, 'UCBrowser'], VERSION], [
	
	        /(dolfin)\/([\w\.]+)/i                                              // Dolphin
	      ], [[NAME, 'Dolphin'], VERSION], [
	
	        /((?:android.+)crmo|crios)\/([\w\.]+)/i                             // Chrome for Android/iOS
	      ], [[NAME, 'Chrome'], VERSION], [
	
	        /XiaoMi\/MiuiBrowser\/([\w\.]+)/i                                   // MIUI Browser
	      ], [VERSION, [NAME, 'MIUI Browser']], [
	
	        /android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)/i         // Android Browser
	      ], [VERSION, [NAME, 'Android Browser']], [
	
	        /FBAV\/([\w\.]+);/i                                                 // Facebook App for iOS
	      ], [VERSION, [NAME, 'Facebook']], [
	
	        /fxios\/([\w\.-]+)/i                                                // Firefox for iOS
	      ], [VERSION, [NAME, 'Firefox']], [
	
	        /version\/([\w\.]+).+?mobile\/\w+\s(safari)/i                       // Mobile Safari
	      ], [VERSION, [NAME, 'Mobile Safari']], [
	
	        /version\/([\w\.]+).+?(mobile\s?safari|safari)/i                    // Safari & Safari Mobile
	      ], [VERSION, NAME], [
	
	        /webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i                     // Safari < 3.0
	      ], [NAME, [VERSION, mapper.str, maps.browser.oldsafari.version]], [
	
	        /(konqueror)\/([\w\.]+)/i,                                          // Konqueror
	        /(webkit|khtml)\/([\w\.]+)/i
	      ], [NAME, VERSION], [
	
	        // Gecko based
	        /(navigator|netscape)\/([\w\.-]+)/i                                 // Netscape
	      ], [[NAME, 'Netscape'], VERSION], [
	        /(swiftfox)/i,                                                      // Swiftfox
	        /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,
	        // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
	        /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix)\/([\w\.-]+)/i,
	        // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
	        /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,                          // Mozilla
	
	        // Other
	        /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,
	        // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir
	        /(links)\s\(([\w\.]+)/i,                                            // Links
	        /(gobrowser)\/?([\w\.]+)*/i,                                        // GoBrowser
	        /(ice\s?browser)\/v?([\w\._]+)/i,                                   // ICE Browser
	        /(mosaic)[\/\s]([\w\.]+)/i                                          // Mosaic
	      ], [NAME, VERSION]
	
	      ]
	  };
	
	/////////////////
	  // Constructor
	  ////////////////
	
	
	  var UAParser = function (uastring, extensions) {
	
	    if (!(this instanceof UAParser)) {
	      return new UAParser(uastring, extensions).getResult();
	    }
	
	    var ua = uastring || ((window && window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : EMPTY);
	    var rgxmap = extensions ? util.extend(regexes, extensions) : regexes;
	
	    this.getBrowser = function () {
	      var browser = mapper.rgx.apply(this, rgxmap.browser);
	      browser.major = util.major(browser.version);
	      return browser;
	    };
	    this.getResult = function() {
	      return {
	        ua      : this.getUA(),
	        browser : this.getBrowser()
	      };
	    };
	    this.getUA = function () {
	      return ua;
	    };
	    this.setUA = function (uastring) {
	      ua = uastring;
	      return this;
	    };
	    this.setUA(ua);
	    return this;
	  };
	
	  UAParser.VERSION = LIBVERSION;
	  UAParser.BROWSER = {
	    NAME    : NAME,
	    MAJOR   : MAJOR, // deprecated
	    VERSION : VERSION
	  };
	  ///////////
	  // Export
	  //////////
	
	  // check js environment
	  if (typeof(exports) !== UNDEF_TYPE) {
	    // nodejs env
	    if (typeof module !== UNDEF_TYPE && module.exports) {
	      exports = module.exports = UAParser;
	    }
	    exports.UAParser = UAParser;
	  } else {
	    // requirejs env (optional)
	    if ("function" === FUNC_TYPE && __webpack_require__(286)) {
	      !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	        return UAParser;
	      }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else {
	      // browser env
	      window.UAParser = UAParser;
	    }
	  }
	
	})(typeof window === 'object' ? window : this);


/***/ }),
/* 1058 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ }),
/* 1059 */
/***/ (function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ }),
/* 1060 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	var rng;
	
	var crypto = global.crypto || global.msCrypto; // for IE 11
	if (crypto && crypto.getRandomValues) {
	  // WHATWG crypto-based RNG - http://wiki.whatwg.org/wiki/Crypto
	  // Moderately fast, high quality
	  var _rnds8 = new Uint8Array(16);
	  rng = function whatwgRNG() {
	    crypto.getRandomValues(_rnds8);
	    return _rnds8;
	  };
	}
	
	if (!rng) {
	  // Math.random()-based (RNG)
	  //
	  // If all else fails, use Math.random().  It's fast, but is of unspecified
	  // quality.
	  var  _rnds = new Array(16);
	  rng = function() {
	    for (var i = 0, r; i < 16; i++) {
	      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
	      _rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
	    }
	
	    return _rnds;
	  };
	}
	
	module.exports = rng;
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1061 */
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),
/* 1062 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(__webpack_module_template_argument_0__);
	
	var Tooltip = function () {
	    function Tooltip() {
	        _classCallCheck(this, Tooltip);
	
	        this.template = __webpack_require__(__webpack_module_template_argument_1__);
	    }
	
	    Tooltip.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    return Tooltip;
	}();
	
	module.exports = {
	    constructor: Tooltip
	};

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(__webpack_module_template_argument_0__);
	var _ = __webpack_require__(3);
	var moment = __webpack_require__(34);
	var $ = __webpack_require__(12);
	
	var ITEM = '.' + css.item;
	var IS_DISABLED = '.' + css._isDisabled;
	
	var Calendar = function () {
	    function Calendar() {
	        _classCallCheck(this, Calendar);
	
	        this.template = __webpack_require__(__webpack_module_template_argument_1__);
	    }
	
	    Calendar.prototype.bind = function bind() {
	        var _click;
	
	        return {
	            click: (_click = {}, _click[ITEM] = this.selectDate, _click)
	        };
	    };
	
	    Calendar.prototype.selectDate = function selectDate(e) {
	        var item = $(e.currentTarget).children();
	        var date = item.attr('cat-date');
	
	        if (!item.hasClass(IS_DISABLED.substring(1))) {
	            var selectDate = this.$context.props['selectDate'];
	            var datepickerId = this.$context.attributes['cat-datepicker-id'];
	
	            this.$context.signal(selectDate, { date: date, datepickerId: datepickerId });
	        }
	    };
	
	    Calendar.reshape = function reshape(array, n) {
	        return _.compact(_.map(array, function (el, i) {
	            if (i % n === 0) {
	                return array.slice(i, i + n);
	            }
	        }));
	    };
	
	    Calendar.equalsForBounds = function equalsForBounds(date, range, period) {
	        var bounds = range.toDate();
	        var start = moment(bounds[0]);
	        var end = moment(bounds[1]);
	
	        return date.isSame(start, period) || date.isSame(end, period);
	    };
	
	    Calendar.prototype.render = function render() {
	        var attrs = this.$context.attributes;
	
	        this.type = attrs['cat-type'];
	        this.date = Number(attrs['cat-date']);
	
	        var typesMap = {
	            month: this.getFormatedMonth,
	            year: this.getFormatedYear
	        };
	
	        var calendarTypeFunc = typesMap[this.type] || this.getFormatedMonth;
	        var availableRange = this.getAvailableRange();
	        var selectedRange = this.getSelectedRange();
	
	        var data = calendarTypeFunc(this.date, availableRange, selectedRange);
	
	        return Object.assign({}, data, { css: css });
	    };
	
	    Calendar.prototype.getAvailableRange = function getAvailableRange() {
	        var attrs = this.$context.attributes;
	
	        if (attrs['cat-afrom'] || attrs['cat-atill']) {
	            var from = moment.unix(Number(attrs['cat-afrom']));
	            var tillUnix = attrs['cat-atill'];
	            var till = tillUnix ? moment.unix(Number(tillUnix)) : from.clone().add(1, 'years');
	
	            return moment.range(from, till);
	        }
	
	        return {};
	    };
	
	    Calendar.prototype.getSelectedRange = function getSelectedRange() {
	        var attrs = this.$context.attributes;
	        var selectedDate = Number(attrs['cat-selected-date']);
	        var rangeDates = void 0;
	
	        if (selectedDate) {
	            rangeDates = {
	                from: moment.unix(selectedDate),
	                till: moment.unix(selectedDate)
	            };
	        } else {
	            rangeDates = {
	                from: moment.unix(Number(attrs['cat-rfrom'])),
	                till: moment.unix(Number(attrs['cat-rtill']))
	            };
	        }
	
	        return moment.range(rangeDates.from, rangeDates.till);
	    };
	
	    Calendar.prototype.getFormatedYear = function getFormatedYear(date, availableRange, range) {
	        var yearContent = [];
	
	        var currentDate = moment.unix(date).startOf('year');
	
	        _.times(12, function () {
	            var unixDate = currentDate.unix();
	            var inSelectdedRange = range.contains(currentDate);
	            var inAvailableRange = availableRange.contains(currentDate);
	
	            var isBoundOfRange = Calendar.equalsForBounds(currentDate, range, 'month');
	
	            yearContent.push({
	                date: _.capitalize(currentDate.format('MMM')),
	                isInRange: inSelectdedRange,
	                isBoundOfRange: isBoundOfRange,
	                isDisabled: !inAvailableRange,
	                unixDate: unixDate
	            });
	
	            currentDate.add(1, 'months');
	        });
	
	        yearContent = Calendar.reshape(yearContent, 3);
	
	        var periodTitle = moment.unix(date).format('YYYY');
	        var mode = 'year';
	
	        return {
	            periodTitle: periodTitle,
	            content: yearContent,
	            mode: mode
	        };
	    };
	
	    Calendar.prototype.getFormatedMonth = function getFormatedMonth(date, availableRange, range) {
	        function daysInMonth(momentDate) {
	            return momentDate.toDate().getDate();
	        }
	
	        var daysLabels = moment.weekdaysShort();
	        daysLabels.push(daysLabels.shift());
	
	        var monthStart = moment.unix(date).startOf('month');
	        var monthEnd = moment.unix(date).endOf('month');
	
	        var numOfDays = daysInMonth(monthEnd);
	        var startOffset = monthStart.day() - 1;
	
	        if (startOffset == -1) {
	            startOffset = 6;
	        }
	        var endOffset = 42 - (numOfDays + startOffset);
	
	        var monthContent = [];
	
	        _.times(startOffset, function () {
	            monthContent.push({ isHidden: true });
	        });
	
	        var currentDate = monthStart;
	
	        _.times(numOfDays, function (i) {
	            var unixDate = currentDate.unix();
	
	            var inAvailableRange = availableRange.contains(currentDate);
	            var inSelectedRange = range.contains(currentDate);
	
	            var isBoundOfRange = Calendar.equalsForBounds(currentDate, range, 'day');
	
	            monthContent.push({
	                date: i + 1,
	                isDisabled: !inAvailableRange,
	                isInRange: inSelectedRange,
	                isBoundOfRange: isBoundOfRange,
	                unixDate: unixDate
	            });
	
	            currentDate.add(1, 'days');
	        });
	
	        _.times(endOffset, function () {
	            monthContent.push({ isHidden: true });
	        });
	
	        monthContent = Calendar.reshape(monthContent, 7);
	
	        var periodTitle = moment.unix(date).format('MMMM YYYY');
	        var mode = 'month';
	
	        return {
	            periodTitle: periodTitle,
	            content: monthContent,
	            daysLabels: daysLabels,
	            mode: mode
	        };
	    };
	
	    return Calendar;
	}();
	
	module.exports = {
	    constructor: Calendar
	};

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(__webpack_module_template_argument_0__);
	var $ = __webpack_require__(12);
	
	var CHECKBOX = '.' + css.checkbox;
	var SELECT = '.' + css.select;
	var DROPDOWN = '.' + css.dropdown;
	var BUTTON = '.' + css.button;
	var IS_OPEN = css.isOpen;
	
	var ChecklistSelect = function () {
	    function ChecklistSelect() {
	        _classCallCheck(this, ChecklistSelect);
	
	        this.template = __webpack_require__(__webpack_module_template_argument_1__);
	    }
	
	    ChecklistSelect.prototype.render = function render() {
	        var props = this.$context.props;
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, props, { css: css });
	        });
	    };
	
	    ChecklistSelect.prototype.bind = function bind() {
	        var _change, _click;
	
	        return {
	            change: (_change = {}, _change[CHECKBOX] = this.changeCheckbox, _change),
	            click: (_click = {}, _click[SELECT] = this.toggleDropdown, _click[DROPDOWN] = this.stopPropagation, _click[BUTTON] = this.applyList, _click)
	        };
	    };
	
	    ChecklistSelect.prototype.changeCheckbox = function changeCheckbox(e) {
	        var checkbox = $(e.currentTarget);
	        var isChecked = checkbox.is(':checked');
	
	        var key = checkbox.attr('cat-key');
	        var id = checkbox.attr('id');
	
	        var changeCheckboxSignal = this.$context.props.toggleBox;
	        var toggleCheckboxes = this.$context.props.toggleAll;
	
	        if (id == 'allOptions') {
	            this.$context.signal(toggleCheckboxes, { isChecked: isChecked });
	        } else {
	            this.$context.signal(changeCheckboxSignal, { key: key, isChecked: isChecked });
	        }
	    };
	
	    ChecklistSelect.prototype.toggleDropdown = function toggleDropdown(e) {
	        e.stopPropagation();
	
	        var checklistBody = $(e.currentTarget);
	        var dropdown = checklistBody.next();
	        var isOpen = !dropdown.hasClass(IS_OPEN);
	        var changeDropdownSignal = this.$context.props.toggleDropdown;
	
	        this.$context.signal(changeDropdownSignal, { isOpen: isOpen });
	    };
	
	    ChecklistSelect.prototype.applyList = function applyList(e) {
	        e.stopPropagation();
	
	        var applyListSignal = this.$context.props.applyList;
	        this.$context.signal(applyListSignal);
	    };
	
	    ChecklistSelect.prototype.stopPropagation = function stopPropagation(e) {
	        e.stopPropagation();
	    };
	
	    return ChecklistSelect;
	}();
	
	module.exports = {
	    constructor: ChecklistSelect
	};

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(__webpack_module_template_argument_0__);
	var CHECKBOX = '.' + css.checkbox;
	
	var Checkbox = function () {
	    function Checkbox() {
	        _classCallCheck(this, Checkbox);
	
	        this.template = __webpack_require__(__webpack_module_template_argument_1__);
	    }
	
	    Checkbox.prototype.render = function render() {
	        var _this = this;
	
	        return this.$context.getWatcherData().then(function (data) {
	            var attributes = _this.$context.attributes;
	            var title = attributes['cat-title'];
	            return Object.assign({}, data, attributes, { css: css }, { title: title });
	        });
	    };
	
	    Checkbox.prototype.bind = function bind() {
	        var _change;
	
	        return {
	            change: (_change = {}, _change[CHECKBOX] = this.onChange, _change)
	        };
	    };
	
	    Checkbox.prototype.onChange = function onChange(e) {
	        e.stopPropagation();
	
	        var signal = this.$context.props.signal;
	        var path = this.$context.attributes['cat-path'];
	        var value = e.currentTarget.checked;
	
	        this.$context.signal(signal, { path: path, value: value });
	    };
	
	    return Checkbox;
	}();
	
	module.exports = {
	    constructor: Checkbox
	};

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(__webpack_module_template_argument_0__);
	var $ = __webpack_require__(12);
	var moment = __webpack_require__(34);
	var _ = __webpack_require__(3);
	
	var ARROW = '.' + css.arrow;
	var SELECT_BUTTON = '.' + css.selectButton;
	var APPEAR_BUTTON = '.' + css.appearButton;
	var CLEAR_BUTTON = '.' + css.clearButton;
	var CONTAINER = '.' + css.container;
	var PERIOD = '.' + css.period;
	var FROM = '.' + css.from;
	var TILL = '.' + css.till;
	var IS_OPEN = '.' + css.isOpen;
	var RIGHT = '.' + css.right;
	var ERROR = '.' + css.error;
	
	var Calendar = __webpack_require__(__webpack_module_template_argument_1__);
	
	var Datepicker = function () {
	    function Datepicker() {
	        _classCallCheck(this, Datepicker);
	
	        this.template = __webpack_require__(__webpack_module_template_argument_2__);
	    }
	
	    Datepicker.prototype.bind = function bind() {
	        var _click, _keyup;
	
	        this.initMaskedInput();
	
	        return {
	            click: (_click = {}, _click[ARROW] = this.changePage, _click[SELECT_BUTTON] = this.selectPeriod, _click[APPEAR_BUTTON] = this.toggleDropdown, _click[CLEAR_BUTTON] = this.clearInput, _click[CONTAINER] = this.stopPropagation, _click),
	            keyup: (_keyup = {}, _keyup[PERIOD + FROM] = _.partialRight(this.handleInput, 'from'), _keyup[PERIOD + TILL] = _.partialRight(this.handleInput, 'till'), _keyup)
	        };
	    };
	
	    Datepicker.prototype.render = function render() {
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { css: css });
	        });
	    };
	
	    Datepicker.prototype.toggleDropdown = function toggleDropdown(e) {
	        e.stopPropagation();
	
	        var isParentFieldsSetDisabled = $(e.currentTarget).closest('fieldset').attr('disabled') === 'disabled';
	        if (isParentFieldsSetDisabled) {
	            return;
	        }
	
	        var datepickerBody = $(e.currentTarget);
	        var dropdown = datepickerBody.next();
	        var isOpen = !dropdown.hasClass(IS_OPEN.substring(1));
	
	        var dropdownSignal = this.$context.props.toggleDropdown;
	        var id = this.$context.attributes['id'];
	
	        this.$context.signal(dropdownSignal, { id: id, isOpen: isOpen });
	    };
	
	    Datepicker.prototype.changePage = function changePage(e) {
	        e.stopPropagation();
	
	        var arrow = $(e.currentTarget);
	        var toRight = arrow.hasClass(RIGHT.substring(1));
	
	        var changePageSignal = this.$context.props.scrollPage;
	        var type = this.$context.props.srollType;
	        var id = this.$context.attributes['id'];
	
	        this.$context.signal(changePageSignal, { id: id, toRight: toRight, type: type });
	    };
	
	    Datepicker.prototype.selectPeriod = function selectPeriod() {
	        var periods = $(PERIOD);
	        var fromVal = periods.filter(FROM).val();
	        var tillVal = periods.filter(TILL).val();
	
	        var format = 'DD.MM.YYYY';
	        var from = moment(fromVal, format);
	        var till = moment(tillVal, format);
	
	        var period = void 0;
	
	        if (from.isValid() && till.isValid()) {
	            var date1 = from.unix();
	            var date2 = till.unix();
	
	            if (date1 > date2) {
	                period = {
	                    from: date2,
	                    till: date1
	                };
	            } else {
	                period = {
	                    from: date1,
	                    till: date2
	                };
	            }
	        }
	
	        var setPeriod = this.$context.props.setPeriod;
	
	        this.$context.signal(setPeriod, { period: period });
	    };
	
	    Datepicker.prototype.clearInput = function clearInput(e) {
	        e.preventDefault();
	
	        var id = this.$context.attributes['id'];
	        var clearInput = this.$context.props.clearInput;
	        this.$context.signal(clearInput, { id: id });
	    };
	
	    Datepicker.prototype.stopPropagation = function stopPropagation(e) {
	        e.stopPropagation();
	    };
	
	    Datepicker.prototype.initMaskedInput = function initMaskedInput() {
	        var element = this.$context.element;
	
	        $(element).find(PERIOD).mask('99.99.9999');
	    };
	
	    Datepicker.prototype.handleInput = function handleInput(e) {
	        var validate = this.$context.attributes['cat-validate'];
	
	        if (validate) {
	            return;
	        }
	
	        var $target = $(e.currentTarget);
	        var $inputs = $(PERIOD);
	        var $button = $(SELECT_BUTTON);
	        var value = $target.val();
	
	        var isFullDate = value.indexOf('_') === -1;
	        var isValid = moment(value, 'DD.MM.YYYY').isValid();
	
	        var isError = !(isFullDate && isValid);
	
	        $target.toggleClass(ERROR.substring(1), isError);
	
	        if ($inputs.hasClass(ERROR.substring(1))) {
	            isError = true;
	        }
	
	        $button.toggleClass(ERROR.substring(1), isError);
	    };
	
	    return Datepicker;
	}();
	
	module.exports = {
	    constructor: Datepicker,
	    children: [{
	        name: 'calendar',
	        component: Calendar,
	        parentPropsMap: {
	            selectDate: 'selectDate'
	        }
	    }]
	};

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(__webpack_module_template_argument_0__);
	var $ = __webpack_require__(12);
	var _ = __webpack_require__(3);
	
	var SELECT = '.' + css.select;
	var OPTION = '.' + css.option;
	var INPUT = '.' + css.input;
	var DROPDOWN = '.' + css.dropdown;
	var OPTIONS = '.' + css.options;
	var TEXTFIELD_WRAPPER = '.' + css.textfieldWrapper;
	var TEXTFIELD = '.' + css.textfield;
	var SCROLLBAR = '.' + css.scrollbar;
	var SCROLLTRACK = '.' + css.scrolltrack;
	var IS_HIGHLIGHTED = '.' + css.isHighlighted;
	var IS_UP = '.' + css.isUp;
	var IS_DISABLED = '.' + css.isDisabled;
	var WARN_MISSED_PATH = 'Text must accept path as attribute';
	
	var Select = function () {
	    function Select(locator) {
	        _classCallCheck(this, Select);
	
	        this._logger = locator.resolve('logger');
	        this.template = __webpack_require__(__webpack_module_template_argument_1__);
	    }
	
	    Select.prototype.render = function render() {
	        var skinName = _.get(this.$context.attributes, 'cat-skin');
	        var skin = _.get(css, skinName);
	        var filterPlaceholder = this.$context.props.filterPlaceholder;
	        var id = this.$context.attributes['id'];
	        var name = this.$context.attributes['name'];
	
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { skin: skin });
	        }).then(function (data) {
	            return Object.assign({ css: css }, data, { id: id, filterPlaceholder: filterPlaceholder, name: name });
	        });
	    };
	
	    Select.prototype.bind = function bind() {
	        var _click, _mouseenter, _input, _keydown, _keyup;
	
	        this.fillUI();
	
	        return {
	            click: (_click = {}, _click[SELECT] = this.clickOnSelect, _click[OPTION] = this.clickOnItem, _click[TEXTFIELD] = this.clickOnTextField, _click[TEXTFIELD_WRAPPER] = this.clickOnTextField, _click),
	            mouseenter: (_mouseenter = {}, _mouseenter[OPTION] = this.enterItem, _mouseenter),
	            input: (_input = {}, _input[TEXTFIELD] = _.partial(this.inputEvent, this.$context.props.signalInputText), _input),
	            keydown: (_keydown = {}, _keydown[INPUT] = this.prevent, _keydown),
	            keyup: (_keyup = {}, _keyup[INPUT] = this.keyHandler, _keyup)
	        };
	    };
	
	    Select.prototype.fillUI = function fillUI() {
	        var $el = $(this.$context.element);
	        var wrapper = _.get(this.$context.attributes, 'cat-wrapper');
	        this.$select = $el.find(INPUT);
	        this.$dropdown = $el.find(DROPDOWN);
	        this.$itemWrapper = $el.find(OPTIONS);
	        this.$items = $el.find(OPTION);
	
	        var activeItem = this.$items.filter(IS_HIGHLIGHTED.substring(1));
	        this._selected = activeItem.length ? activeItem.index() : 0;
	
	        if (wrapper) {
	            this.$wrapper = $(wrapper);
	        }
	
	        this.initBaron();
	    };
	
	    Select.prototype.initBaron = function initBaron() {
	        var baron = __webpack_require__(64);
	        var elementId = this.$context.attributes.id;
	
	        baron({
	            root: '#' + elementId + ' ' + DROPDOWN,
	            scroller: OPTIONS,
	            bar: SCROLLBAR,
	            track: SCROLLTRACK,
	            $: $
	        });
	    };
	
	    Select.prototype.prevent = function prevent(e) {
	        if (_.includes([38, 40], e.keyCode)) {
	            e.preventDefault();
	        }
	    };
	
	    Select.prototype.clickOnSelect = function clickOnSelect(e) {
	        var _this = this;
	
	        e.preventDefault();
	        e.stopPropagation();
	
	        var $el = $(SELECT);
	        var name = $(this.$context.element).attr('cat-name');
	        var signalOnToggle = this.$context.props.signalOnToggle;
	
	        var isParentFieldsSetDisabled = $el.closest('fieldset').attr('disabled') === 'disabled';
	
	        if ($el.hasClass(IS_DISABLED.substring(1)) || isParentFieldsSetDisabled) {
	            return;
	        }
	
	        this.$context.signal(signalOnToggle, { name: name });
	
	        _.defer(function () {
	            var textFieldElement = $(TEXTFIELD);
	
	            if (textFieldElement) {
	                textFieldElement.focus();
	            }
	
	            _this.calculateDropdownHeight();
	        });
	    };
	
	    Select.prototype.clickOnItem = function clickOnItem(e) {
	        this.selectValue(e);
	    };
	
	    Select.prototype.clickOnTextField = function clickOnTextField(e) {
	        e.stopPropagation();
	    };
	
	    Select.prototype.inputEvent = function inputEvent(signal, e) {
	        var _this2 = this;
	
	        var path = this.$context.attributes['path'];
	        var value = e.currentTarget.value;
	
	        if (!path) {
	            this._logger.warn(WARN_MISSED_PATH);
	            return;
	        }
	
	        this.$context.signal(signal, { path: path, value: value });
	
	        _.defer(function () {
	            _this2.calculateDropdownHeight();
	        });
	    };
	
	    Select.prototype.keyHandler = function keyHandler(e) {
	        var signalOnToggle = this.$context.props.signalOnToggle;
	        var name = $(this.$context.element).attr('cat-name');
	
	        switch (e.keyCode) {
	            case 13:
	                this.$context.signal(signalOnToggle, { name: name });
	                this.selectValue(e);
	                break;
	            case 27:
	                break;
	            case 38:
	                e.stopPropagation();
	                if (this._current > 0) {
	                    this._current--;
	                }
	                break;
	            case 40:
	                e.stopPropagation();
	                if (this._current + 1 < this.$items.length) {
	                    this._current++;
	                }
	                break;
	            default:
	                break;
	        }
	
	        if (_.includes([38, 40], e.keyCode)) {
	            this.changeHighlight(this._current);
	        }
	    };
	
	    Select.prototype.enterItem = function enterItem(e) {
	        var index = $(e.target).index();
	
	        this.changeHighlight(index);
	    };
	
	    Select.prototype.selectValue = function selectValue(e) {
	        var $currentItem = this.$items.filter(IS_HIGHLIGHTED)[0];
	        var selectedValue = $currentItem.getAttribute('cat-value');
	        var signalOnSelect = this.$context.props.signalOnSelect;
	        var field = _.get(this.$context.attributes, 'cat-field');
	        var ctx = this.$context;
	
	        if (signalOnSelect && $currentItem) {
	            ctx.signal(signalOnSelect, { selectedValue: selectedValue, field: field });
	        }
	    };
	
	    Select.prototype.changeHighlight = function changeHighlight(index) {
	        this.$items.removeClass(IS_HIGHLIGHTED.substring(1));
	        this.$items.eq(index).addClass(IS_HIGHLIGHTED.substring(1));
	        this._current = index;
	    };
	
	    Select.prototype.calculateDropdownHeight = function calculateDropdownHeight() {
	        var selectHeight = $(this.$select).outerHeight();
	        var offsetTop = $(this.$select).offset().top;
	        var scrollTop = $(window).scrollTop();
	        var viewportHeight = $(window).height();
	        var viewportTop = offsetTop - scrollTop;
	        var viewportBottom = viewportHeight - (offsetTop + selectHeight - scrollTop);
	        var itemsHeight = this.$items.eq(0).outerHeight() * this.$items.length;
	
	        var height = itemsHeight < viewportBottom - 30 ? viewportBottom : _.max([viewportTop, viewportBottom]);
	
	        this.$itemWrapper.css('maxHeight', _.min([height, 300]) - 20);
	        this.$dropdown.toggleClass(IS_UP.substring(1), height === viewportTop);
	    };
	
	    return Select;
	}();
	
	module.exports = {
	    constructor: Select
	};

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__) {

	'use strict';
	
	var Checkbox = __webpack_require__(__webpack_module_template_argument_0__);
	var Subnavigation = __webpack_require__(__webpack_module_template_argument_1__);
	var SegmentSelect = __webpack_require__(__webpack_module_template_argument_2__);
	var Datepicker = __webpack_require__(__webpack_module_template_argument_3__);
	var Text = __webpack_require__(__webpack_module_template_argument_4__);
	var Select = __webpack_require__(__webpack_module_template_argument_5__);
	var FilteredSelect = __webpack_require__(__webpack_module_template_argument_6__);
	var CheckListSelect = __webpack_require__(__webpack_module_template_argument_7__);
	var Radio = __webpack_require__(__webpack_module_template_argument_8__);
	
	module.exports = {
	    Checkbox: Checkbox,
	    Subnavigation: Subnavigation,
	    SegmentSelect: SegmentSelect,
	    Datepicker: Datepicker,
	    Text: Text,
	    Select: Select,
	    FilteredSelect: FilteredSelect,
	    CheckListSelect: CheckListSelect,
	    Radio: Radio
	};

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(__webpack_module_template_argument_0__);
	var RADIO = '.' + css.radio;
	
	var Radio = function () {
	    function Radio() {
	        _classCallCheck(this, Radio);
	
	        this.template = __webpack_require__(__webpack_module_template_argument_1__);
	    }
	
	    Radio.prototype.render = function render() {
	        var _this = this;
	
	        return this.$context.getWatcherData().then(function (data) {
	            var attributes = _this.$context.attributes;
	            return Object.assign({}, data, attributes, { css: css });
	        });
	    };
	
	    Radio.prototype.bind = function bind() {
	        var _change;
	
	        return {
	            change: (_change = {}, _change[RADIO] = this.onChange, _change)
	        };
	    };
	
	    Radio.prototype.onChange = function onChange(e) {
	        e.stopPropagation();
	
	        var signal = this.$context.props.signal;
	        var key = this.$context.attributes['cat-key'];
	        var value = e.currentTarget.checked;
	
	        this.$context.signal(signal, { key: key, value: value });
	    };
	
	    return Radio;
	}();
	
	module.exports = {
	    constructor: Radio
	};

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(__webpack_module_template_argument_0__);
	var SELECTOR_OPTION = '.' + css.button;
	
	var SegmentedSelect = function () {
	    function SegmentedSelect() {
	        _classCallCheck(this, SegmentedSelect);
	
	        this.template = __webpack_require__(__webpack_module_template_argument_1__);
	    }
	
	    SegmentedSelect.prototype.render = function render() {
	        var _this = this;
	
	        return this.$context.getWatcherData().then(function (data) {
	            var attributes = _this.$context.attributes;
	            return Object.assign({}, data, attributes, { css: css });
	        });
	    };
	
	    SegmentedSelect.prototype.bind = function bind() {
	        var _click;
	
	        return {
	            click: (_click = {}, _click[SELECTOR_OPTION] = this.selectTab, _click)
	        };
	    };
	
	    SegmentedSelect.prototype.selectTab = function selectTab(e) {
	        if (e.target.tagName !== 'A') {
	            e.stopPropagation();
	        }
	
	        var signal = this.$context.props.signal;
	
	        if (signal) {
	            var selectedTab = e.currentTarget.getAttribute('cat-key');
	            this.$context.signal(signal, { selectedTab: selectedTab });
	        }
	    };
	
	    return SegmentedSelect;
	}();
	
	module.exports = {
	    constructor: SegmentedSelect
	};

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(__webpack_module_template_argument_0__);
	var $ = __webpack_require__(12);
	var _ = __webpack_require__(3);
	
	var SELECT = '.' + css.select;
	var OPTION = '.' + css.option;
	var INPUT = '.' + css.input;
	var DROPDOWN = '.' + css.dropdown;
	var OPTIONS = '.' + css.options;
	var SCROLLBAR = '.' + css.scrollbar;
	var SCROLLTRACK = '.' + css.scrolltrack;
	var IS_HIGHLIGHTED = '.' + css.isHighlighted;
	var IS_UP = '.' + css.isUp;
	var IS_DISABLED = '.' + css.isDisabled;
	
	var Select = function () {
	    function Select() {
	        _classCallCheck(this, Select);
	
	        this.template = __webpack_require__(__webpack_module_template_argument_1__);
	    }
	
	    Select.prototype.render = function render() {
	        var skinName = _.get(this.$context.attributes, 'cat-skin');
	        var skin = _.get(css, skinName);
	
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, { skin: skin });
	        }).then(function (data) {
	            return Object.assign({ css: css }, data);
	        });
	    };
	
	    Select.prototype.bind = function bind() {
	        var _click, _mouseenter, _keydown, _keyup;
	
	        this.fillUI();
	        return {
	            click: (_click = {}, _click[SELECT] = this.clickOnSelect, _click[OPTION] = this.clickOnItem, _click),
	            mouseenter: (_mouseenter = {}, _mouseenter[OPTION] = this.enterItem, _mouseenter),
	            keydown: (_keydown = {}, _keydown[INPUT] = this.prevent, _keydown),
	            keyup: (_keyup = {}, _keyup[INPUT] = this.keyHandler, _keyup)
	        };
	    };
	
	    Select.prototype.fillUI = function fillUI() {
	        var $el = $(this.$context.element);
	        var wrapper = _.get(this.$context.attributes, 'cat-wrapper');
	        this.$select = $el.find(INPUT);
	        this.$dropdown = $el.find(DROPDOWN);
	        this.$itemWrapper = $el.find(OPTIONS);
	        this.$items = $el.find(OPTION);
	
	        var activeItem = this.$items.filter(IS_HIGHLIGHTED.substring(1));
	        this._selected = activeItem.length ? activeItem.index() : 0;
	
	        if (wrapper) {
	            this.$wrapper = $(wrapper);
	        }
	        this.initBaron();
	    };
	
	    Select.prototype.initBaron = function initBaron() {
	        var baron = __webpack_require__(64);
	        var elementId = this.$context.attributes.id;
	
	        baron({
	            root: '#' + elementId + ' ' + DROPDOWN,
	            scroller: OPTIONS,
	            bar: SCROLLBAR,
	            track: SCROLLTRACK,
	            $: $
	        });
	    };
	
	    Select.prototype.prevent = function prevent(e) {
	        if (_.includes([38, 40], e.keyCode)) {
	            e.preventDefault();
	        }
	    };
	
	    Select.prototype.clickOnSelect = function clickOnSelect(e) {
	        var _this = this;
	
	        e.preventDefault();
	        e.stopPropagation();
	
	        var $el = $(SELECT);
	        var name = $(this.$context.element).attr('cat-name');
	        var signalOnToggle = this.$context.props.signalOnToggle;
	
	        var isParentFieldsSetDisabled = $el.closest('fieldset').attr('disabled') === 'disabled';
	        if ($el.hasClass(IS_DISABLED.substring(1)) || isParentFieldsSetDisabled) {
	            return;
	        }
	
	        this.$context.signal(signalOnToggle, { name: name });
	
	        _.defer(function () {
	            _this.calculateDropdownHeight();
	        });
	    };
	
	    Select.prototype.clickOnItem = function clickOnItem(e) {
	        this.selectValue(e);
	    };
	
	    Select.prototype.keyHandler = function keyHandler(e) {
	        var signalOnToggle = this.$context.props.signalOnToggle;
	        var name = $(this.$context.element).attr('cat-name');
	
	        switch (e.keyCode) {
	            case 13:
	                this.$context.signal(signalOnToggle, { name: name });
	                this.selectValue(e);
	                break;
	            case 27:
	                break;
	            case 38:
	                e.stopPropagation();
	                if (this._current > 0) {
	                    this._current--;
	                }
	                break;
	            case 40:
	                e.stopPropagation();
	                if (this._current + 1 < this.$items.length) {
	                    this._current++;
	                }
	                break;
	            default:
	                break;
	        }
	
	        if (_.includes([38, 40], e.keyCode)) {
	            this.changeHighlight(this._current);
	        }
	    };
	
	    Select.prototype.enterItem = function enterItem(e) {
	        var index = $(e.target).index();
	        this.changeHighlight(index);
	    };
	
	    Select.prototype.selectValue = function selectValue(e) {
	        var $currentItem = this.$items.filter(IS_HIGHLIGHTED)[0];
	        var selectedValue = $currentItem.getAttribute('cat-value');
	        var signalOnSelect = this.$context.props.signalOnSelect;
	        var field = _.get(this.$context.attributes, 'cat-field');
	        var ctx = this.$context;
	
	        if (signalOnSelect && $currentItem) {
	            ctx.signal(signalOnSelect, { selectedValue: selectedValue, field: field });
	        }
	    };
	
	    Select.prototype.changeHighlight = function changeHighlight(index) {
	        this.$items.removeClass(IS_HIGHLIGHTED.substring(1));
	        this.$items.eq(index).addClass(IS_HIGHLIGHTED.substring(1));
	        this._current = index;
	    };
	
	    Select.prototype.calculateDropdownHeight = function calculateDropdownHeight() {
	        var selectHeight = $(this.$select).outerHeight();
	        var offsetTop = $(this.$select).offset().top;
	        var scrollTop = $(window).scrollTop();
	        var viewportHeight = $(window).height();
	        var viewportTop = offsetTop - scrollTop;
	        var viewportBottom = viewportHeight - (offsetTop + selectHeight - scrollTop);
	        var itemsHeight = this.$items.eq(0).outerHeight() * this.$items.length;
	
	        var height = itemsHeight < viewportBottom - 30 ? viewportBottom : _.max([viewportTop, viewportBottom]);
	        this.$itemWrapper.css('maxHeight', _.min([height, 300]) - 20);
	        this.$dropdown.toggleClass(IS_UP.substring(1), height === viewportTop);
	    };
	
	    return Select;
	}();
	
	module.exports = {
	    constructor: Select
	};

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(__webpack_module_template_argument_0__);
	var SELECTOR_ITEM = '.' + css.item;
	
	var Subnavigation = function () {
	    function Subnavigation() {
	        _classCallCheck(this, Subnavigation);
	
	        this.template = __webpack_require__(__webpack_module_template_argument_1__);
	    }
	
	    Subnavigation.prototype.render = function render() {
	        var props = this.$context.props;
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, data, props, { css: css });
	        });
	    };
	
	    Subnavigation.prototype.bind = function bind() {
	        var _click;
	
	        return {
	            click: (_click = {}, _click[SELECTOR_ITEM] = this.selectTab, _click)
	        };
	    };
	
	    Subnavigation.prototype.selectTab = function selectTab(e) {
	        var subPage = e.currentTarget.getAttribute('cat-page');
	        var signal = this.$context.props.signal;
	
	        if (signal) {
	            this.$context.signal(signal, { subPage: subPage });
	        }
	
	        var followHref = this.$context.props['follow-href'];
	
	        if (followHref) {
	            e.stopPropagation();
	        }
	    };
	
	    return Subnavigation;
	}();
	
	module.exports = {
	    constructor: Subnavigation
	};

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(__webpack_module_template_argument_0__);
	var _ = __webpack_require__(3);
	var $ = __webpack_require__(12);
	
	var SELECTOR_TEXTFIELD = '.' + css.textfield;
	var WARN_MISSED_PATH = 'Text must accept path as attribute';
	
	var ALLOWED_KEYS = ['ArrowLeft', 'Left', 'ArrowUp', 'Up', 'ArrowRight', 'Right', 'ArrowDown', 'Down', 'Backspace', 'Tab', 'Delete'];
	
	var ALLOWED_CHARS_WITH_MODIFIER = ['a', 'c', 'x', 'r'];
	
	var Text = function () {
	    function Text(locator) {
	        _classCallCheck(this, Text);
	
	        this._logger = locator.resolve('logger');
	        this.template = __webpack_require__(__webpack_module_template_argument_1__);
	    }
	
	    Text.prototype.render = function render() {
	        var _this = this;
	
	        return this.$context.getWatcherData().then(function (data) {
	            return Object.assign({}, { css: css }, _this.$context.attributes, _this.$context.props, data);
	        });
	    };
	
	    Text.prototype.bind = function bind() {
	        var _input, _keypress, _blur, _paste;
	
	        var mask = this.$context.props.mask;
	
	        if (mask) {
	            this.setMask(mask);
	        }
	
	        return {
	            input: (_input = {}, _input[SELECTOR_TEXTFIELD] = _.partial(this.inputEvent, this.$context.props.signals.inputText), _input),
	            keypress: (_keypress = {}, _keypress[SELECTOR_TEXTFIELD] = this.validate, _keypress),
	            blur: (_blur = {}, _blur[SELECTOR_TEXTFIELD] = _.partial(this.inputEvent, this.$context.props.signals.blurText), _blur),
	            paste: (_paste = {}, _paste[SELECTOR_TEXTFIELD] = this.validate, _paste)
	        };
	    };
	
	    Text.prototype.inputEvent = function inputEvent(signal, e) {
	        var path = this.$context.attributes['path'];
	        var value = e.currentTarget.value;
	        var errorPath = this.$context.attributes['error-path'];
	        var scheme = this.$context.props.scheme;
	        var errorMessage = this.$context.attributes['error-message'];
	
	        if (!path) {
	            this._logger.warn(WARN_MISSED_PATH);
	            return;
	        }
	
	        this.$context.signal(signal, { path: path, value: value, errorPath: errorPath, scheme: scheme, errorMessage: errorMessage });
	    };
	
	    Text.prototype.validate = function validate(e) {
	        var scheme = this.$context.props.scheme;
	        var regexp = _.get(scheme, 'properties.value.regexp');
	
	        if (!regexp) {
	            return;
	        }
	
	        if (ALLOWED_KEYS.includes(e.key)) {
	            return;
	        }
	
	        if (e.type == 'paste') {
	            var clipboardData = e.clipboardData || window.clipboardData;
	            var pastedValue = clipboardData.getData('Text');
	            var isValidPastedValue = regexp.test(pastedValue);
	
	            if (!isValidPastedValue) {
	                e.preventDefault();
	            }
	
	            return;
	        }
	
	        var modifierPressed = e.getModifierState('Control') || e.getModifierState('Meta');
	        var pressedChar = String.fromCharCode(e.which);
	
	        if (modifierPressed && ALLOWED_CHARS_WITH_MODIFIER.includes(pressedChar)) {
	            return;
	        }
	
	        var clearChar = pressedChar.replace(regexp, '');
	
	        if (!clearChar) {
	            e.preventDefault();
	        }
	    };
	
	    Text.prototype.setMask = function setMask(mask) {
	        var element = this.$context.element;
	        $(element).find(SELECTOR_TEXTFIELD).mask(mask);
	    };
	
	    return Text;
	}();
	
	module.exports = {
	    constructor: Text
	};

/***/ })
/******/ ])));


// WEBPACK FOOTER //
// bundle.js